const copyToClipboard$o = "Copied to clipboard!";
const UnlocktheAIgenerated$o = "Unlock the AI generated";
const UpgradetoPremium$o = "Upgrade to Premium";
const Result$o = "Result";
const Copy$o = "Copy";
const Save$o = "Save";
const Edit$o = "Edit";
const Processing$o = "Processing";
const YourAIgeneratedcontentwillshowhere$o = "Your AI generated content will show here";
const hopeYouFindUseful$o = "Hope you find this result useful!";
const regenerate$o = "Re-generate";
const ProvideAdditionalFeedback$o = "Provide Additional Feedback";
const Enteranyfeedback$o = "Enter any feedback";
const Notimpressive$o = "Not impressive";
const thisIsntTrue$o = "This isn't true";
const Notpersonalized$o = "Not personalized";
const Tone$o = "Tone";
const Length$o = "Length";
const Template$o = "Template";
const Generatedon$o = "Generated on";
const Copiedtoclipboard$o = "Copied to clipboard";
const CopytoClipboard$o = "Copy to Clipboard";
const DownloadasPDF$o = "Download as PDF";
const ViewDetails$o = "View Details";
const JobDescriptionImported$o = "Job Description Imported";
const ImportfromJob$o = "Import from Job";
const Saved$o = "Saved";
const Applied$o = "Applied";
const Offer$o = "Offer";
const Interviewing$o = "Interviewing";
const Rejected$o = "Rejected";
const Search$o = "Search";
const Import$o = "Import";
const CoverLetterGeneratorHistory$o = "Cover Letter Generator History";
const NoCoverLettersGenerated$o = "No Cover Letters Generated";
const getStartedCoverLetter$o = "You have not generated any cover letters yet. Get started and have cover letters by matching job description with your relavant experience.";
const getStarted$o = "Get Started!";
const Documents$o = "Documents";
const UploadNewDocument$o = "Upload New Document";
const AICoverLetterGenerator$o = "AI Cover Letter Generator";
const ViewHistory$o = "View History";
const JobDescription$o = "Job Description";
const ImportfromBoard$o = "Import from Board";
const EnterJobDescription$o = "Enter Job Description";
const JobTitle$o = "Job Title";
const EnterJobTitle$o = "Enter Job Title";
const CompanyName$o = "Company Name";
const EnterCompanyName$o = "Enter Company Name";
const YourProfile$o = "Your Profile";
const ResumeUpload$o = "Resume Upload";
const UseLinkedinProfile$o = "Use Linkedin Profile";
const Uploadyourresume$o = "Upload your resume";
const AddyourResume$o = "Add your Resume";
const fileNameCannotFormat$o = "File names cannot contain spaces or underscores and should be in either .doc, .docx, or .pdf.";
const ChooseorUpload$o = "Choose or Upload";
const SelectTemplate$o = "Select Template";
const Preview$o = "Preview";
const UseTemplate$o = "Use Template";
const Change$o = "Change";
const AdvancedSettings$o = "Advanced Settings";
const AdditionalContext$o = "Additional Context";
const Professional$o = "Professional";
const Casual$o = "Casual";
const Enthusiastic$o = "Enthusiastic";
const Informational$o = "Informational";
const Short$o = "Short";
const Medium$o = "Medium";
const Long$o = "Long";
const Language$o = "Language";
const iAmOkayBack$o = "I am okay! Go Back";
const Generate$o = "Generate";
const CoverLetter$o = "Cover Letter";
const SelectLanguage$o = "Select Language";
const AboutGeneratorHistory$o = "About Generator History";
const NoAboutsGenerated$o = "No Abouts Generated";
const getStartedAbouts$o = "You have not generated any abouts yet. Get started and have abouts by matching job description with your relavant experience.";
const noAttachmentsFound$o = "No attachments found.";
const TargetJobTitle$o = "Target Job Title";
const KeywordsToInclude$o = "Keywords To Include";
const UploadYourResume$o = "Upload Your Resume";
const AddYourResume$o = "Add Your Resume";
const LinkedinProfile$o = "Linkedin Profile";
const Linkedinprofilenotfound$o = "Linkedin profile not found";
const startUsingChromeExtension$o = "Start optimizing your linkedin profile using our Chrome extension to use this option.";
const Download$o = "Download";
const UseEmojis$o = "Use Emojis";
const UseBulletPoints$o = "Use Bullet Points";
const SpeechFocus$o = "Speech Focus";
const FirstPerson$o = "First Person";
const ThirdPerson$o = "Third Person";
const HeadlineGeneratorHistory$o = "Headline Generator History";
const NoHeadlinesGenerated$o = "No Headlines Generated";
const getStartedHeadline$o = "You have not generated any headlines yet. Get started and have headlines by matching job description with your relavant experience.";
const AIHeadlineGenerator$o = "AI Headline Generator";
const KeywordstoInclude$o = "Keywords to Include";
const Pressenteraftereachword$o = "Press enter after each word";
const LinkedinProfilenotfound$o = "LinkedIn Profile not found";
const Headline$o = "Headline";
const PostGeneratorHistory$o = "Post Generator History";
const NoPostsGenerated$o = "No Posts Generated";
const getStartedPost$o = "You have not generated any posts yet. Get started and have posts by matching job description with your relavant experience.";
const Topic$o = "Topic";
const Description$o = "Description";
const DescriptionPlaceholder = "Paste or Type the Job Description here";
const UseHashtags$o = "Use Hashtags";
const Custom$o = "Custom";
const EnterCustomTone$o = "Enter Custom Tone";
const Added$o = "Added";
const ComingSoon$o = {
	header: "Engineers at work!",
	content_1: "Our team of engineers is hard at work, trying to get this feature up and running soon",
	content_2: "Want this feature soon? Let us know by simply checking the box below.",
	content_3: "I want this feature",
	ComingSoon: "Coming Soon"
};
const Company$o = "Company";
const JobInterview$o = "Job Interview";
const Research$o = "Research";
const Networking$o = "Networking";
const Referral$o = "Referral";
const MustbeContacted$o = "Must be Contacted";
const ScheduleaMeeting$o = "Schedule a Meeting";
const needAFollowUp$o = "Need to follow-up";
const Today$o = "Today";
const Viewdetails$o = "View details";
const Activity$o = "Activity";
const ActivityDetails$o = "Activity Details";
const Delete$o = "Delete";
const Title$o = "Title";
const Goal$o = "Goal";
const Status$o = "Status";
const FollowUp$o = "Follow Up";
const AddActivity$o = "Add Activity";
const Enteractivitytitle$o = "Enter activity title";
const Cancel$o = "Cancel";
const SaveActivity$o = "Save Activity";
const noActivityPresent$o = "No Activity present, add activity.";
const Addnew$o = "Add new";
const About$o = "About";
const noDataPresentYou$o = "No data present you can edit this contact and add fields.";
const Experience$o = "Experience";
const Education$o = "Education";
const Skills$o = "Skills";
const Overview$o = "Overview";
const LinkedJobs$o = "Linked Jobs";
const Notes$o = "Notes";
const FullName$o = "Full Name";
const Location$o = "Location";
const Relationship$o = "Relationship";
const Contacts$o = "Contacts";
const CreateContact$o = "Create Contact";
const NotesCreated$o = "Notes Created";
const Notesupdated$o = "Notes updated";
const Addnote$o = "Add note";
const areYouSureDeleteNote$o = "Are you sure you want delete this note?";
const Createdby$o = "Created by";
const notSureWhyResumeCalls$o = "Not sure why your resume isn’t getting you interview calls? ☎️";
const getExpertResumeReview$o = "Get an Expert Resume Review 💎✨";
const youHaventAddedContacts$o = "You haven't added any contacts yet.";
const noMatchingContacts$o = "No matching contacts found.";
const Link$o = "Link";
const unlink$o = "Un-link";
const Locationnotavailable$o = "Location not available";
const Emailnotavailable$o = "Email not available";
const PhoneNumbernotavailable$o = "Phone Number not available";
const createdby$o = "created by";
const areYouSureDeleteContact$o = "Are you sure you want delete this Contact?";
const areYouSureUnlinkContact$o = "Are you sure you want to Un-Link this Contact?";
const Addedbyyou$o = "Added by you";
const Addedby$o = "Added by";
const Timeline$o = "Timeline";
const Timelineempty$o = "Timeline empty";
const Discard$o = "Discard";
const SaveContact$o = "Save Contact";
const Recruiter$o = "Recruiter";
const Candidate$o = "Candidate";
const Colleague$o = "Colleague";
const Employee$o = "Employee";
const EnterValidEmail$o = "Enter Valid Email";
const EnterValidPhoneNumber$o = "Enter Valid Phone Number";
const editingProfileNotAvailable$o = "Editing Profile Photo is not available yet.";
const itWillBeSoonAvailable$o = "It will be available soon in our";
const ChromeExtension$o = "Chrome Extension";
const SelectTag$o = "Select Tag";
const FirstName$o = "First Name";
const FirstNameisrequired$o = "First Name is required";
const LastName$o = "Last Name";
const LastNameisrequired$o = "Last Name is required";
const Companyisrequired$o = "Company is required";
const Email$o = "Email";
const ThisisnotavalidEmail$o = "This is not a valid Email";
const AddEmail$o = "Add Email";
const PhoneNumber$o = "Phone Number";
const notaValidPhone$o = "This is not a valid phone number. Enter numbers only";
const phoneNoMinimum5char$o = "Phone Number must be minimum 5 characters.";
const phoneNoMinumum15char$o = "Phone Number must be maximum 15 characters.";
const AddPhoneNumber$o = "Add Phone Number";
const SelectGoal$o = "Select Goal";
const SelectStatus$o = "Select Status";
const Followup$o = "Follow-up";
const SocialMedia$o = "Social Media";
const Linkedinhandle$o = "Linkedin Handle";
const Twitterhandle$o = "Twitter handle";
const Facebookhandle$o = "Facebook handle";
const Githubhandle$o = "Github handle";
const Gmailhandle$o = "Gmail handle";
const Changessavedsuccessfully$o = "Changes saved successfully";
const EditContact$o = "Edit Contact";
const BasicInformation$o = "Basic Information";
const EditContactDetails$o = "Edit Contact Details";
const SaveChanges$o = "Save Changes";
const phoneNoMinimum14char$o = "Phone Number must be minimum 14 characters.";
const LinkedIn$o = "LinkedIn";
const Twitter$o = "Twitter";
const Facebook$o = "Facebook";
const Github$o = "Github";
const Gmail$o = "Gmail";
const youCanWriteAbout$o = "You can write about your years of experience, industry, or skills. People also talk about their achievements or previous job experiences.";
const Addednewsection$o = "Added new section";
const Removedsuccessfully$o = "Removed successfully";
const Remove$o = "Remove";
const Institute$o = "Institute";
const Schoolisrequired$o = "School is required";
const Degree$o = "Degree";
const StartMonth$o = "Start Month";
const StartYear$o = "Start Year";
const EndMonth$o = "End Month";
const EndYear$o = "End Year";
const Addmore$o = "Add more";
const PositionTitle$o = "Position Title";
const ExperienceType$o = "Experience Type";
const Addednewitem$o = "Added new item";
const whatSkillsDoYouEnjoy$o = "What skills do you have or enjoy working with";
const Typeskillshere$o = "Type skills here";
const LinkedContacts$o = "Linked Contacts";
const LinkContact$o = "Link Contact";
const NocontactsLinked$o = "No contacts linked";
const JobContactsComponent$o = {
	linkContact: "By linking contacts, you can quickly see who the important people like the recruiter, hiring manager, etc., are for this role! In the future, we'll be able to surface relevant insights based on your contacts."
};
const Nocontacts$o = "No contacts";
const LinkJobto$o = "Link Job to";
const Contact$o = "Contact";
const Document$o = "Document";
const Nojobsfound$o = "No jobs found";
const LinkJob$o = "Link Job";
const youCanLinkContactJobImported$o = "You can link this contact to a job you have imported into Careerflow.";
const Prev$o = "Prev";
const Next$o = "Next";
const areYouSureUnlinkDocument$o = "Are you sure you want to unlink this document?";
const areYouSureDeleteDocument$o = "Are you sure you want delete this Document?";
const Category$o = "Category";
const CreatedOn$o = "Created On";
const Joblinked$o = "Job linked";
const Quickactions$o = "Quick actions";
const All$o = "All";
const Resume$o = "Resume";
const Portfolio$o = "Portfolio";
const Other$o = "Other";
const Adddocument$o = "Add document";
const Type$o = "Type";
const Sortingby$o = "Sorting by";
const SwitchtoGridLayout$o = "Switch to Grid Layout";
const SwitchtoListLayout$o = "Switch to List Layout";
const NoDocumentsAdded$o = "No Documents Added";
const DocumentsComponent$o = {
	nodocs: "You have not created any documents yet. You can upload your resume versions, cover letters, and more, and link them to jobs you are tracking!"
};
const NoDocumentFound$o = "No Document Found";
const SelectFile$o = "Select File";
const onlyPdfDocxSupported$o = "Only .pdf and .docx supported";
const Uploadfile$o = "Upload file";
const DocumentCategory$o = "Document Category";
const SaveDocument$o = "Save Document";
const AddDocument$o = "Add Document";
const LinkedDocuments$o = "Linked Documents";
const LinkDocument$o = "Link Document";
const NodocumentsLinked$o = "No documents linked";
const JobDocumentsComponent$o = {
	linkDocs: "Linking all your relevant documents like your resume, cover letter, etc that you submitted for this job will help you keep track of everything on one place. Try it out!"
};
const NoDocuments$o = "No Documents";
const CreateDocuments$o = "Create Documents";
const youCanLinkDocumentJobImported$o = "You can link this Document to a job you have imported into Careerflow.";
const Documenteditedsuccessfully$o = "Document edited successfully";
const DocumentDetails$o = "Document Details";
const ResumeCreatedByStudent = "This resume is created by student";
const ViewResume = "View Resume";
const UnsavedChanges$o = "Unsaved Changes";
const yourChangesWillBeLostSureClose$o = "Your changes will be lost, are you sure you want to close?";
const yourChangesWillBeLostSureDiscard$o = "Your changes will be lost, are you sure you want to discard your changes?";
const DiscardChanges$o = "Discard Changes";
const WeeklyGoalAlert$o = "Weekly Goal Alert";
const Progress$o = "Progress";
const AllGoals$o = "All Goals";
const Name$o = "Name";
const Completedon$o = "Completed on";
const Createdon$o = "Created on";
const Action$o = "Action";
const Back$o = "Back";
const OverallScore$o = "Overall Score";
const Aboutthegoal$o = "About the goal";
const GoalTracking$o = "Goal Tracking";
const Week$o = "Week";
const progress$o = "progress";
const loading$o = "Loading";
const Apply$o = "Apply";
const Thisskillhasbeenreported$o = "This skill has been reported";
const issueGettingResume$o = "These was a issue with getting the resume";
const Interview$o = "Interview";
const Tasks$o = "Tasks";
const Loading$o = "Loading";
const Skilladdedsuccessfully$o = "Skill added successfully";
const problemAddingSkill$o = "There was a problem in adding skill.";
const Reportaproblem$o = "Report a problem";
const Submit$o = "Submit";
const Addanewskill$o = "Add a new skill";
const JobDetailsComponent$o = {
	classifySkill: "How would you classify this skill (Optional)",
	includedKeywordsWillCount: "Include this keyword?",
	yesIncludeThisSkill: "Included keywords will count against your match score for all future scans. You can change included keywords from your profile",
	addSkill: "Do you want to add this as a skill?"
};
const yesIncludeThisSkill = "Yes, include this skill for all my future resume scans.";
const HardSkill$o = "Hard Skill";
const SoftSkill$o = "Soft Skill";
const Pleaseshareanyadditionalcontext$o = "Please share any additional context";
const Addasskill$o = "Add as skill";
const Skill$o = "Skill";
const JobFrequency$o = "Job Frequency";
const ResumeFrequency$o = "Resume Frequency";
const Reportskill$o = "Report skill";
const JobDetails$o = "Job Details";
const ViewJobLink$o = "View Job Link";
const Salary$o = "Salary";
const areYouSureDeleteJob$o = "Are you sure you want delete this job?";
const ViewMore$o = "View More";
const ViewLess$o = "View Less";
const matchYouSkillsAgainstJob$o = "Match your skills against the job description";
const pleaseUploadResumeSkillMatch$o = "Please upload your resume to get your skill match score.";
const AddResume$o = "Add Resume";
const thisJobDoesNotHaveAnyDesc$o = "This job does not have any description";
const youCanEditJobToAdd$o = "You can edit this job to add a description to it. You can also import jobs using our";
const chromeextension$o = "chrome extension";
const fromVariousJobPortalsOnce$o = "from various job portals. Once you add a description you will also be able to see skill related information.";
const AddDescription$o = "Add Description";
const CompanyInfo$o = "Company Info";
const Website$o = "Website";
const Industry$o = "Industry";
const EmployeeCount$o = "Employee Count";
const ExprienceLevel$o = "Experience Level";
const Address$o = "Address";
const Resumes$o = "Resumes";
const Setasdefault$o = "Set as default";
const Ok$o = "Ok";
const UploadNewResume$o = "Upload New Resume";
const Default$o = "Default";
const Jobnotfound$o = "Job not found";
const EditDetails$o = "Edit Details";
const JobPostURL$o = "Job Post URL";
const Enterjoburl$o = "Enter job url";
const Nojobselected$o = "No job selected";
const Viewjobdetails$o = "View job details";
const Jobaddedtoyourboardsuccessfully$o = "Job added to your board successfully";
const AddJob$o = "Add Job";
const Addnewjobname$o = "Job Title";
const JobUrl$o = "Job Url";
const Addjoburl$o = "Job Url";
const Section$o = "Section";
const didYouKnow$o = {
	chromeExtension: "Did you know? You can also save jobs directly from our Chrome Extension and have all data imported in a single click! It takes just a few seconds."
};
const Jobs$o = "Jobs";
const AddJobtoboard$o = "Add Job to board";
const Currentlynojobsareavailable$o = "Currently no jobs are available";
const noMatchingJobs$o = "No matching jobs found.";
const welcomeToYourPersonalJobTracker$o = "Welcome to your personal Job Tracker!";
const weShortTutorialOnHowTrackingJob$o = "We’ll take you through a short tutorial on how to start tracking your job applications in a few easy steps!";
const Addanewjob$o = "Add a new job";
const inOrderTrackCreatButton$o = "In order to start tracking job applications, you need to first add it to the board by clicking the ‘Create’ button.";
const Providesomedetails$o = "Provide some details";
const toBeginTypeJobTitleCompany$o = "To begin with, simply type in the job title, the company name, and the status you’d like to add it to. You can add more details later, but this is all you’d need for now!";
const asAnExampleFilledForYou$o = "As an example, we've already filled this in for you!";
const wohooAddedFirstJob$o = "Woohoo! You added your first job to your job tracker!";
const youCanDragDropJobCard$o = "You can now drag-and-drop the job card into the various stages of the job application process. Clicking on the job card will allow you to view more details, edit them, save notes, and more!";
const Lastbutnotleast$o = "Last but not least";
const finalStepMakeSure$o = "As a final step, make sure you have our";
const autoMaticallyImportJobs$o = "which will allow you to automatically import jobs from your favorite job search websites like LinkedIn, Indeed, and more! Our extension also helps you improve your LinkedIn profile and get 2.5X more search appearances!";
const selectanysection$o = "select any section";
const Accept$o = "Accept";
const My2023JobSearch$o = "My 2024 Job Search";
const AddedFrom$o = "Added From";
const AddedUntil$o = "Added Until";
const BasicModal$o = "Basic Modal";
const AddnewSectionName$o = "Add new Section Name";
const OpenTo$o = "OpenTo";
const Featured$o = "Featured";
const LicenceAndCerts$o = "Licence And Certs";
const Banner$o = "Banner";
const LinkedInURL$o = "LinkedIn URL";
const Recommendations$o = "Recommendations";
const LinkedinReview$o = "Linkedin Review";
const NoDataAvailable$o = "No Data Available";
const looksLikeYouDidNot$o = "Looks like you did not start using our";
const toOptimizeProfileScoreVisible$o = "to optimize your linkedin profile yet. Once you do that, your profile score will be visible here.";
const LinkedinComponent$o = {
	letsOptimize: "Let's optimize"
};
const improveYourChancesLandingDreamJob$o = "Improve your chances of landing your dream job. Use these tried-and-tested strategies to give your LinkedIn profile a much needed makeover.";
const VisitProfile$o = "Visit Profile";
const wantToGetLinkedinMakeover$o = "Want to get a complete LinkedIn Makeover?";
const PostGenerator$o = "Post Generator";
const LinkedinHeadlineGenerator$o = "Linkedin Headline Generator";
const LinkedinAboutSectionGenerator$o = "Linkedin About Section Generator";
const AITools$o = "AI Tools";
const Premium$o = "Premium";
const LinkedInOptimization$o = "LinkedIn Optimization";
const JobTracker$o = "Job Tracker";
const whoIsHiring$o = "Who's Hiring";
const Autofill$o = "Autofill";
const HeadlineGenerator$o = "Headline Generator";
const skillMatching$o = "Skill Matching";
const SummarizeJD$o = "Summarize Job Description";
const contactFeature$o = "Contact Tracking";
const documentFeature$o = "Documents";
const landJobWithoutStress$o = "Your AI Career Copilot is here.";
const discoverFeatures$o = "Discover the array of Careerflow.ai features designed to streamline your job search and enhance your professional journey!";
const letsBeginOnboarding$o = "Let’s get to know you better!";
const inTheNextFewScreensJobThirdParties$o = "In the next few screens, we’ll ask you some questions which will help us tailor the experience for you as well as auto-fill your job applications (so that you don’t have to)! We do not sell your data to any third parties.";
const letsAddBasicInformation$o = "Let’s add your Basic Information";
const Pleaseselectanoptionfirst$o = "Please select an option first";
const JobApplicationTracker$o = "Job Application Tracker";
const LinkedInProfileOptimizer$o = "LinkedIn Profile Optimizer";
const UnlimitedDocuments$o = "Unlimited Documents";
const UnlimitedContacts$o = "Unlimited Contacts";
const HiringManagerSearch$o = "Hiring Manager Search";
const AILinkedInPostGenerator$o = "AI LinkedIn Post Generator";
const ATSKeywordSkillMatch$o = "ATS Keyword / Skill Match Job";
const ChooseyourPlan$o = "Choose Plan";
const superChargeYourJobSearch$o = "Supercharge your job search and improve your job application process, increase your interviews, and land your dream job. All with the help of Careerflow's premium toolkit.";
const startNowGoto$o = "Start Now (Go to app)";
const CreatedBy$o = "Created By";
const CreateNewNote$o = "Create New Note";
const Nonotescreated$o = "No notes created";
const approxTimeIsFourMinutes$o = "The approximate time to complete the onboarding process is 4 minutes.";
const Continue$o = "Continue";
const iWillDoLaterTakeMeToApp$o = "I'll do this later. Take me to the app.";
const allDone$o = "All done!";
const welcomeAbord$o = "Welcome Aboard!";
const letsBegin$o = "Let’s begin";
const UpgradeyourplanandgetAIAssistance$o = "Upgrade your plan and get AI Assistance";
const DownloadPDF$o = "Download PDF";
const oopsWeCouldntProcessResume$o = "Oops, we couldn't process this resume.";
const MyProfile$o = "My Profile";
const Setting$o = "Settings";
const Logout$o = "Logout";
const SignIn$o = "Sign In";
const Typeyourfirstnamehere$o = "Your First Name";
const Enteryourlastname$o = "Your Last Name";
const ManageSubscription$o = "Manage Subscription";
const ifYouHaveDifficultiesProfile$o = "If you have any difficulties with your profile information, please reach out to";
const forSupport$o = "for support.";
const whatIsIdealCompanySize$o = "What is your ideal company size?";
const Saveandcontinue$o = "Save and Continue";
const whatIsMinExpectedSalary$o = "What is your minimum expected salary (per year)?";
const Atleast$o = "At least";
const SlidetoAdjust$o = "Slide to Adjust";
const whatIndustryExcitedWork$o = "What industries are exciting for you?";
const Add$o = "Add";
const statusOfJobSearch$o = "Status of your job search?";
const Finish$o = "Finish";
const whatLevelRoleLooking$o = "What level of role are you looking for?";
const Selectuptotwo$o = "Select up to two";
const PreviousStep$o = "Previous Step";
const Skip$o = "Skip";
const whatDoYouValueNewRole$o = "What do you value in a new role?";
const Selectuptothree$o = "Select up to three";
const EqualEmploymentData$o = "Equal Employment Data";
const whatIsYourEthnicity$o = "What is your ethnicity?";
const areYouAuthorizedToWorkUs$o = "Are you authorized to work in the US?";
const willYouRequireSponsorShip$o = "Will you now or in the future require sponsorship for employment visa status?";
const doYouHaveADisability$o = "Do you have a disability?";
const areYouAVeteran$o = "Are you a veteran?";
const rolesYouInterestedIn$o = "What kind of roles you are interested in?";
const Selectuptofive$o = "Select up to five";
const AddCustomrole$o = "Add Custom role";
const whereDoYouLikeWork$o = "Where would you like to work?";
const Resources$o = "Resources";
const currentlyNoResourceAvailable$o = "Currently no Resources are available.";
const AddNewSection$o = "Add New Section";
const ChangeSections$o = "Change Sections";
const Settings$o = "Settings";
const Dashboard$o = "Dashboard";
const JobBoard$o = "Job Tracker";
const Linkedin$o = "Linkedin";
const Community$o = "Community";
const FindRecruiters$o = "Find Recruiters";
const Goals$o = "Goals";
const DownloadExtension$o = "Download Extension";
const SuggestaFeature$o = "Suggest a Feature";
const leftPanel$o = {
	ReportanIssue: "Report an Issue"
};
const PhoneNumberisrequired$o = "Phone Number is required";
const MobileNumber$o = "Mobile Number";
const Enteronlynumbers$o = "Enter only numbers";
const Countryyoulivein$o = "Country you live in";
const SelectaCountry$o = "Select a Country";
const DateofBirth$o = "Date of Birth";
const Gender$o = "Gender";
const JobPreferences$o = "Job Preferences";
const pleaseEnterValidEmail$o = "Please enter a valid email.";
const emailSendForResetting$o = "An email has been sent to you for resetiing password";
const VerifyyourEmailID$o = "Verify your Email ID";
const sentPleaseCheckEmail$o = "Sent! Please check your email";
const tooManyAttemptsTryAgain$o = "Too many attempts, please try again in sometime";
const Resend$o = "Resend";
const Login$o = "Login";
const weHaveSentVerificationLinkAtEmail$o = "We’ve sent you a verification link at your email";
const pleaseVerifyEmailContinueSpam$o = "Please verify your email to continue. Please also check spam or promotion for verification email.";
const Logintogetstarted$o = "Log into get started";
const ContinuewithGoogle$o = "Continue with Google";
const pleaseInputEmail$o = "Please input your email!";
const Password$o = "Password";
const pleaseInputPassword$o = "Please input your password!";
const passwordLowerUpperDigitSpecial$o = "Your password must contain atleast one lowercase, uppercase, digit and a special character";
const atLeastSixChar$o = "At least 6 characters";
const forgotPassword$o = "Forgot password?";
const Bysigninginyouagreetoour$o = "By signing in you agree to our";
const Terms$o = "Terms";
const Conditions$o = "Conditions";
const and$o = "and";
const PrivacyPolicy$o = "Privacy Policy";
const theseAreTheTopsSkillsExtracted$o = "These are the top skills extracted from the job description";
const TopSkills$o = "Top Skills";
const weCoulNotExtractSkills$o = "We could not extract any skills from this job description";
const upgradeToPremiumToView$o = "Upgrade to Premium to view your resume skills match score";
const SkillScore$o = "Skill Score";
const thisIsYourSkillScoreBasedOn$o = "This is your skill score based on the job description and your resume.";
const theseSkllsAreStrongMatch$o = "These skills are a strong match between your resume and the job description";
const Strongmatch$o = "Strong match";
const theseSkillsArePartialMatch$o = "These skills are a partial match between your resume and the job description";
const Partialmatch$o = "Partial match";
const theseSkillsAreMissingFrom$o = "These keywords are missing from your resume but are present in the job description. They may be skills or general keywords that are specific to the job opportunity and may be useful to add to your resume.";
const SkillMatchComponent$o = {
	excludeKeyword: "Exclude this keyword?",
	removeSkill: "What is your main reason for reporting a problem for the keyword"
};
const Optional$o = "Optional";
const Notrelevanttothejob$o = "Not relevant to the job";
const Notaskill$o = "No skill";
const Toogeneric$o = "Too generic";
const Pleaseshareanyfeedback$o = "Please share any feedback";
const excludedKeywordsWillNot$o = "Excluded keywords will not count against your match score for all future scans. You can change excluded keywords from your profile";
const yesExcludeThisSkillFrom$o = "Yes, exclude this skill from all my resume scans.";
const PartialMatch$o = "Partial Match";
const MissingKeywords$o = "Missing Keywords";
const Providetitletotask$o = "Provide title to task";
const TasksList$o = "Tasks List";
const AddTask$o = "Add Task";
const EnterTaskTitlehere$o = "Enter Task Title here";
const TasksComponent$o = {
	listEmpty: "Task List empty, Create New."
};
const CompletedTasks$o = "Completed Tasks";
const CompleteYourtasks$o = "Complete Your tasks";
const Steps$o = "Steps";
const PremiumMember$o = "Premium Member";
const Thankyouforupgradingto$o = "Thank you for upgrading to";
const CareerflowPremium$o = "Career flow Premium";
const hereIsHowYouCanAccessPremium$o = "Here's how to access your Premium benefits!";
const stepOne$o = "Step 1";
const DownloadourChromeExtension$o = "Download our Chrome Extension";
const youJobSearchCopilotIshere$o = "Your Job Search's AI Copilot is here.";
const DownloadNow$o = "Download Now";
const stepTwo$o = "Step 2";
const GetStarted$o = "Get Started";
const stepThree$o = "Step 3";
const SignintoChromeExtension$o = "Sign into Chrome Extension";
const entityCreated$o = "New {{entity}} created";
const entityUpdated$o = "{{entity}} updated";
const entityDeleted$o = "{{entity}} deleted";
const entityLinked$o = "{{entity}} linked";
const entityUnlinked$o = "{{entity}} unlinked";
const entityMovedTo$o = "Moved to {{entity}}";
const youAddedANewEntity$o = "You added a new {{entity}}";
const personCreated$o = "{{creator}} created a {{entity}} for {{owner}}";
const youUpdatedAEntity$o = "You updated a {{entity}}";
const personUpdated$o = "{{creator}} updated a {{entity}} for {{owner}}";
const youDeletedAEntity$o = "You deleted a {{entity}}";
const personDeleted$o = "{{creator}} deleted a {{entity}} for {{owner}}";
const youLinkedEntity$o = "You linked a {{entity}} to this Job";
const personLinked$o = "{{creator}} linked a {{entity}} to this Job for {{owner}}";
const youUnlinked$o = "You un-linked a {{entity}} to this Job";
const personUnlinked$o = "{{creator}} unlinked a {{entity}} to this Job for {{owner}}";
const youMovedEntity$o = "You moved this {{entity}} from {{sectionFrom}} to {{sectionTo}}";
const personMoved$o = "{{creator}} moved this {{entity}} from {{sectionFrom}} to {{sectionTo}} for {{owner}}";
const addedByName$o = "Added by {{name}}";
const DownloadChromeExtension$o = "Download Chrome Extension";
const ourChromeExtensionIs$o = "Our chrome extension is an integrated tool to help you optimize LinkedIn profile, save jobs, save contacts, generate cover letter and more";
const Optimizeyourprofile$o = "Optimize your LinkedIn profile";
const startOptimizingYourProfile$o = "Start optimizing your profile to have better chances of getting contacted by recruiters.";
const OptimizeNow$o = "Optimize Now";
const Addyourfirstjob$o = "Add your first job";
const startSavingJobApplicationsToTrack$o = "Start saving job applications to track your job search journey and find useful insights.";
const AddNow$o = "Add Now";
const CompleteProfile$o = "Complete Profile";
const completeYourProfileForUsing$o = "Complete your profile for using auto-fill feature and getting a more personalized experience.";
const CompleteNow$o = "Complete Now";
const Addyourfirstcontact$o = "Add your first contact";
const addContactToFollowUpWith$o = "Add contact to follow up with them for later, add notes, and more.";
const JoinCommunity$o = "Join Community";
const ourCommunityisAlways$o = "Our community is always there with you in your job search journey.";
const JoinNow$o = "Join Now";
const welcomeToCareerflow$o = "Welcome to Careerflow!";
const yourHubForCareerInsights2$o = "This is your hub for career insights, activities, and more. Explore your personalized dashboard to stay on top of your professional journey.";
const ChecklistCompleted$o = "Your checklist is completed!";
const Completeyourchecklist$o = "Complete your checklist";
const completeAFewStepsTo$o = "Complete a few steps to land your next job.";
const Completed$o = "Completed";
const JobCountByStage$o = "Job Count By Stage";
const NopastapplicationDatafound$o = "No past application Data found";
const YourJobSearchStages$o = "Your job search stages";
const NoDatafound$o = "No Data found";
const JobApplicationAutofill = "Job Application Autofill";
const AIMockInterview = "AI Mock Interview";
const AIResumeOptimizer = "AI Resume Optimizer";
const MockInterview = "Mock Interview";
const AIResumeBuilder = "AI Resume Builder";
const SwitchToCoachView = "Switch to Coach View";
const HelpCenter = "Help Center";
const ElevatorPitchHistory = "Elevator Pitch History";
const NoElevatorPitchGenerated = "No Elevator Pitch Generated";
const ElevatorPitch = "Elevator Pitch";
const getStartedElevatorPitch = "You have not generated any elevator pitches yet. Get started!";
const cloneResume = "Clone Resume";
const myResumes = "My Resumes";
const crerateOrEditResume = "Create/Edit, analyze, and organize your resumes for diverse opportunities.";
const studentCreatedResume = "This is a non-editable document, in order to edit please clone this document";
const editable = "Editable";
const Coach = "Coach";
const Student = "Student";
const EnterDocumentUrl = "Enter Document Url";
const AddResource = "Add Resource";
const en = {
	copyToClipboard: copyToClipboard$o,
	UnlocktheAIgenerated: UnlocktheAIgenerated$o,
	UpgradetoPremium: UpgradetoPremium$o,
	Result: Result$o,
	Copy: Copy$o,
	Save: Save$o,
	Edit: Edit$o,
	Processing: Processing$o,
	YourAIgeneratedcontentwillshowhere: YourAIgeneratedcontentwillshowhere$o,
	hopeYouFindUseful: hopeYouFindUseful$o,
	regenerate: regenerate$o,
	ProvideAdditionalFeedback: ProvideAdditionalFeedback$o,
	Enteranyfeedback: Enteranyfeedback$o,
	Notimpressive: Notimpressive$o,
	thisIsntTrue: thisIsntTrue$o,
	Notpersonalized: Notpersonalized$o,
	Tone: Tone$o,
	Length: Length$o,
	Template: Template$o,
	Generatedon: Generatedon$o,
	Copiedtoclipboard: Copiedtoclipboard$o,
	CopytoClipboard: CopytoClipboard$o,
	DownloadasPDF: DownloadasPDF$o,
	ViewDetails: ViewDetails$o,
	JobDescriptionImported: JobDescriptionImported$o,
	ImportfromJob: ImportfromJob$o,
	Saved: Saved$o,
	Applied: Applied$o,
	Offer: Offer$o,
	Interviewing: Interviewing$o,
	Rejected: Rejected$o,
	Search: Search$o,
	Import: Import$o,
	CoverLetterGeneratorHistory: CoverLetterGeneratorHistory$o,
	NoCoverLettersGenerated: NoCoverLettersGenerated$o,
	getStartedCoverLetter: getStartedCoverLetter$o,
	getStarted: getStarted$o,
	Documents: Documents$o,
	UploadNewDocument: UploadNewDocument$o,
	AICoverLetterGenerator: AICoverLetterGenerator$o,
	ViewHistory: ViewHistory$o,
	JobDescription: JobDescription$o,
	ImportfromBoard: ImportfromBoard$o,
	EnterJobDescription: EnterJobDescription$o,
	JobTitle: JobTitle$o,
	EnterJobTitle: EnterJobTitle$o,
	CompanyName: CompanyName$o,
	EnterCompanyName: EnterCompanyName$o,
	YourProfile: YourProfile$o,
	ResumeUpload: ResumeUpload$o,
	UseLinkedinProfile: UseLinkedinProfile$o,
	Uploadyourresume: Uploadyourresume$o,
	AddyourResume: AddyourResume$o,
	fileNameCannotFormat: fileNameCannotFormat$o,
	ChooseorUpload: ChooseorUpload$o,
	SelectTemplate: SelectTemplate$o,
	Preview: Preview$o,
	UseTemplate: UseTemplate$o,
	Change: Change$o,
	AdvancedSettings: AdvancedSettings$o,
	AdditionalContext: AdditionalContext$o,
	Professional: Professional$o,
	Casual: Casual$o,
	Enthusiastic: Enthusiastic$o,
	Informational: Informational$o,
	Short: Short$o,
	Medium: Medium$o,
	Long: Long$o,
	Language: Language$o,
	iAmOkayBack: iAmOkayBack$o,
	Generate: Generate$o,
	CoverLetter: CoverLetter$o,
	SelectLanguage: SelectLanguage$o,
	AboutGeneratorHistory: AboutGeneratorHistory$o,
	NoAboutsGenerated: NoAboutsGenerated$o,
	getStartedAbouts: getStartedAbouts$o,
	noAttachmentsFound: noAttachmentsFound$o,
	TargetJobTitle: TargetJobTitle$o,
	KeywordsToInclude: KeywordsToInclude$o,
	UploadYourResume: UploadYourResume$o,
	AddYourResume: AddYourResume$o,
	LinkedinProfile: LinkedinProfile$o,
	Linkedinprofilenotfound: Linkedinprofilenotfound$o,
	startUsingChromeExtension: startUsingChromeExtension$o,
	Download: Download$o,
	UseEmojis: UseEmojis$o,
	UseBulletPoints: UseBulletPoints$o,
	SpeechFocus: SpeechFocus$o,
	FirstPerson: FirstPerson$o,
	ThirdPerson: ThirdPerson$o,
	HeadlineGeneratorHistory: HeadlineGeneratorHistory$o,
	NoHeadlinesGenerated: NoHeadlinesGenerated$o,
	getStartedHeadline: getStartedHeadline$o,
	AIHeadlineGenerator: AIHeadlineGenerator$o,
	KeywordstoInclude: KeywordstoInclude$o,
	Pressenteraftereachword: Pressenteraftereachword$o,
	LinkedinProfilenotfound: LinkedinProfilenotfound$o,
	Headline: Headline$o,
	PostGeneratorHistory: PostGeneratorHistory$o,
	NoPostsGenerated: NoPostsGenerated$o,
	getStartedPost: getStartedPost$o,
	Topic: Topic$o,
	Description: Description$o,
	DescriptionPlaceholder: DescriptionPlaceholder,
	UseHashtags: UseHashtags$o,
	Custom: Custom$o,
	EnterCustomTone: EnterCustomTone$o,
	Added: Added$o,
	ComingSoon: ComingSoon$o,
	Company: Company$o,
	JobInterview: JobInterview$o,
	Research: Research$o,
	Networking: Networking$o,
	Referral: Referral$o,
	MustbeContacted: MustbeContacted$o,
	ScheduleaMeeting: ScheduleaMeeting$o,
	needAFollowUp: needAFollowUp$o,
	Today: Today$o,
	Viewdetails: Viewdetails$o,
	Activity: Activity$o,
	ActivityDetails: ActivityDetails$o,
	Delete: Delete$o,
	Title: Title$o,
	Goal: Goal$o,
	Status: Status$o,
	FollowUp: FollowUp$o,
	AddActivity: AddActivity$o,
	Enteractivitytitle: Enteractivitytitle$o,
	Cancel: Cancel$o,
	SaveActivity: SaveActivity$o,
	noActivityPresent: noActivityPresent$o,
	Addnew: Addnew$o,
	About: About$o,
	noDataPresentYou: noDataPresentYou$o,
	Experience: Experience$o,
	Education: Education$o,
	Skills: Skills$o,
	Overview: Overview$o,
	LinkedJobs: LinkedJobs$o,
	Notes: Notes$o,
	FullName: FullName$o,
	Location: Location$o,
	Relationship: Relationship$o,
	Contacts: Contacts$o,
	CreateContact: CreateContact$o,
	NotesCreated: NotesCreated$o,
	Notesupdated: Notesupdated$o,
	Addnote: Addnote$o,
	areYouSureDeleteNote: areYouSureDeleteNote$o,
	Createdby: Createdby$o,
	notSureWhyResumeCalls: notSureWhyResumeCalls$o,
	getExpertResumeReview: getExpertResumeReview$o,
	youHaventAddedContacts: youHaventAddedContacts$o,
	noMatchingContacts: noMatchingContacts$o,
	Link: Link$o,
	unlink: unlink$o,
	Locationnotavailable: Locationnotavailable$o,
	Emailnotavailable: Emailnotavailable$o,
	PhoneNumbernotavailable: PhoneNumbernotavailable$o,
	createdby: createdby$o,
	areYouSureDeleteContact: areYouSureDeleteContact$o,
	areYouSureUnlinkContact: areYouSureUnlinkContact$o,
	Addedbyyou: Addedbyyou$o,
	Addedby: Addedby$o,
	Timeline: Timeline$o,
	Timelineempty: Timelineempty$o,
	Discard: Discard$o,
	SaveContact: SaveContact$o,
	Recruiter: Recruiter$o,
	Candidate: Candidate$o,
	Colleague: Colleague$o,
	Employee: Employee$o,
	"Needtofollow-up": "Need to follow-up",
	EnterValidEmail: EnterValidEmail$o,
	EnterValidPhoneNumber: EnterValidPhoneNumber$o,
	editingProfileNotAvailable: editingProfileNotAvailable$o,
	itWillBeSoonAvailable: itWillBeSoonAvailable$o,
	ChromeExtension: ChromeExtension$o,
	SelectTag: SelectTag$o,
	FirstName: FirstName$o,
	FirstNameisrequired: FirstNameisrequired$o,
	LastName: LastName$o,
	LastNameisrequired: LastNameisrequired$o,
	Companyisrequired: Companyisrequired$o,
	Email: Email$o,
	ThisisnotavalidEmail: ThisisnotavalidEmail$o,
	AddEmail: AddEmail$o,
	PhoneNumber: PhoneNumber$o,
	notaValidPhone: notaValidPhone$o,
	phoneNoMinimum5char: phoneNoMinimum5char$o,
	phoneNoMinumum15char: phoneNoMinumum15char$o,
	AddPhoneNumber: AddPhoneNumber$o,
	SelectGoal: SelectGoal$o,
	SelectStatus: SelectStatus$o,
	Followup: Followup$o,
	SocialMedia: SocialMedia$o,
	Linkedinhandle: Linkedinhandle$o,
	Twitterhandle: Twitterhandle$o,
	Facebookhandle: Facebookhandle$o,
	Githubhandle: Githubhandle$o,
	Gmailhandle: Gmailhandle$o,
	Changessavedsuccessfully: Changessavedsuccessfully$o,
	EditContact: EditContact$o,
	BasicInformation: BasicInformation$o,
	EditContactDetails: EditContactDetails$o,
	SaveChanges: SaveChanges$o,
	phoneNoMinimum14char: phoneNoMinimum14char$o,
	LinkedIn: LinkedIn$o,
	Twitter: Twitter$o,
	Facebook: Facebook$o,
	Github: Github$o,
	Gmail: Gmail$o,
	youCanWriteAbout: youCanWriteAbout$o,
	Addednewsection: Addednewsection$o,
	Removedsuccessfully: Removedsuccessfully$o,
	Remove: Remove$o,
	Institute: Institute$o,
	Schoolisrequired: Schoolisrequired$o,
	Degree: Degree$o,
	StartMonth: StartMonth$o,
	StartYear: StartYear$o,
	EndMonth: EndMonth$o,
	EndYear: EndYear$o,
	Addmore: Addmore$o,
	PositionTitle: PositionTitle$o,
	ExperienceType: ExperienceType$o,
	Addednewitem: Addednewitem$o,
	whatSkillsDoYouEnjoy: whatSkillsDoYouEnjoy$o,
	Typeskillshere: Typeskillshere$o,
	LinkedContacts: LinkedContacts$o,
	LinkContact: LinkContact$o,
	NocontactsLinked: NocontactsLinked$o,
	JobContactsComponent: JobContactsComponent$o,
	Nocontacts: Nocontacts$o,
	LinkJobto: LinkJobto$o,
	Contact: Contact$o,
	Document: Document$o,
	Nojobsfound: Nojobsfound$o,
	LinkJob: LinkJob$o,
	youCanLinkContactJobImported: youCanLinkContactJobImported$o,
	Prev: Prev$o,
	Next: Next$o,
	areYouSureUnlinkDocument: areYouSureUnlinkDocument$o,
	areYouSureDeleteDocument: areYouSureDeleteDocument$o,
	Category: Category$o,
	CreatedOn: CreatedOn$o,
	Joblinked: Joblinked$o,
	Quickactions: Quickactions$o,
	All: All$o,
	Resume: Resume$o,
	Portfolio: Portfolio$o,
	Other: Other$o,
	Adddocument: Adddocument$o,
	Type: Type$o,
	Sortingby: Sortingby$o,
	SwitchtoGridLayout: SwitchtoGridLayout$o,
	SwitchtoListLayout: SwitchtoListLayout$o,
	NoDocumentsAdded: NoDocumentsAdded$o,
	DocumentsComponent: DocumentsComponent$o,
	NoDocumentFound: NoDocumentFound$o,
	SelectFile: SelectFile$o,
	onlyPdfDocxSupported: onlyPdfDocxSupported$o,
	Uploadfile: Uploadfile$o,
	DocumentCategory: DocumentCategory$o,
	SaveDocument: SaveDocument$o,
	AddDocument: AddDocument$o,
	LinkedDocuments: LinkedDocuments$o,
	LinkDocument: LinkDocument$o,
	NodocumentsLinked: NodocumentsLinked$o,
	JobDocumentsComponent: JobDocumentsComponent$o,
	NoDocuments: NoDocuments$o,
	CreateDocuments: CreateDocuments$o,
	youCanLinkDocumentJobImported: youCanLinkDocumentJobImported$o,
	Documenteditedsuccessfully: Documenteditedsuccessfully$o,
	DocumentDetails: DocumentDetails$o,
	ResumeCreatedByStudent: ResumeCreatedByStudent,
	ViewResume: ViewResume,
	UnsavedChanges: UnsavedChanges$o,
	yourChangesWillBeLostSureClose: yourChangesWillBeLostSureClose$o,
	yourChangesWillBeLostSureDiscard: yourChangesWillBeLostSureDiscard$o,
	DiscardChanges: DiscardChanges$o,
	WeeklyGoalAlert: WeeklyGoalAlert$o,
	Progress: Progress$o,
	AllGoals: AllGoals$o,
	Name: Name$o,
	Completedon: Completedon$o,
	Createdon: Createdon$o,
	Action: Action$o,
	Back: Back$o,
	OverallScore: OverallScore$o,
	Aboutthegoal: Aboutthegoal$o,
	GoalTracking: GoalTracking$o,
	Week: Week$o,
	progress: progress$o,
	loading: loading$o,
	Apply: Apply$o,
	Thisskillhasbeenreported: Thisskillhasbeenreported$o,
	issueGettingResume: issueGettingResume$o,
	Interview: Interview$o,
	Tasks: Tasks$o,
	Loading: Loading$o,
	Skilladdedsuccessfully: Skilladdedsuccessfully$o,
	problemAddingSkill: problemAddingSkill$o,
	Reportaproblem: Reportaproblem$o,
	Submit: Submit$o,
	Addanewskill: Addanewskill$o,
	JobDetailsComponent: JobDetailsComponent$o,
	yesIncludeThisSkill: yesIncludeThisSkill,
	HardSkill: HardSkill$o,
	SoftSkill: SoftSkill$o,
	Pleaseshareanyadditionalcontext: Pleaseshareanyadditionalcontext$o,
	Addasskill: Addasskill$o,
	Skill: Skill$o,
	JobFrequency: JobFrequency$o,
	ResumeFrequency: ResumeFrequency$o,
	Reportskill: Reportskill$o,
	JobDetails: JobDetails$o,
	ViewJobLink: ViewJobLink$o,
	Salary: Salary$o,
	areYouSureDeleteJob: areYouSureDeleteJob$o,
	ViewMore: ViewMore$o,
	ViewLess: ViewLess$o,
	matchYouSkillsAgainstJob: matchYouSkillsAgainstJob$o,
	pleaseUploadResumeSkillMatch: pleaseUploadResumeSkillMatch$o,
	AddResume: AddResume$o,
	thisJobDoesNotHaveAnyDesc: thisJobDoesNotHaveAnyDesc$o,
	youCanEditJobToAdd: youCanEditJobToAdd$o,
	chromeextension: chromeextension$o,
	fromVariousJobPortalsOnce: fromVariousJobPortalsOnce$o,
	AddDescription: AddDescription$o,
	CompanyInfo: CompanyInfo$o,
	Website: Website$o,
	Industry: Industry$o,
	EmployeeCount: EmployeeCount$o,
	ExprienceLevel: ExprienceLevel$o,
	Address: Address$o,
	Resumes: Resumes$o,
	Setasdefault: Setasdefault$o,
	Ok: Ok$o,
	UploadNewResume: UploadNewResume$o,
	Default: Default$o,
	Jobnotfound: Jobnotfound$o,
	EditDetails: EditDetails$o,
	JobPostURL: JobPostURL$o,
	Enterjoburl: Enterjoburl$o,
	Nojobselected: Nojobselected$o,
	Viewjobdetails: Viewjobdetails$o,
	Jobaddedtoyourboardsuccessfully: Jobaddedtoyourboardsuccessfully$o,
	AddJob: AddJob$o,
	Addnewjobname: Addnewjobname$o,
	JobUrl: JobUrl$o,
	Addjoburl: Addjoburl$o,
	Section: Section$o,
	didYouKnow: didYouKnow$o,
	Jobs: Jobs$o,
	AddJobtoboard: AddJobtoboard$o,
	Currentlynojobsareavailable: Currentlynojobsareavailable$o,
	noMatchingJobs: noMatchingJobs$o,
	welcomeToYourPersonalJobTracker: welcomeToYourPersonalJobTracker$o,
	weShortTutorialOnHowTrackingJob: weShortTutorialOnHowTrackingJob$o,
	Addanewjob: Addanewjob$o,
	inOrderTrackCreatButton: inOrderTrackCreatButton$o,
	Providesomedetails: Providesomedetails$o,
	toBeginTypeJobTitleCompany: toBeginTypeJobTitleCompany$o,
	asAnExampleFilledForYou: asAnExampleFilledForYou$o,
	wohooAddedFirstJob: wohooAddedFirstJob$o,
	youCanDragDropJobCard: youCanDragDropJobCard$o,
	Lastbutnotleast: Lastbutnotleast$o,
	finalStepMakeSure: finalStepMakeSure$o,
	autoMaticallyImportJobs: autoMaticallyImportJobs$o,
	selectanysection: selectanysection$o,
	Accept: Accept$o,
	My2023JobSearch: My2023JobSearch$o,
	AddedFrom: AddedFrom$o,
	AddedUntil: AddedUntil$o,
	BasicModal: BasicModal$o,
	AddnewSectionName: AddnewSectionName$o,
	OpenTo: OpenTo$o,
	Featured: Featured$o,
	LicenceAndCerts: LicenceAndCerts$o,
	Banner: Banner$o,
	LinkedInURL: LinkedInURL$o,
	Recommendations: Recommendations$o,
	LinkedinReview: LinkedinReview$o,
	NoDataAvailable: NoDataAvailable$o,
	looksLikeYouDidNot: looksLikeYouDidNot$o,
	toOptimizeProfileScoreVisible: toOptimizeProfileScoreVisible$o,
	LinkedinComponent: LinkedinComponent$o,
	improveYourChancesLandingDreamJob: improveYourChancesLandingDreamJob$o,
	VisitProfile: VisitProfile$o,
	wantToGetLinkedinMakeover: wantToGetLinkedinMakeover$o,
	PostGenerator: PostGenerator$o,
	LinkedinHeadlineGenerator: LinkedinHeadlineGenerator$o,
	LinkedinAboutSectionGenerator: LinkedinAboutSectionGenerator$o,
	AITools: AITools$o,
	Premium: Premium$o,
	LinkedInOptimization: LinkedInOptimization$o,
	JobTracker: JobTracker$o,
	whoIsHiring: whoIsHiring$o,
	Autofill: Autofill$o,
	HeadlineGenerator: HeadlineGenerator$o,
	skillMatching: skillMatching$o,
	SummarizeJD: SummarizeJD$o,
	contactFeature: contactFeature$o,
	documentFeature: documentFeature$o,
	landJobWithoutStress: landJobWithoutStress$o,
	discoverFeatures: discoverFeatures$o,
	letsBeginOnboarding: letsBeginOnboarding$o,
	inTheNextFewScreensJobThirdParties: inTheNextFewScreensJobThirdParties$o,
	letsAddBasicInformation: letsAddBasicInformation$o,
	Pleaseselectanoptionfirst: Pleaseselectanoptionfirst$o,
	JobApplicationTracker: JobApplicationTracker$o,
	LinkedInProfileOptimizer: LinkedInProfileOptimizer$o,
	UnlimitedDocuments: UnlimitedDocuments$o,
	UnlimitedContacts: UnlimitedContacts$o,
	HiringManagerSearch: HiringManagerSearch$o,
	AILinkedInPostGenerator: AILinkedInPostGenerator$o,
	ATSKeywordSkillMatch: ATSKeywordSkillMatch$o,
	"Auto-Apply": "Auto-Apply",
	ChooseyourPlan: ChooseyourPlan$o,
	superChargeYourJobSearch: superChargeYourJobSearch$o,
	startNowGoto: startNowGoto$o,
	CreatedBy: CreatedBy$o,
	CreateNewNote: CreateNewNote$o,
	Nonotescreated: Nonotescreated$o,
	approxTimeIsFourMinutes: approxTimeIsFourMinutes$o,
	Continue: Continue$o,
	iWillDoLaterTakeMeToApp: iWillDoLaterTakeMeToApp$o,
	allDone: allDone$o,
	welcomeAbord: welcomeAbord$o,
	letsBegin: letsBegin$o,
	UpgradeyourplanandgetAIAssistance: UpgradeyourplanandgetAIAssistance$o,
	DownloadPDF: DownloadPDF$o,
	oopsWeCouldntProcessResume: oopsWeCouldntProcessResume$o,
	MyProfile: MyProfile$o,
	Setting: Setting$o,
	Logout: Logout$o,
	SignIn: SignIn$o,
	Typeyourfirstnamehere: Typeyourfirstnamehere$o,
	Enteryourlastname: Enteryourlastname$o,
	ManageSubscription: ManageSubscription$o,
	ifYouHaveDifficultiesProfile: ifYouHaveDifficultiesProfile$o,
	forSupport: forSupport$o,
	whatIsIdealCompanySize: whatIsIdealCompanySize$o,
	Saveandcontinue: Saveandcontinue$o,
	whatIsMinExpectedSalary: whatIsMinExpectedSalary$o,
	Atleast: Atleast$o,
	SlidetoAdjust: SlidetoAdjust$o,
	whatIndustryExcitedWork: whatIndustryExcitedWork$o,
	Add: Add$o,
	statusOfJobSearch: statusOfJobSearch$o,
	Finish: Finish$o,
	whatLevelRoleLooking: whatLevelRoleLooking$o,
	Selectuptotwo: Selectuptotwo$o,
	PreviousStep: PreviousStep$o,
	Skip: Skip$o,
	whatDoYouValueNewRole: whatDoYouValueNewRole$o,
	Selectuptothree: Selectuptothree$o,
	EqualEmploymentData: EqualEmploymentData$o,
	whatIsYourEthnicity: whatIsYourEthnicity$o,
	areYouAuthorizedToWorkUs: areYouAuthorizedToWorkUs$o,
	willYouRequireSponsorShip: willYouRequireSponsorShip$o,
	doYouHaveADisability: doYouHaveADisability$o,
	areYouAVeteran: areYouAVeteran$o,
	rolesYouInterestedIn: rolesYouInterestedIn$o,
	Selectuptofive: Selectuptofive$o,
	AddCustomrole: AddCustomrole$o,
	whereDoYouLikeWork: whereDoYouLikeWork$o,
	Resources: Resources$o,
	currentlyNoResourceAvailable: currentlyNoResourceAvailable$o,
	AddNewSection: AddNewSection$o,
	ChangeSections: ChangeSections$o,
	Settings: Settings$o,
	Dashboard: Dashboard$o,
	JobBoard: JobBoard$o,
	Linkedin: Linkedin$o,
	Community: Community$o,
	FindRecruiters: FindRecruiters$o,
	Goals: Goals$o,
	DownloadExtension: DownloadExtension$o,
	SuggestaFeature: SuggestaFeature$o,
	leftPanel: leftPanel$o,
	PhoneNumberisrequired: PhoneNumberisrequired$o,
	MobileNumber: MobileNumber$o,
	Enteronlynumbers: Enteronlynumbers$o,
	Countryyoulivein: Countryyoulivein$o,
	SelectaCountry: SelectaCountry$o,
	DateofBirth: DateofBirth$o,
	Gender: Gender$o,
	JobPreferences: JobPreferences$o,
	pleaseEnterValidEmail: pleaseEnterValidEmail$o,
	emailSendForResetting: emailSendForResetting$o,
	VerifyyourEmailID: VerifyyourEmailID$o,
	sentPleaseCheckEmail: sentPleaseCheckEmail$o,
	tooManyAttemptsTryAgain: tooManyAttemptsTryAgain$o,
	Resend: Resend$o,
	Login: Login$o,
	weHaveSentVerificationLinkAtEmail: weHaveSentVerificationLinkAtEmail$o,
	pleaseVerifyEmailContinueSpam: pleaseVerifyEmailContinueSpam$o,
	Logintogetstarted: Logintogetstarted$o,
	ContinuewithGoogle: ContinuewithGoogle$o,
	pleaseInputEmail: pleaseInputEmail$o,
	Password: Password$o,
	pleaseInputPassword: pleaseInputPassword$o,
	passwordLowerUpperDigitSpecial: passwordLowerUpperDigitSpecial$o,
	atLeastSixChar: atLeastSixChar$o,
	forgotPassword: forgotPassword$o,
	Bysigninginyouagreetoour: Bysigninginyouagreetoour$o,
	Terms: Terms$o,
	Conditions: Conditions$o,
	and: and$o,
	PrivacyPolicy: PrivacyPolicy$o,
	theseAreTheTopsSkillsExtracted: theseAreTheTopsSkillsExtracted$o,
	TopSkills: TopSkills$o,
	weCoulNotExtractSkills: weCoulNotExtractSkills$o,
	upgradeToPremiumToView: upgradeToPremiumToView$o,
	SkillScore: SkillScore$o,
	thisIsYourSkillScoreBasedOn: thisIsYourSkillScoreBasedOn$o,
	theseSkllsAreStrongMatch: theseSkllsAreStrongMatch$o,
	Strongmatch: Strongmatch$o,
	theseSkillsArePartialMatch: theseSkillsArePartialMatch$o,
	Partialmatch: Partialmatch$o,
	theseSkillsAreMissingFrom: theseSkillsAreMissingFrom$o,
	"Missing Keywords": "Missing Keywords",
	SkillMatchComponent: SkillMatchComponent$o,
	Optional: Optional$o,
	Notrelevanttothejob: Notrelevanttothejob$o,
	Notaskill: Notaskill$o,
	Toogeneric: Toogeneric$o,
	Pleaseshareanyfeedback: Pleaseshareanyfeedback$o,
	excludedKeywordsWillNot: excludedKeywordsWillNot$o,
	yesExcludeThisSkillFrom: yesExcludeThisSkillFrom$o,
	PartialMatch: PartialMatch$o,
	MissingKeywords: MissingKeywords$o,
	Providetitletotask: Providetitletotask$o,
	TasksList: TasksList$o,
	AddTask: AddTask$o,
	EnterTaskTitlehere: EnterTaskTitlehere$o,
	TasksComponent: TasksComponent$o,
	CompletedTasks: CompletedTasks$o,
	CompleteYourtasks: CompleteYourtasks$o,
	Steps: Steps$o,
	PremiumMember: PremiumMember$o,
	Thankyouforupgradingto: Thankyouforupgradingto$o,
	CareerflowPremium: CareerflowPremium$o,
	hereIsHowYouCanAccessPremium: hereIsHowYouCanAccessPremium$o,
	stepOne: stepOne$o,
	DownloadourChromeExtension: DownloadourChromeExtension$o,
	youJobSearchCopilotIshere: youJobSearchCopilotIshere$o,
	DownloadNow: DownloadNow$o,
	stepTwo: stepTwo$o,
	GetStarted: GetStarted$o,
	stepThree: stepThree$o,
	SignintoChromeExtension: SignintoChromeExtension$o,
	entityCreated: entityCreated$o,
	entityUpdated: entityUpdated$o,
	entityDeleted: entityDeleted$o,
	entityLinked: entityLinked$o,
	entityUnlinked: entityUnlinked$o,
	entityMovedTo: entityMovedTo$o,
	youAddedANewEntity: youAddedANewEntity$o,
	personCreated: personCreated$o,
	youUpdatedAEntity: youUpdatedAEntity$o,
	personUpdated: personUpdated$o,
	youDeletedAEntity: youDeletedAEntity$o,
	personDeleted: personDeleted$o,
	youLinkedEntity: youLinkedEntity$o,
	personLinked: personLinked$o,
	youUnlinked: youUnlinked$o,
	personUnlinked: personUnlinked$o,
	youMovedEntity: youMovedEntity$o,
	personMoved: personMoved$o,
	addedByName: addedByName$o,
	DownloadChromeExtension: DownloadChromeExtension$o,
	ourChromeExtensionIs: ourChromeExtensionIs$o,
	Optimizeyourprofile: Optimizeyourprofile$o,
	startOptimizingYourProfile: startOptimizingYourProfile$o,
	OptimizeNow: OptimizeNow$o,
	Addyourfirstjob: Addyourfirstjob$o,
	startSavingJobApplicationsToTrack: startSavingJobApplicationsToTrack$o,
	AddNow: AddNow$o,
	CompleteProfile: CompleteProfile$o,
	completeYourProfileForUsing: completeYourProfileForUsing$o,
	CompleteNow: CompleteNow$o,
	Addyourfirstcontact: Addyourfirstcontact$o,
	addContactToFollowUpWith: addContactToFollowUpWith$o,
	JoinCommunity: JoinCommunity$o,
	ourCommunityisAlways: ourCommunityisAlways$o,
	JoinNow: JoinNow$o,
	welcomeToCareerflow: welcomeToCareerflow$o,
	yourHubForCareerInsights2: yourHubForCareerInsights2$o,
	ChecklistCompleted: ChecklistCompleted$o,
	Completeyourchecklist: Completeyourchecklist$o,
	completeAFewStepsTo: completeAFewStepsTo$o,
	Completed: Completed$o,
	JobCountByStage: JobCountByStage$o,
	NopastapplicationDatafound: NopastapplicationDatafound$o,
	YourJobSearchStages: YourJobSearchStages$o,
	NoDatafound: NoDatafound$o,
	JobApplicationAutofill: JobApplicationAutofill,
	AIMockInterview: AIMockInterview,
	AIResumeOptimizer: AIResumeOptimizer,
	MockInterview: MockInterview,
	AIResumeBuilder: AIResumeBuilder,
	SwitchToCoachView: SwitchToCoachView,
	HelpCenter: HelpCenter,
	ElevatorPitchHistory: ElevatorPitchHistory,
	NoElevatorPitchGenerated: NoElevatorPitchGenerated,
	ElevatorPitch: ElevatorPitch,
	"Enter any additional instructions or information": "Enter any additional instructions or information",
	"Who is going to receive your pitch?": "Who is going to receive your pitch?",
	getStartedElevatorPitch: getStartedElevatorPitch,
	"Target Audience": "Target Audience",
	"What do you want the pitch to focus on?": "What do you want the pitch to focus on?",
	"Focus Area": "Focus Area",
	"Why are you pitching?": "Why are you pitching?",
	cloneResume: cloneResume,
	myResumes: myResumes,
	crerateOrEditResume: crerateOrEditResume,
	studentCreatedResume: studentCreatedResume,
	editable: editable,
	Coach: Coach,
	Student: Student,
	EnterDocumentUrl: EnterDocumentUrl,
	AddResource: AddResource
};

const copyToClipboard$n = "Копирано в клипборда!";
const UnlocktheAIgenerated$n = "Отключете генерираното от изкуствен интелект.";
const UpgradetoPremium$n = "Надстройка до Премиум";
const Result$n = "Резултат";
const Copy$n = "Копиране";
const Save$n = "Запази";
const Edit$n = "Редактирай";
const Processing$n = "Обработка";
const YourAIgeneratedcontentwillshowhere$n = "Тук ще се покаже вашият AI генериран съдържание";
const hopeYouFindUseful$n = "Надявам се, че този резултат ще бъде полезен за вас!";
const regenerate$n = "Прегенерирай";
const ProvideAdditionalFeedback$n = "Предоставете допълнителна обратна връзка";
const Enteranyfeedback$n = "Въведете всякаква обратна връзка";
const Notimpressive$n = "Не впечатляващо";
const thisIsntTrue$n = "Това не е вярно";
const Notpersonalized$n = "Не персонализирано";
const Tone$n = "Тон";
const Length$n = "Дължина";
const Template$n = "Шаблон";
const Generatedon$n = "Генерирано на";
const Copiedtoclipboard$n = "Копирано в клипборда.";
const CopytoClipboard$n = "Копиране в буфер";
const DownloadasPDF$n = "Изтегли като PDF";
const ViewDetails$n = "Преглед на детайлите";
const JobDescriptionImported$n = "Описание на работата - Импортирано";
const ImportfromJob$n = "Импорт от работа";
const Saved$n = "Запазено";
const Applied$n = "Приложено";
const Offer$n = "Предложение";
const Interviewing$n = "Интервюиране";
const Rejected$n = "Отхвърлено";
const Search$n = "Търсене";
const Import$n = "Внос";
const CoverLetterGeneratorHistory$n = "История на генератора за мотивационни писма";
const NoCoverLettersGenerated$n = "Не са генерирани мотивационни писма";
const getStartedCoverLetter$n = "Все още не сте генерирали нито едно мотивационно писмо. Започнете и създайте писма, като съчетаете обява за работа със своето съответстващо опит.";
const getStarted$n = "Започни!";
const Documents$n = "Документи";
const UploadNewDocument$n = "Качи нов документ";
const AICoverLetterGenerator$n = "Генератор на мотивационни писма с изкуствен интелект";
const ViewHistory$n = "Преглед на историята";
const JobDescription$n = "Обява за работа";
const ImportfromBoard$n = "Внасяне от дъска";
const EnterJobDescription$n = "Въведете обява за работа";
const JobTitle$n = "Длъжност";
const EnterJobTitle$n = "Въведете длъжност";
const CompanyName$n = "Име на компанията";
const EnterCompanyName$n = "Въведете име на компанията";
const YourProfile$n = "Вашият профил";
const ResumeUpload$n = "Качване на резюме";
const UseLinkedinProfile$n = "Използвайте профила си в LinkedIn";
const Uploadyourresume$n = "Качете вашето резюме";
const AddyourResume$n = "Добавете вашето резюме";
const fileNameCannotFormat$n = "Имената на файловете не могат да съдържат интервали или долни черти и трябва да бъдат във формат .doc, .docx или .pdf.";
const ChooseorUpload$n = "Изберете или качете";
const SelectTemplate$n = "Изберете шаблон";
const Preview$n = "Преглед";
const UseTemplate$n = "Използвайте шаблона";
const Change$n = "Промяна";
const AdvancedSettings$n = "Разширени настройки";
const AdditionalContext$n = "Допълнителен контекст";
const Professional$n = "Професионален";
const Casual$n = "Неофициален";
const Enthusiastic$n = "Ентусиазиран";
const Informational$n = "Информативен";
const Short$n = "Кратък";
const Medium$n = "Среден";
const Long$n = "Дълъг";
const Language$n = "Език";
const iAmOkayBack$n = "Всичко е наред! Назад";
const Generate$n = "Генерирай";
const CoverLetter$n = "Мотивационно писмо";
const SelectLanguage$n = "Изберете език";
const AboutGeneratorHistory$n = "История на генератора за информации";
const NoAboutsGenerated$n = "Не са генерирани информации";
const getStartedAbouts$n = "Все още не сте генерирали никакви информации. Започнете и създайте информации, като съчетаете обява за работа със своя съответстващ опит.";
const noAttachmentsFound$n = "Не са намерени прикачени файлове.";
const TargetJobTitle$n = "Целева длъжност";
const KeywordsToInclude$n = "Ключови думи за включване";
const UploadYourResume$n = "Качете своето резюме.";
const AddYourResume$n = "Добавете своето резюме.";
const LinkedinProfile$n = "Профил в LinkedIn";
const Linkedinprofilenotfound$n = "Профилът в LinkedIn не е намерен";
const startUsingChromeExtension$n = "Започнете оптимизацията на вашия профил в LinkedIn, като използвате нашето разширение за Chrome, за да използвате тази опция.";
const Download$n = "Изтегли";
const UseEmojis$n = "Използвайте емотикони";
const UseBulletPoints$n = "Използвайте маркерни точки";
const SpeechFocus$n = "Фокус на речта";
const FirstPerson$n = "Първо лице";
const ThirdPerson$n = "Трето лице";
const HeadlineGeneratorHistory$n = "История на генератора за заглавия";
const NoHeadlinesGenerated$n = "Не са генерирани заглавия";
const getStartedHeadline$n = "Все още не сте генерирали никакви заглавия. Започнете и създайте заглавия, като съчетаете обява за работа със своя съответстващ опит.";
const AIHeadlineGenerator$n = "Генератор на заглавия с изкуствен интелект";
const KeywordstoInclude$n = "Ключови думи за включване";
const Pressenteraftereachword$n = "Натиснете enter след всяка дума.";
const LinkedinProfilenotfound$n = "Профилът в LinkedIn не е намерен";
const Headline$n = "Главна идея";
const PostGeneratorHistory$n = "История на генератора за публикации";
const NoPostsGenerated$n = "Не са генерирани публикации";
const getStartedPost$n = "Все още не сте генерирали никакви публикации. Започнете и създайте публикации, като съчетаете обява за работа със своя съответстващ опит.";
const Topic$n = "Тема";
const Description$n = "Описание";
const UseHashtags$n = "Използвайте хаштаги";
const Custom$n = "Персонализиран";
const EnterCustomTone$n = "Въведете персонализиран тон";
const Added$n = "Добавено";
const ComingSoon$n = {
	header: "Инженерите работят!",
	content_1: "Нашата екип от инженери усилено работи, за да активира тази функция в близко бъдеще",
	content_2: "Искате ли тази функция скоро? Съобщете ни, като просто отметнете кутията по-долу.",
	content_3: "Искам тази функция"
};
const Company$n = "Компания";
const JobInterview$n = "Работно интервю";
const Research$n = "Изследване";
const Networking$n = "Мрежуване";
const Referral$n = "Препоръка";
const MustbeContacted$n = "Трябва да се свърже";
const ScheduleaMeeting$n = "Планиране на среща";
const needAFollowUp$n = "Трябва да направя последващо";
const Today$n = "Днес";
const Viewdetails$n = "Преглед на детайлите";
const Activity$n = "Дейност";
const ActivityDetails$n = "Детайли за дейността";
const Delete$n = "Изтрий";
const Title$n = "Заглавие";
const Goal$n = "Цел";
const Status$n = "Статус";
const FollowUp$n = "Следене";
const AddActivity$n = "Добави дейност";
const Enteractivitytitle$n = "Въведете заглавие на дейността";
const Cancel$n = "Отказ";
const SaveActivity$n = "Запази дейността";
const noActivityPresent$n = "Няма налична дейност, добавете дейност.";
const Addnew$n = "Добави ново";
const About$n = "Относно";
const noDataPresentYou$n = "Няма налични данни, можете да редактирате този контакт и да добавите полета.";
const Experience$n = "Опит";
const Education$n = "Образование";
const Skills$n = "Умения";
const Overview$n = "Преглед";
const LinkedJobs$n = "Свързани работни места";
const Notes$n = "Бележки";
const FullName$n = "Пълно име";
const Location$n = "Местоположение";
const Relationship$n = "Връзка";
const Contacts$n = "Контакти";
const CreateContact$n = "Създай контакт";
const NotesCreated$n = "Създадени бележки";
const Notesupdated$n = "Актуализирани бележки";
const Addnote$n = "Добави бележка";
const areYouSureDeleteNote$n = "Сигурни ли сте, че искате да изтриете тази бележка?";
const Createdby$n = "Създадено от";
const notSureWhyResumeCalls$n = "Не сте сигурни защо вашето резюме не ви донесе повиквания за интервюта? ☎️";
const getExpertResumeReview$n = "Получете професионално прегледано резюме 💎✨";
const youHaventAddedContacts$n = "Все още не сте добавили никакви контакти.";
const noMatchingContacts$n = "Не са намерени съвпадащи контакти.";
const Link$n = "Връзка";
const unlink$n = "Разкачи";
const Locationnotavailable$n = "Местоположението не е налично";
const Emailnotavailable$n = "Имейлът не е наличен";
const PhoneNumbernotavailable$n = "Телефонният номер не е наличен";
const createdby$n = "създадено от";
const areYouSureDeleteContact$n = "Сигурни ли сте, че искате да изтриете този контакт?";
const areYouSureUnlinkContact$n = "Сигурни ли сте, че искате да разкачите този контакт?";
const Addedbyyou$n = "Добавено от вас";
const Addedby$n = "Добавено от";
const Timeline$n = "График";
const Timelineempty$n = "Графикът е празен";
const Discard$n = "Отхвърли";
const SaveContact$n = "Запазване на контакт";
const Recruiter$n = "Рекрутер";
const Candidate$n = "Кандидат";
const Colleague$n = "Колега";
const Employee$n = "Служител";
const EnterValidEmail$n = "Въведете валиден имейл";
const EnterValidPhoneNumber$n = "Въведете валиден телефонен номер";
const editingProfileNotAvailable$n = "Редактирането на профилната снимка все още не е налично.";
const itWillBeSoonAvailable$n = "То ще бъде налично скоро в нашата.";
const ChromeExtension$n = "Разширение на Chrome";
const SelectTag$n = "Изберете таг";
const FirstName$n = "Първо име";
const FirstNameisrequired$n = "Името е задължително";
const LastName$n = "Фамилия";
const LastNameisrequired$n = "Фамилията е задължителна";
const Companyisrequired$n = "Компанията е задължителна";
const Email$n = "Имейл";
const ThisisnotavalidEmail$n = "Това не е валиден имейл.";
const AddEmail$n = "Добави имейл";
const PhoneNumber$n = "Телефонен номер";
const notaValidPhone$n = "Това не е валиден телефонен номер. Въведете само цифри.";
const phoneNoMinimum5char$n = "Телефонният номер трябва да е минимум 5 знака.";
const phoneNoMinumum15char$n = "Телефонният номер трябва да бъде максимум 15 знака.";
const AddPhoneNumber$n = "Добави телефонен номер";
const SelectGoal$n = "Избери цел";
const SelectStatus$n = "Изберете статус";
const Followup$n = "Следене";
const SocialMedia$n = "Социални медии";
const Linkedinhandle$n = "Профил в Linkedin";
const Twitterhandle$n = "Туитър ръка";
const Facebookhandle$n = "Фейсбук ръка";
const Githubhandle$n = "GitHub ръка";
const Gmailhandle$n = "Gmail ръка";
const Changessavedsuccessfully$n = "Промените са успешно запазени";
const EditContact$n = "Редактирай контакта";
const BasicInformation$n = "Основна информация";
const EditContactDetails$n = "Редактиране на данните за контакт";
const SaveChanges$n = "Запази промените";
const phoneNoMinimum14char$n = "Телефонният номер трябва да е минимум 14 знака.";
const LinkedIn$n = "LinkedIn";
const Twitter$n = "Туитър";
const Facebook$n = "Фейсбук";
const Github$n = "Github";
const Gmail$n = "Gmail";
const youCanWriteAbout$n = "Можете да пишете за годините си на опит, индустрията или уменията си. Хората също говорят за своите постижения или предишни работни опити.";
const Addednewsection$n = "Добавена е нова секция";
const Removedsuccessfully$n = "Успешно премахнато.";
const Remove$n = "Премахни";
const Institute$n = "Институт";
const Schoolisrequired$n = "Училището е задължително.";
const Degree$n = "Степен";
const StartMonth$n = "Начален месец";
const StartYear$n = "Година на стартиране";
const EndMonth$n = "Краят на месеца";
const EndYear$n = "Край на годината";
const Addmore$n = "Добави повече";
const PositionTitle$n = "Длъжност";
const ExperienceType$n = "Тип на преживяването";
const Addednewitem$n = "Добавен нов артикул";
const whatSkillsDoYouEnjoy$n = "Какви умения имате или се забавлявате да работите с тях?";
const Typeskillshere$n = "Въведете умения тук";
const LinkedContacts$n = "Свързани контакти";
const LinkContact$n = "Свържи контакт";
const NocontactsLinked$n = "Няма свързани контакти";
const JobContactsComponent$n = {
	linkContact: "Свързвайки контакти, бързо можете да видите кой са важните хора като рекрутер, мениджър по наемане и др. за тази роля! В бъдеще ще можем да предоставим съответни прозрения, базирани на вашите контакти."
};
const Nocontacts$n = "Няма контакти";
const LinkJobto$n = "Свържете работата с";
const Contact$n = "Контакт";
const Document$n = "Документ";
const Nojobsfound$n = "Не са намерени работи";
const LinkJob$n = "Свържи работа";
const youCanLinkContactJobImported$n = "Можете да свържете този контакт с работа, която сте импортирали в Careerflow.";
const Prev$n = "Предишен";
const Next$n = "Следващо";
const areYouSureUnlinkDocument$n = "Сигурни ли сте, че искате да разкачите този документ?";
const areYouSureDeleteDocument$n = "Сигурни ли сте, че искате да изтриете този документ?";
const Category$n = "Категория";
const CreatedOn$n = "Създадено на";
const Joblinked$n = "Работа свързана";
const Quickactions$n = "Бързи действия";
const All$n = "Всичко";
const Resume$n = "Резюме";
const Portfolio$n = "Портфолио";
const Other$n = "Друг";
const Adddocument$n = "Добави документ";
const Type$n = "Тип";
const Sortingby$n = "Сортиране по";
const SwitchtoGridLayout$n = "Превключване към решетъчен изглед.";
const SwitchtoListLayout$n = "Превключване към списъчен изглед.";
const NoDocumentsAdded$n = "Не са добавени документи";
const DocumentsComponent$n = {
	nodocs: "Все още не сте създали никакви документи. Можете да качвате версии на вашето резюме, мотивационни писма и други и да ги свързвате с работите, които проследявате!"
};
const NoDocumentFound$n = "Не е намерен документ";
const SelectFile$n = "Изберете файл";
const onlyPdfDocxSupported$n = "Поддържат се само .pdf и .docx формати.";
const Uploadfile$n = "Качете файл";
const DocumentCategory$n = "Категория на документа";
const SaveDocument$n = "Запази документа";
const AddDocument$n = "Добави документ";
const LinkedDocuments$n = "Свързани документи";
const LinkDocument$n = "Свържи документ";
const NodocumentsLinked$n = "Няма свързани документи";
const JobDocumentsComponent$n = {
	linkDocs: "Свързването на всички съответни документи като резюме, мотивационно писмо и др., които сте изпратили за тази работа, ще ви помогне да проследявате всичко на едно място. Опитайте го!"
};
const NoDocuments$n = "Няма документи";
const CreateDocuments$n = "Създай документи";
const youCanLinkDocumentJobImported$n = "Можете да свържете този документ с работа, която сте импортирали в Careerflow.";
const Documenteditedsuccessfully$n = "Документът е успешно редактиран";
const DocumentDetails$n = "Детайли за документа";
const UnsavedChanges$n = "Незапазени промени";
const yourChangesWillBeLostSureClose$n = "Вашите промени ще бъдат загубени, сигурни ли сте, че искате да затворите?";
const yourChangesWillBeLostSureDiscard$n = "Вашите промени ще бъдат загубени, сигурни ли сте, че искате да ги отхвърлите?";
const DiscardChanges$n = "Отхвърли промените";
const WeeklyGoalAlert$n = "Седмично предупреждение за целта";
const Progress$n = "Прогрес";
const AllGoals$n = "Всички цели";
const Name$n = "Име";
const Completedon$n = "Завършено на";
const Createdon$n = "Създадено на";
const Action$n = "Действие";
const Back$n = "Назад";
const OverallScore$n = "Общ резултат";
const Aboutthegoal$n = "Относно целта";
const GoalTracking$n = "Следене на целта";
const Week$n = "Седмица";
const progress$n = "прогрес";
const loading$n = "Зареждане";
const Apply$n = "Приложи";
const Thisskillhasbeenreported$n = "Тази умение е докладвано.";
const issueGettingResume$n = "Има проблем с получаването на резюмето.";
const Interview$n = "Интервю";
const Tasks$n = "Задачи";
const Loading$n = "Зареждане";
const Skilladdedsuccessfully$n = "Умение добавено успешно.";
const problemAddingSkill$n = "Има проблем при добавянето на умение.";
const Reportaproblem$n = "Докладвай проблем";
const Submit$n = "Изпрати";
const Addanewskill$n = "Добави нов умение";
const JobDetailsComponent$n = {
	classifySkill: "Как бихте класифицирали тази умение (по избор)?",
	includedKeywordsWillCount: "Включете ли тази ключова дума?",
	yesIncludeThisSkill: "Включените ключови думи ще намалят резултата на съвпадение при всички бъдещи сканирания. Можете да промените включените ключови думи от профила си.",
	addSkill: "Искате ли да добавите това като умение?"
};
const HardSkill$n = "Трудово умение";
const SoftSkill$n = "Меко умение";
const Pleaseshareanyadditionalcontext$n = "Моля, споделете всякакъв допълнителен контекст";
const Addasskill$n = "Добави като умение";
const Skill$n = "Умение";
const JobFrequency$n = "Честота на обявата за работа";
const ResumeFrequency$n = "Честота на резюмето";
const Reportskill$n = "Доклад за умение";
const JobDetails$n = "Детайли за работата";
const ViewJobLink$n = "Преглед на връзката за работа";
const Salary$n = "Заплата";
const areYouSureDeleteJob$n = "Сигурни ли сте, че искате да изтриете тази работа?";
const ViewMore$n = "Виж повече";
const ViewLess$n = "Виж по-малко";
const matchYouSkillsAgainstJob$n = "Сравнете уменията си с описанието на работата.";
const pleaseUploadResumeSkillMatch$n = "Моля качете своето резюме, за да получите оценка на съответствието на уменията ви.";
const AddResume$n = "Добави резюме";
const thisJobDoesNotHaveAnyDesc$n = "Тази работа няма описание.";
const youCanEditJobToAdd$n = "Можете да редактирате тази работа, за да добавите описание към нея. Можете също да импортирате работи, използвайки нашата.";
const chromeextension$n = "разширение за Chrome";
const fromVariousJobPortalsOnce$n = "от различни портали за работа. След като добавите описание, ще можете да видите и информация за умения, свързани с работата.";
const AddDescription$n = "Добавете описание.";
const CompanyInfo$n = "Информация за компанията";
const Website$n = "Уебсайт";
const Industry$n = "Индустрия";
const EmployeeCount$n = "Брой служители";
const ExprienceLevel$n = "Ниво на опит";
const Address$n = "Адрес";
const Resumes$n = "Резюмета";
const Setasdefault$n = "Задай като стандарт";
const Ok$n = "Ок";
const UploadNewResume$n = "Качи ново резюме";
const Default$n = "Стандартно";
const Jobnotfound$n = "Работата не е намерена";
const EditDetails$n = "Редактирай детайлите";
const JobPostURL$n = "URL на обявата за работа";
const Enterjoburl$n = "Въведете URL адрес на работата";
const Nojobselected$n = "Не е избрана работа";
const Viewjobdetails$n = "Прегледай детайлите за работата";
const Jobaddedtoyourboardsuccessfully$n = "Работата е успешно добавена към твоята дъска.";
const AddJob$n = "Добави работа";
const Addnewjobname$n = "Добавете ново име на работа.";
const JobUrl$n = "URL на работата";
const Addjoburl$n = "Добавете URL на работата.";
const Section$n = "Секция";
const didYouKnow$n = {
	chromeExtension: "Знаете ли? Можете също да запазвате работи директно от нашето разширение за Chrome и да импортирате всички данни с един клик! Това отнема само няколко секунди."
};
const Jobs$n = "Работи";
const AddJobtoboard$n = "Добавете работа към дъската.";
const Currentlynojobsareavailable$n = "В момента няма налични работни места.";
const noMatchingJobs$n = "Не са намерени съвпадащи работи.";
const welcomeToYourPersonalJobTracker$n = "Добре дошли във вашия личен Job Tracker!";
const weShortTutorialOnHowTrackingJob$n = "Ще ви проведем през кратък урок за това как да започнете да проследявате вашите кандидатури за работа в няколко лесни стъпки!";
const Addanewjob$n = "Добавете нова работа.";
const inOrderTrackCreatButton$n = "За да започнете да проследявате кандидатурите за работа, трябва първо да ги добавите към дъската, като кликнете върху бутона \"Създай\".";
const Providesomedetails$n = "Предоставете някои подробности.";
const toBeginTypeJobTitleCompany$n = "За да започнете, просто въведете заглавието на работата, името на компанията и статуса, към който искате да го добавите. Можете да добавите повече подробности по-късно, но това е всичко, от което се нуждаете за момента!";
const asAnExampleFilledForYou$n = "Като пример, вече сме го попълнили за вас!";
const wohooAddedFirstJob$n = "Ура! Добави първата си работа към списъка си за проследяване на работа!";
const youCanDragDropJobCard$n = "Вече можете да влачите и пускате картичката за работата в различните етапи на процеса на кандидатстване за работа. Като кликнете върху картичката за работата, ще можете да видите повече подробности, да ги редактирате, да запазвате бележки и други!";
const Lastbutnotleast$n = "Последно, но не на последно място";
const finalStepMakeSure$n = "Като последна стъпка, уверете се, че имате нашия.";
const autoMaticallyImportJobs$n = "което ще ви позволи автоматично да импортирате обяви за работа от любимите си уеб сайтове за търсене на работа като LinkedIn, Indeed и други! Нашето разширение също ви помага да подобрите профила си в LinkedIn и да получите 2,5 пъти повече търсения!";
const selectanysection$n = "изберете която и да е секция";
const Accept$n = "Приемам.";
const My2023JobSearch$n = "Моето търсене на работа за 2023 г.";
const AddedFrom$n = "Добавено от";
const AddedUntil$n = "Добавено до.";
const BasicModal$n = "Основен модален прозорец";
const AddnewSectionName$n = "Добави ново име на секцията";
const OpenTo$n = "Отворено за";
const Featured$n = "Препоръчано";
const LicenceAndCerts$n = "Лицензи и сертификати";
const Banner$n = "Банер";
const LinkedInURL$n = "LinkedIn URL";
const Recommendations$n = "Препоръки";
const LinkedinReview$n = "Преглед на Linkedin";
const NoDataAvailable$n = "Няма налични данни.";
const looksLikeYouDidNot$n = "Изглежда, че не сте започнали да използвате нашата";
const toOptimizeProfileScoreVisible$n = "да оптимизирате профила си в LinkedIn все още. Когато го направите, резултатът от профила ви ще бъде видим тук.";
const LinkedinComponent$n = {
	letsOptimize: "Нека оптимизираме"
};
const improveYourChancesLandingDreamJob$n = "Подобрете шансовете си да получите мечтаната си работа. Използвайте тези опитани и тествани стратегии, за да направите необходимата промяна на профила си в LinkedIn.";
const VisitProfile$n = "Посетете профила";
const wantToGetLinkedinMakeover$n = "Искате ли пълна промяна на профила ви в LinkedIn?";
const PostGenerator$n = "Генератор на публикации";
const LinkedinHeadlineGenerator$n = "Генератор на заглавия в LinkedIn";
const LinkedinAboutSectionGenerator$n = "Генератор на раздел 'Относно мен' в LinkedIn";
const AITools$n = "Изкуствен интелект";
const Premium$n = "Премиум";
const LinkedInOptimization$n = "Оптимизация на LinkedIn";
const JobTracker$n = "Следене на работни места";
const whoIsHiring$n = "Кой назначава";
const Autofill$n = "Автоматично попълване";
const HeadlineGenerator$n = "Генератор на заглавия";
const skillMatching$n = "Съответствие на уменията";
const SummarizeJD$n = "Обобщете описание на работата";
const contactFeature$n = "Следене на контакти";
const documentFeature$n = "Документи";
const landJobWithoutStress$n = "Постигнете мечтаната си работа. Без стрес.";
const discoverFeatures$n = "Открийте множеството функции на Careerflow.ai, създадени да оптимизират търсенето на работа и да подобрят професионалното ви пътуване!";
const letsBeginOnboarding$n = "Да се запознаем по-добре с вас!";
const inTheNextFewScreensJobThirdParties$n = "В следващите няколко екрана ще ви зададем някои въпроси, които ще ни помогнат да персонализираме преживяването за вас, както и да автоматично попълним вашите кандидатури за работа (за да не трябва да го правите вие)! Ние не продаваме вашите данни на трети страни.";
const letsAddBasicInformation$n = "Да добавим основната ви информация";
const Pleaseselectanoptionfirst$n = "Моля, първо изберете опция.";
const JobApplicationTracker$n = "Тракер за кандидатствания за работа";
const LinkedInProfileOptimizer$n = "Оптимизатор на профила в Linked In";
const UnlimitedDocuments$n = "Неограничени документи";
const UnlimitedContacts$n = "Неограничен брой контакти.";
const HiringManagerSearch$n = "Търсене на управител на назначенията.";
const AILinkedInPostGenerator$n = "Генератор на публикации в LinkedIn с изкуствен интелект";
const ATSKeywordSkillMatch$n = "Работа, съвпадаща с ключови думи / умения в ATS";
const ChooseyourPlan$n = "Изберете своя план.";
const superChargeYourJobSearch$n = "Ускорете търсенето на работа и подобрете процеса на кандидатстване, увеличете броя на интервютата и постигнете мечтаната си работа. Всичко това с помощта на премиум инструментите на Careerflow.";
const startNowGoto$n = "Започнете сега (Отидете към приложението)";
const CreatedBy$n = "Създадено от";
const CreateNewNote$n = "Създай нова бележка";
const Nonotescreated$n = "Няма създадени бележки";
const approxTimeIsFourMinutes$n = "Приблизителното време за завършване на процеса на въвеждане е 4 минути.";
const Continue$n = "Продължи";
const iWillDoLaterTakeMeToApp$n = "Ще го направя по-късно. Отведи ме към приложението.";
const allDone$n = "Всичко готово!";
const welcomeAbord$n = "Добре дошли на борда!";
const letsBegin$n = "Нека започнем.";
const UpgradeyourplanandgetAIAssistance$n = "Подобрете плана си и получете помощ от изкуствен интелект.";
const DownloadPDF$n = "Изтеглете PDF";
const oopsWeCouldntProcessResume$n = "Опа, не можем да обработим това резюме.";
const MyProfile$n = "Моят профил";
const Setting$n = "Настройка";
const Logout$n = "Изход";
const SignIn$n = "Вход";
const Typeyourfirstnamehere$n = "Твоето първо име";
const Enteryourlastname$n = "Вашата фамилия";
const ManageSubscription$n = "Управление на абонамента";
const ifYouHaveDifficultiesProfile$n = "Ако имате затруднения с информацията в профила си, моля, свържете се с";
const forSupport$n = "за подкрепа.";
const whatIsIdealCompanySize$n = "Какъв е идеалният размер на компанията за вас?";
const Saveandcontinue$n = "Запази и продължи";
const whatIsMinExpectedSalary$n = "Каква е вашата минимална очаквана заплата (годишно)?";
const Atleast$n = "Поне";
const SlidetoAdjust$n = "Плъзнете за настройка";
const whatIndustryExcitedWork$n = "Кои индустрии те вълнуват?";
const Add$n = "Добави";
const statusOfJobSearch$n = "Какво е състоянието на твоето търсене на работа?";
const Finish$n = "Завършено";
const whatLevelRoleLooking$n = "Какво ниво на роля търсите?";
const Selectuptotwo$n = "Изберете до две.";
const PreviousStep$n = "Предишна стъпка";
const Skip$n = "Пропусни";
const whatDoYouValueNewRole$n = "Какво цените в новата си роля?";
const Selectuptothree$n = "Изберете до три.";
const EqualEmploymentData$n = "Данни за равнопоставеност при заетостта";
const whatIsYourEthnicity$n = "Какво е твоето етническо произход?";
const areYouAuthorizedToWorkUs$n = "Имате ли разрешение да работите в САЩ?";
const willYouRequireSponsorShip$n = "Ще имате ли нужда от спонсорство за статута на работната виза в настоящия момент или в бъдеще?";
const doYouHaveADisability$n = "Имате ли увреждане?";
const areYouAVeteran$n = "Ветеран ли сте?";
const rolesYouInterestedIn$n = "В какви роли се интересувате?";
const Selectuptofive$n = "Изберете до пет.";
const AddCustomrole$n = "Добавяне на персонализирана роля.";
const whereDoYouLikeWork$n = "Къде би искал да работиш?";
const Resources$n = "Ресурси";
const currentlyNoResourceAvailable$n = "В момента няма налични ресурси.";
const AddNewSection$n = "Добави нова секция";
const ChangeSections$n = "Промяна на раздели";
const Settings$n = "Настройки";
const Dashboard$n = "Табло";
const JobBoard$n = "Обяви за работа";
const Linkedin$n = "Линкедин";
const Community$n = "Общност";
const FindRecruiters$n = "Намерете рекрутери";
const Goals$n = "Цели";
const DownloadExtension$n = "Изтегли разширението";
const SuggestaFeature$n = "Предложете функция";
const leftPanel$n = {
	ReportanIssue: "Докладване на проблем"
};
const PhoneNumberisrequired$n = "Изисква се телефонен номер";
const MobileNumber$n = "Мобилен номер";
const Enteronlynumbers$n = "Въведете само числа.";
const Countryyoulivein$n = "Държавата, в която живеете";
const SelectaCountry$n = "Изберете държава.";
const DateofBirth$n = "Дата на раждане";
const Gender$n = "Пол";
const JobPreferences$n = "Предпочитания за работа";
const pleaseEnterValidEmail$n = "Моля, въведете валиден имейл.";
const emailSendForResetting$n = "Изпратено е имейл за нулиране на паролата ви.";
const VerifyyourEmailID$n = "Потвърдете своя имейл адрес.";
const sentPleaseCheckEmail$n = "Изпратено! Моля, проверете вашия имейл.";
const tooManyAttemptsTryAgain$n = "Твърде много опити, моля опитайте отново след време.";
const Resend$n = "Препрати";
const Login$n = "Вход";
const weHaveSentVerificationLinkAtEmail$n = "Изпратихме ви връзка за потвърждение на вашия имейл.";
const pleaseVerifyEmailContinueSpam$n = "Моля, потвърдете вашия имейл, за да продължите. Моля, проверете и спам или промоции за имейла за потвърждение.";
const Logintogetstarted$n = "Влезте, за да започнете.";
const ContinuewithGoogle$n = "Продължете с Google.";
const pleaseInputEmail$n = "Моля, въведете вашия имейл!";
const Password$n = "Парола";
const pleaseInputPassword$n = "Моля, въведете паролата си!";
const passwordLowerUpperDigitSpecial$n = "Вашата парола трябва да съдържа поне една малка буква, голяма буква, цифра и специален символ.";
const atLeastSixChar$n = "Поне 6 знака.";
const forgotPassword$n = "Забравена парола?";
const Bysigninginyouagreetoour$n = "Като влезете в профила си, вие се съгласявате с нашите условия.";
const Terms$n = "Условия";
const Conditions$n = "Условия";
const and$n = "и";
const PrivacyPolicy$n = "Политика за поверителност";
const theseAreTheTopsSkillsExtracted$n = "Това са най-важните умения, извлечени от описанието на работата.";
const TopSkills$n = "Най-добрите умения";
const weCoulNotExtractSkills$n = "Не можем да извлечем никакви умения от тази работна обява.";
const upgradeToPremiumToView$n = "Надстройте до Премиум, за да видите оценката за съвпадение на уменията във вашето резюме.";
const SkillScore$n = "Оценка на умението";
const thisIsYourSkillScoreBasedOn$n = "Това е вашият резултат за уменията ви, базирани на описанието на работата и вашето резюме.";
const theseSkllsAreStrongMatch$n = "Тези умения са силно съвпадение между вашето резюме и описанието на работата.";
const Strongmatch$n = "Силно съответствие";
const theseSkillsArePartialMatch$n = "Тези умения са частично съвпадение между вашето резюме и описанието на работата.";
const Partialmatch$n = "Частично съвпадение";
const theseSkillsAreMissingFrom$n = "Тези ключови думи липсват във вашето резюме, но са налични в описанието на работата. Те могат да бъдат умения или общи ключови думи, специфични за възможността за работа и може да бъдат полезни за добавяне към вашето резюме.";
const SkillMatchComponent$n = {
	removeSkill: "Какъв е основният ви Grund за докладване за проблем с ключовата дума"
};
const Optional$n = "Опционално";
const Notrelevanttothejob$n = "Нерелевантно за работата";
const Notaskill$n = "Няма умение";
const Toogeneric$n = "Твърде общо";
const Pleaseshareanyfeedback$n = "Моля, споделете всякакъв отзив";
const excludedKeywordsWillNot$n = "Изключените ключови думи няма да се вземат предвид при оценката на съвпаденията за всички бъдещи сканирания. Можете да промените изключените ключови думи от профила си.";
const yesExcludeThisSkillFrom$n = "Да, изключете тази умение от всички сканирания на моето резюме.";
const PartialMatch$n = "Частично съответствие";
const MissingKeywords$n = "Липсващи ключови думи";
const Providetitletotask$n = "Предоставете заглавие на задачата";
const TasksList$n = "Списък със задачи";
const AddTask$n = "Добави задача";
const EnterTaskTitlehere$n = "Въведете заглавието на задачата тук";
const TasksComponent$n = {
	listEmpty: "Списъкът с задачи е празен, създайте нов."
};
const CompletedTasks$n = "Завършени задачи";
const CompleteYourtasks$n = "Завършете вашите задачи";
const Steps$n = "Стъпки";
const PremiumMember$n = "Премиум член";
const Thankyouforupgradingto$n = "Благодарим Ви, че сте надградили до";
const CareerflowPremium$n = "Кариерен поток Премиум";
const hereIsHowYouCanAccessPremium$n = "Ето как да получите своите премиум предимства!";
const stepOne$n = "Стъпка 1";
const DownloadourChromeExtension$n = "Изтеглете нашето разширение за Chrome.";
const youJobSearchCopilotIshere$n = "Вашият AI съпътник при търсенето на работа е тук.";
const DownloadNow$n = "Изтегли сега";
const stepTwo$n = "Стъпка 2";
const GetStarted$n = "Започнете";
const stepThree$n = "Стъпка 3";
const SignintoChromeExtension$n = "Влезте в разширението на Chrome.";
const entityCreated$n = "Създаден е нов {{entity}}";
const entityUpdated$n = "{{entity}} актуализирано.";
const entityDeleted$n = "{{entity}} изтрито.";
const entityLinked$n = "{{entity}} свързан";
const entityUnlinked$n = "{{entity}} несвързан/не свързан";
const entityMovedTo$n = "Прехвърлен в {{entity}}.";
const youAddedANewEntity$n = "Добавихте нов {{entity}}.";
const personCreated$n = "{{creator}} създаде {{entity}} за {{owner}}.";
const youUpdatedAEntity$n = "Актуализирахте {{entity}}";
const personUpdated$n = "{{creator}} актуализира {{entity}} за {{owner}}.";
const youDeletedAEntity$n = "Изтрихте {{entity}}.";
const personDeleted$n = "{{creator}} изтри {{entity}} на {{owner}}.";
const youLinkedEntity$n = "Свързахте {{entity}} с тази работа.";
const personLinked$n = "{{creator}} свърза {{entity}} с тази работа за {{owner}}.";
const youUnlinked$n = "Отвързахте {{entity}} от тази работа.";
const personUnlinked$n = "{{creator}} откачи {{entity}} от тази работа за {{owner}}.";
const youMovedEntity$n = "Премести този {{entity}} от {{sectionFrom}} в {{sectionTo}}";
const personMoved$n = "{{creator}} премести това {{entity}} от {{sectionFrom}} в {{sectionTo}} за {{owner}}.";
const addedByName$n = "Добавено от {{name}}.";
const DownloadChromeExtension$n = "Изтеглете разширението на Chrome.";
const ourChromeExtensionIs$n = "Нашето разширение за Chrome е интегриран инструмент, който ви помага да оптимизирате профила си в LinkedIn, да запазвате работни места, контакти, да генерирате мотивационно писмо и още много други.";
const Optimizeyourprofile$n = "Оптимизирайте профила си.";
const startOptimizingYourProfile$n = "Започнете оптимизирането на профила си, за да имате по-добри шансове да бъдете контактувани от рекрутери.";
const OptimizeNow$n = "Оптимизирай сега.";
const Addyourfirstjob$n = "Добавете първата си работа.";
const startSavingJobApplicationsToTrack$n = "Започнете да запазвате кандидатурите за работа, за да проследите своето търсене на работа и да откриете полезни прозрения.";
const AddNow$n = "Добави сега.";
const CompleteProfile$n = "Пълен профил";
const completeYourProfileForUsing$n = "Завършете профила си, за да използвате функцията за автоматично попълване и да получите по-персонализирано изживяване.";
const CompleteNow$n = "Завършено сега";
const Addyourfirstcontact$n = "Добавете първия си контакт.";
const addContactToFollowUpWith$n = "Добавете контакт, за да може да ги последвате по-късно, добавете бележки и други.";
const JoinCommunity$n = "Присъединете се към общността.";
const ourCommunityisAlways$n = "Нашата общност винаги е тук с вас по време на вашето търсене на работа.";
const JoinNow$n = "Присъединете се сега";
const welcomeToCareerflow$n = "Добре дошли в Careerflow!";
const yourHubForCareerInsights2$n = "Това е вашата централа за кариерни идеи, дейности и още много. Изследвайте персонализираната си табла, за да останете на върха на професионалното си пътешествие.";
const ChecklistCompleted$n = "Вашата проверка е завършена!";
const Completeyourchecklist$n = "Завършете своята проверкалиста.";
const completeAFewStepsTo$n = "Изпълнете няколко стъпки, за да намерите следващата си работа.";
const Completed$n = "Завършено";
const JobCountByStage$n = "Брой на работите по етапи";
const NopastapplicationDatafound$n = "Не са намерени данни за предишни заявки.";
const YourJobSearchStages$n = "Етапите на търсенето на работа ви";
const NoDatafound$n = "Няма намерени данни";
const bg = {
	copyToClipboard: copyToClipboard$n,
	UnlocktheAIgenerated: UnlocktheAIgenerated$n,
	UpgradetoPremium: UpgradetoPremium$n,
	Result: Result$n,
	Copy: Copy$n,
	Save: Save$n,
	Edit: Edit$n,
	Processing: Processing$n,
	YourAIgeneratedcontentwillshowhere: YourAIgeneratedcontentwillshowhere$n,
	hopeYouFindUseful: hopeYouFindUseful$n,
	regenerate: regenerate$n,
	ProvideAdditionalFeedback: ProvideAdditionalFeedback$n,
	Enteranyfeedback: Enteranyfeedback$n,
	Notimpressive: Notimpressive$n,
	thisIsntTrue: thisIsntTrue$n,
	Notpersonalized: Notpersonalized$n,
	Tone: Tone$n,
	Length: Length$n,
	Template: Template$n,
	Generatedon: Generatedon$n,
	Copiedtoclipboard: Copiedtoclipboard$n,
	CopytoClipboard: CopytoClipboard$n,
	DownloadasPDF: DownloadasPDF$n,
	ViewDetails: ViewDetails$n,
	JobDescriptionImported: JobDescriptionImported$n,
	ImportfromJob: ImportfromJob$n,
	Saved: Saved$n,
	Applied: Applied$n,
	Offer: Offer$n,
	Interviewing: Interviewing$n,
	Rejected: Rejected$n,
	Search: Search$n,
	Import: Import$n,
	CoverLetterGeneratorHistory: CoverLetterGeneratorHistory$n,
	NoCoverLettersGenerated: NoCoverLettersGenerated$n,
	getStartedCoverLetter: getStartedCoverLetter$n,
	getStarted: getStarted$n,
	Documents: Documents$n,
	UploadNewDocument: UploadNewDocument$n,
	AICoverLetterGenerator: AICoverLetterGenerator$n,
	ViewHistory: ViewHistory$n,
	JobDescription: JobDescription$n,
	ImportfromBoard: ImportfromBoard$n,
	EnterJobDescription: EnterJobDescription$n,
	JobTitle: JobTitle$n,
	EnterJobTitle: EnterJobTitle$n,
	CompanyName: CompanyName$n,
	EnterCompanyName: EnterCompanyName$n,
	YourProfile: YourProfile$n,
	ResumeUpload: ResumeUpload$n,
	UseLinkedinProfile: UseLinkedinProfile$n,
	Uploadyourresume: Uploadyourresume$n,
	AddyourResume: AddyourResume$n,
	fileNameCannotFormat: fileNameCannotFormat$n,
	ChooseorUpload: ChooseorUpload$n,
	SelectTemplate: SelectTemplate$n,
	Preview: Preview$n,
	UseTemplate: UseTemplate$n,
	Change: Change$n,
	AdvancedSettings: AdvancedSettings$n,
	AdditionalContext: AdditionalContext$n,
	Professional: Professional$n,
	Casual: Casual$n,
	Enthusiastic: Enthusiastic$n,
	Informational: Informational$n,
	Short: Short$n,
	Medium: Medium$n,
	Long: Long$n,
	Language: Language$n,
	iAmOkayBack: iAmOkayBack$n,
	Generate: Generate$n,
	CoverLetter: CoverLetter$n,
	SelectLanguage: SelectLanguage$n,
	AboutGeneratorHistory: AboutGeneratorHistory$n,
	NoAboutsGenerated: NoAboutsGenerated$n,
	getStartedAbouts: getStartedAbouts$n,
	noAttachmentsFound: noAttachmentsFound$n,
	TargetJobTitle: TargetJobTitle$n,
	KeywordsToInclude: KeywordsToInclude$n,
	UploadYourResume: UploadYourResume$n,
	AddYourResume: AddYourResume$n,
	LinkedinProfile: LinkedinProfile$n,
	Linkedinprofilenotfound: Linkedinprofilenotfound$n,
	startUsingChromeExtension: startUsingChromeExtension$n,
	Download: Download$n,
	UseEmojis: UseEmojis$n,
	UseBulletPoints: UseBulletPoints$n,
	SpeechFocus: SpeechFocus$n,
	FirstPerson: FirstPerson$n,
	ThirdPerson: ThirdPerson$n,
	HeadlineGeneratorHistory: HeadlineGeneratorHistory$n,
	NoHeadlinesGenerated: NoHeadlinesGenerated$n,
	getStartedHeadline: getStartedHeadline$n,
	AIHeadlineGenerator: AIHeadlineGenerator$n,
	KeywordstoInclude: KeywordstoInclude$n,
	Pressenteraftereachword: Pressenteraftereachword$n,
	LinkedinProfilenotfound: LinkedinProfilenotfound$n,
	Headline: Headline$n,
	PostGeneratorHistory: PostGeneratorHistory$n,
	NoPostsGenerated: NoPostsGenerated$n,
	getStartedPost: getStartedPost$n,
	Topic: Topic$n,
	Description: Description$n,
	UseHashtags: UseHashtags$n,
	Custom: Custom$n,
	EnterCustomTone: EnterCustomTone$n,
	Added: Added$n,
	ComingSoon: ComingSoon$n,
	Company: Company$n,
	JobInterview: JobInterview$n,
	Research: Research$n,
	Networking: Networking$n,
	Referral: Referral$n,
	MustbeContacted: MustbeContacted$n,
	ScheduleaMeeting: ScheduleaMeeting$n,
	needAFollowUp: needAFollowUp$n,
	Today: Today$n,
	Viewdetails: Viewdetails$n,
	Activity: Activity$n,
	ActivityDetails: ActivityDetails$n,
	Delete: Delete$n,
	Title: Title$n,
	Goal: Goal$n,
	Status: Status$n,
	FollowUp: FollowUp$n,
	AddActivity: AddActivity$n,
	Enteractivitytitle: Enteractivitytitle$n,
	Cancel: Cancel$n,
	SaveActivity: SaveActivity$n,
	noActivityPresent: noActivityPresent$n,
	Addnew: Addnew$n,
	About: About$n,
	noDataPresentYou: noDataPresentYou$n,
	Experience: Experience$n,
	Education: Education$n,
	Skills: Skills$n,
	Overview: Overview$n,
	LinkedJobs: LinkedJobs$n,
	Notes: Notes$n,
	FullName: FullName$n,
	Location: Location$n,
	Relationship: Relationship$n,
	Contacts: Contacts$n,
	CreateContact: CreateContact$n,
	NotesCreated: NotesCreated$n,
	Notesupdated: Notesupdated$n,
	Addnote: Addnote$n,
	areYouSureDeleteNote: areYouSureDeleteNote$n,
	Createdby: Createdby$n,
	notSureWhyResumeCalls: notSureWhyResumeCalls$n,
	getExpertResumeReview: getExpertResumeReview$n,
	youHaventAddedContacts: youHaventAddedContacts$n,
	noMatchingContacts: noMatchingContacts$n,
	Link: Link$n,
	unlink: unlink$n,
	Locationnotavailable: Locationnotavailable$n,
	Emailnotavailable: Emailnotavailable$n,
	PhoneNumbernotavailable: PhoneNumbernotavailable$n,
	createdby: createdby$n,
	areYouSureDeleteContact: areYouSureDeleteContact$n,
	areYouSureUnlinkContact: areYouSureUnlinkContact$n,
	Addedbyyou: Addedbyyou$n,
	Addedby: Addedby$n,
	Timeline: Timeline$n,
	Timelineempty: Timelineempty$n,
	Discard: Discard$n,
	SaveContact: SaveContact$n,
	Recruiter: Recruiter$n,
	Candidate: Candidate$n,
	Colleague: Colleague$n,
	Employee: Employee$n,
	"Needtofollow-up": "Нужда от последващи действия",
	EnterValidEmail: EnterValidEmail$n,
	EnterValidPhoneNumber: EnterValidPhoneNumber$n,
	editingProfileNotAvailable: editingProfileNotAvailable$n,
	itWillBeSoonAvailable: itWillBeSoonAvailable$n,
	ChromeExtension: ChromeExtension$n,
	SelectTag: SelectTag$n,
	FirstName: FirstName$n,
	FirstNameisrequired: FirstNameisrequired$n,
	LastName: LastName$n,
	LastNameisrequired: LastNameisrequired$n,
	Companyisrequired: Companyisrequired$n,
	Email: Email$n,
	ThisisnotavalidEmail: ThisisnotavalidEmail$n,
	AddEmail: AddEmail$n,
	PhoneNumber: PhoneNumber$n,
	notaValidPhone: notaValidPhone$n,
	phoneNoMinimum5char: phoneNoMinimum5char$n,
	phoneNoMinumum15char: phoneNoMinumum15char$n,
	AddPhoneNumber: AddPhoneNumber$n,
	SelectGoal: SelectGoal$n,
	SelectStatus: SelectStatus$n,
	Followup: Followup$n,
	SocialMedia: SocialMedia$n,
	Linkedinhandle: Linkedinhandle$n,
	Twitterhandle: Twitterhandle$n,
	Facebookhandle: Facebookhandle$n,
	Githubhandle: Githubhandle$n,
	Gmailhandle: Gmailhandle$n,
	Changessavedsuccessfully: Changessavedsuccessfully$n,
	EditContact: EditContact$n,
	BasicInformation: BasicInformation$n,
	EditContactDetails: EditContactDetails$n,
	SaveChanges: SaveChanges$n,
	phoneNoMinimum14char: phoneNoMinimum14char$n,
	LinkedIn: LinkedIn$n,
	Twitter: Twitter$n,
	Facebook: Facebook$n,
	Github: Github$n,
	Gmail: Gmail$n,
	youCanWriteAbout: youCanWriteAbout$n,
	Addednewsection: Addednewsection$n,
	Removedsuccessfully: Removedsuccessfully$n,
	Remove: Remove$n,
	Institute: Institute$n,
	Schoolisrequired: Schoolisrequired$n,
	Degree: Degree$n,
	StartMonth: StartMonth$n,
	StartYear: StartYear$n,
	EndMonth: EndMonth$n,
	EndYear: EndYear$n,
	Addmore: Addmore$n,
	PositionTitle: PositionTitle$n,
	ExperienceType: ExperienceType$n,
	Addednewitem: Addednewitem$n,
	whatSkillsDoYouEnjoy: whatSkillsDoYouEnjoy$n,
	Typeskillshere: Typeskillshere$n,
	LinkedContacts: LinkedContacts$n,
	LinkContact: LinkContact$n,
	NocontactsLinked: NocontactsLinked$n,
	JobContactsComponent: JobContactsComponent$n,
	Nocontacts: Nocontacts$n,
	LinkJobto: LinkJobto$n,
	Contact: Contact$n,
	Document: Document$n,
	Nojobsfound: Nojobsfound$n,
	LinkJob: LinkJob$n,
	youCanLinkContactJobImported: youCanLinkContactJobImported$n,
	Prev: Prev$n,
	Next: Next$n,
	areYouSureUnlinkDocument: areYouSureUnlinkDocument$n,
	areYouSureDeleteDocument: areYouSureDeleteDocument$n,
	Category: Category$n,
	CreatedOn: CreatedOn$n,
	Joblinked: Joblinked$n,
	Quickactions: Quickactions$n,
	All: All$n,
	Resume: Resume$n,
	Portfolio: Portfolio$n,
	Other: Other$n,
	Adddocument: Adddocument$n,
	Type: Type$n,
	Sortingby: Sortingby$n,
	SwitchtoGridLayout: SwitchtoGridLayout$n,
	SwitchtoListLayout: SwitchtoListLayout$n,
	NoDocumentsAdded: NoDocumentsAdded$n,
	DocumentsComponent: DocumentsComponent$n,
	NoDocumentFound: NoDocumentFound$n,
	SelectFile: SelectFile$n,
	onlyPdfDocxSupported: onlyPdfDocxSupported$n,
	Uploadfile: Uploadfile$n,
	DocumentCategory: DocumentCategory$n,
	SaveDocument: SaveDocument$n,
	AddDocument: AddDocument$n,
	LinkedDocuments: LinkedDocuments$n,
	LinkDocument: LinkDocument$n,
	NodocumentsLinked: NodocumentsLinked$n,
	JobDocumentsComponent: JobDocumentsComponent$n,
	NoDocuments: NoDocuments$n,
	CreateDocuments: CreateDocuments$n,
	youCanLinkDocumentJobImported: youCanLinkDocumentJobImported$n,
	Documenteditedsuccessfully: Documenteditedsuccessfully$n,
	DocumentDetails: DocumentDetails$n,
	UnsavedChanges: UnsavedChanges$n,
	yourChangesWillBeLostSureClose: yourChangesWillBeLostSureClose$n,
	yourChangesWillBeLostSureDiscard: yourChangesWillBeLostSureDiscard$n,
	DiscardChanges: DiscardChanges$n,
	WeeklyGoalAlert: WeeklyGoalAlert$n,
	Progress: Progress$n,
	AllGoals: AllGoals$n,
	Name: Name$n,
	Completedon: Completedon$n,
	Createdon: Createdon$n,
	Action: Action$n,
	Back: Back$n,
	OverallScore: OverallScore$n,
	Aboutthegoal: Aboutthegoal$n,
	GoalTracking: GoalTracking$n,
	Week: Week$n,
	progress: progress$n,
	loading: loading$n,
	Apply: Apply$n,
	Thisskillhasbeenreported: Thisskillhasbeenreported$n,
	issueGettingResume: issueGettingResume$n,
	Interview: Interview$n,
	Tasks: Tasks$n,
	Loading: Loading$n,
	Skilladdedsuccessfully: Skilladdedsuccessfully$n,
	problemAddingSkill: problemAddingSkill$n,
	Reportaproblem: Reportaproblem$n,
	Submit: Submit$n,
	Addanewskill: Addanewskill$n,
	JobDetailsComponent: JobDetailsComponent$n,
	HardSkill: HardSkill$n,
	SoftSkill: SoftSkill$n,
	Pleaseshareanyadditionalcontext: Pleaseshareanyadditionalcontext$n,
	Addasskill: Addasskill$n,
	Skill: Skill$n,
	JobFrequency: JobFrequency$n,
	ResumeFrequency: ResumeFrequency$n,
	Reportskill: Reportskill$n,
	JobDetails: JobDetails$n,
	ViewJobLink: ViewJobLink$n,
	Salary: Salary$n,
	areYouSureDeleteJob: areYouSureDeleteJob$n,
	ViewMore: ViewMore$n,
	ViewLess: ViewLess$n,
	matchYouSkillsAgainstJob: matchYouSkillsAgainstJob$n,
	pleaseUploadResumeSkillMatch: pleaseUploadResumeSkillMatch$n,
	AddResume: AddResume$n,
	thisJobDoesNotHaveAnyDesc: thisJobDoesNotHaveAnyDesc$n,
	youCanEditJobToAdd: youCanEditJobToAdd$n,
	chromeextension: chromeextension$n,
	fromVariousJobPortalsOnce: fromVariousJobPortalsOnce$n,
	AddDescription: AddDescription$n,
	CompanyInfo: CompanyInfo$n,
	Website: Website$n,
	Industry: Industry$n,
	EmployeeCount: EmployeeCount$n,
	ExprienceLevel: ExprienceLevel$n,
	Address: Address$n,
	Resumes: Resumes$n,
	Setasdefault: Setasdefault$n,
	Ok: Ok$n,
	UploadNewResume: UploadNewResume$n,
	Default: Default$n,
	Jobnotfound: Jobnotfound$n,
	EditDetails: EditDetails$n,
	JobPostURL: JobPostURL$n,
	Enterjoburl: Enterjoburl$n,
	Nojobselected: Nojobselected$n,
	Viewjobdetails: Viewjobdetails$n,
	Jobaddedtoyourboardsuccessfully: Jobaddedtoyourboardsuccessfully$n,
	AddJob: AddJob$n,
	Addnewjobname: Addnewjobname$n,
	JobUrl: JobUrl$n,
	Addjoburl: Addjoburl$n,
	Section: Section$n,
	didYouKnow: didYouKnow$n,
	Jobs: Jobs$n,
	AddJobtoboard: AddJobtoboard$n,
	Currentlynojobsareavailable: Currentlynojobsareavailable$n,
	noMatchingJobs: noMatchingJobs$n,
	welcomeToYourPersonalJobTracker: welcomeToYourPersonalJobTracker$n,
	weShortTutorialOnHowTrackingJob: weShortTutorialOnHowTrackingJob$n,
	Addanewjob: Addanewjob$n,
	inOrderTrackCreatButton: inOrderTrackCreatButton$n,
	Providesomedetails: Providesomedetails$n,
	toBeginTypeJobTitleCompany: toBeginTypeJobTitleCompany$n,
	asAnExampleFilledForYou: asAnExampleFilledForYou$n,
	wohooAddedFirstJob: wohooAddedFirstJob$n,
	youCanDragDropJobCard: youCanDragDropJobCard$n,
	Lastbutnotleast: Lastbutnotleast$n,
	finalStepMakeSure: finalStepMakeSure$n,
	autoMaticallyImportJobs: autoMaticallyImportJobs$n,
	selectanysection: selectanysection$n,
	Accept: Accept$n,
	My2023JobSearch: My2023JobSearch$n,
	AddedFrom: AddedFrom$n,
	AddedUntil: AddedUntil$n,
	BasicModal: BasicModal$n,
	AddnewSectionName: AddnewSectionName$n,
	OpenTo: OpenTo$n,
	Featured: Featured$n,
	LicenceAndCerts: LicenceAndCerts$n,
	Banner: Banner$n,
	LinkedInURL: LinkedInURL$n,
	Recommendations: Recommendations$n,
	LinkedinReview: LinkedinReview$n,
	NoDataAvailable: NoDataAvailable$n,
	looksLikeYouDidNot: looksLikeYouDidNot$n,
	toOptimizeProfileScoreVisible: toOptimizeProfileScoreVisible$n,
	LinkedinComponent: LinkedinComponent$n,
	improveYourChancesLandingDreamJob: improveYourChancesLandingDreamJob$n,
	VisitProfile: VisitProfile$n,
	wantToGetLinkedinMakeover: wantToGetLinkedinMakeover$n,
	PostGenerator: PostGenerator$n,
	LinkedinHeadlineGenerator: LinkedinHeadlineGenerator$n,
	LinkedinAboutSectionGenerator: LinkedinAboutSectionGenerator$n,
	AITools: AITools$n,
	Premium: Premium$n,
	LinkedInOptimization: LinkedInOptimization$n,
	JobTracker: JobTracker$n,
	whoIsHiring: whoIsHiring$n,
	Autofill: Autofill$n,
	HeadlineGenerator: HeadlineGenerator$n,
	skillMatching: skillMatching$n,
	SummarizeJD: SummarizeJD$n,
	contactFeature: contactFeature$n,
	documentFeature: documentFeature$n,
	landJobWithoutStress: landJobWithoutStress$n,
	discoverFeatures: discoverFeatures$n,
	letsBeginOnboarding: letsBeginOnboarding$n,
	inTheNextFewScreensJobThirdParties: inTheNextFewScreensJobThirdParties$n,
	letsAddBasicInformation: letsAddBasicInformation$n,
	Pleaseselectanoptionfirst: Pleaseselectanoptionfirst$n,
	JobApplicationTracker: JobApplicationTracker$n,
	LinkedInProfileOptimizer: LinkedInProfileOptimizer$n,
	UnlimitedDocuments: UnlimitedDocuments$n,
	UnlimitedContacts: UnlimitedContacts$n,
	HiringManagerSearch: HiringManagerSearch$n,
	AILinkedInPostGenerator: AILinkedInPostGenerator$n,
	ATSKeywordSkillMatch: ATSKeywordSkillMatch$n,
	"Auto-Apply": "Автоматично прилагане",
	ChooseyourPlan: ChooseyourPlan$n,
	superChargeYourJobSearch: superChargeYourJobSearch$n,
	startNowGoto: startNowGoto$n,
	CreatedBy: CreatedBy$n,
	CreateNewNote: CreateNewNote$n,
	Nonotescreated: Nonotescreated$n,
	approxTimeIsFourMinutes: approxTimeIsFourMinutes$n,
	Continue: Continue$n,
	iWillDoLaterTakeMeToApp: iWillDoLaterTakeMeToApp$n,
	allDone: allDone$n,
	welcomeAbord: welcomeAbord$n,
	letsBegin: letsBegin$n,
	UpgradeyourplanandgetAIAssistance: UpgradeyourplanandgetAIAssistance$n,
	DownloadPDF: DownloadPDF$n,
	oopsWeCouldntProcessResume: oopsWeCouldntProcessResume$n,
	MyProfile: MyProfile$n,
	Setting: Setting$n,
	Logout: Logout$n,
	SignIn: SignIn$n,
	Typeyourfirstnamehere: Typeyourfirstnamehere$n,
	Enteryourlastname: Enteryourlastname$n,
	ManageSubscription: ManageSubscription$n,
	ifYouHaveDifficultiesProfile: ifYouHaveDifficultiesProfile$n,
	forSupport: forSupport$n,
	whatIsIdealCompanySize: whatIsIdealCompanySize$n,
	Saveandcontinue: Saveandcontinue$n,
	whatIsMinExpectedSalary: whatIsMinExpectedSalary$n,
	Atleast: Atleast$n,
	SlidetoAdjust: SlidetoAdjust$n,
	whatIndustryExcitedWork: whatIndustryExcitedWork$n,
	Add: Add$n,
	statusOfJobSearch: statusOfJobSearch$n,
	Finish: Finish$n,
	whatLevelRoleLooking: whatLevelRoleLooking$n,
	Selectuptotwo: Selectuptotwo$n,
	PreviousStep: PreviousStep$n,
	Skip: Skip$n,
	whatDoYouValueNewRole: whatDoYouValueNewRole$n,
	Selectuptothree: Selectuptothree$n,
	EqualEmploymentData: EqualEmploymentData$n,
	whatIsYourEthnicity: whatIsYourEthnicity$n,
	areYouAuthorizedToWorkUs: areYouAuthorizedToWorkUs$n,
	willYouRequireSponsorShip: willYouRequireSponsorShip$n,
	doYouHaveADisability: doYouHaveADisability$n,
	areYouAVeteran: areYouAVeteran$n,
	rolesYouInterestedIn: rolesYouInterestedIn$n,
	Selectuptofive: Selectuptofive$n,
	AddCustomrole: AddCustomrole$n,
	whereDoYouLikeWork: whereDoYouLikeWork$n,
	Resources: Resources$n,
	currentlyNoResourceAvailable: currentlyNoResourceAvailable$n,
	AddNewSection: AddNewSection$n,
	ChangeSections: ChangeSections$n,
	Settings: Settings$n,
	Dashboard: Dashboard$n,
	JobBoard: JobBoard$n,
	Linkedin: Linkedin$n,
	Community: Community$n,
	FindRecruiters: FindRecruiters$n,
	Goals: Goals$n,
	DownloadExtension: DownloadExtension$n,
	SuggestaFeature: SuggestaFeature$n,
	leftPanel: leftPanel$n,
	PhoneNumberisrequired: PhoneNumberisrequired$n,
	MobileNumber: MobileNumber$n,
	Enteronlynumbers: Enteronlynumbers$n,
	Countryyoulivein: Countryyoulivein$n,
	SelectaCountry: SelectaCountry$n,
	DateofBirth: DateofBirth$n,
	Gender: Gender$n,
	JobPreferences: JobPreferences$n,
	pleaseEnterValidEmail: pleaseEnterValidEmail$n,
	emailSendForResetting: emailSendForResetting$n,
	VerifyyourEmailID: VerifyyourEmailID$n,
	sentPleaseCheckEmail: sentPleaseCheckEmail$n,
	tooManyAttemptsTryAgain: tooManyAttemptsTryAgain$n,
	Resend: Resend$n,
	Login: Login$n,
	weHaveSentVerificationLinkAtEmail: weHaveSentVerificationLinkAtEmail$n,
	pleaseVerifyEmailContinueSpam: pleaseVerifyEmailContinueSpam$n,
	Logintogetstarted: Logintogetstarted$n,
	ContinuewithGoogle: ContinuewithGoogle$n,
	pleaseInputEmail: pleaseInputEmail$n,
	Password: Password$n,
	pleaseInputPassword: pleaseInputPassword$n,
	passwordLowerUpperDigitSpecial: passwordLowerUpperDigitSpecial$n,
	atLeastSixChar: atLeastSixChar$n,
	forgotPassword: forgotPassword$n,
	Bysigninginyouagreetoour: Bysigninginyouagreetoour$n,
	Terms: Terms$n,
	Conditions: Conditions$n,
	and: and$n,
	PrivacyPolicy: PrivacyPolicy$n,
	theseAreTheTopsSkillsExtracted: theseAreTheTopsSkillsExtracted$n,
	TopSkills: TopSkills$n,
	weCoulNotExtractSkills: weCoulNotExtractSkills$n,
	upgradeToPremiumToView: upgradeToPremiumToView$n,
	SkillScore: SkillScore$n,
	thisIsYourSkillScoreBasedOn: thisIsYourSkillScoreBasedOn$n,
	theseSkllsAreStrongMatch: theseSkllsAreStrongMatch$n,
	Strongmatch: Strongmatch$n,
	theseSkillsArePartialMatch: theseSkillsArePartialMatch$n,
	Partialmatch: Partialmatch$n,
	theseSkillsAreMissingFrom: theseSkillsAreMissingFrom$n,
	"Missing Keywords": "Липсващи ключови думи",
	SkillMatchComponent: SkillMatchComponent$n,
	Optional: Optional$n,
	Notrelevanttothejob: Notrelevanttothejob$n,
	Notaskill: Notaskill$n,
	Toogeneric: Toogeneric$n,
	Pleaseshareanyfeedback: Pleaseshareanyfeedback$n,
	excludedKeywordsWillNot: excludedKeywordsWillNot$n,
	yesExcludeThisSkillFrom: yesExcludeThisSkillFrom$n,
	PartialMatch: PartialMatch$n,
	MissingKeywords: MissingKeywords$n,
	Providetitletotask: Providetitletotask$n,
	TasksList: TasksList$n,
	AddTask: AddTask$n,
	EnterTaskTitlehere: EnterTaskTitlehere$n,
	TasksComponent: TasksComponent$n,
	CompletedTasks: CompletedTasks$n,
	CompleteYourtasks: CompleteYourtasks$n,
	Steps: Steps$n,
	PremiumMember: PremiumMember$n,
	Thankyouforupgradingto: Thankyouforupgradingto$n,
	CareerflowPremium: CareerflowPremium$n,
	hereIsHowYouCanAccessPremium: hereIsHowYouCanAccessPremium$n,
	stepOne: stepOne$n,
	DownloadourChromeExtension: DownloadourChromeExtension$n,
	youJobSearchCopilotIshere: youJobSearchCopilotIshere$n,
	DownloadNow: DownloadNow$n,
	stepTwo: stepTwo$n,
	GetStarted: GetStarted$n,
	stepThree: stepThree$n,
	SignintoChromeExtension: SignintoChromeExtension$n,
	entityCreated: entityCreated$n,
	entityUpdated: entityUpdated$n,
	entityDeleted: entityDeleted$n,
	entityLinked: entityLinked$n,
	entityUnlinked: entityUnlinked$n,
	entityMovedTo: entityMovedTo$n,
	youAddedANewEntity: youAddedANewEntity$n,
	personCreated: personCreated$n,
	youUpdatedAEntity: youUpdatedAEntity$n,
	personUpdated: personUpdated$n,
	youDeletedAEntity: youDeletedAEntity$n,
	personDeleted: personDeleted$n,
	youLinkedEntity: youLinkedEntity$n,
	personLinked: personLinked$n,
	youUnlinked: youUnlinked$n,
	personUnlinked: personUnlinked$n,
	youMovedEntity: youMovedEntity$n,
	personMoved: personMoved$n,
	addedByName: addedByName$n,
	DownloadChromeExtension: DownloadChromeExtension$n,
	ourChromeExtensionIs: ourChromeExtensionIs$n,
	Optimizeyourprofile: Optimizeyourprofile$n,
	startOptimizingYourProfile: startOptimizingYourProfile$n,
	OptimizeNow: OptimizeNow$n,
	Addyourfirstjob: Addyourfirstjob$n,
	startSavingJobApplicationsToTrack: startSavingJobApplicationsToTrack$n,
	AddNow: AddNow$n,
	CompleteProfile: CompleteProfile$n,
	completeYourProfileForUsing: completeYourProfileForUsing$n,
	CompleteNow: CompleteNow$n,
	Addyourfirstcontact: Addyourfirstcontact$n,
	addContactToFollowUpWith: addContactToFollowUpWith$n,
	JoinCommunity: JoinCommunity$n,
	ourCommunityisAlways: ourCommunityisAlways$n,
	JoinNow: JoinNow$n,
	welcomeToCareerflow: welcomeToCareerflow$n,
	yourHubForCareerInsights2: yourHubForCareerInsights2$n,
	ChecklistCompleted: ChecklistCompleted$n,
	Completeyourchecklist: Completeyourchecklist$n,
	completeAFewStepsTo: completeAFewStepsTo$n,
	Completed: Completed$n,
	JobCountByStage: JobCountByStage$n,
	NopastapplicationDatafound: NopastapplicationDatafound$n,
	YourJobSearchStages: YourJobSearchStages$n,
	NoDatafound: NoDatafound$n
};

const copyToClipboard$m = "Zkopírováno do schránky!";
const UnlocktheAIgenerated$m = "Odemkněte generované umělé inteligence.";
const UpgradetoPremium$m = "Upgradovat na prémiovou verzi";
const Result$m = "Výsledek";
const Copy$m = "Kopírovat";
const Save$m = "Uložit";
const Edit$m = "Upravit";
const Processing$m = "Zpracování";
const YourAIgeneratedcontentwillshowhere$m = "Vaše obsah vygenerovaný umělou inteligencí se zobrazí zde";
const hopeYouFindUseful$m = "Doufám, že tento výsledek bude pro vás užitečný!";
const regenerate$m = "Znovu vygenerovat";
const ProvideAdditionalFeedback$m = "Poskytnout další zpětnou vazbu";
const Enteranyfeedback$m = "Zadat jakoukoli zpětnou vazbu";
const Notimpressive$m = "Není působivé";
const thisIsntTrue$m = "To není pravda";
const Notpersonalized$m = "Není personalizované";
const Tone$m = "Tón";
const Length$m = "Délka";
const Template$m = "Šablona";
const Generatedon$m = "Vygenerováno dne";
const Copiedtoclipboard$m = "Zkopírováno do schránky";
const CopytoClipboard$m = "Kopírovat do schránky";
const DownloadasPDF$m = "Stáhnout jako PDF";
const ViewDetails$m = "Zobrazit podrobnosti";
const JobDescriptionImported$m = "Popis práce importován";
const ImportfromJob$m = "Import z pracovního místa";
const Saved$m = "Uloženo";
const Applied$m = "Použito";
const Offer$m = "Nabídka";
const Interviewing$m = "Rozhovorování";
const Rejected$m = "Odmítnuto";
const Search$m = "Hledat";
const Import$m = "Import";
const CoverLetterGeneratorHistory$m = "Historie generátoru životopisných dopisů";
const NoCoverLettersGenerated$m = "Nebyly vygenerovány žádné životopisné dopisy";
const getStartedCoverLetter$m = "Zatím jste nevygenerovali žádné životopisné dopisy. Začněte a generujte životopisné dopisy tím, že budete odpovídat na popis pracovní pozice se svými relevantními zkušenostmi.";
const getStarted$m = "Začít!";
const Documents$m = "Dokumenty";
const UploadNewDocument$m = "Nahrát nový dokument";
const AICoverLetterGenerator$m = "AI generátor životopisných dopisů";
const ViewHistory$m = "Zobrazit historii";
const JobDescription$m = "Popis pracovní pozice";
const ImportfromBoard$m = "Importovat z nástěnky";
const EnterJobDescription$m = "Zadat popis pracovní pozice";
const JobTitle$m = "Název pracovní pozice";
const EnterJobTitle$m = "Zadat název pracovní pozice";
const CompanyName$m = "Název společnosti";
const EnterCompanyName$m = "Zadat název společnosti";
const YourProfile$m = "Váš profil";
const ResumeUpload$m = "Nahrát životopis";
const UseLinkedinProfile$m = "Použít LinkedIn profil";
const Uploadyourresume$m = "Nahrát váš životopis";
const AddyourResume$m = "Přidat váš životopis";
const fileNameCannotFormat$m = "Názvy souborů nesmí obsahovat mezery nebo podtržítka a měly by být ve formátu .doc, .docx nebo .pdf.";
const ChooseorUpload$m = "Vybrat nebo nahrát";
const SelectTemplate$m = "Vybrat šablonu";
const Preview$m = "Náhled";
const UseTemplate$m = "Použít šablonu";
const Change$m = "Změnit";
const AdvancedSettings$m = "Pokročilá nastavení";
const AdditionalContext$m = "Další kontext";
const Professional$m = "Profesionální";
const Casual$m = "Neformální";
const Enthusiastic$m = "Nadšený";
const Informational$m = "Informativní";
const Short$m = "Krátký";
const Medium$m = "Střední";
const Long$m = "Dlouhý";
const Language$m = "Jazyk";
const iAmOkayBack$m = "Je to v pořádku! Vraťte se";
const Generate$m = "Generovat";
const CoverLetter$m = "Motivační dopis";
const SelectLanguage$m = "Vybrat jazyk";
const AboutGeneratorHistory$m = "Historie generátoru o mně";
const NoAboutsGenerated$m = "Nebyly vygenerovány žádné informace o mně";
const getStartedAbouts$m = "Zatím jste nevygenerovali žádné informace o mně. Začněte a generujte informace o mně odpovídáním na popis pracovní pozice se svými relevantními zkušenostmi.";
const noAttachmentsFound$m = "Nebyly nalezeny žádné přílohy.";
const TargetJobTitle$m = "Cílový název pracovní pozice";
const KeywordsToInclude$m = "Klíčová slova k zahrnutí";
const UploadYourResume$m = "Nahrajte své životopis";
const AddYourResume$m = "Přidejte své životopis";
const LinkedinProfile$m = "LinkedIn profil";
const Linkedinprofilenotfound$m = "LinkedIn profil nebyl nalezen";
const startUsingChromeExtension$m = "Začněte optimalizovat svůj LinkedIn profil pomocí naší rozšíření pro Chrome a využijte této možnosti.";
const Download$m = "Stáhnout";
const UseEmojis$m = "Použít emotikony";
const UseBulletPoints$m = "Použít odrážky";
const SpeechFocus$m = "Zaměření projevu";
const FirstPerson$m = "První osoba";
const ThirdPerson$m = "Třetí osoba";
const HeadlineGeneratorHistory$m = "Historie generátoru nadpisů";
const NoHeadlinesGenerated$m = "Nebyly vygenerovány žádné nadpisy";
const getStartedHeadline$m = "Zatím jste nevygenerovali žádné nadpisy. Začněte a generujte nadpisy odpovídáním na popis pracovní pozice se svými relevantními zkušenostmi.";
const AIHeadlineGenerator$m = "AI generátor nadpisů";
const KeywordstoInclude$m = "Klíčová slova k zahrnutí";
const Pressenteraftereachword$m = "Stiskněte klávesu Enter po každém slově.";
const LinkedinProfilenotfound$m = "Profil na LinkedIn nenalezen";
const Headline$m = "Titulek";
const PostGeneratorHistory$m = "Historie generátoru příspěvků";
const NoPostsGenerated$m = "Nebyly vygenerovány žádné příspěvky";
const getStartedPost$m = "Zatím jste nevygenerovali žádné příspěvky. Začněte a generujte příspěvky odpovídáním na popis pracovní pozice se svými relevantními zkušenostmi.";
const Topic$m = "Téma";
const Description$m = "Popis";
const UseHashtags$m = "Použít hashtage";
const Custom$m = "Vlastní";
const EnterCustomTone$m = "Zadat vlastní tón";
const Added$m = "Přidáno";
const ComingSoon$m = {
	header: "Inženýři pracují!",
	content_1: "Náš tým inženýrů tvrdě pracuje na tom, aby tuto funkci co nejdříve spustil",
	content_2: "Chcete tuto funkci brzy? Dejte nám vědět jednoduchým zaškrtnutím políčka níže.",
	content_3: "Chci tuto funkci"
};
const Company$m = "Společnost";
const JobInterview$m = "Pohovor o zaměstnání";
const Research$m = "Výzkum";
const Networking$m = "Síťování";
const Referral$m = "Odkaz";
const MustbeContacted$m = "Musí být kontaktováno";
const ScheduleaMeeting$m = "Naplánovat schůzku";
const needAFollowUp$m = "Potřeba následného kontaktu";
const Today$m = "Dnes";
const Viewdetails$m = "Zobrazit podrobnosti";
const Activity$m = "Aktivita";
const ActivityDetails$m = "Podrobnosti o aktivitě";
const Delete$m = "Smazat";
const Title$m = "Název";
const Goal$m = "Cíl";
const Status$m = "Stav";
const FollowUp$m = "Následná akce";
const AddActivity$m = "Přidat aktivitu";
const Enteractivitytitle$m = "Zadejte název aktivity";
const Cancel$m = "Zrušit";
const SaveActivity$m = "Uložit aktivitu";
const noActivityPresent$m = "Žádná aktivita není přítomna, přidejte aktivitu.";
const Addnew$m = "Přidat nový";
const About$m = "O mně";
const noDataPresentYou$m = "Nejsou k dispozici žádná data, můžete upravit tento kontakt a přidat pole.";
const Experience$m = "Zkušenosti";
const Education$m = "Vzdělání";
const Skills$m = "Dovednosti";
const Overview$m = "Přehled";
const LinkedJobs$m = "Propojené práce";
const Notes$m = "Poznámky";
const FullName$m = "Celé jméno";
const Location$m = "Lokace";
const Relationship$m = "Vztah";
const Contacts$m = "Kontakty";
const CreateContact$m = "Vytvořit kontakt";
const NotesCreated$m = "Poznámky vytvořeny";
const Notesupdated$m = "Poznámky aktualizovány";
const Addnote$m = "Přidat poznámku";
const areYouSureDeleteNote$m = "Jste si jistý/á, že chcete smazat tuto poznámku?";
const Createdby$m = "Vytvořeno uživatelem";
const notSureWhyResumeCalls$m = "Nevíte, proč vás váš životopis nedostává pozvání na pohovor? ☎️";
const getExpertResumeReview$m = "Získejte odborné zhodnocení životopisu 💎✨";
const youHaventAddedContacts$m = "Ještě jste nepřidal(a) žádné kontakty.";
const noMatchingContacts$m = "Nebyly nalezeny žádné odpovídající kontakty.";
const Link$m = "Odkaz";
const unlink$m = "Odebrat odkaz";
const Locationnotavailable$m = "Místo není k dispozici";
const Emailnotavailable$m = "E-mail není k dispozici";
const PhoneNumbernotavailable$m = "Telefonní číslo není k dispozici";
const createdby$m = "vytvořeno od";
const areYouSureDeleteContact$m = "Jste si jistí, že chcete smazat tento kontakt?";
const areYouSureUnlinkContact$m = "Jste si jistí, že chcete odebrat odkaz na tento kontakt?";
const Addedbyyou$m = "Přidáno vámi";
const Addedby$m = "Přidáno uživatelem";
const Timeline$m = "Časová osa";
const Timelineempty$m = "Časová osa je prázdná";
const Discard$m = "Zahodit";
const SaveContact$m = "Uložit kontakt";
const Recruiter$m = "Rekruiter";
const Candidate$m = "Kandidát";
const Colleague$m = "Kolega";
const Employee$m = "Zaměstnanec";
const EnterValidEmail$m = "Zadejte platný e-mail";
const EnterValidPhoneNumber$m = "Zadejte platné telefonní číslo";
const editingProfileNotAvailable$m = "Úprava profilové fotky zatím není k dispozici.";
const itWillBeSoonAvailable$m = "Brzy bude k dispozici naší.";
const ChromeExtension$m = "Rozšíření pro Chrome";
const SelectTag$m = "Vybrat značku";
const FirstName$m = "Jméno";
const FirstNameisrequired$m = "Jméno je povinné";
const LastName$m = "Příjmení";
const LastNameisrequired$m = "Příjmení je povinné";
const Companyisrequired$m = "Firma je povinná.";
const Email$m = "E-mail";
const ThisisnotavalidEmail$m = "Toto není platný e-mail.";
const AddEmail$m = "Přidat e-mail";
const PhoneNumber$m = "Telefonní číslo";
const notaValidPhone$m = "Toto není platné telefonní číslo. Zadejte pouze číslice.";
const phoneNoMinimum5char$m = "Telefonní číslo musí být minimálně 5 znaků dlouhé.";
const phoneNoMinumum15char$m = "Telefonní číslo musí být maximálně 15 znaků.";
const AddPhoneNumber$m = "Přidat telefonní číslo";
const SelectGoal$m = "Vybrat cíl";
const SelectStatus$m = "Vyberte stav";
const Followup$m = "Následná akce";
const SocialMedia$m = "Sociální média";
const Linkedinhandle$m = "Linkedin účet";
const Twitterhandle$m = "Twitter účet";
const Facebookhandle$m = "Facebook účet";
const Githubhandle$m = "Github účet";
const Gmailhandle$m = "Gmail účet";
const Changessavedsuccessfully$m = "Změny byly úspěšně uloženy";
const EditContact$m = "Upravit kontakt";
const BasicInformation$m = "Základní informace";
const EditContactDetails$m = "Upravit kontaktní údaje";
const SaveChanges$m = "Uložit změny";
const phoneNoMinimum14char$m = "Telefonní číslo musí být minimálně 14 znaků dlouhé.";
const LinkedIn$m = "LinkedIn";
const Twitter$m = "Twitter";
const Facebook$m = "Facebook";
const Github$m = "Github";
const Gmail$m = "Gmail";
const youCanWriteAbout$m = "Můžete psát o svých letech zkušeností, odvětví nebo dovednostech. Lidé také hovoří o svých úspěších nebo předchozích pracovních zkušenostech.";
const Addednewsection$m = "Přidána nová sekce";
const Removedsuccessfully$m = "Úspěšně odstraněno.";
const Remove$m = "Odstranit";
const Institute$m = "Institut";
const Schoolisrequired$m = "Škola je povinná.";
const Degree$m = "Stupeň";
const StartMonth$m = "Začátek měsíce";
const StartYear$m = "Začátek roku";
const EndMonth$m = "Konec měsíce";
const EndYear$m = "Konec roku";
const Addmore$m = "Přidat další";
const PositionTitle$m = "Název pozice";
const ExperienceType$m = "Typ zkušenosti";
const Addednewitem$m = "Přidán nový položka";
const whatSkillsDoYouEnjoy$m = "Jaké máte dovednosti nebo rádi pracujete s jakými dovednostmi?";
const Typeskillshere$m = "Napište zde své dovednosti";
const LinkedContacts$m = "Propojené kontakty";
const LinkContact$m = "Propojit kontakt";
const NocontactsLinked$m = "Žádné propojené kontakty";
const JobContactsComponent$m = {
	linkContact: "Propojením kontaktů můžete rychle vidět, kdo jsou důležité osoby, jako je rekruiter, manažer náběhu, atd., pro tuto roli! V budoucnu budeme schopni poskytovat relevantní informace na základě vašich kontaktů."
};
const Nocontacts$m = "Žádné kontakty";
const LinkJobto$m = "Propojit práci s";
const Contact$m = "Kontakt";
const Document$m = "Dokument";
const Nojobsfound$m = "Nebyly nalezeny žádné práce";
const LinkJob$m = "Propojit práci";
const youCanLinkContactJobImported$m = "Můžete propojit tento kontakt s pracovní nabídkou, kterou jste importovali do Careerflow.";
const Prev$m = "Není k dispozici dostatek informací k překladu.";
const Next$m = "Další";
const areYouSureUnlinkDocument$m = "Jste si jistí, že chcete odpojit tento dokument?";
const areYouSureDeleteDocument$m = "Jste si jistí, že chcete smazat tento dokument?";
const Category$m = "Kategorie";
const CreatedOn$m = "Vytvořeno dne";
const Joblinked$m = "Pracovně propojený";
const Quickactions$m = "Rychlé akce";
const All$m = "Vše";
const Resume$m = "Životopis";
const Portfolio$m = "Portfolio";
const Other$m = "Jiné";
const Adddocument$m = "Přidat dokument";
const Type$m = "Typ";
const Sortingby$m = "Třídění podle";
const SwitchtoGridLayout$m = "Přepnout na mřížkové rozvržení";
const SwitchtoListLayout$m = "Přepnout na seznamové rozvržení";
const NoDocumentsAdded$m = "Nebyly přidány žádné dokumenty";
const DocumentsComponent$m = {
	nodocs: "Dosud jste nevytvořili žádné dokumenty. Můžete nahrát verze svého životopisu, motivačních dopisů a dalších a propojit je s pracemi, které sledujete!"
};
const NoDocumentFound$m = "Žádný dokument nenalezen";
const SelectFile$m = "Vybrat soubor";
const onlyPdfDocxSupported$m = "Podporovány jsou pouze formáty .pdf a .docx.";
const Uploadfile$m = "Nahrát soubor";
const DocumentCategory$m = "Kategorie dokumentu";
const SaveDocument$m = "Uložit dokument";
const AddDocument$m = "Přidat dokument";
const LinkedDocuments$m = "Propojené dokumenty";
const LinkDocument$m = "Propojit dokument";
const NodocumentsLinked$m = "Žádné propojené dokumenty";
const JobDocumentsComponent$m = {
	linkDocs: "Propojením všech relevantních dokumentů, jako jsou váš životopis, motivační dopis atd., které jste odeslali pro tuto práci, si udržíte přehled o všem na jednom místě. Vyzkoušejte to!"
};
const NoDocuments$m = "Žádné dokumenty";
const CreateDocuments$m = "Vytvořit dokumenty";
const youCanLinkDocumentJobImported$m = "Můžete propojit tento dokument s pracovní nabídkou, kterou jste importovali do Careerflow.";
const Documenteditedsuccessfully$m = "Dokument byl úspěšně upraven.";
const DocumentDetails$m = "Podrobnosti dokumentu";
const UnsavedChanges$m = "Neuložené změny";
const yourChangesWillBeLostSureClose$m = "Vaše změny budou ztraceny, jste si jisti, že chcete zavřít?";
const yourChangesWillBeLostSureDiscard$m = "Vaše změny budou ztraceny, jste si jisti, že chcete své změny zrušit?";
const DiscardChanges$m = "Zrušit změny";
const WeeklyGoalAlert$m = "Týdenní upozornění na cíle";
const Progress$m = "Pokrok";
const AllGoals$m = "Všechny cíle";
const Name$m = "Jméno";
const Completedon$m = "Dokončeno dne";
const Createdon$m = "Vytvořeno dne";
const Action$m = "Akce";
const Back$m = "Zpět";
const OverallScore$m = "Celkové hodnocení";
const Aboutthegoal$m = "O cíli";
const GoalTracking$m = "Sledování cíle";
const Week$m = "Týden";
const progress$m = "pokrok";
const loading$m = "Načítání";
const Apply$m = "Použít";
const Thisskillhasbeenreported$m = "Tato dovednost byla nahlášena.";
const issueGettingResume$m = "Došlo k problému s získáním životopisu.";
const Interview$m = "Rozhovor";
const Tasks$m = "Úkoly";
const Loading$m = "Načítání";
const Skilladdedsuccessfully$m = "Dovednost úspěšně přidána.";
const problemAddingSkill$m = "Došlo k problému při přidávání dovednosti.";
const Reportaproblem$m = "Nahlásit problém";
const Submit$m = "Odeslat";
const Addanewskill$m = "Přidat novou dovednost";
const JobDetailsComponent$m = {
	classifySkill: "Jak byste klasifikovali tuto dovednost (volitelné)?",
	includedKeywordsWillCount: "Zahrnout tento klíčový výraz?",
	yesIncludeThisSkill: "Zahrnutá klíčová slova budou brána v úvahu při všech budoucích skenováních. Můžete změnit zahrnutá klíčová slova ze svého profilu.",
	addSkill: "Chcete to přidat jako dovednost?"
};
const HardSkill$m = "Tvrdá dovednost";
const SoftSkill$m = "Měkká dovednost";
const Pleaseshareanyadditionalcontext$m = "Sdílejte prosím jakýkoli další kontext";
const Addasskill$m = "Přidat jako dovednost";
const Skill$m = "Dovednost";
const JobFrequency$m = "Frekvence práce";
const ResumeFrequency$m = "Frekvence životopisu";
const Reportskill$m = "Nahlásit dovednost";
const JobDetails$m = "Podrobnosti o práci";
const ViewJobLink$m = "Zobrazit odkaz na práci";
const Salary$m = "Plat";
const areYouSureDeleteJob$m = "Jste si jistý/á, že chcete smazat tuto práci?";
const ViewMore$m = "Zobrazit více";
const ViewLess$m = "Zobrazit méně";
const matchYouSkillsAgainstJob$m = "Porovnejte své dovednosti s popisem práce.";
const pleaseUploadResumeSkillMatch$m = "Prosím, nahrajte své životopis k získání skóre shody vašich dovedností.";
const AddResume$m = "Přidat životopis";
const thisJobDoesNotHaveAnyDesc$m = "Tato práce nemá žádný popis.";
const youCanEditJobToAdd$m = "Můžete upravit tuto práci a přidat k ní popis. Můžete také importovat práce pomocí našeho.";
const chromeextension$m = "rozšíření pro Chrome";
const fromVariousJobPortalsOnce$m = "z různých pracovních portálů. Jakmile přidáte popis, budete také schopni vidět informace související se schopnostmi.";
const AddDescription$m = "Přidat popis";
const CompanyInfo$m = "Informace o společnosti";
const Website$m = "Webová stránka";
const Industry$m = "Průmysl";
const EmployeeCount$m = "Počet zaměstnanců";
const ExprienceLevel$m = "Úroveň zkušeností";
const Address$m = "Adresa";
const Resumes$m = "Životopisy";
const Setasdefault$m = "Nastavit jako výchozí";
const Ok$m = "Ok";
const UploadNewResume$m = "Nahrát nový životopis";
const Default$m = "Výchozí";
const Jobnotfound$m = "Práce nenalezena.";
const EditDetails$m = "Upravit podrobnosti";
const JobPostURL$m = "URL příspěvku o práci";
const Enterjoburl$m = "Zadejte URL adresu práce";
const Nojobselected$m = "Nebyla vybrána žádná práce";
const Viewjobdetails$m = "Zobrazit detaily práce";
const Jobaddedtoyourboardsuccessfully$m = "Práce byla úspěšně přidána na vaši desku.";
const AddJob$m = "Přidat práci";
const Addnewjobname$m = "Přidat nový název práce";
const JobUrl$m = "URL práce";
const Addjoburl$m = "Přidat URL práce";
const Section$m = "Sekce";
const didYouKnow$m = {
	chromeExtension: "Věděli jste, že? Můžete také ukládat práce přímo z našeho rozšíření pro Chrome a všechna data importovat jedním kliknutím! Trvá to jen pár sekund."
};
const Jobs$m = "Práce";
const AddJobtoboard$m = "Přidat práci na nástěnku";
const Currentlynojobsareavailable$m = "Momentálně nejsou k dispozici žádné pracovní pozice.";
const noMatchingJobs$m = "Nebyly nalezeny žádné odpovídající pracovní pozice.";
const welcomeToYourPersonalJobTracker$m = "Vítejte ve vašem osobním sledovači pracovních pozic!";
const weShortTutorialOnHowTrackingJob$m = "Přivedeme vás krátkým tutoriálem, jak začít sledovat vaše žádosti o práci v několika snadných krocích!";
const Addanewjob$m = "Přidat novou práci";
const inOrderTrackCreatButton$m = "Aby začali sledovat žádosti o práci, musíte ji nejprve přidat na desku kliknutím na tlačítko „Vytvořit“.";
const Providesomedetails$m = "Poskytněte nějaké podrobnosti.";
const toBeginTypeJobTitleCompany$m = "Nejprve jednoduše zadejte název pracovní pozice, název společnosti a stav, ke kterému ji chcete přidat. Podrobnosti můžete přidat později, ale pro začátek toto stačí!";
const asAnExampleFilledForYou$m = "Jako příklad jsme to již pro vás vyplnili!";
const wohooAddedFirstJob$m = "Woohoo! Přidal jsi svou první práci do svého sledovače pracovních pozic!";
const youCanDragDropJobCard$m = "Nyní můžete táhnout a upouštět pracovní kartu do různých fází procesu přihlášení o práci. Kliknutím na pracovní kartu si můžete zobrazit více podrobností, upravit je, uložit poznámky a mnoho dalšího!";
const Lastbutnotleast$m = "Nakonec ale nejméně";
const finalStepMakeSure$m = "Jako poslední krok se ujistěte, že máte naši.";
const autoMaticallyImportJobs$m = "co vám umožní automaticky importovat pracovní nabídky z vašich oblíbených webových stránek pro hledání práce, jako jsou LinkedIn, Indeed a další! Naše rozšíření vám také pomáhá vylepšit váš profil na LinkedIn a získat 2,5krát více zobrazení ve vyhledávání!";
const selectanysection$m = "Vyberte libovolnou sekci";
const Accept$m = "Přijmout";
const My2023JobSearch$m = "Můj hledání práce v roce 2023";
const AddedFrom$m = "Přidáno z";
const AddedUntil$m = "Přidáno do";
const BasicModal$m = "Základní modální okno";
const AddnewSectionName$m = "Přidat nový název sekce";
const OpenTo$m = "Otevřeno pro";
const Featured$m = "Doporučené";
const LicenceAndCerts$m = "Licence a certifikáty";
const Banner$m = "Banner";
const LinkedInURL$m = "LinkedIn URL";
const Recommendations$m = "Doporučení";
const LinkedinReview$m = "Přehled na Linkedinu";
const NoDataAvailable$m = "Žádná dostupná data";
const looksLikeYouDidNot$m = "Vypadá to, že jste ještě nezačali používat naše";
const toOptimizeProfileScoreVisible$m = "Ještě jste neoptimalizovali svůj profil na LinkedIn. Jakmile to uděláte, váš skóre profilu bude viditelné zde.";
const LinkedinComponent$m = {
	letsOptimize: "Optimalizujme to"
};
const improveYourChancesLandingDreamJob$m = "Zlepšete své šance na získání svého vysněného zaměstnání. Použijte tyto ověřené strategie k tomu, aby váš profil na LinkedIn dostal potřebnou úpravu.";
const VisitProfile$m = "Navštívit profil";
const wantToGetLinkedinMakeover$m = "Chcete získat kompletní přeměnu profilu na LinkedIn?";
const PostGenerator$m = "Generátor příspěvků";
const LinkedinHeadlineGenerator$m = "Generátor nadpisů LinkedIn";
const LinkedinAboutSectionGenerator$m = "Generátor sekce O mně na LinkedIn";
const AITools$m = "Nástroje AI";
const Premium$m = "Prémiový";
const LinkedInOptimization$m = "Optimalizace na LinkedIn";
const JobTracker$m = "Sledovač pracovních pozic";
const whoIsHiring$m = "Kdo nabírá";
const Autofill$m = "Automatické vyplňování";
const HeadlineGenerator$m = "Generátor titulků";
const skillMatching$m = "Shodování dovedností";
const SummarizeJD$m = "Shrnutí popisu práce";
const contactFeature$m = "Sledování kontaktů";
const documentFeature$m = "Dokumenty";
const landJobWithoutStress$m = "Získejte svou vysněnou práci. Bez stresu.";
const discoverFeatures$m = "Objevte širokou škálu funkcí Careerflow.ai navržených k usnadnění vašeho hledání práce a zlepšení vaší profesionální cesty!";
const letsBeginOnboarding$m = "Pojďme se lépe poznat!";
const inTheNextFewScreensJobThirdParties$m = "V následujících několika obrazovkách vám položíme několik otázek, které nám pomohou přizpůsobit zážitek pro vás a automaticky vyplnit vaše žádosti o práci (takže to nemusíte dělat sami)! Vaše data neprodáváme žádným třetím stranám.";
const letsAddBasicInformation$m = "Přidejme vaše základní informace.";
const Pleaseselectanoptionfirst$m = "Prosím, nejprve vyberte možnost.";
const JobApplicationTracker$m = "Sledovač žádostí o zaměstnání";
const LinkedInProfileOptimizer$m = "Optimalizátor profilu na LinkedIn";
const UnlimitedDocuments$m = "Neomezené dokumenty";
const UnlimitedContacts$m = "Neomezené kontakty";
const HiringManagerSearch$m = "Hledání manažera pro nábor zaměstnanců";
const AILinkedInPostGenerator$m = "Generátor příspěvků na LinkedIn s využitím umělé inteligence";
const ATSKeywordSkillMatch$m = "Práce odpovídající klíčovým slovům / dovednostem ATS";
const ChooseyourPlan$m = "Vyberte si svůj plán";
const superChargeYourJobSearch$m = "Zrychlete své hledání práce a zlepšete svůj proces podávání žádostí o práci, zvýšte počet pohovorů a získejte svou vysněnou práci. To vše s pomocí prémiového nástroje Careerflow.";
const startNowGoto$m = "Začněte nyní (Přejít do aplikace)";
const CreatedBy$m = "Vytvořil";
const CreateNewNote$m = "Vytvořit novou poznámku";
const Nonotescreated$m = "Nebyly vytvořeny žádné poznámky";
const approxTimeIsFourMinutes$m = "Přibližný čas dokončení procesu onboardingu je 4 minuty.";
const Continue$m = "Pokračovat";
const iWillDoLaterTakeMeToApp$m = "To udělám později. Převeď mě do aplikace.";
const allDone$m = "Vše hotovo!";
const welcomeAbord$m = "Vítejte na palubě!";
const letsBegin$m = "Začněme";
const UpgradeyourplanandgetAIAssistance$m = "Vylepšete svůj plán a získejte pomoc umělé inteligence.";
const DownloadPDF$m = "Stáhnout PDF";
const oopsWeCouldntProcessResume$m = "Omlouváme se, nemohli jsme zpracovat tento životopis.";
const MyProfile$m = "Můj profil";
const Setting$m = "Nastavení";
const Logout$m = "Odhlásit se";
const SignIn$m = "Přihlásit se";
const Typeyourfirstnamehere$m = "Vaše křestní jméno";
const Enteryourlastname$m = "Vaše příjmení";
const ManageSubscription$m = "Spravovat předplatné";
const ifYouHaveDifficultiesProfile$m = "Pokud máte nějaké potíže s informacemi ve svém profilu, obraťte se na";
const forSupport$m = "pro podporu.";
const whatIsIdealCompanySize$m = "Jaká je pro vás ideální velikost společnosti?";
const Saveandcontinue$m = "Uložit a pokračovat";
const whatIsMinExpectedSalary$m = "Jaká je vaše minimální očekávaná mzda (za rok)?";
const Atleast$m = "Alespoň";
const SlidetoAdjust$m = "Přesuňte pro nastavení";
const whatIndustryExcitedWork$m = "Které průmysly vás vzrušují?";
const Add$m = "Přidat";
const statusOfJobSearch$m = "Stav vašeho hledání práce?";
const Finish$m = "Hotovo";
const whatLevelRoleLooking$m = "Na jaké úrovni role se chcete podílet?";
const Selectuptotwo$m = "Vyberte až dva.";
const PreviousStep$m = "Předchozí krok";
const Skip$m = "Přeskočit";
const whatDoYouValueNewRole$m = "Co v nové roli oceňujete?";
const Selectuptothree$m = "Vyberte až tři.";
const EqualEmploymentData$m = "Rovné zaměstnanecké údaje";
const whatIsYourEthnicity$m = "Jaké jste národnosti?";
const areYouAuthorizedToWorkUs$m = "Máte povolení pracovat v USA?";
const willYouRequireSponsorShip$m = "Budete nyní nebo v budoucnu vyžadovat sponzorství pro zaměstnanecký vízový status?";
const doYouHaveADisability$m = "Máte nějaké postižení?";
const areYouAVeteran$m = "Jste veterán?";
const rolesYouInterestedIn$m = "V jakých rolích máte zájem?";
const Selectuptofive$m = "Vyberte až pět.";
const AddCustomrole$m = "Přidat vlastní roli";
const whereDoYouLikeWork$m = "Kde byste chtěli pracovat?";
const Resources$m = "Zdroje";
const currentlyNoResourceAvailable$m = "Momentálně nejsou k dispozici žádné zdroje.";
const AddNewSection$m = "Přidat novou sekci";
const ChangeSections$m = "Změnit sekce";
const Settings$m = "Nastavení";
const Dashboard$m = "Přehled";
const JobBoard$m = "Pracovní deska";
const Linkedin$m = "Linkedin";
const Community$m = "Komunita";
const FindRecruiters$m = "Najít náboráře";
const Goals$m = "Cíle";
const DownloadExtension$m = "Stáhnout rozšíření";
const SuggestaFeature$m = "Navrhnout funkci";
const leftPanel$m = {
	ReportanIssue: "Nahlásit problém"
};
const PhoneNumberisrequired$m = "Telefonní číslo je povinné.";
const MobileNumber$m = "Mobilní číslo";
const Enteronlynumbers$m = "Zadejte pouze čísla";
const Countryyoulivein$m = "Země, ve které žijete";
const SelectaCountry$m = "Vyberte zemi";
const DateofBirth$m = "Datum narození";
const Gender$m = "Pohlaví";
const JobPreferences$m = "Preferované zaměstnání";
const pleaseEnterValidEmail$m = "Prosím, zadejte platnou e-mailovou adresu.";
const emailSendForResetting$m = "Byl vám zaslán e-mail pro resetování hesla.";
const VerifyyourEmailID$m = "Ověřte své e-mailové ID";
const sentPleaseCheckEmail$m = "Odesláno! Zkontrolujte svůj e-mail.";
const tooManyAttemptsTryAgain$m = "Příliš mnoho pokusů, zkuste to prosím znovu za chvíli.";
const Resend$m = "Znovu odeslat";
const Login$m = "Přihlášení";
const weHaveSentVerificationLinkAtEmail$m = "Poslali jsme vám ověřovací odkaz na vaši e-mailovou adresu.";
const pleaseVerifyEmailContinueSpam$m = "Prosím ověřte svůj email, aby jste mohli pokračovat. Také zkontrolujte složky spam nebo propagace pro ověřovací email.";
const Logintogetstarted$m = "Přihlaste se a začněte";
const ContinuewithGoogle$m = "Pokračovat s Googlem";
const pleaseInputEmail$m = "Prosím, zadejte svůj email!";
const Password$m = "Heslo";
const pleaseInputPassword$m = "Prosím, zadejte své heslo!";
const passwordLowerUpperDigitSpecial$m = "Vaše heslo musí obsahovat alespoň jedno malé písmeno, velké písmeno, číslici a speciální znak.";
const atLeastSixChar$m = "Alespoň 6 znaků.";
const forgotPassword$m = "Zapomněli jste heslo?";
const Bysigninginyouagreetoour$m = "Přihlášením souhlasíte s našimi.";
const Terms$m = "Podmínky";
const Conditions$m = "Podmínky";
const and$m = "a";
const PrivacyPolicy$m = "Zásady ochrany osobních údajů";
const theseAreTheTopsSkillsExtracted$m = "Toto jsou nejlepší dovednosti vyvozené z popisu práce.";
const TopSkills$m = "Nejlepší dovednosti";
const weCoulNotExtractSkills$m = "Nepodařilo se nám získat žádné dovednosti z této pracovní nabídky.";
const upgradeToPremiumToView$m = "Upgradujte na Premium, abyste viděli shodu dovedností vašeho životopisu.";
const SkillScore$m = "Skóre dovednosti";
const thisIsYourSkillScoreBasedOn$m = "Toto je váš skóre dovedností založené na popisu práce a vašem životopise.";
const theseSkllsAreStrongMatch$m = "Tyto dovednosti jsou silným zápasem mezi tvým životopisem a popisem práce.";
const Strongmatch$m = "Silná shoda";
const theseSkillsArePartialMatch$m = "Tyto dovednosti jsou částečně shodné mezi vaším životopisem a popisem práce.";
const Partialmatch$m = "Částečné shodnutí";
const theseSkillsAreMissingFrom$m = "Tyto klíčová slova chybí ve vašem životopise, ale jsou uvedena v popisu práce. Mohou to být dovednosti nebo obecná klíčová slova, která jsou specifická pro pracovní příležitost a mohou být užitečná k přidání do vašeho životopisu.";
const SkillMatchComponent$m = {
	removeSkill: "Jaký je váš hlavní důvod nahlášení problému s klíčovým slovem"
};
const Optional$m = "Volitelné";
const Notrelevanttothejob$m = "Není relevantní pro práci";
const Notaskill$m = "Žádná dovednost";
const Toogeneric$m = "Příliš obecné";
const Pleaseshareanyfeedback$m = "Sdílejte prosím jakékoli zpětné vazby";
const excludedKeywordsWillNot$m = "Vyloučená klíčová slova se nebudou počítat do vašeho shodného skóre pro všechny budoucí skenování. Můžete změnit vyloučená klíčová slova ze svého profilu.";
const yesExcludeThisSkillFrom$m = "Ano, vyloučit tuto dovednost ze všech skenů mých životopisů.";
const PartialMatch$m = "Částečná shoda";
const MissingKeywords$m = "Chybějící klíčová slova";
const Providetitletotask$m = "Poskytněte název úkolu";
const TasksList$m = "Seznam úkolů";
const AddTask$m = "Přidat úkol";
const EnterTaskTitlehere$m = "Zadejte název úkolu zde";
const TasksComponent$m = {
	listEmpty: "Seznam úkolů je prázdný, vytvořte nový."
};
const CompletedTasks$m = "Dokončené úkoly";
const CompleteYourtasks$m = "Dokončete své úkoly";
const Steps$m = "Kroky";
const PremiumMember$m = "Prémiový člen";
const Thankyouforupgradingto$m = "Děkujeme vám za upgrade na\"\"\"";
const CareerflowPremium$m = "Kariérní tok Premium";
const hereIsHowYouCanAccessPremium$m = "Zde je, jak získat své prémiové výhody!";
const stepOne$m = "Krok 1";
const DownloadourChromeExtension$m = "Stáhněte si naše rozšíření pro Chrome.";
const youJobSearchCopilotIshere$m = "Váš AI spolujezdec při hledání práce je tady.";
const DownloadNow$m = "Stáhnout nyní";
const stepTwo$m = "Krok 2";
const GetStarted$m = "Začněte";
const stepThree$m = "Krok 3";
const SignintoChromeExtension$m = "Přihlásit se do rozšíření Chrome";
const entityCreated$m = "Vytvořen nový {{entity}}";
const entityUpdated$m = "{{entity}} aktualizováno.";
const entityDeleted$m = "{{entity}} smazáno.";
const entityLinked$m = "{{entity}} propojeno";
const entityUnlinked$m = "{{entity}} odpojeno";
const entityMovedTo$m = "Přesunuto do {{entity}}.";
const youAddedANewEntity$m = "Přidali jste novou {{entity}}.";
const personCreated$m = "{{creator}} vytvořil {{entity}} pro {{owner}}.";
const youUpdatedAEntity$m = "Aktualizoval(a) jste {{entity}}.";
const personUpdated$m = "{{creator}} aktualizoval {{entity}} pro {{owner}}.";
const youDeletedAEntity$m = "Smažl jsi {{entity}}";
const personDeleted$m = "{{creator}} smazal {{entity}} pro {{owner}}.";
const youLinkedEntity$m = "Připojili jste {{entity}} k této práci.";
const personLinked$m = "{{creator}} propojil {{entity}} s tímto úkolem pro {{owner}}.";
const youUnlinked$m = "Odloučili jste {{entity}} od této práce.";
const personUnlinked$m = "{{creator}} odpojil {{entity}} od této práce pro {{owner}}.";
const youMovedEntity$m = "Přesunuli jste tento {{entity}} z {{sectionFrom}} do {{sectionTo}}.";
const personMoved$m = "{{creator}} přesunul tento {{entity}} z {{sectionFrom}} do {{sectionTo}} pro {{owner}}.";
const addedByName$m = "Přidáno uživatelem {{name}}.";
const DownloadChromeExtension$m = "Stáhnout rozšíření Chrome";
const ourChromeExtensionIs$m = "Náš chrome doplněk je integrovaný nástroj, který vám pomůže optimalizovat váš LinkedIn profil, ukládat pracovní nabídky, ukládat kontakty, generovat motivační dopis a mnoho dalšího.";
const Optimizeyourprofile$m = "Optimalizujte svůj profil.";
const startOptimizingYourProfile$m = "Začněte optimalizovat svůj profil, aby se zvýšily vaše šance na kontaktování ze strany náborářů.";
const OptimizeNow$m = "Optimalizovat nyní";
const Addyourfirstjob$m = "Přidejte svou první práci";
const startSavingJobApplicationsToTrack$m = "Začněte ukládat žádosti o práci, abyste sledovali svou cestu hledání práce a získali užitečné poznatky.";
const AddNow$m = "Přidat nyní";
const CompleteProfile$m = "Kompletní profil";
const completeYourProfileForUsing$m = "Dokončete svůj profil pro použití funkce automatického vyplňování a získání více personalizovaného zážitku.";
const CompleteNow$m = "Dokončit nyní";
const Addyourfirstcontact$m = "Přidejte svůj první kontakt";
const addContactToFollowUpWith$m = "Přidejte kontakt pro pozdější následné jednání, přidejte poznámky a další informace.";
const JoinCommunity$m = "Připojte se k komunitě";
const ourCommunityisAlways$m = "Naše komunita je vždy s vámi během vaší cesty hledání práce.";
const JoinNow$m = "Připojte se nyní";
const welcomeToCareerflow$m = "Vítejte v Careerflow!";
const yourHubForCareerInsights2$m = "Toto je váš střed pro kariérní poznatky, aktivity a další. Prozkoumejte svou personalizovanou nástěnku, abyste zůstali na vrcholu své profesionální cesty.";
const ChecklistCompleted$m = "Vaše kontrolní seznam je dokončen!";
const Completeyourchecklist$m = "Dokončete svůj kontrolní seznam";
const completeAFewStepsTo$m = "Dokončete několik kroků, abyste získali svou další práci.";
const Completed$m = "Dokončeno";
const JobCountByStage$m = "Počet pracovních pozic podle fáze";
const NopastapplicationDatafound$m = "Nebyla nalezena žádná minulá data aplikace.";
const YourJobSearchStages$m = "Fáze vašeho hledání práce";
const NoDatafound$m = "Nebyly nalezeny žádné údaje.";
const cs = {
	copyToClipboard: copyToClipboard$m,
	UnlocktheAIgenerated: UnlocktheAIgenerated$m,
	UpgradetoPremium: UpgradetoPremium$m,
	Result: Result$m,
	Copy: Copy$m,
	Save: Save$m,
	Edit: Edit$m,
	Processing: Processing$m,
	YourAIgeneratedcontentwillshowhere: YourAIgeneratedcontentwillshowhere$m,
	hopeYouFindUseful: hopeYouFindUseful$m,
	regenerate: regenerate$m,
	ProvideAdditionalFeedback: ProvideAdditionalFeedback$m,
	Enteranyfeedback: Enteranyfeedback$m,
	Notimpressive: Notimpressive$m,
	thisIsntTrue: thisIsntTrue$m,
	Notpersonalized: Notpersonalized$m,
	Tone: Tone$m,
	Length: Length$m,
	Template: Template$m,
	Generatedon: Generatedon$m,
	Copiedtoclipboard: Copiedtoclipboard$m,
	CopytoClipboard: CopytoClipboard$m,
	DownloadasPDF: DownloadasPDF$m,
	ViewDetails: ViewDetails$m,
	JobDescriptionImported: JobDescriptionImported$m,
	ImportfromJob: ImportfromJob$m,
	Saved: Saved$m,
	Applied: Applied$m,
	Offer: Offer$m,
	Interviewing: Interviewing$m,
	Rejected: Rejected$m,
	Search: Search$m,
	Import: Import$m,
	CoverLetterGeneratorHistory: CoverLetterGeneratorHistory$m,
	NoCoverLettersGenerated: NoCoverLettersGenerated$m,
	getStartedCoverLetter: getStartedCoverLetter$m,
	getStarted: getStarted$m,
	Documents: Documents$m,
	UploadNewDocument: UploadNewDocument$m,
	AICoverLetterGenerator: AICoverLetterGenerator$m,
	ViewHistory: ViewHistory$m,
	JobDescription: JobDescription$m,
	ImportfromBoard: ImportfromBoard$m,
	EnterJobDescription: EnterJobDescription$m,
	JobTitle: JobTitle$m,
	EnterJobTitle: EnterJobTitle$m,
	CompanyName: CompanyName$m,
	EnterCompanyName: EnterCompanyName$m,
	YourProfile: YourProfile$m,
	ResumeUpload: ResumeUpload$m,
	UseLinkedinProfile: UseLinkedinProfile$m,
	Uploadyourresume: Uploadyourresume$m,
	AddyourResume: AddyourResume$m,
	fileNameCannotFormat: fileNameCannotFormat$m,
	ChooseorUpload: ChooseorUpload$m,
	SelectTemplate: SelectTemplate$m,
	Preview: Preview$m,
	UseTemplate: UseTemplate$m,
	Change: Change$m,
	AdvancedSettings: AdvancedSettings$m,
	AdditionalContext: AdditionalContext$m,
	Professional: Professional$m,
	Casual: Casual$m,
	Enthusiastic: Enthusiastic$m,
	Informational: Informational$m,
	Short: Short$m,
	Medium: Medium$m,
	Long: Long$m,
	Language: Language$m,
	iAmOkayBack: iAmOkayBack$m,
	Generate: Generate$m,
	CoverLetter: CoverLetter$m,
	SelectLanguage: SelectLanguage$m,
	AboutGeneratorHistory: AboutGeneratorHistory$m,
	NoAboutsGenerated: NoAboutsGenerated$m,
	getStartedAbouts: getStartedAbouts$m,
	noAttachmentsFound: noAttachmentsFound$m,
	TargetJobTitle: TargetJobTitle$m,
	KeywordsToInclude: KeywordsToInclude$m,
	UploadYourResume: UploadYourResume$m,
	AddYourResume: AddYourResume$m,
	LinkedinProfile: LinkedinProfile$m,
	Linkedinprofilenotfound: Linkedinprofilenotfound$m,
	startUsingChromeExtension: startUsingChromeExtension$m,
	Download: Download$m,
	UseEmojis: UseEmojis$m,
	UseBulletPoints: UseBulletPoints$m,
	SpeechFocus: SpeechFocus$m,
	FirstPerson: FirstPerson$m,
	ThirdPerson: ThirdPerson$m,
	HeadlineGeneratorHistory: HeadlineGeneratorHistory$m,
	NoHeadlinesGenerated: NoHeadlinesGenerated$m,
	getStartedHeadline: getStartedHeadline$m,
	AIHeadlineGenerator: AIHeadlineGenerator$m,
	KeywordstoInclude: KeywordstoInclude$m,
	Pressenteraftereachword: Pressenteraftereachword$m,
	LinkedinProfilenotfound: LinkedinProfilenotfound$m,
	Headline: Headline$m,
	PostGeneratorHistory: PostGeneratorHistory$m,
	NoPostsGenerated: NoPostsGenerated$m,
	getStartedPost: getStartedPost$m,
	Topic: Topic$m,
	Description: Description$m,
	UseHashtags: UseHashtags$m,
	Custom: Custom$m,
	EnterCustomTone: EnterCustomTone$m,
	Added: Added$m,
	ComingSoon: ComingSoon$m,
	Company: Company$m,
	JobInterview: JobInterview$m,
	Research: Research$m,
	Networking: Networking$m,
	Referral: Referral$m,
	MustbeContacted: MustbeContacted$m,
	ScheduleaMeeting: ScheduleaMeeting$m,
	needAFollowUp: needAFollowUp$m,
	Today: Today$m,
	Viewdetails: Viewdetails$m,
	Activity: Activity$m,
	ActivityDetails: ActivityDetails$m,
	Delete: Delete$m,
	Title: Title$m,
	Goal: Goal$m,
	Status: Status$m,
	FollowUp: FollowUp$m,
	AddActivity: AddActivity$m,
	Enteractivitytitle: Enteractivitytitle$m,
	Cancel: Cancel$m,
	SaveActivity: SaveActivity$m,
	noActivityPresent: noActivityPresent$m,
	Addnew: Addnew$m,
	About: About$m,
	noDataPresentYou: noDataPresentYou$m,
	Experience: Experience$m,
	Education: Education$m,
	Skills: Skills$m,
	Overview: Overview$m,
	LinkedJobs: LinkedJobs$m,
	Notes: Notes$m,
	FullName: FullName$m,
	Location: Location$m,
	Relationship: Relationship$m,
	Contacts: Contacts$m,
	CreateContact: CreateContact$m,
	NotesCreated: NotesCreated$m,
	Notesupdated: Notesupdated$m,
	Addnote: Addnote$m,
	areYouSureDeleteNote: areYouSureDeleteNote$m,
	Createdby: Createdby$m,
	notSureWhyResumeCalls: notSureWhyResumeCalls$m,
	getExpertResumeReview: getExpertResumeReview$m,
	youHaventAddedContacts: youHaventAddedContacts$m,
	noMatchingContacts: noMatchingContacts$m,
	Link: Link$m,
	unlink: unlink$m,
	Locationnotavailable: Locationnotavailable$m,
	Emailnotavailable: Emailnotavailable$m,
	PhoneNumbernotavailable: PhoneNumbernotavailable$m,
	createdby: createdby$m,
	areYouSureDeleteContact: areYouSureDeleteContact$m,
	areYouSureUnlinkContact: areYouSureUnlinkContact$m,
	Addedbyyou: Addedbyyou$m,
	Addedby: Addedby$m,
	Timeline: Timeline$m,
	Timelineempty: Timelineempty$m,
	Discard: Discard$m,
	SaveContact: SaveContact$m,
	Recruiter: Recruiter$m,
	Candidate: Candidate$m,
	Colleague: Colleague$m,
	Employee: Employee$m,
	"Needtofollow-up": "Je třeba následovat",
	EnterValidEmail: EnterValidEmail$m,
	EnterValidPhoneNumber: EnterValidPhoneNumber$m,
	editingProfileNotAvailable: editingProfileNotAvailable$m,
	itWillBeSoonAvailable: itWillBeSoonAvailable$m,
	ChromeExtension: ChromeExtension$m,
	SelectTag: SelectTag$m,
	FirstName: FirstName$m,
	FirstNameisrequired: FirstNameisrequired$m,
	LastName: LastName$m,
	LastNameisrequired: LastNameisrequired$m,
	Companyisrequired: Companyisrequired$m,
	Email: Email$m,
	ThisisnotavalidEmail: ThisisnotavalidEmail$m,
	AddEmail: AddEmail$m,
	PhoneNumber: PhoneNumber$m,
	notaValidPhone: notaValidPhone$m,
	phoneNoMinimum5char: phoneNoMinimum5char$m,
	phoneNoMinumum15char: phoneNoMinumum15char$m,
	AddPhoneNumber: AddPhoneNumber$m,
	SelectGoal: SelectGoal$m,
	SelectStatus: SelectStatus$m,
	Followup: Followup$m,
	SocialMedia: SocialMedia$m,
	Linkedinhandle: Linkedinhandle$m,
	Twitterhandle: Twitterhandle$m,
	Facebookhandle: Facebookhandle$m,
	Githubhandle: Githubhandle$m,
	Gmailhandle: Gmailhandle$m,
	Changessavedsuccessfully: Changessavedsuccessfully$m,
	EditContact: EditContact$m,
	BasicInformation: BasicInformation$m,
	EditContactDetails: EditContactDetails$m,
	SaveChanges: SaveChanges$m,
	phoneNoMinimum14char: phoneNoMinimum14char$m,
	LinkedIn: LinkedIn$m,
	Twitter: Twitter$m,
	Facebook: Facebook$m,
	Github: Github$m,
	Gmail: Gmail$m,
	youCanWriteAbout: youCanWriteAbout$m,
	Addednewsection: Addednewsection$m,
	Removedsuccessfully: Removedsuccessfully$m,
	Remove: Remove$m,
	Institute: Institute$m,
	Schoolisrequired: Schoolisrequired$m,
	Degree: Degree$m,
	StartMonth: StartMonth$m,
	StartYear: StartYear$m,
	EndMonth: EndMonth$m,
	EndYear: EndYear$m,
	Addmore: Addmore$m,
	PositionTitle: PositionTitle$m,
	ExperienceType: ExperienceType$m,
	Addednewitem: Addednewitem$m,
	whatSkillsDoYouEnjoy: whatSkillsDoYouEnjoy$m,
	Typeskillshere: Typeskillshere$m,
	LinkedContacts: LinkedContacts$m,
	LinkContact: LinkContact$m,
	NocontactsLinked: NocontactsLinked$m,
	JobContactsComponent: JobContactsComponent$m,
	Nocontacts: Nocontacts$m,
	LinkJobto: LinkJobto$m,
	Contact: Contact$m,
	Document: Document$m,
	Nojobsfound: Nojobsfound$m,
	LinkJob: LinkJob$m,
	youCanLinkContactJobImported: youCanLinkContactJobImported$m,
	Prev: Prev$m,
	Next: Next$m,
	areYouSureUnlinkDocument: areYouSureUnlinkDocument$m,
	areYouSureDeleteDocument: areYouSureDeleteDocument$m,
	Category: Category$m,
	CreatedOn: CreatedOn$m,
	Joblinked: Joblinked$m,
	Quickactions: Quickactions$m,
	All: All$m,
	Resume: Resume$m,
	Portfolio: Portfolio$m,
	Other: Other$m,
	Adddocument: Adddocument$m,
	Type: Type$m,
	Sortingby: Sortingby$m,
	SwitchtoGridLayout: SwitchtoGridLayout$m,
	SwitchtoListLayout: SwitchtoListLayout$m,
	NoDocumentsAdded: NoDocumentsAdded$m,
	DocumentsComponent: DocumentsComponent$m,
	NoDocumentFound: NoDocumentFound$m,
	SelectFile: SelectFile$m,
	onlyPdfDocxSupported: onlyPdfDocxSupported$m,
	Uploadfile: Uploadfile$m,
	DocumentCategory: DocumentCategory$m,
	SaveDocument: SaveDocument$m,
	AddDocument: AddDocument$m,
	LinkedDocuments: LinkedDocuments$m,
	LinkDocument: LinkDocument$m,
	NodocumentsLinked: NodocumentsLinked$m,
	JobDocumentsComponent: JobDocumentsComponent$m,
	NoDocuments: NoDocuments$m,
	CreateDocuments: CreateDocuments$m,
	youCanLinkDocumentJobImported: youCanLinkDocumentJobImported$m,
	Documenteditedsuccessfully: Documenteditedsuccessfully$m,
	DocumentDetails: DocumentDetails$m,
	UnsavedChanges: UnsavedChanges$m,
	yourChangesWillBeLostSureClose: yourChangesWillBeLostSureClose$m,
	yourChangesWillBeLostSureDiscard: yourChangesWillBeLostSureDiscard$m,
	DiscardChanges: DiscardChanges$m,
	WeeklyGoalAlert: WeeklyGoalAlert$m,
	Progress: Progress$m,
	AllGoals: AllGoals$m,
	Name: Name$m,
	Completedon: Completedon$m,
	Createdon: Createdon$m,
	Action: Action$m,
	Back: Back$m,
	OverallScore: OverallScore$m,
	Aboutthegoal: Aboutthegoal$m,
	GoalTracking: GoalTracking$m,
	Week: Week$m,
	progress: progress$m,
	loading: loading$m,
	Apply: Apply$m,
	Thisskillhasbeenreported: Thisskillhasbeenreported$m,
	issueGettingResume: issueGettingResume$m,
	Interview: Interview$m,
	Tasks: Tasks$m,
	Loading: Loading$m,
	Skilladdedsuccessfully: Skilladdedsuccessfully$m,
	problemAddingSkill: problemAddingSkill$m,
	Reportaproblem: Reportaproblem$m,
	Submit: Submit$m,
	Addanewskill: Addanewskill$m,
	JobDetailsComponent: JobDetailsComponent$m,
	HardSkill: HardSkill$m,
	SoftSkill: SoftSkill$m,
	Pleaseshareanyadditionalcontext: Pleaseshareanyadditionalcontext$m,
	Addasskill: Addasskill$m,
	Skill: Skill$m,
	JobFrequency: JobFrequency$m,
	ResumeFrequency: ResumeFrequency$m,
	Reportskill: Reportskill$m,
	JobDetails: JobDetails$m,
	ViewJobLink: ViewJobLink$m,
	Salary: Salary$m,
	areYouSureDeleteJob: areYouSureDeleteJob$m,
	ViewMore: ViewMore$m,
	ViewLess: ViewLess$m,
	matchYouSkillsAgainstJob: matchYouSkillsAgainstJob$m,
	pleaseUploadResumeSkillMatch: pleaseUploadResumeSkillMatch$m,
	AddResume: AddResume$m,
	thisJobDoesNotHaveAnyDesc: thisJobDoesNotHaveAnyDesc$m,
	youCanEditJobToAdd: youCanEditJobToAdd$m,
	chromeextension: chromeextension$m,
	fromVariousJobPortalsOnce: fromVariousJobPortalsOnce$m,
	AddDescription: AddDescription$m,
	CompanyInfo: CompanyInfo$m,
	Website: Website$m,
	Industry: Industry$m,
	EmployeeCount: EmployeeCount$m,
	ExprienceLevel: ExprienceLevel$m,
	Address: Address$m,
	Resumes: Resumes$m,
	Setasdefault: Setasdefault$m,
	Ok: Ok$m,
	UploadNewResume: UploadNewResume$m,
	Default: Default$m,
	Jobnotfound: Jobnotfound$m,
	EditDetails: EditDetails$m,
	JobPostURL: JobPostURL$m,
	Enterjoburl: Enterjoburl$m,
	Nojobselected: Nojobselected$m,
	Viewjobdetails: Viewjobdetails$m,
	Jobaddedtoyourboardsuccessfully: Jobaddedtoyourboardsuccessfully$m,
	AddJob: AddJob$m,
	Addnewjobname: Addnewjobname$m,
	JobUrl: JobUrl$m,
	Addjoburl: Addjoburl$m,
	Section: Section$m,
	didYouKnow: didYouKnow$m,
	Jobs: Jobs$m,
	AddJobtoboard: AddJobtoboard$m,
	Currentlynojobsareavailable: Currentlynojobsareavailable$m,
	noMatchingJobs: noMatchingJobs$m,
	welcomeToYourPersonalJobTracker: welcomeToYourPersonalJobTracker$m,
	weShortTutorialOnHowTrackingJob: weShortTutorialOnHowTrackingJob$m,
	Addanewjob: Addanewjob$m,
	inOrderTrackCreatButton: inOrderTrackCreatButton$m,
	Providesomedetails: Providesomedetails$m,
	toBeginTypeJobTitleCompany: toBeginTypeJobTitleCompany$m,
	asAnExampleFilledForYou: asAnExampleFilledForYou$m,
	wohooAddedFirstJob: wohooAddedFirstJob$m,
	youCanDragDropJobCard: youCanDragDropJobCard$m,
	Lastbutnotleast: Lastbutnotleast$m,
	finalStepMakeSure: finalStepMakeSure$m,
	autoMaticallyImportJobs: autoMaticallyImportJobs$m,
	selectanysection: selectanysection$m,
	Accept: Accept$m,
	My2023JobSearch: My2023JobSearch$m,
	AddedFrom: AddedFrom$m,
	AddedUntil: AddedUntil$m,
	BasicModal: BasicModal$m,
	AddnewSectionName: AddnewSectionName$m,
	OpenTo: OpenTo$m,
	Featured: Featured$m,
	LicenceAndCerts: LicenceAndCerts$m,
	Banner: Banner$m,
	LinkedInURL: LinkedInURL$m,
	Recommendations: Recommendations$m,
	LinkedinReview: LinkedinReview$m,
	NoDataAvailable: NoDataAvailable$m,
	looksLikeYouDidNot: looksLikeYouDidNot$m,
	toOptimizeProfileScoreVisible: toOptimizeProfileScoreVisible$m,
	LinkedinComponent: LinkedinComponent$m,
	improveYourChancesLandingDreamJob: improveYourChancesLandingDreamJob$m,
	VisitProfile: VisitProfile$m,
	wantToGetLinkedinMakeover: wantToGetLinkedinMakeover$m,
	PostGenerator: PostGenerator$m,
	LinkedinHeadlineGenerator: LinkedinHeadlineGenerator$m,
	LinkedinAboutSectionGenerator: LinkedinAboutSectionGenerator$m,
	AITools: AITools$m,
	Premium: Premium$m,
	LinkedInOptimization: LinkedInOptimization$m,
	JobTracker: JobTracker$m,
	whoIsHiring: whoIsHiring$m,
	Autofill: Autofill$m,
	HeadlineGenerator: HeadlineGenerator$m,
	skillMatching: skillMatching$m,
	SummarizeJD: SummarizeJD$m,
	contactFeature: contactFeature$m,
	documentFeature: documentFeature$m,
	landJobWithoutStress: landJobWithoutStress$m,
	discoverFeatures: discoverFeatures$m,
	letsBeginOnboarding: letsBeginOnboarding$m,
	inTheNextFewScreensJobThirdParties: inTheNextFewScreensJobThirdParties$m,
	letsAddBasicInformation: letsAddBasicInformation$m,
	Pleaseselectanoptionfirst: Pleaseselectanoptionfirst$m,
	JobApplicationTracker: JobApplicationTracker$m,
	LinkedInProfileOptimizer: LinkedInProfileOptimizer$m,
	UnlimitedDocuments: UnlimitedDocuments$m,
	UnlimitedContacts: UnlimitedContacts$m,
	HiringManagerSearch: HiringManagerSearch$m,
	AILinkedInPostGenerator: AILinkedInPostGenerator$m,
	ATSKeywordSkillMatch: ATSKeywordSkillMatch$m,
	"Auto-Apply": "Automatické použití",
	ChooseyourPlan: ChooseyourPlan$m,
	superChargeYourJobSearch: superChargeYourJobSearch$m,
	startNowGoto: startNowGoto$m,
	CreatedBy: CreatedBy$m,
	CreateNewNote: CreateNewNote$m,
	Nonotescreated: Nonotescreated$m,
	approxTimeIsFourMinutes: approxTimeIsFourMinutes$m,
	Continue: Continue$m,
	iWillDoLaterTakeMeToApp: iWillDoLaterTakeMeToApp$m,
	allDone: allDone$m,
	welcomeAbord: welcomeAbord$m,
	letsBegin: letsBegin$m,
	UpgradeyourplanandgetAIAssistance: UpgradeyourplanandgetAIAssistance$m,
	DownloadPDF: DownloadPDF$m,
	oopsWeCouldntProcessResume: oopsWeCouldntProcessResume$m,
	MyProfile: MyProfile$m,
	Setting: Setting$m,
	Logout: Logout$m,
	SignIn: SignIn$m,
	Typeyourfirstnamehere: Typeyourfirstnamehere$m,
	Enteryourlastname: Enteryourlastname$m,
	ManageSubscription: ManageSubscription$m,
	ifYouHaveDifficultiesProfile: ifYouHaveDifficultiesProfile$m,
	forSupport: forSupport$m,
	whatIsIdealCompanySize: whatIsIdealCompanySize$m,
	Saveandcontinue: Saveandcontinue$m,
	whatIsMinExpectedSalary: whatIsMinExpectedSalary$m,
	Atleast: Atleast$m,
	SlidetoAdjust: SlidetoAdjust$m,
	whatIndustryExcitedWork: whatIndustryExcitedWork$m,
	Add: Add$m,
	statusOfJobSearch: statusOfJobSearch$m,
	Finish: Finish$m,
	whatLevelRoleLooking: whatLevelRoleLooking$m,
	Selectuptotwo: Selectuptotwo$m,
	PreviousStep: PreviousStep$m,
	Skip: Skip$m,
	whatDoYouValueNewRole: whatDoYouValueNewRole$m,
	Selectuptothree: Selectuptothree$m,
	EqualEmploymentData: EqualEmploymentData$m,
	whatIsYourEthnicity: whatIsYourEthnicity$m,
	areYouAuthorizedToWorkUs: areYouAuthorizedToWorkUs$m,
	willYouRequireSponsorShip: willYouRequireSponsorShip$m,
	doYouHaveADisability: doYouHaveADisability$m,
	areYouAVeteran: areYouAVeteran$m,
	rolesYouInterestedIn: rolesYouInterestedIn$m,
	Selectuptofive: Selectuptofive$m,
	AddCustomrole: AddCustomrole$m,
	whereDoYouLikeWork: whereDoYouLikeWork$m,
	Resources: Resources$m,
	currentlyNoResourceAvailable: currentlyNoResourceAvailable$m,
	AddNewSection: AddNewSection$m,
	ChangeSections: ChangeSections$m,
	Settings: Settings$m,
	Dashboard: Dashboard$m,
	JobBoard: JobBoard$m,
	Linkedin: Linkedin$m,
	Community: Community$m,
	FindRecruiters: FindRecruiters$m,
	Goals: Goals$m,
	DownloadExtension: DownloadExtension$m,
	SuggestaFeature: SuggestaFeature$m,
	leftPanel: leftPanel$m,
	PhoneNumberisrequired: PhoneNumberisrequired$m,
	MobileNumber: MobileNumber$m,
	Enteronlynumbers: Enteronlynumbers$m,
	Countryyoulivein: Countryyoulivein$m,
	SelectaCountry: SelectaCountry$m,
	DateofBirth: DateofBirth$m,
	Gender: Gender$m,
	JobPreferences: JobPreferences$m,
	pleaseEnterValidEmail: pleaseEnterValidEmail$m,
	emailSendForResetting: emailSendForResetting$m,
	VerifyyourEmailID: VerifyyourEmailID$m,
	sentPleaseCheckEmail: sentPleaseCheckEmail$m,
	tooManyAttemptsTryAgain: tooManyAttemptsTryAgain$m,
	Resend: Resend$m,
	Login: Login$m,
	weHaveSentVerificationLinkAtEmail: weHaveSentVerificationLinkAtEmail$m,
	pleaseVerifyEmailContinueSpam: pleaseVerifyEmailContinueSpam$m,
	Logintogetstarted: Logintogetstarted$m,
	ContinuewithGoogle: ContinuewithGoogle$m,
	pleaseInputEmail: pleaseInputEmail$m,
	Password: Password$m,
	pleaseInputPassword: pleaseInputPassword$m,
	passwordLowerUpperDigitSpecial: passwordLowerUpperDigitSpecial$m,
	atLeastSixChar: atLeastSixChar$m,
	forgotPassword: forgotPassword$m,
	Bysigninginyouagreetoour: Bysigninginyouagreetoour$m,
	Terms: Terms$m,
	Conditions: Conditions$m,
	and: and$m,
	PrivacyPolicy: PrivacyPolicy$m,
	theseAreTheTopsSkillsExtracted: theseAreTheTopsSkillsExtracted$m,
	TopSkills: TopSkills$m,
	weCoulNotExtractSkills: weCoulNotExtractSkills$m,
	upgradeToPremiumToView: upgradeToPremiumToView$m,
	SkillScore: SkillScore$m,
	thisIsYourSkillScoreBasedOn: thisIsYourSkillScoreBasedOn$m,
	theseSkllsAreStrongMatch: theseSkllsAreStrongMatch$m,
	Strongmatch: Strongmatch$m,
	theseSkillsArePartialMatch: theseSkillsArePartialMatch$m,
	Partialmatch: Partialmatch$m,
	theseSkillsAreMissingFrom: theseSkillsAreMissingFrom$m,
	"Missing Keywords": "Chybějící klíčová slova",
	SkillMatchComponent: SkillMatchComponent$m,
	Optional: Optional$m,
	Notrelevanttothejob: Notrelevanttothejob$m,
	Notaskill: Notaskill$m,
	Toogeneric: Toogeneric$m,
	Pleaseshareanyfeedback: Pleaseshareanyfeedback$m,
	excludedKeywordsWillNot: excludedKeywordsWillNot$m,
	yesExcludeThisSkillFrom: yesExcludeThisSkillFrom$m,
	PartialMatch: PartialMatch$m,
	MissingKeywords: MissingKeywords$m,
	Providetitletotask: Providetitletotask$m,
	TasksList: TasksList$m,
	AddTask: AddTask$m,
	EnterTaskTitlehere: EnterTaskTitlehere$m,
	TasksComponent: TasksComponent$m,
	CompletedTasks: CompletedTasks$m,
	CompleteYourtasks: CompleteYourtasks$m,
	Steps: Steps$m,
	PremiumMember: PremiumMember$m,
	Thankyouforupgradingto: Thankyouforupgradingto$m,
	CareerflowPremium: CareerflowPremium$m,
	hereIsHowYouCanAccessPremium: hereIsHowYouCanAccessPremium$m,
	stepOne: stepOne$m,
	DownloadourChromeExtension: DownloadourChromeExtension$m,
	youJobSearchCopilotIshere: youJobSearchCopilotIshere$m,
	DownloadNow: DownloadNow$m,
	stepTwo: stepTwo$m,
	GetStarted: GetStarted$m,
	stepThree: stepThree$m,
	SignintoChromeExtension: SignintoChromeExtension$m,
	entityCreated: entityCreated$m,
	entityUpdated: entityUpdated$m,
	entityDeleted: entityDeleted$m,
	entityLinked: entityLinked$m,
	entityUnlinked: entityUnlinked$m,
	entityMovedTo: entityMovedTo$m,
	youAddedANewEntity: youAddedANewEntity$m,
	personCreated: personCreated$m,
	youUpdatedAEntity: youUpdatedAEntity$m,
	personUpdated: personUpdated$m,
	youDeletedAEntity: youDeletedAEntity$m,
	personDeleted: personDeleted$m,
	youLinkedEntity: youLinkedEntity$m,
	personLinked: personLinked$m,
	youUnlinked: youUnlinked$m,
	personUnlinked: personUnlinked$m,
	youMovedEntity: youMovedEntity$m,
	personMoved: personMoved$m,
	addedByName: addedByName$m,
	DownloadChromeExtension: DownloadChromeExtension$m,
	ourChromeExtensionIs: ourChromeExtensionIs$m,
	Optimizeyourprofile: Optimizeyourprofile$m,
	startOptimizingYourProfile: startOptimizingYourProfile$m,
	OptimizeNow: OptimizeNow$m,
	Addyourfirstjob: Addyourfirstjob$m,
	startSavingJobApplicationsToTrack: startSavingJobApplicationsToTrack$m,
	AddNow: AddNow$m,
	CompleteProfile: CompleteProfile$m,
	completeYourProfileForUsing: completeYourProfileForUsing$m,
	CompleteNow: CompleteNow$m,
	Addyourfirstcontact: Addyourfirstcontact$m,
	addContactToFollowUpWith: addContactToFollowUpWith$m,
	JoinCommunity: JoinCommunity$m,
	ourCommunityisAlways: ourCommunityisAlways$m,
	JoinNow: JoinNow$m,
	welcomeToCareerflow: welcomeToCareerflow$m,
	yourHubForCareerInsights2: yourHubForCareerInsights2$m,
	ChecklistCompleted: ChecklistCompleted$m,
	Completeyourchecklist: Completeyourchecklist$m,
	completeAFewStepsTo: completeAFewStepsTo$m,
	Completed: Completed$m,
	JobCountByStage: JobCountByStage$m,
	NopastapplicationDatafound: NopastapplicationDatafound$m,
	YourJobSearchStages: YourJobSearchStages$m,
	NoDatafound: NoDatafound$m
};

const copyToClipboard$l = "Kopieret til udklipsholderen!";
const UnlocktheAIgenerated$l = "Åbn den AI-genererede";
const UpgradetoPremium$l = "Opgrader til Premium";
const Result$l = "Resultat";
const Copy$l = "Kopiér";
const Save$l = "Gem";
const Edit$l = "Rediger";
const Processing$l = "Behandling";
const YourAIgeneratedcontentwillshowhere$l = "Din AI-genererede indhold vil blive vist her";
const hopeYouFindUseful$l = "Håber du finder dette resultat nyttigt!";
const regenerate$l = "Gen-generer";
const ProvideAdditionalFeedback$l = "Giv yderligere feedback";
const Enteranyfeedback$l = "Indtast eventuel feedback";
const Notimpressive$l = "Ikke imponerende";
const thisIsntTrue$l = "Dette er ikke sandt";
const Notpersonalized$l = "Ikke personliggjort";
const Tone$l = "Tone";
const Length$l = "Længde";
const Template$l = "Skabelon";
const Generatedon$l = "Genereret den";
const Copiedtoclipboard$l = "Kopieret til udklipsholderen";
const CopytoClipboard$l = "Kopier til udklipsholder";
const DownloadasPDF$l = "Download som PDF";
const ViewDetails$l = "Se detaljer";
const JobDescriptionImported$l = "Jobbeskrivelse importeret";
const ImportfromJob$l = "Import fra job";
const Saved$l = "Gemt";
const Applied$l = "Anvendt";
const Offer$l = "Tilbud";
const Interviewing$l = "Interview";
const Rejected$l = "Afvist";
const Search$l = "Søg";
const Import$l = "Import";
const CoverLetterGeneratorHistory$l = "Historik for ansøgningsbrevsgenerator";
const NoCoverLettersGenerated$l = "Ingen ansøgningsbreve genereret";
const getStartedCoverLetter$l = "Du har endnu ikke genereret nogen ansøgningsbreve. Kom i gang og få ansøgningsbreve ved at matche jobbeskrivelsen med din relevante erfaring.";
const getStarted$l = "Kom i gang!";
const Documents$l = "Dokumenter";
const UploadNewDocument$l = "Upload nyt dokument";
const AICoverLetterGenerator$l = "AI Ansøgningsbrevsgenerator";
const ViewHistory$l = "Se historik";
const JobDescription$l = "Jobbeskrivelse";
const ImportfromBoard$l = "Importer fra tavle";
const EnterJobDescription$l = "Indtast jobbeskrivelse";
const JobTitle$l = "Jobtitel";
const EnterJobTitle$l = "Indtast jobtitel";
const CompanyName$l = "Virksomhedsnavn";
const EnterCompanyName$l = "Indtast virksomhedsnavn";
const YourProfile$l = "Din profil";
const ResumeUpload$l = "Upload CV";
const UseLinkedinProfile$l = "Brug LinkedIn-profil";
const Uploadyourresume$l = "Upload dit CV";
const AddyourResume$l = "Tilføj dit CV";
const fileNameCannotFormat$l = "Filnavne kan ikke indeholde mellemrum eller understregninger og skal være enten .doc, .docx eller .pdf.";
const ChooseorUpload$l = "Vælg eller upload";
const SelectTemplate$l = "Vælg skabelon";
const Preview$l = "Forhåndsvisning";
const UseTemplate$l = "Brug skabelon";
const Change$l = "Ændr";
const AdvancedSettings$l = "Avancerede indstillinger";
const AdditionalContext$l = "Yderligere kontekst";
const Professional$l = "Professionel";
const Casual$l = "Afslappet";
const Enthusiastic$l = "Entusiastisk";
const Informational$l = "Informativ";
const Short$l = "Kort";
const Medium$l = "Mellem";
const Long$l = "Lang";
const Language$l = "Sprog";
const iAmOkayBack$l = "Jeg er okay! Gå tilbage";
const Generate$l = "Generer";
const CoverLetter$l = "Ansøgning";
const SelectLanguage$l = "Vælg sprog";
const AboutGeneratorHistory$l = "Om generatorhistorik";
const NoAboutsGenerated$l = "Ingen oplysninger genereret";
const getStartedAbouts$l = "Du har endnu ikke genereret nogen oplysninger. Kom i gang og få oplysninger ved at matche jobbeskrivelsen med din relevante erfaring.";
const noAttachmentsFound$l = "Ingen vedhæftede filer fundet.";
const TargetJobTitle$l = "Måljobtitel";
const KeywordsToInclude$l = "Nøgleord at inkludere";
const UploadYourResume$l = "Upload din CV";
const AddYourResume$l = "Tilføj dit CV";
const LinkedinProfile$l = "LinkedIn-profil";
const Linkedinprofilenotfound$l = "LinkedIn-profil ikke fundet";
const startUsingChromeExtension$l = "Begynd at optimere din LinkedIn-profil ved hjælp af vores Chrome-udvidelse for at bruge denne mulighed.";
const Download$l = "Download";
const UseEmojis$l = "Brug emojis";
const UseBulletPoints$l = "Brug punkttegn";
const SpeechFocus$l = "Talefokus";
const FirstPerson$l = "Første person";
const ThirdPerson$l = "Tredje person";
const HeadlineGeneratorHistory$l = "Overskrifts-generatorhistorik";
const NoHeadlinesGenerated$l = "Ingen overskrifter genereret";
const getStartedHeadline$l = "Du har endnu ikke genereret nogen overskrifter. Kom i gang og få overskrifter ved at matche jobbeskrivelsen med din relevante erfaring.";
const AIHeadlineGenerator$l = "AI Overskrifts-generator";
const KeywordstoInclude$l = "Nøgleord at inkludere";
const Pressenteraftereachword$l = "Tast enter efter hvert ord";
const LinkedinProfilenotfound$l = "LinkedIn-profil ikke fundet.";
const Headline$l = "Overskrift";
const PostGeneratorHistory$l = "Post-generatorhistorik";
const NoPostsGenerated$l = "Ingen indlæg genereret";
const getStartedPost$l = "Du har endnu ikke genereret nogen indlæg. Kom i gang og få indlæg ved at matche jobbeskrivelsen med din relevante erfaring.";
const Topic$l = "Emne";
const Description$l = "Beskrivelse";
const UseHashtags$l = "Brug hashtags";
const Custom$l = "Brugerdefineret";
const EnterCustomTone$l = "Indtast brugerdefineret tone";
const Added$l = "Tilføjet";
const ComingSoon$l = {
	header: "Ingeniører i arbejde!",
	content_1: "Vores hold af ingeniører arbejder hårdt på at få denne funktion op at køre snart",
	content_2: "Vil du have denne funktion snart? Lad os vide det ved blot at markere afkrydsningsfeltet nedenfor.",
	content_3: "Jeg vil gerne have denne funktion"
};
const Company$l = "Virksomhed";
const JobInterview$l = "Jobsamtale";
const Research$l = "Forskning";
const Networking$l = "Netværk";
const Referral$l = "Henvisning";
const MustbeContacted$l = "Skal kontaktes";
const ScheduleaMeeting$l = "Planlæg et møde";
const needAFollowUp$l = "Skal følge op";
const Today$l = "I dag";
const Viewdetails$l = "Se detaljer";
const Activity$l = "Aktivitet";
const ActivityDetails$l = "Aktivitetsdetaljer";
const Delete$l = "Slet";
const Title$l = "Titel";
const Goal$l = "Mål";
const Status$l = "Status";
const FollowUp$l = "Opfølgning";
const AddActivity$l = "Tilføj Aktivitet";
const Enteractivitytitle$l = "Indtast aktivitetstitel";
const Cancel$l = "Annuller";
const SaveActivity$l = "Gem Aktivitet";
const noActivityPresent$l = "Ingen aktivitet til stede, tilføj aktivitet.";
const Addnew$l = "Tilføj ny";
const About$l = "Om";
const noDataPresentYou$l = "Ingen data til stede, du kan redigere denne kontakt og tilføje felter.";
const Experience$l = "Erfaring";
const Education$l = "Uddannelse";
const Skills$l = "Færdigheder";
const Overview$l = "Oversigt";
const LinkedJobs$l = "Linkede Jobs";
const Notes$l = "Noter";
const FullName$l = "Fulde Navn";
const Location$l = "Placering";
const Relationship$l = "Forhold";
const Contacts$l = "Kontakter";
const CreateContact$l = "Opret Kontakt";
const NotesCreated$l = "Noter Oprettet";
const Notesupdated$l = "Noter opdateret";
const Addnote$l = "Tilføj note";
const areYouSureDeleteNote$l = "Er du sikker på, at du vil slette denne note?";
const Createdby$l = "Oprettet af";
const notSureWhyResumeCalls$l = "Er du ikke sikker på, hvorfor dit CV ikke får dig til at modtage opkald til jobsamtaler? ☎️";
const getExpertResumeReview$l = "Få en ekspertvurdering af dit CV 💎✨";
const youHaventAddedContacts$l = "Du har endnu ikke tilføjet nogen kontakter.";
const noMatchingContacts$l = "Ingen matchende kontakter fundet.";
const Link$l = "Link";
const unlink$l = "Aflink";
const Locationnotavailable$l = "Sted ikke tilgængeligt";
const Emailnotavailable$l = "E-mail ikke tilgængelig";
const PhoneNumbernotavailable$l = "Telefonnummer ikke tilgængeligt";
const createdby$l = "oprettet af";
const areYouSureDeleteContact$l = "Er du sikker på, at du vil slette denne kontakt?";
const areYouSureUnlinkContact$l = "Er du sikker på, at du vil af-link denne kontakt?";
const Addedbyyou$l = "Tilføjet af dig";
const Addedby$l = "Tilføjet af";
const Timeline$l = "Tidslinje";
const Timelineempty$l = "Tidslinje tom";
const Discard$l = "Kassér";
const SaveContact$l = "Gem kontakt";
const Recruiter$l = "Rekrutterer";
const Candidate$l = "Kandidat";
const Colleague$l = "Kollega";
const Employee$l = "Medarbejder";
const EnterValidEmail$l = "Indtast gyldig e-mail";
const EnterValidPhoneNumber$l = "Indtast gyldigt telefonnummer";
const editingProfileNotAvailable$l = "Redigering af profilfoto er endnu ikke tilgængelig.";
const itWillBeSoonAvailable$l = "Det vil snart være tilgængeligt på vores";
const ChromeExtension$l = "Chrome-udvidelse";
const SelectTag$l = "Vælg tag";
const FirstName$l = "Fornavn";
const FirstNameisrequired$l = "Fornavn er påkrævet";
const LastName$l = "Efternavn";
const LastNameisrequired$l = "Efternavn er påkrævet";
const Companyisrequired$l = "Firma er påkrævet";
const Email$l = "E-mail";
const ThisisnotavalidEmail$l = "Dette er ikke en gyldig e-mail.";
const AddEmail$l = "Tilføj E-mail";
const PhoneNumber$l = "Telefonnummer";
const notaValidPhone$l = "Dette er ikke et gyldigt telefonnummer. Indtast kun tal.";
const phoneNoMinimum5char$l = "Telefonnummeret skal være mindst 5 tegn.";
const phoneNoMinumum15char$l = "Telefonnummeret skal være maksimalt 15 tegn.";
const AddPhoneNumber$l = "Tilføj Telefonnummer";
const SelectGoal$l = "Vælg Mål";
const SelectStatus$l = "Vælg status";
const Followup$l = "Opfølgning";
const SocialMedia$l = "Sociale Medier";
const Linkedinhandle$l = "Linkedin håndtag";
const Twitterhandle$l = "Twitter-håndtag";
const Facebookhandle$l = "Facebook-håndtag";
const Githubhandle$l = "Github-håndtag";
const Gmailhandle$l = "Gmail-håndtag";
const Changessavedsuccessfully$l = "Ændringer gemt med succes";
const EditContact$l = "Rediger Kontakt";
const BasicInformation$l = "Grundlæggende Information";
const EditContactDetails$l = "Rediger kontaktoplysninger";
const SaveChanges$l = "Gem Ændringer";
const phoneNoMinimum14char$l = "Telefonnummeret skal være mindst 14 tegn.";
const LinkedIn$l = "LinkedIn";
const Twitter$l = "Twitter";
const Facebook$l = "Facebook";
const Github$l = "Github";
const Gmail$l = "Gmail";
const youCanWriteAbout$l = "Du kan skrive om dine års erfaring, branche eller færdigheder. Folk taler også om deres resultater eller tidligere joboplevelser.";
const Addednewsection$l = "Tilføjet ny sektion";
const Removedsuccessfully$l = "Fjernet med succes";
const Remove$l = "Fjern";
const Institute$l = "Institut";
const Schoolisrequired$l = "Skole er påkrævet";
const Degree$l = "Grad";
const StartMonth$l = "Start måned";
const StartYear$l = "Startår";
const EndMonth$l = "Slutningen af måneden";
const EndYear$l = "Slutningen af året";
const Addmore$l = "Tilføj mere";
const PositionTitle$l = "Stillingsbetegnelse";
const ExperienceType$l = "Oplevelsestype";
const Addednewitem$l = "Tilføjet nyt element";
const whatSkillsDoYouEnjoy$l = "Hvilke færdigheder har du eller nyder du at arbejde med?";
const Typeskillshere$l = "Skriv færdigheder her";
const LinkedContacts$l = "Linkede Kontakter";
const LinkContact$l = "Link Kontakt";
const NocontactsLinked$l = "Ingen kontakter er linkede";
const JobContactsComponent$l = {
	linkContact: "Ved at linke kontakter kan du hurtigt se, hvem de vigtige personer som rekruttereren, ansvarlig for ansættelse osv. er for denne rolle! I fremtiden vil vi kunne præsentere relevante indsigter baseret på dine kontakter."
};
const Nocontacts$l = "Ingen kontakter";
const LinkJobto$l = "Link job til";
const Contact$l = "Kontakt";
const Document$l = "Dokument";
const Nojobsfound$l = "Ingen jobs fundet";
const LinkJob$l = "Link Job";
const youCanLinkContactJobImported$l = "Du kan linke denne kontakt til et job, du har importeret til Careerflow.";
const Prev$l = "Forrige";
const Next$l = "Næste";
const areYouSureUnlinkDocument$l = "Er du sikker på, at du vil af-link dette dokument?";
const areYouSureDeleteDocument$l = "Er du sikker på, at du vil slette dette dokument?";
const Category$l = "Kategori";
const CreatedOn$l = "Oprettet den";
const Joblinked$l = "Job forbundet";
const Quickactions$l = "Hurtige handlinger";
const All$l = "Alle";
const Resume$l = "CV";
const Portfolio$l = "Portefølje";
const Other$l = "Andet";
const Adddocument$l = "Tilføj dokument";
const Type$l = "Type";
const Sortingby$l = "Sortering efter";
const SwitchtoGridLayout$l = "Skift til gitterlayout";
const SwitchtoListLayout$l = "Skift til liste-layout";
const NoDocumentsAdded$l = "Ingen Dokumenter Tilføjet";
const DocumentsComponent$l = {
	nodocs: "Du har endnu ikke oprettet nogen dokumenter. Du kan uploade dine cv-versioner, ansøgninger og mere og linke dem til de job, du følger!"
};
const NoDocumentFound$l = "Ingen dokument fundet.";
const SelectFile$l = "Vælg Fil";
const onlyPdfDocxSupported$l = "Kun .pdf og .docx understøttet.";
const Uploadfile$l = "Upload fil";
const DocumentCategory$l = "Dokumentkategori";
const SaveDocument$l = "Gem Dokument";
const AddDocument$l = "Tilføj Dokument";
const LinkedDocuments$l = "Linkede dokumenter";
const LinkDocument$l = "Link Dokument";
const NodocumentsLinked$l = "Ingen dokumenter er linkede";
const JobDocumentsComponent$l = {
	linkDocs: "Ved at linke alle dine relevante dokumenter som dit cv, ansøgning osv., som du har indsendt til dette job, vil hjælpe dig med at holde styr på alt på ét sted. Prøv det!"
};
const NoDocuments$l = "Ingen dokumenter";
const CreateDocuments$l = "Opret dokumenter";
const youCanLinkDocumentJobImported$l = "Du kan linke dette dokument til en job, du har importeret til Careerflow.";
const Documenteditedsuccessfully$l = "Dokumentet blev redigeret succesfuldt.";
const DocumentDetails$l = "Dokumentdetaljer";
const UnsavedChanges$l = "Ugemte ændringer";
const yourChangesWillBeLostSureClose$l = "Dine ændringer vil gå tabt, er du sikker på, at du vil lukke?";
const yourChangesWillBeLostSureDiscard$l = "Dine ændringer vil gå tabt, er du sikker på, at du vil forkaste dine ændringer?";
const DiscardChanges$l = "Fortryd ændringer";
const WeeklyGoalAlert$l = "Ugentligt målvarsel";
const Progress$l = "Fremgang";
const AllGoals$l = "Alle mål";
const Name$l = "Navn";
const Completedon$l = "Afsluttet den";
const Createdon$l = "Oprettet den";
const Action$l = "Handling";
const Back$l = "Tilbage";
const OverallScore$l = "Samlet score";
const Aboutthegoal$l = "Om målet";
const GoalTracking$l = "Målsporing";
const Week$l = "Uge";
const progress$l = "fremgang";
const loading$l = "Indlæser";
const Apply$l = "Ansøg";
const Thisskillhasbeenreported$l = "Denne færdighed er blevet rapporteret.";
const issueGettingResume$l = "Der var et problem med at få CV'et.";
const Interview$l = "Interview";
const Tasks$l = "Opgaver";
const Loading$l = "Indlæser";
const Skilladdedsuccessfully$l = "Færdighed tilføjet med succes";
const problemAddingSkill$l = "Der var et problem med at tilføje færdighed.";
const Reportaproblem$l = "Rapporter et problem";
const Submit$l = "Indsend";
const Addanewskill$l = "Tilføj en ny færdighed";
const JobDetailsComponent$l = {
	classifySkill: "Hvordan vil du klassificere denne færdighed (valgfrit)?",
	includedKeywordsWillCount: "Inkluder dette nøgleord?",
	yesIncludeThisSkill: "Medtagne nøgleord vil tælle imod din match-score for alle fremtidige scanninger. Du kan ændre medtagne nøgleord fra din profil.",
	addSkill: "Vil du tilføje dette som en færdighed?"
};
const HardSkill$l = "Hård færdighed";
const SoftSkill$l = "Blød færdighed";
const Pleaseshareanyadditionalcontext$l = "Del venligst yderligere kontekst";
const Addasskill$l = "Tilføj som færdighed";
const Skill$l = "Færdighed";
const JobFrequency$l = "Jobfrekvens";
const ResumeFrequency$l = "CV-frekvens";
const Reportskill$l = "Rapporter færdighed";
const JobDetails$l = "Joboplysninger";
const ViewJobLink$l = "Se joblink";
const Salary$l = "Løn";
const areYouSureDeleteJob$l = "Er du sikker på, at du vil slette dette job?";
const ViewMore$l = "Vis mere";
const ViewLess$l = "Vis mindre";
const matchYouSkillsAgainstJob$l = "Match dine færdigheder med jobbeskrivelsen.";
const pleaseUploadResumeSkillMatch$l = "Venligst upload dit CV for at få din færdighedsmatchscore.";
const AddResume$l = "Tilføj CV";
const thisJobDoesNotHaveAnyDesc$l = "Denne job har ingen beskrivelse.";
const youCanEditJobToAdd$l = "Du kan redigere denne job for at tilføje en beskrivelse til den. Du kan også importere jobs ved hjælp af vores.";
const chromeextension$l = "Chrome-udvidelse";
const fromVariousJobPortalsOnce$l = "fra forskellige jobportaler. Når du tilføjer en beskrivelse, vil du også kunne se information om færdigheder.";
const AddDescription$l = "Tilføj beskrivelse.";
const CompanyInfo$l = "Firmaoplysninger";
const Website$l = "Hjemmeside";
const Industry$l = "Branchen";
const EmployeeCount$l = "Antal medarbejdere";
const ExprienceLevel$l = "Erfaringsniveau";
const Address$l = "Adresse";
const Resumes$l = "CV'er";
const Setasdefault$l = "Indstil som standard";
const Ok$l = "Ok";
const UploadNewResume$l = "Upload nyt CV";
const Default$l = "Standard";
const Jobnotfound$l = "Job ikke fundet";
const EditDetails$l = "Rediger detaljer";
const JobPostURL$l = "Jobindlæg URL";
const Enterjoburl$l = "Indtast job-URL";
const Nojobselected$l = "Ingen job valgt.";
const Viewjobdetails$l = "Se jobdetaljer";
const Jobaddedtoyourboardsuccessfully$l = "Job tilføjet til din tavle med succes";
const AddJob$l = "Tilføj job";
const Addnewjobname$l = "Tilføj nyt jobnavn";
const JobUrl$l = "Job-URL";
const Addjoburl$l = "Tilføj job-URL";
const Section$l = "Afsnit";
const didYouKnow$l = {
	chromeExtension: "Vidste du det? Du kan også gemme job direkte fra vores Chrome-udvidelse og importere alle data med et enkelt klik! Det tager kun få sekunder."
};
const Jobs$l = "Job";
const AddJobtoboard$l = "Tilføj job til tavlen";
const Currentlynojobsareavailable$l = "I øjeblikket er der ingen ledige job.";
const noMatchingJobs$l = "Ingen matchende job fundet.";
const welcomeToYourPersonalJobTracker$l = "Velkommen til din personlige Job Tracker!";
const weShortTutorialOnHowTrackingJob$l = "Vi vil guide dig gennem en kort tutorial om, hvordan du kan begynde at spore dine jobansøgninger på få nemme trin!";
const Addanewjob$l = "Tilføj en ny job";
const inOrderTrackCreatButton$l = "For at begynde at spore jobansøgninger, skal du først tilføje den til tavlen ved at klikke på knappen 'Opret'.";
const Providesomedetails$l = "Giv nogle detaljer.";
const toBeginTypeJobTitleCompany$l = "For at begynde, skal du blot indtaste jobtitlen, virksomhedens navn og den status, du gerne vil tilføje den til. Du kan tilføje flere detaljer senere, men dette er alt, hvad du har brug for lige nu!";
const asAnExampleFilledForYou$l = "Som et eksempel har vi allerede udfyldt dette for dig!";
const wohooAddedFirstJob$l = "Woohoo! Du har tilføjet dit første job til din jobtracker!";
const youCanDragDropJobCard$l = "Du kan nu trække og slippe jobkortet ind i de forskellige faser af jobansøgningsprocessen. Ved at klikke på jobkortet kan du se flere detaljer, redigere dem, gemme noter og mere!";
const Lastbutnotleast$l = "Sidst men ikke mindst";
const finalStepMakeSure$l = "Som det sidste trin, sørg for at du har vores.";
const autoMaticallyImportJobs$l = "Som vil tillade dig at automatisk importere job fra dine foretrukne job-søgningswebsites som LinkedIn, Indeed og mere! Vores udvidelse hjælper også med at forbedre din LinkedIn-profil og få 2,5 gange flere søgeoptrædener!";
const selectanysection$l = "Vælg en hvilken som helst sektion";
const Accept$l = "Accepter";
const My2023JobSearch$l = "Min 2023 Job-søgning";
const AddedFrom$l = "Tilføjet fra";
const AddedUntil$l = "Tilføjet indtil";
const BasicModal$l = "Basal modal";
const AddnewSectionName$l = "Tilføj nyt afsnitsnavn";
const OpenTo$l = "Åben for";
const Featured$l = "Udvalgt";
const LicenceAndCerts$l = "Licenser og certifikater";
const Banner$l = "Banner";
const LinkedInURL$l = "LinkedIn URL";
const Recommendations$l = "Anbefalinger";
const LinkedinReview$l = "Linkedin anmeldelse";
const NoDataAvailable$l = "Ingen data tilgængelig.";
const looksLikeYouDidNot$l = "Det ser ud til, at du ikke er begyndt at bruge vores";
const toOptimizeProfileScoreVisible$l = "at optimere din LinkedIn-profil endnu. Når du har gjort det, vil din profil score være synlig her.";
const LinkedinComponent$l = {
	letsOptimize: "Lad os optimere"
};
const improveYourChancesLandingDreamJob$l = "Forbedr dine chancer for at få dit drømmejob. Brug disse afprøvede strategier til at give din LinkedIn-profil en tiltrængt makeover.";
const VisitProfile$l = "Besøg profil";
const wantToGetLinkedinMakeover$l = "Vil du have en fuldstændig LinkedIn-omdannelse?";
const PostGenerator$l = "Post Generator";
const LinkedinHeadlineGenerator$l = "LinkedIn Overskrift Generator";
const LinkedinAboutSectionGenerator$l = "LinkedIn Om-sektion Generator";
const AITools$l = "AI-værktøjer";
const Premium$l = "Premium";
const LinkedInOptimization$l = "Optimering af LinkedIn";
const JobTracker$l = "Job Tracker";
const whoIsHiring$l = "Hvem ansætter";
const Autofill$l = "Auto udfyld";
const HeadlineGenerator$l = "Overskriftsgenerator";
const skillMatching$l = "Færdighedsmatching";
const SummarizeJD$l = "Opsummer jobbeskrivelsen";
const contactFeature$l = "Kontaktsporing";
const documentFeature$l = "Dokumenter";
const landJobWithoutStress$l = "Få dit drømmejob. Uden stress.";
const discoverFeatures$l = "Opdag det brede udvalg af Careerflow.ai funktioner, der er designet til at optimere din jobsøgning og forbedre din professionelle rejse!";
const letsBeginOnboarding$l = "Lad os lære dig bedre at kende!";
const inTheNextFewScreensJobThirdParties$l = "I de næste par skærme vil vi stille dig nogle spørgsmål, som vil hjælpe os med at tilpasse oplevelsen til dig og automatisk udfylde dine jobansøgninger (så du ikke behøver at gøre det)! Vi sælger ikke dine data til tredjeparter.";
const letsAddBasicInformation$l = "Lad os tilføje dine grundlæggende oplysninger";
const Pleaseselectanoptionfirst$l = "Vælg venligst en mulighed først.";
const JobApplicationTracker$l = "Jobansøgnings-tracker";
const LinkedInProfileOptimizer$l = "Optimerer af LinkedIn-profil";
const UnlimitedDocuments$l = "Ubegrænsede dokumenter";
const UnlimitedContacts$l = "Ubegrænsede kontakter";
const HiringManagerSearch$l = "Ansættelsesansvarlig søgning";
const AILinkedInPostGenerator$l = "AI LinkedIn Indlægsgenerator";
const ATSKeywordSkillMatch$l = "ATS nøgleord / færdighedsmatch job";
const ChooseyourPlan$l = "Vælg din plan";
const superChargeYourJobSearch$l = "Optimer din jobsøgning og forbedre din jobansøgningsproces, øg dine interviews og få dit drømmejob. Alt sammen med hjælp fra Careerflows premium værktøjskasse.";
const startNowGoto$l = "Start nu (Gå til app)";
const CreatedBy$l = "Oprettet af";
const CreateNewNote$l = "Opret ny note";
const Nonotescreated$l = "Ingen noter oprettet";
const approxTimeIsFourMinutes$l = "Den omtrentlige tid til at fuldføre onboarding-processen er 4 minutter.";
const Continue$l = "Fortsæt";
const iWillDoLaterTakeMeToApp$l = "Jeg vil gøre det senere. Tag mig til appen.";
const allDone$l = "Alt færdigt!";
const welcomeAbord$l = "Velkommen om bord!";
const letsBegin$l = "Lad os begynde";
const UpgradeyourplanandgetAIAssistance$l = "Opgrader din plan og få AI-assistance.";
const DownloadPDF$l = "Download PDF";
const oopsWeCouldntProcessResume$l = "Ups, vi kunne ikke behandle dette CV.";
const MyProfile$l = "Min profil";
const Setting$l = "Indstilling";
const Logout$l = "Log ud";
const SignIn$l = "Log ind";
const Typeyourfirstnamehere$l = "Dit Fornavn";
const Enteryourlastname$l = "Dit efternavn";
const ManageSubscription$l = "Administrer abonnement";
const ifYouHaveDifficultiesProfile$l = "Hvis du har problemer med din profilinformation, bedes du kontakte";
const forSupport$l = "til support.";
const whatIsIdealCompanySize$l = "Hvad er din ideelle virksomhedsstørrelse?";
const Saveandcontinue$l = "Gem og fortsæt";
const whatIsMinExpectedSalary$l = "Hvad er din forventede mindsteløn (årligt)?";
const Atleast$l = "I det mindste";
const SlidetoAdjust$l = "Skub for at justere";
const whatIndustryExcitedWork$l = "Hvilke brancher er spændende for dig?";
const Add$l = "Tilføj";
const statusOfJobSearch$l = "Status på din jobsøgning?";
const Finish$l = "Afslut";
const whatLevelRoleLooking$l = "Hvilket niveau af rolle leder du efter?";
const Selectuptotwo$l = "Vælg op til to.";
const PreviousStep$l = "Tidligere trin";
const Skip$l = "Spring";
const whatDoYouValueNewRole$l = "Hvad vægter du i en ny rolle?";
const Selectuptothree$l = "Vælg op til tre.";
const EqualEmploymentData$l = "Lige muligheder for beskæftigelse data";
const whatIsYourEthnicity$l = "Hvad er din etnicitet?";
const areYouAuthorizedToWorkUs$l = "Er du autoriseret til at arbejde i USA?";
const willYouRequireSponsorShip$l = "Vil du nu eller i fremtiden kræve sponsorering til ansættelsesvisumstatus?";
const doYouHaveADisability$l = "Har du en handicap?";
const areYouAVeteran$l = "Er du en veteran?";
const rolesYouInterestedIn$l = "Hvilke slags roller er du interesseret i?";
const Selectuptofive$l = "Vælg op til fem.";
const AddCustomrole$l = "Tilføj brugerdefineret rolle";
const whereDoYouLikeWork$l = "Hvor vil du gerne arbejde?";
const Resources$l = "Ressourcer";
const currentlyNoResourceAvailable$l = "I øjeblikket er der ingen ressourcer tilgængelige.";
const AddNewSection$l = "Tilføj nyt afsnit";
const ChangeSections$l = "Ændre sektioner";
const Settings$l = "Indstillinger";
const Dashboard$l = "Instrumentbræt";
const JobBoard$l = "Jobtavle";
const Linkedin$l = "Linkedin";
const Community$l = "Fællesskab";
const FindRecruiters$l = "Find rekrutteringskonsulenter";
const Goals$l = "Mål";
const DownloadExtension$l = "Download udvidelse";
const SuggestaFeature$l = "Foreslå en funktion";
const leftPanel$l = {
	ReportanIssue: "Rapporter et problem"
};
const PhoneNumberisrequired$l = "Telefonnummer er påkrævet";
const MobileNumber$l = "Mobilnummer";
const Enteronlynumbers$l = "Indtast kun tal.";
const Countryyoulivein$l = "Landet du bor i";
const SelectaCountry$l = "Vælg et land";
const DateofBirth$l = "Fødselsdato";
const Gender$l = "Køn";
const JobPreferences$l = "Jobpræferencer";
const pleaseEnterValidEmail$l = "Indtast venligst en gyldig e-mail.";
const emailSendForResetting$l = "En e-mail er blevet sendt til dig for at nulstille adgangskoden";
const VerifyyourEmailID$l = "Bekræft din e-mailadresse";
const sentPleaseCheckEmail$l = "Sendt! Tjek venligst din e-mail.";
const tooManyAttemptsTryAgain$l = "For mange forsøg, prøv igen om lidt.";
const Resend$l = "Gensend";
const Login$l = "Log ind";
const weHaveSentVerificationLinkAtEmail$l = "Vi har sendt dig et verifikationslink til din e-mail.";
const pleaseVerifyEmailContinueSpam$l = "Venligst bekræft din e-mail for at fortsætte. Tjek også din spam eller promotions-mappe for bekræftelses-e-mailen.";
const Logintogetstarted$l = "Log ind for at komme i gang.";
const ContinuewithGoogle$l = "Fortsæt med Google";
const pleaseInputEmail$l = "Indtast venligst din e-mail!";
const Password$l = "Adgangskode";
const pleaseInputPassword$l = "Indtast venligst dit kodeord!";
const passwordLowerUpperDigitSpecial$l = "Dit kodeord skal indeholde mindst ét lille bogstav, ét stort bogstav, ét tal og et specialtegn.";
const atLeastSixChar$l = "Mindst 6 tegn";
const forgotPassword$l = "Glemt adgangskode?";
const Bysigninginyouagreetoour$l = "Ved at logge ind accepterer du vores";
const Terms$l = "Betingelser";
const Conditions$l = "Betingelser";
const and$l = "og";
const PrivacyPolicy$l = "Fortrolighedspolitik";
const theseAreTheTopsSkillsExtracted$l = "Dette er de vigtigste færdigheder udtrukket fra jobbeskrivelsen.";
const TopSkills$l = "Topfærdigheder";
const weCoulNotExtractSkills$l = "Vi kunne ikke udtrække nogen færdigheder fra denne jobbeskrivelse.";
const upgradeToPremiumToView$l = "Opgrader til Premium for at se din match-score for færdigheder i dit CV.";
const SkillScore$l = "Færdighedsscore";
const thisIsYourSkillScoreBasedOn$l = "Dette er din færdighedsscore baseret på jobbeskrivelsen og dit CV.";
const theseSkllsAreStrongMatch$l = "Disse færdigheder er en stærk match mellem dit CV og jobbeskrivelsen.";
const Strongmatch$l = "Stærkt match";
const theseSkillsArePartialMatch$l = "Disse færdigheder er en delvis match mellem dit CV og jobbeskrivelsen.";
const Partialmatch$l = "Delvis match";
const theseSkillsAreMissingFrom$l = "Disse nøgleord mangler på dit CV, men er til stede i jobbeskrivelsen. De kan være færdigheder eller generelle nøgleord, der er specifikke for jobmuligheden, og det kan være nyttigt at tilføje dem til dit CV.";
const SkillMatchComponent$l = {
	removeSkill: "Hvad er din hovedårsag til at rapportere et problem med nøgleordet"
};
const Optional$l = "Valgfri";
const Notrelevanttothejob$l = "Ikke relevant for jobbet";
const Notaskill$l = "Ingen færdighed";
const Toogeneric$l = "For generisk";
const Pleaseshareanyfeedback$l = "Del venligst feedback";
const excludedKeywordsWillNot$l = "Udelukkede nøgleord vil ikke tælle mod din match-score for alle fremtidige scanninger. Du kan ændre udelukkede nøgleord fra din profil.";
const yesExcludeThisSkillFrom$l = "Ja, udelad denne færdighed fra alle mine CV-scanninger.";
const PartialMatch$l = "Delvis match";
const MissingKeywords$l = "Manglende nøgleord";
const Providetitletotask$l = "Giv opgaven en titel";
const TasksList$l = "Opgaveliste";
const AddTask$l = "Tilføj opgave";
const EnterTaskTitlehere$l = "Indtast opgavetitel her";
const TasksComponent$l = {
	listEmpty: "Opgavelisten er tom. Opret ny."
};
const CompletedTasks$l = "Afsluttede opgaver";
const CompleteYourtasks$l = "Fuldfør dine opgaver";
const Steps$l = "Trin";
const PremiumMember$l = "Premium medlem";
const Thankyouforupgradingto$l = "Tak for opgraderingen til";
const CareerflowPremium$l = "Karriereflow Premium";
const hereIsHowYouCanAccessPremium$l = "Her er hvordan du får adgang til dine Premium-fordele!";
const stepOne$l = "Trin 1";
const DownloadourChromeExtension$l = "Download vores Chrome-udvidelse.";
const youJobSearchCopilotIshere$l = "Din jobsøgnings AI-copilot er her.";
const DownloadNow$l = "Download nu";
const stepTwo$l = "Trin 2";
const GetStarted$l = "Kom i gang";
const stepThree$l = "Trin 3";
const SignintoChromeExtension$l = "Tilmeld dig Chrome-udvidelse";
const entityCreated$l = "Ny {{entity}} oprettet";
const entityUpdated$l = "{{entity}} opdateret";
const entityDeleted$l = "{{entity}} slettet";
const entityLinked$l = "{{entity}} linket";
const entityUnlinked$l = "{{entity}} afkoblet";
const entityMovedTo$l = "Flyttet til {{entity}}";
const youAddedANewEntity$l = "Du har tilføjet en ny {{entity}}";
const personCreated$l = "{{creator}} skabte en {{entity}} til {{owner}}.";
const youUpdatedAEntity$l = "Du har opdateret en {{entity}}";
const personUpdated$l = "{{creator}} opdaterede en {{entity}} for {{owner}}.";
const youDeletedAEntity$l = "Du har slettet en {{entity}}";
const personDeleted$l = "{{creator}} slettede en {{entity}} for {{owner}}";
const youLinkedEntity$l = "Du har linket en {{entity}} til dette job.";
const personLinked$l = "{{creator}} har linket en {{entity}} til dette job for {{owner}}.";
const youUnlinked$l = "Du har fjernet linket til {{entity}} fra denne job.";
const personUnlinked$l = "{{creator}} fjernede linket til en {{entity}} fra denne opgave for {{owner}}.";
const youMovedEntity$l = "Du flyttede denne {{entity}} fra {{sectionFrom}} til {{sectionTo}}";
const personMoved$l = "{{creator}} flyttede denne {{entity}} fra {{sectionFrom}} til {{sectionTo}} for {{owner}}";
const addedByName$l = "Tilføjet af {{name}}";
const DownloadChromeExtension$l = "Download Chrome-udvidelse";
const ourChromeExtensionIs$l = "Vores Chrome-udvidelse er et integreret værktøj til at hjælpe dig med at optimere din LinkedIn-profil, gemme job, gemme kontakter, generere ansøgningsbrev og mere.";
const Optimizeyourprofile$l = "Optimer din profil";
const startOptimizingYourProfile$l = "Begynd at optimere din profil for at have bedre chancer for at blive kontaktet af rekrutteringsfolk.";
const OptimizeNow$l = "Optimer nu";
const Addyourfirstjob$l = "Tilføj dit første job";
const startSavingJobApplicationsToTrack$l = "Begynd at gemme jobansøgninger for at følge din jobsøgningsrejse og finde nyttige indsigter.";
const AddNow$l = "Tilføj nu";
const CompleteProfile$l = "Fuldført profil";
const completeYourProfileForUsing$l = "Fuldfør din profil for at bruge autofyldningsfunktionen og få en mere personlig oplevelse.";
const CompleteNow$l = "Færdiggør nu";
const Addyourfirstcontact$l = "Tilføj din første kontakt";
const addContactToFollowUpWith$l = "Tilføj kontakt til at følge op med dem senere, tilføj noter og mere.";
const JoinCommunity$l = "Bliv en del af fællesskabet";
const ourCommunityisAlways$l = "Vores fællesskab er altid der for dig på din jobsøgningsrejse.";
const JoinNow$l = "Tilmeld dig nu";
const welcomeToCareerflow$l = "Velkommen til Careerflow!";
const yourHubForCareerInsights2$l = "Dette er dit center for karriereindsigter, aktiviteter og mere. Udforsk dit personlige dashboard for at holde dig på toppen af din professionelle rejse.";
const ChecklistCompleted$l = "Din tjekliste er fuldført!";
const Completeyourchecklist$l = "Fuldfør din tjekliste.";
const completeAFewStepsTo$l = "Gennemfør et par trin for at lande dit næste job.";
const Completed$l = "Afsluttet";
const JobCountByStage$l = "Antal job efter stadie";
const NopastapplicationDatafound$l = "Ingen tidligere ansøgningsdata fundet.";
const YourJobSearchStages$l = "Dine jobsøgningsfaser";
const NoDatafound$l = "Ingen data fundet.";
const da = {
	copyToClipboard: copyToClipboard$l,
	UnlocktheAIgenerated: UnlocktheAIgenerated$l,
	UpgradetoPremium: UpgradetoPremium$l,
	Result: Result$l,
	Copy: Copy$l,
	Save: Save$l,
	Edit: Edit$l,
	Processing: Processing$l,
	YourAIgeneratedcontentwillshowhere: YourAIgeneratedcontentwillshowhere$l,
	hopeYouFindUseful: hopeYouFindUseful$l,
	regenerate: regenerate$l,
	ProvideAdditionalFeedback: ProvideAdditionalFeedback$l,
	Enteranyfeedback: Enteranyfeedback$l,
	Notimpressive: Notimpressive$l,
	thisIsntTrue: thisIsntTrue$l,
	Notpersonalized: Notpersonalized$l,
	Tone: Tone$l,
	Length: Length$l,
	Template: Template$l,
	Generatedon: Generatedon$l,
	Copiedtoclipboard: Copiedtoclipboard$l,
	CopytoClipboard: CopytoClipboard$l,
	DownloadasPDF: DownloadasPDF$l,
	ViewDetails: ViewDetails$l,
	JobDescriptionImported: JobDescriptionImported$l,
	ImportfromJob: ImportfromJob$l,
	Saved: Saved$l,
	Applied: Applied$l,
	Offer: Offer$l,
	Interviewing: Interviewing$l,
	Rejected: Rejected$l,
	Search: Search$l,
	Import: Import$l,
	CoverLetterGeneratorHistory: CoverLetterGeneratorHistory$l,
	NoCoverLettersGenerated: NoCoverLettersGenerated$l,
	getStartedCoverLetter: getStartedCoverLetter$l,
	getStarted: getStarted$l,
	Documents: Documents$l,
	UploadNewDocument: UploadNewDocument$l,
	AICoverLetterGenerator: AICoverLetterGenerator$l,
	ViewHistory: ViewHistory$l,
	JobDescription: JobDescription$l,
	ImportfromBoard: ImportfromBoard$l,
	EnterJobDescription: EnterJobDescription$l,
	JobTitle: JobTitle$l,
	EnterJobTitle: EnterJobTitle$l,
	CompanyName: CompanyName$l,
	EnterCompanyName: EnterCompanyName$l,
	YourProfile: YourProfile$l,
	ResumeUpload: ResumeUpload$l,
	UseLinkedinProfile: UseLinkedinProfile$l,
	Uploadyourresume: Uploadyourresume$l,
	AddyourResume: AddyourResume$l,
	fileNameCannotFormat: fileNameCannotFormat$l,
	ChooseorUpload: ChooseorUpload$l,
	SelectTemplate: SelectTemplate$l,
	Preview: Preview$l,
	UseTemplate: UseTemplate$l,
	Change: Change$l,
	AdvancedSettings: AdvancedSettings$l,
	AdditionalContext: AdditionalContext$l,
	Professional: Professional$l,
	Casual: Casual$l,
	Enthusiastic: Enthusiastic$l,
	Informational: Informational$l,
	Short: Short$l,
	Medium: Medium$l,
	Long: Long$l,
	Language: Language$l,
	iAmOkayBack: iAmOkayBack$l,
	Generate: Generate$l,
	CoverLetter: CoverLetter$l,
	SelectLanguage: SelectLanguage$l,
	AboutGeneratorHistory: AboutGeneratorHistory$l,
	NoAboutsGenerated: NoAboutsGenerated$l,
	getStartedAbouts: getStartedAbouts$l,
	noAttachmentsFound: noAttachmentsFound$l,
	TargetJobTitle: TargetJobTitle$l,
	KeywordsToInclude: KeywordsToInclude$l,
	UploadYourResume: UploadYourResume$l,
	AddYourResume: AddYourResume$l,
	LinkedinProfile: LinkedinProfile$l,
	Linkedinprofilenotfound: Linkedinprofilenotfound$l,
	startUsingChromeExtension: startUsingChromeExtension$l,
	Download: Download$l,
	UseEmojis: UseEmojis$l,
	UseBulletPoints: UseBulletPoints$l,
	SpeechFocus: SpeechFocus$l,
	FirstPerson: FirstPerson$l,
	ThirdPerson: ThirdPerson$l,
	HeadlineGeneratorHistory: HeadlineGeneratorHistory$l,
	NoHeadlinesGenerated: NoHeadlinesGenerated$l,
	getStartedHeadline: getStartedHeadline$l,
	AIHeadlineGenerator: AIHeadlineGenerator$l,
	KeywordstoInclude: KeywordstoInclude$l,
	Pressenteraftereachword: Pressenteraftereachword$l,
	LinkedinProfilenotfound: LinkedinProfilenotfound$l,
	Headline: Headline$l,
	PostGeneratorHistory: PostGeneratorHistory$l,
	NoPostsGenerated: NoPostsGenerated$l,
	getStartedPost: getStartedPost$l,
	Topic: Topic$l,
	Description: Description$l,
	UseHashtags: UseHashtags$l,
	Custom: Custom$l,
	EnterCustomTone: EnterCustomTone$l,
	Added: Added$l,
	ComingSoon: ComingSoon$l,
	Company: Company$l,
	JobInterview: JobInterview$l,
	Research: Research$l,
	Networking: Networking$l,
	Referral: Referral$l,
	MustbeContacted: MustbeContacted$l,
	ScheduleaMeeting: ScheduleaMeeting$l,
	needAFollowUp: needAFollowUp$l,
	Today: Today$l,
	Viewdetails: Viewdetails$l,
	Activity: Activity$l,
	ActivityDetails: ActivityDetails$l,
	Delete: Delete$l,
	Title: Title$l,
	Goal: Goal$l,
	Status: Status$l,
	FollowUp: FollowUp$l,
	AddActivity: AddActivity$l,
	Enteractivitytitle: Enteractivitytitle$l,
	Cancel: Cancel$l,
	SaveActivity: SaveActivity$l,
	noActivityPresent: noActivityPresent$l,
	Addnew: Addnew$l,
	About: About$l,
	noDataPresentYou: noDataPresentYou$l,
	Experience: Experience$l,
	Education: Education$l,
	Skills: Skills$l,
	Overview: Overview$l,
	LinkedJobs: LinkedJobs$l,
	Notes: Notes$l,
	FullName: FullName$l,
	Location: Location$l,
	Relationship: Relationship$l,
	Contacts: Contacts$l,
	CreateContact: CreateContact$l,
	NotesCreated: NotesCreated$l,
	Notesupdated: Notesupdated$l,
	Addnote: Addnote$l,
	areYouSureDeleteNote: areYouSureDeleteNote$l,
	Createdby: Createdby$l,
	notSureWhyResumeCalls: notSureWhyResumeCalls$l,
	getExpertResumeReview: getExpertResumeReview$l,
	youHaventAddedContacts: youHaventAddedContacts$l,
	noMatchingContacts: noMatchingContacts$l,
	Link: Link$l,
	unlink: unlink$l,
	Locationnotavailable: Locationnotavailable$l,
	Emailnotavailable: Emailnotavailable$l,
	PhoneNumbernotavailable: PhoneNumbernotavailable$l,
	createdby: createdby$l,
	areYouSureDeleteContact: areYouSureDeleteContact$l,
	areYouSureUnlinkContact: areYouSureUnlinkContact$l,
	Addedbyyou: Addedbyyou$l,
	Addedby: Addedby$l,
	Timeline: Timeline$l,
	Timelineempty: Timelineempty$l,
	Discard: Discard$l,
	SaveContact: SaveContact$l,
	Recruiter: Recruiter$l,
	Candidate: Candidate$l,
	Colleague: Colleague$l,
	Employee: Employee$l,
	"Needtofollow-up": "Skal følges op",
	EnterValidEmail: EnterValidEmail$l,
	EnterValidPhoneNumber: EnterValidPhoneNumber$l,
	editingProfileNotAvailable: editingProfileNotAvailable$l,
	itWillBeSoonAvailable: itWillBeSoonAvailable$l,
	ChromeExtension: ChromeExtension$l,
	SelectTag: SelectTag$l,
	FirstName: FirstName$l,
	FirstNameisrequired: FirstNameisrequired$l,
	LastName: LastName$l,
	LastNameisrequired: LastNameisrequired$l,
	Companyisrequired: Companyisrequired$l,
	Email: Email$l,
	ThisisnotavalidEmail: ThisisnotavalidEmail$l,
	AddEmail: AddEmail$l,
	PhoneNumber: PhoneNumber$l,
	notaValidPhone: notaValidPhone$l,
	phoneNoMinimum5char: phoneNoMinimum5char$l,
	phoneNoMinumum15char: phoneNoMinumum15char$l,
	AddPhoneNumber: AddPhoneNumber$l,
	SelectGoal: SelectGoal$l,
	SelectStatus: SelectStatus$l,
	Followup: Followup$l,
	SocialMedia: SocialMedia$l,
	Linkedinhandle: Linkedinhandle$l,
	Twitterhandle: Twitterhandle$l,
	Facebookhandle: Facebookhandle$l,
	Githubhandle: Githubhandle$l,
	Gmailhandle: Gmailhandle$l,
	Changessavedsuccessfully: Changessavedsuccessfully$l,
	EditContact: EditContact$l,
	BasicInformation: BasicInformation$l,
	EditContactDetails: EditContactDetails$l,
	SaveChanges: SaveChanges$l,
	phoneNoMinimum14char: phoneNoMinimum14char$l,
	LinkedIn: LinkedIn$l,
	Twitter: Twitter$l,
	Facebook: Facebook$l,
	Github: Github$l,
	Gmail: Gmail$l,
	youCanWriteAbout: youCanWriteAbout$l,
	Addednewsection: Addednewsection$l,
	Removedsuccessfully: Removedsuccessfully$l,
	Remove: Remove$l,
	Institute: Institute$l,
	Schoolisrequired: Schoolisrequired$l,
	Degree: Degree$l,
	StartMonth: StartMonth$l,
	StartYear: StartYear$l,
	EndMonth: EndMonth$l,
	EndYear: EndYear$l,
	Addmore: Addmore$l,
	PositionTitle: PositionTitle$l,
	ExperienceType: ExperienceType$l,
	Addednewitem: Addednewitem$l,
	whatSkillsDoYouEnjoy: whatSkillsDoYouEnjoy$l,
	Typeskillshere: Typeskillshere$l,
	LinkedContacts: LinkedContacts$l,
	LinkContact: LinkContact$l,
	NocontactsLinked: NocontactsLinked$l,
	JobContactsComponent: JobContactsComponent$l,
	Nocontacts: Nocontacts$l,
	LinkJobto: LinkJobto$l,
	Contact: Contact$l,
	Document: Document$l,
	Nojobsfound: Nojobsfound$l,
	LinkJob: LinkJob$l,
	youCanLinkContactJobImported: youCanLinkContactJobImported$l,
	Prev: Prev$l,
	Next: Next$l,
	areYouSureUnlinkDocument: areYouSureUnlinkDocument$l,
	areYouSureDeleteDocument: areYouSureDeleteDocument$l,
	Category: Category$l,
	CreatedOn: CreatedOn$l,
	Joblinked: Joblinked$l,
	Quickactions: Quickactions$l,
	All: All$l,
	Resume: Resume$l,
	Portfolio: Portfolio$l,
	Other: Other$l,
	Adddocument: Adddocument$l,
	Type: Type$l,
	Sortingby: Sortingby$l,
	SwitchtoGridLayout: SwitchtoGridLayout$l,
	SwitchtoListLayout: SwitchtoListLayout$l,
	NoDocumentsAdded: NoDocumentsAdded$l,
	DocumentsComponent: DocumentsComponent$l,
	NoDocumentFound: NoDocumentFound$l,
	SelectFile: SelectFile$l,
	onlyPdfDocxSupported: onlyPdfDocxSupported$l,
	Uploadfile: Uploadfile$l,
	DocumentCategory: DocumentCategory$l,
	SaveDocument: SaveDocument$l,
	AddDocument: AddDocument$l,
	LinkedDocuments: LinkedDocuments$l,
	LinkDocument: LinkDocument$l,
	NodocumentsLinked: NodocumentsLinked$l,
	JobDocumentsComponent: JobDocumentsComponent$l,
	NoDocuments: NoDocuments$l,
	CreateDocuments: CreateDocuments$l,
	youCanLinkDocumentJobImported: youCanLinkDocumentJobImported$l,
	Documenteditedsuccessfully: Documenteditedsuccessfully$l,
	DocumentDetails: DocumentDetails$l,
	UnsavedChanges: UnsavedChanges$l,
	yourChangesWillBeLostSureClose: yourChangesWillBeLostSureClose$l,
	yourChangesWillBeLostSureDiscard: yourChangesWillBeLostSureDiscard$l,
	DiscardChanges: DiscardChanges$l,
	WeeklyGoalAlert: WeeklyGoalAlert$l,
	Progress: Progress$l,
	AllGoals: AllGoals$l,
	Name: Name$l,
	Completedon: Completedon$l,
	Createdon: Createdon$l,
	Action: Action$l,
	Back: Back$l,
	OverallScore: OverallScore$l,
	Aboutthegoal: Aboutthegoal$l,
	GoalTracking: GoalTracking$l,
	Week: Week$l,
	progress: progress$l,
	loading: loading$l,
	Apply: Apply$l,
	Thisskillhasbeenreported: Thisskillhasbeenreported$l,
	issueGettingResume: issueGettingResume$l,
	Interview: Interview$l,
	Tasks: Tasks$l,
	Loading: Loading$l,
	Skilladdedsuccessfully: Skilladdedsuccessfully$l,
	problemAddingSkill: problemAddingSkill$l,
	Reportaproblem: Reportaproblem$l,
	Submit: Submit$l,
	Addanewskill: Addanewskill$l,
	JobDetailsComponent: JobDetailsComponent$l,
	HardSkill: HardSkill$l,
	SoftSkill: SoftSkill$l,
	Pleaseshareanyadditionalcontext: Pleaseshareanyadditionalcontext$l,
	Addasskill: Addasskill$l,
	Skill: Skill$l,
	JobFrequency: JobFrequency$l,
	ResumeFrequency: ResumeFrequency$l,
	Reportskill: Reportskill$l,
	JobDetails: JobDetails$l,
	ViewJobLink: ViewJobLink$l,
	Salary: Salary$l,
	areYouSureDeleteJob: areYouSureDeleteJob$l,
	ViewMore: ViewMore$l,
	ViewLess: ViewLess$l,
	matchYouSkillsAgainstJob: matchYouSkillsAgainstJob$l,
	pleaseUploadResumeSkillMatch: pleaseUploadResumeSkillMatch$l,
	AddResume: AddResume$l,
	thisJobDoesNotHaveAnyDesc: thisJobDoesNotHaveAnyDesc$l,
	youCanEditJobToAdd: youCanEditJobToAdd$l,
	chromeextension: chromeextension$l,
	fromVariousJobPortalsOnce: fromVariousJobPortalsOnce$l,
	AddDescription: AddDescription$l,
	CompanyInfo: CompanyInfo$l,
	Website: Website$l,
	Industry: Industry$l,
	EmployeeCount: EmployeeCount$l,
	ExprienceLevel: ExprienceLevel$l,
	Address: Address$l,
	Resumes: Resumes$l,
	Setasdefault: Setasdefault$l,
	Ok: Ok$l,
	UploadNewResume: UploadNewResume$l,
	Default: Default$l,
	Jobnotfound: Jobnotfound$l,
	EditDetails: EditDetails$l,
	JobPostURL: JobPostURL$l,
	Enterjoburl: Enterjoburl$l,
	Nojobselected: Nojobselected$l,
	Viewjobdetails: Viewjobdetails$l,
	Jobaddedtoyourboardsuccessfully: Jobaddedtoyourboardsuccessfully$l,
	AddJob: AddJob$l,
	Addnewjobname: Addnewjobname$l,
	JobUrl: JobUrl$l,
	Addjoburl: Addjoburl$l,
	Section: Section$l,
	didYouKnow: didYouKnow$l,
	Jobs: Jobs$l,
	AddJobtoboard: AddJobtoboard$l,
	Currentlynojobsareavailable: Currentlynojobsareavailable$l,
	noMatchingJobs: noMatchingJobs$l,
	welcomeToYourPersonalJobTracker: welcomeToYourPersonalJobTracker$l,
	weShortTutorialOnHowTrackingJob: weShortTutorialOnHowTrackingJob$l,
	Addanewjob: Addanewjob$l,
	inOrderTrackCreatButton: inOrderTrackCreatButton$l,
	Providesomedetails: Providesomedetails$l,
	toBeginTypeJobTitleCompany: toBeginTypeJobTitleCompany$l,
	asAnExampleFilledForYou: asAnExampleFilledForYou$l,
	wohooAddedFirstJob: wohooAddedFirstJob$l,
	youCanDragDropJobCard: youCanDragDropJobCard$l,
	Lastbutnotleast: Lastbutnotleast$l,
	finalStepMakeSure: finalStepMakeSure$l,
	autoMaticallyImportJobs: autoMaticallyImportJobs$l,
	selectanysection: selectanysection$l,
	Accept: Accept$l,
	My2023JobSearch: My2023JobSearch$l,
	AddedFrom: AddedFrom$l,
	AddedUntil: AddedUntil$l,
	BasicModal: BasicModal$l,
	AddnewSectionName: AddnewSectionName$l,
	OpenTo: OpenTo$l,
	Featured: Featured$l,
	LicenceAndCerts: LicenceAndCerts$l,
	Banner: Banner$l,
	LinkedInURL: LinkedInURL$l,
	Recommendations: Recommendations$l,
	LinkedinReview: LinkedinReview$l,
	NoDataAvailable: NoDataAvailable$l,
	looksLikeYouDidNot: looksLikeYouDidNot$l,
	toOptimizeProfileScoreVisible: toOptimizeProfileScoreVisible$l,
	LinkedinComponent: LinkedinComponent$l,
	improveYourChancesLandingDreamJob: improveYourChancesLandingDreamJob$l,
	VisitProfile: VisitProfile$l,
	wantToGetLinkedinMakeover: wantToGetLinkedinMakeover$l,
	PostGenerator: PostGenerator$l,
	LinkedinHeadlineGenerator: LinkedinHeadlineGenerator$l,
	LinkedinAboutSectionGenerator: LinkedinAboutSectionGenerator$l,
	AITools: AITools$l,
	Premium: Premium$l,
	LinkedInOptimization: LinkedInOptimization$l,
	JobTracker: JobTracker$l,
	whoIsHiring: whoIsHiring$l,
	Autofill: Autofill$l,
	HeadlineGenerator: HeadlineGenerator$l,
	skillMatching: skillMatching$l,
	SummarizeJD: SummarizeJD$l,
	contactFeature: contactFeature$l,
	documentFeature: documentFeature$l,
	landJobWithoutStress: landJobWithoutStress$l,
	discoverFeatures: discoverFeatures$l,
	letsBeginOnboarding: letsBeginOnboarding$l,
	inTheNextFewScreensJobThirdParties: inTheNextFewScreensJobThirdParties$l,
	letsAddBasicInformation: letsAddBasicInformation$l,
	Pleaseselectanoptionfirst: Pleaseselectanoptionfirst$l,
	JobApplicationTracker: JobApplicationTracker$l,
	LinkedInProfileOptimizer: LinkedInProfileOptimizer$l,
	UnlimitedDocuments: UnlimitedDocuments$l,
	UnlimitedContacts: UnlimitedContacts$l,
	HiringManagerSearch: HiringManagerSearch$l,
	AILinkedInPostGenerator: AILinkedInPostGenerator$l,
	ATSKeywordSkillMatch: ATSKeywordSkillMatch$l,
	"Auto-Apply": "Auto-Anvend",
	ChooseyourPlan: ChooseyourPlan$l,
	superChargeYourJobSearch: superChargeYourJobSearch$l,
	startNowGoto: startNowGoto$l,
	CreatedBy: CreatedBy$l,
	CreateNewNote: CreateNewNote$l,
	Nonotescreated: Nonotescreated$l,
	approxTimeIsFourMinutes: approxTimeIsFourMinutes$l,
	Continue: Continue$l,
	iWillDoLaterTakeMeToApp: iWillDoLaterTakeMeToApp$l,
	allDone: allDone$l,
	welcomeAbord: welcomeAbord$l,
	letsBegin: letsBegin$l,
	UpgradeyourplanandgetAIAssistance: UpgradeyourplanandgetAIAssistance$l,
	DownloadPDF: DownloadPDF$l,
	oopsWeCouldntProcessResume: oopsWeCouldntProcessResume$l,
	MyProfile: MyProfile$l,
	Setting: Setting$l,
	Logout: Logout$l,
	SignIn: SignIn$l,
	Typeyourfirstnamehere: Typeyourfirstnamehere$l,
	Enteryourlastname: Enteryourlastname$l,
	ManageSubscription: ManageSubscription$l,
	ifYouHaveDifficultiesProfile: ifYouHaveDifficultiesProfile$l,
	forSupport: forSupport$l,
	whatIsIdealCompanySize: whatIsIdealCompanySize$l,
	Saveandcontinue: Saveandcontinue$l,
	whatIsMinExpectedSalary: whatIsMinExpectedSalary$l,
	Atleast: Atleast$l,
	SlidetoAdjust: SlidetoAdjust$l,
	whatIndustryExcitedWork: whatIndustryExcitedWork$l,
	Add: Add$l,
	statusOfJobSearch: statusOfJobSearch$l,
	Finish: Finish$l,
	whatLevelRoleLooking: whatLevelRoleLooking$l,
	Selectuptotwo: Selectuptotwo$l,
	PreviousStep: PreviousStep$l,
	Skip: Skip$l,
	whatDoYouValueNewRole: whatDoYouValueNewRole$l,
	Selectuptothree: Selectuptothree$l,
	EqualEmploymentData: EqualEmploymentData$l,
	whatIsYourEthnicity: whatIsYourEthnicity$l,
	areYouAuthorizedToWorkUs: areYouAuthorizedToWorkUs$l,
	willYouRequireSponsorShip: willYouRequireSponsorShip$l,
	doYouHaveADisability: doYouHaveADisability$l,
	areYouAVeteran: areYouAVeteran$l,
	rolesYouInterestedIn: rolesYouInterestedIn$l,
	Selectuptofive: Selectuptofive$l,
	AddCustomrole: AddCustomrole$l,
	whereDoYouLikeWork: whereDoYouLikeWork$l,
	Resources: Resources$l,
	currentlyNoResourceAvailable: currentlyNoResourceAvailable$l,
	AddNewSection: AddNewSection$l,
	ChangeSections: ChangeSections$l,
	Settings: Settings$l,
	Dashboard: Dashboard$l,
	JobBoard: JobBoard$l,
	Linkedin: Linkedin$l,
	Community: Community$l,
	FindRecruiters: FindRecruiters$l,
	Goals: Goals$l,
	DownloadExtension: DownloadExtension$l,
	SuggestaFeature: SuggestaFeature$l,
	leftPanel: leftPanel$l,
	PhoneNumberisrequired: PhoneNumberisrequired$l,
	MobileNumber: MobileNumber$l,
	Enteronlynumbers: Enteronlynumbers$l,
	Countryyoulivein: Countryyoulivein$l,
	SelectaCountry: SelectaCountry$l,
	DateofBirth: DateofBirth$l,
	Gender: Gender$l,
	JobPreferences: JobPreferences$l,
	pleaseEnterValidEmail: pleaseEnterValidEmail$l,
	emailSendForResetting: emailSendForResetting$l,
	VerifyyourEmailID: VerifyyourEmailID$l,
	sentPleaseCheckEmail: sentPleaseCheckEmail$l,
	tooManyAttemptsTryAgain: tooManyAttemptsTryAgain$l,
	Resend: Resend$l,
	Login: Login$l,
	weHaveSentVerificationLinkAtEmail: weHaveSentVerificationLinkAtEmail$l,
	pleaseVerifyEmailContinueSpam: pleaseVerifyEmailContinueSpam$l,
	Logintogetstarted: Logintogetstarted$l,
	ContinuewithGoogle: ContinuewithGoogle$l,
	pleaseInputEmail: pleaseInputEmail$l,
	Password: Password$l,
	pleaseInputPassword: pleaseInputPassword$l,
	passwordLowerUpperDigitSpecial: passwordLowerUpperDigitSpecial$l,
	atLeastSixChar: atLeastSixChar$l,
	forgotPassword: forgotPassword$l,
	Bysigninginyouagreetoour: Bysigninginyouagreetoour$l,
	Terms: Terms$l,
	Conditions: Conditions$l,
	and: and$l,
	PrivacyPolicy: PrivacyPolicy$l,
	theseAreTheTopsSkillsExtracted: theseAreTheTopsSkillsExtracted$l,
	TopSkills: TopSkills$l,
	weCoulNotExtractSkills: weCoulNotExtractSkills$l,
	upgradeToPremiumToView: upgradeToPremiumToView$l,
	SkillScore: SkillScore$l,
	thisIsYourSkillScoreBasedOn: thisIsYourSkillScoreBasedOn$l,
	theseSkllsAreStrongMatch: theseSkllsAreStrongMatch$l,
	Strongmatch: Strongmatch$l,
	theseSkillsArePartialMatch: theseSkillsArePartialMatch$l,
	Partialmatch: Partialmatch$l,
	theseSkillsAreMissingFrom: theseSkillsAreMissingFrom$l,
	"Missing Keywords": "Manglende nøgleord",
	SkillMatchComponent: SkillMatchComponent$l,
	Optional: Optional$l,
	Notrelevanttothejob: Notrelevanttothejob$l,
	Notaskill: Notaskill$l,
	Toogeneric: Toogeneric$l,
	Pleaseshareanyfeedback: Pleaseshareanyfeedback$l,
	excludedKeywordsWillNot: excludedKeywordsWillNot$l,
	yesExcludeThisSkillFrom: yesExcludeThisSkillFrom$l,
	PartialMatch: PartialMatch$l,
	MissingKeywords: MissingKeywords$l,
	Providetitletotask: Providetitletotask$l,
	TasksList: TasksList$l,
	AddTask: AddTask$l,
	EnterTaskTitlehere: EnterTaskTitlehere$l,
	TasksComponent: TasksComponent$l,
	CompletedTasks: CompletedTasks$l,
	CompleteYourtasks: CompleteYourtasks$l,
	Steps: Steps$l,
	PremiumMember: PremiumMember$l,
	Thankyouforupgradingto: Thankyouforupgradingto$l,
	CareerflowPremium: CareerflowPremium$l,
	hereIsHowYouCanAccessPremium: hereIsHowYouCanAccessPremium$l,
	stepOne: stepOne$l,
	DownloadourChromeExtension: DownloadourChromeExtension$l,
	youJobSearchCopilotIshere: youJobSearchCopilotIshere$l,
	DownloadNow: DownloadNow$l,
	stepTwo: stepTwo$l,
	GetStarted: GetStarted$l,
	stepThree: stepThree$l,
	SignintoChromeExtension: SignintoChromeExtension$l,
	entityCreated: entityCreated$l,
	entityUpdated: entityUpdated$l,
	entityDeleted: entityDeleted$l,
	entityLinked: entityLinked$l,
	entityUnlinked: entityUnlinked$l,
	entityMovedTo: entityMovedTo$l,
	youAddedANewEntity: youAddedANewEntity$l,
	personCreated: personCreated$l,
	youUpdatedAEntity: youUpdatedAEntity$l,
	personUpdated: personUpdated$l,
	youDeletedAEntity: youDeletedAEntity$l,
	personDeleted: personDeleted$l,
	youLinkedEntity: youLinkedEntity$l,
	personLinked: personLinked$l,
	youUnlinked: youUnlinked$l,
	personUnlinked: personUnlinked$l,
	youMovedEntity: youMovedEntity$l,
	personMoved: personMoved$l,
	addedByName: addedByName$l,
	DownloadChromeExtension: DownloadChromeExtension$l,
	ourChromeExtensionIs: ourChromeExtensionIs$l,
	Optimizeyourprofile: Optimizeyourprofile$l,
	startOptimizingYourProfile: startOptimizingYourProfile$l,
	OptimizeNow: OptimizeNow$l,
	Addyourfirstjob: Addyourfirstjob$l,
	startSavingJobApplicationsToTrack: startSavingJobApplicationsToTrack$l,
	AddNow: AddNow$l,
	CompleteProfile: CompleteProfile$l,
	completeYourProfileForUsing: completeYourProfileForUsing$l,
	CompleteNow: CompleteNow$l,
	Addyourfirstcontact: Addyourfirstcontact$l,
	addContactToFollowUpWith: addContactToFollowUpWith$l,
	JoinCommunity: JoinCommunity$l,
	ourCommunityisAlways: ourCommunityisAlways$l,
	JoinNow: JoinNow$l,
	welcomeToCareerflow: welcomeToCareerflow$l,
	yourHubForCareerInsights2: yourHubForCareerInsights2$l,
	ChecklistCompleted: ChecklistCompleted$l,
	Completeyourchecklist: Completeyourchecklist$l,
	completeAFewStepsTo: completeAFewStepsTo$l,
	Completed: Completed$l,
	JobCountByStage: JobCountByStage$l,
	NopastapplicationDatafound: NopastapplicationDatafound$l,
	YourJobSearchStages: YourJobSearchStages$l,
	NoDatafound: NoDatafound$l
};

const copyToClipboard$k = "In die Zwischenablage kopiert!";
const UnlocktheAIgenerated$k = "Entsperren Sie das künstlich generierte";
const UpgradetoPremium$k = "Upgrade auf Premium";
const Result$k = "Ergebnis";
const Copy$k = "Kopieren";
const Save$k = "Speichern";
const Edit$k = "Bearbeiten";
const Processing$k = "Verarbeitung";
const YourAIgeneratedcontentwillshowhere$k = "Ihr KI-generierter Inhalt wird hier angezeigt";
const hopeYouFindUseful$k = "Ich hoffe, dass du dieses Ergebnis nützlich findest!";
const regenerate$k = "Neu generieren";
const ProvideAdditionalFeedback$k = "Zusätzliches Feedback geben";
const Enteranyfeedback$k = "Geben Sie hier Ihr Feedback ein";
const Notimpressive$k = "Nicht beeindruckend";
const thisIsntTrue$k = "Das ist nicht wahr";
const Notpersonalized$k = "Nicht personalisiert";
const Tone$k = "Ton";
const Length$k = "Länge";
const Template$k = "Vorlage";
const Generatedon$k = "Generiert am";
const Copiedtoclipboard$k = "In die Zwischenablage kopiert";
const CopytoClipboard$k = "In die Zwischenablage kopieren";
const DownloadasPDF$k = "Als PDF herunterladen";
const ViewDetails$k = "Details anzeigen";
const JobDescriptionImported$k = "Stellenbeschreibung importiert";
const ImportfromJob$k = "Import aus Job";
const Saved$k = "Gespeichert";
const Applied$k = "Beworben";
const Offer$k = "Angebot";
const Interviewing$k = "Interviewen";
const Rejected$k = "Abgelehnt";
const Search$k = "Suche";
const Import$k = "Import";
const CoverLetterGeneratorHistory$k = "Verlauf des Anschreibengenerators";
const NoCoverLettersGenerated$k = "Keine Anschreiben generiert";
const getStartedCoverLetter$k = "Sie haben noch keine Anschreiben generiert. Fangen Sie an und erstellen Sie Anschreiben, indem Sie die Stellenbeschreibung mit Ihrer relevanten Erfahrung abgleichen.";
const getStarted$k = "Los geht's!";
const Documents$k = "Dokumente";
const UploadNewDocument$k = "Neues Dokument hochladen";
const AICoverLetterGenerator$k = "KI-Anschreibengenerator";
const ViewHistory$k = "Verlauf anzeigen";
const JobDescription$k = "Stellenbeschreibung";
const ImportfromBoard$k = "Von der Tafel importieren";
const EnterJobDescription$k = "Stellenbeschreibung eingeben";
const JobTitle$k = "Berufsbezeichnung";
const EnterJobTitle$k = "Berufsbezeichnung eingeben";
const CompanyName$k = "Firmenname";
const EnterCompanyName$k = "Firmenname eingeben";
const YourProfile$k = "Ihr Profil";
const ResumeUpload$k = "Lebenslauf hochladen";
const UseLinkedinProfile$k = "LinkedIn-Profil verwenden";
const Uploadyourresume$k = "Laden Sie Ihren Lebenslauf hoch";
const AddyourResume$k = "Fügen Sie Ihren Lebenslauf hinzu";
const fileNameCannotFormat$k = "Dateinamen dürfen keine Leerzeichen oder Unterstriche enthalten und sollten entweder .doc, .docx oder .pdf sein.";
const ChooseorUpload$k = "Auswählen oder hochladen";
const SelectTemplate$k = "Vorlage auswählen";
const Preview$k = "Vorschau";
const UseTemplate$k = "Vorlage verwenden";
const Change$k = "Ändern";
const AdvancedSettings$k = "Erweiterte Einstellungen";
const AdditionalContext$k = "Zusätzlicher Kontext";
const Professional$k = "Professionell";
const Casual$k = "Lässig";
const Enthusiastic$k = "Begeistert";
const Informational$k = "Informativ";
const Short$k = "Kurz";
const Medium$k = "Mittel";
const Long$k = "Lang";
const Language$k = "Sprache";
const iAmOkayBack$k = "Mir geht's gut! Zurück";
const Generate$k = "Generieren";
const CoverLetter$k = "Bewerbungsschreiben";
const SelectLanguage$k = "Sprache auswählen";
const AboutGeneratorHistory$k = "Verlauf des Über-uns-Generators";
const NoAboutsGenerated$k = "Keine Über-uns-Texte generiert";
const getStartedAbouts$k = "Sie haben noch keine Über-uns-Texte generiert. Fangen Sie an und erstellen Sie Texte, indem Sie die Stellenbeschreibung mit Ihrer relevanten Erfahrung abgleichen.";
const noAttachmentsFound$k = "Keine Anhänge gefunden.";
const TargetJobTitle$k = "Ziel-Berufsbezeichnung";
const KeywordsToInclude$k = "Schlüsselwörter einzuschließen";
const UploadYourResume$k = "Laden Sie Ihren Lebenslauf hoch";
const AddYourResume$k = "Fügen Sie Ihren Lebenslauf hinzu";
const LinkedinProfile$k = "LinkedIn-Profil";
const Linkedinprofilenotfound$k = "LinkedIn-Profil nicht gefunden";
const startUsingChromeExtension$k = "Beginnen Sie mit der Optimierung Ihres LinkedIn-Profils mithilfe unserer Chrome-Erweiterung, um diese Option zu nutzen.";
const Download$k = "Herunterladen";
const UseEmojis$k = "Emojis verwenden";
const UseBulletPoints$k = "Aufzählungspunkte verwenden";
const SpeechFocus$k = "Sprachfokus";
const FirstPerson$k = "Ich-Form";
const ThirdPerson$k = "Dritte Person";
const HeadlineGeneratorHistory$k = "Verlauf des Schlagzeilengenerators";
const NoHeadlinesGenerated$k = "Keine Schlagzeilen generiert";
const getStartedHeadline$k = "Sie haben noch keine Schlagzeilen generiert. Fangen Sie an und erstellen Sie Schlagzeilen, indem Sie die Stellenbeschreibung mit Ihrer relevanten Erfahrung abgleichen.";
const AIHeadlineGenerator$k = "KI Schlagzeilengenerator";
const KeywordstoInclude$k = "Einzubeziehende Schlüsselwörter";
const Pressenteraftereachword$k = "Drücken Sie nach jedem Wort die Eingabetaste";
const LinkedinProfilenotfound$k = "LinkedIn-Profil nicht gefunden";
const Headline$k = "Überschrift";
const PostGeneratorHistory$k = "Verlauf des Beitragsgenerators";
const NoPostsGenerated$k = "Keine Beiträge generiert";
const getStartedPost$k = "Sie haben noch keine Beiträge generiert. Fangen Sie an und erstellen Sie Beiträge, indem Sie die Stellenbeschreibung mit Ihrer relevanten Erfahrung abgleichen.";
const Topic$k = "Thema";
const Description$k = "Beschreibung";
const UseHashtags$k = "Hashtags verwenden";
const Custom$k = "Benutzerdefiniert";
const EnterCustomTone$k = "Benutzerdefinierten Ton eingeben";
const Added$k = "Hinzugefügt";
const ComingSoon$k = {
	header: "Ingenieure am Werk!",
	content_1: "Unser Team von Ingenieuren arbeitet hart daran, diese Funktion bald einsatzbereit zu machen",
	content_2: "Möchten Sie diese Funktion bald? Lassen Sie es uns einfach wissen, indem Sie das unten stehende Kästchen ankreuzen.",
	content_3: "Ich möchte diese Funktion"
};
const Company$k = "Unternehmen";
const JobInterview$k = "Bewerbungsgespräch";
const Research$k = "Forschung";
const Networking$k = "Networking";
const Referral$k = "Weiterempfehlung";
const MustbeContacted$k = "Muss kontaktiert werden";
const ScheduleaMeeting$k = "Ein Meeting vereinbaren";
const needAFollowUp$k = "Muss nachfassen";
const Today$k = "Heute";
const Viewdetails$k = "Details anzeigen";
const Activity$k = "Aktivität";
const ActivityDetails$k = "Aktivitätsdetails";
const Delete$k = "Löschen";
const Title$k = "Titel";
const Goal$k = "Ziel";
const Status$k = "Status";
const FollowUp$k = "Folge auf";
const AddActivity$k = "Aktivität hinzufügen";
const Enteractivitytitle$k = "Aktivitätstitel eingeben";
const Cancel$k = "Abbrechen";
const SaveActivity$k = "Aktivität speichern";
const noActivityPresent$k = "Keine Aktivität vorhanden, füge eine Aktivität hinzu.";
const Addnew$k = "Neu hinzufügen";
const About$k = "Über";
const noDataPresentYou$k = "Keine Daten vorhanden. Sie können diesen Kontakt bearbeiten und Felder hinzufügen.";
const Experience$k = "Erfahrung";
const Education$k = "Bildung";
const Skills$k = "Fähigkeiten";
const Overview$k = "Überblick";
const LinkedJobs$k = "Verknüpfte Jobs";
const Notes$k = "Notizen";
const FullName$k = "Vollständiger Name";
const Location$k = "Ort";
const Relationship$k = "Beziehung";
const Contacts$k = "Kontakte";
const CreateContact$k = "Kontakt erstellen";
const NotesCreated$k = "Notizen erstellt";
const Notesupdated$k = "Notizen aktualisiert";
const Addnote$k = "Notiz hinzufügen";
const areYouSureDeleteNote$k = "Sind Sie sicher, dass Sie diese Notiz löschen möchten?";
const Createdby$k = "Erstellt von";
const notSureWhyResumeCalls$k = "Nicht sicher, warum Ihr Lebenslauf Ihnen keine Vorstellungsgespräche einbringt? ☎️";
const getExpertResumeReview$k = "Erhalten Sie eine Expertenbewertung Ihres Lebenslaufs 💎✨";
const youHaventAddedContacts$k = "Sie haben noch keine Kontakte hinzugefügt.";
const noMatchingContacts$k = "Keine übereinstimmenden Kontakte gefunden.";
const Link$k = "Link";
const unlink$k = "Verknüpfung aufheben";
const Locationnotavailable$k = "Ort nicht verfügbar";
const Emailnotavailable$k = "E-Mail nicht verfügbar";
const PhoneNumbernotavailable$k = "Telefonnummer nicht verfügbar";
const createdby$k = "erstellt von";
const areYouSureDeleteContact$k = "Sind Sie sicher, dass Sie diesen Kontakt löschen möchten?";
const areYouSureUnlinkContact$k = "Sind Sie sicher, dass Sie diese Verknüpfung aufheben möchten?";
const Addedbyyou$k = "Von Ihnen hinzugefügt";
const Addedby$k = "Hinzugefügt von";
const Timeline$k = "Zeitstrahl";
const Timelineempty$k = "Zeitstrahl leer";
const Discard$k = "Verwerfen";
const SaveContact$k = "Kontakt speichern";
const Recruiter$k = "Personalvermittler";
const Candidate$k = "Bewerber";
const Colleague$k = "Kollege";
const Employee$k = "Mitarbeiter";
const EnterValidEmail$k = "Geben Sie eine gültige E-Mail-Adresse ein";
const EnterValidPhoneNumber$k = "Geben Sie eine gültige Telefonnummer ein";
const editingProfileNotAvailable$k = "Das Bearbeiten des Profilfotos ist noch nicht verfügbar.";
const itWillBeSoonAvailable$k = "Es wird bald in unserem Angebot verfügbar sein.";
const ChromeExtension$k = "Chrome-Erweiterung";
const SelectTag$k = "Auswahl-Tag";
const FirstName$k = "Vorname";
const FirstNameisrequired$k = "Vorname ist erforderlich";
const LastName$k = "Nachname";
const LastNameisrequired$k = "Nachname ist erforderlich";
const Companyisrequired$k = "Unternehmen ist erforderlich";
const Email$k = "E-Mail";
const ThisisnotavalidEmail$k = "Dies ist keine gültige E-Mail.";
const AddEmail$k = "E-Mail hinzufügen";
const PhoneNumber$k = "Telefonnummer";
const notaValidPhone$k = "Dies ist keine gültige Telefonnummer. Bitte gib nur Zahlen ein.";
const phoneNoMinimum5char$k = "Die Telefonnummer muss mindestens 5 Zeichen lang sein.";
const phoneNoMinumum15char$k = "Die Telefonnummer darf maximal 15 Zeichen lang sein.";
const AddPhoneNumber$k = "Telefonnummer hinzufügen";
const SelectGoal$k = "Ziel auswählen";
const SelectStatus$k = "Status auswählen";
const Followup$k = "Nachverfolgung";
const SocialMedia$k = "Soziale Medien";
const Linkedinhandle$k = "Linkedin-Griff";
const Twitterhandle$k = "Twitter-Handle";
const Facebookhandle$k = "Facebook-Handle";
const Githubhandle$k = "Github-Handle";
const Gmailhandle$k = "Gmail-Handle";
const Changessavedsuccessfully$k = "Änderungen erfolgreich gespeichert";
const EditContact$k = "Kontakt bearbeiten";
const BasicInformation$k = "Grundlegende Informationen";
const EditContactDetails$k = "Kontaktdetails bearbeiten";
const SaveChanges$k = "Änderungen speichern";
const phoneNoMinimum14char$k = "Die Telefonnummer muss mindestens 14 Zeichen lang sein.";
const LinkedIn$k = "LinkedIn";
const Twitter$k = "Twitter";
const Facebook$k = "Facebook";
const Github$k = "Github";
const Gmail$k = "Gmail";
const youCanWriteAbout$k = "Sie können über Ihre Jahre an Erfahrung, Branche oder Fähigkeiten schreiben. Menschen sprechen auch über ihre Erfolge oder frühere Berufserfahrungen.";
const Addednewsection$k = "Hinzugefügte neue Sektion";
const Removedsuccessfully$k = "Erfolgreich entfernt.";
const Remove$k = "Entfernen";
const Institute$k = "Institut";
const Schoolisrequired$k = "Schule ist erforderlich";
const Degree$k = "Grad";
const StartMonth$k = "Startmonat";
const StartYear$k = "Startjahr";
const EndMonth$k = "Ende des Monats";
const EndYear$k = "Jahresende";
const Addmore$k = "Mehr hinzufügen";
const PositionTitle$k = "Stellenbezeichnung";
const ExperienceType$k = "Erfahrungstyp";
const Addednewitem$k = "Hinzugefügter neuer Artikel";
const whatSkillsDoYouEnjoy$k = "Über welche Fähigkeiten verfügst du oder welche Arbeit macht dir Freude?";
const Typeskillshere$k = "Geben Sie hier Ihre Fähigkeiten ein";
const LinkedContacts$k = "Verknüpfte Kontakte";
const LinkContact$k = "Kontakt verknüpfen";
const NocontactsLinked$k = "Keine verknüpften Kontakte";
const JobContactsComponent$k = {
	linkContact: "Durch Verknüpfen von Kontakten können Sie schnell sehen, wer die wichtigen Personen wie den Personalvermittler, den Einstellungsmanager usw. für diese Rolle sind! In Zukunft werden wir relevante Einblicke basierend auf Ihren Kontakten anzeigen können."
};
const Nocontacts$k = "Keine Kontakte";
const LinkJobto$k = "Verknüpfe Job mit";
const Contact$k = "Kontakt";
const Document$k = "Dokument";
const Nojobsfound$k = "Keine Jobs gefunden";
const LinkJob$k = "Job verknüpfen";
const youCanLinkContactJobImported$k = "Sie können diesen Kontakt mit einem Job verknüpfen, den Sie in Careerflow importiert haben.";
const Prev$k = "Vorherige";
const Next$k = "Nächstes";
const areYouSureUnlinkDocument$k = "Sind Sie sicher, dass Sie diese Verknüpfung zum Dokument aufheben möchten?";
const areYouSureDeleteDocument$k = "Sind Sie sicher, dass Sie dieses Dokument löschen möchten?";
const Category$k = "Kategorie";
const CreatedOn$k = "Erstellt am";
const Joblinked$k = "Arbeitsbezogen";
const Quickactions$k = "Schnelle Aktionen";
const All$k = "Alle";
const Resume$k = "Lebenslauf";
const Portfolio$k = "Portfolio";
const Other$k = "Andere";
const Adddocument$k = "Dokument hinzufügen";
const Type$k = "Typ";
const Sortingby$k = "Sortieren nach";
const SwitchtoGridLayout$k = "Wechseln Sie zum Rasterlayout";
const SwitchtoListLayout$k = "Wechseln Sie zur Listenansicht";
const NoDocumentsAdded$k = "Keine Dokumente hinzugefügt";
const DocumentsComponent$k = {
	nodocs: "Sie haben noch keine Dokumente erstellt. Sie können Ihre Lebenslaufversionen, Anschreiben und mehr hochladen und mit den von Ihnen verfolgten Jobs verknüpfen!"
};
const NoDocumentFound$k = "Kein Dokument gefunden";
const SelectFile$k = "Datei auswählen";
const onlyPdfDocxSupported$k = "Nur .pdf und .docx werden unterstützt.";
const Uploadfile$k = "Datei hochladen";
const DocumentCategory$k = "Dokumentenkategorie";
const SaveDocument$k = "Dokument speichern";
const AddDocument$k = "Dokument hinzufügen";
const LinkedDocuments$k = "Verknüpfte Dokumente";
const LinkDocument$k = "Dokument verknüpfen";
const NodocumentsLinked$k = "Keine verknüpften Dokumente";
const JobDocumentsComponent$k = {
	linkDocs: "Durch Verknüpfen aller relevanten Dokumente wie Lebenslauf, Anschreiben usw., die Sie für diesen Job eingereicht haben, behalten Sie alles an einem Ort im Blick. Probieren Sie es aus!"
};
const NoDocuments$k = "Keine Dokumente";
const CreateDocuments$k = "Dokumente erstellen";
const youCanLinkDocumentJobImported$k = "Sie können dieses Dokument mit einem Job verknüpfen, den Sie in Careerflow importiert haben.";
const Documenteditedsuccessfully$k = "Dokument erfolgreich bearbeitet";
const DocumentDetails$k = "Dokumentendetails";
const UnsavedChanges$k = "Ungespeicherte Änderungen";
const yourChangesWillBeLostSureClose$k = "Ihre Änderungen gehen verloren, sind Sie sicher, dass Sie schließen möchten?";
const yourChangesWillBeLostSureDiscard$k = "Ihre Änderungen gehen verloren. Sind Sie sicher, dass Sie Ihre Änderungen verwerfen möchten?";
const DiscardChanges$k = "Änderungen verwerfen";
const WeeklyGoalAlert$k = "Wöchentliche Zielbenachrichtigung";
const Progress$k = "Fortschritt";
const AllGoals$k = "Alle Ziele";
const Name$k = "Name";
const Completedon$k = "Abgeschlossen am";
const Createdon$k = "Erstellt am";
const Action$k = "Aktion";
const Back$k = "Zurück";
const OverallScore$k = "Gesamtpunktzahl";
const Aboutthegoal$k = "Über das Ziel";
const GoalTracking$k = "Zielverfolgung";
const Week$k = "Woche";
const progress$k = "Fortschritt";
const loading$k = "Laden";
const Apply$k = "Anwenden";
const Thisskillhasbeenreported$k = "Diese Fähigkeit wurde gemeldet.";
const issueGettingResume$k = "Es gab ein Problem beim Abrufen des Lebenslaufs.";
const Interview$k = "Interview";
const Tasks$k = "Aufgaben";
const Loading$k = "Laden";
const Skilladdedsuccessfully$k = "Fähigkeit erfolgreich hinzugefügt";
const problemAddingSkill$k = "Es gab ein Problem beim Hinzufügen von Fähigkeiten.";
const Reportaproblem$k = "Problem melden";
const Submit$k = "Einreichen";
const Addanewskill$k = "Neue Fähigkeit hinzufügen";
const JobDetailsComponent$k = {
	classifySkill: "Wie würden Sie diese Fähigkeit klassifizieren? (Optional)",
	includedKeywordsWillCount: "Dieses Schlüsselwort einbeziehen?",
	yesIncludeThisSkill: "Eingeschlossene Schlüsselwörter werden bei allen zukünftigen Scans in Ihre Übereinstimmungspunktzahl einbezogen. Sie können die eingeschlossenen Schlüsselwörter in Ihrem Profil ändern.",
	addSkill: "Möchtest du dies als Fähigkeit hinzufügen?"
};
const HardSkill$k = "Hard Skill";
const SoftSkill$k = "Soft Skill";
const Pleaseshareanyadditionalcontext$k = "Bitte teilen Sie jeden zusätzlichen Kontext mit";
const Addasskill$k = "Als Fähigkeit hinzufügen";
const Skill$k = "Fähigkeit";
const JobFrequency$k = "Jobfrequenz";
const ResumeFrequency$k = "Lebenslauf-Frequenz";
const Reportskill$k = "Fähigkeit melden";
const JobDetails$k = "Stellenbeschreibung";
const ViewJobLink$k = "Stellenangebot ansehen";
const Salary$k = "Gehalt";
const areYouSureDeleteJob$k = "Sind Sie sicher, dass Sie diesen Job löschen möchten?";
const ViewMore$k = "Mehr anzeigen";
const ViewLess$k = "Weniger anzeigen";
const matchYouSkillsAgainstJob$k = "Vergleichen Sie Ihre Fähigkeiten mit der Stellenbeschreibung.";
const pleaseUploadResumeSkillMatch$k = "Bitte laden Sie Ihren Lebenslauf hoch, um Ihre Fähigkeiten-Match-Punktzahl zu erhalten.";
const AddResume$k = "Lebenslauf hinzufügen";
const thisJobDoesNotHaveAnyDesc$k = "Diese Stelle hat keine Beschreibung.";
const youCanEditJobToAdd$k = "Sie können diesen Job bearbeiten, um eine Beschreibung hinzuzufügen. Sie können auch Jobs über unsere Importfunktion importieren.";
const chromeextension$k = "Chrome-Erweiterung";
const fromVariousJobPortalsOnce$k = "von verschiedenen Jobportalen. Sobald Sie eine Beschreibung hinzufügen, können Sie auch fachbezogene Informationen sehen.";
const AddDescription$k = "Fügen Sie eine Beschreibung hinzu";
const CompanyInfo$k = "Firmeninformationen";
const Website$k = "Website";
const Industry$k = "Industrie";
const EmployeeCount$k = "Mitarbeiterzahl";
const ExprienceLevel$k = "Erfahrungsstufe";
const Address$k = "Adresse";
const Resumes$k = "Lebensläufe";
const Setasdefault$k = "Als Standard festlegen";
const Ok$k = "Ok";
const UploadNewResume$k = "Neuen Lebenslauf hochladen";
const Default$k = "Standard";
const Jobnotfound$k = "Stelle nicht gefunden";
const EditDetails$k = "Details bearbeiten";
const JobPostURL$k = "Job-Beitrags-URL";
const Enterjoburl$k = "Geben Sie die Job-URL ein";
const Nojobselected$k = "Kein Job ausgewählt";
const Viewjobdetails$k = "Jobdetails anzeigen";
const Jobaddedtoyourboardsuccessfully$k = "Stelle erfolgreich zu Ihrem Board hinzugefügt";
const AddJob$k = "Job hinzufügen";
const Addnewjobname$k = "Fügen Sie einen neuen Jobnamen hinzu";
const JobUrl$k = "Job-URL";
const Addjoburl$k = "Füge Job-URL hinzu";
const Section$k = "Abschnitt";
const didYouKnow$k = {
	chromeExtension: "Wussten Sie schon? Sie können Jobs auch direkt über unsere Chrome-Erweiterung speichern und alle Daten mit nur einem Klick importieren! Es dauert nur wenige Sekunden."
};
const Jobs$k = "Jobs";
const AddJobtoboard$k = "Job zum Board hinzufügen";
const Currentlynojobsareavailable$k = "Derzeit sind keine Stellen verfügbar.";
const noMatchingJobs$k = "Keine passenden Stellenangebote gefunden.";
const welcomeToYourPersonalJobTracker$k = "Willkommen bei Ihrem persönlichen Job-Tracker!";
const weShortTutorialOnHowTrackingJob$k = "Wir werden Sie in wenigen einfachen Schritten durch ein kurzes Tutorial führen, wie Sie mit der Verfolgung Ihrer Bewerbungen beginnen können!";
const Addanewjob$k = "Füge einen neuen Job hinzu";
const inOrderTrackCreatButton$k = "Um Bewerbungen zu verfolgen, müssen Sie sie zuerst durch Klicken auf die Schaltfläche \"Erstellen\" zum Board hinzufügen.";
const Providesomedetails$k = "Geben Sie einige Details an.";
const toBeginTypeJobTitleCompany$k = "Zunächst geben Sie einfach den Jobtitel, den Firmennamen und den Status ein, den Sie hinzufügen möchten. Sie können später weitere Details hinzufügen, aber das ist alles, was Sie jetzt brauchen!";
const asAnExampleFilledForYou$k = "Als Beispiel haben wir das bereits für Sie ausgefüllt!";
const wohooAddedFirstJob$k = "Juhu! Du hast deinen ersten Job zu deinem Job-Tracker hinzugefügt!";
const youCanDragDropJobCard$k = "Sie können jetzt die Jobkarte in die verschiedenen Stufen des Bewerbungsprozesses ziehen und ablegen. Wenn Sie auf die Jobkarte klicken, können Sie weitere Details anzeigen, bearbeiten, Notizen speichern und vieles mehr!";
const Lastbutnotleast$k = "Zu guter Letzt";
const finalStepMakeSure$k = "Als letzter Schritt, stellen Sie sicher, dass Sie unser haben.";
const autoMaticallyImportJobs$k = "Dies wird es Ihnen ermöglichen, automatisch Jobs von Ihren bevorzugten Job-Such-Websites wie LinkedIn, Indeed und mehr zu importieren! Unsere Erweiterung hilft Ihnen auch dabei, Ihr LinkedIn-Profil zu verbessern und 2,5-mal mehr Suchauftritte zu erhalten!";
const selectanysection$k = "Wählen Sie eine beliebige Sektion aus.";
const Accept$k = "Akzeptieren";
const My2023JobSearch$k = "Meine Jobsuche 2023";
const AddedFrom$k = "Hinzugefügt von";
const AddedUntil$k = "Hinzugefügt bis";
const BasicModal$k = "Grundlegendes Modal";
const AddnewSectionName$k = "Neuen Abschnittsnamen hinzufügen";
const OpenTo$k = "Offen für";
const Featured$k = "Vorgestellt";
const LicenceAndCerts$k = "Lizenz und Zertifikate";
const Banner$k = "Banner";
const LinkedInURL$k = "LinkedIn-URL";
const Recommendations$k = "Empfehlungen";
const LinkedinReview$k = "Linkedin Bewertung";
const NoDataAvailable$k = "Keine Daten verfügbar.";
const looksLikeYouDidNot$k = "Es sieht so aus, als hättest du noch nicht damit begonnen, unsere...";
const toOptimizeProfileScoreVisible$k = "um Ihr LinkedIn-Profil zu optimieren. Sobald Sie das getan haben, wird Ihr Profil-Score hier sichtbar sein.";
const LinkedinComponent$k = {
	letsOptimize: "Optimieren wir"
};
const improveYourChancesLandingDreamJob$k = "Verbessern Sie Ihre Chancen, Ihren Traumjob zu bekommen. Verwenden Sie diese erprobten Strategien, um Ihrem LinkedIn-Profil eine dringend benötigte Überarbeitung zu geben.";
const VisitProfile$k = "Profil besuchen";
const wantToGetLinkedinMakeover$k = "Möchten Sie eine komplette LinkedIn-Verjüngungskur?";
const PostGenerator$k = "Post-Generator";
const LinkedinHeadlineGenerator$k = "LinkedIn-Überschriften-Generator";
const LinkedinAboutSectionGenerator$k = "LinkedIn Über-mich-Generator";
const AITools$k = "KI-Werkzeuge";
const Premium$k = "Premium";
const LinkedInOptimization$k = "Optimierung auf LinkedIn";
const JobTracker$k = "Stellenverfolgung";
const whoIsHiring$k = "Wer stellt ein?";
const Autofill$k = "Automatische Vervollständigung";
const HeadlineGenerator$k = "Schlagzeilen-Generator";
const skillMatching$k = "Fähigkeitenabgleich";
const SummarizeJD$k = "Zusammenfassung der Stellenbeschreibung";
const contactFeature$k = "Kontaktverfolgung";
const documentFeature$k = "Dokumente";
const landJobWithoutStress$k = "Erreichen Sie Ihren Traumjob. Ohne Stress.";
const discoverFeatures$k = "Entdecken Sie die Vielzahl von Careerflow.ai-Funktionen, die entwickelt wurden, um Ihre Jobsuche zu optimieren und Ihre berufliche Reise zu verbessern!";
const letsBeginOnboarding$k = "Lass uns dich besser kennenlernen!";
const inTheNextFewScreensJobThirdParties$k = "In den nächsten Bildschirmen werden wir Ihnen einige Fragen stellen, die uns helfen werden, das Erlebnis für Sie anzupassen und Ihre Bewerbungen automatisch auszufüllen (damit Sie es nicht tun müssen)! Wir verkaufen Ihre Daten nicht an Dritte.";
const letsAddBasicInformation$k = "Lassen Sie uns Ihre Grundinformationen hinzufügen.";
const Pleaseselectanoptionfirst$k = "Bitte wählen Sie zuerst eine Option aus.";
const JobApplicationTracker$k = "Bewerbungsverfolgung";
const LinkedInProfileOptimizer$k = "LinkedIn Profil-Optimierer";
const UnlimitedDocuments$k = "Unbegrenzte Dokumente";
const UnlimitedContacts$k = "Unbegrenzte Kontakte";
const HiringManagerSearch$k = "Suche nach einem Einstellungsmanager";
const AILinkedInPostGenerator$k = "AI LinkedIn-Beitrags-Generator";
const ATSKeywordSkillMatch$k = "ATS-Schlüsselwort / Fähigkeiten-übereinstimmender Job";
const ChooseyourPlan$k = "Wähle deinen Plan";
const superChargeYourJobSearch$k = "Beschleunigen Sie Ihre Jobsuche und verbessern Sie Ihren Bewerbungsprozess, erhöhen Sie Ihre Vorstellungsgespräche und landen Sie Ihren Traumjob. All dies mit Hilfe des Premium-Toolkits von Careerflow.";
const startNowGoto$k = "Jetzt starten (Zur App gehen)";
const CreatedBy$k = "Erstellt von";
const CreateNewNote$k = "Neue Notiz erstellen";
const Nonotescreated$k = "Keine Notizen erstellt";
const approxTimeIsFourMinutes$k = "Die ungefähre Zeit, um den Onboarding-Prozess abzuschließen, beträgt 4 Minuten.";
const Continue$k = "Weiter";
const iWillDoLaterTakeMeToApp$k = "Ich mache das später. Bring mich zur App.";
const allDone$k = "Alles erledigt!";
const welcomeAbord$k = "Herzlich willkommen an Bord!";
const letsBegin$k = "Lass uns beginnen";
const UpgradeyourplanandgetAIAssistance$k = "Verbessern Sie Ihren Plan und erhalten Sie KI-Unterstützung.";
const DownloadPDF$k = "PDF herunterladen";
const oopsWeCouldntProcessResume$k = "Hoppla, wir konnten diesen Lebenslauf nicht verarbeiten.";
const MyProfile$k = "Mein Profil";
const Setting$k = "Einstellung";
const Logout$k = "Abmelden";
const SignIn$k = "Anmelden";
const Typeyourfirstnamehere$k = "Ihr Vorname";
const Enteryourlastname$k = "Ihr Nachname";
const ManageSubscription$k = "Verwalten Sie das Abonnement";
const ifYouHaveDifficultiesProfile$k = "Wenn Sie Schwierigkeiten mit Ihren Profilinformationen haben, wenden Sie sich bitte an";
const forSupport$k = "für Unterstützung.";
const whatIsIdealCompanySize$k = "Was ist die ideale Größe Ihres Unternehmens?";
const Saveandcontinue$k = "Speichern und Fortfahren";
const whatIsMinExpectedSalary$k = "Was ist Ihr erwartetes Mindestgehalt (pro Jahr)?";
const Atleast$k = "Mindestens";
const SlidetoAdjust$k = "Schieben zum Anpassen";
const whatIndustryExcitedWork$k = "Welche Branchen begeistern Sie?";
const Add$k = "Hinzufügen";
const statusOfJobSearch$k = "Stand Ihrer Jobsuche?";
const Finish$k = "Fertig";
const whatLevelRoleLooking$k = "Auf welcher Ebene suchst du eine Rolle?";
const Selectuptotwo$k = "Wählen Sie bis zu zwei aus.";
const PreviousStep$k = "Vorheriger Schritt";
const Skip$k = "Überspringen";
const whatDoYouValueNewRole$k = "Was schätzen Sie an einer neuen Rolle?";
const Selectuptothree$k = "Wählen Sie bis zu drei aus.";
const EqualEmploymentData$k = "Gleichstellungsdaten";
const whatIsYourEthnicity$k = "Was ist deine ethnische Herkunft?";
const areYouAuthorizedToWorkUs$k = "Sind Sie berechtigt, in den USA zu arbeiten?";
const willYouRequireSponsorShip$k = "Werden Sie jetzt oder in Zukunft eine Unterstützung für den Arbeitsvisum-Status benötigen?";
const doYouHaveADisability$k = "Hast du eine Behinderung?";
const areYouAVeteran$k = "Bist du ein Veteran?";
const rolesYouInterestedIn$k = "An welchen Rollen bist du interessiert?";
const Selectuptofive$k = "Wählen Sie bis zu fünf aus.";
const AddCustomrole$k = "Füge eine benutzerdefinierte Rolle hinzu";
const whereDoYouLikeWork$k = "Wo möchtest du arbeiten?";
const Resources$k = "Ressourcen";
const currentlyNoResourceAvailable$k = "Derzeit sind keine Ressourcen verfügbar.";
const AddNewSection$k = "Neuen Abschnitt hinzufügen";
const ChangeSections$k = "Abschnitte ändern";
const Settings$k = "Einstellungen";
const Dashboard$k = "Dashboard";
const JobBoard$k = "Jobbörse";
const Linkedin$k = "Linkedin";
const Community$k = "Gemeinschaft";
const FindRecruiters$k = "Finde Personalvermittler";
const Goals$k = "Ziele";
const DownloadExtension$k = "Erweiterung herunterladen";
const SuggestaFeature$k = "Feature vorschlagen";
const leftPanel$k = {
	ReportanIssue: "Problem melden"
};
const PhoneNumberisrequired$k = "Telefonnummer ist erforderlich";
const MobileNumber$k = "Handynummer";
const Enteronlynumbers$k = "Geben Sie nur Zahlen ein";
const Countryyoulivein$k = "Land, in dem du lebst";
const SelectaCountry$k = "Wählen Sie ein Land aus";
const DateofBirth$k = "Geburtsdatum";
const Gender$k = "Geschlecht";
const JobPreferences$k = "Jobpräferenzen";
const pleaseEnterValidEmail$k = "Bitte geben Sie eine gültige E-Mail-Adresse ein.";
const emailSendForResetting$k = "Es wurde Ihnen eine E-Mail zum Zurücksetzen des Passworts gesendet.";
const VerifyyourEmailID$k = "Bestätigen Sie Ihre E-Mail-Adresse";
const sentPleaseCheckEmail$k = "Gesendet! Bitte überprüfen Sie Ihre E-Mail.";
const tooManyAttemptsTryAgain$k = "Zu viele Versuche, bitte versuchen Sie es später erneut.";
const Resend$k = "Erneut senden";
const Login$k = "Anmeldung";
const weHaveSentVerificationLinkAtEmail$k = "Wir haben Ihnen einen Bestätigungslink an Ihre E-Mail-Adresse gesendet.";
const pleaseVerifyEmailContinueSpam$k = "Bitte bestätigen Sie Ihre E-Mail-Adresse, um fortzufahren. Bitte überprüfen Sie auch den Spam- oder Werbeordner für die Bestätigungs-E-Mail.";
const Logintogetstarted$k = "Melden Sie sich an, um loszulegen.";
const ContinuewithGoogle$k = "Weiter mit Google";
const pleaseInputEmail$k = "Bitte geben Sie Ihre E-Mail-Adresse ein!";
const Password$k = "Passwort";
const pleaseInputPassword$k = "Bitte geben Sie Ihr Passwort ein!";
const passwordLowerUpperDigitSpecial$k = "Ihr Passwort muss mindestens einen Kleinbuchstaben, einen Großbuchstaben, eine Ziffer und ein Sonderzeichen enthalten.";
const atLeastSixChar$k = "Mindestens 6 Zeichen";
const forgotPassword$k = "Passwort vergessen?";
const Bysigninginyouagreetoour$k = "Durch die Anmeldung stimmst du unseren zu.";
const Terms$k = "Bedingungen";
const Conditions$k = "Bedingungen";
const and$k = "und";
const PrivacyPolicy$k = "Datenschutzrichtlinie";
const theseAreTheTopsSkillsExtracted$k = "Dies sind die wichtigsten Fähigkeiten, die aus der Stellenbeschreibung extrahiert wurden.";
const TopSkills$k = "Top-Fähigkeiten";
const weCoulNotExtractSkills$k = "Wir konnten keine Fähigkeiten aus dieser Stellenbeschreibung extrahieren.";
const upgradeToPremiumToView$k = "Upgrade auf Premium, um deine Übereinstimmung der Fähigkeiten im Lebenslauf anzuzeigen.";
const SkillScore$k = "Fähigkeitsbewertung";
const thisIsYourSkillScoreBasedOn$k = "Dies ist Ihre Fähigkeitsbewertung basierend auf der Stellenbeschreibung und Ihrem Lebenslauf.";
const theseSkllsAreStrongMatch$k = "Diese Fähigkeiten stimmen gut mit Ihrem Lebenslauf und der Stellenbeschreibung überein.";
const Strongmatch$k = "Starker Treffer";
const theseSkillsArePartialMatch$k = "Diese Fähigkeiten sind eine teilweise Übereinstimmung zwischen Ihrem Lebenslauf und der Stellenbeschreibung.";
const Partialmatch$k = "Teilweise Übereinstimmung";
const theseSkillsAreMissingFrom$k = "Diese Schlüsselwörter fehlen in Ihrem Lebenslauf, sind jedoch in der Stellenbeschreibung vorhanden. Es handelt sich möglicherweise um Fähigkeiten oder allgemeine Schlüsselwörter, die spezifisch für die Stellenmöglichkeit sind und Ihrem Lebenslauf hinzugefügt werden können.";
const SkillMatchComponent$k = {
	removeSkill: "Was ist Ihr Hauptgrund für die Meldung eines Problems für das Schlüsselwort"
};
const Optional$k = "Optional";
const Notrelevanttothejob$k = "Nicht relevant für den Job";
const Notaskill$k = "Keine Fähigkeit";
const Toogeneric$k = "Zu allgemein";
const Pleaseshareanyfeedback$k = "Bitte teilen Sie uns Ihr Feedback mit";
const excludedKeywordsWillNot$k = "Ausgeschlossene Schlüsselwörter werden bei allen zukünftigen Scans nicht mehr in Ihre Übereinstimmungspunktzahl einbezogen. Sie können ausgeschlossene Schlüsselwörter in Ihrem Profil ändern.";
const yesExcludeThisSkillFrom$k = "Ja, schließe diese Fähigkeit von allen meinen Lebenslauf-Scans aus.";
const PartialMatch$k = "Teiltreffer";
const MissingKeywords$k = "Fehlende Schlüsselwörter";
const Providetitletotask$k = "Geben Sie der Aufgabe einen Titel";
const TasksList$k = "Aufgabenliste";
const AddTask$k = "Aufgabe hinzufügen";
const EnterTaskTitlehere$k = "Geben Sie hier den Aufgabentitel ein";
const TasksComponent$k = {
	listEmpty: "Aufgabenliste leer, Neue erstellen."
};
const CompletedTasks$k = "Abgeschlossene Aufgaben";
const CompleteYourtasks$k = "Vervollständige deine Aufgaben";
const Steps$k = "Schritte";
const PremiumMember$k = "Premium-Mitglied";
const Thankyouforupgradingto$k = "Vielen Dank für das Upgrade auf";
const CareerflowPremium$k = "Karrierefluss Premium";
const hereIsHowYouCanAccessPremium$k = "So greifen Sie auf Ihre Premium-Vorteile zu!";
const stepOne$k = "Schritt 1";
const DownloadourChromeExtension$k = "Laden Sie unsere Chrome-Erweiterung herunter";
const youJobSearchCopilotIshere$k = "Ihr Job-Such-Kopilot mit künstlicher Intelligenz ist hier.";
const DownloadNow$k = "Jetzt herunterladen";
const stepTwo$k = "Schritt 2";
const GetStarted$k = "Los geht's";
const stepThree$k = "Schritt 3";
const SignintoChromeExtension$k = "Anmeldung bei der Chrome-Erweiterung";
const entityCreated$k = "Neues {{entity}} erstellt";
const entityUpdated$k = "{{entity}} aktualisiert";
const entityDeleted$k = "{{entity}} gelöscht";
const entityLinked$k = "{{entity}} verknüpft";
const entityUnlinked$k = "{{entity}} wurde entkoppelt.";
const entityMovedTo$k = "Umgezogen nach {{entity}}";
const youAddedANewEntity$k = "Sie haben eine neue {{entity}} hinzugefügt.";
const personCreated$k = "{{creator}} hat eine {{entity}} für {{owner}} erstellt.";
const youUpdatedAEntity$k = "Sie haben eine {{entity}} aktualisiert.";
const personUpdated$k = "{{creator}} hat eine {{entity}} für {{owner}} aktualisiert.";
const youDeletedAEntity$k = "Du hast eine {{entity}} gelöscht.";
const personDeleted$k = "{{creator}} hat eine {{entity}} für {{owner}} gelöscht.";
const youLinkedEntity$k = "Du hast eine {{entity}} mit diesem Job verknüpft.";
const personLinked$k = "{{creator}} hat eine {{entity}} für {{owner}} mit diesem Job verknüpft.";
const youUnlinked$k = "Du hast eine {{entity}} von diesem Job entfernt.";
const personUnlinked$k = "{{creator}} hat eine {{entity}} von diesem Job für {{owner}} entfernt.";
const youMovedEntity$k = "Du hast diese {{entity}} von {{sectionFrom}} nach {{sectionTo}} verschoben.";
const personMoved$k = "{{creator}} hat dieses {{entity}} von {{sectionFrom}} nach {{sectionTo}} für {{owner}} verschoben.";
const addedByName$k = "Hinzugefügt von {{name}}";
const DownloadChromeExtension$k = "Lade die Chrome-Erweiterung herunter";
const ourChromeExtensionIs$k = "Unsere Chrome-Erweiterung ist ein integriertes Werkzeug, um Ihnen bei der Optimierung Ihres LinkedIn-Profils, dem Speichern von Jobs, Kontakten, der Erstellung von Anschreiben und mehr zu helfen.";
const Optimizeyourprofile$k = "Optimiere dein Profil";
const startOptimizingYourProfile$k = "Beginnen Sie damit, Ihr Profil zu optimieren, um bessere Chancen zu haben, von Personalvermittlern kontaktiert zu werden.";
const OptimizeNow$k = "Jetzt optimieren";
const Addyourfirstjob$k = "Fügen Sie Ihren ersten Job hinzu";
const startSavingJobApplicationsToTrack$k = "Beginnen Sie damit, Bewerbungen zu speichern, um Ihren Job-Suchprozess zu verfolgen und nützliche Erkenntnisse zu gewinnen.";
const AddNow$k = "Hinzufügen";
const CompleteProfile$k = "Vollständiges Profil";
const completeYourProfileForUsing$k = "Vervollständigen Sie Ihr Profil, um die Auto-Fill-Funktion zu nutzen und eine persönlichere Erfahrung zu erhalten.";
const CompleteNow$k = "Jetzt abschließen";
const Addyourfirstcontact$k = "Fügen Sie Ihren ersten Kontakt hinzu";
const addContactToFollowUpWith$k = "Fügen Sie den Kontakt hinzu, um später mit ihnen in Kontakt zu treten, fügen Sie Notizen hinzu und vieles mehr.";
const JoinCommunity$k = "Trete der Gemeinschaft bei";
const ourCommunityisAlways$k = "Unsere Gemeinschaft ist immer bei dir auf deiner Jobsuche-Reise dabei.";
const JoinNow$k = "Jetzt beitreten";
const welcomeToCareerflow$k = "Willkommen bei Careerflow!";
const yourHubForCareerInsights2$k = "Dies ist Ihr zentraler Ort für Karriere-Einblicke, Aktivitäten und mehr. Erkunden Sie Ihr personalisiertes Dashboard, um auf Ihrer beruflichen Reise auf dem Laufenden zu bleiben.";
const ChecklistCompleted$k = "Ihre Checkliste ist abgeschlossen!";
const Completeyourchecklist$k = "Vervollständige deine Checkliste";
const completeAFewStepsTo$k = "Führen Sie einige Schritte aus, um Ihren nächsten Job zu finden.";
const Completed$k = "Abgeschlossen";
const JobCountByStage$k = "Anzahl der Stellen nach Stufe";
const NopastapplicationDatafound$k = "Keine vergangenen Anwendungsdaten gefunden";
const YourJobSearchStages$k = "Ihre Phasen der Jobsuche";
const NoDatafound$k = "Keine Daten gefunden";
const de = {
	copyToClipboard: copyToClipboard$k,
	UnlocktheAIgenerated: UnlocktheAIgenerated$k,
	UpgradetoPremium: UpgradetoPremium$k,
	Result: Result$k,
	Copy: Copy$k,
	Save: Save$k,
	Edit: Edit$k,
	Processing: Processing$k,
	YourAIgeneratedcontentwillshowhere: YourAIgeneratedcontentwillshowhere$k,
	hopeYouFindUseful: hopeYouFindUseful$k,
	regenerate: regenerate$k,
	ProvideAdditionalFeedback: ProvideAdditionalFeedback$k,
	Enteranyfeedback: Enteranyfeedback$k,
	Notimpressive: Notimpressive$k,
	thisIsntTrue: thisIsntTrue$k,
	Notpersonalized: Notpersonalized$k,
	Tone: Tone$k,
	Length: Length$k,
	Template: Template$k,
	Generatedon: Generatedon$k,
	Copiedtoclipboard: Copiedtoclipboard$k,
	CopytoClipboard: CopytoClipboard$k,
	DownloadasPDF: DownloadasPDF$k,
	ViewDetails: ViewDetails$k,
	JobDescriptionImported: JobDescriptionImported$k,
	ImportfromJob: ImportfromJob$k,
	Saved: Saved$k,
	Applied: Applied$k,
	Offer: Offer$k,
	Interviewing: Interviewing$k,
	Rejected: Rejected$k,
	Search: Search$k,
	Import: Import$k,
	CoverLetterGeneratorHistory: CoverLetterGeneratorHistory$k,
	NoCoverLettersGenerated: NoCoverLettersGenerated$k,
	getStartedCoverLetter: getStartedCoverLetter$k,
	getStarted: getStarted$k,
	Documents: Documents$k,
	UploadNewDocument: UploadNewDocument$k,
	AICoverLetterGenerator: AICoverLetterGenerator$k,
	ViewHistory: ViewHistory$k,
	JobDescription: JobDescription$k,
	ImportfromBoard: ImportfromBoard$k,
	EnterJobDescription: EnterJobDescription$k,
	JobTitle: JobTitle$k,
	EnterJobTitle: EnterJobTitle$k,
	CompanyName: CompanyName$k,
	EnterCompanyName: EnterCompanyName$k,
	YourProfile: YourProfile$k,
	ResumeUpload: ResumeUpload$k,
	UseLinkedinProfile: UseLinkedinProfile$k,
	Uploadyourresume: Uploadyourresume$k,
	AddyourResume: AddyourResume$k,
	fileNameCannotFormat: fileNameCannotFormat$k,
	ChooseorUpload: ChooseorUpload$k,
	SelectTemplate: SelectTemplate$k,
	Preview: Preview$k,
	UseTemplate: UseTemplate$k,
	Change: Change$k,
	AdvancedSettings: AdvancedSettings$k,
	AdditionalContext: AdditionalContext$k,
	Professional: Professional$k,
	Casual: Casual$k,
	Enthusiastic: Enthusiastic$k,
	Informational: Informational$k,
	Short: Short$k,
	Medium: Medium$k,
	Long: Long$k,
	Language: Language$k,
	iAmOkayBack: iAmOkayBack$k,
	Generate: Generate$k,
	CoverLetter: CoverLetter$k,
	SelectLanguage: SelectLanguage$k,
	AboutGeneratorHistory: AboutGeneratorHistory$k,
	NoAboutsGenerated: NoAboutsGenerated$k,
	getStartedAbouts: getStartedAbouts$k,
	noAttachmentsFound: noAttachmentsFound$k,
	TargetJobTitle: TargetJobTitle$k,
	KeywordsToInclude: KeywordsToInclude$k,
	UploadYourResume: UploadYourResume$k,
	AddYourResume: AddYourResume$k,
	LinkedinProfile: LinkedinProfile$k,
	Linkedinprofilenotfound: Linkedinprofilenotfound$k,
	startUsingChromeExtension: startUsingChromeExtension$k,
	Download: Download$k,
	UseEmojis: UseEmojis$k,
	UseBulletPoints: UseBulletPoints$k,
	SpeechFocus: SpeechFocus$k,
	FirstPerson: FirstPerson$k,
	ThirdPerson: ThirdPerson$k,
	HeadlineGeneratorHistory: HeadlineGeneratorHistory$k,
	NoHeadlinesGenerated: NoHeadlinesGenerated$k,
	getStartedHeadline: getStartedHeadline$k,
	AIHeadlineGenerator: AIHeadlineGenerator$k,
	KeywordstoInclude: KeywordstoInclude$k,
	Pressenteraftereachword: Pressenteraftereachword$k,
	LinkedinProfilenotfound: LinkedinProfilenotfound$k,
	Headline: Headline$k,
	PostGeneratorHistory: PostGeneratorHistory$k,
	NoPostsGenerated: NoPostsGenerated$k,
	getStartedPost: getStartedPost$k,
	Topic: Topic$k,
	Description: Description$k,
	UseHashtags: UseHashtags$k,
	Custom: Custom$k,
	EnterCustomTone: EnterCustomTone$k,
	Added: Added$k,
	ComingSoon: ComingSoon$k,
	Company: Company$k,
	JobInterview: JobInterview$k,
	Research: Research$k,
	Networking: Networking$k,
	Referral: Referral$k,
	MustbeContacted: MustbeContacted$k,
	ScheduleaMeeting: ScheduleaMeeting$k,
	needAFollowUp: needAFollowUp$k,
	Today: Today$k,
	Viewdetails: Viewdetails$k,
	Activity: Activity$k,
	ActivityDetails: ActivityDetails$k,
	Delete: Delete$k,
	Title: Title$k,
	Goal: Goal$k,
	Status: Status$k,
	FollowUp: FollowUp$k,
	AddActivity: AddActivity$k,
	Enteractivitytitle: Enteractivitytitle$k,
	Cancel: Cancel$k,
	SaveActivity: SaveActivity$k,
	noActivityPresent: noActivityPresent$k,
	Addnew: Addnew$k,
	About: About$k,
	noDataPresentYou: noDataPresentYou$k,
	Experience: Experience$k,
	Education: Education$k,
	Skills: Skills$k,
	Overview: Overview$k,
	LinkedJobs: LinkedJobs$k,
	Notes: Notes$k,
	FullName: FullName$k,
	Location: Location$k,
	Relationship: Relationship$k,
	Contacts: Contacts$k,
	CreateContact: CreateContact$k,
	NotesCreated: NotesCreated$k,
	Notesupdated: Notesupdated$k,
	Addnote: Addnote$k,
	areYouSureDeleteNote: areYouSureDeleteNote$k,
	Createdby: Createdby$k,
	notSureWhyResumeCalls: notSureWhyResumeCalls$k,
	getExpertResumeReview: getExpertResumeReview$k,
	youHaventAddedContacts: youHaventAddedContacts$k,
	noMatchingContacts: noMatchingContacts$k,
	Link: Link$k,
	unlink: unlink$k,
	Locationnotavailable: Locationnotavailable$k,
	Emailnotavailable: Emailnotavailable$k,
	PhoneNumbernotavailable: PhoneNumbernotavailable$k,
	createdby: createdby$k,
	areYouSureDeleteContact: areYouSureDeleteContact$k,
	areYouSureUnlinkContact: areYouSureUnlinkContact$k,
	Addedbyyou: Addedbyyou$k,
	Addedby: Addedby$k,
	Timeline: Timeline$k,
	Timelineempty: Timelineempty$k,
	Discard: Discard$k,
	SaveContact: SaveContact$k,
	Recruiter: Recruiter$k,
	Candidate: Candidate$k,
	Colleague: Colleague$k,
	Employee: Employee$k,
	"Needtofollow-up": "Muss nachverfolgt werden",
	EnterValidEmail: EnterValidEmail$k,
	EnterValidPhoneNumber: EnterValidPhoneNumber$k,
	editingProfileNotAvailable: editingProfileNotAvailable$k,
	itWillBeSoonAvailable: itWillBeSoonAvailable$k,
	ChromeExtension: ChromeExtension$k,
	SelectTag: SelectTag$k,
	FirstName: FirstName$k,
	FirstNameisrequired: FirstNameisrequired$k,
	LastName: LastName$k,
	LastNameisrequired: LastNameisrequired$k,
	Companyisrequired: Companyisrequired$k,
	Email: Email$k,
	ThisisnotavalidEmail: ThisisnotavalidEmail$k,
	AddEmail: AddEmail$k,
	PhoneNumber: PhoneNumber$k,
	notaValidPhone: notaValidPhone$k,
	phoneNoMinimum5char: phoneNoMinimum5char$k,
	phoneNoMinumum15char: phoneNoMinumum15char$k,
	AddPhoneNumber: AddPhoneNumber$k,
	SelectGoal: SelectGoal$k,
	SelectStatus: SelectStatus$k,
	Followup: Followup$k,
	SocialMedia: SocialMedia$k,
	Linkedinhandle: Linkedinhandle$k,
	Twitterhandle: Twitterhandle$k,
	Facebookhandle: Facebookhandle$k,
	Githubhandle: Githubhandle$k,
	Gmailhandle: Gmailhandle$k,
	Changessavedsuccessfully: Changessavedsuccessfully$k,
	EditContact: EditContact$k,
	BasicInformation: BasicInformation$k,
	EditContactDetails: EditContactDetails$k,
	SaveChanges: SaveChanges$k,
	phoneNoMinimum14char: phoneNoMinimum14char$k,
	LinkedIn: LinkedIn$k,
	Twitter: Twitter$k,
	Facebook: Facebook$k,
	Github: Github$k,
	Gmail: Gmail$k,
	youCanWriteAbout: youCanWriteAbout$k,
	Addednewsection: Addednewsection$k,
	Removedsuccessfully: Removedsuccessfully$k,
	Remove: Remove$k,
	Institute: Institute$k,
	Schoolisrequired: Schoolisrequired$k,
	Degree: Degree$k,
	StartMonth: StartMonth$k,
	StartYear: StartYear$k,
	EndMonth: EndMonth$k,
	EndYear: EndYear$k,
	Addmore: Addmore$k,
	PositionTitle: PositionTitle$k,
	ExperienceType: ExperienceType$k,
	Addednewitem: Addednewitem$k,
	whatSkillsDoYouEnjoy: whatSkillsDoYouEnjoy$k,
	Typeskillshere: Typeskillshere$k,
	LinkedContacts: LinkedContacts$k,
	LinkContact: LinkContact$k,
	NocontactsLinked: NocontactsLinked$k,
	JobContactsComponent: JobContactsComponent$k,
	Nocontacts: Nocontacts$k,
	LinkJobto: LinkJobto$k,
	Contact: Contact$k,
	Document: Document$k,
	Nojobsfound: Nojobsfound$k,
	LinkJob: LinkJob$k,
	youCanLinkContactJobImported: youCanLinkContactJobImported$k,
	Prev: Prev$k,
	Next: Next$k,
	areYouSureUnlinkDocument: areYouSureUnlinkDocument$k,
	areYouSureDeleteDocument: areYouSureDeleteDocument$k,
	Category: Category$k,
	CreatedOn: CreatedOn$k,
	Joblinked: Joblinked$k,
	Quickactions: Quickactions$k,
	All: All$k,
	Resume: Resume$k,
	Portfolio: Portfolio$k,
	Other: Other$k,
	Adddocument: Adddocument$k,
	Type: Type$k,
	Sortingby: Sortingby$k,
	SwitchtoGridLayout: SwitchtoGridLayout$k,
	SwitchtoListLayout: SwitchtoListLayout$k,
	NoDocumentsAdded: NoDocumentsAdded$k,
	DocumentsComponent: DocumentsComponent$k,
	NoDocumentFound: NoDocumentFound$k,
	SelectFile: SelectFile$k,
	onlyPdfDocxSupported: onlyPdfDocxSupported$k,
	Uploadfile: Uploadfile$k,
	DocumentCategory: DocumentCategory$k,
	SaveDocument: SaveDocument$k,
	AddDocument: AddDocument$k,
	LinkedDocuments: LinkedDocuments$k,
	LinkDocument: LinkDocument$k,
	NodocumentsLinked: NodocumentsLinked$k,
	JobDocumentsComponent: JobDocumentsComponent$k,
	NoDocuments: NoDocuments$k,
	CreateDocuments: CreateDocuments$k,
	youCanLinkDocumentJobImported: youCanLinkDocumentJobImported$k,
	Documenteditedsuccessfully: Documenteditedsuccessfully$k,
	DocumentDetails: DocumentDetails$k,
	UnsavedChanges: UnsavedChanges$k,
	yourChangesWillBeLostSureClose: yourChangesWillBeLostSureClose$k,
	yourChangesWillBeLostSureDiscard: yourChangesWillBeLostSureDiscard$k,
	DiscardChanges: DiscardChanges$k,
	WeeklyGoalAlert: WeeklyGoalAlert$k,
	Progress: Progress$k,
	AllGoals: AllGoals$k,
	Name: Name$k,
	Completedon: Completedon$k,
	Createdon: Createdon$k,
	Action: Action$k,
	Back: Back$k,
	OverallScore: OverallScore$k,
	Aboutthegoal: Aboutthegoal$k,
	GoalTracking: GoalTracking$k,
	Week: Week$k,
	progress: progress$k,
	loading: loading$k,
	Apply: Apply$k,
	Thisskillhasbeenreported: Thisskillhasbeenreported$k,
	issueGettingResume: issueGettingResume$k,
	Interview: Interview$k,
	Tasks: Tasks$k,
	Loading: Loading$k,
	Skilladdedsuccessfully: Skilladdedsuccessfully$k,
	problemAddingSkill: problemAddingSkill$k,
	Reportaproblem: Reportaproblem$k,
	Submit: Submit$k,
	Addanewskill: Addanewskill$k,
	JobDetailsComponent: JobDetailsComponent$k,
	HardSkill: HardSkill$k,
	SoftSkill: SoftSkill$k,
	Pleaseshareanyadditionalcontext: Pleaseshareanyadditionalcontext$k,
	Addasskill: Addasskill$k,
	Skill: Skill$k,
	JobFrequency: JobFrequency$k,
	ResumeFrequency: ResumeFrequency$k,
	Reportskill: Reportskill$k,
	JobDetails: JobDetails$k,
	ViewJobLink: ViewJobLink$k,
	Salary: Salary$k,
	areYouSureDeleteJob: areYouSureDeleteJob$k,
	ViewMore: ViewMore$k,
	ViewLess: ViewLess$k,
	matchYouSkillsAgainstJob: matchYouSkillsAgainstJob$k,
	pleaseUploadResumeSkillMatch: pleaseUploadResumeSkillMatch$k,
	AddResume: AddResume$k,
	thisJobDoesNotHaveAnyDesc: thisJobDoesNotHaveAnyDesc$k,
	youCanEditJobToAdd: youCanEditJobToAdd$k,
	chromeextension: chromeextension$k,
	fromVariousJobPortalsOnce: fromVariousJobPortalsOnce$k,
	AddDescription: AddDescription$k,
	CompanyInfo: CompanyInfo$k,
	Website: Website$k,
	Industry: Industry$k,
	EmployeeCount: EmployeeCount$k,
	ExprienceLevel: ExprienceLevel$k,
	Address: Address$k,
	Resumes: Resumes$k,
	Setasdefault: Setasdefault$k,
	Ok: Ok$k,
	UploadNewResume: UploadNewResume$k,
	Default: Default$k,
	Jobnotfound: Jobnotfound$k,
	EditDetails: EditDetails$k,
	JobPostURL: JobPostURL$k,
	Enterjoburl: Enterjoburl$k,
	Nojobselected: Nojobselected$k,
	Viewjobdetails: Viewjobdetails$k,
	Jobaddedtoyourboardsuccessfully: Jobaddedtoyourboardsuccessfully$k,
	AddJob: AddJob$k,
	Addnewjobname: Addnewjobname$k,
	JobUrl: JobUrl$k,
	Addjoburl: Addjoburl$k,
	Section: Section$k,
	didYouKnow: didYouKnow$k,
	Jobs: Jobs$k,
	AddJobtoboard: AddJobtoboard$k,
	Currentlynojobsareavailable: Currentlynojobsareavailable$k,
	noMatchingJobs: noMatchingJobs$k,
	welcomeToYourPersonalJobTracker: welcomeToYourPersonalJobTracker$k,
	weShortTutorialOnHowTrackingJob: weShortTutorialOnHowTrackingJob$k,
	Addanewjob: Addanewjob$k,
	inOrderTrackCreatButton: inOrderTrackCreatButton$k,
	Providesomedetails: Providesomedetails$k,
	toBeginTypeJobTitleCompany: toBeginTypeJobTitleCompany$k,
	asAnExampleFilledForYou: asAnExampleFilledForYou$k,
	wohooAddedFirstJob: wohooAddedFirstJob$k,
	youCanDragDropJobCard: youCanDragDropJobCard$k,
	Lastbutnotleast: Lastbutnotleast$k,
	finalStepMakeSure: finalStepMakeSure$k,
	autoMaticallyImportJobs: autoMaticallyImportJobs$k,
	selectanysection: selectanysection$k,
	Accept: Accept$k,
	My2023JobSearch: My2023JobSearch$k,
	AddedFrom: AddedFrom$k,
	AddedUntil: AddedUntil$k,
	BasicModal: BasicModal$k,
	AddnewSectionName: AddnewSectionName$k,
	OpenTo: OpenTo$k,
	Featured: Featured$k,
	LicenceAndCerts: LicenceAndCerts$k,
	Banner: Banner$k,
	LinkedInURL: LinkedInURL$k,
	Recommendations: Recommendations$k,
	LinkedinReview: LinkedinReview$k,
	NoDataAvailable: NoDataAvailable$k,
	looksLikeYouDidNot: looksLikeYouDidNot$k,
	toOptimizeProfileScoreVisible: toOptimizeProfileScoreVisible$k,
	LinkedinComponent: LinkedinComponent$k,
	improveYourChancesLandingDreamJob: improveYourChancesLandingDreamJob$k,
	VisitProfile: VisitProfile$k,
	wantToGetLinkedinMakeover: wantToGetLinkedinMakeover$k,
	PostGenerator: PostGenerator$k,
	LinkedinHeadlineGenerator: LinkedinHeadlineGenerator$k,
	LinkedinAboutSectionGenerator: LinkedinAboutSectionGenerator$k,
	AITools: AITools$k,
	Premium: Premium$k,
	LinkedInOptimization: LinkedInOptimization$k,
	JobTracker: JobTracker$k,
	whoIsHiring: whoIsHiring$k,
	Autofill: Autofill$k,
	HeadlineGenerator: HeadlineGenerator$k,
	skillMatching: skillMatching$k,
	SummarizeJD: SummarizeJD$k,
	contactFeature: contactFeature$k,
	documentFeature: documentFeature$k,
	landJobWithoutStress: landJobWithoutStress$k,
	discoverFeatures: discoverFeatures$k,
	letsBeginOnboarding: letsBeginOnboarding$k,
	inTheNextFewScreensJobThirdParties: inTheNextFewScreensJobThirdParties$k,
	letsAddBasicInformation: letsAddBasicInformation$k,
	Pleaseselectanoptionfirst: Pleaseselectanoptionfirst$k,
	JobApplicationTracker: JobApplicationTracker$k,
	LinkedInProfileOptimizer: LinkedInProfileOptimizer$k,
	UnlimitedDocuments: UnlimitedDocuments$k,
	UnlimitedContacts: UnlimitedContacts$k,
	HiringManagerSearch: HiringManagerSearch$k,
	AILinkedInPostGenerator: AILinkedInPostGenerator$k,
	ATSKeywordSkillMatch: ATSKeywordSkillMatch$k,
	"Auto-Apply": "Automatische Anwendung",
	ChooseyourPlan: ChooseyourPlan$k,
	superChargeYourJobSearch: superChargeYourJobSearch$k,
	startNowGoto: startNowGoto$k,
	CreatedBy: CreatedBy$k,
	CreateNewNote: CreateNewNote$k,
	Nonotescreated: Nonotescreated$k,
	approxTimeIsFourMinutes: approxTimeIsFourMinutes$k,
	Continue: Continue$k,
	iWillDoLaterTakeMeToApp: iWillDoLaterTakeMeToApp$k,
	allDone: allDone$k,
	welcomeAbord: welcomeAbord$k,
	letsBegin: letsBegin$k,
	UpgradeyourplanandgetAIAssistance: UpgradeyourplanandgetAIAssistance$k,
	DownloadPDF: DownloadPDF$k,
	oopsWeCouldntProcessResume: oopsWeCouldntProcessResume$k,
	MyProfile: MyProfile$k,
	Setting: Setting$k,
	Logout: Logout$k,
	SignIn: SignIn$k,
	Typeyourfirstnamehere: Typeyourfirstnamehere$k,
	Enteryourlastname: Enteryourlastname$k,
	ManageSubscription: ManageSubscription$k,
	ifYouHaveDifficultiesProfile: ifYouHaveDifficultiesProfile$k,
	forSupport: forSupport$k,
	whatIsIdealCompanySize: whatIsIdealCompanySize$k,
	Saveandcontinue: Saveandcontinue$k,
	whatIsMinExpectedSalary: whatIsMinExpectedSalary$k,
	Atleast: Atleast$k,
	SlidetoAdjust: SlidetoAdjust$k,
	whatIndustryExcitedWork: whatIndustryExcitedWork$k,
	Add: Add$k,
	statusOfJobSearch: statusOfJobSearch$k,
	Finish: Finish$k,
	whatLevelRoleLooking: whatLevelRoleLooking$k,
	Selectuptotwo: Selectuptotwo$k,
	PreviousStep: PreviousStep$k,
	Skip: Skip$k,
	whatDoYouValueNewRole: whatDoYouValueNewRole$k,
	Selectuptothree: Selectuptothree$k,
	EqualEmploymentData: EqualEmploymentData$k,
	whatIsYourEthnicity: whatIsYourEthnicity$k,
	areYouAuthorizedToWorkUs: areYouAuthorizedToWorkUs$k,
	willYouRequireSponsorShip: willYouRequireSponsorShip$k,
	doYouHaveADisability: doYouHaveADisability$k,
	areYouAVeteran: areYouAVeteran$k,
	rolesYouInterestedIn: rolesYouInterestedIn$k,
	Selectuptofive: Selectuptofive$k,
	AddCustomrole: AddCustomrole$k,
	whereDoYouLikeWork: whereDoYouLikeWork$k,
	Resources: Resources$k,
	currentlyNoResourceAvailable: currentlyNoResourceAvailable$k,
	AddNewSection: AddNewSection$k,
	ChangeSections: ChangeSections$k,
	Settings: Settings$k,
	Dashboard: Dashboard$k,
	JobBoard: JobBoard$k,
	Linkedin: Linkedin$k,
	Community: Community$k,
	FindRecruiters: FindRecruiters$k,
	Goals: Goals$k,
	DownloadExtension: DownloadExtension$k,
	SuggestaFeature: SuggestaFeature$k,
	leftPanel: leftPanel$k,
	PhoneNumberisrequired: PhoneNumberisrequired$k,
	MobileNumber: MobileNumber$k,
	Enteronlynumbers: Enteronlynumbers$k,
	Countryyoulivein: Countryyoulivein$k,
	SelectaCountry: SelectaCountry$k,
	DateofBirth: DateofBirth$k,
	Gender: Gender$k,
	JobPreferences: JobPreferences$k,
	pleaseEnterValidEmail: pleaseEnterValidEmail$k,
	emailSendForResetting: emailSendForResetting$k,
	VerifyyourEmailID: VerifyyourEmailID$k,
	sentPleaseCheckEmail: sentPleaseCheckEmail$k,
	tooManyAttemptsTryAgain: tooManyAttemptsTryAgain$k,
	Resend: Resend$k,
	Login: Login$k,
	weHaveSentVerificationLinkAtEmail: weHaveSentVerificationLinkAtEmail$k,
	pleaseVerifyEmailContinueSpam: pleaseVerifyEmailContinueSpam$k,
	Logintogetstarted: Logintogetstarted$k,
	ContinuewithGoogle: ContinuewithGoogle$k,
	pleaseInputEmail: pleaseInputEmail$k,
	Password: Password$k,
	pleaseInputPassword: pleaseInputPassword$k,
	passwordLowerUpperDigitSpecial: passwordLowerUpperDigitSpecial$k,
	atLeastSixChar: atLeastSixChar$k,
	forgotPassword: forgotPassword$k,
	Bysigninginyouagreetoour: Bysigninginyouagreetoour$k,
	Terms: Terms$k,
	Conditions: Conditions$k,
	and: and$k,
	PrivacyPolicy: PrivacyPolicy$k,
	theseAreTheTopsSkillsExtracted: theseAreTheTopsSkillsExtracted$k,
	TopSkills: TopSkills$k,
	weCoulNotExtractSkills: weCoulNotExtractSkills$k,
	upgradeToPremiumToView: upgradeToPremiumToView$k,
	SkillScore: SkillScore$k,
	thisIsYourSkillScoreBasedOn: thisIsYourSkillScoreBasedOn$k,
	theseSkllsAreStrongMatch: theseSkllsAreStrongMatch$k,
	Strongmatch: Strongmatch$k,
	theseSkillsArePartialMatch: theseSkillsArePartialMatch$k,
	Partialmatch: Partialmatch$k,
	theseSkillsAreMissingFrom: theseSkillsAreMissingFrom$k,
	"Missing Keywords": "Fehlende Schlüsselwörter",
	SkillMatchComponent: SkillMatchComponent$k,
	Optional: Optional$k,
	Notrelevanttothejob: Notrelevanttothejob$k,
	Notaskill: Notaskill$k,
	Toogeneric: Toogeneric$k,
	Pleaseshareanyfeedback: Pleaseshareanyfeedback$k,
	excludedKeywordsWillNot: excludedKeywordsWillNot$k,
	yesExcludeThisSkillFrom: yesExcludeThisSkillFrom$k,
	PartialMatch: PartialMatch$k,
	MissingKeywords: MissingKeywords$k,
	Providetitletotask: Providetitletotask$k,
	TasksList: TasksList$k,
	AddTask: AddTask$k,
	EnterTaskTitlehere: EnterTaskTitlehere$k,
	TasksComponent: TasksComponent$k,
	CompletedTasks: CompletedTasks$k,
	CompleteYourtasks: CompleteYourtasks$k,
	Steps: Steps$k,
	PremiumMember: PremiumMember$k,
	Thankyouforupgradingto: Thankyouforupgradingto$k,
	CareerflowPremium: CareerflowPremium$k,
	hereIsHowYouCanAccessPremium: hereIsHowYouCanAccessPremium$k,
	stepOne: stepOne$k,
	DownloadourChromeExtension: DownloadourChromeExtension$k,
	youJobSearchCopilotIshere: youJobSearchCopilotIshere$k,
	DownloadNow: DownloadNow$k,
	stepTwo: stepTwo$k,
	GetStarted: GetStarted$k,
	stepThree: stepThree$k,
	SignintoChromeExtension: SignintoChromeExtension$k,
	entityCreated: entityCreated$k,
	entityUpdated: entityUpdated$k,
	entityDeleted: entityDeleted$k,
	entityLinked: entityLinked$k,
	entityUnlinked: entityUnlinked$k,
	entityMovedTo: entityMovedTo$k,
	youAddedANewEntity: youAddedANewEntity$k,
	personCreated: personCreated$k,
	youUpdatedAEntity: youUpdatedAEntity$k,
	personUpdated: personUpdated$k,
	youDeletedAEntity: youDeletedAEntity$k,
	personDeleted: personDeleted$k,
	youLinkedEntity: youLinkedEntity$k,
	personLinked: personLinked$k,
	youUnlinked: youUnlinked$k,
	personUnlinked: personUnlinked$k,
	youMovedEntity: youMovedEntity$k,
	personMoved: personMoved$k,
	addedByName: addedByName$k,
	DownloadChromeExtension: DownloadChromeExtension$k,
	ourChromeExtensionIs: ourChromeExtensionIs$k,
	Optimizeyourprofile: Optimizeyourprofile$k,
	startOptimizingYourProfile: startOptimizingYourProfile$k,
	OptimizeNow: OptimizeNow$k,
	Addyourfirstjob: Addyourfirstjob$k,
	startSavingJobApplicationsToTrack: startSavingJobApplicationsToTrack$k,
	AddNow: AddNow$k,
	CompleteProfile: CompleteProfile$k,
	completeYourProfileForUsing: completeYourProfileForUsing$k,
	CompleteNow: CompleteNow$k,
	Addyourfirstcontact: Addyourfirstcontact$k,
	addContactToFollowUpWith: addContactToFollowUpWith$k,
	JoinCommunity: JoinCommunity$k,
	ourCommunityisAlways: ourCommunityisAlways$k,
	JoinNow: JoinNow$k,
	welcomeToCareerflow: welcomeToCareerflow$k,
	yourHubForCareerInsights2: yourHubForCareerInsights2$k,
	ChecklistCompleted: ChecklistCompleted$k,
	Completeyourchecklist: Completeyourchecklist$k,
	completeAFewStepsTo: completeAFewStepsTo$k,
	Completed: Completed$k,
	JobCountByStage: JobCountByStage$k,
	NopastapplicationDatafound: NopastapplicationDatafound$k,
	YourJobSearchStages: YourJobSearchStages$k,
	NoDatafound: NoDatafound$k
};

const copyToClipboard$j = "¡Copiado al portapapeles!";
const UnlocktheAIgenerated$j = "Desbloquea lo generado por IA";
const UpgradetoPremium$j = "Actualice a Premium";
const Result$j = "Resultado";
const Copy$j = "Copiar";
const Save$j = "Guardar";
const Edit$j = "Editar";
const Processing$j = "Procesando";
const YourAIgeneratedcontentwillshowhere$j = "Tu contenido generado por inteligencia artificial se mostrará aquí";
const hopeYouFindUseful$j = "¡Espero que encuentres este resultado útil!";
const regenerate$j = "Re-generar";
const ProvideAdditionalFeedback$j = "Proporcionar Retroalimentación Adicional";
const Enteranyfeedback$j = "Ingrese cualquier retroalimentación";
const Notimpressive$j = "No impresionante";
const thisIsntTrue$j = "Esto no es cierto";
const Notpersonalized$j = "No personalizado";
const Tone$j = "Tono";
const Length$j = "Longitud";
const Template$j = "Plantilla";
const Generatedon$j = "Generado el";
const Copiedtoclipboard$j = "Copiado al portapapeles";
const CopytoClipboard$j = "Copiar al Portapapeles";
const DownloadasPDF$j = "Descargar como PDF";
const ViewDetails$j = "Ver Detalles";
const JobDescriptionImported$j = "Descripción del trabajo importada";
const ImportfromJob$j = "Importar desde trabajo";
const Saved$j = "Guardado";
const Applied$j = "Aplicado";
const Offer$j = "Oferta";
const Interviewing$j = "Entrevistando";
const Rejected$j = "Rechazado";
const Search$j = "Buscar";
const Import$j = "Importar";
const CoverLetterGeneratorHistory$j = "Historial del Generador de Cartas de Presentación";
const NoCoverLettersGenerated$j = "No se generaron cartas de presentación";
const getStartedCoverLetter$j = "Aún no has generado ninguna carta de presentación. Comienza y obtén cartas de presentación al igualar la descripción del trabajo con tu experiencia relevante.";
const getStarted$j = "¡Comenzar!";
const Documents$j = "Documentos";
const UploadNewDocument$j = "Subir Nuevo Documento";
const AICoverLetterGenerator$j = "Generador de Cartas de Presentación con IA";
const ViewHistory$j = "Ver Historial";
const JobDescription$j = "Descripción del Trabajo";
const ImportfromBoard$j = "Importar desde el Tablero";
const EnterJobDescription$j = "Ingresar Descripción del Trabajo";
const JobTitle$j = "Título del Trabajo";
const EnterJobTitle$j = "Ingresar Título del Trabajo";
const CompanyName$j = "Nombre de la Empresa";
const EnterCompanyName$j = "Ingresar Nombre de la Empresa";
const YourProfile$j = "Tu Perfil";
const ResumeUpload$j = "Cargar Currículum";
const UseLinkedinProfile$j = "Usar Perfil de Linkedin";
const Uploadyourresume$j = "Subir tu currículum";
const AddyourResume$j = "Agregar tu Currículum";
const fileNameCannotFormat$j = "Los nombres de archivo no pueden contener espacios ni guiones bajos y deben estar en formato .doc, .docx o .pdf.";
const ChooseorUpload$j = "Elegir o Subir";
const SelectTemplate$j = "Seleccionar Plantilla";
const Preview$j = "Vista Previa";
const UseTemplate$j = "Usar Plantilla";
const Change$j = "Cambiar";
const AdvancedSettings$j = "Configuración Avanzada";
const AdditionalContext$j = "Contexto Adicional";
const Professional$j = "Profesional";
const Casual$j = "Informal";
const Enthusiastic$j = "Entusiasta";
const Informational$j = "Informativo";
const Short$j = "Corto";
const Medium$j = "Medio";
const Long$j = "Largo";
const Language$j = "Idioma";
const iAmOkayBack$j = "¡Estoy bien! Volver";
const Generate$j = "Generar";
const CoverLetter$j = "Carta de presentación";
const SelectLanguage$j = "Seleccionar Idioma";
const AboutGeneratorHistory$j = "Historial del Generador de Acerca de Mí";
const NoAboutsGenerated$j = "No se generaron descripciones sobre mí";
const getStartedAbouts$j = "Aún no has generado ninguna descripción sobre ti. Comienza y obtén descripciones sobre ti al igualar la descripción del trabajo con tu experiencia relevante.";
const noAttachmentsFound$j = "No se encontraron archivos adjuntos.";
const TargetJobTitle$j = "Título del Trabajo Deseado";
const KeywordsToInclude$j = "Palabras clave a incluir";
const UploadYourResume$j = "Sube tu currículum";
const AddYourResume$j = "Agrega tu currículum";
const LinkedinProfile$j = "Perfil de Linkedin";
const Linkedinprofilenotfound$j = "Perfil de Linkedin no encontrado";
const startUsingChromeExtension$j = "Comienza a optimizar tu perfil de Linkedin usando nuestra extensión de Chrome para utilizar esta opción.";
const Download$j = "Descargar";
const UseEmojis$j = "Usar Emojis";
const UseBulletPoints$j = "Usar Viñetas";
const SpeechFocus$j = "Enfoque del Discurso";
const FirstPerson$j = "Primera Persona";
const ThirdPerson$j = "Tercera Persona";
const HeadlineGeneratorHistory$j = "Historial del Generador de Titulares";
const NoHeadlinesGenerated$j = "No se generaron titulares";
const getStartedHeadline$j = "Aún no has generado ningún titular. Comienza y obtén titulares al igualar la descripción del trabajo con tu experiencia relevante.";
const AIHeadlineGenerator$j = "Generador de Titulares con IA";
const KeywordstoInclude$j = "Palabras Clave para Incluir";
const Pressenteraftereachword$j = "Pulse enter después de cada palabra";
const LinkedinProfilenotfound$j = "Perfil de LinkedIn no encontrado";
const Headline$j = "Titular";
const PostGeneratorHistory$j = "Historial del Generador de Publicaciones";
const NoPostsGenerated$j = "No se generaron publicaciones";
const getStartedPost$j = "Aún no has generado ninguna publicación. Comienza y obtén publicaciones al igualar la descripción del trabajo con tu experiencia relevante.";
const Topic$j = "Tema";
const Description$j = "Descripción";
const UseHashtags$j = "Usar Etiquetas";
const Custom$j = "Personalizado";
const EnterCustomTone$j = "Ingresar Tono Personalizado";
const Added$j = "Añadido";
const ComingSoon$j = {
	header: "¡Ingenieros trabajando!",
	content_1: "Nuestro equipo de ingenieros está trabajando arduamente para poner en marcha esta función pronto",
	content_2: "¿Quieres esta función pronto? Háznoslo saber marcando la casilla a continuación.",
	content_3: "Quiero esta función"
};
const Company$j = "Empresa";
const JobInterview$j = "Entrevista de Trabajo";
const Research$j = "Investigación";
const Networking$j = "Networking";
const Referral$j = "Referencia";
const MustbeContacted$j = "Debe ser Contactado";
const ScheduleaMeeting$j = "Programar una Reunión";
const needAFollowUp$j = "Necesito hacer seguimiento";
const Today$j = "Hoy";
const Viewdetails$j = "Ver detalles";
const Activity$j = "Actividad";
const ActivityDetails$j = "Detalles de la actividad";
const Delete$j = "Eliminar";
const Title$j = "Título";
const Goal$j = "Meta";
const Status$j = "Estado";
const FollowUp$j = "Seguimiento";
const AddActivity$j = "Agregar actividad";
const Enteractivitytitle$j = "Ingrese el título de la actividad";
const Cancel$j = "Cancelar";
const SaveActivity$j = "Guardar actividad";
const noActivityPresent$j = "No hay actividad presente, añadir actividad.";
const Addnew$j = "Agregar nuevo";
const About$j = "Acerca de";
const noDataPresentYou$j = "No hay datos presentes, puedes editar este contacto y agregar campos.";
const Experience$j = "Experiencia";
const Education$j = "Educación";
const Skills$j = "Habilidades";
const Overview$j = "Resumen";
const LinkedJobs$j = "Trabajos vinculados";
const Notes$j = "Notas";
const FullName$j = "Nombre completo";
const Location$j = "Ubicación";
const Relationship$j = "Relación";
const Contacts$j = "Contactos";
const CreateContact$j = "Crear contacto";
const NotesCreated$j = "Notas creadas";
const Notesupdated$j = "Notas actualizadas";
const Addnote$j = "Agregar nota";
const areYouSureDeleteNote$j = "¿Estás seguro de que quieres eliminar esta nota?";
const Createdby$j = "Creado por";
const notSureWhyResumeCalls$j = "¿No estás seguro de por qué tu currículum no te está generando llamadas para entrevistas? ☎️";
const getExpertResumeReview$j = "Obtén una revisión experta de tu currículum 💎✨";
const youHaventAddedContacts$j = "Aún no has agregado ningún contacto.";
const noMatchingContacts$j = "No se encontraron contactos coincidentes.";
const Link$j = "Enlace";
const unlink$j = "Desvincular";
const Locationnotavailable$j = "Ubicación no disponible";
const Emailnotavailable$j = "Correo electrónico no disponible";
const PhoneNumbernotavailable$j = "Número de teléfono no disponible";
const createdby$j = "creado por";
const areYouSureDeleteContact$j = "¿Estás seguro de que quieres eliminar este contacto?";
const areYouSureUnlinkContact$j = "¿Estás seguro de que quieres desvincular este contacto?";
const Addedbyyou$j = "Añadido por ti";
const Addedby$j = "Añadido por";
const Timeline$j = "Línea de tiempo";
const Timelineempty$j = "Línea de tiempo vacía";
const Discard$j = "Descartar";
const SaveContact$j = "Guardar contacto";
const Recruiter$j = "Reclutador";
const Candidate$j = "Candidato";
const Colleague$j = "Colega";
const Employee$j = "Empleado";
const EnterValidEmail$j = "Ingrese un correo electrónico válido";
const EnterValidPhoneNumber$j = "Ingrese un número de teléfono válido";
const editingProfileNotAvailable$j = "La edición de la foto de perfil aún no está disponible.";
const itWillBeSoonAvailable$j = "Pronto estará disponible en nuestro";
const ChromeExtension$j = "Extensión de Chrome";
const SelectTag$j = "Etiqueta de selección";
const FirstName$j = "Nombre";
const FirstNameisrequired$j = "El nombre es obligatorio";
const LastName$j = "Apellido";
const LastNameisrequired$j = "El apellido es obligatorio";
const Companyisrequired$j = "Se requiere empresa";
const Email$j = "Correo electrónico";
const ThisisnotavalidEmail$j = "Este no es un correo electrónico válido";
const AddEmail$j = "Agregar correo electrónico";
const PhoneNumber$j = "Número de teléfono";
const notaValidPhone$j = "Este no es un número de teléfono válido. Ingresa solo números.";
const phoneNoMinimum5char$j = "El número de teléfono debe tener un mínimo de 5 caracteres.";
const phoneNoMinumum15char$j = "El número de teléfono debe tener un máximo de 15 caracteres.";
const AddPhoneNumber$j = "Agregar número de teléfono";
const SelectGoal$j = "Seleccionar meta";
const SelectStatus$j = "Seleccionar Estado";
const Followup$j = "Seguimiento";
const SocialMedia$j = "Redes sociales";
const Linkedinhandle$j = "Nombre de usuario de Linkedin";
const Twitterhandle$j = "Nombre de usuario de Twitter";
const Facebookhandle$j = "Nombre de usuario de Facebook";
const Githubhandle$j = "Nombre de usuario de Github";
const Gmailhandle$j = "Nombre de usuario de Gmail";
const Changessavedsuccessfully$j = "Cambios guardados exitosamente";
const EditContact$j = "Editar contacto";
const BasicInformation$j = "Información básica";
const EditContactDetails$j = "Editar detalles de contacto";
const SaveChanges$j = "Guardar cambios";
const phoneNoMinimum14char$j = "El número de teléfono debe tener un mínimo de 14 caracteres.";
const LinkedIn$j = "LinkedIn";
const Twitter$j = "Twitter";
const Facebook$j = "Facebook";
const Github$j = "Github";
const Gmail$j = "Gmail";
const youCanWriteAbout$j = "Puedes escribir sobre tus años de experiencia, industria o habilidades. La gente también habla sobre sus logros o experiencias laborales anteriores.";
const Addednewsection$j = "Añadida nueva sección";
const Removedsuccessfully$j = "Eliminado exitosamente";
const Remove$j = "Eliminar";
const Institute$j = "Instituto";
const Schoolisrequired$j = "La escuela es obligatoria";
const Degree$j = "Grado";
const StartMonth$j = "Mes de inicio";
const StartYear$j = "Año de inicio";
const EndMonth$j = "Fin de mes";
const EndYear$j = "Fin de año";
const Addmore$j = "Agregar más";
const PositionTitle$j = "Título del puesto";
const ExperienceType$j = "Tipo de experiencia";
const Addednewitem$j = "Añadido nuevo elemento";
const whatSkillsDoYouEnjoy$j = "¿Qué habilidades tienes o disfrutas trabajando con ellas?";
const Typeskillshere$j = "Escriba las habilidades aquí";
const LinkedContacts$j = "Contactos vinculados";
const LinkContact$j = "Vincular contacto";
const NocontactsLinked$j = "No hay contactos vinculados";
const JobContactsComponent$j = {
	linkContact: "Al vincular contactos, podrás ver rápidamente quiénes son las personas importantes como el reclutador, el gerente de contratación, etc., para este puesto. En el futuro, podremos ofrecer información relevante basada en tus contactos."
};
const Nocontacts$j = "No hay contactos";
const LinkJobto$j = "Vincular trabajo a";
const Contact$j = "Contacto";
const Document$j = "Documento";
const Nojobsfound$j = "No se encontraron trabajos";
const LinkJob$j = "Vincular trabajo";
const youCanLinkContactJobImported$j = "Puedes vincular este contacto a un trabajo que hayas importado en Careerflow.";
const Prev$j = "Anterior";
const Next$j = "Siguiente";
const areYouSureUnlinkDocument$j = "¿Estás seguro de que quieres desvincular este documento?";
const areYouSureDeleteDocument$j = "¿Estás seguro de que quieres eliminar este documento?";
const Category$j = "Categoría";
const CreatedOn$j = "Creado el";
const Joblinked$j = "Trabajo vinculado";
const Quickactions$j = "Acciones rápidas";
const All$j = "Todo";
const Resume$j = "Currículum";
const Portfolio$j = "Portafolio";
const Other$j = "Otro";
const Adddocument$j = "Agregar documento";
const Type$j = "Tipo";
const Sortingby$j = "Ordenando por";
const SwitchtoGridLayout$j = "Cambiar a diseño de cuadrícula";
const SwitchtoListLayout$j = "Cambiar a diseño de lista";
const NoDocumentsAdded$j = "No se han agregado documentos";
const DocumentsComponent$j = {
	nodocs: "Aún no has creado ningún documento. Puedes cargar versiones de tu currículum, cartas de presentación y más, y vincularlos a los trabajos que estás siguiendo."
};
const NoDocumentFound$j = "No se encontró ningún documento";
const SelectFile$j = "Seleccionar archivo";
const onlyPdfDocxSupported$j = "Solo se admiten archivos .pdf y .docx";
const Uploadfile$j = "Cargar archivo";
const DocumentCategory$j = "Categoría del documento";
const SaveDocument$j = "Guardar documento";
const AddDocument$j = "Agregar documento";
const LinkedDocuments$j = "Documentos vinculados";
const LinkDocument$j = "Vincular documento";
const NodocumentsLinked$j = "No hay documentos vinculados";
const JobDocumentsComponent$j = {
	linkDocs: "Vincular todos tus documentos relevantes como tu currículum, carta de presentación, etc., que has enviado para este trabajo te ayudará a realizar un seguimiento de todo en un solo lugar. ¡Pruébalo!"
};
const NoDocuments$j = "Sin documentos";
const CreateDocuments$j = "Crear documentos";
const youCanLinkDocumentJobImported$j = "Puedes vincular este documento a un trabajo que hayas importado en Careerflow.";
const Documenteditedsuccessfully$j = "Documento editado exitosamente";
const DocumentDetails$j = "Detalles del documento";
const UnsavedChanges$j = "Cambios no guardados";
const yourChangesWillBeLostSureClose$j = "Se perderán tus cambios, ¿estás seguro/a de que quieres cerrar?";
const yourChangesWillBeLostSureDiscard$j = "Se perderán tus cambios, ¿estás seguro/a de que quieres descartarlos?";
const DiscardChanges$j = "Descartar cambios";
const WeeklyGoalAlert$j = "Alerta de objetivo semanal";
const Progress$j = "Progreso";
const AllGoals$j = "Todos los Objetivos";
const Name$j = "Nombre";
const Completedon$j = "Completado el";
const Createdon$j = "Creado el";
const Action$j = "Acción";
const Back$j = "Volver";
const OverallScore$j = "Puntuación general";
const Aboutthegoal$j = "Acerca del objetivo";
const GoalTracking$j = "Seguimiento de Objetivos";
const Week$j = "Semana";
const progress$j = "progreso";
const loading$j = "Cargando";
const Apply$j = "Aplicar";
const Thisskillhasbeenreported$j = "Esta habilidad ha sido reportada.";
const issueGettingResume$j = "Hubo un problema al obtener el currículum vitae.";
const Interview$j = "Entrevista";
const Tasks$j = "Tareas";
const Loading$j = "Cargando";
const Skilladdedsuccessfully$j = "Habilidad añadida exitosamente";
const problemAddingSkill$j = "Hubo un problema al agregar habilidad.";
const Reportaproblem$j = "Reportar un problema";
const Submit$j = "Enviar";
const Addanewskill$j = "Agregar una nueva habilidad";
const JobDetailsComponent$j = {
	classifySkill: "¿Cómo clasificarías esta habilidad? (Opcional)",
	includedKeywordsWillCount: "¿Incluir esta palabra clave?",
	yesIncludeThisSkill: "\"Las palabras clave incluidas contarán en contra de tu puntuación de coincidencia para todas las exploraciones futuras. Puedes cambiar las palabras clave incluidas desde tu perfil\".",
	addSkill: "¿Quieres agregar esto como una habilidad?"
};
const HardSkill$j = "Habilidad Técnica";
const SoftSkill$j = "Habilidad Blanda";
const Pleaseshareanyadditionalcontext$j = "Por favor, comparte cualquier contexto adicional";
const Addasskill$j = "Agregar como habilidad";
const Skill$j = "Habilidad";
const JobFrequency$j = "Frecuencia del Trabajo";
const ResumeFrequency$j = "Frecuencia del Curriculum Vitae";
const Reportskill$j = "Reportar habilidad";
const JobDetails$j = "Detalles del trabajo";
const ViewJobLink$j = "Ver enlace de trabajo";
const Salary$j = "Salario";
const areYouSureDeleteJob$j = "¿Estás seguro de que quieres eliminar este trabajo?";
const ViewMore$j = "Ver más";
const ViewLess$j = "Ver menos";
const matchYouSkillsAgainstJob$j = "Coincide tus habilidades con la descripción del trabajo";
const pleaseUploadResumeSkillMatch$j = "Por favor, sube tu currículum para obtener tu puntuación de coincidencia de habilidades.";
const AddResume$j = "Agregar Currículum";
const thisJobDoesNotHaveAnyDesc$j = "Este trabajo no tiene ninguna descripción.";
const youCanEditJobToAdd$j = "Puedes editar este trabajo para agregarle una descripción. También puedes importar trabajos usando nuestro";
const chromeextension$j = "extensión de Chrome";
const fromVariousJobPortalsOnce$j = "de varios portales de trabajo. Una vez que agregues una descripción, también podrás ver información relacionada con habilidades.";
const AddDescription$j = "Agregar descripción";
const CompanyInfo$j = "Información de la empresa";
const Website$j = "Sitio web";
const Industry$j = "Industria";
const EmployeeCount$j = "Número de empleados";
const ExprienceLevel$j = "Nivel de experiencia";
const Address$j = "Dirección";
const Resumes$j = "Curriculums Vitae";
const Setasdefault$j = "Establecer como predeterminado";
const Ok$j = "Aceptar";
const UploadNewResume$j = "Subir Nuevo Currículum";
const Default$j = "Predeterminado";
const Jobnotfound$j = "Trabajo no encontrado";
const EditDetails$j = "Editar Detalles";
const JobPostURL$j = "URL del Trabajo Publicado";
const Enterjoburl$j = "Ingrese la URL del trabajo";
const Nojobselected$j = "No se ha seleccionado ningún trabajo";
const Viewjobdetails$j = "Ver Detalles del Trabajo";
const Jobaddedtoyourboardsuccessfully$j = "Trabajo agregado a tu tablero exitosamente";
const AddJob$j = "Agregar Trabajo";
const Addnewjobname$j = "Agregar nuevo nombre de trabajo";
const JobUrl$j = "URL del Trabajo";
const Addjoburl$j = "Agregar URL de trabajo";
const Section$j = "Sección";
const didYouKnow$j = {
	chromeExtension: "¿Sabías? También puedes guardar trabajos directamente desde nuestra Extensión de Chrome e importar todos los datos con un solo clic. ¡Solo toma unos segundos!"
};
const Jobs$j = "Trabajos";
const AddJobtoboard$j = "Agregar trabajo al tablero";
const Currentlynojobsareavailable$j = "Actualmente no hay trabajos disponibles.";
const noMatchingJobs$j = "No se encontraron trabajos coincidentes.";
const welcomeToYourPersonalJobTracker$j = "¡Bienvenido a tu rastreador de trabajo personal!";
const weShortTutorialOnHowTrackingJob$j = "¡Te guiaremos a través de un breve tutorial sobre cómo comenzar a hacer seguimiento a tus solicitudes de trabajo en unos pocos pasos sencillos!";
const Addanewjob$j = "Agregar un nuevo trabajo";
const inOrderTrackCreatButton$j = "Para comenzar a hacer seguimiento de las solicitudes de trabajo, primero debes agregarlas al tablero haciendo clic en el botón 'Crear'.";
const Providesomedetails$j = "Proporcione algunos detalles.";
const toBeginTypeJobTitleCompany$j = "Para empezar, simplemente escriba el título del trabajo, el nombre de la empresa y el estado al que le gustaría agregarlo. Puede agregar más detalles más tarde, ¡pero esto es todo lo que necesitaría por ahora!";
const asAnExampleFilledForYou$j = "¡Como ejemplo, ya lo hemos completado por ti!";
const wohooAddedFirstJob$j = "¡Woohoo! ¡Añadiste tu primer trabajo a tu rastreador de empleos!";
const youCanDragDropJobCard$j = "Ahora puedes arrastrar y soltar la tarjeta de trabajo en las diferentes etapas del proceso de solicitud de trabajo. Al hacer clic en la tarjeta de trabajo, podrás ver más detalles, editarlos, guardar notas ¡y mucho más!";
const Lastbutnotleast$j = "Por último pero no menos importante";
const finalStepMakeSure$j = "Como último paso, asegúrate de tener nuestra.";
const autoMaticallyImportJobs$j = "¡lo que te permitirá importar automáticamente trabajos desde tus sitios web favoritos de búsqueda de empleo como LinkedIn, Indeed y más! ¡Nuestra extensión también te ayuda a mejorar tu perfil de LinkedIn y obtener 2.5 veces más apariciones en búsquedas!";
const selectanysection$j = "selecciona cualquier sección";
const Accept$j = "Aceptar";
const My2023JobSearch$j = "Mi Búsqueda de Trabajo 2023";
const AddedFrom$j = "Añadido desde";
const AddedUntil$j = "Añadido Hasta";
const BasicModal$j = "Modal Básico";
const AddnewSectionName$j = "Agregar Nuevo Nombre de Sección";
const OpenTo$j = "Abierto a";
const Featured$j = "Destacado";
const LicenceAndCerts$j = "Licencias y certificados";
const Banner$j = "Banner";
const LinkedInURL$j = "URL de LinkedIn";
const Recommendations$j = "Recomendaciones";
const LinkedinReview$j = "Reseña de Linkedin";
const NoDataAvailable$j = "No hay datos disponibles";
const looksLikeYouDidNot$j = "Parece que no has empezado a usar nuestra";
const toOptimizeProfileScoreVisible$j = "Aún no has optimizado tu perfil de LinkedIn. Una vez que lo hagas, tu puntuación de perfil será visible aquí.";
const LinkedinComponent$j = {
	letsOptimize: "Optimicemos"
};
const improveYourChancesLandingDreamJob$j = "Mejora tus posibilidades de conseguir el trabajo de tus sueños. Utiliza estas estrategias probadas y comprobadas para darle a tu perfil de LinkedIn una renovación muy necesaria.";
const VisitProfile$j = "Visitar Perfil";
const wantToGetLinkedinMakeover$j = "¿Quieres obtener una renovación completa de tu perfil de LinkedIn?";
const PostGenerator$j = "Generador de Publicaciones";
const LinkedinHeadlineGenerator$j = "Generador de Titulares de LinkedIn";
const LinkedinAboutSectionGenerator$j = "Generador de Sección Acerca de LinkedIn";
const AITools$j = "Herramientas de IA";
const Premium$j = "Premium";
const LinkedInOptimization$j = "Optimización de LinkedIn";
const JobTracker$j = "Seguimiento de trabajo";
const whoIsHiring$j = "¿Quién está contratando?";
const Autofill$j = "Autocompletar";
const HeadlineGenerator$j = "Generador de titulares";
const skillMatching$j = "Emparejamiento de habilidades";
const SummarizeJD$j = "Resumen de la descripción del trabajo";
const contactFeature$j = "Seguimiento de contactos";
const documentFeature$j = "Documentos";
const landJobWithoutStress$j = "Consigue el trabajo de tus sueños. Sin estrés.";
const discoverFeatures$j = "¡Descubre la variedad de características de Careerflow.ai diseñadas para simplificar tu búsqueda de trabajo y mejorar tu trayectoria profesional!";
const letsBeginOnboarding$j = "¡Vamos a conocerte mejor!";
const inTheNextFewScreensJobThirdParties$j = "En las próximas pantallas, te haremos algunas preguntas que nos ayudarán a adaptar la experiencia para ti y también a rellenar automáticamente tus solicitudes de trabajo (¡para que no tengas que hacerlo tú mismo/a)! No vendemos tus datos a terceros.";
const letsAddBasicInformation$j = "Agreguemos tu información básica";
const Pleaseselectanoptionfirst$j = "Por favor, seleccione una opción primero.";
const JobApplicationTracker$j = "Seguimiento de solicitudes de empleo";
const LinkedInProfileOptimizer$j = "Optimizador de perfil de LinkedIn";
const UnlimitedDocuments$j = "Documentos ilimitados";
const UnlimitedContacts$j = "Contactos ilimitados";
const HiringManagerSearch$j = "Búsqueda de Gerente de Contratación";
const AILinkedInPostGenerator$j = "Generador de publicaciones de LinkedIn de IA";
const ATSKeywordSkillMatch$j = "Trabajo con coincidencia de palabras clave / habilidades ATS";
const ChooseyourPlan$j = "Elige tu plan";
const superChargeYourJobSearch$j = "Potencia tu búsqueda de trabajo y mejora tu proceso de solicitud de empleo, aumenta tus entrevistas y consigue el trabajo de tus sueños. Todo con la ayuda del kit de herramientas premium de Careerflow.";
const startNowGoto$j = "Comenzar ahora (Ir a la aplicación)";
const CreatedBy$j = "Creado Por";
const CreateNewNote$j = "Crear Nueva Nota";
const Nonotescreated$j = "No se han creado notas";
const approxTimeIsFourMinutes$j = "El tiempo aproximado para completar el proceso de incorporación es de 4 minutos.";
const Continue$j = "Continuar";
const iWillDoLaterTakeMeToApp$j = "Lo haré más tarde. Llévame a la aplicación.";
const allDone$j = "¡Todo listo!";
const welcomeAbord$j = "¡Bienvenido a bordo!";
const letsBegin$j = "Empecemos";
const UpgradeyourplanandgetAIAssistance$j = "Actualiza tu plan y obtén Asistencia de IA";
const DownloadPDF$j = "Descargar PDF";
const oopsWeCouldntProcessResume$j = "Lo siento, no pudimos procesar este currículum.";
const MyProfile$j = "Mi perfil";
const Setting$j = "Ajuste";
const Logout$j = "Cerrar Sesión";
const SignIn$j = "Iniciar Sesión";
const Typeyourfirstnamehere$j = "Tu primer nombre";
const Enteryourlastname$j = "Tu apellido";
const ManageSubscription$j = "Gestionar suscripción";
const ifYouHaveDifficultiesProfile$j = "Si tienes alguna dificultad con la información de tu perfil, por favor contáctanos.";
const forSupport$j = "para soporte.";
const whatIsIdealCompanySize$j = "¿Cuál es el tamaño ideal de tu empresa?";
const Saveandcontinue$j = "Guardar y continuar";
const whatIsMinExpectedSalary$j = "¿Cuál es tu salario mínimo esperado (por año)?";
const Atleast$j = "Al menos";
const SlidetoAdjust$j = "Deslizar para ajustar";
const whatIndustryExcitedWork$j = "¿Qué industrias te emocionan?";
const Add$j = "Agregar";
const statusOfJobSearch$j = "¿Estado de tu búsqueda de trabajo?";
const Finish$j = "Terminar";
const whatLevelRoleLooking$j = "¿Qué nivel de rol estás buscando?";
const Selectuptotwo$j = "Seleccione hasta dos";
const PreviousStep$j = "Paso anterior";
const Skip$j = "Omitir";
const whatDoYouValueNewRole$j = "¿Qué valoras en un nuevo puesto?";
const Selectuptothree$j = "Seleccione hasta tres";
const EqualEmploymentData$j = "Datos de empleo igualitario";
const whatIsYourEthnicity$j = "¿Cuál es tu etnia?";
const areYouAuthorizedToWorkUs$j = "¿Está autorizado para trabajar en los Estados Unidos?";
const willYouRequireSponsorShip$j = "¿Necesitará patrocinio para obtener un estatus de visa de empleo ahora o en el futuro?";
const doYouHaveADisability$j = "¿Tienes alguna discapacidad?";
const areYouAVeteran$j = "¿Eres veterano?";
const rolesYouInterestedIn$j = "¿En qué tipo de roles estás interesado?";
const Selectuptofive$j = "Seleccione hasta cinco";
const AddCustomrole$j = "Agregar rol personalizado";
const whereDoYouLikeWork$j = "¿Dónde te gustaría trabajar?";
const Resources$j = "Recursos";
const currentlyNoResourceAvailable$j = "Actualmente no hay recursos disponibles.";
const AddNewSection$j = "Agregar Nueva Sección";
const ChangeSections$j = "Cambiar secciones";
const Settings$j = "Configuraciones";
const Dashboard$j = "Tablero";
const JobBoard$j = "Tablero de Trabajo";
const Linkedin$j = "Linkedin";
const Community$j = "Comunidad";
const FindRecruiters$j = "Encontrar reclutadores";
const Goals$j = "Objetivos";
const DownloadExtension$j = "Descargar Extensión";
const SuggestaFeature$j = "Sugerir una característica";
const leftPanel$j = {
	ReportanIssue: "Reportar un problema"
};
const PhoneNumberisrequired$j = "Se requiere número de teléfono";
const MobileNumber$j = "Número de teléfono móvil";
const Enteronlynumbers$j = "Ingrese solo números.";
const Countryyoulivein$j = "País en el que vives";
const SelectaCountry$j = "Seleccione un país";
const DateofBirth$j = "Fecha de nacimiento";
const Gender$j = "Género";
const JobPreferences$j = "Preferencias de trabajo";
const pleaseEnterValidEmail$j = "Por favor, ingrese un correo electrónico válido.";
const emailSendForResetting$j = "Se ha enviado un correo electrónico para restablecer la contraseña.";
const VerifyyourEmailID$j = "Verifica tu ID de correo electrónico";
const sentPleaseCheckEmail$j = "¡Enviado! Por favor, revisa tu correo electrónico.";
const tooManyAttemptsTryAgain$j = "Demasiados intentos, por favor inténtelo de nuevo en algún momento.";
const Resend$j = "Reenviar";
const Login$j = "Iniciar sesión";
const weHaveSentVerificationLinkAtEmail$j = "Te hemos enviado un enlace de verificación a tu correo electrónico.";
const pleaseVerifyEmailContinueSpam$j = "Por favor, verifique su correo electrónico para continuar. También revise la carpeta de spam o promociones para encontrar el correo electrónico de verificación.";
const Logintogetstarted$j = "Inicia sesión para empezar";
const ContinuewithGoogle$j = "Continuar con Google";
const pleaseInputEmail$j = "¡Por favor ingrese su correo electrónico!";
const Password$j = "Contraseña";
const pleaseInputPassword$j = "¡Por favor ingrese su contraseña!";
const passwordLowerUpperDigitSpecial$j = "Tu contraseña debe contener al menos una letra minúscula, una mayúscula, un dígito y un carácter especial.";
const atLeastSixChar$j = "Al menos 6 caracteres";
const forgotPassword$j = "¿Olvidaste tu contraseña?";
const Bysigninginyouagreetoour$j = "Al iniciar sesión, aceptas nuestros";
const Terms$j = "Términos";
const Conditions$j = "Condiciones";
const and$j = "y";
const PrivacyPolicy$j = "Política de privacidad";
const theseAreTheTopsSkillsExtracted$j = "Estas son las habilidades principales extraídas de la descripción del trabajo.";
const TopSkills$j = "Principales habilidades";
const weCoulNotExtractSkills$j = "No pudimos extraer ninguna habilidad de esta descripción de trabajo.";
const upgradeToPremiumToView$j = "Actualice a Premium para ver su puntuación de coincidencia de habilidades en su currículum vitae.";
const SkillScore$j = "Puntuación de Habilidad";
const thisIsYourSkillScoreBasedOn$j = "Esta es tu puntuación de habilidades basada en la descripción del trabajo y tu currículum.";
const theseSkllsAreStrongMatch$j = "Estas habilidades son una fuerte coincidencia entre tu currículum y la descripción del trabajo.";
const Strongmatch$j = "Coincidencia Fuerte";
const theseSkillsArePartialMatch$j = "Estas habilidades son una coincidencia parcial entre tu currículum y la descripción del trabajo.";
const Partialmatch$j = "Coincidencia parcial";
const theseSkillsAreMissingFrom$j = "Estas palabras clave faltan en tu currículum pero están presentes en la descripción del trabajo. Pueden ser habilidades o palabras clave generales que son específicas para la oportunidad laboral y pueden ser útiles para agregar a tu currículum.";
const SkillMatchComponent$j = {
	removeSkill: "¿Cuál es tu principal motivo para reportar un problema con la palabra clave?"
};
const Optional$j = "Opcional";
const Notrelevanttothejob$j = "No relevante para el trabajo";
const Notaskill$j = "No es una habilidad";
const Toogeneric$j = "Demasiado genérico";
const Pleaseshareanyfeedback$j = "Por favor, comparte cualquier comentario";
const excludedKeywordsWillNot$j = "Las palabras clave excluidas no contarán en tu puntuación de coincidencia para todas las exploraciones futuras. Puedes cambiar las palabras clave excluidas desde tu perfil.";
const yesExcludeThisSkillFrom$j = "Sí, excluya esta habilidad de todas las exploraciones de mi currículum.";
const PartialMatch$j = "Coincidencia Parcial";
const MissingKeywords$j = "Palabras Clave Ausentes";
const Providetitletotask$j = "Proporcionar título a la tarea";
const TasksList$j = "Lista de tareas";
const AddTask$j = "Agregar Tarea";
const EnterTaskTitlehere$j = "Ingresa el título de la tarea aquí";
const TasksComponent$j = {
	listEmpty: "Lista de tareas vacía. Crea una nueva."
};
const CompletedTasks$j = "Tareas Completadas";
const CompleteYourtasks$j = "Completa tus tareas";
const Steps$j = "Pasos";
const PremiumMember$j = "Miembro Premium";
const Thankyouforupgradingto$j = "Gracias por actualizar a";
const CareerflowPremium$j = "Flujo de carrera Premium";
const hereIsHowYouCanAccessPremium$j = "¡Aquí te mostramos cómo acceder a tus beneficios Premium!";
const stepOne$j = "Paso 1";
const DownloadourChromeExtension$j = "Descarga nuestra extensión de Chrome";
const youJobSearchCopilotIshere$j = "Tu copiloto de IA para la búsqueda de trabajo está aquí.";
const DownloadNow$j = "Descargar ahora";
const stepTwo$j = "Paso 2";
const GetStarted$j = "Empezar";
const stepThree$j = "Paso 3";
const SignintoChromeExtension$j = "Iniciar sesión en la extensión de Chrome";
const entityCreated$j = "Nuevo {{entity}} creado";
const entityUpdated$j = "{{entity}} actualizado";
const entityDeleted$j = "{{entity}} eliminado/a";
const entityLinked$j = "{{entity}} vinculado/a";
const entityUnlinked$j = "{{entity}} desvinculada";
const entityMovedTo$j = "Trasladado a {{entity}}";
const youAddedANewEntity$j = "Añadiste una nueva {{entity}}";
const personCreated$j = "{{creator}} creó una {{entity}} para {{owner}}";
const youUpdatedAEntity$j = "Has actualizado un {{entity}}";
const personUpdated$j = "{{creator}} actualizó un {{entity}} para {{owner}}";
const youDeletedAEntity$j = "Has eliminado una {{entity}}";
const personDeleted$j = "{{creator}} eliminó una {{entity}} de {{owner}}";
const youLinkedEntity$j = "Has vinculado un {{entity}} a este trabajo.";
const personLinked$j = "{{creator}} vinculó una {{entity}} a este trabajo para {{owner}}";
const youUnlinked$j = "Has desvinculado una {{entity}} de este trabajo.";
const personUnlinked$j = "{{creator}} desvinculó una {{entity}} de este trabajo para {{owner}}";
const youMovedEntity$j = "Has movido esta {{entity}} desde {{sectionFrom}} hasta {{sectionTo}}";
const personMoved$j = "{{creator}} movió esta {{entity}} desde {{sectionFrom}} a {{sectionTo}} para {{owner}}";
const addedByName$j = "Añadido por {{name}}";
const DownloadChromeExtension$j = "Descargar extensión de Chrome";
const ourChromeExtensionIs$j = "Nuestra extensión de Chrome es una herramienta integrada para ayudarte a optimizar tu perfil de LinkedIn, guardar trabajos, guardar contactos, generar cartas de presentación y más.";
const Optimizeyourprofile$j = "Optimiza tu perfil";
const startOptimizingYourProfile$j = "Comienza a optimizar tu perfil para tener mejores posibilidades de ser contactado por reclutadores.";
const OptimizeNow$j = "Optimizar ahora";
const Addyourfirstjob$j = "Agrega tu primer trabajo";
const startSavingJobApplicationsToTrack$j = "Comienza a guardar las solicitudes de trabajo para hacer un seguimiento de tu búsqueda de empleo y encontrar información útil.";
const AddNow$j = "Agregar ahora";
const CompleteProfile$j = "Perfil completo";
const completeYourProfileForUsing$j = "Completa tu perfil para utilizar la función de auto-rellenado y obtener una experiencia más personalizada.";
const CompleteNow$j = "Completo ahora";
const Addyourfirstcontact$j = "Añade tu primer contacto";
const addContactToFollowUpWith$j = "Agregue el contacto para hacer seguimiento con ellos más tarde, agregue notas y más.";
const JoinCommunity$j = "Únete a la comunidad";
const ourCommunityisAlways$j = "Nuestra comunidad siempre está contigo en tu búsqueda de trabajo.";
const JoinNow$j = "Únete ahora";
const welcomeToCareerflow$j = "¡Bienvenido a Careerflow!";
const yourHubForCareerInsights2$j = "Este es tu centro de información para obtener perspectivas profesionales, actividades y más. Explora tu panel personalizado para mantenerte al tanto de tu trayectoria profesional.";
const ChecklistCompleted$j = "¡Tu lista de verificación está completa!";
const Completeyourchecklist$j = "Completa tu lista de verificación";
const completeAFewStepsTo$j = "Completa algunos pasos para conseguir tu próximo trabajo.";
const Completed$j = "Completado";
const JobCountByStage$j = "Conteo de trabajos por etapa";
const NopastapplicationDatafound$j = "No se encontraron datos de aplicaciones anteriores";
const YourJobSearchStages$j = "Las etapas de tu búsqueda de trabajo";
const NoDatafound$j = "No se encontraron datos";
const es = {
	copyToClipboard: copyToClipboard$j,
	UnlocktheAIgenerated: UnlocktheAIgenerated$j,
	UpgradetoPremium: UpgradetoPremium$j,
	Result: Result$j,
	Copy: Copy$j,
	Save: Save$j,
	Edit: Edit$j,
	Processing: Processing$j,
	YourAIgeneratedcontentwillshowhere: YourAIgeneratedcontentwillshowhere$j,
	hopeYouFindUseful: hopeYouFindUseful$j,
	regenerate: regenerate$j,
	ProvideAdditionalFeedback: ProvideAdditionalFeedback$j,
	Enteranyfeedback: Enteranyfeedback$j,
	Notimpressive: Notimpressive$j,
	thisIsntTrue: thisIsntTrue$j,
	Notpersonalized: Notpersonalized$j,
	Tone: Tone$j,
	Length: Length$j,
	Template: Template$j,
	Generatedon: Generatedon$j,
	Copiedtoclipboard: Copiedtoclipboard$j,
	CopytoClipboard: CopytoClipboard$j,
	DownloadasPDF: DownloadasPDF$j,
	ViewDetails: ViewDetails$j,
	JobDescriptionImported: JobDescriptionImported$j,
	ImportfromJob: ImportfromJob$j,
	Saved: Saved$j,
	Applied: Applied$j,
	Offer: Offer$j,
	Interviewing: Interviewing$j,
	Rejected: Rejected$j,
	Search: Search$j,
	Import: Import$j,
	CoverLetterGeneratorHistory: CoverLetterGeneratorHistory$j,
	NoCoverLettersGenerated: NoCoverLettersGenerated$j,
	getStartedCoverLetter: getStartedCoverLetter$j,
	getStarted: getStarted$j,
	Documents: Documents$j,
	UploadNewDocument: UploadNewDocument$j,
	AICoverLetterGenerator: AICoverLetterGenerator$j,
	ViewHistory: ViewHistory$j,
	JobDescription: JobDescription$j,
	ImportfromBoard: ImportfromBoard$j,
	EnterJobDescription: EnterJobDescription$j,
	JobTitle: JobTitle$j,
	EnterJobTitle: EnterJobTitle$j,
	CompanyName: CompanyName$j,
	EnterCompanyName: EnterCompanyName$j,
	YourProfile: YourProfile$j,
	ResumeUpload: ResumeUpload$j,
	UseLinkedinProfile: UseLinkedinProfile$j,
	Uploadyourresume: Uploadyourresume$j,
	AddyourResume: AddyourResume$j,
	fileNameCannotFormat: fileNameCannotFormat$j,
	ChooseorUpload: ChooseorUpload$j,
	SelectTemplate: SelectTemplate$j,
	Preview: Preview$j,
	UseTemplate: UseTemplate$j,
	Change: Change$j,
	AdvancedSettings: AdvancedSettings$j,
	AdditionalContext: AdditionalContext$j,
	Professional: Professional$j,
	Casual: Casual$j,
	Enthusiastic: Enthusiastic$j,
	Informational: Informational$j,
	Short: Short$j,
	Medium: Medium$j,
	Long: Long$j,
	Language: Language$j,
	iAmOkayBack: iAmOkayBack$j,
	Generate: Generate$j,
	CoverLetter: CoverLetter$j,
	SelectLanguage: SelectLanguage$j,
	AboutGeneratorHistory: AboutGeneratorHistory$j,
	NoAboutsGenerated: NoAboutsGenerated$j,
	getStartedAbouts: getStartedAbouts$j,
	noAttachmentsFound: noAttachmentsFound$j,
	TargetJobTitle: TargetJobTitle$j,
	KeywordsToInclude: KeywordsToInclude$j,
	UploadYourResume: UploadYourResume$j,
	AddYourResume: AddYourResume$j,
	LinkedinProfile: LinkedinProfile$j,
	Linkedinprofilenotfound: Linkedinprofilenotfound$j,
	startUsingChromeExtension: startUsingChromeExtension$j,
	Download: Download$j,
	UseEmojis: UseEmojis$j,
	UseBulletPoints: UseBulletPoints$j,
	SpeechFocus: SpeechFocus$j,
	FirstPerson: FirstPerson$j,
	ThirdPerson: ThirdPerson$j,
	HeadlineGeneratorHistory: HeadlineGeneratorHistory$j,
	NoHeadlinesGenerated: NoHeadlinesGenerated$j,
	getStartedHeadline: getStartedHeadline$j,
	AIHeadlineGenerator: AIHeadlineGenerator$j,
	KeywordstoInclude: KeywordstoInclude$j,
	Pressenteraftereachword: Pressenteraftereachword$j,
	LinkedinProfilenotfound: LinkedinProfilenotfound$j,
	Headline: Headline$j,
	PostGeneratorHistory: PostGeneratorHistory$j,
	NoPostsGenerated: NoPostsGenerated$j,
	getStartedPost: getStartedPost$j,
	Topic: Topic$j,
	Description: Description$j,
	UseHashtags: UseHashtags$j,
	Custom: Custom$j,
	EnterCustomTone: EnterCustomTone$j,
	Added: Added$j,
	ComingSoon: ComingSoon$j,
	Company: Company$j,
	JobInterview: JobInterview$j,
	Research: Research$j,
	Networking: Networking$j,
	Referral: Referral$j,
	MustbeContacted: MustbeContacted$j,
	ScheduleaMeeting: ScheduleaMeeting$j,
	needAFollowUp: needAFollowUp$j,
	Today: Today$j,
	Viewdetails: Viewdetails$j,
	Activity: Activity$j,
	ActivityDetails: ActivityDetails$j,
	Delete: Delete$j,
	Title: Title$j,
	Goal: Goal$j,
	Status: Status$j,
	FollowUp: FollowUp$j,
	AddActivity: AddActivity$j,
	Enteractivitytitle: Enteractivitytitle$j,
	Cancel: Cancel$j,
	SaveActivity: SaveActivity$j,
	noActivityPresent: noActivityPresent$j,
	Addnew: Addnew$j,
	About: About$j,
	noDataPresentYou: noDataPresentYou$j,
	Experience: Experience$j,
	Education: Education$j,
	Skills: Skills$j,
	Overview: Overview$j,
	LinkedJobs: LinkedJobs$j,
	Notes: Notes$j,
	FullName: FullName$j,
	Location: Location$j,
	Relationship: Relationship$j,
	Contacts: Contacts$j,
	CreateContact: CreateContact$j,
	NotesCreated: NotesCreated$j,
	Notesupdated: Notesupdated$j,
	Addnote: Addnote$j,
	areYouSureDeleteNote: areYouSureDeleteNote$j,
	Createdby: Createdby$j,
	notSureWhyResumeCalls: notSureWhyResumeCalls$j,
	getExpertResumeReview: getExpertResumeReview$j,
	youHaventAddedContacts: youHaventAddedContacts$j,
	noMatchingContacts: noMatchingContacts$j,
	Link: Link$j,
	unlink: unlink$j,
	Locationnotavailable: Locationnotavailable$j,
	Emailnotavailable: Emailnotavailable$j,
	PhoneNumbernotavailable: PhoneNumbernotavailable$j,
	createdby: createdby$j,
	areYouSureDeleteContact: areYouSureDeleteContact$j,
	areYouSureUnlinkContact: areYouSureUnlinkContact$j,
	Addedbyyou: Addedbyyou$j,
	Addedby: Addedby$j,
	Timeline: Timeline$j,
	Timelineempty: Timelineempty$j,
	Discard: Discard$j,
	SaveContact: SaveContact$j,
	Recruiter: Recruiter$j,
	Candidate: Candidate$j,
	Colleague: Colleague$j,
	Employee: Employee$j,
	"Needtofollow-up": "Necesita hacer un seguimiento",
	EnterValidEmail: EnterValidEmail$j,
	EnterValidPhoneNumber: EnterValidPhoneNumber$j,
	editingProfileNotAvailable: editingProfileNotAvailable$j,
	itWillBeSoonAvailable: itWillBeSoonAvailable$j,
	ChromeExtension: ChromeExtension$j,
	SelectTag: SelectTag$j,
	FirstName: FirstName$j,
	FirstNameisrequired: FirstNameisrequired$j,
	LastName: LastName$j,
	LastNameisrequired: LastNameisrequired$j,
	Companyisrequired: Companyisrequired$j,
	Email: Email$j,
	ThisisnotavalidEmail: ThisisnotavalidEmail$j,
	AddEmail: AddEmail$j,
	PhoneNumber: PhoneNumber$j,
	notaValidPhone: notaValidPhone$j,
	phoneNoMinimum5char: phoneNoMinimum5char$j,
	phoneNoMinumum15char: phoneNoMinumum15char$j,
	AddPhoneNumber: AddPhoneNumber$j,
	SelectGoal: SelectGoal$j,
	SelectStatus: SelectStatus$j,
	Followup: Followup$j,
	SocialMedia: SocialMedia$j,
	Linkedinhandle: Linkedinhandle$j,
	Twitterhandle: Twitterhandle$j,
	Facebookhandle: Facebookhandle$j,
	Githubhandle: Githubhandle$j,
	Gmailhandle: Gmailhandle$j,
	Changessavedsuccessfully: Changessavedsuccessfully$j,
	EditContact: EditContact$j,
	BasicInformation: BasicInformation$j,
	EditContactDetails: EditContactDetails$j,
	SaveChanges: SaveChanges$j,
	phoneNoMinimum14char: phoneNoMinimum14char$j,
	LinkedIn: LinkedIn$j,
	Twitter: Twitter$j,
	Facebook: Facebook$j,
	Github: Github$j,
	Gmail: Gmail$j,
	youCanWriteAbout: youCanWriteAbout$j,
	Addednewsection: Addednewsection$j,
	Removedsuccessfully: Removedsuccessfully$j,
	Remove: Remove$j,
	Institute: Institute$j,
	Schoolisrequired: Schoolisrequired$j,
	Degree: Degree$j,
	StartMonth: StartMonth$j,
	StartYear: StartYear$j,
	EndMonth: EndMonth$j,
	EndYear: EndYear$j,
	Addmore: Addmore$j,
	PositionTitle: PositionTitle$j,
	ExperienceType: ExperienceType$j,
	Addednewitem: Addednewitem$j,
	whatSkillsDoYouEnjoy: whatSkillsDoYouEnjoy$j,
	Typeskillshere: Typeskillshere$j,
	LinkedContacts: LinkedContacts$j,
	LinkContact: LinkContact$j,
	NocontactsLinked: NocontactsLinked$j,
	JobContactsComponent: JobContactsComponent$j,
	Nocontacts: Nocontacts$j,
	LinkJobto: LinkJobto$j,
	Contact: Contact$j,
	Document: Document$j,
	Nojobsfound: Nojobsfound$j,
	LinkJob: LinkJob$j,
	youCanLinkContactJobImported: youCanLinkContactJobImported$j,
	Prev: Prev$j,
	Next: Next$j,
	areYouSureUnlinkDocument: areYouSureUnlinkDocument$j,
	areYouSureDeleteDocument: areYouSureDeleteDocument$j,
	Category: Category$j,
	CreatedOn: CreatedOn$j,
	Joblinked: Joblinked$j,
	Quickactions: Quickactions$j,
	All: All$j,
	Resume: Resume$j,
	Portfolio: Portfolio$j,
	Other: Other$j,
	Adddocument: Adddocument$j,
	Type: Type$j,
	Sortingby: Sortingby$j,
	SwitchtoGridLayout: SwitchtoGridLayout$j,
	SwitchtoListLayout: SwitchtoListLayout$j,
	NoDocumentsAdded: NoDocumentsAdded$j,
	DocumentsComponent: DocumentsComponent$j,
	NoDocumentFound: NoDocumentFound$j,
	SelectFile: SelectFile$j,
	onlyPdfDocxSupported: onlyPdfDocxSupported$j,
	Uploadfile: Uploadfile$j,
	DocumentCategory: DocumentCategory$j,
	SaveDocument: SaveDocument$j,
	AddDocument: AddDocument$j,
	LinkedDocuments: LinkedDocuments$j,
	LinkDocument: LinkDocument$j,
	NodocumentsLinked: NodocumentsLinked$j,
	JobDocumentsComponent: JobDocumentsComponent$j,
	NoDocuments: NoDocuments$j,
	CreateDocuments: CreateDocuments$j,
	youCanLinkDocumentJobImported: youCanLinkDocumentJobImported$j,
	Documenteditedsuccessfully: Documenteditedsuccessfully$j,
	DocumentDetails: DocumentDetails$j,
	UnsavedChanges: UnsavedChanges$j,
	yourChangesWillBeLostSureClose: yourChangesWillBeLostSureClose$j,
	yourChangesWillBeLostSureDiscard: yourChangesWillBeLostSureDiscard$j,
	DiscardChanges: DiscardChanges$j,
	WeeklyGoalAlert: WeeklyGoalAlert$j,
	Progress: Progress$j,
	AllGoals: AllGoals$j,
	Name: Name$j,
	Completedon: Completedon$j,
	Createdon: Createdon$j,
	Action: Action$j,
	Back: Back$j,
	OverallScore: OverallScore$j,
	Aboutthegoal: Aboutthegoal$j,
	GoalTracking: GoalTracking$j,
	Week: Week$j,
	progress: progress$j,
	loading: loading$j,
	Apply: Apply$j,
	Thisskillhasbeenreported: Thisskillhasbeenreported$j,
	issueGettingResume: issueGettingResume$j,
	Interview: Interview$j,
	Tasks: Tasks$j,
	Loading: Loading$j,
	Skilladdedsuccessfully: Skilladdedsuccessfully$j,
	problemAddingSkill: problemAddingSkill$j,
	Reportaproblem: Reportaproblem$j,
	Submit: Submit$j,
	Addanewskill: Addanewskill$j,
	JobDetailsComponent: JobDetailsComponent$j,
	HardSkill: HardSkill$j,
	SoftSkill: SoftSkill$j,
	Pleaseshareanyadditionalcontext: Pleaseshareanyadditionalcontext$j,
	Addasskill: Addasskill$j,
	Skill: Skill$j,
	JobFrequency: JobFrequency$j,
	ResumeFrequency: ResumeFrequency$j,
	Reportskill: Reportskill$j,
	JobDetails: JobDetails$j,
	ViewJobLink: ViewJobLink$j,
	Salary: Salary$j,
	areYouSureDeleteJob: areYouSureDeleteJob$j,
	ViewMore: ViewMore$j,
	ViewLess: ViewLess$j,
	matchYouSkillsAgainstJob: matchYouSkillsAgainstJob$j,
	pleaseUploadResumeSkillMatch: pleaseUploadResumeSkillMatch$j,
	AddResume: AddResume$j,
	thisJobDoesNotHaveAnyDesc: thisJobDoesNotHaveAnyDesc$j,
	youCanEditJobToAdd: youCanEditJobToAdd$j,
	chromeextension: chromeextension$j,
	fromVariousJobPortalsOnce: fromVariousJobPortalsOnce$j,
	AddDescription: AddDescription$j,
	CompanyInfo: CompanyInfo$j,
	Website: Website$j,
	Industry: Industry$j,
	EmployeeCount: EmployeeCount$j,
	ExprienceLevel: ExprienceLevel$j,
	Address: Address$j,
	Resumes: Resumes$j,
	Setasdefault: Setasdefault$j,
	Ok: Ok$j,
	UploadNewResume: UploadNewResume$j,
	Default: Default$j,
	Jobnotfound: Jobnotfound$j,
	EditDetails: EditDetails$j,
	JobPostURL: JobPostURL$j,
	Enterjoburl: Enterjoburl$j,
	Nojobselected: Nojobselected$j,
	Viewjobdetails: Viewjobdetails$j,
	Jobaddedtoyourboardsuccessfully: Jobaddedtoyourboardsuccessfully$j,
	AddJob: AddJob$j,
	Addnewjobname: Addnewjobname$j,
	JobUrl: JobUrl$j,
	Addjoburl: Addjoburl$j,
	Section: Section$j,
	didYouKnow: didYouKnow$j,
	Jobs: Jobs$j,
	AddJobtoboard: AddJobtoboard$j,
	Currentlynojobsareavailable: Currentlynojobsareavailable$j,
	noMatchingJobs: noMatchingJobs$j,
	welcomeToYourPersonalJobTracker: welcomeToYourPersonalJobTracker$j,
	weShortTutorialOnHowTrackingJob: weShortTutorialOnHowTrackingJob$j,
	Addanewjob: Addanewjob$j,
	inOrderTrackCreatButton: inOrderTrackCreatButton$j,
	Providesomedetails: Providesomedetails$j,
	toBeginTypeJobTitleCompany: toBeginTypeJobTitleCompany$j,
	asAnExampleFilledForYou: asAnExampleFilledForYou$j,
	wohooAddedFirstJob: wohooAddedFirstJob$j,
	youCanDragDropJobCard: youCanDragDropJobCard$j,
	Lastbutnotleast: Lastbutnotleast$j,
	finalStepMakeSure: finalStepMakeSure$j,
	autoMaticallyImportJobs: autoMaticallyImportJobs$j,
	selectanysection: selectanysection$j,
	Accept: Accept$j,
	My2023JobSearch: My2023JobSearch$j,
	AddedFrom: AddedFrom$j,
	AddedUntil: AddedUntil$j,
	BasicModal: BasicModal$j,
	AddnewSectionName: AddnewSectionName$j,
	OpenTo: OpenTo$j,
	Featured: Featured$j,
	LicenceAndCerts: LicenceAndCerts$j,
	Banner: Banner$j,
	LinkedInURL: LinkedInURL$j,
	Recommendations: Recommendations$j,
	LinkedinReview: LinkedinReview$j,
	NoDataAvailable: NoDataAvailable$j,
	looksLikeYouDidNot: looksLikeYouDidNot$j,
	toOptimizeProfileScoreVisible: toOptimizeProfileScoreVisible$j,
	LinkedinComponent: LinkedinComponent$j,
	improveYourChancesLandingDreamJob: improveYourChancesLandingDreamJob$j,
	VisitProfile: VisitProfile$j,
	wantToGetLinkedinMakeover: wantToGetLinkedinMakeover$j,
	PostGenerator: PostGenerator$j,
	LinkedinHeadlineGenerator: LinkedinHeadlineGenerator$j,
	LinkedinAboutSectionGenerator: LinkedinAboutSectionGenerator$j,
	AITools: AITools$j,
	Premium: Premium$j,
	LinkedInOptimization: LinkedInOptimization$j,
	JobTracker: JobTracker$j,
	whoIsHiring: whoIsHiring$j,
	Autofill: Autofill$j,
	HeadlineGenerator: HeadlineGenerator$j,
	skillMatching: skillMatching$j,
	SummarizeJD: SummarizeJD$j,
	contactFeature: contactFeature$j,
	documentFeature: documentFeature$j,
	landJobWithoutStress: landJobWithoutStress$j,
	discoverFeatures: discoverFeatures$j,
	letsBeginOnboarding: letsBeginOnboarding$j,
	inTheNextFewScreensJobThirdParties: inTheNextFewScreensJobThirdParties$j,
	letsAddBasicInformation: letsAddBasicInformation$j,
	Pleaseselectanoptionfirst: Pleaseselectanoptionfirst$j,
	JobApplicationTracker: JobApplicationTracker$j,
	LinkedInProfileOptimizer: LinkedInProfileOptimizer$j,
	UnlimitedDocuments: UnlimitedDocuments$j,
	UnlimitedContacts: UnlimitedContacts$j,
	HiringManagerSearch: HiringManagerSearch$j,
	AILinkedInPostGenerator: AILinkedInPostGenerator$j,
	ATSKeywordSkillMatch: ATSKeywordSkillMatch$j,
	"Auto-Apply": "Auto-aplicar",
	ChooseyourPlan: ChooseyourPlan$j,
	superChargeYourJobSearch: superChargeYourJobSearch$j,
	startNowGoto: startNowGoto$j,
	CreatedBy: CreatedBy$j,
	CreateNewNote: CreateNewNote$j,
	Nonotescreated: Nonotescreated$j,
	approxTimeIsFourMinutes: approxTimeIsFourMinutes$j,
	Continue: Continue$j,
	iWillDoLaterTakeMeToApp: iWillDoLaterTakeMeToApp$j,
	allDone: allDone$j,
	welcomeAbord: welcomeAbord$j,
	letsBegin: letsBegin$j,
	UpgradeyourplanandgetAIAssistance: UpgradeyourplanandgetAIAssistance$j,
	DownloadPDF: DownloadPDF$j,
	oopsWeCouldntProcessResume: oopsWeCouldntProcessResume$j,
	MyProfile: MyProfile$j,
	Setting: Setting$j,
	Logout: Logout$j,
	SignIn: SignIn$j,
	Typeyourfirstnamehere: Typeyourfirstnamehere$j,
	Enteryourlastname: Enteryourlastname$j,
	ManageSubscription: ManageSubscription$j,
	ifYouHaveDifficultiesProfile: ifYouHaveDifficultiesProfile$j,
	forSupport: forSupport$j,
	whatIsIdealCompanySize: whatIsIdealCompanySize$j,
	Saveandcontinue: Saveandcontinue$j,
	whatIsMinExpectedSalary: whatIsMinExpectedSalary$j,
	Atleast: Atleast$j,
	SlidetoAdjust: SlidetoAdjust$j,
	whatIndustryExcitedWork: whatIndustryExcitedWork$j,
	Add: Add$j,
	statusOfJobSearch: statusOfJobSearch$j,
	Finish: Finish$j,
	whatLevelRoleLooking: whatLevelRoleLooking$j,
	Selectuptotwo: Selectuptotwo$j,
	PreviousStep: PreviousStep$j,
	Skip: Skip$j,
	whatDoYouValueNewRole: whatDoYouValueNewRole$j,
	Selectuptothree: Selectuptothree$j,
	EqualEmploymentData: EqualEmploymentData$j,
	whatIsYourEthnicity: whatIsYourEthnicity$j,
	areYouAuthorizedToWorkUs: areYouAuthorizedToWorkUs$j,
	willYouRequireSponsorShip: willYouRequireSponsorShip$j,
	doYouHaveADisability: doYouHaveADisability$j,
	areYouAVeteran: areYouAVeteran$j,
	rolesYouInterestedIn: rolesYouInterestedIn$j,
	Selectuptofive: Selectuptofive$j,
	AddCustomrole: AddCustomrole$j,
	whereDoYouLikeWork: whereDoYouLikeWork$j,
	Resources: Resources$j,
	currentlyNoResourceAvailable: currentlyNoResourceAvailable$j,
	AddNewSection: AddNewSection$j,
	ChangeSections: ChangeSections$j,
	Settings: Settings$j,
	Dashboard: Dashboard$j,
	JobBoard: JobBoard$j,
	Linkedin: Linkedin$j,
	Community: Community$j,
	FindRecruiters: FindRecruiters$j,
	Goals: Goals$j,
	DownloadExtension: DownloadExtension$j,
	SuggestaFeature: SuggestaFeature$j,
	leftPanel: leftPanel$j,
	PhoneNumberisrequired: PhoneNumberisrequired$j,
	MobileNumber: MobileNumber$j,
	Enteronlynumbers: Enteronlynumbers$j,
	Countryyoulivein: Countryyoulivein$j,
	SelectaCountry: SelectaCountry$j,
	DateofBirth: DateofBirth$j,
	Gender: Gender$j,
	JobPreferences: JobPreferences$j,
	pleaseEnterValidEmail: pleaseEnterValidEmail$j,
	emailSendForResetting: emailSendForResetting$j,
	VerifyyourEmailID: VerifyyourEmailID$j,
	sentPleaseCheckEmail: sentPleaseCheckEmail$j,
	tooManyAttemptsTryAgain: tooManyAttemptsTryAgain$j,
	Resend: Resend$j,
	Login: Login$j,
	weHaveSentVerificationLinkAtEmail: weHaveSentVerificationLinkAtEmail$j,
	pleaseVerifyEmailContinueSpam: pleaseVerifyEmailContinueSpam$j,
	Logintogetstarted: Logintogetstarted$j,
	ContinuewithGoogle: ContinuewithGoogle$j,
	pleaseInputEmail: pleaseInputEmail$j,
	Password: Password$j,
	pleaseInputPassword: pleaseInputPassword$j,
	passwordLowerUpperDigitSpecial: passwordLowerUpperDigitSpecial$j,
	atLeastSixChar: atLeastSixChar$j,
	forgotPassword: forgotPassword$j,
	Bysigninginyouagreetoour: Bysigninginyouagreetoour$j,
	Terms: Terms$j,
	Conditions: Conditions$j,
	and: and$j,
	PrivacyPolicy: PrivacyPolicy$j,
	theseAreTheTopsSkillsExtracted: theseAreTheTopsSkillsExtracted$j,
	TopSkills: TopSkills$j,
	weCoulNotExtractSkills: weCoulNotExtractSkills$j,
	upgradeToPremiumToView: upgradeToPremiumToView$j,
	SkillScore: SkillScore$j,
	thisIsYourSkillScoreBasedOn: thisIsYourSkillScoreBasedOn$j,
	theseSkllsAreStrongMatch: theseSkllsAreStrongMatch$j,
	Strongmatch: Strongmatch$j,
	theseSkillsArePartialMatch: theseSkillsArePartialMatch$j,
	Partialmatch: Partialmatch$j,
	theseSkillsAreMissingFrom: theseSkillsAreMissingFrom$j,
	"Missing Keywords": "Palabras clave faltantes",
	SkillMatchComponent: SkillMatchComponent$j,
	Optional: Optional$j,
	Notrelevanttothejob: Notrelevanttothejob$j,
	Notaskill: Notaskill$j,
	Toogeneric: Toogeneric$j,
	Pleaseshareanyfeedback: Pleaseshareanyfeedback$j,
	excludedKeywordsWillNot: excludedKeywordsWillNot$j,
	yesExcludeThisSkillFrom: yesExcludeThisSkillFrom$j,
	PartialMatch: PartialMatch$j,
	MissingKeywords: MissingKeywords$j,
	Providetitletotask: Providetitletotask$j,
	TasksList: TasksList$j,
	AddTask: AddTask$j,
	EnterTaskTitlehere: EnterTaskTitlehere$j,
	TasksComponent: TasksComponent$j,
	CompletedTasks: CompletedTasks$j,
	CompleteYourtasks: CompleteYourtasks$j,
	Steps: Steps$j,
	PremiumMember: PremiumMember$j,
	Thankyouforupgradingto: Thankyouforupgradingto$j,
	CareerflowPremium: CareerflowPremium$j,
	hereIsHowYouCanAccessPremium: hereIsHowYouCanAccessPremium$j,
	stepOne: stepOne$j,
	DownloadourChromeExtension: DownloadourChromeExtension$j,
	youJobSearchCopilotIshere: youJobSearchCopilotIshere$j,
	DownloadNow: DownloadNow$j,
	stepTwo: stepTwo$j,
	GetStarted: GetStarted$j,
	stepThree: stepThree$j,
	SignintoChromeExtension: SignintoChromeExtension$j,
	entityCreated: entityCreated$j,
	entityUpdated: entityUpdated$j,
	entityDeleted: entityDeleted$j,
	entityLinked: entityLinked$j,
	entityUnlinked: entityUnlinked$j,
	entityMovedTo: entityMovedTo$j,
	youAddedANewEntity: youAddedANewEntity$j,
	personCreated: personCreated$j,
	youUpdatedAEntity: youUpdatedAEntity$j,
	personUpdated: personUpdated$j,
	youDeletedAEntity: youDeletedAEntity$j,
	personDeleted: personDeleted$j,
	youLinkedEntity: youLinkedEntity$j,
	personLinked: personLinked$j,
	youUnlinked: youUnlinked$j,
	personUnlinked: personUnlinked$j,
	youMovedEntity: youMovedEntity$j,
	personMoved: personMoved$j,
	addedByName: addedByName$j,
	DownloadChromeExtension: DownloadChromeExtension$j,
	ourChromeExtensionIs: ourChromeExtensionIs$j,
	Optimizeyourprofile: Optimizeyourprofile$j,
	startOptimizingYourProfile: startOptimizingYourProfile$j,
	OptimizeNow: OptimizeNow$j,
	Addyourfirstjob: Addyourfirstjob$j,
	startSavingJobApplicationsToTrack: startSavingJobApplicationsToTrack$j,
	AddNow: AddNow$j,
	CompleteProfile: CompleteProfile$j,
	completeYourProfileForUsing: completeYourProfileForUsing$j,
	CompleteNow: CompleteNow$j,
	Addyourfirstcontact: Addyourfirstcontact$j,
	addContactToFollowUpWith: addContactToFollowUpWith$j,
	JoinCommunity: JoinCommunity$j,
	ourCommunityisAlways: ourCommunityisAlways$j,
	JoinNow: JoinNow$j,
	welcomeToCareerflow: welcomeToCareerflow$j,
	yourHubForCareerInsights2: yourHubForCareerInsights2$j,
	ChecklistCompleted: ChecklistCompleted$j,
	Completeyourchecklist: Completeyourchecklist$j,
	completeAFewStepsTo: completeAFewStepsTo$j,
	Completed: Completed$j,
	JobCountByStage: JobCountByStage$j,
	NopastapplicationDatafound: NopastapplicationDatafound$j,
	YourJobSearchStages: YourJobSearchStages$j,
	NoDatafound: NoDatafound$j
};

const copyToClipboard$i = "Kopeeritud lõikelauale!";
const UnlocktheAIgenerated$i = "Avage AI-generaator.";
const UpgradetoPremium$i = "Uuenda Premiumi versioonile";
const Result$i = "Tulemus";
const Copy$i = "Kopeeri";
const Save$i = "Salvesta";
const Edit$i = "Muuda";
const Processing$i = "Töötlemine";
const YourAIgeneratedcontentwillshowhere$i = "Siin näete teie tehisintellekti genereeritud sisu";
const hopeYouFindUseful$i = "Loodan, et leiate selle tulemuse kasuliku!";
const regenerate$i = "Uuesti genereeri";
const ProvideAdditionalFeedback$i = "Andke lisasisendit";
const Enteranyfeedback$i = "Sisestage tagasisidet";
const Notimpressive$i = "Mitte muljetavaldav";
const thisIsntTrue$i = "See pole tõsi";
const Notpersonalized$i = "Mitte isikupärastatud";
const Tone$i = "Toon";
const Length$i = "Pikkus";
const Template$i = "Mall";
const Generatedon$i = "Genereeritud";
const Copiedtoclipboard$i = "Kopeeritud lõikelauale";
const CopytoClipboard$i = "Kopeeri lõikelauale";
const DownloadasPDF$i = "Laadi alla PDF-failina";
const ViewDetails$i = "Vaata üksikasju";
const JobDescriptionImported$i = "Töö kirjeldus imporditud";
const ImportfromJob$i = "Töölt importimine";
const Saved$i = "Salvestatud";
const Applied$i = "Kandideeritud";
const Offer$i = "Pakkumine";
const Interviewing$i = "Intervjuu";
const Rejected$i = "Tagasi lükatud";
const Search$i = "Otsi";
const Import$i = "Import";
const CoverLetterGeneratorHistory$i = "Avalduse generaatori ajalugu";
const NoCoverLettersGenerated$i = "Ühtegi kaaskirja pole loodud";
const getStartedCoverLetter$i = "Sa pole veel ühtegi kaaskirja loonud. Alusta ja loo kaaskirjad, sobitades töökirjeldust oma asjakohase kogemusega.";
const getStarted$i = "Alusta!";
const Documents$i = "Dokumendid";
const UploadNewDocument$i = "Laadi üles uus dokument";
const AICoverLetterGenerator$i = "AI kaaskirja generaator";
const ViewHistory$i = "Vaata ajalugu";
const JobDescription$i = "Töö kirjeldus";
const ImportfromBoard$i = "Impordi lauast";
const EnterJobDescription$i = "Sisesta töö kirjeldus";
const JobTitle$i = "Ametinimetus";
const EnterJobTitle$i = "Sisesta ametinimetus";
const CompanyName$i = "Ettevõtte nimi";
const EnterCompanyName$i = "Sisesta ettevõtte nimi";
const YourProfile$i = "Sinu profiil";
const ResumeUpload$i = "CV üleslaadimine";
const UseLinkedinProfile$i = "Kasuta LinkedIni profiili";
const Uploadyourresume$i = "Laadi üles oma CV";
const AddyourResume$i = "Lisa oma CV";
const fileNameCannotFormat$i = "Failinimi ei tohi sisaldada tühikuid ega alakriipse ning see peaks olema kas .doc, .docx või .pdf formaadis.";
const ChooseorUpload$i = "Vali või laadi üles";
const SelectTemplate$i = "Vali mall";
const Preview$i = "Eelvaade";
const UseTemplate$i = "Kasuta malli";
const Change$i = "Muuda";
const AdvancedSettings$i = "Täpsemad seaded";
const AdditionalContext$i = "Lisakontekst";
const Professional$i = "Professionaalne";
const Casual$i = "Vaba";
const Enthusiastic$i = "Vaimustunud";
const Informational$i = "Informatiivne";
const Short$i = "Lühike";
const Medium$i = "Keskmine";
const Long$i = "Pikk";
const Language$i = "Keel";
const iAmOkayBack$i = "Mul on kõik korras! Mine tagasi";
const Generate$i = "Genereeri";
const CoverLetter$i = "Kaaskiri";
const SelectLanguage$i = "Vali keel";
const AboutGeneratorHistory$i = "Teegeneraatori ajalugu";
const NoAboutsGenerated$i = "Ühtegi tutvustust pole loodud";
const getStartedAbouts$i = "Sa ei ole veel ühtegi tutvustust loonud. Alusta ja loo tutvustusi, sobitades töökirjeldust oma asjakohase kogemusega.";
const noAttachmentsFound$i = "Manuseid ei leitud.";
const TargetJobTitle$i = "Siht ametinimetus";
const KeywordsToInclude$i = "Sisse kaasatavad võtmesõnad";
const UploadYourResume$i = "Laadige oma CV üles.";
const AddYourResume$i = "Lisa oma CV.";
const LinkedinProfile$i = "LinkedIni profiil";
const Linkedinprofilenotfound$i = "LinkedIni profiili ei leitud";
const startUsingChromeExtension$i = "Alusta oma LinkedIni profiili optimeerimist meie Chrome'i laienduse abil, et kasutada seda võimalust.";
const Download$i = "Laadi alla";
const UseEmojis$i = "Kasuta emotikone";
const UseBulletPoints$i = "Kasuta märklaudu";
const SpeechFocus$i = "Kõne fookus";
const FirstPerson$i = "Esimene isik";
const ThirdPerson$i = "Kolmas isik";
const HeadlineGeneratorHistory$i = "Pealkirja generaatori ajalugu";
const NoHeadlinesGenerated$i = "Ühtegi pealkirja pole loodud";
const getStartedHeadline$i = "Sa ei ole veel ühtegi pealkirja loonud. Alusta ja loo pealkirjad, sobitades töökirjeldust oma asjakohase kogemusega.";
const AIHeadlineGenerator$i = "AI pealkirja generaator";
const KeywordstoInclude$i = "Sisse kaasatavad märksõnad";
const Pressenteraftereachword$i = "Vajuta iga sõna järel enterit.";
const LinkedinProfilenotfound$i = "LinkedIni profiili ei leitud.";
const Headline$i = "Pealkiri";
const PostGeneratorHistory$i = "Postituse generaatori ajalugu";
const NoPostsGenerated$i = "Ühtegi postitust pole loodud";
const getStartedPost$i = "Sa ei ole veel ühtegi postitust loonud. Alusta ja luo postitusi, sobitades töökirjeldust oma asjakohase kogemusega.";
const Topic$i = "Teema";
const Description$i = "Kirjeldus";
const UseHashtags$i = "Kasuta teemaviiteid";
const Custom$i = "Kohandatud";
const EnterCustomTone$i = "Sisesta kohandatud toon";
const Added$i = "Lisatud";
const ComingSoon$i = {
	header: "Insenerid töötavad!",
	content_1: "Meie inseneride meeskond töötab rasketööl, et see funktsioon võimalikult kiiresti käivituks.",
	content_2: "Soovite seda funktsiooni kiiresti? Andke meile teada, märkides lihtsalt allpool oleva märkeruudu.",
	content_3: "Soovin seda funktsiooni"
};
const Company$i = "Ettevõte";
const JobInterview$i = "Tööintervjuu";
const Research$i = "Uuring";
const Networking$i = "Võrgustik";
const Referral$i = "Soovitus";
const MustbeContacted$i = "Tuleb kontakti võtta";
const ScheduleaMeeting$i = "Kohtumise kokkuleppimine";
const needAFollowUp$i = "Tuleb järelkontrolli teha";
const Today$i = "Täna";
const Viewdetails$i = "Vaata detaile";
const Activity$i = "Tegevus";
const ActivityDetails$i = "Tegevuse üksikasjad";
const Delete$i = "Kustuta";
const Title$i = "Pealkiri";
const Goal$i = "Eesmärk";
const Status$i = "Staatus";
const FollowUp$i = "Järelkontroll";
const AddActivity$i = "Lisa tegevus";
const Enteractivitytitle$i = "Sisesta tegevuse pealkiri";
const Cancel$i = "Tühista";
const SaveActivity$i = "Salvesta tegevus";
const noActivityPresent$i = "Tegevust pole, lisa tegevus.";
const Addnew$i = "Lisa uus";
const About$i = "Info";
const noDataPresentYou$i = "Andmed puuduvad, saate seda kontakti redigeerida ja lisada välju.";
const Experience$i = "Kogemus";
const Education$i = "Haridus";
const Skills$i = "Oskused";
const Overview$i = "Ülevaade";
const LinkedJobs$i = "Seotud töökohad";
const Notes$i = "Märkused";
const FullName$i = "Täisnimi";
const Location$i = "Asukoht";
const Relationship$i = "Suhe";
const Contacts$i = "Kontaktid";
const CreateContact$i = "Loo kontakt";
const NotesCreated$i = "Märkused loodud";
const Notesupdated$i = "Märkused uuendatud";
const Addnote$i = "Lisa märkus";
const areYouSureDeleteNote$i = "Kas olete kindel, et soovite selle märkuse kustutada?";
const Createdby$i = "Loodud";
const notSureWhyResumeCalls$i = "Ei ole kindel, miks teie CV ei too teile vestluskohtumiste kõnesid? ☎️";
const getExpertResumeReview$i = "Saage ekspertide CV ülevaade 💎✨";
const youHaventAddedContacts$i = "Sa pole veel kontakte lisanud.";
const noMatchingContacts$i = "Sobivaid kontakte ei leitud.";
const Link$i = "Link";
const unlink$i = "Lahuta";
const Locationnotavailable$i = "Asukoht pole saadaval";
const Emailnotavailable$i = "E-post pole saadaval";
const PhoneNumbernotavailable$i = "Telefoninumber pole saadaval";
const createdby$i = "loodud";
const areYouSureDeleteContact$i = "Olete kindel, et soovite selle kontakti kustutada?";
const areYouSureUnlinkContact$i = "Olete kindel, et soovite selle kontakti lahutada?";
const Addedbyyou$i = "Lisatud teie poolt";
const Addedby$i = "Lisanud";
const Timeline$i = "Ajalugu";
const Timelineempty$i = "Ajaline joon tühi";
const Discard$i = "Loobu";
const SaveContact$i = "Salvesta kontakt";
const Recruiter$i = "Värbaja";
const Candidate$i = "Kandidaat";
const Colleague$i = "Kolleeg";
const Employee$i = "Töötaja";
const EnterValidEmail$i = "Sisesta kehtiv e-posti aadress";
const EnterValidPhoneNumber$i = "Sisesta kehtiv telefoninumber";
const editingProfileNotAvailable$i = "Profiilifoto muutmine pole veel saadaval.";
const itWillBeSoonAvailable$i = "See on varsti saadaval meie juures.";
const ChromeExtension$i = "Chrome'i laiendus";
const SelectTag$i = "Vali silt";
const FirstName$i = "Eesnimi";
const FirstNameisrequired$i = "Eesnimi on nõutav";
const LastName$i = "Perekonnanimi";
const LastNameisrequired$i = "Perekonnanimi on nõutav";
const Companyisrequired$i = "Ettevõte on nõutud.";
const Email$i = "E-post";
const ThisisnotavalidEmail$i = "See pole kehtiv e-posti aadress.";
const AddEmail$i = "Lisa e-post";
const PhoneNumber$i = "Telefoninumber";
const notaValidPhone$i = "See pole kehtiv telefoninumber. Sisesta ainult numbritega.";
const phoneNoMinimum5char$i = "Telefoninumber peab olema vähemalt 5 tähemärki pikk.";
const phoneNoMinumum15char$i = "Telefoninumber peab olema maksimaalselt 15 tähemärki pikk.";
const AddPhoneNumber$i = "Lisa telefoninumber";
const SelectGoal$i = "Vali eesmärk";
const SelectStatus$i = "Valige staatus";
const Followup$i = "Järelkontroll";
const SocialMedia$i = "Sotsiaalmeedia";
const Linkedinhandle$i = "Linkedin käepide";
const Twitterhandle$i = "Twitteri käepide";
const Facebookhandle$i = "Facebooki käepide";
const Githubhandle$i = "Githubi käepide";
const Gmailhandle$i = "Gmaili käepide";
const Changessavedsuccessfully$i = "Muudatused salvestatud edukalt";
const EditContact$i = "Muuda kontakti";
const BasicInformation$i = "Põhiinfo";
const EditContactDetails$i = "Muuda kontaktandmeid";
const SaveChanges$i = "Salvesta muudatused";
const phoneNoMinimum14char$i = "Telefoninumber peab olema vähemalt 14 tähemärki pikk.";
const LinkedIn$i = "LinkedIn";
const Twitter$i = "Twitter";
const Facebook$i = "Facebook";
const Github$i = "Github";
const Gmail$i = "Gmail";
const youCanWriteAbout$i = "Saate kirjutada oma kogemustest, tööstusharust või oskustest. Inimesed räägivad ka oma saavutustest või varasematest töökogemustest.";
const Addednewsection$i = "Lisatud uus jaotis";
const Removedsuccessfully$i = "Edukalt eemaldatud.";
const Remove$i = "Eemalda";
const Institute$i = "Instituut";
const Schoolisrequired$i = "Kool on kohustuslik.";
const Degree$i = "Kraad";
const StartMonth$i = "Alguskuu";
const StartYear$i = "Algusaasta";
const EndMonth$i = "Kuu lõpp";
const EndYear$i = "Aasta lõpp";
const Addmore$i = "Lisa rohkem";
const PositionTitle$i = "Ametikoha nimetus";
const ExperienceType$i = "Kogemuse tüüp";
const Addednewitem$i = "Lisatud uus ese";
const whatSkillsDoYouEnjoy$i = "Milliseid oskusi sul on või milliste oskuste kasutamisest sa naudid töötamist?";
const Typeskillshere$i = "Sisesta siia oskused";
const LinkedContacts$i = "Seotud kontaktid";
const LinkContact$i = "Seo kontakt";
const NocontactsLinked$i = "Ühtegi kontakti pole seotud";
const JobContactsComponent$i = {
	linkContact: "Kontaktide sidumisega näete kiiresti, kes on selle rolli jaoks olulised inimesed, nagu värbaja, palgajuht jne! Tulevikus saame pakkuda asjakohaseid teadmisi teie kontaktide põhjal."
};
const Nocontacts$i = "Kontakte pole";
const LinkJobto$i = "Seosta töökohtaga";
const Contact$i = "Kontakt";
const Document$i = "Dokument";
const Nojobsfound$i = "Töid ei leitud";
const LinkJob$i = "Seo töö";
const youCanLinkContactJobImported$i = "Saate selle kontakti ühendada karjäärivoolusse imporditud töökohaga.";
const Prev$i = "Eelmine";
const Next$i = "Järgmine";
const areYouSureUnlinkDocument$i = "Olete kindel, et soovite selle dokumendi lahutada?";
const areYouSureDeleteDocument$i = "Olete kindel, et soovite selle dokumendi kustutada?";
const Category$i = "Kategooria";
const CreatedOn$i = "Loodud";
const Joblinked$i = "Töö seotud";
const Quickactions$i = "Kiired tegevused";
const All$i = "Kõik";
const Resume$i = "CV";
const Portfolio$i = "Portfoolio";
const Other$i = "Muu";
const Adddocument$i = "Lisa dokument";
const Type$i = "Tüüp";
const Sortingby$i = "Sorteerimine järgi";
const SwitchtoGridLayout$i = "Vaheta ruudustiku paigutusele.";
const SwitchtoListLayout$i = "Vaheta loendi paigutusele.";
const NoDocumentsAdded$i = "Dokumente pole lisatud";
const DocumentsComponent$i = {
	nodocs: "Te pole veel ühtegi dokumenti loonud. Saate üles laadida oma CV-versioonid, kaaskirjad ja muud ning linkida need jälgitavatele töökohtadele!"
};
const NoDocumentFound$i = "Dokumenti ei leitud.";
const SelectFile$i = "Vali fail";
const onlyPdfDocxSupported$i = "Toetatud on ainult .pdf ja .docx.";
const Uploadfile$i = "Laadi fail üles";
const DocumentCategory$i = "Dokumendi kategooria";
const SaveDocument$i = "Salvesta dokument";
const AddDocument$i = "Lisa dokument";
const LinkedDocuments$i = "Seotud dokumendid";
const LinkDocument$i = "Seo dokument";
const NodocumentsLinked$i = "Ühtegi dokumenti pole seotud";
const JobDocumentsComponent$i = {
	linkDocs: "Kõigi oluliste dokumentide, nagu CV, kaaskiri jne, sidumine selle töö jaoks aitab teil kõike ühes kohas jälgida. Proovige järele!"
};
const NoDocuments$i = "Dokumente pole";
const CreateDocuments$i = "Loo dokumendid";
const youCanLinkDocumentJobImported$i = "Saate selle dokumendi linkida karjääri voogu imporditud tööga.";
const Documenteditedsuccessfully$i = "Dokument on edukalt redigeeritud.";
const DocumentDetails$i = "Dokumendi andmed";
const UnsavedChanges$i = "Salvestamata muudatused";
const yourChangesWillBeLostSureClose$i = "Teie muudatused lähevad kaduma, kas olete kindel, et soovite sulgeda?";
const yourChangesWillBeLostSureDiscard$i = "Teie muudatused kaovad, kas olete kindel, et soovite oma muudatused kustutada?";
const DiscardChanges$i = "Hülga muudatused";
const WeeklyGoalAlert$i = "Iganädalane eesmärgi hoiatus";
const Progress$i = "Edasiminek";
const AllGoals$i = "Kõik eesmärgid";
const Name$i = "Nimi";
const Completedon$i = "Lõpetatud";
const Createdon$i = "Loodud";
const Action$i = "Tegevus";
const Back$i = "Tagasi";
const OverallScore$i = "Üldine skoor";
const Aboutthegoal$i = "Eesmärgi kohta";
const GoalTracking$i = "Eesmärgi jälgimine";
const Week$i = "Nädal";
const progress$i = "edasiminek";
const loading$i = "Laadimine";
const Apply$i = "Kandideeri";
const Thisskillhasbeenreported$i = "See oskus on raporteeritud.";
const issueGettingResume$i = "Probleem tekkis CV saamisega.";
const Interview$i = "Intervjuu";
const Tasks$i = "Ülesanded";
const Loading$i = "Laadimine";
const Skilladdedsuccessfully$i = "Oskus lisati edukalt.";
const problemAddingSkill$i = "Lisamisel tekkis probleem.";
const Reportaproblem$i = "Raporteeri probleem";
const Submit$i = "Esita";
const Addanewskill$i = "Lisa uus oskus";
const JobDetailsComponent$i = {
	classifySkill: "Kuidas klassifitseeriksite seda oskust (valikuline)",
	includedKeywordsWillCount: "Kas kaasata see võtmesõna?",
	yesIncludeThisSkill: "Kaasatud võtmesõnad arvestatakse teie sobivuse skoori kõigi tulevaste skannimiste jaoks. Saate kaasatud võtmesõnu oma profiilist muuta.",
	addSkill: "Kas soovite seda lisada oskuseks?"
};
const HardSkill$i = "Tugev oskus";
const SoftSkill$i = "Pehme oskus";
const Pleaseshareanyadditionalcontext$i = "Jagage palun lisakonteksti";
const Addasskill$i = "Lisa oskusena";
const Skill$i = "Oskus";
const JobFrequency$i = "Töösagedus";
const ResumeFrequency$i = "CV sagedus";
const Reportskill$i = "Teavitage oskusest";
const JobDetails$i = "Töödetailid";
const ViewJobLink$i = "Vaata töölinki";
const Salary$i = "Palk";
const areYouSureDeleteJob$i = "Kas olete kindel, et soovite selle töö kustutada?";
const ViewMore$i = "Vaata rohkem";
const ViewLess$i = "Vaata vähem";
const matchYouSkillsAgainstJob$i = "Võrdle oma oskusi töö kirjeldusega.";
const pleaseUploadResumeSkillMatch$i = "Palun laadige oma CV üles, et saada oma oskuste sobivuse skoor.";
const AddResume$i = "Lisa CV";
const thisJobDoesNotHaveAnyDesc$i = "Sellel tööl pole ühtegi kirjeldust.";
const youCanEditJobToAdd$i = "Saate seda tööd redigeerida, et lisada sellele kirjeldus. Samuti saate töid importida meie abil.";
const chromeextension$i = "Chrome'i laiendus";
const fromVariousJobPortalsOnce$i = "erinevatelt tööportaalidelt. Kui lisate kirjelduse, näete ka oskustega seotud teavet.";
const AddDescription$i = "Lisa kirjeldus.";
const CompanyInfo$i = "Ettevõtte info";
const Website$i = "Veebisait";
const Industry$i = "Tööstusharu";
const EmployeeCount$i = "Töötajate arv";
const ExprienceLevel$i = "Kogemustase";
const Address$i = "Aadress";
const Resumes$i = "Elulookirjeldused";
const Setasdefault$i = "Määra vaikimisi";
const Ok$i = "Ok";
const UploadNewResume$i = "Laadi üles uus CV";
const Default$i = "Vaikimisi";
const Jobnotfound$i = "Tööd ei leitud.";
const EditDetails$i = "Muuda andmeid";
const JobPostURL$i = "Töökuulutuse URL";
const Enterjoburl$i = "Sisesta töö URL";
const Nojobselected$i = "Ühtegi tööd pole valitud.";
const Viewjobdetails$i = "Vaata töö üksikasju";
const Jobaddedtoyourboardsuccessfully$i = "Töö lisatud teie tahvlile edukalt.";
const AddJob$i = "Lisa töökoht";
const Addnewjobname$i = "Lisa uus töö nimi";
const JobUrl$i = "Töö URL";
const Addjoburl$i = "Lisa töö URL";
const Section$i = "Sektsioon";
const didYouKnow$i = {
	chromeExtension: "Kas teadsite? Saate tööd ka otse meie Chrome'i laiendusest salvestada ja kogu teave imporditakse ühe klõpsuga! See võtab vaid mõne sekundi."
};
const Jobs$i = "Töökohad";
const AddJobtoboard$i = "Lisa töökuulutus tahvlile";
const Currentlynojobsareavailable$i = "Hetkel pole töökohti saadaval.";
const noMatchingJobs$i = "Sobivaid töökohti ei leitud.";
const welcomeToYourPersonalJobTracker$i = "Tere tulemast oma isiklikku tööjälgijasse!";
const weShortTutorialOnHowTrackingJob$i = "Me juhendame teid mõne lihtsa sammuga, kuidas alustada oma töötaotluste jälgimist!";
const Addanewjob$i = "Lisa uus töökoht.";
const inOrderTrackCreatButton$i = "Töötaotluste jälgimise alustamiseks peate selle esmalt lisama tahvlile, klõpsates nuppu \"Loo\".";
const Providesomedetails$i = "Andke mõned üksikasjad.";
const toBeginTypeJobTitleCompany$i = "Alustuseks sisestage lihtsalt ametinimetus, ettevõtte nimi ja staatus, mille soovite sellele lisada. Hiljem saate lisada rohkem üksikasju, kuid praegu on see kõik, mida vajate!";
const asAnExampleFilledForYou$i = "Näiteks, me oleme selle juba sinu eest täitnud!";
const wohooAddedFirstJob$i = "Jee! Lisasid oma tööjälgijasse esimese töö!";
const youCanDragDropJobCard$i = "Nüüd saate töökaardi lohistada töötaotluse protsessi erinevatesse etappidesse. Töökaardile klõpsates saate vaadata rohkem üksikasju, neid redigeerida, salvestada märkmeid ja palju muud!";
const Lastbutnotleast$i = "Viimaseks, kuid mitte vähem tähtsaks.";
const finalStepMakeSure$i = "Viimase sammuna veenduge, et teil oleks meie.";
const autoMaticallyImportJobs$i = "mis võimaldab teil automaatselt importida töökohti oma lemmik tööotsingu veebisaitidelt nagu LinkedIn, Indeed ja palju muud! Meie laiendus aitab teil ka parandada oma LinkedIni profiili ja saada 2,5 korda rohkem otsingu ilmumisi!";
const selectanysection$i = "valige mis tahes jaotis";
const Accept$i = "Võta vastu";
const My2023JobSearch$i = "Minu 2023. aasta tööotsing";
const AddedFrom$i = "Lisatud alates";
const AddedUntil$i = "Lisatud kuni";
const BasicModal$i = "Põhiline moodalaken";
const AddnewSectionName$i = "Lisa uus sektsiooni nimi";
const OpenTo$i = "Avatud";
const Featured$i = "Esiletõstetud";
const LicenceAndCerts$i = "Litsentsid ja tunnistused";
const Banner$i = "Bänner";
const LinkedInURL$i = "LinkedIni URL";
const Recommendations$i = "Soovitused";
const LinkedinReview$i = "Linkedin ülevaade";
const NoDataAvailable$i = "Andmed puuduvad.";
const looksLikeYouDidNot$i = "Tundub, et te ei ole veel meie oma kasutama hakanud.";
const toOptimizeProfileScoreVisible$i = "Teie LinkedIni profiili optimeerimine pole veel toimunud. Kui olete seda teinud, on teie profiili skoor siin nähtav.";
const LinkedinComponent$i = {
	letsOptimize: "Optimeerime"
};
const improveYourChancesLandingDreamJob$i = "Paranda oma võimalusi oma unistuste töö leidmisel. Kasuta neid proovitud ja testitud strateegiaid, et anda oma LinkedIni profiilile vajalik uuendus.";
const VisitProfile$i = "Külasta profiili";
const wantToGetLinkedinMakeover$i = "Kas soovite saada täieliku LinkedIni uuenduse?";
const PostGenerator$i = "Postituse koostaja";
const LinkedinHeadlineGenerator$i = "LinkedIni pealkirja koostaja";
const LinkedinAboutSectionGenerator$i = "LinkedIni 'Kes ma olen' osa koostaja";
const AITools$i = "AI tööriistad";
const Premium$i = "Premium";
const LinkedInOptimization$i = "LinkedIn'i optimeerimine";
const JobTracker$i = "Tööde jälgija";
const whoIsHiring$i = "Kes värbab";
const Autofill$i = "Automaatne täitmine";
const HeadlineGenerator$i = "Pealkirjade generaator";
const skillMatching$i = "Oskuste sobitamine";
const SummarizeJD$i = "Töö kirjelduse kokkuvõte";
const contactFeature$i = "Kontaktide jälgimine";
const documentFeature$i = "Dokumendid";
const landJobWithoutStress$i = "Maandage oma unistuste töö. Stressita.";
const discoverFeatures$i = "Avasta Careerflow.ai funktsioonide valik, mis on loodud sinu tööotsingu lihtsustamiseks ja professionaalse teekonna täiustamiseks!";
const letsBeginOnboarding$i = "Aitame sind paremini tundma õppida!";
const inTheNextFewScreensJobThirdParties$i = "Järgnevatel ekraanidel küsime teilt mõningaid küsimusi, mis aitavad meil kohandada teie kogemust ning täita automaatselt teie töötaotlusi (nii et te ei pea seda tegema)! Me ei müü teie andmeid kolmandatele osapooltele.";
const letsAddBasicInformation$i = "Lisame teie põhiinformatsiooni";
const Pleaseselectanoptionfirst$i = "Palun valige esmalt valik.";
const JobApplicationTracker$i = "Töötaotluste jälgija";
const LinkedInProfileOptimizer$i = "Linked In'i profiili optimeerija";
const UnlimitedDocuments$i = "Piiramatud dokumendid";
const UnlimitedContacts$i = "Piiramatu arv kontakte.";
const HiringManagerSearch$i = "Värbamisjuhi otsing";
const AILinkedInPostGenerator$i = "AI LinkedIni postituste generaator";
const ATSKeywordSkillMatch$i = "ATS võtmesõna / oskuste vastavus tööle";
const ChooseyourPlan$i = "Vali oma plaan.";
const superChargeYourJobSearch$i = "Tõsta oma tööotsingut uuele tasemele ja paranda oma töötaotluse protsessi, suurenda oma intervjuude arvu ja saavuta oma unistuste töö. Kõik see Careerflow'i kvaliteetse tööriistakomplekti abil.";
const startNowGoto$i = "Alusta kohe (Mine rakendusse)";
const CreatedBy$i = "Loodud";
const CreateNewNote$i = "Loo uus märkus";
const Nonotescreated$i = "Märkmeid pole loodud";
const approxTimeIsFourMinutes$i = "Uue töötaja sissejuhatamise protsessi lõpetamise ligikaudne aeg on 4 minutit.";
const Continue$i = "Jätka";
const iWillDoLaterTakeMeToApp$i = "Ma teen selle hiljem. Viige mind rakendusse.";
const allDone$i = "Kõik tehtud!";
const welcomeAbord$i = "Tere tulemast pardale!";
const letsBegin$i = "Alustame";
const UpgradeyourplanandgetAIAssistance$i = "Uuenda oma plaani ja saa AI abi.";
const DownloadPDF$i = "Laadi alla PDF";
const oopsWeCouldntProcessResume$i = "Ups, me ei suutnud seda CV-d töödelda.";
const MyProfile$i = "Minu profiil";
const Setting$i = "Seadistus";
const Logout$i = "Logi välja";
const SignIn$i = "Logi sisse";
const Typeyourfirstnamehere$i = "Sinu eesnimi";
const Enteryourlastname$i = "Teie perekonnanimi";
const ManageSubscription$i = "Haldama tellimust";
const ifYouHaveDifficultiesProfile$i = "Kui teil on probleeme oma profiili teabega, võtke palun ühendust.";
const forSupport$i = "toetuseks.";
const whatIsIdealCompanySize$i = "Mis on teie ideaalne ettevõtte suurus?";
const Saveandcontinue$i = "Salvesta ja jätku";
const whatIsMinExpectedSalary$i = "Mis on teie minimaalne oodatav palk (aastas)?";
const Atleast$i = "Vähemalt";
const SlidetoAdjust$i = "Liiguta reguleerimiseks";
const whatIndustryExcitedWork$i = "Millised tööstusharud teid põnevad?";
const Add$i = "Lisa";
const statusOfJobSearch$i = "Sinu tööotsingu staatus?";
const Finish$i = "Lõpeta";
const whatLevelRoleLooking$i = "Millise taseme rolli otsid?";
const Selectuptotwo$i = "Valige kuni kaks.";
const PreviousStep$i = "Eelmine samm";
const Skip$i = "Jäta vahele";
const whatDoYouValueNewRole$i = "Mida hindate uues rollis?";
const Selectuptothree$i = "Valige kuni kolm.";
const EqualEmploymentData$i = "Võrdne tööhõive andmed";
const whatIsYourEthnicity$i = "Mis on teie rahvus?";
const areYouAuthorizedToWorkUs$i = "Kas teil on luba töötada Ameerika Ühendriikides?";
const willYouRequireSponsorShip$i = "Kas vajate praegu või tulevikus tööviisa staatuse jaoks sponsoreerimist?";
const doYouHaveADisability$i = "Kas teil on puue?";
const areYouAVeteran$i = "Kas olete veteran?";
const rolesYouInterestedIn$i = "Millist tüüpi rolle te olete huvitatud?";
const Selectuptofive$i = "Valige kuni viis.";
const AddCustomrole$i = "Lisa kohandatud roll";
const whereDoYouLikeWork$i = "Kus sa tahaksid töötada?";
const Resources$i = "Ressursid";
const currentlyNoResourceAvailable$i = "Hetkel pole ressursse saadaval.";
const AddNewSection$i = "Lisa uus sektsioon";
const ChangeSections$i = "Muuda jaotisi";
const Settings$i = "Seaded";
const Dashboard$i = "Armatuurlaud";
const JobBoard$i = "Töölaud";
const Linkedin$i = "Linkedin";
const Community$i = "Kogukond";
const FindRecruiters$i = "Leia värbajad";
const Goals$i = "Eesmärgid";
const DownloadExtension$i = "Laadi laiendus alla";
const SuggestaFeature$i = "Paku funktsiooni";
const leftPanel$i = {
	ReportanIssue: "Teata probleemist"
};
const PhoneNumberisrequired$i = "Telefoninumber on kohustuslik.";
const MobileNumber$i = "Telefoninumber";
const Enteronlynumbers$i = "Sisesta ainult numbreid.";
const Countryyoulivein$i = "Riik, kus sa elad";
const SelectaCountry$i = "Vali riik.";
const DateofBirth$i = "Sünniaeg";
const Gender$i = "Sugu";
const JobPreferences$i = "Tööeelistused";
const pleaseEnterValidEmail$i = "Palun sisesta kehtiv e-posti aadress.";
const emailSendForResetting$i = "Teile on saadetud e-kiri parooli lähtestamiseks.";
const VerifyyourEmailID$i = "Kinnitage oma e-posti aadressi.";
const sentPleaseCheckEmail$i = "Saadetud! Palun kontrolli oma e-posti.";
const tooManyAttemptsTryAgain$i = "Liiga palju katseid, palun proovige uuesti mõne aja pärast.";
const Resend$i = "Uuesti saatmine";
const Login$i = "Sisselogimine";
const weHaveSentVerificationLinkAtEmail$i = "Oleme saatnud teile kinnituse lingi teie e-posti aadressile.";
const pleaseVerifyEmailContinueSpam$i = "Palun kinnitage oma e-posti aadress jätkamiseks. Palun kontrollige ka rämpsposti või reklaamide kausta kinnituse meili jaoks.";
const Logintogetstarted$i = "Sisselogimiseks alustamiseks.";
const ContinuewithGoogle$i = "Jätka Google'iga";
const pleaseInputEmail$i = "Palun sisestage oma e-posti aadress!";
const Password$i = "Parool";
const pleaseInputPassword$i = "Palun sisesta oma parool!";
const passwordLowerUpperDigitSpecial$i = "Teie parool peab sisaldama vähemalt ühte väiketähte, suurtähte, numbrit ja erimärki.";
const atLeastSixChar$i = "Vähemalt 6 tähemärki.";
const forgotPassword$i = "Unustasid parooli?";
const Bysigninginyouagreetoour$i = "Sisse logides nõustute meiega.";
const Terms$i = "tingimused";
const Conditions$i = "tingimused";
const and$i = "ja";
const PrivacyPolicy$i = "Privaatsuspoliitika";
const theseAreTheTopsSkillsExtracted$i = "Need on välja toodud töö kirjeldusest kõige olulisemad oskused.";
const TopSkills$i = "Tipuoskused";
const weCoulNotExtractSkills$i = "Me ei suutnud selle töö kirjeldusest välja tuua ühtegi oskust.";
const upgradeToPremiumToView$i = "Uuenda Premiumi, et näha oma CV oskuste sobivuse skoori.";
const SkillScore$i = "Oskuste skoor";
const thisIsYourSkillScoreBasedOn$i = "See on teie oskuste skoor töökirjelduse ja teie CV põhjal.";
const theseSkllsAreStrongMatch$i = "Need oskused sobivad hästi teie CV ja töökirjeldusega.";
const Strongmatch$i = "Tugev sobitus";
const theseSkillsArePartialMatch$i = "Need oskused on osaline sobivus teie CV ja töökirjelduse vahel.";
const Partialmatch$i = "Osaline sobivus";
const theseSkillsAreMissingFrom$i = "Need märksõnad puuduvad teie CV-st, kuid need on olemas töökirjelduses. Need võivad olla oskused või üldised märksõnad, mis on spetsiifilised töövõimalusele ja võivad olla kasulikud lisada oma CV-sse.";
const SkillMatchComponent$i = {
	removeSkill: "Mis on teie peamine põhjus märksõna probleemiks teatamiseks"
};
const Optional$i = "Valikuline";
const Notrelevanttothejob$i = "Ei ole seotud tööga";
const Notaskill$i = "Pole oskus";
const Toogeneric$i = "Liiga üldine";
const Pleaseshareanyfeedback$i = "Jagage palun tagasisidet";
const excludedKeywordsWillNot$i = "Välja jäetud võtmesõnad ei mõjuta teie sobivuse skoori tulevikus tehtavate skannimiste jaoks. Võite välja jäetud võtmesõnu oma profiilist muuta.";
const yesExcludeThisSkillFrom$i = "Jah, jätke see oskus kõigist minu CV skannimistest välja.";
const PartialMatch$i = "Osittane sobitus";
const MissingKeywords$i = "Puuduvad märksõnad";
const Providetitletotask$i = "Andke ülesandele pealkiri.";
const TasksList$i = "Ülesannete nimekiri";
const AddTask$i = "Lisa ülesanne";
const EnterTaskTitlehere$i = "Sisestage ülesande pealkiri siia";
const TasksComponent$i = {
	listEmpty: "Ülesandeloend on tühi, looge uus."
};
const CompletedTasks$i = "Lõpetatud ülesanded";
const CompleteYourtasks$i = "Täitke oma ülesanded";
const Steps$i = "Sammud";
const PremiumMember$i = "Premium liige";
const Thankyouforupgradingto$i = "Täname uuendamise eest.";
const CareerflowPremium$i = "Karjääri vool Premium";
const hereIsHowYouCanAccessPremium$i = "Siin on, kuidas saate juurdepääsu oma Premiumi eelistele!";
const stepOne$i = "Samm 1";
const DownloadourChromeExtension$i = "Laadige alla meie Chrome'i laiendus.";
const youJobSearchCopilotIshere$i = "Teie tööotsingu AI kaaspiloot on siin.";
const DownloadNow$i = "Laadi alla kohe.";
const stepTwo$i = "Samm 2";
const GetStarted$i = "Alusta";
const stepThree$i = "Samm 3";
const SignintoChromeExtension$i = "Logi sisse Chrome'i laiendusse.";
const entityCreated$i = "Uus {{entity}} loodud.";
const entityUpdated$i = "{{entity}} uuendatud.";
const entityDeleted$i = "{{entity}} kustutatud.";
const entityLinked$i = "{{entity}} seotud";
const entityUnlinked$i = "{{entity}} lahtiühendatud";
const entityMovedTo$i = "Kolinud {{entity}} juurde.";
const youAddedANewEntity$i = "Lisasid uue {{entity}}.";
const personCreated$i = "{{creator}} lõi {{entity}} omanikule {{owner}}.";
const youUpdatedAEntity$i = "Te värskendasite {{entity}}.";
const personUpdated$i = "{{creator}} uuendas {{entity}} kasutaja {{owner}} jaoks.";
const youDeletedAEntity$i = "Sa kustutasid {{entity}}.";
const personDeleted$i = "{{creator}} kustutas {{entity}} kasutaja {{owner}} jaoks.";
const youLinkedEntity$i = "Sa oled seotud selle tööga {{entity}}.";
const personLinked$i = "{{creator}} seostas selle töö omanikuga {{owner}} seotud {{entity}}.";
const youUnlinked$i = "Te lahutasite selle tööga seotud {{entity}}.";
const personUnlinked$i = "{{creator}} lahutas selle töö omanikult {{owner}} seotud {{entity}}.";
const youMovedEntity$i = "Te liigutasite selle {{entity}} osakonnast {{sectionFrom}} osakonda {{sectionTo}}.";
const personMoved$i = "{{creator}} liigutas selle {{entity}} osakonnast {{sectionFrom}} osakonda {{sectionTo}} omaniku {{owner}} jaoks.";
const addedByName$i = "Lisatud {{name}} poolt.";
const DownloadChromeExtension$i = "Laadi alla Chrome'i laiendus.";
const ourChromeExtensionIs$i = "Meie Chrome'i laiendus on integreeritud tööriist, mis aitab teil optimeerida LinkedIni profiili, salvestada töökohti, salvestada kontakte, luua kaaskirju ja palju muud.";
const Optimizeyourprofile$i = "Optimeeri oma profiil.";
const startOptimizingYourProfile$i = "Alusta oma profiili optimeerimist, et suurendada võimalusi saada kontakti värbajatega.";
const OptimizeNow$i = "Optimeeri kohe";
const Addyourfirstjob$i = "Lisa oma esimene töökoht.";
const startSavingJobApplicationsToTrack$i = "Alusta töötaotluste salvestamist, et jälgida oma tööotsingu teekonda ja leida kasulikke teadmisi.";
const AddNow$i = "Lisa nüüd.";
const CompleteProfile$i = "Täielik profiil";
const completeYourProfileForUsing$i = "Täitke oma profiil, et kasutada automaatse täitmise funktsiooni ja saada isikupärasem kogemus.";
const CompleteNow$i = "Valmis nüüd";
const Addyourfirstcontact$i = "Lisa oma esimene kontakt.";
const addContactToFollowUpWith$i = "Lisage kontakt, kellega hiljem ühendust võtta, lisage märkmeid ja muud.";
const JoinCommunity$i = "Liitu kogukonnaga.";
const ourCommunityisAlways$i = "Meie kogukond on alati sinuga koos sinu tööotsingu teekonnal.";
const JoinNow$i = "Liitu nüüd.";
const welcomeToCareerflow$i = "Tere tulemast Careerflow'sse!";
const yourHubForCareerInsights2$i = "See on teie karjääri ülevaate, tegevuste ja muu jaoks keskne koht. Avastage oma isikupärastatud töölauda, et jääda oma professionaalsel teekonnal kursis.";
const ChecklistCompleted$i = "Teie kontrollnimekiri on täidetud!";
const Completeyourchecklist$i = "Täida oma kontrollnimekiri.";
const completeAFewStepsTo$i = "Täida mõned sammud, et saada oma järgmine töökoht.";
const Completed$i = "Lõpule viidud";
const JobCountByStage$i = "Tööde arv etappide kaupa";
const NopastapplicationDatafound$i = "Eelnevaid taotluse andmeid ei leitud.";
const YourJobSearchStages$i = "Sinu tööotsingu etapid";
const NoDatafound$i = "Andmeid ei leitud.";
const et = {
	copyToClipboard: copyToClipboard$i,
	UnlocktheAIgenerated: UnlocktheAIgenerated$i,
	UpgradetoPremium: UpgradetoPremium$i,
	Result: Result$i,
	Copy: Copy$i,
	Save: Save$i,
	Edit: Edit$i,
	Processing: Processing$i,
	YourAIgeneratedcontentwillshowhere: YourAIgeneratedcontentwillshowhere$i,
	hopeYouFindUseful: hopeYouFindUseful$i,
	regenerate: regenerate$i,
	ProvideAdditionalFeedback: ProvideAdditionalFeedback$i,
	Enteranyfeedback: Enteranyfeedback$i,
	Notimpressive: Notimpressive$i,
	thisIsntTrue: thisIsntTrue$i,
	Notpersonalized: Notpersonalized$i,
	Tone: Tone$i,
	Length: Length$i,
	Template: Template$i,
	Generatedon: Generatedon$i,
	Copiedtoclipboard: Copiedtoclipboard$i,
	CopytoClipboard: CopytoClipboard$i,
	DownloadasPDF: DownloadasPDF$i,
	ViewDetails: ViewDetails$i,
	JobDescriptionImported: JobDescriptionImported$i,
	ImportfromJob: ImportfromJob$i,
	Saved: Saved$i,
	Applied: Applied$i,
	Offer: Offer$i,
	Interviewing: Interviewing$i,
	Rejected: Rejected$i,
	Search: Search$i,
	Import: Import$i,
	CoverLetterGeneratorHistory: CoverLetterGeneratorHistory$i,
	NoCoverLettersGenerated: NoCoverLettersGenerated$i,
	getStartedCoverLetter: getStartedCoverLetter$i,
	getStarted: getStarted$i,
	Documents: Documents$i,
	UploadNewDocument: UploadNewDocument$i,
	AICoverLetterGenerator: AICoverLetterGenerator$i,
	ViewHistory: ViewHistory$i,
	JobDescription: JobDescription$i,
	ImportfromBoard: ImportfromBoard$i,
	EnterJobDescription: EnterJobDescription$i,
	JobTitle: JobTitle$i,
	EnterJobTitle: EnterJobTitle$i,
	CompanyName: CompanyName$i,
	EnterCompanyName: EnterCompanyName$i,
	YourProfile: YourProfile$i,
	ResumeUpload: ResumeUpload$i,
	UseLinkedinProfile: UseLinkedinProfile$i,
	Uploadyourresume: Uploadyourresume$i,
	AddyourResume: AddyourResume$i,
	fileNameCannotFormat: fileNameCannotFormat$i,
	ChooseorUpload: ChooseorUpload$i,
	SelectTemplate: SelectTemplate$i,
	Preview: Preview$i,
	UseTemplate: UseTemplate$i,
	Change: Change$i,
	AdvancedSettings: AdvancedSettings$i,
	AdditionalContext: AdditionalContext$i,
	Professional: Professional$i,
	Casual: Casual$i,
	Enthusiastic: Enthusiastic$i,
	Informational: Informational$i,
	Short: Short$i,
	Medium: Medium$i,
	Long: Long$i,
	Language: Language$i,
	iAmOkayBack: iAmOkayBack$i,
	Generate: Generate$i,
	CoverLetter: CoverLetter$i,
	SelectLanguage: SelectLanguage$i,
	AboutGeneratorHistory: AboutGeneratorHistory$i,
	NoAboutsGenerated: NoAboutsGenerated$i,
	getStartedAbouts: getStartedAbouts$i,
	noAttachmentsFound: noAttachmentsFound$i,
	TargetJobTitle: TargetJobTitle$i,
	KeywordsToInclude: KeywordsToInclude$i,
	UploadYourResume: UploadYourResume$i,
	AddYourResume: AddYourResume$i,
	LinkedinProfile: LinkedinProfile$i,
	Linkedinprofilenotfound: Linkedinprofilenotfound$i,
	startUsingChromeExtension: startUsingChromeExtension$i,
	Download: Download$i,
	UseEmojis: UseEmojis$i,
	UseBulletPoints: UseBulletPoints$i,
	SpeechFocus: SpeechFocus$i,
	FirstPerson: FirstPerson$i,
	ThirdPerson: ThirdPerson$i,
	HeadlineGeneratorHistory: HeadlineGeneratorHistory$i,
	NoHeadlinesGenerated: NoHeadlinesGenerated$i,
	getStartedHeadline: getStartedHeadline$i,
	AIHeadlineGenerator: AIHeadlineGenerator$i,
	KeywordstoInclude: KeywordstoInclude$i,
	Pressenteraftereachword: Pressenteraftereachword$i,
	LinkedinProfilenotfound: LinkedinProfilenotfound$i,
	Headline: Headline$i,
	PostGeneratorHistory: PostGeneratorHistory$i,
	NoPostsGenerated: NoPostsGenerated$i,
	getStartedPost: getStartedPost$i,
	Topic: Topic$i,
	Description: Description$i,
	UseHashtags: UseHashtags$i,
	Custom: Custom$i,
	EnterCustomTone: EnterCustomTone$i,
	Added: Added$i,
	ComingSoon: ComingSoon$i,
	Company: Company$i,
	JobInterview: JobInterview$i,
	Research: Research$i,
	Networking: Networking$i,
	Referral: Referral$i,
	MustbeContacted: MustbeContacted$i,
	ScheduleaMeeting: ScheduleaMeeting$i,
	needAFollowUp: needAFollowUp$i,
	Today: Today$i,
	Viewdetails: Viewdetails$i,
	Activity: Activity$i,
	ActivityDetails: ActivityDetails$i,
	Delete: Delete$i,
	Title: Title$i,
	Goal: Goal$i,
	Status: Status$i,
	FollowUp: FollowUp$i,
	AddActivity: AddActivity$i,
	Enteractivitytitle: Enteractivitytitle$i,
	Cancel: Cancel$i,
	SaveActivity: SaveActivity$i,
	noActivityPresent: noActivityPresent$i,
	Addnew: Addnew$i,
	About: About$i,
	noDataPresentYou: noDataPresentYou$i,
	Experience: Experience$i,
	Education: Education$i,
	Skills: Skills$i,
	Overview: Overview$i,
	LinkedJobs: LinkedJobs$i,
	Notes: Notes$i,
	FullName: FullName$i,
	Location: Location$i,
	Relationship: Relationship$i,
	Contacts: Contacts$i,
	CreateContact: CreateContact$i,
	NotesCreated: NotesCreated$i,
	Notesupdated: Notesupdated$i,
	Addnote: Addnote$i,
	areYouSureDeleteNote: areYouSureDeleteNote$i,
	Createdby: Createdby$i,
	notSureWhyResumeCalls: notSureWhyResumeCalls$i,
	getExpertResumeReview: getExpertResumeReview$i,
	youHaventAddedContacts: youHaventAddedContacts$i,
	noMatchingContacts: noMatchingContacts$i,
	Link: Link$i,
	unlink: unlink$i,
	Locationnotavailable: Locationnotavailable$i,
	Emailnotavailable: Emailnotavailable$i,
	PhoneNumbernotavailable: PhoneNumbernotavailable$i,
	createdby: createdby$i,
	areYouSureDeleteContact: areYouSureDeleteContact$i,
	areYouSureUnlinkContact: areYouSureUnlinkContact$i,
	Addedbyyou: Addedbyyou$i,
	Addedby: Addedby$i,
	Timeline: Timeline$i,
	Timelineempty: Timelineempty$i,
	Discard: Discard$i,
	SaveContact: SaveContact$i,
	Recruiter: Recruiter$i,
	Candidate: Candidate$i,
	Colleague: Colleague$i,
	Employee: Employee$i,
	"Needtofollow-up": "Vajab järelkontrolli",
	EnterValidEmail: EnterValidEmail$i,
	EnterValidPhoneNumber: EnterValidPhoneNumber$i,
	editingProfileNotAvailable: editingProfileNotAvailable$i,
	itWillBeSoonAvailable: itWillBeSoonAvailable$i,
	ChromeExtension: ChromeExtension$i,
	SelectTag: SelectTag$i,
	FirstName: FirstName$i,
	FirstNameisrequired: FirstNameisrequired$i,
	LastName: LastName$i,
	LastNameisrequired: LastNameisrequired$i,
	Companyisrequired: Companyisrequired$i,
	Email: Email$i,
	ThisisnotavalidEmail: ThisisnotavalidEmail$i,
	AddEmail: AddEmail$i,
	PhoneNumber: PhoneNumber$i,
	notaValidPhone: notaValidPhone$i,
	phoneNoMinimum5char: phoneNoMinimum5char$i,
	phoneNoMinumum15char: phoneNoMinumum15char$i,
	AddPhoneNumber: AddPhoneNumber$i,
	SelectGoal: SelectGoal$i,
	SelectStatus: SelectStatus$i,
	Followup: Followup$i,
	SocialMedia: SocialMedia$i,
	Linkedinhandle: Linkedinhandle$i,
	Twitterhandle: Twitterhandle$i,
	Facebookhandle: Facebookhandle$i,
	Githubhandle: Githubhandle$i,
	Gmailhandle: Gmailhandle$i,
	Changessavedsuccessfully: Changessavedsuccessfully$i,
	EditContact: EditContact$i,
	BasicInformation: BasicInformation$i,
	EditContactDetails: EditContactDetails$i,
	SaveChanges: SaveChanges$i,
	phoneNoMinimum14char: phoneNoMinimum14char$i,
	LinkedIn: LinkedIn$i,
	Twitter: Twitter$i,
	Facebook: Facebook$i,
	Github: Github$i,
	Gmail: Gmail$i,
	youCanWriteAbout: youCanWriteAbout$i,
	Addednewsection: Addednewsection$i,
	Removedsuccessfully: Removedsuccessfully$i,
	Remove: Remove$i,
	Institute: Institute$i,
	Schoolisrequired: Schoolisrequired$i,
	Degree: Degree$i,
	StartMonth: StartMonth$i,
	StartYear: StartYear$i,
	EndMonth: EndMonth$i,
	EndYear: EndYear$i,
	Addmore: Addmore$i,
	PositionTitle: PositionTitle$i,
	ExperienceType: ExperienceType$i,
	Addednewitem: Addednewitem$i,
	whatSkillsDoYouEnjoy: whatSkillsDoYouEnjoy$i,
	Typeskillshere: Typeskillshere$i,
	LinkedContacts: LinkedContacts$i,
	LinkContact: LinkContact$i,
	NocontactsLinked: NocontactsLinked$i,
	JobContactsComponent: JobContactsComponent$i,
	Nocontacts: Nocontacts$i,
	LinkJobto: LinkJobto$i,
	Contact: Contact$i,
	Document: Document$i,
	Nojobsfound: Nojobsfound$i,
	LinkJob: LinkJob$i,
	youCanLinkContactJobImported: youCanLinkContactJobImported$i,
	Prev: Prev$i,
	Next: Next$i,
	areYouSureUnlinkDocument: areYouSureUnlinkDocument$i,
	areYouSureDeleteDocument: areYouSureDeleteDocument$i,
	Category: Category$i,
	CreatedOn: CreatedOn$i,
	Joblinked: Joblinked$i,
	Quickactions: Quickactions$i,
	All: All$i,
	Resume: Resume$i,
	Portfolio: Portfolio$i,
	Other: Other$i,
	Adddocument: Adddocument$i,
	Type: Type$i,
	Sortingby: Sortingby$i,
	SwitchtoGridLayout: SwitchtoGridLayout$i,
	SwitchtoListLayout: SwitchtoListLayout$i,
	NoDocumentsAdded: NoDocumentsAdded$i,
	DocumentsComponent: DocumentsComponent$i,
	NoDocumentFound: NoDocumentFound$i,
	SelectFile: SelectFile$i,
	onlyPdfDocxSupported: onlyPdfDocxSupported$i,
	Uploadfile: Uploadfile$i,
	DocumentCategory: DocumentCategory$i,
	SaveDocument: SaveDocument$i,
	AddDocument: AddDocument$i,
	LinkedDocuments: LinkedDocuments$i,
	LinkDocument: LinkDocument$i,
	NodocumentsLinked: NodocumentsLinked$i,
	JobDocumentsComponent: JobDocumentsComponent$i,
	NoDocuments: NoDocuments$i,
	CreateDocuments: CreateDocuments$i,
	youCanLinkDocumentJobImported: youCanLinkDocumentJobImported$i,
	Documenteditedsuccessfully: Documenteditedsuccessfully$i,
	DocumentDetails: DocumentDetails$i,
	UnsavedChanges: UnsavedChanges$i,
	yourChangesWillBeLostSureClose: yourChangesWillBeLostSureClose$i,
	yourChangesWillBeLostSureDiscard: yourChangesWillBeLostSureDiscard$i,
	DiscardChanges: DiscardChanges$i,
	WeeklyGoalAlert: WeeklyGoalAlert$i,
	Progress: Progress$i,
	AllGoals: AllGoals$i,
	Name: Name$i,
	Completedon: Completedon$i,
	Createdon: Createdon$i,
	Action: Action$i,
	Back: Back$i,
	OverallScore: OverallScore$i,
	Aboutthegoal: Aboutthegoal$i,
	GoalTracking: GoalTracking$i,
	Week: Week$i,
	progress: progress$i,
	loading: loading$i,
	Apply: Apply$i,
	Thisskillhasbeenreported: Thisskillhasbeenreported$i,
	issueGettingResume: issueGettingResume$i,
	Interview: Interview$i,
	Tasks: Tasks$i,
	Loading: Loading$i,
	Skilladdedsuccessfully: Skilladdedsuccessfully$i,
	problemAddingSkill: problemAddingSkill$i,
	Reportaproblem: Reportaproblem$i,
	Submit: Submit$i,
	Addanewskill: Addanewskill$i,
	JobDetailsComponent: JobDetailsComponent$i,
	HardSkill: HardSkill$i,
	SoftSkill: SoftSkill$i,
	Pleaseshareanyadditionalcontext: Pleaseshareanyadditionalcontext$i,
	Addasskill: Addasskill$i,
	Skill: Skill$i,
	JobFrequency: JobFrequency$i,
	ResumeFrequency: ResumeFrequency$i,
	Reportskill: Reportskill$i,
	JobDetails: JobDetails$i,
	ViewJobLink: ViewJobLink$i,
	Salary: Salary$i,
	areYouSureDeleteJob: areYouSureDeleteJob$i,
	ViewMore: ViewMore$i,
	ViewLess: ViewLess$i,
	matchYouSkillsAgainstJob: matchYouSkillsAgainstJob$i,
	pleaseUploadResumeSkillMatch: pleaseUploadResumeSkillMatch$i,
	AddResume: AddResume$i,
	thisJobDoesNotHaveAnyDesc: thisJobDoesNotHaveAnyDesc$i,
	youCanEditJobToAdd: youCanEditJobToAdd$i,
	chromeextension: chromeextension$i,
	fromVariousJobPortalsOnce: fromVariousJobPortalsOnce$i,
	AddDescription: AddDescription$i,
	CompanyInfo: CompanyInfo$i,
	Website: Website$i,
	Industry: Industry$i,
	EmployeeCount: EmployeeCount$i,
	ExprienceLevel: ExprienceLevel$i,
	Address: Address$i,
	Resumes: Resumes$i,
	Setasdefault: Setasdefault$i,
	Ok: Ok$i,
	UploadNewResume: UploadNewResume$i,
	Default: Default$i,
	Jobnotfound: Jobnotfound$i,
	EditDetails: EditDetails$i,
	JobPostURL: JobPostURL$i,
	Enterjoburl: Enterjoburl$i,
	Nojobselected: Nojobselected$i,
	Viewjobdetails: Viewjobdetails$i,
	Jobaddedtoyourboardsuccessfully: Jobaddedtoyourboardsuccessfully$i,
	AddJob: AddJob$i,
	Addnewjobname: Addnewjobname$i,
	JobUrl: JobUrl$i,
	Addjoburl: Addjoburl$i,
	Section: Section$i,
	didYouKnow: didYouKnow$i,
	Jobs: Jobs$i,
	AddJobtoboard: AddJobtoboard$i,
	Currentlynojobsareavailable: Currentlynojobsareavailable$i,
	noMatchingJobs: noMatchingJobs$i,
	welcomeToYourPersonalJobTracker: welcomeToYourPersonalJobTracker$i,
	weShortTutorialOnHowTrackingJob: weShortTutorialOnHowTrackingJob$i,
	Addanewjob: Addanewjob$i,
	inOrderTrackCreatButton: inOrderTrackCreatButton$i,
	Providesomedetails: Providesomedetails$i,
	toBeginTypeJobTitleCompany: toBeginTypeJobTitleCompany$i,
	asAnExampleFilledForYou: asAnExampleFilledForYou$i,
	wohooAddedFirstJob: wohooAddedFirstJob$i,
	youCanDragDropJobCard: youCanDragDropJobCard$i,
	Lastbutnotleast: Lastbutnotleast$i,
	finalStepMakeSure: finalStepMakeSure$i,
	autoMaticallyImportJobs: autoMaticallyImportJobs$i,
	selectanysection: selectanysection$i,
	Accept: Accept$i,
	My2023JobSearch: My2023JobSearch$i,
	AddedFrom: AddedFrom$i,
	AddedUntil: AddedUntil$i,
	BasicModal: BasicModal$i,
	AddnewSectionName: AddnewSectionName$i,
	OpenTo: OpenTo$i,
	Featured: Featured$i,
	LicenceAndCerts: LicenceAndCerts$i,
	Banner: Banner$i,
	LinkedInURL: LinkedInURL$i,
	Recommendations: Recommendations$i,
	LinkedinReview: LinkedinReview$i,
	NoDataAvailable: NoDataAvailable$i,
	looksLikeYouDidNot: looksLikeYouDidNot$i,
	toOptimizeProfileScoreVisible: toOptimizeProfileScoreVisible$i,
	LinkedinComponent: LinkedinComponent$i,
	improveYourChancesLandingDreamJob: improveYourChancesLandingDreamJob$i,
	VisitProfile: VisitProfile$i,
	wantToGetLinkedinMakeover: wantToGetLinkedinMakeover$i,
	PostGenerator: PostGenerator$i,
	LinkedinHeadlineGenerator: LinkedinHeadlineGenerator$i,
	LinkedinAboutSectionGenerator: LinkedinAboutSectionGenerator$i,
	AITools: AITools$i,
	Premium: Premium$i,
	LinkedInOptimization: LinkedInOptimization$i,
	JobTracker: JobTracker$i,
	whoIsHiring: whoIsHiring$i,
	Autofill: Autofill$i,
	HeadlineGenerator: HeadlineGenerator$i,
	skillMatching: skillMatching$i,
	SummarizeJD: SummarizeJD$i,
	contactFeature: contactFeature$i,
	documentFeature: documentFeature$i,
	landJobWithoutStress: landJobWithoutStress$i,
	discoverFeatures: discoverFeatures$i,
	letsBeginOnboarding: letsBeginOnboarding$i,
	inTheNextFewScreensJobThirdParties: inTheNextFewScreensJobThirdParties$i,
	letsAddBasicInformation: letsAddBasicInformation$i,
	Pleaseselectanoptionfirst: Pleaseselectanoptionfirst$i,
	JobApplicationTracker: JobApplicationTracker$i,
	LinkedInProfileOptimizer: LinkedInProfileOptimizer$i,
	UnlimitedDocuments: UnlimitedDocuments$i,
	UnlimitedContacts: UnlimitedContacts$i,
	HiringManagerSearch: HiringManagerSearch$i,
	AILinkedInPostGenerator: AILinkedInPostGenerator$i,
	ATSKeywordSkillMatch: ATSKeywordSkillMatch$i,
	"Auto-Apply": "Automaatne rakendamine",
	ChooseyourPlan: ChooseyourPlan$i,
	superChargeYourJobSearch: superChargeYourJobSearch$i,
	startNowGoto: startNowGoto$i,
	CreatedBy: CreatedBy$i,
	CreateNewNote: CreateNewNote$i,
	Nonotescreated: Nonotescreated$i,
	approxTimeIsFourMinutes: approxTimeIsFourMinutes$i,
	Continue: Continue$i,
	iWillDoLaterTakeMeToApp: iWillDoLaterTakeMeToApp$i,
	allDone: allDone$i,
	welcomeAbord: welcomeAbord$i,
	letsBegin: letsBegin$i,
	UpgradeyourplanandgetAIAssistance: UpgradeyourplanandgetAIAssistance$i,
	DownloadPDF: DownloadPDF$i,
	oopsWeCouldntProcessResume: oopsWeCouldntProcessResume$i,
	MyProfile: MyProfile$i,
	Setting: Setting$i,
	Logout: Logout$i,
	SignIn: SignIn$i,
	Typeyourfirstnamehere: Typeyourfirstnamehere$i,
	Enteryourlastname: Enteryourlastname$i,
	ManageSubscription: ManageSubscription$i,
	ifYouHaveDifficultiesProfile: ifYouHaveDifficultiesProfile$i,
	forSupport: forSupport$i,
	whatIsIdealCompanySize: whatIsIdealCompanySize$i,
	Saveandcontinue: Saveandcontinue$i,
	whatIsMinExpectedSalary: whatIsMinExpectedSalary$i,
	Atleast: Atleast$i,
	SlidetoAdjust: SlidetoAdjust$i,
	whatIndustryExcitedWork: whatIndustryExcitedWork$i,
	Add: Add$i,
	statusOfJobSearch: statusOfJobSearch$i,
	Finish: Finish$i,
	whatLevelRoleLooking: whatLevelRoleLooking$i,
	Selectuptotwo: Selectuptotwo$i,
	PreviousStep: PreviousStep$i,
	Skip: Skip$i,
	whatDoYouValueNewRole: whatDoYouValueNewRole$i,
	Selectuptothree: Selectuptothree$i,
	EqualEmploymentData: EqualEmploymentData$i,
	whatIsYourEthnicity: whatIsYourEthnicity$i,
	areYouAuthorizedToWorkUs: areYouAuthorizedToWorkUs$i,
	willYouRequireSponsorShip: willYouRequireSponsorShip$i,
	doYouHaveADisability: doYouHaveADisability$i,
	areYouAVeteran: areYouAVeteran$i,
	rolesYouInterestedIn: rolesYouInterestedIn$i,
	Selectuptofive: Selectuptofive$i,
	AddCustomrole: AddCustomrole$i,
	whereDoYouLikeWork: whereDoYouLikeWork$i,
	Resources: Resources$i,
	currentlyNoResourceAvailable: currentlyNoResourceAvailable$i,
	AddNewSection: AddNewSection$i,
	ChangeSections: ChangeSections$i,
	Settings: Settings$i,
	Dashboard: Dashboard$i,
	JobBoard: JobBoard$i,
	Linkedin: Linkedin$i,
	Community: Community$i,
	FindRecruiters: FindRecruiters$i,
	Goals: Goals$i,
	DownloadExtension: DownloadExtension$i,
	SuggestaFeature: SuggestaFeature$i,
	leftPanel: leftPanel$i,
	PhoneNumberisrequired: PhoneNumberisrequired$i,
	MobileNumber: MobileNumber$i,
	Enteronlynumbers: Enteronlynumbers$i,
	Countryyoulivein: Countryyoulivein$i,
	SelectaCountry: SelectaCountry$i,
	DateofBirth: DateofBirth$i,
	Gender: Gender$i,
	JobPreferences: JobPreferences$i,
	pleaseEnterValidEmail: pleaseEnterValidEmail$i,
	emailSendForResetting: emailSendForResetting$i,
	VerifyyourEmailID: VerifyyourEmailID$i,
	sentPleaseCheckEmail: sentPleaseCheckEmail$i,
	tooManyAttemptsTryAgain: tooManyAttemptsTryAgain$i,
	Resend: Resend$i,
	Login: Login$i,
	weHaveSentVerificationLinkAtEmail: weHaveSentVerificationLinkAtEmail$i,
	pleaseVerifyEmailContinueSpam: pleaseVerifyEmailContinueSpam$i,
	Logintogetstarted: Logintogetstarted$i,
	ContinuewithGoogle: ContinuewithGoogle$i,
	pleaseInputEmail: pleaseInputEmail$i,
	Password: Password$i,
	pleaseInputPassword: pleaseInputPassword$i,
	passwordLowerUpperDigitSpecial: passwordLowerUpperDigitSpecial$i,
	atLeastSixChar: atLeastSixChar$i,
	forgotPassword: forgotPassword$i,
	Bysigninginyouagreetoour: Bysigninginyouagreetoour$i,
	Terms: Terms$i,
	Conditions: Conditions$i,
	and: and$i,
	PrivacyPolicy: PrivacyPolicy$i,
	theseAreTheTopsSkillsExtracted: theseAreTheTopsSkillsExtracted$i,
	TopSkills: TopSkills$i,
	weCoulNotExtractSkills: weCoulNotExtractSkills$i,
	upgradeToPremiumToView: upgradeToPremiumToView$i,
	SkillScore: SkillScore$i,
	thisIsYourSkillScoreBasedOn: thisIsYourSkillScoreBasedOn$i,
	theseSkllsAreStrongMatch: theseSkllsAreStrongMatch$i,
	Strongmatch: Strongmatch$i,
	theseSkillsArePartialMatch: theseSkillsArePartialMatch$i,
	Partialmatch: Partialmatch$i,
	theseSkillsAreMissingFrom: theseSkillsAreMissingFrom$i,
	"Missing Keywords": "Puuduvad võtmesõnad",
	SkillMatchComponent: SkillMatchComponent$i,
	Optional: Optional$i,
	Notrelevanttothejob: Notrelevanttothejob$i,
	Notaskill: Notaskill$i,
	Toogeneric: Toogeneric$i,
	Pleaseshareanyfeedback: Pleaseshareanyfeedback$i,
	excludedKeywordsWillNot: excludedKeywordsWillNot$i,
	yesExcludeThisSkillFrom: yesExcludeThisSkillFrom$i,
	PartialMatch: PartialMatch$i,
	MissingKeywords: MissingKeywords$i,
	Providetitletotask: Providetitletotask$i,
	TasksList: TasksList$i,
	AddTask: AddTask$i,
	EnterTaskTitlehere: EnterTaskTitlehere$i,
	TasksComponent: TasksComponent$i,
	CompletedTasks: CompletedTasks$i,
	CompleteYourtasks: CompleteYourtasks$i,
	Steps: Steps$i,
	PremiumMember: PremiumMember$i,
	Thankyouforupgradingto: Thankyouforupgradingto$i,
	CareerflowPremium: CareerflowPremium$i,
	hereIsHowYouCanAccessPremium: hereIsHowYouCanAccessPremium$i,
	stepOne: stepOne$i,
	DownloadourChromeExtension: DownloadourChromeExtension$i,
	youJobSearchCopilotIshere: youJobSearchCopilotIshere$i,
	DownloadNow: DownloadNow$i,
	stepTwo: stepTwo$i,
	GetStarted: GetStarted$i,
	stepThree: stepThree$i,
	SignintoChromeExtension: SignintoChromeExtension$i,
	entityCreated: entityCreated$i,
	entityUpdated: entityUpdated$i,
	entityDeleted: entityDeleted$i,
	entityLinked: entityLinked$i,
	entityUnlinked: entityUnlinked$i,
	entityMovedTo: entityMovedTo$i,
	youAddedANewEntity: youAddedANewEntity$i,
	personCreated: personCreated$i,
	youUpdatedAEntity: youUpdatedAEntity$i,
	personUpdated: personUpdated$i,
	youDeletedAEntity: youDeletedAEntity$i,
	personDeleted: personDeleted$i,
	youLinkedEntity: youLinkedEntity$i,
	personLinked: personLinked$i,
	youUnlinked: youUnlinked$i,
	personUnlinked: personUnlinked$i,
	youMovedEntity: youMovedEntity$i,
	personMoved: personMoved$i,
	addedByName: addedByName$i,
	DownloadChromeExtension: DownloadChromeExtension$i,
	ourChromeExtensionIs: ourChromeExtensionIs$i,
	Optimizeyourprofile: Optimizeyourprofile$i,
	startOptimizingYourProfile: startOptimizingYourProfile$i,
	OptimizeNow: OptimizeNow$i,
	Addyourfirstjob: Addyourfirstjob$i,
	startSavingJobApplicationsToTrack: startSavingJobApplicationsToTrack$i,
	AddNow: AddNow$i,
	CompleteProfile: CompleteProfile$i,
	completeYourProfileForUsing: completeYourProfileForUsing$i,
	CompleteNow: CompleteNow$i,
	Addyourfirstcontact: Addyourfirstcontact$i,
	addContactToFollowUpWith: addContactToFollowUpWith$i,
	JoinCommunity: JoinCommunity$i,
	ourCommunityisAlways: ourCommunityisAlways$i,
	JoinNow: JoinNow$i,
	welcomeToCareerflow: welcomeToCareerflow$i,
	yourHubForCareerInsights2: yourHubForCareerInsights2$i,
	ChecklistCompleted: ChecklistCompleted$i,
	Completeyourchecklist: Completeyourchecklist$i,
	completeAFewStepsTo: completeAFewStepsTo$i,
	Completed: Completed$i,
	JobCountByStage: JobCountByStage$i,
	NopastapplicationDatafound: NopastapplicationDatafound$i,
	YourJobSearchStages: YourJobSearchStages$i,
	NoDatafound: NoDatafound$i
};

const copyToClipboard$h = "Kopioitu leikepöydälle!";
const UnlocktheAIgenerated$h = "Avaa AI-generoitu.";
const UpgradetoPremium$h = "Päivitä Premiumiksi";
const Result$h = "Tulos";
const Copy$h = "Kopioi";
const Save$h = "Tallenna";
const Edit$h = "Muokkaa";
const Processing$h = "Käsittely";
const YourAIgeneratedcontentwillshowhere$h = "AI-generoitu sisältösi näkyy täällä";
const hopeYouFindUseful$h = "Toivottavasti löydät tästä tuloksesta hyödyllistä!";
const regenerate$h = "Uudelleen-generoi";
const ProvideAdditionalFeedback$h = "Anna lisäpalautetta";
const Enteranyfeedback$h = "Kirjoita palautteesi";
const Notimpressive$h = "Ei vaikuttavaa";
const thisIsntTrue$h = "Tämä ei ole totta";
const Notpersonalized$h = "Ei personoitu";
const Tone$h = "Sävy";
const Length$h = "Pituus";
const Template$h = "Malli";
const Generatedon$h = "Luotu";
const Copiedtoclipboard$h = "Kopioitu leikepöydälle";
const CopytoClipboard$h = "Kopioi leikepöydälle";
const DownloadasPDF$h = "Lataa PDF-tiedostona";
const ViewDetails$h = "Näytä tiedot";
const JobDescriptionImported$h = "Työnkuva tuotu maahan";
const ImportfromJob$h = "Tuo työstä";
const Saved$h = "Tallennettu";
const Applied$h = "Haettu";
const Offer$h = "Tarjous";
const Interviewing$h = "Haastattelu";
const Rejected$h = "Hylätty";
const Search$h = "Haku";
const Import$h = "Tuo";
const CoverLetterGeneratorHistory$h = "Ansioluettelogeneraattorin historia";
const NoCoverLettersGenerated$h = "Ei luotuja työhakemuksia";
const getStartedCoverLetter$h = "Et ole vielä luonut työhakemuskirjettä. Aloita ja luo sellainen vastaamalla työtehtävän vaatimuksiin omalla kokemuksellasi.";
const getStarted$h = "Aloita!";
const Documents$h = "Asiakirjat";
const UploadNewDocument$h = "Lataa uusi asiakirja";
const AICoverLetterGenerator$h = "Tekoälypohjainen työhakemuskirjegeneraattori";
const ViewHistory$h = "Näytä historia";
const JobDescription$h = "Työn kuvaus";
const ImportfromBoard$h = "Tuo tietokannasta";
const EnterJobDescription$h = "Kirjoita työn kuvaus";
const JobTitle$h = "Työnimike";
const EnterJobTitle$h = "Kirjoita työnimike";
const CompanyName$h = "Yrityksen nimi";
const EnterCompanyName$h = "Kirjoita yrityksen nimi";
const YourProfile$h = "Profiilisi";
const ResumeUpload$h = "CV:n lataus";
const UseLinkedinProfile$h = "Käytä LinkedIn-profiilia";
const Uploadyourresume$h = "Lataa CV:si";
const AddyourResume$h = "Lisää CV";
const fileNameCannotFormat$h = "Tiedostonimen ei tulisi sisältää välilyöntejä tai alaviivoja, ja sen tulee olla joko .doc, .docx tai .pdf -muodossa.";
const ChooseorUpload$h = "Valitse tai lataa";
const SelectTemplate$h = "Valitse malli";
const Preview$h = "Esikatselu";
const UseTemplate$h = "Käytä mallia";
const Change$h = "Muuta";
const AdvancedSettings$h = "Lisäasetukset";
const AdditionalContext$h = "Lisätietoja";
const Professional$h = "Ammattimainen";
const Casual$h = "Rentoutunut";
const Enthusiastic$h = "Innokas";
const Informational$h = "Tiedollinen";
const Short$h = "Lyhyt";
const Medium$h = "Keskiverto";
const Long$h = "Pitkä";
const Language$h = "Kieli";
const iAmOkayBack$h = "Kaikki hyvin! Palaa takaisin";
const Generate$h = "Generoi";
const CoverLetter$h = "Hakemuskirje";
const SelectLanguage$h = "Valitse kieli";
const AboutGeneratorHistory$h = "Tietoa-generaattorin historia";
const NoAboutsGenerated$h = "Ei luotuja kuvauksia";
const getStartedAbouts$h = "Et ole vielä luonut kuvauksia. Aloita ja luo kuvauksia vastaamalla työtehtävän vaatimuksiin omalla kokemuksellasi.";
const noAttachmentsFound$h = "Liitteitä ei löytynyt.";
const TargetJobTitle$h = "Kohdetyönimike";
const KeywordsToInclude$h = "Sisällytettävät avainsanat";
const UploadYourResume$h = "Lataa ansioluettelosi";
const AddYourResume$h = "Lisää ansioluettelosi";
const LinkedinProfile$h = "LinkedIn-profiili";
const Linkedinprofilenotfound$h = "LinkedIn-profiilia ei löydy";
const startUsingChromeExtension$h = "Aloita LinkedIn-profiilisi optimointi käyttämällä Chrome-laajennusta tämän vaihtoehdon käyttämiseksi.";
const Download$h = "Lataa";
const UseEmojis$h = "Käytä emojeita";
const UseBulletPoints$h = "Käytä luettelomerkkejä";
const SpeechFocus$h = "Puheen painopiste";
const FirstPerson$h = "Ensimmäinen persoona";
const ThirdPerson$h = "Kolmas persoona";
const HeadlineGeneratorHistory$h = "Otsikkogeneraattorin historia";
const NoHeadlinesGenerated$h = "Ei luotuja otsikoita";
const getStartedHeadline$h = "Et ole vielä luonut otsikoita. Aloita ja luo otsikoita vastaamalla työtehtävän vaatimuksiin omalla kokemuksellasi.";
const AIHeadlineGenerator$h = "Tekoälypohjainen otsikkogeneraattori";
const KeywordstoInclude$h = "Sisällytettävät avainsanat";
const Pressenteraftereachword$h = "Paina enteriä jokaisen sanan jälkeen";
const LinkedinProfilenotfound$h = "LinkedIn-profiilia ei löytynyt.";
const Headline$h = "Otsikko";
const PostGeneratorHistory$h = "Julkaisugeneraattorin historia";
const NoPostsGenerated$h = "Ei luotuja julkaisuja";
const getStartedPost$h = "Et ole vielä luonut julkaisuja. Aloita ja luo julkaisuja vastaamalla työtehtävän vaatimuksiin omalla kokemuksellasi.";
const Topic$h = "Aihe";
const Description$h = "Kuvaus";
const UseHashtags$h = "Käytä aihetunnisteita";
const Custom$h = "Mukautettu";
const EnterCustomTone$h = "Syötä mukautettu sävy";
const Added$h = "Lisätty";
const ComingSoon$h = {
	header: "Insinöörit töissä!",
	content_1: "Tiimimme insinöörit tekevät parhaansa saadakseen tämän ominaisuuden pian käyttöön.",
	content_2: "Haluatko tämän ominaisuuden nopeasti? Kerro meille vain ruudun alapuolella.",
	content_3: "Haluaisin tämän ominaisuuden"
};
const Company$h = "Yritys";
const JobInterview$h = "Työhaastattelu";
const Research$h = "Tutkimus";
const Networking$h = "Verkostoituminen";
const Referral$h = "Suositus";
const MustbeContacted$h = "Täytyy ottaa yhteyttä";
const ScheduleaMeeting$h = "Ajanvaraus";
const needAFollowUp$h = "Tarvitsee seurata jäljessä";
const Today$h = "Tänään";
const Viewdetails$h = "Näytä tiedot";
const Activity$h = "Toiminta";
const ActivityDetails$h = "Toiminnan tiedot";
const Delete$h = "Poista";
const Title$h = "Otsikko";
const Goal$h = "Tavoite";
const Status$h = "Tila";
const FollowUp$h = "Seuranta";
const AddActivity$h = "Lisää toiminta";
const Enteractivitytitle$h = "Syötä toiminnan otsikko";
const Cancel$h = "Peruuta";
const SaveActivity$h = "Tallenna toiminta";
const noActivityPresent$h = "Ei toimintaa, lisää toiminta.";
const Addnew$h = "Lisää uusi";
const About$h = "Tietoa";
const noDataPresentYou$h = "Ei tietoja saatavilla, voit muokata tätä yhteyshenkilöä ja lisätä kenttiä.";
const Experience$h = "Kokemus";
const Education$h = "Koulutus";
const Skills$h = "Taidot";
const Overview$h = "Yleiskatsaus";
const LinkedJobs$h = "Linkitetyt työpaikat";
const Notes$h = "Muistiinpanot";
const FullName$h = "Koko nimi";
const Location$h = "Sijainti";
const Relationship$h = "Suhde";
const Contacts$h = "Yhteystiedot";
const CreateContact$h = "Luo yhteystieto";
const NotesCreated$h = "Muistiinpanot luotu";
const Notesupdated$h = "Muistiinpanot päivitetty";
const Addnote$h = "Lisää muistiinpano";
const areYouSureDeleteNote$h = "Oletko varma, että haluat poistaa tämän muistiinpanon?";
const Createdby$h = "Luonut";
const notSureWhyResumeCalls$h = "Et varmaan tiedä, miksi ansioluettelosi ei saa sinulle haastattelukutsuja? ☎️";
const getExpertResumeReview$h = "Hanki asiantuntijan ansioluettelon arvostelu 💎✨";
const youHaventAddedContacts$h = "Et ole vielä lisännyt yhtään yhteyshenkilöä.";
const noMatchingContacts$h = "Ei löytynyt vastaavia yhteystietoja.";
const Link$h = "Linkki";
const unlink$h = "Poista linkki";
const Locationnotavailable$h = "Sijainti ei ole saatavilla";
const Emailnotavailable$h = "Sähköposti ei saatavilla";
const PhoneNumbernotavailable$h = "Puhelinnumero ei saatavilla";
const createdby$h = "luotu käyttäjän toimesta";
const areYouSureDeleteContact$h = "Oletko varma, että haluat poistaa tämän yhteyshenkilön?";
const areYouSureUnlinkContact$h = "Oletko varma, että haluat poistaa linkin tähän yhteyshenkilöön?";
const Addedbyyou$h = "Lisätty sinun toimestasi";
const Addedby$h = "Lisännyt";
const Timeline$h = "Aikajana";
const Timelineempty$h = "Aikajana tyhjä";
const Discard$h = "Hylkää";
const SaveContact$h = "Tallenna yhteystieto";
const Recruiter$h = "Rekrytoija";
const Candidate$h = "Ehdokas";
const Colleague$h = "Työkaveri";
const Employee$h = "Työntekijä";
const EnterValidEmail$h = "Syötä kelvollinen sähköpostiosoite";
const EnterValidPhoneNumber$h = "Syötä kelvollinen puhelinnumero";
const editingProfileNotAvailable$h = "Profiilikuvan muokkaus ei ole vielä saatavilla.";
const itWillBeSoonAvailable$h = "Se on pian saatavilla meidän kauttamme.";
const ChromeExtension$h = "Chrome-laajennus";
const SelectTag$h = "Valitse tunniste";
const FirstName$h = "Etunimi";
const FirstNameisrequired$h = "Etunimi on pakollinen";
const LastName$h = "Sukunimi";
const LastNameisrequired$h = "Sukunimi on pakollinen";
const Companyisrequired$h = "Yritys on vaadittu.";
const Email$h = "Sähköposti";
const ThisisnotavalidEmail$h = "Tämä ei ole kelvollinen sähköpostiosoite.";
const AddEmail$h = "Lisää sähköposti";
const PhoneNumber$h = "Puhelinnumero";
const notaValidPhone$h = "Tämä ei ole kelvollinen puhelinnumero. Syötä vain numeroita.";
const phoneNoMinimum5char$h = "Puhelinnumero on oltava vähintään 5 merkkiä pitkä.";
const phoneNoMinumum15char$h = "Puhelinnumero saa olla enintään 15 merkkiä pitkä.";
const AddPhoneNumber$h = "Lisää puhelinnumero";
const SelectGoal$h = "Valitse tavoite";
const SelectStatus$h = "Valitse tila";
const Followup$h = "Seuranta";
const SocialMedia$h = "Sosiaalinen media";
const Linkedinhandle$h = "Linkedin-käyttäjätunnus";
const Twitterhandle$h = "Twitter-käyttäjänimi";
const Facebookhandle$h = "Facebook-käyttäjänimi";
const Githubhandle$h = "Github-käyttäjänimi";
const Gmailhandle$h = "Gmail-käyttäjänimi";
const Changessavedsuccessfully$h = "Muutokset tallennettu onnistuneesti";
const EditContact$h = "Muokkaa yhteystietoa";
const BasicInformation$h = "Perustiedot";
const EditContactDetails$h = "Muokkaa yhteystiedon tietoja";
const SaveChanges$h = "Tallenna muutokset";
const phoneNoMinimum14char$h = "Puhelinnumero on oltava vähintään 14 merkkiä pitkä.";
const LinkedIn$h = "LinkedIn";
const Twitter$h = "Twitter";
const Facebook$h = "Facebook";
const Github$h = "Github";
const Gmail$h = "Gmail";
const youCanWriteAbout$h = "Voit kirjoittaa kokemuksistasi, alastasi tai taidoistasi. Ihmiset puhuvat myös saavutuksistaan tai aiemmista työkokemuksistaan.";
const Addednewsection$h = "Lisätty uusi osio";
const Removedsuccessfully$h = "Poistettu onnistuneesti.";
const Remove$h = "Poista";
const Institute$h = "Instituutti";
const Schoolisrequired$h = "Koulu on pakollinen.";
const Degree$h = "Tutkinto";
const StartMonth$h = "Aloituskuukausi";
const StartYear$h = "Aloitusvuosi";
const EndMonth$h = "Kuukauden loppu";
const EndYear$h = "Loppuvuosi";
const Addmore$h = "Lisää lisää";
const PositionTitle$h = "Tehtävänimike";
const ExperienceType$h = "Kokemustyyppi";
const Addednewitem$h = "Lisätty uusi tuote";
const whatSkillsDoYouEnjoy$h = "Mitä taitoja sinulla on tai nautit työskentelemisestä niiden parissa?";
const Typeskillshere$h = "Kirjoita taidot tähän";
const LinkedContacts$h = "Linkitetyt yhteystiedot";
const LinkContact$h = "Linkitä yhteystieto";
const NocontactsLinked$h = "Ei linkitettyjä yhteystietoja";
const JobContactsComponent$h = {
	linkContact: "Linkittämällä yhteystietoja voit nopeasti nähdä, kuka on tärkeä henkilö, kuten rekrytoija, palkkaava johtaja jne., tälle roolille! Tulevaisuudessa voimme tuoda esiin olennaisia ​​tietoja yhteyksiesi perusteella."
};
const Nocontacts$h = "Ei yhteyksiä";
const LinkJobto$h = "Liitä työtehtävään";
const Contact$h = "Yhteystiedot";
const Document$h = "Dokumentti";
const Nojobsfound$h = "Ei löydettyjä työpaikkoja";
const LinkJob$h = "Linkitä työpaikka";
const youCanLinkContactJobImported$h = "Voit linkittää tämän yhteyshenkilön urapolkuun, jonka olet tuonut Careerflow'hun.";
const Prev$h = "Edellinen";
const Next$h = "Seuraava";
const areYouSureUnlinkDocument$h = "Oletko varma, että haluat poistaa linkin tähän asiakirjaan?";
const areYouSureDeleteDocument$h = "Oletko varma, että haluat poistaa tämän asiakirjan?";
const Category$h = "Luokka";
const CreatedOn$h = "Luotu";
const Joblinked$h = "Työ liitetty";
const Quickactions$h = "Pikatoiminnot";
const All$h = "Kaikki";
const Resume$h = "Ansioluettelo";
const Portfolio$h = "Portfolio";
const Other$h = "Muu";
const Adddocument$h = "Lisää asiakirja";
const Type$h = "Tyyppi";
const Sortingby$h = "Lajittelu";
const SwitchtoGridLayout$h = "Vaihda ruudukkomuotoon.";
const SwitchtoListLayout$h = "Vaihda listanäkymään.";
const NoDocumentsAdded$h = "Ei lisättyjä asiakirjoja";
const DocumentsComponent$h = {
	nodocs: "Et ole vielä luonut asiakirjoja. Voit ladata ansioluettelo- ja hakemuskirjaversiot ym. ja liittää ne seuraamiisi työpaikkoihin!"
};
const NoDocumentFound$h = "Ei löytynyt asiakirjaa";
const SelectFile$h = "Valitse tiedosto";
const onlyPdfDocxSupported$h = "Vain .pdf ja .docx tuettu.";
const Uploadfile$h = "Lataa tiedosto";
const DocumentCategory$h = "Asiakirjan luokka";
const SaveDocument$h = "Tallenna asiakirja";
const AddDocument$h = "Lisää asiakirja";
const LinkedDocuments$h = "Linkitetyt asiakirjat";
const LinkDocument$h = "Linkitä asiakirja";
const NodocumentsLinked$h = "Ei linkitettyjä asiakirjoja";
const JobDocumentsComponent$h = {
	linkDocs: "Linkittämällä kaikki olennaiset asiakirjat, kuten ansioluettelosi, hakemuskirjeesi jne., joita olet lähettänyt tähän työpaikkaan, autat pitämään kaiken yhdessä paikassa. Kokeile sitä!"
};
const NoDocuments$h = "Ei asiakirjoja";
const CreateDocuments$h = "Luo asiakirjoja";
const youCanLinkDocumentJobImported$h = "Voit linkittää tämän asiakirjan urapolkusi tuomaan työpaikkaan Careerflow'ssa.";
const Documenteditedsuccessfully$h = "Dokumentti muokattu onnistuneesti";
const DocumentDetails$h = "Dokumentin tiedot";
const UnsavedChanges$h = "Tallentamattomat muutokset";
const yourChangesWillBeLostSureClose$h = "Muutoksesi häviävät, oletko varma että haluat sulkea?";
const yourChangesWillBeLostSureDiscard$h = "Muutoksesi menetetään, oletko varma, että haluat hylätä muutoksesi?";
const DiscardChanges$h = "Hylkää muutokset";
const WeeklyGoalAlert$h = "Viikoittainen tavoiteilmoitus";
const Progress$h = "Edistys";
const AllGoals$h = "Kaikki tavoitteet";
const Name$h = "Nimi";
const Completedon$h = "Valmistunut";
const Createdon$h = "Luotu";
const Action$h = "Toiminta";
const Back$h = "Takaisin";
const OverallScore$h = "Kokonaispisteet";
const Aboutthegoal$h = "Tietoja tavoitteesta";
const GoalTracking$h = "Tavoiteseuranta";
const Week$h = "Viikko";
const progress$h = "edistyminen";
const loading$h = "Ladataan";
const Apply$h = "Hae";
const Thisskillhasbeenreported$h = "Tämä taito on raportoitu";
const issueGettingResume$h = "Tämän kanssa oli ongelma ansioluettelon saamisessa.";
const Interview$h = "Haastattelu";
const Tasks$h = "Tehtävät";
const Loading$h = "Ladataan";
const Skilladdedsuccessfully$h = "Taito lisätty onnistuneesti";
const problemAddingSkill$h = "Taitojen lisäämisessä oli ongelma.";
const Reportaproblem$h = "Ilmoita ongelmasta";
const Submit$h = "Lähetä";
const Addanewskill$h = "Lisää uusi taito";
const JobDetailsComponent$h = {
	classifySkill: "Miten luokittelisit tämän taidon (valinnainen)",
	includedKeywordsWillCount: "Sisällytetäänkö tämä avainsana?",
	yesIncludeThisSkill: "Sisällytetyt avainsanat lasketaan mukaan vastaavuuspisteisiisi kaikissa tulevissa skannauksissa. Voit muuttaa sisällytettyjä avainsanoja profiilistasi.",
	addSkill: "Haluatko lisätä tämän taidoksi?"
};
const HardSkill$h = "Kova taito";
const SoftSkill$h = "Pehmeä taito";
const Pleaseshareanyadditionalcontext$h = "Jaa mahdollinen lisäkonteksti";
const Addasskill$h = "Lisää taitona";
const Skill$h = "Taito";
const JobFrequency$h = "Työtaajuus";
const ResumeFrequency$h = "Ansioluettelon taajuus";
const Reportskill$h = "Ilmoita taidosta";
const JobDetails$h = "Työn tiedot";
const ViewJobLink$h = "Näytä työpaikkalinkki";
const Salary$h = "Palkka";
const areYouSureDeleteJob$h = "Oletko varma, että haluat poistaa tämän työn?";
const ViewMore$h = "Näytä lisää";
const ViewLess$h = "Näytä vähemmän";
const matchYouSkillsAgainstJob$h = "Vastaavatko taitosi työpaikkakuvausta?";
const pleaseUploadResumeSkillMatch$h = "Lataa ansioluettelosi saadaksesi taitojen vastaavuuspisteet.";
const AddResume$h = "Lisää ansioluettelo";
const thisJobDoesNotHaveAnyDesc$h = "Tällä työllä ei ole mitään kuvausta.";
const youCanEditJobToAdd$h = "Voit muokata tätä työtä lisätäksesi siihen kuvauksen. Voit myös tuoda töitä käyttämällä meidän.";
const chromeextension$h = "Chrome-laajennus";
const fromVariousJobPortalsOnce$h = "eri työportaaleista. Kun lisäät kuvauksen, näet myös taitoihin liittyvää tietoa.";
const AddDescription$h = "Lisää kuvaus";
const CompanyInfo$h = "Yritystiedot";
const Website$h = "Verkkosivusto";
const Industry$h = "Toimiala";
const EmployeeCount$h = "Työntekijöiden lukumäärä";
const ExprienceLevel$h = "Kokemustaso";
const Address$h = "Osoite";
const Resumes$h = "Ansioluettelot";
const Setasdefault$h = "Aseta oletukseksi";
const Ok$h = "Ok";
const UploadNewResume$h = "Lataa uusi ansioluettelo";
const Default$h = "Oletus";
const Jobnotfound$h = "Työpaikkaa ei löytynyt";
const EditDetails$h = "Muokkaa tietoja";
const JobPostURL$h = "Työilmoituksen URL";
const Enterjoburl$h = "Syötä työn URL-osoite";
const Nojobselected$h = "Ei valittu työpaikkaa";
const Viewjobdetails$h = "Näytä työpaikkatiedot";
const Jobaddedtoyourboardsuccessfully$h = "Työ lisätty onnistuneesti tauluusi";
const AddJob$h = "Lisää työ";
const Addnewjobname$h = "Lisää uusi työnimi";
const JobUrl$h = "Työn URL";
const Addjoburl$h = "Lisää työn URL-osoite.";
const Section$h = "Osio";
const didYouKnow$h = {
	chromeExtension: "Tiesitkö? Voit tallentaa työpaikkoja suoraan Chrome-laajennuksestamme ja tuoda kaikki tiedot yhdellä napsautuksella! Se kestää vain muutaman sekunnin."
};
const Jobs$h = "Työt";
const AddJobtoboard$h = "Lisää työpaikka ilmoitustaululle";
const Currentlynojobsareavailable$h = "Tällä hetkellä ei ole saatavilla työpaikkoja.";
const noMatchingJobs$h = "Ei löytynyt sopivia työpaikkoja.";
const welcomeToYourPersonalJobTracker$h = "Tervetuloa henkilökohtaiseen työnhakuseurantaasi!";
const weShortTutorialOnHowTrackingJob$h = "Ohjaamme sinut lyhyen opetusohjelman läpi, miten aloitat työhakemustesi seurannan muutamalla helpolla askeleella!";
const Addanewjob$h = "Lisää uusi työ.";
const inOrderTrackCreatButton$h = "Jotta voit aloittaa työhakemusten seurannan, sinun täytyy ensin lisätä se taululle klikkaamalla 'Luo' -painiketta.";
const Providesomedetails$h = "Anna joitain yksityiskohtia.";
const toBeginTypeJobTitleCompany$h = "Aluksi kirjoita vain työnimike, yrityksen nimi ja tila, johon haluat sen lisätä. Voit lisätä lisätietoja myöhemmin, mutta tämä riittää nyt!";
const asAnExampleFilledForYou$h = "Esimerkkinä, olemme jo täyttäneet tämän sinulle!";
const wohooAddedFirstJob$h = "Jee! Lisäsit ensimmäisen työpaikkasi työseurantaan!";
const youCanDragDropJobCard$h = "Voit nyt vetää ja pudottaa työkortin eri vaiheisiin työhakuprosessissa. Työkortin napsauttaminen antaa sinun tarkastella lisätietoja, muokata niitä, tallentaa muistiinpanoja ja paljon muuta!";
const Lastbutnotleast$h = "Viimeisenä muttei vähäisimpänä";
const finalStepMakeSure$h = "Viimeisenä vaiheena varmista, että sinulla on meidän.";
const autoMaticallyImportJobs$h = "joka mahdollistaa sinulle työpaikkojen automaattisen tuonnin suosituimmilta työnhakusivustoilta, kuten LinkedIn, Indeed ja muilta! Laajennuksemme auttaa myös parantamaan LinkedIn-profiiliasi ja saamaan 2,5 kertaa enemmän hakutuloksia!";
const selectanysection$h = "valitse mikä tahansa osio";
const Accept$h = "Hyväksy";
const My2023JobSearch$h = "Oma 2023 työnhaun";
const AddedFrom$h = "Lisätty kohteesta";
const AddedUntil$h = "Lisätty asti";
const BasicModal$h = "Perusmalli";
const AddnewSectionName$h = "Lisää uusi osion nimi";
const OpenTo$h = "Avoinna";
const Featured$h = "Esillä";
const LicenceAndCerts$h = "Lisenssit ja todistukset";
const Banner$h = "Banneri";
const LinkedInURL$h = "LinkedIn URL";
const Recommendations$h = "Suositukset";
const LinkedinReview$h = "Linkedin-arvostelu";
const NoDataAvailable$h = "Ei saatavilla olevia tietoja";
const looksLikeYouDidNot$h = "Näyttää siltä, ettet ole aloittanut käyttämistä meidän";
const toOptimizeProfileScoreVisible$h = "et ole vielä optimoinut LinkedIn-profiiliasi. Kun teet sen, profiilisi pisteet näkyvät täällä.";
const LinkedinComponent$h = {
	letsOptimize: "Optimoidaan"
};
const improveYourChancesLandingDreamJob$h = "Paranna mahdollisuuksiasi saada unelmiesi työpaikka. Käytä näitä kokeiltuja ja testattuja strategioita antaaksesi LinkedIn-profiilillesi kaivatun uudistuksen.";
const VisitProfile$h = "Vieraile profiilissa";
const wantToGetLinkedinMakeover$h = "Haluatko täydellisen LinkedIn-uudistuksen?";
const PostGenerator$h = "Postituotteen generaattori";
const LinkedinHeadlineGenerator$h = "LinkedIn-otsikkogeneraattori";
const LinkedinAboutSectionGenerator$h = "LinkedIn Tietoja-osion generaattori";
const AITools$h = "Tekoälytyökalut";
const Premium$h = "Premiumi";
const LinkedInOptimization$h = "LinkedIn -optimointi";
const JobTracker$h = "Työtehtävien seuranta";
const whoIsHiring$h = "Kuka palkkaa";
const Autofill$h = "Automaattinen täyttö";
const HeadlineGenerator$h = "Otsikkogeneraattori";
const skillMatching$h = "Taitojen yhdistäminen";
const SummarizeJD$h = "Tiivistä työkuvaus";
const contactFeature$h = "Yhteyksien jäljitys";
const documentFeature$h = "Dokumentit";
const landJobWithoutStress$h = "Saat unelmiesi työn ilman stressiä.";
const discoverFeatures$h = "Löydä Careerflow.ai:n ominaisuuksien valikoima, jotka on suunniteltu tehostamaan työnhaun prosessia ja parantamaan ammatillista matkaasi!";
const letsBeginOnboarding$h = "Päästäkäämme paremmin tutustumaan sinuun!";
const inTheNextFewScreensJobThirdParties$h = "Seuraavilla näytöillä kysymme sinulta joitain kysymyksiä, jotka auttavat meitä räätälöimään kokemuksen sinulle sekä täyttämään työhakemuksesi automaattisesti (jotta sinun ei tarvitse tehdä sitä itse)! Emme myy tietojasi kolmansille osapuolille.";
const letsAddBasicInformation$h = "Lisätään perustietosi.";
const Pleaseselectanoptionfirst$h = "Valitse ensin vaihtoehto.";
const JobApplicationTracker$h = "Työhakemusten seurantaohjelma";
const LinkedInProfileOptimizer$h = "LinkedIn -profiilin optimoija";
const UnlimitedDocuments$h = "Rajaton määrä asiakirjoja";
const UnlimitedContacts$h = "Rajaton määrä yhteystietoja";
const HiringManagerSearch$h = "Palkkausjohtajan haku";
const AILinkedInPostGenerator$h = "Tekoälyllä toimiva LinkedIn-julkaisugeneraattori";
const ATSKeywordSkillMatch$h = "ATS-avainsana / taitojen vastaavuus työpaikka";
const ChooseyourPlan$h = "Valitse suunnitelmasi";
const superChargeYourJobSearch$h = "Tehosta työnhaun prosessia ja paranna työnhakuhakemustasi, lisää haastatteluja ja saavuta unelmiesi työpaikka. Kaikki tämä Careerflow:n premium-työkalupakin avulla.";
const startNowGoto$h = "Aloita nyt (Siirry sovellukseen)";
const CreatedBy$h = "Luonut";
const CreateNewNote$h = "Luo uusi muistiinpano";
const Nonotescreated$h = "Ei luotu muistiinpanoja";
const approxTimeIsFourMinutes$h = "Onboarding-prosessin suorittamiseen arvioitu aika on noin 4 minuuttia.";
const Continue$h = "Jatka";
const iWillDoLaterTakeMeToApp$h = "Teen tämän myöhemmin. Vie minut sovellukseen.";
const allDone$h = "Kaikki valmista!";
const welcomeAbord$h = "Tervetuloa kyytiin!";
const letsBegin$h = "Aloitetaan";
const UpgradeyourplanandgetAIAssistance$h = "Päivitä suunnitelmasi ja saat tekoälyavustusta.";
const DownloadPDF$h = "Lataa PDF-tiedosto";
const oopsWeCouldntProcessResume$h = "Hups, emme voineet käsitellä tätä ansioluetteloa.";
const MyProfile$h = "Profiilini";
const Setting$h = "Asetus";
const Logout$h = "Kirjaudu ulos";
const SignIn$h = "Kirjaudu sisään";
const Typeyourfirstnamehere$h = "Etunimesi";
const Enteryourlastname$h = "Viimeinen nimesi";
const ManageSubscription$h = "Hallitse tilausta";
const ifYouHaveDifficultiesProfile$h = "Mikäli sinulla on vaikeuksia profiilitietojesi kanssa, ota yhteyttä.";
const forSupport$h = "tukea varten.";
const whatIsIdealCompanySize$h = "Mikä on ihanteellinen yrityksen koko?";
const Saveandcontinue$h = "Tallenna ja jatka";
const whatIsMinExpectedSalary$h = "Mikä on vähimmäispalkkavaatimuksesi (vuodessa)?";
const Atleast$h = "Vähintään";
const SlidetoAdjust$h = "Liukusäädin säätämiseksi";
const whatIndustryExcitedWork$h = "Mikä teollisuusala innostaa sinua?";
const Add$h = "Lisää";
const statusOfJobSearch$h = "Työnhaun tilanne?";
const Finish$h = "Valmis";
const whatLevelRoleLooking$h = "Minkä tasoista roolia etsit?";
const Selectuptotwo$h = "Valitse enintään kaksi.";
const PreviousStep$h = "Edellinen vaihe";
const Skip$h = "Jätä väliin";
const whatDoYouValueNewRole$h = "Mitä arvostat uudessa roolissa?";
const Selectuptothree$h = "Valitse enintään kolme.";
const EqualEmploymentData$h = "Tasa-arvoiset työllistämistiedot";
const whatIsYourEthnicity$h = "Mikä on etnisyytesi?";
const areYouAuthorizedToWorkUs$h = "Oletko valtuutettu työskentelemään Yhdysvalloissa?";
const willYouRequireSponsorShip$h = "Tarvitsetko nyt tai tulevaisuudessa työviisumin sponsorointia?";
const doYouHaveADisability$h = "Onko sinulla vamma?";
const areYouAVeteran$h = "Oletko veteraani?";
const rolesYouInterestedIn$h = "Minkälaisista rooleista olet kiinnostunut?";
const Selectuptofive$h = "Valitse enintään viisi.";
const AddCustomrole$h = "Lisää mukautettu rooli";
const whereDoYouLikeWork$h = "Missä haluaisit työskennellä?";
const Resources$h = "Resurssit";
const currentlyNoResourceAvailable$h = "Tällä hetkellä resursseja ei ole saatavilla.";
const AddNewSection$h = "Lisää uusi osio";
const ChangeSections$h = "Muuta osioita";
const Settings$h = "Asetukset";
const Dashboard$h = "Ohjausnäyttö";
const JobBoard$h = "Työpaikkataulu";
const Linkedin$h = "Linkedin";
const Community$h = "Yhteisö";
const FindRecruiters$h = "Etsi rekrytoijia";
const Goals$h = "Tavoitteet";
const DownloadExtension$h = "Lataa laajennus";
const SuggestaFeature$h = "Ehdota ominaisuutta";
const leftPanel$h = {
	ReportanIssue: "Raportoi ongelma"
};
const PhoneNumberisrequired$h = "Puhelinnumero on pakollinen";
const MobileNumber$h = "Matkapuhelinnumero";
const Enteronlynumbers$h = "Syötä vain numeroita";
const Countryyoulivein$h = "Maa, jossa asut";
const SelectaCountry$h = "Valitse maa.";
const DateofBirth$h = "Syntymäaika";
const Gender$h = "Sukupuoli";
const JobPreferences$h = "Työpaikkatoiveet";
const pleaseEnterValidEmail$h = "Syötä kelvollinen sähköpostiosoite.";
const emailSendForResetting$h = "Sähköposti on lähetetty sinulle salasanan nollaukseen.";
const VerifyyourEmailID$h = "Vahvista sähköpostiosoitteesi";
const sentPleaseCheckEmail$h = "Lähetetty! Tarkista sähköpostisi.";
const tooManyAttemptsTryAgain$h = "Liian monta yritystä, yritä uudelleen jonkin ajan kuluttua.";
const Resend$h = "Lähetä uudelleen";
const Login$h = "Kirjaudu sisään";
const weHaveSentVerificationLinkAtEmail$h = "Olemme lähettäneet sinulle vahvistuslinkin sähköpostiisi.";
const pleaseVerifyEmailContinueSpam$h = "Vahvista sähköpostiosoitteesi jatkaaksesi. Tarkista myös roskaposti tai mainoskansio vahvistussähköpostin varalta.";
const Logintogetstarted$h = "Kirjaudu sisään aloittaaksesi";
const ContinuewithGoogle$h = "Jatka Googlella";
const pleaseInputEmail$h = "Syötä sähköpostiosoitteesi!";
const Password$h = "Salasana";
const pleaseInputPassword$h = "Syötä salasanasi!";
const passwordLowerUpperDigitSpecial$h = "Salasanasi täytyy sisältää vähintään yhden pienaakkosen, isoaakkosen, numeron ja erikoismerkin.";
const atLeastSixChar$h = "Vähintään 6 merkkiä.";
const forgotPassword$h = "Unohditko salasanasi?";
const Bysigninginyouagreetoour$h = "Kirjautumalla sisään hyväksyt meidän";
const Terms$h = "Ehdot";
const Conditions$h = "Ehdot";
const and$h = "ja";
const PrivacyPolicy$h = "Tietosuojakäytäntö";
const theseAreTheTopsSkillsExtracted$h = "Nämä ovat tärkeimmät taidot, jotka on poimittu työpaikkailmoituksesta.";
const TopSkills$h = "Parhaat taidot";
const weCoulNotExtractSkills$h = "Emme voineet eritellä mitään taitoja tästä työpaikkailmoituksesta.";
const upgradeToPremiumToView$h = "Päivitä Premium-tilaukseen nähdäksesi ansioluettelosi taitojen vastaavuuspisteytyksen.";
const SkillScore$h = "Taitopisteet";
const thisIsYourSkillScoreBasedOn$h = "Tämä on taitopisteesi työpaikkakuvausten ja ansioluettelosi perusteella.";
const theseSkllsAreStrongMatch$h = "Nämä taidot ovat vahva yhteensopivuus ansioluettelosi ja työpaikkakuvaus välillä.";
const Strongmatch$h = "Vahva vastaavuus";
const theseSkillsArePartialMatch$h = "Nämä taidot ovat osittainen vastaavuus ansioluettelosi ja työpaikkailmoituksen välillä.";
const Partialmatch$h = "Osittainen vastaavuus";
const theseSkillsAreMissingFrom$h = "Nämä avainsanat puuttuvat ansioluettelostasi, mutta ne ovat läsnä työpaikkailmoituksessa. Ne voivat olla taitoja tai yleisiä avainsanoja, jotka ovat erityisiä työmahdollisuudelle ja voivat olla hyödyllisiä lisättäessä ansioluetteloon.";
const SkillMatchComponent$h = {
	removeSkill: "Mikä on pääasiallinen syy ilmoittaa ongelmasta avainsanalle"
};
const Optional$h = "Valinnainen";
const Notrelevanttothejob$h = "Ei ole relevantti työlle";
const Notaskill$h = "Ei taitoa";
const Toogeneric$h = "Liian yleinen";
const Pleaseshareanyfeedback$h = "Jaa palautteesi";
const excludedKeywordsWillNot$h = "Poissuljetut avainsanat eivät vaikuta ottelupisteisiisi kaikissa tulevissa skannauksissa. Voit muuttaa poissuljettuja avainsanoja profiilistasi.";
const yesExcludeThisSkillFrom$h = "Kyllä, poista tämä taito kaikista ansioluettelon skannauksista.";
const PartialMatch$h = "Osittainen vastaavuus";
const MissingKeywords$h = "Puuttuvat avainsanat";
const Providetitletotask$h = "Anna tehtävälle otsikko";
const TasksList$h = "Tehtävälista";
const AddTask$h = "Lisää tehtävä";
const EnterTaskTitlehere$h = "Kirjoita tehtävän otsikko tähän";
const TasksComponent$h = {
	listEmpty: "Tehtäväluettelo tyhjä, Luo uusi."
};
const CompletedTasks$h = "Suoritetut tehtävät";
const CompleteYourtasks$h = "Täytä tehtäväsi";
const Steps$h = "Askeleet";
const PremiumMember$h = "Premium-jäsen";
const Thankyouforupgradingto$h = "Kiitos päivityksestäsi.";
const CareerflowPremium$h = "Uran virtaus Premium";
const hereIsHowYouCanAccessPremium$h = "Tässä on miten pääset käsiksi Premium-etuihisi!";
const stepOne$h = "Vaihe 1";
const DownloadourChromeExtension$h = "Lataa Chrome-laajennuksemme.";
const youJobSearchCopilotIshere$h = "Työnhaun AI-kopilotti on täällä.";
const DownloadNow$h = "Lataa nyt";
const stepTwo$h = "Vaihe 2";
const GetStarted$h = "Aloita";
const stepThree$h = "Vaihe 3";
const SignintoChromeExtension$h = "Kirjaudu sisään Chrome-laajennukseen.";
const entityCreated$h = "Uusi {{entity}} luotu";
const entityUpdated$h = "{{entity}} päivitetty";
const entityDeleted$h = "{{entity}} poistettu";
const entityLinked$h = "{{entity}} linkitetty";
const entityUnlinked$h = "{{entity}} poistettu linkityksestä";
const entityMovedTo$h = "Siirretty kohteeseen {{entity}}";
const youAddedANewEntity$h = "Lisäsit uuden {{entity}}.";
const personCreated$h = "{{creator}} loi {{entity}}n omistajalle {{owner}}.";
const youUpdatedAEntity$h = "Päivitit {{entity}}.";
const personUpdated$h = "{{creator}} päivitti {{entity}}n omistajalle {{owner}}.";
const youDeletedAEntity$h = "Poistit {{entity}}.";
const personDeleted$h = "{{creator}} poisti {{entity}} käyttäjältä {{owner}}.";
const youLinkedEntity$h = "Liitit {{entity}} tämän työn yhteyteen";
const personLinked$h = "{{creator}} linkitti {{entity}} tämän työn yhteyteen omistajalle {{owner}}.";
const youUnlinked$h = "Olet poistanut linkin {{entity}} tähän työtehtävään.";
const personUnlinked$h = "{{creator}} poisti linkin {{entity}} tähän työhön omistajalle {{owner}}.";
const youMovedEntity$h = "Siirsit tämän {{entity}} osiosta {{sectionFrom}} osioon {{sectionTo}}";
const personMoved$h = "{{creator}} siirsi tämän {{entity}} osiosta {{sectionFrom}} osioon {{sectionTo}} omistajalle {{owner}}.";
const addedByName$h = "Lisätty käyttäjän {{name}} toimesta.";
const DownloadChromeExtension$h = "Lataa Chrome-laajennus";
const ourChromeExtensionIs$h = "Chrome-laajennuksemme on integroitu työkalu, joka auttaa sinua optimoimaan LinkedIn-profiiliasi, tallentamaan työpaikkoja, tallentamaan yhteystietoja, luomaan työhakemuksen ja paljon muuta.";
const Optimizeyourprofile$h = "Optimoi profiilisi";
const startOptimizingYourProfile$h = "Aloita profiilisi optimointi, jotta sinulla olisi paremmat mahdollisuudet saada yhteydenottoja rekrytoijilta.";
const OptimizeNow$h = "Optimoi nyt";
const Addyourfirstjob$h = "Lisää ensimmäinen työpaikkasi.";
const startSavingJobApplicationsToTrack$h = "Aloita työhakemusten tallentaminen seurataksesi työnhaun matkaasi ja löytääksesi hyödyllisiä oivalluksia.";
const AddNow$h = "Lisää nyt";
const CompleteProfile$h = "Täydellinen profiili";
const completeYourProfileForUsing$h = "Täydennä profiilisi käyttääksesi automaattitäyttötoimintoa ja saadaksesi henkilökohtaisemman käyttökokemuksen.";
const CompleteNow$h = "Valmis nyt";
const Addyourfirstcontact$h = "Lisää ensimmäinen yhteystietosi.";
const addContactToFollowUpWith$h = "Lisää yhteystieto seurataksesi heitä myöhemmin, lisää muistiinpanoja ja muuta.";
const JoinCommunity$h = "Liity yhteisöön";
const ourCommunityisAlways$h = "Yhteisömme on aina tukenasi työnhaun matkallasi.";
const JoinNow$h = "Liity nyt";
const welcomeToCareerflow$h = "Tervetuloa Careerflow'hun!";
const yourHubForCareerInsights2$h = "Tämä on keskuksesi ura-ajatuksille, aktiviteeteille ja muulle. Tutki henkilökohtaista kojelautaasi pysyäksesi ajan tasalla ammatillisesta matkastasi.";
const ChecklistCompleted$h = "Tarkistuslistasi on valmis!";
const Completeyourchecklist$h = "Täytä tarkistuslistasi";
const completeAFewStepsTo$h = "Suorita muutama vaihe päästäksesi seuraavaan työpaikkaasi.";
const Completed$h = "Valmis";
const JobCountByStage$h = "Työpaikkojen määrä vaiheittain";
const NopastapplicationDatafound$h = "Edellisiä hakemustietoja ei löytynyt";
const YourJobSearchStages$h = "Työnhaun vaiheet";
const NoDatafound$h = "Ei löytynyt tietoja";
const fi = {
	copyToClipboard: copyToClipboard$h,
	UnlocktheAIgenerated: UnlocktheAIgenerated$h,
	UpgradetoPremium: UpgradetoPremium$h,
	Result: Result$h,
	Copy: Copy$h,
	Save: Save$h,
	Edit: Edit$h,
	Processing: Processing$h,
	YourAIgeneratedcontentwillshowhere: YourAIgeneratedcontentwillshowhere$h,
	hopeYouFindUseful: hopeYouFindUseful$h,
	regenerate: regenerate$h,
	ProvideAdditionalFeedback: ProvideAdditionalFeedback$h,
	Enteranyfeedback: Enteranyfeedback$h,
	Notimpressive: Notimpressive$h,
	thisIsntTrue: thisIsntTrue$h,
	Notpersonalized: Notpersonalized$h,
	Tone: Tone$h,
	Length: Length$h,
	Template: Template$h,
	Generatedon: Generatedon$h,
	Copiedtoclipboard: Copiedtoclipboard$h,
	CopytoClipboard: CopytoClipboard$h,
	DownloadasPDF: DownloadasPDF$h,
	ViewDetails: ViewDetails$h,
	JobDescriptionImported: JobDescriptionImported$h,
	ImportfromJob: ImportfromJob$h,
	Saved: Saved$h,
	Applied: Applied$h,
	Offer: Offer$h,
	Interviewing: Interviewing$h,
	Rejected: Rejected$h,
	Search: Search$h,
	Import: Import$h,
	CoverLetterGeneratorHistory: CoverLetterGeneratorHistory$h,
	NoCoverLettersGenerated: NoCoverLettersGenerated$h,
	getStartedCoverLetter: getStartedCoverLetter$h,
	getStarted: getStarted$h,
	Documents: Documents$h,
	UploadNewDocument: UploadNewDocument$h,
	AICoverLetterGenerator: AICoverLetterGenerator$h,
	ViewHistory: ViewHistory$h,
	JobDescription: JobDescription$h,
	ImportfromBoard: ImportfromBoard$h,
	EnterJobDescription: EnterJobDescription$h,
	JobTitle: JobTitle$h,
	EnterJobTitle: EnterJobTitle$h,
	CompanyName: CompanyName$h,
	EnterCompanyName: EnterCompanyName$h,
	YourProfile: YourProfile$h,
	ResumeUpload: ResumeUpload$h,
	UseLinkedinProfile: UseLinkedinProfile$h,
	Uploadyourresume: Uploadyourresume$h,
	AddyourResume: AddyourResume$h,
	fileNameCannotFormat: fileNameCannotFormat$h,
	ChooseorUpload: ChooseorUpload$h,
	SelectTemplate: SelectTemplate$h,
	Preview: Preview$h,
	UseTemplate: UseTemplate$h,
	Change: Change$h,
	AdvancedSettings: AdvancedSettings$h,
	AdditionalContext: AdditionalContext$h,
	Professional: Professional$h,
	Casual: Casual$h,
	Enthusiastic: Enthusiastic$h,
	Informational: Informational$h,
	Short: Short$h,
	Medium: Medium$h,
	Long: Long$h,
	Language: Language$h,
	iAmOkayBack: iAmOkayBack$h,
	Generate: Generate$h,
	CoverLetter: CoverLetter$h,
	SelectLanguage: SelectLanguage$h,
	AboutGeneratorHistory: AboutGeneratorHistory$h,
	NoAboutsGenerated: NoAboutsGenerated$h,
	getStartedAbouts: getStartedAbouts$h,
	noAttachmentsFound: noAttachmentsFound$h,
	TargetJobTitle: TargetJobTitle$h,
	KeywordsToInclude: KeywordsToInclude$h,
	UploadYourResume: UploadYourResume$h,
	AddYourResume: AddYourResume$h,
	LinkedinProfile: LinkedinProfile$h,
	Linkedinprofilenotfound: Linkedinprofilenotfound$h,
	startUsingChromeExtension: startUsingChromeExtension$h,
	Download: Download$h,
	UseEmojis: UseEmojis$h,
	UseBulletPoints: UseBulletPoints$h,
	SpeechFocus: SpeechFocus$h,
	FirstPerson: FirstPerson$h,
	ThirdPerson: ThirdPerson$h,
	HeadlineGeneratorHistory: HeadlineGeneratorHistory$h,
	NoHeadlinesGenerated: NoHeadlinesGenerated$h,
	getStartedHeadline: getStartedHeadline$h,
	AIHeadlineGenerator: AIHeadlineGenerator$h,
	KeywordstoInclude: KeywordstoInclude$h,
	Pressenteraftereachword: Pressenteraftereachword$h,
	LinkedinProfilenotfound: LinkedinProfilenotfound$h,
	Headline: Headline$h,
	PostGeneratorHistory: PostGeneratorHistory$h,
	NoPostsGenerated: NoPostsGenerated$h,
	getStartedPost: getStartedPost$h,
	Topic: Topic$h,
	Description: Description$h,
	UseHashtags: UseHashtags$h,
	Custom: Custom$h,
	EnterCustomTone: EnterCustomTone$h,
	Added: Added$h,
	ComingSoon: ComingSoon$h,
	Company: Company$h,
	JobInterview: JobInterview$h,
	Research: Research$h,
	Networking: Networking$h,
	Referral: Referral$h,
	MustbeContacted: MustbeContacted$h,
	ScheduleaMeeting: ScheduleaMeeting$h,
	needAFollowUp: needAFollowUp$h,
	Today: Today$h,
	Viewdetails: Viewdetails$h,
	Activity: Activity$h,
	ActivityDetails: ActivityDetails$h,
	Delete: Delete$h,
	Title: Title$h,
	Goal: Goal$h,
	Status: Status$h,
	FollowUp: FollowUp$h,
	AddActivity: AddActivity$h,
	Enteractivitytitle: Enteractivitytitle$h,
	Cancel: Cancel$h,
	SaveActivity: SaveActivity$h,
	noActivityPresent: noActivityPresent$h,
	Addnew: Addnew$h,
	About: About$h,
	noDataPresentYou: noDataPresentYou$h,
	Experience: Experience$h,
	Education: Education$h,
	Skills: Skills$h,
	Overview: Overview$h,
	LinkedJobs: LinkedJobs$h,
	Notes: Notes$h,
	FullName: FullName$h,
	Location: Location$h,
	Relationship: Relationship$h,
	Contacts: Contacts$h,
	CreateContact: CreateContact$h,
	NotesCreated: NotesCreated$h,
	Notesupdated: Notesupdated$h,
	Addnote: Addnote$h,
	areYouSureDeleteNote: areYouSureDeleteNote$h,
	Createdby: Createdby$h,
	notSureWhyResumeCalls: notSureWhyResumeCalls$h,
	getExpertResumeReview: getExpertResumeReview$h,
	youHaventAddedContacts: youHaventAddedContacts$h,
	noMatchingContacts: noMatchingContacts$h,
	Link: Link$h,
	unlink: unlink$h,
	Locationnotavailable: Locationnotavailable$h,
	Emailnotavailable: Emailnotavailable$h,
	PhoneNumbernotavailable: PhoneNumbernotavailable$h,
	createdby: createdby$h,
	areYouSureDeleteContact: areYouSureDeleteContact$h,
	areYouSureUnlinkContact: areYouSureUnlinkContact$h,
	Addedbyyou: Addedbyyou$h,
	Addedby: Addedby$h,
	Timeline: Timeline$h,
	Timelineempty: Timelineempty$h,
	Discard: Discard$h,
	SaveContact: SaveContact$h,
	Recruiter: Recruiter$h,
	Candidate: Candidate$h,
	Colleague: Colleague$h,
	Employee: Employee$h,
	"Needtofollow-up": "Tarvitsee seurantaa",
	EnterValidEmail: EnterValidEmail$h,
	EnterValidPhoneNumber: EnterValidPhoneNumber$h,
	editingProfileNotAvailable: editingProfileNotAvailable$h,
	itWillBeSoonAvailable: itWillBeSoonAvailable$h,
	ChromeExtension: ChromeExtension$h,
	SelectTag: SelectTag$h,
	FirstName: FirstName$h,
	FirstNameisrequired: FirstNameisrequired$h,
	LastName: LastName$h,
	LastNameisrequired: LastNameisrequired$h,
	Companyisrequired: Companyisrequired$h,
	Email: Email$h,
	ThisisnotavalidEmail: ThisisnotavalidEmail$h,
	AddEmail: AddEmail$h,
	PhoneNumber: PhoneNumber$h,
	notaValidPhone: notaValidPhone$h,
	phoneNoMinimum5char: phoneNoMinimum5char$h,
	phoneNoMinumum15char: phoneNoMinumum15char$h,
	AddPhoneNumber: AddPhoneNumber$h,
	SelectGoal: SelectGoal$h,
	SelectStatus: SelectStatus$h,
	Followup: Followup$h,
	SocialMedia: SocialMedia$h,
	Linkedinhandle: Linkedinhandle$h,
	Twitterhandle: Twitterhandle$h,
	Facebookhandle: Facebookhandle$h,
	Githubhandle: Githubhandle$h,
	Gmailhandle: Gmailhandle$h,
	Changessavedsuccessfully: Changessavedsuccessfully$h,
	EditContact: EditContact$h,
	BasicInformation: BasicInformation$h,
	EditContactDetails: EditContactDetails$h,
	SaveChanges: SaveChanges$h,
	phoneNoMinimum14char: phoneNoMinimum14char$h,
	LinkedIn: LinkedIn$h,
	Twitter: Twitter$h,
	Facebook: Facebook$h,
	Github: Github$h,
	Gmail: Gmail$h,
	youCanWriteAbout: youCanWriteAbout$h,
	Addednewsection: Addednewsection$h,
	Removedsuccessfully: Removedsuccessfully$h,
	Remove: Remove$h,
	Institute: Institute$h,
	Schoolisrequired: Schoolisrequired$h,
	Degree: Degree$h,
	StartMonth: StartMonth$h,
	StartYear: StartYear$h,
	EndMonth: EndMonth$h,
	EndYear: EndYear$h,
	Addmore: Addmore$h,
	PositionTitle: PositionTitle$h,
	ExperienceType: ExperienceType$h,
	Addednewitem: Addednewitem$h,
	whatSkillsDoYouEnjoy: whatSkillsDoYouEnjoy$h,
	Typeskillshere: Typeskillshere$h,
	LinkedContacts: LinkedContacts$h,
	LinkContact: LinkContact$h,
	NocontactsLinked: NocontactsLinked$h,
	JobContactsComponent: JobContactsComponent$h,
	Nocontacts: Nocontacts$h,
	LinkJobto: LinkJobto$h,
	Contact: Contact$h,
	Document: Document$h,
	Nojobsfound: Nojobsfound$h,
	LinkJob: LinkJob$h,
	youCanLinkContactJobImported: youCanLinkContactJobImported$h,
	Prev: Prev$h,
	Next: Next$h,
	areYouSureUnlinkDocument: areYouSureUnlinkDocument$h,
	areYouSureDeleteDocument: areYouSureDeleteDocument$h,
	Category: Category$h,
	CreatedOn: CreatedOn$h,
	Joblinked: Joblinked$h,
	Quickactions: Quickactions$h,
	All: All$h,
	Resume: Resume$h,
	Portfolio: Portfolio$h,
	Other: Other$h,
	Adddocument: Adddocument$h,
	Type: Type$h,
	Sortingby: Sortingby$h,
	SwitchtoGridLayout: SwitchtoGridLayout$h,
	SwitchtoListLayout: SwitchtoListLayout$h,
	NoDocumentsAdded: NoDocumentsAdded$h,
	DocumentsComponent: DocumentsComponent$h,
	NoDocumentFound: NoDocumentFound$h,
	SelectFile: SelectFile$h,
	onlyPdfDocxSupported: onlyPdfDocxSupported$h,
	Uploadfile: Uploadfile$h,
	DocumentCategory: DocumentCategory$h,
	SaveDocument: SaveDocument$h,
	AddDocument: AddDocument$h,
	LinkedDocuments: LinkedDocuments$h,
	LinkDocument: LinkDocument$h,
	NodocumentsLinked: NodocumentsLinked$h,
	JobDocumentsComponent: JobDocumentsComponent$h,
	NoDocuments: NoDocuments$h,
	CreateDocuments: CreateDocuments$h,
	youCanLinkDocumentJobImported: youCanLinkDocumentJobImported$h,
	Documenteditedsuccessfully: Documenteditedsuccessfully$h,
	DocumentDetails: DocumentDetails$h,
	UnsavedChanges: UnsavedChanges$h,
	yourChangesWillBeLostSureClose: yourChangesWillBeLostSureClose$h,
	yourChangesWillBeLostSureDiscard: yourChangesWillBeLostSureDiscard$h,
	DiscardChanges: DiscardChanges$h,
	WeeklyGoalAlert: WeeklyGoalAlert$h,
	Progress: Progress$h,
	AllGoals: AllGoals$h,
	Name: Name$h,
	Completedon: Completedon$h,
	Createdon: Createdon$h,
	Action: Action$h,
	Back: Back$h,
	OverallScore: OverallScore$h,
	Aboutthegoal: Aboutthegoal$h,
	GoalTracking: GoalTracking$h,
	Week: Week$h,
	progress: progress$h,
	loading: loading$h,
	Apply: Apply$h,
	Thisskillhasbeenreported: Thisskillhasbeenreported$h,
	issueGettingResume: issueGettingResume$h,
	Interview: Interview$h,
	Tasks: Tasks$h,
	Loading: Loading$h,
	Skilladdedsuccessfully: Skilladdedsuccessfully$h,
	problemAddingSkill: problemAddingSkill$h,
	Reportaproblem: Reportaproblem$h,
	Submit: Submit$h,
	Addanewskill: Addanewskill$h,
	JobDetailsComponent: JobDetailsComponent$h,
	HardSkill: HardSkill$h,
	SoftSkill: SoftSkill$h,
	Pleaseshareanyadditionalcontext: Pleaseshareanyadditionalcontext$h,
	Addasskill: Addasskill$h,
	Skill: Skill$h,
	JobFrequency: JobFrequency$h,
	ResumeFrequency: ResumeFrequency$h,
	Reportskill: Reportskill$h,
	JobDetails: JobDetails$h,
	ViewJobLink: ViewJobLink$h,
	Salary: Salary$h,
	areYouSureDeleteJob: areYouSureDeleteJob$h,
	ViewMore: ViewMore$h,
	ViewLess: ViewLess$h,
	matchYouSkillsAgainstJob: matchYouSkillsAgainstJob$h,
	pleaseUploadResumeSkillMatch: pleaseUploadResumeSkillMatch$h,
	AddResume: AddResume$h,
	thisJobDoesNotHaveAnyDesc: thisJobDoesNotHaveAnyDesc$h,
	youCanEditJobToAdd: youCanEditJobToAdd$h,
	chromeextension: chromeextension$h,
	fromVariousJobPortalsOnce: fromVariousJobPortalsOnce$h,
	AddDescription: AddDescription$h,
	CompanyInfo: CompanyInfo$h,
	Website: Website$h,
	Industry: Industry$h,
	EmployeeCount: EmployeeCount$h,
	ExprienceLevel: ExprienceLevel$h,
	Address: Address$h,
	Resumes: Resumes$h,
	Setasdefault: Setasdefault$h,
	Ok: Ok$h,
	UploadNewResume: UploadNewResume$h,
	Default: Default$h,
	Jobnotfound: Jobnotfound$h,
	EditDetails: EditDetails$h,
	JobPostURL: JobPostURL$h,
	Enterjoburl: Enterjoburl$h,
	Nojobselected: Nojobselected$h,
	Viewjobdetails: Viewjobdetails$h,
	Jobaddedtoyourboardsuccessfully: Jobaddedtoyourboardsuccessfully$h,
	AddJob: AddJob$h,
	Addnewjobname: Addnewjobname$h,
	JobUrl: JobUrl$h,
	Addjoburl: Addjoburl$h,
	Section: Section$h,
	didYouKnow: didYouKnow$h,
	Jobs: Jobs$h,
	AddJobtoboard: AddJobtoboard$h,
	Currentlynojobsareavailable: Currentlynojobsareavailable$h,
	noMatchingJobs: noMatchingJobs$h,
	welcomeToYourPersonalJobTracker: welcomeToYourPersonalJobTracker$h,
	weShortTutorialOnHowTrackingJob: weShortTutorialOnHowTrackingJob$h,
	Addanewjob: Addanewjob$h,
	inOrderTrackCreatButton: inOrderTrackCreatButton$h,
	Providesomedetails: Providesomedetails$h,
	toBeginTypeJobTitleCompany: toBeginTypeJobTitleCompany$h,
	asAnExampleFilledForYou: asAnExampleFilledForYou$h,
	wohooAddedFirstJob: wohooAddedFirstJob$h,
	youCanDragDropJobCard: youCanDragDropJobCard$h,
	Lastbutnotleast: Lastbutnotleast$h,
	finalStepMakeSure: finalStepMakeSure$h,
	autoMaticallyImportJobs: autoMaticallyImportJobs$h,
	selectanysection: selectanysection$h,
	Accept: Accept$h,
	My2023JobSearch: My2023JobSearch$h,
	AddedFrom: AddedFrom$h,
	AddedUntil: AddedUntil$h,
	BasicModal: BasicModal$h,
	AddnewSectionName: AddnewSectionName$h,
	OpenTo: OpenTo$h,
	Featured: Featured$h,
	LicenceAndCerts: LicenceAndCerts$h,
	Banner: Banner$h,
	LinkedInURL: LinkedInURL$h,
	Recommendations: Recommendations$h,
	LinkedinReview: LinkedinReview$h,
	NoDataAvailable: NoDataAvailable$h,
	looksLikeYouDidNot: looksLikeYouDidNot$h,
	toOptimizeProfileScoreVisible: toOptimizeProfileScoreVisible$h,
	LinkedinComponent: LinkedinComponent$h,
	improveYourChancesLandingDreamJob: improveYourChancesLandingDreamJob$h,
	VisitProfile: VisitProfile$h,
	wantToGetLinkedinMakeover: wantToGetLinkedinMakeover$h,
	PostGenerator: PostGenerator$h,
	LinkedinHeadlineGenerator: LinkedinHeadlineGenerator$h,
	LinkedinAboutSectionGenerator: LinkedinAboutSectionGenerator$h,
	AITools: AITools$h,
	Premium: Premium$h,
	LinkedInOptimization: LinkedInOptimization$h,
	JobTracker: JobTracker$h,
	whoIsHiring: whoIsHiring$h,
	Autofill: Autofill$h,
	HeadlineGenerator: HeadlineGenerator$h,
	skillMatching: skillMatching$h,
	SummarizeJD: SummarizeJD$h,
	contactFeature: contactFeature$h,
	documentFeature: documentFeature$h,
	landJobWithoutStress: landJobWithoutStress$h,
	discoverFeatures: discoverFeatures$h,
	letsBeginOnboarding: letsBeginOnboarding$h,
	inTheNextFewScreensJobThirdParties: inTheNextFewScreensJobThirdParties$h,
	letsAddBasicInformation: letsAddBasicInformation$h,
	Pleaseselectanoptionfirst: Pleaseselectanoptionfirst$h,
	JobApplicationTracker: JobApplicationTracker$h,
	LinkedInProfileOptimizer: LinkedInProfileOptimizer$h,
	UnlimitedDocuments: UnlimitedDocuments$h,
	UnlimitedContacts: UnlimitedContacts$h,
	HiringManagerSearch: HiringManagerSearch$h,
	AILinkedInPostGenerator: AILinkedInPostGenerator$h,
	ATSKeywordSkillMatch: ATSKeywordSkillMatch$h,
	"Auto-Apply": "Automaattinen hakeminen",
	ChooseyourPlan: ChooseyourPlan$h,
	superChargeYourJobSearch: superChargeYourJobSearch$h,
	startNowGoto: startNowGoto$h,
	CreatedBy: CreatedBy$h,
	CreateNewNote: CreateNewNote$h,
	Nonotescreated: Nonotescreated$h,
	approxTimeIsFourMinutes: approxTimeIsFourMinutes$h,
	Continue: Continue$h,
	iWillDoLaterTakeMeToApp: iWillDoLaterTakeMeToApp$h,
	allDone: allDone$h,
	welcomeAbord: welcomeAbord$h,
	letsBegin: letsBegin$h,
	UpgradeyourplanandgetAIAssistance: UpgradeyourplanandgetAIAssistance$h,
	DownloadPDF: DownloadPDF$h,
	oopsWeCouldntProcessResume: oopsWeCouldntProcessResume$h,
	MyProfile: MyProfile$h,
	Setting: Setting$h,
	Logout: Logout$h,
	SignIn: SignIn$h,
	Typeyourfirstnamehere: Typeyourfirstnamehere$h,
	Enteryourlastname: Enteryourlastname$h,
	ManageSubscription: ManageSubscription$h,
	ifYouHaveDifficultiesProfile: ifYouHaveDifficultiesProfile$h,
	forSupport: forSupport$h,
	whatIsIdealCompanySize: whatIsIdealCompanySize$h,
	Saveandcontinue: Saveandcontinue$h,
	whatIsMinExpectedSalary: whatIsMinExpectedSalary$h,
	Atleast: Atleast$h,
	SlidetoAdjust: SlidetoAdjust$h,
	whatIndustryExcitedWork: whatIndustryExcitedWork$h,
	Add: Add$h,
	statusOfJobSearch: statusOfJobSearch$h,
	Finish: Finish$h,
	whatLevelRoleLooking: whatLevelRoleLooking$h,
	Selectuptotwo: Selectuptotwo$h,
	PreviousStep: PreviousStep$h,
	Skip: Skip$h,
	whatDoYouValueNewRole: whatDoYouValueNewRole$h,
	Selectuptothree: Selectuptothree$h,
	EqualEmploymentData: EqualEmploymentData$h,
	whatIsYourEthnicity: whatIsYourEthnicity$h,
	areYouAuthorizedToWorkUs: areYouAuthorizedToWorkUs$h,
	willYouRequireSponsorShip: willYouRequireSponsorShip$h,
	doYouHaveADisability: doYouHaveADisability$h,
	areYouAVeteran: areYouAVeteran$h,
	rolesYouInterestedIn: rolesYouInterestedIn$h,
	Selectuptofive: Selectuptofive$h,
	AddCustomrole: AddCustomrole$h,
	whereDoYouLikeWork: whereDoYouLikeWork$h,
	Resources: Resources$h,
	currentlyNoResourceAvailable: currentlyNoResourceAvailable$h,
	AddNewSection: AddNewSection$h,
	ChangeSections: ChangeSections$h,
	Settings: Settings$h,
	Dashboard: Dashboard$h,
	JobBoard: JobBoard$h,
	Linkedin: Linkedin$h,
	Community: Community$h,
	FindRecruiters: FindRecruiters$h,
	Goals: Goals$h,
	DownloadExtension: DownloadExtension$h,
	SuggestaFeature: SuggestaFeature$h,
	leftPanel: leftPanel$h,
	PhoneNumberisrequired: PhoneNumberisrequired$h,
	MobileNumber: MobileNumber$h,
	Enteronlynumbers: Enteronlynumbers$h,
	Countryyoulivein: Countryyoulivein$h,
	SelectaCountry: SelectaCountry$h,
	DateofBirth: DateofBirth$h,
	Gender: Gender$h,
	JobPreferences: JobPreferences$h,
	pleaseEnterValidEmail: pleaseEnterValidEmail$h,
	emailSendForResetting: emailSendForResetting$h,
	VerifyyourEmailID: VerifyyourEmailID$h,
	sentPleaseCheckEmail: sentPleaseCheckEmail$h,
	tooManyAttemptsTryAgain: tooManyAttemptsTryAgain$h,
	Resend: Resend$h,
	Login: Login$h,
	weHaveSentVerificationLinkAtEmail: weHaveSentVerificationLinkAtEmail$h,
	pleaseVerifyEmailContinueSpam: pleaseVerifyEmailContinueSpam$h,
	Logintogetstarted: Logintogetstarted$h,
	ContinuewithGoogle: ContinuewithGoogle$h,
	pleaseInputEmail: pleaseInputEmail$h,
	Password: Password$h,
	pleaseInputPassword: pleaseInputPassword$h,
	passwordLowerUpperDigitSpecial: passwordLowerUpperDigitSpecial$h,
	atLeastSixChar: atLeastSixChar$h,
	forgotPassword: forgotPassword$h,
	Bysigninginyouagreetoour: Bysigninginyouagreetoour$h,
	Terms: Terms$h,
	Conditions: Conditions$h,
	and: and$h,
	PrivacyPolicy: PrivacyPolicy$h,
	theseAreTheTopsSkillsExtracted: theseAreTheTopsSkillsExtracted$h,
	TopSkills: TopSkills$h,
	weCoulNotExtractSkills: weCoulNotExtractSkills$h,
	upgradeToPremiumToView: upgradeToPremiumToView$h,
	SkillScore: SkillScore$h,
	thisIsYourSkillScoreBasedOn: thisIsYourSkillScoreBasedOn$h,
	theseSkllsAreStrongMatch: theseSkllsAreStrongMatch$h,
	Strongmatch: Strongmatch$h,
	theseSkillsArePartialMatch: theseSkillsArePartialMatch$h,
	Partialmatch: Partialmatch$h,
	theseSkillsAreMissingFrom: theseSkillsAreMissingFrom$h,
	"Missing Keywords": "Puuttuvat avainsanat",
	SkillMatchComponent: SkillMatchComponent$h,
	Optional: Optional$h,
	Notrelevanttothejob: Notrelevanttothejob$h,
	Notaskill: Notaskill$h,
	Toogeneric: Toogeneric$h,
	Pleaseshareanyfeedback: Pleaseshareanyfeedback$h,
	excludedKeywordsWillNot: excludedKeywordsWillNot$h,
	yesExcludeThisSkillFrom: yesExcludeThisSkillFrom$h,
	PartialMatch: PartialMatch$h,
	MissingKeywords: MissingKeywords$h,
	Providetitletotask: Providetitletotask$h,
	TasksList: TasksList$h,
	AddTask: AddTask$h,
	EnterTaskTitlehere: EnterTaskTitlehere$h,
	TasksComponent: TasksComponent$h,
	CompletedTasks: CompletedTasks$h,
	CompleteYourtasks: CompleteYourtasks$h,
	Steps: Steps$h,
	PremiumMember: PremiumMember$h,
	Thankyouforupgradingto: Thankyouforupgradingto$h,
	CareerflowPremium: CareerflowPremium$h,
	hereIsHowYouCanAccessPremium: hereIsHowYouCanAccessPremium$h,
	stepOne: stepOne$h,
	DownloadourChromeExtension: DownloadourChromeExtension$h,
	youJobSearchCopilotIshere: youJobSearchCopilotIshere$h,
	DownloadNow: DownloadNow$h,
	stepTwo: stepTwo$h,
	GetStarted: GetStarted$h,
	stepThree: stepThree$h,
	SignintoChromeExtension: SignintoChromeExtension$h,
	entityCreated: entityCreated$h,
	entityUpdated: entityUpdated$h,
	entityDeleted: entityDeleted$h,
	entityLinked: entityLinked$h,
	entityUnlinked: entityUnlinked$h,
	entityMovedTo: entityMovedTo$h,
	youAddedANewEntity: youAddedANewEntity$h,
	personCreated: personCreated$h,
	youUpdatedAEntity: youUpdatedAEntity$h,
	personUpdated: personUpdated$h,
	youDeletedAEntity: youDeletedAEntity$h,
	personDeleted: personDeleted$h,
	youLinkedEntity: youLinkedEntity$h,
	personLinked: personLinked$h,
	youUnlinked: youUnlinked$h,
	personUnlinked: personUnlinked$h,
	youMovedEntity: youMovedEntity$h,
	personMoved: personMoved$h,
	addedByName: addedByName$h,
	DownloadChromeExtension: DownloadChromeExtension$h,
	ourChromeExtensionIs: ourChromeExtensionIs$h,
	Optimizeyourprofile: Optimizeyourprofile$h,
	startOptimizingYourProfile: startOptimizingYourProfile$h,
	OptimizeNow: OptimizeNow$h,
	Addyourfirstjob: Addyourfirstjob$h,
	startSavingJobApplicationsToTrack: startSavingJobApplicationsToTrack$h,
	AddNow: AddNow$h,
	CompleteProfile: CompleteProfile$h,
	completeYourProfileForUsing: completeYourProfileForUsing$h,
	CompleteNow: CompleteNow$h,
	Addyourfirstcontact: Addyourfirstcontact$h,
	addContactToFollowUpWith: addContactToFollowUpWith$h,
	JoinCommunity: JoinCommunity$h,
	ourCommunityisAlways: ourCommunityisAlways$h,
	JoinNow: JoinNow$h,
	welcomeToCareerflow: welcomeToCareerflow$h,
	yourHubForCareerInsights2: yourHubForCareerInsights2$h,
	ChecklistCompleted: ChecklistCompleted$h,
	Completeyourchecklist: Completeyourchecklist$h,
	completeAFewStepsTo: completeAFewStepsTo$h,
	Completed: Completed$h,
	JobCountByStage: JobCountByStage$h,
	NopastapplicationDatafound: NopastapplicationDatafound$h,
	YourJobSearchStages: YourJobSearchStages$h,
	NoDatafound: NoDatafound$h
};

const copyToClipboard$g = "Copié dans le presse-papiers !";
const UnlocktheAIgenerated$g = "Déverrouillez la génération d'IA";
const UpgradetoPremium$g = "Passer à Premium";
const Result$g = "Résultat";
const Copy$g = "Copier";
const Save$g = "Enregistrer";
const Edit$g = "Modifier";
const Processing$g = "Traitement";
const YourAIgeneratedcontentwillshowhere$g = "Votre contenu généré par l'IA s'affichera ici";
const hopeYouFindUseful$g = "J'espère que vous trouverez ce résultat utile !";
const regenerate$g = "Re-générer";
const ProvideAdditionalFeedback$g = "Fournir des commentaires supplémentaires";
const Enteranyfeedback$g = "Entrer des commentaires";
const Notimpressive$g = "Pas impressionnant";
const thisIsntTrue$g = "Ce n'est pas vrai";
const Notpersonalized$g = "Pas personnalisé";
const Tone$g = "Tonalité";
const Length$g = "Longueur";
const Template$g = "Modèle";
const Generatedon$g = "Généré le";
const Copiedtoclipboard$g = "Copié dans le presse-papiers";
const CopytoClipboard$g = "Copier dans le presse-papiers";
const DownloadasPDF$g = "Télécharger au format PDF";
const ViewDetails$g = "Voir les détails";
const JobDescriptionImported$g = "Description de poste importée";
const ImportfromJob$g = "Importation depuis l'emploi";
const Saved$g = "Enregistré";
const Applied$g = "Postulé";
const Offer$g = "Offre";
const Interviewing$g = "Entretien d'embauche";
const Rejected$g = "Rejeté";
const Search$g = "Rechercher";
const Import$g = "Importation";
const CoverLetterGeneratorHistory$g = "Historique du générateur de lettres de motivation";
const NoCoverLettersGenerated$g = "Aucune lettre de motivation générée";
const getStartedCoverLetter$g = "Vous n'avez pas encore généré de lettres de motivation. Commencez et obtenez des lettres de motivation en mettant en correspondance la description du poste avec votre expérience pertinente.";
const getStarted$g = "Commencer!";
const Documents$g = "Documents";
const UploadNewDocument$g = "Télécharger un nouveau document";
const AICoverLetterGenerator$g = "Générateur de lettres de motivation IA";
const ViewHistory$g = "Voir l'historique";
const JobDescription$g = "Description du poste";
const ImportfromBoard$g = "Importer depuis le tableau";
const EnterJobDescription$g = "Entrer la description du poste";
const JobTitle$g = "Intitulé du poste";
const EnterJobTitle$g = "Entrer l'intitulé du poste";
const CompanyName$g = "Nom de l'entreprise";
const EnterCompanyName$g = "Entrer le nom de l'entreprise";
const YourProfile$g = "Votre profil";
const ResumeUpload$g = "Téléchargement du CV";
const UseLinkedinProfile$g = "Utiliser le profil Linkedin";
const Uploadyourresume$g = "Téléchargez votre CV";
const AddyourResume$g = "Ajoutez votre CV";
const fileNameCannotFormat$g = "Les noms de fichier ne peuvent pas contenir d'espaces ou de traits de soulignement et doivent être en format .doc, .docx ou .pdf.";
const ChooseorUpload$g = "Choisir ou télécharger";
const SelectTemplate$g = "Sélectionner un modèle";
const Preview$g = "Aperçu";
const UseTemplate$g = "Utiliser le modèle";
const Change$g = "Changer";
const AdvancedSettings$g = "Paramètres avancés";
const AdditionalContext$g = "Contexte supplémentaire";
const Professional$g = "Professionnel";
const Casual$g = "Décontracté";
const Enthusiastic$g = "Enthousiaste";
const Informational$g = "Informatif";
const Short$g = "Court";
const Medium$g = "Moyen";
const Long$g = "Long";
const Language$g = "Langue";
const iAmOkayBack$g = "Ça va ! Retour";
const Generate$g = "Générer";
const CoverLetter$g = "Lettre de motivation";
const SelectLanguage$g = "Sélectionner la langue";
const AboutGeneratorHistory$g = "Historique du générateur À propos";
const NoAboutsGenerated$g = "Aucun À propos généré";
const getStartedAbouts$g = "Vous n'avez pas encore généré d'À propos. Commencez et obtenez des À propos en mettant en correspondance la description du poste avec votre expérience pertinente.";
const noAttachmentsFound$g = "Aucune pièce jointe trouvée.";
const TargetJobTitle$g = "Intitulé du poste cible";
const KeywordsToInclude$g = "Mots-clés à inclure";
const UploadYourResume$g = "Téléchargez votre CV";
const AddYourResume$g = "Ajoutez votre CV";
const LinkedinProfile$g = "Profil Linkedin";
const Linkedinprofilenotfound$g = "Profil Linkedin introuvable";
const startUsingChromeExtension$g = "Commencez à optimiser votre profil Linkedin en utilisant notre extension Chrome pour utiliser cette option.";
const Download$g = "Télécharger";
const UseEmojis$g = "Utiliser des emojis";
const UseBulletPoints$g = "Utiliser des puces";
const SpeechFocus$g = "Focus de la parole";
const FirstPerson$g = "Première personne";
const ThirdPerson$g = "Troisième personne";
const HeadlineGeneratorHistory$g = "Historique du générateur de titres";
const NoHeadlinesGenerated$g = "Aucun titre généré";
const getStartedHeadline$g = "Vous n'avez pas encore généré de titres. Commencez et obtenez des titres en mettant en correspondance la description du poste avec votre expérience pertinente.";
const AIHeadlineGenerator$g = "Générateur de titres IA";
const KeywordstoInclude$g = "Mots-clés à inclure";
const Pressenteraftereachword$g = "Appuyez sur Entrée après chaque mot";
const LinkedinProfilenotfound$g = "Profil LinkedIn introuvable.";
const Headline$g = "Titre";
const PostGeneratorHistory$g = "Historique du générateur de publications";
const NoPostsGenerated$g = "Aucune publication générée";
const getStartedPost$g = "Vous n'avez pas encore généré de publications. Commencez et obtenez des publications en mettant en correspondance la description du poste avec votre expérience pertinente.";
const Topic$g = "Sujet";
const Description$g = "Description";
const UseHashtags$g = "Utiliser des hashtags";
const Custom$g = "Personnalisé";
const EnterCustomTone$g = "Entrer le ton personnalisé";
const Added$g = "Ajouté";
const ComingSoon$g = {
	header: "Ingénieurs au travail !",
	content_1: "Notre équipe d'ingénieurs travaille d'arrache-pied pour mettre en place cette fonctionnalité bientôt",
	content_2: "Vous voulez cette fonctionnalité rapidement ? Faites-le nous savoir en cochant simplement la case ci-dessous.",
	content_3: "Je veux cette fonctionnalité"
};
const Company$g = "Entreprise";
const JobInterview$g = "Entretien d'embauche";
const Research$g = "Recherche";
const Networking$g = "Réseautage";
const Referral$g = "Recommandation";
const MustbeContacted$g = "Doit être contacté";
const ScheduleaMeeting$g = "Planifier une réunion";
const needAFollowUp$g = "Besoin de faire un suivi";
const Today$g = "Aujourd'hui";
const Viewdetails$g = "Voir les détails";
const Activity$g = "Activité";
const ActivityDetails$g = "Détails de l'activité";
const Delete$g = "Supprimer";
const Title$g = "Titre";
const Goal$g = "Objectif";
const Status$g = "Statut";
const FollowUp$g = "Suivi";
const AddActivity$g = "Ajouter une activité";
const Enteractivitytitle$g = "Entrer le titre de l'activité";
const Cancel$g = "Annuler";
const SaveActivity$g = "Enregistrer l'activité";
const noActivityPresent$g = "Aucune activité présente, ajouter une activité.";
const Addnew$g = "Ajouter un nouveau";
const About$g = "À propos";
const noDataPresentYou$g = "Aucune donnée présente, vous pouvez modifier ce contact et ajouter des champs.";
const Experience$g = "Expérience";
const Education$g = "Éducation";
const Skills$g = "Compétences";
const Overview$g = "Aperçu";
const LinkedJobs$g = "Emplois liés";
const Notes$g = "Notes";
const FullName$g = "Nom complet";
const Location$g = "Emplacement";
const Relationship$g = "Relation";
const Contacts$g = "Contacts";
const CreateContact$g = "Créer un contact";
const NotesCreated$g = "Notes créées";
const Notesupdated$g = "Notes mises à jour";
const Addnote$g = "Ajouter une note";
const areYouSureDeleteNote$g = "Êtes-vous sûr(e) de vouloir supprimer cette note ?";
const Createdby$g = "Créé par";
const notSureWhyResumeCalls$g = "Pas sûr(e) de savoir pourquoi votre CV ne vous permet pas d'obtenir des appels pour des entretiens ? ☎️";
const getExpertResumeReview$g = "Obtenez une évaluation de CV d'expert 💎✨";
const youHaventAddedContacts$g = "Vous n'avez pas encore ajouté de contacts.";
const noMatchingContacts$g = "Aucun contact correspondant trouvé.";
const Link$g = "Lien";
const unlink$g = "Détacher";
const Locationnotavailable$g = "Emplacement non disponible";
const Emailnotavailable$g = "Email non disponible";
const PhoneNumbernotavailable$g = "Numéro de téléphone non disponible";
const createdby$g = "créé par";
const areYouSureDeleteContact$g = "Êtes-vous sûr de vouloir supprimer ce contact ?";
const areYouSureUnlinkContact$g = "Êtes-vous sûr de vouloir détacher ce contact ?";
const Addedbyyou$g = "Ajouté par vous";
const Addedby$g = "Ajouté par";
const Timeline$g = "Chronologie";
const Timelineempty$g = "Chronologie vide";
const Discard$g = "Ignorer";
const SaveContact$g = "Enregistrer le contact";
const Recruiter$g = "Recruteur";
const Candidate$g = "Candidat";
const Colleague$g = "Collègue";
const Employee$g = "Employé";
const EnterValidEmail$g = "Entrez une adresse e-mail valide";
const EnterValidPhoneNumber$g = "Entrez un numéro de téléphone valide";
const editingProfileNotAvailable$g = "La modification de la photo de profil n'est pas encore disponible.";
const itWillBeSoonAvailable$g = "Il sera bientôt disponible dans notre";
const ChromeExtension$g = "Extension Chrome";
const SelectTag$g = "Sélectionner une balise";
const FirstName$g = "Prénom";
const FirstNameisrequired$g = "Le prénom est requis";
const LastName$g = "Nom de famille";
const LastNameisrequired$g = "Le nom de famille est requis";
const Companyisrequired$g = "L'entreprise est requise";
const Email$g = "Email";
const ThisisnotavalidEmail$g = "Ceci n'est pas une adresse e-mail valide.";
const AddEmail$g = "Ajouter un email";
const PhoneNumber$g = "Numéro de téléphone";
const notaValidPhone$g = "Ceci n'est pas un numéro de téléphone valide. Entrez uniquement des chiffres.";
const phoneNoMinimum5char$g = "Le numéro de téléphone doit comporter au moins 5 caractères.";
const phoneNoMinumum15char$g = "Le numéro de téléphone doit comporter au maximum 15 caractères.";
const AddPhoneNumber$g = "Ajouter un numéro de téléphone";
const SelectGoal$g = "Sélectionner un objectif";
const SelectStatus$g = "Sélectionner le statut";
const Followup$g = "Suivi";
const SocialMedia$g = "Médias sociaux";
const Linkedinhandle$g = "Nom d'utilisateur Linkedin";
const Twitterhandle$g = "Identifiant Twitter";
const Facebookhandle$g = "Identifiant Facebook";
const Githubhandle$g = "Identifiant Github";
const Gmailhandle$g = "Identifiant Gmail";
const Changessavedsuccessfully$g = "Modifications enregistrées avec succès";
const EditContact$g = "Modifier le contact";
const BasicInformation$g = "Informations de base";
const EditContactDetails$g = "Modifier les détails de contact";
const SaveChanges$g = "Enregistrer les modifications";
const phoneNoMinimum14char$g = "Le numéro de téléphone doit comporter au minimum 14 caractères.";
const LinkedIn$g = "LinkedIn";
const Twitter$g = "Twitter";
const Facebook$g = "Facebook";
const Github$g = "Github";
const Gmail$g = "Gmail";
const youCanWriteAbout$g = "Vous pouvez écrire sur vos années d'expérience, votre secteur d'activité ou vos compétences. Les gens parlent également de leurs réalisations ou de leurs expériences professionnelles précédentes.";
const Addednewsection$g = "Ajout d'une nouvelle section";
const Removedsuccessfully$g = "Supprimé avec succès.";
const Remove$g = "Supprimer";
const Institute$g = "Institut";
const Schoolisrequired$g = "L'école est obligatoire";
const Degree$g = "Degré";
const StartMonth$g = "Mois de départ";
const StartYear$g = "Année de début";
const EndMonth$g = "Fin de mois";
const EndYear$g = "Fin d'année";
const Addmore$g = "Ajouter plus";
const PositionTitle$g = "Titre de poste";
const ExperienceType$g = "Type d'expérience";
const Addednewitem$g = "Ajout d'un nouvel élément";
const whatSkillsDoYouEnjoy$g = "Quelles compétences avez-vous ou appréciez-vous travailler avec ?";
const Typeskillshere$g = "Compétences de saisie ici";
const LinkedContacts$g = "Contacts liés";
const LinkContact$g = "Lier le contact";
const NocontactsLinked$g = "Aucun contact lié";
const JobContactsComponent$g = {
	linkContact: "En liant des contacts, vous pouvez rapidement voir qui sont les personnes importantes comme le recruteur, le responsable de l'embauche, etc., pour ce rôle ! À l'avenir, nous pourrons vous fournir des informations pertinentes en fonction de vos contacts."
};
const Nocontacts$g = "Aucun contact";
const LinkJobto$g = "Lier le travail à";
const Contact$g = "Contact";
const Document$g = "Document";
const Nojobsfound$g = "Aucun emploi trouvé";
const LinkJob$g = "Lier l'emploi";
const youCanLinkContactJobImported$g = "Vous pouvez lier ce contact à un emploi que vous avez importé dans Careerflow.";
const Prev$g = "Précédent";
const Next$g = "Suivant";
const areYouSureUnlinkDocument$g = "Êtes-vous sûr de vouloir détacher ce document ?";
const areYouSureDeleteDocument$g = "Êtes-vous sûr de vouloir supprimer ce document ?";
const Category$g = "Catégorie";
const CreatedOn$g = "Créé le";
const Joblinked$g = "Emploi lié";
const Quickactions$g = "Actions rapides";
const All$g = "Tous";
const Resume$g = "CV";
const Portfolio$g = "Portfolio";
const Other$g = "Autre";
const Adddocument$g = "Ajouter un document";
const Type$g = "Type";
const Sortingby$g = "Tri par";
const SwitchtoGridLayout$g = "Passer au mode de disposition en grille";
const SwitchtoListLayout$g = "Passer à la mise en page de liste";
const NoDocumentsAdded$g = "Aucun document ajouté";
const DocumentsComponent$g = {
	nodocs: "Vous n'avez pas encore créé de documents. Vous pouvez télécharger des versions de votre CV, des lettres de motivation, etc., et les lier aux emplois que vous suivez !"
};
const NoDocumentFound$g = "Aucun document trouvé.";
const SelectFile$g = "Sélectionner un fichier";
const onlyPdfDocxSupported$g = "Seuls les formats .pdf et .docx sont pris en charge.";
const Uploadfile$g = "Téléverser le fichier";
const DocumentCategory$g = "Catégorie du document";
const SaveDocument$g = "Enregistrer le document";
const AddDocument$g = "Ajouter un document";
const LinkedDocuments$g = "Documents liés";
const LinkDocument$g = "Lier le document";
const NodocumentsLinked$g = "Aucun document lié";
const JobDocumentsComponent$g = {
	linkDocs: "Lier tous vos documents pertinents comme votre CV, lettre de motivation, etc., que vous avez soumis pour cet emploi vous aidera à suivre tout au même endroit. Essayez-le !"
};
const NoDocuments$g = "Aucun document";
const CreateDocuments$g = "Créer des documents";
const youCanLinkDocumentJobImported$g = "Vous pouvez lier ce document à un emploi que vous avez importé dans Careerflow.";
const Documenteditedsuccessfully$g = "Document édité avec succès";
const DocumentDetails$g = "Détails du document";
const UnsavedChanges$g = "Modifications non enregistrées";
const yourChangesWillBeLostSureClose$g = "Vos modifications seront perdues, êtes-vous sûr de vouloir fermer ?";
const yourChangesWillBeLostSureDiscard$g = "Vos modifications seront perdues, êtes-vous sûr de vouloir abandonner vos modifications ?";
const DiscardChanges$g = "Annuler les modifications";
const WeeklyGoalAlert$g = "Alerte d'objectif hebdomadaire";
const Progress$g = "Progrès";
const AllGoals$g = "Tous les objectifs";
const Name$g = "Nom";
const Completedon$g = "Terminé le";
const Createdon$g = "Créé le";
const Action$g = "Action";
const Back$g = "Retour";
const OverallScore$g = "Score global";
const Aboutthegoal$g = "À propos de l'objectif";
const GoalTracking$g = "Suivi des objectifs";
const Week$g = "Semaine";
const progress$g = "progrès";
const loading$g = "Chargement";
const Apply$g = "Appliquer";
const Thisskillhasbeenreported$g = "Cette compétence a été signalée.";
const issueGettingResume$g = "Il y avait un problème pour obtenir le CV.";
const Interview$g = "Entretien";
const Tasks$g = "Tâches";
const Loading$g = "Chargement";
const Skilladdedsuccessfully$g = "Compétence ajoutée avec succès.";
const problemAddingSkill$g = "Il y avait un problème lors de l'ajout de compétence.";
const Reportaproblem$g = "Signaler un problème";
const Submit$g = "Soumettre";
const Addanewskill$g = "Ajouter une nouvelle compétence";
const JobDetailsComponent$g = {
	classifySkill: "Comment classeriez-vous cette compétence (facultatif) ?",
	includedKeywordsWillCount: "Inclure ce mot-clé ?",
	yesIncludeThisSkill: "Les mots-clés inclus seront pris en compte dans votre score de correspondance pour toutes les analyses futures. Vous pouvez modifier les mots-clés inclus depuis votre profil.",
	addSkill: "Voulez-vous ajouter ceci en tant que compétence ?"
};
const HardSkill$g = "Compétence technique";
const SoftSkill$g = "Compétence comportementale";
const Pleaseshareanyadditionalcontext$g = "Veuillez partager tout contexte supplémentaire";
const Addasskill$g = "Ajouter comme compétence";
const Skill$g = "Compétence";
const JobFrequency$g = "Fréquence de l'emploi";
const ResumeFrequency$g = "Fréquence du CV";
const Reportskill$g = "Signaler la compétence";
const JobDetails$g = "Détails de l'emploi";
const ViewJobLink$g = "Voir le lien d'emploi";
const Salary$g = "Salaire";
const areYouSureDeleteJob$g = "Êtes-vous sûr(e) de vouloir supprimer cette tâche ?";
const ViewMore$g = "Voir plus";
const ViewLess$g = "Voir moins";
const matchYouSkillsAgainstJob$g = "Faites correspondre vos compétences à la description de poste.";
const pleaseUploadResumeSkillMatch$g = "Veuillez télécharger votre CV pour obtenir votre score de correspondance de compétences.";
const AddResume$g = "Ajouter un CV";
const thisJobDoesNotHaveAnyDesc$g = "Ce travail n'a aucune description.";
const youCanEditJobToAdd$g = "Vous pouvez modifier cette offre d'emploi pour y ajouter une description. Vous pouvez également importer des offres d'emploi en utilisant notre";
const chromeextension$g = "extension Chrome";
const fromVariousJobPortalsOnce$g = "à partir de différents portails d'emploi. Une fois que vous ajoutez une description, vous pourrez également voir des informations liées aux compétences.";
const AddDescription$g = "Ajouter une description";
const CompanyInfo$g = "Informations sur l'entreprise";
const Website$g = "Site web";
const Industry$g = "Industrie";
const EmployeeCount$g = "Nombre d'employés";
const ExprienceLevel$g = "Niveau d'expérience";
const Address$g = "Adresse";
const Resumes$g = "Curriculums vitae";
const Setasdefault$g = "Définir par défaut";
const Ok$g = "Ok";
const UploadNewResume$g = "Télécharger un nouveau CV";
const Default$g = "Par défaut";
const Jobnotfound$g = "Emploi non trouvé";
const EditDetails$g = "Modifier les détails";
const JobPostURL$g = "URL de l'offre d'emploi";
const Enterjoburl$g = "Entrez l'URL de l'emploi";
const Nojobselected$g = "Aucun emploi sélectionné.";
const Viewjobdetails$g = "Voir les détails de l'emploi";
const Jobaddedtoyourboardsuccessfully$g = "Emploi ajouté avec succès à votre tableau";
const AddJob$g = "Ajouter un emploi";
const Addnewjobname$g = "Ajouter un nouveau nom de travail";
const JobUrl$g = "URL de l'emploi";
const Addjoburl$g = "Ajouter l'URL de l'emploi";
const Section$g = "Section";
const didYouKnow$g = {
	chromeExtension: "Le saviez-vous ? Vous pouvez également enregistrer des emplois directement depuis notre extension Chrome et importer toutes les données en un seul clic ! Cela ne prend que quelques secondes."
};
const Jobs$g = "Emplois";
const AddJobtoboard$g = "Ajouter un emploi au tableau";
const Currentlynojobsareavailable$g = "Actuellement, aucun emploi n'est disponible.";
const noMatchingJobs$g = "Aucun emploi correspondant trouvé.";
const welcomeToYourPersonalJobTracker$g = "Bienvenue dans votre suivi de travail personnel !";
const weShortTutorialOnHowTrackingJob$g = "Nous allons vous guider à travers un court tutoriel sur la façon de commencer à suivre vos candidatures d'emploi en quelques étapes faciles !";
const Addanewjob$g = "Ajouter un nouveau travail";
const inOrderTrackCreatButton$g = "Pour commencer à suivre les candidatures d'emploi, vous devez d'abord l'ajouter au tableau en cliquant sur le bouton \"Créer\".";
const Providesomedetails$g = "Fournir quelques détails.";
const toBeginTypeJobTitleCompany$g = "Pour commencer, tapez simplement le titre du poste, le nom de l'entreprise et le statut que vous souhaitez lui ajouter. Vous pouvez ajouter plus de détails plus tard, mais c'est tout ce dont vous avez besoin pour le moment !";
const asAnExampleFilledForYou$g = "Par exemple, nous l'avons déjà rempli pour vous !";
const wohooAddedFirstJob$g = "Youpi ! Vous avez ajouté votre premier emploi à votre suivi d'emploi !";
const youCanDragDropJobCard$g = "Vous pouvez maintenant faire glisser la carte d'emploi dans les différentes étapes du processus de candidature. En cliquant sur la carte d'emploi, vous pourrez voir plus de détails, les modifier, enregistrer des notes et plus encore !";
const Lastbutnotleast$g = "Enfin et surtout";
const finalStepMakeSure$g = "Enfin, assurez-vous d'avoir notre...";
const autoMaticallyImportJobs$g = "ce qui vous permettra d'importer automatiquement des offres d'emploi depuis vos sites de recherche d'emploi préférés tels que LinkedIn, Indeed, et bien plus encore ! Notre extension vous aide également à améliorer votre profil LinkedIn et à obtenir 2,5 fois plus d'apparitions dans les résultats de recherche !";
const selectanysection$g = "Sélectionnez n'importe quelle section";
const Accept$g = "Accepter";
const My2023JobSearch$g = "Ma recherche d'emploi 2023";
const AddedFrom$g = "Ajouté depuis";
const AddedUntil$g = "Ajouté jusqu'à";
const BasicModal$g = "Modal de base";
const AddnewSectionName$g = "Ajouter un nouveau nom de section";
const OpenTo$g = "Ouvert à";
const Featured$g = "En vedette";
const LicenceAndCerts$g = "Permis et certificats";
const Banner$g = "Bannière";
const LinkedInURL$g = "URL LinkedIn";
const Recommendations$g = "Recommandations";
const LinkedinReview$g = "Avis sur Linkedin";
const NoDataAvailable$g = "Pas de données disponibles.";
const looksLikeYouDidNot$g = "Il semble que vous n'ayez pas commencé à utiliser notre";
const toOptimizeProfileScoreVisible$g = "pour optimiser votre profil LinkedIn. Une fois que vous l'aurez fait, votre score de profil sera visible ici.";
const LinkedinComponent$g = {
	letsOptimize: "Optimisons"
};
const improveYourChancesLandingDreamJob$g = "Améliorez vos chances de décrocher votre emploi de rêve. Utilisez ces stratégies éprouvées pour donner à votre profil LinkedIn une refonte indispensable.";
const VisitProfile$g = "Visiter le profil";
const wantToGetLinkedinMakeover$g = "Vous voulez une refonte complète de votre profil LinkedIn ?";
const PostGenerator$g = "Générateur de publication";
const LinkedinHeadlineGenerator$g = "Générateur de titre LinkedIn";
const LinkedinAboutSectionGenerator$g = "Générateur de section 'À propos' LinkedIn";
const AITools$g = "Outils d'IA";
const Premium$g = "Prime";
const LinkedInOptimization$g = "Optimisation de LinkedIn";
const JobTracker$g = "Suivi des emplois";
const whoIsHiring$g = "Qui recrute";
const Autofill$g = "Remplissage automatique";
const HeadlineGenerator$g = "Générateur de titres";
const skillMatching$g = "Correspondance des compétences";
const SummarizeJD$g = "Résumé de la description de poste";
const contactFeature$g = "Suivi des contacts";
const documentFeature$g = "Documents";
const landJobWithoutStress$g = "Décrochez votre emploi de rêve. Sans stress.";
const discoverFeatures$g = "Découvrez la gamme de fonctionnalités de Careerflow.ai conçues pour simplifier votre recherche d'emploi et améliorer votre parcours professionnel !";
const letsBeginOnboarding$g = "Apprenons à mieux vous connaître !";
const inTheNextFewScreensJobThirdParties$g = "Dans les prochaines étapes, nous vous poserons quelques questions qui nous aideront à personnaliser l'expérience pour vous et à remplir automatiquement vos candidatures d'emploi (afin que vous n'ayez pas à le faire vous-même) ! Nous ne vendons pas vos données à des tiers.";
const letsAddBasicInformation$g = "Ajoutons vos informations de base";
const Pleaseselectanoptionfirst$g = "Veuillez d'abord sélectionner une option.";
const JobApplicationTracker$g = "Suivi des candidatures d'emploi";
const LinkedInProfileOptimizer$g = "Optimiseur de profil LinkedIn";
const UnlimitedDocuments$g = "Documents illimités";
const UnlimitedContacts$g = "Contacts illimités";
const HiringManagerSearch$g = "Recherche de responsable de recrutement";
const AILinkedInPostGenerator$g = "Générateur de publications AI pour LinkedIn";
const ATSKeywordSkillMatch$g = "Correspondance de mots-clés / compétences pour l'emploi";
const ChooseyourPlan$g = "Choisissez votre plan";
const superChargeYourJobSearch$g = "Boostez votre recherche d'emploi et améliorez votre processus de candidature, augmentez vos entretiens et décrochez votre emploi de rêve. Tout cela avec l'aide de la trousse à outils premium de Careerflow.";
const startNowGoto$g = "Commencez maintenant (allez sur l'application)";
const CreatedBy$g = "Créé par";
const CreateNewNote$g = "Créer une nouvelle note";
const Nonotescreated$g = "Aucune note créée";
const approxTimeIsFourMinutes$g = "Le temps approximatif pour terminer le processus d'intégration est de 4 minutes.";
const Continue$g = "Continuer";
const iWillDoLaterTakeMeToApp$g = "Je le ferai plus tard. Emmenez-moi à l'application.";
const allDone$g = "Tout est fait !";
const welcomeAbord$g = "Bienvenue à bord !";
const letsBegin$g = "Commençons";
const UpgradeyourplanandgetAIAssistance$g = "Mettez à niveau votre plan et obtenez une assistance AI.";
const DownloadPDF$g = "Télécharger le PDF";
const oopsWeCouldntProcessResume$g = "Oops, nous n'avons pas pu traiter ce CV.";
const MyProfile$g = "Mon profil";
const Setting$g = "Réglage";
const Logout$g = "Déconnexion";
const SignIn$g = "Se connecter";
const Typeyourfirstnamehere$g = "Votre prénom";
const Enteryourlastname$g = "Votre nom de famille";
const ManageSubscription$g = "Gérer l'abonnement";
const ifYouHaveDifficultiesProfile$g = "Si vous rencontrez des difficultés avec les informations de votre profil, veuillez contacter";
const forSupport$g = "pour le support.";
const whatIsIdealCompanySize$g = "Quelle est la taille idéale de votre entreprise ?";
const Saveandcontinue$g = "Sauvegarder et continuer";
const whatIsMinExpectedSalary$g = "Quel est votre salaire minimum attendu (par an) ?";
const Atleast$g = "Au moins";
const SlidetoAdjust$g = "Faites glisser pour ajuster";
const whatIndustryExcitedWork$g = "Quels secteurs d'activité vous passionnent ?";
const Add$g = "Ajouter";
const statusOfJobSearch$g = "Statut de votre recherche d'emploi ?";
const Finish$g = "Terminer";
const whatLevelRoleLooking$g = "À quel niveau de rôle êtes-vous intéressé ?";
const Selectuptotwo$g = "Sélectionnez jusqu'à deux.";
const PreviousStep$g = "Étape précédente";
const Skip$g = "Passer";
const whatDoYouValueNewRole$g = "Qu'est-ce que vous valorisez dans un nouveau rôle ?";
const Selectuptothree$g = "Sélectionnez jusqu'à trois.";
const EqualEmploymentData$g = "Données sur l'égalité d'emploi";
const whatIsYourEthnicity$g = "Quelle est votre ethnie ?";
const areYouAuthorizedToWorkUs$g = "Êtes-vous autorisé à travailler aux États-Unis ?";
const willYouRequireSponsorShip$g = "Avez-vous besoin maintenant ou dans le futur d'un parrainage pour votre statut de visa d'emploi ?";
const doYouHaveADisability$g = "Avez-vous un handicap ?";
const areYouAVeteran$g = "Êtes-vous un vétéran ?";
const rolesYouInterestedIn$g = "Quels types de rôles vous intéressent ?";
const Selectuptofive$g = "Sélectionnez jusqu'à cinq.";
const AddCustomrole$g = "Ajouter un rôle personnalisé";
const whereDoYouLikeWork$g = "Où aimerais-tu travailler ?";
const Resources$g = "Ressources";
const currentlyNoResourceAvailable$g = "Actuellement, aucune ressource n'est disponible.";
const AddNewSection$g = "Ajouter une nouvelle section";
const ChangeSections$g = "Changer les sections";
const Settings$g = "Paramètres";
const Dashboard$g = "Tableau de bord";
const JobBoard$g = "Tableau des emplois";
const Linkedin$g = "Linkedin";
const Community$g = "Communauté";
const FindRecruiters$g = "Trouver des recruteurs";
const Goals$g = "Objectifs";
const DownloadExtension$g = "Télécharger l'extension";
const SuggestaFeature$g = "Suggérer une fonctionnalité";
const leftPanel$g = {
	ReportanIssue: "Signaler un problème"
};
const PhoneNumberisrequired$g = "Le numéro de téléphone est obligatoire.";
const MobileNumber$g = "Numéro de téléphone portable";
const Enteronlynumbers$g = "Entrez uniquement des chiffres.";
const Countryyoulivein$g = "Pays dans lequel vous vivez";
const SelectaCountry$g = "Sélectionnez un pays";
const DateofBirth$g = "Date de naissance";
const Gender$g = "Genre";
const JobPreferences$g = "Préférences d'emploi";
const pleaseEnterValidEmail$g = "Veuillez entrer une adresse e-mail valide.";
const emailSendForResetting$g = "Un e-mail vous a été envoyé pour réinitialiser votre mot de passe.";
const VerifyyourEmailID$g = "Vérifiez votre adresse e-mail";
const sentPleaseCheckEmail$g = "Envoyé ! Veuillez vérifier votre courrier électronique.";
const tooManyAttemptsTryAgain$g = "Trop de tentatives, veuillez réessayer dans un certain temps.";
const Resend$g = "Renvoyer";
const Login$g = "Connexion";
const weHaveSentVerificationLinkAtEmail$g = "Nous vous avons envoyé un lien de vérification à votre adresse e-mail.";
const pleaseVerifyEmailContinueSpam$g = "Veuillez vérifier votre adresse e-mail pour continuer. Veuillez également vérifier les spams ou les promotions pour l'e-mail de vérification.";
const Logintogetstarted$g = "Connectez-vous pour commencer.";
const ContinuewithGoogle$g = "Continuer avec Google";
const pleaseInputEmail$g = "Veuillez saisir votre adresse e-mail !";
const Password$g = "Mot de passe";
const pleaseInputPassword$g = "Veuillez entrer votre mot de passe !";
const passwordLowerUpperDigitSpecial$g = "Votre mot de passe doit contenir au moins une lettre minuscule, une lettre majuscule, un chiffre et un caractère spécial.";
const atLeastSixChar$g = "Au moins 6 caractères.";
const forgotPassword$g = "Mot de passe oublié ?";
const Bysigninginyouagreetoour$g = "En vous connectant, vous acceptez nos";
const Terms$g = "Termes";
const Conditions$g = "Conditions";
const and$g = "et";
const PrivacyPolicy$g = "Politique de confidentialité";
const theseAreTheTopsSkillsExtracted$g = "Ce sont les compétences clés extraites de la description de poste.";
const TopSkills$g = "Compétences clés";
const weCoulNotExtractSkills$g = "Nous n'avons pas pu extraire de compétences de cette description de poste.";
const upgradeToPremiumToView$g = "Mettez à niveau vers Premium pour voir votre score de correspondance des compétences de votre CV.";
const SkillScore$g = "Score de compétence";
const thisIsYourSkillScoreBasedOn$g = "Ceci est votre score de compétences basé sur la description de poste et votre CV.";
const theseSkllsAreStrongMatch$g = "Ces compétences correspondent parfaitement à la fois à votre CV et à la description du poste.";
const Strongmatch$g = "Correspondance forte";
const theseSkillsArePartialMatch$g = "Ces compétences sont une correspondance partielle entre votre CV et la description de poste.";
const Partialmatch$g = "Correspondance partielle";
const theseSkillsAreMissingFrom$g = "Ces mots-clés sont absents de votre CV mais sont présents dans la description de poste. Ils peuvent être des compétences ou des mots-clés généraux spécifiques à l'opportunité d'emploi et pourraient être utiles à ajouter à votre CV.";
const SkillMatchComponent$g = {
	removeSkill: "Quelle est votre principale raison de signaler un problème pour le mot-clé"
};
const Optional$g = "Facultatif";
const Notrelevanttothejob$g = "Pas pertinent pour l'emploi";
const Notaskill$g = "Aucune compétence";
const Toogeneric$g = "Trop générique";
const Pleaseshareanyfeedback$g = "Veuillez partager tout commentaire";
const excludedKeywordsWillNot$g = "Les mots-clés exclus ne seront pas pris en compte dans votre score de correspondance pour toutes les analyses futures. Vous pouvez modifier les mots-clés exclus depuis votre profil.";
const yesExcludeThisSkillFrom$g = "Oui, excluez cette compétence de toutes les analyses de mon CV.";
const PartialMatch$g = "Correspondance partielle";
const MissingKeywords$g = "Mots-clés manquants";
const Providetitletotask$g = "Fournir un titre à la tâche";
const TasksList$g = "Liste des tâches";
const AddTask$g = "Ajouter une tâche";
const EnterTaskTitlehere$g = "Entrer le titre de la tâche ici";
const TasksComponent$g = {
	listEmpty: "Liste de tâches vide, créez-en une nouvelle."
};
const CompletedTasks$g = "Tâches terminées";
const CompleteYourtasks$g = "Terminez vos tâches";
const Steps$g = "Étapes";
const PremiumMember$g = "Membre Premium";
const Thankyouforupgradingto$g = "Merci d'avoir effectué une mise à niveau vers";
const CareerflowPremium$g = "Flux de carrière Premium";
const hereIsHowYouCanAccessPremium$g = "Voici comment accéder à vos avantages Premium !";
const stepOne$g = "Étape 1";
const DownloadourChromeExtension$g = "Téléchargez notre extension Chrome";
const youJobSearchCopilotIshere$g = "Votre copilote d'IA pour la recherche d'emploi est là.";
const DownloadNow$g = "Télécharger maintenant";
const stepTwo$g = "Étape 2";
const GetStarted$g = "Commencer";
const stepThree$g = "Étape 3";
const SignintoChromeExtension$g = "Connectez-vous à l'extension Chrome";
const entityCreated$g = "Nouvelle {{entity}} créée.";
const entityUpdated$g = "{{entity}} mis à jour.";
const entityDeleted$g = "{{entity}} supprimé(e)";
const entityLinked$g = "{{entity}} lié";
const entityUnlinked$g = "{{entity}} non lié";
const entityMovedTo$g = "Déplacé vers {{entity}}";
const youAddedANewEntity$g = "Vous avez ajouté une nouvelle {{entité}}";
const personCreated$g = "{{creator}} a créé une {{entity}} pour {{owner}}.";
const youUpdatedAEntity$g = "Vous avez mis à jour une {{entité}}.";
const personUpdated$g = "{{creator}} a mis à jour une {{entity}} pour {{owner}}.";
const youDeletedAEntity$g = "Vous avez supprimé une {{entité}}";
const personDeleted$g = "{{creator}} a supprimé une {{entity}} pour {{owner}}.";
const youLinkedEntity$g = "Vous avez lié une {{entité}} à ce travail.";
const personLinked$g = "{{creator}} a lié une {{entity}} à ce travail pour {{owner}}.";
const youUnlinked$g = "Vous avez dissocié une {{entity}} de ce travail.";
const personUnlinked$g = "{{creator}} a dissocié une {{entity}} de ce travail pour {{owner}}.";
const youMovedEntity$g = "Vous avez déplacé cette {{entity}} de {{sectionFrom}} à {{sectionTo}}";
const personMoved$g = "{{creator}} a déplacé cette {{entity}} de {{sectionFrom}} à {{sectionTo}} pour {{owner}}.";
const addedByName$g = "Ajouté par {{name}}";
const DownloadChromeExtension$g = "Télécharger l'extension Chrome";
const ourChromeExtensionIs$g = "Notre extension Chrome est un outil intégré pour vous aider à optimiser votre profil LinkedIn, enregistrer des offres d'emploi, sauvegarder des contacts, générer des lettres de motivation et bien plus encore.";
const Optimizeyourprofile$g = "Optimisez votre profil";
const startOptimizingYourProfile$g = "Commencez à optimiser votre profil pour avoir de meilleures chances d'être contacté par des recruteurs.";
const OptimizeNow$g = "Optimisez maintenant";
const Addyourfirstjob$g = "Ajoutez votre premier emploi";
const startSavingJobApplicationsToTrack$g = "Commencez à enregistrer les candidatures d'emploi pour suivre votre parcours de recherche d'emploi et trouver des informations utiles.";
const AddNow$g = "Ajouter maintenant";
const CompleteProfile$g = "Profil complet";
const completeYourProfileForUsing$g = "Complétez votre profil pour utiliser la fonction de remplissage automatique et bénéficier d'une expérience plus personnalisée.";
const CompleteNow$g = "Complétez maintenant";
const Addyourfirstcontact$g = "Ajoutez votre premier contact";
const addContactToFollowUpWith$g = "Ajoutez le contact pour un suivi ultérieur, ajoutez des notes et plus encore.";
const JoinCommunity$g = "Rejoindre la communauté";
const ourCommunityisAlways$g = "Notre communauté est toujours là avec vous dans votre parcours de recherche d'emploi.";
const JoinNow$g = "Rejoignez maintenant";
const welcomeToCareerflow$g = "Bienvenue sur Careerflow !";
const yourHubForCareerInsights2$g = "Ceci est votre centre d'informations pour les perspectives de carrière, les activités et bien plus encore. Explorez votre tableau de bord personnalisé pour rester au top de votre parcours professionnel.";
const ChecklistCompleted$g = "Votre liste de contrôle est terminée !";
const Completeyourchecklist$g = "Complétez votre liste de contrôle";
const completeAFewStepsTo$g = "Effectuez quelques étapes pour décrocher votre prochain emploi.";
const Completed$g = "Terminé";
const JobCountByStage$g = "Nombre d'emplois par étape";
const NopastapplicationDatafound$g = "Aucune donnée d'application passée trouvée";
const YourJobSearchStages$g = "Les étapes de votre recherche d'emploi";
const NoDatafound$g = "Aucune donnée trouvée";
const fr = {
	copyToClipboard: copyToClipboard$g,
	UnlocktheAIgenerated: UnlocktheAIgenerated$g,
	UpgradetoPremium: UpgradetoPremium$g,
	Result: Result$g,
	Copy: Copy$g,
	Save: Save$g,
	Edit: Edit$g,
	Processing: Processing$g,
	YourAIgeneratedcontentwillshowhere: YourAIgeneratedcontentwillshowhere$g,
	hopeYouFindUseful: hopeYouFindUseful$g,
	regenerate: regenerate$g,
	ProvideAdditionalFeedback: ProvideAdditionalFeedback$g,
	Enteranyfeedback: Enteranyfeedback$g,
	Notimpressive: Notimpressive$g,
	thisIsntTrue: thisIsntTrue$g,
	Notpersonalized: Notpersonalized$g,
	Tone: Tone$g,
	Length: Length$g,
	Template: Template$g,
	Generatedon: Generatedon$g,
	Copiedtoclipboard: Copiedtoclipboard$g,
	CopytoClipboard: CopytoClipboard$g,
	DownloadasPDF: DownloadasPDF$g,
	ViewDetails: ViewDetails$g,
	JobDescriptionImported: JobDescriptionImported$g,
	ImportfromJob: ImportfromJob$g,
	Saved: Saved$g,
	Applied: Applied$g,
	Offer: Offer$g,
	Interviewing: Interviewing$g,
	Rejected: Rejected$g,
	Search: Search$g,
	Import: Import$g,
	CoverLetterGeneratorHistory: CoverLetterGeneratorHistory$g,
	NoCoverLettersGenerated: NoCoverLettersGenerated$g,
	getStartedCoverLetter: getStartedCoverLetter$g,
	getStarted: getStarted$g,
	Documents: Documents$g,
	UploadNewDocument: UploadNewDocument$g,
	AICoverLetterGenerator: AICoverLetterGenerator$g,
	ViewHistory: ViewHistory$g,
	JobDescription: JobDescription$g,
	ImportfromBoard: ImportfromBoard$g,
	EnterJobDescription: EnterJobDescription$g,
	JobTitle: JobTitle$g,
	EnterJobTitle: EnterJobTitle$g,
	CompanyName: CompanyName$g,
	EnterCompanyName: EnterCompanyName$g,
	YourProfile: YourProfile$g,
	ResumeUpload: ResumeUpload$g,
	UseLinkedinProfile: UseLinkedinProfile$g,
	Uploadyourresume: Uploadyourresume$g,
	AddyourResume: AddyourResume$g,
	fileNameCannotFormat: fileNameCannotFormat$g,
	ChooseorUpload: ChooseorUpload$g,
	SelectTemplate: SelectTemplate$g,
	Preview: Preview$g,
	UseTemplate: UseTemplate$g,
	Change: Change$g,
	AdvancedSettings: AdvancedSettings$g,
	AdditionalContext: AdditionalContext$g,
	Professional: Professional$g,
	Casual: Casual$g,
	Enthusiastic: Enthusiastic$g,
	Informational: Informational$g,
	Short: Short$g,
	Medium: Medium$g,
	Long: Long$g,
	Language: Language$g,
	iAmOkayBack: iAmOkayBack$g,
	Generate: Generate$g,
	CoverLetter: CoverLetter$g,
	SelectLanguage: SelectLanguage$g,
	AboutGeneratorHistory: AboutGeneratorHistory$g,
	NoAboutsGenerated: NoAboutsGenerated$g,
	getStartedAbouts: getStartedAbouts$g,
	noAttachmentsFound: noAttachmentsFound$g,
	TargetJobTitle: TargetJobTitle$g,
	KeywordsToInclude: KeywordsToInclude$g,
	UploadYourResume: UploadYourResume$g,
	AddYourResume: AddYourResume$g,
	LinkedinProfile: LinkedinProfile$g,
	Linkedinprofilenotfound: Linkedinprofilenotfound$g,
	startUsingChromeExtension: startUsingChromeExtension$g,
	Download: Download$g,
	UseEmojis: UseEmojis$g,
	UseBulletPoints: UseBulletPoints$g,
	SpeechFocus: SpeechFocus$g,
	FirstPerson: FirstPerson$g,
	ThirdPerson: ThirdPerson$g,
	HeadlineGeneratorHistory: HeadlineGeneratorHistory$g,
	NoHeadlinesGenerated: NoHeadlinesGenerated$g,
	getStartedHeadline: getStartedHeadline$g,
	AIHeadlineGenerator: AIHeadlineGenerator$g,
	KeywordstoInclude: KeywordstoInclude$g,
	Pressenteraftereachword: Pressenteraftereachword$g,
	LinkedinProfilenotfound: LinkedinProfilenotfound$g,
	Headline: Headline$g,
	PostGeneratorHistory: PostGeneratorHistory$g,
	NoPostsGenerated: NoPostsGenerated$g,
	getStartedPost: getStartedPost$g,
	Topic: Topic$g,
	Description: Description$g,
	UseHashtags: UseHashtags$g,
	Custom: Custom$g,
	EnterCustomTone: EnterCustomTone$g,
	Added: Added$g,
	ComingSoon: ComingSoon$g,
	Company: Company$g,
	JobInterview: JobInterview$g,
	Research: Research$g,
	Networking: Networking$g,
	Referral: Referral$g,
	MustbeContacted: MustbeContacted$g,
	ScheduleaMeeting: ScheduleaMeeting$g,
	needAFollowUp: needAFollowUp$g,
	Today: Today$g,
	Viewdetails: Viewdetails$g,
	Activity: Activity$g,
	ActivityDetails: ActivityDetails$g,
	Delete: Delete$g,
	Title: Title$g,
	Goal: Goal$g,
	Status: Status$g,
	FollowUp: FollowUp$g,
	AddActivity: AddActivity$g,
	Enteractivitytitle: Enteractivitytitle$g,
	Cancel: Cancel$g,
	SaveActivity: SaveActivity$g,
	noActivityPresent: noActivityPresent$g,
	Addnew: Addnew$g,
	About: About$g,
	noDataPresentYou: noDataPresentYou$g,
	Experience: Experience$g,
	Education: Education$g,
	Skills: Skills$g,
	Overview: Overview$g,
	LinkedJobs: LinkedJobs$g,
	Notes: Notes$g,
	FullName: FullName$g,
	Location: Location$g,
	Relationship: Relationship$g,
	Contacts: Contacts$g,
	CreateContact: CreateContact$g,
	NotesCreated: NotesCreated$g,
	Notesupdated: Notesupdated$g,
	Addnote: Addnote$g,
	areYouSureDeleteNote: areYouSureDeleteNote$g,
	Createdby: Createdby$g,
	notSureWhyResumeCalls: notSureWhyResumeCalls$g,
	getExpertResumeReview: getExpertResumeReview$g,
	youHaventAddedContacts: youHaventAddedContacts$g,
	noMatchingContacts: noMatchingContacts$g,
	Link: Link$g,
	unlink: unlink$g,
	Locationnotavailable: Locationnotavailable$g,
	Emailnotavailable: Emailnotavailable$g,
	PhoneNumbernotavailable: PhoneNumbernotavailable$g,
	createdby: createdby$g,
	areYouSureDeleteContact: areYouSureDeleteContact$g,
	areYouSureUnlinkContact: areYouSureUnlinkContact$g,
	Addedbyyou: Addedbyyou$g,
	Addedby: Addedby$g,
	Timeline: Timeline$g,
	Timelineempty: Timelineempty$g,
	Discard: Discard$g,
	SaveContact: SaveContact$g,
	Recruiter: Recruiter$g,
	Candidate: Candidate$g,
	Colleague: Colleague$g,
	Employee: Employee$g,
	"Needtofollow-up": "Besoin de faire un suivi",
	EnterValidEmail: EnterValidEmail$g,
	EnterValidPhoneNumber: EnterValidPhoneNumber$g,
	editingProfileNotAvailable: editingProfileNotAvailable$g,
	itWillBeSoonAvailable: itWillBeSoonAvailable$g,
	ChromeExtension: ChromeExtension$g,
	SelectTag: SelectTag$g,
	FirstName: FirstName$g,
	FirstNameisrequired: FirstNameisrequired$g,
	LastName: LastName$g,
	LastNameisrequired: LastNameisrequired$g,
	Companyisrequired: Companyisrequired$g,
	Email: Email$g,
	ThisisnotavalidEmail: ThisisnotavalidEmail$g,
	AddEmail: AddEmail$g,
	PhoneNumber: PhoneNumber$g,
	notaValidPhone: notaValidPhone$g,
	phoneNoMinimum5char: phoneNoMinimum5char$g,
	phoneNoMinumum15char: phoneNoMinumum15char$g,
	AddPhoneNumber: AddPhoneNumber$g,
	SelectGoal: SelectGoal$g,
	SelectStatus: SelectStatus$g,
	Followup: Followup$g,
	SocialMedia: SocialMedia$g,
	Linkedinhandle: Linkedinhandle$g,
	Twitterhandle: Twitterhandle$g,
	Facebookhandle: Facebookhandle$g,
	Githubhandle: Githubhandle$g,
	Gmailhandle: Gmailhandle$g,
	Changessavedsuccessfully: Changessavedsuccessfully$g,
	EditContact: EditContact$g,
	BasicInformation: BasicInformation$g,
	EditContactDetails: EditContactDetails$g,
	SaveChanges: SaveChanges$g,
	phoneNoMinimum14char: phoneNoMinimum14char$g,
	LinkedIn: LinkedIn$g,
	Twitter: Twitter$g,
	Facebook: Facebook$g,
	Github: Github$g,
	Gmail: Gmail$g,
	youCanWriteAbout: youCanWriteAbout$g,
	Addednewsection: Addednewsection$g,
	Removedsuccessfully: Removedsuccessfully$g,
	Remove: Remove$g,
	Institute: Institute$g,
	Schoolisrequired: Schoolisrequired$g,
	Degree: Degree$g,
	StartMonth: StartMonth$g,
	StartYear: StartYear$g,
	EndMonth: EndMonth$g,
	EndYear: EndYear$g,
	Addmore: Addmore$g,
	PositionTitle: PositionTitle$g,
	ExperienceType: ExperienceType$g,
	Addednewitem: Addednewitem$g,
	whatSkillsDoYouEnjoy: whatSkillsDoYouEnjoy$g,
	Typeskillshere: Typeskillshere$g,
	LinkedContacts: LinkedContacts$g,
	LinkContact: LinkContact$g,
	NocontactsLinked: NocontactsLinked$g,
	JobContactsComponent: JobContactsComponent$g,
	Nocontacts: Nocontacts$g,
	LinkJobto: LinkJobto$g,
	Contact: Contact$g,
	Document: Document$g,
	Nojobsfound: Nojobsfound$g,
	LinkJob: LinkJob$g,
	youCanLinkContactJobImported: youCanLinkContactJobImported$g,
	Prev: Prev$g,
	Next: Next$g,
	areYouSureUnlinkDocument: areYouSureUnlinkDocument$g,
	areYouSureDeleteDocument: areYouSureDeleteDocument$g,
	Category: Category$g,
	CreatedOn: CreatedOn$g,
	Joblinked: Joblinked$g,
	Quickactions: Quickactions$g,
	All: All$g,
	Resume: Resume$g,
	Portfolio: Portfolio$g,
	Other: Other$g,
	Adddocument: Adddocument$g,
	Type: Type$g,
	Sortingby: Sortingby$g,
	SwitchtoGridLayout: SwitchtoGridLayout$g,
	SwitchtoListLayout: SwitchtoListLayout$g,
	NoDocumentsAdded: NoDocumentsAdded$g,
	DocumentsComponent: DocumentsComponent$g,
	NoDocumentFound: NoDocumentFound$g,
	SelectFile: SelectFile$g,
	onlyPdfDocxSupported: onlyPdfDocxSupported$g,
	Uploadfile: Uploadfile$g,
	DocumentCategory: DocumentCategory$g,
	SaveDocument: SaveDocument$g,
	AddDocument: AddDocument$g,
	LinkedDocuments: LinkedDocuments$g,
	LinkDocument: LinkDocument$g,
	NodocumentsLinked: NodocumentsLinked$g,
	JobDocumentsComponent: JobDocumentsComponent$g,
	NoDocuments: NoDocuments$g,
	CreateDocuments: CreateDocuments$g,
	youCanLinkDocumentJobImported: youCanLinkDocumentJobImported$g,
	Documenteditedsuccessfully: Documenteditedsuccessfully$g,
	DocumentDetails: DocumentDetails$g,
	UnsavedChanges: UnsavedChanges$g,
	yourChangesWillBeLostSureClose: yourChangesWillBeLostSureClose$g,
	yourChangesWillBeLostSureDiscard: yourChangesWillBeLostSureDiscard$g,
	DiscardChanges: DiscardChanges$g,
	WeeklyGoalAlert: WeeklyGoalAlert$g,
	Progress: Progress$g,
	AllGoals: AllGoals$g,
	Name: Name$g,
	Completedon: Completedon$g,
	Createdon: Createdon$g,
	Action: Action$g,
	Back: Back$g,
	OverallScore: OverallScore$g,
	Aboutthegoal: Aboutthegoal$g,
	GoalTracking: GoalTracking$g,
	Week: Week$g,
	progress: progress$g,
	loading: loading$g,
	Apply: Apply$g,
	Thisskillhasbeenreported: Thisskillhasbeenreported$g,
	issueGettingResume: issueGettingResume$g,
	Interview: Interview$g,
	Tasks: Tasks$g,
	Loading: Loading$g,
	Skilladdedsuccessfully: Skilladdedsuccessfully$g,
	problemAddingSkill: problemAddingSkill$g,
	Reportaproblem: Reportaproblem$g,
	Submit: Submit$g,
	Addanewskill: Addanewskill$g,
	JobDetailsComponent: JobDetailsComponent$g,
	HardSkill: HardSkill$g,
	SoftSkill: SoftSkill$g,
	Pleaseshareanyadditionalcontext: Pleaseshareanyadditionalcontext$g,
	Addasskill: Addasskill$g,
	Skill: Skill$g,
	JobFrequency: JobFrequency$g,
	ResumeFrequency: ResumeFrequency$g,
	Reportskill: Reportskill$g,
	JobDetails: JobDetails$g,
	ViewJobLink: ViewJobLink$g,
	Salary: Salary$g,
	areYouSureDeleteJob: areYouSureDeleteJob$g,
	ViewMore: ViewMore$g,
	ViewLess: ViewLess$g,
	matchYouSkillsAgainstJob: matchYouSkillsAgainstJob$g,
	pleaseUploadResumeSkillMatch: pleaseUploadResumeSkillMatch$g,
	AddResume: AddResume$g,
	thisJobDoesNotHaveAnyDesc: thisJobDoesNotHaveAnyDesc$g,
	youCanEditJobToAdd: youCanEditJobToAdd$g,
	chromeextension: chromeextension$g,
	fromVariousJobPortalsOnce: fromVariousJobPortalsOnce$g,
	AddDescription: AddDescription$g,
	CompanyInfo: CompanyInfo$g,
	Website: Website$g,
	Industry: Industry$g,
	EmployeeCount: EmployeeCount$g,
	ExprienceLevel: ExprienceLevel$g,
	Address: Address$g,
	Resumes: Resumes$g,
	Setasdefault: Setasdefault$g,
	Ok: Ok$g,
	UploadNewResume: UploadNewResume$g,
	Default: Default$g,
	Jobnotfound: Jobnotfound$g,
	EditDetails: EditDetails$g,
	JobPostURL: JobPostURL$g,
	Enterjoburl: Enterjoburl$g,
	Nojobselected: Nojobselected$g,
	Viewjobdetails: Viewjobdetails$g,
	Jobaddedtoyourboardsuccessfully: Jobaddedtoyourboardsuccessfully$g,
	AddJob: AddJob$g,
	Addnewjobname: Addnewjobname$g,
	JobUrl: JobUrl$g,
	Addjoburl: Addjoburl$g,
	Section: Section$g,
	didYouKnow: didYouKnow$g,
	Jobs: Jobs$g,
	AddJobtoboard: AddJobtoboard$g,
	Currentlynojobsareavailable: Currentlynojobsareavailable$g,
	noMatchingJobs: noMatchingJobs$g,
	welcomeToYourPersonalJobTracker: welcomeToYourPersonalJobTracker$g,
	weShortTutorialOnHowTrackingJob: weShortTutorialOnHowTrackingJob$g,
	Addanewjob: Addanewjob$g,
	inOrderTrackCreatButton: inOrderTrackCreatButton$g,
	Providesomedetails: Providesomedetails$g,
	toBeginTypeJobTitleCompany: toBeginTypeJobTitleCompany$g,
	asAnExampleFilledForYou: asAnExampleFilledForYou$g,
	wohooAddedFirstJob: wohooAddedFirstJob$g,
	youCanDragDropJobCard: youCanDragDropJobCard$g,
	Lastbutnotleast: Lastbutnotleast$g,
	finalStepMakeSure: finalStepMakeSure$g,
	autoMaticallyImportJobs: autoMaticallyImportJobs$g,
	selectanysection: selectanysection$g,
	Accept: Accept$g,
	My2023JobSearch: My2023JobSearch$g,
	AddedFrom: AddedFrom$g,
	AddedUntil: AddedUntil$g,
	BasicModal: BasicModal$g,
	AddnewSectionName: AddnewSectionName$g,
	OpenTo: OpenTo$g,
	Featured: Featured$g,
	LicenceAndCerts: LicenceAndCerts$g,
	Banner: Banner$g,
	LinkedInURL: LinkedInURL$g,
	Recommendations: Recommendations$g,
	LinkedinReview: LinkedinReview$g,
	NoDataAvailable: NoDataAvailable$g,
	looksLikeYouDidNot: looksLikeYouDidNot$g,
	toOptimizeProfileScoreVisible: toOptimizeProfileScoreVisible$g,
	LinkedinComponent: LinkedinComponent$g,
	improveYourChancesLandingDreamJob: improveYourChancesLandingDreamJob$g,
	VisitProfile: VisitProfile$g,
	wantToGetLinkedinMakeover: wantToGetLinkedinMakeover$g,
	PostGenerator: PostGenerator$g,
	LinkedinHeadlineGenerator: LinkedinHeadlineGenerator$g,
	LinkedinAboutSectionGenerator: LinkedinAboutSectionGenerator$g,
	AITools: AITools$g,
	Premium: Premium$g,
	LinkedInOptimization: LinkedInOptimization$g,
	JobTracker: JobTracker$g,
	whoIsHiring: whoIsHiring$g,
	Autofill: Autofill$g,
	HeadlineGenerator: HeadlineGenerator$g,
	skillMatching: skillMatching$g,
	SummarizeJD: SummarizeJD$g,
	contactFeature: contactFeature$g,
	documentFeature: documentFeature$g,
	landJobWithoutStress: landJobWithoutStress$g,
	discoverFeatures: discoverFeatures$g,
	letsBeginOnboarding: letsBeginOnboarding$g,
	inTheNextFewScreensJobThirdParties: inTheNextFewScreensJobThirdParties$g,
	letsAddBasicInformation: letsAddBasicInformation$g,
	Pleaseselectanoptionfirst: Pleaseselectanoptionfirst$g,
	JobApplicationTracker: JobApplicationTracker$g,
	LinkedInProfileOptimizer: LinkedInProfileOptimizer$g,
	UnlimitedDocuments: UnlimitedDocuments$g,
	UnlimitedContacts: UnlimitedContacts$g,
	HiringManagerSearch: HiringManagerSearch$g,
	AILinkedInPostGenerator: AILinkedInPostGenerator$g,
	ATSKeywordSkillMatch: ATSKeywordSkillMatch$g,
	"Auto-Apply": "Application automatique",
	ChooseyourPlan: ChooseyourPlan$g,
	superChargeYourJobSearch: superChargeYourJobSearch$g,
	startNowGoto: startNowGoto$g,
	CreatedBy: CreatedBy$g,
	CreateNewNote: CreateNewNote$g,
	Nonotescreated: Nonotescreated$g,
	approxTimeIsFourMinutes: approxTimeIsFourMinutes$g,
	Continue: Continue$g,
	iWillDoLaterTakeMeToApp: iWillDoLaterTakeMeToApp$g,
	allDone: allDone$g,
	welcomeAbord: welcomeAbord$g,
	letsBegin: letsBegin$g,
	UpgradeyourplanandgetAIAssistance: UpgradeyourplanandgetAIAssistance$g,
	DownloadPDF: DownloadPDF$g,
	oopsWeCouldntProcessResume: oopsWeCouldntProcessResume$g,
	MyProfile: MyProfile$g,
	Setting: Setting$g,
	Logout: Logout$g,
	SignIn: SignIn$g,
	Typeyourfirstnamehere: Typeyourfirstnamehere$g,
	Enteryourlastname: Enteryourlastname$g,
	ManageSubscription: ManageSubscription$g,
	ifYouHaveDifficultiesProfile: ifYouHaveDifficultiesProfile$g,
	forSupport: forSupport$g,
	whatIsIdealCompanySize: whatIsIdealCompanySize$g,
	Saveandcontinue: Saveandcontinue$g,
	whatIsMinExpectedSalary: whatIsMinExpectedSalary$g,
	Atleast: Atleast$g,
	SlidetoAdjust: SlidetoAdjust$g,
	whatIndustryExcitedWork: whatIndustryExcitedWork$g,
	Add: Add$g,
	statusOfJobSearch: statusOfJobSearch$g,
	Finish: Finish$g,
	whatLevelRoleLooking: whatLevelRoleLooking$g,
	Selectuptotwo: Selectuptotwo$g,
	PreviousStep: PreviousStep$g,
	Skip: Skip$g,
	whatDoYouValueNewRole: whatDoYouValueNewRole$g,
	Selectuptothree: Selectuptothree$g,
	EqualEmploymentData: EqualEmploymentData$g,
	whatIsYourEthnicity: whatIsYourEthnicity$g,
	areYouAuthorizedToWorkUs: areYouAuthorizedToWorkUs$g,
	willYouRequireSponsorShip: willYouRequireSponsorShip$g,
	doYouHaveADisability: doYouHaveADisability$g,
	areYouAVeteran: areYouAVeteran$g,
	rolesYouInterestedIn: rolesYouInterestedIn$g,
	Selectuptofive: Selectuptofive$g,
	AddCustomrole: AddCustomrole$g,
	whereDoYouLikeWork: whereDoYouLikeWork$g,
	Resources: Resources$g,
	currentlyNoResourceAvailable: currentlyNoResourceAvailable$g,
	AddNewSection: AddNewSection$g,
	ChangeSections: ChangeSections$g,
	Settings: Settings$g,
	Dashboard: Dashboard$g,
	JobBoard: JobBoard$g,
	Linkedin: Linkedin$g,
	Community: Community$g,
	FindRecruiters: FindRecruiters$g,
	Goals: Goals$g,
	DownloadExtension: DownloadExtension$g,
	SuggestaFeature: SuggestaFeature$g,
	leftPanel: leftPanel$g,
	PhoneNumberisrequired: PhoneNumberisrequired$g,
	MobileNumber: MobileNumber$g,
	Enteronlynumbers: Enteronlynumbers$g,
	Countryyoulivein: Countryyoulivein$g,
	SelectaCountry: SelectaCountry$g,
	DateofBirth: DateofBirth$g,
	Gender: Gender$g,
	JobPreferences: JobPreferences$g,
	pleaseEnterValidEmail: pleaseEnterValidEmail$g,
	emailSendForResetting: emailSendForResetting$g,
	VerifyyourEmailID: VerifyyourEmailID$g,
	sentPleaseCheckEmail: sentPleaseCheckEmail$g,
	tooManyAttemptsTryAgain: tooManyAttemptsTryAgain$g,
	Resend: Resend$g,
	Login: Login$g,
	weHaveSentVerificationLinkAtEmail: weHaveSentVerificationLinkAtEmail$g,
	pleaseVerifyEmailContinueSpam: pleaseVerifyEmailContinueSpam$g,
	Logintogetstarted: Logintogetstarted$g,
	ContinuewithGoogle: ContinuewithGoogle$g,
	pleaseInputEmail: pleaseInputEmail$g,
	Password: Password$g,
	pleaseInputPassword: pleaseInputPassword$g,
	passwordLowerUpperDigitSpecial: passwordLowerUpperDigitSpecial$g,
	atLeastSixChar: atLeastSixChar$g,
	forgotPassword: forgotPassword$g,
	Bysigninginyouagreetoour: Bysigninginyouagreetoour$g,
	Terms: Terms$g,
	Conditions: Conditions$g,
	and: and$g,
	PrivacyPolicy: PrivacyPolicy$g,
	theseAreTheTopsSkillsExtracted: theseAreTheTopsSkillsExtracted$g,
	TopSkills: TopSkills$g,
	weCoulNotExtractSkills: weCoulNotExtractSkills$g,
	upgradeToPremiumToView: upgradeToPremiumToView$g,
	SkillScore: SkillScore$g,
	thisIsYourSkillScoreBasedOn: thisIsYourSkillScoreBasedOn$g,
	theseSkllsAreStrongMatch: theseSkllsAreStrongMatch$g,
	Strongmatch: Strongmatch$g,
	theseSkillsArePartialMatch: theseSkillsArePartialMatch$g,
	Partialmatch: Partialmatch$g,
	theseSkillsAreMissingFrom: theseSkillsAreMissingFrom$g,
	"Missing Keywords": "Mots-clés manquants",
	SkillMatchComponent: SkillMatchComponent$g,
	Optional: Optional$g,
	Notrelevanttothejob: Notrelevanttothejob$g,
	Notaskill: Notaskill$g,
	Toogeneric: Toogeneric$g,
	Pleaseshareanyfeedback: Pleaseshareanyfeedback$g,
	excludedKeywordsWillNot: excludedKeywordsWillNot$g,
	yesExcludeThisSkillFrom: yesExcludeThisSkillFrom$g,
	PartialMatch: PartialMatch$g,
	MissingKeywords: MissingKeywords$g,
	Providetitletotask: Providetitletotask$g,
	TasksList: TasksList$g,
	AddTask: AddTask$g,
	EnterTaskTitlehere: EnterTaskTitlehere$g,
	TasksComponent: TasksComponent$g,
	CompletedTasks: CompletedTasks$g,
	CompleteYourtasks: CompleteYourtasks$g,
	Steps: Steps$g,
	PremiumMember: PremiumMember$g,
	Thankyouforupgradingto: Thankyouforupgradingto$g,
	CareerflowPremium: CareerflowPremium$g,
	hereIsHowYouCanAccessPremium: hereIsHowYouCanAccessPremium$g,
	stepOne: stepOne$g,
	DownloadourChromeExtension: DownloadourChromeExtension$g,
	youJobSearchCopilotIshere: youJobSearchCopilotIshere$g,
	DownloadNow: DownloadNow$g,
	stepTwo: stepTwo$g,
	GetStarted: GetStarted$g,
	stepThree: stepThree$g,
	SignintoChromeExtension: SignintoChromeExtension$g,
	entityCreated: entityCreated$g,
	entityUpdated: entityUpdated$g,
	entityDeleted: entityDeleted$g,
	entityLinked: entityLinked$g,
	entityUnlinked: entityUnlinked$g,
	entityMovedTo: entityMovedTo$g,
	youAddedANewEntity: youAddedANewEntity$g,
	personCreated: personCreated$g,
	youUpdatedAEntity: youUpdatedAEntity$g,
	personUpdated: personUpdated$g,
	youDeletedAEntity: youDeletedAEntity$g,
	personDeleted: personDeleted$g,
	youLinkedEntity: youLinkedEntity$g,
	personLinked: personLinked$g,
	youUnlinked: youUnlinked$g,
	personUnlinked: personUnlinked$g,
	youMovedEntity: youMovedEntity$g,
	personMoved: personMoved$g,
	addedByName: addedByName$g,
	DownloadChromeExtension: DownloadChromeExtension$g,
	ourChromeExtensionIs: ourChromeExtensionIs$g,
	Optimizeyourprofile: Optimizeyourprofile$g,
	startOptimizingYourProfile: startOptimizingYourProfile$g,
	OptimizeNow: OptimizeNow$g,
	Addyourfirstjob: Addyourfirstjob$g,
	startSavingJobApplicationsToTrack: startSavingJobApplicationsToTrack$g,
	AddNow: AddNow$g,
	CompleteProfile: CompleteProfile$g,
	completeYourProfileForUsing: completeYourProfileForUsing$g,
	CompleteNow: CompleteNow$g,
	Addyourfirstcontact: Addyourfirstcontact$g,
	addContactToFollowUpWith: addContactToFollowUpWith$g,
	JoinCommunity: JoinCommunity$g,
	ourCommunityisAlways: ourCommunityisAlways$g,
	JoinNow: JoinNow$g,
	welcomeToCareerflow: welcomeToCareerflow$g,
	yourHubForCareerInsights2: yourHubForCareerInsights2$g,
	ChecklistCompleted: ChecklistCompleted$g,
	Completeyourchecklist: Completeyourchecklist$g,
	completeAFewStepsTo: completeAFewStepsTo$g,
	Completed: Completed$g,
	JobCountByStage: JobCountByStage$g,
	NopastapplicationDatafound: NopastapplicationDatafound$g,
	YourJobSearchStages: YourJobSearchStages$g,
	NoDatafound: NoDatafound$g
};

const copyToClipboard$f = "क्लिपबोर्ड पर कॉपी किया गया!";
const UnlocktheAIgenerated$f = "एआई जेनरेटेड को अनलॉक करें";
const UpgradetoPremium$f = "परिणाम";
const Result$f = "परिणाम";
const Copy$f = "कॉपी";
const Save$f = "सहेजें";
const Edit$f = "संपादित करें";
const Processing$f = "प्रस्सेसिंग";
const YourAIgeneratedcontentwillshowhere$f = "आपकी ए.आई. उत्पन्न सामग्री यहाँ दिखाई जाएगी";
const hopeYouFindUseful$f = "आशा है कि आपको यह परिणाम उपयोगी लगेगा!";
const regenerate$f = "पुनः उत्पन्न करें";
const ProvideAdditionalFeedback$f = "अतिरिक्त प्रतिसाद प्रदान करें";
const Enteranyfeedback$f = "कोई प्रतिसाद दर्ज करें";
const Notimpressive$f = "प्रभावशाली नहीं";
const thisIsntTrue$f = "यह सच नहीं है";
const Notpersonalized$f = "व्यक्तिगत नहीं";
const Tone$f = "टोन";
const Length$f = "लंबाई";
const Template$f = "टेम्प्लेट";
const Generatedon$f = "उत्पन्न हुआ";
const Copiedtoclipboard$f = "क्लिपबोर्ड पर कॉपी किया गया";
const CopytoClipboard$f = "क्लिपबोर्ड पर कॉपी करें";
const DownloadasPDF$f = "पीडीएफ़ के रूप में डाउनलोड करें";
const ViewDetails$f = "विवरण देखें";
const JobDescriptionImported$f = "नौकरी का विवरण आयातित";
const ImportfromJob$f = "नौकरी से आयात";
const Saved$f = "सहेजा गया";
const Applied$f = "लागू किया गया";
const Offer$f = "ऑफर";
const Interviewing$f = "साक्षात्कार";
const Rejected$f = "अस्वीकृत";
const Search$f = "खोजें";
const Import$f = "आयात";
const CoverLetterGeneratorHistory$f = "कवर पत्र जेनरेटर इतिहास";
const NoCoverLettersGenerated$f = "कोई कवर पत्र नहीं जेनरेट हुए";
const getStartedCoverLetter$f = "आपने अबतक कोई कवर पत्र नहीं जेनरेट किए हैं। शुरू हो जाइए और अपने संबंधित अनुभव के साथ नौकरी विवरण को मेल करके कवर पत्र प्राप्त करें।";
const getStarted$f = "शुरू करें!";
const Documents$f = "दस्तावेज़";
const UploadNewDocument$f = "नया दस्तावेज़ अपलोड करें";
const AICoverLetterGenerator$f = "ए.आई. कवर पत्र जेनरेटर";
const ViewHistory$f = "इतिहास देखें";
const JobDescription$f = "नौकरी का विवरण";
const ImportfromBoard$f = "बोर्ड से आयात करें";
const EnterJobDescription$f = "नौकरी का विवरण दर्ज करें";
const JobTitle$f = "नौकरी का शीर्षक";
const EnterJobTitle$f = "नौकरी का शीर्षक दर्ज करें";
const CompanyName$f = "कंपनी का नाम";
const EnterCompanyName$f = "कंपनी का नाम दर्ज करें";
const YourProfile$f = "आपकी प्रोफाइल";
const ResumeUpload$f = "रिज़्यूम अपलोड";
const UseLinkedinProfile$f = "लिंक्डइन प्रोफाइल का उपयोग करें";
const Uploadyourresume$f = "अपना रिज़्यूम अपलोड करें";
const AddyourResume$f = "अपना रिज़्यूम जोड़ें";
const fileNameCannotFormat$f = "फ़ाइल नाम में रिक्त स्थान या अंडरस्कोर नहीं हो सकता है और यह .doc, .docx, या .pdf में होना चाहिए।";
const ChooseorUpload$f = "चयन करें या अपलोड करें";
const SelectTemplate$f = "टेम्प्लेट का चयन करें";
const Preview$f = "पूर्वावलोकन";
const UseTemplate$f = "टेम्प्लेट का उपयोग करें";
const Change$f = "बदलें";
const AdvancedSettings$f = "उन्नत सेटिंग्स";
const AdditionalContext$f = "अतिरिक्त संदर्भ";
const Professional$f = "पेशेवर";
const Casual$f = "सामान्य";
const Enthusiastic$f = "उत्साही";
const Informational$f = "जानकारीक";
const Short$f = "संक्षेप";
const Medium$f = "मध्यम";
const Long$f = "लंबा";
const Language$f = "भाषा";
const iAmOkayBack$f = "मैं ठीक हूं! पीछे जाएं";
const Generate$f = "जेनरेट करें";
const CoverLetter$f = "कवर पत्र";
const SelectLanguage$f = "भाषा चुनें";
const AboutGeneratorHistory$f = "जेनरेटर इतिहास के बारे में";
const NoAboutsGenerated$f = "कोई जेनरेट हुए नहीं";
const getStartedAbouts$f = "आपने अबतक कोई भी बनावट नहीं की हैं। शुरू हो जाइए और अपने संबंधित अनुभव के साथ नौकरी विवरण के मैचिंग करके बनावट प्राप्त करें।";
const noAttachmentsFound$f = "कोई अटैचमेंट्स नहीं मिले।";
const TargetJobTitle$f = "लक्ष्य नौकरी का शीर्षक";
const KeywordsToInclude$f = "शामिल करने के लिए कीवर्ड";
const UploadYourResume$f = "अपने रिज्यूमे अपलोड करें।";
const AddYourResume$f = "अपने रिज्यूमे जोड़ें।";
const LinkedinProfile$f = "लिंक्डइन प्रोफाइल";
const Linkedinprofilenotfound$f = "लिंक्डइन प्रोफाइल नहीं मिला";
const startUsingChromeExtension$f = "इस विकल्प का उपयोग करने के लिए अपनी लिंक्डइन प्रोफाइल को अनुकूलित करना शुरू करें हमारे क्रोम एक्सटेंशन का उपयोग करें।";
const Download$f = "डाउनलोड";
const UseEmojis$f = "इमोजी का उपयोग करें";
const UseBulletPoints$f = "बुलेट पॉइंट्स का उपयोग करें";
const SpeechFocus$f = "भाषण केंद्रित";
const FirstPerson$f = "पहला व्यक्ति";
const ThirdPerson$f = "तृतीय पुरुष";
const HeadlineGeneratorHistory$f = "हेडलाइन जेनरेटर इतिहास";
const NoHeadlinesGenerated$f = "कोई हेडलाइन जेनरेट नहीं हुई";
const getStartedHeadline$f = "आपने अबतक कोई भी हेडलाइन नहीं जेनरेट की हैं। शुरू हो जाइए और अपने संबंधित अनुभव के साथ नौकरी विवरण के मैचिंग करके हेडलाइन प्राप्त करें।";
const AIHeadlineGenerator$f = "ए.आई. हेडलाइन जेनरेटर";
const KeywordstoInclude$f = "शामिल करने के कीवर्ड्स";
const Pressenteraftereachword$f = "हर शब्द के बाद एंटर दबाएं";
const LinkedinProfilenotfound$f = "लिंक्डइन प्रोफ़ाइल नहीं मिली।";
const Headline$f = "शीर्षक";
const PostGeneratorHistory$f = "पोस्ट जेनरेटर इतिहास";
const NoPostsGenerated$f = "कोई पोस्ट जेनरेट नहीं हुई";
const getStartedPost$f = "आपने अबतक कोई पोस्ट नहीं जेनरेट की है। शुरू हो जाइए और अपने संबंधित अनुभव के साथ नौकरी विवरण के मैचिंग करके पोस्ट प्राप्त करें।";
const Topic$f = "विषय";
const Description$f = "विवरण";
const UseHashtags$f = "हैशटैग का उपयोग करें";
const Custom$f = "कस्टम";
const EnterCustomTone$f = "कस्टम टोन दर्ज करें";
const Added$f = "जोड़ा गया";
const ComingSoon$f = {
	header: "काम में इंजीनियर!",
	content_1: "हमारे इंजीनियरों की टीम कड़ी मेहनत कर रही है, जल्दी ही इस सुविधा को चालू करने का प्रयास कर रही है",
	content_2: "इस सुविधा को जल्दी चाहिए? नीचे बॉक्स चेक करके हमें बताएं।",
	content_3: "मुझे यह सुविधा चाहिए"
};
const Company$f = "कंपनी";
const JobInterview$f = "नौकरी का साक्षात्कार";
const Research$f = "अनुसंधान";
const Networking$f = "नेटवर्किंग";
const Referral$f = "रेफरल";
const MustbeContacted$f = "संपर्क करना अनिवार्य है";
const ScheduleaMeeting$f = "मीटिंग का समय निर्धारित करें";
const needAFollowUp$f = "फ़ॉलो-अप करने की आवश्यकता है।";
const Today$f = "आज";
const Viewdetails$f = "विवरण देखें";
const Activity$f = "गतिविधि";
const ActivityDetails$f = "गतिविधि विवरण";
const Delete$f = "हटाएं";
const Title$f = "शीर्षक";
const Goal$f = "लक्ष्य";
const Status$f = "स्थिति";
const FollowUp$f = "फॉलो अप";
const AddActivity$f = "गतिविधि जोड़ें";
const Enteractivitytitle$f = "गतिविधि का शीर्षक दर्ज करें";
const Cancel$f = "रद्द करें";
const SaveActivity$f = "गतिविधि सहेजें";
const noActivityPresent$f = "कोई गतिविधि मौजूद नहीं है, गतिविधि जोड़ें।";
const Addnew$f = "नया जोड़ें";
const About$f = "के बारे में";
const noDataPresentYou$f = "कोई डेटा मौजूद नहीं है, आप इस संपर्क को संपादित कर सकते हैं और फ़ील्ड जोड़ सकते हैं।";
const Experience$f = "अनुभव";
const Education$f = "शिक्षा";
const Skills$f = "कौशल";
const Overview$f = "अवलोकन";
const LinkedJobs$f = "जड़े हुए नौकरियां";
const Notes$f = "टिप्पणियाँ";
const FullName$f = "पूरा नाम";
const Location$f = "स्थान";
const Relationship$f = "रिश्ता";
const Contacts$f = "संपर्क";
const CreateContact$f = "संपर्क बनाएं";
const NotesCreated$f = "टिप्पणियाँ बनाई गईं";
const Notesupdated$f = "टिप्पणियाँ अपडेट की गईं";
const Addnote$f = "टिप्पणी जोड़ें";
const areYouSureDeleteNote$f = "क्या आप यकीन हैं कि आप इस नोट को हटाना चाहते हैं?";
const Createdby$f = "द्वारा बनाई गई";
const notSureWhyResumeCalls$f = "क्या आपको नहीं पता कि आपके रिज्यूमे से इंटरव्यू कॉल नहीं आ रहे हैं? ☎️";
const getExpertResumeReview$f = "एक विशेषज्ञ रिज्यूम समीक्षा प्राप्त करें 💎✨";
const youHaventAddedContacts$f = "आपने अभी तक कोई संपर्क नहीं जोड़ा है।";
const noMatchingContacts$f = "कोई मिलते-जुलते संपर्क नहीं मिले।";
const Link$f = "लिंक";
const unlink$f = "अनलिंक";
const Locationnotavailable$f = "स्थान उपलब्ध नहीं है";
const Emailnotavailable$f = "ईमेल उपलब्ध नहीं है";
const PhoneNumbernotavailable$f = "फ़ोन नंबर उपलब्ध नहीं है";
const createdby$f = "द्वारा बनाया गया";
const areYouSureDeleteContact$f = "क्या आप इस संपर्क को हटाना चाहते हैं?";
const areYouSureUnlinkContact$f = "क्या आप इस संपर्क को अनलिंक करना चाहते हैं?";
const Addedbyyou$f = "आपके द्वारा जोड़ा गया";
const Addedby$f = "द्वारा जोड़ा गया";
const Timeline$f = "टाइमलाइन";
const Timelineempty$f = "टाइमलाइन खाली है";
const Discard$f = "छोड़ें";
const SaveContact$f = "संपर्क बचाएं";
const Recruiter$f = "रिक्रूटर";
const Candidate$f = "उम्मीदवार";
const Colleague$f = "सहकर्मी";
const Employee$f = "कर्मचारी";
const EnterValidEmail$f = "मान्य ईमेल दर्ज करें";
const EnterValidPhoneNumber$f = "मान्य फ़ोन नंबर दर्ज करें";
const editingProfileNotAvailable$f = "प्रोफ़ाइल फोटो संपादन अभी तक उपलब्ध नहीं है।";
const itWillBeSoonAvailable$f = "यह जल्द ही हमारे पास उपलब्ध होगा।";
const ChromeExtension$f = "क्रोम एक्सटेंशन";
const SelectTag$f = "चुनें टैग";
const FirstName$f = "पहला नाम";
const FirstNameisrequired$f = "पहला नाम आवश्यक है";
const LastName$f = "अंतिम नाम";
const LastNameisrequired$f = "अंतिम नाम आवश्यक है";
const Companyisrequired$f = "कंपनी की आवश्यकता है।";
const Email$f = "ईमेल";
const ThisisnotavalidEmail$f = "यह एक मान्य ईमेल नहीं है।";
const AddEmail$f = "ईमेल जोड़ें";
const PhoneNumber$f = "फ़ोन नंबर";
const notaValidPhone$f = "यह एक मान्य फोन नंबर नहीं है। केवल नंबर दर्ज करें।";
const phoneNoMinimum5char$f = "फोन नंबर कम से कम 5 वर्ण होने चाहिए।";
const phoneNoMinumum15char$f = "फोन नंबर अधिकतम 15 वर्ण होने चाहिए।";
const AddPhoneNumber$f = "फ़ोन नंबर जोड़ें";
const SelectGoal$f = "लक्ष्य चुनें";
const SelectStatus$f = "स्थिति चुनें";
const Followup$f = "फॉलो-अप";
const SocialMedia$f = "सोशल मीडिया";
const Linkedinhandle$f = "लिंक्डइन हैंडल";
const Twitterhandle$f = "ट्विटर हैंडल";
const Facebookhandle$f = "फेसबुक हैंडल";
const Githubhandle$f = "गिटहब हैंडल";
const Gmailhandle$f = "जीमेल हैंडल";
const Changessavedsuccessfully$f = "परिवर्तन सफलतापूर्वक सहेजे गए";
const EditContact$f = "संपर्क संपादित करें";
const BasicInformation$f = "मौलिक जानकारी";
const EditContactDetails$f = "संपर्क विवरण संपादित करें";
const SaveChanges$f = "परिवर्तन सहेजें";
const phoneNoMinimum14char$f = "फोन नंबर कम से कम 14 वर्ण होने चाहिए।";
const LinkedIn$f = "लिंक्डइन";
const Twitter$f = "ट्विटर";
const Facebook$f = "फेसबुक";
const Github$f = "गिथब";
const Gmail$f = "जीमेल";
const youCanWriteAbout$f = "आप अपने वर्षों के अनुभव, उद्योग या कौशलों के बारे में लिख सकते हैं। लोग अपनी उपलब्धियों या पिछले नौकरी अनुभवों के बारे में भी बात करते हैं।";
const Addednewsection$f = "नया अनुभाग जोड़ा गया";
const Removedsuccessfully$f = "सफलतापूर्वक हटा दिया गया";
const Remove$f = "हटाएं";
const Institute$f = "संस्थान";
const Schoolisrequired$f = "विद्यालय आवश्यक है।";
const Degree$f = "डिग्री";
const StartMonth$f = "शुरुआत महीना";
const StartYear$f = "शुरुआत वर्ष";
const EndMonth$f = "अंतिम महीना";
const EndYear$f = "अंतिम वर्ष";
const Addmore$f = "और जोड़ें";
const PositionTitle$f = "पद का शीर्षक";
const ExperienceType$f = "अनुभव प्रकार";
const Addednewitem$f = "नया आइटम जोड़ा गया";
const whatSkillsDoYouEnjoy$f = "आपके पास कौन से कौशल हैं या आप कौन से कौशलों के साथ काम करने में आनंद लेते हैं?";
const Typeskillshere$f = "यहाँ टाइपिंग कौशल दर्ज करें";
const LinkedContacts$f = "जड़े हुए संपर्क";
const LinkContact$f = "संपर्क जोड़ें";
const NocontactsLinked$f = "कोई संपर्क जुड़ा नहीं है";
const JobContactsComponent$f = {
	linkContact: "संपर्कों को जोड़कर आप इस भूमिका के लिए महत्वपूर्ण लोगों जैसे रिक्रूटर, हायरिंग मैनेजर, आदि को तेजी से देख सकते हैं! भविष्य में, हम आपके संपर्कों के आधार पर प्रासंगिक अंशों को प्रस्तुत कर सकेंगे।"
};
const Nocontacts$f = "कोई संपर्क नहीं";
const LinkJobto$f = "नौकरी को लिंक करें";
const Contact$f = "संपर्क";
const Document$f = "दस्तावेज़";
const Nojobsfound$f = "कोई नौकरियाँ नहीं मिलीं";
const LinkJob$f = "नौकरी को जोड़ें";
const youCanLinkContactJobImported$f = "आप इस संपर्क को करियरफ्लो में आपने आयातित नौकरी से जोड़ सकते हैं।";
const Prev$f = "पिछला";
const Next$f = "अगला";
const areYouSureUnlinkDocument$f = "क्या आप इस दस्तावेज़ को अनलिंक करना चाहते हैं?";
const areYouSureDeleteDocument$f = "क्या आप इस दस्तावेज़ को हटाना चाहते हैं?";
const Category$f = "श्रेणी";
const CreatedOn$f = "इस तिथि पर बनाया गया";
const Joblinked$f = "नौकरी संबंधित";
const Quickactions$f = "त्वरित कार्रवाईयाँ";
const All$f = "सभी";
const Resume$f = "रिज़्यूम";
const Portfolio$f = "पोर्टफोलियो";
const Other$f = "अन्य";
const Adddocument$f = "दस्तावेज़ जोड़ें";
const Type$f = "प्रकार";
const Sortingby$f = "वर्गीकरण द्वारा";
const SwitchtoGridLayout$f = "ग्रिड लेआउट पर स्विच करें";
const SwitchtoListLayout$f = "सूची लेआउट पर स्विच करें";
const NoDocumentsAdded$f = "कोई दस्तावेज़ नहीं जोड़ी गईं";
const DocumentsComponent$f = {
	nodocs: "आपने अभी तक कोई दस्तावेज़ नहीं बनाए हैं। आप अपने रिज़्यूम संस्करण, कवर पत्र, और अधिक अपलोड कर सकते हैं, और उन्हें आपकी ट्रैकिंग जॉब्स से जोड़ सकते हैं!"
};
const NoDocumentFound$f = "कोई दस्तावेज नहीं मिला।";
const SelectFile$f = "फ़ाइल चुनें";
const onlyPdfDocxSupported$f = "केवल .pdf और .docx समर्थित हैं।";
const Uploadfile$f = "फ़ाइल अपलोड करें";
const DocumentCategory$f = "दस्तावेज़ श्रेणी";
const SaveDocument$f = "दस्तावेज़ सहेजें";
const AddDocument$f = "दस्तावेज़ जोड़ें";
const LinkedDocuments$f = "जुड़े हुए दस्तावेज़";
const LinkDocument$f = "दस्तावेज़ जोड़ें";
const NodocumentsLinked$f = "कोई दस्तावेज़ जुड़ा नहीं है";
const JobDocumentsComponent$f = {
	linkDocs: "अपने संबंधित सभी दस्तावेज़ों को जैसे कि आपके रिज़्यूम, कवर पत्र आदि जो आपने इस नौकरी के लिए प्रस्तुत किए हैं को जोड़ना आपको सब कुछ एक स्थान पर ट्रैक करने में मदद करेगा। इसे आज़माएं!"
};
const NoDocuments$f = "कोई दस्तावेज़ नहीं";
const CreateDocuments$f = "दस्तावेज़ बनाएं";
const youCanLinkDocumentJobImported$f = "आप इस दस्तावेज को करियरफ्लो में आपने आयातित नौकरी से जोड़ सकते हैं।";
const Documenteditedsuccessfully$f = "दस्तावेज सफलतापूर्वक संपादित किया गया है।";
const DocumentDetails$f = "दस्तावेज़ विवरण";
const UnsavedChanges$f = "असहेजित परिवर्तन";
const yourChangesWillBeLostSureClose$f = "आपके बदलाव खो जाएंगे, क्या आप सुनिश्चित हैं कि आप बंद करना चाहते हैं?";
const yourChangesWillBeLostSureDiscard$f = "आपके बदलाव खो जाएंगे, क्या आप वाकई अपने बदलावों को छोड़ना चाहते हैं?";
const DiscardChanges$f = "परिवर्तनों को छोड़ दें";
const WeeklyGoalAlert$f = "साप्ताहिक लक्ष्य अलर्ट";
const Progress$f = "प्रगति";
const AllGoals$f = "सभी लक्ष्य";
const Name$f = "नाम";
const Completedon$f = "पूर्ण किया गया";
const Createdon$f = "बनाया गया";
const Action$f = "क्रिया";
const Back$f = "वापस";
const OverallScore$f = "समग्र स्कोर";
const Aboutthegoal$f = "लक्ष्य के बारे में";
const GoalTracking$f = "लक्ष्य ट्रैकिंग";
const Week$f = "सप्ताह";
const progress$f = "प्रगति";
const loading$f = "लोड हो रहा है";
const Apply$f = "लागू करें";
const Thisskillhasbeenreported$f = "यह कौशल रिपोर्ट किया गया है।";
const issueGettingResume$f = "रिज्यूम मिलाने में समस्या थी।";
const Interview$f = "साक्षात्कार";
const Tasks$f = "कार्य";
const Loading$f = "लोड हो रहा है";
const Skilladdedsuccessfully$f = "कौशल सफलतापूर्वक जोड़ा गया है।";
const problemAddingSkill$f = "कौशल जोड़ने में समस्या थी।";
const Reportaproblem$f = "समस्या रिपोर्ट करें";
const Submit$f = "सबमिट करें";
const Addanewskill$f = "नया कौशल जोड़ें";
const JobDetailsComponent$f = {
	classifySkill: "आप इस कौशल को कैसे वर्गीकृत करेंगे? (वैकल्पिक)",
	includedKeywordsWillCount: "क्या इस कीवर्ड को शामिल करें?",
	yesIncludeThisSkill: "शामिल की गई कीवर्ड भविष्य के सभी स्कैन के लिए आपके मैच स्कोर के खिलाफ गिनी जाएंगी। आप अपनी प्रोफ़ाइल से शामिल कीवर्ड बदल सकते हैं।",
	addSkill: "क्या आप इसे एक कौशल के रूप में जोड़ना चाहते हैं?"
};
const HardSkill$f = "कठिन कौशल";
const SoftSkill$f = "सॉफ्ट कौशल";
const Pleaseshareanyadditionalcontext$f = "कृपया कोई अतिरिक्त संदर्भ साझा करें";
const Addasskill$f = "कौशल के रूप में जोड़ें";
const Skill$f = "कौशल";
const JobFrequency$f = "नौकरी की अक्षरता";
const ResumeFrequency$f = "रिज्यूमे की अक्षरता";
const Reportskill$f = "कौशल की रिपोर्ट करें";
const JobDetails$f = "नौकरी का विवरण";
const ViewJobLink$f = "नौकरी लिंक देखें";
const Salary$f = "वेतन";
const areYouSureDeleteJob$f = "क्या आप निश्चित हैं कि आप इस नौकरी को हटाना चाहते हैं?";
const ViewMore$f = "और देखें";
const ViewLess$f = "कम देखें";
const matchYouSkillsAgainstJob$f = "अपने कौशलों को नौकरी विवरण के साथ मिलान करें।";
const pleaseUploadResumeSkillMatch$f = "कृपया अपने रिज्यूमे को अपलोड करें ताकि आपकी कौशल मिलान स्कोर प्राप्त हो सके।";
const AddResume$f = "रिज्यूमे जोड़ें";
const thisJobDoesNotHaveAnyDesc$f = "इस नौकरी का कोई विवरण नहीं है।";
const youCanEditJobToAdd$f = "आप इस नौकरी को संपादित करके उसमें विवरण जोड़ सकते हैं। आप हमारा उपयोग करके नौकरियों को आयात भी कर सकते हैं।";
const chromeextension$f = "क्रोम एक्सटेंशन";
const fromVariousJobPortalsOnce$f = "विभिन्न नौकरी पोर्टलों से। एक विवरण जोड़ने के बाद आप कौशल संबंधित जानकारी भी देख सकेंगे।";
const AddDescription$f = "विवरण जोड़ें।";
const CompanyInfo$f = "कंपनी की जानकारी";
const Website$f = "वेबसाइट";
const Industry$f = "उद्योग";
const EmployeeCount$f = "कर्मचारी संख्या";
const ExprienceLevel$f = "अनुभव स्तर";
const Address$f = "पता";
const Resumes$f = "बायोडाटा";
const Setasdefault$f = "डिफ़ॉल्ट के रूप में सेट करें";
const Ok$f = "ठीक है";
const UploadNewResume$f = "नया रिज्यूम अपलोड करें";
const Default$f = "डिफ़ॉल्ट";
const Jobnotfound$f = "नौकरी नहीं मिली";
const EditDetails$f = "विवरण संपादित करें";
const JobPostURL$f = "नौकरी पोस्ट URL";
const Enterjoburl$f = "नौकरी का URL दर्ज करें";
const Nojobselected$f = "कोई नौकरी चयन नहीं किया गया।";
const Viewjobdetails$f = "नौकरी का विवरण देखें";
const Jobaddedtoyourboardsuccessfully$f = "आपके बोर्ड में काम सफलतापूर्वक जोड़ा गया है।";
const AddJob$f = "नौकरी जोड़ें";
const Addnewjobname$f = "नया नौकरी नाम जोड़ें";
const JobUrl$f = "नौकरी URL";
const Addjoburl$f = "नौकरी URL जोड़ें";
const Section$f = "खंड";
const didYouKnow$f = {
	chromeExtension: "क्या आप जानते हैं? आप हमारे Chrome एक्सटेंशन से सीधे नौकरियों को सहेज सकते हैं और एक क्लिक में सभी डेटा को आयात कर सकते हैं! यह सिर्फ कुछ सेकंड्स का समय लेता है।"
};
const Jobs$f = "नौकरियाँ";
const AddJobtoboard$f = "बोर्ड में नौकरी जोड़ें";
const Currentlynojobsareavailable$f = "वर्तमान में कोई नौकरियां उपलब्ध नहीं हैं।";
const noMatchingJobs$f = "कोई मिलती जोब्स नहीं मिलीं।";
const welcomeToYourPersonalJobTracker$f = "अपने व्यक्तिगत नौकरी ट्रैकर में आपका स्वागत है!";
const weShortTutorialOnHowTrackingJob$f = "हम आपको कुछ आसान चरणों में अपने नौकरी आवेदनों को ट्रैक करना शुरू करने के बारे में एक छोटे से ट्यूटोरियल के माध्यम से ले जाएंगे!";
const Addanewjob$f = "एक नया नौकरी जोड़ें";
const inOrderTrackCreatButton$f = "नौकरी आवेदनों को ट्रैक करना शुरू करने के लिए, आपको पहले 'बनाएँ' बटन पर क्लिक करके बोर्ड में इसे जोड़ना होगा।";
const Providesomedetails$f = "कुछ विवरण प्रदान करें।";
const toBeginTypeJobTitleCompany$f = "शुरू करने के लिए, सिर्फ नौकरी का शीर्षक, कंपनी का नाम और स्थिति टाइप करें जिसे आप इसमें जोड़ना चाहते हैं। आप बाद में अधिक विवरण जोड़ सकते हैं, लेकिन अभी इसके लिए आपको बस इतना ही चाहिए!";
const asAnExampleFilledForYou$f = "उदाहरण के रूप में, हम इसे पहले से ही भर दिया है!";
const wohooAddedFirstJob$f = "वाह! आपने अपने नौकरी ट्रैकर में अपनी पहली नौकरी जोड़ दी है!";
const youCanDragDropJobCard$f = "अब आप नौकरी आवेदन प्रक्रिया के विभिन्न चरणों में नौकरी कार्ड को खींचकर ड्रॉप कर सकते हैं। नौकरी कार्ड पर क्लिक करने से आप अधिक विवरण देख सकते हैं, उन्हें संपादित कर सकते हैं, नोट बना सकते हैं और अधिक कुछ!";
const Lastbutnotleast$f = "अंतिम लेकिन अंत में";
const finalStepMakeSure$f = "अंतिम चरण के रूप में, सुनिश्चित करें कि आपके पास हमारा है।";
const autoMaticallyImportJobs$f = "जो आपको अपनी पसंदीदा नौकरी खोज वेबसाइटों जैसे LinkedIn, Indeed और अधिक से नौकरियों को स्वचालित रूप से आयात करने की अनुमति देगा! हमारा एक्सटेंशन आपको अपनी LinkedIn प्रोफ़ाइल को सुधारने में भी मदद करता है और 2.5 गुना अधिक खोज दिखाई देता है!";
const selectanysection$f = "कोई भी अनुभाग चुनें।";
const Accept$f = "स्वीकार करें";
const My2023JobSearch$f = "मेरी 2023 नौकरी खोज";
const AddedFrom$f = "जोड़ा गया है।";
const AddedUntil$f = "जोड़ा गया जब तक";
const BasicModal$f = "बेसिक मोडल";
const AddnewSectionName$f = "नई सेक्शन नाम जोड़ें";
const OpenTo$f = "के लिए खुला";
const Featured$f = "विशेष रुप से प्रदर्शित";
const LicenceAndCerts$f = "लाइसेंस और प्रमाणपत्र";
const Banner$f = "बैनर";
const LinkedInURL$f = "लिंक्डइन यूआरएल";
const Recommendations$f = "सिफारिशें";
const LinkedinReview$f = "लिंक्डइन समीक्षा";
const NoDataAvailable$f = "कोई डेटा उपलब्ध नहीं है।";
const looksLikeYouDidNot$f = "लगता है आपने हमारा उपयोग शुरू नहीं किया है।";
const toOptimizeProfileScoreVisible$f = "अपनी लिंक्डइन प्रोफ़ाइल को अनुकूलित करने के बाद आपकी प्रोफ़ाइल स्कोर यहाँ दिखाई देगा।";
const LinkedinComponent$f = {
	letsOptimize: "आइए अनुकूलित करें"
};
const improveYourChancesLandingDreamJob$f = "अपने सपने की नौकरी पाने के अवसरों को बेहतर बनाएं। अपने LinkedIn प्रोफ़ाइल को एक ज़रूरी मेकओवर देने के लिए इन प्रमाणित रणनीतियों का उपयोग करें।";
const VisitProfile$f = "प्रोफ़ाइल देखें";
const wantToGetLinkedinMakeover$f = "क्या आप एक पूर्ण LinkedIn मेकओवर पाना चाहते हैं?";
const PostGenerator$f = "पोस्ट जेनरेटर";
const LinkedinHeadlineGenerator$f = "लिंक्डइन हेडलाइन जेनरेटर";
const LinkedinAboutSectionGenerator$f = "लिंक्डइन विवरण खंड जेनरेटर";
const AITools$f = "ए.आई. टूल्स";
const Premium$f = "प्रीमियम";
const LinkedInOptimization$f = "लिंक्डइन अनुकूलन";
const JobTracker$f = "नौकरी ट्रैकर";
const whoIsHiring$f = "कौन भर्ती कर रहा है";
const Autofill$f = "ऑटो भरें";
const HeadlineGenerator$f = "शीर्षक जेनरेटर";
const skillMatching$f = "कौशल मिलान";
const SummarizeJD$f = "नौकरी विवरण सारांश करें";
const contactFeature$f = "संपर्क ट्रैकिंग";
const documentFeature$f = "दस्तावेज़";
const landJobWithoutStress$f = "अपनी सपने की नौकरी प्राप्त करें। तनाव के बिना।";
const discoverFeatures$f = "अपनी नौकरी खोज को सरल बनाने और अपनी पेशेवर यात्रा को बढ़ावा देने के लिए डिज़ाइन की गई कैरियरफ्लो.एआई की विभिन्न सुविधाओं की खोज करें!";
const letsBeginOnboarding$f = "चलो आपको और अच्छी तरह से जानते हैं!";
const inTheNextFewScreensJobThirdParties$f = "अगले कुछ स्क्रीन में, हम आपसे कुछ सवाल पूछेंगे जो आपके लिए एक अनुभव तैयार करने में मदद करेंगे और आपके नौकरी आवेदनों को ऑटो-फिल करेंगे (ताकि आपको नहीं करना पड़े)! हम आपके डेटा को किसी तीसरे पक्ष को नहीं बेचते हैं।";
const letsAddBasicInformation$f = "आइए आपकी मूलभूत जानकारी जोड़ें";
const Pleaseselectanoptionfirst$f = "कृपया पहले एक विकल्प चुनें।";
const JobApplicationTracker$f = "नौकरी आवेदन ट्रैकर";
const LinkedInProfileOptimizer$f = "लिंक्डइन प्रोफाइल ऑप्टिमाइजर";
const UnlimitedDocuments$f = "असीमित दस्तावेज़ों";
const UnlimitedContacts$f = "असीमित संपर्कों";
const HiringManagerSearch$f = "नियुक्ति प्रबंधक खोज";
const AILinkedInPostGenerator$f = "एआई लिंक्डइन पोस्ट जेनरेटर";
const ATSKeywordSkillMatch$f = "ATS कीवर्ड / कौशल मैच नौकरी";
const ChooseyourPlan$f = "अपनी योजना चुनें";
const superChargeYourJobSearch$f = "अपनी नौकरी खोज को सुपरचार्ज करें और अपनी नौकरी आवेदन प्रक्रिया को सुधारें, अपने साक्षात्कारों की संख्या बढ़ाएं और अपनी सपने की नौकरी प्राप्त करें। सब कुछ कैरियरफ्लो के प्रीमियम टूलकिट की मदद से।";
const startNowGoto$f = "अब शुरू करें (ऐप पर जाएं)";
const CreatedBy$f = "द्वारा बनाया गया";
const CreateNewNote$f = "नई नोट बनाएं";
const Nonotescreated$f = "कोई नोट बनाई गई नहीं";
const approxTimeIsFourMinutes$f = "ऑनबोर्डिंग प्रक्रिया पूरी करने का अनुमानित समय 4 मिनट है।";
const Continue$f = "जारी रखें";
const iWillDoLaterTakeMeToApp$f = "मैं इसे बाद में करूंगा। मुझे ऐप पर ले चलें।";
const allDone$f = "सब कुछ हो गया!";
const welcomeAbord$f = "स्वागत है!";
const letsBegin$f = "आइए शुरू करें।";
const UpgradeyourplanandgetAIAssistance$f = "अपनी योजना अपग्रेड करें और एआई सहायता प्राप्त करें।";
const DownloadPDF$f = "पीडीएफ डाउनलोड करें";
const oopsWeCouldntProcessResume$f = "उफ़्स, हम इस रिज्यूम को प्रोसेस नहीं कर सके।";
const MyProfile$f = "मेरी प्रोफ़ाइल";
const Setting$f = "सेटिंग";
const Logout$f = "लॉग आउट";
const SignIn$f = "साइन इन करें";
const Typeyourfirstnamehere$f = "आपका पहला नाम";
const Enteryourlastname$f = "आपका अंतिम नाम";
const ManageSubscription$f = "सदस्यता प्रबंधित करें";
const ifYouHaveDifficultiesProfile$f = "यदि आपको अपनी प्रोफ़ाइल जानकारी में कोई कठिनाई होती है, तो कृपया संपर्क करें";
const forSupport$f = "समर्थन के लिए।";
const whatIsIdealCompanySize$f = "आपकी आदर्श कंपनी का आकार क्या है?";
const Saveandcontinue$f = "बचाएं और जारी रखें";
const whatIsMinExpectedSalary$f = "आपकी कम से कम अपेक्षित वेतन (प्रति वर्ष) क्या है?";
const Atleast$f = "कम से कम";
const SlidetoAdjust$f = "साइड ऐडजस्ट करें";
const whatIndustryExcitedWork$f = "आपके लिए कौन सी उद्योग रोमांचक हैं?";
const Add$f = "जोड़ें";
const statusOfJobSearch$f = "आपकी नौकरी खोज की स्थिति क्या है?";
const Finish$f = "समाप्त करें।";
const whatLevelRoleLooking$f = "आप कौन से स्तर की भूमिका ढूंढ रहे हैं?";
const Selectuptotwo$f = "दो तक चुनें।";
const PreviousStep$f = "पिछला चरण";
const Skip$f = "छोड़ें";
const whatDoYouValueNewRole$f = "आप एक नए भूमिका में क्या मूल्य रखते हैं?";
const Selectuptothree$f = "तीन तक चुनें।";
const EqualEmploymentData$f = "समान रोजगार डेटा";
const whatIsYourEthnicity$f = "आपकी जाति क्या है?";
const areYouAuthorizedToWorkUs$f = "क्या आपको संयुक्त राज्य अमेरिका में काम करने की अधिकार है?";
const willYouRequireSponsorShip$f = "क्या आप अब या भविष्य में रोजगार वीजा स्थिति के लिए प्रायोजन की आवश्यकता होगी?";
const doYouHaveADisability$f = "क्या आपके पास कोई विकलांगता है?";
const areYouAVeteran$f = "क्या आप एक दिग्गज हैं?";
const rolesYouInterestedIn$f = "आप कौन से प्रकार के रोल में दिलचस्पी रखते हैं?";
const Selectuptofive$f = "पांच तक चुनें।";
const AddCustomrole$f = "कस्टम रोल जोड़ें";
const whereDoYouLikeWork$f = "आप कहाँ काम करना चाहेंगे?";
const Resources$f = "संसाधन";
const currentlyNoResourceAvailable$f = "वर्तमान में कोई संसाधन उपलब्ध नहीं हैं।";
const AddNewSection$f = "नया खंड जोड़ें";
const ChangeSections$f = "अनुभाग बदलें";
const Settings$f = "सेटिंग्स";
const Dashboard$f = "डैशबोर्ड";
const JobBoard$f = "नौकरी का बोर्ड";
const Linkedin$f = "लिंक्डइन";
const Community$f = "समुदाय";
const FindRecruiters$f = "रिक्रूटर्स खोजें";
const Goals$f = "लक्ष्य";
const DownloadExtension$f = "एक्सटेंशन डाउनलोड करें";
const SuggestaFeature$f = "एक सुविधा सुझाएं";
const leftPanel$f = {
	ReportanIssue: "एक मुद्दा रिपोर्ट करें"
};
const PhoneNumberisrequired$f = "फोन नंबर आवश्यक है";
const MobileNumber$f = "मोबाइल नंबर";
const Enteronlynumbers$f = "केवल संख्याएं दर्ज करें";
const Countryyoulivein$f = "आप जिस देश में रहते हैं";
const SelectaCountry$f = "एक देश चुनें";
const DateofBirth$f = "जन्म तिथि";
const Gender$f = "लिंग";
const JobPreferences$f = "नौकरी की पसंद";
const pleaseEnterValidEmail$f = "कृपया एक मान्य ईमेल दर्ज करें।";
const emailSendForResetting$f = "आपको पासवर्ड रीसेट करने के लिए एक ईमेल भेजा गया है।";
const VerifyyourEmailID$f = "अपनी ईमेल आईडी की पुष्टि करें।";
const sentPleaseCheckEmail$f = "भेज दिया गया! कृपया अपना ईमेल देखें।";
const tooManyAttemptsTryAgain$f = "बहुत सारी कोशिशें, कुछ समय बाद पुन: प्रयास करें।";
const Resend$f = "फिर से भेजें";
const Login$f = "लॉगिन";
const weHaveSentVerificationLinkAtEmail$f = "हमने आपके ईमेल पर एक सत्यापन लिंक भेजा है।";
const pleaseVerifyEmailContinueSpam$f = "कृपया जारी रखने के लिए अपना ईमेल सत्यापित करें। सत्यापन ईमेल के लिए स्पैम या प्रमोशन भी जांचें।";
const Logintogetstarted$f = "शुरू करने के लिए लॉग इन करें।";
const ContinuewithGoogle$f = "गूगल के साथ जारी रखें";
const pleaseInputEmail$f = "कृपया अपना ईमेल इनपुट करें!";
const Password$f = "पासवर्ड";
const pleaseInputPassword$f = "कृपया अपना पासवर्ड दर्ज करें!";
const passwordLowerUpperDigitSpecial$f = "आपका पासवर्ड कम से कम एक छोटा अक्षर, एक बड़ा अक्षर, एक अंक और एक विशेष वर्ण शामिल होना चाहिए।";
const atLeastSixChar$f = "कम से कम 6 अक्षरों की आवश्यकता है।";
const forgotPassword$f = "पासवर्ड भूल गए?";
const Bysigninginyouagreetoour$f = "साइन इन करके आप हमारे साथ सहमत होते हैं";
const Terms$f = "शर्तें";
const Conditions$f = "शर्तें";
const and$f = "और";
const PrivacyPolicy$f = "गोपनीयता नीति";
const theseAreTheTopsSkillsExtracted$f = "ये नौकरी विवरण से निकाले गए शीर्ष कौशल हैं।";
const TopSkills$f = "शीर्ष कौशल";
const weCoulNotExtractSkills$f = "हम इस नौकरी विवरण से कोई कौशल नहीं निकाल सके।";
const upgradeToPremiumToView$f = "अपने रिज्यूम कौशल मैच स्कोर देखने के लिए प्रीमियम में अपग्रेड करें।";
const SkillScore$f = "कौशल स्कोर";
const thisIsYourSkillScoreBasedOn$f = "यह आपका कौशल स्कोर नौकरी विवरण और आपके रिज्यूमे के आधार पर है।";
const theseSkllsAreStrongMatch$f = "ये कौशल आपके रिज्यूमे और नौकरी विवरण के बीच एक मजबूत मिलान हैं।";
const Strongmatch$f = "मजबूत मैच";
const theseSkillsArePartialMatch$f = "ये कौशल आपके रिज्यूमे और नौकरी विवरण के बीच आंशिक मिलान हैं।";
const Partialmatch$f = "आंशिक मिलान";
const theseSkillsAreMissingFrom$f = "ये कीवर्ड आपके रिज्यूमे में अनुपस्थित हैं लेकिन नौकरी के विवरण में मौजूद हैं। ये कौशल या आम कीवर्ड हो सकते हैं जो नौकरी के अवसर के लिए विशिष्ट होते हैं और आपके रिज्यूमे में जोड़ने के लिए उपयोगी हो सकते हैं।";
const SkillMatchComponent$f = {
	removeSkill: "क्या आपकी मुख्य कारण है कि आप किसी शब्द के लिए समस्या की रिपोर्ट कर रहे हैं"
};
const Optional$f = "वैकल्पिक";
const Notrelevanttothejob$f = "नौकरी के लिए अनुपयुक्त";
const Notaskill$f = "कोई कौशल नहीं";
const Toogeneric$f = "बहुत सामान्य";
const Pleaseshareanyfeedback$f = "कृपया कोई प्रतिक्रिया साझा करें";
const excludedKeywordsWillNot$f = "छूटे हुए कीवर्ड भविष्य के सभी स्कैन के लिए आपके मैच स्कोर के खिलाफ नहीं होंगे। आप अपनी प्रोफ़ाइल से छूटे हुए कीवर्ड बदल सकते हैं।";
const yesExcludeThisSkillFrom$f = "हाँ, मेरी सभी रिज्यूम स्कैन से इस कौशल को निकाल दें।";
const PartialMatch$f = "आंशिक मैच";
const MissingKeywords$f = "अभावग्रस्त कीवर्ड्स";
const Providetitletotask$f = "कार्य के लिए शीर्षक दें";
const TasksList$f = "कार्य सूची";
const AddTask$f = "कार्य जोड़ें";
const EnterTaskTitlehere$f = "यहाँ कार्य शीर्षक लिखें";
const TasksComponent$f = {
	listEmpty: "कार्य सूची खाली है, नया बनाएं।"
};
const CompletedTasks$f = "पूर्ण किए गए कार्य";
const CompleteYourtasks$f = "अपने कार्य पूर्ण करें";
const Steps$f = "कदम";
const PremiumMember$f = "प्रीमियम सदस्य";
const Thankyouforupgradingto$f = "अपग्रेड करने के लिए धन्यवाद";
const CareerflowPremium$f = "करियर फ्लो प्रीमियम";
const hereIsHowYouCanAccessPremium$f = "यहाँ आपके प्रीमियम लाभों तक पहुंचने का तरीका है!";
const stepOne$f = "चरण 1";
const DownloadourChromeExtension$f = "हमारा क्रोम एक्सटेंशन डाउनलोड करें।";
const youJobSearchCopilotIshere$f = "आपकी नौकरी खोज का एआई को-पायलट यहां है।";
const DownloadNow$f = "अभी डाउनलोड करें";
const stepTwo$f = "चरण 2";
const GetStarted$f = "शुरू करें";
const stepThree$f = "चरण 3";
const SignintoChromeExtension$f = "Chrome एक्सटेंशन में साइन इन करें";
const entityCreated$f = "नया {{entity}} बनाया गया";
const entityUpdated$f = "{{entity}} अपडेट किया गया";
const entityDeleted$f = "{{entity}} हटा दिया गया";
const entityLinked$f = "{{entity}} लिंक किया गया";
const entityUnlinked$f = "{{entity}} अनलिंक हुआ";
const entityMovedTo$f = "{{entity}} में ले जाया गया";
const youAddedANewEntity$f = "आपने एक नया {{entity}} जोड़ा है।";
const personCreated$f = "{{creator}} ने {{owner}} के लिए एक {{entity}} बनाया।";
const youUpdatedAEntity$f = "आपने एक {{entity}} अपडेट किया है।";
const personUpdated$f = "{{creator}} ने {{owner}} के लिए एक {{entity}} अपडेट किया।";
const youDeletedAEntity$f = "आपने एक {{entity}} हटा दिया है।";
const personDeleted$f = "{{creator}} ने {{owner}} के लिए एक {{entity}} हटा दिया।";
const youLinkedEntity$f = "आपने इस नौकरी से एक {{entity}} को लिंक किया है।";
const personLinked$f = "{{creator}} ने {{owner}} के लिए इस नौकरी से एक {{entity}} को जोड़ा।";
const youUnlinked$f = "आपने इस नौकरी से एक {{entity}} को अनलिंक कर दिया है।";
const personUnlinked$f = "{{creator}} ने {{owner}} के लिए इस नौकरी से एक {{entity}} को अनलिंक कर दिया।";
const youMovedEntity$f = "आपने इस {{entity}} को {{sectionFrom}} से {{sectionTo}} में ले जाया।";
const personMoved$f = "{{creator}} ने {{entity}} को {{sectionFrom}} से {{sectionTo}} में {{owner}} के लिए हटाया।";
const addedByName$f = "{{name}} द्वारा जोड़ा गया";
const DownloadChromeExtension$f = "क्रोम एक्सटेंशन डाउनलोड करें";
const ourChromeExtensionIs$f = "हमारा क्रोम एक्सटेंशन एक एकीकृत उपकरण है जो आपकी लिंक्डइन प्रोफ़ाइल को अनुकूलित करने, नौकरियों को बचाने, संपर्कों को बचाने, कवर लेटर उत्पन्न करने और अधिक करने में मदद करता है।";
const Optimizeyourprofile$f = "अपनी प्रोफ़ाइल को अनुकूलित करें।";
const startOptimizingYourProfile$f = "अपनी प्रोफ़ाइल को अनुकूलित करना शुरू करें ताकि रिक्रूटर्स द्वारा संपर्क करने के बेहतर अवसर हों।";
const OptimizeNow$f = "अब अनुकूलित करें";
const Addyourfirstjob$f = "अपनी पहली नौकरी जोड़ें।";
const startSavingJobApplicationsToTrack$f = "अपनी नौकरी खोज यात्रा को ट्रैक करने और उपयोगी इंसाइट्स खोजने के लिए नौकरी आवेदन सहेजना शुरू करें।";
const AddNow$f = "अब जोड़ें।";
const CompleteProfile$f = "पूर्ण प्रोफ़ाइल";
const completeYourProfileForUsing$f = "ऑटो-फिल फीचर का उपयोग करने और एक अधिक व्यक्तिगत अनुभव प्राप्त करने के लिए अपनी प्रोफ़ाइल पूर्ण करें।";
const CompleteNow$f = "अब पूरा करें।";
const Addyourfirstcontact$f = "अपना पहला संपर्क जोड़ें";
const addContactToFollowUpWith$f = "उनके साथ बाद में फॉलो अप करने के लिए संपर्क जोड़ें, नोट्स जोड़ें और अधिक।";
const JoinCommunity$f = "समुदाय में शामिल हों";
const ourCommunityisAlways$f = "हमारी समुदाय हमेशा आपके साथ है आपकी नौकरी खोज यात्रा में।";
const JoinNow$f = "अभी शामिल हों";
const welcomeToCareerflow$f = "करियरफ्लो में आपका स्वागत है!";
const yourHubForCareerInsights2$f = "यह आपके करियर अंतर्दृष्टि, गतिविधियों और अधिक के लिए आपका हब है। अपनी व्यक्तिगत डैशबोर्ड का अन्वेषण करें ताकि आप अपने पेशेवर यात्रा पर शीर्ष पर रहें।";
const ChecklistCompleted$f = "आपकी चेकलिस्ट पूर्ण हो गई है!";
const Completeyourchecklist$f = "अपनी चेकलिस्ट पूरी करें।";
const completeAFewStepsTo$f = "अपनी अगली नौकरी पाने के लिए कुछ कदम पूरे करें।";
const Completed$f = "पूर्ण";
const JobCountByStage$f = "चरण द्वारा नौकरी की संख्या";
const NopastapplicationDatafound$f = "कोई पिछले आवेदन डेटा नहीं मिला";
const YourJobSearchStages$f = "आपकी नौकरी खोज के चरण";
const NoDatafound$f = "कोई डेटा नहीं मिला।";
const hi = {
	copyToClipboard: copyToClipboard$f,
	UnlocktheAIgenerated: UnlocktheAIgenerated$f,
	UpgradetoPremium: UpgradetoPremium$f,
	Result: Result$f,
	Copy: Copy$f,
	Save: Save$f,
	Edit: Edit$f,
	Processing: Processing$f,
	YourAIgeneratedcontentwillshowhere: YourAIgeneratedcontentwillshowhere$f,
	hopeYouFindUseful: hopeYouFindUseful$f,
	regenerate: regenerate$f,
	ProvideAdditionalFeedback: ProvideAdditionalFeedback$f,
	Enteranyfeedback: Enteranyfeedback$f,
	Notimpressive: Notimpressive$f,
	thisIsntTrue: thisIsntTrue$f,
	Notpersonalized: Notpersonalized$f,
	Tone: Tone$f,
	Length: Length$f,
	Template: Template$f,
	Generatedon: Generatedon$f,
	Copiedtoclipboard: Copiedtoclipboard$f,
	CopytoClipboard: CopytoClipboard$f,
	DownloadasPDF: DownloadasPDF$f,
	ViewDetails: ViewDetails$f,
	JobDescriptionImported: JobDescriptionImported$f,
	ImportfromJob: ImportfromJob$f,
	Saved: Saved$f,
	Applied: Applied$f,
	Offer: Offer$f,
	Interviewing: Interviewing$f,
	Rejected: Rejected$f,
	Search: Search$f,
	Import: Import$f,
	CoverLetterGeneratorHistory: CoverLetterGeneratorHistory$f,
	NoCoverLettersGenerated: NoCoverLettersGenerated$f,
	getStartedCoverLetter: getStartedCoverLetter$f,
	getStarted: getStarted$f,
	Documents: Documents$f,
	UploadNewDocument: UploadNewDocument$f,
	AICoverLetterGenerator: AICoverLetterGenerator$f,
	ViewHistory: ViewHistory$f,
	JobDescription: JobDescription$f,
	ImportfromBoard: ImportfromBoard$f,
	EnterJobDescription: EnterJobDescription$f,
	JobTitle: JobTitle$f,
	EnterJobTitle: EnterJobTitle$f,
	CompanyName: CompanyName$f,
	EnterCompanyName: EnterCompanyName$f,
	YourProfile: YourProfile$f,
	ResumeUpload: ResumeUpload$f,
	UseLinkedinProfile: UseLinkedinProfile$f,
	Uploadyourresume: Uploadyourresume$f,
	AddyourResume: AddyourResume$f,
	fileNameCannotFormat: fileNameCannotFormat$f,
	ChooseorUpload: ChooseorUpload$f,
	SelectTemplate: SelectTemplate$f,
	Preview: Preview$f,
	UseTemplate: UseTemplate$f,
	Change: Change$f,
	AdvancedSettings: AdvancedSettings$f,
	AdditionalContext: AdditionalContext$f,
	Professional: Professional$f,
	Casual: Casual$f,
	Enthusiastic: Enthusiastic$f,
	Informational: Informational$f,
	Short: Short$f,
	Medium: Medium$f,
	Long: Long$f,
	Language: Language$f,
	iAmOkayBack: iAmOkayBack$f,
	Generate: Generate$f,
	CoverLetter: CoverLetter$f,
	SelectLanguage: SelectLanguage$f,
	AboutGeneratorHistory: AboutGeneratorHistory$f,
	NoAboutsGenerated: NoAboutsGenerated$f,
	getStartedAbouts: getStartedAbouts$f,
	noAttachmentsFound: noAttachmentsFound$f,
	TargetJobTitle: TargetJobTitle$f,
	KeywordsToInclude: KeywordsToInclude$f,
	UploadYourResume: UploadYourResume$f,
	AddYourResume: AddYourResume$f,
	LinkedinProfile: LinkedinProfile$f,
	Linkedinprofilenotfound: Linkedinprofilenotfound$f,
	startUsingChromeExtension: startUsingChromeExtension$f,
	Download: Download$f,
	UseEmojis: UseEmojis$f,
	UseBulletPoints: UseBulletPoints$f,
	SpeechFocus: SpeechFocus$f,
	FirstPerson: FirstPerson$f,
	ThirdPerson: ThirdPerson$f,
	HeadlineGeneratorHistory: HeadlineGeneratorHistory$f,
	NoHeadlinesGenerated: NoHeadlinesGenerated$f,
	getStartedHeadline: getStartedHeadline$f,
	AIHeadlineGenerator: AIHeadlineGenerator$f,
	KeywordstoInclude: KeywordstoInclude$f,
	Pressenteraftereachword: Pressenteraftereachword$f,
	LinkedinProfilenotfound: LinkedinProfilenotfound$f,
	Headline: Headline$f,
	PostGeneratorHistory: PostGeneratorHistory$f,
	NoPostsGenerated: NoPostsGenerated$f,
	getStartedPost: getStartedPost$f,
	Topic: Topic$f,
	Description: Description$f,
	UseHashtags: UseHashtags$f,
	Custom: Custom$f,
	EnterCustomTone: EnterCustomTone$f,
	Added: Added$f,
	ComingSoon: ComingSoon$f,
	Company: Company$f,
	JobInterview: JobInterview$f,
	Research: Research$f,
	Networking: Networking$f,
	Referral: Referral$f,
	MustbeContacted: MustbeContacted$f,
	ScheduleaMeeting: ScheduleaMeeting$f,
	needAFollowUp: needAFollowUp$f,
	Today: Today$f,
	Viewdetails: Viewdetails$f,
	Activity: Activity$f,
	ActivityDetails: ActivityDetails$f,
	Delete: Delete$f,
	Title: Title$f,
	Goal: Goal$f,
	Status: Status$f,
	FollowUp: FollowUp$f,
	AddActivity: AddActivity$f,
	Enteractivitytitle: Enteractivitytitle$f,
	Cancel: Cancel$f,
	SaveActivity: SaveActivity$f,
	noActivityPresent: noActivityPresent$f,
	Addnew: Addnew$f,
	About: About$f,
	noDataPresentYou: noDataPresentYou$f,
	Experience: Experience$f,
	Education: Education$f,
	Skills: Skills$f,
	Overview: Overview$f,
	LinkedJobs: LinkedJobs$f,
	Notes: Notes$f,
	FullName: FullName$f,
	Location: Location$f,
	Relationship: Relationship$f,
	Contacts: Contacts$f,
	CreateContact: CreateContact$f,
	NotesCreated: NotesCreated$f,
	Notesupdated: Notesupdated$f,
	Addnote: Addnote$f,
	areYouSureDeleteNote: areYouSureDeleteNote$f,
	Createdby: Createdby$f,
	notSureWhyResumeCalls: notSureWhyResumeCalls$f,
	getExpertResumeReview: getExpertResumeReview$f,
	youHaventAddedContacts: youHaventAddedContacts$f,
	noMatchingContacts: noMatchingContacts$f,
	Link: Link$f,
	unlink: unlink$f,
	Locationnotavailable: Locationnotavailable$f,
	Emailnotavailable: Emailnotavailable$f,
	PhoneNumbernotavailable: PhoneNumbernotavailable$f,
	createdby: createdby$f,
	areYouSureDeleteContact: areYouSureDeleteContact$f,
	areYouSureUnlinkContact: areYouSureUnlinkContact$f,
	Addedbyyou: Addedbyyou$f,
	Addedby: Addedby$f,
	Timeline: Timeline$f,
	Timelineempty: Timelineempty$f,
	Discard: Discard$f,
	SaveContact: SaveContact$f,
	Recruiter: Recruiter$f,
	Candidate: Candidate$f,
	Colleague: Colleague$f,
	Employee: Employee$f,
	"Needtofollow-up": "फॉलो-अप करना है",
	EnterValidEmail: EnterValidEmail$f,
	EnterValidPhoneNumber: EnterValidPhoneNumber$f,
	editingProfileNotAvailable: editingProfileNotAvailable$f,
	itWillBeSoonAvailable: itWillBeSoonAvailable$f,
	ChromeExtension: ChromeExtension$f,
	SelectTag: SelectTag$f,
	FirstName: FirstName$f,
	FirstNameisrequired: FirstNameisrequired$f,
	LastName: LastName$f,
	LastNameisrequired: LastNameisrequired$f,
	Companyisrequired: Companyisrequired$f,
	Email: Email$f,
	ThisisnotavalidEmail: ThisisnotavalidEmail$f,
	AddEmail: AddEmail$f,
	PhoneNumber: PhoneNumber$f,
	notaValidPhone: notaValidPhone$f,
	phoneNoMinimum5char: phoneNoMinimum5char$f,
	phoneNoMinumum15char: phoneNoMinumum15char$f,
	AddPhoneNumber: AddPhoneNumber$f,
	SelectGoal: SelectGoal$f,
	SelectStatus: SelectStatus$f,
	Followup: Followup$f,
	SocialMedia: SocialMedia$f,
	Linkedinhandle: Linkedinhandle$f,
	Twitterhandle: Twitterhandle$f,
	Facebookhandle: Facebookhandle$f,
	Githubhandle: Githubhandle$f,
	Gmailhandle: Gmailhandle$f,
	Changessavedsuccessfully: Changessavedsuccessfully$f,
	EditContact: EditContact$f,
	BasicInformation: BasicInformation$f,
	EditContactDetails: EditContactDetails$f,
	SaveChanges: SaveChanges$f,
	phoneNoMinimum14char: phoneNoMinimum14char$f,
	LinkedIn: LinkedIn$f,
	Twitter: Twitter$f,
	Facebook: Facebook$f,
	Github: Github$f,
	Gmail: Gmail$f,
	youCanWriteAbout: youCanWriteAbout$f,
	Addednewsection: Addednewsection$f,
	Removedsuccessfully: Removedsuccessfully$f,
	Remove: Remove$f,
	Institute: Institute$f,
	Schoolisrequired: Schoolisrequired$f,
	Degree: Degree$f,
	StartMonth: StartMonth$f,
	StartYear: StartYear$f,
	EndMonth: EndMonth$f,
	EndYear: EndYear$f,
	Addmore: Addmore$f,
	PositionTitle: PositionTitle$f,
	ExperienceType: ExperienceType$f,
	Addednewitem: Addednewitem$f,
	whatSkillsDoYouEnjoy: whatSkillsDoYouEnjoy$f,
	Typeskillshere: Typeskillshere$f,
	LinkedContacts: LinkedContacts$f,
	LinkContact: LinkContact$f,
	NocontactsLinked: NocontactsLinked$f,
	JobContactsComponent: JobContactsComponent$f,
	Nocontacts: Nocontacts$f,
	LinkJobto: LinkJobto$f,
	Contact: Contact$f,
	Document: Document$f,
	Nojobsfound: Nojobsfound$f,
	LinkJob: LinkJob$f,
	youCanLinkContactJobImported: youCanLinkContactJobImported$f,
	Prev: Prev$f,
	Next: Next$f,
	areYouSureUnlinkDocument: areYouSureUnlinkDocument$f,
	areYouSureDeleteDocument: areYouSureDeleteDocument$f,
	Category: Category$f,
	CreatedOn: CreatedOn$f,
	Joblinked: Joblinked$f,
	Quickactions: Quickactions$f,
	All: All$f,
	Resume: Resume$f,
	Portfolio: Portfolio$f,
	Other: Other$f,
	Adddocument: Adddocument$f,
	Type: Type$f,
	Sortingby: Sortingby$f,
	SwitchtoGridLayout: SwitchtoGridLayout$f,
	SwitchtoListLayout: SwitchtoListLayout$f,
	NoDocumentsAdded: NoDocumentsAdded$f,
	DocumentsComponent: DocumentsComponent$f,
	NoDocumentFound: NoDocumentFound$f,
	SelectFile: SelectFile$f,
	onlyPdfDocxSupported: onlyPdfDocxSupported$f,
	Uploadfile: Uploadfile$f,
	DocumentCategory: DocumentCategory$f,
	SaveDocument: SaveDocument$f,
	AddDocument: AddDocument$f,
	LinkedDocuments: LinkedDocuments$f,
	LinkDocument: LinkDocument$f,
	NodocumentsLinked: NodocumentsLinked$f,
	JobDocumentsComponent: JobDocumentsComponent$f,
	NoDocuments: NoDocuments$f,
	CreateDocuments: CreateDocuments$f,
	youCanLinkDocumentJobImported: youCanLinkDocumentJobImported$f,
	Documenteditedsuccessfully: Documenteditedsuccessfully$f,
	DocumentDetails: DocumentDetails$f,
	UnsavedChanges: UnsavedChanges$f,
	yourChangesWillBeLostSureClose: yourChangesWillBeLostSureClose$f,
	yourChangesWillBeLostSureDiscard: yourChangesWillBeLostSureDiscard$f,
	DiscardChanges: DiscardChanges$f,
	WeeklyGoalAlert: WeeklyGoalAlert$f,
	Progress: Progress$f,
	AllGoals: AllGoals$f,
	Name: Name$f,
	Completedon: Completedon$f,
	Createdon: Createdon$f,
	Action: Action$f,
	Back: Back$f,
	OverallScore: OverallScore$f,
	Aboutthegoal: Aboutthegoal$f,
	GoalTracking: GoalTracking$f,
	Week: Week$f,
	progress: progress$f,
	loading: loading$f,
	Apply: Apply$f,
	Thisskillhasbeenreported: Thisskillhasbeenreported$f,
	issueGettingResume: issueGettingResume$f,
	Interview: Interview$f,
	Tasks: Tasks$f,
	Loading: Loading$f,
	Skilladdedsuccessfully: Skilladdedsuccessfully$f,
	problemAddingSkill: problemAddingSkill$f,
	Reportaproblem: Reportaproblem$f,
	Submit: Submit$f,
	Addanewskill: Addanewskill$f,
	JobDetailsComponent: JobDetailsComponent$f,
	HardSkill: HardSkill$f,
	SoftSkill: SoftSkill$f,
	Pleaseshareanyadditionalcontext: Pleaseshareanyadditionalcontext$f,
	Addasskill: Addasskill$f,
	Skill: Skill$f,
	JobFrequency: JobFrequency$f,
	ResumeFrequency: ResumeFrequency$f,
	Reportskill: Reportskill$f,
	JobDetails: JobDetails$f,
	ViewJobLink: ViewJobLink$f,
	Salary: Salary$f,
	areYouSureDeleteJob: areYouSureDeleteJob$f,
	ViewMore: ViewMore$f,
	ViewLess: ViewLess$f,
	matchYouSkillsAgainstJob: matchYouSkillsAgainstJob$f,
	pleaseUploadResumeSkillMatch: pleaseUploadResumeSkillMatch$f,
	AddResume: AddResume$f,
	thisJobDoesNotHaveAnyDesc: thisJobDoesNotHaveAnyDesc$f,
	youCanEditJobToAdd: youCanEditJobToAdd$f,
	chromeextension: chromeextension$f,
	fromVariousJobPortalsOnce: fromVariousJobPortalsOnce$f,
	AddDescription: AddDescription$f,
	CompanyInfo: CompanyInfo$f,
	Website: Website$f,
	Industry: Industry$f,
	EmployeeCount: EmployeeCount$f,
	ExprienceLevel: ExprienceLevel$f,
	Address: Address$f,
	Resumes: Resumes$f,
	Setasdefault: Setasdefault$f,
	Ok: Ok$f,
	UploadNewResume: UploadNewResume$f,
	Default: Default$f,
	Jobnotfound: Jobnotfound$f,
	EditDetails: EditDetails$f,
	JobPostURL: JobPostURL$f,
	Enterjoburl: Enterjoburl$f,
	Nojobselected: Nojobselected$f,
	Viewjobdetails: Viewjobdetails$f,
	Jobaddedtoyourboardsuccessfully: Jobaddedtoyourboardsuccessfully$f,
	AddJob: AddJob$f,
	Addnewjobname: Addnewjobname$f,
	JobUrl: JobUrl$f,
	Addjoburl: Addjoburl$f,
	Section: Section$f,
	didYouKnow: didYouKnow$f,
	Jobs: Jobs$f,
	AddJobtoboard: AddJobtoboard$f,
	Currentlynojobsareavailable: Currentlynojobsareavailable$f,
	noMatchingJobs: noMatchingJobs$f,
	welcomeToYourPersonalJobTracker: welcomeToYourPersonalJobTracker$f,
	weShortTutorialOnHowTrackingJob: weShortTutorialOnHowTrackingJob$f,
	Addanewjob: Addanewjob$f,
	inOrderTrackCreatButton: inOrderTrackCreatButton$f,
	Providesomedetails: Providesomedetails$f,
	toBeginTypeJobTitleCompany: toBeginTypeJobTitleCompany$f,
	asAnExampleFilledForYou: asAnExampleFilledForYou$f,
	wohooAddedFirstJob: wohooAddedFirstJob$f,
	youCanDragDropJobCard: youCanDragDropJobCard$f,
	Lastbutnotleast: Lastbutnotleast$f,
	finalStepMakeSure: finalStepMakeSure$f,
	autoMaticallyImportJobs: autoMaticallyImportJobs$f,
	selectanysection: selectanysection$f,
	Accept: Accept$f,
	My2023JobSearch: My2023JobSearch$f,
	AddedFrom: AddedFrom$f,
	AddedUntil: AddedUntil$f,
	BasicModal: BasicModal$f,
	AddnewSectionName: AddnewSectionName$f,
	OpenTo: OpenTo$f,
	Featured: Featured$f,
	LicenceAndCerts: LicenceAndCerts$f,
	Banner: Banner$f,
	LinkedInURL: LinkedInURL$f,
	Recommendations: Recommendations$f,
	LinkedinReview: LinkedinReview$f,
	NoDataAvailable: NoDataAvailable$f,
	looksLikeYouDidNot: looksLikeYouDidNot$f,
	toOptimizeProfileScoreVisible: toOptimizeProfileScoreVisible$f,
	LinkedinComponent: LinkedinComponent$f,
	improveYourChancesLandingDreamJob: improveYourChancesLandingDreamJob$f,
	VisitProfile: VisitProfile$f,
	wantToGetLinkedinMakeover: wantToGetLinkedinMakeover$f,
	PostGenerator: PostGenerator$f,
	LinkedinHeadlineGenerator: LinkedinHeadlineGenerator$f,
	LinkedinAboutSectionGenerator: LinkedinAboutSectionGenerator$f,
	AITools: AITools$f,
	Premium: Premium$f,
	LinkedInOptimization: LinkedInOptimization$f,
	JobTracker: JobTracker$f,
	whoIsHiring: whoIsHiring$f,
	Autofill: Autofill$f,
	HeadlineGenerator: HeadlineGenerator$f,
	skillMatching: skillMatching$f,
	SummarizeJD: SummarizeJD$f,
	contactFeature: contactFeature$f,
	documentFeature: documentFeature$f,
	landJobWithoutStress: landJobWithoutStress$f,
	discoverFeatures: discoverFeatures$f,
	letsBeginOnboarding: letsBeginOnboarding$f,
	inTheNextFewScreensJobThirdParties: inTheNextFewScreensJobThirdParties$f,
	letsAddBasicInformation: letsAddBasicInformation$f,
	Pleaseselectanoptionfirst: Pleaseselectanoptionfirst$f,
	JobApplicationTracker: JobApplicationTracker$f,
	LinkedInProfileOptimizer: LinkedInProfileOptimizer$f,
	UnlimitedDocuments: UnlimitedDocuments$f,
	UnlimitedContacts: UnlimitedContacts$f,
	HiringManagerSearch: HiringManagerSearch$f,
	AILinkedInPostGenerator: AILinkedInPostGenerator$f,
	ATSKeywordSkillMatch: ATSKeywordSkillMatch$f,
	"Auto-Apply": "स्वचालित लागू करें",
	ChooseyourPlan: ChooseyourPlan$f,
	superChargeYourJobSearch: superChargeYourJobSearch$f,
	startNowGoto: startNowGoto$f,
	CreatedBy: CreatedBy$f,
	CreateNewNote: CreateNewNote$f,
	Nonotescreated: Nonotescreated$f,
	approxTimeIsFourMinutes: approxTimeIsFourMinutes$f,
	Continue: Continue$f,
	iWillDoLaterTakeMeToApp: iWillDoLaterTakeMeToApp$f,
	allDone: allDone$f,
	welcomeAbord: welcomeAbord$f,
	letsBegin: letsBegin$f,
	UpgradeyourplanandgetAIAssistance: UpgradeyourplanandgetAIAssistance$f,
	DownloadPDF: DownloadPDF$f,
	oopsWeCouldntProcessResume: oopsWeCouldntProcessResume$f,
	MyProfile: MyProfile$f,
	Setting: Setting$f,
	Logout: Logout$f,
	SignIn: SignIn$f,
	Typeyourfirstnamehere: Typeyourfirstnamehere$f,
	Enteryourlastname: Enteryourlastname$f,
	ManageSubscription: ManageSubscription$f,
	ifYouHaveDifficultiesProfile: ifYouHaveDifficultiesProfile$f,
	forSupport: forSupport$f,
	whatIsIdealCompanySize: whatIsIdealCompanySize$f,
	Saveandcontinue: Saveandcontinue$f,
	whatIsMinExpectedSalary: whatIsMinExpectedSalary$f,
	Atleast: Atleast$f,
	SlidetoAdjust: SlidetoAdjust$f,
	whatIndustryExcitedWork: whatIndustryExcitedWork$f,
	Add: Add$f,
	statusOfJobSearch: statusOfJobSearch$f,
	Finish: Finish$f,
	whatLevelRoleLooking: whatLevelRoleLooking$f,
	Selectuptotwo: Selectuptotwo$f,
	PreviousStep: PreviousStep$f,
	Skip: Skip$f,
	whatDoYouValueNewRole: whatDoYouValueNewRole$f,
	Selectuptothree: Selectuptothree$f,
	EqualEmploymentData: EqualEmploymentData$f,
	whatIsYourEthnicity: whatIsYourEthnicity$f,
	areYouAuthorizedToWorkUs: areYouAuthorizedToWorkUs$f,
	willYouRequireSponsorShip: willYouRequireSponsorShip$f,
	doYouHaveADisability: doYouHaveADisability$f,
	areYouAVeteran: areYouAVeteran$f,
	rolesYouInterestedIn: rolesYouInterestedIn$f,
	Selectuptofive: Selectuptofive$f,
	AddCustomrole: AddCustomrole$f,
	whereDoYouLikeWork: whereDoYouLikeWork$f,
	Resources: Resources$f,
	currentlyNoResourceAvailable: currentlyNoResourceAvailable$f,
	AddNewSection: AddNewSection$f,
	ChangeSections: ChangeSections$f,
	Settings: Settings$f,
	Dashboard: Dashboard$f,
	JobBoard: JobBoard$f,
	Linkedin: Linkedin$f,
	Community: Community$f,
	FindRecruiters: FindRecruiters$f,
	Goals: Goals$f,
	DownloadExtension: DownloadExtension$f,
	SuggestaFeature: SuggestaFeature$f,
	leftPanel: leftPanel$f,
	PhoneNumberisrequired: PhoneNumberisrequired$f,
	MobileNumber: MobileNumber$f,
	Enteronlynumbers: Enteronlynumbers$f,
	Countryyoulivein: Countryyoulivein$f,
	SelectaCountry: SelectaCountry$f,
	DateofBirth: DateofBirth$f,
	Gender: Gender$f,
	JobPreferences: JobPreferences$f,
	pleaseEnterValidEmail: pleaseEnterValidEmail$f,
	emailSendForResetting: emailSendForResetting$f,
	VerifyyourEmailID: VerifyyourEmailID$f,
	sentPleaseCheckEmail: sentPleaseCheckEmail$f,
	tooManyAttemptsTryAgain: tooManyAttemptsTryAgain$f,
	Resend: Resend$f,
	Login: Login$f,
	weHaveSentVerificationLinkAtEmail: weHaveSentVerificationLinkAtEmail$f,
	pleaseVerifyEmailContinueSpam: pleaseVerifyEmailContinueSpam$f,
	Logintogetstarted: Logintogetstarted$f,
	ContinuewithGoogle: ContinuewithGoogle$f,
	pleaseInputEmail: pleaseInputEmail$f,
	Password: Password$f,
	pleaseInputPassword: pleaseInputPassword$f,
	passwordLowerUpperDigitSpecial: passwordLowerUpperDigitSpecial$f,
	atLeastSixChar: atLeastSixChar$f,
	forgotPassword: forgotPassword$f,
	Bysigninginyouagreetoour: Bysigninginyouagreetoour$f,
	Terms: Terms$f,
	Conditions: Conditions$f,
	and: and$f,
	PrivacyPolicy: PrivacyPolicy$f,
	theseAreTheTopsSkillsExtracted: theseAreTheTopsSkillsExtracted$f,
	TopSkills: TopSkills$f,
	weCoulNotExtractSkills: weCoulNotExtractSkills$f,
	upgradeToPremiumToView: upgradeToPremiumToView$f,
	SkillScore: SkillScore$f,
	thisIsYourSkillScoreBasedOn: thisIsYourSkillScoreBasedOn$f,
	theseSkllsAreStrongMatch: theseSkllsAreStrongMatch$f,
	Strongmatch: Strongmatch$f,
	theseSkillsArePartialMatch: theseSkillsArePartialMatch$f,
	Partialmatch: Partialmatch$f,
	theseSkillsAreMissingFrom: theseSkillsAreMissingFrom$f,
	"Missing Keywords": "गुम हुए कीवर्ड",
	SkillMatchComponent: SkillMatchComponent$f,
	Optional: Optional$f,
	Notrelevanttothejob: Notrelevanttothejob$f,
	Notaskill: Notaskill$f,
	Toogeneric: Toogeneric$f,
	Pleaseshareanyfeedback: Pleaseshareanyfeedback$f,
	excludedKeywordsWillNot: excludedKeywordsWillNot$f,
	yesExcludeThisSkillFrom: yesExcludeThisSkillFrom$f,
	PartialMatch: PartialMatch$f,
	MissingKeywords: MissingKeywords$f,
	Providetitletotask: Providetitletotask$f,
	TasksList: TasksList$f,
	AddTask: AddTask$f,
	EnterTaskTitlehere: EnterTaskTitlehere$f,
	TasksComponent: TasksComponent$f,
	CompletedTasks: CompletedTasks$f,
	CompleteYourtasks: CompleteYourtasks$f,
	Steps: Steps$f,
	PremiumMember: PremiumMember$f,
	Thankyouforupgradingto: Thankyouforupgradingto$f,
	CareerflowPremium: CareerflowPremium$f,
	hereIsHowYouCanAccessPremium: hereIsHowYouCanAccessPremium$f,
	stepOne: stepOne$f,
	DownloadourChromeExtension: DownloadourChromeExtension$f,
	youJobSearchCopilotIshere: youJobSearchCopilotIshere$f,
	DownloadNow: DownloadNow$f,
	stepTwo: stepTwo$f,
	GetStarted: GetStarted$f,
	stepThree: stepThree$f,
	SignintoChromeExtension: SignintoChromeExtension$f,
	entityCreated: entityCreated$f,
	entityUpdated: entityUpdated$f,
	entityDeleted: entityDeleted$f,
	entityLinked: entityLinked$f,
	entityUnlinked: entityUnlinked$f,
	entityMovedTo: entityMovedTo$f,
	youAddedANewEntity: youAddedANewEntity$f,
	personCreated: personCreated$f,
	youUpdatedAEntity: youUpdatedAEntity$f,
	personUpdated: personUpdated$f,
	youDeletedAEntity: youDeletedAEntity$f,
	personDeleted: personDeleted$f,
	youLinkedEntity: youLinkedEntity$f,
	personLinked: personLinked$f,
	youUnlinked: youUnlinked$f,
	personUnlinked: personUnlinked$f,
	youMovedEntity: youMovedEntity$f,
	personMoved: personMoved$f,
	addedByName: addedByName$f,
	DownloadChromeExtension: DownloadChromeExtension$f,
	ourChromeExtensionIs: ourChromeExtensionIs$f,
	Optimizeyourprofile: Optimizeyourprofile$f,
	startOptimizingYourProfile: startOptimizingYourProfile$f,
	OptimizeNow: OptimizeNow$f,
	Addyourfirstjob: Addyourfirstjob$f,
	startSavingJobApplicationsToTrack: startSavingJobApplicationsToTrack$f,
	AddNow: AddNow$f,
	CompleteProfile: CompleteProfile$f,
	completeYourProfileForUsing: completeYourProfileForUsing$f,
	CompleteNow: CompleteNow$f,
	Addyourfirstcontact: Addyourfirstcontact$f,
	addContactToFollowUpWith: addContactToFollowUpWith$f,
	JoinCommunity: JoinCommunity$f,
	ourCommunityisAlways: ourCommunityisAlways$f,
	JoinNow: JoinNow$f,
	welcomeToCareerflow: welcomeToCareerflow$f,
	yourHubForCareerInsights2: yourHubForCareerInsights2$f,
	ChecklistCompleted: ChecklistCompleted$f,
	Completeyourchecklist: Completeyourchecklist$f,
	completeAFewStepsTo: completeAFewStepsTo$f,
	Completed: Completed$f,
	JobCountByStage: JobCountByStage$f,
	NopastapplicationDatafound: NopastapplicationDatafound$f,
	YourJobSearchStages: YourJobSearchStages$f,
	NoDatafound: NoDatafound$f
};

const copyToClipboard$e = "Kopirano u međuspremnik!";
const UnlocktheAIgenerated$e = "Otključajte AI generirano.";
const UpgradetoPremium$e = "Nadogradite na Premium.";
const Result$e = "Rezultat";
const Copy$e = "Kopiraj";
const Save$e = "Spremi";
const Edit$e = "Uredi";
const Processing$e = "Obrada";
const YourAIgeneratedcontentwillshowhere$e = "Vaš AI generirani sadržaj će se prikazati ovdje";
const hopeYouFindUseful$e = "Nadam se da će vam ovaj rezultat biti koristan!";
const regenerate$e = "Ponovno generiraj";
const ProvideAdditionalFeedback$e = "Priložite dodatne povratne informacije";
const Enteranyfeedback$e = "Unesite bilo kakve povratne informacije";
const Notimpressive$e = "Nije impresivno";
const thisIsntTrue$e = "Ovo nije istina";
const Notpersonalized$e = "Nije personalizirano";
const Tone$e = "Ton";
const Length$e = "Duljina";
const Template$e = "Predložak";
const Generatedon$e = "Generirano na";
const Copiedtoclipboard$e = "Kopirano u međuspremnik.";
const CopytoClipboard$e = "Kopiraj u međuspremnik";
const DownloadasPDF$e = "Preuzmi kao PDF";
const ViewDetails$e = "Pregledaj detalje";
const JobDescriptionImported$e = "Opis posla uvezen";
const ImportfromJob$e = "Uvoz iz posla";
const Saved$e = "Spremljeno";
const Applied$e = "Primijenjeno";
const Offer$e = "Ponuda";
const Interviewing$e = "Intervjuiranje";
const Rejected$e = "Odbijeno";
const Search$e = "Pretraži";
const Import$e = "Uvoz";
const CoverLetterGeneratorHistory$e = "Povijest generatora životopisa";
const NoCoverLettersGenerated$e = "Nema generiranih životopisa";
const getStartedCoverLetter$e = "Još niste generirali nijedan životopis. Počnite i stvorite životopise usklađene s opisom posla i vašim relevantnim iskustvom.";
const getStarted$e = "Počnite!";
const Documents$e = "Dokumenti";
const UploadNewDocument$e = "Učitaj novi dokument";
const AICoverLetterGenerator$e = "AI Generator životopisa";
const ViewHistory$e = "Pogledaj povijest";
const JobDescription$e = "Opis posla";
const ImportfromBoard$e = "Uvoz s ploče";
const EnterJobDescription$e = "Unesite opis posla";
const JobTitle$e = "Naziv posla";
const EnterJobTitle$e = "Unesite naziv posla";
const CompanyName$e = "Naziv tvrtke";
const EnterCompanyName$e = "Unesite naziv tvrtke";
const YourProfile$e = "Vaš profil";
const ResumeUpload$e = "Učitaj životopis";
const UseLinkedinProfile$e = "Koristi LinkedIn profil";
const Uploadyourresume$e = "Učitajte svoj životopis";
const AddyourResume$e = "Dodajte svoj životopis";
const fileNameCannotFormat$e = "Nazivi datoteka ne mogu sadržavati razmake ni podcrtavanja i trebaju biti u formatu .doc, .docx ili .pdf.";
const ChooseorUpload$e = "Odaberite ili učitajte";
const SelectTemplate$e = "Odaberi predložak";
const Preview$e = "Pregled";
const UseTemplate$e = "Koristi predložak";
const Change$e = "Promijeni";
const AdvancedSettings$e = "Napredne postavke";
const AdditionalContext$e = "Dodatni kontekst";
const Professional$e = "Stručno";
const Casual$e = "Opušteno";
const Enthusiastic$e = "Oduševljeno";
const Informational$e = "Informativno";
const Short$e = "Kratko";
const Medium$e = "Srednje";
const Long$e = "Dugo";
const Language$e = "Jezik";
const iAmOkayBack$e = "Slažem se! Vrati se";
const Generate$e = "Generiraj";
const CoverLetter$e = "Motivacijsko pismo";
const SelectLanguage$e = "Odaberi jezik";
const AboutGeneratorHistory$e = "Povijest generatora o meni";
const NoAboutsGenerated$e = "Nema generiranih informacija o meni";
const getStartedAbouts$e = "Još niste generirali nijedne informacije o meni. Počnite i stvorite ih usklađene s opisom posla i vašim relevantnim iskustvom.";
const noAttachmentsFound$e = "Nema pronađenih privitaka.";
const TargetJobTitle$e = "Ciljni naziv posla";
const KeywordsToInclude$e = "Ključne riječi za uključiti";
const UploadYourResume$e = "Prenesite svoj životopis";
const AddYourResume$e = "Dodajte svoj životopis";
const LinkedinProfile$e = "LinkedIn profil";
const Linkedinprofilenotfound$e = "LinkedIn profil nije pronađen";
const startUsingChromeExtension$e = "Započnite optimizaciju svog LinkedIn profila pomoću našeg dodatka za Chrome kako biste koristili ovu opciju.";
const Download$e = "Preuzmi";
const UseEmojis$e = "Koristi emotikone";
const UseBulletPoints$e = "Koristi oznake";
const SpeechFocus$e = "Fokus govora";
const FirstPerson$e = "Prva osoba";
const ThirdPerson$e = "Treća osoba";
const HeadlineGeneratorHistory$e = "Povijest generatora naslova";
const NoHeadlinesGenerated$e = "Nema generiranih naslova";
const getStartedHeadline$e = "Još niste generirali nijedan naslov. Počnite i stvorite ih usklađene s opisom posla i vašim relevantnim iskustvom.";
const AIHeadlineGenerator$e = "AI Generator naslova";
const KeywordstoInclude$e = "Ključne riječi za uključivanje";
const Pressenteraftereachword$e = "Pritisnite Enter nakon svake riječi.";
const LinkedinProfilenotfound$e = "Profil na LinkedInu nije pronađen.";
const Headline$e = "Naslov";
const PostGeneratorHistory$e = "Povijest generatora objava";
const NoPostsGenerated$e = "Nema generiranih objava";
const getStartedPost$e = "Još niste generirali nijednu objavu. Počnite i stvorite ih usklađene s opisom posla i vašim relevantnim iskustvom.";
const Topic$e = "Tema";
const Description$e = "Opis";
const UseHashtags$e = "Koristi oznake";
const Custom$e = "Prilagođeno";
const EnterCustomTone$e = "Unesite prilagođeni ton";
const Added$e = "Dodano";
const ComingSoon$e = {
	header: "Inženjeri na djelu!",
	content_1: "Naš tim inženjera naporno radi kako bi uskoro pokrenuo ovu značajku",
	content_2: "Želite li ovu značajku uskoro? Javite nam samo označavanjem kućice u nastavku.",
	content_3: "Želim ovu značajku"
};
const Company$e = "Tvrtka";
const JobInterview$e = "Razgovor za posao";
const Research$e = "Istraživanje";
const Networking$e = "Mreženje";
const Referral$e = "Preporuka";
const MustbeContacted$e = "Mora se kontaktirati";
const ScheduleaMeeting$e = "Zakazivanje sastanka";
const needAFollowUp$e = "Potrebno je pratiti.";
const Today$e = "Danas";
const Viewdetails$e = "Pogledaj detalje";
const Activity$e = "Aktivnost";
const ActivityDetails$e = "Detalji aktivnosti";
const Delete$e = "Izbriši";
const Title$e = "Naslov";
const Goal$e = "Cilj";
const Status$e = "Status";
const FollowUp$e = "Pratiti";
const AddActivity$e = "Dodaj aktivnost";
const Enteractivitytitle$e = "Unesite naslov aktivnosti";
const Cancel$e = "Otkaži";
const SaveActivity$e = "Spremi aktivnost";
const noActivityPresent$e = "Nema aktivnosti, dodaj aktivnost.";
const Addnew$e = "Dodaj novo";
const About$e = "O meni";
const noDataPresentYou$e = "Nema dostupnih podataka, možete urediti ovaj kontakt i dodati polja.";
const Experience$e = "Iskustvo";
const Education$e = "Obrazovanje";
const Skills$e = "Vještine";
const Overview$e = "Pregled";
const LinkedJobs$e = "Povezani poslovi";
const Notes$e = "Bilješke";
const FullName$e = "Puno ime";
const Location$e = "Lokacija";
const Relationship$e = "Odnos";
const Contacts$e = "Kontakti";
const CreateContact$e = "Stvori kontakt";
const NotesCreated$e = "Bilješke stvorene";
const Notesupdated$e = "Bilješke ažurirane";
const Addnote$e = "Dodaj bilješku";
const areYouSureDeleteNote$e = "Jeste li sigurni da želite izbrisati ovu bilješku?";
const Createdby$e = "Stvoreno od";
const notSureWhyResumeCalls$e = "Niste sigurni zašto vaš životopis ne privlači pozive za razgovor za posao? ☎️";
const getExpertResumeReview$e = "Dobijte stručnu recenziju životopisa 💎✨";
const youHaventAddedContacts$e = "Još niste dodali kontakte.";
const noMatchingContacts$e = "Nisu pronađeni odgovarajući kontakti.";
const Link$e = "Poveznica";
const unlink$e = "Iskopčaj";
const Locationnotavailable$e = "Lokacija nije dostupna";
const Emailnotavailable$e = "E-pošta nije dostupna";
const PhoneNumbernotavailable$e = "Broj telefona nije dostupan";
const createdby$e = "stvoreno od strane";
const areYouSureDeleteContact$e = "Jeste li sigurni da želite izbrisati ovaj kontakt?";
const areYouSureUnlinkContact$e = "Jeste li sigurni da želite iskopčati ovaj kontakt?";
const Addedbyyou$e = "Dodano od strane vas";
const Addedby$e = "Dodano od";
const Timeline$e = "Vremenska crta";
const Timelineempty$e = "Vremenska crta prazna";
const Discard$e = "Odbaci";
const SaveContact$e = "Spremi kontakt";
const Recruiter$e = "Regruter";
const Candidate$e = "Kandidat";
const Colleague$e = "Kolega";
const Employee$e = "Zaposlenik";
const EnterValidEmail$e = "Unesite ispravnu e-poštu";
const EnterValidPhoneNumber$e = "Unesite ispravan broj telefona";
const editingProfileNotAvailable$e = "Uređivanje profilne fotografije još nije dostupno.";
const itWillBeSoonAvailable$e = "Bit će uskoro dostupno u našem.";
const ChromeExtension$e = "Dodatak za Chrome";
const SelectTag$e = "Odaberi oznaku";
const FirstName$e = "Ime";
const FirstNameisrequired$e = "Ime je obavezno";
const LastName$e = "Prezime";
const LastNameisrequired$e = "Prezime je obavezno";
const Companyisrequired$e = "Tvrtka je potrebna.";
const Email$e = "E-pošta";
const ThisisnotavalidEmail$e = "Ovo nije valjana e-pošta.";
const AddEmail$e = "Dodaj e-poštu";
const PhoneNumber$e = "Broj telefona";
const notaValidPhone$e = "Ovo nije valjani broj telefona. Unesite samo brojeve.";
const phoneNoMinimum5char$e = "Broj telefona mora biti minimalno 5 znakova.";
const phoneNoMinumum15char$e = "Broj telefona mora biti najviše 15 znakova.";
const AddPhoneNumber$e = "Dodaj broj telefona";
const SelectGoal$e = "Odaberi cilj";
const SelectStatus$e = "Odaberi status";
const Followup$e = "Pratiti";
const SocialMedia$e = "Društveni mediji";
const Linkedinhandle$e = "Linkedin korisničko ime";
const Twitterhandle$e = "Twitter korisničko ime";
const Facebookhandle$e = "Facebook korisničko ime";
const Githubhandle$e = "Github korisničko ime";
const Gmailhandle$e = "Gmail korisničko ime";
const Changessavedsuccessfully$e = "Promjene uspješno spremljene";
const EditContact$e = "Uredi kontakt";
const BasicInformation$e = "Osnovne informacije";
const EditContactDetails$e = "Uredi detalje kontakta";
const SaveChanges$e = "Spremi promjene";
const phoneNoMinimum14char$e = "Broj telefona mora biti minimalno 14 znakova.";
const LinkedIn$e = "LinkedIn";
const Twitter$e = "Twitter";
const Facebook$e = "Facebook";
const Github$e = "Github";
const Gmail$e = "Gmail";
const youCanWriteAbout$e = "Možete pisati o svojim godinama iskustva, industriji ili vještinama. Ljudi također govore o svojim postignućima ili prethodnim radnim iskustvima.";
const Addednewsection$e = "Dodana je nova sekcija";
const Removedsuccessfully$e = "Uspješno uklonjeno.";
const Remove$e = "Ukloni";
const Institute$e = "Institut";
const Schoolisrequired$e = "Škola je obavezna.";
const Degree$e = "Stupanj";
const StartMonth$e = "Početni mjesec";
const StartYear$e = "Početna godina";
const EndMonth$e = "Kraj mjeseca";
const EndYear$e = "Kraj godine";
const Addmore$e = "Dodaj još";
const PositionTitle$e = "Naslov pozicije";
const ExperienceType$e = "Vrsta iskustva";
const Addednewitem$e = "Dodan novi predmet";
const whatSkillsDoYouEnjoy$e = "Koje vještine posjedujete ili uživate raditi s njima?";
const Typeskillshere$e = "Upišite vještine ovdje";
const LinkedContacts$e = "Povezani kontakti";
const LinkContact$e = "Poveži kontakt";
const NocontactsLinked$e = "Nema povezanih kontakata";
const JobContactsComponent$e = {
	linkContact: "Povezivanjem kontakata brzo možete vidjeti tko su važne osobe poput regrutera, upravitelja zapošljavanja, itd., za ovu ulogu! U budućnosti ćemo moći prikazivati relevantne informacije na temelju vaših kontakata."
};
const Nocontacts$e = "Nema kontakata";
const LinkJobto$e = "Poveži posao s";
const Contact$e = "Kontakt";
const Document$e = "Dokument";
const Nojobsfound$e = "Nema pronađenih poslova";
const LinkJob$e = "Poveži posao";
const youCanLinkContactJobImported$e = "Možete povezati ovaj kontakt s poslom koji ste uvezli u Careerflow.";
const Prev$e = "Nema prijevoda (There is no translation)";
const Next$e = "Sljedeće";
const areYouSureUnlinkDocument$e = "Jeste li sigurni da želite iskopčati ovaj dokument?";
const areYouSureDeleteDocument$e = "Jeste li sigurni da želite izbrisati ovaj dokument?";
const Category$e = "Kategorija";
const CreatedOn$e = "Stvoreno";
const Joblinked$e = "Povezano s poslom";
const Quickactions$e = "Brze akcije";
const All$e = "Sve";
const Resume$e = "Životopis";
const Portfolio$e = "Portfelj";
const Other$e = "Ostalo";
const Adddocument$e = "Dodaj dokument";
const Type$e = "Vrsta";
const Sortingby$e = "Sortiranje po";
const SwitchtoGridLayout$e = "Prebacite se na mrežni raspored.";
const SwitchtoListLayout$e = "Prebacite se na prikaz u obliku liste.";
const NoDocumentsAdded$e = "Nema dodanih dokumenata";
const DocumentsComponent$e = {
	nodocs: "Još niste stvorili nikakve dokumente. Možete učitati verzije svog životopisa, motivacijska pisma i još toga, te ih povezati s poslovima koje pratite!"
};
const NoDocumentFound$e = "Nije pronađen dokument";
const SelectFile$e = "Odaberi datoteku";
const onlyPdfDocxSupported$e = "Podržani su samo .pdf i .docx formati.";
const Uploadfile$e = "Učitaj datoteku";
const DocumentCategory$e = "Kategorija dokumenta";
const SaveDocument$e = "Spremi dokument";
const AddDocument$e = "Dodaj dokument";
const LinkedDocuments$e = "Povezani dokumenti";
const LinkDocument$e = "Poveži dokument";
const NodocumentsLinked$e = "Nema povezanih dokumenata";
const JobDocumentsComponent$e = {
	linkDocs: "Povezivanje svih relevantnih dokumenata poput životopisa, motivacijskog pisma, itd., koje ste poslali za ovaj posao, pomoći će vam da pratite sve na jednom mjestu. Isprobajte to!"
};
const NoDocuments$e = "Nema dokumenata";
const CreateDocuments$e = "Kreiraj dokumente";
const youCanLinkDocumentJobImported$e = "Možete povezati ovaj dokument s poslom koji ste uvezli u Careerflow.";
const Documenteditedsuccessfully$e = "Dokument je uspješno uređen.";
const DocumentDetails$e = "Detalji dokumenta";
const UnsavedChanges$e = "Nespremljene promjene";
const yourChangesWillBeLostSureClose$e = "Vaše promjene bit će izgubljene, jeste li sigurni da želite zatvoriti?";
const yourChangesWillBeLostSureDiscard$e = "Vaše promjene bit će izgubljene, jeste li sigurni da želite odbaciti svoje promjene?";
const DiscardChanges$e = "Odbaci promjene";
const WeeklyGoalAlert$e = "Tjedno upozorenje o ciljevima";
const Progress$e = "Napredak";
const AllGoals$e = "Svi ciljevi";
const Name$e = "Ime";
const Completedon$e = "Završeno";
const Createdon$e = "Stvoreno";
const Action$e = "Akcija";
const Back$e = "Natrag";
const OverallScore$e = "Ukupni rezultat";
const Aboutthegoal$e = "O cilju";
const GoalTracking$e = "Pracenje cilja";
const Week$e = "Tjedan";
const progress$e = "napredak";
const loading$e = "Učitavanje";
const Apply$e = "Primijeni";
const Thisskillhasbeenreported$e = "Ova vještina je prijavljena.";
const issueGettingResume$e = "Došlo je do problema prilikom dobivanja životopisa.";
const Interview$e = "Intervju";
const Tasks$e = "Zadaci";
const Loading$e = "Učitavanje";
const Skilladdedsuccessfully$e = "Vještina uspješno dodana.";
const problemAddingSkill$e = "Došlo je do problema prilikom dodavanja vještine.";
const Reportaproblem$e = "Prijavi problem";
const Submit$e = "Pošalji";
const Addanewskill$e = "Dodaj novu vještinu";
const JobDetailsComponent$e = {
	classifySkill: "Kako biste klasificirali ovu vještinu (neobavezno)?",
	includedKeywordsWillCount: "Uključiti ovaj ključni pojam?",
	yesIncludeThisSkill: "Uključene ključne riječi će utjecati na vašu podudarnost bodova za sve buduće skeniranja. Možete promijeniti uključene ključne riječi iz svog profila.",
	addSkill: "Želite li dodati ovo kao vještinu?"
};
const HardSkill$e = "Tvrdi vještinski skup";
const SoftSkill$e = "Meki vještinski skup";
const Pleaseshareanyadditionalcontext$e = "Podijelite dodatni kontekst, molim vas";
const Addasskill$e = "Dodaj kao vještinu";
const Skill$e = "Vještina";
const JobFrequency$e = "Frekvencija posla";
const ResumeFrequency$e = "Frekvencija životopisa";
const Reportskill$e = "Prijavi vještinu";
const JobDetails$e = "Pojedinosti o poslu";
const ViewJobLink$e = "Pogledajte poveznicu za posao";
const Salary$e = "Plaća";
const areYouSureDeleteJob$e = "Jeste li sigurni da želite izbrisati ovaj posao?";
const ViewMore$e = "Prikaži više";
const ViewLess$e = "Prikaži manje";
const matchYouSkillsAgainstJob$e = "Usporedite svoje vještine s opisom posla.";
const pleaseUploadResumeSkillMatch$e = "Molimo vas da prenesete svoj životopis kako biste dobili ocjenu podudarnosti vaših vještina.";
const AddResume$e = "Dodaj životopis";
const thisJobDoesNotHaveAnyDesc$e = "Ovaj posao nema opis.";
const youCanEditJobToAdd$e = "Možete urediti ovaj posao dodavanjem opisa. Također možete uvesti poslove pomoću našeg alata.";
const chromeextension$e = "dodatak za Chrome preglednik";
const fromVariousJobPortalsOnce$e = "s raznih poslovnih portala. Nakon što dodate opis, također ćete moći vidjeti informacije vezane uz vještine.";
const AddDescription$e = "Dodaj opis.";
const CompanyInfo$e = "Informacije o tvrtki";
const Website$e = "Web stranica";
const Industry$e = "Industrija";
const EmployeeCount$e = "Broj zaposlenika";
const ExprienceLevel$e = "Razina iskustva";
const Address$e = "Adresa";
const Resumes$e = "Životopisi";
const Setasdefault$e = "Postavi kao zadano";
const Ok$e = "U redu";
const UploadNewResume$e = "Učitaj novi životopis";
const Default$e = "Zadano";
const Jobnotfound$e = "Posao nije pronađen.";
const EditDetails$e = "Uredi detalje";
const JobPostURL$e = "URL objave posla";
const Enterjoburl$e = "Unesite URL posla";
const Nojobselected$e = "Nije odabran posao";
const Viewjobdetails$e = "Pogledaj detalje posla";
const Jobaddedtoyourboardsuccessfully$e = "Posao je uspješno dodan na vašu ploču.";
const AddJob$e = "Dodaj posao";
const Addnewjobname$e = "Dodajte novi naziv posla.";
const JobUrl$e = "URL posla";
const Addjoburl$e = "Dodaj URL posla.";
const Section$e = "Sekcija";
const didYouKnow$e = {
	chromeExtension: "Znate li? Također možete spremiti poslove izravno putem naše Chrome ekstenzije i uvesti sve podatke u jednom kliku! To traje samo nekoliko sekundi."
};
const Jobs$e = "Poslovi";
const AddJobtoboard$e = "Dodaj posao na ploču";
const Currentlynojobsareavailable$e = "Trenutno nema dostupnih poslova.";
const noMatchingJobs$e = "Nisu pronađeni odgovarajući poslovi.";
const welcomeToYourPersonalJobTracker$e = "Dobrodošli u vaš osobni praćenje poslova!";
const weShortTutorialOnHowTrackingJob$e = "Vodit ćemo vas kroz kratki tutorial o tome kako započeti praćenje vaših prijava za posao u nekoliko jednostavnih koraka!";
const Addanewjob$e = "Dodaj novi posao";
const inOrderTrackCreatButton$e = "Da biste započeli praćenje prijava za posao, prvo ga morate dodati na ploču klikom na gumb \"Stvori\".";
const Providesomedetails$e = "Navedite neke detalje";
const toBeginTypeJobTitleCompany$e = "Za početak, jednostavno upišite naziv posla, naziv tvrtke i status kojeg želite dodati. Kasnije možete dodati više detalja, ali za sada je to sve što vam treba!";
const asAnExampleFilledForYou$e = "Kao primjer, već smo to popunili za vas!";
const wohooAddedFirstJob$e = "Woohoo! Dodali ste svoj prvi posao u svoj sustav praćenja poslova!";
const youCanDragDropJobCard$e = "Sada možete povući i ispustiti karticu posla u različite faze procesa prijave za posao. Klikom na karticu posla možete vidjeti više detalja, urediti ih, spremiti bilješke i još mnogo toga!";
const Lastbutnotleast$e = "Konačno, ali ne manje važno";
const finalStepMakeSure$e = "Kao konačni korak, provjerite imate li naš.";
const autoMaticallyImportJobs$e = "što će vam omogućiti automatski uvoz poslova s vaših omiljenih web stranica za traženje poslova poput LinkedIna, Indeeda i drugih! Naša ekstenzija također vam pomaže poboljšati vaš LinkedIn profil i dobiti 2,5 puta više pojavljivanja u pretraživanju!";
const selectanysection$e = "odaberite bilo koji odjeljak";
const Accept$e = "Prihvati";
const My2023JobSearch$e = "Moj posao u 2023. godini";
const AddedFrom$e = "Dodano iz";
const AddedUntil$e = "Dodano do";
const BasicModal$e = "Osnovni modal";
const AddnewSectionName$e = "Dodajte novo ime odjeljka";
const OpenTo$e = "Otvoreno za";
const Featured$e = "Istaknuto";
const LicenceAndCerts$e = "Dozvole i certifikati";
const Banner$e = "Zastava";
const LinkedInURL$e = "LinkedIn URL";
const Recommendations$e = "Preporuke";
const LinkedinReview$e = "Pregled na Linkedinu";
const NoDataAvailable$e = "Nema dostupnih podataka";
const looksLikeYouDidNot$e = "Izgleda da niste počeli koristiti našu";
const toOptimizeProfileScoreVisible$e = "još niste optimizirali svoj LinkedIn profil. Nakon što to učinite, vaša će se ocjena profila vidjeti ovdje.";
const LinkedinComponent$e = {
	letsOptimize: "Optimizirajmo"
};
const improveYourChancesLandingDreamJob$e = "Poboljšajte svoje šanse za dobivanje posla iz snova. Koristite ove isprobane strategije kako biste dali svojem LinkedIn profilu potrebnu preobrazbu.";
const VisitProfile$e = "Posjeti profil";
const wantToGetLinkedinMakeover$e = "Želite li potpunu preobrazbu profila na LinkedInu?";
const PostGenerator$e = "Generator postova";
const LinkedinHeadlineGenerator$e = "Generator naslova za LinkedIn";
const LinkedinAboutSectionGenerator$e = "Generator o odjeljku O meni na LinkedInu";
const AITools$e = "AI Alati";
const Premium$e = "Premium";
const LinkedInOptimization$e = "Optimizacija na LinkedIn-u";
const JobTracker$e = "Praćenje poslova";
const whoIsHiring$e = "Tko zapošljava";
const Autofill$e = "Automatsko popunjavanje";
const HeadlineGenerator$e = "Generator naslova";
const skillMatching$e = "Pronalaženje vještina";
const SummarizeJD$e = "Sažetak opisa posla";
const contactFeature$e = "Praćenje kontakata";
const documentFeature$e = "Dokumenti";
const landJobWithoutStress$e = "Osigurajte svoj posao iz snova. Bez stresa.";
const discoverFeatures$e = "Otkrijte niz značajki Careerflow.ai dizajniranih za pojednostavljenje vaše potrage za poslom i poboljšanje vašeg profesionalnog puta!";
const letsBeginOnboarding$e = "Upoznajmo te bolje!";
const inTheNextFewScreensJobThirdParties$e = "U sljedećim zaslonima postavit ćemo vam neka pitanja koja će nam pomoći prilagoditi iskustvo za vas i automatski popuniti vaše prijave za posao (tako da to ne morate sami)! Ne prodajemo vaše podatke trećim stranama.";
const letsAddBasicInformation$e = "Dodajmo vaše osnovne informacije.";
const Pleaseselectanoptionfirst$e = "Molimo odaberite prvo opciju.";
const JobApplicationTracker$e = "Praćenje prijava za posao";
const LinkedInProfileOptimizer$e = "Optimizator profila na LinkedIn-u";
const UnlimitedDocuments$e = "Neograničeni dokumenti";
const UnlimitedContacts$e = "Neograničeni kontakti";
const HiringManagerSearch$e = "Pretraživanje menadžera za zapošljavanje";
const AILinkedInPostGenerator$e = "Generator objava na LinkedInu pomoću AI tehnologije";
const ATSKeywordSkillMatch$e = "Posao koji odgovara ključnoj riječi / vještini ATS-a";
const ChooseyourPlan$e = "Odaberite svoj plan";
const superChargeYourJobSearch$e = "Poboljšajte svoju potragu za poslom i proces prijave za posao, povećajte broj intervjua i ostvarite svoj san o poslu. Sve to uz pomoć premium alata Careerflow-a.";
const startNowGoto$e = "Počni sada (Idi na aplikaciju)";
const CreatedBy$e = "Kreirao";
const CreateNewNote$e = "Kreirajte novu bilješku";
const Nonotescreated$e = "Nema kreiranih bilješki";
const approxTimeIsFourMinutes$e = "Približno vrijeme za dovršetak procesa uvođenja je 4 minute.";
const Continue$e = "Nastavi";
const iWillDoLaterTakeMeToApp$e = "To ću kasnije napraviti. Odvedi me na aplikaciju.";
const allDone$e = "Sve gotovo!";
const welcomeAbord$e = "Dobrodošli na brod!";
const letsBegin$e = "Krenimo.";
const UpgradeyourplanandgetAIAssistance$e = "Nadogradite svoj plan i dobijte pomoć umjetne inteligencije.";
const DownloadPDF$e = "Preuzmi PDF";
const oopsWeCouldntProcessResume$e = "Ups, nismo mogli obraditi ovaj životopis.";
const MyProfile$e = "Moj profil";
const Setting$e = "Postavljanje";
const Logout$e = "Odjava";
const SignIn$e = "Prijava";
const Typeyourfirstnamehere$e = "Vaše ime";
const Enteryourlastname$e = "Vaše prezime";
const ManageSubscription$e = "Upravljanje pretplatom";
const ifYouHaveDifficultiesProfile$e = "Ako imate bilo kakvih poteškoća s informacijama na svom profilu, molimo kontaktirajte";
const forSupport$e = "za podršku.";
const whatIsIdealCompanySize$e = "Koja je idealna veličina tvrtke za vas?";
const Saveandcontinue$e = "Spremi i nastavi";
const whatIsMinExpectedSalary$e = "Koja je vaša minimalna očekivana plaća (godišnje)?";
const Atleast$e = "Bar";
const SlidetoAdjust$e = "Kliznite za podešavanje.";
const whatIndustryExcitedWork$e = "Koje su industrije uzbudljive za vas?";
const Add$e = "Dodaj";
const statusOfJobSearch$e = "Kakav je status vaše potrage za poslom?";
const Finish$e = "Završi";
const whatLevelRoleLooking$e = "Kakvu razinu uloge tražite?";
const Selectuptotwo$e = "Odaberite do dvije.";
const PreviousStep$e = "Prethodni korak";
const Skip$e = "Preskoči";
const whatDoYouValueNewRole$e = "Što cijenite u novoj ulozi?";
const Selectuptothree$e = "Odaberite do tri.";
const EqualEmploymentData$e = "Podaci o jednakoj zaposlenosti";
const whatIsYourEthnicity$e = "Koje si etničke pripadnosti?";
const areYouAuthorizedToWorkUs$e = "Jeste li ovlašteni raditi u SAD-u?";
const willYouRequireSponsorShip$e = "Treba li vam sada ili u budućnosti sponzorstvo za status radne vize?";
const doYouHaveADisability$e = "Imate li invaliditet?";
const areYouAVeteran$e = "Jeste li veteran?";
const rolesYouInterestedIn$e = "Kakve uloge vas zanimaju?";
const Selectuptofive$e = "Odaberite do pet.";
const AddCustomrole$e = "Dodaj prilagođenu ulogu";
const whereDoYouLikeWork$e = "Gdje biste željeli raditi?";
const Resources$e = "Resursi";
const currentlyNoResourceAvailable$e = "Trenutno nema dostupnih resursa.";
const AddNewSection$e = "Dodaj novi odjeljak";
const ChangeSections$e = "Izmijeni odjeljke";
const Settings$e = "Postavke";
const Dashboard$e = "Nadzorna ploča";
const JobBoard$e = "Oglasna ploča za poslove";
const Linkedin$e = "Linkedin";
const Community$e = "Zajednica";
const FindRecruiters$e = "Pronađi regrutere";
const Goals$e = "Ciljevi";
const DownloadExtension$e = "Preuzmi ekstenziju";
const SuggestaFeature$e = "Prijedlog značajke";
const leftPanel$e = {
	ReportanIssue: "Prijavi problem"
};
const PhoneNumberisrequired$e = "Broj telefona je obavezan";
const MobileNumber$e = "Mobilni broj";
const Enteronlynumbers$e = "Unesite samo brojeve.";
const Countryyoulivein$e = "Zemlja u kojoj živite";
const SelectaCountry$e = "Odaberite državu";
const DateofBirth$e = "Datum rođenja";
const Gender$e = "Spol";
const JobPreferences$e = "Želje za poslom";
const pleaseEnterValidEmail$e = "Molimo unesite valjanu e-mail adresu.";
const emailSendForResetting$e = "Poslan vam je e-mail za resetiranje lozinke.";
const VerifyyourEmailID$e = "Potvrdite svoj Email ID";
const sentPleaseCheckEmail$e = "Poslano! Molimo provjerite svoj e-mail.";
const tooManyAttemptsTryAgain$e = "Previše pokušaja, molimo pokušajte ponovno za neko vrijeme.";
const Resend$e = "Ponovno pošalji";
const Login$e = "Prijava";
const weHaveSentVerificationLinkAtEmail$e = "Poslali smo vam verifikacijski link na vašu e-poštu.";
const pleaseVerifyEmailContinueSpam$e = "Molimo potvrdite svoju e-poštu kako biste nastavili. Također provjerite mapu neželjene pošte ili promocija za e-poštu za potvrdu.";
const Logintogetstarted$e = "Prijavite se da biste počeli.";
const ContinuewithGoogle$e = "Nastavi s Googleom";
const pleaseInputEmail$e = "Molimo unesite svoju e-mail adresu!";
const Password$e = "Lozinka";
const pleaseInputPassword$e = "Molimo unesite svoju lozinku!";
const passwordLowerUpperDigitSpecial$e = "Vaša lozinka mora sadržavati barem jedno malo slovo, veliko slovo, broj i poseban znak.";
const atLeastSixChar$e = "Najmanje 6 znakova.";
const forgotPassword$e = "Zaboravili ste lozinku?";
const Bysigninginyouagreetoour$e = "Prijavom se slažete s našim.";
const Terms$e = "Uvjeti";
const Conditions$e = "Uvjeti";
const and$e = "i";
const PrivacyPolicy$e = "Politika privatnosti";
const theseAreTheTopsSkillsExtracted$e = "Ovo su najvažnije vještine izdvojene iz opisa posla.";
const TopSkills$e = "Najbolje vještine";
const weCoulNotExtractSkills$e = "Nismo mogli izvući nikakve vještine iz ovog opisa posla.";
const upgradeToPremiumToView$e = "Nadogradite na Premium verziju kako biste vidjeli podudarnost vještina u vašem životopisu.";
const SkillScore$e = "Ocjena vještine";
const thisIsYourSkillScoreBasedOn$e = "Ovo je vaša ocjena vještina temeljena na opisu posla i vašem životopisu.";
const theseSkllsAreStrongMatch$e = "Ove vještine su snažno podudaranje između vašeg životopisa i opisa posla.";
const Strongmatch$e = "Snažno podudaranje";
const theseSkillsArePartialMatch$e = "Ove vještine djelomično se podudaraju između vašeg životopisa i opisa posla.";
const Partialmatch$e = "Djelomično podudaranje";
const theseSkillsAreMissingFrom$e = "Ove ključne riječi nedostaju u vašem životopisu, ali su prisutne u opisu posla. Mogu biti vještine ili opće ključne riječi koje su specifične za priliku za posao i mogu biti korisne za dodavanje u vaš životopis.";
const SkillMatchComponent$e = {
	removeSkill: "Koji je vaš glavni razlog za prijavu problema s ključnom riječi"
};
const Optional$e = "Opcionalno";
const Notrelevanttothejob$e = "Nije relevantno za posao";
const Notaskill$e = "Nema vještine";
const Toogeneric$e = "Preopćenito";
const Pleaseshareanyfeedback$e = "Podijelite bilo kakve povratne informacije";
const excludedKeywordsWillNot$e = "Isključene ključne riječi neće se računati u vašu ocjenu podudaranja za sve buduće skeniranja. Možete promijeniti isključene ključne riječi iz svog profila.";
const yesExcludeThisSkillFrom$e = "Da, isključite ovu vještinu iz svih skeniranja mog životopisa.";
const PartialMatch$e = "Djelomično podudaranje";
const MissingKeywords$e = "Nedostajući ključni pojmovi";
const Providetitletotask$e = "Navedite naslov zadatka";
const TasksList$e = "Popis zadataka";
const AddTask$e = "Dodaj zadatak";
const EnterTaskTitlehere$e = "Unesite naslov zadatka ovdje";
const TasksComponent$e = {
	listEmpty: "Popis zadataka je prazan, stvorite novi."
};
const CompletedTasks$e = "Završeni zadaci";
const CompleteYourtasks$e = "Završite svoje zadatke";
const Steps$e = "Koraci";
const PremiumMember$e = "Premium član";
const Thankyouforupgradingto$e = "Hvala vam na nadogradnji na";
const CareerflowPremium$e = "Karijerni tok Premium";
const hereIsHowYouCanAccessPremium$e = "Evo kako pristupiti svojim Premium pogodnostima!";
const stepOne$e = "Korak 1";
const DownloadourChromeExtension$e = "Preuzmite našu Chrome ekstenziju.";
const youJobSearchCopilotIshere$e = "Vaš AI suvozač u potrazi za poslom je ovdje.";
const DownloadNow$e = "Preuzmi sada";
const stepTwo$e = "Korak 2";
const GetStarted$e = "Počnite";
const stepThree$e = "Korak 3";
const SignintoChromeExtension$e = "Prijavite se u Chrome proširenje";
const entityCreated$e = "Novi {{entitet}} stvoren.";
const entityUpdated$e = "{{entitet}} ažurirano.";
const entityDeleted$e = "{{entitet}} izbrisano";
const entityLinked$e = "{{entitet}} povezan";
const entityUnlinked$e = "{{entitet}} odvojen";
const entityMovedTo$e = "Preselio/la se u {{entity}}.";
const youAddedANewEntity$e = "Dodali ste novi {{entity}}.";
const personCreated$e = "{{creator}} je stvorio {{entity}} za {{owner}}.";
const youUpdatedAEntity$e = "Ažurirali ste {{entity}}.";
const personUpdated$e = "{{creator}} je ažurirao {{entity}} za {{owner}}.";
const youDeletedAEntity$e = "Izbrisali ste {{entity}}.";
const personDeleted$e = "{{creator}} je izbrisao {{entity}} za {{owner}}.";
const youLinkedEntity$e = "Povezali ste {{entity}} s ovim poslom.";
const personLinked$e = "{{creator}} je povezao {{entity}} s ovim poslom za {{owner}}.";
const youUnlinked$e = "Otkinuli ste poveznicu {{entity}} s ovim poslom.";
const personUnlinked$e = "{{creator}} je odvezao {{entity}} od ovog posla za {{owner}}.";
const youMovedEntity$e = "Pomaknuli ste ovaj {{entity}} iz {{sectionFrom}} u {{sectionTo}}";
const personMoved$e = "{{creator}} premjestio je ovaj {{entity}} iz {{sectionFrom}} u {{sectionTo}} za {{owner}}.";
const addedByName$e = "Dodano od strane {{name}}";
const DownloadChromeExtension$e = "Preuzmite Chrome proširenje.";
const ourChromeExtensionIs$e = "Naša Chrome ekstenzija je integrirani alat koji vam pomaže optimizirati LinkedIn profil, spremiti poslove, kontakte, generirati prijavak za posao i još mnogo toga.";
const Optimizeyourprofile$e = "Optimizirajte svoj profil.";
const startOptimizingYourProfile$e = "Počnite optimizirati svoj profil kako biste imali bolje šanse da vas kontaktiraju regruteri.";
const OptimizeNow$e = "Optimiziraj sada";
const Addyourfirstjob$e = "Dodajte svoj prvi posao.";
const startSavingJobApplicationsToTrack$e = "Počnite spremati prijave za posao kako biste pratili svoje putovanje u potrazi za poslom i pronašli korisne uvide.";
const AddNow$e = "Dodaj sada";
const CompleteProfile$e = "Potpuni profil";
const completeYourProfileForUsing$e = "Dovršite svoj profil kako biste mogli koristiti funkciju automatskog popunjavanja i doživjeli još personaliziranije iskustvo.";
const CompleteNow$e = "Završi sada";
const Addyourfirstcontact$e = "Dodajte svoj prvi kontakt.";
const addContactToFollowUpWith$e = "Dodajte kontakt za kasnije praćenje, dodajte bilješke i još više.";
const JoinCommunity$e = "Pridružite se zajednici";
const ourCommunityisAlways$e = "Naša zajednica uvijek je uz vas u vašoj potrazi za poslom.";
const JoinNow$e = "Pridruži se sada";
const welcomeToCareerflow$e = "Dobrodošli u Careerflow!";
const yourHubForCareerInsights2$e = "Ovo je vaš centar za uvide u karijeru, aktivnosti i još mnogo toga. Istražite svoju personaliziranu nadzornu ploču kako biste ostali na vrhu svog profesionalnog puta.";
const ChecklistCompleted$e = "Vaša lista provjere je završena!";
const Completeyourchecklist$e = "Završite svoju kontrolnu listu";
const completeAFewStepsTo$e = "Izvršite nekoliko koraka kako biste pronašli svoj sljedeći posao.";
const Completed$e = "Završeno";
const JobCountByStage$e = "Broj poslova po fazi";
const NopastapplicationDatafound$e = "Nisu pronađeni podaci o prethodnoj aplikaciji";
const YourJobSearchStages$e = "Faze pretraživanja posla";
const NoDatafound$e = "Nema pronađenih podataka";
const hr = {
	copyToClipboard: copyToClipboard$e,
	UnlocktheAIgenerated: UnlocktheAIgenerated$e,
	UpgradetoPremium: UpgradetoPremium$e,
	Result: Result$e,
	Copy: Copy$e,
	Save: Save$e,
	Edit: Edit$e,
	Processing: Processing$e,
	YourAIgeneratedcontentwillshowhere: YourAIgeneratedcontentwillshowhere$e,
	hopeYouFindUseful: hopeYouFindUseful$e,
	regenerate: regenerate$e,
	ProvideAdditionalFeedback: ProvideAdditionalFeedback$e,
	Enteranyfeedback: Enteranyfeedback$e,
	Notimpressive: Notimpressive$e,
	thisIsntTrue: thisIsntTrue$e,
	Notpersonalized: Notpersonalized$e,
	Tone: Tone$e,
	Length: Length$e,
	Template: Template$e,
	Generatedon: Generatedon$e,
	Copiedtoclipboard: Copiedtoclipboard$e,
	CopytoClipboard: CopytoClipboard$e,
	DownloadasPDF: DownloadasPDF$e,
	ViewDetails: ViewDetails$e,
	JobDescriptionImported: JobDescriptionImported$e,
	ImportfromJob: ImportfromJob$e,
	Saved: Saved$e,
	Applied: Applied$e,
	Offer: Offer$e,
	Interviewing: Interviewing$e,
	Rejected: Rejected$e,
	Search: Search$e,
	Import: Import$e,
	CoverLetterGeneratorHistory: CoverLetterGeneratorHistory$e,
	NoCoverLettersGenerated: NoCoverLettersGenerated$e,
	getStartedCoverLetter: getStartedCoverLetter$e,
	getStarted: getStarted$e,
	Documents: Documents$e,
	UploadNewDocument: UploadNewDocument$e,
	AICoverLetterGenerator: AICoverLetterGenerator$e,
	ViewHistory: ViewHistory$e,
	JobDescription: JobDescription$e,
	ImportfromBoard: ImportfromBoard$e,
	EnterJobDescription: EnterJobDescription$e,
	JobTitle: JobTitle$e,
	EnterJobTitle: EnterJobTitle$e,
	CompanyName: CompanyName$e,
	EnterCompanyName: EnterCompanyName$e,
	YourProfile: YourProfile$e,
	ResumeUpload: ResumeUpload$e,
	UseLinkedinProfile: UseLinkedinProfile$e,
	Uploadyourresume: Uploadyourresume$e,
	AddyourResume: AddyourResume$e,
	fileNameCannotFormat: fileNameCannotFormat$e,
	ChooseorUpload: ChooseorUpload$e,
	SelectTemplate: SelectTemplate$e,
	Preview: Preview$e,
	UseTemplate: UseTemplate$e,
	Change: Change$e,
	AdvancedSettings: AdvancedSettings$e,
	AdditionalContext: AdditionalContext$e,
	Professional: Professional$e,
	Casual: Casual$e,
	Enthusiastic: Enthusiastic$e,
	Informational: Informational$e,
	Short: Short$e,
	Medium: Medium$e,
	Long: Long$e,
	Language: Language$e,
	iAmOkayBack: iAmOkayBack$e,
	Generate: Generate$e,
	CoverLetter: CoverLetter$e,
	SelectLanguage: SelectLanguage$e,
	AboutGeneratorHistory: AboutGeneratorHistory$e,
	NoAboutsGenerated: NoAboutsGenerated$e,
	getStartedAbouts: getStartedAbouts$e,
	noAttachmentsFound: noAttachmentsFound$e,
	TargetJobTitle: TargetJobTitle$e,
	KeywordsToInclude: KeywordsToInclude$e,
	UploadYourResume: UploadYourResume$e,
	AddYourResume: AddYourResume$e,
	LinkedinProfile: LinkedinProfile$e,
	Linkedinprofilenotfound: Linkedinprofilenotfound$e,
	startUsingChromeExtension: startUsingChromeExtension$e,
	Download: Download$e,
	UseEmojis: UseEmojis$e,
	UseBulletPoints: UseBulletPoints$e,
	SpeechFocus: SpeechFocus$e,
	FirstPerson: FirstPerson$e,
	ThirdPerson: ThirdPerson$e,
	HeadlineGeneratorHistory: HeadlineGeneratorHistory$e,
	NoHeadlinesGenerated: NoHeadlinesGenerated$e,
	getStartedHeadline: getStartedHeadline$e,
	AIHeadlineGenerator: AIHeadlineGenerator$e,
	KeywordstoInclude: KeywordstoInclude$e,
	Pressenteraftereachword: Pressenteraftereachword$e,
	LinkedinProfilenotfound: LinkedinProfilenotfound$e,
	Headline: Headline$e,
	PostGeneratorHistory: PostGeneratorHistory$e,
	NoPostsGenerated: NoPostsGenerated$e,
	getStartedPost: getStartedPost$e,
	Topic: Topic$e,
	Description: Description$e,
	UseHashtags: UseHashtags$e,
	Custom: Custom$e,
	EnterCustomTone: EnterCustomTone$e,
	Added: Added$e,
	ComingSoon: ComingSoon$e,
	Company: Company$e,
	JobInterview: JobInterview$e,
	Research: Research$e,
	Networking: Networking$e,
	Referral: Referral$e,
	MustbeContacted: MustbeContacted$e,
	ScheduleaMeeting: ScheduleaMeeting$e,
	needAFollowUp: needAFollowUp$e,
	Today: Today$e,
	Viewdetails: Viewdetails$e,
	Activity: Activity$e,
	ActivityDetails: ActivityDetails$e,
	Delete: Delete$e,
	Title: Title$e,
	Goal: Goal$e,
	Status: Status$e,
	FollowUp: FollowUp$e,
	AddActivity: AddActivity$e,
	Enteractivitytitle: Enteractivitytitle$e,
	Cancel: Cancel$e,
	SaveActivity: SaveActivity$e,
	noActivityPresent: noActivityPresent$e,
	Addnew: Addnew$e,
	About: About$e,
	noDataPresentYou: noDataPresentYou$e,
	Experience: Experience$e,
	Education: Education$e,
	Skills: Skills$e,
	Overview: Overview$e,
	LinkedJobs: LinkedJobs$e,
	Notes: Notes$e,
	FullName: FullName$e,
	Location: Location$e,
	Relationship: Relationship$e,
	Contacts: Contacts$e,
	CreateContact: CreateContact$e,
	NotesCreated: NotesCreated$e,
	Notesupdated: Notesupdated$e,
	Addnote: Addnote$e,
	areYouSureDeleteNote: areYouSureDeleteNote$e,
	Createdby: Createdby$e,
	notSureWhyResumeCalls: notSureWhyResumeCalls$e,
	getExpertResumeReview: getExpertResumeReview$e,
	youHaventAddedContacts: youHaventAddedContacts$e,
	noMatchingContacts: noMatchingContacts$e,
	Link: Link$e,
	unlink: unlink$e,
	Locationnotavailable: Locationnotavailable$e,
	Emailnotavailable: Emailnotavailable$e,
	PhoneNumbernotavailable: PhoneNumbernotavailable$e,
	createdby: createdby$e,
	areYouSureDeleteContact: areYouSureDeleteContact$e,
	areYouSureUnlinkContact: areYouSureUnlinkContact$e,
	Addedbyyou: Addedbyyou$e,
	Addedby: Addedby$e,
	Timeline: Timeline$e,
	Timelineempty: Timelineempty$e,
	Discard: Discard$e,
	SaveContact: SaveContact$e,
	Recruiter: Recruiter$e,
	Candidate: Candidate$e,
	Colleague: Colleague$e,
	Employee: Employee$e,
	"Needtofollow-up": "Potrebno je pratiti",
	EnterValidEmail: EnterValidEmail$e,
	EnterValidPhoneNumber: EnterValidPhoneNumber$e,
	editingProfileNotAvailable: editingProfileNotAvailable$e,
	itWillBeSoonAvailable: itWillBeSoonAvailable$e,
	ChromeExtension: ChromeExtension$e,
	SelectTag: SelectTag$e,
	FirstName: FirstName$e,
	FirstNameisrequired: FirstNameisrequired$e,
	LastName: LastName$e,
	LastNameisrequired: LastNameisrequired$e,
	Companyisrequired: Companyisrequired$e,
	Email: Email$e,
	ThisisnotavalidEmail: ThisisnotavalidEmail$e,
	AddEmail: AddEmail$e,
	PhoneNumber: PhoneNumber$e,
	notaValidPhone: notaValidPhone$e,
	phoneNoMinimum5char: phoneNoMinimum5char$e,
	phoneNoMinumum15char: phoneNoMinumum15char$e,
	AddPhoneNumber: AddPhoneNumber$e,
	SelectGoal: SelectGoal$e,
	SelectStatus: SelectStatus$e,
	Followup: Followup$e,
	SocialMedia: SocialMedia$e,
	Linkedinhandle: Linkedinhandle$e,
	Twitterhandle: Twitterhandle$e,
	Facebookhandle: Facebookhandle$e,
	Githubhandle: Githubhandle$e,
	Gmailhandle: Gmailhandle$e,
	Changessavedsuccessfully: Changessavedsuccessfully$e,
	EditContact: EditContact$e,
	BasicInformation: BasicInformation$e,
	EditContactDetails: EditContactDetails$e,
	SaveChanges: SaveChanges$e,
	phoneNoMinimum14char: phoneNoMinimum14char$e,
	LinkedIn: LinkedIn$e,
	Twitter: Twitter$e,
	Facebook: Facebook$e,
	Github: Github$e,
	Gmail: Gmail$e,
	youCanWriteAbout: youCanWriteAbout$e,
	Addednewsection: Addednewsection$e,
	Removedsuccessfully: Removedsuccessfully$e,
	Remove: Remove$e,
	Institute: Institute$e,
	Schoolisrequired: Schoolisrequired$e,
	Degree: Degree$e,
	StartMonth: StartMonth$e,
	StartYear: StartYear$e,
	EndMonth: EndMonth$e,
	EndYear: EndYear$e,
	Addmore: Addmore$e,
	PositionTitle: PositionTitle$e,
	ExperienceType: ExperienceType$e,
	Addednewitem: Addednewitem$e,
	whatSkillsDoYouEnjoy: whatSkillsDoYouEnjoy$e,
	Typeskillshere: Typeskillshere$e,
	LinkedContacts: LinkedContacts$e,
	LinkContact: LinkContact$e,
	NocontactsLinked: NocontactsLinked$e,
	JobContactsComponent: JobContactsComponent$e,
	Nocontacts: Nocontacts$e,
	LinkJobto: LinkJobto$e,
	Contact: Contact$e,
	Document: Document$e,
	Nojobsfound: Nojobsfound$e,
	LinkJob: LinkJob$e,
	youCanLinkContactJobImported: youCanLinkContactJobImported$e,
	Prev: Prev$e,
	Next: Next$e,
	areYouSureUnlinkDocument: areYouSureUnlinkDocument$e,
	areYouSureDeleteDocument: areYouSureDeleteDocument$e,
	Category: Category$e,
	CreatedOn: CreatedOn$e,
	Joblinked: Joblinked$e,
	Quickactions: Quickactions$e,
	All: All$e,
	Resume: Resume$e,
	Portfolio: Portfolio$e,
	Other: Other$e,
	Adddocument: Adddocument$e,
	Type: Type$e,
	Sortingby: Sortingby$e,
	SwitchtoGridLayout: SwitchtoGridLayout$e,
	SwitchtoListLayout: SwitchtoListLayout$e,
	NoDocumentsAdded: NoDocumentsAdded$e,
	DocumentsComponent: DocumentsComponent$e,
	NoDocumentFound: NoDocumentFound$e,
	SelectFile: SelectFile$e,
	onlyPdfDocxSupported: onlyPdfDocxSupported$e,
	Uploadfile: Uploadfile$e,
	DocumentCategory: DocumentCategory$e,
	SaveDocument: SaveDocument$e,
	AddDocument: AddDocument$e,
	LinkedDocuments: LinkedDocuments$e,
	LinkDocument: LinkDocument$e,
	NodocumentsLinked: NodocumentsLinked$e,
	JobDocumentsComponent: JobDocumentsComponent$e,
	NoDocuments: NoDocuments$e,
	CreateDocuments: CreateDocuments$e,
	youCanLinkDocumentJobImported: youCanLinkDocumentJobImported$e,
	Documenteditedsuccessfully: Documenteditedsuccessfully$e,
	DocumentDetails: DocumentDetails$e,
	UnsavedChanges: UnsavedChanges$e,
	yourChangesWillBeLostSureClose: yourChangesWillBeLostSureClose$e,
	yourChangesWillBeLostSureDiscard: yourChangesWillBeLostSureDiscard$e,
	DiscardChanges: DiscardChanges$e,
	WeeklyGoalAlert: WeeklyGoalAlert$e,
	Progress: Progress$e,
	AllGoals: AllGoals$e,
	Name: Name$e,
	Completedon: Completedon$e,
	Createdon: Createdon$e,
	Action: Action$e,
	Back: Back$e,
	OverallScore: OverallScore$e,
	Aboutthegoal: Aboutthegoal$e,
	GoalTracking: GoalTracking$e,
	Week: Week$e,
	progress: progress$e,
	loading: loading$e,
	Apply: Apply$e,
	Thisskillhasbeenreported: Thisskillhasbeenreported$e,
	issueGettingResume: issueGettingResume$e,
	Interview: Interview$e,
	Tasks: Tasks$e,
	Loading: Loading$e,
	Skilladdedsuccessfully: Skilladdedsuccessfully$e,
	problemAddingSkill: problemAddingSkill$e,
	Reportaproblem: Reportaproblem$e,
	Submit: Submit$e,
	Addanewskill: Addanewskill$e,
	JobDetailsComponent: JobDetailsComponent$e,
	HardSkill: HardSkill$e,
	SoftSkill: SoftSkill$e,
	Pleaseshareanyadditionalcontext: Pleaseshareanyadditionalcontext$e,
	Addasskill: Addasskill$e,
	Skill: Skill$e,
	JobFrequency: JobFrequency$e,
	ResumeFrequency: ResumeFrequency$e,
	Reportskill: Reportskill$e,
	JobDetails: JobDetails$e,
	ViewJobLink: ViewJobLink$e,
	Salary: Salary$e,
	areYouSureDeleteJob: areYouSureDeleteJob$e,
	ViewMore: ViewMore$e,
	ViewLess: ViewLess$e,
	matchYouSkillsAgainstJob: matchYouSkillsAgainstJob$e,
	pleaseUploadResumeSkillMatch: pleaseUploadResumeSkillMatch$e,
	AddResume: AddResume$e,
	thisJobDoesNotHaveAnyDesc: thisJobDoesNotHaveAnyDesc$e,
	youCanEditJobToAdd: youCanEditJobToAdd$e,
	chromeextension: chromeextension$e,
	fromVariousJobPortalsOnce: fromVariousJobPortalsOnce$e,
	AddDescription: AddDescription$e,
	CompanyInfo: CompanyInfo$e,
	Website: Website$e,
	Industry: Industry$e,
	EmployeeCount: EmployeeCount$e,
	ExprienceLevel: ExprienceLevel$e,
	Address: Address$e,
	Resumes: Resumes$e,
	Setasdefault: Setasdefault$e,
	Ok: Ok$e,
	UploadNewResume: UploadNewResume$e,
	Default: Default$e,
	Jobnotfound: Jobnotfound$e,
	EditDetails: EditDetails$e,
	JobPostURL: JobPostURL$e,
	Enterjoburl: Enterjoburl$e,
	Nojobselected: Nojobselected$e,
	Viewjobdetails: Viewjobdetails$e,
	Jobaddedtoyourboardsuccessfully: Jobaddedtoyourboardsuccessfully$e,
	AddJob: AddJob$e,
	Addnewjobname: Addnewjobname$e,
	JobUrl: JobUrl$e,
	Addjoburl: Addjoburl$e,
	Section: Section$e,
	didYouKnow: didYouKnow$e,
	Jobs: Jobs$e,
	AddJobtoboard: AddJobtoboard$e,
	Currentlynojobsareavailable: Currentlynojobsareavailable$e,
	noMatchingJobs: noMatchingJobs$e,
	welcomeToYourPersonalJobTracker: welcomeToYourPersonalJobTracker$e,
	weShortTutorialOnHowTrackingJob: weShortTutorialOnHowTrackingJob$e,
	Addanewjob: Addanewjob$e,
	inOrderTrackCreatButton: inOrderTrackCreatButton$e,
	Providesomedetails: Providesomedetails$e,
	toBeginTypeJobTitleCompany: toBeginTypeJobTitleCompany$e,
	asAnExampleFilledForYou: asAnExampleFilledForYou$e,
	wohooAddedFirstJob: wohooAddedFirstJob$e,
	youCanDragDropJobCard: youCanDragDropJobCard$e,
	Lastbutnotleast: Lastbutnotleast$e,
	finalStepMakeSure: finalStepMakeSure$e,
	autoMaticallyImportJobs: autoMaticallyImportJobs$e,
	selectanysection: selectanysection$e,
	Accept: Accept$e,
	My2023JobSearch: My2023JobSearch$e,
	AddedFrom: AddedFrom$e,
	AddedUntil: AddedUntil$e,
	BasicModal: BasicModal$e,
	AddnewSectionName: AddnewSectionName$e,
	OpenTo: OpenTo$e,
	Featured: Featured$e,
	LicenceAndCerts: LicenceAndCerts$e,
	Banner: Banner$e,
	LinkedInURL: LinkedInURL$e,
	Recommendations: Recommendations$e,
	LinkedinReview: LinkedinReview$e,
	NoDataAvailable: NoDataAvailable$e,
	looksLikeYouDidNot: looksLikeYouDidNot$e,
	toOptimizeProfileScoreVisible: toOptimizeProfileScoreVisible$e,
	LinkedinComponent: LinkedinComponent$e,
	improveYourChancesLandingDreamJob: improveYourChancesLandingDreamJob$e,
	VisitProfile: VisitProfile$e,
	wantToGetLinkedinMakeover: wantToGetLinkedinMakeover$e,
	PostGenerator: PostGenerator$e,
	LinkedinHeadlineGenerator: LinkedinHeadlineGenerator$e,
	LinkedinAboutSectionGenerator: LinkedinAboutSectionGenerator$e,
	AITools: AITools$e,
	Premium: Premium$e,
	LinkedInOptimization: LinkedInOptimization$e,
	JobTracker: JobTracker$e,
	whoIsHiring: whoIsHiring$e,
	Autofill: Autofill$e,
	HeadlineGenerator: HeadlineGenerator$e,
	skillMatching: skillMatching$e,
	SummarizeJD: SummarizeJD$e,
	contactFeature: contactFeature$e,
	documentFeature: documentFeature$e,
	landJobWithoutStress: landJobWithoutStress$e,
	discoverFeatures: discoverFeatures$e,
	letsBeginOnboarding: letsBeginOnboarding$e,
	inTheNextFewScreensJobThirdParties: inTheNextFewScreensJobThirdParties$e,
	letsAddBasicInformation: letsAddBasicInformation$e,
	Pleaseselectanoptionfirst: Pleaseselectanoptionfirst$e,
	JobApplicationTracker: JobApplicationTracker$e,
	LinkedInProfileOptimizer: LinkedInProfileOptimizer$e,
	UnlimitedDocuments: UnlimitedDocuments$e,
	UnlimitedContacts: UnlimitedContacts$e,
	HiringManagerSearch: HiringManagerSearch$e,
	AILinkedInPostGenerator: AILinkedInPostGenerator$e,
	ATSKeywordSkillMatch: ATSKeywordSkillMatch$e,
	"Auto-Apply": "Automatska primjena",
	ChooseyourPlan: ChooseyourPlan$e,
	superChargeYourJobSearch: superChargeYourJobSearch$e,
	startNowGoto: startNowGoto$e,
	CreatedBy: CreatedBy$e,
	CreateNewNote: CreateNewNote$e,
	Nonotescreated: Nonotescreated$e,
	approxTimeIsFourMinutes: approxTimeIsFourMinutes$e,
	Continue: Continue$e,
	iWillDoLaterTakeMeToApp: iWillDoLaterTakeMeToApp$e,
	allDone: allDone$e,
	welcomeAbord: welcomeAbord$e,
	letsBegin: letsBegin$e,
	UpgradeyourplanandgetAIAssistance: UpgradeyourplanandgetAIAssistance$e,
	DownloadPDF: DownloadPDF$e,
	oopsWeCouldntProcessResume: oopsWeCouldntProcessResume$e,
	MyProfile: MyProfile$e,
	Setting: Setting$e,
	Logout: Logout$e,
	SignIn: SignIn$e,
	Typeyourfirstnamehere: Typeyourfirstnamehere$e,
	Enteryourlastname: Enteryourlastname$e,
	ManageSubscription: ManageSubscription$e,
	ifYouHaveDifficultiesProfile: ifYouHaveDifficultiesProfile$e,
	forSupport: forSupport$e,
	whatIsIdealCompanySize: whatIsIdealCompanySize$e,
	Saveandcontinue: Saveandcontinue$e,
	whatIsMinExpectedSalary: whatIsMinExpectedSalary$e,
	Atleast: Atleast$e,
	SlidetoAdjust: SlidetoAdjust$e,
	whatIndustryExcitedWork: whatIndustryExcitedWork$e,
	Add: Add$e,
	statusOfJobSearch: statusOfJobSearch$e,
	Finish: Finish$e,
	whatLevelRoleLooking: whatLevelRoleLooking$e,
	Selectuptotwo: Selectuptotwo$e,
	PreviousStep: PreviousStep$e,
	Skip: Skip$e,
	whatDoYouValueNewRole: whatDoYouValueNewRole$e,
	Selectuptothree: Selectuptothree$e,
	EqualEmploymentData: EqualEmploymentData$e,
	whatIsYourEthnicity: whatIsYourEthnicity$e,
	areYouAuthorizedToWorkUs: areYouAuthorizedToWorkUs$e,
	willYouRequireSponsorShip: willYouRequireSponsorShip$e,
	doYouHaveADisability: doYouHaveADisability$e,
	areYouAVeteran: areYouAVeteran$e,
	rolesYouInterestedIn: rolesYouInterestedIn$e,
	Selectuptofive: Selectuptofive$e,
	AddCustomrole: AddCustomrole$e,
	whereDoYouLikeWork: whereDoYouLikeWork$e,
	Resources: Resources$e,
	currentlyNoResourceAvailable: currentlyNoResourceAvailable$e,
	AddNewSection: AddNewSection$e,
	ChangeSections: ChangeSections$e,
	Settings: Settings$e,
	Dashboard: Dashboard$e,
	JobBoard: JobBoard$e,
	Linkedin: Linkedin$e,
	Community: Community$e,
	FindRecruiters: FindRecruiters$e,
	Goals: Goals$e,
	DownloadExtension: DownloadExtension$e,
	SuggestaFeature: SuggestaFeature$e,
	leftPanel: leftPanel$e,
	PhoneNumberisrequired: PhoneNumberisrequired$e,
	MobileNumber: MobileNumber$e,
	Enteronlynumbers: Enteronlynumbers$e,
	Countryyoulivein: Countryyoulivein$e,
	SelectaCountry: SelectaCountry$e,
	DateofBirth: DateofBirth$e,
	Gender: Gender$e,
	JobPreferences: JobPreferences$e,
	pleaseEnterValidEmail: pleaseEnterValidEmail$e,
	emailSendForResetting: emailSendForResetting$e,
	VerifyyourEmailID: VerifyyourEmailID$e,
	sentPleaseCheckEmail: sentPleaseCheckEmail$e,
	tooManyAttemptsTryAgain: tooManyAttemptsTryAgain$e,
	Resend: Resend$e,
	Login: Login$e,
	weHaveSentVerificationLinkAtEmail: weHaveSentVerificationLinkAtEmail$e,
	pleaseVerifyEmailContinueSpam: pleaseVerifyEmailContinueSpam$e,
	Logintogetstarted: Logintogetstarted$e,
	ContinuewithGoogle: ContinuewithGoogle$e,
	pleaseInputEmail: pleaseInputEmail$e,
	Password: Password$e,
	pleaseInputPassword: pleaseInputPassword$e,
	passwordLowerUpperDigitSpecial: passwordLowerUpperDigitSpecial$e,
	atLeastSixChar: atLeastSixChar$e,
	forgotPassword: forgotPassword$e,
	Bysigninginyouagreetoour: Bysigninginyouagreetoour$e,
	Terms: Terms$e,
	Conditions: Conditions$e,
	and: and$e,
	PrivacyPolicy: PrivacyPolicy$e,
	theseAreTheTopsSkillsExtracted: theseAreTheTopsSkillsExtracted$e,
	TopSkills: TopSkills$e,
	weCoulNotExtractSkills: weCoulNotExtractSkills$e,
	upgradeToPremiumToView: upgradeToPremiumToView$e,
	SkillScore: SkillScore$e,
	thisIsYourSkillScoreBasedOn: thisIsYourSkillScoreBasedOn$e,
	theseSkllsAreStrongMatch: theseSkllsAreStrongMatch$e,
	Strongmatch: Strongmatch$e,
	theseSkillsArePartialMatch: theseSkillsArePartialMatch$e,
	Partialmatch: Partialmatch$e,
	theseSkillsAreMissingFrom: theseSkillsAreMissingFrom$e,
	"Missing Keywords": "Nedostajuće ključne riječi",
	SkillMatchComponent: SkillMatchComponent$e,
	Optional: Optional$e,
	Notrelevanttothejob: Notrelevanttothejob$e,
	Notaskill: Notaskill$e,
	Toogeneric: Toogeneric$e,
	Pleaseshareanyfeedback: Pleaseshareanyfeedback$e,
	excludedKeywordsWillNot: excludedKeywordsWillNot$e,
	yesExcludeThisSkillFrom: yesExcludeThisSkillFrom$e,
	PartialMatch: PartialMatch$e,
	MissingKeywords: MissingKeywords$e,
	Providetitletotask: Providetitletotask$e,
	TasksList: TasksList$e,
	AddTask: AddTask$e,
	EnterTaskTitlehere: EnterTaskTitlehere$e,
	TasksComponent: TasksComponent$e,
	CompletedTasks: CompletedTasks$e,
	CompleteYourtasks: CompleteYourtasks$e,
	Steps: Steps$e,
	PremiumMember: PremiumMember$e,
	Thankyouforupgradingto: Thankyouforupgradingto$e,
	CareerflowPremium: CareerflowPremium$e,
	hereIsHowYouCanAccessPremium: hereIsHowYouCanAccessPremium$e,
	stepOne: stepOne$e,
	DownloadourChromeExtension: DownloadourChromeExtension$e,
	youJobSearchCopilotIshere: youJobSearchCopilotIshere$e,
	DownloadNow: DownloadNow$e,
	stepTwo: stepTwo$e,
	GetStarted: GetStarted$e,
	stepThree: stepThree$e,
	SignintoChromeExtension: SignintoChromeExtension$e,
	entityCreated: entityCreated$e,
	entityUpdated: entityUpdated$e,
	entityDeleted: entityDeleted$e,
	entityLinked: entityLinked$e,
	entityUnlinked: entityUnlinked$e,
	entityMovedTo: entityMovedTo$e,
	youAddedANewEntity: youAddedANewEntity$e,
	personCreated: personCreated$e,
	youUpdatedAEntity: youUpdatedAEntity$e,
	personUpdated: personUpdated$e,
	youDeletedAEntity: youDeletedAEntity$e,
	personDeleted: personDeleted$e,
	youLinkedEntity: youLinkedEntity$e,
	personLinked: personLinked$e,
	youUnlinked: youUnlinked$e,
	personUnlinked: personUnlinked$e,
	youMovedEntity: youMovedEntity$e,
	personMoved: personMoved$e,
	addedByName: addedByName$e,
	DownloadChromeExtension: DownloadChromeExtension$e,
	ourChromeExtensionIs: ourChromeExtensionIs$e,
	Optimizeyourprofile: Optimizeyourprofile$e,
	startOptimizingYourProfile: startOptimizingYourProfile$e,
	OptimizeNow: OptimizeNow$e,
	Addyourfirstjob: Addyourfirstjob$e,
	startSavingJobApplicationsToTrack: startSavingJobApplicationsToTrack$e,
	AddNow: AddNow$e,
	CompleteProfile: CompleteProfile$e,
	completeYourProfileForUsing: completeYourProfileForUsing$e,
	CompleteNow: CompleteNow$e,
	Addyourfirstcontact: Addyourfirstcontact$e,
	addContactToFollowUpWith: addContactToFollowUpWith$e,
	JoinCommunity: JoinCommunity$e,
	ourCommunityisAlways: ourCommunityisAlways$e,
	JoinNow: JoinNow$e,
	welcomeToCareerflow: welcomeToCareerflow$e,
	yourHubForCareerInsights2: yourHubForCareerInsights2$e,
	ChecklistCompleted: ChecklistCompleted$e,
	Completeyourchecklist: Completeyourchecklist$e,
	completeAFewStepsTo: completeAFewStepsTo$e,
	Completed: Completed$e,
	JobCountByStage: JobCountByStage$e,
	NopastapplicationDatafound: NopastapplicationDatafound$e,
	YourJobSearchStages: YourJobSearchStages$e,
	NoDatafound: NoDatafound$e
};

const copyToClipboard$d = "Másolva a vágólapra!";
const UnlocktheAIgenerated$d = "Oldd fel az AI által generáltakat";
const UpgradetoPremium$d = "Feliratkozás Prémiumra";
const Result$d = "Eredmény";
const Copy$d = "Másolás";
const Save$d = "Mentés";
const Edit$d = "Szerkesztés";
const Processing$d = "Feldolgozás";
const YourAIgeneratedcontentwillshowhere$d = "Az AI-generált tartalom itt fog megjelenni";
const hopeYouFindUseful$d = "Remélem, hasznosnak találod ezt az eredményt!";
const regenerate$d = "Újragenerálás";
const ProvideAdditionalFeedback$d = "További visszajelzés megadása";
const Enteranyfeedback$d = "Adjon meg bármilyen visszajelzést";
const Notimpressive$d = "Nem lenyűgöző";
const thisIsntTrue$d = "Ez nem igaz";
const Notpersonalized$d = "Nem személyre szabott";
const Tone$d = "Stílus";
const Length$d = "Hosszúság";
const Template$d = "Sablon";
const Generatedon$d = "Generálva:";
const Copiedtoclipboard$d = "Másolva a vágólapra";
const CopytoClipboard$d = "Másolás a vágólapra";
const DownloadasPDF$d = "Letöltés PDF-ként";
const ViewDetails$d = "Részletek megtekintése";
const JobDescriptionImported$d = "Munkaköri leírás importálva";
const ImportfromJob$d = "Munkából importálás";
const Saved$d = "Mentve";
const Applied$d = "Jelentkezve";
const Offer$d = "Ajánlat";
const Interviewing$d = "Interjúkészítés";
const Rejected$d = "Elutasítva";
const Search$d = "Keresés";
const Import$d = "Importálás";
const CoverLetterGeneratorHistory$d = "Motivációs levél generátor előzményei";
const NoCoverLettersGenerated$d = "Nincs generált motivációs levél";
const getStartedCoverLetter$d = "Még nem generáltál motivációs levelet. Kezdd el a releváns tapasztalatod alapján a munkaleírásokkal való egyeztetést, hogy létrehozhass motivációs leveleket.";
const getStarted$d = "Kezdés!";
const Documents$d = "Dokumentumok";
const UploadNewDocument$d = "Új dokumentum feltöltése";
const AICoverLetterGenerator$d = "MI motivációs levél generátor";
const ViewHistory$d = "Előzmények megtekintése";
const JobDescription$d = "Munkaleírás";
const ImportfromBoard$d = "Importálás a tábláról";
const EnterJobDescription$d = "Írd be a munkaleírást";
const JobTitle$d = "Munkakör";
const EnterJobTitle$d = "Írd be a munkakört";
const CompanyName$d = "Cég neve";
const EnterCompanyName$d = "Írd be a cég nevét";
const YourProfile$d = "Profilod";
const ResumeUpload$d = "Önéletrajz feltöltése";
const UseLinkedinProfile$d = "LinkedIn profil használata";
const Uploadyourresume$d = "Önéletrajz feltöltése";
const AddyourResume$d = "Önéletrajz hozzáadása";
const fileNameCannotFormat$d = "A fájlnevek nem tartalmazhatnak szóközt vagy aláhúzást, és csak .doc, .docx vagy .pdf formátumban lehetnek.";
const ChooseorUpload$d = "Válassz vagy tölts fel";
const SelectTemplate$d = "Sablon kiválasztása";
const Preview$d = "Előnézet";
const UseTemplate$d = "Sablon használata";
const Change$d = "Módosítás";
const AdvancedSettings$d = "Speciális beállítások";
const AdditionalContext$d = "További összefüggések";
const Professional$d = "Professzionális";
const Casual$d = "Laza";
const Enthusiastic$d = "Lendületes";
const Informational$d = "Informatív";
const Short$d = "Rövid";
const Medium$d = "Közepes";
const Long$d = "Hosszú";
const Language$d = "Nyelv";
const iAmOkayBack$d = "Rendben vagyok! Vissza";
const Generate$d = "Generálás";
const CoverLetter$d = "Motivációs levél";
const SelectLanguage$d = "Nyelv kiválasztása";
const AboutGeneratorHistory$d = "Bemutatkozás generátor előzményei";
const NoAboutsGenerated$d = "Nincs generált bemutatkozás";
const getStartedAbouts$d = "Még nem generáltál bemutatkozást. Kezdd el a releváns tapasztalatod alapján a munkaleírásokkal való egyeztetést, hogy létrehozhass bemutatkozásokat.";
const noAttachmentsFound$d = "Nincsenek mellékletek.";
const TargetJobTitle$d = "Cél munkakör";
const KeywordsToInclude$d = "Beleértendő kulcsszavak";
const UploadYourResume$d = "Töltsd fel az önéletrajzodat";
const AddYourResume$d = "Adj hozzá az önéletrajzodat";
const LinkedinProfile$d = "LinkedIn profil";
const Linkedinprofilenotfound$d = "LinkedIn profil nem található";
const startUsingChromeExtension$d = "Kezdd el optimalizálni LinkedIn profilodat Chrome kiterjesztésünk segítségével, hogy használhasd ezt az opciót.";
const Download$d = "Letöltés";
const UseEmojis$d = "Emojik használata";
const UseBulletPoints$d = "Pontozás használata";
const SpeechFocus$d = "Beszéd középpontja";
const FirstPerson$d = "Első személy";
const ThirdPerson$d = "Harmadik személy";
const HeadlineGeneratorHistory$d = "Cím generátor előzményei";
const NoHeadlinesGenerated$d = "Nincs generált cím";
const getStartedHeadline$d = "Még nem generáltál címet. Kezdd el a releváns tapasztalatod alapján a munkaleírásokkal való egyeztetést, hogy létrehozhass címeket.";
const AIHeadlineGenerator$d = "MI cím generátor";
const KeywordstoInclude$d = "Beleértendő kulcsszavak";
const Pressenteraftereachword$d = "Üssön entert minden szó után";
const LinkedinProfilenotfound$d = "A LinkedIn profil nem található";
const Headline$d = "Cím";
const PostGeneratorHistory$d = "Poszt generátor előzményei";
const NoPostsGenerated$d = "Nincs generált poszt";
const getStartedPost$d = "Még nem generáltál posztot. Kezdd el a releváns tapasztalatod alapján a munkaleírásokkal való egyeztetést, hogy létrehozhass posztokat.";
const Topic$d = "Téma";
const Description$d = "Leírás";
const UseHashtags$d = "Hashtagek használata";
const Custom$d = "Egyedi";
const EnterCustomTone$d = "Egyedi stílus megadása";
const Added$d = "Hozzáadva";
const ComingSoon$d = {
	header: "Mérnökök dolgoznak!",
	content_1: "Mérnökcsapatunk keményen dolgozik, hogy mihamarabb működésbe hozza ezt a funkciót.",
	content_2: "Szeretnéd ezt a funkciót hamarosan? Tájékoztass minket egyszerűen az alábbi négyzetről való jelöléssel.",
	content_3: "Szeretném ezt a funkciót"
};
const Company$d = "Cég";
const JobInterview$d = "Állásinterjú";
const Research$d = "Kutatás";
const Networking$d = "Hálózatépítés";
const Referral$d = "Ajánlás";
const MustbeContacted$d = "Kapcsolatba kell lépni";
const ScheduleaMeeting$d = "Találkozó időpontjának megszervezése";
const needAFollowUp$d = "Követni kell";
const Today$d = "Ma";
const Viewdetails$d = "Részletek megtekintése";
const Activity$d = "Tevékenység";
const ActivityDetails$d = "Tevékenység részletei";
const Delete$d = "Törlés";
const Title$d = "Cím";
const Goal$d = "Cél";
const Status$d = "Állapot";
const FollowUp$d = "Követés";
const AddActivity$d = "Tevékenység hozzáadása";
const Enteractivitytitle$d = "Adja meg a tevékenység címét";
const Cancel$d = "Mégse";
const SaveActivity$d = "Tevékenység mentése";
const noActivityPresent$d = "Nincs tevékenység jelen, adj hozzá tevékenységet.";
const Addnew$d = "Új hozzáadása";
const About$d = "Rólam";
const noDataPresentYou$d = "Nincs adat jelen, szerkesztheti ezt a kapcsolatot és hozzáadhat mezőket.";
const Experience$d = "Tapasztalat";
const Education$d = "Oktatás";
const Skills$d = "Készségek";
const Overview$d = "Áttekintés";
const LinkedJobs$d = "Kapcsolt állások";
const Notes$d = "Jegyzetek";
const FullName$d = "Teljes név";
const Location$d = "Helyszín";
const Relationship$d = "Kapcsolat";
const Contacts$d = "Kapcsolatok";
const CreateContact$d = "Kapcsolat létrehozása";
const NotesCreated$d = "Jegyzetek létrehozva";
const Notesupdated$d = "Jegyzetek frissítve";
const Addnote$d = "Jegyzet hozzáadása";
const areYouSureDeleteNote$d = "Biztosan törölni szeretné ezt a jegyzetet?";
const Createdby$d = "Készítette";
const notSureWhyResumeCalls$d = "Nem biztos benne, hogy miért nem hívják be az állásinterjúkra az önéletrajzát? ☎️";
const getExpertResumeReview$d = "Szerezzen szakértői önéletrajz-értékelést 💎✨";
const youHaventAddedContacts$d = "Még nem adtál hozzá egyetlen kapcsolatot sem.";
const noMatchingContacts$d = "Nincs találat a megfelelő kapcsolatok között.";
const Link$d = "Hivatkozás";
const unlink$d = "Szétcsatolás";
const Locationnotavailable$d = "Hely nem elérhető";
const Emailnotavailable$d = "Az e-mail nem elérhető";
const PhoneNumbernotavailable$d = "A telefonszám nem elérhető";
const createdby$d = "létrehozta";
const areYouSureDeleteContact$d = "Biztosan törölni szeretné ezt a kapcsolatot?";
const areYouSureUnlinkContact$d = "Biztosan szét szeretné csatolni ezt a kapcsolatot?";
const Addedbyyou$d = "Hozzáadva általad";
const Addedby$d = "Hozzáadva:";
const Timeline$d = "Idővonal";
const Timelineempty$d = "Idővonal üres";
const Discard$d = "Elvetés";
const SaveContact$d = "Mentés kapcsolatba";
const Recruiter$d = "Személyzeti tanácsadó";
const Candidate$d = "Jelölt";
const Colleague$d = "Kolléga";
const Employee$d = "Munkavállaló";
const EnterValidEmail$d = "Érvényes e-mail cím megadása";
const EnterValidPhoneNumber$d = "Érvényes telefonszám megadása";
const editingProfileNotAvailable$d = "A profilfotó szerkesztése még nem elérhető.";
const itWillBeSoonAvailable$d = "Hamarosan elérhető lesz nálunk.";
const ChromeExtension$d = "Chrome bővítmény";
const SelectTag$d = "Válassza ki a címkét";
const FirstName$d = "Keresztnév";
const FirstNameisrequired$d = "A keresztnév megadása kötelező";
const LastName$d = "Vezetéknév";
const LastNameisrequired$d = "A vezetéknév megadása kötelező";
const Companyisrequired$d = "A cég szükséges";
const Email$d = "E-mail";
const ThisisnotavalidEmail$d = "Ez nem érvényes e-mail cím.";
const AddEmail$d = "E-mail hozzáadása";
const PhoneNumber$d = "Telefonszám";
const notaValidPhone$d = "Ez nem érvényes telefonszám. Csak számokat írjon be.";
const phoneNoMinimum5char$d = "A telefonszámnak legalább 5 karakter hosszúnak kell lennie.";
const phoneNoMinumum15char$d = "A telefonszám legfeljebb 15 karakter lehet.";
const AddPhoneNumber$d = "Telefonszám hozzáadása";
const SelectGoal$d = "Cél kiválasztása";
const SelectStatus$d = "Állapot kiválasztása";
const Followup$d = "Követés";
const SocialMedia$d = "Társadalmi média";
const Linkedinhandle$d = "Linkedin felhasználónév";
const Twitterhandle$d = "Twitter kezelő";
const Facebookhandle$d = "Facebook kezelő";
const Githubhandle$d = "Github kezelő";
const Gmailhandle$d = "Gmail kezelő";
const Changessavedsuccessfully$d = "A változtatások sikeresen mentve";
const EditContact$d = "Kapcsolat szerkesztése";
const BasicInformation$d = "Alapinformáció";
const EditContactDetails$d = "Személyes adatok szerkesztése";
const SaveChanges$d = "Változtatások mentése";
const phoneNoMinimum14char$d = "A telefonszámnak legalább 14 karakter hosszúnak kell lennie.";
const LinkedIn$d = "LinkedIn";
const Twitter$d = "Twitter";
const Facebook$d = "Facebook";
const Github$d = "Github";
const Gmail$d = "Gmail";
const youCanWriteAbout$d = "Írhat a tapasztalatairól, az iparágról vagy a készségeiről. Az emberek beszélnek az eredményeikről vagy korábbi munkatapasztalataikról is.";
const Addednewsection$d = "Hozzáadott új szakasz";
const Removedsuccessfully$d = "Sikeresen eltávolítva";
const Remove$d = "Eltávolítás";
const Institute$d = "Intézet";
const Schoolisrequired$d = "Az iskola kötelező";
const Degree$d = "Fokozat";
const StartMonth$d = "Kezdő hónap";
const StartYear$d = "Kezdés éve";
const EndMonth$d = "Hónap vége";
const EndYear$d = "Év vége";
const Addmore$d = "További hozzáadása";
const PositionTitle$d = "Pozíció címe";
const ExperienceType$d = "Tapasztalat típusa";
const Addednewitem$d = "Hozzáadva új elem";
const whatSkillsDoYouEnjoy$d = "Milyen képességeid vannak, vagy milyen munkával szeretsz foglalkozni?";
const Typeskillshere$d = "Írja be itt a készségeit";
const LinkedContacts$d = "Kapcsolt kapcsolatok";
const LinkContact$d = "Kapcsolat hozzáadása";
const NocontactsLinked$d = "Nincsenek kapcsolt kapcsolatok";
const JobContactsComponent$d = {
	linkContact: "A kapcsolatok hozzáadásával gyorsan láthatja, hogy kik azok a fontos emberek, mint például a személyzeti tanácsadó, a felvételi vezető, stb. ehhez a szerephez! A jövőben releváns információkat is felszínre hozhatunk kapcsolatai alapján."
};
const Nocontacts$d = "Nincsenek kapcsolatok";
const LinkJobto$d = "Kapcsolja össze a munkát";
const Contact$d = "Kapcsolat";
const Document$d = "Dokumentum";
const Nojobsfound$d = "Nincsenek találatok";
const LinkJob$d = "Munka kapcsolása";
const youCanLinkContactJobImported$d = "Ezt a kapcsolatot összekötheti egy olyan munkával, amelyet a Careerflow-ba importált.";
const Prev$d = "Előző";
const Next$d = "Következő";
const areYouSureUnlinkDocument$d = "Biztosan szét szeretné csatolni ezt a dokumentumot?";
const areYouSureDeleteDocument$d = "Biztosan törölni szeretné ezt a dokumentumot?";
const Category$d = "Kategória";
const CreatedOn$d = "Létrehozva";
const Joblinked$d = "Munkához kapcsolódó";
const Quickactions$d = "Gyors intézkedések";
const All$d = "Mind";
const Resume$d = "Önéletrajz";
const Portfolio$d = "Portfólió";
const Other$d = "Egyéb";
const Adddocument$d = "Dokumentum hozzáadása";
const Type$d = "Típus";
const Sortingby$d = "Rendezés szerint";
const SwitchtoGridLayout$d = "Váltás rács elrendezésre";
const SwitchtoListLayout$d = "Váltás listanézetre";
const NoDocumentsAdded$d = "Nincsenek hozzáadott dokumentumok";
const DocumentsComponent$d = {
	nodocs: "Még nem hozott létre dokumentumokat. Feltöltheti önéletrajz-verzióit, motivációs leveleit és még sok mást, majd kapcsolhatja azokat az általa követett munkákhoz!"
};
const NoDocumentFound$d = "Nincs találat";
const SelectFile$d = "Fájl kiválasztása";
const onlyPdfDocxSupported$d = "Csak .pdf és .docx formátum támogatott.";
const Uploadfile$d = "Fájl feltöltése";
const DocumentCategory$d = "Dokumentum kategória";
const SaveDocument$d = "Dokumentum mentése";
const AddDocument$d = "Dokumentum hozzáadása";
const LinkedDocuments$d = "Kapcsolt dokumentumok";
const LinkDocument$d = "Dokumentum hozzárendelése";
const NodocumentsLinked$d = "Nincsenek kapcsolt dokumentumok";
const JobDocumentsComponent$d = {
	linkDocs: "Az összes releváns dokumentum, mint például az önéletrajz, a motivációs levél stb. összekapcsolása segít nyomon követni mindent egy helyen. Próbálja ki!"
};
const NoDocuments$d = "Nincs dokumentum";
const CreateDocuments$d = "Dokumentumok létrehozása";
const youCanLinkDocumentJobImported$d = "Ezt a dokumentumot összekapcsolhatja egy olyan állással, amelyet a Careerflow-ba importált.";
const Documenteditedsuccessfully$d = "A dokumentum sikeresen szerkesztve.";
const DocumentDetails$d = "Dokumentum részletei";
const UnsavedChanges$d = "Nem mentett változtatások";
const yourChangesWillBeLostSureClose$d = "Az Ön változtatásai elvesznek, biztosan be akarja zárni?";
const yourChangesWillBeLostSureDiscard$d = "Az Ön változtatásai elvesznek, biztosan el akarja dobni a változtatásait?";
const DiscardChanges$d = "Változtatások elvetése";
const WeeklyGoalAlert$d = "Heti cél figyelmeztetés";
const Progress$d = "Fejlődés";
const AllGoals$d = "Az összes cél";
const Name$d = "Név";
const Completedon$d = "Befejezve";
const Createdon$d = "Létrehozva";
const Action$d = "Művelet";
const Back$d = "Vissza";
const OverallScore$d = "Átfogó pontszám";
const Aboutthegoal$d = "A célról";
const GoalTracking$d = "Célkövetés";
const Week$d = "Hét";
const progress$d = "haladás";
const loading$d = "Betöltés";
const Apply$d = "Alkalmaz";
const Thisskillhasbeenreported$d = "Ez a képesség jelentve lett.";
const issueGettingResume$d = "Probléma volt az önéletrajz beszerzésével.";
const Interview$d = "Interjú";
const Tasks$d = "Feladatok";
const Loading$d = "Betöltés";
const Skilladdedsuccessfully$d = "A készség sikeresen hozzáadva";
const problemAddingSkill$d = "Probléma volt a képesség hozzáadásával.";
const Reportaproblem$d = "Probléma bejelentése";
const Submit$d = "Beküldés";
const Addanewskill$d = "Új készség hozzáadása";
const JobDetailsComponent$d = {
	classifySkill: "Hogyan osztályoznád ezt a képességet? (Opcionális)",
	includedKeywordsWillCount: "Tartalmazza ezt a kulcsszót?",
	yesIncludeThisSkill: "Az inkludált kulcsszavak befolyásolják a találati pontszámát minden további szkennelésnél. Az inkludált kulcsszavakat a profiljában módosíthatja.",
	addSkill: "Szeretnéd hozzáadni ezt készségként?"
};
const HardSkill$d = "Kemény készség";
const SoftSkill$d = "Lágy készség";
const Pleaseshareanyadditionalcontext$d = "Kérjük, ossza meg bármilyen további kontextust";
const Addasskill$d = "Hozzáadás készségként";
const Skill$d = "Készség";
const JobFrequency$d = "Állás gyakorisága";
const ResumeFrequency$d = "Önéletrajz gyakorisága";
const Reportskill$d = "Készség jelentése";
const JobDetails$d = "Munka részletei";
const ViewJobLink$d = "Munka link megtekintése";
const Salary$d = "Fizetés";
const areYouSureDeleteJob$d = "Biztosan törölni szeretné ezt a munkát?";
const ViewMore$d = "További megtekintése";
const ViewLess$d = "Kevesebb megtekintése";
const matchYouSkillsAgainstJob$d = "Illeszd össze a képességeidet a munkaleírással.";
const pleaseUploadResumeSkillMatch$d = "Kérjük, töltsd fel az önéletrajzodat, hogy megkapd a készségpontszámodat.";
const AddResume$d = "Önéletrajz hozzáadása";
const thisJobDoesNotHaveAnyDesc$d = "Ez a munka nem rendelkezik leírással.";
const youCanEditJobToAdd$d = "Szerkesztheti ezt a munkát, hogy hozzáadhasson hozzá egy leírást. A munkák importálásához is használhatja a miénket.";
const chromeextension$d = "Chrome bővítmény";
const fromVariousJobPortalsOnce$d = "különböző állásportálokról. Miután hozzáad egy leírást, képes lesz megtekinteni a készségekkel kapcsolatos információkat is.";
const AddDescription$d = "Leírás hozzáadása";
const CompanyInfo$d = "Céginformációk";
const Website$d = "Weboldal";
const Industry$d = "Ágazat";
const EmployeeCount$d = "Munkavállalók száma";
const ExprienceLevel$d = "Tapasztalati szint";
const Address$d = "Cím";
const Resumes$d = "Önéletrajzok";
const Setasdefault$d = "Beállítás alapértelmezettnek";
const Ok$d = "Ok";
const UploadNewResume$d = "Új önéletrajz feltöltése";
const Default$d = "Alapértelmezett";
const Jobnotfound$d = "Munka nem található";
const EditDetails$d = "Részletek szerkesztése";
const JobPostURL$d = "Álláshirdetés URL-je";
const Enterjoburl$d = "Írja be a munka URL-ját";
const Nojobselected$d = "Nincs kiválasztott állás";
const Viewjobdetails$d = "Állás részleteinek megtekintése";
const Jobaddedtoyourboardsuccessfully$d = "A munka sikeresen hozzáadva a táblához.";
const AddJob$d = "Álláshirdetés hozzáadása";
const Addnewjobname$d = "Új munka nevének hozzáadása";
const JobUrl$d = "Állás URL-je";
const Addjoburl$d = "Állás URL hozzáadása";
const Section$d = "Szekció";
const didYouKnow$d = {
	chromeExtension: "Tudtad? A munkakeresést közvetlenül a Chrome-bővítményünkkel is mentheted, és az összes adatot egyetlen kattintással importálhatod! Csak néhány másodpercig tart."
};
const Jobs$d = "Állások";
const AddJobtoboard$d = "Munka hozzáadása a táblához";
const Currentlynojobsareavailable$d = "Jelenleg nincsenek álláslehetőségek.";
const noMatchingJobs$d = "Nincs találat a megfelelő állásokra.";
const welcomeToYourPersonalJobTracker$d = "Üdvözöljük a személyes munka nyomon követőjében!";
const weShortTutorialOnHowTrackingJob$d = "Egy rövid útmutatót adunk arról, hogyan kezdheti el követni álláspályázatait néhány könnyű lépésben!";
const Addanewjob$d = "Új munka hozzáadása";
const inOrderTrackCreatButton$d = "Ahhoz, hogy elkezdje követni az állásra vonatkozó jelentkezéseket, először hozzá kell adnia a táblához a \"Létrehozás\" gombra kattintva.";
const Providesomedetails$d = "Adj néhány részletet.";
const toBeginTypeJobTitleCompany$d = "Először csak írja be a munkakört, a cég nevét és a státuszt, amelyhez hozzá szeretné adni. Később hozzáadhat több részletet, de ez most minden, amire szüksége van!";
const asAnExampleFilledForYou$d = "Példaként már kitöltöttük ezt Önnek!";
const wohooAddedFirstJob$d = "Juhú! Hozzáadtad az első munkádat a munka nyomonkövetődhöz!";
const youCanDragDropJobCard$d = "Mostantól húzhatja és ejtheti a munkakártyát a munkaalkalmazási folyamat különböző szakaszaiba. A munkakártyára kattintva megtekintheti a részleteket, szerkesztheti őket, jegyzeteket menthet, és még sok mást!";
const Lastbutnotleast$d = "Végül, de nem utolsó sorban";
const finalStepMakeSure$d = "Az utolsó lépésként győződjön meg róla, hogy rendelkezik a miénkkel.";
const autoMaticallyImportJobs$d = "amely lehetővé teszi, hogy automatikusan importálja a munkákat kedvenc álláskereső weboldalairól, mint például a LinkedIn, az Indeed és még több! Bővítményünk segít javítani a LinkedIn-profilját, és 2,5-szer több keresési megjelenést érhet el!";
const selectanysection$d = "válasszon bármelyik szakaszt";
const Accept$d = "Elfogadás";
const My2023JobSearch$d = "2023-as álláskeresésem";
const AddedFrom$d = "Hozzáadva innen";
const AddedUntil$d = "Hozzáadva eddig";
const BasicModal$d = "Alap modalitás";
const AddnewSectionName$d = "Új szekció nevének hozzáadása";
const OpenTo$d = "Nyitott";
const Featured$d = "Kiemelt";
const LicenceAndCerts$d = "Licenc és tanúsítványok";
const Banner$d = "Banner";
const LinkedInURL$d = "LinkedIn URL";
const Recommendations$d = "Ajánlások";
const LinkedinReview$d = "Linkedin értékelés";
const NoDataAvailable$d = "Nincs elérhető adat";
const looksLikeYouDidNot$d = "Úgy tűnik, hogy még nem kezdtél el használni minket.";
const toOptimizeProfileScoreVisible$d = "még nem optimalizálta a LinkedIn-profilját. Ha ezt megteszi, a profilpontszáma itt lesz látható.";
const LinkedinComponent$d = {
	letsOptimize: "Optimalizáljuk"
};
const improveYourChancesLandingDreamJob$d = "Növeld az esélyeidet álmaid munkájának megszerzésére. Használd ezeket a kipróbált és bevált stratégiákat, hogy a LinkedIn profilodat átalakítsd és feljavítsd.";
const VisitProfile$d = "Profil megtekintése";
const wantToGetLinkedinMakeover$d = "Szeretnél teljes LinkedIn átalakítást kapni?";
const PostGenerator$d = "Bejegyzés generátor";
const LinkedinHeadlineGenerator$d = "LinkedIn címke generátor";
const LinkedinAboutSectionGenerator$d = "LinkedIn Rólam szakasz generátor";
const AITools$d = "Mesterséges intelligencia eszközök";
const Premium$d = "Prémium";
const LinkedInOptimization$d = "Linked In optimalizálás";
const JobTracker$d = "Munka nyomon követő";
const whoIsHiring$d = "Ki keres munkavállalót?";
const Autofill$d = "Automatikus kitöltés";
const HeadlineGenerator$d = "Cím Generátor";
const skillMatching$d = "Képesség-illesztés";
const SummarizeJD$d = "Munkaköri leírás összefoglalása";
const contactFeature$d = "Kapcsolattartás nyomon követése";
const documentFeature$d = "Dokumentumok";
const landJobWithoutStress$d = "Szerezd meg az álmaid munkáját. Stressz nélkül.";
const discoverFeatures$d = "Fedezze fel a Careerflow.ai funkcióinak sokféleségét, amelyek a munkakeresését egyszerűsítik és szakmai fejlődését elősegítik!";
const letsBeginOnboarding$d = "Ismerjük meg jobban!";
const inTheNextFewScreensJobThirdParties$d = "A következő néhány képernyőn néhány kérdést teszünk fel, amelyek segítenek nekünk testreszabni az élményt Önnek, valamint automatikusan kitölteni az álláspályázatait (hogy ne kelljen)! Nem adjuk el az adatait harmadik feleknek.";
const letsAddBasicInformation$d = "Adjuk hozzá az alapvető információidat.";
const Pleaseselectanoptionfirst$d = "Kérjük, először válasszon egy lehetőséget.";
const JobApplicationTracker$d = "Álláspályázat nyomonkövető";
const LinkedInProfileOptimizer$d = "Linked In profil optimalizáló";
const UnlimitedDocuments$d = "Korlátlan dokumentumok";
const UnlimitedContacts$d = "Korlátlan kapcsolatok";
const HiringManagerSearch$d = "Állásajánlatokat kereső menedzser";
const AILinkedInPostGenerator$d = "AI LinkedIn poszt generátor";
const ATSKeywordSkillMatch$d = "ATS kulcsszó / készség illeszkedő állás";
const ChooseyourPlan$d = "Válassza ki a tervét";
const superChargeYourJobSearch$d = "Gyorsítsd fel álláskeresésedet, javítsd állásra jelentkezési folyamatodat, növeld az interjúk számát és szerezd meg álmaid állását. Mindez a Careerflow prémium eszközkészletének segítségével.";
const startNowGoto$d = "Kezdj el most (Ugrás az alkalmazásra)";
const CreatedBy$d = "Készítette";
const CreateNewNote$d = "Új megjegyzés létrehozása";
const Nonotescreated$d = "Nincs létrehozott jegyzet";
const approxTimeIsFourMinutes$d = "Az onboarding folyamat befejezésének hozzávetőleges ideje 4 perc.";
const Continue$d = "Folytatás";
const iWillDoLaterTakeMeToApp$d = "Később csinálom meg. Vigyél az alkalmazáshoz.";
const allDone$d = "Minden kész!";
const welcomeAbord$d = "Üdvözöljük fedélzeten!";
const letsBegin$d = "Kezdjük el";
const UpgradeyourplanandgetAIAssistance$d = "Frissítse a tervét és szerezzen AI segítséget.";
const DownloadPDF$d = "Letöltés PDF";
const oopsWeCouldntProcessResume$d = "Hoppá, nem tudtuk feldolgozni ezt az önéletrajzot.";
const MyProfile$d = "A Profilom";
const Setting$d = "Beállítás";
const Logout$d = "Kijelentkezés";
const SignIn$d = "Bejelentkezés";
const Typeyourfirstnamehere$d = "A Keresztneved";
const Enteryourlastname$d = "Az utolsó neved";
const ManageSubscription$d = "Kezelje az előfizetést";
const ifYouHaveDifficultiesProfile$d = "Ha bármilyen nehézséged van a profilinformációddal kapcsolatban, kérjük, lépj kapcsolatba a következővel:";
const forSupport$d = "támogatásért.";
const whatIsIdealCompanySize$d = "Mi lenne az ideális vállalatméreted?";
const Saveandcontinue$d = "Mentés és folytatás";
const whatIsMinExpectedSalary$d = "Mi az elvárt minimális fizetésed (évente)?";
const Atleast$d = "Legalább";
const SlidetoAdjust$d = "Csúsztass a beállításhoz";
const whatIndustryExcitedWork$d = "Milyen iparágak izgalmasak számodra?";
const Add$d = "Hozzáadás";
const statusOfJobSearch$d = "Munkakeresési állapotod?";
const Finish$d = "Befejezés";
const whatLevelRoleLooking$d = "Milyen szintű szerepet keresel?";
const Selectuptotwo$d = "Válasszon legfeljebb kettőt.";
const PreviousStep$d = "Előző lépés";
const Skip$d = "Kihagyás";
const whatDoYouValueNewRole$d = "Milyen értékeket tartasz fontosnak egy új szerepben?";
const Selectuptothree$d = "Válasszon legfeljebb három lehetőséget.";
const EqualEmploymentData$d = "Egyenlő foglalkoztatási adatok";
const whatIsYourEthnicity$d = "Mi a származásod?";
const areYouAuthorizedToWorkUs$d = "Engedélyezett munkavégzésre az Egyesült Államokban?";
const willYouRequireSponsorShip$d = "Szüksége lesz jelenleg vagy a jövőben támogatásra az állás vízumállapotához?";
const doYouHaveADisability$d = "Van fogyatékossága?";
const areYouAVeteran$d = "Veterán vagy?";
const rolesYouInterestedIn$d = "Milyen szerepekre vagy kíváncsi?";
const Selectuptofive$d = "Válasszon legfeljebb ötöt.";
const AddCustomrole$d = "Hozzáadás egyéni szerepkör";
const whereDoYouLikeWork$d = "Hol szeretnél dolgozni?";
const Resources$d = "Erőforrások";
const currentlyNoResourceAvailable$d = "Jelenleg nincsenek elérhető erőforrások.";
const AddNewSection$d = "Új szekció hozzáadása";
const ChangeSections$d = "Szekciók módosítása";
const Settings$d = "Beállítások";
const Dashboard$d = "Irányítópult";
const JobBoard$d = "Állásportál";
const Linkedin$d = "Linkedin";
const Community$d = "Közösség";
const FindRecruiters$d = "Keresd meg a toborzókat";
const Goals$d = "Célok";
const DownloadExtension$d = "Bővítmény letöltése";
const SuggestaFeature$d = "Javasolj egy funkciót";
const leftPanel$d = {
	ReportanIssue: "Probléma jelentése"
};
const PhoneNumberisrequired$d = "A telefonszám kötelező";
const MobileNumber$d = "Mobiltelefonszám";
const Enteronlynumbers$d = "Csak számokat írjon be";
const Countryyoulivein$d = "Az ország, amelyben él.";
const SelectaCountry$d = "Válasszon egy országot";
const DateofBirth$d = "Születési dátum";
const Gender$d = "Nem";
const JobPreferences$d = "Munka preferenciák";
const pleaseEnterValidEmail$d = "Kérjük, adjon meg egy érvényes e-mail címet.";
const emailSendForResetting$d = "Egy e-mailt küldtek Önnek a jelszó visszaállításához.";
const VerifyyourEmailID$d = "Ellenőrizze az e-mail címét";
const sentPleaseCheckEmail$d = "Elküldve! Kérjük, ellenőrizze az e-mail fiókját.";
const tooManyAttemptsTryAgain$d = "Túl sok próbálkozás, kérjük próbálja újra később.";
const Resend$d = "Újraküldés";
const Login$d = "Bejelentkezés";
const weHaveSentVerificationLinkAtEmail$d = "Elküldtünk Önnek egy ellenőrző linket az e-mail címére.";
const pleaseVerifyEmailContinueSpam$d = "Kérjük, erősítse meg az e-mail címét a folytatáshoz. Kérjük, ellenőrizze a spam vagy promóció mappát a megerősítő e-mailért.";
const Logintogetstarted$d = "Jelentkezz be a kezdéshez";
const ContinuewithGoogle$d = "Folytatás a Google-lal";
const pleaseInputEmail$d = "Kérjük, adja meg az e-mail címét!";
const Password$d = "Jelszó";
const pleaseInputPassword$d = "Kérem, adja meg a jelszavát!";
const passwordLowerUpperDigitSpecial$d = "A jelszavadnak legalább egy kisbetűt, nagybetűt, számot és speciális karaktert kell tartalmaznia.";
const atLeastSixChar$d = "Legalább 6 karakter";
const forgotPassword$d = "Elfelejtette a jelszavát?";
const Bysigninginyouagreetoour$d = "Bejelentkezéssel elfogadod az alábbiakat:";
const Terms$d = "Feltételek";
const Conditions$d = "Körülmények";
const and$d = "és";
const PrivacyPolicy$d = "Adatvédelmi irányelvek";
const theseAreTheTopsSkillsExtracted$d = "Ezek a legfontosabb készségek, amelyeket a munkaköri leírásból kinyertünk.";
const TopSkills$d = "Felső készségek";
const weCoulNotExtractSkills$d = "Nem tudtunk kinyerni semmilyen készséget ebből a munkaköri leírásból.";
const upgradeToPremiumToView$d = "Frissítse a Prémiumot, hogy megtekinthesse az önéletrajz-készségei illeszkedési pontszámát.";
const SkillScore$d = "Készség pontszám";
const thisIsYourSkillScoreBasedOn$d = "Ez a szakértelmi pontszámod a munkaleírás és az önéletrajzod alapján.";
const theseSkllsAreStrongMatch$d = "Ezek a készségek erős egyezést mutatnak az önéletrajzod és a munkaköri leírás között.";
const Strongmatch$d = "Erős egyezés";
const theseSkillsArePartialMatch$d = "Ezek a készségek részben illeszkednek az önéletrajzodhoz és a munkaköri leíráshoz.";
const Partialmatch$d = "Részleges találat";
const theseSkillsAreMissingFrom$d = "Ezek a kulcsszavak hiányoznak az önéletrajzodból, de megtalálhatóak a munkaleírásban. Lehetnek készségek vagy általános kulcsszavak, amelyek specifikusak a munkalehetőségre, és hasznos lehet őket hozzáadni az önéletrajzodhoz.";
const SkillMatchComponent$d = {
	removeSkill: "Mi a fő oka annak, hogy problémát jelentesz a kulcsszóval kapcsolatban?"
};
const Optional$d = "Opcionális";
const Notrelevanttothejob$d = "Nem releváns a munkához";
const Notaskill$d = "Nincs készség";
const Toogeneric$d = "Túl általános";
const Pleaseshareanyfeedback$d = "Kérjük, ossza meg a visszajelzését";
const excludedKeywordsWillNot$d = "Az kizárt kulcsszavak nem számítanak bele a találati pontszámába az összes jövőbeli szkennelés során. A kizárt kulcsszavakat módosíthatja a profiljából.";
const yesExcludeThisSkillFrom$d = "Igen, zárja ki ezt a képességet az összes önéletrajzom szkenneléséből.";
const PartialMatch$d = "Részleges egyezés";
const MissingKeywords$d = "Hiányzó kulcsszavak";
const Providetitletotask$d = "Adj címet a feladatnak";
const TasksList$d = "Feladatok listája";
const AddTask$d = "Feladat hozzáadása";
const EnterTaskTitlehere$d = "Add meg a feladat címét itt";
const TasksComponent$d = {
	listEmpty: "A feladatlista üres, hozzon létre újat."
};
const CompletedTasks$d = "Befejezett feladatok";
const CompleteYourtasks$d = "Fejezze be a feladatait";
const Steps$d = "Lépések";
const PremiumMember$d = "Prémium tag";
const Thankyouforupgradingto$d = "Köszönjük, hogy frissített a(z) ...-ra.";
const CareerflowPremium$d = "Karrieráramlás Prémium";
const hereIsHowYouCanAccessPremium$d = "Így érheti el a Prémium előnyeit!";
const stepOne$d = "Lépés 1";
const DownloadourChromeExtension$d = "Töltse le a Chrome-bővítményünket";
const youJobSearchCopilotIshere$d = "Az álláskeresési AI-társad itt van.";
const DownloadNow$d = "Töltse le most";
const stepTwo$d = "Lépés 2";
const GetStarted$d = "Kezdjük el";
const stepThree$d = "3. lépés";
const SignintoChromeExtension$d = "Jelentkezz be a Chrome bővítménybe";
const entityCreated$d = "Új {{entity}} létrehozva";
const entityUpdated$d = "{{entity}} frissítve.";
const entityDeleted$d = "{{entity}} törölve";
const entityLinked$d = "{{entity}} összekapcsolva";
const entityUnlinked$d = "{{entity}} kicsatolva";
const entityMovedTo$d = "Áthelyezve a(z) {{entity}}-ba.";
const youAddedANewEntity$d = "Hozzáadtál egy új {{entity}}-t.";
const personCreated$d = "{{creator}} létrehozott egy {{entity}}-t a {{owner}} számára.";
const youUpdatedAEntity$d = "Frissítetted a(z) {{entity}}-t.";
const personUpdated$d = "{{creator}} frissítette a(z) {{entity}}-t a(z) {{owner}} számára.";
const youDeletedAEntity$d = "Töröltél egy {{entity}}-t.";
const personDeleted$d = "{{creator}} törölte a(z) {{entity}}-t a(z) {{owner}} tulajdonos számára.";
const youLinkedEntity$d = "Egy {{entity}}-t kapcsoltál ehhez a munkához.";
const personLinked$d = "{{creator}} egy {{entity}}-t kapcsolt ehhez a munkához a(z) {{owner}} tulajdonos számára.";
const youUnlinked$d = "Eltávolítottad a(z) {{entity}} kapcsolatát ennek a munkának.";
const personUnlinked$d = "{{creator}} eltávolította a(z) {{entity}} kapcsolatát ezzel a feladattal a(z) {{owner}} tulajdonos számára.";
const youMovedEntity$d = "Áthelyezted ezt a(z) {{entity}}-t a(z) {{sectionFrom}}-ból a(z) {{sectionTo}}-ba.";
const personMoved$d = "{{creator}} áthelyezte ezt a(z) {{entity}}-t a(z) {{sectionFrom}}-ból a(z) {{sectionTo}}-ba a(z) {{owner}} tulajdonosnak.";
const addedByName$d = "Hozzáadva: {{name}}";
const DownloadChromeExtension$d = "Töltse le a Chrome bővítményt";
const ourChromeExtensionIs$d = "A chrome kiegészítőnk egy integrált eszköz, amely segít optimalizálni a LinkedIn profilodat, állásokat menteni, kapcsolatokat menteni, motivációs levelet generálni és még sok mást.";
const Optimizeyourprofile$d = "Optimalizáld a profilodat";
const startOptimizingYourProfile$d = "Kezd el optimalizálni a profilodat, hogy jobb esélyeid legyenek arra, hogy kapcsolatba lépjenek veled a toborzók.";
const OptimizeNow$d = "Optimalizálás most";
const Addyourfirstjob$d = "Add az első munkádat";
const startSavingJobApplicationsToTrack$d = "Kezd el menteni az állásajánlatokat, hogy nyomon követhesd az álláskeresésed útját és hasznos információkat találj.";
const AddNow$d = "Hozzáadás most";
const CompleteProfile$d = "Teljes profil";
const completeYourProfileForUsing$d = "Töltsd ki a profilodat az automatikus kitöltési funkció használatához és egy személyre szabottabb élményhez.";
const CompleteNow$d = "Kész";
const Addyourfirstcontact$d = "Addd hozzá az első kapcsolatodat";
const addContactToFollowUpWith$d = "Adj hozzá kapcsolatot, hogy később követhesd, jegyzeteket és még többet.";
const JoinCommunity$d = "Csatlakozz a közösséghez";
const ourCommunityisAlways$d = "A közösségünk mindig veled van az álláskeresési útjaid során.";
const JoinNow$d = "Csatlakozzon most";
const welcomeToCareerflow$d = "Üdvözöljük a Careerflow oldalon!";
const yourHubForCareerInsights2$d = "Ez az Ön központja a karrierbeli betekintésekhez, tevékenységekhez és még sok más információhoz. Fedezze fel személyre szabott vezérlőpultját, hogy mindig naprakész legyen a szakmai útján.";
const ChecklistCompleted$d = "A te ellenőrző listád elkészült!";
const Completeyourchecklist$d = "Töltsd ki a teendőlistádat";
const completeAFewStepsTo$d = "Tegyen meg néhány lépést, hogy megszerezze következő állását.";
const Completed$d = "Befejezve";
const JobCountByStage$d = "Munka számláló szakaszonként";
const NopastapplicationDatafound$d = "Nem található korábbi alkalmazás adat.";
const YourJobSearchStages$d = "A munkakeresési szakaszaid";
const NoDatafound$d = "Nincs adat található";
const hu = {
	copyToClipboard: copyToClipboard$d,
	UnlocktheAIgenerated: UnlocktheAIgenerated$d,
	UpgradetoPremium: UpgradetoPremium$d,
	Result: Result$d,
	Copy: Copy$d,
	Save: Save$d,
	Edit: Edit$d,
	Processing: Processing$d,
	YourAIgeneratedcontentwillshowhere: YourAIgeneratedcontentwillshowhere$d,
	hopeYouFindUseful: hopeYouFindUseful$d,
	regenerate: regenerate$d,
	ProvideAdditionalFeedback: ProvideAdditionalFeedback$d,
	Enteranyfeedback: Enteranyfeedback$d,
	Notimpressive: Notimpressive$d,
	thisIsntTrue: thisIsntTrue$d,
	Notpersonalized: Notpersonalized$d,
	Tone: Tone$d,
	Length: Length$d,
	Template: Template$d,
	Generatedon: Generatedon$d,
	Copiedtoclipboard: Copiedtoclipboard$d,
	CopytoClipboard: CopytoClipboard$d,
	DownloadasPDF: DownloadasPDF$d,
	ViewDetails: ViewDetails$d,
	JobDescriptionImported: JobDescriptionImported$d,
	ImportfromJob: ImportfromJob$d,
	Saved: Saved$d,
	Applied: Applied$d,
	Offer: Offer$d,
	Interviewing: Interviewing$d,
	Rejected: Rejected$d,
	Search: Search$d,
	Import: Import$d,
	CoverLetterGeneratorHistory: CoverLetterGeneratorHistory$d,
	NoCoverLettersGenerated: NoCoverLettersGenerated$d,
	getStartedCoverLetter: getStartedCoverLetter$d,
	getStarted: getStarted$d,
	Documents: Documents$d,
	UploadNewDocument: UploadNewDocument$d,
	AICoverLetterGenerator: AICoverLetterGenerator$d,
	ViewHistory: ViewHistory$d,
	JobDescription: JobDescription$d,
	ImportfromBoard: ImportfromBoard$d,
	EnterJobDescription: EnterJobDescription$d,
	JobTitle: JobTitle$d,
	EnterJobTitle: EnterJobTitle$d,
	CompanyName: CompanyName$d,
	EnterCompanyName: EnterCompanyName$d,
	YourProfile: YourProfile$d,
	ResumeUpload: ResumeUpload$d,
	UseLinkedinProfile: UseLinkedinProfile$d,
	Uploadyourresume: Uploadyourresume$d,
	AddyourResume: AddyourResume$d,
	fileNameCannotFormat: fileNameCannotFormat$d,
	ChooseorUpload: ChooseorUpload$d,
	SelectTemplate: SelectTemplate$d,
	Preview: Preview$d,
	UseTemplate: UseTemplate$d,
	Change: Change$d,
	AdvancedSettings: AdvancedSettings$d,
	AdditionalContext: AdditionalContext$d,
	Professional: Professional$d,
	Casual: Casual$d,
	Enthusiastic: Enthusiastic$d,
	Informational: Informational$d,
	Short: Short$d,
	Medium: Medium$d,
	Long: Long$d,
	Language: Language$d,
	iAmOkayBack: iAmOkayBack$d,
	Generate: Generate$d,
	CoverLetter: CoverLetter$d,
	SelectLanguage: SelectLanguage$d,
	AboutGeneratorHistory: AboutGeneratorHistory$d,
	NoAboutsGenerated: NoAboutsGenerated$d,
	getStartedAbouts: getStartedAbouts$d,
	noAttachmentsFound: noAttachmentsFound$d,
	TargetJobTitle: TargetJobTitle$d,
	KeywordsToInclude: KeywordsToInclude$d,
	UploadYourResume: UploadYourResume$d,
	AddYourResume: AddYourResume$d,
	LinkedinProfile: LinkedinProfile$d,
	Linkedinprofilenotfound: Linkedinprofilenotfound$d,
	startUsingChromeExtension: startUsingChromeExtension$d,
	Download: Download$d,
	UseEmojis: UseEmojis$d,
	UseBulletPoints: UseBulletPoints$d,
	SpeechFocus: SpeechFocus$d,
	FirstPerson: FirstPerson$d,
	ThirdPerson: ThirdPerson$d,
	HeadlineGeneratorHistory: HeadlineGeneratorHistory$d,
	NoHeadlinesGenerated: NoHeadlinesGenerated$d,
	getStartedHeadline: getStartedHeadline$d,
	AIHeadlineGenerator: AIHeadlineGenerator$d,
	KeywordstoInclude: KeywordstoInclude$d,
	Pressenteraftereachword: Pressenteraftereachword$d,
	LinkedinProfilenotfound: LinkedinProfilenotfound$d,
	Headline: Headline$d,
	PostGeneratorHistory: PostGeneratorHistory$d,
	NoPostsGenerated: NoPostsGenerated$d,
	getStartedPost: getStartedPost$d,
	Topic: Topic$d,
	Description: Description$d,
	UseHashtags: UseHashtags$d,
	Custom: Custom$d,
	EnterCustomTone: EnterCustomTone$d,
	Added: Added$d,
	ComingSoon: ComingSoon$d,
	Company: Company$d,
	JobInterview: JobInterview$d,
	Research: Research$d,
	Networking: Networking$d,
	Referral: Referral$d,
	MustbeContacted: MustbeContacted$d,
	ScheduleaMeeting: ScheduleaMeeting$d,
	needAFollowUp: needAFollowUp$d,
	Today: Today$d,
	Viewdetails: Viewdetails$d,
	Activity: Activity$d,
	ActivityDetails: ActivityDetails$d,
	Delete: Delete$d,
	Title: Title$d,
	Goal: Goal$d,
	Status: Status$d,
	FollowUp: FollowUp$d,
	AddActivity: AddActivity$d,
	Enteractivitytitle: Enteractivitytitle$d,
	Cancel: Cancel$d,
	SaveActivity: SaveActivity$d,
	noActivityPresent: noActivityPresent$d,
	Addnew: Addnew$d,
	About: About$d,
	noDataPresentYou: noDataPresentYou$d,
	Experience: Experience$d,
	Education: Education$d,
	Skills: Skills$d,
	Overview: Overview$d,
	LinkedJobs: LinkedJobs$d,
	Notes: Notes$d,
	FullName: FullName$d,
	Location: Location$d,
	Relationship: Relationship$d,
	Contacts: Contacts$d,
	CreateContact: CreateContact$d,
	NotesCreated: NotesCreated$d,
	Notesupdated: Notesupdated$d,
	Addnote: Addnote$d,
	areYouSureDeleteNote: areYouSureDeleteNote$d,
	Createdby: Createdby$d,
	notSureWhyResumeCalls: notSureWhyResumeCalls$d,
	getExpertResumeReview: getExpertResumeReview$d,
	youHaventAddedContacts: youHaventAddedContacts$d,
	noMatchingContacts: noMatchingContacts$d,
	Link: Link$d,
	unlink: unlink$d,
	Locationnotavailable: Locationnotavailable$d,
	Emailnotavailable: Emailnotavailable$d,
	PhoneNumbernotavailable: PhoneNumbernotavailable$d,
	createdby: createdby$d,
	areYouSureDeleteContact: areYouSureDeleteContact$d,
	areYouSureUnlinkContact: areYouSureUnlinkContact$d,
	Addedbyyou: Addedbyyou$d,
	Addedby: Addedby$d,
	Timeline: Timeline$d,
	Timelineempty: Timelineempty$d,
	Discard: Discard$d,
	SaveContact: SaveContact$d,
	Recruiter: Recruiter$d,
	Candidate: Candidate$d,
	Colleague: Colleague$d,
	Employee: Employee$d,
	"Needtofollow-up": "Követés szükséges",
	EnterValidEmail: EnterValidEmail$d,
	EnterValidPhoneNumber: EnterValidPhoneNumber$d,
	editingProfileNotAvailable: editingProfileNotAvailable$d,
	itWillBeSoonAvailable: itWillBeSoonAvailable$d,
	ChromeExtension: ChromeExtension$d,
	SelectTag: SelectTag$d,
	FirstName: FirstName$d,
	FirstNameisrequired: FirstNameisrequired$d,
	LastName: LastName$d,
	LastNameisrequired: LastNameisrequired$d,
	Companyisrequired: Companyisrequired$d,
	Email: Email$d,
	ThisisnotavalidEmail: ThisisnotavalidEmail$d,
	AddEmail: AddEmail$d,
	PhoneNumber: PhoneNumber$d,
	notaValidPhone: notaValidPhone$d,
	phoneNoMinimum5char: phoneNoMinimum5char$d,
	phoneNoMinumum15char: phoneNoMinumum15char$d,
	AddPhoneNumber: AddPhoneNumber$d,
	SelectGoal: SelectGoal$d,
	SelectStatus: SelectStatus$d,
	Followup: Followup$d,
	SocialMedia: SocialMedia$d,
	Linkedinhandle: Linkedinhandle$d,
	Twitterhandle: Twitterhandle$d,
	Facebookhandle: Facebookhandle$d,
	Githubhandle: Githubhandle$d,
	Gmailhandle: Gmailhandle$d,
	Changessavedsuccessfully: Changessavedsuccessfully$d,
	EditContact: EditContact$d,
	BasicInformation: BasicInformation$d,
	EditContactDetails: EditContactDetails$d,
	SaveChanges: SaveChanges$d,
	phoneNoMinimum14char: phoneNoMinimum14char$d,
	LinkedIn: LinkedIn$d,
	Twitter: Twitter$d,
	Facebook: Facebook$d,
	Github: Github$d,
	Gmail: Gmail$d,
	youCanWriteAbout: youCanWriteAbout$d,
	Addednewsection: Addednewsection$d,
	Removedsuccessfully: Removedsuccessfully$d,
	Remove: Remove$d,
	Institute: Institute$d,
	Schoolisrequired: Schoolisrequired$d,
	Degree: Degree$d,
	StartMonth: StartMonth$d,
	StartYear: StartYear$d,
	EndMonth: EndMonth$d,
	EndYear: EndYear$d,
	Addmore: Addmore$d,
	PositionTitle: PositionTitle$d,
	ExperienceType: ExperienceType$d,
	Addednewitem: Addednewitem$d,
	whatSkillsDoYouEnjoy: whatSkillsDoYouEnjoy$d,
	Typeskillshere: Typeskillshere$d,
	LinkedContacts: LinkedContacts$d,
	LinkContact: LinkContact$d,
	NocontactsLinked: NocontactsLinked$d,
	JobContactsComponent: JobContactsComponent$d,
	Nocontacts: Nocontacts$d,
	LinkJobto: LinkJobto$d,
	Contact: Contact$d,
	Document: Document$d,
	Nojobsfound: Nojobsfound$d,
	LinkJob: LinkJob$d,
	youCanLinkContactJobImported: youCanLinkContactJobImported$d,
	Prev: Prev$d,
	Next: Next$d,
	areYouSureUnlinkDocument: areYouSureUnlinkDocument$d,
	areYouSureDeleteDocument: areYouSureDeleteDocument$d,
	Category: Category$d,
	CreatedOn: CreatedOn$d,
	Joblinked: Joblinked$d,
	Quickactions: Quickactions$d,
	All: All$d,
	Resume: Resume$d,
	Portfolio: Portfolio$d,
	Other: Other$d,
	Adddocument: Adddocument$d,
	Type: Type$d,
	Sortingby: Sortingby$d,
	SwitchtoGridLayout: SwitchtoGridLayout$d,
	SwitchtoListLayout: SwitchtoListLayout$d,
	NoDocumentsAdded: NoDocumentsAdded$d,
	DocumentsComponent: DocumentsComponent$d,
	NoDocumentFound: NoDocumentFound$d,
	SelectFile: SelectFile$d,
	onlyPdfDocxSupported: onlyPdfDocxSupported$d,
	Uploadfile: Uploadfile$d,
	DocumentCategory: DocumentCategory$d,
	SaveDocument: SaveDocument$d,
	AddDocument: AddDocument$d,
	LinkedDocuments: LinkedDocuments$d,
	LinkDocument: LinkDocument$d,
	NodocumentsLinked: NodocumentsLinked$d,
	JobDocumentsComponent: JobDocumentsComponent$d,
	NoDocuments: NoDocuments$d,
	CreateDocuments: CreateDocuments$d,
	youCanLinkDocumentJobImported: youCanLinkDocumentJobImported$d,
	Documenteditedsuccessfully: Documenteditedsuccessfully$d,
	DocumentDetails: DocumentDetails$d,
	UnsavedChanges: UnsavedChanges$d,
	yourChangesWillBeLostSureClose: yourChangesWillBeLostSureClose$d,
	yourChangesWillBeLostSureDiscard: yourChangesWillBeLostSureDiscard$d,
	DiscardChanges: DiscardChanges$d,
	WeeklyGoalAlert: WeeklyGoalAlert$d,
	Progress: Progress$d,
	AllGoals: AllGoals$d,
	Name: Name$d,
	Completedon: Completedon$d,
	Createdon: Createdon$d,
	Action: Action$d,
	Back: Back$d,
	OverallScore: OverallScore$d,
	Aboutthegoal: Aboutthegoal$d,
	GoalTracking: GoalTracking$d,
	Week: Week$d,
	progress: progress$d,
	loading: loading$d,
	Apply: Apply$d,
	Thisskillhasbeenreported: Thisskillhasbeenreported$d,
	issueGettingResume: issueGettingResume$d,
	Interview: Interview$d,
	Tasks: Tasks$d,
	Loading: Loading$d,
	Skilladdedsuccessfully: Skilladdedsuccessfully$d,
	problemAddingSkill: problemAddingSkill$d,
	Reportaproblem: Reportaproblem$d,
	Submit: Submit$d,
	Addanewskill: Addanewskill$d,
	JobDetailsComponent: JobDetailsComponent$d,
	HardSkill: HardSkill$d,
	SoftSkill: SoftSkill$d,
	Pleaseshareanyadditionalcontext: Pleaseshareanyadditionalcontext$d,
	Addasskill: Addasskill$d,
	Skill: Skill$d,
	JobFrequency: JobFrequency$d,
	ResumeFrequency: ResumeFrequency$d,
	Reportskill: Reportskill$d,
	JobDetails: JobDetails$d,
	ViewJobLink: ViewJobLink$d,
	Salary: Salary$d,
	areYouSureDeleteJob: areYouSureDeleteJob$d,
	ViewMore: ViewMore$d,
	ViewLess: ViewLess$d,
	matchYouSkillsAgainstJob: matchYouSkillsAgainstJob$d,
	pleaseUploadResumeSkillMatch: pleaseUploadResumeSkillMatch$d,
	AddResume: AddResume$d,
	thisJobDoesNotHaveAnyDesc: thisJobDoesNotHaveAnyDesc$d,
	youCanEditJobToAdd: youCanEditJobToAdd$d,
	chromeextension: chromeextension$d,
	fromVariousJobPortalsOnce: fromVariousJobPortalsOnce$d,
	AddDescription: AddDescription$d,
	CompanyInfo: CompanyInfo$d,
	Website: Website$d,
	Industry: Industry$d,
	EmployeeCount: EmployeeCount$d,
	ExprienceLevel: ExprienceLevel$d,
	Address: Address$d,
	Resumes: Resumes$d,
	Setasdefault: Setasdefault$d,
	Ok: Ok$d,
	UploadNewResume: UploadNewResume$d,
	Default: Default$d,
	Jobnotfound: Jobnotfound$d,
	EditDetails: EditDetails$d,
	JobPostURL: JobPostURL$d,
	Enterjoburl: Enterjoburl$d,
	Nojobselected: Nojobselected$d,
	Viewjobdetails: Viewjobdetails$d,
	Jobaddedtoyourboardsuccessfully: Jobaddedtoyourboardsuccessfully$d,
	AddJob: AddJob$d,
	Addnewjobname: Addnewjobname$d,
	JobUrl: JobUrl$d,
	Addjoburl: Addjoburl$d,
	Section: Section$d,
	didYouKnow: didYouKnow$d,
	Jobs: Jobs$d,
	AddJobtoboard: AddJobtoboard$d,
	Currentlynojobsareavailable: Currentlynojobsareavailable$d,
	noMatchingJobs: noMatchingJobs$d,
	welcomeToYourPersonalJobTracker: welcomeToYourPersonalJobTracker$d,
	weShortTutorialOnHowTrackingJob: weShortTutorialOnHowTrackingJob$d,
	Addanewjob: Addanewjob$d,
	inOrderTrackCreatButton: inOrderTrackCreatButton$d,
	Providesomedetails: Providesomedetails$d,
	toBeginTypeJobTitleCompany: toBeginTypeJobTitleCompany$d,
	asAnExampleFilledForYou: asAnExampleFilledForYou$d,
	wohooAddedFirstJob: wohooAddedFirstJob$d,
	youCanDragDropJobCard: youCanDragDropJobCard$d,
	Lastbutnotleast: Lastbutnotleast$d,
	finalStepMakeSure: finalStepMakeSure$d,
	autoMaticallyImportJobs: autoMaticallyImportJobs$d,
	selectanysection: selectanysection$d,
	Accept: Accept$d,
	My2023JobSearch: My2023JobSearch$d,
	AddedFrom: AddedFrom$d,
	AddedUntil: AddedUntil$d,
	BasicModal: BasicModal$d,
	AddnewSectionName: AddnewSectionName$d,
	OpenTo: OpenTo$d,
	Featured: Featured$d,
	LicenceAndCerts: LicenceAndCerts$d,
	Banner: Banner$d,
	LinkedInURL: LinkedInURL$d,
	Recommendations: Recommendations$d,
	LinkedinReview: LinkedinReview$d,
	NoDataAvailable: NoDataAvailable$d,
	looksLikeYouDidNot: looksLikeYouDidNot$d,
	toOptimizeProfileScoreVisible: toOptimizeProfileScoreVisible$d,
	LinkedinComponent: LinkedinComponent$d,
	improveYourChancesLandingDreamJob: improveYourChancesLandingDreamJob$d,
	VisitProfile: VisitProfile$d,
	wantToGetLinkedinMakeover: wantToGetLinkedinMakeover$d,
	PostGenerator: PostGenerator$d,
	LinkedinHeadlineGenerator: LinkedinHeadlineGenerator$d,
	LinkedinAboutSectionGenerator: LinkedinAboutSectionGenerator$d,
	AITools: AITools$d,
	Premium: Premium$d,
	LinkedInOptimization: LinkedInOptimization$d,
	JobTracker: JobTracker$d,
	whoIsHiring: whoIsHiring$d,
	Autofill: Autofill$d,
	HeadlineGenerator: HeadlineGenerator$d,
	skillMatching: skillMatching$d,
	SummarizeJD: SummarizeJD$d,
	contactFeature: contactFeature$d,
	documentFeature: documentFeature$d,
	landJobWithoutStress: landJobWithoutStress$d,
	discoverFeatures: discoverFeatures$d,
	letsBeginOnboarding: letsBeginOnboarding$d,
	inTheNextFewScreensJobThirdParties: inTheNextFewScreensJobThirdParties$d,
	letsAddBasicInformation: letsAddBasicInformation$d,
	Pleaseselectanoptionfirst: Pleaseselectanoptionfirst$d,
	JobApplicationTracker: JobApplicationTracker$d,
	LinkedInProfileOptimizer: LinkedInProfileOptimizer$d,
	UnlimitedDocuments: UnlimitedDocuments$d,
	UnlimitedContacts: UnlimitedContacts$d,
	HiringManagerSearch: HiringManagerSearch$d,
	AILinkedInPostGenerator: AILinkedInPostGenerator$d,
	ATSKeywordSkillMatch: ATSKeywordSkillMatch$d,
	"Auto-Apply": "Automatikus alkalmazás",
	ChooseyourPlan: ChooseyourPlan$d,
	superChargeYourJobSearch: superChargeYourJobSearch$d,
	startNowGoto: startNowGoto$d,
	CreatedBy: CreatedBy$d,
	CreateNewNote: CreateNewNote$d,
	Nonotescreated: Nonotescreated$d,
	approxTimeIsFourMinutes: approxTimeIsFourMinutes$d,
	Continue: Continue$d,
	iWillDoLaterTakeMeToApp: iWillDoLaterTakeMeToApp$d,
	allDone: allDone$d,
	welcomeAbord: welcomeAbord$d,
	letsBegin: letsBegin$d,
	UpgradeyourplanandgetAIAssistance: UpgradeyourplanandgetAIAssistance$d,
	DownloadPDF: DownloadPDF$d,
	oopsWeCouldntProcessResume: oopsWeCouldntProcessResume$d,
	MyProfile: MyProfile$d,
	Setting: Setting$d,
	Logout: Logout$d,
	SignIn: SignIn$d,
	Typeyourfirstnamehere: Typeyourfirstnamehere$d,
	Enteryourlastname: Enteryourlastname$d,
	ManageSubscription: ManageSubscription$d,
	ifYouHaveDifficultiesProfile: ifYouHaveDifficultiesProfile$d,
	forSupport: forSupport$d,
	whatIsIdealCompanySize: whatIsIdealCompanySize$d,
	Saveandcontinue: Saveandcontinue$d,
	whatIsMinExpectedSalary: whatIsMinExpectedSalary$d,
	Atleast: Atleast$d,
	SlidetoAdjust: SlidetoAdjust$d,
	whatIndustryExcitedWork: whatIndustryExcitedWork$d,
	Add: Add$d,
	statusOfJobSearch: statusOfJobSearch$d,
	Finish: Finish$d,
	whatLevelRoleLooking: whatLevelRoleLooking$d,
	Selectuptotwo: Selectuptotwo$d,
	PreviousStep: PreviousStep$d,
	Skip: Skip$d,
	whatDoYouValueNewRole: whatDoYouValueNewRole$d,
	Selectuptothree: Selectuptothree$d,
	EqualEmploymentData: EqualEmploymentData$d,
	whatIsYourEthnicity: whatIsYourEthnicity$d,
	areYouAuthorizedToWorkUs: areYouAuthorizedToWorkUs$d,
	willYouRequireSponsorShip: willYouRequireSponsorShip$d,
	doYouHaveADisability: doYouHaveADisability$d,
	areYouAVeteran: areYouAVeteran$d,
	rolesYouInterestedIn: rolesYouInterestedIn$d,
	Selectuptofive: Selectuptofive$d,
	AddCustomrole: AddCustomrole$d,
	whereDoYouLikeWork: whereDoYouLikeWork$d,
	Resources: Resources$d,
	currentlyNoResourceAvailable: currentlyNoResourceAvailable$d,
	AddNewSection: AddNewSection$d,
	ChangeSections: ChangeSections$d,
	Settings: Settings$d,
	Dashboard: Dashboard$d,
	JobBoard: JobBoard$d,
	Linkedin: Linkedin$d,
	Community: Community$d,
	FindRecruiters: FindRecruiters$d,
	Goals: Goals$d,
	DownloadExtension: DownloadExtension$d,
	SuggestaFeature: SuggestaFeature$d,
	leftPanel: leftPanel$d,
	PhoneNumberisrequired: PhoneNumberisrequired$d,
	MobileNumber: MobileNumber$d,
	Enteronlynumbers: Enteronlynumbers$d,
	Countryyoulivein: Countryyoulivein$d,
	SelectaCountry: SelectaCountry$d,
	DateofBirth: DateofBirth$d,
	Gender: Gender$d,
	JobPreferences: JobPreferences$d,
	pleaseEnterValidEmail: pleaseEnterValidEmail$d,
	emailSendForResetting: emailSendForResetting$d,
	VerifyyourEmailID: VerifyyourEmailID$d,
	sentPleaseCheckEmail: sentPleaseCheckEmail$d,
	tooManyAttemptsTryAgain: tooManyAttemptsTryAgain$d,
	Resend: Resend$d,
	Login: Login$d,
	weHaveSentVerificationLinkAtEmail: weHaveSentVerificationLinkAtEmail$d,
	pleaseVerifyEmailContinueSpam: pleaseVerifyEmailContinueSpam$d,
	Logintogetstarted: Logintogetstarted$d,
	ContinuewithGoogle: ContinuewithGoogle$d,
	pleaseInputEmail: pleaseInputEmail$d,
	Password: Password$d,
	pleaseInputPassword: pleaseInputPassword$d,
	passwordLowerUpperDigitSpecial: passwordLowerUpperDigitSpecial$d,
	atLeastSixChar: atLeastSixChar$d,
	forgotPassword: forgotPassword$d,
	Bysigninginyouagreetoour: Bysigninginyouagreetoour$d,
	Terms: Terms$d,
	Conditions: Conditions$d,
	and: and$d,
	PrivacyPolicy: PrivacyPolicy$d,
	theseAreTheTopsSkillsExtracted: theseAreTheTopsSkillsExtracted$d,
	TopSkills: TopSkills$d,
	weCoulNotExtractSkills: weCoulNotExtractSkills$d,
	upgradeToPremiumToView: upgradeToPremiumToView$d,
	SkillScore: SkillScore$d,
	thisIsYourSkillScoreBasedOn: thisIsYourSkillScoreBasedOn$d,
	theseSkllsAreStrongMatch: theseSkllsAreStrongMatch$d,
	Strongmatch: Strongmatch$d,
	theseSkillsArePartialMatch: theseSkillsArePartialMatch$d,
	Partialmatch: Partialmatch$d,
	theseSkillsAreMissingFrom: theseSkillsAreMissingFrom$d,
	"Missing Keywords": "Hiányzó kulcsszavak",
	SkillMatchComponent: SkillMatchComponent$d,
	Optional: Optional$d,
	Notrelevanttothejob: Notrelevanttothejob$d,
	Notaskill: Notaskill$d,
	Toogeneric: Toogeneric$d,
	Pleaseshareanyfeedback: Pleaseshareanyfeedback$d,
	excludedKeywordsWillNot: excludedKeywordsWillNot$d,
	yesExcludeThisSkillFrom: yesExcludeThisSkillFrom$d,
	PartialMatch: PartialMatch$d,
	MissingKeywords: MissingKeywords$d,
	Providetitletotask: Providetitletotask$d,
	TasksList: TasksList$d,
	AddTask: AddTask$d,
	EnterTaskTitlehere: EnterTaskTitlehere$d,
	TasksComponent: TasksComponent$d,
	CompletedTasks: CompletedTasks$d,
	CompleteYourtasks: CompleteYourtasks$d,
	Steps: Steps$d,
	PremiumMember: PremiumMember$d,
	Thankyouforupgradingto: Thankyouforupgradingto$d,
	CareerflowPremium: CareerflowPremium$d,
	hereIsHowYouCanAccessPremium: hereIsHowYouCanAccessPremium$d,
	stepOne: stepOne$d,
	DownloadourChromeExtension: DownloadourChromeExtension$d,
	youJobSearchCopilotIshere: youJobSearchCopilotIshere$d,
	DownloadNow: DownloadNow$d,
	stepTwo: stepTwo$d,
	GetStarted: GetStarted$d,
	stepThree: stepThree$d,
	SignintoChromeExtension: SignintoChromeExtension$d,
	entityCreated: entityCreated$d,
	entityUpdated: entityUpdated$d,
	entityDeleted: entityDeleted$d,
	entityLinked: entityLinked$d,
	entityUnlinked: entityUnlinked$d,
	entityMovedTo: entityMovedTo$d,
	youAddedANewEntity: youAddedANewEntity$d,
	personCreated: personCreated$d,
	youUpdatedAEntity: youUpdatedAEntity$d,
	personUpdated: personUpdated$d,
	youDeletedAEntity: youDeletedAEntity$d,
	personDeleted: personDeleted$d,
	youLinkedEntity: youLinkedEntity$d,
	personLinked: personLinked$d,
	youUnlinked: youUnlinked$d,
	personUnlinked: personUnlinked$d,
	youMovedEntity: youMovedEntity$d,
	personMoved: personMoved$d,
	addedByName: addedByName$d,
	DownloadChromeExtension: DownloadChromeExtension$d,
	ourChromeExtensionIs: ourChromeExtensionIs$d,
	Optimizeyourprofile: Optimizeyourprofile$d,
	startOptimizingYourProfile: startOptimizingYourProfile$d,
	OptimizeNow: OptimizeNow$d,
	Addyourfirstjob: Addyourfirstjob$d,
	startSavingJobApplicationsToTrack: startSavingJobApplicationsToTrack$d,
	AddNow: AddNow$d,
	CompleteProfile: CompleteProfile$d,
	completeYourProfileForUsing: completeYourProfileForUsing$d,
	CompleteNow: CompleteNow$d,
	Addyourfirstcontact: Addyourfirstcontact$d,
	addContactToFollowUpWith: addContactToFollowUpWith$d,
	JoinCommunity: JoinCommunity$d,
	ourCommunityisAlways: ourCommunityisAlways$d,
	JoinNow: JoinNow$d,
	welcomeToCareerflow: welcomeToCareerflow$d,
	yourHubForCareerInsights2: yourHubForCareerInsights2$d,
	ChecklistCompleted: ChecklistCompleted$d,
	Completeyourchecklist: Completeyourchecklist$d,
	completeAFewStepsTo: completeAFewStepsTo$d,
	Completed: Completed$d,
	JobCountByStage: JobCountByStage$d,
	NopastapplicationDatafound: NopastapplicationDatafound$d,
	YourJobSearchStages: YourJobSearchStages$d,
	NoDatafound: NoDatafound$d
};

const copyToClipboard$c = "Copiato negli appunti!";
const UnlocktheAIgenerated$c = "Sblocca l'AI generata";
const UpgradetoPremium$c = "Passa a Premium";
const Result$c = "Risultato";
const Copy$c = "Copia";
const Save$c = "Salva";
const Edit$c = "Modifica";
const Processing$c = "Elaborazione";
const YourAIgeneratedcontentwillshowhere$c = "Il tuo contenuto generato dall'IA apparirà qui";
const hopeYouFindUseful$c = "Spero che trovi utile questo risultato!";
const regenerate$c = "Rigenera";
const ProvideAdditionalFeedback$c = "Fornisci Feedback Aggiuntivo";
const Enteranyfeedback$c = "Inserisci qualsiasi feedback";
const Notimpressive$c = "Non impressionante";
const thisIsntTrue$c = "Questo non è vero";
const Notpersonalized$c = "Non personalizzato";
const Tone$c = "Tono";
const Length$c = "Lunghezza";
const Template$c = "Modello";
const Generatedon$c = "Generato il";
const Copiedtoclipboard$c = "Copiato negli appunti";
const CopytoClipboard$c = "Copia negli Appunti";
const DownloadasPDF$c = "Scarica come PDF";
const ViewDetails$c = "Visualizza Dettagli";
const JobDescriptionImported$c = "Descrizione del lavoro importata";
const ImportfromJob$c = "Importa dal lavoro";
const Saved$c = "Salvato";
const Applied$c = "Applicato";
const Offer$c = "Offerta";
const Interviewing$c = "Intervista";
const Rejected$c = "Respinto";
const Search$c = "Ricerca";
const Import$c = "Importazione";
const CoverLetterGeneratorHistory$c = "Storia del Generatore di Lettere di Presentazione";
const NoCoverLettersGenerated$c = "Nessuna Lettera di Presentazione Generata";
const getStartedCoverLetter$c = "Non hai ancora generato alcuna lettera di presentazione. Inizia e ottieni lettere di presentazione abbinando la descrizione del lavoro con la tua esperienza rilevante.";
const getStarted$c = "Inizia!";
const Documents$c = "Documenti";
const UploadNewDocument$c = "Carica Nuovo Documento";
const AICoverLetterGenerator$c = "Generatore di Lettere di Presentazione AI";
const ViewHistory$c = "Visualizza Cronologia";
const JobDescription$c = "Descrizione del Lavoro";
const ImportfromBoard$c = "Importa da Board";
const EnterJobDescription$c = "Inserisci Descrizione del Lavoro";
const JobTitle$c = "Titolo del Lavoro";
const EnterJobTitle$c = "Inserisci Titolo del Lavoro";
const CompanyName$c = "Nome dell'Azienda";
const EnterCompanyName$c = "Inserisci Nome dell'Azienda";
const YourProfile$c = "Il Tuo Profilo";
const ResumeUpload$c = "Carica Curriculum";
const UseLinkedinProfile$c = "Usa Profilo Linkedin";
const Uploadyourresume$c = "Carica il tuo curriculum";
const AddyourResume$c = "Aggiungi il tuo Curriculum";
const fileNameCannotFormat$c = "I nomi dei file non possono contenere spazi o trattini bassi e devono essere in formato .doc, .docx o .pdf.";
const ChooseorUpload$c = "Scegli o Carica";
const SelectTemplate$c = "Seleziona Modello";
const Preview$c = "Anteprima";
const UseTemplate$c = "Usa Modello";
const Change$c = "Modifica";
const AdvancedSettings$c = "Impostazioni Avanzate";
const AdditionalContext$c = "Contesto Aggiuntivo";
const Professional$c = "Professionale";
const Casual$c = "Informale";
const Enthusiastic$c = "Entusiasta";
const Informational$c = "Informativo";
const Short$c = "Breve";
const Medium$c = "Medio";
const Long$c = "Lungo";
const Language$c = "Lingua";
const iAmOkayBack$c = "Va bene! Torna Indietro";
const Generate$c = "Genera";
const CoverLetter$c = "Lettera di Presentazione";
const SelectLanguage$c = "Seleziona Lingua";
const AboutGeneratorHistory$c = "Storia del Generatore di Descrizioni";
const NoAboutsGenerated$c = "Nessuna Descrizione Generata";
const getStartedAbouts$c = "Non hai ancora generato alcuna descrizione. Inizia e ottieni descrizioni abbinando la descrizione del lavoro con la tua esperienza rilevante.";
const noAttachmentsFound$c = "Nessun allegato trovato.";
const TargetJobTitle$c = "Titolo del Lavoro Desiderato";
const KeywordsToInclude$c = "Parole chiave da includere";
const UploadYourResume$c = "Carica il tuo curriculum";
const AddYourResume$c = "Aggiungi il tuo curriculum";
const LinkedinProfile$c = "Profilo Linkedin";
const Linkedinprofilenotfound$c = "Profilo Linkedin non trovato";
const startUsingChromeExtension$c = "Inizia a ottimizzare il tuo profilo Linkedin utilizzando la nostra estensione Chrome per utilizzare questa opzione.";
const Download$c = "Scarica";
const UseEmojis$c = "Usa Emojis";
const UseBulletPoints$c = "Usa Punti Elenco";
const SpeechFocus$c = "Focus del Discorso";
const FirstPerson$c = "Prima Persona";
const ThirdPerson$c = "Terza Persona";
const HeadlineGeneratorHistory$c = "Storia del Generatore di Titoli";
const NoHeadlinesGenerated$c = "Nessun Titolo Generato";
const getStartedHeadline$c = "Non hai ancora generato alcun titolo. Inizia e ottieni titoli abbinando la descrizione del lavoro con la tua esperienza rilevante.";
const AIHeadlineGenerator$c = "Generatore di Titoli AI";
const KeywordstoInclude$c = "Parole Chiave da Includere";
const Pressenteraftereachword$c = "Premi invio dopo ogni parola";
const LinkedinProfilenotfound$c = "Profilo LinkedIn non trovato.";
const Headline$c = "Titolo";
const PostGeneratorHistory$c = "Storia del Generatore di Post";
const NoPostsGenerated$c = "Nessun Post Generato";
const getStartedPost$c = "Non hai ancora generato alcun post. Inizia e ottieni post abbinando la descrizione del lavoro con la tua esperienza rilevante.";
const Topic$c = "Argomento";
const Description$c = "Descrizione";
const UseHashtags$c = "Usa Hashtags";
const Custom$c = "Personalizzato";
const EnterCustomTone$c = "Inserisci Tono Personalizzato";
const Added$c = "Aggiunto";
const ComingSoon$c = {
	header: "Ingegneri al lavoro!",
	content_1: "Il nostro team di ingegneri sta lavorando duramente per rendere questa funzionalità operativa il prima possibile",
	content_2: "Vuoi questa funzionalità presto? Faccielo sapere semplicemente spuntando la casella sottostante.",
	content_3: "Voglio questa funzionalità"
};
const Company$c = "Azienda";
const JobInterview$c = "Colloquio di Lavoro";
const Research$c = "Ricerca";
const Networking$c = "Rete di Contatti";
const Referral$c = "Raccomandazione";
const MustbeContacted$c = "Deve Essere Contattato";
const ScheduleaMeeting$c = "Pianifica un Incontro";
const needAFollowUp$c = "È necessario fare un follow-up";
const Today$c = "Oggi";
const Viewdetails$c = "Visualizza Dettagli";
const Activity$c = "Attività";
const ActivityDetails$c = "Dettagli dell'Attività";
const Delete$c = "Elimina";
const Title$c = "Titolo";
const Goal$c = "Obiettivo";
const Status$c = "Stato";
const FollowUp$c = "Seguito";
const AddActivity$c = "Aggiungi Attività";
const Enteractivitytitle$c = "Inserisci il titolo dell'attività";
const Cancel$c = "Annulla";
const SaveActivity$c = "Salva Attività";
const noActivityPresent$c = "Nessuna attività presente, aggiungi attività.";
const Addnew$c = "Aggiungi nuovo";
const About$c = "Informazioni";
const noDataPresentYou$c = "Nessun dato presente, puoi modificare questo contatto e aggiungere campi.";
const Experience$c = "Esperienza";
const Education$c = "Educazione";
const Skills$c = "Competenze";
const Overview$c = "Panoramica";
const LinkedJobs$c = "Lavori Collegati";
const Notes$c = "Note";
const FullName$c = "Nome Completo";
const Location$c = "Posizione";
const Relationship$c = "Relazione";
const Contacts$c = "Contatti";
const CreateContact$c = "Crea Contatto";
const NotesCreated$c = "Note Create";
const Notesupdated$c = "Note Aggiornate";
const Addnote$c = "Aggiungi nota";
const areYouSureDeleteNote$c = "Sei sicuro di voler eliminare questa nota?";
const Createdby$c = "Creato da";
const notSureWhyResumeCalls$c = "Non sei sicuro del motivo per cui il tuo curriculum non ti sta procurando chiamate per i colloqui? ☎️";
const getExpertResumeReview$c = "Ottieni una revisione del curriculum da un esperto 💎✨";
const youHaventAddedContacts$c = "Non hai ancora aggiunto nessun contatto.";
const noMatchingContacts$c = "Nessun contatto corrispondente trovato.";
const Link$c = "Collegamento";
const unlink$c = "Scollega";
const Locationnotavailable$c = "Posizione non disponibile";
const Emailnotavailable$c = "Email non disponibile";
const PhoneNumbernotavailable$c = "Numero di telefono non disponibile";
const createdby$c = "creato da";
const areYouSureDeleteContact$c = "Sei sicuro di voler eliminare questo Contatto?";
const areYouSureUnlinkContact$c = "Sei sicuro di voler Scollegare questo Contatto?";
const Addedbyyou$c = "Aggiunto da te";
const Addedby$c = "Aggiunto da";
const Timeline$c = "Cronologia";
const Timelineempty$c = "Cronologia vuota";
const Discard$c = "Annulla";
const SaveContact$c = "Salva contatto";
const Recruiter$c = "Reclutatore";
const Candidate$c = "Candidato";
const Colleague$c = "Collega";
const Employee$c = "Dipendente";
const EnterValidEmail$c = "Inserisci un'email valida";
const EnterValidPhoneNumber$c = "Inserisci un numero di telefono valido";
const editingProfileNotAvailable$c = "La modifica della foto del profilo non è ancora disponibile.";
const itWillBeSoonAvailable$c = "Sarà presto disponibile nel nostro";
const ChromeExtension$c = "Estensione di Chrome";
const SelectTag$c = "Seleziona Tag";
const FirstName$c = "Nome";
const FirstNameisrequired$c = "Il Nome è obbligatorio";
const LastName$c = "Cognome";
const LastNameisrequired$c = "Il Cognome è obbligatorio";
const Companyisrequired$c = "È richiesta l'azienda";
const Email$c = "Email";
const ThisisnotavalidEmail$c = "Questa non è un'email valida";
const AddEmail$c = "Aggiungi Email";
const PhoneNumber$c = "Numero di telefono";
const notaValidPhone$c = "Questo non è un numero di telefono valido. Inserisci solo numeri.";
const phoneNoMinimum5char$c = "Il numero di telefono deve essere di almeno 5 caratteri.";
const phoneNoMinumum15char$c = "Il numero di telefono deve essere di massimo 15 caratteri.";
const AddPhoneNumber$c = "Aggiungi Numero di telefono";
const SelectGoal$c = "Seleziona Obiettivo";
const SelectStatus$c = "Seleziona Stato";
const Followup$c = "Follow-up";
const SocialMedia$c = "Social Media";
const Linkedinhandle$c = "Nome utente Linkedin";
const Twitterhandle$c = "Nome utente Twitter";
const Facebookhandle$c = "Nome utente Facebook";
const Githubhandle$c = "Nome utente Github";
const Gmailhandle$c = "Nome utente Gmail";
const Changessavedsuccessfully$c = "Modifiche salvate con successo";
const EditContact$c = "Modifica Contatto";
const BasicInformation$c = "Informazioni di Base";
const EditContactDetails$c = "Modifica dettagli contatto";
const SaveChanges$c = "Salva Modifiche";
const phoneNoMinimum14char$c = "Il numero di telefono deve essere di almeno 14 caratteri.";
const LinkedIn$c = "LinkedIn";
const Twitter$c = "Twitter";
const Facebook$c = "Facebook";
const Github$c = "Github";
const Gmail$c = "Gmail";
const youCanWriteAbout$c = "Puoi scrivere della tua esperienza lavorativa, del settore in cui hai lavorato o delle tue competenze. Le persone parlano anche dei loro successi o delle esperienze lavorative precedenti.";
const Addednewsection$c = "Aggiunta nuova sezione";
const Removedsuccessfully$c = "Rimosso con successo.";
const Remove$c = "Rimuovi";
const Institute$c = "Istituto";
const Schoolisrequired$c = "La scuola è obbligatoria.";
const Degree$c = "Laurea";
const StartMonth$c = "Mese di inizio";
const StartYear$c = "Anno di inizio";
const EndMonth$c = "Fine mese";
const EndYear$c = "Fine anno";
const Addmore$c = "Aggiungi altro";
const PositionTitle$c = "Titolo della posizione";
const ExperienceType$c = "Tipo di esperienza";
const Addednewitem$c = "Aggiunto nuovo elemento";
const whatSkillsDoYouEnjoy$c = "Quali abilità hai o ti piace lavorare con?";
const Typeskillshere$c = "Inserisci qui le tue competenze";
const LinkedContacts$c = "Contatti Collegati";
const LinkContact$c = "Collega Contatto";
const NocontactsLinked$c = "Nessun contatto collegato";
const JobContactsComponent$c = {
	linkContact: "Collegando i contatti, puoi rapidamente vedere chi sono le persone importanti come il reclutatore, il responsabile delle assunzioni, ecc., per questo ruolo! In futuro, potremo mostrare informazioni rilevanti basate sui tuoi contatti."
};
const Nocontacts$c = "Nessun contatto";
const LinkJobto$c = "Collega lavoro a";
const Contact$c = "Contatto";
const Document$c = "Documento";
const Nojobsfound$c = "Nessun lavoro trovato";
const LinkJob$c = "Collega Lavoro";
const youCanLinkContactJobImported$c = "Puoi collegare questo contatto a un lavoro che hai importato in Careerflow.";
const Prev$c = "Precedente";
const Next$c = "Prossimo";
const areYouSureUnlinkDocument$c = "Sei sicuro di voler scollegare questo documento?";
const areYouSureDeleteDocument$c = "Sei sicuro di voler eliminare questo Documento?";
const Category$c = "Categoria";
const CreatedOn$c = "Creato il";
const Joblinked$c = "Lavoro collegato";
const Quickactions$c = "Azioni rapide";
const All$c = "Tutti";
const Resume$c = "Curriculum";
const Portfolio$c = "Portfolio";
const Other$c = "Altro";
const Adddocument$c = "Aggiungi documento";
const Type$c = "Tipo";
const Sortingby$c = "Ordinamento per";
const SwitchtoGridLayout$c = "Passa alla disposizione a griglia.";
const SwitchtoListLayout$c = "Passa alla visualizzazione a lista.";
const NoDocumentsAdded$c = "Nessun Documento Aggiunto";
const DocumentsComponent$c = {
	nodocs: "Non hai ancora creato documenti. Puoi caricare le versioni del tuo curriculum, lettere di presentazione e altro, e collegarli ai lavori che stai seguendo!"
};
const NoDocumentFound$c = "Nessun documento trovato";
const SelectFile$c = "Seleziona File";
const onlyPdfDocxSupported$c = "Solo .pdf e .docx supportati.";
const Uploadfile$c = "Carica file";
const DocumentCategory$c = "Categoria del Documento";
const SaveDocument$c = "Salva Documento";
const AddDocument$c = "Aggiungi Documento";
const LinkedDocuments$c = "Documenti collegati";
const LinkDocument$c = "Collega Documento";
const NodocumentsLinked$c = "Nessun documento collegato";
const JobDocumentsComponent$c = {
	linkDocs: "Collegare tutti i documenti rilevanti come il curriculum, la lettera di presentazione, ecc., che hai inviato per questo lavoro ti aiuterà a tener traccia di tutto in un unico posto. Provalo!"
};
const NoDocuments$c = "Nessun Documento";
const CreateDocuments$c = "Crea Documenti";
const youCanLinkDocumentJobImported$c = "Puoi collegare questo documento a un lavoro che hai importato in Careerflow.";
const Documenteditedsuccessfully$c = "Documento modificato con successo";
const DocumentDetails$c = "Dettagli del documento";
const UnsavedChanges$c = "Cambiamenti non salvati";
const yourChangesWillBeLostSureClose$c = "Le tue modifiche saranno perse, sei sicuro di voler chiudere?";
const yourChangesWillBeLostSureDiscard$c = "Le tue modifiche saranno perse, sei sicuro di voler eliminare le tue modifiche?";
const DiscardChanges$c = "Annulla modifiche";
const WeeklyGoalAlert$c = "Avviso Obiettivo Settimanale";
const Progress$c = "Progresso";
const AllGoals$c = "Tutti gli obiettivi";
const Name$c = "Nome";
const Completedon$c = "Completato il";
const Createdon$c = "Creato il";
const Action$c = "Azione";
const Back$c = "Indietro";
const OverallScore$c = "Punteggio complessivo";
const Aboutthegoal$c = "Informazioni sull'obiettivo";
const GoalTracking$c = "Tracciamento obiettivi";
const Week$c = "Settimana";
const progress$c = "progresso";
const loading$c = "Caricamento";
const Apply$c = "Applicare";
const Thisskillhasbeenreported$c = "Questa abilità è stata segnalata";
const issueGettingResume$c = "C'è stato un problema nel recuperare il curriculum vitae.";
const Interview$c = "Intervista";
const Tasks$c = "Compiti";
const Loading$c = "Caricamento";
const Skilladdedsuccessfully$c = "Abilità aggiunta con successo";
const problemAddingSkill$c = "C'è stato un problema nell'aggiungere la competenza.";
const Reportaproblem$c = "Segnala un Problema";
const Submit$c = "Invia";
const Addanewskill$c = "Aggiungi una nuova competenza";
const JobDetailsComponent$c = {
	classifySkill: "Come classificheresti questa competenza (opzionale)?",
	includedKeywordsWillCount: "Includere questa parola chiave?",
	yesIncludeThisSkill: "Le parole chiave incluse verranno conteggiate nel tuo punteggio di corrispondenza per tutte le scansioni future. Puoi modificare le parole chiave incluse dal tuo profilo.",
	addSkill: "Vuoi aggiungerlo come abilità?"
};
const HardSkill$c = "Competenza Tecnica";
const SoftSkill$c = "Competenza Soft";
const Pleaseshareanyadditionalcontext$c = "Per favore, condividi eventuali contesti aggiuntivi";
const Addasskill$c = "Aggiungi come competenza";
const Skill$c = "Abilità";
const JobFrequency$c = "Frequenza del Lavoro";
const ResumeFrequency$c = "Frequenza del Curriculum";
const Reportskill$c = "Segnala competenza";
const JobDetails$c = "Dettagli dell'impiego";
const ViewJobLink$c = "Visualizza link dell'offerta di lavoro";
const Salary$c = "Stipendio";
const areYouSureDeleteJob$c = "Sei sicuro di voler eliminare questo lavoro?";
const ViewMore$c = "Visualizza Altro";
const ViewLess$c = "Visualizza Meno";
const matchYouSkillsAgainstJob$c = "Abbinare le tue competenze alla descrizione del lavoro.";
const pleaseUploadResumeSkillMatch$c = "Si prega di caricare il proprio curriculum per ottenere il punteggio di corrispondenza delle competenze.";
const AddResume$c = "Aggiungi Curriculum";
const thisJobDoesNotHaveAnyDesc$c = "Questo lavoro non ha alcuna descrizione";
const youCanEditJobToAdd$c = "Puoi modificare questo lavoro per aggiungere una descrizione. Puoi anche importare lavori utilizzando il nostro.";
const chromeextension$c = "estensione di Chrome";
const fromVariousJobPortalsOnce$c = "dai vari portali di lavoro. Una volta che aggiungi una descrizione, sarai anche in grado di vedere informazioni relative alle competenze.";
const AddDescription$c = "Aggiungi descrizione.";
const CompanyInfo$c = "Informazioni sulla società";
const Website$c = "Sito Web";
const Industry$c = "Settore";
const EmployeeCount$c = "Numero di Dipendenti";
const ExprienceLevel$c = "Livello di Esperienza";
const Address$c = "Indirizzo";
const Resumes$c = "Curriculum vitae";
const Setasdefault$c = "Imposta come predefinito";
const Ok$c = "Ok";
const UploadNewResume$c = "Carica Nuovo Curriculum";
const Default$c = "Predefinito";
const Jobnotfound$c = "Lavoro non trovato";
const EditDetails$c = "Modifica Dettagli";
const JobPostURL$c = "URL del Posto di Lavoro";
const Enterjoburl$c = "Inserisci l'URL del lavoro";
const Nojobselected$c = "Nessun lavoro selezionato";
const Viewjobdetails$c = "Visualizza dettagli lavoro";
const Jobaddedtoyourboardsuccessfully$c = "Lavoro aggiunto con successo alla tua bacheca";
const AddJob$c = "Aggiungi Lavoro";
const Addnewjobname$c = "Aggiungi nuovo nome lavoro";
const JobUrl$c = "URL del Lavoro";
const Addjoburl$c = "Aggiungi URL del lavoro";
const Section$c = "Sezione";
const didYouKnow$c = {
	chromeExtension: "Lo sapevi? Puoi anche salvare lavori direttamente dalla nostra Estensione Chrome e importare tutti i dati con un solo clic! Ci vogliono solo pochi secondi."
};
const Jobs$c = "Lavori";
const AddJobtoboard$c = "Aggiungi lavoro alla bacheca";
const Currentlynojobsareavailable$c = "Attualmente non ci sono lavori disponibili.";
const noMatchingJobs$c = "Nessun lavoro corrispondente trovato.";
const welcomeToYourPersonalJobTracker$c = "Benvenuto nel tuo tracciatore di lavoro personale!";
const weShortTutorialOnHowTrackingJob$c = "Ti guideremo attraverso un breve tutorial su come iniziare a tracciare le tue candidature per lavoro in pochi semplici passaggi!";
const Addanewjob$c = "Aggiungi un nuovo lavoro.";
const inOrderTrackCreatButton$c = "Per iniziare a tracciare le candidature di lavoro, devi prima aggiungerle alla bacheca cliccando sul pulsante \"Crea\".";
const Providesomedetails$c = "Fornisci alcuni dettagli.";
const toBeginTypeJobTitleCompany$c = "Per cominciare, basta digitare il titolo del lavoro, il nome dell'azienda e lo stato in cui desideri aggiungerlo. Puoi aggiungere ulteriori dettagli in seguito, ma per ora questo è tutto ciò di cui hai bisogno!";
const asAnExampleFilledForYou$c = "Come esempio, l'abbiamo già compilato per te!";
const wohooAddedFirstJob$c = "Woohoo! Hai aggiunto il tuo primo lavoro al tuo tracker di lavoro!";
const youCanDragDropJobCard$c = "Ora è possibile trascinare la scheda di lavoro nelle varie fasi del processo di candidatura. Cliccando sulla scheda di lavoro sarà possibile visualizzare ulteriori dettagli, modificarli, salvare note e altro ancora!";
const Lastbutnotleast$c = "Ultimo ma non meno importante";
const finalStepMakeSure$c = "Come ultimo passaggio, assicurati di avere il nostro.";
const autoMaticallyImportJobs$c = "che ti permetterà di importare automaticamente lavori dai tuoi siti di ricerca lavoro preferiti come LinkedIn, Indeed e altri ancora! La nostra estensione ti aiuta anche a migliorare il tuo profilo LinkedIn e ottenere 2,5 volte più apparizioni nelle ricerche!";
const selectanysection$c = "seleziona qualsiasi sezione";
const Accept$c = "Accettare";
const My2023JobSearch$c = "La Mia Ricerca di Lavoro nel 2023";
const AddedFrom$c = "Aggiunto da";
const AddedUntil$c = "Aggiunto fino a";
const BasicModal$c = "Modale Base";
const AddnewSectionName$c = "Aggiungi Nuovo Nome di Sezione";
const OpenTo$c = "Aperto a";
const Featured$c = "In primo piano";
const LicenceAndCerts$c = "Licenze e certificati";
const Banner$c = "Banner";
const LinkedInURL$c = "URL di LinkedIn";
const Recommendations$c = "Raccomandazioni";
const LinkedinReview$c = "Recensione su Linkedin";
const NoDataAvailable$c = "Nessun dato disponibile";
const looksLikeYouDidNot$c = "Sembra che tu non abbia iniziato ad utilizzare la nostra";
const toOptimizeProfileScoreVisible$c = "per ottimizzare il tuo profilo LinkedIn ancora. Una volta fatto ciò, il punteggio del tuo profilo sarà visibile qui.";
const LinkedinComponent$c = {
	letsOptimize: "Ottimizziamo"
};
const improveYourChancesLandingDreamJob$c = "Migliora le tue possibilità di ottenere il lavoro dei tuoi sogni. Utilizza queste strategie provate e testate per dare al tuo profilo LinkedIn il tanto necessario restyling.";
const VisitProfile$c = "Visita il profilo";
const wantToGetLinkedinMakeover$c = "Vuoi ottenere una completa ristrutturazione del tuo profilo LinkedIn?";
const PostGenerator$c = "Generatore di post";
const LinkedinHeadlineGenerator$c = "Generatore di titoli LinkedIn";
const LinkedinAboutSectionGenerator$c = "Generatore della sezione 'Informazioni su LinkedIn'";
const AITools$c = "Strumenti AI";
const Premium$c = "Premium";
const LinkedInOptimization$c = "Ottimizzazione di LinkedIn";
const JobTracker$c = "Tracciatore di lavoro";
const whoIsHiring$c = "Chi sta assumendo";
const Autofill$c = "Riempimento automatico";
const HeadlineGenerator$c = "Generatore di titoli";
const skillMatching$c = "Abbinamento di competenze";
const SummarizeJD$c = "Riassunto della descrizione del lavoro";
const contactFeature$c = "Tracciamento dei contatti";
const documentFeature$c = "Documenti";
const landJobWithoutStress$c = "Trova il lavoro dei tuoi sogni. Senza stress.";
const discoverFeatures$c = "Scopri la gamma di funzionalità di Careerflow.ai progettate per semplificare la tua ricerca di lavoro e migliorare il tuo percorso professionale!";
const letsBeginOnboarding$c = "Conosciamoti meglio!";
const inTheNextFewScreensJobThirdParties$c = "Nelle prossime schermate, ti faremo alcune domande che ci aiuteranno a personalizzare l'esperienza per te e a compilare automaticamente le tue candidature (in modo che tu non debba farlo)! Non vendiamo i tuoi dati a terze parti.";
const letsAddBasicInformation$c = "Aggiungiamo le tue informazioni di base";
const Pleaseselectanoptionfirst$c = "Per favore, seleziona prima un'opzione.";
const JobApplicationTracker$c = "Tracciatore di candidature lavorative";
const LinkedInProfileOptimizer$c = "Ottimizzatore del profilo LinkedIn";
const UnlimitedDocuments$c = "Documenti illimitati";
const UnlimitedContacts$c = "Contatti illimitati";
const HiringManagerSearch$c = "Ricerca del responsabile delle assunzioni";
const AILinkedInPostGenerator$c = "Generatore di post AI su LinkedIn";
const ATSKeywordSkillMatch$c = "Lavoro corrispondente alle parole chiave / competenze ATS";
const ChooseyourPlan$c = "Scegli il tuo piano";
const superChargeYourJobSearch$c = "Potenzia la tua ricerca di lavoro e migliora il processo di candidatura, aumenta i tuoi colloqui e ottieni il lavoro dei tuoi sogni. Tutto con l'aiuto del toolkit premium di Careerflow.";
const startNowGoto$c = "Inizia ora (Vai all'app)";
const CreatedBy$c = "Creato Da";
const CreateNewNote$c = "Crea Nuova Nota";
const Nonotescreated$c = "Nessuna nota creata";
const approxTimeIsFourMinutes$c = "Il tempo approssimativo per completare il processo di onboarding è di 4 minuti.";
const Continue$c = "Continua";
const iWillDoLaterTakeMeToApp$c = "Lo farò più tardi. Portami all'app.";
const allDone$c = "Fatto tutto!";
const welcomeAbord$c = "Benvenuti a bordo!";
const letsBegin$c = "Cominciamo.";
const UpgradeyourplanandgetAIAssistance$c = "Aggiorna il tuo piano e ottieni l'assistenza dell'AI";
const DownloadPDF$c = "Scarica PDF";
const oopsWeCouldntProcessResume$c = "Ops, non siamo riusciti a elaborare questo curriculum.";
const MyProfile$c = "Il mio profilo";
const Setting$c = "Ambiente";
const Logout$c = "Esci";
const SignIn$c = "Accedi";
const Typeyourfirstnamehere$c = "Il tuo nome";
const Enteryourlastname$c = "Il tuo cognome";
const ManageSubscription$c = "Gestisci abbonamento";
const ifYouHaveDifficultiesProfile$c = "Se hai difficoltà con le informazioni del tuo profilo, ti preghiamo di contattare";
const forSupport$c = "per supporto.";
const whatIsIdealCompanySize$c = "Qual è la dimensione ideale della tua azienda?";
const Saveandcontinue$c = "Salva e continua";
const whatIsMinExpectedSalary$c = "Qual è il tuo salario minimo previsto (all'anno)?";
const Atleast$c = "Almeno";
const SlidetoAdjust$c = "Scorri per regolare";
const whatIndustryExcitedWork$c = "Quali settori ti entusiasmano?";
const Add$c = "Aggiungi";
const statusOfJobSearch$c = "Stato della tua ricerca di lavoro?";
const Finish$c = "Fine";
const whatLevelRoleLooking$c = "A quale livello di ruolo stai puntando?";
const Selectuptotwo$c = "Seleziona fino a due.";
const PreviousStep$c = "Passo precedente";
const Skip$c = "Salta";
const whatDoYouValueNewRole$c = "Cosa valorizzi in un nuovo ruolo?";
const Selectuptothree$c = "Seleziona fino a tre.";
const EqualEmploymentData$c = "Dati sull'uguaglianza nell'occupazione";
const whatIsYourEthnicity$c = "Qual è la tua etnia?";
const areYouAuthorizedToWorkUs$c = "Sei autorizzato a lavorare negli Stati Uniti?";
const willYouRequireSponsorShip$c = "Avrai bisogno di sponsorizzazione per lo status del visto di lavoro ora o in futuro?";
const doYouHaveADisability$c = "Hai una disabilità?";
const areYouAVeteran$c = "Sei un veterano?";
const rolesYouInterestedIn$c = "In che tipo di ruoli sei interessato/a?";
const Selectuptofive$c = "Seleziona fino a cinque.";
const AddCustomrole$c = "Aggiungi ruolo personalizzato";
const whereDoYouLikeWork$c = "Dove vorresti lavorare?";
const Resources$c = "Risorse";
const currentlyNoResourceAvailable$c = "Attualmente non sono disponibili risorse.";
const AddNewSection$c = "Aggiungi Nuova Sezione";
const ChangeSections$c = "Cambia sezioni";
const Settings$c = "Impostazioni";
const Dashboard$c = "Cruscotto";
const JobBoard$c = "Bacheca di Lavoro";
const Linkedin$c = "Linkedin";
const Community$c = "Comunità";
const FindRecruiters$c = "Trovare reclutatori";
const Goals$c = "Obiettivi";
const DownloadExtension$c = "Scarica Estensione";
const SuggestaFeature$c = "Suggerisci una funzionalità";
const leftPanel$c = {
	ReportanIssue: "Segnala un problema"
};
const PhoneNumberisrequired$c = "È richiesto il numero di telefono";
const MobileNumber$c = "Numero di cellulare";
const Enteronlynumbers$c = "Inserisci solo numeri.";
const Countryyoulivein$c = "Paese in cui vivi";
const SelectaCountry$c = "Seleziona un Paese";
const DateofBirth$c = "Data di nascita";
const Gender$c = "Sesso";
const JobPreferences$c = "Preferenze di lavoro";
const pleaseEnterValidEmail$c = "Inserisci un indirizzo email valido.";
const emailSendForResetting$c = "È stato inviato un'email per reimpostare la password";
const VerifyyourEmailID$c = "Verifica il tuo ID email";
const sentPleaseCheckEmail$c = "Inviato! Controlla la tua email.";
const tooManyAttemptsTryAgain$c = "Troppi tentativi, riprova tra un po' di tempo.";
const Resend$c = "Rispedisci";
const Login$c = "Accesso";
const weHaveSentVerificationLinkAtEmail$c = "Ti abbiamo inviato un link di verifica al tuo indirizzo email";
const pleaseVerifyEmailContinueSpam$c = "Verifica la tua email per continuare. Controlla anche la cartella spam o promozioni per l'email di verifica.";
const Logintogetstarted$c = "Accedi per iniziare.";
const ContinuewithGoogle$c = "Continua con Google";
const pleaseInputEmail$c = "Inserisci la tua email!";
const Password$c = "Password";
const pleaseInputPassword$c = "Inserisci la tua password!";
const passwordLowerUpperDigitSpecial$c = "La tua password deve contenere almeno una lettera minuscola, una maiuscola, una cifra e un carattere speciale.";
const atLeastSixChar$c = "Almeno 6 caratteri";
const forgotPassword$c = "Hai dimenticato la password?";
const Bysigninginyouagreetoour$c = "Accedendo, accetti i nostri";
const Terms$c = "Termini";
const Conditions$c = "Condizioni";
const and$c = "e";
const PrivacyPolicy$c = "Politica sulla privacy";
const theseAreTheTopsSkillsExtracted$c = "Queste sono le competenze principali estratte dalla descrizione del lavoro";
const TopSkills$c = "Competenze principali";
const weCoulNotExtractSkills$c = "Non siamo riusciti ad estrarre alcuna competenza da questa descrizione del lavoro.";
const upgradeToPremiumToView$c = "Aggiorna a Premium per visualizzare il punteggio di corrispondenza delle tue competenze nel curriculum.";
const SkillScore$c = "Punteggio Competenza";
const thisIsYourSkillScoreBasedOn$c = "Questo è il tuo punteggio di competenze basato sulla descrizione del lavoro e sul tuo curriculum.";
const theseSkllsAreStrongMatch$c = "Queste competenze sono una forte corrispondenza tra il tuo curriculum e la descrizione del lavoro";
const Strongmatch$c = "Corrispondenza Forte";
const theseSkillsArePartialMatch$c = "Queste competenze sono una corrispondenza parziale tra il tuo curriculum e la descrizione del lavoro.";
const Partialmatch$c = "Corrispondenza parziale";
const theseSkillsAreMissingFrom$c = "Queste parole chiave mancano nel tuo curriculum ma sono presenti nella descrizione del lavoro. Potrebbero essere competenze o parole chiave generali specifiche per l'opportunità di lavoro e potrebbero essere utili da aggiungere al tuo curriculum.";
const SkillMatchComponent$c = {
	removeSkill: "Qual è la tua principale ragione per segnalare un problema per la parola chiave"
};
const Optional$c = "Opzionale";
const Notrelevanttothejob$c = "Non rilevante per il lavoro";
const Notaskill$c = "Nessuna competenza";
const Toogeneric$c = "Troppo generico";
const Pleaseshareanyfeedback$c = "Per favore, condividi eventuali feedback";
const excludedKeywordsWillNot$c = "Le parole chiave escluse non verranno conteggiate nel tuo punteggio di corrispondenza per tutte le scansioni future. Puoi modificare le parole chiave escluse dal tuo profilo.";
const yesExcludeThisSkillFrom$c = "Sì, escludi questa competenza da tutte le scansioni del mio curriculum.";
const PartialMatch$c = "Corrispondenza Parziale";
const MissingKeywords$c = "Parole Chiave Mancanti";
const Providetitletotask$c = "Fornisci un titolo al compito";
const TasksList$c = "Lista delle attività";
const AddTask$c = "Aggiungi Compito";
const EnterTaskTitlehere$c = "Inserisci Titolo Compito qui";
const TasksComponent$c = {
	listEmpty: "Lista Compiti vuota, Crea Nuovi."
};
const CompletedTasks$c = "Attività completate";
const CompleteYourtasks$c = "Completa le tue attività";
const Steps$c = "Passi";
const PremiumMember$c = "Membro Premium";
const Thankyouforupgradingto$c = "Grazie per l'aggiornamento a";
const CareerflowPremium$c = "Flusso di carriera Premium";
const hereIsHowYouCanAccessPremium$c = "Ecco come accedere ai tuoi vantaggi Premium!";
const stepOne$c = "Passo 1";
const DownloadourChromeExtension$c = "Scarica la nostra estensione per Chrome.";
const youJobSearchCopilotIshere$c = "Il copilota AI della tua ricerca di lavoro è qui.";
const DownloadNow$c = "Scarica ora";
const stepTwo$c = "Passaggio 2";
const GetStarted$c = "Inizia";
const stepThree$c = "Passaggio 3";
const SignintoChromeExtension$c = "Accedi all'estensione di Chrome";
const entityCreated$c = "Nuovo {{entity}} creato.";
const entityUpdated$c = "{{entity}} aggiornato/a.";
const entityDeleted$c = "{{entity}} eliminato/a.";
const entityLinked$c = "{{entity}} collegato";
const entityUnlinked$c = "{{entity}} non collegato";
const entityMovedTo$c = "Spostato su {{entity}}";
const youAddedANewEntity$c = "Hai aggiunto una nuova {{entità}}.";
const personCreated$c = "{{creator}} ha creato un {{entity}} per {{owner}}";
const youUpdatedAEntity$c = "Hai aggiornato un {{entità}}.";
const personUpdated$c = "{{creator}} ha aggiornato un {{entity}} per {{owner}}.";
const youDeletedAEntity$c = "Hai eliminato un {{entità}}";
const personDeleted$c = "{{creator}} ha eliminato un {{entity}} per {{owner}}";
const youLinkedEntity$c = "Hai collegato un {{entity}} a questo lavoro.";
const personLinked$c = "{{creator}} ha collegato un {{entity}} a questo lavoro per {{owner}}";
const youUnlinked$c = "Hai scollegato un {{entity}} da questo lavoro";
const personUnlinked$c = "{{creator}} ha scollegato un {{entity}} da questo lavoro per {{owner}}.";
const youMovedEntity$c = "Hai spostato questa {{entity}} da {{sectionFrom}} a {{sectionTo}}";
const personMoved$c = "{{creator}} ha spostato questa {{entity}} da {{sectionFrom}} a {{sectionTo}} per {{owner}}";
const addedByName$c = "Aggiunto da {{name}}";
const DownloadChromeExtension$c = "Scarica l'estensione di Chrome";
const ourChromeExtensionIs$c = "La nostra estensione per Chrome è uno strumento integrato per aiutarti a ottimizzare il profilo LinkedIn, salvare lavori, salvare contatti, generare lettere di presentazione e altro ancora.";
const Optimizeyourprofile$c = "Ottimizza il tuo profilo";
const startOptimizingYourProfile$c = "Inizia ad ottimizzare il tuo profilo per avere maggiori possibilità di essere contattato dai recruiter.";
const OptimizeNow$c = "Ottimizza ora";
const Addyourfirstjob$c = "Aggiungi il tuo primo lavoro";
const startSavingJobApplicationsToTrack$c = "Inizia a salvare le candidature per tenere traccia del tuo percorso di ricerca del lavoro e trovare informazioni utili.";
const AddNow$c = "Aggiungi ora";
const CompleteProfile$c = "Profilo completo";
const completeYourProfileForUsing$c = "Completa il tuo profilo per utilizzare la funzione di auto-compilazione e ottenere un'esperienza più personalizzata.";
const CompleteNow$c = "Completa ora";
const Addyourfirstcontact$c = "Aggiungi il tuo primo contatto";
const addContactToFollowUpWith$c = "Aggiungi il contatto per seguirlo in seguito, aggiungi note e altro ancora.";
const JoinCommunity$c = "Unisciti alla comunità";
const ourCommunityisAlways$c = "La nostra comunità è sempre con te nel tuo percorso di ricerca del lavoro.";
const JoinNow$c = "Iscriviti ora";
const welcomeToCareerflow$c = "Benvenuti in Careerflow!";
const yourHubForCareerInsights2$c = "Questo è il tuo centro per le informazioni sulla carriera, le attività e altro ancora. Esplora il tuo cruscotto personalizzato per rimanere al top del tuo percorso professionale.";
const ChecklistCompleted$c = "La tua lista di controllo è completata!";
const Completeyourchecklist$c = "Completa la tua lista di controllo";
const completeAFewStepsTo$c = "Completa alcuni passaggi per ottenere il tuo prossimo lavoro.";
const Completed$c = "Completato";
const JobCountByStage$c = "Conteggio lavori per stadio";
const NopastapplicationDatafound$c = "Nessun dato di applicazione passata trovato";
const YourJobSearchStages$c = "Le fasi della tua ricerca di lavoro";
const NoDatafound$c = "Nessun dato trovato";
const it = {
	copyToClipboard: copyToClipboard$c,
	UnlocktheAIgenerated: UnlocktheAIgenerated$c,
	UpgradetoPremium: UpgradetoPremium$c,
	Result: Result$c,
	Copy: Copy$c,
	Save: Save$c,
	Edit: Edit$c,
	Processing: Processing$c,
	YourAIgeneratedcontentwillshowhere: YourAIgeneratedcontentwillshowhere$c,
	hopeYouFindUseful: hopeYouFindUseful$c,
	regenerate: regenerate$c,
	ProvideAdditionalFeedback: ProvideAdditionalFeedback$c,
	Enteranyfeedback: Enteranyfeedback$c,
	Notimpressive: Notimpressive$c,
	thisIsntTrue: thisIsntTrue$c,
	Notpersonalized: Notpersonalized$c,
	Tone: Tone$c,
	Length: Length$c,
	Template: Template$c,
	Generatedon: Generatedon$c,
	Copiedtoclipboard: Copiedtoclipboard$c,
	CopytoClipboard: CopytoClipboard$c,
	DownloadasPDF: DownloadasPDF$c,
	ViewDetails: ViewDetails$c,
	JobDescriptionImported: JobDescriptionImported$c,
	ImportfromJob: ImportfromJob$c,
	Saved: Saved$c,
	Applied: Applied$c,
	Offer: Offer$c,
	Interviewing: Interviewing$c,
	Rejected: Rejected$c,
	Search: Search$c,
	Import: Import$c,
	CoverLetterGeneratorHistory: CoverLetterGeneratorHistory$c,
	NoCoverLettersGenerated: NoCoverLettersGenerated$c,
	getStartedCoverLetter: getStartedCoverLetter$c,
	getStarted: getStarted$c,
	Documents: Documents$c,
	UploadNewDocument: UploadNewDocument$c,
	AICoverLetterGenerator: AICoverLetterGenerator$c,
	ViewHistory: ViewHistory$c,
	JobDescription: JobDescription$c,
	ImportfromBoard: ImportfromBoard$c,
	EnterJobDescription: EnterJobDescription$c,
	JobTitle: JobTitle$c,
	EnterJobTitle: EnterJobTitle$c,
	CompanyName: CompanyName$c,
	EnterCompanyName: EnterCompanyName$c,
	YourProfile: YourProfile$c,
	ResumeUpload: ResumeUpload$c,
	UseLinkedinProfile: UseLinkedinProfile$c,
	Uploadyourresume: Uploadyourresume$c,
	AddyourResume: AddyourResume$c,
	fileNameCannotFormat: fileNameCannotFormat$c,
	ChooseorUpload: ChooseorUpload$c,
	SelectTemplate: SelectTemplate$c,
	Preview: Preview$c,
	UseTemplate: UseTemplate$c,
	Change: Change$c,
	AdvancedSettings: AdvancedSettings$c,
	AdditionalContext: AdditionalContext$c,
	Professional: Professional$c,
	Casual: Casual$c,
	Enthusiastic: Enthusiastic$c,
	Informational: Informational$c,
	Short: Short$c,
	Medium: Medium$c,
	Long: Long$c,
	Language: Language$c,
	iAmOkayBack: iAmOkayBack$c,
	Generate: Generate$c,
	CoverLetter: CoverLetter$c,
	SelectLanguage: SelectLanguage$c,
	AboutGeneratorHistory: AboutGeneratorHistory$c,
	NoAboutsGenerated: NoAboutsGenerated$c,
	getStartedAbouts: getStartedAbouts$c,
	noAttachmentsFound: noAttachmentsFound$c,
	TargetJobTitle: TargetJobTitle$c,
	KeywordsToInclude: KeywordsToInclude$c,
	UploadYourResume: UploadYourResume$c,
	AddYourResume: AddYourResume$c,
	LinkedinProfile: LinkedinProfile$c,
	Linkedinprofilenotfound: Linkedinprofilenotfound$c,
	startUsingChromeExtension: startUsingChromeExtension$c,
	Download: Download$c,
	UseEmojis: UseEmojis$c,
	UseBulletPoints: UseBulletPoints$c,
	SpeechFocus: SpeechFocus$c,
	FirstPerson: FirstPerson$c,
	ThirdPerson: ThirdPerson$c,
	HeadlineGeneratorHistory: HeadlineGeneratorHistory$c,
	NoHeadlinesGenerated: NoHeadlinesGenerated$c,
	getStartedHeadline: getStartedHeadline$c,
	AIHeadlineGenerator: AIHeadlineGenerator$c,
	KeywordstoInclude: KeywordstoInclude$c,
	Pressenteraftereachword: Pressenteraftereachword$c,
	LinkedinProfilenotfound: LinkedinProfilenotfound$c,
	Headline: Headline$c,
	PostGeneratorHistory: PostGeneratorHistory$c,
	NoPostsGenerated: NoPostsGenerated$c,
	getStartedPost: getStartedPost$c,
	Topic: Topic$c,
	Description: Description$c,
	UseHashtags: UseHashtags$c,
	Custom: Custom$c,
	EnterCustomTone: EnterCustomTone$c,
	Added: Added$c,
	ComingSoon: ComingSoon$c,
	Company: Company$c,
	JobInterview: JobInterview$c,
	Research: Research$c,
	Networking: Networking$c,
	Referral: Referral$c,
	MustbeContacted: MustbeContacted$c,
	ScheduleaMeeting: ScheduleaMeeting$c,
	needAFollowUp: needAFollowUp$c,
	Today: Today$c,
	Viewdetails: Viewdetails$c,
	Activity: Activity$c,
	ActivityDetails: ActivityDetails$c,
	Delete: Delete$c,
	Title: Title$c,
	Goal: Goal$c,
	Status: Status$c,
	FollowUp: FollowUp$c,
	AddActivity: AddActivity$c,
	Enteractivitytitle: Enteractivitytitle$c,
	Cancel: Cancel$c,
	SaveActivity: SaveActivity$c,
	noActivityPresent: noActivityPresent$c,
	Addnew: Addnew$c,
	About: About$c,
	noDataPresentYou: noDataPresentYou$c,
	Experience: Experience$c,
	Education: Education$c,
	Skills: Skills$c,
	Overview: Overview$c,
	LinkedJobs: LinkedJobs$c,
	Notes: Notes$c,
	FullName: FullName$c,
	Location: Location$c,
	Relationship: Relationship$c,
	Contacts: Contacts$c,
	CreateContact: CreateContact$c,
	NotesCreated: NotesCreated$c,
	Notesupdated: Notesupdated$c,
	Addnote: Addnote$c,
	areYouSureDeleteNote: areYouSureDeleteNote$c,
	Createdby: Createdby$c,
	notSureWhyResumeCalls: notSureWhyResumeCalls$c,
	getExpertResumeReview: getExpertResumeReview$c,
	youHaventAddedContacts: youHaventAddedContacts$c,
	noMatchingContacts: noMatchingContacts$c,
	Link: Link$c,
	unlink: unlink$c,
	Locationnotavailable: Locationnotavailable$c,
	Emailnotavailable: Emailnotavailable$c,
	PhoneNumbernotavailable: PhoneNumbernotavailable$c,
	createdby: createdby$c,
	areYouSureDeleteContact: areYouSureDeleteContact$c,
	areYouSureUnlinkContact: areYouSureUnlinkContact$c,
	Addedbyyou: Addedbyyou$c,
	Addedby: Addedby$c,
	Timeline: Timeline$c,
	Timelineempty: Timelineempty$c,
	Discard: Discard$c,
	SaveContact: SaveContact$c,
	Recruiter: Recruiter$c,
	Candidate: Candidate$c,
	Colleague: Colleague$c,
	Employee: Employee$c,
	"Needtofollow-up": "Necessita di un Follow-up",
	EnterValidEmail: EnterValidEmail$c,
	EnterValidPhoneNumber: EnterValidPhoneNumber$c,
	editingProfileNotAvailable: editingProfileNotAvailable$c,
	itWillBeSoonAvailable: itWillBeSoonAvailable$c,
	ChromeExtension: ChromeExtension$c,
	SelectTag: SelectTag$c,
	FirstName: FirstName$c,
	FirstNameisrequired: FirstNameisrequired$c,
	LastName: LastName$c,
	LastNameisrequired: LastNameisrequired$c,
	Companyisrequired: Companyisrequired$c,
	Email: Email$c,
	ThisisnotavalidEmail: ThisisnotavalidEmail$c,
	AddEmail: AddEmail$c,
	PhoneNumber: PhoneNumber$c,
	notaValidPhone: notaValidPhone$c,
	phoneNoMinimum5char: phoneNoMinimum5char$c,
	phoneNoMinumum15char: phoneNoMinumum15char$c,
	AddPhoneNumber: AddPhoneNumber$c,
	SelectGoal: SelectGoal$c,
	SelectStatus: SelectStatus$c,
	Followup: Followup$c,
	SocialMedia: SocialMedia$c,
	Linkedinhandle: Linkedinhandle$c,
	Twitterhandle: Twitterhandle$c,
	Facebookhandle: Facebookhandle$c,
	Githubhandle: Githubhandle$c,
	Gmailhandle: Gmailhandle$c,
	Changessavedsuccessfully: Changessavedsuccessfully$c,
	EditContact: EditContact$c,
	BasicInformation: BasicInformation$c,
	EditContactDetails: EditContactDetails$c,
	SaveChanges: SaveChanges$c,
	phoneNoMinimum14char: phoneNoMinimum14char$c,
	LinkedIn: LinkedIn$c,
	Twitter: Twitter$c,
	Facebook: Facebook$c,
	Github: Github$c,
	Gmail: Gmail$c,
	youCanWriteAbout: youCanWriteAbout$c,
	Addednewsection: Addednewsection$c,
	Removedsuccessfully: Removedsuccessfully$c,
	Remove: Remove$c,
	Institute: Institute$c,
	Schoolisrequired: Schoolisrequired$c,
	Degree: Degree$c,
	StartMonth: StartMonth$c,
	StartYear: StartYear$c,
	EndMonth: EndMonth$c,
	EndYear: EndYear$c,
	Addmore: Addmore$c,
	PositionTitle: PositionTitle$c,
	ExperienceType: ExperienceType$c,
	Addednewitem: Addednewitem$c,
	whatSkillsDoYouEnjoy: whatSkillsDoYouEnjoy$c,
	Typeskillshere: Typeskillshere$c,
	LinkedContacts: LinkedContacts$c,
	LinkContact: LinkContact$c,
	NocontactsLinked: NocontactsLinked$c,
	JobContactsComponent: JobContactsComponent$c,
	Nocontacts: Nocontacts$c,
	LinkJobto: LinkJobto$c,
	Contact: Contact$c,
	Document: Document$c,
	Nojobsfound: Nojobsfound$c,
	LinkJob: LinkJob$c,
	youCanLinkContactJobImported: youCanLinkContactJobImported$c,
	Prev: Prev$c,
	Next: Next$c,
	areYouSureUnlinkDocument: areYouSureUnlinkDocument$c,
	areYouSureDeleteDocument: areYouSureDeleteDocument$c,
	Category: Category$c,
	CreatedOn: CreatedOn$c,
	Joblinked: Joblinked$c,
	Quickactions: Quickactions$c,
	All: All$c,
	Resume: Resume$c,
	Portfolio: Portfolio$c,
	Other: Other$c,
	Adddocument: Adddocument$c,
	Type: Type$c,
	Sortingby: Sortingby$c,
	SwitchtoGridLayout: SwitchtoGridLayout$c,
	SwitchtoListLayout: SwitchtoListLayout$c,
	NoDocumentsAdded: NoDocumentsAdded$c,
	DocumentsComponent: DocumentsComponent$c,
	NoDocumentFound: NoDocumentFound$c,
	SelectFile: SelectFile$c,
	onlyPdfDocxSupported: onlyPdfDocxSupported$c,
	Uploadfile: Uploadfile$c,
	DocumentCategory: DocumentCategory$c,
	SaveDocument: SaveDocument$c,
	AddDocument: AddDocument$c,
	LinkedDocuments: LinkedDocuments$c,
	LinkDocument: LinkDocument$c,
	NodocumentsLinked: NodocumentsLinked$c,
	JobDocumentsComponent: JobDocumentsComponent$c,
	NoDocuments: NoDocuments$c,
	CreateDocuments: CreateDocuments$c,
	youCanLinkDocumentJobImported: youCanLinkDocumentJobImported$c,
	Documenteditedsuccessfully: Documenteditedsuccessfully$c,
	DocumentDetails: DocumentDetails$c,
	UnsavedChanges: UnsavedChanges$c,
	yourChangesWillBeLostSureClose: yourChangesWillBeLostSureClose$c,
	yourChangesWillBeLostSureDiscard: yourChangesWillBeLostSureDiscard$c,
	DiscardChanges: DiscardChanges$c,
	WeeklyGoalAlert: WeeklyGoalAlert$c,
	Progress: Progress$c,
	AllGoals: AllGoals$c,
	Name: Name$c,
	Completedon: Completedon$c,
	Createdon: Createdon$c,
	Action: Action$c,
	Back: Back$c,
	OverallScore: OverallScore$c,
	Aboutthegoal: Aboutthegoal$c,
	GoalTracking: GoalTracking$c,
	Week: Week$c,
	progress: progress$c,
	loading: loading$c,
	Apply: Apply$c,
	Thisskillhasbeenreported: Thisskillhasbeenreported$c,
	issueGettingResume: issueGettingResume$c,
	Interview: Interview$c,
	Tasks: Tasks$c,
	Loading: Loading$c,
	Skilladdedsuccessfully: Skilladdedsuccessfully$c,
	problemAddingSkill: problemAddingSkill$c,
	Reportaproblem: Reportaproblem$c,
	Submit: Submit$c,
	Addanewskill: Addanewskill$c,
	JobDetailsComponent: JobDetailsComponent$c,
	HardSkill: HardSkill$c,
	SoftSkill: SoftSkill$c,
	Pleaseshareanyadditionalcontext: Pleaseshareanyadditionalcontext$c,
	Addasskill: Addasskill$c,
	Skill: Skill$c,
	JobFrequency: JobFrequency$c,
	ResumeFrequency: ResumeFrequency$c,
	Reportskill: Reportskill$c,
	JobDetails: JobDetails$c,
	ViewJobLink: ViewJobLink$c,
	Salary: Salary$c,
	areYouSureDeleteJob: areYouSureDeleteJob$c,
	ViewMore: ViewMore$c,
	ViewLess: ViewLess$c,
	matchYouSkillsAgainstJob: matchYouSkillsAgainstJob$c,
	pleaseUploadResumeSkillMatch: pleaseUploadResumeSkillMatch$c,
	AddResume: AddResume$c,
	thisJobDoesNotHaveAnyDesc: thisJobDoesNotHaveAnyDesc$c,
	youCanEditJobToAdd: youCanEditJobToAdd$c,
	chromeextension: chromeextension$c,
	fromVariousJobPortalsOnce: fromVariousJobPortalsOnce$c,
	AddDescription: AddDescription$c,
	CompanyInfo: CompanyInfo$c,
	Website: Website$c,
	Industry: Industry$c,
	EmployeeCount: EmployeeCount$c,
	ExprienceLevel: ExprienceLevel$c,
	Address: Address$c,
	Resumes: Resumes$c,
	Setasdefault: Setasdefault$c,
	Ok: Ok$c,
	UploadNewResume: UploadNewResume$c,
	Default: Default$c,
	Jobnotfound: Jobnotfound$c,
	EditDetails: EditDetails$c,
	JobPostURL: JobPostURL$c,
	Enterjoburl: Enterjoburl$c,
	Nojobselected: Nojobselected$c,
	Viewjobdetails: Viewjobdetails$c,
	Jobaddedtoyourboardsuccessfully: Jobaddedtoyourboardsuccessfully$c,
	AddJob: AddJob$c,
	Addnewjobname: Addnewjobname$c,
	JobUrl: JobUrl$c,
	Addjoburl: Addjoburl$c,
	Section: Section$c,
	didYouKnow: didYouKnow$c,
	Jobs: Jobs$c,
	AddJobtoboard: AddJobtoboard$c,
	Currentlynojobsareavailable: Currentlynojobsareavailable$c,
	noMatchingJobs: noMatchingJobs$c,
	welcomeToYourPersonalJobTracker: welcomeToYourPersonalJobTracker$c,
	weShortTutorialOnHowTrackingJob: weShortTutorialOnHowTrackingJob$c,
	Addanewjob: Addanewjob$c,
	inOrderTrackCreatButton: inOrderTrackCreatButton$c,
	Providesomedetails: Providesomedetails$c,
	toBeginTypeJobTitleCompany: toBeginTypeJobTitleCompany$c,
	asAnExampleFilledForYou: asAnExampleFilledForYou$c,
	wohooAddedFirstJob: wohooAddedFirstJob$c,
	youCanDragDropJobCard: youCanDragDropJobCard$c,
	Lastbutnotleast: Lastbutnotleast$c,
	finalStepMakeSure: finalStepMakeSure$c,
	autoMaticallyImportJobs: autoMaticallyImportJobs$c,
	selectanysection: selectanysection$c,
	Accept: Accept$c,
	My2023JobSearch: My2023JobSearch$c,
	AddedFrom: AddedFrom$c,
	AddedUntil: AddedUntil$c,
	BasicModal: BasicModal$c,
	AddnewSectionName: AddnewSectionName$c,
	OpenTo: OpenTo$c,
	Featured: Featured$c,
	LicenceAndCerts: LicenceAndCerts$c,
	Banner: Banner$c,
	LinkedInURL: LinkedInURL$c,
	Recommendations: Recommendations$c,
	LinkedinReview: LinkedinReview$c,
	NoDataAvailable: NoDataAvailable$c,
	looksLikeYouDidNot: looksLikeYouDidNot$c,
	toOptimizeProfileScoreVisible: toOptimizeProfileScoreVisible$c,
	LinkedinComponent: LinkedinComponent$c,
	improveYourChancesLandingDreamJob: improveYourChancesLandingDreamJob$c,
	VisitProfile: VisitProfile$c,
	wantToGetLinkedinMakeover: wantToGetLinkedinMakeover$c,
	PostGenerator: PostGenerator$c,
	LinkedinHeadlineGenerator: LinkedinHeadlineGenerator$c,
	LinkedinAboutSectionGenerator: LinkedinAboutSectionGenerator$c,
	AITools: AITools$c,
	Premium: Premium$c,
	LinkedInOptimization: LinkedInOptimization$c,
	JobTracker: JobTracker$c,
	whoIsHiring: whoIsHiring$c,
	Autofill: Autofill$c,
	HeadlineGenerator: HeadlineGenerator$c,
	skillMatching: skillMatching$c,
	SummarizeJD: SummarizeJD$c,
	contactFeature: contactFeature$c,
	documentFeature: documentFeature$c,
	landJobWithoutStress: landJobWithoutStress$c,
	discoverFeatures: discoverFeatures$c,
	letsBeginOnboarding: letsBeginOnboarding$c,
	inTheNextFewScreensJobThirdParties: inTheNextFewScreensJobThirdParties$c,
	letsAddBasicInformation: letsAddBasicInformation$c,
	Pleaseselectanoptionfirst: Pleaseselectanoptionfirst$c,
	JobApplicationTracker: JobApplicationTracker$c,
	LinkedInProfileOptimizer: LinkedInProfileOptimizer$c,
	UnlimitedDocuments: UnlimitedDocuments$c,
	UnlimitedContacts: UnlimitedContacts$c,
	HiringManagerSearch: HiringManagerSearch$c,
	AILinkedInPostGenerator: AILinkedInPostGenerator$c,
	ATSKeywordSkillMatch: ATSKeywordSkillMatch$c,
	"Auto-Apply": "Applicazione automatica",
	ChooseyourPlan: ChooseyourPlan$c,
	superChargeYourJobSearch: superChargeYourJobSearch$c,
	startNowGoto: startNowGoto$c,
	CreatedBy: CreatedBy$c,
	CreateNewNote: CreateNewNote$c,
	Nonotescreated: Nonotescreated$c,
	approxTimeIsFourMinutes: approxTimeIsFourMinutes$c,
	Continue: Continue$c,
	iWillDoLaterTakeMeToApp: iWillDoLaterTakeMeToApp$c,
	allDone: allDone$c,
	welcomeAbord: welcomeAbord$c,
	letsBegin: letsBegin$c,
	UpgradeyourplanandgetAIAssistance: UpgradeyourplanandgetAIAssistance$c,
	DownloadPDF: DownloadPDF$c,
	oopsWeCouldntProcessResume: oopsWeCouldntProcessResume$c,
	MyProfile: MyProfile$c,
	Setting: Setting$c,
	Logout: Logout$c,
	SignIn: SignIn$c,
	Typeyourfirstnamehere: Typeyourfirstnamehere$c,
	Enteryourlastname: Enteryourlastname$c,
	ManageSubscription: ManageSubscription$c,
	ifYouHaveDifficultiesProfile: ifYouHaveDifficultiesProfile$c,
	forSupport: forSupport$c,
	whatIsIdealCompanySize: whatIsIdealCompanySize$c,
	Saveandcontinue: Saveandcontinue$c,
	whatIsMinExpectedSalary: whatIsMinExpectedSalary$c,
	Atleast: Atleast$c,
	SlidetoAdjust: SlidetoAdjust$c,
	whatIndustryExcitedWork: whatIndustryExcitedWork$c,
	Add: Add$c,
	statusOfJobSearch: statusOfJobSearch$c,
	Finish: Finish$c,
	whatLevelRoleLooking: whatLevelRoleLooking$c,
	Selectuptotwo: Selectuptotwo$c,
	PreviousStep: PreviousStep$c,
	Skip: Skip$c,
	whatDoYouValueNewRole: whatDoYouValueNewRole$c,
	Selectuptothree: Selectuptothree$c,
	EqualEmploymentData: EqualEmploymentData$c,
	whatIsYourEthnicity: whatIsYourEthnicity$c,
	areYouAuthorizedToWorkUs: areYouAuthorizedToWorkUs$c,
	willYouRequireSponsorShip: willYouRequireSponsorShip$c,
	doYouHaveADisability: doYouHaveADisability$c,
	areYouAVeteran: areYouAVeteran$c,
	rolesYouInterestedIn: rolesYouInterestedIn$c,
	Selectuptofive: Selectuptofive$c,
	AddCustomrole: AddCustomrole$c,
	whereDoYouLikeWork: whereDoYouLikeWork$c,
	Resources: Resources$c,
	currentlyNoResourceAvailable: currentlyNoResourceAvailable$c,
	AddNewSection: AddNewSection$c,
	ChangeSections: ChangeSections$c,
	Settings: Settings$c,
	Dashboard: Dashboard$c,
	JobBoard: JobBoard$c,
	Linkedin: Linkedin$c,
	Community: Community$c,
	FindRecruiters: FindRecruiters$c,
	Goals: Goals$c,
	DownloadExtension: DownloadExtension$c,
	SuggestaFeature: SuggestaFeature$c,
	leftPanel: leftPanel$c,
	PhoneNumberisrequired: PhoneNumberisrequired$c,
	MobileNumber: MobileNumber$c,
	Enteronlynumbers: Enteronlynumbers$c,
	Countryyoulivein: Countryyoulivein$c,
	SelectaCountry: SelectaCountry$c,
	DateofBirth: DateofBirth$c,
	Gender: Gender$c,
	JobPreferences: JobPreferences$c,
	pleaseEnterValidEmail: pleaseEnterValidEmail$c,
	emailSendForResetting: emailSendForResetting$c,
	VerifyyourEmailID: VerifyyourEmailID$c,
	sentPleaseCheckEmail: sentPleaseCheckEmail$c,
	tooManyAttemptsTryAgain: tooManyAttemptsTryAgain$c,
	Resend: Resend$c,
	Login: Login$c,
	weHaveSentVerificationLinkAtEmail: weHaveSentVerificationLinkAtEmail$c,
	pleaseVerifyEmailContinueSpam: pleaseVerifyEmailContinueSpam$c,
	Logintogetstarted: Logintogetstarted$c,
	ContinuewithGoogle: ContinuewithGoogle$c,
	pleaseInputEmail: pleaseInputEmail$c,
	Password: Password$c,
	pleaseInputPassword: pleaseInputPassword$c,
	passwordLowerUpperDigitSpecial: passwordLowerUpperDigitSpecial$c,
	atLeastSixChar: atLeastSixChar$c,
	forgotPassword: forgotPassword$c,
	Bysigninginyouagreetoour: Bysigninginyouagreetoour$c,
	Terms: Terms$c,
	Conditions: Conditions$c,
	and: and$c,
	PrivacyPolicy: PrivacyPolicy$c,
	theseAreTheTopsSkillsExtracted: theseAreTheTopsSkillsExtracted$c,
	TopSkills: TopSkills$c,
	weCoulNotExtractSkills: weCoulNotExtractSkills$c,
	upgradeToPremiumToView: upgradeToPremiumToView$c,
	SkillScore: SkillScore$c,
	thisIsYourSkillScoreBasedOn: thisIsYourSkillScoreBasedOn$c,
	theseSkllsAreStrongMatch: theseSkllsAreStrongMatch$c,
	Strongmatch: Strongmatch$c,
	theseSkillsArePartialMatch: theseSkillsArePartialMatch$c,
	Partialmatch: Partialmatch$c,
	theseSkillsAreMissingFrom: theseSkillsAreMissingFrom$c,
	"Missing Keywords": "Parole chiave mancanti",
	SkillMatchComponent: SkillMatchComponent$c,
	Optional: Optional$c,
	Notrelevanttothejob: Notrelevanttothejob$c,
	Notaskill: Notaskill$c,
	Toogeneric: Toogeneric$c,
	Pleaseshareanyfeedback: Pleaseshareanyfeedback$c,
	excludedKeywordsWillNot: excludedKeywordsWillNot$c,
	yesExcludeThisSkillFrom: yesExcludeThisSkillFrom$c,
	PartialMatch: PartialMatch$c,
	MissingKeywords: MissingKeywords$c,
	Providetitletotask: Providetitletotask$c,
	TasksList: TasksList$c,
	AddTask: AddTask$c,
	EnterTaskTitlehere: EnterTaskTitlehere$c,
	TasksComponent: TasksComponent$c,
	CompletedTasks: CompletedTasks$c,
	CompleteYourtasks: CompleteYourtasks$c,
	Steps: Steps$c,
	PremiumMember: PremiumMember$c,
	Thankyouforupgradingto: Thankyouforupgradingto$c,
	CareerflowPremium: CareerflowPremium$c,
	hereIsHowYouCanAccessPremium: hereIsHowYouCanAccessPremium$c,
	stepOne: stepOne$c,
	DownloadourChromeExtension: DownloadourChromeExtension$c,
	youJobSearchCopilotIshere: youJobSearchCopilotIshere$c,
	DownloadNow: DownloadNow$c,
	stepTwo: stepTwo$c,
	GetStarted: GetStarted$c,
	stepThree: stepThree$c,
	SignintoChromeExtension: SignintoChromeExtension$c,
	entityCreated: entityCreated$c,
	entityUpdated: entityUpdated$c,
	entityDeleted: entityDeleted$c,
	entityLinked: entityLinked$c,
	entityUnlinked: entityUnlinked$c,
	entityMovedTo: entityMovedTo$c,
	youAddedANewEntity: youAddedANewEntity$c,
	personCreated: personCreated$c,
	youUpdatedAEntity: youUpdatedAEntity$c,
	personUpdated: personUpdated$c,
	youDeletedAEntity: youDeletedAEntity$c,
	personDeleted: personDeleted$c,
	youLinkedEntity: youLinkedEntity$c,
	personLinked: personLinked$c,
	youUnlinked: youUnlinked$c,
	personUnlinked: personUnlinked$c,
	youMovedEntity: youMovedEntity$c,
	personMoved: personMoved$c,
	addedByName: addedByName$c,
	DownloadChromeExtension: DownloadChromeExtension$c,
	ourChromeExtensionIs: ourChromeExtensionIs$c,
	Optimizeyourprofile: Optimizeyourprofile$c,
	startOptimizingYourProfile: startOptimizingYourProfile$c,
	OptimizeNow: OptimizeNow$c,
	Addyourfirstjob: Addyourfirstjob$c,
	startSavingJobApplicationsToTrack: startSavingJobApplicationsToTrack$c,
	AddNow: AddNow$c,
	CompleteProfile: CompleteProfile$c,
	completeYourProfileForUsing: completeYourProfileForUsing$c,
	CompleteNow: CompleteNow$c,
	Addyourfirstcontact: Addyourfirstcontact$c,
	addContactToFollowUpWith: addContactToFollowUpWith$c,
	JoinCommunity: JoinCommunity$c,
	ourCommunityisAlways: ourCommunityisAlways$c,
	JoinNow: JoinNow$c,
	welcomeToCareerflow: welcomeToCareerflow$c,
	yourHubForCareerInsights2: yourHubForCareerInsights2$c,
	ChecklistCompleted: ChecklistCompleted$c,
	Completeyourchecklist: Completeyourchecklist$c,
	completeAFewStepsTo: completeAFewStepsTo$c,
	Completed: Completed$c,
	JobCountByStage: JobCountByStage$c,
	NopastapplicationDatafound: NopastapplicationDatafound$c,
	YourJobSearchStages: YourJobSearchStages$c,
	NoDatafound: NoDatafound$c
};

const copyToClipboard$b = "Nukopijuota į iškarpinę!";
const UnlocktheAIgenerated$b = "Atrakinkite dirbtinio intelekto sukurtą.";
const UpgradetoPremium$b = "Pereiti prie Premium";
const Result$b = "Rezultatas";
const Copy$b = "Kopijuoti";
const Save$b = "Išsaugoti";
const Edit$b = "Redaguoti";
const Processing$b = "Apdorojama";
const YourAIgeneratedcontentwillshowhere$b = "Jūsų dirbtinai sukurtas turinys bus rodomas čia";
const hopeYouFindUseful$b = "Tikiuosi, kad šis rezultatas jums bus naudingas!";
const regenerate$b = "Perkurti";
const ProvideAdditionalFeedback$b = "Pateikti papildomą atsiliepimą";
const Enteranyfeedback$b = "Įveskite bet kokią grąžinimą";
const Notimpressive$b = "Nenuostabu";
const thisIsntTrue$b = "Tai netiesa";
const Notpersonalized$b = "Nepersonalizuota";
const Tone$b = "Tonas";
const Length$b = "Ilgis";
const Template$b = "Šablonas";
const Generatedon$b = "Sugeneruota";
const Copiedtoclipboard$b = "Nukopijuota į iškarpinę";
const CopytoClipboard$b = "Kopijuoti į iškarpinę";
const DownloadasPDF$b = "Atsisiųsti kaip PDF";
const ViewDetails$b = "Peržiūrėti informaciją";
const JobDescriptionImported$b = "Darbo aprašymas importuotas";
const ImportfromJob$b = "Importuoti iš darbo";
const Saved$b = "Išsaugota";
const Applied$b = "Pritaikyta";
const Offer$b = "Paslauga";
const Interviewing$b = "Interviu";
const Rejected$b = "Atmesta";
const Search$b = "Ieškoti";
const Import$b = "Importas";
const CoverLetterGeneratorHistory$b = "Motyvacinio laiško kūrėjo istorija";
const NoCoverLettersGenerated$b = "Nebuvo sukurti jokie motyviniai laiškai";
const getStartedCoverLetter$b = "Dar nebuvo sukurti jokie motyviniai laiškai. Pradėkite ir gaukite motyvinius laiškus, derinant darbo aprašą su savo atitinkama patirtimi.";
const getStarted$b = "Pradėkite!";
const Documents$b = "Dokumentai";
const UploadNewDocument$b = "Įkelti naują dokumentą";
const AICoverLetterGenerator$b = "Dirbtinio intelekto Motyvacinio laiško kūrėjas";
const ViewHistory$b = "Peržiūrėti istoriją";
const JobDescription$b = "Darbo aprašymas";
const ImportfromBoard$b = "Importuoti iš lentos";
const EnterJobDescription$b = "Įveskite darbo aprašymą";
const JobTitle$b = "Pareigos pavadinimas";
const EnterJobTitle$b = "Įveskite pareigų pavadinimą";
const CompanyName$b = "Įmonės pavadinimas";
const EnterCompanyName$b = "Įveskite įmonės pavadinimą";
const YourProfile$b = "Jūsų profilis";
const ResumeUpload$b = "CV įkėlimas";
const UseLinkedinProfile$b = "Naudokite „LinkedIn“ profilį";
const Uploadyourresume$b = "Įkelti savo CV";
const AddyourResume$b = "Pridėkite savo CV";
const fileNameCannotFormat$b = "Failo pavadinime negali būti tarpų arba pabraukimo ženklų ir jis turi būti formato .doc, .docx arba .pdf.";
const ChooseorUpload$b = "Pasirinkite arba įkelkite";
const SelectTemplate$b = "Pasirinkti šabloną";
const Preview$b = "Peržiūra";
const UseTemplate$b = "Naudoti šabloną";
const Change$b = "Keisti";
const AdvancedSettings$b = "Papildomi nustatymai";
const AdditionalContext$b = "Papildomas kontekstas";
const Professional$b = "Profesionalus";
const Casual$b = "Atsipalaidavęs";
const Enthusiastic$b = "Entuziastingas";
const Informational$b = "Informatyvus";
const Short$b = "Trumpas";
const Medium$b = "Vidutinio ilgio";
const Long$b = "Ilgas";
const Language$b = "Kalba";
const iAmOkayBack$b = "Viskas gerai! Grįžti atgal";
const Generate$b = "Generuoti";
const CoverLetter$b = "Motyvacinė kalba";
const SelectLanguage$b = "Pasirinkti kalbą";
const AboutGeneratorHistory$b = "Apie generatoriaus istoriją";
const NoAboutsGenerated$b = "Nebuvo sukurti jokie „Apie mane“ skyriai";
const getStartedAbouts$b = "Dar nebuvo sukurti jokie „Apie mane“ skyriai. Pradėkite ir gaukite „Apie mane“ skyrius, derinant darbo aprašą su savo atitinkama patirtimi.";
const noAttachmentsFound$b = "Nerasta priedų.";
const TargetJobTitle$b = "Norimas pareigų pavadinimas";
const KeywordsToInclude$b = "Įtraukti raktažodžiai";
const UploadYourResume$b = "Įkelti savo gyvenimo aprašymą";
const AddYourResume$b = "Pridėkite savo gyvenimo aprašymą";
const LinkedinProfile$b = "LinkedIn profilis";
const Linkedinprofilenotfound$b = "LinkedIn profilio nerasta";
const startUsingChromeExtension$b = "Pradėkite optimizuoti savo LinkedIn profilį naudodami mūsų „Chrome“ pratęsimą, kad galėtumėte naudoti šią parinktį.";
const Download$b = "Atsisiųsti";
const UseEmojis$b = "Naudoti emoji";
const UseBulletPoints$b = "Naudoti sąrašo taškus";
const SpeechFocus$b = "Kalbos akcentas";
const FirstPerson$b = "Pirmo asmens";
const ThirdPerson$b = "Trečio asmens";
const HeadlineGeneratorHistory$b = "Antraštės kūrėjo istorija";
const NoHeadlinesGenerated$b = "Nebuvo sukurtos jokios antraštės";
const getStartedHeadline$b = "Dar nebuvo sukurtos jokios antraštės. Pradėkite ir gaukite antraštes, derinant darbo aprašą su savo atitinkama patirtimi.";
const AIHeadlineGenerator$b = "Dirbtinio intelekto Antraštės kūrėjas";
const KeywordstoInclude$b = "Įtraukti raktažodžiai";
const Pressenteraftereachword$b = "Spauskite Enter po kiekvienos žodžio";
const LinkedinProfilenotfound$b = "LinkedIn profilio nerasta.";
const Headline$b = "Antraštė";
const PostGeneratorHistory$b = "Įrašo kūrėjo istorija";
const NoPostsGenerated$b = "Nebuvo sukurti jokie įrašai";
const getStartedPost$b = "Dar nebuvo sukurti jokie įrašai. Pradėkite ir gaukite įrašus, derinant darbo aprašą su savo atitinkama patirtimi.";
const Topic$b = "Tema";
const Description$b = "Aprašymas";
const UseHashtags$b = "Naudoti # žymes";
const Custom$b = "Pasirinktinis";
const EnterCustomTone$b = "Įveskite pasirinktinį toną";
const Added$b = "Pridėta";
const ComingSoon$b = {
	header: "Inžinieriai dirba!",
	content_1: "Mūsų inžinierių komanda sunkiai dirba, bandydama šią funkciją paleisti kuo greičiau",
	content_2: "Norite šios funkcijos greičiau? Praneškite mums, pažymėdami žemėlapį žemiau.",
	content_3: "Norėčiau šios funkcijos"
};
const Company$b = "Įmonė";
const JobInterview$b = "Darbo pokalbis";
const Research$b = "Tyrimas";
const Networking$b = "Tinklo kūrimas";
const Referral$b = "Siuntimas";
const MustbeContacted$b = "Būtina susisiekti";
const ScheduleaMeeting$b = "Susitarkite susitikimą";
const needAFollowUp$b = "Reikia sekti atgal.";
const Today$b = "Šiandien";
const Viewdetails$b = "Peržiūrėti informaciją";
const Activity$b = "Veikla";
const ActivityDetails$b = "Veiklos informacija";
const Delete$b = "Ištrinti";
const Title$b = "Pavadinimas";
const Goal$b = "Tikslas";
const Status$b = "Būsena";
const FollowUp$b = "Sekantis žingsnis";
const AddActivity$b = "Pridėti veiklą";
const Enteractivitytitle$b = "Įveskite veiklos pavadinimą";
const Cancel$b = "Atšaukti";
const SaveActivity$b = "Išsaugoti veiklą";
const noActivityPresent$b = "Nėra veiklos, pridėkite veiklą.";
const Addnew$b = "Pridėti naują";
const About$b = "Apie";
const noDataPresentYou$b = "Nėra duomenų, galite redaguoti šį kontaktą ir pridėti laukus.";
const Experience$b = "Patirtis";
const Education$b = "Išsilavinimas";
const Skills$b = "Įgūdžiai";
const Overview$b = "Apžvalga";
const LinkedJobs$b = "Susieti darbai";
const Notes$b = "Pastabos";
const FullName$b = "Pilnas vardas";
const Location$b = "Vieta";
const Relationship$b = "Santykis";
const Contacts$b = "Kontaktai";
const CreateContact$b = "Sukurti kontaktą";
const NotesCreated$b = "Pastabos sukurtos";
const Notesupdated$b = "Pastabos atnaujintos";
const Addnote$b = "Pridėti pastabą";
const areYouSureDeleteNote$b = "Ar tikrai norite ištrinti šią pastabą?";
const Createdby$b = "Sukūrė";
const notSureWhyResumeCalls$b = "Nesate tikri, kodėl jūsų gyvenimo aprašymas nesukelia jums pokalbių dėl darbo? ☎️";
const getExpertResumeReview$b = "Gaukite profesionalų gyvenimo aprašymo peržiūrą 💎✨";
const youHaventAddedContacts$b = "Jūs dar nepridėjote jokių kontaktų.";
const noMatchingContacts$b = "Nerasta atitinkančių kontaktų.";
const Link$b = "Nuoroda";
const unlink$b = "Atjungti";
const Locationnotavailable$b = "Vieta negalima";
const Emailnotavailable$b = "El. paštas nepasiekiamas";
const PhoneNumbernotavailable$b = "Telefono numeris nepasiekiamas";
const createdby$b = "sukurta";
const areYouSureDeleteContact$b = "Ar tikrai norite ištrinti šį kontaktą?";
const areYouSureUnlinkContact$b = "Ar tikrai norite atjungti šį kontaktą?";
const Addedbyyou$b = "Pridėta jūsų";
const Addedby$b = "Pridėta";
const Timeline$b = "Laiko juosta";
const Timelineempty$b = "Laiko juosta tuščia";
const Discard$b = "Atmesti";
const SaveContact$b = "Išsaugoti kontaktą";
const Recruiter$b = "Atsakingas asmuo už atranką";
const Candidate$b = "Kandidatas";
const Colleague$b = "Kolega";
const Employee$b = "Darbuotojas";
const EnterValidEmail$b = "Įveskite galiojantį el. paštą";
const EnterValidPhoneNumber$b = "Įveskite galiojantį telefono numerį";
const editingProfileNotAvailable$b = "Profilio nuotraukos redagavimas dar nėra galimas.";
const itWillBeSoonAvailable$b = "Tai greitai bus prieinama mūsų.";
const ChromeExtension$b = "Chrome plėtinys";
const SelectTag$b = "Pasirinkti žymę";
const FirstName$b = "Vardas";
const FirstNameisrequired$b = "Vardas privalomas";
const LastName$b = "Pavardė";
const LastNameisrequired$b = "Pavardė privaloma";
const Companyisrequired$b = "Reikalinga įmonė.";
const Email$b = "El. paštas";
const ThisisnotavalidEmail$b = "Tai neleidžiamas el. paštas.";
const AddEmail$b = "Pridėti el. paštą";
const PhoneNumber$b = "Telefono numeris";
const notaValidPhone$b = "Tai nėra galiojantis telefono numeris. Įveskite tik numerius.";
const phoneNoMinimum5char$b = "Telefono numeris turi būti mažiausiai 5 simboliai.";
const phoneNoMinumum15char$b = "Telefono numeris turi būti ne daugiau kaip 15 simbolių.";
const AddPhoneNumber$b = "Pridėti telefono numerį";
const SelectGoal$b = "Pasirinkite tikslą";
const SelectStatus$b = "Pasirinkite būseną";
const Followup$b = "Sekantis žingsnis";
const SocialMedia$b = "Socialiniai tinklai";
const Linkedinhandle$b = "Linkedin vartotojo vardas";
const Twitterhandle$b = "Twitter vardas";
const Facebookhandle$b = "Facebook vardas";
const Githubhandle$b = "Github vardas";
const Gmailhandle$b = "Gmail vardas";
const Changessavedsuccessfully$b = "Pakeitimai sėkmingai išsaugoti";
const EditContact$b = "Redaguoti kontaktą";
const BasicInformation$b = "Pagrindinė informacija";
const EditContactDetails$b = "Redaguoti kontaktų informaciją";
const SaveChanges$b = "Išsaugoti pakeitimus";
const phoneNoMinimum14char$b = "Telefono numeris turi būti mažiausiai 14 simbolių.";
const LinkedIn$b = "„LinkedIn“";
const Twitter$b = "Twitteras";
const Facebook$b = "Facebookas";
const Github$b = "Github";
const Gmail$b = "Gmail";
const youCanWriteAbout$b = "Galite rašyti apie savo patirties metus, pramonę ar įgūdžius. Žmonės taip pat kalba apie savo pasiekimus ar ankstesnes darbo patirtis.";
const Addednewsection$b = "Pridėta nauja sekcija";
const Removedsuccessfully$b = "Sėkmingai pašalinta.";
const Remove$b = "Pašalinti";
const Institute$b = "Institutas";
const Schoolisrequired$b = "Mokykla yra privaloma";
const Degree$b = "Laipsnis";
const StartMonth$b = "Pradžios mėnuo";
const StartYear$b = "Pradžios metai";
const EndMonth$b = "Pabaigos mėnuo";
const EndYear$b = "Pabaigos metai";
const Addmore$b = "Pridėti daugiau";
const PositionTitle$b = "Pareigos pavadinimas";
const ExperienceType$b = "Patirties tipas";
const Addednewitem$b = "Pridėtas naujas daiktas";
const whatSkillsDoYouEnjoy$b = "Kokias įgūdžius turite ar mėgstate dirbti su?";
const Typeskillshere$b = "Įveskite čia savo įgūdžius";
const LinkedContacts$b = "Susieti kontaktai";
const LinkContact$b = "Susieti kontaktą";
const NocontactsLinked$b = "Nėra susietų kontaktų";
const JobContactsComponent$b = {
	linkContact: "Susieję kontaktus, greitai matysite, kas yra svarbūs žmonės, tokių kaip atrankos atsakingasis, priėmimo vadovas ir kt., šiam vaidmeniui! Vėliau galėsime pateikti susijusius įžvalgų pagrindu, remdamiesi jūsų kontaktų duomenimis."
};
const Nocontacts$b = "Nėra kontaktų";
const LinkJobto$b = "Susieti darbą su";
const Contact$b = "Kontaktai";
const Document$b = "Dokumentas";
const Nojobsfound$b = "Nerasta darbų";
const LinkJob$b = "Susieti darbą";
const youCanLinkContactJobImported$b = "Jūs galite susieti šį kontaktą su darbu, kurį importavote į Careerflow.";
const Prev$b = "Nuvykęs";
const Next$b = "Sekantis";
const areYouSureUnlinkDocument$b = "Ar tikrai norite atjungti šį dokumentą?";
const areYouSureDeleteDocument$b = "Ar tikrai norite ištrinti šį dokumentą?";
const Category$b = "Kategorija";
const CreatedOn$b = "Sukurta";
const Joblinked$b = "Darbas susietas";
const Quickactions$b = "Greiti veiksmai";
const All$b = "Visi";
const Resume$b = "Gyvenimo aprašymas";
const Portfolio$b = "Portfolio";
const Other$b = "Kitas";
const Adddocument$b = "Pridėti dokumentą";
const Type$b = "Tipas";
const Sortingby$b = "Rūšiavimas pagal";
const SwitchtoGridLayout$b = "Perjungti į tinklelio išdėstymą.";
const SwitchtoListLayout$b = "Perjungti į sąrašo išdėstymą.";
const NoDocumentsAdded$b = "Nėra pridėtų dokumentų";
const DocumentsComponent$b = {
	nodocs: "Jūs dar nepasidarėte jokių dokumentų. Galite įkelti gyvenimo aprašymo versijas, motyvacinės kalbos ir daugiau ir susieti juos su sekamais darbais!"
};
const NoDocumentFound$b = "Nerasta dokumentų";
const SelectFile$b = "Pasirinkite failą";
const onlyPdfDocxSupported$b = "Palaikomi tik .pdf ir .docx failai.";
const Uploadfile$b = "Įkelti failą";
const DocumentCategory$b = "Dokumento kategorija";
const SaveDocument$b = "Išsaugoti dokumentą";
const AddDocument$b = "Pridėti dokumentą";
const LinkedDocuments$b = "Susieti dokumentai";
const LinkDocument$b = "Susieti dokumentą";
const NodocumentsLinked$b = "Nėra susietų dokumentų";
const JobDocumentsComponent$b = {
	linkDocs: "Visus susijusius dokumentus, tokius kaip gyvenimo aprašymas, motyvacinė kalba ir kt., kuriuos pateikėte šiam darbui, susieję, padės jums viską stebėti vienoje vietoje. Išbandykite tai!"
};
const NoDocuments$b = "Nėra dokumentų";
const CreateDocuments$b = "Sukurti dokumentus";
const youCanLinkDocumentJobImported$b = "Jūs galite susieti šį dokumentą su darbu, kurį importavote į Careerflow.";
const Documenteditedsuccessfully$b = "Dokumentas sėkmingai redaguotas";
const DocumentDetails$b = "Dokumento informacija";
const UnsavedChanges$b = "Neišsaugoti pakeitimai";
const yourChangesWillBeLostSureClose$b = "Jūsų pakeitimai bus prarasti, ar tikrai norite uždaryti?";
const yourChangesWillBeLostSureDiscard$b = "Jūsų pakeitimai bus prarasti, ar tikrai norite atsisakyti savo pakeitimų?";
const DiscardChanges$b = "Atmesti pakeitimus";
const WeeklyGoalAlert$b = "Savaitinis tikslų įspėjimas";
const Progress$b = "Pokytis";
const AllGoals$b = "Visi tikslai";
const Name$b = "Vardas";
const Completedon$b = "Baigta";
const Createdon$b = "Sukurta";
const Action$b = "Veiksmas";
const Back$b = "Atgal";
const OverallScore$b = "Bendras įvertinimas";
const Aboutthegoal$b = "Apie tikslą";
const GoalTracking$b = "Tikslo sekimas";
const Week$b = "Savaitė";
const progress$b = "pažanga";
const loading$b = "Kraunama";
const Apply$b = "Pritaikyti";
const Thisskillhasbeenreported$b = "Ši gebėjimas buvo praneštas.";
const issueGettingResume$b = "Buvo problema gauti gyvenimo aprašymą.";
const Interview$b = "Interviu";
const Tasks$b = "Užduotys";
const Loading$b = "Kraunama";
const Skilladdedsuccessfully$b = "Įgūdis sėkmingai pridėtas.";
const problemAddingSkill$b = "Kilo problema pridedant įgūdžių.";
const Reportaproblem$b = "Pranešti apie problemą";
const Submit$b = "Pateikti";
const Addanewskill$b = "Pridėti naują įgūdį";
const JobDetailsComponent$b = {
	classifySkill: "Kaip jūs klasifikuotumėte šią įgūdžių (neprivaloma)",
	includedKeywordsWillCount: "Įtraukti šį raktažodį?",
	yesIncludeThisSkill: "Įtraukti raktažodžiai bus įskaičiuoti į jūsų atitikimo rezultatą visiems ateities skenavimams. Galite pakeisti įtrauktus raktažodžius savo profilyje.",
	addSkill: "Ar norite pridėti tai kaip įgūdį?"
};
const HardSkill$b = "Sunkus įgūdis";
const SoftSkill$b = "Minkštas įgūdis";
const Pleaseshareanyadditionalcontext$b = "Prašome dalintis papildomu kontekstu";
const Addasskill$b = "Pridėti kaip įgūdį";
const Skill$b = "Įgūdis";
const JobFrequency$b = "Darbo dažnis";
const ResumeFrequency$b = "CV dažnis";
const Reportskill$b = "Pranešti apie įgūdį";
const JobDetails$b = "Darbo informacija";
const ViewJobLink$b = "Peržiūrėti darbo nuorodą";
const Salary$b = "Atlyginimas";
const areYouSureDeleteJob$b = "Ar tikrai norite ištrinti šį darbą?";
const ViewMore$b = "Rodyti daugiau";
const ViewLess$b = "Rodyti mažiau";
const matchYouSkillsAgainstJob$b = "Atitinkite savo įgūdžius su darbo aprašymu.";
const pleaseUploadResumeSkillMatch$b = "Norėdami gauti savo įgūdžių atitikimo rezultatą, įkelkite savo gyvenimo aprašymą.";
const AddResume$b = "Pridėti CV";
const thisJobDoesNotHaveAnyDesc$b = "Ši darbo vieta neturi jokio aprašymo.";
const youCanEditJobToAdd$b = "Galite redaguoti šį darbą, kad pridėtumėte aprašymą. Taip pat galite importuoti darbus naudodami mūsų.";
const chromeextension$b = "chromo plėtinys";
const fromVariousJobPortalsOnce$b = "iš įvairių darbo portalų. Kai pridėsite aprašymą, taip pat galėsite pamatyti susijusią sugebėjimų informaciją.";
const AddDescription$b = "Pridėti aprašymą.";
const CompanyInfo$b = "Įmonės informacija";
const Website$b = "Tinklapis";
const Industry$b = "Industrė";
const EmployeeCount$b = "Darbuotojų skaičius";
const ExprienceLevel$b = "Patirties lygis";
const Address$b = "Adresas";
const Resumes$b = "CV";
const Setasdefault$b = "Nustatyti kaip numatytąjį";
const Ok$b = "Gerai";
const UploadNewResume$b = "Įkelti naują CV";
const Default$b = "Numatytasis";
const Jobnotfound$b = "Darbo pasiūlymo nerasta";
const EditDetails$b = "Redaguoti informaciją";
const JobPostURL$b = "Darbo skelbimo URL";
const Enterjoburl$b = "Įveskite darbo URL";
const Nojobselected$b = "Nepasirinkta jokia darbo pozicija";
const Viewjobdetails$b = "Peržiūrėti darbo informaciją";
const Jobaddedtoyourboardsuccessfully$b = "Darbas sėkmingai pridėtas į jūsų lentą";
const AddJob$b = "Pridėti darbą";
const Addnewjobname$b = "Pridėti naują darbo pavadinimą";
const JobUrl$b = "Darbo nuoroda";
const Addjoburl$b = "Pridėti darbo URL";
const Section$b = "Skyrius";
const didYouKnow$b = {
	chromeExtension: "Ar žinote? Galite taip pat išsaugoti darbus tiesiogiai naudodami mūsų 'Chrome Extension' ir visus duomenis importuoti vienu paspaudimu! Tai užtrunka vos kelias sekundes."
};
const Jobs$b = "Darbai";
const AddJobtoboard$b = "Pridėti darbą į lentą.";
const Currentlynojobsareavailable$b = "Šiuo metu nėra laisvų darbo vietų.";
const noMatchingJobs$b = "Nerasta atitinkančių darbų.";
const welcomeToYourPersonalJobTracker$b = "Sveiki atvykę į jūsų asmeninį darbo sekimo įrankį!";
const weShortTutorialOnHowTrackingJob$b = "Mes pateiksime jums trumpą vadovą, kaip pradėti stebėti savo darbo aplikacijas keliais paprastais žingsniais!";
const Addanewjob$b = "Pridėti naują darbą.";
const inOrderTrackCreatButton$b = "Norėdami pradėti stebėti darbo aplikacijas, pirmiausia turite pridėti ją į lentą, spustelėdami mygtuką „Sukurti“.";
const Providesomedetails$b = "Pateikite kai kuriuos detalės.";
const toBeginTypeJobTitleCompany$b = "Pradėkite nuo to, kad tiesiog įveskite darbo pavadinimą, įmonės pavadinimą ir būseną, kurią norite pridėti. Vėliau galite pridėti daugiau informacijos, bet dabar tai viskas, ko jums reikia!";
const asAnExampleFilledForYou$b = "Pavyzdžiui, mes jau užpildėme tai už jus!";
const wohooAddedFirstJob$b = "Woohoo! Pridėjai pirmąjį darbą į savo darbo sekimo sistemą!";
const youCanDragDropJobCard$b = "Dabar galite vilkti ir mesti darbo kortelę į įvairias darbo aplikacijos proceso stadijas. Spustelėję darbo kortelę, galėsite peržiūrėti daugiau informacijos, ją redaguoti, įrašyti pastabas ir daugiau!";
const Lastbutnotleast$b = "Paskutinis, bet ne mažiau svarbus";
const finalStepMakeSure$b = "Kaip paskutinį žingsnį, įsitikinkite, kad turite mūsų.";
const autoMaticallyImportJobs$b = "Tai leis jums automatiškai importuoti darbo pasiūlymus iš jūsų mėgstamų darbo paieškos svetainių, tokių kaip LinkedIn, Indeed ir kt.! Mūsų plėtinys taip pat padeda gerinti jūsų LinkedIn profilį ir gauti 2,5 kartus daugiau paieškos rezultatų!";
const selectanysection$b = "pasirinkite bet kurią sekciją";
const Accept$b = "Priimti";
const My2023JobSearch$b = "Mano 2023 m. darbo paieška";
const AddedFrom$b = "Pridėta iš";
const AddedUntil$b = "Pridėta iki";
const BasicModal$b = "Pagrindinis modalinis langas";
const AddnewSectionName$b = "Pridėti naują skyriaus pavadinimą";
const OpenTo$b = "Atviras";
const Featured$b = "Pateiktas";
const LicenceAndCerts$b = "Licencijos ir sertifikatai";
const Banner$b = "Baneris";
const LinkedInURL$b = "„LinkedIn“ URL";
const Recommendations$b = "Rekomendacijos";
const LinkedinReview$b = "Linkedin apžvalga";
const NoDataAvailable$b = "Nėra duomenų.";
const looksLikeYouDidNot$b = "Atrodo, kad dar nesate pradėję naudoti mūsų";
const toOptimizeProfileScoreVisible$b = "dar nesate optimizavę savo LinkedIn profilio. Kai tai padarysite, jūsų profilio įvertinimas bus matomas čia.";
const LinkedinComponent$b = {
	letsOptimize: "Optimizuokime"
};
const improveYourChancesLandingDreamJob$b = "Pagerinkite savo galimybes įsidarbinti svajonių darbą. Naudokite šias išbandytas ir patikrintas strategijas, kad suteiktumėte savo LinkedIn profilui reikiamą atnaujinimą.";
const VisitProfile$b = "Aplankyti profilį";
const wantToGetLinkedinMakeover$b = "Norite gauti visišką LinkedIn atnaujinimą?";
const PostGenerator$b = "Įrašo kūrėjas";
const LinkedinHeadlineGenerator$b = "„LinkedIn“ antraštės kūrėjas";
const LinkedinAboutSectionGenerator$b = "„LinkedIn“ apie skyriaus kūrėjas";
const AITools$b = "Dirbtiniai intelekto įrankiai";
const Premium$b = "Aukščiausios kokybės";
const LinkedInOptimization$b = "LinkedIn optimizavimas";
const JobTracker$b = "Darbo sekimo sistema";
const whoIsHiring$b = "Kas įdarbiną?";
const Autofill$b = "#ERROR!";
const HeadlineGenerator$b = "Antraščių kūrėjas";
const skillMatching$b = "Įgūdžių atitikimas";
const SummarizeJD$b = "Suvesti darbo aprašymą";
const contactFeature$b = "Kontaktų sekimas";
const documentFeature$b = "Dokumentai";
const landJobWithoutStress$b = "Pasiekti savo svajonių darbą. Be streso.";
const discoverFeatures$b = "Atraskite Careerflow.ai funkcijų spektrą, skirtą optimizuoti darbo paieškas ir pagerinti jūsų profesinę kelionę!";
const letsBeginOnboarding$b = "Gerai pažinkime jus geriau!";
const inTheNextFewScreensJobThirdParties$b = "Kituose keliose ekranose mes jums užduosime kelis klausimus, kurie padės mums pritaikyti patirtį jums ir automatiškai užpildys jūsų darbo paraiškas (kad jums nereikėtų to daryti)! Mes neperduodame jūsų duomenų trečiosioms šalims.";
const letsAddBasicInformation$b = "Pridėkime tavo pagrindinę informaciją";
const Pleaseselectanoptionfirst$b = "Prašome pirmiausia pasirinkti parinktį.";
const JobApplicationTracker$b = "Darbo aplikacijų sekimas";
const LinkedInProfileOptimizer$b = "Linked In profilio optimizatorius";
const UnlimitedDocuments$b = "Neriboti dokumentai";
const UnlimitedContacts$b = "Neriboti kontaktai";
const HiringManagerSearch$b = "Darbdavio paieška";
const AILinkedInPostGenerator$b = "AI LinkedIn skelbimų kūrėjas";
const ATSKeywordSkillMatch$b = "ATS raktažodžių / įgūdžių atitikimo darbas";
const ChooseyourPlan$b = "Pasirinkite savo planą";
const superChargeYourJobSearch$b = "Paspartinkite savo darbo paiešką ir pagerinkite savo darbo paraiškos procesą, padidinkite savo pokalbius ir pasieksite savo svajonių darbą. Visa tai su Careerflow premijos įrankių rinkiniu.";
const startNowGoto$b = "Pradėkite dabar (Eikite į programą)";
const CreatedBy$b = "Sukūrė";
const CreateNewNote$b = "Sukurti naują pastabą";
const Nonotescreated$b = "Nėra sukurta pastabų";
const approxTimeIsFourMinutes$b = "Apytikslis laikas, reikalingas užbaigti įdarbinimo procesą, yra 4 minutės.";
const Continue$b = "Tęsti";
const iWillDoLaterTakeMeToApp$b = "Aš tai padarysiu vėliau. Nuvesk mane į programą.";
const allDone$b = "Viskas padaryta!";
const welcomeAbord$b = "Sveiki atvykę!";
const letsBegin$b = "Pradėkime";
const UpgradeyourplanandgetAIAssistance$b = "Pakeiskite savo planą ir gaukite dirbtinio intelekto pagalbą";
const DownloadPDF$b = "Atsisiųskite PDF";
const oopsWeCouldntProcessResume$b = "Oi, mes negalėjome apdoroti šio gyvenimo aprašymo.";
const MyProfile$b = "Mano profilis";
const Setting$b = "Nustatymas";
const Logout$b = "Atsijungti";
const SignIn$b = "Prisijungti";
const Typeyourfirstnamehere$b = "Tavo Vardas";
const Enteryourlastname$b = "Jūsų pavardė";
const ManageSubscription$b = "Tvarkyti prenumeratą";
const ifYouHaveDifficultiesProfile$b = "Jei turite sunkumų su savo profilio informacija, prašome susisiekti su";
const forSupport$b = "palaikymui.";
const whatIsIdealCompanySize$b = "Kokia yra jūsų idealioji įmonės dydis?";
const Saveandcontinue$b = "Išsaugoti ir Tęsti";
const whatIsMinExpectedSalary$b = "Kokia yra Jūsų minimali tikimasi alga (per metus)?";
const Atleast$b = "Mažiausiai";
const SlidetoAdjust$b = "Slinkti, kad sureguliuoti";
const whatIndustryExcitedWork$b = "Kokios pramonės jums kelia susidomėjimą?";
const Add$b = "Pridėti";
const statusOfJobSearch$b = "Kokia yra jūsų darbo paieškos padėtis?";
const Finish$b = "Pabaiga";
const whatLevelRoleLooking$b = "Kokio lygio vaidmenį ieškote?";
const Selectuptotwo$b = "Pasirinkite iki dviejų.";
const PreviousStep$b = "Ankstesnis žingsnis";
const Skip$b = "Praleisti";
const whatDoYouValueNewRole$b = "Kokias savybes vertinate naujoje pareigoje?";
const Selectuptothree$b = "Pasirinkite iki trijų.";
const EqualEmploymentData$b = "Lygių galimybių darbo statistika";
const whatIsYourEthnicity$b = "Kokia yra tavo etninė kilmė?";
const areYouAuthorizedToWorkUs$b = "Ar turite leidimą dirbti JAV?";
const willYouRequireSponsorShip$b = "Ar jums dabar ar ateityje reikės rėmimo darbo vizos statusui?";
const doYouHaveADisability$b = "Ar turite negalią?";
const areYouAVeteran$b = "Ar esate karo veteranas?";
const rolesYouInterestedIn$b = "Kokio tipo vaidmenys jus domina?";
const Selectuptofive$b = "Pasirinkite iki penkių.";
const AddCustomrole$b = "Pridėti pasirinktinę rolę";
const whereDoYouLikeWork$b = "Kur norėtumėte dirbti?";
const Resources$b = "Resursai";
const currentlyNoResourceAvailable$b = "Šiuo metu nėra jokių išteklių.";
const AddNewSection$b = "Pridėti naują skyrių";
const ChangeSections$b = "Pakeisti skyrius";
const Settings$b = "Nustatymai";
const Dashboard$b = "Valdymo skydas";
const JobBoard$b = "Darbo skelbimų lentelė";
const Linkedin$b = "Linkedin";
const Community$b = "Bendruomenė";
const FindRecruiters$b = "Rasti atrankos specialistus";
const Goals$b = "Tikslai";
const DownloadExtension$b = "Atsisiųsti plėtinį";
const SuggestaFeature$b = "Pasiūlykite funkciją";
const leftPanel$b = {
	ReportanIssue: "Pateikti problemą"
};
const PhoneNumberisrequired$b = "Reikalingas telefono numeris.";
const MobileNumber$b = "Mobilusis numeris";
const Enteronlynumbers$b = "Įveskite tik skaičius.";
const Countryyoulivein$b = "Šalis, kurioje gyvenate";
const SelectaCountry$b = "Pasirinkite šalį";
const DateofBirth$b = "Gimimo data";
const Gender$b = "Lytis";
const JobPreferences$b = "Darbo pageidavimai";
const pleaseEnterValidEmail$b = "Prašome įvesti galiojantį el. paštą.";
const emailSendForResetting$b = "Jums buvo išsiųstas el. laiškas, skirtas slaptažodžio atstatymui.";
const VerifyyourEmailID$b = "Patvirtinkite savo el. pašto adresą.";
const sentPleaseCheckEmail$b = "Išsiųsta! Prašome patikrinti savo el. paštą.";
const tooManyAttemptsTryAgain$b = "Per daug bandymų, prašome pabandyti vėliau.";
const Resend$b = "Pakartoti siuntimą";
const Login$b = "Prisijungimas";
const weHaveSentVerificationLinkAtEmail$b = "Mes išsiuntėme jums patvirtinimo nuorodą į jūsų el. paštą.";
const pleaseVerifyEmailContinueSpam$b = "Prašome patvirtinti savo el. paštą, kad galėtumėte tęsti. Taip pat patikrinkite savo šlamšto ar reklaminius laiškus dėl patvirtinimo el. laiško.";
const Logintogetstarted$b = "Prisijunkite, kad pradėtumėte.";
const ContinuewithGoogle$b = "Tęsti su Google";
const pleaseInputEmail$b = "Įveskite savo el. paštą!";
const Password$b = "Slaptažodis";
const pleaseInputPassword$b = "Įveskite savo slaptažodį!";
const passwordLowerUpperDigitSpecial$b = "Jūsų slaptažodis turi būti sudarytas bent iš vienos mažosios raidės, didžiosios raidės, skaitmens ir specialaus simbolio.";
const atLeastSixChar$b = "Mažiausiai 6 simboliai.";
const forgotPassword$b = "Pamiršote slaptažodį?";
const Bysigninginyouagreetoour$b = "Prisijungdami sutinkate su mūsų.";
const Terms$b = "Sąlygos";
const Conditions$b = "Sąlygos";
const and$b = "ir";
const PrivacyPolicy$b = "Privatumo politika";
const theseAreTheTopsSkillsExtracted$b = "Tai yra pagrindinės įgūdžių ištraukos iš darbo aprašymo.";
const TopSkills$b = "Top įgūdžiai";
const weCoulNotExtractSkills$b = "Mes negalėjome išgauti jokių įgūdžių iš šios darbo aprašymo.";
const upgradeToPremiumToView$b = "Pereikite į Premium, kad pamatytumėte savo gyvenimo aprašymo įgūdžių atitikimo rezultatą";
const SkillScore$b = "Įgūdžių įvertinimas";
const thisIsYourSkillScoreBasedOn$b = "Tai yra jūsų įgūdžių įvertinimas, remiantis darbo aprašymu ir jūsų gyvenimo aprašymu.";
const theseSkllsAreStrongMatch$b = "Šios įgūdžių yra stiprus atitikimas tarp jūsų gyvenimo aprašymo ir darbo aprašymo.";
const Strongmatch$b = "Stiprus atitikimas";
const theseSkillsArePartialMatch$b = "Šios įgūdžių yra dalinis atitikimas tarp jūsų gyvenimo aprašymo ir darbo aprašymo.";
const Partialmatch$b = "Dalinis atitikmuo";
const theseSkillsAreMissingFrom$b = "Šie raktiniai žodžiai trūksta jūsų gyvenimo aprašyme, tačiau jie yra paminėti darbo aprašyme. Tai gali būti įgūdžiai ar bendrieji raktiniai žodžiai, kurie yra specifiniai darbo galimybei ir gali būti naudingi pridėjant juos į jūsų gyvenimo aprašymą.";
const SkillMatchComponent$b = {
	removeSkill: "Koks pagrindinis jūsų pranešimo dėl raktažodžio priežastis"
};
const Optional$b = "Neprivaloma";
const Notrelevanttothejob$b = "Nesijungia prie darbo";
const Notaskill$b = "Neįgūdis";
const Toogeneric$b = "Per daug bendras";
const Pleaseshareanyfeedback$b = "Prašome dalintis atsiliepimais";
const excludedKeywordsWillNot$b = "Išskirti raktažodžiai ateityje nebus įskaičiuojami į jūsų atitikimo rezultatą visiems būsimiems skenavimams. Jūs galite keisti išskirtus raktažodžius savo profilyje.";
const yesExcludeThisSkillFrom$b = "Taip, pašalinkite šią įgūdžių kategoriją iš visų mano gyvenimo aprašymų skenavimų.";
const PartialMatch$b = "Dalinis atitikimas";
const MissingKeywords$b = "Trūksta raktinių žodžių";
const Providetitletotask$b = "Pateikite užduoties pavadinimą";
const TasksList$b = "Užduočių sąrašas";
const AddTask$b = "Pridėti užduotį";
const EnterTaskTitlehere$b = "Įveskite užduoties pavadinimą čia";
const TasksComponent$b = {
	listEmpty: "Užduočių sąrašas tuščias, sukurti naują."
};
const CompletedTasks$b = "Baigti užduotys";
const CompleteYourtasks$b = "Baigti savo užduotis";
const Steps$b = "Žingsniai";
const PremiumMember$b = "Aukščiausios klasės narys";
const Thankyouforupgradingto$b = "Ačiū, kad atnaujinote į";
const CareerflowPremium$b = "Karjeros srautas Premium";
const hereIsHowYouCanAccessPremium$b = "Čia pateikiamas būdas pasiekti savo Premium naudą!";
const stepOne$b = "Žingsnis 1";
const DownloadourChromeExtension$b = "Atsisiųskite mūsų „Chrome“ plėtinį.";
const youJobSearchCopilotIshere$b = "Tavo darbo paieškos AI kopilotas yra čia.";
const DownloadNow$b = "Parsisiųsti dabar";
const stepTwo$b = "Žingsnis 2";
const GetStarted$b = "Pradėti";
const stepThree$b = "3 žingsnis";
const SignintoChromeExtension$b = "Prisijunkite prie „Chrome“ plėtinio.";
const entityCreated$b = "Sukurtas naujas {{entity}}";
const entityUpdated$b = "{{entity}} atnaujintas.";
const entityDeleted$b = "{{entity}} ištrintas.";
const entityLinked$b = "{{entity}} susietas";
const entityUnlinked$b = "{{entity}} atsietas nuorodos";
const entityMovedTo$b = "Perkelta į {{entity}}.";
const youAddedANewEntity$b = "Jūs pridėjote naują {{entity}}.";
const personCreated$b = "{{creator}} sukūrė {{entity}} savininkui {{owner}}.";
const youUpdatedAEntity$b = "Jūs atnaujinote {{entity}}.";
const personUpdated$b = "{{creator}} atnaujino {{entity}} savininkui {{owner}}.";
const youDeletedAEntity$b = "Jūs ištrynėte {{entity}}.";
const personDeleted$b = "{{creator}} ištrynė {{entity}} nuo {{owner}}";
const youLinkedEntity$b = "Jūs susiejote {{entity}} su šiuo darbu.";
const personLinked$b = "{{creator}} susiejęs {{entity}} su šiuo darbu, priklausantį {{owner}}.";
const youUnlinked$b = "Jūs atjungėte {{entity}} nuo šio darbo.";
const personUnlinked$b = "{{creator}} atsietas {{entity}} nuo šio darbo už {{owner}}.";
const youMovedEntity$b = "Jūs perkėlėte šią {{entity}} iš {{sectionFrom}} į {{sectionTo}}";
const personMoved$b = "{{creator}} perkėlė šią {{entity}} iš {{sectionFrom}} į {{sectionTo}} dėl {{owner}}";
const addedByName$b = "Pridėta {{name}}";
const DownloadChromeExtension$b = "Parsisiųskite „Chrome“ plėtinį";
const ourChromeExtensionIs$b = "Mūsų „Chrome“ plėtinys yra integruota priemonė, padedanti optimizuoti LinkedIn profilį, išsaugoti darbo vietų, kontaktų, generuoti motyvacinį laišką ir daugiau.";
const Optimizeyourprofile$b = "Optimizuokite savo profilį.";
const startOptimizingYourProfile$b = "Pradėkite optimizuoti savo profilį, kad turėtumėte geresnių galimybių būti susisiekę su jumis darbdavių.";
const OptimizeNow$b = "Optimizuokite dabar";
const Addyourfirstjob$b = "Pridėkite savo pirmą darbą";
const startSavingJobApplicationsToTrack$b = "Pradėkite taupyti darbo paraiškas, kad galėtumėte sekti savo darbo paieškos kelionę ir rasti naudingų įžvalgų.";
const AddNow$b = "Pridėti dabar";
const CompleteProfile$b = "Pilnas profilis";
const completeYourProfileForUsing$b = "Užbaikite savo profilį, kad galėtumėte naudoti automatinio užpildymo funkciją ir gautumėte labiau pritaikytą patirtį.";
const CompleteNow$b = "Užbaikite dabar";
const Addyourfirstcontact$b = "Pridėkite savo pirmąjį kontaktą";
const addContactToFollowUpWith$b = "Pridėkite kontaktą, kad galėtumėte su jais susisiekti vėliau, pridėkite pastabas ir daugiau.";
const JoinCommunity$b = "Prisijunkite prie bendruomenės";
const ourCommunityisAlways$b = "Mūsų bendruomenė visada yra su jumis jūsų darbo paieškos kelionėje.";
const JoinNow$b = "Prisijunkite dabar";
const welcomeToCareerflow$b = "Sveiki atvykę į Careerflow!";
const yourHubForCareerInsights2$b = "Tai yra jūsų karjeros įžanga, veiklos ir daugiau. Naršykite savo asmeninę informacijos suvestinę, kad išliktumėte savo profesinėje kelionėje.";
const ChecklistCompleted$b = "Jūsų sąrašas užbaigtas!";
const Completeyourchecklist$b = "Užbaikite savo kontrolinę sąrašą.";
const completeAFewStepsTo$b = "Atlikite kelis žingsnius, kad gautumėte savo kitą darbą.";
const Completed$b = "Baigta";
const JobCountByStage$b = "Darbo skaičius pagal etapą";
const NopastapplicationDatafound$b = "Nerasta ankstesnių paraiškų duomenų";
const YourJobSearchStages$b = "Jūsų darbo paieškos etapai";
const NoDatafound$b = "Nerasta duomenų";
const lt = {
	copyToClipboard: copyToClipboard$b,
	UnlocktheAIgenerated: UnlocktheAIgenerated$b,
	UpgradetoPremium: UpgradetoPremium$b,
	Result: Result$b,
	Copy: Copy$b,
	Save: Save$b,
	Edit: Edit$b,
	Processing: Processing$b,
	YourAIgeneratedcontentwillshowhere: YourAIgeneratedcontentwillshowhere$b,
	hopeYouFindUseful: hopeYouFindUseful$b,
	regenerate: regenerate$b,
	ProvideAdditionalFeedback: ProvideAdditionalFeedback$b,
	Enteranyfeedback: Enteranyfeedback$b,
	Notimpressive: Notimpressive$b,
	thisIsntTrue: thisIsntTrue$b,
	Notpersonalized: Notpersonalized$b,
	Tone: Tone$b,
	Length: Length$b,
	Template: Template$b,
	Generatedon: Generatedon$b,
	Copiedtoclipboard: Copiedtoclipboard$b,
	CopytoClipboard: CopytoClipboard$b,
	DownloadasPDF: DownloadasPDF$b,
	ViewDetails: ViewDetails$b,
	JobDescriptionImported: JobDescriptionImported$b,
	ImportfromJob: ImportfromJob$b,
	Saved: Saved$b,
	Applied: Applied$b,
	Offer: Offer$b,
	Interviewing: Interviewing$b,
	Rejected: Rejected$b,
	Search: Search$b,
	Import: Import$b,
	CoverLetterGeneratorHistory: CoverLetterGeneratorHistory$b,
	NoCoverLettersGenerated: NoCoverLettersGenerated$b,
	getStartedCoverLetter: getStartedCoverLetter$b,
	getStarted: getStarted$b,
	Documents: Documents$b,
	UploadNewDocument: UploadNewDocument$b,
	AICoverLetterGenerator: AICoverLetterGenerator$b,
	ViewHistory: ViewHistory$b,
	JobDescription: JobDescription$b,
	ImportfromBoard: ImportfromBoard$b,
	EnterJobDescription: EnterJobDescription$b,
	JobTitle: JobTitle$b,
	EnterJobTitle: EnterJobTitle$b,
	CompanyName: CompanyName$b,
	EnterCompanyName: EnterCompanyName$b,
	YourProfile: YourProfile$b,
	ResumeUpload: ResumeUpload$b,
	UseLinkedinProfile: UseLinkedinProfile$b,
	Uploadyourresume: Uploadyourresume$b,
	AddyourResume: AddyourResume$b,
	fileNameCannotFormat: fileNameCannotFormat$b,
	ChooseorUpload: ChooseorUpload$b,
	SelectTemplate: SelectTemplate$b,
	Preview: Preview$b,
	UseTemplate: UseTemplate$b,
	Change: Change$b,
	AdvancedSettings: AdvancedSettings$b,
	AdditionalContext: AdditionalContext$b,
	Professional: Professional$b,
	Casual: Casual$b,
	Enthusiastic: Enthusiastic$b,
	Informational: Informational$b,
	Short: Short$b,
	Medium: Medium$b,
	Long: Long$b,
	Language: Language$b,
	iAmOkayBack: iAmOkayBack$b,
	Generate: Generate$b,
	CoverLetter: CoverLetter$b,
	SelectLanguage: SelectLanguage$b,
	AboutGeneratorHistory: AboutGeneratorHistory$b,
	NoAboutsGenerated: NoAboutsGenerated$b,
	getStartedAbouts: getStartedAbouts$b,
	noAttachmentsFound: noAttachmentsFound$b,
	TargetJobTitle: TargetJobTitle$b,
	KeywordsToInclude: KeywordsToInclude$b,
	UploadYourResume: UploadYourResume$b,
	AddYourResume: AddYourResume$b,
	LinkedinProfile: LinkedinProfile$b,
	Linkedinprofilenotfound: Linkedinprofilenotfound$b,
	startUsingChromeExtension: startUsingChromeExtension$b,
	Download: Download$b,
	UseEmojis: UseEmojis$b,
	UseBulletPoints: UseBulletPoints$b,
	SpeechFocus: SpeechFocus$b,
	FirstPerson: FirstPerson$b,
	ThirdPerson: ThirdPerson$b,
	HeadlineGeneratorHistory: HeadlineGeneratorHistory$b,
	NoHeadlinesGenerated: NoHeadlinesGenerated$b,
	getStartedHeadline: getStartedHeadline$b,
	AIHeadlineGenerator: AIHeadlineGenerator$b,
	KeywordstoInclude: KeywordstoInclude$b,
	Pressenteraftereachword: Pressenteraftereachword$b,
	LinkedinProfilenotfound: LinkedinProfilenotfound$b,
	Headline: Headline$b,
	PostGeneratorHistory: PostGeneratorHistory$b,
	NoPostsGenerated: NoPostsGenerated$b,
	getStartedPost: getStartedPost$b,
	Topic: Topic$b,
	Description: Description$b,
	UseHashtags: UseHashtags$b,
	Custom: Custom$b,
	EnterCustomTone: EnterCustomTone$b,
	Added: Added$b,
	ComingSoon: ComingSoon$b,
	Company: Company$b,
	JobInterview: JobInterview$b,
	Research: Research$b,
	Networking: Networking$b,
	Referral: Referral$b,
	MustbeContacted: MustbeContacted$b,
	ScheduleaMeeting: ScheduleaMeeting$b,
	needAFollowUp: needAFollowUp$b,
	Today: Today$b,
	Viewdetails: Viewdetails$b,
	Activity: Activity$b,
	ActivityDetails: ActivityDetails$b,
	Delete: Delete$b,
	Title: Title$b,
	Goal: Goal$b,
	Status: Status$b,
	FollowUp: FollowUp$b,
	AddActivity: AddActivity$b,
	Enteractivitytitle: Enteractivitytitle$b,
	Cancel: Cancel$b,
	SaveActivity: SaveActivity$b,
	noActivityPresent: noActivityPresent$b,
	Addnew: Addnew$b,
	About: About$b,
	noDataPresentYou: noDataPresentYou$b,
	Experience: Experience$b,
	Education: Education$b,
	Skills: Skills$b,
	Overview: Overview$b,
	LinkedJobs: LinkedJobs$b,
	Notes: Notes$b,
	FullName: FullName$b,
	Location: Location$b,
	Relationship: Relationship$b,
	Contacts: Contacts$b,
	CreateContact: CreateContact$b,
	NotesCreated: NotesCreated$b,
	Notesupdated: Notesupdated$b,
	Addnote: Addnote$b,
	areYouSureDeleteNote: areYouSureDeleteNote$b,
	Createdby: Createdby$b,
	notSureWhyResumeCalls: notSureWhyResumeCalls$b,
	getExpertResumeReview: getExpertResumeReview$b,
	youHaventAddedContacts: youHaventAddedContacts$b,
	noMatchingContacts: noMatchingContacts$b,
	Link: Link$b,
	unlink: unlink$b,
	Locationnotavailable: Locationnotavailable$b,
	Emailnotavailable: Emailnotavailable$b,
	PhoneNumbernotavailable: PhoneNumbernotavailable$b,
	createdby: createdby$b,
	areYouSureDeleteContact: areYouSureDeleteContact$b,
	areYouSureUnlinkContact: areYouSureUnlinkContact$b,
	Addedbyyou: Addedbyyou$b,
	Addedby: Addedby$b,
	Timeline: Timeline$b,
	Timelineempty: Timelineempty$b,
	Discard: Discard$b,
	SaveContact: SaveContact$b,
	Recruiter: Recruiter$b,
	Candidate: Candidate$b,
	Colleague: Colleague$b,
	Employee: Employee$b,
	"Needtofollow-up": "Reikia sekti",
	EnterValidEmail: EnterValidEmail$b,
	EnterValidPhoneNumber: EnterValidPhoneNumber$b,
	editingProfileNotAvailable: editingProfileNotAvailable$b,
	itWillBeSoonAvailable: itWillBeSoonAvailable$b,
	ChromeExtension: ChromeExtension$b,
	SelectTag: SelectTag$b,
	FirstName: FirstName$b,
	FirstNameisrequired: FirstNameisrequired$b,
	LastName: LastName$b,
	LastNameisrequired: LastNameisrequired$b,
	Companyisrequired: Companyisrequired$b,
	Email: Email$b,
	ThisisnotavalidEmail: ThisisnotavalidEmail$b,
	AddEmail: AddEmail$b,
	PhoneNumber: PhoneNumber$b,
	notaValidPhone: notaValidPhone$b,
	phoneNoMinimum5char: phoneNoMinimum5char$b,
	phoneNoMinumum15char: phoneNoMinumum15char$b,
	AddPhoneNumber: AddPhoneNumber$b,
	SelectGoal: SelectGoal$b,
	SelectStatus: SelectStatus$b,
	Followup: Followup$b,
	SocialMedia: SocialMedia$b,
	Linkedinhandle: Linkedinhandle$b,
	Twitterhandle: Twitterhandle$b,
	Facebookhandle: Facebookhandle$b,
	Githubhandle: Githubhandle$b,
	Gmailhandle: Gmailhandle$b,
	Changessavedsuccessfully: Changessavedsuccessfully$b,
	EditContact: EditContact$b,
	BasicInformation: BasicInformation$b,
	EditContactDetails: EditContactDetails$b,
	SaveChanges: SaveChanges$b,
	phoneNoMinimum14char: phoneNoMinimum14char$b,
	LinkedIn: LinkedIn$b,
	Twitter: Twitter$b,
	Facebook: Facebook$b,
	Github: Github$b,
	Gmail: Gmail$b,
	youCanWriteAbout: youCanWriteAbout$b,
	Addednewsection: Addednewsection$b,
	Removedsuccessfully: Removedsuccessfully$b,
	Remove: Remove$b,
	Institute: Institute$b,
	Schoolisrequired: Schoolisrequired$b,
	Degree: Degree$b,
	StartMonth: StartMonth$b,
	StartYear: StartYear$b,
	EndMonth: EndMonth$b,
	EndYear: EndYear$b,
	Addmore: Addmore$b,
	PositionTitle: PositionTitle$b,
	ExperienceType: ExperienceType$b,
	Addednewitem: Addednewitem$b,
	whatSkillsDoYouEnjoy: whatSkillsDoYouEnjoy$b,
	Typeskillshere: Typeskillshere$b,
	LinkedContacts: LinkedContacts$b,
	LinkContact: LinkContact$b,
	NocontactsLinked: NocontactsLinked$b,
	JobContactsComponent: JobContactsComponent$b,
	Nocontacts: Nocontacts$b,
	LinkJobto: LinkJobto$b,
	Contact: Contact$b,
	Document: Document$b,
	Nojobsfound: Nojobsfound$b,
	LinkJob: LinkJob$b,
	youCanLinkContactJobImported: youCanLinkContactJobImported$b,
	Prev: Prev$b,
	Next: Next$b,
	areYouSureUnlinkDocument: areYouSureUnlinkDocument$b,
	areYouSureDeleteDocument: areYouSureDeleteDocument$b,
	Category: Category$b,
	CreatedOn: CreatedOn$b,
	Joblinked: Joblinked$b,
	Quickactions: Quickactions$b,
	All: All$b,
	Resume: Resume$b,
	Portfolio: Portfolio$b,
	Other: Other$b,
	Adddocument: Adddocument$b,
	Type: Type$b,
	Sortingby: Sortingby$b,
	SwitchtoGridLayout: SwitchtoGridLayout$b,
	SwitchtoListLayout: SwitchtoListLayout$b,
	NoDocumentsAdded: NoDocumentsAdded$b,
	DocumentsComponent: DocumentsComponent$b,
	NoDocumentFound: NoDocumentFound$b,
	SelectFile: SelectFile$b,
	onlyPdfDocxSupported: onlyPdfDocxSupported$b,
	Uploadfile: Uploadfile$b,
	DocumentCategory: DocumentCategory$b,
	SaveDocument: SaveDocument$b,
	AddDocument: AddDocument$b,
	LinkedDocuments: LinkedDocuments$b,
	LinkDocument: LinkDocument$b,
	NodocumentsLinked: NodocumentsLinked$b,
	JobDocumentsComponent: JobDocumentsComponent$b,
	NoDocuments: NoDocuments$b,
	CreateDocuments: CreateDocuments$b,
	youCanLinkDocumentJobImported: youCanLinkDocumentJobImported$b,
	Documenteditedsuccessfully: Documenteditedsuccessfully$b,
	DocumentDetails: DocumentDetails$b,
	UnsavedChanges: UnsavedChanges$b,
	yourChangesWillBeLostSureClose: yourChangesWillBeLostSureClose$b,
	yourChangesWillBeLostSureDiscard: yourChangesWillBeLostSureDiscard$b,
	DiscardChanges: DiscardChanges$b,
	WeeklyGoalAlert: WeeklyGoalAlert$b,
	Progress: Progress$b,
	AllGoals: AllGoals$b,
	Name: Name$b,
	Completedon: Completedon$b,
	Createdon: Createdon$b,
	Action: Action$b,
	Back: Back$b,
	OverallScore: OverallScore$b,
	Aboutthegoal: Aboutthegoal$b,
	GoalTracking: GoalTracking$b,
	Week: Week$b,
	progress: progress$b,
	loading: loading$b,
	Apply: Apply$b,
	Thisskillhasbeenreported: Thisskillhasbeenreported$b,
	issueGettingResume: issueGettingResume$b,
	Interview: Interview$b,
	Tasks: Tasks$b,
	Loading: Loading$b,
	Skilladdedsuccessfully: Skilladdedsuccessfully$b,
	problemAddingSkill: problemAddingSkill$b,
	Reportaproblem: Reportaproblem$b,
	Submit: Submit$b,
	Addanewskill: Addanewskill$b,
	JobDetailsComponent: JobDetailsComponent$b,
	HardSkill: HardSkill$b,
	SoftSkill: SoftSkill$b,
	Pleaseshareanyadditionalcontext: Pleaseshareanyadditionalcontext$b,
	Addasskill: Addasskill$b,
	Skill: Skill$b,
	JobFrequency: JobFrequency$b,
	ResumeFrequency: ResumeFrequency$b,
	Reportskill: Reportskill$b,
	JobDetails: JobDetails$b,
	ViewJobLink: ViewJobLink$b,
	Salary: Salary$b,
	areYouSureDeleteJob: areYouSureDeleteJob$b,
	ViewMore: ViewMore$b,
	ViewLess: ViewLess$b,
	matchYouSkillsAgainstJob: matchYouSkillsAgainstJob$b,
	pleaseUploadResumeSkillMatch: pleaseUploadResumeSkillMatch$b,
	AddResume: AddResume$b,
	thisJobDoesNotHaveAnyDesc: thisJobDoesNotHaveAnyDesc$b,
	youCanEditJobToAdd: youCanEditJobToAdd$b,
	chromeextension: chromeextension$b,
	fromVariousJobPortalsOnce: fromVariousJobPortalsOnce$b,
	AddDescription: AddDescription$b,
	CompanyInfo: CompanyInfo$b,
	Website: Website$b,
	Industry: Industry$b,
	EmployeeCount: EmployeeCount$b,
	ExprienceLevel: ExprienceLevel$b,
	Address: Address$b,
	Resumes: Resumes$b,
	Setasdefault: Setasdefault$b,
	Ok: Ok$b,
	UploadNewResume: UploadNewResume$b,
	Default: Default$b,
	Jobnotfound: Jobnotfound$b,
	EditDetails: EditDetails$b,
	JobPostURL: JobPostURL$b,
	Enterjoburl: Enterjoburl$b,
	Nojobselected: Nojobselected$b,
	Viewjobdetails: Viewjobdetails$b,
	Jobaddedtoyourboardsuccessfully: Jobaddedtoyourboardsuccessfully$b,
	AddJob: AddJob$b,
	Addnewjobname: Addnewjobname$b,
	JobUrl: JobUrl$b,
	Addjoburl: Addjoburl$b,
	Section: Section$b,
	didYouKnow: didYouKnow$b,
	Jobs: Jobs$b,
	AddJobtoboard: AddJobtoboard$b,
	Currentlynojobsareavailable: Currentlynojobsareavailable$b,
	noMatchingJobs: noMatchingJobs$b,
	welcomeToYourPersonalJobTracker: welcomeToYourPersonalJobTracker$b,
	weShortTutorialOnHowTrackingJob: weShortTutorialOnHowTrackingJob$b,
	Addanewjob: Addanewjob$b,
	inOrderTrackCreatButton: inOrderTrackCreatButton$b,
	Providesomedetails: Providesomedetails$b,
	toBeginTypeJobTitleCompany: toBeginTypeJobTitleCompany$b,
	asAnExampleFilledForYou: asAnExampleFilledForYou$b,
	wohooAddedFirstJob: wohooAddedFirstJob$b,
	youCanDragDropJobCard: youCanDragDropJobCard$b,
	Lastbutnotleast: Lastbutnotleast$b,
	finalStepMakeSure: finalStepMakeSure$b,
	autoMaticallyImportJobs: autoMaticallyImportJobs$b,
	selectanysection: selectanysection$b,
	Accept: Accept$b,
	My2023JobSearch: My2023JobSearch$b,
	AddedFrom: AddedFrom$b,
	AddedUntil: AddedUntil$b,
	BasicModal: BasicModal$b,
	AddnewSectionName: AddnewSectionName$b,
	OpenTo: OpenTo$b,
	Featured: Featured$b,
	LicenceAndCerts: LicenceAndCerts$b,
	Banner: Banner$b,
	LinkedInURL: LinkedInURL$b,
	Recommendations: Recommendations$b,
	LinkedinReview: LinkedinReview$b,
	NoDataAvailable: NoDataAvailable$b,
	looksLikeYouDidNot: looksLikeYouDidNot$b,
	toOptimizeProfileScoreVisible: toOptimizeProfileScoreVisible$b,
	LinkedinComponent: LinkedinComponent$b,
	improveYourChancesLandingDreamJob: improveYourChancesLandingDreamJob$b,
	VisitProfile: VisitProfile$b,
	wantToGetLinkedinMakeover: wantToGetLinkedinMakeover$b,
	PostGenerator: PostGenerator$b,
	LinkedinHeadlineGenerator: LinkedinHeadlineGenerator$b,
	LinkedinAboutSectionGenerator: LinkedinAboutSectionGenerator$b,
	AITools: AITools$b,
	Premium: Premium$b,
	LinkedInOptimization: LinkedInOptimization$b,
	JobTracker: JobTracker$b,
	whoIsHiring: whoIsHiring$b,
	Autofill: Autofill$b,
	HeadlineGenerator: HeadlineGenerator$b,
	skillMatching: skillMatching$b,
	SummarizeJD: SummarizeJD$b,
	contactFeature: contactFeature$b,
	documentFeature: documentFeature$b,
	landJobWithoutStress: landJobWithoutStress$b,
	discoverFeatures: discoverFeatures$b,
	letsBeginOnboarding: letsBeginOnboarding$b,
	inTheNextFewScreensJobThirdParties: inTheNextFewScreensJobThirdParties$b,
	letsAddBasicInformation: letsAddBasicInformation$b,
	Pleaseselectanoptionfirst: Pleaseselectanoptionfirst$b,
	JobApplicationTracker: JobApplicationTracker$b,
	LinkedInProfileOptimizer: LinkedInProfileOptimizer$b,
	UnlimitedDocuments: UnlimitedDocuments$b,
	UnlimitedContacts: UnlimitedContacts$b,
	HiringManagerSearch: HiringManagerSearch$b,
	AILinkedInPostGenerator: AILinkedInPostGenerator$b,
	ATSKeywordSkillMatch: ATSKeywordSkillMatch$b,
	"Auto-Apply": "Automatinis taikymas",
	ChooseyourPlan: ChooseyourPlan$b,
	superChargeYourJobSearch: superChargeYourJobSearch$b,
	startNowGoto: startNowGoto$b,
	CreatedBy: CreatedBy$b,
	CreateNewNote: CreateNewNote$b,
	Nonotescreated: Nonotescreated$b,
	approxTimeIsFourMinutes: approxTimeIsFourMinutes$b,
	Continue: Continue$b,
	iWillDoLaterTakeMeToApp: iWillDoLaterTakeMeToApp$b,
	allDone: allDone$b,
	welcomeAbord: welcomeAbord$b,
	letsBegin: letsBegin$b,
	UpgradeyourplanandgetAIAssistance: UpgradeyourplanandgetAIAssistance$b,
	DownloadPDF: DownloadPDF$b,
	oopsWeCouldntProcessResume: oopsWeCouldntProcessResume$b,
	MyProfile: MyProfile$b,
	Setting: Setting$b,
	Logout: Logout$b,
	SignIn: SignIn$b,
	Typeyourfirstnamehere: Typeyourfirstnamehere$b,
	Enteryourlastname: Enteryourlastname$b,
	ManageSubscription: ManageSubscription$b,
	ifYouHaveDifficultiesProfile: ifYouHaveDifficultiesProfile$b,
	forSupport: forSupport$b,
	whatIsIdealCompanySize: whatIsIdealCompanySize$b,
	Saveandcontinue: Saveandcontinue$b,
	whatIsMinExpectedSalary: whatIsMinExpectedSalary$b,
	Atleast: Atleast$b,
	SlidetoAdjust: SlidetoAdjust$b,
	whatIndustryExcitedWork: whatIndustryExcitedWork$b,
	Add: Add$b,
	statusOfJobSearch: statusOfJobSearch$b,
	Finish: Finish$b,
	whatLevelRoleLooking: whatLevelRoleLooking$b,
	Selectuptotwo: Selectuptotwo$b,
	PreviousStep: PreviousStep$b,
	Skip: Skip$b,
	whatDoYouValueNewRole: whatDoYouValueNewRole$b,
	Selectuptothree: Selectuptothree$b,
	EqualEmploymentData: EqualEmploymentData$b,
	whatIsYourEthnicity: whatIsYourEthnicity$b,
	areYouAuthorizedToWorkUs: areYouAuthorizedToWorkUs$b,
	willYouRequireSponsorShip: willYouRequireSponsorShip$b,
	doYouHaveADisability: doYouHaveADisability$b,
	areYouAVeteran: areYouAVeteran$b,
	rolesYouInterestedIn: rolesYouInterestedIn$b,
	Selectuptofive: Selectuptofive$b,
	AddCustomrole: AddCustomrole$b,
	whereDoYouLikeWork: whereDoYouLikeWork$b,
	Resources: Resources$b,
	currentlyNoResourceAvailable: currentlyNoResourceAvailable$b,
	AddNewSection: AddNewSection$b,
	ChangeSections: ChangeSections$b,
	Settings: Settings$b,
	Dashboard: Dashboard$b,
	JobBoard: JobBoard$b,
	Linkedin: Linkedin$b,
	Community: Community$b,
	FindRecruiters: FindRecruiters$b,
	Goals: Goals$b,
	DownloadExtension: DownloadExtension$b,
	SuggestaFeature: SuggestaFeature$b,
	leftPanel: leftPanel$b,
	PhoneNumberisrequired: PhoneNumberisrequired$b,
	MobileNumber: MobileNumber$b,
	Enteronlynumbers: Enteronlynumbers$b,
	Countryyoulivein: Countryyoulivein$b,
	SelectaCountry: SelectaCountry$b,
	DateofBirth: DateofBirth$b,
	Gender: Gender$b,
	JobPreferences: JobPreferences$b,
	pleaseEnterValidEmail: pleaseEnterValidEmail$b,
	emailSendForResetting: emailSendForResetting$b,
	VerifyyourEmailID: VerifyyourEmailID$b,
	sentPleaseCheckEmail: sentPleaseCheckEmail$b,
	tooManyAttemptsTryAgain: tooManyAttemptsTryAgain$b,
	Resend: Resend$b,
	Login: Login$b,
	weHaveSentVerificationLinkAtEmail: weHaveSentVerificationLinkAtEmail$b,
	pleaseVerifyEmailContinueSpam: pleaseVerifyEmailContinueSpam$b,
	Logintogetstarted: Logintogetstarted$b,
	ContinuewithGoogle: ContinuewithGoogle$b,
	pleaseInputEmail: pleaseInputEmail$b,
	Password: Password$b,
	pleaseInputPassword: pleaseInputPassword$b,
	passwordLowerUpperDigitSpecial: passwordLowerUpperDigitSpecial$b,
	atLeastSixChar: atLeastSixChar$b,
	forgotPassword: forgotPassword$b,
	Bysigninginyouagreetoour: Bysigninginyouagreetoour$b,
	Terms: Terms$b,
	Conditions: Conditions$b,
	and: and$b,
	PrivacyPolicy: PrivacyPolicy$b,
	theseAreTheTopsSkillsExtracted: theseAreTheTopsSkillsExtracted$b,
	TopSkills: TopSkills$b,
	weCoulNotExtractSkills: weCoulNotExtractSkills$b,
	upgradeToPremiumToView: upgradeToPremiumToView$b,
	SkillScore: SkillScore$b,
	thisIsYourSkillScoreBasedOn: thisIsYourSkillScoreBasedOn$b,
	theseSkllsAreStrongMatch: theseSkllsAreStrongMatch$b,
	Strongmatch: Strongmatch$b,
	theseSkillsArePartialMatch: theseSkillsArePartialMatch$b,
	Partialmatch: Partialmatch$b,
	theseSkillsAreMissingFrom: theseSkillsAreMissingFrom$b,
	"Missing Keywords": "Trūkstami raktažodžiai",
	SkillMatchComponent: SkillMatchComponent$b,
	Optional: Optional$b,
	Notrelevanttothejob: Notrelevanttothejob$b,
	Notaskill: Notaskill$b,
	Toogeneric: Toogeneric$b,
	Pleaseshareanyfeedback: Pleaseshareanyfeedback$b,
	excludedKeywordsWillNot: excludedKeywordsWillNot$b,
	yesExcludeThisSkillFrom: yesExcludeThisSkillFrom$b,
	PartialMatch: PartialMatch$b,
	MissingKeywords: MissingKeywords$b,
	Providetitletotask: Providetitletotask$b,
	TasksList: TasksList$b,
	AddTask: AddTask$b,
	EnterTaskTitlehere: EnterTaskTitlehere$b,
	TasksComponent: TasksComponent$b,
	CompletedTasks: CompletedTasks$b,
	CompleteYourtasks: CompleteYourtasks$b,
	Steps: Steps$b,
	PremiumMember: PremiumMember$b,
	Thankyouforupgradingto: Thankyouforupgradingto$b,
	CareerflowPremium: CareerflowPremium$b,
	hereIsHowYouCanAccessPremium: hereIsHowYouCanAccessPremium$b,
	stepOne: stepOne$b,
	DownloadourChromeExtension: DownloadourChromeExtension$b,
	youJobSearchCopilotIshere: youJobSearchCopilotIshere$b,
	DownloadNow: DownloadNow$b,
	stepTwo: stepTwo$b,
	GetStarted: GetStarted$b,
	stepThree: stepThree$b,
	SignintoChromeExtension: SignintoChromeExtension$b,
	entityCreated: entityCreated$b,
	entityUpdated: entityUpdated$b,
	entityDeleted: entityDeleted$b,
	entityLinked: entityLinked$b,
	entityUnlinked: entityUnlinked$b,
	entityMovedTo: entityMovedTo$b,
	youAddedANewEntity: youAddedANewEntity$b,
	personCreated: personCreated$b,
	youUpdatedAEntity: youUpdatedAEntity$b,
	personUpdated: personUpdated$b,
	youDeletedAEntity: youDeletedAEntity$b,
	personDeleted: personDeleted$b,
	youLinkedEntity: youLinkedEntity$b,
	personLinked: personLinked$b,
	youUnlinked: youUnlinked$b,
	personUnlinked: personUnlinked$b,
	youMovedEntity: youMovedEntity$b,
	personMoved: personMoved$b,
	addedByName: addedByName$b,
	DownloadChromeExtension: DownloadChromeExtension$b,
	ourChromeExtensionIs: ourChromeExtensionIs$b,
	Optimizeyourprofile: Optimizeyourprofile$b,
	startOptimizingYourProfile: startOptimizingYourProfile$b,
	OptimizeNow: OptimizeNow$b,
	Addyourfirstjob: Addyourfirstjob$b,
	startSavingJobApplicationsToTrack: startSavingJobApplicationsToTrack$b,
	AddNow: AddNow$b,
	CompleteProfile: CompleteProfile$b,
	completeYourProfileForUsing: completeYourProfileForUsing$b,
	CompleteNow: CompleteNow$b,
	Addyourfirstcontact: Addyourfirstcontact$b,
	addContactToFollowUpWith: addContactToFollowUpWith$b,
	JoinCommunity: JoinCommunity$b,
	ourCommunityisAlways: ourCommunityisAlways$b,
	JoinNow: JoinNow$b,
	welcomeToCareerflow: welcomeToCareerflow$b,
	yourHubForCareerInsights2: yourHubForCareerInsights2$b,
	ChecklistCompleted: ChecklistCompleted$b,
	Completeyourchecklist: Completeyourchecklist$b,
	completeAFewStepsTo: completeAFewStepsTo$b,
	Completed: Completed$b,
	JobCountByStage: JobCountByStage$b,
	NopastapplicationDatafound: NopastapplicationDatafound$b,
	YourJobSearchStages: YourJobSearchStages$b,
	NoDatafound: NoDatafound$b
};

const copyToClipboard$a = "Kopēts uz starpliktuves!";
const UnlocktheAIgenerated$a = "Atbloķēt AI radīto";
const UpgradetoPremium$a = "Atjaunot uz Premium";
const Result$a = "Rezultāts";
const Copy$a = "Kopēt";
const Save$a = "Saglabāt";
const Edit$a = "Rediģēt";
const Processing$a = "Apstrāde";
const YourAIgeneratedcontentwillshowhere$a = "Jūsu ģenerētais AI saturs parādīsies šeit";
const hopeYouFindUseful$a = "Ceru, ka šis rezultāts jums būs noderīgs!";
const regenerate$a = "Pārģenerēt";
const ProvideAdditionalFeedback$a = "Sniedziet papildu atsauksmes";
const Enteranyfeedback$a = "Ievadiet jebkādas atsauksmes";
const Notimpressive$a = "Nav iespaidīgi";
const thisIsntTrue$a = "Tas nav patiesība";
const Notpersonalized$a = "Nav personalizēti";
const Tone$a = "Tonis";
const Length$a = "Garums";
const Template$a = "Veidne";
const Generatedon$a = "Ģenerēts";
const Copiedtoclipboard$a = "Kopēts uz starpliktuves";
const CopytoClipboard$a = "Kopēt uz starpliku";
const DownloadasPDF$a = "Lejupielādēt kā PDF";
const ViewDetails$a = "Skatīt detaļas";
const JobDescriptionImported$a = "Darba apraksts importēts";
const ImportfromJob$a = "Darba imports";
const Saved$a = "Saglabāts";
const Applied$a = "Pieteikts";
const Offer$a = "Piedāvājums";
const Interviewing$a = "Intervēšana";
const Rejected$a = "Noraidīts";
const Search$a = "Meklēt";
const Import$a = "Ievedums";
const CoverLetterGeneratorHistory$a = "Motivācijas vēstules ģenerātora vēsture";
const NoCoverLettersGenerated$a = "Nav ģenerētas motivācijas vēstules";
const getStartedCoverLetter$a = "Jūs vēl neesat ģenerējis nevienu motivācijas vēstuli. Sāciet un saņemiet vēstules, salīdzinot darba aprakstu ar savu atbilstošo pieredzi.";
const getStarted$a = "Sākt!";
const Documents$a = "Dokumenti";
const UploadNewDocument$a = "Augšupielādēt jaunu dokumentu";
const AICoverLetterGenerator$a = "Mākslīgais intelekts Motivācijas vēstuļu ģenerators";
const ViewHistory$a = "Aplūkot vēsturi";
const JobDescription$a = "Darba apraksts";
const ImportfromBoard$a = "Importēt no dēļa";
const EnterJobDescription$a = "Ievadiet darba aprakstu";
const JobTitle$a = "Amata nosaukums";
const EnterJobTitle$a = "Ievadiet amata nosaukumu";
const CompanyName$a = "Uzņēmuma nosaukums";
const EnterCompanyName$a = "Ievadiet uzņēmuma nosaukumu";
const YourProfile$a = "Jūsu profils";
const ResumeUpload$a = "CV augšupielāde";
const UseLinkedinProfile$a = "Izmantojiet Linkedin profilu";
const Uploadyourresume$a = "Augšupielādējiet savu CV";
const AddyourResume$a = "Pievienojiet savu CV";
const fileNameCannotFormat$a = "Failu nosaukumi nedrīkst saturēt atstarpes vai apakšsvītras un tiem jābūt formātā .doc, .docx vai .pdf.";
const ChooseorUpload$a = "Izvēlēties vai augšupielādēt";
const SelectTemplate$a = "Atlasīt veidni";
const Preview$a = "Priekšskatījums";
const UseTemplate$a = "Izmantojiet veidni";
const Change$a = "Mainīt";
const AdvancedSettings$a = "Papildu iestatījumi";
const AdditionalContext$a = "Papildu konteksts";
const Professional$a = "Profesionāls";
const Casual$a = "Neformāls";
const Enthusiastic$a = "Iespaidīgs";
const Informational$a = "Informatīvs";
const Short$a = "Īss";
const Medium$a = "Vidējs";
const Long$a = "Garš";
const Language$a = "Valoda";
const iAmOkayBack$a = "Es esmu ok! Atgriezties";
const Generate$a = "Ģenerēt";
const CoverLetter$a = "Pavadu vēstule";
const SelectLanguage$a = "Izvēlieties valodu";
const AboutGeneratorHistory$a = "Par ģeneratora vēsturi";
const NoAboutsGenerated$a = "Nav ģenerēts neviens paragrāfs";
const getStartedAbouts$a = "Jūs vēl neesat ģenerējis nevienu paragrāfu. Sāciet un saņemiet paragrāfus, salīdzinot darba aprakstu ar savu atbilstošo pieredzi.";
const noAttachmentsFound$a = "Nav atrasta neviena pielikuma.";
const TargetJobTitle$a = "Mērķa amata nosaukums";
const KeywordsToInclude$a = "Iekļaujamie atslēgvārdi";
const UploadYourResume$a = "Ielādējiet savu CV";
const AddYourResume$a = "Pievienojiet savu CV";
const LinkedinProfile$a = "Linkedin profils";
const Linkedinprofilenotfound$a = "Linkedin profils nav atrasts";
const startUsingChromeExtension$a = "Sāciet optimizēt savu Linkedin profilu, izmantojot mūsu Chrome paplašinājumu, lai izmantotu šo iespēju.";
const Download$a = "Lejupielādēt";
const UseEmojis$a = "Izmantojiet emotikonas";
const UseBulletPoints$a = "Izmantojiet punktus";
const SpeechFocus$a = "Runas fokuss";
const FirstPerson$a = "Pirmā persona";
const ThirdPerson$a = "Trešā persona";
const HeadlineGeneratorHistory$a = "Virsrakstu ģenerātora vēsture";
const NoHeadlinesGenerated$a = "Nav ģenerēti virsraksti";
const getStartedHeadline$a = "Jūs vēl neesat ģenerējis nevienu virsrakstu. Sāciet un saņemiet virsrakstus, salīdzinot darba aprakstu ar savu atbilstošo pieredzi.";
const AIHeadlineGenerator$a = "Mākslīgais intelekts Virsrakstu ģenerators";
const KeywordstoInclude$a = "Iekļautie atslēgvārdi";
const Pressenteraftereachword$a = "Nospiediet enter pēc katras vārda";
const LinkedinProfilenotfound$a = "LinkedIn profils nav atrasts.";
const Headline$a = "Virsraksts";
const PostGeneratorHistory$a = "Paziņojumu ģenerātora vēsture";
const NoPostsGenerated$a = "Nav ģenerēti paziņojumi";
const getStartedPost$a = "Jūs vēl neesat ģenerējis nevienu paziņojumu. Sāciet un saņemiet paziņojumus, salīdzinot darba aprakstu ar savu atbilstošo pieredzi.";
const Topic$a = "Tēma";
const Description$a = "Apraksts";
const UseHashtags$a = "Izmantojiet heštegi";
const Custom$a = "Pielāgots";
const EnterCustomTone$a = "Ievadiet pielāgotu toni";
const Added$a = "Pievienots";
const ComingSoon$a = {
	header: "Inženieri strādā!",
	content_1: "Mūsu inženieru komanda strādā cītīgi, cenšoties šo funkciju drīz darbināt",
	content_2: "Vēlaties šo funkciju drīz? Informējiet mūs, vienkārši atzīmējot zemāk esošo lodziņu.",
	content_3: "Es vēlos šo funkciju"
};
const Company$a = "Uzņēmums";
const JobInterview$a = "Darba intervija";
const Research$a = "Pētījums";
const Networking$a = "Tīklošana";
const Referral$a = "Norāde";
const MustbeContacted$a = "Jāsazinās";
const ScheduleaMeeting$a = "Ieplānot tikšanos";
const needAFollowUp$a = "Nepieciešams sekojošs darbs.";
const Today$a = "Šodien";
const Viewdetails$a = "Skatīt detaļas";
const Activity$a = "Aktivitāte";
const ActivityDetails$a = "Aktivitāšu detaļas";
const Delete$a = "Dzēst";
const Title$a = "Nosaukums";
const Goal$a = "Mērķis";
const Status$a = "Statuss";
const FollowUp$a = "Uzraudzība";
const AddActivity$a = "Pievienot aktivitāti";
const Enteractivitytitle$a = "Ievadiet aktivitātes nosaukumu";
const Cancel$a = "Atcelt";
const SaveActivity$a = "Saglabāt aktivitāti";
const noActivityPresent$a = "Nav aktivitātes, pievienojiet aktivitāti.";
const Addnew$a = "Pievienot jaunu";
const About$a = "Par";
const noDataPresentYou$a = "Nav pieejami dati, jūs varat rediģēt šo kontaktu un pievienot laukus.";
const Experience$a = "Pieredze";
const Education$a = "Izglītība";
const Skills$a = "Prasmes";
const Overview$a = "Pārskats";
const LinkedJobs$a = "Saistītie darbi";
const Notes$a = "Piezīmes";
const FullName$a = "Pilns vārds";
const Location$a = "Atrašanās vieta";
const Relationship$a = "Attiecības";
const Contacts$a = "Kontakti";
const CreateContact$a = "Izveidot kontaktu";
const NotesCreated$a = "Piezīmes izveidotas";
const Notesupdated$a = "Piezīmes atjauninātas";
const Addnote$a = "Pievienot piezīmi";
const areYouSureDeleteNote$a = "Vai jūs esat drošs, ka vēlaties dzēst šo piezīmi?";
const Createdby$a = "Izveidoja";
const notSureWhyResumeCalls$a = "Neesmu pārliecināts/-a, kāpēc tavs CV nesaņem zvanus interviju saņemšanai? ☎️";
const getExpertResumeReview$a = "Iegūstiet eksperta CV pārskatu 💎✨";
const youHaventAddedContacts$a = "Jūs vēl neesat pievienojis nevienu kontaktu.";
const noMatchingContacts$a = "Nav atrasti atbilstoši kontakti.";
const Link$a = "Saite";
const unlink$a = "Atsaistīt";
const Locationnotavailable$a = "Atrašanās vieta nav pieejama";
const Emailnotavailable$a = "E-pasts nav pieejams";
const PhoneNumbernotavailable$a = "Telefona numurs nav pieejams";
const createdby$a = "izveidots ar";
const areYouSureDeleteContact$a = "Vai tiešām vēlaties dzēst šo kontaktu?";
const areYouSureUnlinkContact$a = "Vai tiešām vēlaties atsaistīt šo kontaktu?";
const Addedbyyou$a = "Pievienots jums";
const Addedby$a = "Pievienojis";
const Timeline$a = "Laika līnija";
const Timelineempty$a = "Laika līnija tukša";
const Discard$a = "Atmest";
const SaveContact$a = "Saglabāt kontaktu";
const Recruiter$a = "Rekrutors";
const Candidate$a = "Kandidāts";
const Colleague$a = "Kolēģis";
const Employee$a = "Darbinieks";
const EnterValidEmail$a = "Ievadiet derīgu e-pasta adresi";
const EnterValidPhoneNumber$a = "Ievadiet derīgu telefona numuru";
const editingProfileNotAvailable$a = "Profila fotoattēla rediģēšana vēl nav pieejama.";
const itWillBeSoonAvailable$a = "Drīzumā tas būs pieejams mūsu ...";
const ChromeExtension$a = "Chrome paplašinājums";
const SelectTag$a = "Izvēlēties tagu";
const FirstName$a = "Vārds";
const FirstNameisrequired$a = "Vārds ir obligāts";
const LastName$a = "Uzvārds";
const LastNameisrequired$a = "Uzvārds ir obligāts";
const Companyisrequired$a = "Uzņēmumam ir nepieciešams";
const Email$a = "E-pasts";
const ThisisnotavalidEmail$a = "Šis nav derīgs e-pasts.";
const AddEmail$a = "Pievienot e-pastu";
const PhoneNumber$a = "Telefona numurs";
const notaValidPhone$a = "Šis nav derīgs telefona numurs. Ievadiet tikai numurus.";
const phoneNoMinimum5char$a = "Telefona numuram jābūt vismaz 5 rakstzīmēm.";
const phoneNoMinumum15char$a = "Telefona numuram jābūt maksimāli 15 rakstzīmēm.";
const AddPhoneNumber$a = "Pievienot telefona numuru";
const SelectGoal$a = "Izvēlieties mērķi";
const SelectStatus$a = "Izvēlieties statusu";
const Followup$a = "Uzraudzība";
const SocialMedia$a = "Sociālie tīkli";
const Linkedinhandle$a = "Linkedin profils";
const Twitterhandle$a = "Twitter rokturis";
const Facebookhandle$a = "Facebook rokturis";
const Githubhandle$a = "Github rokturis";
const Gmailhandle$a = "Gmail rokturis";
const Changessavedsuccessfully$a = "Izmaiņas veiksmīgi saglabātas";
const EditContact$a = "Rediģēt kontaktu";
const BasicInformation$a = "Pamatinformācija";
const EditContactDetails$a = "Rediģēt kontakta datus";
const SaveChanges$a = "Saglabāt izmaiņas";
const phoneNoMinimum14char$a = "Telefona numuram jābūt vismaz 14 rakstzīmēm.";
const LinkedIn$a = "LinkedIn";
const Twitter$a = "Twitter";
const Facebook$a = "Facebooks";
const Github$a = "Github";
const Gmail$a = "Gmail";
const youCanWriteAbout$a = "Jūs varat rakstīt par savu pieredzi gados, nozari vai prasmēm. Cilvēki arī runā par savām sasniegumiem vai iepriekšējām darba pieredzēm.";
const Addednewsection$a = "Pievienota jauna sadaļa";
const Removedsuccessfully$a = "Veiksmīgi noņemts.";
const Remove$a = "Noņemt";
const Institute$a = "Institūts";
const Schoolisrequired$a = "Skola ir obligāta";
const Degree$a = "Grāds";
const StartMonth$a = "Sākuma mēnesis";
const StartYear$a = "Sākuma gads";
const EndMonth$a = "Mēneša beigas";
const EndYear$a = "Gada beigas";
const Addmore$a = "Pievienot vairāk";
const PositionTitle$a = "Amata nosaukums";
const ExperienceType$a = "Pieredzes tips";
const Addednewitem$a = "Pievienots jauns priekšmets";
const whatSkillsDoYouEnjoy$a = "Kādas prasmes tev ir vai kādu darbu tu priecājies veikt?";
const Typeskillshere$a = "Ierakstiet prasmes šeit";
const LinkedContacts$a = "Saistītie kontakti";
const LinkContact$a = "Saistīt kontaktu";
const NocontactsLinked$a = "Nav saistītu kontaktu";
const JobContactsComponent$a = {
	linkContact: "Saistot kontaktus, jūs ātri varat redzēt, kuri cilvēki, piemēram, rekrutors, pieņēmējs utt., ir svarīgi šim darbam! Nākotnē mēs varēsim piedāvāt atbilstošus ieteikumus, pamatojoties uz jūsu kontaktiem."
};
const Nocontacts$a = "Nav kontaktu";
const LinkJobto$a = "Sasaistīt darbu ar";
const Contact$a = "Kontakti";
const Document$a = "Dokuments";
const Nojobsfound$a = "Nav atrasts neviens darbs";
const LinkJob$a = "Saistīt darbu";
const youCanLinkContactJobImported$a = "Jūs varat saistīt šo kontaktu ar darbu, ko esat importējis Careerflow.";
const Prev$a = "iepriekš";
const Next$a = "Nākamais";
const areYouSureUnlinkDocument$a = "Vai tiešām vēlaties atsaistīt šo dokumentu?";
const areYouSureDeleteDocument$a = "Vai tiešām vēlaties dzēst šo dokumentu?";
const Category$a = "Kategorija";
const CreatedOn$a = "Izveidots";
const Joblinked$a = "Darbs saistīts";
const Quickactions$a = "Ātrās darbības";
const All$a = "Visi";
const Resume$a = "Dzīves apraksts";
const Portfolio$a = "Portfelis";
const Other$a = "Cits";
const Adddocument$a = "Pievienot dokumentu";
const Type$a = "Tips";
const Sortingby$a = "Kārtošana pēc";
const SwitchtoGridLayout$a = "Pārslēgties uz režģa izkārtojumu";
const SwitchtoListLayout$a = "Pārslēgt uz saraksta izkārtojumu";
const NoDocumentsAdded$a = "Nav pievienoti dokumenti";
const DocumentsComponent$a = {
	nodocs: "Jūs vēl neesat izveidojis nevienu dokumentu. Jūs varat augšupielādēt savus rezumes versijas, pavadu vēstules un citus dokumentus un saistīt tos ar darbiem, kurus sekojat!"
};
const NoDocumentFound$a = "Dokuments nav atrasts";
const SelectFile$a = "Atlasīt failu";
const onlyPdfDocxSupported$a = "Tiek atbalstīti tikai .pdf un .docx formāti.";
const Uploadfile$a = "Augšupielādēt failu";
const DocumentCategory$a = "Dokumenta kategorija";
const SaveDocument$a = "Saglabāt dokumentu";
const AddDocument$a = "Pievienot dokumentu";
const LinkedDocuments$a = "Savienotie dokumenti";
const LinkDocument$a = "Saistīt dokumentu";
const NodocumentsLinked$a = "Nav saistītu dokumentu";
const JobDocumentsComponent$a = {
	linkDocs: "Saistot visus svarīgos dokumentus, piemēram, dzīves aprakstu, pavadu vēstuli utt., ko jūs iesniedzāt šim darbam, jums būs vieglāk visu uzturēt vienuviet."
};
const NoDocuments$a = "Nav dokumentu";
const CreateDocuments$a = "Izveidot dokumentus";
const youCanLinkDocumentJobImported$a = "Jūs varat saistīt šo dokumentu ar darbu, ko esat importējis Careerflow.";
const Documenteditedsuccessfully$a = "Dokuments veiksmīgi rediģēts";
const DocumentDetails$a = "Dokumenta informācija";
const UnsavedChanges$a = "Nesaglabātās izmaiņas";
const yourChangesWillBeLostSureClose$a = "Jūsu veiktie izmaiņas tiks zaudētas, vai tiešām vēlaties aizvērt?";
const yourChangesWillBeLostSureDiscard$a = "Jūsu veiktie izmaiņas tiks zaudētas, vai tiešām vēlaties atmest izmaiņas?";
const DiscardChanges$a = "Atcelt izmaiņas";
const WeeklyGoalAlert$a = "Nedēļas mērķa brīdinājums";
const Progress$a = "Progress - \"Progress\"";
const AllGoals$a = "Visi mērķi";
const Name$a = "Vārds";
const Completedon$a = "Pabeigts";
const Createdon$a = "Izveidots";
const Action$a = "Darbība";
const Back$a = "Atpakaļ";
const OverallScore$a = "Kopējais vērtējums";
const Aboutthegoal$a = "Par mērķi";
const GoalTracking$a = "Mērķa izsekošana";
const Week$a = "Nedēļa";
const progress$a = "progress - progresss";
const loading$a = "Ielādē...";
const Apply$a = "Pieteikties";
const Thisskillhasbeenreported$a = "Šis prasības līmenis ir ziņots.";
const issueGettingResume$a = "Bija problēma ar CV iegūšanu.";
const Interview$a = "Intervija";
const Tasks$a = "Uzdevumi";
const Loading$a = "Ielāde";
const Skilladdedsuccessfully$a = "Prasme veiksmīgi pievienota.";
const problemAddingSkill$a = "Bija problēma pievienojot prasmi.";
const Reportaproblem$a = "Ziņot par problēmu";
const Submit$a = "Iesniegt";
const Addanewskill$a = "Pievienot jaunu prasmi";
const JobDetailsComponent$a = {
	classifySkill: "Kā jūs klasificētu šo prasmi (neobligāti)",
	includedKeywordsWillCount: "Iekļaut šo atslēgvārdu?",
	yesIncludeThisSkill: "Iekļautie atslēgvārdi tiks ņemti vērā jūsu atbilstības rezultātos visos turpmākajos skenēšanas procesos. Jūs varat mainīt iekļautos atslēgvārdus savā profilā.",
	addSkill: "Vai vēlaties pievienot to kā prasmi?"
};
const HardSkill$a = "Ciešā prasme";
const SoftSkill$a = "Mīkstā prasme";
const Pleaseshareanyadditionalcontext$a = "Lūdzu, dalieties ar papildu kontekstu";
const Addasskill$a = "Pievienot kā prasmi";
const Skill$a = "Prasme";
const JobFrequency$a = "Darba biežums";
const ResumeFrequency$a = "CV biežums";
const Reportskill$a = "Ziņot par prasmi";
const JobDetails$a = "Darba apraksts";
const ViewJobLink$a = "Skatīt darba saiti";
const Salary$a = "Alga";
const areYouSureDeleteJob$a = "Vai jūs esat drošs, ka vēlaties dzēst šo darbu?";
const ViewMore$a = "Skatīt vairāk";
const ViewLess$a = "Skatīt mazāk";
const matchYouSkillsAgainstJob$a = "Saskaņojiet savas prasmes ar darba aprakstu.";
const pleaseUploadResumeSkillMatch$a = "Lūdzu, augšupielādējiet savu CV, lai saņemtu savu prasmju atbilstības rezultātu.";
const AddResume$a = "Pievienot CV";
const thisJobDoesNotHaveAnyDesc$a = "Šim darbam nav nekāda apraksta.";
const youCanEditJobToAdd$a = "Jūs varat rediģēt šo darbu, lai pievienotu tam aprakstu. Jūs arī varat importēt darbus, izmantojot mūsu.";
const chromeextension$a = "Chrome paplašinājums";
const fromVariousJobPortalsOnce$a = "no dažādiem darba portāliem. Kad pievienosiet aprakstu, jūs arī varēsiet redzēt prasmju saistīto informāciju.";
const AddDescription$a = "Pievienot aprakstu";
const CompanyInfo$a = "Uzņēmuma informācija";
const Website$a = "Mājaslapa";
const Industry$a = "Nozare";
const EmployeeCount$a = "Darbinieku skaits";
const ExprienceLevel$a = "Pieredzes līmenis";
const Address$a = "Adrese";
const Resumes$a = "CV";
const Setasdefault$a = "Iestatīt kā noklusējumu";
const Ok$a = "Labi";
const UploadNewResume$a = "Augšupielādēt jaunu CV";
const Default$a = "Noklusējums";
const Jobnotfound$a = "Darbs nav atrasts";
const EditDetails$a = "Rediģēt detaļas";
const JobPostURL$a = "Darba sludinājuma URL";
const Enterjoburl$a = "Ievadiet darba vietnes adresi";
const Nojobselected$a = "Nav izvēlēta darba vieta";
const Viewjobdetails$a = "Skatīt darba detaļas";
const Jobaddedtoyourboardsuccessfully$a = "Darbs veiksmīgi pievienots jūsu dēļam";
const AddJob$a = "Pievienot darbu";
const Addnewjobname$a = "Pievienot jaunu darba nosaukumu";
const JobUrl$a = "Darba saites URL";
const Addjoburl$a = "Pievienot darba vietnes adresi";
const Section$a = "Sadaļa";
const didYouKnow$a = {
	chromeExtension: "Vai jūs zinājāt? Jūs varat arī saglabāt darbus tieši no mūsu Chrome paplašinājuma un visu informāciju importēt vienā klikšķī! Tas aizņem tikai dažas sekundes."
};
const Jobs$a = "Darbi";
const AddJobtoboard$a = "Pievienot darbu dēļam";
const Currentlynojobsareavailable$a = "Pašlaik nav pieejamu darba vietu.";
const noMatchingJobs$a = "Nav atrasts neviens atbilstošs darbs.";
const welcomeToYourPersonalJobTracker$a = "Laipni lūdzam Jūsu personīgajā darba uzskaitē!";
const weShortTutorialOnHowTrackingJob$a = "Mēs jums sniegsim īsu pamācību par to, kā sākt sekot līdzi savām darba pieteikumiem dažos vienkāršos soļos!";
const Addanewjob$a = "Pievienot jaunu darbu";
const inOrderTrackCreatButton$a = "Lai sāktu darba pieteikumu izsekošanu, jums vispirms jāpievieno tas uz dēļa, noklikšķinot uz pogas \"Izveidot\".";
const Providesomedetails$a = "Sniedziet dažas detaļas.";
const toBeginTypeJobTitleCompany$a = "Sākumā vienkārši ierakstiet darba nosaukumu, uzņēmuma nosaukumu un statusu, ko vēlaties tam pievienot. Vēlāk varat pievienot vairāk informācijas, bet pašlaik tas ir viss, kas jums nepieciešams!";
const asAnExampleFilledForYou$a = "Kā piemēru, mēs jau esam aizpildījuši to jums!";
const wohooAddedFirstJob$a = "Woohoo! Tu pievienoji savu pirmo darbu savam darba uzskaitītājam!";
const youCanDragDropJobCard$a = "Tagad jūs varat vilkt un nomest darba karti dažādās darba pieteikuma procesa stadijās. Noklikšķinot uz darba kartes, jūs varat skatīt vairāk informācijas, to rediģēt, saglabāt piezīmes un citu!";
const Lastbutnotleast$a = "Nobeigumā";
const finalStepMakeSure$a = "Kā pēdējo soli, pārliecinieties, ka jums ir mūsu latviešu tulkojums.";
const autoMaticallyImportJobs$a = "kas ļaus jums automātiski importēt darba piedāvājumus no jūsu iecienītākajiem darba meklēšanas portāliem, piemēram, LinkedIn, Indeed un citiem! Mūsu paplašinājums arī palīdzēs jums uzlabot jūsu LinkedIn profilu un iegūt 2,5 reizes vairāk meklēšanas parādījumu!";
const selectanysection$a = "izvēlieties jebkuru sadaļu";
const Accept$a = "Akceptēt";
const My2023JobSearch$a = "Mana 2023. gada darba meklēšana";
const AddedFrom$a = "Pievienots no";
const AddedUntil$a = "Pievienots līdz";
const BasicModal$a = "Pamata modāls";
const AddnewSectionName$a = "Pievienot jaunu sadaļas nosaukumu";
const OpenTo$a = "Atvērts";
const Featured$a = "Izcelts";
const LicenceAndCerts$a = "Atļaujas un sertifikāti";
const Banner$a = "Baneris";
const LinkedInURL$a = "LinkedIn URL";
const Recommendations$a = "Ieteikumi";
const LinkedinReview$a = "Atsauksme par Linkedin";
const NoDataAvailable$a = "Dati nav pieejami";
const looksLikeYouDidNot$a = "Izskatās, ka jūs neesat sākuši izmantot mūsu latviešu tulkojumu.";
const toOptimizeProfileScoreVisible$a = "vēl nav optimizējis savu LinkedIn profilu. Kad to izdarīsi, šeit būs redzams tavs profila vērtējums.";
const LinkedinComponent$a = {
	letsOptimize: "Optimizēsim"
};
const improveYourChancesLandingDreamJob$a = "Uzlabojiet savas izredzes iegūt savu sapņu darbu. Izmantojiet šīs pārbaudītas stratēģijas, lai dotu savam LinkedIn profilam nepieciešamo atjauninājumu.";
const VisitProfile$a = "Apmeklēt profilu";
const wantToGetLinkedinMakeover$a = "Vai vēlaties saņemt pilnīgu LinkedIn pārveidošanu?";
const PostGenerator$a = "Ierakstu ģenerators";
const LinkedinHeadlineGenerator$a = "LinkedIn virsraksta ģenerators";
const LinkedinAboutSectionGenerator$a = "LinkedIn Par sadaļas ģenerators";
const AITools$a = "AI instrumenti";
const Premium$a = "Augstākā klase";
const LinkedInOptimization$a = "Savienojuma optimizācija";
const JobTracker$a = "Darba uzskaitītājs";
const whoIsHiring$a = "Kas pieņem darbā";
const Autofill$a = "Automātiskais aizpildījums";
const HeadlineGenerator$a = "Virsrakstu ģenerators";
const skillMatching$a = "Prasmju saskaņošana";
const SummarizeJD$a = "Kopsavilkums par darba aprakstu";
const contactFeature$a = "Kontaktu izsekošana";
const documentFeature$a = "Dokumenti";
const landJobWithoutStress$a = "Iegūsti savu sapņu darbu. Bez stresa.";
const discoverFeatures$a = "Atklājiet Careerflow.ai funkciju klāstu, kas izstrādātas, lai optimizētu jūsu darba meklēšanu un uzlabotu profesionālo ceļu!";
const letsBeginOnboarding$a = "Iepazīsimies labāk!";
const inTheNextFewScreensJobThirdParties$a = "Nākamajās dažās ekrānos mēs jautāsim jums dažus jautājumus, kas palīdzēs mums pielāgot pieredzi jums, kā arī automātiski aizpildīt jūsu darba pieteikumus (lai jums nav jādara tas pats)! Mēs neizpārdodam jūsu datus trešajām personām.";
const letsAddBasicInformation$a = "Pievienojam Tavu pamatinformāciju";
const Pleaseselectanoptionfirst$a = "Lūdzu, vispirms izvēlieties opciju.";
const JobApplicationTracker$a = "Darba Pieteikumu Sekotājs";
const LinkedInProfileOptimizer$a = "Linked In profila optimizētājs";
const UnlimitedDocuments$a = "Neierobežoti dokumenti.";
const UnlimitedContacts$a = "Neierobežoti kontakti.";
const HiringManagerSearch$a = "Darba devēja meklēšana";
const AILinkedInPostGenerator$a = "AI LinkedIn ierakstu ģenerators";
const ATSKeywordSkillMatch$a = "ATS atslēgvārdu / prasmju atbilstības darbs";
const ChooseyourPlan$a = "Izvēlies savu plānu";
const superChargeYourJobSearch$a = "Paātriniet savu darba meklēšanu un uzlabojiet savu darba pieteikuma procesu, palieliniet savas intervijas un iegūstiet savu sapņu darbu. Viss ar Careerflow premium rīku palīdzību.";
const startNowGoto$a = "Sāc tagad (iet uz lietotni)";
const CreatedBy$a = "Izveidojis";
const CreateNewNote$a = "Izveidot jaunu piezīmi";
const Nonotescreated$a = "Nav izveidotas piezīmes";
const approxTimeIsFourMinutes$a = "Aptuvenais laiks, lai pabeigtu iepazīšanās procesu, ir 4 minūtes.";
const Continue$a = "Turpināt";
const iWillDoLaterTakeMeToApp$a = "Es to darīšu vēlāk. Aizved mani uz lietotni.";
const allDone$a = "Viss darīts!";
const welcomeAbord$a = "Laipni lūdzam piebord!";
const letsBegin$a = "Sāksim";
const UpgradeyourplanandgetAIAssistance$a = "Uzlabojiet savu plānu un saņemiet AI palīdzību";
const DownloadPDF$a = "Lejupielādēt PDF";
const oopsWeCouldntProcessResume$a = "Atvainojiet, mēs nevarējām apstrādāt šo CV.";
const MyProfile$a = "Mana profils";
const Setting$a = "Iestatījums";
const Logout$a = "Izrakstīties";
const SignIn$a = "Pierakstīties";
const Typeyourfirstnamehere$a = "Jūsu vārds";
const Enteryourlastname$a = "Jūsu uzvārds";
const ManageSubscription$a = "Pārvaldīt abonementu";
const ifYouHaveDifficultiesProfile$a = "Ja jums ir grūtības ar jūsu profilu informāciju, lūdzu, sazinieties ar";
const forSupport$a = "Atbalstam.";
const whatIsIdealCompanySize$a = "Kāda ir jūsu ideālā uzņēmuma lielums?";
const Saveandcontinue$a = "Saglabāt un turpināt";
const whatIsMinExpectedSalary$a = "Kāda ir jūsu minimālā gaidāmā alga (gadā)?";
const Atleast$a = "Vismaz";
const SlidetoAdjust$a = "Slīdēt, lai pielāgotu";
const whatIndustryExcitedWork$a = "Kādas nozarēs jūs interesē?";
const Add$a = "Pievienot";
const statusOfJobSearch$a = "Kāds ir jūsu darba meklēšanas statuss?";
const Finish$a = "Pabeigt";
const whatLevelRoleLooking$a = "Kādu lomu līmeni jūs meklējat?";
const Selectuptotwo$a = "Izvēlieties līdz diviem.";
const PreviousStep$a = "Iepriekšējais solis";
const Skip$a = "Izlaist";
const whatDoYouValueNewRole$a = "Ko jūs novērtējat jaunā lomā?";
const Selectuptothree$a = "Izvēlieties līdz trim.";
const EqualEmploymentData$a = "Vienlīdzīgas nodarbinātības dati";
const whatIsYourEthnicity$a = "Kāda ir jūsu etniskā piederība?";
const areYouAuthorizedToWorkUs$a = "Vai jums ir atļauja strādāt ASV?";
const willYouRequireSponsorShip$a = "Vai jums tagad vai nākotnē būs nepieciešama atbalsta sniegšana darba vīzas statusam?";
const doYouHaveADisability$a = "Vai jums ir kāda invaliditāte?";
const areYouAVeteran$a = "Vai jūs esat veterāns?";
const rolesYouInterestedIn$a = "Kādas lomas tev interesē?";
const Selectuptofive$a = "Izvēlieties līdz pat pieciem.";
const AddCustomrole$a = "Pievienot pielāgotu lomu";
const whereDoYouLikeWork$a = "Kur jūs vēlētos strādāt?";
const Resources$a = "Resursi";
const currentlyNoResourceAvailable$a = "Pašlaik nav pieejamu resursu.";
const AddNewSection$a = "Pievienot jaunu sadaļu";
const ChangeSections$a = "Izmainīt sadaļas";
const Settings$a = "Iestatījumi";
const Dashboard$a = "Informācijas panelis";
const JobBoard$a = "Darba dēlis";
const Linkedin$a = "Linkedin";
const Community$a = "Kopiena";
const FindRecruiters$a = "Atrast darba devējus";
const Goals$a = "Mērķi";
const DownloadExtension$a = "Lejupielādēt paplašinājumu";
const SuggestaFeature$a = "Ieteikt funkciju";
const leftPanel$a = {
	ReportanIssue: "Ziņot par problēmu"
};
const PhoneNumberisrequired$a = "Nepieciešams norādīt telefona numuru.";
const MobileNumber$a = "Mobilais numurs";
const Enteronlynumbers$a = "Ievadiet tikai skaitļus";
const Countryyoulivein$a = "Valsts, kurā dzīvojat";
const SelectaCountry$a = "Izvēlieties valsti";
const DateofBirth$a = "Dzimšanas datums";
const Gender$a = "Dzimums";
const JobPreferences$a = "Darba vēlmes";
const pleaseEnterValidEmail$a = "Lūdzu, ievadiet derīgu e-pasta adresi.";
const emailSendForResetting$a = "Jums ir nosūtīts e-pasts par paroles atiestatīšanu.";
const VerifyyourEmailID$a = "Pārbaudiet savu e-pasta adresi";
const sentPleaseCheckEmail$a = "Nosūtīts! Lūdzu, pārbaudiet savu e-pastu.";
const tooManyAttemptsTryAgain$a = "Pārāk daudz mēģinājumu, lūdzu, mēģiniet vēlreiz pēc kāda laika.";
const Resend$a = "Atkārtoti nosūtīt";
const Login$a = "Pieteikties";
const weHaveSentVerificationLinkAtEmail$a = "Mēs esam nosūtījuši jums verifikācijas saiti uz jūsu e-pastu.";
const pleaseVerifyEmailContinueSpam$a = "Lūdzu, verificējiet savu e-pastu, lai turpinātu. Lūdzu, pārbaudiet arī savu spamu vai reklāmu mapē, lai atrastu verifikācijas e-pastu.";
const Logintogetstarted$a = "Ielogojieties, lai sāktu.";
const ContinuewithGoogle$a = "Turpināt ar Google";
const pleaseInputEmail$a = "Lūdzu, ievadiet savu e-pastu!";
const Password$a = "Parole";
const pleaseInputPassword$a = "Lūdzu, ievadiet savu paroli!";
const passwordLowerUpperDigitSpecial$a = "Jūsu parolei jāsatur vismaz viena maza burta, liela burta, cipara un īpaša rakstura simbols.";
const atLeastSixChar$a = "Vismaz 6 rakstzīmes.";
const forgotPassword$a = "Aizmirsāt paroli?";
const Bysigninginyouagreetoour$a = "Pierakstoties, jūs piekrītat mūsu.";
const Terms$a = "Noteikumi";
const Conditions$a = "Nosacījumi";
const and$a = "un";
const PrivacyPolicy$a = "Privātuma politika";
const theseAreTheTopsSkillsExtracted$a = "Šie ir augstākās prasmes, kas izceltas no darba apraksta.";
const TopSkills$a = "Labākās prasmes";
const weCoulNotExtractSkills$a = "Mēs nevarējām izvilkt nekādas prasmes no šī darba apraksta.";
const upgradeToPremiumToView$a = "Uzlabojiet uz Premium, lai skatītu savu CV prasmju atbilstības rezultātu.";
const SkillScore$a = "Prasmes vērtējums";
const thisIsYourSkillScoreBasedOn$a = "Šis ir jūsu prasmju vērtējums, pamatojoties uz darba aprakstu un jūsu CV.";
const theseSkllsAreStrongMatch$a = "Šie prasības ir spēcīgi saderīgas ar jūsu CV un darba aprakstu.";
const Strongmatch$a = "Spēcīgs saskaņojums";
const theseSkillsArePartialMatch$a = "Šie prasmes ir daļēji atbilstošas jūsu CV un darba aprakstam.";
const Partialmatch$a = "Daļēji atbilst";
const theseSkillsAreMissingFrom$a = "Šie atslēgvārdi nav iekļauti jūsu CV, bet tie ir pieejami darba aprakstā. Tie var būt prasmes vai vispārējie atslēgvārdi, kas ir specifiski darba iespējai un varētu būt noderīgi, lai pievienotu tos savam CV.";
const SkillMatchComponent$a = {
	removeSkill: "Kāds ir jūsu galvenais iemesls problēmai ar atslēgvārdu"
};
const Optional$a = "Izvēles";
const Notrelevanttothejob$a = "Nav saistīts ar darbu";
const Notaskill$a = "Nav prasme";
const Toogeneric$a = "Pārāk vispārīgs";
const Pleaseshareanyfeedback$a = "Lūdzu, dalieties ar jebkādu atsauksmi";
const excludedKeywordsWillNot$a = "Izslēgtie atslēgvārdi neskaitīsies pret jūsu atbilstības rezultātu visām turpmākajām skenēšanām. Jūs varat mainīt izslēgtos atslēgvārdus savā profilā.";
const yesExcludeThisSkillFrom$a = "Jā, izslēdziet šo prasmi no visiem maniem CV skenējumiem.";
const PartialMatch$a = "Daļējs saskaņojums";
const MissingKeywords$a = "Trūkstošie atslēgvārdi";
const Providetitletotask$a = "Nodrošiniet uzdevumam nosaukumu";
const TasksList$a = "Uzdevumu saraksts";
const AddTask$a = "Pievienot uzdevumu";
const EnterTaskTitlehere$a = "Ievadiet uzdevuma nosaukumu šeit";
const TasksComponent$a = {
	listEmpty: "Uzdevumu saraksts ir tukšs. Izveidojiet jaunu."
};
const CompletedTasks$a = "Pabeigtie uzdevumi";
const CompleteYourtasks$a = "Pabeidziet savus uzdevumus";
const Steps$a = "Soļi";
const PremiumMember$a = "Augstākās klases biedrs";
const Thankyouforupgradingto$a = "Paldies par uzlabojumu uz";
const CareerflowPremium$a = "Karjeras plūsma Premium";
const hereIsHowYouCanAccessPremium$a = "Šeit ir kā piekļūt jūsu Premium priekšrocībām!";
const stepOne$a = "1. solis";
const DownloadourChromeExtension$a = "Lejupielādējiet mūsu Chrome paplašinājumu";
const youJobSearchCopilotIshere$a = "Jūsu darba meklēšanas AI kopilots ir šeit.";
const DownloadNow$a = "Lejupielādēt tagad";
const stepTwo$a = "2. solis";
const GetStarted$a = "Sākt";
const stepThree$a = "3. solis";
const SignintoChromeExtension$a = "Pierakstieties Chrome paplašinājumā";
const entityCreated$a = "Izveidots jauns {{entity}}";
const entityUpdated$a = "{{entity}} atjaunināts.";
const entityDeleted$a = "{{entity}} dzēsts.";
const entityLinked$a = "{{entity}} saistīts";
const entityUnlinked$a = "{{entity}} nav saistīts";
const entityMovedTo$a = "Pārvietots uz {{entity}}.";
const youAddedANewEntity$a = "Jūs pievienojāt jaunu {{entity}}.";
const personCreated$a = "{{creator}} izveidoja {{entity}} priekš {{owner}}.";
const youUpdatedAEntity$a = "Jūs atjauninājāt {{entity}}.";
const personUpdated$a = "{{creator}} atjaunināja {{entity}} priekš {{owner}}.";
const youDeletedAEntity$a = "Jūs dzēsāt {{entity}}.";
const personDeleted$a = "{{creator}} dzēsa {{entity}} priekš {{owner}}.";
const youLinkedEntity$a = "Jūs saistījāt {{entity}} ar šo darbu.";
const personLinked$a = "{{creator}} saistīja {{entity}} ar šo darbu priekš {{owner}}.";
const youUnlinked$a = "Jūs atsaistījāt {{entity}} no šī darba.";
const personUnlinked$a = "{{creator}} atsaistīja {{entity}} no šī darba uzdevuma, kas pieder {{owner}}.";
const youMovedEntity$a = "Jūs pārvietojāt šo {{entity}} no {{sectionFrom}} uz {{sectionTo}}.";
const personMoved$a = "{{creator}} pārvietoja šo {{entity}} no {{sectionFrom}} uz {{sectionTo}} priekš {{owner}}.";
const addedByName$a = "Pievienots ar {{name}}.";
const DownloadChromeExtension$a = "Lejupielādēt Chrome paplašinājumu";
const ourChromeExtensionIs$a = "Mūsu hroma paplašinājums ir integrēts rīks, kas palīdzēs jums optimizēt LinkedIn profilu, saglabāt darbu, saglabāt kontaktus, ģenerēt pieteikuma vēstuli un vēl daudz ko citu.";
const Optimizeyourprofile$a = "Optimizējiet savu profilu.";
const startOptimizingYourProfile$a = "Sāciet optimizēt savu profilu, lai palielinātu iespējas saņemt kontaktu no darba devējiem.";
const OptimizeNow$a = "Optimizēt tagad";
const Addyourfirstjob$a = "Pievieno savu pirmo darbu";
const startSavingJobApplicationsToTrack$a = "Sāc saglabāt darba pieteikumus, lai sekotu savam darba meklējumu ceļam un atrastu noderīgus atziņas.";
const AddNow$a = "Pievienot tagad";
const CompleteProfile$a = "Pilns profils";
const completeYourProfileForUsing$a = "Aizpildiet savu profilu, lai izmantotu automātiskās aizpildīšanas funkciju un saņemtu vēl personīgāku pieredzi.";
const CompleteNow$a = "Pabeigt tagad";
const Addyourfirstcontact$a = "Pievieno savu pirmo kontaktu";
const addContactToFollowUpWith$a = "Pievienojiet kontaktu, lai to varētu vēlāk sekot, pievienojiet piezīmes un vēl vairāk.";
const JoinCommunity$a = "Pievienojies kopienai";
const ourCommunityisAlways$a = "Mūsu kopiena vienmēr ir ar tevi tavā darba meklējumu ceļojumā.";
const JoinNow$a = "Pievienojies tagad";
const welcomeToCareerflow$a = "Laipni lūdzam Careerflow!";
const yourHubForCareerInsights2$a = "Šis ir tavs centrs karjeras ieskatu, aktivitātēm un vairāk. Izpēti savu personalizēto informācijas paneli, lai paliktu uz augšu savā profesionālajā ceļojumā.";
const ChecklistCompleted$a = "Jūsu kontrolsaraksts ir pabeigts!";
const Completeyourchecklist$a = "Pabeidziet savu kontrolsarakstu.";
const completeAFewStepsTo$a = "Pabeidziet dažus soļus, lai iegūtu nākamo darbu.";
const Completed$a = "Pabeigts";
const JobCountByStage$a = "Darba skaits pēc posma";
const NopastapplicationDatafound$a = "Nav atrasts iepriekšējais pieteikuma datu";
const YourJobSearchStages$a = "Jūsu darba meklēšanas posmi";
const NoDatafound$a = "Dati nav atrasti";
const lv = {
	copyToClipboard: copyToClipboard$a,
	UnlocktheAIgenerated: UnlocktheAIgenerated$a,
	UpgradetoPremium: UpgradetoPremium$a,
	Result: Result$a,
	Copy: Copy$a,
	Save: Save$a,
	Edit: Edit$a,
	Processing: Processing$a,
	YourAIgeneratedcontentwillshowhere: YourAIgeneratedcontentwillshowhere$a,
	hopeYouFindUseful: hopeYouFindUseful$a,
	regenerate: regenerate$a,
	ProvideAdditionalFeedback: ProvideAdditionalFeedback$a,
	Enteranyfeedback: Enteranyfeedback$a,
	Notimpressive: Notimpressive$a,
	thisIsntTrue: thisIsntTrue$a,
	Notpersonalized: Notpersonalized$a,
	Tone: Tone$a,
	Length: Length$a,
	Template: Template$a,
	Generatedon: Generatedon$a,
	Copiedtoclipboard: Copiedtoclipboard$a,
	CopytoClipboard: CopytoClipboard$a,
	DownloadasPDF: DownloadasPDF$a,
	ViewDetails: ViewDetails$a,
	JobDescriptionImported: JobDescriptionImported$a,
	ImportfromJob: ImportfromJob$a,
	Saved: Saved$a,
	Applied: Applied$a,
	Offer: Offer$a,
	Interviewing: Interviewing$a,
	Rejected: Rejected$a,
	Search: Search$a,
	Import: Import$a,
	CoverLetterGeneratorHistory: CoverLetterGeneratorHistory$a,
	NoCoverLettersGenerated: NoCoverLettersGenerated$a,
	getStartedCoverLetter: getStartedCoverLetter$a,
	getStarted: getStarted$a,
	Documents: Documents$a,
	UploadNewDocument: UploadNewDocument$a,
	AICoverLetterGenerator: AICoverLetterGenerator$a,
	ViewHistory: ViewHistory$a,
	JobDescription: JobDescription$a,
	ImportfromBoard: ImportfromBoard$a,
	EnterJobDescription: EnterJobDescription$a,
	JobTitle: JobTitle$a,
	EnterJobTitle: EnterJobTitle$a,
	CompanyName: CompanyName$a,
	EnterCompanyName: EnterCompanyName$a,
	YourProfile: YourProfile$a,
	ResumeUpload: ResumeUpload$a,
	UseLinkedinProfile: UseLinkedinProfile$a,
	Uploadyourresume: Uploadyourresume$a,
	AddyourResume: AddyourResume$a,
	fileNameCannotFormat: fileNameCannotFormat$a,
	ChooseorUpload: ChooseorUpload$a,
	SelectTemplate: SelectTemplate$a,
	Preview: Preview$a,
	UseTemplate: UseTemplate$a,
	Change: Change$a,
	AdvancedSettings: AdvancedSettings$a,
	AdditionalContext: AdditionalContext$a,
	Professional: Professional$a,
	Casual: Casual$a,
	Enthusiastic: Enthusiastic$a,
	Informational: Informational$a,
	Short: Short$a,
	Medium: Medium$a,
	Long: Long$a,
	Language: Language$a,
	iAmOkayBack: iAmOkayBack$a,
	Generate: Generate$a,
	CoverLetter: CoverLetter$a,
	SelectLanguage: SelectLanguage$a,
	AboutGeneratorHistory: AboutGeneratorHistory$a,
	NoAboutsGenerated: NoAboutsGenerated$a,
	getStartedAbouts: getStartedAbouts$a,
	noAttachmentsFound: noAttachmentsFound$a,
	TargetJobTitle: TargetJobTitle$a,
	KeywordsToInclude: KeywordsToInclude$a,
	UploadYourResume: UploadYourResume$a,
	AddYourResume: AddYourResume$a,
	LinkedinProfile: LinkedinProfile$a,
	Linkedinprofilenotfound: Linkedinprofilenotfound$a,
	startUsingChromeExtension: startUsingChromeExtension$a,
	Download: Download$a,
	UseEmojis: UseEmojis$a,
	UseBulletPoints: UseBulletPoints$a,
	SpeechFocus: SpeechFocus$a,
	FirstPerson: FirstPerson$a,
	ThirdPerson: ThirdPerson$a,
	HeadlineGeneratorHistory: HeadlineGeneratorHistory$a,
	NoHeadlinesGenerated: NoHeadlinesGenerated$a,
	getStartedHeadline: getStartedHeadline$a,
	AIHeadlineGenerator: AIHeadlineGenerator$a,
	KeywordstoInclude: KeywordstoInclude$a,
	Pressenteraftereachword: Pressenteraftereachword$a,
	LinkedinProfilenotfound: LinkedinProfilenotfound$a,
	Headline: Headline$a,
	PostGeneratorHistory: PostGeneratorHistory$a,
	NoPostsGenerated: NoPostsGenerated$a,
	getStartedPost: getStartedPost$a,
	Topic: Topic$a,
	Description: Description$a,
	UseHashtags: UseHashtags$a,
	Custom: Custom$a,
	EnterCustomTone: EnterCustomTone$a,
	Added: Added$a,
	ComingSoon: ComingSoon$a,
	Company: Company$a,
	JobInterview: JobInterview$a,
	Research: Research$a,
	Networking: Networking$a,
	Referral: Referral$a,
	MustbeContacted: MustbeContacted$a,
	ScheduleaMeeting: ScheduleaMeeting$a,
	needAFollowUp: needAFollowUp$a,
	Today: Today$a,
	Viewdetails: Viewdetails$a,
	Activity: Activity$a,
	ActivityDetails: ActivityDetails$a,
	Delete: Delete$a,
	Title: Title$a,
	Goal: Goal$a,
	Status: Status$a,
	FollowUp: FollowUp$a,
	AddActivity: AddActivity$a,
	Enteractivitytitle: Enteractivitytitle$a,
	Cancel: Cancel$a,
	SaveActivity: SaveActivity$a,
	noActivityPresent: noActivityPresent$a,
	Addnew: Addnew$a,
	About: About$a,
	noDataPresentYou: noDataPresentYou$a,
	Experience: Experience$a,
	Education: Education$a,
	Skills: Skills$a,
	Overview: Overview$a,
	LinkedJobs: LinkedJobs$a,
	Notes: Notes$a,
	FullName: FullName$a,
	Location: Location$a,
	Relationship: Relationship$a,
	Contacts: Contacts$a,
	CreateContact: CreateContact$a,
	NotesCreated: NotesCreated$a,
	Notesupdated: Notesupdated$a,
	Addnote: Addnote$a,
	areYouSureDeleteNote: areYouSureDeleteNote$a,
	Createdby: Createdby$a,
	notSureWhyResumeCalls: notSureWhyResumeCalls$a,
	getExpertResumeReview: getExpertResumeReview$a,
	youHaventAddedContacts: youHaventAddedContacts$a,
	noMatchingContacts: noMatchingContacts$a,
	Link: Link$a,
	unlink: unlink$a,
	Locationnotavailable: Locationnotavailable$a,
	Emailnotavailable: Emailnotavailable$a,
	PhoneNumbernotavailable: PhoneNumbernotavailable$a,
	createdby: createdby$a,
	areYouSureDeleteContact: areYouSureDeleteContact$a,
	areYouSureUnlinkContact: areYouSureUnlinkContact$a,
	Addedbyyou: Addedbyyou$a,
	Addedby: Addedby$a,
	Timeline: Timeline$a,
	Timelineempty: Timelineempty$a,
	Discard: Discard$a,
	SaveContact: SaveContact$a,
	Recruiter: Recruiter$a,
	Candidate: Candidate$a,
	Colleague: Colleague$a,
	Employee: Employee$a,
	"Needtofollow-up": "Jāseko līdzi",
	EnterValidEmail: EnterValidEmail$a,
	EnterValidPhoneNumber: EnterValidPhoneNumber$a,
	editingProfileNotAvailable: editingProfileNotAvailable$a,
	itWillBeSoonAvailable: itWillBeSoonAvailable$a,
	ChromeExtension: ChromeExtension$a,
	SelectTag: SelectTag$a,
	FirstName: FirstName$a,
	FirstNameisrequired: FirstNameisrequired$a,
	LastName: LastName$a,
	LastNameisrequired: LastNameisrequired$a,
	Companyisrequired: Companyisrequired$a,
	Email: Email$a,
	ThisisnotavalidEmail: ThisisnotavalidEmail$a,
	AddEmail: AddEmail$a,
	PhoneNumber: PhoneNumber$a,
	notaValidPhone: notaValidPhone$a,
	phoneNoMinimum5char: phoneNoMinimum5char$a,
	phoneNoMinumum15char: phoneNoMinumum15char$a,
	AddPhoneNumber: AddPhoneNumber$a,
	SelectGoal: SelectGoal$a,
	SelectStatus: SelectStatus$a,
	Followup: Followup$a,
	SocialMedia: SocialMedia$a,
	Linkedinhandle: Linkedinhandle$a,
	Twitterhandle: Twitterhandle$a,
	Facebookhandle: Facebookhandle$a,
	Githubhandle: Githubhandle$a,
	Gmailhandle: Gmailhandle$a,
	Changessavedsuccessfully: Changessavedsuccessfully$a,
	EditContact: EditContact$a,
	BasicInformation: BasicInformation$a,
	EditContactDetails: EditContactDetails$a,
	SaveChanges: SaveChanges$a,
	phoneNoMinimum14char: phoneNoMinimum14char$a,
	LinkedIn: LinkedIn$a,
	Twitter: Twitter$a,
	Facebook: Facebook$a,
	Github: Github$a,
	Gmail: Gmail$a,
	youCanWriteAbout: youCanWriteAbout$a,
	Addednewsection: Addednewsection$a,
	Removedsuccessfully: Removedsuccessfully$a,
	Remove: Remove$a,
	Institute: Institute$a,
	Schoolisrequired: Schoolisrequired$a,
	Degree: Degree$a,
	StartMonth: StartMonth$a,
	StartYear: StartYear$a,
	EndMonth: EndMonth$a,
	EndYear: EndYear$a,
	Addmore: Addmore$a,
	PositionTitle: PositionTitle$a,
	ExperienceType: ExperienceType$a,
	Addednewitem: Addednewitem$a,
	whatSkillsDoYouEnjoy: whatSkillsDoYouEnjoy$a,
	Typeskillshere: Typeskillshere$a,
	LinkedContacts: LinkedContacts$a,
	LinkContact: LinkContact$a,
	NocontactsLinked: NocontactsLinked$a,
	JobContactsComponent: JobContactsComponent$a,
	Nocontacts: Nocontacts$a,
	LinkJobto: LinkJobto$a,
	Contact: Contact$a,
	Document: Document$a,
	Nojobsfound: Nojobsfound$a,
	LinkJob: LinkJob$a,
	youCanLinkContactJobImported: youCanLinkContactJobImported$a,
	Prev: Prev$a,
	Next: Next$a,
	areYouSureUnlinkDocument: areYouSureUnlinkDocument$a,
	areYouSureDeleteDocument: areYouSureDeleteDocument$a,
	Category: Category$a,
	CreatedOn: CreatedOn$a,
	Joblinked: Joblinked$a,
	Quickactions: Quickactions$a,
	All: All$a,
	Resume: Resume$a,
	Portfolio: Portfolio$a,
	Other: Other$a,
	Adddocument: Adddocument$a,
	Type: Type$a,
	Sortingby: Sortingby$a,
	SwitchtoGridLayout: SwitchtoGridLayout$a,
	SwitchtoListLayout: SwitchtoListLayout$a,
	NoDocumentsAdded: NoDocumentsAdded$a,
	DocumentsComponent: DocumentsComponent$a,
	NoDocumentFound: NoDocumentFound$a,
	SelectFile: SelectFile$a,
	onlyPdfDocxSupported: onlyPdfDocxSupported$a,
	Uploadfile: Uploadfile$a,
	DocumentCategory: DocumentCategory$a,
	SaveDocument: SaveDocument$a,
	AddDocument: AddDocument$a,
	LinkedDocuments: LinkedDocuments$a,
	LinkDocument: LinkDocument$a,
	NodocumentsLinked: NodocumentsLinked$a,
	JobDocumentsComponent: JobDocumentsComponent$a,
	NoDocuments: NoDocuments$a,
	CreateDocuments: CreateDocuments$a,
	youCanLinkDocumentJobImported: youCanLinkDocumentJobImported$a,
	Documenteditedsuccessfully: Documenteditedsuccessfully$a,
	DocumentDetails: DocumentDetails$a,
	UnsavedChanges: UnsavedChanges$a,
	yourChangesWillBeLostSureClose: yourChangesWillBeLostSureClose$a,
	yourChangesWillBeLostSureDiscard: yourChangesWillBeLostSureDiscard$a,
	DiscardChanges: DiscardChanges$a,
	WeeklyGoalAlert: WeeklyGoalAlert$a,
	Progress: Progress$a,
	AllGoals: AllGoals$a,
	Name: Name$a,
	Completedon: Completedon$a,
	Createdon: Createdon$a,
	Action: Action$a,
	Back: Back$a,
	OverallScore: OverallScore$a,
	Aboutthegoal: Aboutthegoal$a,
	GoalTracking: GoalTracking$a,
	Week: Week$a,
	progress: progress$a,
	loading: loading$a,
	Apply: Apply$a,
	Thisskillhasbeenreported: Thisskillhasbeenreported$a,
	issueGettingResume: issueGettingResume$a,
	Interview: Interview$a,
	Tasks: Tasks$a,
	Loading: Loading$a,
	Skilladdedsuccessfully: Skilladdedsuccessfully$a,
	problemAddingSkill: problemAddingSkill$a,
	Reportaproblem: Reportaproblem$a,
	Submit: Submit$a,
	Addanewskill: Addanewskill$a,
	JobDetailsComponent: JobDetailsComponent$a,
	HardSkill: HardSkill$a,
	SoftSkill: SoftSkill$a,
	Pleaseshareanyadditionalcontext: Pleaseshareanyadditionalcontext$a,
	Addasskill: Addasskill$a,
	Skill: Skill$a,
	JobFrequency: JobFrequency$a,
	ResumeFrequency: ResumeFrequency$a,
	Reportskill: Reportskill$a,
	JobDetails: JobDetails$a,
	ViewJobLink: ViewJobLink$a,
	Salary: Salary$a,
	areYouSureDeleteJob: areYouSureDeleteJob$a,
	ViewMore: ViewMore$a,
	ViewLess: ViewLess$a,
	matchYouSkillsAgainstJob: matchYouSkillsAgainstJob$a,
	pleaseUploadResumeSkillMatch: pleaseUploadResumeSkillMatch$a,
	AddResume: AddResume$a,
	thisJobDoesNotHaveAnyDesc: thisJobDoesNotHaveAnyDesc$a,
	youCanEditJobToAdd: youCanEditJobToAdd$a,
	chromeextension: chromeextension$a,
	fromVariousJobPortalsOnce: fromVariousJobPortalsOnce$a,
	AddDescription: AddDescription$a,
	CompanyInfo: CompanyInfo$a,
	Website: Website$a,
	Industry: Industry$a,
	EmployeeCount: EmployeeCount$a,
	ExprienceLevel: ExprienceLevel$a,
	Address: Address$a,
	Resumes: Resumes$a,
	Setasdefault: Setasdefault$a,
	Ok: Ok$a,
	UploadNewResume: UploadNewResume$a,
	Default: Default$a,
	Jobnotfound: Jobnotfound$a,
	EditDetails: EditDetails$a,
	JobPostURL: JobPostURL$a,
	Enterjoburl: Enterjoburl$a,
	Nojobselected: Nojobselected$a,
	Viewjobdetails: Viewjobdetails$a,
	Jobaddedtoyourboardsuccessfully: Jobaddedtoyourboardsuccessfully$a,
	AddJob: AddJob$a,
	Addnewjobname: Addnewjobname$a,
	JobUrl: JobUrl$a,
	Addjoburl: Addjoburl$a,
	Section: Section$a,
	didYouKnow: didYouKnow$a,
	Jobs: Jobs$a,
	AddJobtoboard: AddJobtoboard$a,
	Currentlynojobsareavailable: Currentlynojobsareavailable$a,
	noMatchingJobs: noMatchingJobs$a,
	welcomeToYourPersonalJobTracker: welcomeToYourPersonalJobTracker$a,
	weShortTutorialOnHowTrackingJob: weShortTutorialOnHowTrackingJob$a,
	Addanewjob: Addanewjob$a,
	inOrderTrackCreatButton: inOrderTrackCreatButton$a,
	Providesomedetails: Providesomedetails$a,
	toBeginTypeJobTitleCompany: toBeginTypeJobTitleCompany$a,
	asAnExampleFilledForYou: asAnExampleFilledForYou$a,
	wohooAddedFirstJob: wohooAddedFirstJob$a,
	youCanDragDropJobCard: youCanDragDropJobCard$a,
	Lastbutnotleast: Lastbutnotleast$a,
	finalStepMakeSure: finalStepMakeSure$a,
	autoMaticallyImportJobs: autoMaticallyImportJobs$a,
	selectanysection: selectanysection$a,
	Accept: Accept$a,
	My2023JobSearch: My2023JobSearch$a,
	AddedFrom: AddedFrom$a,
	AddedUntil: AddedUntil$a,
	BasicModal: BasicModal$a,
	AddnewSectionName: AddnewSectionName$a,
	OpenTo: OpenTo$a,
	Featured: Featured$a,
	LicenceAndCerts: LicenceAndCerts$a,
	Banner: Banner$a,
	LinkedInURL: LinkedInURL$a,
	Recommendations: Recommendations$a,
	LinkedinReview: LinkedinReview$a,
	NoDataAvailable: NoDataAvailable$a,
	looksLikeYouDidNot: looksLikeYouDidNot$a,
	toOptimizeProfileScoreVisible: toOptimizeProfileScoreVisible$a,
	LinkedinComponent: LinkedinComponent$a,
	improveYourChancesLandingDreamJob: improveYourChancesLandingDreamJob$a,
	VisitProfile: VisitProfile$a,
	wantToGetLinkedinMakeover: wantToGetLinkedinMakeover$a,
	PostGenerator: PostGenerator$a,
	LinkedinHeadlineGenerator: LinkedinHeadlineGenerator$a,
	LinkedinAboutSectionGenerator: LinkedinAboutSectionGenerator$a,
	AITools: AITools$a,
	Premium: Premium$a,
	LinkedInOptimization: LinkedInOptimization$a,
	JobTracker: JobTracker$a,
	whoIsHiring: whoIsHiring$a,
	Autofill: Autofill$a,
	HeadlineGenerator: HeadlineGenerator$a,
	skillMatching: skillMatching$a,
	SummarizeJD: SummarizeJD$a,
	contactFeature: contactFeature$a,
	documentFeature: documentFeature$a,
	landJobWithoutStress: landJobWithoutStress$a,
	discoverFeatures: discoverFeatures$a,
	letsBeginOnboarding: letsBeginOnboarding$a,
	inTheNextFewScreensJobThirdParties: inTheNextFewScreensJobThirdParties$a,
	letsAddBasicInformation: letsAddBasicInformation$a,
	Pleaseselectanoptionfirst: Pleaseselectanoptionfirst$a,
	JobApplicationTracker: JobApplicationTracker$a,
	LinkedInProfileOptimizer: LinkedInProfileOptimizer$a,
	UnlimitedDocuments: UnlimitedDocuments$a,
	UnlimitedContacts: UnlimitedContacts$a,
	HiringManagerSearch: HiringManagerSearch$a,
	AILinkedInPostGenerator: AILinkedInPostGenerator$a,
	ATSKeywordSkillMatch: ATSKeywordSkillMatch$a,
	"Auto-Apply": "Automātiska piemērošana",
	ChooseyourPlan: ChooseyourPlan$a,
	superChargeYourJobSearch: superChargeYourJobSearch$a,
	startNowGoto: startNowGoto$a,
	CreatedBy: CreatedBy$a,
	CreateNewNote: CreateNewNote$a,
	Nonotescreated: Nonotescreated$a,
	approxTimeIsFourMinutes: approxTimeIsFourMinutes$a,
	Continue: Continue$a,
	iWillDoLaterTakeMeToApp: iWillDoLaterTakeMeToApp$a,
	allDone: allDone$a,
	welcomeAbord: welcomeAbord$a,
	letsBegin: letsBegin$a,
	UpgradeyourplanandgetAIAssistance: UpgradeyourplanandgetAIAssistance$a,
	DownloadPDF: DownloadPDF$a,
	oopsWeCouldntProcessResume: oopsWeCouldntProcessResume$a,
	MyProfile: MyProfile$a,
	Setting: Setting$a,
	Logout: Logout$a,
	SignIn: SignIn$a,
	Typeyourfirstnamehere: Typeyourfirstnamehere$a,
	Enteryourlastname: Enteryourlastname$a,
	ManageSubscription: ManageSubscription$a,
	ifYouHaveDifficultiesProfile: ifYouHaveDifficultiesProfile$a,
	forSupport: forSupport$a,
	whatIsIdealCompanySize: whatIsIdealCompanySize$a,
	Saveandcontinue: Saveandcontinue$a,
	whatIsMinExpectedSalary: whatIsMinExpectedSalary$a,
	Atleast: Atleast$a,
	SlidetoAdjust: SlidetoAdjust$a,
	whatIndustryExcitedWork: whatIndustryExcitedWork$a,
	Add: Add$a,
	statusOfJobSearch: statusOfJobSearch$a,
	Finish: Finish$a,
	whatLevelRoleLooking: whatLevelRoleLooking$a,
	Selectuptotwo: Selectuptotwo$a,
	PreviousStep: PreviousStep$a,
	Skip: Skip$a,
	whatDoYouValueNewRole: whatDoYouValueNewRole$a,
	Selectuptothree: Selectuptothree$a,
	EqualEmploymentData: EqualEmploymentData$a,
	whatIsYourEthnicity: whatIsYourEthnicity$a,
	areYouAuthorizedToWorkUs: areYouAuthorizedToWorkUs$a,
	willYouRequireSponsorShip: willYouRequireSponsorShip$a,
	doYouHaveADisability: doYouHaveADisability$a,
	areYouAVeteran: areYouAVeteran$a,
	rolesYouInterestedIn: rolesYouInterestedIn$a,
	Selectuptofive: Selectuptofive$a,
	AddCustomrole: AddCustomrole$a,
	whereDoYouLikeWork: whereDoYouLikeWork$a,
	Resources: Resources$a,
	currentlyNoResourceAvailable: currentlyNoResourceAvailable$a,
	AddNewSection: AddNewSection$a,
	ChangeSections: ChangeSections$a,
	Settings: Settings$a,
	Dashboard: Dashboard$a,
	JobBoard: JobBoard$a,
	Linkedin: Linkedin$a,
	Community: Community$a,
	FindRecruiters: FindRecruiters$a,
	Goals: Goals$a,
	DownloadExtension: DownloadExtension$a,
	SuggestaFeature: SuggestaFeature$a,
	leftPanel: leftPanel$a,
	PhoneNumberisrequired: PhoneNumberisrequired$a,
	MobileNumber: MobileNumber$a,
	Enteronlynumbers: Enteronlynumbers$a,
	Countryyoulivein: Countryyoulivein$a,
	SelectaCountry: SelectaCountry$a,
	DateofBirth: DateofBirth$a,
	Gender: Gender$a,
	JobPreferences: JobPreferences$a,
	pleaseEnterValidEmail: pleaseEnterValidEmail$a,
	emailSendForResetting: emailSendForResetting$a,
	VerifyyourEmailID: VerifyyourEmailID$a,
	sentPleaseCheckEmail: sentPleaseCheckEmail$a,
	tooManyAttemptsTryAgain: tooManyAttemptsTryAgain$a,
	Resend: Resend$a,
	Login: Login$a,
	weHaveSentVerificationLinkAtEmail: weHaveSentVerificationLinkAtEmail$a,
	pleaseVerifyEmailContinueSpam: pleaseVerifyEmailContinueSpam$a,
	Logintogetstarted: Logintogetstarted$a,
	ContinuewithGoogle: ContinuewithGoogle$a,
	pleaseInputEmail: pleaseInputEmail$a,
	Password: Password$a,
	pleaseInputPassword: pleaseInputPassword$a,
	passwordLowerUpperDigitSpecial: passwordLowerUpperDigitSpecial$a,
	atLeastSixChar: atLeastSixChar$a,
	forgotPassword: forgotPassword$a,
	Bysigninginyouagreetoour: Bysigninginyouagreetoour$a,
	Terms: Terms$a,
	Conditions: Conditions$a,
	and: and$a,
	PrivacyPolicy: PrivacyPolicy$a,
	theseAreTheTopsSkillsExtracted: theseAreTheTopsSkillsExtracted$a,
	TopSkills: TopSkills$a,
	weCoulNotExtractSkills: weCoulNotExtractSkills$a,
	upgradeToPremiumToView: upgradeToPremiumToView$a,
	SkillScore: SkillScore$a,
	thisIsYourSkillScoreBasedOn: thisIsYourSkillScoreBasedOn$a,
	theseSkllsAreStrongMatch: theseSkllsAreStrongMatch$a,
	Strongmatch: Strongmatch$a,
	theseSkillsArePartialMatch: theseSkillsArePartialMatch$a,
	Partialmatch: Partialmatch$a,
	theseSkillsAreMissingFrom: theseSkillsAreMissingFrom$a,
	"Missing Keywords": "Trūkstošie atslēgvārdi",
	SkillMatchComponent: SkillMatchComponent$a,
	Optional: Optional$a,
	Notrelevanttothejob: Notrelevanttothejob$a,
	Notaskill: Notaskill$a,
	Toogeneric: Toogeneric$a,
	Pleaseshareanyfeedback: Pleaseshareanyfeedback$a,
	excludedKeywordsWillNot: excludedKeywordsWillNot$a,
	yesExcludeThisSkillFrom: yesExcludeThisSkillFrom$a,
	PartialMatch: PartialMatch$a,
	MissingKeywords: MissingKeywords$a,
	Providetitletotask: Providetitletotask$a,
	TasksList: TasksList$a,
	AddTask: AddTask$a,
	EnterTaskTitlehere: EnterTaskTitlehere$a,
	TasksComponent: TasksComponent$a,
	CompletedTasks: CompletedTasks$a,
	CompleteYourtasks: CompleteYourtasks$a,
	Steps: Steps$a,
	PremiumMember: PremiumMember$a,
	Thankyouforupgradingto: Thankyouforupgradingto$a,
	CareerflowPremium: CareerflowPremium$a,
	hereIsHowYouCanAccessPremium: hereIsHowYouCanAccessPremium$a,
	stepOne: stepOne$a,
	DownloadourChromeExtension: DownloadourChromeExtension$a,
	youJobSearchCopilotIshere: youJobSearchCopilotIshere$a,
	DownloadNow: DownloadNow$a,
	stepTwo: stepTwo$a,
	GetStarted: GetStarted$a,
	stepThree: stepThree$a,
	SignintoChromeExtension: SignintoChromeExtension$a,
	entityCreated: entityCreated$a,
	entityUpdated: entityUpdated$a,
	entityDeleted: entityDeleted$a,
	entityLinked: entityLinked$a,
	entityUnlinked: entityUnlinked$a,
	entityMovedTo: entityMovedTo$a,
	youAddedANewEntity: youAddedANewEntity$a,
	personCreated: personCreated$a,
	youUpdatedAEntity: youUpdatedAEntity$a,
	personUpdated: personUpdated$a,
	youDeletedAEntity: youDeletedAEntity$a,
	personDeleted: personDeleted$a,
	youLinkedEntity: youLinkedEntity$a,
	personLinked: personLinked$a,
	youUnlinked: youUnlinked$a,
	personUnlinked: personUnlinked$a,
	youMovedEntity: youMovedEntity$a,
	personMoved: personMoved$a,
	addedByName: addedByName$a,
	DownloadChromeExtension: DownloadChromeExtension$a,
	ourChromeExtensionIs: ourChromeExtensionIs$a,
	Optimizeyourprofile: Optimizeyourprofile$a,
	startOptimizingYourProfile: startOptimizingYourProfile$a,
	OptimizeNow: OptimizeNow$a,
	Addyourfirstjob: Addyourfirstjob$a,
	startSavingJobApplicationsToTrack: startSavingJobApplicationsToTrack$a,
	AddNow: AddNow$a,
	CompleteProfile: CompleteProfile$a,
	completeYourProfileForUsing: completeYourProfileForUsing$a,
	CompleteNow: CompleteNow$a,
	Addyourfirstcontact: Addyourfirstcontact$a,
	addContactToFollowUpWith: addContactToFollowUpWith$a,
	JoinCommunity: JoinCommunity$a,
	ourCommunityisAlways: ourCommunityisAlways$a,
	JoinNow: JoinNow$a,
	welcomeToCareerflow: welcomeToCareerflow$a,
	yourHubForCareerInsights2: yourHubForCareerInsights2$a,
	ChecklistCompleted: ChecklistCompleted$a,
	Completeyourchecklist: Completeyourchecklist$a,
	completeAFewStepsTo: completeAFewStepsTo$a,
	Completed: Completed$a,
	JobCountByStage: JobCountByStage$a,
	NopastapplicationDatafound: NopastapplicationDatafound$a,
	YourJobSearchStages: YourJobSearchStages$a,
	NoDatafound: NoDatafound$a
};

const copyToClipboard$9 = "Gekopieerd naar het klembord!";
const UnlocktheAIgenerated$9 = "Ontgrendel de door AI gegenereerde";
const UpgradetoPremium$9 = "Upgrade naar Premium";
const Result$9 = "Resultaat";
const Copy$9 = "Kopiëren";
const Save$9 = "Opslaan";
const Edit$9 = "Bewerken";
const Processing$9 = "Verwerken";
const YourAIgeneratedcontentwillshowhere$9 = "Uw door AI gegenereerde inhoud wordt hier weergegeven";
const hopeYouFindUseful$9 = "Ik hoop dat je dit resultaat nuttig vindt!";
const regenerate$9 = "Opnieuw genereren";
const ProvideAdditionalFeedback$9 = "Geef aanvullende feedback";
const Enteranyfeedback$9 = "Voer eventuele feedback in";
const Notimpressive$9 = "Niet indrukwekkend";
const thisIsntTrue$9 = "Dit is niet waar";
const Notpersonalized$9 = "Niet gepersonaliseerd";
const Tone$9 = "Toon";
const Length$9 = "Lengte";
const Template$9 = "Sjabloon";
const Generatedon$9 = "Gegenereerd op";
const Copiedtoclipboard$9 = "Gekopieerd naar het klembord";
const CopytoClipboard$9 = "Kopiëren naar klembord";
const DownloadasPDF$9 = "Downloaden als PDF";
const ViewDetails$9 = "Details bekijken";
const JobDescriptionImported$9 = "Vacaturebeschrijving geïmporteerd";
const ImportfromJob$9 = "Importeren vanuit baan";
const Saved$9 = "Opgeslagen";
const Applied$9 = "Toegepast";
const Offer$9 = "Aanbod";
const Interviewing$9 = "Interviewen";
const Rejected$9 = "Afgewezen";
const Search$9 = "Zoeken";
const Import$9 = "Importeren";
const CoverLetterGeneratorHistory$9 = "Geschiedenis van sollicitatiebriefgenerator";
const NoCoverLettersGenerated$9 = "Geen sollicitatiebrieven gegenereerd";
const getStartedCoverLetter$9 = "Je hebt nog geen sollicitatiebrieven gegenereerd. Begin en krijg sollicitatiebrieven door de vacatureomschrijving te matchen met jouw relevante ervaring.";
const getStarted$9 = "Aan de slag!";
const Documents$9 = "Documenten";
const UploadNewDocument$9 = "Nieuw document uploaden";
const AICoverLetterGenerator$9 = "AI Sollicitatiebriefgenerator";
const ViewHistory$9 = "Geschiedenis bekijken";
const JobDescription$9 = "Functieomschrijving";
const ImportfromBoard$9 = "Importeren vanaf bord";
const EnterJobDescription$9 = "Voer functieomschrijving in";
const JobTitle$9 = "Functietitel";
const EnterJobTitle$9 = "Voer functietitel in";
const CompanyName$9 = "Bedrijfsnaam";
const EnterCompanyName$9 = "Voer bedrijfsnaam in";
const YourProfile$9 = "Jouw profiel";
const ResumeUpload$9 = "CV uploaden";
const UseLinkedinProfile$9 = "Gebruik Linkedin-profiel";
const Uploadyourresume$9 = "Upload je CV";
const AddyourResume$9 = "Voeg je CV toe";
const fileNameCannotFormat$9 = "Bestandsnamen mogen geen spaties of underscores bevatten en moeten eindigen op .doc, .docx, of .pdf.";
const ChooseorUpload$9 = "Kiezen of uploaden";
const SelectTemplate$9 = "Sjabloon selecteren";
const Preview$9 = "Voorbeeld";
const UseTemplate$9 = "Sjabloon gebruiken";
const Change$9 = "Veranderen";
const AdvancedSettings$9 = "Geavanceerde instellingen";
const AdditionalContext$9 = "Extra context";
const Professional$9 = "Professioneel";
const Casual$9 = "Informeel";
const Enthusiastic$9 = "Enthousiast";
const Informational$9 = "Informatief";
const Short$9 = "Kort";
const Medium$9 = "Gemiddeld";
const Long$9 = "Lang";
const Language$9 = "Taal";
const iAmOkayBack$9 = "Het is prima! Terug gaan";
const Generate$9 = "Genereren";
const CoverLetter$9 = "Sollicitatiebrief";
const SelectLanguage$9 = "Taal selecteren";
const AboutGeneratorHistory$9 = "Geschiedenis van 'Over mij'-generator";
const NoAboutsGenerated$9 = "Geen 'Over mij'-teksten gegenereerd";
const getStartedAbouts$9 = "Je hebt nog geen 'Over mij'-teksten gegenereerd. Begin en krijg 'Over mij'-teksten door de vacatureomschrijving te matchen met jouw relevante ervaring.";
const noAttachmentsFound$9 = "Geen bijlagen gevonden.";
const TargetJobTitle$9 = "Doelfunctietitel";
const KeywordsToInclude$9 = "Sleutelwoorden om op te nemen";
const UploadYourResume$9 = "Upload uw cv";
const AddYourResume$9 = "Voeg uw cv toe";
const LinkedinProfile$9 = "Linkedin-profiel";
const Linkedinprofilenotfound$9 = "Linkedin-profiel niet gevonden";
const startUsingChromeExtension$9 = "Begin je Linkedin-profiel te optimaliseren met onze Chrome-extensie om deze optie te gebruiken.";
const Download$9 = "Downloaden";
const UseEmojis$9 = "Gebruik emoji's";
const UseBulletPoints$9 = "Gebruik opsommingstekens";
const SpeechFocus$9 = "Spraakklemtoon";
const FirstPerson$9 = "Eerste persoon";
const ThirdPerson$9 = "Derde persoon";
const HeadlineGeneratorHistory$9 = "Geschiedenis van kopgenerator";
const NoHeadlinesGenerated$9 = "Geen koppen gegenereerd";
const getStartedHeadline$9 = "Je hebt nog geen koppen gegenereerd. Begin en krijg koppen door de vacatureomschrijving te matchen met jouw relevante ervaring.";
const AIHeadlineGenerator$9 = "AI Kopgenerator";
const KeywordstoInclude$9 = "In te sluiten trefwoorden";
const Pressenteraftereachword$9 = "Druk op enter na elk woord";
const LinkedinProfilenotfound$9 = "LinkedIn-profiel niet gevonden";
const Headline$9 = "Kop";
const PostGeneratorHistory$9 = "Geschiedenis van berichtgenerator";
const NoPostsGenerated$9 = "Geen berichten gegenereerd";
const getStartedPost$9 = "Je hebt nog geen berichten gegenereerd. Begin en krijg berichten door de vacatureomschrijving te matchen met jouw relevante ervaring.";
const Topic$9 = "Onderwerp";
const Description$9 = "Beschrijving";
const UseHashtags$9 = "Gebruik hashtags";
const Custom$9 = "Aangepast";
const EnterCustomTone$9 = "Voer aangepaste toon in";
const Added$9 = "Toegevoegd";
const ComingSoon$9 = {
	header: "Ingenieurs aan het werk!",
	content_1: "Ons team van ingenieurs werkt hard om deze functie binnenkort operationeel te krijgen.",
	content_2: "Wil je deze functie snel? Laat het ons weten door eenvoudig het onderstaande vakje aan te vinken.",
	content_3: "Ik wil deze functie"
};
const Company$9 = "Bedrijf";
const JobInterview$9 = "Sollicitatiegesprek";
const Research$9 = "Onderzoek";
const Networking$9 = "Netwerken";
const Referral$9 = "Aanbeveling";
const MustbeContacted$9 = "Moet worden gecontacteerd";
const ScheduleaMeeting$9 = "Afspraak inplannen";
const needAFollowUp$9 = "Moet opvolgen";
const Today$9 = "Vandaag";
const Viewdetails$9 = "Details bekijken";
const Activity$9 = "Activiteit";
const ActivityDetails$9 = "Activiteitsdetails";
const Delete$9 = "Verwijderen";
const Title$9 = "Titel";
const Goal$9 = "Doel";
const Status$9 = "Status";
const FollowUp$9 = "Opvolging";
const AddActivity$9 = "Activiteit Toevoegen";
const Enteractivitytitle$9 = "Voer activiteitstitel in";
const Cancel$9 = "Annuleren";
const SaveActivity$9 = "Activiteit Opslaan";
const noActivityPresent$9 = "Geen activiteit aanwezig, voeg activiteit toe.";
const Addnew$9 = "Toevoegen";
const About$9 = "Over";
const noDataPresentYou$9 = "Geen gegevens aanwezig, u kunt deze contactpersoon bewerken en velden toevoegen.";
const Experience$9 = "Ervaring";
const Education$9 = "Opleiding";
const Skills$9 = "Vaardigheden";
const Overview$9 = "Overzicht";
const LinkedJobs$9 = "Gekoppelde Banen";
const Notes$9 = "Notities";
const FullName$9 = "Volledige Naam";
const Location$9 = "Locatie";
const Relationship$9 = "Relatie";
const Contacts$9 = "Contacten";
const CreateContact$9 = "Contact Aanmaken";
const NotesCreated$9 = "Notities Aangemaakt";
const Notesupdated$9 = "Notities Bijgewerkt";
const Addnote$9 = "Notitie Toevoegen";
const areYouSureDeleteNote$9 = "Weet je zeker dat je deze notitie wilt verwijderen?";
const Createdby$9 = "Gemaakt door";
const notSureWhyResumeCalls$9 = "Niet zeker waarom je cv je geen sollicitatiegesprekken oplevert? ☎️";
const getExpertResumeReview$9 = "Ontvang een deskundige beoordeling van je cv 💎✨";
const youHaventAddedContacts$9 = "Je hebt nog geen contacten toegevoegd.";
const noMatchingContacts$9 = "Geen overeenkomende contacten gevonden.";
const Link$9 = "Link";
const unlink$9 = "Ontkoppelen";
const Locationnotavailable$9 = "Locatie niet beschikbaar";
const Emailnotavailable$9 = "E-mail niet beschikbaar";
const PhoneNumbernotavailable$9 = "Telefoonnummer niet beschikbaar";
const createdby$9 = "gemaakt door";
const areYouSureDeleteContact$9 = "Weet u zeker dat u dit contact wilt verwijderen?";
const areYouSureUnlinkContact$9 = "Weet u zeker dat u dit contact wilt ontkoppelen?";
const Addedbyyou$9 = "Toegevoegd door u";
const Addedby$9 = "Toegevoegd door";
const Timeline$9 = "Tijdlijn";
const Timelineempty$9 = "Tijdlijn leeg";
const Discard$9 = "Afbreken";
const SaveContact$9 = "Contact opslaan";
const Recruiter$9 = "Recruiter";
const Candidate$9 = "Kandidaat";
const Colleague$9 = "Collega";
const Employee$9 = "Werknemer";
const EnterValidEmail$9 = "Voer een geldig e-mailadres in";
const EnterValidPhoneNumber$9 = "Voer een geldig telefoonnummer in";
const editingProfileNotAvailable$9 = "Het bewerken van het profielfoto is nog niet beschikbaar.";
const itWillBeSoonAvailable$9 = "Het zal binnenkort beschikbaar zijn in onze";
const ChromeExtension$9 = "Chrome-extensie";
const SelectTag$9 = "Selecteer Tag";
const FirstName$9 = "Voornaam";
const FirstNameisrequired$9 = "Voornaam is verplicht";
const LastName$9 = "Achternaam";
const LastNameisrequired$9 = "Achternaam is verplicht";
const Companyisrequired$9 = "Bedrijf is verplicht";
const Email$9 = "E-mail";
const ThisisnotavalidEmail$9 = "Dit is geen geldig e-mailadres.";
const AddEmail$9 = "E-mail Toevoegen";
const PhoneNumber$9 = "Telefoonnummer";
const notaValidPhone$9 = "Dit is geen geldig telefoonnummer. Voer alleen cijfers in.";
const phoneNoMinimum5char$9 = "Telefoonnummer moet minimaal 5 tekens bevatten.";
const phoneNoMinumum15char$9 = "Telefoonnummer mag maximaal 15 tekens bevatten.";
const AddPhoneNumber$9 = "Telefoonnummer Toevoegen";
const SelectGoal$9 = "Doel Selecteren";
const SelectStatus$9 = "Selecteer status";
const Followup$9 = "Opvolging";
const SocialMedia$9 = "Sociale Media";
const Linkedinhandle$9 = "Linkedin Handvat";
const Twitterhandle$9 = "Twitter-handle";
const Facebookhandle$9 = "Facebook-handle";
const Githubhandle$9 = "Github-handle";
const Gmailhandle$9 = "Gmail-handle";
const Changessavedsuccessfully$9 = "Wijzigingen succesvol opgeslagen";
const EditContact$9 = "Contact Bewerken";
const BasicInformation$9 = "Basisinformatie";
const EditContactDetails$9 = "Bewerk contactgegevens";
const SaveChanges$9 = "Wijzigingen Opslaan";
const phoneNoMinimum14char$9 = "Het telefoonnummer moet minimaal 14 tekens bevatten.";
const LinkedIn$9 = "LinkedIn";
const Twitter$9 = "Twitter";
const Facebook$9 = "Facebook";
const Github$9 = "Github";
const Gmail$9 = "Gmail";
const youCanWriteAbout$9 = "Je kunt schrijven over je jarenlange ervaring, branche of vaardigheden. Mensen praten ook over hun prestaties of vorige werkervaringen.";
const Addednewsection$9 = "Nieuwe sectie toegevoegd";
const Removedsuccessfully$9 = "Succesvol verwijderd";
const Remove$9 = "Verwijderen";
const Institute$9 = "Instituut";
const Schoolisrequired$9 = "School is verplicht";
const Degree$9 = "Graad";
const StartMonth$9 = "Start Maand";
const StartYear$9 = "Startjaar";
const EndMonth$9 = "Eind maand";
const EndYear$9 = "Einde jaar";
const Addmore$9 = "Meer Toevoegen";
const PositionTitle$9 = "Positie Titel";
const ExperienceType$9 = "Ervaringstype";
const Addednewitem$9 = "Nieuw item toegevoegd";
const whatSkillsDoYouEnjoy$9 = "Welke vaardigheden heb je of vind je leuk om mee te werken?";
const Typeskillshere$9 = "Typ hier vaardigheden in";
const LinkedContacts$9 = "Gekoppelde Contacten";
const LinkContact$9 = "Contact Koppelen";
const NocontactsLinked$9 = "Geen gekoppelde contacten";
const JobContactsComponent$9 = {
	linkContact: "Door contacten te koppelen, kunt u snel zien wie de belangrijke personen zoals de recruiter, hiring manager, enz., zijn voor deze rol! In de toekomst kunnen we relevante inzichten tonen op basis van uw contacten."
};
const Nocontacts$9 = "Geen contacten";
const LinkJobto$9 = "Koppel baan aan";
const Contact$9 = "Contact";
const Document$9 = "Document";
const Nojobsfound$9 = "Geen banen gevonden";
const LinkJob$9 = "Job Koppelen";
const youCanLinkContactJobImported$9 = "Je kunt deze contactpersoon koppelen aan een baan die je hebt geïmporteerd in Careerflow.";
const Prev$9 = "Vorige";
const Next$9 = "Volgende";
const areYouSureUnlinkDocument$9 = "Weet u zeker dat u dit document wilt ontkoppelen?";
const areYouSureDeleteDocument$9 = "Weet u zeker dat u dit document wilt verwijderen?";
const Category$9 = "Categorie";
const CreatedOn$9 = "Gemaakt Op";
const Joblinked$9 = "Baangekoppeld";
const Quickactions$9 = "Snelkoppelingen";
const All$9 = "Alles";
const Resume$9 = "CV";
const Portfolio$9 = "Portfolio";
const Other$9 = "Overig";
const Adddocument$9 = "Document Toevoegen";
const Type$9 = "Type";
const Sortingby$9 = "Sorteren op";
const SwitchtoGridLayout$9 = "Schakel over naar rasterindeling.";
const SwitchtoListLayout$9 = "Schakel over naar Lijstweergave";
const NoDocumentsAdded$9 = "Geen Documenten Toegevoegd";
const DocumentsComponent$9 = {
	nodocs: "U heeft nog geen documenten aangemaakt. U kunt uw cv-versies, sollicitatiebrieven en meer uploaden en koppelen aan banen die u volgt!"
};
const NoDocumentFound$9 = "Geen document gevonden.";
const SelectFile$9 = "Bestand Selecteren";
const onlyPdfDocxSupported$9 = "Alleen .pdf en .docx worden ondersteund.";
const Uploadfile$9 = "Bestand Uploaden";
const DocumentCategory$9 = "Document Categorie";
const SaveDocument$9 = "Document Opslaan";
const AddDocument$9 = "Document Toevoegen";
const LinkedDocuments$9 = "Gekoppelde documenten";
const LinkDocument$9 = "Document Koppelen";
const NodocumentsLinked$9 = "Geen gekoppelde documenten";
const JobDocumentsComponent$9 = {
	linkDocs: "Het koppelen van al uw relevante documenten zoals uw cv, sollicitatiebrief, enz., die u heeft ingediend voor deze baan, zal u helpen alles op één plek bij te houden. Probeer het eens!"
};
const NoDocuments$9 = "Geen Documenten";
const CreateDocuments$9 = "Documenten Maken";
const youCanLinkDocumentJobImported$9 = "Je kunt dit document koppelen aan een baan die je hebt geïmporteerd in Careerflow.";
const Documenteditedsuccessfully$9 = "Document succesvol bewerkt";
const DocumentDetails$9 = "Documentgegevens";
const UnsavedChanges$9 = "Onopgeslagen wijzigingen";
const yourChangesWillBeLostSureClose$9 = "Je wijzigingen gaan verloren, weet je zeker dat je wilt sluiten?";
const yourChangesWillBeLostSureDiscard$9 = "Je wijzigingen zullen verloren gaan, weet je zeker dat je je wijzigingen wilt negeren?";
const DiscardChanges$9 = "Verwijder wijzigingen";
const WeeklyGoalAlert$9 = "Wekelijkse Doel Alert";
const Progress$9 = "Vooruitgang";
const AllGoals$9 = "Alle Doelen";
const Name$9 = "Naam";
const Completedon$9 = "Voltooid op";
const Createdon$9 = "Gemaakt op";
const Action$9 = "Actie";
const Back$9 = "Terug";
const OverallScore$9 = "Algemene score";
const Aboutthegoal$9 = "Over het doel";
const GoalTracking$9 = "Doel Tracking";
const Week$9 = "Week";
const progress$9 = "voortgang";
const loading$9 = "Laden";
const Apply$9 = "Toepassen";
const Thisskillhasbeenreported$9 = "Deze vaardigheid is gemeld.";
const issueGettingResume$9 = "Er was een probleem met het verkrijgen van het cv.";
const Interview$9 = "Interview";
const Tasks$9 = "Taken";
const Loading$9 = "Bezig met laden";
const Skilladdedsuccessfully$9 = "Vaardigheid succesvol toegevoegd";
const problemAddingSkill$9 = "Er was een probleem bij het toevoegen van vaardigheid.";
const Reportaproblem$9 = "Meld een probleem";
const Submit$9 = "Indienen";
const Addanewskill$9 = "Voeg een nieuwe vaardigheid toe";
const JobDetailsComponent$9 = {
	classifySkill: "Hoe zou je deze vaardigheid classificeren (Optioneel)",
	includedKeywordsWillCount: "Inclusief dit trefwoord?",
	yesIncludeThisSkill: "Inbegrepen zoekwoorden tellen mee voor uw matchscore bij alle toekomstige scans. U kunt inbegrepen zoekwoorden wijzigen vanuit uw profiel.",
	addSkill: "Wil je dit toevoegen als vaardigheid?"
};
const HardSkill$9 = "Technische Vaardigheid";
const SoftSkill$9 = "Sociale Vaardigheid";
const Pleaseshareanyadditionalcontext$9 = "Deel alstublieft aanvullende context";
const Addasskill$9 = "Toevoegen als vaardigheid";
const Skill$9 = "Vaardigheid";
const JobFrequency$9 = "Frequentie van de Baan";
const ResumeFrequency$9 = "Frequentie van het CV";
const Reportskill$9 = "Rapporteer vaardigheid";
const JobDetails$9 = "Vacature details";
const ViewJobLink$9 = "Bekijk vacaturelink";
const Salary$9 = "Salaris";
const areYouSureDeleteJob$9 = "Weet je zeker dat je deze taak wilt verwijderen?";
const ViewMore$9 = "Meer weergeven";
const ViewLess$9 = "Minder weergeven";
const matchYouSkillsAgainstJob$9 = "Vergelijk je vaardigheden met de functieomschrijving.";
const pleaseUploadResumeSkillMatch$9 = "Gelieve uw cv te uploaden om uw vaardigheidsmatchscore te ontvangen.";
const AddResume$9 = "CV Toevoegen";
const thisJobDoesNotHaveAnyDesc$9 = "Deze baan heeft geen beschrijving.";
const youCanEditJobToAdd$9 = "U kunt deze baan bewerken om er een beschrijving aan toe te voegen. U kunt ook banen importeren met behulp van onze.";
const chromeextension$9 = "Chrome-extensie";
const fromVariousJobPortalsOnce$9 = "van verschillende vacatureportals. Zodra je een beschrijving toevoegt, kun je ook vaardigheden gerelateerde informatie zien.";
const AddDescription$9 = "Voeg beschrijving toe";
const CompanyInfo$9 = "Bedrijfsinformatie";
const Website$9 = "Website";
const Industry$9 = "Industrie";
const EmployeeCount$9 = "Aantal Medewerkers";
const ExprienceLevel$9 = "Ervaringsniveau";
const Address$9 = "Adres";
const Resumes$9 = "CV's";
const Setasdefault$9 = "Stel in als standaard";
const Ok$9 = "Oké";
const UploadNewResume$9 = "Nieuw CV Uploaden";
const Default$9 = "Standaard";
const Jobnotfound$9 = "Vacature niet gevonden";
const EditDetails$9 = "Details Bewerken";
const JobPostURL$9 = "URL van de Vacature";
const Enterjoburl$9 = "Voer de url van de vacature in";
const Nojobselected$9 = "Geen baan geselecteerd";
const Viewjobdetails$9 = "Bekijk baan details";
const Jobaddedtoyourboardsuccessfully$9 = "Taak succesvol toegevoegd aan uw bord";
const AddJob$9 = "Vacature Toevoegen";
const Addnewjobname$9 = "Voeg nieuwe functienaam toe";
const JobUrl$9 = "Vacature-URL";
const Addjoburl$9 = "Voeg vacature-URL toe";
const Section$9 = "Sectie";
const didYouKnow$9 = {
	chromeExtension: "Wist u dat? U kunt ook banen rechtstreeks opslaan vanuit onze Chrome-extensie en alle gegevens in één klik importeren! Het duurt slechts een paar seconden."
};
const Jobs$9 = "Banen";
const AddJobtoboard$9 = "Voeg baan toe aan bord";
const Currentlynojobsareavailable$9 = "Op dit moment zijn er geen vacatures beschikbaar.";
const noMatchingJobs$9 = "Geen overeenkomende banen gevonden.";
const welcomeToYourPersonalJobTracker$9 = "Welkom bij jouw persoonlijke Job Tracker!";
const weShortTutorialOnHowTrackingJob$9 = "We zullen je in een korte tutorial door een paar eenvoudige stappen leiden om te beginnen met het bijhouden van je sollicitaties!";
const Addanewjob$9 = "Voeg een nieuwe baan toe";
const inOrderTrackCreatButton$9 = "Om sollicitaties bij te houden, moet je het eerst toevoegen aan het bord door op de knop 'Aanmaken' te klikken.";
const Providesomedetails$9 = "Geef wat details";
const toBeginTypeJobTitleCompany$9 = "Om te beginnen, typ gewoon de functietitel, de naam van het bedrijf en de status die je eraan wilt toevoegen. Je kunt later meer details toevoegen, maar dit is alles wat je nu nodig hebt!";
const asAnExampleFilledForYou$9 = "Als voorbeeld hebben we dit al voor u ingevuld!";
const wohooAddedFirstJob$9 = "Woohoo! Je hebt je eerste baan toegevoegd aan je baantracker!";
const youCanDragDropJobCard$9 = "Je kunt nu de vacaturekaart slepen en neerzetten in de verschillende stadia van het sollicitatieproces. Door te klikken op de vacaturekaart kun je meer details bekijken, bewerken, notities opslaan en meer!";
const Lastbutnotleast$9 = "Last but not least";
const finalStepMakeSure$9 = "Als laatste stap, zorg ervoor dat je onze hebt.";
const autoMaticallyImportJobs$9 = "Dit stelt je in staat om automatisch vacatures te importeren van je favoriete vacaturesites zoals LinkedIn, Indeed en meer! Onze extensie helpt je ook om je LinkedIn-profiel te verbeteren en 2,5 keer meer zoekopdrachten te krijgen!";
const selectanysection$9 = "Selecteer een willekeurige sectie";
const Accept$9 = "Aanvaarden";
const My2023JobSearch$9 = "Mijn 2023 Banenzoektocht";
const AddedFrom$9 = "Toegevoegd vanuit";
const AddedUntil$9 = "Toegevoegd tot";
const BasicModal$9 = "Basis Modaal";
const AddnewSectionName$9 = "Nieuwe Sectienaam Toevoegen";
const OpenTo$9 = "Open voor";
const Featured$9 = "Uitgelicht";
const LicenceAndCerts$9 = "Vergunningen en certificaten";
const Banner$9 = "Banner";
const LinkedInURL$9 = "LinkedIn URL";
const Recommendations$9 = "Aanbevelingen";
const LinkedinReview$9 = "Linkedin beoordeling";
const NoDataAvailable$9 = "Geen gegevens beschikbaar.";
const looksLikeYouDidNot$9 = "Het lijkt erop dat je nog niet begonnen bent met het gebruik van onze";
const toOptimizeProfileScoreVisible$9 = "om je LinkedIn-profiel te optimaliseren. Zodra je dat doet, zal je profielscore hier zichtbaar zijn.";
const LinkedinComponent$9 = {
	letsOptimize: "Laten we optimaliseren"
};
const improveYourChancesLandingDreamJob$9 = "Verbeter uw kansen om uw droombaan te bemachtigen. Gebruik deze beproefde strategieën om uw LinkedIn-profiel een broodnodige make-over te geven.";
const VisitProfile$9 = "Bekijk Profiel";
const wantToGetLinkedinMakeover$9 = "Wilt u een volledige LinkedIn-makeover krijgen?";
const PostGenerator$9 = "Bericht Generator";
const LinkedinHeadlineGenerator$9 = "LinkedIn Headline Generator";
const LinkedinAboutSectionGenerator$9 = "LinkedIn Over sectie Generator";
const AITools$9 = "AI Hulpmiddelen";
const Premium$9 = "Premium";
const LinkedInOptimization$9 = "Optimalisatie van LinkedIn";
const JobTracker$9 = "Vacature Tracker";
const whoIsHiring$9 = "Wie is er aan het werven?";
const Autofill$9 = "Automatisch invullen";
const HeadlineGenerator$9 = "Koppen Generator";
const skillMatching$9 = "Vaardigheden matchen";
const SummarizeJD$9 = "Samenvatting van de functieomschrijving";
const contactFeature$9 = "Contact Tracering";
const documentFeature$9 = "Documenten";
const landJobWithoutStress$9 = "Verover je droombaan. Zonder stress.";
const discoverFeatures$9 = "Ontdek het scala aan Careerflow.ai functies die zijn ontworpen om uw zoektocht naar werk te stroomlijnen en uw professionele reis te verbeteren!";
const letsBeginOnboarding$9 = "Laten we je beter leren kennen!";
const inTheNextFewScreensJobThirdParties$9 = "In de volgende paar schermen zullen we u enkele vragen stellen die ons zullen helpen de ervaring voor u op maat te maken en uw sollicitaties automatisch in te vullen (zodat u dat niet hoeft te doen)! We verkopen uw gegevens niet aan derden.";
const letsAddBasicInformation$9 = "Laten we jouw basisinformatie toevoegen.";
const Pleaseselectanoptionfirst$9 = "Selecteer eerst een optie.";
const JobApplicationTracker$9 = "Sollicitatievolgsysteem";
const LinkedInProfileOptimizer$9 = "Linked In Profiel Optimalisator";
const UnlimitedDocuments$9 = "Onbeperkte documenten";
const UnlimitedContacts$9 = "Onbeperkte contacten";
const HiringManagerSearch$9 = "Zoeken naar een personeelsmanager";
const AILinkedInPostGenerator$9 = "AI LinkedIn Berichtengenerator";
const ATSKeywordSkillMatch$9 = "ATS Trefwoord / Vaardigheid Match Vacature";
const ChooseyourPlan$9 = "Kies je plan";
const superChargeYourJobSearch$9 = "Versnel je zoektocht naar een baan en verbeter je sollicitatieproces, verhoog je aantal sollicitatiegesprekken en land je droombaan. Dit alles met behulp van de premium toolkit van Careerflow.";
const startNowGoto$9 = "Begin nu (Ga naar de app)";
const CreatedBy$9 = "Gemaakt Door";
const CreateNewNote$9 = "Nieuwe Notitie Maken";
const Nonotescreated$9 = "Geen notities aangemaakt";
const approxTimeIsFourMinutes$9 = "De geschatte tijd om het onboarding proces te voltooien is 4 minuten.";
const Continue$9 = "Doorgaan";
const iWillDoLaterTakeMeToApp$9 = "Ik doe dit later. Breng me naar de app.";
const allDone$9 = "Alles klaar!";
const welcomeAbord$9 = "Welkom aan boord!";
const letsBegin$9 = "Laten we beginnen";
const UpgradeyourplanandgetAIAssistance$9 = "Upgrade uw plan en krijg AI-assistentie";
const DownloadPDF$9 = "Download PDF";
const oopsWeCouldntProcessResume$9 = "Oeps, we konden dit cv niet verwerken.";
const MyProfile$9 = "Mijn profiel";
const Setting$9 = "Instelling";
const Logout$9 = "Uitloggen";
const SignIn$9 = "Aanmelden";
const Typeyourfirstnamehere$9 = "Je voornaam";
const Enteryourlastname$9 = "Uw achternaam";
const ManageSubscription$9 = "Beheer abonnement";
const ifYouHaveDifficultiesProfile$9 = "Als u problemen heeft met uw profielinformatie, neem dan contact op met";
const forSupport$9 = "voor ondersteuning.";
const whatIsIdealCompanySize$9 = "Wat is de ideale grootte van jouw bedrijf?";
const Saveandcontinue$9 = "Opslaan en doorgaan";
const whatIsMinExpectedSalary$9 = "Wat is jouw minimale verwachte salaris (per jaar)?";
const Atleast$9 = "Ten minste";
const SlidetoAdjust$9 = "Schuif om aan te passen";
const whatIndustryExcitedWork$9 = "Welke industrieën vind je opwindend?";
const Add$9 = "Toevoegen";
const statusOfJobSearch$9 = "Status van je zoektocht naar werk?";
const Finish$9 = "Afwerken";
const whatLevelRoleLooking$9 = "Op welk niveau zoek je een rol?";
const Selectuptotwo$9 = "Selecteer maximaal twee";
const PreviousStep$9 = "Vorige stap";
const Skip$9 = "Overslaan";
const whatDoYouValueNewRole$9 = "Wat waardeer je in een nieuwe functie?";
const Selectuptothree$9 = "Selecteer tot drie";
const EqualEmploymentData$9 = "Gelijke Werkgelegenheidsgegevens";
const whatIsYourEthnicity$9 = "Wat is jouw etniciteit?";
const areYouAuthorizedToWorkUs$9 = "Bent u gemachtigd om in de VS te werken?";
const willYouRequireSponsorShip$9 = "Heeft u nu of in de toekomst sponsoring nodig voor uw werkvisumstatus?";
const doYouHaveADisability$9 = "Heb je een handicap?";
const areYouAVeteran$9 = "Bent u een veteraan?";
const rolesYouInterestedIn$9 = "In welke soort rollen ben je geïnteresseerd?";
const Selectuptofive$9 = "Selecteer tot vijf";
const AddCustomrole$9 = "Voeg aangepaste rol toe";
const whereDoYouLikeWork$9 = "Waar zou je willen werken?";
const Resources$9 = "Middelen";
const currentlyNoResourceAvailable$9 = "Op dit moment zijn er geen middelen beschikbaar.";
const AddNewSection$9 = "Nieuwe Sectie Toevoegen";
const ChangeSections$9 = "Wijzig secties";
const Settings$9 = "Instellingen";
const Dashboard$9 = "Dashboard";
const JobBoard$9 = "Vacaturebord";
const Linkedin$9 = "Linkedin";
const Community$9 = "Gemeenschap";
const FindRecruiters$9 = "Vind recruiters";
const Goals$9 = "Doelen";
const DownloadExtension$9 = "Extensie Downloaden";
const SuggestaFeature$9 = "Suggesteer een functie";
const leftPanel$9 = {
	ReportanIssue: "Meld een probleem"
};
const PhoneNumberisrequired$9 = "Telefoonnummer is verplicht";
const MobileNumber$9 = "Mobiel nummer";
const Enteronlynumbers$9 = "Voer alleen nummers in";
const Countryyoulivein$9 = "Land waarin je woont";
const SelectaCountry$9 = "Selecteer een land";
const DateofBirth$9 = "Geboortedatum";
const Gender$9 = "Geslacht";
const JobPreferences$9 = "Voorkeuren voor werk";
const pleaseEnterValidEmail$9 = "Voer alstublieft een geldig e-mailadres in.";
const emailSendForResetting$9 = "Een e-mail is naar u verzonden voor het resetten van het wachtwoord.";
const VerifyyourEmailID$9 = "Verifieer uw e-mailadres";
const sentPleaseCheckEmail$9 = "Verzonden! Controleer alstublieft uw e-mail.";
const tooManyAttemptsTryAgain$9 = "Te veel pogingen, probeer het later opnieuw.";
const Resend$9 = "Opnieuw verzenden";
const Login$9 = "Inloggen";
const weHaveSentVerificationLinkAtEmail$9 = "We hebben je een verificatielink gestuurd naar je e-mail.";
const pleaseVerifyEmailContinueSpam$9 = "Gelieve uw e-mail te verifiëren om door te gaan. Controleer ook uw spam- of promotiemappen voor de verificatie-e-mail.";
const Logintogetstarted$9 = "Inloggen om te beginnen";
const ContinuewithGoogle$9 = "Ga verder met Google";
const pleaseInputEmail$9 = "Voer alstublieft uw e-mailadres in!";
const Password$9 = "Wachtwoord";
const pleaseInputPassword$9 = "Voer alstublieft uw wachtwoord in!";
const passwordLowerUpperDigitSpecial$9 = "Je wachtwoord moet tenminste één kleine letter, één hoofdletter, één cijfer en een speciaal teken bevatten.";
const atLeastSixChar$9 = "Minimaal 6 tekens";
const forgotPassword$9 = "Wachtwoord vergeten?";
const Bysigninginyouagreetoour$9 = "Door in te loggen ga je akkoord met onze";
const Terms$9 = "Voorwaarden";
const Conditions$9 = "Voorwaarden";
const and$9 = "en";
const PrivacyPolicy$9 = "Privacybeleid";
const theseAreTheTopsSkillsExtracted$9 = "Dit zijn de belangrijkste vaardigheden die zijn afgeleid uit de functieomschrijving.";
const TopSkills$9 = "Top vaardigheden";
const weCoulNotExtractSkills$9 = "We konden geen vaardigheden uit deze vacaturebeschrijving halen.";
const upgradeToPremiumToView$9 = "Upgrade naar Premium om de score van jouw vaardighedenmatch in je cv te bekijken.";
const SkillScore$9 = "Vaardigheidsscore";
const thisIsYourSkillScoreBasedOn$9 = "Dit is jouw vaardigheidsscore op basis van de functieomschrijving en jouw cv.";
const theseSkllsAreStrongMatch$9 = "Deze vaardigheden komen sterk overeen met zowel jouw cv als de functieomschrijving.";
const Strongmatch$9 = "Sterke Match";
const theseSkillsArePartialMatch$9 = "Deze vaardigheden zijn een gedeeltelijke match tussen jouw cv en de functiebeschrijving.";
const Partialmatch$9 = "Gedeeltelijke overeenkomst";
const theseSkillsAreMissingFrom$9 = "Deze zoekwoorden ontbreken in jouw cv, maar zijn aanwezig in de vacatureomschrijving. Het kunnen vaardigheden of algemene zoekwoorden zijn die specifiek zijn voor de baan en nuttig kunnen zijn om aan jouw cv toe te voegen.";
const SkillMatchComponent$9 = {
	removeSkill: "Wat is uw belangrijkste reden om een probleem te melden voor het trefwoord"
};
const Optional$9 = "Optioneel";
const Notrelevanttothejob$9 = "Niet relevant voor de baan";
const Notaskill$9 = "Geen vaardigheid";
const Toogeneric$9 = "Te generiek";
const Pleaseshareanyfeedback$9 = "Deel alstublieft feedback";
const excludedKeywordsWillNot$9 = "Uitgesloten zoekwoorden tellen niet mee voor uw matchscore bij alle toekomstige scans. U kunt uitgesloten zoekwoorden wijzigen vanuit uw profiel.";
const yesExcludeThisSkillFrom$9 = "Ja, sluit deze vaardigheid uit van al mijn cv-scans.";
const PartialMatch$9 = "Gedeeltelijke Match";
const MissingKeywords$9 = "Ontbrekende Trefwoorden";
const Providetitletotask$9 = "Geef titel aan taak";
const TasksList$9 = "Takenlijst";
const AddTask$9 = "Taak Toevoegen";
const EnterTaskTitlehere$9 = "Voer hier de titel van de taak in";
const TasksComponent$9 = {
	listEmpty: "Takenlijst leeg, Maak Nieuw."
};
const CompletedTasks$9 = "Voltooide taken";
const CompleteYourtasks$9 = "Voltooi je taken";
const Steps$9 = "Stappen";
const PremiumMember$9 = "Premium lid";
const Thankyouforupgradingto$9 = "Bedankt voor het upgraden naar";
const CareerflowPremium$9 = "Loopbaanstroom Premium";
const hereIsHowYouCanAccessPremium$9 = "Hier is hoe je toegang krijgt tot je Premium voordelen!";
const stepOne$9 = "Stap 1";
const DownloadourChromeExtension$9 = "Download onze Chrome-extensie";
const youJobSearchCopilotIshere$9 = "Jouw AI Copiloot voor het zoeken van een baan is hier.";
const DownloadNow$9 = "Nu downloaden";
const stepTwo$9 = "Stap 2";
const GetStarted$9 = "Aan de slag";
const stepThree$9 = "Stap 3";
const SignintoChromeExtension$9 = "Inloggen bij Chrome-extensie";
const entityCreated$9 = "Nieuwe {{entiteit}} aangemaakt";
const entityUpdated$9 = "{{entity}} bijgewerkt";
const entityDeleted$9 = "{{entity}} verwijderd";
const entityLinked$9 = "{{entiteit}} gekoppeld";
const entityUnlinked$9 = "{{entiteit}} losgekoppeld";
const entityMovedTo$9 = "Verhuisd naar {{entity}}";
const youAddedANewEntity$9 = "Je hebt een nieuwe {{entiteit}} toegevoegd.";
const personCreated$9 = "{{creator}} heeft een {{entity}} gemaakt voor {{owner}}.";
const youUpdatedAEntity$9 = "Je hebt een {{entity}} bijgewerkt.";
const personUpdated$9 = "{{creator}} heeft een {{entity}} bijgewerkt voor {{owner}}.";
const youDeletedAEntity$9 = "Je hebt een {{entiteit}} verwijderd.";
const personDeleted$9 = "{{creator}} heeft een {{entity}} verwijderd van {{owner}}";
const youLinkedEntity$9 = "Je hebt een {{entity}} gekoppeld aan deze baan.";
const personLinked$9 = "{{creator}} heeft een {{entity}} aan deze taak gekoppeld voor {{owner}}.";
const youUnlinked$9 = "Je hebt een {{entity}} losgekoppeld van deze baan.";
const personUnlinked$9 = "{{creator}} heeft een {{entity}} losgekoppeld van deze taak voor {{owner}}.";
const youMovedEntity$9 = "Je hebt deze {{entity}} verplaatst van {{sectionFrom}} naar {{sectionTo}}";
const personMoved$9 = "{{creator}} heeft deze {{entity}} verplaatst van {{sectionFrom}} naar {{sectionTo}} voor {{owner}}.";
const addedByName$9 = "Toegevoegd door {{name}}";
const DownloadChromeExtension$9 = "Download Chrome-extensie";
const ourChromeExtensionIs$9 = "Onze Chrome-extensie is een geïntegreerd hulpmiddel om u te helpen uw LinkedIn-profiel te optimaliseren, vacatures op te slaan, contacten op te slaan, een sollicitatiebrief te genereren en meer.";
const Optimizeyourprofile$9 = "Optimaliseer je profiel";
const startOptimizingYourProfile$9 = "Begin met het optimaliseren van je profiel om betere kansen te hebben om gecontacteerd te worden door recruiters.";
const OptimizeNow$9 = "Optimaliseer nu";
const Addyourfirstjob$9 = "Voeg je eerste baan toe";
const startSavingJobApplicationsToTrack$9 = "Begin met het opslaan van sollicitaties om je zoektocht naar werk bij te houden en nuttige inzichten te vinden.";
const AddNow$9 = "Voeg nu toe";
const CompleteProfile$9 = "Volledig profiel";
const completeYourProfileForUsing$9 = "Voltooi uw profiel om gebruik te maken van de automatisch invullen functie en een meer gepersonaliseerde ervaring te krijgen.";
const CompleteNow$9 = "Nu voltooien";
const Addyourfirstcontact$9 = "Voeg je eerste contactpersoon toe";
const addContactToFollowUpWith$9 = "Voeg contactpersoon toe om later op te volgen, voeg notities toe en meer.";
const JoinCommunity$9 = "Word lid van de gemeenschap";
const ourCommunityisAlways$9 = "Onze gemeenschap staat altijd aan jouw zijde tijdens jouw zoektocht naar werk.";
const JoinNow$9 = "Word nu lid";
const welcomeToCareerflow$9 = "Welkom bij Careerflow!";
const yourHubForCareerInsights2$9 = "Dit is jouw centrale plek voor loopbaaninzichten, activiteiten en meer. Verken jouw gepersonaliseerde dashboard om op de hoogte te blijven van jouw professionele reis.";
const ChecklistCompleted$9 = "Je checklist is voltooid!";
const Completeyourchecklist$9 = "Voltooi je checklist";
const completeAFewStepsTo$9 = "Voltooi een paar stappen om je volgende baan te bemachtigen.";
const Completed$9 = "Voltooid";
const JobCountByStage$9 = "Aantal banen per fase";
const NopastapplicationDatafound$9 = "Geen vorige toepassingsgegevens gevonden";
const YourJobSearchStages$9 = "De stadia van jouw zoektocht naar werk";
const NoDatafound$9 = "Geen gegevens gevonden.";
const nl = {
	copyToClipboard: copyToClipboard$9,
	UnlocktheAIgenerated: UnlocktheAIgenerated$9,
	UpgradetoPremium: UpgradetoPremium$9,
	Result: Result$9,
	Copy: Copy$9,
	Save: Save$9,
	Edit: Edit$9,
	Processing: Processing$9,
	YourAIgeneratedcontentwillshowhere: YourAIgeneratedcontentwillshowhere$9,
	hopeYouFindUseful: hopeYouFindUseful$9,
	regenerate: regenerate$9,
	ProvideAdditionalFeedback: ProvideAdditionalFeedback$9,
	Enteranyfeedback: Enteranyfeedback$9,
	Notimpressive: Notimpressive$9,
	thisIsntTrue: thisIsntTrue$9,
	Notpersonalized: Notpersonalized$9,
	Tone: Tone$9,
	Length: Length$9,
	Template: Template$9,
	Generatedon: Generatedon$9,
	Copiedtoclipboard: Copiedtoclipboard$9,
	CopytoClipboard: CopytoClipboard$9,
	DownloadasPDF: DownloadasPDF$9,
	ViewDetails: ViewDetails$9,
	JobDescriptionImported: JobDescriptionImported$9,
	ImportfromJob: ImportfromJob$9,
	Saved: Saved$9,
	Applied: Applied$9,
	Offer: Offer$9,
	Interviewing: Interviewing$9,
	Rejected: Rejected$9,
	Search: Search$9,
	Import: Import$9,
	CoverLetterGeneratorHistory: CoverLetterGeneratorHistory$9,
	NoCoverLettersGenerated: NoCoverLettersGenerated$9,
	getStartedCoverLetter: getStartedCoverLetter$9,
	getStarted: getStarted$9,
	Documents: Documents$9,
	UploadNewDocument: UploadNewDocument$9,
	AICoverLetterGenerator: AICoverLetterGenerator$9,
	ViewHistory: ViewHistory$9,
	JobDescription: JobDescription$9,
	ImportfromBoard: ImportfromBoard$9,
	EnterJobDescription: EnterJobDescription$9,
	JobTitle: JobTitle$9,
	EnterJobTitle: EnterJobTitle$9,
	CompanyName: CompanyName$9,
	EnterCompanyName: EnterCompanyName$9,
	YourProfile: YourProfile$9,
	ResumeUpload: ResumeUpload$9,
	UseLinkedinProfile: UseLinkedinProfile$9,
	Uploadyourresume: Uploadyourresume$9,
	AddyourResume: AddyourResume$9,
	fileNameCannotFormat: fileNameCannotFormat$9,
	ChooseorUpload: ChooseorUpload$9,
	SelectTemplate: SelectTemplate$9,
	Preview: Preview$9,
	UseTemplate: UseTemplate$9,
	Change: Change$9,
	AdvancedSettings: AdvancedSettings$9,
	AdditionalContext: AdditionalContext$9,
	Professional: Professional$9,
	Casual: Casual$9,
	Enthusiastic: Enthusiastic$9,
	Informational: Informational$9,
	Short: Short$9,
	Medium: Medium$9,
	Long: Long$9,
	Language: Language$9,
	iAmOkayBack: iAmOkayBack$9,
	Generate: Generate$9,
	CoverLetter: CoverLetter$9,
	SelectLanguage: SelectLanguage$9,
	AboutGeneratorHistory: AboutGeneratorHistory$9,
	NoAboutsGenerated: NoAboutsGenerated$9,
	getStartedAbouts: getStartedAbouts$9,
	noAttachmentsFound: noAttachmentsFound$9,
	TargetJobTitle: TargetJobTitle$9,
	KeywordsToInclude: KeywordsToInclude$9,
	UploadYourResume: UploadYourResume$9,
	AddYourResume: AddYourResume$9,
	LinkedinProfile: LinkedinProfile$9,
	Linkedinprofilenotfound: Linkedinprofilenotfound$9,
	startUsingChromeExtension: startUsingChromeExtension$9,
	Download: Download$9,
	UseEmojis: UseEmojis$9,
	UseBulletPoints: UseBulletPoints$9,
	SpeechFocus: SpeechFocus$9,
	FirstPerson: FirstPerson$9,
	ThirdPerson: ThirdPerson$9,
	HeadlineGeneratorHistory: HeadlineGeneratorHistory$9,
	NoHeadlinesGenerated: NoHeadlinesGenerated$9,
	getStartedHeadline: getStartedHeadline$9,
	AIHeadlineGenerator: AIHeadlineGenerator$9,
	KeywordstoInclude: KeywordstoInclude$9,
	Pressenteraftereachword: Pressenteraftereachword$9,
	LinkedinProfilenotfound: LinkedinProfilenotfound$9,
	Headline: Headline$9,
	PostGeneratorHistory: PostGeneratorHistory$9,
	NoPostsGenerated: NoPostsGenerated$9,
	getStartedPost: getStartedPost$9,
	Topic: Topic$9,
	Description: Description$9,
	UseHashtags: UseHashtags$9,
	Custom: Custom$9,
	EnterCustomTone: EnterCustomTone$9,
	Added: Added$9,
	ComingSoon: ComingSoon$9,
	Company: Company$9,
	JobInterview: JobInterview$9,
	Research: Research$9,
	Networking: Networking$9,
	Referral: Referral$9,
	MustbeContacted: MustbeContacted$9,
	ScheduleaMeeting: ScheduleaMeeting$9,
	needAFollowUp: needAFollowUp$9,
	Today: Today$9,
	Viewdetails: Viewdetails$9,
	Activity: Activity$9,
	ActivityDetails: ActivityDetails$9,
	Delete: Delete$9,
	Title: Title$9,
	Goal: Goal$9,
	Status: Status$9,
	FollowUp: FollowUp$9,
	AddActivity: AddActivity$9,
	Enteractivitytitle: Enteractivitytitle$9,
	Cancel: Cancel$9,
	SaveActivity: SaveActivity$9,
	noActivityPresent: noActivityPresent$9,
	Addnew: Addnew$9,
	About: About$9,
	noDataPresentYou: noDataPresentYou$9,
	Experience: Experience$9,
	Education: Education$9,
	Skills: Skills$9,
	Overview: Overview$9,
	LinkedJobs: LinkedJobs$9,
	Notes: Notes$9,
	FullName: FullName$9,
	Location: Location$9,
	Relationship: Relationship$9,
	Contacts: Contacts$9,
	CreateContact: CreateContact$9,
	NotesCreated: NotesCreated$9,
	Notesupdated: Notesupdated$9,
	Addnote: Addnote$9,
	areYouSureDeleteNote: areYouSureDeleteNote$9,
	Createdby: Createdby$9,
	notSureWhyResumeCalls: notSureWhyResumeCalls$9,
	getExpertResumeReview: getExpertResumeReview$9,
	youHaventAddedContacts: youHaventAddedContacts$9,
	noMatchingContacts: noMatchingContacts$9,
	Link: Link$9,
	unlink: unlink$9,
	Locationnotavailable: Locationnotavailable$9,
	Emailnotavailable: Emailnotavailable$9,
	PhoneNumbernotavailable: PhoneNumbernotavailable$9,
	createdby: createdby$9,
	areYouSureDeleteContact: areYouSureDeleteContact$9,
	areYouSureUnlinkContact: areYouSureUnlinkContact$9,
	Addedbyyou: Addedbyyou$9,
	Addedby: Addedby$9,
	Timeline: Timeline$9,
	Timelineempty: Timelineempty$9,
	Discard: Discard$9,
	SaveContact: SaveContact$9,
	Recruiter: Recruiter$9,
	Candidate: Candidate$9,
	Colleague: Colleague$9,
	Employee: Employee$9,
	"Needtofollow-up": "Moet opgevolgd worden",
	EnterValidEmail: EnterValidEmail$9,
	EnterValidPhoneNumber: EnterValidPhoneNumber$9,
	editingProfileNotAvailable: editingProfileNotAvailable$9,
	itWillBeSoonAvailable: itWillBeSoonAvailable$9,
	ChromeExtension: ChromeExtension$9,
	SelectTag: SelectTag$9,
	FirstName: FirstName$9,
	FirstNameisrequired: FirstNameisrequired$9,
	LastName: LastName$9,
	LastNameisrequired: LastNameisrequired$9,
	Companyisrequired: Companyisrequired$9,
	Email: Email$9,
	ThisisnotavalidEmail: ThisisnotavalidEmail$9,
	AddEmail: AddEmail$9,
	PhoneNumber: PhoneNumber$9,
	notaValidPhone: notaValidPhone$9,
	phoneNoMinimum5char: phoneNoMinimum5char$9,
	phoneNoMinumum15char: phoneNoMinumum15char$9,
	AddPhoneNumber: AddPhoneNumber$9,
	SelectGoal: SelectGoal$9,
	SelectStatus: SelectStatus$9,
	Followup: Followup$9,
	SocialMedia: SocialMedia$9,
	Linkedinhandle: Linkedinhandle$9,
	Twitterhandle: Twitterhandle$9,
	Facebookhandle: Facebookhandle$9,
	Githubhandle: Githubhandle$9,
	Gmailhandle: Gmailhandle$9,
	Changessavedsuccessfully: Changessavedsuccessfully$9,
	EditContact: EditContact$9,
	BasicInformation: BasicInformation$9,
	EditContactDetails: EditContactDetails$9,
	SaveChanges: SaveChanges$9,
	phoneNoMinimum14char: phoneNoMinimum14char$9,
	LinkedIn: LinkedIn$9,
	Twitter: Twitter$9,
	Facebook: Facebook$9,
	Github: Github$9,
	Gmail: Gmail$9,
	youCanWriteAbout: youCanWriteAbout$9,
	Addednewsection: Addednewsection$9,
	Removedsuccessfully: Removedsuccessfully$9,
	Remove: Remove$9,
	Institute: Institute$9,
	Schoolisrequired: Schoolisrequired$9,
	Degree: Degree$9,
	StartMonth: StartMonth$9,
	StartYear: StartYear$9,
	EndMonth: EndMonth$9,
	EndYear: EndYear$9,
	Addmore: Addmore$9,
	PositionTitle: PositionTitle$9,
	ExperienceType: ExperienceType$9,
	Addednewitem: Addednewitem$9,
	whatSkillsDoYouEnjoy: whatSkillsDoYouEnjoy$9,
	Typeskillshere: Typeskillshere$9,
	LinkedContacts: LinkedContacts$9,
	LinkContact: LinkContact$9,
	NocontactsLinked: NocontactsLinked$9,
	JobContactsComponent: JobContactsComponent$9,
	Nocontacts: Nocontacts$9,
	LinkJobto: LinkJobto$9,
	Contact: Contact$9,
	Document: Document$9,
	Nojobsfound: Nojobsfound$9,
	LinkJob: LinkJob$9,
	youCanLinkContactJobImported: youCanLinkContactJobImported$9,
	Prev: Prev$9,
	Next: Next$9,
	areYouSureUnlinkDocument: areYouSureUnlinkDocument$9,
	areYouSureDeleteDocument: areYouSureDeleteDocument$9,
	Category: Category$9,
	CreatedOn: CreatedOn$9,
	Joblinked: Joblinked$9,
	Quickactions: Quickactions$9,
	All: All$9,
	Resume: Resume$9,
	Portfolio: Portfolio$9,
	Other: Other$9,
	Adddocument: Adddocument$9,
	Type: Type$9,
	Sortingby: Sortingby$9,
	SwitchtoGridLayout: SwitchtoGridLayout$9,
	SwitchtoListLayout: SwitchtoListLayout$9,
	NoDocumentsAdded: NoDocumentsAdded$9,
	DocumentsComponent: DocumentsComponent$9,
	NoDocumentFound: NoDocumentFound$9,
	SelectFile: SelectFile$9,
	onlyPdfDocxSupported: onlyPdfDocxSupported$9,
	Uploadfile: Uploadfile$9,
	DocumentCategory: DocumentCategory$9,
	SaveDocument: SaveDocument$9,
	AddDocument: AddDocument$9,
	LinkedDocuments: LinkedDocuments$9,
	LinkDocument: LinkDocument$9,
	NodocumentsLinked: NodocumentsLinked$9,
	JobDocumentsComponent: JobDocumentsComponent$9,
	NoDocuments: NoDocuments$9,
	CreateDocuments: CreateDocuments$9,
	youCanLinkDocumentJobImported: youCanLinkDocumentJobImported$9,
	Documenteditedsuccessfully: Documenteditedsuccessfully$9,
	DocumentDetails: DocumentDetails$9,
	UnsavedChanges: UnsavedChanges$9,
	yourChangesWillBeLostSureClose: yourChangesWillBeLostSureClose$9,
	yourChangesWillBeLostSureDiscard: yourChangesWillBeLostSureDiscard$9,
	DiscardChanges: DiscardChanges$9,
	WeeklyGoalAlert: WeeklyGoalAlert$9,
	Progress: Progress$9,
	AllGoals: AllGoals$9,
	Name: Name$9,
	Completedon: Completedon$9,
	Createdon: Createdon$9,
	Action: Action$9,
	Back: Back$9,
	OverallScore: OverallScore$9,
	Aboutthegoal: Aboutthegoal$9,
	GoalTracking: GoalTracking$9,
	Week: Week$9,
	progress: progress$9,
	loading: loading$9,
	Apply: Apply$9,
	Thisskillhasbeenreported: Thisskillhasbeenreported$9,
	issueGettingResume: issueGettingResume$9,
	Interview: Interview$9,
	Tasks: Tasks$9,
	Loading: Loading$9,
	Skilladdedsuccessfully: Skilladdedsuccessfully$9,
	problemAddingSkill: problemAddingSkill$9,
	Reportaproblem: Reportaproblem$9,
	Submit: Submit$9,
	Addanewskill: Addanewskill$9,
	JobDetailsComponent: JobDetailsComponent$9,
	HardSkill: HardSkill$9,
	SoftSkill: SoftSkill$9,
	Pleaseshareanyadditionalcontext: Pleaseshareanyadditionalcontext$9,
	Addasskill: Addasskill$9,
	Skill: Skill$9,
	JobFrequency: JobFrequency$9,
	ResumeFrequency: ResumeFrequency$9,
	Reportskill: Reportskill$9,
	JobDetails: JobDetails$9,
	ViewJobLink: ViewJobLink$9,
	Salary: Salary$9,
	areYouSureDeleteJob: areYouSureDeleteJob$9,
	ViewMore: ViewMore$9,
	ViewLess: ViewLess$9,
	matchYouSkillsAgainstJob: matchYouSkillsAgainstJob$9,
	pleaseUploadResumeSkillMatch: pleaseUploadResumeSkillMatch$9,
	AddResume: AddResume$9,
	thisJobDoesNotHaveAnyDesc: thisJobDoesNotHaveAnyDesc$9,
	youCanEditJobToAdd: youCanEditJobToAdd$9,
	chromeextension: chromeextension$9,
	fromVariousJobPortalsOnce: fromVariousJobPortalsOnce$9,
	AddDescription: AddDescription$9,
	CompanyInfo: CompanyInfo$9,
	Website: Website$9,
	Industry: Industry$9,
	EmployeeCount: EmployeeCount$9,
	ExprienceLevel: ExprienceLevel$9,
	Address: Address$9,
	Resumes: Resumes$9,
	Setasdefault: Setasdefault$9,
	Ok: Ok$9,
	UploadNewResume: UploadNewResume$9,
	Default: Default$9,
	Jobnotfound: Jobnotfound$9,
	EditDetails: EditDetails$9,
	JobPostURL: JobPostURL$9,
	Enterjoburl: Enterjoburl$9,
	Nojobselected: Nojobselected$9,
	Viewjobdetails: Viewjobdetails$9,
	Jobaddedtoyourboardsuccessfully: Jobaddedtoyourboardsuccessfully$9,
	AddJob: AddJob$9,
	Addnewjobname: Addnewjobname$9,
	JobUrl: JobUrl$9,
	Addjoburl: Addjoburl$9,
	Section: Section$9,
	didYouKnow: didYouKnow$9,
	Jobs: Jobs$9,
	AddJobtoboard: AddJobtoboard$9,
	Currentlynojobsareavailable: Currentlynojobsareavailable$9,
	noMatchingJobs: noMatchingJobs$9,
	welcomeToYourPersonalJobTracker: welcomeToYourPersonalJobTracker$9,
	weShortTutorialOnHowTrackingJob: weShortTutorialOnHowTrackingJob$9,
	Addanewjob: Addanewjob$9,
	inOrderTrackCreatButton: inOrderTrackCreatButton$9,
	Providesomedetails: Providesomedetails$9,
	toBeginTypeJobTitleCompany: toBeginTypeJobTitleCompany$9,
	asAnExampleFilledForYou: asAnExampleFilledForYou$9,
	wohooAddedFirstJob: wohooAddedFirstJob$9,
	youCanDragDropJobCard: youCanDragDropJobCard$9,
	Lastbutnotleast: Lastbutnotleast$9,
	finalStepMakeSure: finalStepMakeSure$9,
	autoMaticallyImportJobs: autoMaticallyImportJobs$9,
	selectanysection: selectanysection$9,
	Accept: Accept$9,
	My2023JobSearch: My2023JobSearch$9,
	AddedFrom: AddedFrom$9,
	AddedUntil: AddedUntil$9,
	BasicModal: BasicModal$9,
	AddnewSectionName: AddnewSectionName$9,
	OpenTo: OpenTo$9,
	Featured: Featured$9,
	LicenceAndCerts: LicenceAndCerts$9,
	Banner: Banner$9,
	LinkedInURL: LinkedInURL$9,
	Recommendations: Recommendations$9,
	LinkedinReview: LinkedinReview$9,
	NoDataAvailable: NoDataAvailable$9,
	looksLikeYouDidNot: looksLikeYouDidNot$9,
	toOptimizeProfileScoreVisible: toOptimizeProfileScoreVisible$9,
	LinkedinComponent: LinkedinComponent$9,
	improveYourChancesLandingDreamJob: improveYourChancesLandingDreamJob$9,
	VisitProfile: VisitProfile$9,
	wantToGetLinkedinMakeover: wantToGetLinkedinMakeover$9,
	PostGenerator: PostGenerator$9,
	LinkedinHeadlineGenerator: LinkedinHeadlineGenerator$9,
	LinkedinAboutSectionGenerator: LinkedinAboutSectionGenerator$9,
	AITools: AITools$9,
	Premium: Premium$9,
	LinkedInOptimization: LinkedInOptimization$9,
	JobTracker: JobTracker$9,
	whoIsHiring: whoIsHiring$9,
	Autofill: Autofill$9,
	HeadlineGenerator: HeadlineGenerator$9,
	skillMatching: skillMatching$9,
	SummarizeJD: SummarizeJD$9,
	contactFeature: contactFeature$9,
	documentFeature: documentFeature$9,
	landJobWithoutStress: landJobWithoutStress$9,
	discoverFeatures: discoverFeatures$9,
	letsBeginOnboarding: letsBeginOnboarding$9,
	inTheNextFewScreensJobThirdParties: inTheNextFewScreensJobThirdParties$9,
	letsAddBasicInformation: letsAddBasicInformation$9,
	Pleaseselectanoptionfirst: Pleaseselectanoptionfirst$9,
	JobApplicationTracker: JobApplicationTracker$9,
	LinkedInProfileOptimizer: LinkedInProfileOptimizer$9,
	UnlimitedDocuments: UnlimitedDocuments$9,
	UnlimitedContacts: UnlimitedContacts$9,
	HiringManagerSearch: HiringManagerSearch$9,
	AILinkedInPostGenerator: AILinkedInPostGenerator$9,
	ATSKeywordSkillMatch: ATSKeywordSkillMatch$9,
	"Auto-Apply": "Automatisch toepassen",
	ChooseyourPlan: ChooseyourPlan$9,
	superChargeYourJobSearch: superChargeYourJobSearch$9,
	startNowGoto: startNowGoto$9,
	CreatedBy: CreatedBy$9,
	CreateNewNote: CreateNewNote$9,
	Nonotescreated: Nonotescreated$9,
	approxTimeIsFourMinutes: approxTimeIsFourMinutes$9,
	Continue: Continue$9,
	iWillDoLaterTakeMeToApp: iWillDoLaterTakeMeToApp$9,
	allDone: allDone$9,
	welcomeAbord: welcomeAbord$9,
	letsBegin: letsBegin$9,
	UpgradeyourplanandgetAIAssistance: UpgradeyourplanandgetAIAssistance$9,
	DownloadPDF: DownloadPDF$9,
	oopsWeCouldntProcessResume: oopsWeCouldntProcessResume$9,
	MyProfile: MyProfile$9,
	Setting: Setting$9,
	Logout: Logout$9,
	SignIn: SignIn$9,
	Typeyourfirstnamehere: Typeyourfirstnamehere$9,
	Enteryourlastname: Enteryourlastname$9,
	ManageSubscription: ManageSubscription$9,
	ifYouHaveDifficultiesProfile: ifYouHaveDifficultiesProfile$9,
	forSupport: forSupport$9,
	whatIsIdealCompanySize: whatIsIdealCompanySize$9,
	Saveandcontinue: Saveandcontinue$9,
	whatIsMinExpectedSalary: whatIsMinExpectedSalary$9,
	Atleast: Atleast$9,
	SlidetoAdjust: SlidetoAdjust$9,
	whatIndustryExcitedWork: whatIndustryExcitedWork$9,
	Add: Add$9,
	statusOfJobSearch: statusOfJobSearch$9,
	Finish: Finish$9,
	whatLevelRoleLooking: whatLevelRoleLooking$9,
	Selectuptotwo: Selectuptotwo$9,
	PreviousStep: PreviousStep$9,
	Skip: Skip$9,
	whatDoYouValueNewRole: whatDoYouValueNewRole$9,
	Selectuptothree: Selectuptothree$9,
	EqualEmploymentData: EqualEmploymentData$9,
	whatIsYourEthnicity: whatIsYourEthnicity$9,
	areYouAuthorizedToWorkUs: areYouAuthorizedToWorkUs$9,
	willYouRequireSponsorShip: willYouRequireSponsorShip$9,
	doYouHaveADisability: doYouHaveADisability$9,
	areYouAVeteran: areYouAVeteran$9,
	rolesYouInterestedIn: rolesYouInterestedIn$9,
	Selectuptofive: Selectuptofive$9,
	AddCustomrole: AddCustomrole$9,
	whereDoYouLikeWork: whereDoYouLikeWork$9,
	Resources: Resources$9,
	currentlyNoResourceAvailable: currentlyNoResourceAvailable$9,
	AddNewSection: AddNewSection$9,
	ChangeSections: ChangeSections$9,
	Settings: Settings$9,
	Dashboard: Dashboard$9,
	JobBoard: JobBoard$9,
	Linkedin: Linkedin$9,
	Community: Community$9,
	FindRecruiters: FindRecruiters$9,
	Goals: Goals$9,
	DownloadExtension: DownloadExtension$9,
	SuggestaFeature: SuggestaFeature$9,
	leftPanel: leftPanel$9,
	PhoneNumberisrequired: PhoneNumberisrequired$9,
	MobileNumber: MobileNumber$9,
	Enteronlynumbers: Enteronlynumbers$9,
	Countryyoulivein: Countryyoulivein$9,
	SelectaCountry: SelectaCountry$9,
	DateofBirth: DateofBirth$9,
	Gender: Gender$9,
	JobPreferences: JobPreferences$9,
	pleaseEnterValidEmail: pleaseEnterValidEmail$9,
	emailSendForResetting: emailSendForResetting$9,
	VerifyyourEmailID: VerifyyourEmailID$9,
	sentPleaseCheckEmail: sentPleaseCheckEmail$9,
	tooManyAttemptsTryAgain: tooManyAttemptsTryAgain$9,
	Resend: Resend$9,
	Login: Login$9,
	weHaveSentVerificationLinkAtEmail: weHaveSentVerificationLinkAtEmail$9,
	pleaseVerifyEmailContinueSpam: pleaseVerifyEmailContinueSpam$9,
	Logintogetstarted: Logintogetstarted$9,
	ContinuewithGoogle: ContinuewithGoogle$9,
	pleaseInputEmail: pleaseInputEmail$9,
	Password: Password$9,
	pleaseInputPassword: pleaseInputPassword$9,
	passwordLowerUpperDigitSpecial: passwordLowerUpperDigitSpecial$9,
	atLeastSixChar: atLeastSixChar$9,
	forgotPassword: forgotPassword$9,
	Bysigninginyouagreetoour: Bysigninginyouagreetoour$9,
	Terms: Terms$9,
	Conditions: Conditions$9,
	and: and$9,
	PrivacyPolicy: PrivacyPolicy$9,
	theseAreTheTopsSkillsExtracted: theseAreTheTopsSkillsExtracted$9,
	TopSkills: TopSkills$9,
	weCoulNotExtractSkills: weCoulNotExtractSkills$9,
	upgradeToPremiumToView: upgradeToPremiumToView$9,
	SkillScore: SkillScore$9,
	thisIsYourSkillScoreBasedOn: thisIsYourSkillScoreBasedOn$9,
	theseSkllsAreStrongMatch: theseSkllsAreStrongMatch$9,
	Strongmatch: Strongmatch$9,
	theseSkillsArePartialMatch: theseSkillsArePartialMatch$9,
	Partialmatch: Partialmatch$9,
	theseSkillsAreMissingFrom: theseSkillsAreMissingFrom$9,
	"Missing Keywords": "Ontbrekende zoekwoorden",
	SkillMatchComponent: SkillMatchComponent$9,
	Optional: Optional$9,
	Notrelevanttothejob: Notrelevanttothejob$9,
	Notaskill: Notaskill$9,
	Toogeneric: Toogeneric$9,
	Pleaseshareanyfeedback: Pleaseshareanyfeedback$9,
	excludedKeywordsWillNot: excludedKeywordsWillNot$9,
	yesExcludeThisSkillFrom: yesExcludeThisSkillFrom$9,
	PartialMatch: PartialMatch$9,
	MissingKeywords: MissingKeywords$9,
	Providetitletotask: Providetitletotask$9,
	TasksList: TasksList$9,
	AddTask: AddTask$9,
	EnterTaskTitlehere: EnterTaskTitlehere$9,
	TasksComponent: TasksComponent$9,
	CompletedTasks: CompletedTasks$9,
	CompleteYourtasks: CompleteYourtasks$9,
	Steps: Steps$9,
	PremiumMember: PremiumMember$9,
	Thankyouforupgradingto: Thankyouforupgradingto$9,
	CareerflowPremium: CareerflowPremium$9,
	hereIsHowYouCanAccessPremium: hereIsHowYouCanAccessPremium$9,
	stepOne: stepOne$9,
	DownloadourChromeExtension: DownloadourChromeExtension$9,
	youJobSearchCopilotIshere: youJobSearchCopilotIshere$9,
	DownloadNow: DownloadNow$9,
	stepTwo: stepTwo$9,
	GetStarted: GetStarted$9,
	stepThree: stepThree$9,
	SignintoChromeExtension: SignintoChromeExtension$9,
	entityCreated: entityCreated$9,
	entityUpdated: entityUpdated$9,
	entityDeleted: entityDeleted$9,
	entityLinked: entityLinked$9,
	entityUnlinked: entityUnlinked$9,
	entityMovedTo: entityMovedTo$9,
	youAddedANewEntity: youAddedANewEntity$9,
	personCreated: personCreated$9,
	youUpdatedAEntity: youUpdatedAEntity$9,
	personUpdated: personUpdated$9,
	youDeletedAEntity: youDeletedAEntity$9,
	personDeleted: personDeleted$9,
	youLinkedEntity: youLinkedEntity$9,
	personLinked: personLinked$9,
	youUnlinked: youUnlinked$9,
	personUnlinked: personUnlinked$9,
	youMovedEntity: youMovedEntity$9,
	personMoved: personMoved$9,
	addedByName: addedByName$9,
	DownloadChromeExtension: DownloadChromeExtension$9,
	ourChromeExtensionIs: ourChromeExtensionIs$9,
	Optimizeyourprofile: Optimizeyourprofile$9,
	startOptimizingYourProfile: startOptimizingYourProfile$9,
	OptimizeNow: OptimizeNow$9,
	Addyourfirstjob: Addyourfirstjob$9,
	startSavingJobApplicationsToTrack: startSavingJobApplicationsToTrack$9,
	AddNow: AddNow$9,
	CompleteProfile: CompleteProfile$9,
	completeYourProfileForUsing: completeYourProfileForUsing$9,
	CompleteNow: CompleteNow$9,
	Addyourfirstcontact: Addyourfirstcontact$9,
	addContactToFollowUpWith: addContactToFollowUpWith$9,
	JoinCommunity: JoinCommunity$9,
	ourCommunityisAlways: ourCommunityisAlways$9,
	JoinNow: JoinNow$9,
	welcomeToCareerflow: welcomeToCareerflow$9,
	yourHubForCareerInsights2: yourHubForCareerInsights2$9,
	ChecklistCompleted: ChecklistCompleted$9,
	Completeyourchecklist: Completeyourchecklist$9,
	completeAFewStepsTo: completeAFewStepsTo$9,
	Completed: Completed$9,
	JobCountByStage: JobCountByStage$9,
	NopastapplicationDatafound: NopastapplicationDatafound$9,
	YourJobSearchStages: YourJobSearchStages$9,
	NoDatafound: NoDatafound$9
};

const copyToClipboard$8 = "Kopiert til utklippstavlen!";
const UnlocktheAIgenerated$8 = "Lås opp det AI-genererte.";
const UpgradetoPremium$8 = "Oppgrader til Premium";
const Result$8 = "Resultat";
const Copy$8 = "Kopier";
const Save$8 = "Lagre";
const Edit$8 = "Rediger";
const Processing$8 = "Behandler";
const YourAIgeneratedcontentwillshowhere$8 = "Ditt AI-genererte innhold vil vises her";
const hopeYouFindUseful$8 = "Håper du finner dette resultatet nyttig!";
const regenerate$8 = "Regenerer";
const ProvideAdditionalFeedback$8 = "Gi Tilleggs Tilbakemelding";
const Enteranyfeedback$8 = "Skriv inn eventuelle tilbakemeldinger";
const Notimpressive$8 = "Ikke imponerende";
const thisIsntTrue$8 = "Dette er ikke sant";
const Notpersonalized$8 = "Ikke personlig tilpasset";
const Tone$8 = "Tone";
const Length$8 = "Lengde";
const Template$8 = "Mal";
const Generatedon$8 = "Generert den";
const Copiedtoclipboard$8 = "Kopiert til utklippstavlen";
const CopytoClipboard$8 = "Kopier til utklippstavle";
const DownloadasPDF$8 = "Last ned som PDF";
const ViewDetails$8 = "Se detaljer";
const JobDescriptionImported$8 = "Jobbeskrivelse importert";
const ImportfromJob$8 = "Import fra jobb";
const Saved$8 = "Lagret";
const Applied$8 = "Søkt";
const Offer$8 = "Tilbud";
const Interviewing$8 = "Intervju";
const Rejected$8 = "Avvist";
const Search$8 = "Søk";
const Import$8 = "Import";
const CoverLetterGeneratorHistory$8 = "Historikk for søknadsbrevsgenerator";
const NoCoverLettersGenerated$8 = "Ingen søknadsbrev generert";
const getStartedCoverLetter$8 = "Du har ikke generert noen søknadsbrev ennå. Kom i gang og lag søknadsbrev ved å matche jobbeskrivelsen med din relevante erfaring.";
const getStarted$8 = "Kom i gang!";
const Documents$8 = "Dokumenter";
const UploadNewDocument$8 = "Last opp nytt dokument";
const AICoverLetterGenerator$8 = "AI Søknadsbrevsgenerator";
const ViewHistory$8 = "Vis historikk";
const JobDescription$8 = "Jobbeskrivelse";
const ImportfromBoard$8 = "Importer fra tavlen";
const EnterJobDescription$8 = "Skriv inn jobbeskrivelse";
const JobTitle$8 = "Stillingsbetegnelse";
const EnterJobTitle$8 = "Skriv inn stillingsbetegnelse";
const CompanyName$8 = "Firmanavn";
const EnterCompanyName$8 = "Skriv inn firmanavn";
const YourProfile$8 = "Din profil";
const ResumeUpload$8 = "Last opp CV";
const UseLinkedinProfile$8 = "Bruk Linkedin-profil";
const Uploadyourresume$8 = "Last opp din CV";
const AddyourResume$8 = "Legg til din CV";
const fileNameCannotFormat$8 = "Filnavn kan ikke inneholde mellomrom eller understreker og skal være i enten .doc, .docx eller .pdf-format.";
const ChooseorUpload$8 = "Velg eller last opp";
const SelectTemplate$8 = "Velg mal";
const Preview$8 = "Forhåndsvisning";
const UseTemplate$8 = "Bruk mal";
const Change$8 = "Endre";
const AdvancedSettings$8 = "Avanserte innstillinger";
const AdditionalContext$8 = "Tilleggsinformasjon";
const Professional$8 = "Profesjonell";
const Casual$8 = "Uformell";
const Enthusiastic$8 = "Entusiastisk";
const Informational$8 = "Informativ";
const Short$8 = "Kort";
const Medium$8 = "Medium";
const Long$8 = "Lang";
const Language$8 = "Språk";
const iAmOkayBack$8 = "Jeg er ok! Gå tilbake";
const Generate$8 = "Generer";
const CoverLetter$8 = "Søknadsbrev";
const SelectLanguage$8 = "Velg språk";
const AboutGeneratorHistory$8 = "Om generatorhistorikk";
const NoAboutsGenerated$8 = "Ingen om-deler generert";
const getStartedAbouts$8 = "Du har ikke generert noen om-deler ennå. Kom i gang og lag om-deler ved å matche jobbeskrivelsen med din relevante erfaring.";
const noAttachmentsFound$8 = "Ingen vedlegg funnet.";
const TargetJobTitle$8 = "Mål stillingstittel";
const KeywordsToInclude$8 = "Nøkkelord å inkludere";
const UploadYourResume$8 = "Last opp din CV";
const AddYourResume$8 = "Legg til din CV";
const LinkedinProfile$8 = "Linkedin-profil";
const Linkedinprofilenotfound$8 = "Linkedin-profil ikke funnet";
const startUsingChromeExtension$8 = "Begynn å optimalisere Linkedin-profilen din ved å bruke vår Chrome-utvidelse for å bruke denne opsjonen.";
const Download$8 = "Last ned";
const UseEmojis$8 = "Bruk emojis";
const UseBulletPoints$8 = "Bruk punktlister";
const SpeechFocus$8 = "Talefokus";
const FirstPerson$8 = "Første person";
const ThirdPerson$8 = "Tredje person";
const HeadlineGeneratorHistory$8 = "Historikk for overskriftsgenerator";
const NoHeadlinesGenerated$8 = "Ingen overskrifter generert";
const getStartedHeadline$8 = "Du har ikke generert noen overskrifter ennå. Kom i gang og lag overskrifter ved å matche jobbeskrivelsen med din relevante erfaring.";
const AIHeadlineGenerator$8 = "AI Overskriftsgenerator";
const KeywordstoInclude$8 = "Nøkkelord å inkludere";
const Pressenteraftereachword$8 = "Trykk enter etter hvert ord.";
const LinkedinProfilenotfound$8 = "LinkedIn-profil ikke funnet.";
const Headline$8 = "Overskrift";
const PostGeneratorHistory$8 = "Historikk for innleggsgenerator";
const NoPostsGenerated$8 = "Ingen innlegg generert";
const getStartedPost$8 = "Du har ikke generert noen innlegg ennå. Kom i gang og lag innlegg ved å matche jobbeskrivelsen med din relevante erfaring.";
const Topic$8 = "Tema";
const Description$8 = "";
const UseHashtags$8 = "Bruk emneknagger";
const Custom$8 = "Egendefinert";
const EnterCustomTone$8 = "Skriv inn egendefinert tone";
const Added$8 = "Lagt til";
const ComingSoon$8 = {
	header: "Ingeniører i arbeid!",
	content_1: "Vårt team av ingeniører jobber hardt for å få denne funksjonen opp og kjøre snart",
	content_2: "Ønsker du denne funksjonen snart? La oss vite ved å bare krysse av i boksen nedenfor.",
	content_3: "Jeg vil ha denne funksjonen"
};
const Company$8 = "Selskap";
const JobInterview$8 = "Jobbintervju";
const Research$8 = "Forskning";
const Networking$8 = "Nettverking";
const Referral$8 = "Henvisning";
const MustbeContacted$8 = "Må kontaktes";
const ScheduleaMeeting$8 = "Planlegg et møte";
const needAFollowUp$8 = "Må følge opp.";
const Today$8 = "I dag";
const Viewdetails$8 = "Se detaljer";
const Activity$8 = "Aktivitet";
const ActivityDetails$8 = "Aktivitetsdetaljer";
const Delete$8 = "Slett";
const Title$8 = "Tittel";
const Goal$8 = "Mål";
const Status$8 = "Status";
const FollowUp$8 = "Oppfølging";
const AddActivity$8 = "Legg til aktivitet";
const Enteractivitytitle$8 = "Skriv inn tittel for aktivitet";
const Cancel$8 = "Avbryt";
const SaveActivity$8 = "Lagre aktivitet";
const noActivityPresent$8 = "Ingen aktivitet til stede, legg til aktivitet.";
const Addnew$8 = "Legg til ny";
const About$8 = "Om";
const noDataPresentYou$8 = "Ingen data til stede, du kan redigere denne kontakten og legge til felt.";
const Experience$8 = "Erfaring";
const Education$8 = "Utdanning";
const Skills$8 = "Ferdigheter";
const Overview$8 = "Oversikt";
const LinkedJobs$8 = "Lenkede jobber";
const Notes$8 = "Notater";
const FullName$8 = "Fullt navn";
const Location$8 = "Sted";
const Relationship$8 = "Forhold";
const Contacts$8 = "Kontakter";
const CreateContact$8 = "Opprett kontakt";
const NotesCreated$8 = "Notater opprettet";
const Notesupdated$8 = "Notater oppdatert";
const Addnote$8 = "Legg til notat";
const areYouSureDeleteNote$8 = "Er du sikker på at du vil slette denne notatet?";
const Createdby$8 = "Opprettet av";
const notSureWhyResumeCalls$8 = "Usikker på hvorfor CV-en din ikke gir deg intervjuanrop? ☎️";
const getExpertResumeReview$8 = "Få en ekspertvurdering av CV-en din 💎✨";
const youHaventAddedContacts$8 = "Du har ikke lagt til noen kontakter ennå.";
const noMatchingContacts$8 = "Ingen matchende kontakter funnet.";
const Link$8 = "Lenke";
const unlink$8 = "Fjern lenke";
const Locationnotavailable$8 = "Sted ikke tilgjengelig";
const Emailnotavailable$8 = "E-post ikke tilgjengelig";
const PhoneNumbernotavailable$8 = "Telefonnummer ikke tilgjengelig";
const createdby$8 = "opprettet av";
const areYouSureDeleteContact$8 = "Er du sikker på at du vil slette denne kontakten?";
const areYouSureUnlinkContact$8 = "Er du sikker på at du vil fjerne lenken til denne kontakten?";
const Addedbyyou$8 = "Lagt til av deg";
const Addedby$8 = "Lagt til av";
const Timeline$8 = "Tidslinje";
const Timelineempty$8 = "Tidslinje tom";
const Discard$8 = "Forkast";
const SaveContact$8 = "Lagre kontakt";
const Recruiter$8 = "Rekrutterer";
const Candidate$8 = "Kandidat";
const Colleague$8 = "Kollega";
const Employee$8 = "Ansatt";
const EnterValidEmail$8 = "Skriv inn gyldig e-post";
const EnterValidPhoneNumber$8 = "Skriv inn gyldig telefonnummer";
const editingProfileNotAvailable$8 = "Redigering av profilbilde er ikke tilgjengelig ennå.";
const itWillBeSoonAvailable$8 = "Det vil snart være tilgjengelig på vår.";
const ChromeExtension$8 = "Chrome-utvidelse";
const SelectTag$8 = "Velg tagg";
const FirstName$8 = "Fornavn";
const FirstNameisrequired$8 = "Fornavn er påkrevd";
const LastName$8 = "Etternavn";
const LastNameisrequired$8 = "Etternavn er påkrevd";
const Companyisrequired$8 = "Selskapet er påkrevd";
const Email$8 = "E-post";
const ThisisnotavalidEmail$8 = "Dette er ikke en gyldig e-postadresse.";
const AddEmail$8 = "Legg til e-post";
const PhoneNumber$8 = "Telefonnummer";
const notaValidPhone$8 = "Dette er ikke et gyldig telefonnummer. Skriv inn kun nummer.";
const phoneNoMinimum5char$8 = "Telefonnummeret må være minst 5 tegn.";
const phoneNoMinumum15char$8 = "Telefonnummeret må være maksimalt 15 tegn.";
const AddPhoneNumber$8 = "Legg til telefonnummer";
const SelectGoal$8 = "Velg mål";
const SelectStatus$8 = "Velg Status";
const Followup$8 = "Oppfølging";
const SocialMedia$8 = "Sosiale medier";
const Linkedinhandle$8 = "Linkedin-håndtak";
const Twitterhandle$8 = "Twitter-håndtak";
const Facebookhandle$8 = "Facebook-håndtak";
const Githubhandle$8 = "Github-håndtak";
const Gmailhandle$8 = "Gmail-håndtak";
const Changessavedsuccessfully$8 = "Endringer lagret";
const EditContact$8 = "Rediger kontakt";
const BasicInformation$8 = "Grunnleggende informasjon";
const EditContactDetails$8 = "Rediger kontaktinformasjon";
const SaveChanges$8 = "Lagre endringer";
const phoneNoMinimum14char$8 = "Telefonnummeret må være minst 14 tegn.";
const LinkedIn$8 = "LinkedIn";
const Twitter$8 = "Twitter";
const Facebook$8 = "Facebook";
const Github$8 = "Github";
const Gmail$8 = "Gmail";
const youCanWriteAbout$8 = "Du kan skrive om dine års erfaring, bransje eller ferdigheter. Folk snakker også om sine prestasjoner eller tidligere jobberfaringer.";
const Addednewsection$8 = "Lagt til ny seksjon";
const Removedsuccessfully$8 = "Fjernet vellykket";
const Remove$8 = "Fjern";
const Institute$8 = "Institutt";
const Schoolisrequired$8 = "Skole er påkrevd";
const Degree$8 = "Grad";
const StartMonth$8 = "Startmåned";
const StartYear$8 = "Startår";
const EndMonth$8 = "Slutten av måneden";
const EndYear$8 = "Slutten av året";
const Addmore$8 = "Legg til flere";
const PositionTitle$8 = "Stillingstittel";
const ExperienceType$8 = "Erfaringstype";
const Addednewitem$8 = "Lagt til nytt element";
const whatSkillsDoYouEnjoy$8 = "Hvilke ferdigheter har du eller liker du å jobbe med?";
const Typeskillshere$8 = "Skriv ferdigheter her";
const LinkedContacts$8 = "Lenkede kontakter";
const LinkContact$8 = "Lenk kontakt";
const NocontactsLinked$8 = "Ingen lenkede kontakter";
const JobContactsComponent$8 = {
	linkContact: "Ved å lenke kontakter kan du raskt se hvem de viktige personene som rekrutterer, ansettelsesansvarlig, etc., er for denne rollen! I fremtiden vil vi kunne presentere relevante innsikter basert på kontaktene dine."
};
const Nocontacts$8 = "Ingen kontakter";
const LinkJobto$8 = "Koble jobb til";
const Contact$8 = "Kontakt";
const Document$8 = "Dokument";
const Nojobsfound$8 = "Ingen jobber funnet";
const LinkJob$8 = "Lenk jobb";
const youCanLinkContactJobImported$8 = "Du kan knytte denne kontakten til en jobb du har importert til Careerflow.";
const Prev$8 = "Prev";
const Next$8 = "Neste";
const areYouSureUnlinkDocument$8 = "Er du sikker på at du vil fjerne lenken til dette dokumentet?";
const areYouSureDeleteDocument$8 = "Er du sikker på at du vil slette dette dokumentet?";
const Category$8 = "Kategori";
const CreatedOn$8 = "Opprettet den";
const Joblinked$8 = "Jobb koblet";
const Quickactions$8 = "Raske handlinger";
const All$8 = "Alle";
const Resume$8 = "CV";
const Portfolio$8 = "Portefølje";
const Other$8 = "Annet";
const Adddocument$8 = "Legg til dokument";
const Type$8 = "Type";
const Sortingby$8 = "Sortering etter";
const SwitchtoGridLayout$8 = "Bytt til rutenettlayout";
const SwitchtoListLayout$8 = "Bytt til listeoppsett";
const NoDocumentsAdded$8 = "Ingen dokumenter lagt til";
const DocumentsComponent$8 = {
	nodocs: "Du har ikke opprettet noen dokumenter ennå. Du kan laste opp CV-versjoner, søknadsbrev og mer, og knytte dem til jobber du følger!"
};
const NoDocumentFound$8 = "Ingen dokument funnet.";
const SelectFile$8 = "Velg fil";
const onlyPdfDocxSupported$8 = "Bare .pdf og .docx støttet.";
const Uploadfile$8 = "Last opp fil";
const DocumentCategory$8 = "Dokumentkategori";
const SaveDocument$8 = "Lagre dokument";
const AddDocument$8 = "Legg til dokument";
const LinkedDocuments$8 = "Lenkede dokumenter";
const LinkDocument$8 = "Lenk dokument";
const NodocumentsLinked$8 = "Ingen lenkede dokumenter";
const JobDocumentsComponent$8 = {
	linkDocs: "Ved å lenke alle relevante dokumenter som CV, søknadsbrev, etc. som du har sendt inn for denne jobben, vil du kunne holde oversikt over alt på ett sted. Prøv det ut!"
};
const NoDocuments$8 = "Ingen dokumenter";
const CreateDocuments$8 = "Opprett dokumenter";
const youCanLinkDocumentJobImported$8 = "Du kan lenke dette dokumentet til en jobb du har importert til Careerflow.";
const Documenteditedsuccessfully$8 = "Dokumentet ble redigert vellykket";
const DocumentDetails$8 = "Dokumentdetaljer";
const UnsavedChanges$8 = "Ulagrede endringer";
const yourChangesWillBeLostSureClose$8 = "Endringene dine vil gå tapt, er du sikker på at du vil lukke?";
const yourChangesWillBeLostSureDiscard$8 = "Endringene dine vil gå tapt, er du sikker på at du vil forkaste endringene dine?";
const DiscardChanges$8 = "Forkast endringer";
const WeeklyGoalAlert$8 = "Ukentlig målvarsel";
const Progress$8 = "Framgang";
const AllGoals$8 = "Alle mål";
const Name$8 = "Navn";
const Completedon$8 = "Fullført den";
const Createdon$8 = "Opprettet den";
const Action$8 = "Handling";
const Back$8 = "Tilbake";
const OverallScore$8 = "Total poengsum";
const Aboutthegoal$8 = "Om målet";
const GoalTracking$8 = "Målsporing";
const Week$8 = "Uke";
const progress$8 = "fremgang";
const loading$8 = "Laster";
const Apply$8 = "Søk";
const Thisskillhasbeenreported$8 = "Denne ferdigheten er rapportert.";
const issueGettingResume$8 = "Det var et problem med å få tak i CV-en.";
const Interview$8 = "Intervju";
const Tasks$8 = "Oppgaver";
const Loading$8 = "Laster";
const Skilladdedsuccessfully$8 = "Ferdighet lagt til vellykket";
const problemAddingSkill$8 = "Det var et problem med å legge til ferdighet.";
const Reportaproblem$8 = "Rapporter et problem";
const Submit$8 = "Send inn";
const Addanewskill$8 = "Legg til ny ferdighet";
const JobDetailsComponent$8 = {
	classifySkill: "Hvordan vil du klassifisere denne ferdigheten (valgfritt)?",
	includedKeywordsWillCount: "Inkludere dette nøkkelordet?",
	yesIncludeThisSkill: "Inkluderte nøkkelord vil telle mot din match-score for alle fremtidige skanninger. Du kan endre inkluderte nøkkelord fra din profil.",
	addSkill: "Vil du legge dette til som en ferdighet?"
};
const HardSkill$8 = "Hard ferdighet";
const SoftSkill$8 = "Myk ferdighet";
const Pleaseshareanyadditionalcontext$8 = "Vennligst del eventuell ekstra kontekst";
const Addasskill$8 = "Legg til som ferdighet";
const Skill$8 = "Ferdighet";
const JobFrequency$8 = "Jobbfrekvens";
const ResumeFrequency$8 = "CV-frekvens";
const Reportskill$8 = "Rapporter ferdighet";
const JobDetails$8 = "Jobbdetaljer";
const ViewJobLink$8 = "Se jobb lenke";
const Salary$8 = "Lønn";
const areYouSureDeleteJob$8 = "Er du sikker på at du vil slette denne jobben?";
const ViewMore$8 = "Vis mer";
const ViewLess$8 = "Vis mindre";
const matchYouSkillsAgainstJob$8 = "Match dine ferdigheter mot jobbeskrivelsen.";
const pleaseUploadResumeSkillMatch$8 = "Vennligst last opp din CV for å få din ferdighetsmatchscore.";
const AddResume$8 = "Legg til CV";
const thisJobDoesNotHaveAnyDesc$8 = "Denne jobben har ingen beskrivelse.";
const youCanEditJobToAdd$8 = "Du kan redigere denne jobben for å legge til en beskrivelse. Du kan også importere jobber ved hjelp av vår.";
const chromeextension$8 = "Chrome-utvidelse";
const fromVariousJobPortalsOnce$8 = "fra ulike jobbportaler. Når du legger til en beskrivelse, vil du også kunne se informasjon om ferdigheter.";
const AddDescription$8 = "Legg til beskrivelse.";
const CompanyInfo$8 = "Firmaopplysninger";
const Website$8 = "Nettsted";
const Industry$8 = "Industri";
const EmployeeCount$8 = "Antall ansatte";
const ExprienceLevel$8 = "Erfaringsnivå";
const Address$8 = "Adresse";
const Resumes$8 = "CV-er";
const Setasdefault$8 = "Sett som standard";
const Ok$8 = "Ok";
const UploadNewResume$8 = "Last opp ny CV";
const Default$8 = "Standard";
const Jobnotfound$8 = "Jobb ikke funnet.";
const EditDetails$8 = "Rediger detaljer";
const JobPostURL$8 = "Jobbannonsens URL";
const Enterjoburl$8 = "Skriv inn jobb-URL";
const Nojobselected$8 = "Ingen jobb valgt.";
const Viewjobdetails$8 = "Vis jobbdetaljer";
const Jobaddedtoyourboardsuccessfully$8 = "Jobben ble lagt til på tavlen din vellykket.";
const AddJob$8 = "Legg til jobb";
const Addnewjobname$8 = "Legg til ny jobbtittel";
const JobUrl$8 = "Jobb-URL";
const Addjoburl$8 = "Legg til jobb-URL";
const Section$8 = "Seksjon";
const didYouKnow$8 = {
	chromeExtension: "Visste du det? Du kan også lagre jobber direkte fra vår Chrome-utvidelse og importere all data med ett klikk! Det tar bare noen få sekunder."
};
const Jobs$8 = "Jobber";
const AddJobtoboard$8 = "Legg til jobb på tavlen";
const Currentlynojobsareavailable$8 = "For øyeblikket er det ingen ledige jobber.";
const noMatchingJobs$8 = "Ingen matchende jobber funnet.";
const welcomeToYourPersonalJobTracker$8 = "Velkommen til din personlige jobbtracker!";
const weShortTutorialOnHowTrackingJob$8 = "Vi vil ta deg gjennom en kort opplæring om hvordan du kan begynne å spore jobbsøknadene dine på noen få enkle trinn!";
const Addanewjob$8 = "Legg til en ny jobb.";
const inOrderTrackCreatButton$8 = "For å begynne å spore jobbsøknader, må du først legge den til på tavlen ved å klikke på \"Opprett\" -knappen.";
const Providesomedetails$8 = "Gi noen detaljer.";
const toBeginTypeJobTitleCompany$8 = "For å begynne, skriv bare inn stillingstittelen, selskapsnavnet og statusen du vil legge den til. Du kan legge til flere detaljer senere, men dette er alt du trenger for nå!";
const asAnExampleFilledForYou$8 = "Som et eksempel har vi allerede fylt dette ut for deg!";
const wohooAddedFirstJob$8 = "Jippi! Du la til din første jobb i jobbtrackeren din!";
const youCanDragDropJobCard$8 = "Du kan nå dra og slippe jobbkortet inn i de ulike stadiene av jobbsøknadsprosessen. Ved å klikke på jobbkortet kan du se mer detaljer, redigere dem, lagre notater og mer!";
const Lastbutnotleast$8 = "Til slutt, men ikke minst.";
const finalStepMakeSure$8 = "Som en siste trinn, sørg for at du har vår.";
const autoMaticallyImportJobs$8 = "Dette vil tillate deg å automatisk importere jobber fra dine favoritt jobbsøk-nettsteder som LinkedIn, Indeed og mer! Vår utvidelse hjelper deg også med å forbedre din LinkedIn-profil og få 2,5 ganger flere søkevisninger!";
const selectanysection$8 = "velg hvilken som helst seksjon";
const Accept$8 = "Aksepter";
const My2023JobSearch$8 = "Min jobbsøk i 2023";
const AddedFrom$8 = "Lagt til fra";
const AddedUntil$8 = "Lagt til inntil";
const BasicModal$8 = "Grunnleggende modal";
const AddnewSectionName$8 = "Legg til ny seksjonsnavn";
const OpenTo$8 = "Åpen for";
const Featured$8 = "Utvalgt";
const LicenceAndCerts$8 = "Lisenser og sertifikater";
const Banner$8 = "Banner";
const LinkedInURL$8 = "LinkedIn URL";
const Recommendations$8 = "Anbefalinger";
const LinkedinReview$8 = "Linkedin-anmeldelse";
const NoDataAvailable$8 = "Ingen data tilgjengelig.";
const looksLikeYouDidNot$8 = "Ser ut som du ikke har begynt å bruke vår";
const toOptimizeProfileScoreVisible$8 = "å optimalisere din LinkedIn-profil ennå. Når du gjør det, vil profilpoengsummen din være synlig her.";
const LinkedinComponent$8 = {
	letsOptimize: "La oss optimalisere"
};
const improveYourChancesLandingDreamJob$8 = "Forbedre sjansene dine for å få drømmejobben din. Bruk disse utprøvde strategiene for å gi LinkedIn-profilen din en sårt tiltrengt oppgradering.";
const VisitProfile$8 = "Besøk profil";
const wantToGetLinkedinMakeover$8 = "Ønsker du en fullstendig LinkedIn-oppgradering?";
const PostGenerator$8 = "Innleggsgenerator";
const LinkedinHeadlineGenerator$8 = "LinkedIn Overskrift Generator";
const LinkedinAboutSectionGenerator$8 = "LinkedIn Om Seksjon Generator";
const AITools$8 = "AI-verktøy";
const Premium$8 = "Premium";
const LinkedInOptimization$8 = "Optimalisering av LinkedIn";
const JobTracker$8 = "Jobb-sporer";
const whoIsHiring$8 = "Som søker etter ansatte";
const Autofill$8 = "Autofyll";
const HeadlineGenerator$8 = "Overskriftsgenerator";
const skillMatching$8 = "Ferdighetsmatching";
const SummarizeJD$8 = "Sammendrag av stillingsbeskrivelse";
const contactFeature$8 = "Kontaktsporing";
const documentFeature$8 = "Dokumenter";
const landJobWithoutStress$8 = "Få drømmejobben din. Uten stress.";
const discoverFeatures$8 = "Oppdag utvalget av Careerflow.ai-funksjoner som er designet for å forenkle jobbsøket ditt og forbedre din profesjonelle reise!";
const letsBeginOnboarding$8 = "La oss bli bedre kjent med deg!";
const inTheNextFewScreensJobThirdParties$8 = "I de neste skjermene vil vi stille deg noen spørsmål som vil hjelpe oss med å tilpasse opplevelsen for deg og automatisk fylle ut jobbsøknadene dine (slik at du slipper å gjøre det selv)! Vi selger ikke dataene dine til tredjeparter.";
const letsAddBasicInformation$8 = "La oss legge til din grunnleggende informasjon.";
const Pleaseselectanoptionfirst$8 = "Vennligst velg et alternativ først.";
const JobApplicationTracker$8 = "Jobbsøknadssporer";
const LinkedInProfileOptimizer$8 = "Optimaliserer for LinkedIn-profil";
const UnlimitedDocuments$8 = "Ubegrensede dokumenter";
const UnlimitedContacts$8 = "Ubegrenset antall kontakter";
const HiringManagerSearch$8 = "Søk etter ansettelsesleder";
const AILinkedInPostGenerator$8 = "AI LinkedIn Innleggsgenerator";
const ATSKeywordSkillMatch$8 = "ATS nøkkelord / ferdighetsmatch jobb";
const ChooseyourPlan$8 = "Velg ditt plan";
const superChargeYourJobSearch$8 = "Gi jobbsøket ditt en boost og forbedre søknadsprosessen, øk antall intervjuer og få drømmejobben din. Alt med hjelp av Careerflow's premium verktøysett.";
const startNowGoto$8 = "Start nå (Gå til appen)";
const CreatedBy$8 = "Opprettet av";
const CreateNewNote$8 = "Opprett ny merknad";
const Nonotescreated$8 = "Ingen merknader opprettet";
const approxTimeIsFourMinutes$8 = "Omtrentlig tid for å fullføre onboarding-prosessen er 4 minutter.";
const Continue$8 = "Fortsett";
const iWillDoLaterTakeMeToApp$8 = "Jeg gjør dette senere. Ta meg til appen.";
const allDone$8 = "Alt ferdig!";
const welcomeAbord$8 = "Velkommen om bord!";
const letsBegin$8 = "La oss begynne.";
const UpgradeyourplanandgetAIAssistance$8 = "Oppgrader planen din og få AI-assistanse.";
const DownloadPDF$8 = "Last ned PDF";
const oopsWeCouldntProcessResume$8 = "Oops, vi kunne ikke behandle denne CV-en.";
const MyProfile$8 = "Min profil";
const Setting$8 = "Innstilling";
const Logout$8 = "Logg ut";
const SignIn$8 = "Logg inn";
const Typeyourfirstnamehere$8 = "Ditt Fornavn";
const Enteryourlastname$8 = "Ditt etternavn";
const ManageSubscription$8 = "Administrer abonnement";
const ifYouHaveDifficultiesProfile$8 = "Hvis du har noen problemer med din profilinformasjon, vennligst ta kontakt med";
const forSupport$8 = "for støtte.";
const whatIsIdealCompanySize$8 = "Hva er din ideelle bedriftsstørrelse?";
const Saveandcontinue$8 = "Lagre og fortsett";
const whatIsMinExpectedSalary$8 = "Hva er din forventede minimumslønn (per år)?";
const Atleast$8 = "I det minste";
const SlidetoAdjust$8 = "Skyv for å justere";
const whatIndustryExcitedWork$8 = "Hvilke bransjer er spennende for deg?";
const Add$8 = "Legg til";
const statusOfJobSearch$8 = "Status på jobbsøket ditt?";
const Finish$8 = "Ferdig";
const whatLevelRoleLooking$8 = "Hvilket nivå av rolle ser du etter?";
const Selectuptotwo$8 = "Velg opptil to";
const PreviousStep$8 = "Forrige trinn";
const Skip$8 = "Skip";
const whatDoYouValueNewRole$8 = "Hva verdsetter du i en ny rolle?";
const Selectuptothree$8 = "Velg opptil tre";
const EqualEmploymentData$8 = "Likestillingsdata for sysselsetting";
const whatIsYourEthnicity$8 = "Hva er din etnisitet?";
const areYouAuthorizedToWorkUs$8 = "Er du autorisert til å jobbe i USA?";
const willYouRequireSponsorShip$8 = "Vil du nå eller i fremtiden trenge sponsing for arbeidsvisumstatus?";
const doYouHaveADisability$8 = "Har du en funksjonshemming?";
const areYouAVeteran$8 = "Er du en veteran?";
const rolesYouInterestedIn$8 = "Hvilke typer roller er du interessert i?";
const Selectuptofive$8 = "Velg opptil fem.";
const AddCustomrole$8 = "Legg til tilpasset rolle";
const whereDoYouLikeWork$8 = "Hvor vil du jobbe?";
const Resources$8 = "Ressurser";
const currentlyNoResourceAvailable$8 = "For øyeblikket er det ingen tilgjengelige ressurser.";
const AddNewSection$8 = "Legg til ny seksjon";
const ChangeSections$8 = "Endre seksjoner";
const Settings$8 = "Innstillinger";
const Dashboard$8 = "Instrumentbord";
const JobBoard$8 = "Jobbtavle";
const Linkedin$8 = "Linkedin";
const Community$8 = "Fellesskap";
const FindRecruiters$8 = "Finn rekrutterere";
const Goals$8 = "Mål";
const DownloadExtension$8 = "Last ned utvidelse";
const SuggestaFeature$8 = "Foreslå en funksjon";
const leftPanel$8 = {
	ReportanIssue: "Rapporter et problem"
};
const PhoneNumberisrequired$8 = "Telefonnummer er påkrevd.";
const MobileNumber$8 = "Mobilnummer";
const Enteronlynumbers$8 = "Skriv kun inn tall";
const Countryyoulivein$8 = "Landet du bor i";
const SelectaCountry$8 = "Velg et land";
const DateofBirth$8 = "Fødselsdato";
const Gender$8 = "Kjønn";
const JobPreferences$8 = "Jobbpreferanser";
const pleaseEnterValidEmail$8 = "Vennligst skriv inn en gyldig e-postadresse.";
const emailSendForResetting$8 = "En e-post har blitt sendt til deg for å tilbakestille passordet.";
const VerifyyourEmailID$8 = "Bekreft din e-postadresse";
const sentPleaseCheckEmail$8 = "Sendt! Vennligst sjekk e-posten din.";
const tooManyAttemptsTryAgain$8 = "For mange forsøk, prøv igjen om en stund.";
const Resend$8 = "Send på nytt";
const Login$8 = "Innlogging";
const weHaveSentVerificationLinkAtEmail$8 = "Vi har sendt deg en verifiseringslenke til din e-post.";
const pleaseVerifyEmailContinueSpam$8 = "Vennligst bekreft e-posten din for å fortsette. Sjekk også søppelpost eller promotering for verifiserings-e-post.";
const Logintogetstarted$8 = "Logg inn for å komme i gang";
const ContinuewithGoogle$8 = "Fortsett med Google";
const pleaseInputEmail$8 = "Vennligst skriv inn din e-postadresse!";
const Password$8 = "Passord";
const pleaseInputPassword$8 = "Vennligst skriv inn passordet ditt!";
const passwordLowerUpperDigitSpecial$8 = "Ditt passord må inneholde minst én liten bokstav, én stor bokstav, ett tall og ett spesialtegn.";
const atLeastSixChar$8 = "Minst 6 tegn";
const forgotPassword$8 = "Glemt passord?";
const Bysigninginyouagreetoour$8 = "Ved å logge inn godtar du våre";
const Terms$8 = "Betingelser";
const Conditions$8 = "Betingelser";
const and$8 = "og";
const PrivacyPolicy$8 = "Personvernserklæring";
const theseAreTheTopsSkillsExtracted$8 = "Dette er de viktigste ferdighetene som er utledet fra jobbeskrivelsen.";
const TopSkills$8 = "Toppferdigheter";
const weCoulNotExtractSkills$8 = "Vi kunne ikke finne noen ferdigheter i denne jobbeskrivelsen.";
const upgradeToPremiumToView$8 = "Oppgrader til Premium for å se din matchscore for ferdigheter i CV-en din.";
const SkillScore$8 = "Ferdighetspoeng";
const thisIsYourSkillScoreBasedOn$8 = "Dette er din ferdighetspoengsum basert på jobbeskrivelsen og CV-en din.";
const theseSkllsAreStrongMatch$8 = "Disse ferdighetene er en sterk match mellom din CV og jobbeskrivelsen.";
const Strongmatch$8 = "Sterk match";
const theseSkillsArePartialMatch$8 = "Disse ferdighetene er en delvis match mellom CV-en din og jobbeskrivelsen.";
const Partialmatch$8 = "Delvis treff";
const theseSkillsAreMissingFrom$8 = "Disse nøkkelordene mangler i CV-en din, men er til stede i jobbeskrivelsen. De kan være ferdigheter eller generelle nøkkelord som er spesifikke for jobbmuligheten og kan være nyttige å legge til i CV-en din.";
const SkillMatchComponent$8 = {
	removeSkill: "Hva er hovedårsaken til at du rapporterer et problem med nøkkelordet"
};
const Optional$8 = "Valgfritt";
const Notrelevanttothejob$8 = "Ikke relevant for jobben";
const Notaskill$8 = "Ingen ferdighet";
const Toogeneric$8 = "For generisk";
const Pleaseshareanyfeedback$8 = "Vennligst del eventuelle tilbakemeldinger";
const excludedKeywordsWillNot$8 = "Ekskluderte nøkkelord vil ikke telle mot din match score for alle fremtidige skanninger. Du kan endre ekskluderte nøkkelord fra din profil.";
const yesExcludeThisSkillFrom$8 = "Ja, ekskluder denne ferdigheten fra alle mine CV-skanninger.";
const PartialMatch$8 = "Delvis match";
const MissingKeywords$8 = "Manglende nøkkelord";
const Providetitletotask$8 = "Gi tittel til oppgave";
const TasksList$8 = "Oppgaveliste";
const AddTask$8 = "Legg til oppgave";
const EnterTaskTitlehere$8 = "Skriv inn oppgavetittel her";
const TasksComponent$8 = {
	listEmpty: "Oppgavelisten er tom. Opprett ny."
};
const CompletedTasks$8 = "Fullførte oppgaver";
const CompleteYourtasks$8 = "Fullfør dine oppgaver";
const Steps$8 = "Trinn";
const PremiumMember$8 = "Premiummedlem";
const Thankyouforupgradingto$8 = "Takk for oppgraderingen til";
const CareerflowPremium$8 = "Karriereflyt Premium";
const hereIsHowYouCanAccessPremium$8 = "Her er hvordan du får tilgang til dine Premium-fordeler!";
const stepOne$8 = "Trinn 1";
const DownloadourChromeExtension$8 = "Last ned vår Chrome-utvidelse.";
const youJobSearchCopilotIshere$8 = "Din jobbsøkings AI-kopilot er her.";
const DownloadNow$8 = "Last ned nå";
const stepTwo$8 = "Trinn 2";
const GetStarted$8 = "Kom i gang";
const stepThree$8 = "Trinn 3";
const SignintoChromeExtension$8 = "Logg inn på Chrome-utvidelsen.";
const entityCreated$8 = "Ny {{entity}} opprettet.";
const entityUpdated$8 = "{{entity}} oppdatert";
const entityDeleted$8 = "{{entity}} slettet";
const entityLinked$8 = "{{entity}} lenket";
const entityUnlinked$8 = "{{entity}} frakoblet";
const entityMovedTo$8 = "Flyttet til {{entity}}";
const youAddedANewEntity$8 = "Du la til en ny {{entity}}";
const personCreated$8 = "{{creator}} skapte en {{entity}} for {{owner}}.";
const youUpdatedAEntity$8 = "Du oppdaterte en {{entity}}";
const personUpdated$8 = "{{creator}} oppdaterte en {{entity}} for {{owner}}.";
const youDeletedAEntity$8 = "Du slettet en {{entity}}.";
const personDeleted$8 = "{{creator}} slettet en {{entity}} for {{owner}}";
const youLinkedEntity$8 = "Du har koblet en {{entity}} til denne jobben.";
const personLinked$8 = "{{creator}} lenket en {{entity}} til denne jobben for {{owner}}.";
const youUnlinked$8 = "Du har fjernet koblingen til {{entity}} fra denne jobben.";
const personUnlinked$8 = "{{creator}} har fjernet koblingen til en {{entity}} fra denne jobben for {{owner}}.";
const youMovedEntity$8 = "Du flyttet denne {{entity}} fra {{sectionFrom}} til {{sectionTo}}";
const personMoved$8 = "{{creator}} flyttet denne {{entity}} fra {{sectionFrom}} til {{sectionTo}} for {{owner}}.";
const addedByName$8 = "Lagt til av {{name}}";
const DownloadChromeExtension$8 = "Last ned Chrome-utvidelse";
const ourChromeExtensionIs$8 = "Vår Chrome-utvidelse er et integrert verktøy som hjelper deg med å optimalisere LinkedIn-profilen din, lagre jobber, lagre kontakter, generere søknadsbrev og mer.";
const Optimizeyourprofile$8 = "Optimaliser profilen din.";
const startOptimizingYourProfile$8 = "Begynn å optimalisere profilen din for å øke sjansene dine for å bli kontaktet av rekrutterere.";
const OptimizeNow$8 = "Optimaliser nå";
const Addyourfirstjob$8 = "Legg til din første jobb";
const startSavingJobApplicationsToTrack$8 = "Begynn å lagre jobbsøknader for å følge jobbsøkeprosessen din og finne nyttige innsikter.";
const AddNow$8 = "Legg til nå";
const CompleteProfile$8 = "Fullstendig profil";
const completeYourProfileForUsing$8 = "Fullfør profilen din for å bruke autofyll-funksjonen og få en mer personlig opplevelse.";
const CompleteNow$8 = "Ferdig nå";
const Addyourfirstcontact$8 = "Legg til din første kontakt.";
const addContactToFollowUpWith$8 = "Legg til kontakt for å følge opp med dem senere, legg til notater og mer.";
const JoinCommunity$8 = "Bli med i fellesskapet";
const ourCommunityisAlways$8 = "Vårt fellesskap er alltid der med deg på din jobbsøke-reise.";
const JoinNow$8 = "Bli med nå";
const welcomeToCareerflow$8 = "Velkommen til Careerflow!";
const yourHubForCareerInsights2$8 = "Dette er din sentrale plass for karriereinnsikt, aktiviteter og mer. Utforsk din personlige oversikt for å holde deg oppdatert på din profesjonelle reise.";
const ChecklistCompleted$8 = "Sjekklisten din er fullført!";
const Completeyourchecklist$8 = "Fullfør sjekklisten din.";
const completeAFewStepsTo$8 = "Fullfør noen trinn for å lande din neste jobb.";
const Completed$8 = "Fullført";
const JobCountByStage$8 = "Antall jobber etter stadie";
const NopastapplicationDatafound$8 = "Ingen tidligere søknadsdata funnet.";
const YourJobSearchStages$8 = "Dine jobbsøkingsfaser";
const NoDatafound$8 = "Ingen data funnet.";
const no = {
	copyToClipboard: copyToClipboard$8,
	UnlocktheAIgenerated: UnlocktheAIgenerated$8,
	UpgradetoPremium: UpgradetoPremium$8,
	Result: Result$8,
	Copy: Copy$8,
	Save: Save$8,
	Edit: Edit$8,
	Processing: Processing$8,
	YourAIgeneratedcontentwillshowhere: YourAIgeneratedcontentwillshowhere$8,
	hopeYouFindUseful: hopeYouFindUseful$8,
	regenerate: regenerate$8,
	ProvideAdditionalFeedback: ProvideAdditionalFeedback$8,
	Enteranyfeedback: Enteranyfeedback$8,
	Notimpressive: Notimpressive$8,
	thisIsntTrue: thisIsntTrue$8,
	Notpersonalized: Notpersonalized$8,
	Tone: Tone$8,
	Length: Length$8,
	Template: Template$8,
	Generatedon: Generatedon$8,
	Copiedtoclipboard: Copiedtoclipboard$8,
	CopytoClipboard: CopytoClipboard$8,
	DownloadasPDF: DownloadasPDF$8,
	ViewDetails: ViewDetails$8,
	JobDescriptionImported: JobDescriptionImported$8,
	ImportfromJob: ImportfromJob$8,
	Saved: Saved$8,
	Applied: Applied$8,
	Offer: Offer$8,
	Interviewing: Interviewing$8,
	Rejected: Rejected$8,
	Search: Search$8,
	Import: Import$8,
	CoverLetterGeneratorHistory: CoverLetterGeneratorHistory$8,
	NoCoverLettersGenerated: NoCoverLettersGenerated$8,
	getStartedCoverLetter: getStartedCoverLetter$8,
	getStarted: getStarted$8,
	Documents: Documents$8,
	UploadNewDocument: UploadNewDocument$8,
	AICoverLetterGenerator: AICoverLetterGenerator$8,
	ViewHistory: ViewHistory$8,
	JobDescription: JobDescription$8,
	ImportfromBoard: ImportfromBoard$8,
	EnterJobDescription: EnterJobDescription$8,
	JobTitle: JobTitle$8,
	EnterJobTitle: EnterJobTitle$8,
	CompanyName: CompanyName$8,
	EnterCompanyName: EnterCompanyName$8,
	YourProfile: YourProfile$8,
	ResumeUpload: ResumeUpload$8,
	UseLinkedinProfile: UseLinkedinProfile$8,
	Uploadyourresume: Uploadyourresume$8,
	AddyourResume: AddyourResume$8,
	fileNameCannotFormat: fileNameCannotFormat$8,
	ChooseorUpload: ChooseorUpload$8,
	SelectTemplate: SelectTemplate$8,
	Preview: Preview$8,
	UseTemplate: UseTemplate$8,
	Change: Change$8,
	AdvancedSettings: AdvancedSettings$8,
	AdditionalContext: AdditionalContext$8,
	Professional: Professional$8,
	Casual: Casual$8,
	Enthusiastic: Enthusiastic$8,
	Informational: Informational$8,
	Short: Short$8,
	Medium: Medium$8,
	Long: Long$8,
	Language: Language$8,
	iAmOkayBack: iAmOkayBack$8,
	Generate: Generate$8,
	CoverLetter: CoverLetter$8,
	SelectLanguage: SelectLanguage$8,
	AboutGeneratorHistory: AboutGeneratorHistory$8,
	NoAboutsGenerated: NoAboutsGenerated$8,
	getStartedAbouts: getStartedAbouts$8,
	noAttachmentsFound: noAttachmentsFound$8,
	TargetJobTitle: TargetJobTitle$8,
	KeywordsToInclude: KeywordsToInclude$8,
	UploadYourResume: UploadYourResume$8,
	AddYourResume: AddYourResume$8,
	LinkedinProfile: LinkedinProfile$8,
	Linkedinprofilenotfound: Linkedinprofilenotfound$8,
	startUsingChromeExtension: startUsingChromeExtension$8,
	Download: Download$8,
	UseEmojis: UseEmojis$8,
	UseBulletPoints: UseBulletPoints$8,
	SpeechFocus: SpeechFocus$8,
	FirstPerson: FirstPerson$8,
	ThirdPerson: ThirdPerson$8,
	HeadlineGeneratorHistory: HeadlineGeneratorHistory$8,
	NoHeadlinesGenerated: NoHeadlinesGenerated$8,
	getStartedHeadline: getStartedHeadline$8,
	AIHeadlineGenerator: AIHeadlineGenerator$8,
	KeywordstoInclude: KeywordstoInclude$8,
	Pressenteraftereachword: Pressenteraftereachword$8,
	LinkedinProfilenotfound: LinkedinProfilenotfound$8,
	Headline: Headline$8,
	PostGeneratorHistory: PostGeneratorHistory$8,
	NoPostsGenerated: NoPostsGenerated$8,
	getStartedPost: getStartedPost$8,
	Topic: Topic$8,
	Description: Description$8,
	UseHashtags: UseHashtags$8,
	Custom: Custom$8,
	EnterCustomTone: EnterCustomTone$8,
	Added: Added$8,
	ComingSoon: ComingSoon$8,
	Company: Company$8,
	JobInterview: JobInterview$8,
	Research: Research$8,
	Networking: Networking$8,
	Referral: Referral$8,
	MustbeContacted: MustbeContacted$8,
	ScheduleaMeeting: ScheduleaMeeting$8,
	needAFollowUp: needAFollowUp$8,
	Today: Today$8,
	Viewdetails: Viewdetails$8,
	Activity: Activity$8,
	ActivityDetails: ActivityDetails$8,
	Delete: Delete$8,
	Title: Title$8,
	Goal: Goal$8,
	Status: Status$8,
	FollowUp: FollowUp$8,
	AddActivity: AddActivity$8,
	Enteractivitytitle: Enteractivitytitle$8,
	Cancel: Cancel$8,
	SaveActivity: SaveActivity$8,
	noActivityPresent: noActivityPresent$8,
	Addnew: Addnew$8,
	About: About$8,
	noDataPresentYou: noDataPresentYou$8,
	Experience: Experience$8,
	Education: Education$8,
	Skills: Skills$8,
	Overview: Overview$8,
	LinkedJobs: LinkedJobs$8,
	Notes: Notes$8,
	FullName: FullName$8,
	Location: Location$8,
	Relationship: Relationship$8,
	Contacts: Contacts$8,
	CreateContact: CreateContact$8,
	NotesCreated: NotesCreated$8,
	Notesupdated: Notesupdated$8,
	Addnote: Addnote$8,
	areYouSureDeleteNote: areYouSureDeleteNote$8,
	Createdby: Createdby$8,
	notSureWhyResumeCalls: notSureWhyResumeCalls$8,
	getExpertResumeReview: getExpertResumeReview$8,
	youHaventAddedContacts: youHaventAddedContacts$8,
	noMatchingContacts: noMatchingContacts$8,
	Link: Link$8,
	unlink: unlink$8,
	Locationnotavailable: Locationnotavailable$8,
	Emailnotavailable: Emailnotavailable$8,
	PhoneNumbernotavailable: PhoneNumbernotavailable$8,
	createdby: createdby$8,
	areYouSureDeleteContact: areYouSureDeleteContact$8,
	areYouSureUnlinkContact: areYouSureUnlinkContact$8,
	Addedbyyou: Addedbyyou$8,
	Addedby: Addedby$8,
	Timeline: Timeline$8,
	Timelineempty: Timelineempty$8,
	Discard: Discard$8,
	SaveContact: SaveContact$8,
	Recruiter: Recruiter$8,
	Candidate: Candidate$8,
	Colleague: Colleague$8,
	Employee: Employee$8,
	"Needtofollow-up": "Må følge opp",
	EnterValidEmail: EnterValidEmail$8,
	EnterValidPhoneNumber: EnterValidPhoneNumber$8,
	editingProfileNotAvailable: editingProfileNotAvailable$8,
	itWillBeSoonAvailable: itWillBeSoonAvailable$8,
	ChromeExtension: ChromeExtension$8,
	SelectTag: SelectTag$8,
	FirstName: FirstName$8,
	FirstNameisrequired: FirstNameisrequired$8,
	LastName: LastName$8,
	LastNameisrequired: LastNameisrequired$8,
	Companyisrequired: Companyisrequired$8,
	Email: Email$8,
	ThisisnotavalidEmail: ThisisnotavalidEmail$8,
	AddEmail: AddEmail$8,
	PhoneNumber: PhoneNumber$8,
	notaValidPhone: notaValidPhone$8,
	phoneNoMinimum5char: phoneNoMinimum5char$8,
	phoneNoMinumum15char: phoneNoMinumum15char$8,
	AddPhoneNumber: AddPhoneNumber$8,
	SelectGoal: SelectGoal$8,
	SelectStatus: SelectStatus$8,
	Followup: Followup$8,
	SocialMedia: SocialMedia$8,
	Linkedinhandle: Linkedinhandle$8,
	Twitterhandle: Twitterhandle$8,
	Facebookhandle: Facebookhandle$8,
	Githubhandle: Githubhandle$8,
	Gmailhandle: Gmailhandle$8,
	Changessavedsuccessfully: Changessavedsuccessfully$8,
	EditContact: EditContact$8,
	BasicInformation: BasicInformation$8,
	EditContactDetails: EditContactDetails$8,
	SaveChanges: SaveChanges$8,
	phoneNoMinimum14char: phoneNoMinimum14char$8,
	LinkedIn: LinkedIn$8,
	Twitter: Twitter$8,
	Facebook: Facebook$8,
	Github: Github$8,
	Gmail: Gmail$8,
	youCanWriteAbout: youCanWriteAbout$8,
	Addednewsection: Addednewsection$8,
	Removedsuccessfully: Removedsuccessfully$8,
	Remove: Remove$8,
	Institute: Institute$8,
	Schoolisrequired: Schoolisrequired$8,
	Degree: Degree$8,
	StartMonth: StartMonth$8,
	StartYear: StartYear$8,
	EndMonth: EndMonth$8,
	EndYear: EndYear$8,
	Addmore: Addmore$8,
	PositionTitle: PositionTitle$8,
	ExperienceType: ExperienceType$8,
	Addednewitem: Addednewitem$8,
	whatSkillsDoYouEnjoy: whatSkillsDoYouEnjoy$8,
	Typeskillshere: Typeskillshere$8,
	LinkedContacts: LinkedContacts$8,
	LinkContact: LinkContact$8,
	NocontactsLinked: NocontactsLinked$8,
	JobContactsComponent: JobContactsComponent$8,
	Nocontacts: Nocontacts$8,
	LinkJobto: LinkJobto$8,
	Contact: Contact$8,
	Document: Document$8,
	Nojobsfound: Nojobsfound$8,
	LinkJob: LinkJob$8,
	youCanLinkContactJobImported: youCanLinkContactJobImported$8,
	Prev: Prev$8,
	Next: Next$8,
	areYouSureUnlinkDocument: areYouSureUnlinkDocument$8,
	areYouSureDeleteDocument: areYouSureDeleteDocument$8,
	Category: Category$8,
	CreatedOn: CreatedOn$8,
	Joblinked: Joblinked$8,
	Quickactions: Quickactions$8,
	All: All$8,
	Resume: Resume$8,
	Portfolio: Portfolio$8,
	Other: Other$8,
	Adddocument: Adddocument$8,
	Type: Type$8,
	Sortingby: Sortingby$8,
	SwitchtoGridLayout: SwitchtoGridLayout$8,
	SwitchtoListLayout: SwitchtoListLayout$8,
	NoDocumentsAdded: NoDocumentsAdded$8,
	DocumentsComponent: DocumentsComponent$8,
	NoDocumentFound: NoDocumentFound$8,
	SelectFile: SelectFile$8,
	onlyPdfDocxSupported: onlyPdfDocxSupported$8,
	Uploadfile: Uploadfile$8,
	DocumentCategory: DocumentCategory$8,
	SaveDocument: SaveDocument$8,
	AddDocument: AddDocument$8,
	LinkedDocuments: LinkedDocuments$8,
	LinkDocument: LinkDocument$8,
	NodocumentsLinked: NodocumentsLinked$8,
	JobDocumentsComponent: JobDocumentsComponent$8,
	NoDocuments: NoDocuments$8,
	CreateDocuments: CreateDocuments$8,
	youCanLinkDocumentJobImported: youCanLinkDocumentJobImported$8,
	Documenteditedsuccessfully: Documenteditedsuccessfully$8,
	DocumentDetails: DocumentDetails$8,
	UnsavedChanges: UnsavedChanges$8,
	yourChangesWillBeLostSureClose: yourChangesWillBeLostSureClose$8,
	yourChangesWillBeLostSureDiscard: yourChangesWillBeLostSureDiscard$8,
	DiscardChanges: DiscardChanges$8,
	WeeklyGoalAlert: WeeklyGoalAlert$8,
	Progress: Progress$8,
	AllGoals: AllGoals$8,
	Name: Name$8,
	Completedon: Completedon$8,
	Createdon: Createdon$8,
	Action: Action$8,
	Back: Back$8,
	OverallScore: OverallScore$8,
	Aboutthegoal: Aboutthegoal$8,
	GoalTracking: GoalTracking$8,
	Week: Week$8,
	progress: progress$8,
	loading: loading$8,
	Apply: Apply$8,
	Thisskillhasbeenreported: Thisskillhasbeenreported$8,
	issueGettingResume: issueGettingResume$8,
	Interview: Interview$8,
	Tasks: Tasks$8,
	Loading: Loading$8,
	Skilladdedsuccessfully: Skilladdedsuccessfully$8,
	problemAddingSkill: problemAddingSkill$8,
	Reportaproblem: Reportaproblem$8,
	Submit: Submit$8,
	Addanewskill: Addanewskill$8,
	JobDetailsComponent: JobDetailsComponent$8,
	HardSkill: HardSkill$8,
	SoftSkill: SoftSkill$8,
	Pleaseshareanyadditionalcontext: Pleaseshareanyadditionalcontext$8,
	Addasskill: Addasskill$8,
	Skill: Skill$8,
	JobFrequency: JobFrequency$8,
	ResumeFrequency: ResumeFrequency$8,
	Reportskill: Reportskill$8,
	JobDetails: JobDetails$8,
	ViewJobLink: ViewJobLink$8,
	Salary: Salary$8,
	areYouSureDeleteJob: areYouSureDeleteJob$8,
	ViewMore: ViewMore$8,
	ViewLess: ViewLess$8,
	matchYouSkillsAgainstJob: matchYouSkillsAgainstJob$8,
	pleaseUploadResumeSkillMatch: pleaseUploadResumeSkillMatch$8,
	AddResume: AddResume$8,
	thisJobDoesNotHaveAnyDesc: thisJobDoesNotHaveAnyDesc$8,
	youCanEditJobToAdd: youCanEditJobToAdd$8,
	chromeextension: chromeextension$8,
	fromVariousJobPortalsOnce: fromVariousJobPortalsOnce$8,
	AddDescription: AddDescription$8,
	CompanyInfo: CompanyInfo$8,
	Website: Website$8,
	Industry: Industry$8,
	EmployeeCount: EmployeeCount$8,
	ExprienceLevel: ExprienceLevel$8,
	Address: Address$8,
	Resumes: Resumes$8,
	Setasdefault: Setasdefault$8,
	Ok: Ok$8,
	UploadNewResume: UploadNewResume$8,
	Default: Default$8,
	Jobnotfound: Jobnotfound$8,
	EditDetails: EditDetails$8,
	JobPostURL: JobPostURL$8,
	Enterjoburl: Enterjoburl$8,
	Nojobselected: Nojobselected$8,
	Viewjobdetails: Viewjobdetails$8,
	Jobaddedtoyourboardsuccessfully: Jobaddedtoyourboardsuccessfully$8,
	AddJob: AddJob$8,
	Addnewjobname: Addnewjobname$8,
	JobUrl: JobUrl$8,
	Addjoburl: Addjoburl$8,
	Section: Section$8,
	didYouKnow: didYouKnow$8,
	Jobs: Jobs$8,
	AddJobtoboard: AddJobtoboard$8,
	Currentlynojobsareavailable: Currentlynojobsareavailable$8,
	noMatchingJobs: noMatchingJobs$8,
	welcomeToYourPersonalJobTracker: welcomeToYourPersonalJobTracker$8,
	weShortTutorialOnHowTrackingJob: weShortTutorialOnHowTrackingJob$8,
	Addanewjob: Addanewjob$8,
	inOrderTrackCreatButton: inOrderTrackCreatButton$8,
	Providesomedetails: Providesomedetails$8,
	toBeginTypeJobTitleCompany: toBeginTypeJobTitleCompany$8,
	asAnExampleFilledForYou: asAnExampleFilledForYou$8,
	wohooAddedFirstJob: wohooAddedFirstJob$8,
	youCanDragDropJobCard: youCanDragDropJobCard$8,
	Lastbutnotleast: Lastbutnotleast$8,
	finalStepMakeSure: finalStepMakeSure$8,
	autoMaticallyImportJobs: autoMaticallyImportJobs$8,
	selectanysection: selectanysection$8,
	Accept: Accept$8,
	My2023JobSearch: My2023JobSearch$8,
	AddedFrom: AddedFrom$8,
	AddedUntil: AddedUntil$8,
	BasicModal: BasicModal$8,
	AddnewSectionName: AddnewSectionName$8,
	OpenTo: OpenTo$8,
	Featured: Featured$8,
	LicenceAndCerts: LicenceAndCerts$8,
	Banner: Banner$8,
	LinkedInURL: LinkedInURL$8,
	Recommendations: Recommendations$8,
	LinkedinReview: LinkedinReview$8,
	NoDataAvailable: NoDataAvailable$8,
	looksLikeYouDidNot: looksLikeYouDidNot$8,
	toOptimizeProfileScoreVisible: toOptimizeProfileScoreVisible$8,
	LinkedinComponent: LinkedinComponent$8,
	improveYourChancesLandingDreamJob: improveYourChancesLandingDreamJob$8,
	VisitProfile: VisitProfile$8,
	wantToGetLinkedinMakeover: wantToGetLinkedinMakeover$8,
	PostGenerator: PostGenerator$8,
	LinkedinHeadlineGenerator: LinkedinHeadlineGenerator$8,
	LinkedinAboutSectionGenerator: LinkedinAboutSectionGenerator$8,
	AITools: AITools$8,
	Premium: Premium$8,
	LinkedInOptimization: LinkedInOptimization$8,
	JobTracker: JobTracker$8,
	whoIsHiring: whoIsHiring$8,
	Autofill: Autofill$8,
	HeadlineGenerator: HeadlineGenerator$8,
	skillMatching: skillMatching$8,
	SummarizeJD: SummarizeJD$8,
	contactFeature: contactFeature$8,
	documentFeature: documentFeature$8,
	landJobWithoutStress: landJobWithoutStress$8,
	discoverFeatures: discoverFeatures$8,
	letsBeginOnboarding: letsBeginOnboarding$8,
	inTheNextFewScreensJobThirdParties: inTheNextFewScreensJobThirdParties$8,
	letsAddBasicInformation: letsAddBasicInformation$8,
	Pleaseselectanoptionfirst: Pleaseselectanoptionfirst$8,
	JobApplicationTracker: JobApplicationTracker$8,
	LinkedInProfileOptimizer: LinkedInProfileOptimizer$8,
	UnlimitedDocuments: UnlimitedDocuments$8,
	UnlimitedContacts: UnlimitedContacts$8,
	HiringManagerSearch: HiringManagerSearch$8,
	AILinkedInPostGenerator: AILinkedInPostGenerator$8,
	ATSKeywordSkillMatch: ATSKeywordSkillMatch$8,
	"Auto-Apply": "Auto-Apply",
	ChooseyourPlan: ChooseyourPlan$8,
	superChargeYourJobSearch: superChargeYourJobSearch$8,
	startNowGoto: startNowGoto$8,
	CreatedBy: CreatedBy$8,
	CreateNewNote: CreateNewNote$8,
	Nonotescreated: Nonotescreated$8,
	approxTimeIsFourMinutes: approxTimeIsFourMinutes$8,
	Continue: Continue$8,
	iWillDoLaterTakeMeToApp: iWillDoLaterTakeMeToApp$8,
	allDone: allDone$8,
	welcomeAbord: welcomeAbord$8,
	letsBegin: letsBegin$8,
	UpgradeyourplanandgetAIAssistance: UpgradeyourplanandgetAIAssistance$8,
	DownloadPDF: DownloadPDF$8,
	oopsWeCouldntProcessResume: oopsWeCouldntProcessResume$8,
	MyProfile: MyProfile$8,
	Setting: Setting$8,
	Logout: Logout$8,
	SignIn: SignIn$8,
	Typeyourfirstnamehere: Typeyourfirstnamehere$8,
	Enteryourlastname: Enteryourlastname$8,
	ManageSubscription: ManageSubscription$8,
	ifYouHaveDifficultiesProfile: ifYouHaveDifficultiesProfile$8,
	forSupport: forSupport$8,
	whatIsIdealCompanySize: whatIsIdealCompanySize$8,
	Saveandcontinue: Saveandcontinue$8,
	whatIsMinExpectedSalary: whatIsMinExpectedSalary$8,
	Atleast: Atleast$8,
	SlidetoAdjust: SlidetoAdjust$8,
	whatIndustryExcitedWork: whatIndustryExcitedWork$8,
	Add: Add$8,
	statusOfJobSearch: statusOfJobSearch$8,
	Finish: Finish$8,
	whatLevelRoleLooking: whatLevelRoleLooking$8,
	Selectuptotwo: Selectuptotwo$8,
	PreviousStep: PreviousStep$8,
	Skip: Skip$8,
	whatDoYouValueNewRole: whatDoYouValueNewRole$8,
	Selectuptothree: Selectuptothree$8,
	EqualEmploymentData: EqualEmploymentData$8,
	whatIsYourEthnicity: whatIsYourEthnicity$8,
	areYouAuthorizedToWorkUs: areYouAuthorizedToWorkUs$8,
	willYouRequireSponsorShip: willYouRequireSponsorShip$8,
	doYouHaveADisability: doYouHaveADisability$8,
	areYouAVeteran: areYouAVeteran$8,
	rolesYouInterestedIn: rolesYouInterestedIn$8,
	Selectuptofive: Selectuptofive$8,
	AddCustomrole: AddCustomrole$8,
	whereDoYouLikeWork: whereDoYouLikeWork$8,
	Resources: Resources$8,
	currentlyNoResourceAvailable: currentlyNoResourceAvailable$8,
	AddNewSection: AddNewSection$8,
	ChangeSections: ChangeSections$8,
	Settings: Settings$8,
	Dashboard: Dashboard$8,
	JobBoard: JobBoard$8,
	Linkedin: Linkedin$8,
	Community: Community$8,
	FindRecruiters: FindRecruiters$8,
	Goals: Goals$8,
	DownloadExtension: DownloadExtension$8,
	SuggestaFeature: SuggestaFeature$8,
	leftPanel: leftPanel$8,
	PhoneNumberisrequired: PhoneNumberisrequired$8,
	MobileNumber: MobileNumber$8,
	Enteronlynumbers: Enteronlynumbers$8,
	Countryyoulivein: Countryyoulivein$8,
	SelectaCountry: SelectaCountry$8,
	DateofBirth: DateofBirth$8,
	Gender: Gender$8,
	JobPreferences: JobPreferences$8,
	pleaseEnterValidEmail: pleaseEnterValidEmail$8,
	emailSendForResetting: emailSendForResetting$8,
	VerifyyourEmailID: VerifyyourEmailID$8,
	sentPleaseCheckEmail: sentPleaseCheckEmail$8,
	tooManyAttemptsTryAgain: tooManyAttemptsTryAgain$8,
	Resend: Resend$8,
	Login: Login$8,
	weHaveSentVerificationLinkAtEmail: weHaveSentVerificationLinkAtEmail$8,
	pleaseVerifyEmailContinueSpam: pleaseVerifyEmailContinueSpam$8,
	Logintogetstarted: Logintogetstarted$8,
	ContinuewithGoogle: ContinuewithGoogle$8,
	pleaseInputEmail: pleaseInputEmail$8,
	Password: Password$8,
	pleaseInputPassword: pleaseInputPassword$8,
	passwordLowerUpperDigitSpecial: passwordLowerUpperDigitSpecial$8,
	atLeastSixChar: atLeastSixChar$8,
	forgotPassword: forgotPassword$8,
	Bysigninginyouagreetoour: Bysigninginyouagreetoour$8,
	Terms: Terms$8,
	Conditions: Conditions$8,
	and: and$8,
	PrivacyPolicy: PrivacyPolicy$8,
	theseAreTheTopsSkillsExtracted: theseAreTheTopsSkillsExtracted$8,
	TopSkills: TopSkills$8,
	weCoulNotExtractSkills: weCoulNotExtractSkills$8,
	upgradeToPremiumToView: upgradeToPremiumToView$8,
	SkillScore: SkillScore$8,
	thisIsYourSkillScoreBasedOn: thisIsYourSkillScoreBasedOn$8,
	theseSkllsAreStrongMatch: theseSkllsAreStrongMatch$8,
	Strongmatch: Strongmatch$8,
	theseSkillsArePartialMatch: theseSkillsArePartialMatch$8,
	Partialmatch: Partialmatch$8,
	theseSkillsAreMissingFrom: theseSkillsAreMissingFrom$8,
	"Missing Keywords": "Manglende nøkkelord",
	SkillMatchComponent: SkillMatchComponent$8,
	Optional: Optional$8,
	Notrelevanttothejob: Notrelevanttothejob$8,
	Notaskill: Notaskill$8,
	Toogeneric: Toogeneric$8,
	Pleaseshareanyfeedback: Pleaseshareanyfeedback$8,
	excludedKeywordsWillNot: excludedKeywordsWillNot$8,
	yesExcludeThisSkillFrom: yesExcludeThisSkillFrom$8,
	PartialMatch: PartialMatch$8,
	MissingKeywords: MissingKeywords$8,
	Providetitletotask: Providetitletotask$8,
	TasksList: TasksList$8,
	AddTask: AddTask$8,
	EnterTaskTitlehere: EnterTaskTitlehere$8,
	TasksComponent: TasksComponent$8,
	CompletedTasks: CompletedTasks$8,
	CompleteYourtasks: CompleteYourtasks$8,
	Steps: Steps$8,
	PremiumMember: PremiumMember$8,
	Thankyouforupgradingto: Thankyouforupgradingto$8,
	CareerflowPremium: CareerflowPremium$8,
	hereIsHowYouCanAccessPremium: hereIsHowYouCanAccessPremium$8,
	stepOne: stepOne$8,
	DownloadourChromeExtension: DownloadourChromeExtension$8,
	youJobSearchCopilotIshere: youJobSearchCopilotIshere$8,
	DownloadNow: DownloadNow$8,
	stepTwo: stepTwo$8,
	GetStarted: GetStarted$8,
	stepThree: stepThree$8,
	SignintoChromeExtension: SignintoChromeExtension$8,
	entityCreated: entityCreated$8,
	entityUpdated: entityUpdated$8,
	entityDeleted: entityDeleted$8,
	entityLinked: entityLinked$8,
	entityUnlinked: entityUnlinked$8,
	entityMovedTo: entityMovedTo$8,
	youAddedANewEntity: youAddedANewEntity$8,
	personCreated: personCreated$8,
	youUpdatedAEntity: youUpdatedAEntity$8,
	personUpdated: personUpdated$8,
	youDeletedAEntity: youDeletedAEntity$8,
	personDeleted: personDeleted$8,
	youLinkedEntity: youLinkedEntity$8,
	personLinked: personLinked$8,
	youUnlinked: youUnlinked$8,
	personUnlinked: personUnlinked$8,
	youMovedEntity: youMovedEntity$8,
	personMoved: personMoved$8,
	addedByName: addedByName$8,
	DownloadChromeExtension: DownloadChromeExtension$8,
	ourChromeExtensionIs: ourChromeExtensionIs$8,
	Optimizeyourprofile: Optimizeyourprofile$8,
	startOptimizingYourProfile: startOptimizingYourProfile$8,
	OptimizeNow: OptimizeNow$8,
	Addyourfirstjob: Addyourfirstjob$8,
	startSavingJobApplicationsToTrack: startSavingJobApplicationsToTrack$8,
	AddNow: AddNow$8,
	CompleteProfile: CompleteProfile$8,
	completeYourProfileForUsing: completeYourProfileForUsing$8,
	CompleteNow: CompleteNow$8,
	Addyourfirstcontact: Addyourfirstcontact$8,
	addContactToFollowUpWith: addContactToFollowUpWith$8,
	JoinCommunity: JoinCommunity$8,
	ourCommunityisAlways: ourCommunityisAlways$8,
	JoinNow: JoinNow$8,
	welcomeToCareerflow: welcomeToCareerflow$8,
	yourHubForCareerInsights2: yourHubForCareerInsights2$8,
	ChecklistCompleted: ChecklistCompleted$8,
	Completeyourchecklist: Completeyourchecklist$8,
	completeAFewStepsTo: completeAFewStepsTo$8,
	Completed: Completed$8,
	JobCountByStage: JobCountByStage$8,
	NopastapplicationDatafound: NopastapplicationDatafound$8,
	YourJobSearchStages: YourJobSearchStages$8,
	NoDatafound: NoDatafound$8
};

const copyToClipboard$7 = "Skopiowane do schowka!";
const UnlocktheAIgenerated$7 = "Odblokuj wygenerowane przez sztuczną inteligencję.";
const UpgradetoPremium$7 = "Ulepsz do Premium";
const Result$7 = "Wynik";
const Copy$7 = "Kopiuj";
const Save$7 = "Zapisz";
const Edit$7 = "Edytuj";
const Processing$7 = "Przetwarzanie";
const YourAIgeneratedcontentwillshowhere$7 = "Twój wygenerowany przez sztuczną inteligencję kontent pojawi się tutaj";
const hopeYouFindUseful$7 = "Mam nadzieję, że ten wynik okaże się dla Ciebie przydatny!";
const regenerate$7 = "Ponownie wygeneruj";
const ProvideAdditionalFeedback$7 = "Podaj Dodatkową Opinię";
const Enteranyfeedback$7 = "Wprowadź opinię";
const Notimpressive$7 = "Nieimponujące";
const thisIsntTrue$7 = "To nie jest prawda";
const Notpersonalized$7 = "Nie spersonalizowane";
const Tone$7 = "Tonacja";
const Length$7 = "Długość";
const Template$7 = "Szablon";
const Generatedon$7 = "Generowane dnia";
const Copiedtoclipboard$7 = "Skopiowane do schowka";
const CopytoClipboard$7 = "Kopiuj do schowka";
const DownloadasPDF$7 = "Pobierz jako PDF";
const ViewDetails$7 = "Pokaż szczegóły";
const JobDescriptionImported$7 = "Opis stanowiska - importowany";
const ImportfromJob$7 = "Import z pracy";
const Saved$7 = "Zapisane";
const Applied$7 = "Zastosowane";
const Offer$7 = "Oferta";
const Interviewing$7 = "Rozmowa kwalifikacyjna";
const Rejected$7 = "Odrzucone";
const Search$7 = "Szukaj";
const Import$7 = "Import";
const CoverLetterGeneratorHistory$7 = "Historia generatora listu motywacyjnego";
const NoCoverLettersGenerated$7 = "Brak wygenerowanych listów motywacyjnych";
const getStartedCoverLetter$7 = "Nie wygenerowałeś jeszcze żadnych listów motywacyjnych. Zacznij i uzyskaj listy motywacyjne, dopasowując opis stanowiska do swojego doświadczenia.";
const getStarted$7 = "Zacznij!";
const Documents$7 = "Dokumenty";
const UploadNewDocument$7 = "Prześlij nowy dokument";
const AICoverLetterGenerator$7 = "Generator Listu Motywacyjnego AI";
const ViewHistory$7 = "Pokaż historię";
const JobDescription$7 = "Opis stanowiska";
const ImportfromBoard$7 = "Importuj z tablicy";
const EnterJobDescription$7 = "Wprowadź opis stanowiska";
const JobTitle$7 = "Stanowisko";
const EnterJobTitle$7 = "Wprowadź nazwę stanowiska";
const CompanyName$7 = "Nazwa firmy";
const EnterCompanyName$7 = "Wprowadź nazwę firmy";
const YourProfile$7 = "Twój profil";
const ResumeUpload$7 = "Prześlij życiorys";
const UseLinkedinProfile$7 = "Użyj profilu Linkedin";
const Uploadyourresume$7 = "Prześlij swój życiorys";
const AddyourResume$7 = "Dodaj swój życiorys";
const fileNameCannotFormat$7 = "Nazwy plików nie mogą zawierać spacji ani podkreślników i powinny być w formacie .doc, .docx lub .pdf.";
const ChooseorUpload$7 = "Wybierz lub prześlij";
const SelectTemplate$7 = "Wybierz szablon";
const Preview$7 = "Podgląd";
const UseTemplate$7 = "Użyj szablonu";
const Change$7 = "Zmień";
const AdvancedSettings$7 = "Ustawienia zaawansowane";
const AdditionalContext$7 = "Dodatkowy kontekst";
const Professional$7 = "Profesjonalny";
const Casual$7 = "Swobodny";
const Enthusiastic$7 = "Entuzjastyczny";
const Informational$7 = "Informacyjny";
const Short$7 = "Krótki";
const Medium$7 = "Średni";
const Long$7 = "Długi";
const Language$7 = "Język";
const iAmOkayBack$7 = "W porządku! Wróć";
const Generate$7 = "Generuj";
const CoverLetter$7 = "List motywacyjny";
const SelectLanguage$7 = "Wybierz język";
const AboutGeneratorHistory$7 = "Historia generatora informacji o sobie";
const NoAboutsGenerated$7 = "Brak wygenerowanych informacji o sobie";
const getStartedAbouts$7 = "Nie wygenerowałeś jeszcze żadnych informacji o sobie. Zacznij i uzyskaj informacje, dopasowując opis stanowiska do swojego doświadczenia.";
const noAttachmentsFound$7 = "Nie znaleziono załączników.";
const TargetJobTitle$7 = "Docelowe stanowisko";
const KeywordsToInclude$7 = "Słowa kluczowe do uwzględnienia";
const UploadYourResume$7 = "Prześlij swoje CV";
const AddYourResume$7 = "Dodaj swoje CV";
const LinkedinProfile$7 = "Profil Linkedin";
const Linkedinprofilenotfound$7 = "Profil Linkedin nie znaleziony";
const startUsingChromeExtension$7 = "Rozpocznij optymalizację swojego profilu Linkedin za pomocą naszego rozszerzenia Chrome, aby skorzystać z tej opcji.";
const Download$7 = "Pobierz";
const UseEmojis$7 = "Użyj emotikonów";
const UseBulletPoints$7 = "Użyj punktorów";
const SpeechFocus$7 = "Skupienie wypowiedzi";
const FirstPerson$7 = "Pierwsza osoba";
const ThirdPerson$7 = "Trzecia osoba";
const HeadlineGeneratorHistory$7 = "Historia generatora nagłówków";
const NoHeadlinesGenerated$7 = "Brak wygenerowanych nagłówków";
const getStartedHeadline$7 = "Nie wygenerowałeś jeszcze żadnych nagłówków. Zacznij i uzyskaj nagłówki, dopasowując opis stanowiska do swojego doświadczenia.";
const AIHeadlineGenerator$7 = "Generator nagłówków AI";
const KeywordstoInclude$7 = "Słowa kluczowe do uwzględnienia";
const Pressenteraftereachword$7 = "Naciśnij enter po każdym słowie";
const LinkedinProfilenotfound$7 = "Nie znaleziono profilu LinkedIn.";
const Headline$7 = "Nagłówek";
const PostGeneratorHistory$7 = "Historia generatora wpisów";
const NoPostsGenerated$7 = "Brak wygenerowanych wpisów";
const getStartedPost$7 = "Nie wygenerowałeś jeszcze żadnych wpisów. Zacznij i uzyskaj wpisy, dopasowując opis stanowiska do swojego doświadczenia.";
const Topic$7 = "Temat";
const Description$7 = "Opis";
const UseHashtags$7 = "Użyj hashtagów";
const Custom$7 = "Niestandardowy";
const EnterCustomTone$7 = "Wprowadź niestandardową tonację";
const Added$7 = "Dodano";
const ComingSoon$7 = {
	header: "Inżynierowie pracują!",
	content_1: "Nasz zespół inżynierów ciężko pracuje, aby jak najszybciej uruchomić tę funkcję.",
	content_2: "Chcesz tę funkcję szybko? Daj nam znać, zaznaczając po prostu poniższe pole.",
	content_3: "Chcę tę funkcję"
};
const Company$7 = "Firma";
const JobInterview$7 = "Rozmowa o pracę";
const Research$7 = "Badania";
const Networking$7 = "Networking";
const Referral$7 = "Polecający";
const MustbeContacted$7 = "Należy skontaktować się";
const ScheduleaMeeting$7 = "Umów spotkanie";
const needAFollowUp$7 = "Potrzeba podążać za tym";
const Today$7 = "Dzisiaj";
const Viewdetails$7 = "Pokaż szczegóły";
const Activity$7 = "Aktywność";
const ActivityDetails$7 = "Szczegóły działalności";
const Delete$7 = "Usuń";
const Title$7 = "Tytuł";
const Goal$7 = "Cel";
const Status$7 = "Status";
const FollowUp$7 = "Follow Up";
const AddActivity$7 = "Dodaj działalność";
const Enteractivitytitle$7 = "Wprowadź tytuł działalności";
const Cancel$7 = "Anuluj";
const SaveActivity$7 = "Zapisz działalność";
const noActivityPresent$7 = "Brak aktywności, dodaj aktywność.";
const Addnew$7 = "Dodaj nowe";
const About$7 = "O";
const noDataPresentYou$7 = "Brak danych, możesz edytować ten kontakt i dodać pola.";
const Experience$7 = "Doświadczenie";
const Education$7 = "Edukacja";
const Skills$7 = "Umiejętności";
const Overview$7 = "Przegląd";
const LinkedJobs$7 = "Powiązane oferty pracy";
const Notes$7 = "Notatki";
const FullName$7 = "Pełne imię i nazwisko";
const Location$7 = "Lokalizacja";
const Relationship$7 = "Relacja";
const Contacts$7 = "Kontakty";
const CreateContact$7 = "Utwórz kontakt";
const NotesCreated$7 = "Notatki utworzone";
const Notesupdated$7 = "Notatki zaktualizowane";
const Addnote$7 = "Dodaj notatkę";
const areYouSureDeleteNote$7 = "Czy na pewno chcesz usunąć tę notatkę?";
const Createdby$7 = "Utworzone przez";
const notSureWhyResumeCalls$7 = "Nie jesteś pewien/pewna, dlaczego twoje CV nie przynosi ci zaproszeń na rozmowy kwalifikacyjne? ☎️";
const getExpertResumeReview$7 = "Otrzymaj ekspertową ocenę swojego CV 💎✨";
const youHaventAddedContacts$7 = "Nie dodałeś jeszcze żadnych kontaktów.";
const noMatchingContacts$7 = "Nie znaleziono pasujących kontaktów.";
const Link$7 = "Link";
const unlink$7 = "Odłącz";
const Locationnotavailable$7 = "Lokalizacja niedostępna";
const Emailnotavailable$7 = "E-mail niedostępny";
const PhoneNumbernotavailable$7 = "Numer telefonu niedostępny";
const createdby$7 = "stworzone przez";
const areYouSureDeleteContact$7 = "Czy na pewno chcesz usunąć ten Kontakt?";
const areYouSureUnlinkContact$7 = "Czy na pewno chcesz odłączyć ten Kontakt?";
const Addedbyyou$7 = "Dodane przez Ciebie";
const Addedby$7 = "Dodane przez";
const Timeline$7 = "Oś czasu";
const Timelineempty$7 = "Brak wpisów na osi czasu";
const Discard$7 = "Odrzuć";
const SaveContact$7 = "Zapisz kontakt";
const Recruiter$7 = "Rekruter";
const Candidate$7 = "Kandydat";
const Colleague$7 = "Kolega";
const Employee$7 = "Pracownik";
const EnterValidEmail$7 = "Wprowadź prawidłowy adres e-mail";
const EnterValidPhoneNumber$7 = "Wprowadź prawidłowy numer telefonu";
const editingProfileNotAvailable$7 = "Edycja zdjęcia profilowego nie jest jeszcze dostępna.";
const itWillBeSoonAvailable$7 = "Wkrótce będzie dostępne w naszej.";
const ChromeExtension$7 = "Rozszerzenie Chrome";
const SelectTag$7 = "Wybierz tag";
const FirstName$7 = "Imię";
const FirstNameisrequired$7 = "Imię jest wymagane";
const LastName$7 = "Nazwisko";
const LastNameisrequired$7 = "Nazwisko jest wymagane";
const Companyisrequired$7 = "Firma jest wymagana";
const Email$7 = "E-mail";
const ThisisnotavalidEmail$7 = "To nie jest prawidłowy adres e-mail.";
const AddEmail$7 = "Dodaj e-mail";
const PhoneNumber$7 = "Numer telefonu";
const notaValidPhone$7 = "To nie jest prawidłowy numer telefonu. Wprowadź tylko cyfry.";
const phoneNoMinimum5char$7 = "Numer telefonu musi mieć co najmniej 5 znaków.";
const phoneNoMinumum15char$7 = "Numer telefonu musi mieć maksymalnie 15 znaków.";
const AddPhoneNumber$7 = "Dodaj numer telefonu";
const SelectGoal$7 = "Wybierz cel";
const SelectStatus$7 = "Wybierz Status";
const Followup$7 = "Następne działanie";
const SocialMedia$7 = "Media społecznościowe";
const Linkedinhandle$7 = "Uchwyt Linkedin";
const Twitterhandle$7 = "Uchwyt Twittera";
const Facebookhandle$7 = "Uchwyt Facebooka";
const Githubhandle$7 = "Uchwyt Githuba";
const Gmailhandle$7 = "Uchwyt Gmaila";
const Changessavedsuccessfully$7 = "Zmiany zapisane pomyślnie";
const EditContact$7 = "Edytuj kontakt";
const BasicInformation$7 = "Podstawowe informacje";
const EditContactDetails$7 = "Edytuj szczegóły kontaktowe";
const SaveChanges$7 = "Zapisz zmiany";
const phoneNoMinimum14char$7 = "Numer telefonu musi mieć co najmniej 14 znaków.";
const LinkedIn$7 = "LinkedIn";
const Twitter$7 = "Twitter";
const Facebook$7 = "Facebook";
const Github$7 = "Github";
const Gmail$7 = "Gmail";
const youCanWriteAbout$7 = "Możesz pisać o swoich latach doświadczenia, branży lub umiejętnościach. Ludzie również mówią o swoich osiągnięciach lub poprzednich doświadczeniach zawodowych.";
const Addednewsection$7 = "Dodano nową sekcję";
const Removedsuccessfully$7 = "Usunięto pomyślnie.";
const Remove$7 = "Usuń";
const Institute$7 = "Instytut";
const Schoolisrequired$7 = "Szkoła jest wymagana";
const Degree$7 = "Stopień";
const StartMonth$7 = "Rozpocznij miesiąc";
const StartYear$7 = "Rok rozpoczęcia";
const EndMonth$7 = "Koniec miesiąca";
const EndYear$7 = "Koniec roku";
const Addmore$7 = "Dodaj więcej";
const PositionTitle$7 = "Tytuł stanowiska";
const ExperienceType$7 = "Typ doświadczenia";
const Addednewitem$7 = "Dodano nowy przedmiot";
const whatSkillsDoYouEnjoy$7 = "Jakie umiejętności posiadasz lub lubisz nimi się zajmować?";
const Typeskillshere$7 = "Wpisz tutaj umiejętności";
const LinkedContacts$7 = "Powiązane kontakty";
const LinkContact$7 = "Powiąż kontakt";
const NocontactsLinked$7 = "Brak powiązanych kontaktów";
const JobContactsComponent$7 = {
	linkContact: "Poprzez powiązanie kontaktów szybko zobaczysz, kto jest ważnym kontaktem, jak rekruter, kierownik rekrutacji, itp., dla tej roli! W przyszłości będziemy w stanie dostarczać istotne informacje oparte na Twoich kontaktach."
};
const Nocontacts$7 = "Brak kontaktów";
const LinkJobto$7 = "Połącz pracę z";
const Contact$7 = "Kontakt";
const Document$7 = "Dokument";
const Nojobsfound$7 = "Nie znaleziono ofert pracy";
const LinkJob$7 = "Powiąż ofertę pracy";
const youCanLinkContactJobImported$7 = "Możesz połączyć ten kontakt z pracą, którą zaimportowałeś do Careerflow.";
const Prev$7 = "Poprzedni";
const Next$7 = "Następne";
const areYouSureUnlinkDocument$7 = "Czy na pewno chcesz odłączyć ten dokument?";
const areYouSureDeleteDocument$7 = "Czy na pewno chcesz usunąć ten Dokument?";
const Category$7 = "Kategoria";
const CreatedOn$7 = "Utworzono";
const Joblinked$7 = "Praca powiązana";
const Quickactions$7 = "Szybkie działania";
const All$7 = "Wszystko";
const Resume$7 = "CV";
const Portfolio$7 = "Portfolio";
const Other$7 = "Inne";
const Adddocument$7 = "Dodaj dokument";
const Type$7 = "Typ";
const Sortingby$7 = "Sortowanie według";
const SwitchtoGridLayout$7 = "Przełącz na układ siatki";
const SwitchtoListLayout$7 = "Przełącz na układ listy";
const NoDocumentsAdded$7 = "Brak dodanych dokumentów";
const DocumentsComponent$7 = {
	nodocs: "Nie utworzyłeś jeszcze żadnych dokumentów. Możesz przesyłać wersje swojego CV, listy motywacyjne itp. i powiązywać je z ofertami pracy, które śledzisz!"
};
const NoDocumentFound$7 = "Nie znaleziono dokumentu.";
const SelectFile$7 = "Wybierz plik";
const onlyPdfDocxSupported$7 = "Obsługiwane tylko formaty .pdf i .docx.";
const Uploadfile$7 = "Prześlij plik";
const DocumentCategory$7 = "Kategoria dokumentu";
const SaveDocument$7 = "Zapisz dokument";
const AddDocument$7 = "Dodaj dokument";
const LinkedDocuments$7 = "Połączone dokumenty";
const LinkDocument$7 = "Powiąż dokument";
const NodocumentsLinked$7 = "Brak powiązanych dokumentów";
const JobDocumentsComponent$7 = {
	linkDocs: "Powiązanie wszystkich istotnych dokumentów, takich jak CV, list motywacyjny, itp., które przesłałeś do tej oferty pracy, pomoże Ci śledzić wszystko w jednym miejscu. Wypróbuj to!"
};
const NoDocuments$7 = "Brak dokumentów";
const CreateDocuments$7 = "Utwórz dokumenty";
const youCanLinkDocumentJobImported$7 = "Możesz połączyć ten dokument z pracą, którą zaimportowałeś do Careerflow.";
const Documenteditedsuccessfully$7 = "Dokument został pomyślnie edytowany";
const DocumentDetails$7 = "Szczegóły dokumentu";
const UnsavedChanges$7 = "Niezapisane zmiany";
const yourChangesWillBeLostSureClose$7 = "Twoje zmiany zostaną utracone, czy na pewno chcesz zamknąć?";
const yourChangesWillBeLostSureDiscard$7 = "Twoje zmiany zostaną utracone, czy na pewno chcesz je odrzucić?";
const DiscardChanges$7 = "Odrzuć zmiany.";
const WeeklyGoalAlert$7 = "Alert celu tygodniowego";
const Progress$7 = "Postęp";
const AllGoals$7 = "Wszystkie cele";
const Name$7 = "Imię";
const Completedon$7 = "Zakończono";
const Createdon$7 = "Utworzono";
const Action$7 = "Akcja";
const Back$7 = "Wstecz";
const OverallScore$7 = "Ogólna ocena";
const Aboutthegoal$7 = "O celu";
const GoalTracking$7 = "Śledzenie celu";
const Week$7 = "Tydzień";
const progress$7 = "postęp";
const loading$7 = "Ładowanie";
const Apply$7 = "Zastosuj";
const Thisskillhasbeenreported$7 = "Ta umiejętność została zgłoszona.";
const issueGettingResume$7 = "Był problem z uzyskaniem życiorysu.";
const Interview$7 = "Rozmowa kwalifikacyjna";
const Tasks$7 = "Zadania";
const Loading$7 = "Ładowanie";
const Skilladdedsuccessfully$7 = "Umiejętność dodana pomyślnie";
const problemAddingSkill$7 = "Był problem przy dodawaniu umiejętności.";
const Reportaproblem$7 = "Zgłoś problem";
const Submit$7 = "Prześlij";
const Addanewskill$7 = "Dodaj nową umiejętność";
const JobDetailsComponent$7 = {
	classifySkill: "Jak sklasyfikowałbyś tę umiejętność (opcjonalnie)?",
	includedKeywordsWillCount: "Zawierać to słowo kluczowe?",
	yesIncludeThisSkill: "Dołączone słowa kluczowe będą wpływać na wynik dopasowania podczas wszystkich przyszłych skanowań. Możesz zmienić dołączone słowa kluczowe w swoim profilu.",
	addSkill: "Czy chcesz dodać to jako umiejętność?"
};
const HardSkill$7 = "Umiejętność techniczna";
const SoftSkill$7 = "Umiejętność miękka";
const Pleaseshareanyadditionalcontext$7 = "Podziel się dodatkowym kontekstem";
const Addasskill$7 = "Dodaj jako umiejętność";
const Skill$7 = "Umiejętność";
const JobFrequency$7 = "Częstotliwość pracy";
const ResumeFrequency$7 = "Częstotliwość resume";
const Reportskill$7 = "Zgłoś umiejętność";
const JobDetails$7 = "Szczegóły pracy";
const ViewJobLink$7 = "Zobacz link do oferty pracy";
const Salary$7 = "Pensja";
const areYouSureDeleteJob$7 = "Czy na pewno chcesz usunąć to zadanie?";
const ViewMore$7 = "Zobacz więcej";
const ViewLess$7 = "Zobacz mniej";
const matchYouSkillsAgainstJob$7 = "Porównaj swoje umiejętności z opisem pracy.";
const pleaseUploadResumeSkillMatch$7 = "Proszę przesłać swoje CV, aby otrzymać wynik dopasowania umiejętności.";
const AddResume$7 = "Dodaj CV";
const thisJobDoesNotHaveAnyDesc$7 = "To stanowisko nie ma żadnego opisu.";
const youCanEditJobToAdd$7 = "Możesz edytować to zadanie, aby dodać do niego opis. Możesz również importować zadania za pomocą naszej.";
const chromeextension$7 = "rozszerzenie Chrome";
const fromVariousJobPortalsOnce$7 = "z różnych portali pracy. Po dodaniu opisu będziesz mógł również zobaczyć informacje związane ze zdolnościami.";
const AddDescription$7 = "Dodaj opis";
const CompanyInfo$7 = "Informacje o firmie";
const Website$7 = "Strona internetowa";
const Industry$7 = "Przemysł";
const EmployeeCount$7 = "Liczba pracowników";
const ExprienceLevel$7 = "Poziom doświadczenia";
const Address$7 = "Adres";
const Resumes$7 = "Życiorysy";
const Setasdefault$7 = "Ustaw jako domyślne";
const Ok$7 = "Ok";
const UploadNewResume$7 = "Prześlij nowe CV";
const Default$7 = "Domyślne";
const Jobnotfound$7 = "Praca nie znaleziona";
const EditDetails$7 = "Edytuj szczegóły";
const JobPostURL$7 = "URL ogłoszenia o pracę";
const Enterjoburl$7 = "Wprowadź adres URL pracy";
const Nojobselected$7 = "Nie wybrano pracy.";
const Viewjobdetails$7 = "Zobacz szczegóły pracy";
const Jobaddedtoyourboardsuccessfully$7 = "Praca została pomyślnie dodana do Twojej tablicy";
const AddJob$7 = "Dodaj pracę";
const Addnewjobname$7 = "Dodaj nową nazwę pracy";
const JobUrl$7 = "URL oferty pracy";
const Addjoburl$7 = "Dodaj adres URL pracy";
const Section$7 = "Sekcja";
const didYouKnow$7 = {
	chromeExtension: "Czy wiesz? Możesz także zapisywać oferty pracy bezpośrednio za pomocą naszego rozszerzenia do przeglądarki Chrome i importować wszystkie dane jednym kliknięciem! To zajmuje tylko kilka sekund."
};
const Jobs$7 = "Oferty pracy";
const AddJobtoboard$7 = "Dodaj pracę do tablicy";
const Currentlynojobsareavailable$7 = "Obecnie nie ma dostępnych żadnych ofert pracy.";
const noMatchingJobs$7 = "Nie znaleziono pasujących ofert pracy.";
const welcomeToYourPersonalJobTracker$7 = "Witaj w swoim osobistym śledzeniu pracy!";
const weShortTutorialOnHowTrackingJob$7 = "Przeprowadzimy Cię przez krótki samouczek, jak rozpocząć śledzenie swoich aplikacji o pracę w kilku prostych krokach!";
const Addanewjob$7 = "Dodaj nowe zadanie.";
const inOrderTrackCreatButton$7 = "Aby rozpocząć śledzenie aplikacji o pracę, musisz najpierw dodać ją do tablicy, klikając przycisk \"Utwórz\".";
const Providesomedetails$7 = "Podaj kilka szczegółów";
const toBeginTypeJobTitleCompany$7 = "Na początek po prostu wpisz tytuł pracy, nazwę firmy i status, który chcesz dodać. Możesz dodać więcej szczegółów później, ale na razie to wszystko, czego potrzebujesz!";
const asAnExampleFilledForYou$7 = "Jako przykład, już to dla Ciebie wypełniliśmy!";
const wohooAddedFirstJob$7 = "Woohoo! Dodałeś swoją pierwszą pracę do swojego śledzenia pracy!";
const youCanDragDropJobCard$7 = "Teraz możesz przeciągnąć kartę pracy i upuścić ją w różnych etapach procesu aplikacji o pracę. Kliknięcie na kartę pracy pozwoli Ci zobaczyć więcej szczegółów, edytować je, zapisać notatki i wiele więcej!";
const Lastbutnotleast$7 = "Ostatni, ale nie najmniej ważny";
const finalStepMakeSure$7 = "Na koniec upewnij się, że masz naszą";
const autoMaticallyImportJobs$7 = "co pozwoli Ci automatycznie importować oferty pracy z Twoich ulubionych stron z wyszukiwaniem pracy, takich jak LinkedIn, Indeed i wiele innych! Nasze rozszerzenie pomaga również poprawić Twój profil LinkedIn i uzyskać 2,5 razy więcej wyświetleń w wynikach wyszukiwania!";
const selectanysection$7 = "wybierz dowolną sekcję";
const Accept$7 = "Akceptuj";
const My2023JobSearch$7 = "Moje poszukiwania pracy w 2023 roku";
const AddedFrom$7 = "Dodane z";
const AddedUntil$7 = "Dodano do";
const BasicModal$7 = "Podstawowe okno modalne";
const AddnewSectionName$7 = "Dodaj nową nazwę sekcji";
const OpenTo$7 = "Otwarte dla";
const Featured$7 = "Wyróżnione";
const LicenceAndCerts$7 = "Licencje i certyfikaty";
const Banner$7 = "Baner";
const LinkedInURL$7 = "URL LinkedIn";
const Recommendations$7 = "Rekomendacje";
const LinkedinReview$7 = "Recenzja na Linkedinie";
const NoDataAvailable$7 = "Brak dostępnych danych.";
const looksLikeYouDidNot$7 = "Wygląda na to, że nie zacząłeś korzystać z naszego";
const toOptimizeProfileScoreVisible$7 = "Jeśli jeszcze nie zoptymalizowałeś swojego profilu na LinkedIn, zrób to teraz. Po tym Twoja ocena profilu będzie widoczna tutaj.";
const LinkedinComponent$7 = {
	letsOptimize: "Optymalizujmy"
};
const improveYourChancesLandingDreamJob$7 = "Popraw swoje szanse na zdobycie wymarzonej pracy. Wykorzystaj te wypróbowane i sprawdzone strategie, aby odświeżyć swój profil LinkedIn.";
const VisitProfile$7 = "Odwiedź profil";
const wantToGetLinkedinMakeover$7 = "Chcesz przeprowadzić kompletną metamorfozę swojego profilu na LinkedIn?";
const PostGenerator$7 = "Generator postów";
const LinkedinHeadlineGenerator$7 = "Generator nagłówka LinkedIn";
const LinkedinAboutSectionGenerator$7 = "Generator sekcji 'O mnie' LinkedIn";
const AITools$7 = "Narzędzia AI";
const Premium$7 = "Premium";
const LinkedInOptimization$7 = "Optymalizacja LinkedIn";
const JobTracker$7 = "Śledzenie pracy";
const whoIsHiring$7 = "Kto zatrudnia";
const Autofill$7 = "Automatyczne wypełnianie";
const HeadlineGenerator$7 = "Generator nagłówków";
const skillMatching$7 = "Dopasowanie umiejętności";
const SummarizeJD$7 = "Podsumowanie opisu pracy";
const contactFeature$7 = "Śledzenie kontaktów";
const documentFeature$7 = "Dokumenty";
const landJobWithoutStress$7 = "Zdobądź swoją wymarzoną pracę. Bez stresu.";
const discoverFeatures$7 = "Odkryj gamę funkcji Careerflow.ai, które zostały zaprojektowane w celu usprawnienia Twojego poszukiwania pracy i poprawy Twojej drogi zawodowej!";
const letsBeginOnboarding$7 = "Poznajmy cię lepiej!";
const inTheNextFewScreensJobThirdParties$7 = "W kolejnych kilku ekranach zadać Ci będziemy kilka pytań, które pomogą nam dostosować do Ciebie doświadczenie oraz automatycznie wypełnić Twoje aplikacje o pracę (abyś nie musiał/a)! Nie sprzedajemy Twoich danych żadnym trzecim stronom.";
const letsAddBasicInformation$7 = "Dodajmy Twoje podstawowe informacje";
const Pleaseselectanoptionfirst$7 = "Proszę najpierw wybrać opcję.";
const JobApplicationTracker$7 = "Śledzenie aplikacji o pracę";
const LinkedInProfileOptimizer$7 = "Optymalizator profilu Linked In";
const UnlimitedDocuments$7 = "Nielimitowane dokumenty";
const UnlimitedContacts$7 = "Nieograniczona liczba kontaktów.";
const HiringManagerSearch$7 = "Wyszukiwanie menedżera do zatrudnienia";
const AILinkedInPostGenerator$7 = "Generator postów na LinkedIn z wykorzystaniem sztucznej inteligencji";
const ATSKeywordSkillMatch$7 = "Praca dopasowana do słów kluczowych / umiejętności ATS";
const ChooseyourPlan$7 = "Wybierz swój plan";
const superChargeYourJobSearch$7 = "Przyspiesz swoje poszukiwania pracy i popraw swoje procesy aplikacyjne, zwiększ liczbę rozmów kwalifikacyjnych i zdobądź wymarzoną pracę. Wszystko to dzięki narzędziom premium Careerflow.";
const startNowGoto$7 = "Zacznij teraz (Przejdź do aplikacji)";
const CreatedBy$7 = "Utworzone przez";
const CreateNewNote$7 = "Utwórz nową notatkę";
const Nonotescreated$7 = "Brak utworzonych notatek";
const approxTimeIsFourMinutes$7 = "Przybliżony czas zakończenia procesu wprowadzania wynosi 4 minuty.";
const Continue$7 = "Kontynuuj";
const iWillDoLaterTakeMeToApp$7 = "Zrobię to później. Przenieś mnie do aplikacji.";
const allDone$7 = "Wszystko zrobione!";
const welcomeAbord$7 = "Witaj na pokładzie!";
const letsBegin$7 = "Zaczynajmy.";
const UpgradeyourplanandgetAIAssistance$7 = "Zaktualizuj swój plan i otrzymaj pomoc sztucznej inteligencji";
const DownloadPDF$7 = "Pobierz PDF";
const oopsWeCouldntProcessResume$7 = "Ups, nie udało nam się przetworzyć tego życiorysu.";
const MyProfile$7 = "Mój profil";
const Setting$7 = "Ustawienie";
const Logout$7 = "Wyloguj się";
const SignIn$7 = "Zaloguj się";
const Typeyourfirstnamehere$7 = "Twoje imię";
const Enteryourlastname$7 = "Twoje nazwisko";
const ManageSubscription$7 = "Zarządzaj subskrypcją";
const ifYouHaveDifficultiesProfile$7 = "Jeśli masz jakieś trudności z informacjami na swoim profilu, proszę się skontaktować z";
const forSupport$7 = "na wsparcie.";
const whatIsIdealCompanySize$7 = "Jaka jest Twoja idealna wielkość firmy?";
const Saveandcontinue$7 = "Zapisz i kontynuuj";
const whatIsMinExpectedSalary$7 = "Jaka jest Twoja minimalna oczekiwana pensja (rocznie)?";
const Atleast$7 = "Przynajmniej";
const SlidetoAdjust$7 = "Przesuń, aby dostosować";
const whatIndustryExcitedWork$7 = "Jakie branże są dla Ciebie ekscytujące?";
const Add$7 = "Dodaj";
const statusOfJobSearch$7 = "Jaki jest status Twojego poszukiwania pracy?";
const Finish$7 = "Koniec";
const whatLevelRoleLooking$7 = "Na jakim poziomie roli się skupiasz?";
const Selectuptotwo$7 = "Wybierz maksymalnie dwie.";
const PreviousStep$7 = "Poprzedni krok";
const Skip$7 = "Pomiń";
const whatDoYouValueNewRole$7 = "Co cenisz w nowej roli?";
const Selectuptothree$7 = "Wybierz maksymalnie trzy.";
const EqualEmploymentData$7 = "Dane dotyczące równości zatrudnienia";
const whatIsYourEthnicity$7 = "Jaka jest twoja narodowość?";
const areYouAuthorizedToWorkUs$7 = "Czy masz uprawnienia do pracy w USA?";
const willYouRequireSponsorShip$7 = "Czy w chwili obecnej lub w przyszłości będziesz potrzebować sponsorowania w celu uzyskania wizy związanej z zatrudnieniem?";
const doYouHaveADisability$7 = "Czy masz niepełnosprawność?";
const areYouAVeteran$7 = "Jesteś weteranem?";
const rolesYouInterestedIn$7 = "Jakie role Cię interesują?";
const Selectuptofive$7 = "Wybierz maksymalnie pięć.";
const AddCustomrole$7 = "Dodaj niestandardową rolę";
const whereDoYouLikeWork$7 = "Gdzie chciałbyś pracować?";
const Resources$7 = "Zasoby";
const currentlyNoResourceAvailable$7 = "Obecnie nie ma dostępnych zasobów.";
const AddNewSection$7 = "Dodaj nową sekcję";
const ChangeSections$7 = "Zmień sekcje";
const Settings$7 = "Ustawienia";
const Dashboard$7 = "Panel";
const JobBoard$7 = "Tablica ogłoszeń o pracę";
const Linkedin$7 = "Linkedin";
const Community$7 = "Społeczność";
const FindRecruiters$7 = "Znajdź rekruterów";
const Goals$7 = "Cele";
const DownloadExtension$7 = "Pobierz rozszerzenie";
const SuggestaFeature$7 = "Zaproponuj funkcję";
const leftPanel$7 = {
	ReportanIssue: "Zgłoś problem"
};
const PhoneNumberisrequired$7 = "Wymagany jest numer telefonu";
const MobileNumber$7 = "Numer telefonu komórkowego";
const Enteronlynumbers$7 = "Wprowadź tylko liczby.";
const Countryyoulivein$7 = "Kraj, w którym mieszkasz";
const SelectaCountry$7 = "Wybierz kraj";
const DateofBirth$7 = "Data urodzenia";
const Gender$7 = "Płeć";
const JobPreferences$7 = "Preferencje dotyczące pracy";
const pleaseEnterValidEmail$7 = "Proszę podać poprawny adres e-mail.";
const emailSendForResetting$7 = "Wysłano do Ciebie e-mail w celu zresetowania hasła";
const VerifyyourEmailID$7 = "Zweryfikuj swój adres e-mail";
const sentPleaseCheckEmail$7 = "Wysłano! Proszę sprawdzić swoją skrzynkę e-mail.";
const tooManyAttemptsTryAgain$7 = "Zbyt wiele prób, spróbuj ponownie za jakiś czas.";
const Resend$7 = "Prześlij ponownie";
const Login$7 = "Logowanie";
const weHaveSentVerificationLinkAtEmail$7 = "Wysłaliśmy Ci link weryfikacyjny na Twój adres e-mail.";
const pleaseVerifyEmailContinueSpam$7 = "Proszę zweryfikować swój adres e-mail, aby kontynuować. Proszę również sprawdzić folder spam lub promocje w poszukiwaniu wiadomości z linkiem weryfikacyjnym.";
const Logintogetstarted$7 = "Zaloguj się, aby rozpocząć.";
const ContinuewithGoogle$7 = "Kontynuuj z Google";
const pleaseInputEmail$7 = "Proszę podać swój adres e-mail!";
const Password$7 = "Hasło";
const pleaseInputPassword$7 = "Proszę wprowadzić swoje hasło!";
const passwordLowerUpperDigitSpecial$7 = "Twoje hasło musi zawierać przynajmniej jedną małą literę, jedną dużą literę, cyfrę i znak specjalny.";
const atLeastSixChar$7 = "Przynajmniej 6 znaków.";
const forgotPassword$7 = "Zapomniałeś hasła?";
const Bysigninginyouagreetoour$7 = "Logując się, zgadzasz się na nasze";
const Terms$7 = "Warunki";
const Conditions$7 = "Warunki";
const and$7 = "i";
const PrivacyPolicy$7 = "Polityka prywatności";
const theseAreTheTopsSkillsExtracted$7 = "To są najważniejsze umiejętności wyodrębnione z opisu pracy.";
const TopSkills$7 = "Najważniejsze umiejętności";
const weCoulNotExtractSkills$7 = "Nie udało nam się wyodrębnić żadnych umiejętności z tego opisu pracy.";
const upgradeToPremiumToView$7 = "Zaktualizuj do Premium, aby zobaczyć wynik dopasowania umiejętności w Twoim CV";
const SkillScore$7 = "Ocena umiejętności";
const thisIsYourSkillScoreBasedOn$7 = "To jest Twój wynik umiejętności na podstawie opisu pracy i Twojego CV.";
const theseSkllsAreStrongMatch$7 = "Te umiejętności są silnym dopasowaniem między twoim CV a opisem pracy.";
const Strongmatch$7 = "Silne dopasowanie";
const theseSkillsArePartialMatch$7 = "Te umiejętności są częściowo dopasowane między twoim CV a opisem pracy.";
const Partialmatch$7 = "Częściowe dopasowanie";
const theseSkillsAreMissingFrom$7 = "Te słowa kluczowe brakują na twoim CV, ale są obecne w opisie pracy. Mogą to być umiejętności lub ogólne słowa kluczowe, które są specyficzne dla oferty pracy i mogą być przydatne do dodania do twojego CV.";
const SkillMatchComponent$7 = {
	removeSkill: "Jaka jest główna przyczyna zgłoszenia problemu dla tego słowa kluczowego"
};
const Optional$7 = "Opcjonalne";
const Notrelevanttothejob$7 = "Nieistotne dla pracy";
const Notaskill$7 = "Brak umiejętności";
const Toogeneric$7 = "Zbyt ogólne";
const Pleaseshareanyfeedback$7 = "Podziel się opinią";
const excludedKeywordsWillNot$7 = "Wykluczone słowa kluczowe nie będą wliczane do wyniku dopasowania podczas wszystkich przyszłych skanów. Możesz zmienić wykluczone słowa kluczowe w swoim profilu.";
const yesExcludeThisSkillFrom$7 = "Tak, wyklucz tę umiejętność ze wszystkich skanów mojego CV.";
const PartialMatch$7 = "Częściowe dopasowanie";
const MissingKeywords$7 = "Brakujące słowa kluczowe";
const Providetitletotask$7 = "Podaj tytuł zadania";
const TasksList$7 = "Lista zadań";
const AddTask$7 = "Dodaj zadanie";
const EnterTaskTitlehere$7 = "Wprowadź tytuł zadania tutaj";
const TasksComponent$7 = {
	listEmpty: "Lista zadań jest pusta, utwórz nowe."
};
const CompletedTasks$7 = "Zakończone zadania";
const CompleteYourtasks$7 = "Zakończ swoje zadania";
const Steps$7 = "Kroki";
const PremiumMember$7 = "Członek Premium";
const Thankyouforupgradingto$7 = "Dziękujemy za uaktualnienie do";
const CareerflowPremium$7 = "Kariera przepływ Premium";
const hereIsHowYouCanAccessPremium$7 = "Oto jak uzyskać dostęp do swoich korzyści Premium!";
const stepOne$7 = "Krok 1";
const DownloadourChromeExtension$7 = "Pobierz nasze rozszerzenie Chrome.";
const youJobSearchCopilotIshere$7 = "Twój współpilot sztucznej inteligencji w poszukiwaniach pracy jest tutaj.";
const DownloadNow$7 = "Pobierz teraz";
const stepTwo$7 = "Krok 2";
const GetStarted$7 = "Zacznij";
const stepThree$7 = "Krok 3";
const SignintoChromeExtension$7 = "Zaloguj się do rozszerzenia Chrome.";
const entityCreated$7 = "Nowy {{entity}} utworzony.";
const entityUpdated$7 = "{{entity}} zaktualizowane.";
const entityDeleted$7 = "{{entity}} usunięto.";
const entityLinked$7 = "{{entity}} połączony/a/y";
const entityUnlinked$7 = "{{entity}} odłączony";
const entityMovedTo$7 = "Przeniesiono do {{entity}}.";
const youAddedANewEntity$7 = "Dodałeś nową {{entity}}.";
const personCreated$7 = "{{creator}} stworzył {{entity}} dla {{owner}}.";
const youUpdatedAEntity$7 = "Zaktualizowałeś {{entity}}.";
const personUpdated$7 = "{{creator}} zaktualizował {{entity}} dla {{owner}}.";
const youDeletedAEntity$7 = "Usunąłeś {{entity}}.";
const personDeleted$7 = "{{creator}} usunął {{entity}} dla {{owner}}.";
const youLinkedEntity$7 = "Połączyłeś {{entity}} z tym zadaniem";
const personLinked$7 = "{{creator}} połączył {{entity}} z tym zadaniem dla {{owner}}.";
const youUnlinked$7 = "Odłączyłeś {{entity}} od tego zadania";
const personUnlinked$7 = "{{creator}} odlinkował {{entity}} od tego zadania dla {{owner}}.";
const youMovedEntity$7 = "Przeniosłeś ten {{entity}} z {{sectionFrom}} do {{sectionTo}}";
const personMoved$7 = "{{creator}} przeniósł ten {{entity}} z {{sectionFrom}} do {{sectionTo}} dla {{owner}}.";
const addedByName$7 = "Dodane przez {{name}}.";
const DownloadChromeExtension$7 = "Pobierz rozszerzenie Chrome";
const ourChromeExtensionIs$7 = "Nasze rozszerzenie Chrome to zintegrowane narzędzie, które pomoże Ci zoptymalizować profil LinkedIn, zapisać oferty pracy, kontakty, wygenerować list motywacyjny i wiele więcej.";
const Optimizeyourprofile$7 = "Optymalizuj swój profil.";
const startOptimizingYourProfile$7 = "Zacznij optymalizować swój profil, aby mieć lepsze szanse na kontaktowanie się przez rekruterów.";
const OptimizeNow$7 = "Optymalizuj teraz";
const Addyourfirstjob$7 = "Dodaj swoją pierwszą pracę.";
const startSavingJobApplicationsToTrack$7 = "Zacznij zapisywać aplikacje o pracę, aby śledzić swoją drogę poszukiwania pracy i znaleźć przydatne wnioski.";
const AddNow$7 = "Dodaj teraz";
const CompleteProfile$7 = "Pełny profil";
const completeYourProfileForUsing$7 = "Uzupełnij swój profil, aby korzystać z funkcji automatycznego wypełniania i uzyskać bardziej spersonalizowane doświadczenie.";
const CompleteNow$7 = "Zakończ teraz";
const Addyourfirstcontact$7 = "Dodaj swoje pierwsze kontakty.";
const addContactToFollowUpWith$7 = "Dodaj kontakt, aby móc się z nimi skontaktować w przyszłości, dodaj notatki i wiele więcej.";
const JoinCommunity$7 = "Dołącz do społeczności";
const ourCommunityisAlways$7 = "Nasza społeczność zawsze jest z tobą podczas twojej drogi poszukiwania pracy.";
const JoinNow$7 = "Dołącz teraz";
const welcomeToCareerflow$7 = "Witaj w Careerflow!";
const yourHubForCareerInsights2$7 = "To jest Twoje centrum wiedzy o karierze, aktywnościach i nie tylko. Przeglądaj swoją spersonalizowaną tablicę, aby być na bieżąco z Twoją drogą zawodową.";
const ChecklistCompleted$7 = "Twoja lista kontrolna jest ukończona!";
const Completeyourchecklist$7 = "Uzupełnij swoją listę kontrolną";
const completeAFewStepsTo$7 = "Wykonaj kilka kroków, aby zdobyć swoją następną pracę.";
const Completed$7 = "Zakończone";
const JobCountByStage$7 = "Liczba zadań według etapu";
const NopastapplicationDatafound$7 = "Nie znaleziono danych dotyczących poprzednich aplikacji.";
const YourJobSearchStages$7 = "Etapy poszukiwania pracy";
const NoDatafound$7 = "Nie znaleziono danych.";
const pl = {
	copyToClipboard: copyToClipboard$7,
	UnlocktheAIgenerated: UnlocktheAIgenerated$7,
	UpgradetoPremium: UpgradetoPremium$7,
	Result: Result$7,
	Copy: Copy$7,
	Save: Save$7,
	Edit: Edit$7,
	Processing: Processing$7,
	YourAIgeneratedcontentwillshowhere: YourAIgeneratedcontentwillshowhere$7,
	hopeYouFindUseful: hopeYouFindUseful$7,
	regenerate: regenerate$7,
	ProvideAdditionalFeedback: ProvideAdditionalFeedback$7,
	Enteranyfeedback: Enteranyfeedback$7,
	Notimpressive: Notimpressive$7,
	thisIsntTrue: thisIsntTrue$7,
	Notpersonalized: Notpersonalized$7,
	Tone: Tone$7,
	Length: Length$7,
	Template: Template$7,
	Generatedon: Generatedon$7,
	Copiedtoclipboard: Copiedtoclipboard$7,
	CopytoClipboard: CopytoClipboard$7,
	DownloadasPDF: DownloadasPDF$7,
	ViewDetails: ViewDetails$7,
	JobDescriptionImported: JobDescriptionImported$7,
	ImportfromJob: ImportfromJob$7,
	Saved: Saved$7,
	Applied: Applied$7,
	Offer: Offer$7,
	Interviewing: Interviewing$7,
	Rejected: Rejected$7,
	Search: Search$7,
	Import: Import$7,
	CoverLetterGeneratorHistory: CoverLetterGeneratorHistory$7,
	NoCoverLettersGenerated: NoCoverLettersGenerated$7,
	getStartedCoverLetter: getStartedCoverLetter$7,
	getStarted: getStarted$7,
	Documents: Documents$7,
	UploadNewDocument: UploadNewDocument$7,
	AICoverLetterGenerator: AICoverLetterGenerator$7,
	ViewHistory: ViewHistory$7,
	JobDescription: JobDescription$7,
	ImportfromBoard: ImportfromBoard$7,
	EnterJobDescription: EnterJobDescription$7,
	JobTitle: JobTitle$7,
	EnterJobTitle: EnterJobTitle$7,
	CompanyName: CompanyName$7,
	EnterCompanyName: EnterCompanyName$7,
	YourProfile: YourProfile$7,
	ResumeUpload: ResumeUpload$7,
	UseLinkedinProfile: UseLinkedinProfile$7,
	Uploadyourresume: Uploadyourresume$7,
	AddyourResume: AddyourResume$7,
	fileNameCannotFormat: fileNameCannotFormat$7,
	ChooseorUpload: ChooseorUpload$7,
	SelectTemplate: SelectTemplate$7,
	Preview: Preview$7,
	UseTemplate: UseTemplate$7,
	Change: Change$7,
	AdvancedSettings: AdvancedSettings$7,
	AdditionalContext: AdditionalContext$7,
	Professional: Professional$7,
	Casual: Casual$7,
	Enthusiastic: Enthusiastic$7,
	Informational: Informational$7,
	Short: Short$7,
	Medium: Medium$7,
	Long: Long$7,
	Language: Language$7,
	iAmOkayBack: iAmOkayBack$7,
	Generate: Generate$7,
	CoverLetter: CoverLetter$7,
	SelectLanguage: SelectLanguage$7,
	AboutGeneratorHistory: AboutGeneratorHistory$7,
	NoAboutsGenerated: NoAboutsGenerated$7,
	getStartedAbouts: getStartedAbouts$7,
	noAttachmentsFound: noAttachmentsFound$7,
	TargetJobTitle: TargetJobTitle$7,
	KeywordsToInclude: KeywordsToInclude$7,
	UploadYourResume: UploadYourResume$7,
	AddYourResume: AddYourResume$7,
	LinkedinProfile: LinkedinProfile$7,
	Linkedinprofilenotfound: Linkedinprofilenotfound$7,
	startUsingChromeExtension: startUsingChromeExtension$7,
	Download: Download$7,
	UseEmojis: UseEmojis$7,
	UseBulletPoints: UseBulletPoints$7,
	SpeechFocus: SpeechFocus$7,
	FirstPerson: FirstPerson$7,
	ThirdPerson: ThirdPerson$7,
	HeadlineGeneratorHistory: HeadlineGeneratorHistory$7,
	NoHeadlinesGenerated: NoHeadlinesGenerated$7,
	getStartedHeadline: getStartedHeadline$7,
	AIHeadlineGenerator: AIHeadlineGenerator$7,
	KeywordstoInclude: KeywordstoInclude$7,
	Pressenteraftereachword: Pressenteraftereachword$7,
	LinkedinProfilenotfound: LinkedinProfilenotfound$7,
	Headline: Headline$7,
	PostGeneratorHistory: PostGeneratorHistory$7,
	NoPostsGenerated: NoPostsGenerated$7,
	getStartedPost: getStartedPost$7,
	Topic: Topic$7,
	Description: Description$7,
	UseHashtags: UseHashtags$7,
	Custom: Custom$7,
	EnterCustomTone: EnterCustomTone$7,
	Added: Added$7,
	ComingSoon: ComingSoon$7,
	Company: Company$7,
	JobInterview: JobInterview$7,
	Research: Research$7,
	Networking: Networking$7,
	Referral: Referral$7,
	MustbeContacted: MustbeContacted$7,
	ScheduleaMeeting: ScheduleaMeeting$7,
	needAFollowUp: needAFollowUp$7,
	Today: Today$7,
	Viewdetails: Viewdetails$7,
	Activity: Activity$7,
	ActivityDetails: ActivityDetails$7,
	Delete: Delete$7,
	Title: Title$7,
	Goal: Goal$7,
	Status: Status$7,
	FollowUp: FollowUp$7,
	AddActivity: AddActivity$7,
	Enteractivitytitle: Enteractivitytitle$7,
	Cancel: Cancel$7,
	SaveActivity: SaveActivity$7,
	noActivityPresent: noActivityPresent$7,
	Addnew: Addnew$7,
	About: About$7,
	noDataPresentYou: noDataPresentYou$7,
	Experience: Experience$7,
	Education: Education$7,
	Skills: Skills$7,
	Overview: Overview$7,
	LinkedJobs: LinkedJobs$7,
	Notes: Notes$7,
	FullName: FullName$7,
	Location: Location$7,
	Relationship: Relationship$7,
	Contacts: Contacts$7,
	CreateContact: CreateContact$7,
	NotesCreated: NotesCreated$7,
	Notesupdated: Notesupdated$7,
	Addnote: Addnote$7,
	areYouSureDeleteNote: areYouSureDeleteNote$7,
	Createdby: Createdby$7,
	notSureWhyResumeCalls: notSureWhyResumeCalls$7,
	getExpertResumeReview: getExpertResumeReview$7,
	youHaventAddedContacts: youHaventAddedContacts$7,
	noMatchingContacts: noMatchingContacts$7,
	Link: Link$7,
	unlink: unlink$7,
	Locationnotavailable: Locationnotavailable$7,
	Emailnotavailable: Emailnotavailable$7,
	PhoneNumbernotavailable: PhoneNumbernotavailable$7,
	createdby: createdby$7,
	areYouSureDeleteContact: areYouSureDeleteContact$7,
	areYouSureUnlinkContact: areYouSureUnlinkContact$7,
	Addedbyyou: Addedbyyou$7,
	Addedby: Addedby$7,
	Timeline: Timeline$7,
	Timelineempty: Timelineempty$7,
	Discard: Discard$7,
	SaveContact: SaveContact$7,
	Recruiter: Recruiter$7,
	Candidate: Candidate$7,
	Colleague: Colleague$7,
	Employee: Employee$7,
	"Needtofollow-up": "Trzeba podążać za",
	EnterValidEmail: EnterValidEmail$7,
	EnterValidPhoneNumber: EnterValidPhoneNumber$7,
	editingProfileNotAvailable: editingProfileNotAvailable$7,
	itWillBeSoonAvailable: itWillBeSoonAvailable$7,
	ChromeExtension: ChromeExtension$7,
	SelectTag: SelectTag$7,
	FirstName: FirstName$7,
	FirstNameisrequired: FirstNameisrequired$7,
	LastName: LastName$7,
	LastNameisrequired: LastNameisrequired$7,
	Companyisrequired: Companyisrequired$7,
	Email: Email$7,
	ThisisnotavalidEmail: ThisisnotavalidEmail$7,
	AddEmail: AddEmail$7,
	PhoneNumber: PhoneNumber$7,
	notaValidPhone: notaValidPhone$7,
	phoneNoMinimum5char: phoneNoMinimum5char$7,
	phoneNoMinumum15char: phoneNoMinumum15char$7,
	AddPhoneNumber: AddPhoneNumber$7,
	SelectGoal: SelectGoal$7,
	SelectStatus: SelectStatus$7,
	Followup: Followup$7,
	SocialMedia: SocialMedia$7,
	Linkedinhandle: Linkedinhandle$7,
	Twitterhandle: Twitterhandle$7,
	Facebookhandle: Facebookhandle$7,
	Githubhandle: Githubhandle$7,
	Gmailhandle: Gmailhandle$7,
	Changessavedsuccessfully: Changessavedsuccessfully$7,
	EditContact: EditContact$7,
	BasicInformation: BasicInformation$7,
	EditContactDetails: EditContactDetails$7,
	SaveChanges: SaveChanges$7,
	phoneNoMinimum14char: phoneNoMinimum14char$7,
	LinkedIn: LinkedIn$7,
	Twitter: Twitter$7,
	Facebook: Facebook$7,
	Github: Github$7,
	Gmail: Gmail$7,
	youCanWriteAbout: youCanWriteAbout$7,
	Addednewsection: Addednewsection$7,
	Removedsuccessfully: Removedsuccessfully$7,
	Remove: Remove$7,
	Institute: Institute$7,
	Schoolisrequired: Schoolisrequired$7,
	Degree: Degree$7,
	StartMonth: StartMonth$7,
	StartYear: StartYear$7,
	EndMonth: EndMonth$7,
	EndYear: EndYear$7,
	Addmore: Addmore$7,
	PositionTitle: PositionTitle$7,
	ExperienceType: ExperienceType$7,
	Addednewitem: Addednewitem$7,
	whatSkillsDoYouEnjoy: whatSkillsDoYouEnjoy$7,
	Typeskillshere: Typeskillshere$7,
	LinkedContacts: LinkedContacts$7,
	LinkContact: LinkContact$7,
	NocontactsLinked: NocontactsLinked$7,
	JobContactsComponent: JobContactsComponent$7,
	Nocontacts: Nocontacts$7,
	LinkJobto: LinkJobto$7,
	Contact: Contact$7,
	Document: Document$7,
	Nojobsfound: Nojobsfound$7,
	LinkJob: LinkJob$7,
	youCanLinkContactJobImported: youCanLinkContactJobImported$7,
	Prev: Prev$7,
	Next: Next$7,
	areYouSureUnlinkDocument: areYouSureUnlinkDocument$7,
	areYouSureDeleteDocument: areYouSureDeleteDocument$7,
	Category: Category$7,
	CreatedOn: CreatedOn$7,
	Joblinked: Joblinked$7,
	Quickactions: Quickactions$7,
	All: All$7,
	Resume: Resume$7,
	Portfolio: Portfolio$7,
	Other: Other$7,
	Adddocument: Adddocument$7,
	Type: Type$7,
	Sortingby: Sortingby$7,
	SwitchtoGridLayout: SwitchtoGridLayout$7,
	SwitchtoListLayout: SwitchtoListLayout$7,
	NoDocumentsAdded: NoDocumentsAdded$7,
	DocumentsComponent: DocumentsComponent$7,
	NoDocumentFound: NoDocumentFound$7,
	SelectFile: SelectFile$7,
	onlyPdfDocxSupported: onlyPdfDocxSupported$7,
	Uploadfile: Uploadfile$7,
	DocumentCategory: DocumentCategory$7,
	SaveDocument: SaveDocument$7,
	AddDocument: AddDocument$7,
	LinkedDocuments: LinkedDocuments$7,
	LinkDocument: LinkDocument$7,
	NodocumentsLinked: NodocumentsLinked$7,
	JobDocumentsComponent: JobDocumentsComponent$7,
	NoDocuments: NoDocuments$7,
	CreateDocuments: CreateDocuments$7,
	youCanLinkDocumentJobImported: youCanLinkDocumentJobImported$7,
	Documenteditedsuccessfully: Documenteditedsuccessfully$7,
	DocumentDetails: DocumentDetails$7,
	UnsavedChanges: UnsavedChanges$7,
	yourChangesWillBeLostSureClose: yourChangesWillBeLostSureClose$7,
	yourChangesWillBeLostSureDiscard: yourChangesWillBeLostSureDiscard$7,
	DiscardChanges: DiscardChanges$7,
	WeeklyGoalAlert: WeeklyGoalAlert$7,
	Progress: Progress$7,
	AllGoals: AllGoals$7,
	Name: Name$7,
	Completedon: Completedon$7,
	Createdon: Createdon$7,
	Action: Action$7,
	Back: Back$7,
	OverallScore: OverallScore$7,
	Aboutthegoal: Aboutthegoal$7,
	GoalTracking: GoalTracking$7,
	Week: Week$7,
	progress: progress$7,
	loading: loading$7,
	Apply: Apply$7,
	Thisskillhasbeenreported: Thisskillhasbeenreported$7,
	issueGettingResume: issueGettingResume$7,
	Interview: Interview$7,
	Tasks: Tasks$7,
	Loading: Loading$7,
	Skilladdedsuccessfully: Skilladdedsuccessfully$7,
	problemAddingSkill: problemAddingSkill$7,
	Reportaproblem: Reportaproblem$7,
	Submit: Submit$7,
	Addanewskill: Addanewskill$7,
	JobDetailsComponent: JobDetailsComponent$7,
	HardSkill: HardSkill$7,
	SoftSkill: SoftSkill$7,
	Pleaseshareanyadditionalcontext: Pleaseshareanyadditionalcontext$7,
	Addasskill: Addasskill$7,
	Skill: Skill$7,
	JobFrequency: JobFrequency$7,
	ResumeFrequency: ResumeFrequency$7,
	Reportskill: Reportskill$7,
	JobDetails: JobDetails$7,
	ViewJobLink: ViewJobLink$7,
	Salary: Salary$7,
	areYouSureDeleteJob: areYouSureDeleteJob$7,
	ViewMore: ViewMore$7,
	ViewLess: ViewLess$7,
	matchYouSkillsAgainstJob: matchYouSkillsAgainstJob$7,
	pleaseUploadResumeSkillMatch: pleaseUploadResumeSkillMatch$7,
	AddResume: AddResume$7,
	thisJobDoesNotHaveAnyDesc: thisJobDoesNotHaveAnyDesc$7,
	youCanEditJobToAdd: youCanEditJobToAdd$7,
	chromeextension: chromeextension$7,
	fromVariousJobPortalsOnce: fromVariousJobPortalsOnce$7,
	AddDescription: AddDescription$7,
	CompanyInfo: CompanyInfo$7,
	Website: Website$7,
	Industry: Industry$7,
	EmployeeCount: EmployeeCount$7,
	ExprienceLevel: ExprienceLevel$7,
	Address: Address$7,
	Resumes: Resumes$7,
	Setasdefault: Setasdefault$7,
	Ok: Ok$7,
	UploadNewResume: UploadNewResume$7,
	Default: Default$7,
	Jobnotfound: Jobnotfound$7,
	EditDetails: EditDetails$7,
	JobPostURL: JobPostURL$7,
	Enterjoburl: Enterjoburl$7,
	Nojobselected: Nojobselected$7,
	Viewjobdetails: Viewjobdetails$7,
	Jobaddedtoyourboardsuccessfully: Jobaddedtoyourboardsuccessfully$7,
	AddJob: AddJob$7,
	Addnewjobname: Addnewjobname$7,
	JobUrl: JobUrl$7,
	Addjoburl: Addjoburl$7,
	Section: Section$7,
	didYouKnow: didYouKnow$7,
	Jobs: Jobs$7,
	AddJobtoboard: AddJobtoboard$7,
	Currentlynojobsareavailable: Currentlynojobsareavailable$7,
	noMatchingJobs: noMatchingJobs$7,
	welcomeToYourPersonalJobTracker: welcomeToYourPersonalJobTracker$7,
	weShortTutorialOnHowTrackingJob: weShortTutorialOnHowTrackingJob$7,
	Addanewjob: Addanewjob$7,
	inOrderTrackCreatButton: inOrderTrackCreatButton$7,
	Providesomedetails: Providesomedetails$7,
	toBeginTypeJobTitleCompany: toBeginTypeJobTitleCompany$7,
	asAnExampleFilledForYou: asAnExampleFilledForYou$7,
	wohooAddedFirstJob: wohooAddedFirstJob$7,
	youCanDragDropJobCard: youCanDragDropJobCard$7,
	Lastbutnotleast: Lastbutnotleast$7,
	finalStepMakeSure: finalStepMakeSure$7,
	autoMaticallyImportJobs: autoMaticallyImportJobs$7,
	selectanysection: selectanysection$7,
	Accept: Accept$7,
	My2023JobSearch: My2023JobSearch$7,
	AddedFrom: AddedFrom$7,
	AddedUntil: AddedUntil$7,
	BasicModal: BasicModal$7,
	AddnewSectionName: AddnewSectionName$7,
	OpenTo: OpenTo$7,
	Featured: Featured$7,
	LicenceAndCerts: LicenceAndCerts$7,
	Banner: Banner$7,
	LinkedInURL: LinkedInURL$7,
	Recommendations: Recommendations$7,
	LinkedinReview: LinkedinReview$7,
	NoDataAvailable: NoDataAvailable$7,
	looksLikeYouDidNot: looksLikeYouDidNot$7,
	toOptimizeProfileScoreVisible: toOptimizeProfileScoreVisible$7,
	LinkedinComponent: LinkedinComponent$7,
	improveYourChancesLandingDreamJob: improveYourChancesLandingDreamJob$7,
	VisitProfile: VisitProfile$7,
	wantToGetLinkedinMakeover: wantToGetLinkedinMakeover$7,
	PostGenerator: PostGenerator$7,
	LinkedinHeadlineGenerator: LinkedinHeadlineGenerator$7,
	LinkedinAboutSectionGenerator: LinkedinAboutSectionGenerator$7,
	AITools: AITools$7,
	Premium: Premium$7,
	LinkedInOptimization: LinkedInOptimization$7,
	JobTracker: JobTracker$7,
	whoIsHiring: whoIsHiring$7,
	Autofill: Autofill$7,
	HeadlineGenerator: HeadlineGenerator$7,
	skillMatching: skillMatching$7,
	SummarizeJD: SummarizeJD$7,
	contactFeature: contactFeature$7,
	documentFeature: documentFeature$7,
	landJobWithoutStress: landJobWithoutStress$7,
	discoverFeatures: discoverFeatures$7,
	letsBeginOnboarding: letsBeginOnboarding$7,
	inTheNextFewScreensJobThirdParties: inTheNextFewScreensJobThirdParties$7,
	letsAddBasicInformation: letsAddBasicInformation$7,
	Pleaseselectanoptionfirst: Pleaseselectanoptionfirst$7,
	JobApplicationTracker: JobApplicationTracker$7,
	LinkedInProfileOptimizer: LinkedInProfileOptimizer$7,
	UnlimitedDocuments: UnlimitedDocuments$7,
	UnlimitedContacts: UnlimitedContacts$7,
	HiringManagerSearch: HiringManagerSearch$7,
	AILinkedInPostGenerator: AILinkedInPostGenerator$7,
	ATSKeywordSkillMatch: ATSKeywordSkillMatch$7,
	"Auto-Apply": "Automatyczne zastosowanie",
	ChooseyourPlan: ChooseyourPlan$7,
	superChargeYourJobSearch: superChargeYourJobSearch$7,
	startNowGoto: startNowGoto$7,
	CreatedBy: CreatedBy$7,
	CreateNewNote: CreateNewNote$7,
	Nonotescreated: Nonotescreated$7,
	approxTimeIsFourMinutes: approxTimeIsFourMinutes$7,
	Continue: Continue$7,
	iWillDoLaterTakeMeToApp: iWillDoLaterTakeMeToApp$7,
	allDone: allDone$7,
	welcomeAbord: welcomeAbord$7,
	letsBegin: letsBegin$7,
	UpgradeyourplanandgetAIAssistance: UpgradeyourplanandgetAIAssistance$7,
	DownloadPDF: DownloadPDF$7,
	oopsWeCouldntProcessResume: oopsWeCouldntProcessResume$7,
	MyProfile: MyProfile$7,
	Setting: Setting$7,
	Logout: Logout$7,
	SignIn: SignIn$7,
	Typeyourfirstnamehere: Typeyourfirstnamehere$7,
	Enteryourlastname: Enteryourlastname$7,
	ManageSubscription: ManageSubscription$7,
	ifYouHaveDifficultiesProfile: ifYouHaveDifficultiesProfile$7,
	forSupport: forSupport$7,
	whatIsIdealCompanySize: whatIsIdealCompanySize$7,
	Saveandcontinue: Saveandcontinue$7,
	whatIsMinExpectedSalary: whatIsMinExpectedSalary$7,
	Atleast: Atleast$7,
	SlidetoAdjust: SlidetoAdjust$7,
	whatIndustryExcitedWork: whatIndustryExcitedWork$7,
	Add: Add$7,
	statusOfJobSearch: statusOfJobSearch$7,
	Finish: Finish$7,
	whatLevelRoleLooking: whatLevelRoleLooking$7,
	Selectuptotwo: Selectuptotwo$7,
	PreviousStep: PreviousStep$7,
	Skip: Skip$7,
	whatDoYouValueNewRole: whatDoYouValueNewRole$7,
	Selectuptothree: Selectuptothree$7,
	EqualEmploymentData: EqualEmploymentData$7,
	whatIsYourEthnicity: whatIsYourEthnicity$7,
	areYouAuthorizedToWorkUs: areYouAuthorizedToWorkUs$7,
	willYouRequireSponsorShip: willYouRequireSponsorShip$7,
	doYouHaveADisability: doYouHaveADisability$7,
	areYouAVeteran: areYouAVeteran$7,
	rolesYouInterestedIn: rolesYouInterestedIn$7,
	Selectuptofive: Selectuptofive$7,
	AddCustomrole: AddCustomrole$7,
	whereDoYouLikeWork: whereDoYouLikeWork$7,
	Resources: Resources$7,
	currentlyNoResourceAvailable: currentlyNoResourceAvailable$7,
	AddNewSection: AddNewSection$7,
	ChangeSections: ChangeSections$7,
	Settings: Settings$7,
	Dashboard: Dashboard$7,
	JobBoard: JobBoard$7,
	Linkedin: Linkedin$7,
	Community: Community$7,
	FindRecruiters: FindRecruiters$7,
	Goals: Goals$7,
	DownloadExtension: DownloadExtension$7,
	SuggestaFeature: SuggestaFeature$7,
	leftPanel: leftPanel$7,
	PhoneNumberisrequired: PhoneNumberisrequired$7,
	MobileNumber: MobileNumber$7,
	Enteronlynumbers: Enteronlynumbers$7,
	Countryyoulivein: Countryyoulivein$7,
	SelectaCountry: SelectaCountry$7,
	DateofBirth: DateofBirth$7,
	Gender: Gender$7,
	JobPreferences: JobPreferences$7,
	pleaseEnterValidEmail: pleaseEnterValidEmail$7,
	emailSendForResetting: emailSendForResetting$7,
	VerifyyourEmailID: VerifyyourEmailID$7,
	sentPleaseCheckEmail: sentPleaseCheckEmail$7,
	tooManyAttemptsTryAgain: tooManyAttemptsTryAgain$7,
	Resend: Resend$7,
	Login: Login$7,
	weHaveSentVerificationLinkAtEmail: weHaveSentVerificationLinkAtEmail$7,
	pleaseVerifyEmailContinueSpam: pleaseVerifyEmailContinueSpam$7,
	Logintogetstarted: Logintogetstarted$7,
	ContinuewithGoogle: ContinuewithGoogle$7,
	pleaseInputEmail: pleaseInputEmail$7,
	Password: Password$7,
	pleaseInputPassword: pleaseInputPassword$7,
	passwordLowerUpperDigitSpecial: passwordLowerUpperDigitSpecial$7,
	atLeastSixChar: atLeastSixChar$7,
	forgotPassword: forgotPassword$7,
	Bysigninginyouagreetoour: Bysigninginyouagreetoour$7,
	Terms: Terms$7,
	Conditions: Conditions$7,
	and: and$7,
	PrivacyPolicy: PrivacyPolicy$7,
	theseAreTheTopsSkillsExtracted: theseAreTheTopsSkillsExtracted$7,
	TopSkills: TopSkills$7,
	weCoulNotExtractSkills: weCoulNotExtractSkills$7,
	upgradeToPremiumToView: upgradeToPremiumToView$7,
	SkillScore: SkillScore$7,
	thisIsYourSkillScoreBasedOn: thisIsYourSkillScoreBasedOn$7,
	theseSkllsAreStrongMatch: theseSkllsAreStrongMatch$7,
	Strongmatch: Strongmatch$7,
	theseSkillsArePartialMatch: theseSkillsArePartialMatch$7,
	Partialmatch: Partialmatch$7,
	theseSkillsAreMissingFrom: theseSkillsAreMissingFrom$7,
	"Missing Keywords": "Brakujące słowa kluczowe",
	SkillMatchComponent: SkillMatchComponent$7,
	Optional: Optional$7,
	Notrelevanttothejob: Notrelevanttothejob$7,
	Notaskill: Notaskill$7,
	Toogeneric: Toogeneric$7,
	Pleaseshareanyfeedback: Pleaseshareanyfeedback$7,
	excludedKeywordsWillNot: excludedKeywordsWillNot$7,
	yesExcludeThisSkillFrom: yesExcludeThisSkillFrom$7,
	PartialMatch: PartialMatch$7,
	MissingKeywords: MissingKeywords$7,
	Providetitletotask: Providetitletotask$7,
	TasksList: TasksList$7,
	AddTask: AddTask$7,
	EnterTaskTitlehere: EnterTaskTitlehere$7,
	TasksComponent: TasksComponent$7,
	CompletedTasks: CompletedTasks$7,
	CompleteYourtasks: CompleteYourtasks$7,
	Steps: Steps$7,
	PremiumMember: PremiumMember$7,
	Thankyouforupgradingto: Thankyouforupgradingto$7,
	CareerflowPremium: CareerflowPremium$7,
	hereIsHowYouCanAccessPremium: hereIsHowYouCanAccessPremium$7,
	stepOne: stepOne$7,
	DownloadourChromeExtension: DownloadourChromeExtension$7,
	youJobSearchCopilotIshere: youJobSearchCopilotIshere$7,
	DownloadNow: DownloadNow$7,
	stepTwo: stepTwo$7,
	GetStarted: GetStarted$7,
	stepThree: stepThree$7,
	SignintoChromeExtension: SignintoChromeExtension$7,
	entityCreated: entityCreated$7,
	entityUpdated: entityUpdated$7,
	entityDeleted: entityDeleted$7,
	entityLinked: entityLinked$7,
	entityUnlinked: entityUnlinked$7,
	entityMovedTo: entityMovedTo$7,
	youAddedANewEntity: youAddedANewEntity$7,
	personCreated: personCreated$7,
	youUpdatedAEntity: youUpdatedAEntity$7,
	personUpdated: personUpdated$7,
	youDeletedAEntity: youDeletedAEntity$7,
	personDeleted: personDeleted$7,
	youLinkedEntity: youLinkedEntity$7,
	personLinked: personLinked$7,
	youUnlinked: youUnlinked$7,
	personUnlinked: personUnlinked$7,
	youMovedEntity: youMovedEntity$7,
	personMoved: personMoved$7,
	addedByName: addedByName$7,
	DownloadChromeExtension: DownloadChromeExtension$7,
	ourChromeExtensionIs: ourChromeExtensionIs$7,
	Optimizeyourprofile: Optimizeyourprofile$7,
	startOptimizingYourProfile: startOptimizingYourProfile$7,
	OptimizeNow: OptimizeNow$7,
	Addyourfirstjob: Addyourfirstjob$7,
	startSavingJobApplicationsToTrack: startSavingJobApplicationsToTrack$7,
	AddNow: AddNow$7,
	CompleteProfile: CompleteProfile$7,
	completeYourProfileForUsing: completeYourProfileForUsing$7,
	CompleteNow: CompleteNow$7,
	Addyourfirstcontact: Addyourfirstcontact$7,
	addContactToFollowUpWith: addContactToFollowUpWith$7,
	JoinCommunity: JoinCommunity$7,
	ourCommunityisAlways: ourCommunityisAlways$7,
	JoinNow: JoinNow$7,
	welcomeToCareerflow: welcomeToCareerflow$7,
	yourHubForCareerInsights2: yourHubForCareerInsights2$7,
	ChecklistCompleted: ChecklistCompleted$7,
	Completeyourchecklist: Completeyourchecklist$7,
	completeAFewStepsTo: completeAFewStepsTo$7,
	Completed: Completed$7,
	JobCountByStage: JobCountByStage$7,
	NopastapplicationDatafound: NopastapplicationDatafound$7,
	YourJobSearchStages: YourJobSearchStages$7,
	NoDatafound: NoDatafound$7
};

const copyToClipboard$6 = "Copiado para a área de transferência!";
const UnlocktheAIgenerated$6 = "Desbloqueie o gerado por IA";
const UpgradetoPremium$6 = "Atualize para Premium";
const Result$6 = "Resultado";
const Copy$6 = "Copiar";
const Save$6 = "Salvar";
const Edit$6 = "Editar";
const Processing$6 = "Processando";
const YourAIgeneratedcontentwillshowhere$6 = "Seu conteúdo gerado por IA será exibido aqui";
const hopeYouFindUseful$6 = "Espero que você ache este resultado útil!";
const regenerate$6 = "Regenerar";
const ProvideAdditionalFeedback$6 = "Fornecer Feedback Adicional";
const Enteranyfeedback$6 = "Digite qualquer feedback";
const Notimpressive$6 = "Não impressionante";
const thisIsntTrue$6 = "Isso não é verdade";
const Notpersonalized$6 = "Não personalizado";
const Tone$6 = "Tom";
const Length$6 = "Comprimento";
const Template$6 = "Modelo";
const Generatedon$6 = "Gerado em";
const Copiedtoclipboard$6 = "Copiado para a área de transferência";
const CopytoClipboard$6 = "Copiar para a Área de Transferência";
const DownloadasPDF$6 = "Baixar como PDF";
const ViewDetails$6 = "Ver Detalhes";
const JobDescriptionImported$6 = "Descrição do trabalho importada";
const ImportfromJob$6 = "Importar do trabalho";
const Saved$6 = "Salvo";
const Applied$6 = "Aplicado";
const Offer$6 = "Oferta";
const Interviewing$6 = "Entrevistando";
const Rejected$6 = "Rejeitado";
const Search$6 = "Buscar";
const Import$6 = "Importar";
const CoverLetterGeneratorHistory$6 = "Histórico do Gerador de Cartas de Apresentação";
const NoCoverLettersGenerated$6 = "Nenhuma Carta de Apresentação Gerada";
const getStartedCoverLetter$6 = "Você ainda não gerou nenhuma carta de apresentação. Comece e tenha cartas de apresentação correspondendo à descrição do trabalho com sua experiência relevante.";
const getStarted$6 = "Começar!";
const Documents$6 = "Documentos";
const UploadNewDocument$6 = "Enviar Novo Documento";
const AICoverLetterGenerator$6 = "Gerador de Cartas de Apresentação com Inteligência Artificial";
const ViewHistory$6 = "Ver Histórico";
const JobDescription$6 = "Descrição do Trabalho";
const ImportfromBoard$6 = "Importar do Quadro";
const EnterJobDescription$6 = "Digite a Descrição do Trabalho";
const JobTitle$6 = "Cargo";
const EnterJobTitle$6 = "Digite o Cargo";
const CompanyName$6 = "Nome da Empresa";
const EnterCompanyName$6 = "Digite o Nome da Empresa";
const YourProfile$6 = "Seu Perfil";
const ResumeUpload$6 = "Enviar Currículo";
const UseLinkedinProfile$6 = "Usar Perfil do Linkedin";
const Uploadyourresume$6 = "Envie seu currículo";
const AddyourResume$6 = "Adicione seu Currículo";
const fileNameCannotFormat$6 = "Os nomes de arquivo não podem conter espaços ou underscores e devem estar em .doc, .docx ou .pdf.";
const ChooseorUpload$6 = "Escolher ou Enviar";
const SelectTemplate$6 = "Selecionar Modelo";
const Preview$6 = "Visualizar";
const UseTemplate$6 = "Usar Modelo";
const Change$6 = "Alterar";
const AdvancedSettings$6 = "Configurações Avançadas";
const AdditionalContext$6 = "Contexto Adicional";
const Professional$6 = "Profissional";
const Casual$6 = "Informal";
const Enthusiastic$6 = "Entusiástico";
const Informational$6 = "Informativo";
const Short$6 = "Curto";
const Medium$6 = "Médio";
const Long$6 = "Longo";
const Language$6 = "Idioma";
const iAmOkayBack$6 = "Está bem! Voltar";
const Generate$6 = "Gerar";
const CoverLetter$6 = "Carta de Apresentação";
const SelectLanguage$6 = "Selecionar Idioma";
const AboutGeneratorHistory$6 = "Histórico do Gerador de Sobre";
const NoAboutsGenerated$6 = "Nenhum Sobre Gerado";
const getStartedAbouts$6 = "Você ainda não gerou nenhum sobre. Comece e tenha sobres correspondendo à descrição do trabalho com sua experiência relevante.";
const noAttachmentsFound$6 = "Nenhum anexo encontrado.";
const TargetJobTitle$6 = "Cargo Alvo";
const KeywordsToInclude$6 = "Palavras-chave a incluir";
const UploadYourResume$6 = "Carregue seu currículo";
const AddYourResume$6 = "Adicione seu currículo";
const LinkedinProfile$6 = "Perfil do Linkedin";
const Linkedinprofilenotfound$6 = "Perfil do Linkedin não encontrado";
const startUsingChromeExtension$6 = "Comece a otimizar seu perfil do Linkedin usando nossa extensão para Chrome para usar esta opção.";
const Download$6 = "Baixar";
const UseEmojis$6 = "Usar Emojis";
const UseBulletPoints$6 = "Usar Marcadores";
const SpeechFocus$6 = "Foco do Discurso";
const FirstPerson$6 = "Primeira Pessoa";
const ThirdPerson$6 = "Terceira Pessoa";
const HeadlineGeneratorHistory$6 = "Histórico do Gerador de Manchetes";
const NoHeadlinesGenerated$6 = "Nenhuma Manchete Gerada";
const getStartedHeadline$6 = "Você ainda não gerou nenhuma manchete. Comece e tenha manchetes correspondendo à descrição do trabalho com sua experiência relevante.";
const AIHeadlineGenerator$6 = "Gerador de Manchetes com Inteligência Artificial";
const KeywordstoInclude$6 = "Palavras-chave para Incluir";
const Pressenteraftereachword$6 = "Pressione enter após cada palavra";
const LinkedinProfilenotfound$6 = "Perfil do LinkedIn não encontrado";
const Headline$6 = "Manchete";
const PostGeneratorHistory$6 = "Histórico do Gerador de Postagens";
const NoPostsGenerated$6 = "Nenhuma Postagem Gerada";
const getStartedPost$6 = "Você ainda não gerou nenhuma postagem. Comece e tenha postagens correspondendo à descrição do trabalho com sua experiência relevante.";
const Topic$6 = "Tópico";
const Description$6 = "Descrição";
const UseHashtags$6 = "Usar Hashtags";
const Custom$6 = "Personalizado";
const EnterCustomTone$6 = "Digite o Tom Personalizado";
const Added$6 = "Adicionado";
const ComingSoon$6 = {
	header: "Engenheiros trabalhando!",
	content_1: "Nossa equipe de engenheiros está trabalhando arduamente para colocar esse recurso em funcionamento em breve",
	content_2: "Quer este recurso em breve? Avise-nos marcando a caixa abaixo.",
	content_3: "Eu quero este recurso"
};
const Company$6 = "Empresa";
const JobInterview$6 = "Entrevista de Emprego";
const Research$6 = "Pesquisa";
const Networking$6 = "Networking";
const Referral$6 = "Indicação";
const MustbeContacted$6 = "Deve ser Contatado";
const ScheduleaMeeting$6 = "Agendar uma Reunião";
const needAFollowUp$6 = "É necessário fazer um acompanhamento";
const Today$6 = "Hoje";
const Viewdetails$6 = "Ver Detalhes";
const Activity$6 = "Atividade";
const ActivityDetails$6 = "Detalhes da Atividade";
const Delete$6 = "Excluir";
const Title$6 = "Título";
const Goal$6 = "Meta";
const Status$6 = "Status";
const FollowUp$6 = "Acompanhamento";
const AddActivity$6 = "Adicionar Atividade";
const Enteractivitytitle$6 = "Insira o título da atividade";
const Cancel$6 = "Cancelar";
const SaveActivity$6 = "Salvar Atividade";
const noActivityPresent$6 = "Nenhuma atividade presente, adicione uma atividade.";
const Addnew$6 = "Adicionar novo";
const About$6 = "Sobre";
const noDataPresentYou$6 = "Nenhum dado presente, você pode editar este contato e adicionar campos.";
const Experience$6 = "Experiência";
const Education$6 = "Educação";
const Skills$6 = "Habilidades";
const Overview$6 = "Visão Geral";
const LinkedJobs$6 = "Empregos Relacionados";
const Notes$6 = "Notas";
const FullName$6 = "Nome Completo";
const Location$6 = "Localização";
const Relationship$6 = "Relacionamento";
const Contacts$6 = "Contatos";
const CreateContact$6 = "Criar Contato";
const NotesCreated$6 = "Notas Criadas";
const Notesupdated$6 = "Notas Atualizadas";
const Addnote$6 = "Adicionar nota";
const areYouSureDeleteNote$6 = "Tem certeza de que deseja excluir esta nota?";
const Createdby$6 = "Criado por";
const notSureWhyResumeCalls$6 = "Não tem certeza por que seu currículo não está recebendo chamadas de entrevista? ☎️";
const getExpertResumeReview$6 = "Obtenha uma Revisão de Currículo de Especialista 💎✨";
const youHaventAddedContacts$6 = "Você ainda não adicionou nenhum contato.";
const noMatchingContacts$6 = "Nenhum contato correspondente encontrado.";
const Link$6 = "Link";
const unlink$6 = "Desvincular";
const Locationnotavailable$6 = "Localização não disponível";
const Emailnotavailable$6 = "E-mail não disponível";
const PhoneNumbernotavailable$6 = "Número de telefone não disponível";
const createdby$6 = "criado por";
const areYouSureDeleteContact$6 = "Você tem certeza de que deseja excluir este Contato?";
const areYouSureUnlinkContact$6 = "Você tem certeza de que deseja desvincular este Contato?";
const Addedbyyou$6 = "Adicionado por você";
const Addedby$6 = "Adicionado por";
const Timeline$6 = "Linha do tempo";
const Timelineempty$6 = "Linha do tempo vazia";
const Discard$6 = "Descartar";
const SaveContact$6 = "Salvar contato";
const Recruiter$6 = "Recrutador";
const Candidate$6 = "Candidato";
const Colleague$6 = "Colega";
const Employee$6 = "Funcionário";
const EnterValidEmail$6 = "Insira um E-mail Válido";
const EnterValidPhoneNumber$6 = "Insira um Número de Telefone Válido";
const editingProfileNotAvailable$6 = "A edição da foto do perfil ainda não está disponível.";
const itWillBeSoonAvailable$6 = "Em breve estará disponível em nosso";
const ChromeExtension$6 = "Extensão do Chrome";
const SelectTag$6 = "Selecionar Tag";
const FirstName$6 = "Primeiro Nome";
const FirstNameisrequired$6 = "O Primeiro Nome é obrigatório";
const LastName$6 = "Sobrenome";
const LastNameisrequired$6 = "O Sobrenome é obrigatório";
const Companyisrequired$6 = "Empresa é obrigatória";
const Email$6 = "E-mail";
const ThisisnotavalidEmail$6 = "Este não é um e-mail válido";
const AddEmail$6 = "Adicionar E-mail";
const PhoneNumber$6 = "Número de Telefone";
const notaValidPhone$6 = "Este não é um número de telefone válido. Insira apenas números.";
const phoneNoMinimum5char$6 = "O número de telefone deve ter no mínimo 5 caracteres.";
const phoneNoMinumum15char$6 = "O número de telefone deve ter no máximo 15 caracteres.";
const AddPhoneNumber$6 = "Adicionar Número de Telefone";
const SelectGoal$6 = "Selecionar Meta";
const SelectStatus$6 = "Selecionar Status";
const Followup$6 = "Acompanhamento";
const SocialMedia$6 = "Mídias Sociais";
const Linkedinhandle$6 = "Identificador do Linkedin";
const Twitterhandle$6 = "Identificador do Twitter";
const Facebookhandle$6 = "Identificador do Facebook";
const Githubhandle$6 = "Identificador do Github";
const Gmailhandle$6 = "Identificador do Gmail";
const Changessavedsuccessfully$6 = "Alterações salvas com sucesso";
const EditContact$6 = "Editar Contato";
const BasicInformation$6 = "Informações Básicas";
const EditContactDetails$6 = "Editar Detalhes de Contato";
const SaveChanges$6 = "Salvar Alterações";
const phoneNoMinimum14char$6 = "O número de telefone deve ter no mínimo 14 caracteres.";
const LinkedIn$6 = "LinkedIn";
const Twitter$6 = "Twitter";
const Facebook$6 = "Facebook";
const Github$6 = "Github";
const Gmail$6 = "Gmail";
const youCanWriteAbout$6 = "Você pode escrever sobre seus anos de experiência, setor ou habilidades. As pessoas também falam sobre suas conquistas ou experiências anteriores de trabalho.";
const Addednewsection$6 = "Adicionada nova seção";
const Removedsuccessfully$6 = "Removido com sucesso.";
const Remove$6 = "Remover";
const Institute$6 = "Instituto";
const Schoolisrequired$6 = "A escola é obrigatória";
const Degree$6 = "Grau";
const StartMonth$6 = "Mês de início";
const StartYear$6 = "Ano de início";
const EndMonth$6 = "Fim do mês";
const EndYear$6 = "Fim de ano";
const Addmore$6 = "Adicionar mais";
const PositionTitle$6 = "Título do cargo";
const ExperienceType$6 = "Tipo de Experiência";
const Addednewitem$6 = "Adicionado novo item";
const whatSkillsDoYouEnjoy$6 = "Que habilidades você tem ou gosta de trabalhar?";
const Typeskillshere$6 = "Digite as habilidades aqui";
const LinkedContacts$6 = "Contatos Relacionados";
const LinkContact$6 = "Vincular Contato";
const NocontactsLinked$6 = "Nenhum contato vinculado";
const JobContactsComponent$6 = {
	linkContact: "Ao vincular contatos, você pode ver rapidamente quem são as pessoas importantes, como o recrutador, gerente de contratação, etc., para este papel! No futuro, poderemos apresentar insights relevantes com base nos seus contatos."
};
const Nocontacts$6 = "Sem contatos";
const LinkJobto$6 = "Vincular trabalho a";
const Contact$6 = "Contato";
const Document$6 = "Documento";
const Nojobsfound$6 = "Nenhum emprego encontrado";
const LinkJob$6 = "Vincular Emprego";
const youCanLinkContactJobImported$6 = "Você pode vincular este contato a um trabalho que você importou para o Careerflow.";
const Prev$6 = "Anteriormente";
const Next$6 = "Próximo";
const areYouSureUnlinkDocument$6 = "Você tem certeza de que deseja desvincular este documento?";
const areYouSureDeleteDocument$6 = "Você tem certeza de que deseja excluir este Documento?";
const Category$6 = "Categoria";
const CreatedOn$6 = "Criado Em";
const Joblinked$6 = "Trabalho vinculado";
const Quickactions$6 = "Ações rápidas";
const All$6 = "Todos";
const Resume$6 = "Currículo";
const Portfolio$6 = "Portfólio";
const Other$6 = "Outro";
const Adddocument$6 = "Adicionar Documento";
const Type$6 = "Tipo";
const Sortingby$6 = "Ordenando por";
const SwitchtoGridLayout$6 = "Mudar para o Layout de Grade";
const SwitchtoListLayout$6 = "Mudar para o Layout de Lista";
const NoDocumentsAdded$6 = "Nenhum Documento Adicionado";
const DocumentsComponent$6 = {
	nodocs: "Você ainda não criou nenhum documento. Você pode fazer upload de versões do seu currículo, cartas de apresentação, e mais, e vinculá-los aos empregos que está acompanhando!"
};
const NoDocumentFound$6 = "Nenhum documento encontrado";
const SelectFile$6 = "Selecionar Arquivo";
const onlyPdfDocxSupported$6 = "Apenas .pdf e .docx são suportados.";
const Uploadfile$6 = "Enviar arquivo";
const DocumentCategory$6 = "Categoria do Documento";
const SaveDocument$6 = "Salvar Documento";
const AddDocument$6 = "Adicionar Documento";
const LinkedDocuments$6 = "Documentos vinculados";
const LinkDocument$6 = "Vincular Documento";
const NodocumentsLinked$6 = "Nenhum documento vinculado";
const JobDocumentsComponent$6 = {
	linkDocs: "Vincular todos os seus documentos relevantes, como seu currículo, carta de apresentação, etc., que você enviou para este emprego, ajudará a manter o controle de tudo em um só lugar. Experimente!"
};
const NoDocuments$6 = "Sem Documentos";
const CreateDocuments$6 = "Criar Documentos";
const youCanLinkDocumentJobImported$6 = "Você pode vincular este documento a um trabalho que você importou para o Careerflow.";
const Documenteditedsuccessfully$6 = "Documento editado com sucesso";
const DocumentDetails$6 = "Detalhes do documento";
const UnsavedChanges$6 = "Mudanças não salvas";
const yourChangesWillBeLostSureClose$6 = "As suas alterações serão perdidas, tem a certeza de que quer fechar?";
const yourChangesWillBeLostSureDiscard$6 = "As suas alterações serão perdidas, tem a certeza de que deseja descartá-las?";
const DiscardChanges$6 = "Descartar alterações";
const WeeklyGoalAlert$6 = "Alerta de Meta Semanal";
const Progress$6 = "Progresso";
const AllGoals$6 = "Todas as Metas";
const Name$6 = "Nome";
const Completedon$6 = "Concluído em";
const Createdon$6 = "Criado em";
const Action$6 = "Ação";
const Back$6 = "Voltar";
const OverallScore$6 = "Pontuação geral";
const Aboutthegoal$6 = "Sobre a Meta";
const GoalTracking$6 = "Rastreamento de Metas";
const Week$6 = "Semana";
const progress$6 = "progresso";
const loading$6 = "Carregando";
const Apply$6 = "Aplicar";
const Thisskillhasbeenreported$6 = "Esta habilidade foi relatada";
const issueGettingResume$6 = "Houve um problema ao obter o currículo.";
const Interview$6 = "Entrevista";
const Tasks$6 = "Tarefas";
const Loading$6 = "Carregando";
const Skilladdedsuccessfully$6 = "Habilidade adicionada com sucesso";
const problemAddingSkill$6 = "Houve um problema ao adicionar habilidade.";
const Reportaproblem$6 = "Relatar um problema";
const Submit$6 = "Enviar";
const Addanewskill$6 = "Adicionar uma nova habilidade";
const JobDetailsComponent$6 = {
	classifySkill: "Como você classificaria essa habilidade (opcional)",
	includedKeywordsWillCount: "Incluir esta palavra-chave?",
	yesIncludeThisSkill: "As palavras-chave incluídas contarão contra sua pontuação de correspondência para todas as varreduras futuras. Você pode alterar as palavras-chave incluídas em seu perfil.",
	addSkill: "Você quer adicionar isso como uma habilidade?"
};
const HardSkill$6 = "Habilidade Técnica";
const SoftSkill$6 = "Habilidade Comportamental";
const Pleaseshareanyadditionalcontext$6 = "Por favor, compartilhe qualquer contexto adicional";
const Addasskill$6 = "Adicionar como habilidade";
const Skill$6 = "Habilidade";
const JobFrequency$6 = "Frequência do Trabalho";
const ResumeFrequency$6 = "Frequência do Currículo";
const Reportskill$6 = "Relatar habilidade";
const JobDetails$6 = "Detalhes do trabalho";
const ViewJobLink$6 = "Ver link da vaga";
const Salary$6 = "Salário";
const areYouSureDeleteJob$6 = "Tem certeza de que deseja excluir este trabalho?";
const ViewMore$6 = "Ver Mais";
const ViewLess$6 = "Ver Menos";
const matchYouSkillsAgainstJob$6 = "Combine suas habilidades com a descrição do trabalho";
const pleaseUploadResumeSkillMatch$6 = "Por favor, faça o upload do seu currículo para obter sua pontuação de correspondência de habilidades.";
const AddResume$6 = "Adicionar Currículo";
const thisJobDoesNotHaveAnyDesc$6 = "Este trabalho não tem nenhuma descrição";
const youCanEditJobToAdd$6 = "Você pode editar este trabalho para adicionar uma descrição a ele. Você também pode importar trabalhos usando o nosso";
const chromeextension$6 = "extensão do Chrome";
const fromVariousJobPortalsOnce$6 = "de vários portais de emprego. Uma vez que você adicionar uma descrição, também será capaz de ver informações relacionadas às habilidades.";
const AddDescription$6 = "Adicionar descrição";
const CompanyInfo$6 = "Informações da Empresa";
const Website$6 = "Site";
const Industry$6 = "Indústria";
const EmployeeCount$6 = "Número de Funcionários";
const ExprienceLevel$6 = "Nível de Experiência";
const Address$6 = "Endereço";
const Resumes$6 = "Currículos";
const Setasdefault$6 = "Definir como padrão";
const Ok$6 = "Ok";
const UploadNewResume$6 = "Enviar Novo Currículo";
const Default$6 = "Padrão";
const Jobnotfound$6 = "Trabalho não encontrado";
const EditDetails$6 = "Editar Detalhes";
const JobPostURL$6 = "URL do Anúncio de Trabalho";
const Enterjoburl$6 = "Insira o URL do trabalho";
const Nojobselected$6 = "Nenhum trabalho selecionado";
const Viewjobdetails$6 = "Ver Detalhes do Emprego";
const Jobaddedtoyourboardsuccessfully$6 = "Trabalho adicionado com sucesso ao seu quadro";
const AddJob$6 = "Adicionar Trabalho";
const Addnewjobname$6 = "Adicionar novo nome de trabalho";
const JobUrl$6 = "URL do Trabalho";
const Addjoburl$6 = "Adicionar URL do trabalho";
const Section$6 = "Seção";
const didYouKnow$6 = {
	chromeExtension: "Você sabia? Você também pode salvar trabalhos diretamente de nossa Extensão para o Chrome e ter todos os dados importados em um único clique! Leva apenas alguns segundos."
};
const Jobs$6 = "Trabalhos";
const AddJobtoboard$6 = "Adicionar trabalho ao quadro";
const Currentlynojobsareavailable$6 = "Atualmente não há vagas disponíveis.";
const noMatchingJobs$6 = "Nenhum trabalho correspondente encontrado.";
const welcomeToYourPersonalJobTracker$6 = "Bem-vindo ao seu rastreador de empregos pessoal!";
const weShortTutorialOnHowTrackingJob$6 = "Iremos guiá-lo através de um breve tutorial sobre como começar a rastrear suas candidaturas a empregos em alguns passos simples!";
const Addanewjob$6 = "Adicionar um novo trabalho";
const inOrderTrackCreatButton$6 = "Para começar a rastrear candidaturas de emprego, você precisa primeiro adicioná-las ao quadro clicando no botão 'Criar'.";
const Providesomedetails$6 = "Forneça alguns detalhes.";
const toBeginTypeJobTitleCompany$6 = "Para começar, basta digitar o título do trabalho, o nome da empresa e o status que você gostaria de adicioná-lo. Você pode adicionar mais detalhes depois, mas isso é tudo o que você precisa por agora!";
const asAnExampleFilledForYou$6 = "Como exemplo, já preenchemos isso para você!";
const wohooAddedFirstJob$6 = "Uau! Você adicionou seu primeiro trabalho ao seu rastreador de empregos!";
const youCanDragDropJobCard$6 = "Agora você pode arrastar e soltar o cartão de trabalho nas várias etapas do processo de candidatura a emprego. Clicar no cartão de trabalho permitirá que você visualize mais detalhes, edite-os, salve notas e muito mais!";
const Lastbutnotleast$6 = "Por último, mas não menos importante.";
const finalStepMakeSure$6 = "Como último passo, certifique-se de ter a nossa.";
const autoMaticallyImportJobs$6 = "o que permitirá que você importe automaticamente empregos de seus sites de busca de emprego favoritos, como LinkedIn, Indeed e muito mais! Nossa extensão também ajuda a melhorar seu perfil do LinkedIn e obter 2,5 vezes mais aparências em pesquisas!";
const selectanysection$6 = "selecione qualquer seção";
const Accept$6 = "Aceitar";
const My2023JobSearch$6 = "Minha Busca de Emprego em 2023";
const AddedFrom$6 = "Adicionado de";
const AddedUntil$6 = "Adicionado até";
const BasicModal$6 = "Modal Básico";
const AddnewSectionName$6 = "Adicionar Novo Nome de Seção";
const OpenTo$6 = "Aberto Para";
const Featured$6 = "Destaque";
const LicenceAndCerts$6 = "Licenças e Certificados";
const Banner$6 = "Banner";
const LinkedInURL$6 = "URL do LinkedIn";
const Recommendations$6 = "Recomendações";
const LinkedinReview$6 = "Avaliação do Linkedin";
const NoDataAvailable$6 = "Não há dados disponíveis";
const looksLikeYouDidNot$6 = "Parece que você não começou a usar nossa tradução em português.";
const toOptimizeProfileScoreVisible$6 = "para otimizar seu perfil do LinkedIn ainda. Depois de fazer isso, sua pontuação de perfil será visível aqui.";
const LinkedinComponent$6 = {
	letsOptimize: "Vamos otimizar"
};
const improveYourChancesLandingDreamJob$6 = "Melhore suas chances de conseguir o emprego dos seus sonhos. Use essas estratégias testadas e comprovadas para dar uma reformulada muito necessária em seu perfil do LinkedIn.";
const VisitProfile$6 = "Visitar Perfil";
const wantToGetLinkedinMakeover$6 = "Quer fazer uma transformação completa no seu LinkedIn?";
const PostGenerator$6 = "Gerador de Postagem";
const LinkedinHeadlineGenerator$6 = "Gerador de Manchete do LinkedIn";
const LinkedinAboutSectionGenerator$6 = "Gerador de Seção 'Sobre' do LinkedIn";
const AITools$6 = "Ferramentas de IA";
const Premium$6 = "Premium";
const LinkedInOptimization$6 = "Otimização do LinkedIn";
const JobTracker$6 = "Rastreador de empregos";
const whoIsHiring$6 = "Quem está contratando";
const Autofill$6 = "Preenchimento automático";
const HeadlineGenerator$6 = "Gerador de Títulos";
const skillMatching$6 = "Correspondência de habilidades";
const SummarizeJD$6 = "Resumo da descrição do trabalho";
const contactFeature$6 = "Rastreamento de Contato";
const documentFeature$6 = "Documentos";
const landJobWithoutStress$6 = "Conquiste o emprego dos seus sonhos. Sem estresse.";
const discoverFeatures$6 = "Descubra a variedade de recursos do Careerflow.ai projetados para simplificar sua busca por emprego e aprimorar sua jornada profissional!";
const letsBeginOnboarding$6 = "Vamos conhecê-lo melhor!";
const inTheNextFewScreensJobThirdParties$6 = "Nas próximas telas, faremos algumas perguntas que nos ajudarão a personalizar a experiência para você e preencher automaticamente suas candidaturas a empregos (para que você não precise fazer isso)! Não vendemos seus dados para terceiros.";
const letsAddBasicInformation$6 = "Vamos adicionar suas informações básicas";
const Pleaseselectanoptionfirst$6 = "Por favor, selecione uma opção primeiro.";
const JobApplicationTracker$6 = "Rastreador de Candidaturas de Emprego";
const LinkedInProfileOptimizer$6 = "Otimizador de perfil do LinkedIn";
const UnlimitedDocuments$6 = "Documentos ilimitados";
const UnlimitedContacts$6 = "Contatos ilimitados";
const HiringManagerSearch$6 = "Busca de Gerente de Contratação";
const AILinkedInPostGenerator$6 = "Gerador de postagens de IA no LinkedIn";
const ATSKeywordSkillMatch$6 = "Emprego com correspondência de palavras-chave / habilidades ATS";
const ChooseyourPlan$6 = "Escolha o seu plano";
const superChargeYourJobSearch$6 = "Turbocharge sua busca por emprego e melhore seu processo de candidatura, aumente suas entrevistas e conquiste seu emprego dos sonhos. Tudo com a ajuda do kit de ferramentas premium da Careerflow.";
const startNowGoto$6 = "Comece agora (Vá para o aplicativo)";
const CreatedBy$6 = "Criado Por";
const CreateNewNote$6 = "Criar Nova Nota";
const Nonotescreated$6 = "Nenhuma nota criada";
const approxTimeIsFourMinutes$6 = "O tempo aproximado para concluir o processo de integração é de 4 minutos.";
const Continue$6 = "Continuar";
const iWillDoLaterTakeMeToApp$6 = "Vou fazer isso mais tarde. Leve-me para o aplicativo.";
const allDone$6 = "Tudo feito!";
const welcomeAbord$6 = "Bem-vindo a bordo!";
const letsBegin$6 = "Vamos começar.";
const UpgradeyourplanandgetAIAssistance$6 = "Melhore seu plano e obtenha Assistência de IA";
const DownloadPDF$6 = "Baixar PDF";
const oopsWeCouldntProcessResume$6 = "Oops, não conseguimos processar este currículo.";
const MyProfile$6 = "Meu perfil";
const Setting$6 = "Ajuste";
const Logout$6 = "Sair";
const SignIn$6 = "Entrar";
const Typeyourfirstnamehere$6 = "Seu primeiro nome";
const Enteryourlastname$6 = "Seu Sobrenome";
const ManageSubscription$6 = "Gerenciar assinatura";
const ifYouHaveDifficultiesProfile$6 = "Se você tiver alguma dificuldade com as informações do seu perfil, entre em contato com";
const forSupport$6 = "para suporte.";
const whatIsIdealCompanySize$6 = "Qual é o tamanho ideal da sua empresa?";
const Saveandcontinue$6 = "Salvar e Continuar";
const whatIsMinExpectedSalary$6 = "Qual é o seu salário mínimo esperado (por ano)?";
const Atleast$6 = "Pelo menos";
const SlidetoAdjust$6 = "Deslize para ajustar";
const whatIndustryExcitedWork$6 = "Quais indústrias te empolgam?";
const Add$6 = "Adicionar";
const statusOfJobSearch$6 = "Qual é o status da sua busca por emprego?";
const Finish$6 = "Terminar";
const whatLevelRoleLooking$6 = "Qual nível de cargo você está procurando?";
const Selectuptotwo$6 = "Selecione até dois.";
const PreviousStep$6 = "Passo anterior";
const Skip$6 = "Pular";
const whatDoYouValueNewRole$6 = "O que você valoriza em um novo papel?";
const Selectuptothree$6 = "Selecione até três.";
const EqualEmploymentData$6 = "Dados de Emprego Igualitário";
const whatIsYourEthnicity$6 = "Qual é a sua etnia?";
const areYouAuthorizedToWorkUs$6 = "Você está autorizado a trabalhar nos Estados Unidos?";
const willYouRequireSponsorShip$6 = "Você precisará de patrocínio para o status de visto de emprego agora ou no futuro?";
const doYouHaveADisability$6 = "Você tem alguma deficiência?";
const areYouAVeteran$6 = "Você é um veterano?";
const rolesYouInterestedIn$6 = "Em que tipo de papéis você está interessado?";
const Selectuptofive$6 = "Selecione até cinco.";
const AddCustomrole$6 = "Adicionar função personalizada";
const whereDoYouLikeWork$6 = "Onde você gostaria de trabalhar?";
const Resources$6 = "Recursos";
const currentlyNoResourceAvailable$6 = "Atualmente não há recursos disponíveis.";
const AddNewSection$6 = "Adicionar Nova Seção";
const ChangeSections$6 = "Mudar seções";
const Settings$6 = "Configurações";
const Dashboard$6 = "Painel";
const JobBoard$6 = "Quadro de Trabalho";
const Linkedin$6 = "Linkedin";
const Community$6 = "Comunidade";
const FindRecruiters$6 = "Encontre Recrutadores";
const Goals$6 = "Metas";
const DownloadExtension$6 = "Baixar Extensão";
const SuggestaFeature$6 = "Sugerir uma funcionalidade";
const leftPanel$6 = {
	ReportanIssue: "Reportar um problema"
};
const PhoneNumberisrequired$6 = "O número de telefone é obrigatório";
const MobileNumber$6 = "Número de celular";
const Enteronlynumbers$6 = "Digite apenas números";
const Countryyoulivein$6 = "País em que você vive";
const SelectaCountry$6 = "Selecione um país";
const DateofBirth$6 = "Data de Nascimento";
const Gender$6 = "Gênero";
const JobPreferences$6 = "Preferências de trabalho";
const pleaseEnterValidEmail$6 = "Por favor, insira um e-mail válido.";
const emailSendForResetting$6 = "Um e-mail foi enviado para você para redefinir a senha";
const VerifyyourEmailID$6 = "Verifique seu ID de e-mail";
const sentPleaseCheckEmail$6 = "Enviado! Por favor, verifique seu e-mail.";
const tooManyAttemptsTryAgain$6 = "Muitas tentativas, por favor tente novamente em algum momento.";
const Resend$6 = "Reenviar";
const Login$6 = "Login";
const weHaveSentVerificationLinkAtEmail$6 = "Enviamos um link de verificação para o seu e-mail.";
const pleaseVerifyEmailContinueSpam$6 = "Por favor, verifique seu e-mail para continuar. Por favor, verifique também a pasta de spam ou promoções para o e-mail de verificação.";
const Logintogetstarted$6 = "Faça login para começar";
const ContinuewithGoogle$6 = "Continuar com o Google";
const pleaseInputEmail$6 = "Por favor, insira seu e-mail!";
const Password$6 = "Senha";
const pleaseInputPassword$6 = "Por favor, digite sua senha!";
const passwordLowerUpperDigitSpecial$6 = "Sua senha deve conter pelo menos uma letra minúscula, uma letra maiúscula, um dígito e um caractere especial.";
const atLeastSixChar$6 = "Pelo menos 6 caracteres";
const forgotPassword$6 = "Esqueceu a senha?";
const Bysigninginyouagreetoour$6 = "Ao fazer login, você concorda com nossos.";
const Terms$6 = "Termos";
const Conditions$6 = "Condições";
const and$6 = "e";
const PrivacyPolicy$6 = "Política de Privacidade";
const theseAreTheTopsSkillsExtracted$6 = "Estas são as principais habilidades extraídas da descrição do trabalho.";
const TopSkills$6 = "Principais habilidades";
const weCoulNotExtractSkills$6 = "Não conseguimos extrair nenhuma habilidade desta descrição de trabalho.";
const upgradeToPremiumToView$6 = "Faça upgrade para Premium para visualizar a pontuação de correspondência de habilidades do seu currículo.";
const SkillScore$6 = "Pontuação de Habilidade";
const thisIsYourSkillScoreBasedOn$6 = "Esta é a sua pontuação de habilidades com base na descrição do trabalho e no seu currículo.";
const theseSkllsAreStrongMatch$6 = "Essas habilidades são uma forte correspondência entre o seu currículo e a descrição do trabalho.";
const Strongmatch$6 = "Correspondência Forte";
const theseSkillsArePartialMatch$6 = "Essas habilidades são uma correspondência parcial entre o seu currículo e a descrição do trabalho.";
const Partialmatch$6 = "Correspondência parcial";
const theseSkillsAreMissingFrom$6 = "Estas palavras-chave estão faltando em seu currículo, mas estão presentes na descrição do trabalho. Elas podem ser habilidades ou palavras-chave gerais específicas para a oportunidade de trabalho e podem ser úteis para adicionar ao seu currículo.";
const SkillMatchComponent$6 = {
	removeSkill: "Qual é o seu principal motivo para relatar um problema com a palavra-chave"
};
const Optional$6 = "Opcional";
const Notrelevanttothejob$6 = "Não relevante para o trabalho";
const Notaskill$6 = "Nenhuma habilidade";
const Toogeneric$6 = "Muito genérico";
const Pleaseshareanyfeedback$6 = "Por favor, compartilhe qualquer feedback";
const excludedKeywordsWillNot$6 = "Palavras-chave excluídas não contarão em sua pontuação de correspondência para todas as futuras varreduras. Você pode alterar as palavras-chave excluídas do seu perfil.";
const yesExcludeThisSkillFrom$6 = "Sim, exclua esta habilidade de todas as varreduras do meu currículo.";
const PartialMatch$6 = "Correspondência Parcial";
const MissingKeywords$6 = "Palavras-chave Ausentes";
const Providetitletotask$6 = "Fornecer título para a tarefa";
const TasksList$6 = "Lista de Tarefas";
const AddTask$6 = "Adicionar Tarefa";
const EnterTaskTitlehere$6 = "Digite o Título da Tarefa aqui";
const TasksComponent$6 = {
	listEmpty: "Lista de Tarefas vazia, Crie Novas."
};
const CompletedTasks$6 = "Tarefas Concluídas";
const CompleteYourtasks$6 = "Complete Suas Tarefas";
const Steps$6 = "Passos";
const PremiumMember$6 = "Membro Premium";
const Thankyouforupgradingto$6 = "Obrigado por fazer o upgrade para";
const CareerflowPremium$6 = "Fluxo de carreira Premium";
const hereIsHowYouCanAccessPremium$6 = "Aqui está como acessar seus benefícios Premium!";
const stepOne$6 = "Passo 1";
const DownloadourChromeExtension$6 = "Baixe nossa Extensão para o Chrome";
const youJobSearchCopilotIshere$6 = "O Copiloto de IA da sua busca por emprego está aqui.";
const DownloadNow$6 = "Baixar agora";
const stepTwo$6 = "Passo 2";
const GetStarted$6 = "Começar";
const stepThree$6 = "Passo 3";
const SignintoChromeExtension$6 = "Entrar na Extensão do Chrome";
const entityCreated$6 = "Novo {{entidade}} criado";
const entityUpdated$6 = "{{entidade}} atualizada.";
const entityDeleted$6 = "{{entidade}} excluída.";
const entityLinked$6 = "{{entidade}} vinculada";
const entityUnlinked$6 = "{{entidade}} desvinculada";
const entityMovedTo$6 = "Mudou-se para {{entidade}}";
const youAddedANewEntity$6 = "Você adicionou uma nova {{entidade}}";
const personCreated$6 = "{{creator}} criou uma {{entity}} para {{owner}}.";
const youUpdatedAEntity$6 = "Você atualizou um {{entidade}}";
const personUpdated$6 = "{{creator}} atualizou um {{entity}} para {{owner}}.";
const youDeletedAEntity$6 = "Você deletou um(a) {{entidade}}";
const personDeleted$6 = "{{creator}} apagou um(a) {{entity}} de {{owner}}";
const youLinkedEntity$6 = "Você vinculou uma {{entidade}} a este trabalho";
const personLinked$6 = "{{creator}} vinculou uma {{entity}} a este trabalho para {{owner}}";
const youUnlinked$6 = "Você desvinculou uma {{entidade}} deste trabalho";
const personUnlinked$6 = "{{creator}} desvinculou uma {{entity}} deste trabalho para {{owner}}";
const youMovedEntity$6 = "Você moveu esta {{entity}} de {{sectionFrom}} para {{sectionTo}}";
const personMoved$6 = "{{creator}} moveu esta {{entity}} da {{sectionFrom}} para a {{sectionTo}} para {{owner}}";
const addedByName$6 = "Adicionado por {{name}}";
const DownloadChromeExtension$6 = "Baixar Extensão do Chrome";
const ourChromeExtensionIs$6 = "A nossa extensão do Chrome é uma ferramenta integrada para ajudá-lo a otimizar o seu perfil do LinkedIn, salvar empregos, salvar contatos, gerar cartas de apresentação e muito mais.";
const Optimizeyourprofile$6 = "Otimize seu perfil";
const startOptimizingYourProfile$6 = "Comece a otimizar seu perfil para ter melhores chances de ser contatado por recrutadores.";
const OptimizeNow$6 = "Otimizar agora";
const Addyourfirstjob$6 = "Adicione seu primeiro emprego";
const startSavingJobApplicationsToTrack$6 = "Comece a salvar as candidaturas de emprego para acompanhar sua jornada de busca por emprego e encontrar insights úteis.";
const AddNow$6 = "Adicionar agora";
const CompleteProfile$6 = "Perfil completo";
const completeYourProfileForUsing$6 = "Complete o seu perfil para utilizar a função de preenchimento automático e ter uma experiência mais personalizada.";
const CompleteNow$6 = "Complete agora";
const Addyourfirstcontact$6 = "Adicione seu primeiro contato";
const addContactToFollowUpWith$6 = "Adicione o contato para acompanhá-los posteriormente, adicione notas e muito mais.";
const JoinCommunity$6 = "Junte-se à comunidade";
const ourCommunityisAlways$6 = "Nossa comunidade está sempre ao seu lado em sua jornada de busca por emprego.";
const JoinNow$6 = "Junte-se agora";
const welcomeToCareerflow$6 = "Bem-vindo ao Careerflow!";
const yourHubForCareerInsights2$6 = "Este é o seu centro de informações sobre carreira, atividades e muito mais. Explore o seu painel personalizado para se manter atualizado em sua jornada profissional.";
const ChecklistCompleted$6 = "Sua lista de verificação está concluída!";
const Completeyourchecklist$6 = "Complete sua lista de verificação";
const completeAFewStepsTo$6 = "Complete alguns passos para conseguir seu próximo emprego.";
const Completed$6 = "Concluído";
const JobCountByStage$6 = "Contagem de Trabalhos por Estágio";
const NopastapplicationDatafound$6 = "Nenhum dado de aplicação anterior encontrado";
const YourJobSearchStages$6 = "Estágios da sua busca por emprego";
const NoDatafound$6 = "Nenhum dado encontrado";
const pt = {
	copyToClipboard: copyToClipboard$6,
	UnlocktheAIgenerated: UnlocktheAIgenerated$6,
	UpgradetoPremium: UpgradetoPremium$6,
	Result: Result$6,
	Copy: Copy$6,
	Save: Save$6,
	Edit: Edit$6,
	Processing: Processing$6,
	YourAIgeneratedcontentwillshowhere: YourAIgeneratedcontentwillshowhere$6,
	hopeYouFindUseful: hopeYouFindUseful$6,
	regenerate: regenerate$6,
	ProvideAdditionalFeedback: ProvideAdditionalFeedback$6,
	Enteranyfeedback: Enteranyfeedback$6,
	Notimpressive: Notimpressive$6,
	thisIsntTrue: thisIsntTrue$6,
	Notpersonalized: Notpersonalized$6,
	Tone: Tone$6,
	Length: Length$6,
	Template: Template$6,
	Generatedon: Generatedon$6,
	Copiedtoclipboard: Copiedtoclipboard$6,
	CopytoClipboard: CopytoClipboard$6,
	DownloadasPDF: DownloadasPDF$6,
	ViewDetails: ViewDetails$6,
	JobDescriptionImported: JobDescriptionImported$6,
	ImportfromJob: ImportfromJob$6,
	Saved: Saved$6,
	Applied: Applied$6,
	Offer: Offer$6,
	Interviewing: Interviewing$6,
	Rejected: Rejected$6,
	Search: Search$6,
	Import: Import$6,
	CoverLetterGeneratorHistory: CoverLetterGeneratorHistory$6,
	NoCoverLettersGenerated: NoCoverLettersGenerated$6,
	getStartedCoverLetter: getStartedCoverLetter$6,
	getStarted: getStarted$6,
	Documents: Documents$6,
	UploadNewDocument: UploadNewDocument$6,
	AICoverLetterGenerator: AICoverLetterGenerator$6,
	ViewHistory: ViewHistory$6,
	JobDescription: JobDescription$6,
	ImportfromBoard: ImportfromBoard$6,
	EnterJobDescription: EnterJobDescription$6,
	JobTitle: JobTitle$6,
	EnterJobTitle: EnterJobTitle$6,
	CompanyName: CompanyName$6,
	EnterCompanyName: EnterCompanyName$6,
	YourProfile: YourProfile$6,
	ResumeUpload: ResumeUpload$6,
	UseLinkedinProfile: UseLinkedinProfile$6,
	Uploadyourresume: Uploadyourresume$6,
	AddyourResume: AddyourResume$6,
	fileNameCannotFormat: fileNameCannotFormat$6,
	ChooseorUpload: ChooseorUpload$6,
	SelectTemplate: SelectTemplate$6,
	Preview: Preview$6,
	UseTemplate: UseTemplate$6,
	Change: Change$6,
	AdvancedSettings: AdvancedSettings$6,
	AdditionalContext: AdditionalContext$6,
	Professional: Professional$6,
	Casual: Casual$6,
	Enthusiastic: Enthusiastic$6,
	Informational: Informational$6,
	Short: Short$6,
	Medium: Medium$6,
	Long: Long$6,
	Language: Language$6,
	iAmOkayBack: iAmOkayBack$6,
	Generate: Generate$6,
	CoverLetter: CoverLetter$6,
	SelectLanguage: SelectLanguage$6,
	AboutGeneratorHistory: AboutGeneratorHistory$6,
	NoAboutsGenerated: NoAboutsGenerated$6,
	getStartedAbouts: getStartedAbouts$6,
	noAttachmentsFound: noAttachmentsFound$6,
	TargetJobTitle: TargetJobTitle$6,
	KeywordsToInclude: KeywordsToInclude$6,
	UploadYourResume: UploadYourResume$6,
	AddYourResume: AddYourResume$6,
	LinkedinProfile: LinkedinProfile$6,
	Linkedinprofilenotfound: Linkedinprofilenotfound$6,
	startUsingChromeExtension: startUsingChromeExtension$6,
	Download: Download$6,
	UseEmojis: UseEmojis$6,
	UseBulletPoints: UseBulletPoints$6,
	SpeechFocus: SpeechFocus$6,
	FirstPerson: FirstPerson$6,
	ThirdPerson: ThirdPerson$6,
	HeadlineGeneratorHistory: HeadlineGeneratorHistory$6,
	NoHeadlinesGenerated: NoHeadlinesGenerated$6,
	getStartedHeadline: getStartedHeadline$6,
	AIHeadlineGenerator: AIHeadlineGenerator$6,
	KeywordstoInclude: KeywordstoInclude$6,
	Pressenteraftereachword: Pressenteraftereachword$6,
	LinkedinProfilenotfound: LinkedinProfilenotfound$6,
	Headline: Headline$6,
	PostGeneratorHistory: PostGeneratorHistory$6,
	NoPostsGenerated: NoPostsGenerated$6,
	getStartedPost: getStartedPost$6,
	Topic: Topic$6,
	Description: Description$6,
	UseHashtags: UseHashtags$6,
	Custom: Custom$6,
	EnterCustomTone: EnterCustomTone$6,
	Added: Added$6,
	ComingSoon: ComingSoon$6,
	Company: Company$6,
	JobInterview: JobInterview$6,
	Research: Research$6,
	Networking: Networking$6,
	Referral: Referral$6,
	MustbeContacted: MustbeContacted$6,
	ScheduleaMeeting: ScheduleaMeeting$6,
	needAFollowUp: needAFollowUp$6,
	Today: Today$6,
	Viewdetails: Viewdetails$6,
	Activity: Activity$6,
	ActivityDetails: ActivityDetails$6,
	Delete: Delete$6,
	Title: Title$6,
	Goal: Goal$6,
	Status: Status$6,
	FollowUp: FollowUp$6,
	AddActivity: AddActivity$6,
	Enteractivitytitle: Enteractivitytitle$6,
	Cancel: Cancel$6,
	SaveActivity: SaveActivity$6,
	noActivityPresent: noActivityPresent$6,
	Addnew: Addnew$6,
	About: About$6,
	noDataPresentYou: noDataPresentYou$6,
	Experience: Experience$6,
	Education: Education$6,
	Skills: Skills$6,
	Overview: Overview$6,
	LinkedJobs: LinkedJobs$6,
	Notes: Notes$6,
	FullName: FullName$6,
	Location: Location$6,
	Relationship: Relationship$6,
	Contacts: Contacts$6,
	CreateContact: CreateContact$6,
	NotesCreated: NotesCreated$6,
	Notesupdated: Notesupdated$6,
	Addnote: Addnote$6,
	areYouSureDeleteNote: areYouSureDeleteNote$6,
	Createdby: Createdby$6,
	notSureWhyResumeCalls: notSureWhyResumeCalls$6,
	getExpertResumeReview: getExpertResumeReview$6,
	youHaventAddedContacts: youHaventAddedContacts$6,
	noMatchingContacts: noMatchingContacts$6,
	Link: Link$6,
	unlink: unlink$6,
	Locationnotavailable: Locationnotavailable$6,
	Emailnotavailable: Emailnotavailable$6,
	PhoneNumbernotavailable: PhoneNumbernotavailable$6,
	createdby: createdby$6,
	areYouSureDeleteContact: areYouSureDeleteContact$6,
	areYouSureUnlinkContact: areYouSureUnlinkContact$6,
	Addedbyyou: Addedbyyou$6,
	Addedby: Addedby$6,
	Timeline: Timeline$6,
	Timelineempty: Timelineempty$6,
	Discard: Discard$6,
	SaveContact: SaveContact$6,
	Recruiter: Recruiter$6,
	Candidate: Candidate$6,
	Colleague: Colleague$6,
	Employee: Employee$6,
	"Needtofollow-up": "Precisa fazer um acompanhamento",
	EnterValidEmail: EnterValidEmail$6,
	EnterValidPhoneNumber: EnterValidPhoneNumber$6,
	editingProfileNotAvailable: editingProfileNotAvailable$6,
	itWillBeSoonAvailable: itWillBeSoonAvailable$6,
	ChromeExtension: ChromeExtension$6,
	SelectTag: SelectTag$6,
	FirstName: FirstName$6,
	FirstNameisrequired: FirstNameisrequired$6,
	LastName: LastName$6,
	LastNameisrequired: LastNameisrequired$6,
	Companyisrequired: Companyisrequired$6,
	Email: Email$6,
	ThisisnotavalidEmail: ThisisnotavalidEmail$6,
	AddEmail: AddEmail$6,
	PhoneNumber: PhoneNumber$6,
	notaValidPhone: notaValidPhone$6,
	phoneNoMinimum5char: phoneNoMinimum5char$6,
	phoneNoMinumum15char: phoneNoMinumum15char$6,
	AddPhoneNumber: AddPhoneNumber$6,
	SelectGoal: SelectGoal$6,
	SelectStatus: SelectStatus$6,
	Followup: Followup$6,
	SocialMedia: SocialMedia$6,
	Linkedinhandle: Linkedinhandle$6,
	Twitterhandle: Twitterhandle$6,
	Facebookhandle: Facebookhandle$6,
	Githubhandle: Githubhandle$6,
	Gmailhandle: Gmailhandle$6,
	Changessavedsuccessfully: Changessavedsuccessfully$6,
	EditContact: EditContact$6,
	BasicInformation: BasicInformation$6,
	EditContactDetails: EditContactDetails$6,
	SaveChanges: SaveChanges$6,
	phoneNoMinimum14char: phoneNoMinimum14char$6,
	LinkedIn: LinkedIn$6,
	Twitter: Twitter$6,
	Facebook: Facebook$6,
	Github: Github$6,
	Gmail: Gmail$6,
	youCanWriteAbout: youCanWriteAbout$6,
	Addednewsection: Addednewsection$6,
	Removedsuccessfully: Removedsuccessfully$6,
	Remove: Remove$6,
	Institute: Institute$6,
	Schoolisrequired: Schoolisrequired$6,
	Degree: Degree$6,
	StartMonth: StartMonth$6,
	StartYear: StartYear$6,
	EndMonth: EndMonth$6,
	EndYear: EndYear$6,
	Addmore: Addmore$6,
	PositionTitle: PositionTitle$6,
	ExperienceType: ExperienceType$6,
	Addednewitem: Addednewitem$6,
	whatSkillsDoYouEnjoy: whatSkillsDoYouEnjoy$6,
	Typeskillshere: Typeskillshere$6,
	LinkedContacts: LinkedContacts$6,
	LinkContact: LinkContact$6,
	NocontactsLinked: NocontactsLinked$6,
	JobContactsComponent: JobContactsComponent$6,
	Nocontacts: Nocontacts$6,
	LinkJobto: LinkJobto$6,
	Contact: Contact$6,
	Document: Document$6,
	Nojobsfound: Nojobsfound$6,
	LinkJob: LinkJob$6,
	youCanLinkContactJobImported: youCanLinkContactJobImported$6,
	Prev: Prev$6,
	Next: Next$6,
	areYouSureUnlinkDocument: areYouSureUnlinkDocument$6,
	areYouSureDeleteDocument: areYouSureDeleteDocument$6,
	Category: Category$6,
	CreatedOn: CreatedOn$6,
	Joblinked: Joblinked$6,
	Quickactions: Quickactions$6,
	All: All$6,
	Resume: Resume$6,
	Portfolio: Portfolio$6,
	Other: Other$6,
	Adddocument: Adddocument$6,
	Type: Type$6,
	Sortingby: Sortingby$6,
	SwitchtoGridLayout: SwitchtoGridLayout$6,
	SwitchtoListLayout: SwitchtoListLayout$6,
	NoDocumentsAdded: NoDocumentsAdded$6,
	DocumentsComponent: DocumentsComponent$6,
	NoDocumentFound: NoDocumentFound$6,
	SelectFile: SelectFile$6,
	onlyPdfDocxSupported: onlyPdfDocxSupported$6,
	Uploadfile: Uploadfile$6,
	DocumentCategory: DocumentCategory$6,
	SaveDocument: SaveDocument$6,
	AddDocument: AddDocument$6,
	LinkedDocuments: LinkedDocuments$6,
	LinkDocument: LinkDocument$6,
	NodocumentsLinked: NodocumentsLinked$6,
	JobDocumentsComponent: JobDocumentsComponent$6,
	NoDocuments: NoDocuments$6,
	CreateDocuments: CreateDocuments$6,
	youCanLinkDocumentJobImported: youCanLinkDocumentJobImported$6,
	Documenteditedsuccessfully: Documenteditedsuccessfully$6,
	DocumentDetails: DocumentDetails$6,
	UnsavedChanges: UnsavedChanges$6,
	yourChangesWillBeLostSureClose: yourChangesWillBeLostSureClose$6,
	yourChangesWillBeLostSureDiscard: yourChangesWillBeLostSureDiscard$6,
	DiscardChanges: DiscardChanges$6,
	WeeklyGoalAlert: WeeklyGoalAlert$6,
	Progress: Progress$6,
	AllGoals: AllGoals$6,
	Name: Name$6,
	Completedon: Completedon$6,
	Createdon: Createdon$6,
	Action: Action$6,
	Back: Back$6,
	OverallScore: OverallScore$6,
	Aboutthegoal: Aboutthegoal$6,
	GoalTracking: GoalTracking$6,
	Week: Week$6,
	progress: progress$6,
	loading: loading$6,
	Apply: Apply$6,
	Thisskillhasbeenreported: Thisskillhasbeenreported$6,
	issueGettingResume: issueGettingResume$6,
	Interview: Interview$6,
	Tasks: Tasks$6,
	Loading: Loading$6,
	Skilladdedsuccessfully: Skilladdedsuccessfully$6,
	problemAddingSkill: problemAddingSkill$6,
	Reportaproblem: Reportaproblem$6,
	Submit: Submit$6,
	Addanewskill: Addanewskill$6,
	JobDetailsComponent: JobDetailsComponent$6,
	HardSkill: HardSkill$6,
	SoftSkill: SoftSkill$6,
	Pleaseshareanyadditionalcontext: Pleaseshareanyadditionalcontext$6,
	Addasskill: Addasskill$6,
	Skill: Skill$6,
	JobFrequency: JobFrequency$6,
	ResumeFrequency: ResumeFrequency$6,
	Reportskill: Reportskill$6,
	JobDetails: JobDetails$6,
	ViewJobLink: ViewJobLink$6,
	Salary: Salary$6,
	areYouSureDeleteJob: areYouSureDeleteJob$6,
	ViewMore: ViewMore$6,
	ViewLess: ViewLess$6,
	matchYouSkillsAgainstJob: matchYouSkillsAgainstJob$6,
	pleaseUploadResumeSkillMatch: pleaseUploadResumeSkillMatch$6,
	AddResume: AddResume$6,
	thisJobDoesNotHaveAnyDesc: thisJobDoesNotHaveAnyDesc$6,
	youCanEditJobToAdd: youCanEditJobToAdd$6,
	chromeextension: chromeextension$6,
	fromVariousJobPortalsOnce: fromVariousJobPortalsOnce$6,
	AddDescription: AddDescription$6,
	CompanyInfo: CompanyInfo$6,
	Website: Website$6,
	Industry: Industry$6,
	EmployeeCount: EmployeeCount$6,
	ExprienceLevel: ExprienceLevel$6,
	Address: Address$6,
	Resumes: Resumes$6,
	Setasdefault: Setasdefault$6,
	Ok: Ok$6,
	UploadNewResume: UploadNewResume$6,
	Default: Default$6,
	Jobnotfound: Jobnotfound$6,
	EditDetails: EditDetails$6,
	JobPostURL: JobPostURL$6,
	Enterjoburl: Enterjoburl$6,
	Nojobselected: Nojobselected$6,
	Viewjobdetails: Viewjobdetails$6,
	Jobaddedtoyourboardsuccessfully: Jobaddedtoyourboardsuccessfully$6,
	AddJob: AddJob$6,
	Addnewjobname: Addnewjobname$6,
	JobUrl: JobUrl$6,
	Addjoburl: Addjoburl$6,
	Section: Section$6,
	didYouKnow: didYouKnow$6,
	Jobs: Jobs$6,
	AddJobtoboard: AddJobtoboard$6,
	Currentlynojobsareavailable: Currentlynojobsareavailable$6,
	noMatchingJobs: noMatchingJobs$6,
	welcomeToYourPersonalJobTracker: welcomeToYourPersonalJobTracker$6,
	weShortTutorialOnHowTrackingJob: weShortTutorialOnHowTrackingJob$6,
	Addanewjob: Addanewjob$6,
	inOrderTrackCreatButton: inOrderTrackCreatButton$6,
	Providesomedetails: Providesomedetails$6,
	toBeginTypeJobTitleCompany: toBeginTypeJobTitleCompany$6,
	asAnExampleFilledForYou: asAnExampleFilledForYou$6,
	wohooAddedFirstJob: wohooAddedFirstJob$6,
	youCanDragDropJobCard: youCanDragDropJobCard$6,
	Lastbutnotleast: Lastbutnotleast$6,
	finalStepMakeSure: finalStepMakeSure$6,
	autoMaticallyImportJobs: autoMaticallyImportJobs$6,
	selectanysection: selectanysection$6,
	Accept: Accept$6,
	My2023JobSearch: My2023JobSearch$6,
	AddedFrom: AddedFrom$6,
	AddedUntil: AddedUntil$6,
	BasicModal: BasicModal$6,
	AddnewSectionName: AddnewSectionName$6,
	OpenTo: OpenTo$6,
	Featured: Featured$6,
	LicenceAndCerts: LicenceAndCerts$6,
	Banner: Banner$6,
	LinkedInURL: LinkedInURL$6,
	Recommendations: Recommendations$6,
	LinkedinReview: LinkedinReview$6,
	NoDataAvailable: NoDataAvailable$6,
	looksLikeYouDidNot: looksLikeYouDidNot$6,
	toOptimizeProfileScoreVisible: toOptimizeProfileScoreVisible$6,
	LinkedinComponent: LinkedinComponent$6,
	improveYourChancesLandingDreamJob: improveYourChancesLandingDreamJob$6,
	VisitProfile: VisitProfile$6,
	wantToGetLinkedinMakeover: wantToGetLinkedinMakeover$6,
	PostGenerator: PostGenerator$6,
	LinkedinHeadlineGenerator: LinkedinHeadlineGenerator$6,
	LinkedinAboutSectionGenerator: LinkedinAboutSectionGenerator$6,
	AITools: AITools$6,
	Premium: Premium$6,
	LinkedInOptimization: LinkedInOptimization$6,
	JobTracker: JobTracker$6,
	whoIsHiring: whoIsHiring$6,
	Autofill: Autofill$6,
	HeadlineGenerator: HeadlineGenerator$6,
	skillMatching: skillMatching$6,
	SummarizeJD: SummarizeJD$6,
	contactFeature: contactFeature$6,
	documentFeature: documentFeature$6,
	landJobWithoutStress: landJobWithoutStress$6,
	discoverFeatures: discoverFeatures$6,
	letsBeginOnboarding: letsBeginOnboarding$6,
	inTheNextFewScreensJobThirdParties: inTheNextFewScreensJobThirdParties$6,
	letsAddBasicInformation: letsAddBasicInformation$6,
	Pleaseselectanoptionfirst: Pleaseselectanoptionfirst$6,
	JobApplicationTracker: JobApplicationTracker$6,
	LinkedInProfileOptimizer: LinkedInProfileOptimizer$6,
	UnlimitedDocuments: UnlimitedDocuments$6,
	UnlimitedContacts: UnlimitedContacts$6,
	HiringManagerSearch: HiringManagerSearch$6,
	AILinkedInPostGenerator: AILinkedInPostGenerator$6,
	ATSKeywordSkillMatch: ATSKeywordSkillMatch$6,
	"Auto-Apply": "Auto-Aplicar",
	ChooseyourPlan: ChooseyourPlan$6,
	superChargeYourJobSearch: superChargeYourJobSearch$6,
	startNowGoto: startNowGoto$6,
	CreatedBy: CreatedBy$6,
	CreateNewNote: CreateNewNote$6,
	Nonotescreated: Nonotescreated$6,
	approxTimeIsFourMinutes: approxTimeIsFourMinutes$6,
	Continue: Continue$6,
	iWillDoLaterTakeMeToApp: iWillDoLaterTakeMeToApp$6,
	allDone: allDone$6,
	welcomeAbord: welcomeAbord$6,
	letsBegin: letsBegin$6,
	UpgradeyourplanandgetAIAssistance: UpgradeyourplanandgetAIAssistance$6,
	DownloadPDF: DownloadPDF$6,
	oopsWeCouldntProcessResume: oopsWeCouldntProcessResume$6,
	MyProfile: MyProfile$6,
	Setting: Setting$6,
	Logout: Logout$6,
	SignIn: SignIn$6,
	Typeyourfirstnamehere: Typeyourfirstnamehere$6,
	Enteryourlastname: Enteryourlastname$6,
	ManageSubscription: ManageSubscription$6,
	ifYouHaveDifficultiesProfile: ifYouHaveDifficultiesProfile$6,
	forSupport: forSupport$6,
	whatIsIdealCompanySize: whatIsIdealCompanySize$6,
	Saveandcontinue: Saveandcontinue$6,
	whatIsMinExpectedSalary: whatIsMinExpectedSalary$6,
	Atleast: Atleast$6,
	SlidetoAdjust: SlidetoAdjust$6,
	whatIndustryExcitedWork: whatIndustryExcitedWork$6,
	Add: Add$6,
	statusOfJobSearch: statusOfJobSearch$6,
	Finish: Finish$6,
	whatLevelRoleLooking: whatLevelRoleLooking$6,
	Selectuptotwo: Selectuptotwo$6,
	PreviousStep: PreviousStep$6,
	Skip: Skip$6,
	whatDoYouValueNewRole: whatDoYouValueNewRole$6,
	Selectuptothree: Selectuptothree$6,
	EqualEmploymentData: EqualEmploymentData$6,
	whatIsYourEthnicity: whatIsYourEthnicity$6,
	areYouAuthorizedToWorkUs: areYouAuthorizedToWorkUs$6,
	willYouRequireSponsorShip: willYouRequireSponsorShip$6,
	doYouHaveADisability: doYouHaveADisability$6,
	areYouAVeteran: areYouAVeteran$6,
	rolesYouInterestedIn: rolesYouInterestedIn$6,
	Selectuptofive: Selectuptofive$6,
	AddCustomrole: AddCustomrole$6,
	whereDoYouLikeWork: whereDoYouLikeWork$6,
	Resources: Resources$6,
	currentlyNoResourceAvailable: currentlyNoResourceAvailable$6,
	AddNewSection: AddNewSection$6,
	ChangeSections: ChangeSections$6,
	Settings: Settings$6,
	Dashboard: Dashboard$6,
	JobBoard: JobBoard$6,
	Linkedin: Linkedin$6,
	Community: Community$6,
	FindRecruiters: FindRecruiters$6,
	Goals: Goals$6,
	DownloadExtension: DownloadExtension$6,
	SuggestaFeature: SuggestaFeature$6,
	leftPanel: leftPanel$6,
	PhoneNumberisrequired: PhoneNumberisrequired$6,
	MobileNumber: MobileNumber$6,
	Enteronlynumbers: Enteronlynumbers$6,
	Countryyoulivein: Countryyoulivein$6,
	SelectaCountry: SelectaCountry$6,
	DateofBirth: DateofBirth$6,
	Gender: Gender$6,
	JobPreferences: JobPreferences$6,
	pleaseEnterValidEmail: pleaseEnterValidEmail$6,
	emailSendForResetting: emailSendForResetting$6,
	VerifyyourEmailID: VerifyyourEmailID$6,
	sentPleaseCheckEmail: sentPleaseCheckEmail$6,
	tooManyAttemptsTryAgain: tooManyAttemptsTryAgain$6,
	Resend: Resend$6,
	Login: Login$6,
	weHaveSentVerificationLinkAtEmail: weHaveSentVerificationLinkAtEmail$6,
	pleaseVerifyEmailContinueSpam: pleaseVerifyEmailContinueSpam$6,
	Logintogetstarted: Logintogetstarted$6,
	ContinuewithGoogle: ContinuewithGoogle$6,
	pleaseInputEmail: pleaseInputEmail$6,
	Password: Password$6,
	pleaseInputPassword: pleaseInputPassword$6,
	passwordLowerUpperDigitSpecial: passwordLowerUpperDigitSpecial$6,
	atLeastSixChar: atLeastSixChar$6,
	forgotPassword: forgotPassword$6,
	Bysigninginyouagreetoour: Bysigninginyouagreetoour$6,
	Terms: Terms$6,
	Conditions: Conditions$6,
	and: and$6,
	PrivacyPolicy: PrivacyPolicy$6,
	theseAreTheTopsSkillsExtracted: theseAreTheTopsSkillsExtracted$6,
	TopSkills: TopSkills$6,
	weCoulNotExtractSkills: weCoulNotExtractSkills$6,
	upgradeToPremiumToView: upgradeToPremiumToView$6,
	SkillScore: SkillScore$6,
	thisIsYourSkillScoreBasedOn: thisIsYourSkillScoreBasedOn$6,
	theseSkllsAreStrongMatch: theseSkllsAreStrongMatch$6,
	Strongmatch: Strongmatch$6,
	theseSkillsArePartialMatch: theseSkillsArePartialMatch$6,
	Partialmatch: Partialmatch$6,
	theseSkillsAreMissingFrom: theseSkillsAreMissingFrom$6,
	"Missing Keywords": "Palavras-chave ausentes",
	SkillMatchComponent: SkillMatchComponent$6,
	Optional: Optional$6,
	Notrelevanttothejob: Notrelevanttothejob$6,
	Notaskill: Notaskill$6,
	Toogeneric: Toogeneric$6,
	Pleaseshareanyfeedback: Pleaseshareanyfeedback$6,
	excludedKeywordsWillNot: excludedKeywordsWillNot$6,
	yesExcludeThisSkillFrom: yesExcludeThisSkillFrom$6,
	PartialMatch: PartialMatch$6,
	MissingKeywords: MissingKeywords$6,
	Providetitletotask: Providetitletotask$6,
	TasksList: TasksList$6,
	AddTask: AddTask$6,
	EnterTaskTitlehere: EnterTaskTitlehere$6,
	TasksComponent: TasksComponent$6,
	CompletedTasks: CompletedTasks$6,
	CompleteYourtasks: CompleteYourtasks$6,
	Steps: Steps$6,
	PremiumMember: PremiumMember$6,
	Thankyouforupgradingto: Thankyouforupgradingto$6,
	CareerflowPremium: CareerflowPremium$6,
	hereIsHowYouCanAccessPremium: hereIsHowYouCanAccessPremium$6,
	stepOne: stepOne$6,
	DownloadourChromeExtension: DownloadourChromeExtension$6,
	youJobSearchCopilotIshere: youJobSearchCopilotIshere$6,
	DownloadNow: DownloadNow$6,
	stepTwo: stepTwo$6,
	GetStarted: GetStarted$6,
	stepThree: stepThree$6,
	SignintoChromeExtension: SignintoChromeExtension$6,
	entityCreated: entityCreated$6,
	entityUpdated: entityUpdated$6,
	entityDeleted: entityDeleted$6,
	entityLinked: entityLinked$6,
	entityUnlinked: entityUnlinked$6,
	entityMovedTo: entityMovedTo$6,
	youAddedANewEntity: youAddedANewEntity$6,
	personCreated: personCreated$6,
	youUpdatedAEntity: youUpdatedAEntity$6,
	personUpdated: personUpdated$6,
	youDeletedAEntity: youDeletedAEntity$6,
	personDeleted: personDeleted$6,
	youLinkedEntity: youLinkedEntity$6,
	personLinked: personLinked$6,
	youUnlinked: youUnlinked$6,
	personUnlinked: personUnlinked$6,
	youMovedEntity: youMovedEntity$6,
	personMoved: personMoved$6,
	addedByName: addedByName$6,
	DownloadChromeExtension: DownloadChromeExtension$6,
	ourChromeExtensionIs: ourChromeExtensionIs$6,
	Optimizeyourprofile: Optimizeyourprofile$6,
	startOptimizingYourProfile: startOptimizingYourProfile$6,
	OptimizeNow: OptimizeNow$6,
	Addyourfirstjob: Addyourfirstjob$6,
	startSavingJobApplicationsToTrack: startSavingJobApplicationsToTrack$6,
	AddNow: AddNow$6,
	CompleteProfile: CompleteProfile$6,
	completeYourProfileForUsing: completeYourProfileForUsing$6,
	CompleteNow: CompleteNow$6,
	Addyourfirstcontact: Addyourfirstcontact$6,
	addContactToFollowUpWith: addContactToFollowUpWith$6,
	JoinCommunity: JoinCommunity$6,
	ourCommunityisAlways: ourCommunityisAlways$6,
	JoinNow: JoinNow$6,
	welcomeToCareerflow: welcomeToCareerflow$6,
	yourHubForCareerInsights2: yourHubForCareerInsights2$6,
	ChecklistCompleted: ChecklistCompleted$6,
	Completeyourchecklist: Completeyourchecklist$6,
	completeAFewStepsTo: completeAFewStepsTo$6,
	Completed: Completed$6,
	JobCountByStage: JobCountByStage$6,
	NopastapplicationDatafound: NopastapplicationDatafound$6,
	YourJobSearchStages: YourJobSearchStages$6,
	NoDatafound: NoDatafound$6
};

const copyToClipboard$5 = "Copiat în clipboard!";
const UnlocktheAIgenerated$5 = "Deblocați generatul de AI";
const UpgradetoPremium$5 = "Upgrade la Premium";
const Result$5 = "Rezultat";
const Copy$5 = "Copiază";
const Save$5 = "Salvează";
const Edit$5 = "Editează";
const Processing$5 = "În curs de procesare";
const YourAIgeneratedcontentwillshowhere$5 = "Conținutul generat de AI va fi afișat aici";
const hopeYouFindUseful$5 = "Sper că veți găsi acest rezultat util!";
const regenerate$5 = "Re-genera";
const ProvideAdditionalFeedback$5 = "Oferă Feedback Suplimentar";
const Enteranyfeedback$5 = "Introduceți orice feedback";
const Notimpressive$5 = "Nu este impresionant";
const thisIsntTrue$5 = "Acest lucru nu este adevărat";
const Notpersonalized$5 = "Nu este personalizat";
const Tone$5 = "Ton";
const Length$5 = "Lungime";
const Template$5 = "Șablon";
const Generatedon$5 = "Generat la";
const Copiedtoclipboard$5 = "Copiat în clipboard";
const CopytoClipboard$5 = "Copiază în Clipboard";
const DownloadasPDF$5 = "Descarcă ca PDF";
const ViewDetails$5 = "Vezi Detalii";
const JobDescriptionImported$5 = "Descrierea postului importată";
const ImportfromJob$5 = "Import din Job";
const Saved$5 = "Salvat";
const Applied$5 = "Aplicat";
const Offer$5 = "Ofertă";
const Interviewing$5 = "Interviu";
const Rejected$5 = "Respins";
const Search$5 = "Caută";
const Import$5 = "Import";
const CoverLetterGeneratorHistory$5 = "Istoric Generator Scrisoare de Intenție";
const NoCoverLettersGenerated$5 = "Nicio Scrisoare de Intenție Generată";
const getStartedCoverLetter$5 = "Nu ai generat încă nicio scrisoare de intenție. Începe și obține scrisori de intenție potrivind descrierea jobului cu experiența ta relevantă.";
const getStarted$5 = "Începe!";
const Documents$5 = "Documente";
const UploadNewDocument$5 = "Încarcă Document Nou";
const AICoverLetterGenerator$5 = "Generator Automat de Scrisori de Intenție";
const ViewHistory$5 = "Vezi Istoric";
const JobDescription$5 = "Descrierea Jobului";
const ImportfromBoard$5 = "Importă de pe Tablă";
const EnterJobDescription$5 = "Introdu Descrierea Jobului";
const JobTitle$5 = "Titlul Jobului";
const EnterJobTitle$5 = "Introdu Titlul Jobului";
const CompanyName$5 = "Numele Companiei";
const EnterCompanyName$5 = "Introdu Numele Companiei";
const YourProfile$5 = "Profilul Tău";
const ResumeUpload$5 = "Încarcă CV-ul";
const UseLinkedinProfile$5 = "Folosește Profilul Linkedin";
const Uploadyourresume$5 = "Încarcă-ți CV-ul";
const AddyourResume$5 = "Adaugă-ți CV-ul";
const fileNameCannotFormat$5 = "Numele fișierului nu poate conține spații sau sublinieri și ar trebui să fie în format .doc, .docx sau .pdf.";
const ChooseorUpload$5 = "Alege sau Încarcă";
const SelectTemplate$5 = "Selectează Șablonul";
const Preview$5 = "Previzualizare";
const UseTemplate$5 = "Folosește Șablonul";
const Change$5 = "Schimbă";
const AdvancedSettings$5 = "Setări Avansate";
const AdditionalContext$5 = "Context Suplimentar";
const Professional$5 = "Profesional";
const Casual$5 = "Lejer";
const Enthusiastic$5 = "Entuziast";
const Informational$5 = "Informativ";
const Short$5 = "Scurt";
const Medium$5 = "Mediu";
const Long$5 = "Lung";
const Language$5 = "Limba";
const iAmOkayBack$5 = "Sunt de acord! Întoarce-te";
const Generate$5 = "Generează";
const CoverLetter$5 = "Scrisoare de Intenție";
const SelectLanguage$5 = "Selectează Limba";
const AboutGeneratorHistory$5 = "Despre Istoricul Generatorului";
const NoAboutsGenerated$5 = "Nicio Descriere Generată";
const getStartedAbouts$5 = "Nu ai generat încă nicio descriere. Începe și obține descrieri potrivind descrierea jobului cu experiența ta relevantă.";
const noAttachmentsFound$5 = "Nicio atașare găsită.";
const TargetJobTitle$5 = "Titlu Job Țintă";
const KeywordsToInclude$5 = "Cuvinte cheie de inclus";
const UploadYourResume$5 = "Încărcați CV-ul dumneavoastră.";
const AddYourResume$5 = "Adaugă CV-ul tău";
const LinkedinProfile$5 = "Profil Linkedin";
const Linkedinprofilenotfound$5 = "Profil Linkedin negăsit";
const startUsingChromeExtension$5 = "Începe să-ți optimizezi profilul Linkedin folosind extensia noastră Chrome pentru a utiliza această opțiune.";
const Download$5 = "Descarcă";
const UseEmojis$5 = "Folosește Emojis";
const UseBulletPoints$5 = "Folosește Puncte";
const SpeechFocus$5 = "Focalizare Discurs";
const FirstPerson$5 = "Persoana I";
const ThirdPerson$5 = "Persoana a III-a";
const HeadlineGeneratorHistory$5 = "Istoric Generator Titluri";
const NoHeadlinesGenerated$5 = "Nicio Titlu Generat";
const getStartedHeadline$5 = "Nu ai generat încă niciun titlu. Începe și obține titluri potrivind descrierea jobului cu experiența ta relevantă.";
const AIHeadlineGenerator$5 = "Generator Automat de Titluri";
const KeywordstoInclude$5 = "Cuvinte Cheie de Inclus";
const Pressenteraftereachword$5 = "Apăsați tasta Enter după fiecare cuvânt.";
const LinkedinProfilenotfound$5 = "Profilul LinkedIn nu a fost găsit.";
const Headline$5 = "Titlu";
const PostGeneratorHistory$5 = "Istoric Generator Postări";
const NoPostsGenerated$5 = "Nicio Postare Generată";
const getStartedPost$5 = "Nu ai generat încă nicio postare. Începe și obține postări potrivind descrierea jobului cu experiența ta relevantă.";
const Topic$5 = "Subiect";
const Description$5 = "Descriere";
const UseHashtags$5 = "Folosește Hashtags";
const Custom$5 = "Personalizat";
const EnterCustomTone$5 = "Introdu Ton Personalizat";
const Added$5 = "Adăugat";
const ComingSoon$5 = {
	header: "Inginerii lucrează!",
	content_1: "Echipa noastră de ingineri lucrează intens pentru a aduce această funcționalitate în curând",
	content_2: "Vrei această funcționalitate rapid? Anunță-ne doar bifând caseta de mai jos.",
	content_3: "Vreau această funcționalitate"
};
const Company$5 = "Companie";
const JobInterview$5 = "Interviu de Angajare";
const Research$5 = "Cercetare";
const Networking$5 = "Networking";
const Referral$5 = "Recomandare";
const MustbeContacted$5 = "Trebuie Contactat";
const ScheduleaMeeting$5 = "Programare Întâlnire";
const needAFollowUp$5 = "Trebuie să urmăresc";
const Today$5 = "Astăzi";
const Viewdetails$5 = "Vezi Detalii";
const Activity$5 = "Activitate";
const ActivityDetails$5 = "Detalii Activitate";
const Delete$5 = "Șterge";
const Title$5 = "Titlu";
const Goal$5 = "Obiectiv";
const Status$5 = "Stare";
const FollowUp$5 = "Urmărire";
const AddActivity$5 = "Adaugă Activitate";
const Enteractivitytitle$5 = "Introduceți titlul activității";
const Cancel$5 = "Anulează";
const SaveActivity$5 = "Salvează Activitate";
const noActivityPresent$5 = "Nicio activitate prezentă, adăugați activitate.";
const Addnew$5 = "Adaugă nou";
const About$5 = "Despre";
const noDataPresentYou$5 = "Nu există date disponibile, puteți edita acest contact și adăuga câmpuri.";
const Experience$5 = "Experiență";
const Education$5 = "Educație";
const Skills$5 = "Abilități";
const Overview$5 = "Prezentare generală";
const LinkedJobs$5 = "Joburi Conectate";
const Notes$5 = "Note";
const FullName$5 = "Nume Complet";
const Location$5 = "Locație";
const Relationship$5 = "Relație";
const Contacts$5 = "Contacte";
const CreateContact$5 = "Creează Contact";
const NotesCreated$5 = "Note create";
const Notesupdated$5 = "Note actualizate";
const Addnote$5 = "Adaugă notă";
const areYouSureDeleteNote$5 = "Sunteți sigur că doriți să ștergeți această notă?";
const Createdby$5 = "Creat de";
const notSureWhyResumeCalls$5 = "Nu ești sigur de ce CV-ul tău nu îți aduce apeluri pentru interviuri? ☎️";
const getExpertResumeReview$5 = "Obțineți o revizuire a CV-ului de la un expert 💎✨";
const youHaventAddedContacts$5 = "Nu ai adăugat încă niciun contact.";
const noMatchingContacts$5 = "Nu s-au găsit contacte potrivite.";
const Link$5 = "Link";
const unlink$5 = "Dezactivează legătura";
const Locationnotavailable$5 = "Locație indisponibilă";
const Emailnotavailable$5 = "Email indisponibil";
const PhoneNumbernotavailable$5 = "Număr de telefon indisponibil";
const createdby$5 = "creat de";
const areYouSureDeleteContact$5 = "Sunteți sigur că doriți să ștergeți acest contact?";
const areYouSureUnlinkContact$5 = "Sunteți sigur că doriți să dezactivați legătura acestui contact?";
const Addedbyyou$5 = "Adăugat de tine";
const Addedby$5 = "Adăugat de";
const Timeline$5 = "Cronologie";
const Timelineempty$5 = "Linia de timp goală";
const Discard$5 = "Renunță";
const SaveContact$5 = "Salvează contactul";
const Recruiter$5 = "Recrutor";
const Candidate$5 = "Candidat";
const Colleague$5 = "Coleg";
const Employee$5 = "Angajat";
const EnterValidEmail$5 = "Introduceți un Email valid";
const EnterValidPhoneNumber$5 = "Introduceți un Număr de Telefon valid";
const editingProfileNotAvailable$5 = "Editarea fotografiei de profil nu este încă disponibilă.";
const itWillBeSoonAvailable$5 = "Va fi disponibil în curând în al nostru";
const ChromeExtension$5 = "Extensie Chrome";
const SelectTag$5 = "Selectați eticheta";
const FirstName$5 = "Prenume";
const FirstNameisrequired$5 = "Prenumele este obligatoriu";
const LastName$5 = "Nume de Familie";
const LastNameisrequired$5 = "Numele de familie este obligatoriu";
const Companyisrequired$5 = "Compania este obligatorie";
const Email$5 = "Email";
const ThisisnotavalidEmail$5 = "Acesta nu este un email valid";
const AddEmail$5 = "Adaugă Email";
const PhoneNumber$5 = "Număr de Telefon";
const notaValidPhone$5 = "Acesta nu este un număr de telefon valid. Introduceți doar numere.";
const phoneNoMinimum5char$5 = "Numărul de telefon trebuie să fie de cel puțin 5 caractere.";
const phoneNoMinumum15char$5 = "Numărul de telefon trebuie să fie de maximum 15 caractere.";
const AddPhoneNumber$5 = "Adaugă Număr de Telefon";
const SelectGoal$5 = "Selectați Obiectivul";
const SelectStatus$5 = "Selectați Starea";
const Followup$5 = "Urmărire";
const SocialMedia$5 = "Media Socială";
const Linkedinhandle$5 = "Cont Linkedin";
const Twitterhandle$5 = "Utilizator Twitter";
const Facebookhandle$5 = "Utilizator Facebook";
const Githubhandle$5 = "Utilizator Github";
const Gmailhandle$5 = "Utilizator Gmail";
const Changessavedsuccessfully$5 = "Schimbările au fost salvate cu succes";
const EditContact$5 = "Editează Contact";
const BasicInformation$5 = "Informații de Bază";
const EditContactDetails$5 = "Editare detalii de contact";
const SaveChanges$5 = "Salvează Schimbările";
const phoneNoMinimum14char$5 = "Numărul de telefon trebuie să fie de cel puțin 14 caractere.";
const LinkedIn$5 = "LinkedIn";
const Twitter$5 = "Twitter";
const Facebook$5 = "Facebook";
const Github$5 = "Github";
const Gmail$5 = "Gmail";
const youCanWriteAbout$5 = "Puteți scrie despre ani de experiență, industrie sau abilități. Oamenii vorbesc, de asemenea, despre realizările lor sau experiențele anterioare de muncă.";
const Addednewsection$5 = "Adăugată nouă secțiune";
const Removedsuccessfully$5 = "Eliminat cu succes.";
const Remove$5 = "Elimină";
const Institute$5 = "Institut";
const Schoolisrequired$5 = "Școala este obligatorie.";
const Degree$5 = "Grad";
const StartMonth$5 = "Luna de început";
const StartYear$5 = "Anul de început";
const EndMonth$5 = "Sfârșitul lunii";
const EndYear$5 = "Anul Nou";
const Addmore$5 = "Adaugă mai mult";
const PositionTitle$5 = "Titlul poziției";
const ExperienceType$5 = "Tipul de experiență";
const Addednewitem$5 = "Adăugat un element nou";
const whatSkillsDoYouEnjoy$5 = "Ce abilități aveți sau vă place să lucrați cu ele?";
const Typeskillshere$5 = "Tastați abilitățile aici";
const LinkedContacts$5 = "Contacte Conectate";
const LinkContact$5 = "Conectează Contact";
const NocontactsLinked$5 = "Niciun contact conectat";
const JobContactsComponent$5 = {
	linkContact: "Prin conectarea contactelor, puteți vedea rapid cine sunt persoanele importante, cum ar fi recrutorul, managerul de recrutare, etc., pentru acest rol! În viitor, vom putea aduce în evidență informații relevante bazate pe contactele dvs."
};
const Nocontacts$5 = "Fără contacte";
const LinkJobto$5 = "Conectează job-ul la";
const Contact$5 = "Contact";
const Document$5 = "Document";
const Nojobsfound$5 = "Niciun job găsit";
const LinkJob$5 = "Conectează Job";
const youCanLinkContactJobImported$5 = "Puteți lega acest contact la un loc de muncă pe care l-ați importat în Careerflow.";
const Prev$5 = "N/A (The quoted text is not a complete sentence and does not have a clear meaning.)";
const Next$5 = "Următorul";
const areYouSureUnlinkDocument$5 = "Sunteți sigur că doriți să dezactivați legătura acestui document?";
const areYouSureDeleteDocument$5 = "Sunteți sigur că doriți să ștergeți acest document?";
const Category$5 = "Categorie";
const CreatedOn$5 = "Creat la";
const Joblinked$5 = "Loc de muncă conectat";
const Quickactions$5 = "Acțiuni rapide";
const All$5 = "Toate";
const Resume$5 = "CV";
const Portfolio$5 = "Portofoliu";
const Other$5 = "Altul";
const Adddocument$5 = "Adaugă document";
const Type$5 = "Tip";
const Sortingby$5 = "Sortare după";
const SwitchtoGridLayout$5 = "Treci la aspectul de grilă.";
const SwitchtoListLayout$5 = "Comutați la aspectul de listă.";
const NoDocumentsAdded$5 = "Niciun Document Adăugat";
const DocumentsComponent$5 = {
	nodocs: "Nu ați creat încă niciun document. Puteți încărca versiunile dvs. de CV, scrisori de intenție și altele și le puteți conecta la joburile pe care le urmăriți!"
};
const NoDocumentFound$5 = "Niciun document găsit";
const SelectFile$5 = "Selectați Fișier";
const onlyPdfDocxSupported$5 = "Doar .pdf și .docx sunt acceptate.";
const Uploadfile$5 = "Încarcă fișier";
const DocumentCategory$5 = "Categorie Document";
const SaveDocument$5 = "Salvează Document";
const AddDocument$5 = "Adaugă Document";
const LinkedDocuments$5 = "Documente asociate";
const LinkDocument$5 = "Conectează Document";
const NodocumentsLinked$5 = "Niciun document conectat";
const JobDocumentsComponent$5 = {
	linkDocs: "Conectarea tuturor documentelor relevante, cum ar fi CV-ul, scrisoarea de intenție, etc., pe care le-ați depus pentru acest job vă va ajuta să urmăriți totul într-un singur loc. Încercați acum!"
};
const NoDocuments$5 = "Niciun Document";
const CreateDocuments$5 = "Creează Documente";
const youCanLinkDocumentJobImported$5 = "Puteți lega acest document de un loc de muncă pe care l-ați importat în Careerflow.";
const Documenteditedsuccessfully$5 = "Documentul a fost editat cu succes";
const DocumentDetails$5 = "Detalii ale documentului";
const UnsavedChanges$5 = "Modificări nesalvate";
const yourChangesWillBeLostSureClose$5 = "Schimbările tale vor fi pierdute, ești sigur că vrei să închizi?";
const yourChangesWillBeLostSureDiscard$5 = "Schimbările tale vor fi pierdute, ești sigur că vrei să renunți la ele?";
const DiscardChanges$5 = "Renunță la modificări";
const WeeklyGoalAlert$5 = "Alertă de obiectiv săptămânal";
const Progress$5 = "Progres";
const AllGoals$5 = "Toate obiectivele";
const Name$5 = "Nume";
const Completedon$5 = "Finalizat la";
const Createdon$5 = "Creat la";
const Action$5 = "Acțiune";
const Back$5 = "Înapoi";
const OverallScore$5 = "Punctaj general";
const Aboutthegoal$5 = "Despre obiectiv";
const GoalTracking$5 = "Urmărire obiectiv";
const Week$5 = "Săptămână";
const progress$5 = "progres";
const loading$5 = "Încărcare";
const Apply$5 = "Aplicați";
const Thisskillhasbeenreported$5 = "Această abilitate a fost raportată";
const issueGettingResume$5 = "A existat o problemă în obținerea CV-ului.";
const Interview$5 = "Interviu";
const Tasks$5 = "Sarcini";
const Loading$5 = "Încărcare";
const Skilladdedsuccessfully$5 = "Abilitate adăugată cu succes.";
const problemAddingSkill$5 = "A existat o problemă la adăugarea abilității.";
const Reportaproblem$5 = "Raportează o Problemă";
const Submit$5 = "Trimite";
const Addanewskill$5 = "Adaugă o nouă abilitate";
const JobDetailsComponent$5 = {
	classifySkill: "Cum ai clasifica această abilitate (Opțional)",
	includedKeywordsWillCount: "Includem acest cuvânt cheie?",
	yesIncludeThisSkill: "Cuvintele cheie incluse vor conta împotriva scorului tău de potrivire pentru toate scanările viitoare. Puteți schimba cuvintele cheie incluse din profilul tău.",
	addSkill: "Doriți să adăugați acest lucru ca abilitate?"
};
const HardSkill$5 = "Abilitate Tehnică";
const SoftSkill$5 = "Abilitate Moale";
const Pleaseshareanyadditionalcontext$5 = "Vă rugăm să partajați orice context suplimentar";
const Addasskill$5 = "Adaugă ca abilitate";
const Skill$5 = "Abilitate";
const JobFrequency$5 = "Frecvență Job";
const ResumeFrequency$5 = "Frecvență CV";
const Reportskill$5 = "Raportează abilitate";
const JobDetails$5 = "Detalii despre locul de muncă";
const ViewJobLink$5 = "Vizualizați linkul de job";
const Salary$5 = "Salariu";
const areYouSureDeleteJob$5 = "Sunteți sigur că doriți să ștergeți acest loc de muncă?";
const ViewMore$5 = "Vezi Mai Mult";
const ViewLess$5 = "Vezi Mai Puțin";
const matchYouSkillsAgainstJob$5 = "Potrivește-ți abilitățile cu descrierea postului.";
const pleaseUploadResumeSkillMatch$5 = "Vă rugăm să încărcați CV-ul dumneavoastră pentru a obține scorul de potrivire a abilităților.";
const AddResume$5 = "Adaugă CV";
const thisJobDoesNotHaveAnyDesc$5 = "Această slujbă nu are nicio descriere";
const youCanEditJobToAdd$5 = "Puteți edita acest loc de muncă pentru a adăuga o descriere. De asemenea, puteți importa locuri de muncă folosind platforma noastră.";
const chromeextension$5 = "extensie Chrome";
const fromVariousJobPortalsOnce$5 = "de la diverse portaluri de joburi. Odată ce adăugați o descriere, veți putea vedea și informații legate de abilități.";
const AddDescription$5 = "Adăugați descriere.";
const CompanyInfo$5 = "Informații despre companie";
const Website$5 = "Website";
const Industry$5 = "Industrie";
const EmployeeCount$5 = "Număr Angajați";
const ExprienceLevel$5 = "Nivel Experiență";
const Address$5 = "Adresă";
const Resumes$5 = "CV-uri";
const Setasdefault$5 = "Setează ca implicit";
const Ok$5 = "Ok";
const UploadNewResume$5 = "Încarcă CV Nou";
const Default$5 = "Implicit";
const Jobnotfound$5 = "Locul de muncă nu a fost găsit";
const EditDetails$5 = "Editează Detalii";
const JobPostURL$5 = "URL Postare Job";
const Enterjoburl$5 = "Introduceți URL-ul locului de muncă.";
const Nojobselected$5 = "Niciun loc de muncă selectat";
const Viewjobdetails$5 = "Vedeți detalii despre job";
const Jobaddedtoyourboardsuccessfully$5 = "Job-ul a fost adăugat cu succes pe tabla ta.";
const AddJob$5 = "Adaugă Job";
const Addnewjobname$5 = "Adăugați un nou nume de job.";
const JobUrl$5 = "URL Job";
const Addjoburl$5 = "Adăugați URL-ul locului de muncă.";
const Section$5 = "Secțiune";
const didYouKnow$5 = {
	chromeExtension: "Știați? Puteți salva, de asemenea, joburile direct din Extensia Chrome și aveți toate datele importate într-un singur clic! Durează doar câteva secunde."
};
const Jobs$5 = "Joburi";
const AddJobtoboard$5 = "Adăugați loc de muncă pe tablă.";
const Currentlynojobsareavailable$5 = "În prezent nu sunt disponibile locuri de muncă.";
const noMatchingJobs$5 = "Nicio ofertă de muncă potrivită găsită.";
const welcomeToYourPersonalJobTracker$5 = "Bine ați venit la urmăritorul personal de locuri de muncă!";
const weShortTutorialOnHowTrackingJob$5 = "Vă vom ghida printr-un tutorial scurt despre cum să începeți să urmăriți aplicațiile dvs. de job în câțiva pași simpli!";
const Addanewjob$5 = "Adăugați un nou loc de muncă.";
const inOrderTrackCreatButton$5 = "Pentru a începe să urmăriți aplicațiile de job, trebuie mai întâi să le adăugați pe tablă, făcând clic pe butonul \"Creează\".";
const Providesomedetails$5 = "Furnizați câteva detalii.";
const toBeginTypeJobTitleCompany$5 = "În primul rând, tastați pur și simplu titlul job-ului, numele companiei și starea în care doriți să-l adăugați. Puteți adăuga mai multe detalii mai târziu, dar asta este tot ce aveți nevoie acum!";
const asAnExampleFilledForYou$5 = "Ca exemplu, deja am completat asta pentru tine!";
const wohooAddedFirstJob$5 = "Woohoo! Ai adăugat primul tău loc de muncă în urmăritorul de job-uri!";
const youCanDragDropJobCard$5 = "Acum puteți trage și plasa cartela de loc de muncă în diferitele etape ale procesului de aplicare pentru locul de muncă. Dând clic pe cartela de loc de muncă vă permite să vizualizați mai multe detalii, să le editați, să salvați note și multe altele!";
const Lastbutnotleast$5 = "Nu în ultimul rând";
const finalStepMakeSure$5 = "Ca ultim pas, asigurați-vă că aveți traducerea noastră.";
const autoMaticallyImportJobs$5 = "care vă va permite să importați automat locuri de muncă de pe site-urile dvs. preferate de căutare a locurilor de muncă, cum ar fi LinkedIn, Indeed și altele! Extensia noastră vă ajută, de asemenea, să vă îmbunătățiți profilul LinkedIn și să obțineți de 2,5 ori mai multe apariții în căutările de locuri de muncă!";
const selectanysection$5 = "selectați orice secțiune";
const Accept$5 = "Acceptați";
const My2023JobSearch$5 = "Căutarea Mea de Job 2023";
const AddedFrom$5 = "Adăugat de la";
const AddedUntil$5 = "Adăugat până la";
const BasicModal$5 = "Modalitate de Bază";
const AddnewSectionName$5 = "Adaugă Nume Secțiune Nouă";
const OpenTo$5 = "Deschis pentru";
const Featured$5 = "Recomandat";
const LicenceAndCerts$5 = "Licențe și certificate";
const Banner$5 = "Banner";
const LinkedInURL$5 = "URL LinkedIn";
const Recommendations$5 = "Recomandări";
const LinkedinReview$5 = "Recenzie Linkedin";
const NoDataAvailable$5 = "Nu sunt date disponibile.";
const looksLikeYouDidNot$5 = "Se pare că nu ai început să folosești traducerea noastră în limba română.";
const toOptimizeProfileScoreVisible$5 = "pentru a-ți optimiza profilul de LinkedIn încă. Odată ce vei face asta, scorul profilului tău va fi vizibil aici.";
const LinkedinComponent$5 = {
	letsOptimize: "Optimizați"
};
const improveYourChancesLandingDreamJob$5 = "Îmbunătățiți-vă șansele de a obține jobul visurilor dvs. Utilizați aceste strategii testate și verificate pentru a da profilului dvs. LinkedIn o transformare mult necesară.";
const VisitProfile$5 = "Vizitați profilul";
const wantToGetLinkedinMakeover$5 = "Doriți să obțineți o transformare completă a profilului de LinkedIn?";
const PostGenerator$5 = "Generator de postări";
const LinkedinHeadlineGenerator$5 = "Generator de titluri LinkedIn";
const LinkedinAboutSectionGenerator$5 = "Generator de secțiuni despre LinkedIn";
const AITools$5 = "Instrumente AI";
const Premium$5 = "Premium";
const LinkedInOptimization$5 = "Optimizarea pe LinkedIn";
const JobTracker$5 = "Urmăritor de locuri de muncă";
const whoIsHiring$5 = "Cine angajează";
const Autofill$5 = "Completare automată";
const HeadlineGenerator$5 = "Generator de titluri";
const skillMatching$5 = "Potrivirea abilităților";
const SummarizeJD$5 = "Rezumatul descrierii postului";
const contactFeature$5 = "Urmărirea contactelor";
const documentFeature$5 = "Documente";
const landJobWithoutStress$5 = "Obține job-ul visurilor tale. Fără stres.";
const discoverFeatures$5 = "Descoperă gama de funcționalități Careerflow.ai concepute pentru a-ți simplifica căutarea de locuri de muncă și a-ți îmbunătăți călătoria profesională!";
const letsBeginOnboarding$5 = "Să te cunoaștem mai bine!";
const inTheNextFewScreensJobThirdParties$5 = "În următoarele ecrane, vă vom întreba câteva întrebări care ne vor ajuta să personalizăm experiența pentru dvs. și să completați automat aplicațiile dvs. de locuri de muncă (astfel încât să nu fie nevoie să o faceți)! Nu vindem datele dvs. către terți.";
const letsAddBasicInformation$5 = "Să adăugăm informațiile tale de bază";
const Pleaseselectanoptionfirst$5 = "Vă rugăm să selectați mai întâi o opțiune.";
const JobApplicationTracker$5 = "Urmăritor de cereri de angajare";
const LinkedInProfileOptimizer$5 = "Optimizer pentru profilul de LinkedIn";
const UnlimitedDocuments$5 = "Documente nelimitate";
const UnlimitedContacts$5 = "Contacte nelimitate";
const HiringManagerSearch$5 = "Căutare de manager de angajare";
const AILinkedInPostGenerator$5 = "Generator de postări AI pe LinkedIn";
const ATSKeywordSkillMatch$5 = "Jobul potrivit cu cuvinte cheie / abilități ATS";
const ChooseyourPlan$5 = "Alegeți planul dumneavoastră";
const superChargeYourJobSearch$5 = "Îmbunătățiți-vă căutarea de locuri de muncă și procesul de aplicare, creșteți numărul interviurilor și obțineți jobul visurilor dvs. Cu ajutorul trusei premium Careerflow.";
const startNowGoto$5 = "Începe acum (Accesează aplicația)";
const CreatedBy$5 = "Creat De";
const CreateNewNote$5 = "Creează Notă Nouă";
const Nonotescreated$5 = "Nicio notă creată";
const approxTimeIsFourMinutes$5 = "Timpul aproximativ pentru finalizarea procesului de integrare este de 4 minute.";
const Continue$5 = "Continuă";
const iWillDoLaterTakeMeToApp$5 = "O să fac asta mai târziu. Du-mă la aplicație.";
const allDone$5 = "Totul gata!";
const welcomeAbord$5 = "Bun venit la bord!";
const letsBegin$5 = "Să începem";
const UpgradeyourplanandgetAIAssistance$5 = "Îmbunătățiți-vă planul și obțineți asistență AI.";
const DownloadPDF$5 = "Descarcă PDF";
const oopsWeCouldntProcessResume$5 = "Oops, nu am putut procesa acest CV.";
const MyProfile$5 = "Profilul meu";
const Setting$5 = "Configurare";
const Logout$5 = "Deconectare";
const SignIn$5 = "Conectare";
const Typeyourfirstnamehere$5 = "Prenumele tău";
const Enteryourlastname$5 = "Numele tău de familie";
const ManageSubscription$5 = "Administrare abonament";
const ifYouHaveDifficultiesProfile$5 = "Dacă întâmpinați dificultăți cu informațiile din profilul dumneavoastră, vă rugăm să ne contactați.";
const forSupport$5 = "pentru suport.";
const whatIsIdealCompanySize$5 = "Care este dimensiunea ideală a companiei tale?";
const Saveandcontinue$5 = "Salvează și continuă";
const whatIsMinExpectedSalary$5 = "Care este salariul minim așteptat (pe an)?";
const Atleast$5 = "Cel puțin";
const SlidetoAdjust$5 = "Glisați pentru a ajusta";
const whatIndustryExcitedWork$5 = "Ce industrii te entuziasmează?";
const Add$5 = "Adăugați";
const statusOfJobSearch$5 = "Starea căutării tale de loc de muncă?";
const Finish$5 = "Terminat";
const whatLevelRoleLooking$5 = "Ce nivel de rol căutați?";
const Selectuptotwo$5 = "Selectați până la două.";
const PreviousStep$5 = "Pasul anterior";
const Skip$5 = "Omite";
const whatDoYouValueNewRole$5 = "Ce apreciați într-un nou rol?";
const Selectuptothree$5 = "Selectați până la trei.";
const EqualEmploymentData$5 = "Date privind egalitatea de angajare";
const whatIsYourEthnicity$5 = "Care este etnia ta?";
const areYouAuthorizedToWorkUs$5 = "Sunteți autorizat să lucrați în SUA?";
const willYouRequireSponsorShip$5 = "Veți avea nevoie acum sau în viitor de sponsorizare pentru statutul de viză de angajare?";
const doYouHaveADisability$5 = "Aveți o dizabilitate?";
const areYouAVeteran$5 = "Ești veteran?";
const rolesYouInterestedIn$5 = "În ce fel de roluri ești interesat?";
const Selectuptofive$5 = "Selectați până la cinci.";
const AddCustomrole$5 = "Adăugați rol personalizat.";
const whereDoYouLikeWork$5 = "Unde ai dori să lucrezi?";
const Resources$5 = "Resurse";
const currentlyNoResourceAvailable$5 = "În prezent nu sunt disponibile resurse.";
const AddNewSection$5 = "Adaugă Secțiune Nouă";
const ChangeSections$5 = "Schimbă secțiunile";
const Settings$5 = "Setări";
const Dashboard$5 = "Panou de Control";
const JobBoard$5 = "Tablou de Anunțuri";
const Linkedin$5 = "Linkedin";
const Community$5 = "Comunitate";
const FindRecruiters$5 = "Găsiți recrutori";
const Goals$5 = "Obiective";
const DownloadExtension$5 = "Descarcă Extensia";
const SuggestaFeature$5 = "Sugerează o funcționalitate";
const leftPanel$5 = {
	ReportanIssue: "Raportează o problemă"
};
const PhoneNumberisrequired$5 = "Numărul de telefon este obligatoriu.";
const MobileNumber$5 = "Număr de telefon mobil";
const Enteronlynumbers$5 = "Introduceți doar numere.";
const Countryyoulivein$5 = "Țara în care locuiești";
const SelectaCountry$5 = "Selectați o țară";
const DateofBirth$5 = "Data nașterii";
const Gender$5 = "Gen";
const JobPreferences$5 = "Preferințe de locuri de muncă";
const pleaseEnterValidEmail$5 = "Vă rugăm să introduceți o adresă de email validă.";
const emailSendForResetting$5 = "Un email a fost trimis către tine pentru resetarea parolei";
const VerifyyourEmailID$5 = "Verificați adresa dvs. de email";
const sentPleaseCheckEmail$5 = "Trimis! Vă rugăm să verificați emailul.";
const tooManyAttemptsTryAgain$5 = "Prea multe încercări, vă rugăm să încercați din nou într-un timp.";
const Resend$5 = "Retrimite";
const Login$5 = "Autentificare";
const weHaveSentVerificationLinkAtEmail$5 = "V-am trimis un link de verificare la adresa dvs. de e-mail";
const pleaseVerifyEmailContinueSpam$5 = "Vă rugăm să verificați adresa dvs. de e-mail pentru a continua. Vă rugăm să verificați și folderul de spam sau de promovare pentru e-mailul de verificare.";
const Logintogetstarted$5 = "Conectează-te pentru a începe.";
const ContinuewithGoogle$5 = "Continuați cu Google";
const pleaseInputEmail$5 = "Vă rugăm să introduceți adresa dvs. de email!";
const Password$5 = "Parolă";
const pleaseInputPassword$5 = "Vă rugăm să introduceți parola dumneavoastră!";
const passwordLowerUpperDigitSpecial$5 = "Parola ta trebuie să conțină cel puțin o literă mică, o literă mare, o cifră și un caracter special.";
const atLeastSixChar$5 = "Cel puțin 6 caractere.";
const forgotPassword$5 = "Ați uitat parola?";
const Bysigninginyouagreetoour$5 = "Prin autentificarea dumneavoastră sunteți de acord cu termenii noștri.";
const Terms$5 = "Termeni";
const Conditions$5 = "Condiții";
const and$5 = "și";
const PrivacyPolicy$5 = "Politica de confidențialitate";
const theseAreTheTopsSkillsExtracted$5 = "Acestea sunt abilitățile de top extrase din descrierea postului.";
const TopSkills$5 = "Abilități de top";
const weCoulNotExtractSkills$5 = "Nu am putut extrage nicio abilitate din această descriere a jobului.";
const upgradeToPremiumToView$5 = "Upgrade la Premium pentru a vedea scorul de potrivire a abilităților din CV-ul tău.";
const SkillScore$5 = "Scor Abilitate";
const thisIsYourSkillScoreBasedOn$5 = "Aceasta este scorul tău de competențe bazat pe descrierea jobului și CV-ul tău.";
const theseSkllsAreStrongMatch$5 = "Aceste abilități se potrivesc perfect între CV-ul tău și descrierea postului.";
const Strongmatch$5 = "Potrivire Puternică";
const theseSkillsArePartialMatch$5 = "Aceste abilități sunt o potrivire parțială între CV-ul tău și descrierea postului.";
const Partialmatch$5 = "Potrivire parțială";
const theseSkillsAreMissingFrom$5 = "Aceste cuvinte cheie lipsesc din CV-ul tău, dar sunt prezente în descrierea postului. Acestea pot fi abilități sau cuvinte cheie generale specifice oportunității de angajare și ar putea fi utile să le adaugi în CV-ul tău.";
const SkillMatchComponent$5 = {
	removeSkill: "Care este principalul motiv pentru raportarea unei probleme pentru cuvântul cheie"
};
const Optional$5 = "Opțional";
const Notrelevanttothejob$5 = "Nu este relevant pentru job";
const Notaskill$5 = "Fără abilități";
const Toogeneric$5 = "Prea general";
const Pleaseshareanyfeedback$5 = "Vă rugăm să împărtășiți orice feedback";
const excludedKeywordsWillNot$5 = "Cuvintele cheie excluse nu vor conta în scorul tău de potrivire pentru toate scanările viitoare. Puteți schimba cuvintele cheie excluse din profilul tău.";
const yesExcludeThisSkillFrom$5 = "Da, excludeți această abilitate din toate scanările mele de CV.";
const PartialMatch$5 = "Potrivire Parțială";
const MissingKeywords$5 = "Cuvinte Cheie Lipsă";
const Providetitletotask$5 = "Furnizați titlu pentru sarcină";
const TasksList$5 = "Lista de sarcini";
const AddTask$5 = "Adaugă Sarcină";
const EnterTaskTitlehere$5 = "Introduceți Titlul Sarcinii aici";
const TasksComponent$5 = {
	listEmpty: "Lista de Sarcini este goală, Creați una Nouă."
};
const CompletedTasks$5 = "Sarcini finalizate";
const CompleteYourtasks$5 = "Finalizați-vă sarcinile";
const Steps$5 = "Pasii";
const PremiumMember$5 = "Membru Premium";
const Thankyouforupgradingto$5 = "Mulțumim pentru upgrade-ul la";
const CareerflowPremium$5 = "Cariera flux Premium";
const hereIsHowYouCanAccessPremium$5 = "Iată cum să accesezi beneficiile tale Premium!";
const stepOne$5 = "Pasul 1";
const DownloadourChromeExtension$5 = "Descărcați extensia noastră Chrome.";
const youJobSearchCopilotIshere$5 = "Co-pilotul tău AI pentru căutarea de job-uri este aici.";
const DownloadNow$5 = "Descarcă acum";
const stepTwo$5 = "Etapa 2";
const GetStarted$5 = "Începeți";
const stepThree$5 = "Etapa 3";
const SignintoChromeExtension$5 = "Conectați-vă la extensia Chrome";
const entityCreated$5 = "Noua {{entitate}} a fost creată.";
const entityUpdated$5 = "{{entity}} actualizat.";
const entityDeleted$5 = "{{entity}} șters.";
const entityLinked$5 = "{{entitate}} conectată";
const entityUnlinked$5 = "{{entitate}} dezlegată";
const entityMovedTo$5 = "Mutat la {{entitate}}.";
const youAddedANewEntity$5 = "Ați adăugat o nouă {{entitate}}.";
const personCreated$5 = "{{creator}} a creat o {{entity}} pentru {{owner}}.";
const youUpdatedAEntity$5 = "Ați actualizat o {{entitate}}.";
const personUpdated$5 = "{{creator}} a actualizat o {{entitate}} pentru {{proprietar}}.";
const youDeletedAEntity$5 = "Ați șters o {{entitate}}.";
const personDeleted$5 = "{{creator}} a șters o {{entity}} pentru {{owner}}.";
const youLinkedEntity$5 = "Ați legat o {{entitate}} la acest Job";
const personLinked$5 = "{{creator}} a legat o {{entity}} la acest Job pentru {{owner}}.";
const youUnlinked$5 = "Ați dezlegat o {{entitate}} de acest loc de muncă.";
const personUnlinked$5 = "{{creator}} a dezlegat o {{entity}} de acest Job pentru {{owner}}.";
const youMovedEntity$5 = "Ați mutat această {{entity}} din {{sectionFrom}} în {{sectionTo}}";
const personMoved$5 = "{{creator}} a mutat această {{entity}} din {{sectionFrom}} în {{sectionTo}} pentru {{owner}}.";
const addedByName$5 = "Adăugat de {{name}}.";
const DownloadChromeExtension$5 = "Descărcați extensia Chrome.";
const ourChromeExtensionIs$5 = "Extensia noastră Chrome este o unealtă integrată pentru a vă ajuta să vă optimizați profilul LinkedIn, să salvați locuri de muncă, să salvați contacte, să generați scrisori de intenție și multe altele.";
const Optimizeyourprofile$5 = "Optimizați-vă profilul";
const startOptimizingYourProfile$5 = "Începeți să vă optimizați profilul pentru a avea mai multe șanse de a fi contactat de recrutori.";
const OptimizeNow$5 = "Optimizați acum";
const Addyourfirstjob$5 = "Adaugă-ți primul loc de muncă";
const startSavingJobApplicationsToTrack$5 = "Începeți să salvați aplicațiile de job pentru a urmări călătoria căutării de locuri de muncă și pentru a găsi informații utile.";
const AddNow$5 = "Adaugă acum";
const CompleteProfile$5 = "Profil complet";
const completeYourProfileForUsing$5 = "Completați-vă profilul pentru a utiliza funcția de completare automată și pentru a obține o experiență mai personalizată.";
const CompleteNow$5 = "Finalizat acum";
const Addyourfirstcontact$5 = "Adăugați primul contact al dvs.";
const addContactToFollowUpWith$5 = "Adăugați contactul pentru a-i urmări mai târziu, adăugați note și multe altele.";
const JoinCommunity$5 = "Alătură-te comunității";
const ourCommunityisAlways$5 = "Comunitatea noastră este mereu alături de tine în călătoria ta de căutare a unui loc de muncă.";
const JoinNow$5 = "Alătură-te acum";
const welcomeToCareerflow$5 = "Bun venit la Careerflow!";
const yourHubForCareerInsights2$5 = "Acesta este centrul tău pentru informații despre carieră, activități și multe altele. Explorează panoul tău personalizat pentru a rămâne la curent cu călătoria ta profesională.";
const ChecklistCompleted$5 = "Lista ta de verificare este completă!";
const Completeyourchecklist$5 = "Finalizează lista de verificare";
const completeAFewStepsTo$5 = "Parcurge câțiva pași pentru a-ți găsi următorul loc de muncă.";
const Completed$5 = "Finalizat";
const JobCountByStage$5 = "Numărul de locuri de muncă în funcție de etapă";
const NopastapplicationDatafound$5 = "Nicio informație despre aplicații anterioare găsită";
const YourJobSearchStages$5 = "Etapele căutării tale de loc de muncă";
const NoDatafound$5 = "Nu s-au găsit date.";
const ro = {
	copyToClipboard: copyToClipboard$5,
	UnlocktheAIgenerated: UnlocktheAIgenerated$5,
	UpgradetoPremium: UpgradetoPremium$5,
	Result: Result$5,
	Copy: Copy$5,
	Save: Save$5,
	Edit: Edit$5,
	Processing: Processing$5,
	YourAIgeneratedcontentwillshowhere: YourAIgeneratedcontentwillshowhere$5,
	hopeYouFindUseful: hopeYouFindUseful$5,
	regenerate: regenerate$5,
	ProvideAdditionalFeedback: ProvideAdditionalFeedback$5,
	Enteranyfeedback: Enteranyfeedback$5,
	Notimpressive: Notimpressive$5,
	thisIsntTrue: thisIsntTrue$5,
	Notpersonalized: Notpersonalized$5,
	Tone: Tone$5,
	Length: Length$5,
	Template: Template$5,
	Generatedon: Generatedon$5,
	Copiedtoclipboard: Copiedtoclipboard$5,
	CopytoClipboard: CopytoClipboard$5,
	DownloadasPDF: DownloadasPDF$5,
	ViewDetails: ViewDetails$5,
	JobDescriptionImported: JobDescriptionImported$5,
	ImportfromJob: ImportfromJob$5,
	Saved: Saved$5,
	Applied: Applied$5,
	Offer: Offer$5,
	Interviewing: Interviewing$5,
	Rejected: Rejected$5,
	Search: Search$5,
	Import: Import$5,
	CoverLetterGeneratorHistory: CoverLetterGeneratorHistory$5,
	NoCoverLettersGenerated: NoCoverLettersGenerated$5,
	getStartedCoverLetter: getStartedCoverLetter$5,
	getStarted: getStarted$5,
	Documents: Documents$5,
	UploadNewDocument: UploadNewDocument$5,
	AICoverLetterGenerator: AICoverLetterGenerator$5,
	ViewHistory: ViewHistory$5,
	JobDescription: JobDescription$5,
	ImportfromBoard: ImportfromBoard$5,
	EnterJobDescription: EnterJobDescription$5,
	JobTitle: JobTitle$5,
	EnterJobTitle: EnterJobTitle$5,
	CompanyName: CompanyName$5,
	EnterCompanyName: EnterCompanyName$5,
	YourProfile: YourProfile$5,
	ResumeUpload: ResumeUpload$5,
	UseLinkedinProfile: UseLinkedinProfile$5,
	Uploadyourresume: Uploadyourresume$5,
	AddyourResume: AddyourResume$5,
	fileNameCannotFormat: fileNameCannotFormat$5,
	ChooseorUpload: ChooseorUpload$5,
	SelectTemplate: SelectTemplate$5,
	Preview: Preview$5,
	UseTemplate: UseTemplate$5,
	Change: Change$5,
	AdvancedSettings: AdvancedSettings$5,
	AdditionalContext: AdditionalContext$5,
	Professional: Professional$5,
	Casual: Casual$5,
	Enthusiastic: Enthusiastic$5,
	Informational: Informational$5,
	Short: Short$5,
	Medium: Medium$5,
	Long: Long$5,
	Language: Language$5,
	iAmOkayBack: iAmOkayBack$5,
	Generate: Generate$5,
	CoverLetter: CoverLetter$5,
	SelectLanguage: SelectLanguage$5,
	AboutGeneratorHistory: AboutGeneratorHistory$5,
	NoAboutsGenerated: NoAboutsGenerated$5,
	getStartedAbouts: getStartedAbouts$5,
	noAttachmentsFound: noAttachmentsFound$5,
	TargetJobTitle: TargetJobTitle$5,
	KeywordsToInclude: KeywordsToInclude$5,
	UploadYourResume: UploadYourResume$5,
	AddYourResume: AddYourResume$5,
	LinkedinProfile: LinkedinProfile$5,
	Linkedinprofilenotfound: Linkedinprofilenotfound$5,
	startUsingChromeExtension: startUsingChromeExtension$5,
	Download: Download$5,
	UseEmojis: UseEmojis$5,
	UseBulletPoints: UseBulletPoints$5,
	SpeechFocus: SpeechFocus$5,
	FirstPerson: FirstPerson$5,
	ThirdPerson: ThirdPerson$5,
	HeadlineGeneratorHistory: HeadlineGeneratorHistory$5,
	NoHeadlinesGenerated: NoHeadlinesGenerated$5,
	getStartedHeadline: getStartedHeadline$5,
	AIHeadlineGenerator: AIHeadlineGenerator$5,
	KeywordstoInclude: KeywordstoInclude$5,
	Pressenteraftereachword: Pressenteraftereachword$5,
	LinkedinProfilenotfound: LinkedinProfilenotfound$5,
	Headline: Headline$5,
	PostGeneratorHistory: PostGeneratorHistory$5,
	NoPostsGenerated: NoPostsGenerated$5,
	getStartedPost: getStartedPost$5,
	Topic: Topic$5,
	Description: Description$5,
	UseHashtags: UseHashtags$5,
	Custom: Custom$5,
	EnterCustomTone: EnterCustomTone$5,
	Added: Added$5,
	ComingSoon: ComingSoon$5,
	Company: Company$5,
	JobInterview: JobInterview$5,
	Research: Research$5,
	Networking: Networking$5,
	Referral: Referral$5,
	MustbeContacted: MustbeContacted$5,
	ScheduleaMeeting: ScheduleaMeeting$5,
	needAFollowUp: needAFollowUp$5,
	Today: Today$5,
	Viewdetails: Viewdetails$5,
	Activity: Activity$5,
	ActivityDetails: ActivityDetails$5,
	Delete: Delete$5,
	Title: Title$5,
	Goal: Goal$5,
	Status: Status$5,
	FollowUp: FollowUp$5,
	AddActivity: AddActivity$5,
	Enteractivitytitle: Enteractivitytitle$5,
	Cancel: Cancel$5,
	SaveActivity: SaveActivity$5,
	noActivityPresent: noActivityPresent$5,
	Addnew: Addnew$5,
	About: About$5,
	noDataPresentYou: noDataPresentYou$5,
	Experience: Experience$5,
	Education: Education$5,
	Skills: Skills$5,
	Overview: Overview$5,
	LinkedJobs: LinkedJobs$5,
	Notes: Notes$5,
	FullName: FullName$5,
	Location: Location$5,
	Relationship: Relationship$5,
	Contacts: Contacts$5,
	CreateContact: CreateContact$5,
	NotesCreated: NotesCreated$5,
	Notesupdated: Notesupdated$5,
	Addnote: Addnote$5,
	areYouSureDeleteNote: areYouSureDeleteNote$5,
	Createdby: Createdby$5,
	notSureWhyResumeCalls: notSureWhyResumeCalls$5,
	getExpertResumeReview: getExpertResumeReview$5,
	youHaventAddedContacts: youHaventAddedContacts$5,
	noMatchingContacts: noMatchingContacts$5,
	Link: Link$5,
	unlink: unlink$5,
	Locationnotavailable: Locationnotavailable$5,
	Emailnotavailable: Emailnotavailable$5,
	PhoneNumbernotavailable: PhoneNumbernotavailable$5,
	createdby: createdby$5,
	areYouSureDeleteContact: areYouSureDeleteContact$5,
	areYouSureUnlinkContact: areYouSureUnlinkContact$5,
	Addedbyyou: Addedbyyou$5,
	Addedby: Addedby$5,
	Timeline: Timeline$5,
	Timelineempty: Timelineempty$5,
	Discard: Discard$5,
	SaveContact: SaveContact$5,
	Recruiter: Recruiter$5,
	Candidate: Candidate$5,
	Colleague: Colleague$5,
	Employee: Employee$5,
	"Needtofollow-up": "Necesar de Urmat",
	EnterValidEmail: EnterValidEmail$5,
	EnterValidPhoneNumber: EnterValidPhoneNumber$5,
	editingProfileNotAvailable: editingProfileNotAvailable$5,
	itWillBeSoonAvailable: itWillBeSoonAvailable$5,
	ChromeExtension: ChromeExtension$5,
	SelectTag: SelectTag$5,
	FirstName: FirstName$5,
	FirstNameisrequired: FirstNameisrequired$5,
	LastName: LastName$5,
	LastNameisrequired: LastNameisrequired$5,
	Companyisrequired: Companyisrequired$5,
	Email: Email$5,
	ThisisnotavalidEmail: ThisisnotavalidEmail$5,
	AddEmail: AddEmail$5,
	PhoneNumber: PhoneNumber$5,
	notaValidPhone: notaValidPhone$5,
	phoneNoMinimum5char: phoneNoMinimum5char$5,
	phoneNoMinumum15char: phoneNoMinumum15char$5,
	AddPhoneNumber: AddPhoneNumber$5,
	SelectGoal: SelectGoal$5,
	SelectStatus: SelectStatus$5,
	Followup: Followup$5,
	SocialMedia: SocialMedia$5,
	Linkedinhandle: Linkedinhandle$5,
	Twitterhandle: Twitterhandle$5,
	Facebookhandle: Facebookhandle$5,
	Githubhandle: Githubhandle$5,
	Gmailhandle: Gmailhandle$5,
	Changessavedsuccessfully: Changessavedsuccessfully$5,
	EditContact: EditContact$5,
	BasicInformation: BasicInformation$5,
	EditContactDetails: EditContactDetails$5,
	SaveChanges: SaveChanges$5,
	phoneNoMinimum14char: phoneNoMinimum14char$5,
	LinkedIn: LinkedIn$5,
	Twitter: Twitter$5,
	Facebook: Facebook$5,
	Github: Github$5,
	Gmail: Gmail$5,
	youCanWriteAbout: youCanWriteAbout$5,
	Addednewsection: Addednewsection$5,
	Removedsuccessfully: Removedsuccessfully$5,
	Remove: Remove$5,
	Institute: Institute$5,
	Schoolisrequired: Schoolisrequired$5,
	Degree: Degree$5,
	StartMonth: StartMonth$5,
	StartYear: StartYear$5,
	EndMonth: EndMonth$5,
	EndYear: EndYear$5,
	Addmore: Addmore$5,
	PositionTitle: PositionTitle$5,
	ExperienceType: ExperienceType$5,
	Addednewitem: Addednewitem$5,
	whatSkillsDoYouEnjoy: whatSkillsDoYouEnjoy$5,
	Typeskillshere: Typeskillshere$5,
	LinkedContacts: LinkedContacts$5,
	LinkContact: LinkContact$5,
	NocontactsLinked: NocontactsLinked$5,
	JobContactsComponent: JobContactsComponent$5,
	Nocontacts: Nocontacts$5,
	LinkJobto: LinkJobto$5,
	Contact: Contact$5,
	Document: Document$5,
	Nojobsfound: Nojobsfound$5,
	LinkJob: LinkJob$5,
	youCanLinkContactJobImported: youCanLinkContactJobImported$5,
	Prev: Prev$5,
	Next: Next$5,
	areYouSureUnlinkDocument: areYouSureUnlinkDocument$5,
	areYouSureDeleteDocument: areYouSureDeleteDocument$5,
	Category: Category$5,
	CreatedOn: CreatedOn$5,
	Joblinked: Joblinked$5,
	Quickactions: Quickactions$5,
	All: All$5,
	Resume: Resume$5,
	Portfolio: Portfolio$5,
	Other: Other$5,
	Adddocument: Adddocument$5,
	Type: Type$5,
	Sortingby: Sortingby$5,
	SwitchtoGridLayout: SwitchtoGridLayout$5,
	SwitchtoListLayout: SwitchtoListLayout$5,
	NoDocumentsAdded: NoDocumentsAdded$5,
	DocumentsComponent: DocumentsComponent$5,
	NoDocumentFound: NoDocumentFound$5,
	SelectFile: SelectFile$5,
	onlyPdfDocxSupported: onlyPdfDocxSupported$5,
	Uploadfile: Uploadfile$5,
	DocumentCategory: DocumentCategory$5,
	SaveDocument: SaveDocument$5,
	AddDocument: AddDocument$5,
	LinkedDocuments: LinkedDocuments$5,
	LinkDocument: LinkDocument$5,
	NodocumentsLinked: NodocumentsLinked$5,
	JobDocumentsComponent: JobDocumentsComponent$5,
	NoDocuments: NoDocuments$5,
	CreateDocuments: CreateDocuments$5,
	youCanLinkDocumentJobImported: youCanLinkDocumentJobImported$5,
	Documenteditedsuccessfully: Documenteditedsuccessfully$5,
	DocumentDetails: DocumentDetails$5,
	UnsavedChanges: UnsavedChanges$5,
	yourChangesWillBeLostSureClose: yourChangesWillBeLostSureClose$5,
	yourChangesWillBeLostSureDiscard: yourChangesWillBeLostSureDiscard$5,
	DiscardChanges: DiscardChanges$5,
	WeeklyGoalAlert: WeeklyGoalAlert$5,
	Progress: Progress$5,
	AllGoals: AllGoals$5,
	Name: Name$5,
	Completedon: Completedon$5,
	Createdon: Createdon$5,
	Action: Action$5,
	Back: Back$5,
	OverallScore: OverallScore$5,
	Aboutthegoal: Aboutthegoal$5,
	GoalTracking: GoalTracking$5,
	Week: Week$5,
	progress: progress$5,
	loading: loading$5,
	Apply: Apply$5,
	Thisskillhasbeenreported: Thisskillhasbeenreported$5,
	issueGettingResume: issueGettingResume$5,
	Interview: Interview$5,
	Tasks: Tasks$5,
	Loading: Loading$5,
	Skilladdedsuccessfully: Skilladdedsuccessfully$5,
	problemAddingSkill: problemAddingSkill$5,
	Reportaproblem: Reportaproblem$5,
	Submit: Submit$5,
	Addanewskill: Addanewskill$5,
	JobDetailsComponent: JobDetailsComponent$5,
	HardSkill: HardSkill$5,
	SoftSkill: SoftSkill$5,
	Pleaseshareanyadditionalcontext: Pleaseshareanyadditionalcontext$5,
	Addasskill: Addasskill$5,
	Skill: Skill$5,
	JobFrequency: JobFrequency$5,
	ResumeFrequency: ResumeFrequency$5,
	Reportskill: Reportskill$5,
	JobDetails: JobDetails$5,
	ViewJobLink: ViewJobLink$5,
	Salary: Salary$5,
	areYouSureDeleteJob: areYouSureDeleteJob$5,
	ViewMore: ViewMore$5,
	ViewLess: ViewLess$5,
	matchYouSkillsAgainstJob: matchYouSkillsAgainstJob$5,
	pleaseUploadResumeSkillMatch: pleaseUploadResumeSkillMatch$5,
	AddResume: AddResume$5,
	thisJobDoesNotHaveAnyDesc: thisJobDoesNotHaveAnyDesc$5,
	youCanEditJobToAdd: youCanEditJobToAdd$5,
	chromeextension: chromeextension$5,
	fromVariousJobPortalsOnce: fromVariousJobPortalsOnce$5,
	AddDescription: AddDescription$5,
	CompanyInfo: CompanyInfo$5,
	Website: Website$5,
	Industry: Industry$5,
	EmployeeCount: EmployeeCount$5,
	ExprienceLevel: ExprienceLevel$5,
	Address: Address$5,
	Resumes: Resumes$5,
	Setasdefault: Setasdefault$5,
	Ok: Ok$5,
	UploadNewResume: UploadNewResume$5,
	Default: Default$5,
	Jobnotfound: Jobnotfound$5,
	EditDetails: EditDetails$5,
	JobPostURL: JobPostURL$5,
	Enterjoburl: Enterjoburl$5,
	Nojobselected: Nojobselected$5,
	Viewjobdetails: Viewjobdetails$5,
	Jobaddedtoyourboardsuccessfully: Jobaddedtoyourboardsuccessfully$5,
	AddJob: AddJob$5,
	Addnewjobname: Addnewjobname$5,
	JobUrl: JobUrl$5,
	Addjoburl: Addjoburl$5,
	Section: Section$5,
	didYouKnow: didYouKnow$5,
	Jobs: Jobs$5,
	AddJobtoboard: AddJobtoboard$5,
	Currentlynojobsareavailable: Currentlynojobsareavailable$5,
	noMatchingJobs: noMatchingJobs$5,
	welcomeToYourPersonalJobTracker: welcomeToYourPersonalJobTracker$5,
	weShortTutorialOnHowTrackingJob: weShortTutorialOnHowTrackingJob$5,
	Addanewjob: Addanewjob$5,
	inOrderTrackCreatButton: inOrderTrackCreatButton$5,
	Providesomedetails: Providesomedetails$5,
	toBeginTypeJobTitleCompany: toBeginTypeJobTitleCompany$5,
	asAnExampleFilledForYou: asAnExampleFilledForYou$5,
	wohooAddedFirstJob: wohooAddedFirstJob$5,
	youCanDragDropJobCard: youCanDragDropJobCard$5,
	Lastbutnotleast: Lastbutnotleast$5,
	finalStepMakeSure: finalStepMakeSure$5,
	autoMaticallyImportJobs: autoMaticallyImportJobs$5,
	selectanysection: selectanysection$5,
	Accept: Accept$5,
	My2023JobSearch: My2023JobSearch$5,
	AddedFrom: AddedFrom$5,
	AddedUntil: AddedUntil$5,
	BasicModal: BasicModal$5,
	AddnewSectionName: AddnewSectionName$5,
	OpenTo: OpenTo$5,
	Featured: Featured$5,
	LicenceAndCerts: LicenceAndCerts$5,
	Banner: Banner$5,
	LinkedInURL: LinkedInURL$5,
	Recommendations: Recommendations$5,
	LinkedinReview: LinkedinReview$5,
	NoDataAvailable: NoDataAvailable$5,
	looksLikeYouDidNot: looksLikeYouDidNot$5,
	toOptimizeProfileScoreVisible: toOptimizeProfileScoreVisible$5,
	LinkedinComponent: LinkedinComponent$5,
	improveYourChancesLandingDreamJob: improveYourChancesLandingDreamJob$5,
	VisitProfile: VisitProfile$5,
	wantToGetLinkedinMakeover: wantToGetLinkedinMakeover$5,
	PostGenerator: PostGenerator$5,
	LinkedinHeadlineGenerator: LinkedinHeadlineGenerator$5,
	LinkedinAboutSectionGenerator: LinkedinAboutSectionGenerator$5,
	AITools: AITools$5,
	Premium: Premium$5,
	LinkedInOptimization: LinkedInOptimization$5,
	JobTracker: JobTracker$5,
	whoIsHiring: whoIsHiring$5,
	Autofill: Autofill$5,
	HeadlineGenerator: HeadlineGenerator$5,
	skillMatching: skillMatching$5,
	SummarizeJD: SummarizeJD$5,
	contactFeature: contactFeature$5,
	documentFeature: documentFeature$5,
	landJobWithoutStress: landJobWithoutStress$5,
	discoverFeatures: discoverFeatures$5,
	letsBeginOnboarding: letsBeginOnboarding$5,
	inTheNextFewScreensJobThirdParties: inTheNextFewScreensJobThirdParties$5,
	letsAddBasicInformation: letsAddBasicInformation$5,
	Pleaseselectanoptionfirst: Pleaseselectanoptionfirst$5,
	JobApplicationTracker: JobApplicationTracker$5,
	LinkedInProfileOptimizer: LinkedInProfileOptimizer$5,
	UnlimitedDocuments: UnlimitedDocuments$5,
	UnlimitedContacts: UnlimitedContacts$5,
	HiringManagerSearch: HiringManagerSearch$5,
	AILinkedInPostGenerator: AILinkedInPostGenerator$5,
	ATSKeywordSkillMatch: ATSKeywordSkillMatch$5,
	"Auto-Apply": "Auto-Aplicare",
	ChooseyourPlan: ChooseyourPlan$5,
	superChargeYourJobSearch: superChargeYourJobSearch$5,
	startNowGoto: startNowGoto$5,
	CreatedBy: CreatedBy$5,
	CreateNewNote: CreateNewNote$5,
	Nonotescreated: Nonotescreated$5,
	approxTimeIsFourMinutes: approxTimeIsFourMinutes$5,
	Continue: Continue$5,
	iWillDoLaterTakeMeToApp: iWillDoLaterTakeMeToApp$5,
	allDone: allDone$5,
	welcomeAbord: welcomeAbord$5,
	letsBegin: letsBegin$5,
	UpgradeyourplanandgetAIAssistance: UpgradeyourplanandgetAIAssistance$5,
	DownloadPDF: DownloadPDF$5,
	oopsWeCouldntProcessResume: oopsWeCouldntProcessResume$5,
	MyProfile: MyProfile$5,
	Setting: Setting$5,
	Logout: Logout$5,
	SignIn: SignIn$5,
	Typeyourfirstnamehere: Typeyourfirstnamehere$5,
	Enteryourlastname: Enteryourlastname$5,
	ManageSubscription: ManageSubscription$5,
	ifYouHaveDifficultiesProfile: ifYouHaveDifficultiesProfile$5,
	forSupport: forSupport$5,
	whatIsIdealCompanySize: whatIsIdealCompanySize$5,
	Saveandcontinue: Saveandcontinue$5,
	whatIsMinExpectedSalary: whatIsMinExpectedSalary$5,
	Atleast: Atleast$5,
	SlidetoAdjust: SlidetoAdjust$5,
	whatIndustryExcitedWork: whatIndustryExcitedWork$5,
	Add: Add$5,
	statusOfJobSearch: statusOfJobSearch$5,
	Finish: Finish$5,
	whatLevelRoleLooking: whatLevelRoleLooking$5,
	Selectuptotwo: Selectuptotwo$5,
	PreviousStep: PreviousStep$5,
	Skip: Skip$5,
	whatDoYouValueNewRole: whatDoYouValueNewRole$5,
	Selectuptothree: Selectuptothree$5,
	EqualEmploymentData: EqualEmploymentData$5,
	whatIsYourEthnicity: whatIsYourEthnicity$5,
	areYouAuthorizedToWorkUs: areYouAuthorizedToWorkUs$5,
	willYouRequireSponsorShip: willYouRequireSponsorShip$5,
	doYouHaveADisability: doYouHaveADisability$5,
	areYouAVeteran: areYouAVeteran$5,
	rolesYouInterestedIn: rolesYouInterestedIn$5,
	Selectuptofive: Selectuptofive$5,
	AddCustomrole: AddCustomrole$5,
	whereDoYouLikeWork: whereDoYouLikeWork$5,
	Resources: Resources$5,
	currentlyNoResourceAvailable: currentlyNoResourceAvailable$5,
	AddNewSection: AddNewSection$5,
	ChangeSections: ChangeSections$5,
	Settings: Settings$5,
	Dashboard: Dashboard$5,
	JobBoard: JobBoard$5,
	Linkedin: Linkedin$5,
	Community: Community$5,
	FindRecruiters: FindRecruiters$5,
	Goals: Goals$5,
	DownloadExtension: DownloadExtension$5,
	SuggestaFeature: SuggestaFeature$5,
	leftPanel: leftPanel$5,
	PhoneNumberisrequired: PhoneNumberisrequired$5,
	MobileNumber: MobileNumber$5,
	Enteronlynumbers: Enteronlynumbers$5,
	Countryyoulivein: Countryyoulivein$5,
	SelectaCountry: SelectaCountry$5,
	DateofBirth: DateofBirth$5,
	Gender: Gender$5,
	JobPreferences: JobPreferences$5,
	pleaseEnterValidEmail: pleaseEnterValidEmail$5,
	emailSendForResetting: emailSendForResetting$5,
	VerifyyourEmailID: VerifyyourEmailID$5,
	sentPleaseCheckEmail: sentPleaseCheckEmail$5,
	tooManyAttemptsTryAgain: tooManyAttemptsTryAgain$5,
	Resend: Resend$5,
	Login: Login$5,
	weHaveSentVerificationLinkAtEmail: weHaveSentVerificationLinkAtEmail$5,
	pleaseVerifyEmailContinueSpam: pleaseVerifyEmailContinueSpam$5,
	Logintogetstarted: Logintogetstarted$5,
	ContinuewithGoogle: ContinuewithGoogle$5,
	pleaseInputEmail: pleaseInputEmail$5,
	Password: Password$5,
	pleaseInputPassword: pleaseInputPassword$5,
	passwordLowerUpperDigitSpecial: passwordLowerUpperDigitSpecial$5,
	atLeastSixChar: atLeastSixChar$5,
	forgotPassword: forgotPassword$5,
	Bysigninginyouagreetoour: Bysigninginyouagreetoour$5,
	Terms: Terms$5,
	Conditions: Conditions$5,
	and: and$5,
	PrivacyPolicy: PrivacyPolicy$5,
	theseAreTheTopsSkillsExtracted: theseAreTheTopsSkillsExtracted$5,
	TopSkills: TopSkills$5,
	weCoulNotExtractSkills: weCoulNotExtractSkills$5,
	upgradeToPremiumToView: upgradeToPremiumToView$5,
	SkillScore: SkillScore$5,
	thisIsYourSkillScoreBasedOn: thisIsYourSkillScoreBasedOn$5,
	theseSkllsAreStrongMatch: theseSkllsAreStrongMatch$5,
	Strongmatch: Strongmatch$5,
	theseSkillsArePartialMatch: theseSkillsArePartialMatch$5,
	Partialmatch: Partialmatch$5,
	theseSkillsAreMissingFrom: theseSkillsAreMissingFrom$5,
	"Missing Keywords": "Cuvinte cheie lipsă",
	SkillMatchComponent: SkillMatchComponent$5,
	Optional: Optional$5,
	Notrelevanttothejob: Notrelevanttothejob$5,
	Notaskill: Notaskill$5,
	Toogeneric: Toogeneric$5,
	Pleaseshareanyfeedback: Pleaseshareanyfeedback$5,
	excludedKeywordsWillNot: excludedKeywordsWillNot$5,
	yesExcludeThisSkillFrom: yesExcludeThisSkillFrom$5,
	PartialMatch: PartialMatch$5,
	MissingKeywords: MissingKeywords$5,
	Providetitletotask: Providetitletotask$5,
	TasksList: TasksList$5,
	AddTask: AddTask$5,
	EnterTaskTitlehere: EnterTaskTitlehere$5,
	TasksComponent: TasksComponent$5,
	CompletedTasks: CompletedTasks$5,
	CompleteYourtasks: CompleteYourtasks$5,
	Steps: Steps$5,
	PremiumMember: PremiumMember$5,
	Thankyouforupgradingto: Thankyouforupgradingto$5,
	CareerflowPremium: CareerflowPremium$5,
	hereIsHowYouCanAccessPremium: hereIsHowYouCanAccessPremium$5,
	stepOne: stepOne$5,
	DownloadourChromeExtension: DownloadourChromeExtension$5,
	youJobSearchCopilotIshere: youJobSearchCopilotIshere$5,
	DownloadNow: DownloadNow$5,
	stepTwo: stepTwo$5,
	GetStarted: GetStarted$5,
	stepThree: stepThree$5,
	SignintoChromeExtension: SignintoChromeExtension$5,
	entityCreated: entityCreated$5,
	entityUpdated: entityUpdated$5,
	entityDeleted: entityDeleted$5,
	entityLinked: entityLinked$5,
	entityUnlinked: entityUnlinked$5,
	entityMovedTo: entityMovedTo$5,
	youAddedANewEntity: youAddedANewEntity$5,
	personCreated: personCreated$5,
	youUpdatedAEntity: youUpdatedAEntity$5,
	personUpdated: personUpdated$5,
	youDeletedAEntity: youDeletedAEntity$5,
	personDeleted: personDeleted$5,
	youLinkedEntity: youLinkedEntity$5,
	personLinked: personLinked$5,
	youUnlinked: youUnlinked$5,
	personUnlinked: personUnlinked$5,
	youMovedEntity: youMovedEntity$5,
	personMoved: personMoved$5,
	addedByName: addedByName$5,
	DownloadChromeExtension: DownloadChromeExtension$5,
	ourChromeExtensionIs: ourChromeExtensionIs$5,
	Optimizeyourprofile: Optimizeyourprofile$5,
	startOptimizingYourProfile: startOptimizingYourProfile$5,
	OptimizeNow: OptimizeNow$5,
	Addyourfirstjob: Addyourfirstjob$5,
	startSavingJobApplicationsToTrack: startSavingJobApplicationsToTrack$5,
	AddNow: AddNow$5,
	CompleteProfile: CompleteProfile$5,
	completeYourProfileForUsing: completeYourProfileForUsing$5,
	CompleteNow: CompleteNow$5,
	Addyourfirstcontact: Addyourfirstcontact$5,
	addContactToFollowUpWith: addContactToFollowUpWith$5,
	JoinCommunity: JoinCommunity$5,
	ourCommunityisAlways: ourCommunityisAlways$5,
	JoinNow: JoinNow$5,
	welcomeToCareerflow: welcomeToCareerflow$5,
	yourHubForCareerInsights2: yourHubForCareerInsights2$5,
	ChecklistCompleted: ChecklistCompleted$5,
	Completeyourchecklist: Completeyourchecklist$5,
	completeAFewStepsTo: completeAFewStepsTo$5,
	Completed: Completed$5,
	JobCountByStage: JobCountByStage$5,
	NopastapplicationDatafound: NopastapplicationDatafound$5,
	YourJobSearchStages: YourJobSearchStages$5,
	NoDatafound: NoDatafound$5
};

const copyToClipboard$4 = "Skopírované do schránky!";
const UnlocktheAIgenerated$4 = "Odomknite vygenerované AI.";
const UpgradetoPremium$4 = "Vylepšiť na Premium";
const Result$4 = "Výsledek";
const Copy$4 = "Kopírovať";
const Save$4 = "Uložiť";
const Edit$4 = "Upraviť";
const Processing$4 = "Spracovanie";
const YourAIgeneratedcontentwillshowhere$4 = "Váš obsah generovaný umelou inteligenciou sa zobrazí tu";
const hopeYouFindUseful$4 = "Dúfam, že tento výsledok bude pre vás užitočný!";
const regenerate$4 = "Znovu vygenerovať";
const ProvideAdditionalFeedback$4 = "Poskytnite ďalšiu spätnú väzbu";
const Enteranyfeedback$4 = "Zadajte akúkoľvek spätnú väzbu";
const Notimpressive$4 = "Nie je pôsobivé";
const thisIsntTrue$4 = "To nie je pravda";
const Notpersonalized$4 = "Nie je personalizované";
const Tone$4 = "Tón";
const Length$4 = "Dĺžka";
const Template$4 = "Šablóna";
const Generatedon$4 = "Vygenerované dňa";
const Copiedtoclipboard$4 = "Skopírované do schránky";
const CopytoClipboard$4 = "Kopírovať do schránky";
const DownloadasPDF$4 = "Stiahnuť ako PDF";
const ViewDetails$4 = "Zobraziť podrobnosti";
const JobDescriptionImported$4 = "Popis práce importovaný";
const ImportfromJob$4 = "Import z pracovnej ponuky";
const Saved$4 = "Uložené";
const Applied$4 = "Odoslané";
const Offer$4 = "Ponuka";
const Interviewing$4 = "Rozhovorovanie";
const Rejected$4 = "Zamietnuté";
const Search$4 = "Vyhľadávanie";
const Import$4 = "Import";
const CoverLetterGeneratorHistory$4 = "História generátora motivačných listov";
const NoCoverLettersGenerated$4 = "Žiadne vygenerované motivačné listy";
const getStartedCoverLetter$4 = "Zatiaľ ste nevygenerovali žiadne motivačné listy. Začnite a vytvorte si motivačné listy zhodovaním pracovného popisu s vašimi relevantnými skúsenosťami.";
const getStarted$4 = "Začnite!";
const Documents$4 = "Dokumenty";
const UploadNewDocument$4 = "Nahrať nový dokument";
const AICoverLetterGenerator$4 = "AI Generátor motivačných listov";
const ViewHistory$4 = "Zobraziť históriu";
const JobDescription$4 = "Popis práce";
const ImportfromBoard$4 = "Importovať z nástenky";
const EnterJobDescription$4 = "Zadajte popis práce";
const JobTitle$4 = "Názov pracovnej pozície";
const EnterJobTitle$4 = "Zadajte názov pracovnej pozície";
const CompanyName$4 = "Názov spoločnosti";
const EnterCompanyName$4 = "Zadajte názov spoločnosti";
const YourProfile$4 = "Váš profil";
const ResumeUpload$4 = "Nahrať životopis";
const UseLinkedinProfile$4 = "Použiť LinkedIn profil";
const Uploadyourresume$4 = "Nahrajte svoj životopis";
const AddyourResume$4 = "Pridajte svoj životopis";
const fileNameCannotFormat$4 = "Názvy súborov nemôžu obsahovať medzery ani podčiarkovníky a musia byť vo formáte .doc, .docx alebo .pdf.";
const ChooseorUpload$4 = "Vybrať alebo nahrať";
const SelectTemplate$4 = "Vybrať šablónu";
const Preview$4 = "Náhľad";
const UseTemplate$4 = "Použiť šablónu";
const Change$4 = "Zmeniť";
const AdvancedSettings$4 = "Pokročilé nastavenia";
const AdditionalContext$4 = "Ďalší kontext";
const Professional$4 = "Profesionálny";
const Casual$4 = "Neformálny";
const Enthusiastic$4 = "Enthusiastický";
const Informational$4 = "Informatívny";
const Short$4 = "Krátke";
const Medium$4 = "Stredné";
const Long$4 = "Dlhé";
const Language$4 = "Jazyk";
const iAmOkayBack$4 = "Súhlasím! Vrátiť sa späť";
const Generate$4 = "Generovať";
const CoverLetter$4 = "Žiadosť";
const SelectLanguage$4 = "Vyberte jazyk";
const AboutGeneratorHistory$4 = "História generátora o sebe";
const NoAboutsGenerated$4 = "Žiadne vygenerované informácie o sebe";
const getStartedAbouts$4 = "Zatiaľ ste nevygenerovali žiadne informácie o sebe. Začnite a vytvorte si informácie o sebe zhodovaním pracovného popisu s vašimi relevantnými skúsenosťami.";
const noAttachmentsFound$4 = "Nenašli sa žiadne prílohy.";
const TargetJobTitle$4 = "Cieľový názov pracovnej pozície";
const KeywordsToInclude$4 = "Kľúčové slová na zahrnutie";
const UploadYourResume$4 = "Nahrajte svoj životopis";
const AddYourResume$4 = "Pridajte svoj životopis";
const LinkedinProfile$4 = "LinkedIn profil";
const Linkedinprofilenotfound$4 = "LinkedIn profil nenájdený";
const startUsingChromeExtension$4 = "Začnite optimalizovať svoj LinkedIn profil pomocou našeho rozšírenia pre Chrome a využite túto možnosť.";
const Download$4 = "Stiahnuť";
const UseEmojis$4 = "Použiť emotikony";
const UseBulletPoints$4 = "Použiť odrážky";
const SpeechFocus$4 = "Zameranie reči";
const FirstPerson$4 = "Prvá osoba";
const ThirdPerson$4 = "Tretia osoba";
const HeadlineGeneratorHistory$4 = "História generátora nadpisov";
const NoHeadlinesGenerated$4 = "Žiadne vygenerované nadpisy";
const getStartedHeadline$4 = "Zatiaľ ste nevygenerovali žiadne nadpisy. Začnite a vytvorte si nadpisy zhodovaním pracovného popisu s vašimi relevantnými skúsenosťami.";
const AIHeadlineGenerator$4 = "AI Generátor nadpisov";
const KeywordstoInclude$4 = "Kľúčové slová na zahrnutie";
const Pressenteraftereachword$4 = "Stlačte enter po každom slove";
const LinkedinProfilenotfound$4 = "Profil na LinkedIn sa nenašiel";
const Headline$4 = "Titulok";
const PostGeneratorHistory$4 = "História generátora príspevkov";
const NoPostsGenerated$4 = "Žiadne vygenerované príspevky";
const getStartedPost$4 = "Zatiaľ ste nevygenerovali žiadne príspevky. Začnite a vytvorte si príspevky zhodovaním pracovného popisu s vašimi relevantnými skúsenosťami.";
const Topic$4 = "Téma";
const Description$4 = "Popis";
const UseHashtags$4 = "Použiť hashtagy";
const Custom$4 = "Vlastné";
const EnterCustomTone$4 = "Zadajte vlastný tón";
const Added$4 = "Pridané";
const ComingSoon$4 = {
	header: "Inžinieri pracujú!",
	content_1: "Náš tím inžinierov intenzívne pracuje na tom, aby čo najskôr spustil túto funkciu",
	content_2: "Chcete túto funkciu čo najskôr? Dajte nám vedieť jednoduchým označením políčka nižšie.",
	content_3: "Chcem túto funkciu"
};
const Company$4 = "Spoločnosť";
const JobInterview$4 = "Pohovor o zamestnaní";
const Research$4 = "Výskum";
const Networking$4 = "Pripájanie";
const Referral$4 = "Odporúčanie";
const MustbeContacted$4 = "Musí byť kontaktovaný";
const ScheduleaMeeting$4 = "Plánovať stretnutie";
const needAFollowUp$4 = "Potreba nasledovať";
const Today$4 = "Dnes";
const Viewdetails$4 = "Zobraziť detaily";
const Activity$4 = "Aktivita";
const ActivityDetails$4 = "Detaily aktivity";
const Delete$4 = "Vymazať";
const Title$4 = "Názov";
const Goal$4 = "Cieľ";
const Status$4 = "Stav";
const FollowUp$4 = "Follow Up";
const AddActivity$4 = "Pridať aktivitu";
const Enteractivitytitle$4 = "Zadajte názov aktivity";
const Cancel$4 = "Zrušiť";
const SaveActivity$4 = "Uložiť aktivitu";
const noActivityPresent$4 = "Žiadna aktivita nie je prítomná, pridajte aktivitu.";
const Addnew$4 = "Pridať nové";
const About$4 = "O";
const noDataPresentYou$4 = "Žiadne údaje nie sú prítomné, môžete upraviť tento kontakt a pridať polia.";
const Experience$4 = "Skúsenosti";
const Education$4 = "Vzdelanie";
const Skills$4 = "Zručnosti";
const Overview$4 = "Prehľad";
const LinkedJobs$4 = "Prepojené práce";
const Notes$4 = "Poznámky";
const FullName$4 = "Celé meno";
const Location$4 = "Lokalita";
const Relationship$4 = "Vzťah";
const Contacts$4 = "Kontakty";
const CreateContact$4 = "Vytvoriť kontakt";
const NotesCreated$4 = "Poznámky vytvorené";
const Notesupdated$4 = "Poznámky aktualizované";
const Addnote$4 = "Pridať poznámku";
const areYouSureDeleteNote$4 = "Ste si istý, že chcete vymazať túto poznámku?";
const Createdby$4 = "Vytvorené";
const notSureWhyResumeCalls$4 = "Nie ste si istí, prečo vás váš životopis nezískava pozvánky na pohovory? ☎️";
const getExpertResumeReview$4 = "Získajte odborné posúdenie životopisu 💎✨";
const youHaventAddedContacts$4 = "Ešte ste nepridali žiadne kontakty.";
const noMatchingContacts$4 = "Nenašli sa žiadne zhodné kontakty.";
const Link$4 = "Odkaz";
const unlink$4 = "Odznačiť";
const Locationnotavailable$4 = "Poloha nie je k dispozícii";
const Emailnotavailable$4 = "E-mail nie je k dispozícii";
const PhoneNumbernotavailable$4 = "Telefónne číslo nie je k dispozícii";
const createdby$4 = "vytvorené od";
const areYouSureDeleteContact$4 = "Ste si istí, že chcete odstrániť tento kontakt?";
const areYouSureUnlinkContact$4 = "Ste si istí, že chcete odpojiť tento kontakt?";
const Addedbyyou$4 = "Pridané vami";
const Addedby$4 = "Pridal(a)";
const Timeline$4 = "Časová os";
const Timelineempty$4 = "Časová os prázdna";
const Discard$4 = "Zahodiť";
const SaveContact$4 = "Uložiť kontakt";
const Recruiter$4 = "Rekrutér";
const Candidate$4 = "Kandidát";
const Colleague$4 = "Kolega";
const Employee$4 = "Zamestnanec";
const EnterValidEmail$4 = "Zadajte platný e-mail";
const EnterValidPhoneNumber$4 = "Zadajte platné telefónne číslo";
const editingProfileNotAvailable$4 = "Úprava profilového obrázku zatiaľ nie je k dispozícii.";
const itWillBeSoonAvailable$4 = "Čoskoro bude k dispozícii našej.";
const ChromeExtension$4 = "Rozšírenie pre Chrome";
const SelectTag$4 = "Vybrať značku";
const FirstName$4 = "Krstné meno";
const FirstNameisrequired$4 = "Krstné meno je povinné";
const LastName$4 = "Priezvisko";
const LastNameisrequired$4 = "Priezvisko je povinné";
const Companyisrequired$4 = "Firma je povinná.";
const Email$4 = "E-mail";
const ThisisnotavalidEmail$4 = "Toto nie je platný e-mail.";
const AddEmail$4 = "Pridať e-mail";
const PhoneNumber$4 = "Telefónne číslo";
const notaValidPhone$4 = "Toto nie je platné telefónne číslo. Zadajte iba číslice.";
const phoneNoMinimum5char$4 = "Telefónne číslo musí byť minimálne 5 znakov.";
const phoneNoMinumum15char$4 = "Telefónne číslo musí byť maximálne 15 znakov.";
const AddPhoneNumber$4 = "Pridať telefónne číslo";
const SelectGoal$4 = "Vyberte cieľ";
const SelectStatus$4 = "Vyberte stav";
const Followup$4 = "Follow-up";
const SocialMedia$4 = "Sociálne médiá";
const Linkedinhandle$4 = "Linkedin účet";
const Twitterhandle$4 = "Twitter handle";
const Facebookhandle$4 = "Facebook handle";
const Githubhandle$4 = "Github handle";
const Gmailhandle$4 = "Gmail handle";
const Changessavedsuccessfully$4 = "Zmeny úspešne uložené";
const EditContact$4 = "Upraviť kontakt";
const BasicInformation$4 = "Základné informácie";
const EditContactDetails$4 = "Upraviť kontaktné údaje";
const SaveChanges$4 = "Uložiť zmeny";
const phoneNoMinimum14char$4 = "Telefónne číslo musí byť minimálne 14 znakov.";
const LinkedIn$4 = "LinkedIn";
const Twitter$4 = "Twitter";
const Facebook$4 = "Facebook";
const Github$4 = "Github";
const Gmail$4 = "Gmail";
const youCanWriteAbout$4 = "Môžete písať o svojich rokoch skúseností, odvetví alebo zručnostiach. Ľudia tiež hovoria o svojich úspechoch alebo predchádzajúcich pracovných skúsenostiach.";
const Addednewsection$4 = "Pridaná nová sekcia";
const Removedsuccessfully$4 = "Úspešne odstránené.";
const Remove$4 = "Odstrániť";
const Institute$4 = "Inštitút";
const Schoolisrequired$4 = "Škola je povinná.";
const Degree$4 = "Stupeň";
const StartMonth$4 = "Začiatočný mesiac";
const StartYear$4 = "Začiatok roka";
const EndMonth$4 = "Koniec mesiaca";
const EndYear$4 = "Koniec roka";
const Addmore$4 = "Pridať ďalšie";
const PositionTitle$4 = "Názov pozície";
const ExperienceType$4 = "Typ zážitku";
const Addednewitem$4 = "Pridaná nová položka";
const whatSkillsDoYouEnjoy$4 = "Aké zručnosti máte alebo radi s nimi pracujete?";
const Typeskillshere$4 = "Zadajte zručnosti tu";
const LinkedContacts$4 = "Prepojené kontakty";
const LinkContact$4 = "Prepojiť kontakt";
const NocontactsLinked$4 = "Žiadne prepojené kontakty";
const JobContactsComponent$4 = {
	linkContact: "Prepojením kontaktov môžete rýchlo vidieť, kto sú dôležití ľudia, ako napríklad rekrutér, manažér náboru, atď., pre túto úlohu! V budúcnosti budeme schopní poskytnúť relevantné informácie na základe vašich kontaktov."
};
const Nocontacts$4 = "Žiadne kontakty";
const LinkJobto$4 = "Prepojiť prácu s";
const Contact$4 = "Kontakt";
const Document$4 = "Dokument";
const Nojobsfound$4 = "Nenašli sa žiadne práce";
const LinkJob$4 = "Prepojiť úlohu";
const youCanLinkContactJobImported$4 = "Môžete prepojiť tento kontakt s pracovnou pozíciou, ktorú ste importovali do Careerflow.";
const Prev$4 = "N/A (There is no text to translate as \"Prev\" is not a complete sentence or word in English.)";
const Next$4 = "Ďalší";
const areYouSureUnlinkDocument$4 = "Ste si istí, že chcete odpojiť tento dokument?";
const areYouSureDeleteDocument$4 = "Ste si istí, že chcete odstrániť tento dokument?";
const Category$4 = "Kategória";
const CreatedOn$4 = "Vytvorené dňa";
const Joblinked$4 = "Pracovne spojeny";
const Quickactions$4 = "Rýchle akcie";
const All$4 = "Všetko";
const Resume$4 = "Životopis";
const Portfolio$4 = "Portfólio";
const Other$4 = "Iný";
const Adddocument$4 = "Pridať dokument";
const Type$4 = "Typ";
const Sortingby$4 = "Zoradenie podľa";
const SwitchtoGridLayout$4 = "Prepnúť na mriežkové rozloženie";
const SwitchtoListLayout$4 = "Prepnúť na zoznamový rozloženie";
const NoDocumentsAdded$4 = "Žiadne pridané dokumenty";
const DocumentsComponent$4 = {
	nodocs: "Zatiaľ ste nevytvorili žiadne dokumenty. Môžete nahrať verzie vášho životopisu, motivačné listy a ďalšie a prepojiť ich s prácou, ktorú sledujete!"
};
const NoDocumentFound$4 = "Nenašiel sa žiadny dokument";
const SelectFile$4 = "Vyberte súbor";
const onlyPdfDocxSupported$4 = "Podporované sú len formáty .pdf a .docx.";
const Uploadfile$4 = "Nahrať súbor";
const DocumentCategory$4 = "Kategória dokumentu";
const SaveDocument$4 = "Uložiť dokument";
const AddDocument$4 = "Pridať dokument";
const LinkedDocuments$4 = "Prepojené dokumenty";
const LinkDocument$4 = "Prepojiť dokument";
const NodocumentsLinked$4 = "Žiadne prepojené dokumenty";
const JobDocumentsComponent$4 = {
	linkDocs: "Prepojením všetkých relevantných dokumentov, ako je váš životopis, žiadosť atď., ktoré ste odoslali pre túto prácu, vám pomôže udržiavať prehľad v jednom mieste. Vyskúšajte to!"
};
const NoDocuments$4 = "Žiadne dokumenty";
const CreateDocuments$4 = "Vytvoriť dokumenty";
const youCanLinkDocumentJobImported$4 = "Môžete prepojiť tento dokument s pracovnou ponukou, ktorú ste importovali do Careerflow.";
const Documenteditedsuccessfully$4 = "Dokument úspešne upravený";
const DocumentDetails$4 = "Podrobnosti dokumentu";
const UnsavedChanges$4 = "Neuložené zmeny";
const yourChangesWillBeLostSureClose$4 = "Vaše zmeny budú stratené, ste si istý, že chcete zatvoriť?";
const yourChangesWillBeLostSureDiscard$4 = "Vaše zmeny budú stratené, ste si istý, že chcete zahodiť svoje zmeny?";
const DiscardChanges$4 = "Zahodiť zmeny";
const WeeklyGoalAlert$4 = "Týždenné upozornenie na ciele";
const Progress$4 = "Pokrok";
const AllGoals$4 = "Všetky ciele";
const Name$4 = "Meno";
const Completedon$4 = "Dokončené dňa";
const Createdon$4 = "Vytvorené dňa";
const Action$4 = "Akcia";
const Back$4 = "Späť";
const OverallScore$4 = "Celkové hodnotenie";
const Aboutthegoal$4 = "O cieľe";
const GoalTracking$4 = "Sledovanie cieľa";
const Week$4 = "Týždeň";
const progress$4 = "pokrok";
const loading$4 = "Načítava sa";
const Apply$4 = "Uplatniť";
const Thisskillhasbeenreported$4 = "Táto zručnosť bola nahlásená.";
const issueGettingResume$4 = "Bola tu problém s získaním životopisu.";
const Interview$4 = "Rozhovor";
const Tasks$4 = "Úlohy";
const Loading$4 = "Načítava sa";
const Skilladdedsuccessfully$4 = "Zručnosť úspešne pridaná";
const problemAddingSkill$4 = "Vyskytol sa problém pri pridávaní zručnosti.";
const Reportaproblem$4 = "Nahlásiť problém";
const Submit$4 = "Odoslať";
const Addanewskill$4 = "Pridať novú zručnosť";
const JobDetailsComponent$4 = {
	classifySkill: "Ako by ste klasifikovali túto zručnosť (voliteľné)",
	includedKeywordsWillCount: "Zahrnúť toto kľúčové slovo?",
	yesIncludeThisSkill: "Zahrnuté kľúčové slová sa budú počítať proti vašemu zhodnoteniu pre všetky budúce skenovania. Môžete zmeniť zahrnuté kľúčové slová vo svojom profile.",
	addSkill: "Chcete to pridať ako zručnosť?"
};
const HardSkill$4 = "Tvrdá zručnosť";
const SoftSkill$4 = "Mäkká zručnosť";
const Pleaseshareanyadditionalcontext$4 = "Prosím, zdieľajte akýkoľvek ďalší kontext";
const Addasskill$4 = "Pridať ako zručnosť";
const Skill$4 = "Zručnosť";
const JobFrequency$4 = "Frekvencia práce";
const ResumeFrequency$4 = "Frekvencia životopisu";
const Reportskill$4 = "Nahlásiť zručnosť";
const JobDetails$4 = "Podrobnosti o práci";
const ViewJobLink$4 = "Zobraziť odkaz na prácu";
const Salary$4 = "Plat";
const areYouSureDeleteJob$4 = "Ste si istý, že chcete vymazať túto prácu?";
const ViewMore$4 = "Zobraziť viac";
const ViewLess$4 = "Zobraziť menej";
const matchYouSkillsAgainstJob$4 = "Porovnajte svoje zručnosti s popisom práce.";
const pleaseUploadResumeSkillMatch$4 = "Prosím, nahrajte svoj životopis pre získanie skóre zhody vašich zručností.";
const AddResume$4 = "Pridať životopis";
const thisJobDoesNotHaveAnyDesc$4 = "Táto práca nemá žiadny popis.";
const youCanEditJobToAdd$4 = "Môžete upraviť túto prácu a pridať k nej popis. Môžete tiež importovať práce pomocou našej.";
const chromeextension$4 = "rozšírenie prehliadača Chrome";
const fromVariousJobPortalsOnce$4 = "z rôznych pracovných portálov. Keď pridáte popis, budete tiež môcť vidieť informácie súvisiace s zručnosťami.";
const AddDescription$4 = "Pridať popis";
const CompanyInfo$4 = "Informácie o spoločnosti";
const Website$4 = "Webová stránka";
const Industry$4 = "Priemysel";
const EmployeeCount$4 = "Počet zamestnancov";
const ExprienceLevel$4 = "Úroveň skúseností";
const Address$4 = "Adresa";
const Resumes$4 = "Životopisy";
const Setasdefault$4 = "Nastaviť ako predvolené";
const Ok$4 = "Ok";
const UploadNewResume$4 = "Nahrať nový životopis";
const Default$4 = "Predvolené";
const Jobnotfound$4 = "Práca nenájdená";
const EditDetails$4 = "Upraviť údaje";
const JobPostURL$4 = "URL pracovnej ponuky";
const Enterjoburl$4 = "Zadajte URL práce";
const Nojobselected$4 = "Nie je vybraná žiadna práca";
const Viewjobdetails$4 = "Zobraziť podrobnosti o pracovnej ponuke";
const Jobaddedtoyourboardsuccessfully$4 = "Práca bola úspešne pridaná na vašu nástenku.";
const AddJob$4 = "Pridať pracovnú ponuku";
const Addnewjobname$4 = "Pridať nový názov práce";
const JobUrl$4 = "URL pracovnej ponuky";
const Addjoburl$4 = "Pridať URL práce";
const Section$4 = "Sekcia";
const didYouKnow$4 = {
	chromeExtension: "Viete, že? Môžete tiež ukladať práce priamo zo nášho rozšírenia pre Chrome a všetky údaje importovať jedným kliknutím! Trvá to len pár sekúnd."
};
const Jobs$4 = "Práce";
const AddJobtoboard$4 = "Pridať prácu na nástenku";
const Currentlynojobsareavailable$4 = "Momentálne nie sú k dispozícii žiadne pracovné miesta.";
const noMatchingJobs$4 = "Nenašli sa žiadne zhodné pracovné miesta.";
const welcomeToYourPersonalJobTracker$4 = "Vitajte vo vašom osobnom sledovači práce!";
const weShortTutorialOnHowTrackingJob$4 = "Vezmeme vás cez krátky tutoriál, ako začať sledovať vaše žiadosti o prácu v niekoľkých jednoduchých krokoch!";
const Addanewjob$4 = "Pridať novú prácu";
const inOrderTrackCreatButton$4 = "Aby ste mohli začať sledovať žiadosti o zamestnanie, musíte ju najskôr pridať na nástenku kliknutím na tlačidlo „Vytvoriť“.";
const Providesomedetails$4 = "Poskytnite niekoľko detailov.";
const toBeginTypeJobTitleCompany$4 = "Na začiatok jednoducho napíšte názov pracovnej pozície, názov spoločnosti a stav, do ktorého ju chcete pridať. Neskôr môžete pridať viac detailov, ale toto je všetko, čo teraz potrebujete!";
const asAnExampleFilledForYou$4 = "Ako príklad sme to už pre vás vyplnili!";
const wohooAddedFirstJob$4 = "Woohoo! Pridal si svoju prvú prácu do svojho sledovača práce!";
const youCanDragDropJobCard$4 = "Teraz môžete ťahať a hádzať pracovnú kartu do rôznych fáz procesu prijímania do práce. Kliknutím na pracovnú kartu si môžete zobraziť viac detailov, upraviť ich, uložiť poznámky a ďalšie!";
const Lastbutnotleast$4 = "Naposledy, ale nie najmenej.";
const finalStepMakeSure$4 = "Ako posledný krok sa uistite, že máte našu.";
const autoMaticallyImportJobs$4 = "ktorý vám umožní automaticky importovať pracovné pozície z vašich obľúbených webových stránok s pracovnými ponukami, ako je LinkedIn, Indeed a ďalšie! Naša rozšírenie tiež pomáha zlepšiť váš profil na LinkedIn a získať 2,5-krát viac zobrazení vo vyhľadávaní!";
const selectanysection$4 = "vyberte akúkoľvek sekciu";
const Accept$4 = "Prijať";
const My2023JobSearch$4 = "Moje vyhľadávanie práce v roku 2023";
const AddedFrom$4 = "Pridané z";
const AddedUntil$4 = "Pridané do";
const BasicModal$4 = "Základné modálne okno";
const AddnewSectionName$4 = "Pridať nový názov sekcie";
const OpenTo$4 = "Otvorené pre";
const Featured$4 = "Vyrobené";
const LicenceAndCerts$4 = "Licencia a certifikáty";
const Banner$4 = "Banner";
const LinkedInURL$4 = "URL adresa LinkedIn";
const Recommendations$4 = "Odporúčania";
const LinkedinReview$4 = "Hodnotenie na LinkedIn";
const NoDataAvailable$4 = "Žiadne dostupné údaje.";
const looksLikeYouDidNot$4 = "Zdá sa, že ste ešte nezačali používať našu";
const toOptimizeProfileScoreVisible$4 = "ešte optimalizovať svoj profil na LinkedIn. Keď to urobíte, váš skóre profilu bude viditeľné tu.";
const LinkedinComponent$4 = {
	letsOptimize: "Optimalizujme to"
};
const improveYourChancesLandingDreamJob$4 = "Zlepšite svoje šance na získanie svojej vysnívanej práce. Použite tieto overené stratégie na prepracovanie vášho profilu na LinkedIn.";
const VisitProfile$4 = "Navštíviť profil";
const wantToGetLinkedinMakeover$4 = "Chcete získať kompletnú premenu profilu na LinkedIn?";
const PostGenerator$4 = "Generátor príspevkov";
const LinkedinHeadlineGenerator$4 = "Generátor titulkov LinkedIn";
const LinkedinAboutSectionGenerator$4 = "Generátor sekcie O LinkedIn";
const AITools$4 = "AI Nástroje";
const Premium$4 = "Prémiový";
const LinkedInOptimization$4 = "Optimalizácia na Linked In";
const JobTracker$4 = "Správca pracovných miest";
const whoIsHiring$4 = "Kto zamestnáva";
const Autofill$4 = "Automatické vyplňovanie";
const HeadlineGenerator$4 = "Generátor titulkov";
const skillMatching$4 = "Zlučovanie zručností";
const SummarizeJD$4 = "Zhrnutie popisu práce";
const contactFeature$4 = "Sledovanie kontaktov";
const documentFeature$4 = "Dokumenty";
const landJobWithoutStress$4 = "Získajte svoju vysnívanú prácu. Bez stresu.";
const discoverFeatures$4 = "Objavte širokú škálu funkcií Careerflow.ai navrhnutých na zjednodušenie vášho hľadania práce a zlepšenie vášho profesionálneho vývoja!";
const letsBeginOnboarding$4 = "Spoznajme sa lepšie!";
const inTheNextFewScreensJobThirdParties$4 = "V nasledujúcich niekoľkých obrazovkách vám položíme niekoľko otázok, ktoré nám pomôžu prispôsobiť vaše skúsenosti a automaticky vyplniť vaše žiadosti o prácu (aby ste to nemuseli robiť sami)! Vaše údaje nepredávame tretím stranám.";
const letsAddBasicInformation$4 = "Pridajme tvoje základné informácie.";
const Pleaseselectanoptionfirst$4 = "Prosím, najprv vyberte možnosť.";
const JobApplicationTracker$4 = "Sledovač žiadostí o zamestnanie";
const LinkedInProfileOptimizer$4 = "Optimalizér profilu na Linked In";
const UnlimitedDocuments$4 = "Neobmedzené dokumenty.";
const UnlimitedContacts$4 = "Neobmedzené kontakty.";
const HiringManagerSearch$4 = "Hľadanie manažéra náboru";
const AILinkedInPostGenerator$4 = "Generátor príspevkov na LinkedIn s využitím umelej inteligencie";
const ATSKeywordSkillMatch$4 = "Práca zodpovedajúca kľúčovým slovám / zručnostiam ATS";
const ChooseyourPlan$4 = "Vyberte si svoj plán";
const superChargeYourJobSearch$4 = "Zrýchlite svoje hľadanie práce a zlepšite svoj proces prihlasovania o prácu, zvýšte počet pohovorov a získajte svoju vysnívanú prácu. Všetko s pomocou prvotriedneho nástroja Careerflow.";
const startNowGoto$4 = "Začať teraz (Prejsť na aplikáciu)";
const CreatedBy$4 = "Vytvorené od";
const CreateNewNote$4 = "Vytvoriť novú poznámku";
const Nonotescreated$4 = "Žiadne poznámky nevytvorené";
const approxTimeIsFourMinutes$4 = "Približný čas na dokončenie procesu uvádzania do prevádzky je 4 minúty.";
const Continue$4 = "Pokračovať";
const iWillDoLaterTakeMeToApp$4 = "Urobím to neskôr. Zavedieme ma do aplikácie.";
const allDone$4 = "Všetko hotové!";
const welcomeAbord$4 = "Vitajte na palube!";
const letsBegin$4 = "Začnime.";
const UpgradeyourplanandgetAIAssistance$4 = "Vylepšite svoj plán a získajte pomoc umelou inteligenciou.";
const DownloadPDF$4 = "Stiahnuť PDF";
const oopsWeCouldntProcessResume$4 = "Ups, tento životopis sa nám nepodarilo spracovať.";
const MyProfile$4 = "Môj profil";
const Setting$4 = "Nastavenie";
const Logout$4 = "Odhlásiť sa";
const SignIn$4 = "Prihlásiť sa";
const Typeyourfirstnamehere$4 = "Tvoje krstné meno";
const Enteryourlastname$4 = "Vaše priezvisko";
const ManageSubscription$4 = "Spravovať predplatné";
const ifYouHaveDifficultiesProfile$4 = "Ak máte akékoľvek ťažkosti s informáciami vo vašom profile, prosím, obráťte sa na";
const forSupport$4 = "pre podporu.";
const whatIsIdealCompanySize$4 = "Aká je vaša ideálna veľkosť spoločnosti?";
const Saveandcontinue$4 = "Uložiť a pokračovať";
const whatIsMinExpectedSalary$4 = "Aká je vaša minimálna očakávaná mzda (ročne)?";
const Atleast$4 = "Aspoň";
const SlidetoAdjust$4 = "Posuňte pre nastavenie";
const whatIndustryExcitedWork$4 = "Ktoré odvetvia sú pre vás vzrušujúce?";
const Add$4 = "Pridať";
const statusOfJobSearch$4 = "Ako sa darí v hľadaní práce?";
const Finish$4 = "Koniec";
const whatLevelRoleLooking$4 = "Akú úroveň role hľadáte?";
const Selectuptotwo$4 = "Vyberte až dve";
const PreviousStep$4 = "Predchádzajúci krok";
const Skip$4 = "Preskočiť";
const whatDoYouValueNewRole$4 = "Čo si ceníte v novej úlohe?";
const Selectuptothree$4 = "Vyberte až tri.";
const EqualEmploymentData$4 = "Rovnaké údaje o zamestnaní";
const whatIsYourEthnicity$4 = "Aké je tvoje etnické zázemie?";
const areYouAuthorizedToWorkUs$4 = "Máte povolenie pracovať v USA?";
const willYouRequireSponsorShip$4 = "Budete teraz alebo v budúcnosti potrebovať sponzorstvo pre získanie pracovného víza?";
const doYouHaveADisability$4 = "Máte nejaké zdravotné postihnutie?";
const areYouAVeteran$4 = "Ste veterán?";
const rolesYouInterestedIn$4 = "V akých rolách máte záujem?";
const Selectuptofive$4 = "Vyberte až päť.";
const AddCustomrole$4 = "Pridať vlastnú rolu";
const whereDoYouLikeWork$4 = "Kde by si chcel pracovať?";
const Resources$4 = "Zdroje";
const currentlyNoResourceAvailable$4 = "Momentálne nie sú k dispozícii žiadne zdroje.";
const AddNewSection$4 = "Pridať novú sekciu";
const ChangeSections$4 = "Zmeniť sekcie";
const Settings$4 = "Nastavenia";
const Dashboard$4 = "Dashboard";
const JobBoard$4 = "Pracovná ponuka";
const Linkedin$4 = "Linkedin";
const Community$4 = "Komunita";
const FindRecruiters$4 = "Nájsť náborárov";
const Goals$4 = "Ciele";
const DownloadExtension$4 = "Stiahnuť rozšírenie";
const SuggestaFeature$4 = "Navrhnite funkciu";
const leftPanel$4 = {
	ReportanIssue: "Nahlásiť problém"
};
const PhoneNumberisrequired$4 = "Telefónne číslo je povinné.";
const MobileNumber$4 = "Mobilné číslo";
const Enteronlynumbers$4 = "Zadávajte iba čísla";
const Countryyoulivein$4 = "Krajina, v ktorej žijete";
const SelectaCountry$4 = "Vyberte krajinu";
const DateofBirth$4 = "Dátum narodenia";
const Gender$4 = "Pohlavie";
const JobPreferences$4 = "Preferencie pri práci";
const pleaseEnterValidEmail$4 = "Prosím, zadajte platnú e-mailovú adresu.";
const emailSendForResetting$4 = "Bol vám odoslaný e-mail na obnovenie hesla.";
const VerifyyourEmailID$4 = "Overte svoj e-mailový identifikátor.";
const sentPleaseCheckEmail$4 = "Odoslané! Skontrolujte si svoj e-mail.";
const tooManyAttemptsTryAgain$4 = "Príliš veľa pokusov, skúste to znova o chvíľu.";
const Resend$4 = "Znova odoslať";
const Login$4 = "Prihlásenie";
const weHaveSentVerificationLinkAtEmail$4 = "Poslali sme vám overovací odkaz na vašu e-mailovú adresu.";
const pleaseVerifyEmailContinueSpam$4 = "Prosím, overte svoj email, aby ste mohli pokračovať. Skontrolujte tiež spam alebo promočné správy pre overovací email.";
const Logintogetstarted$4 = "Prihláste sa a začnite.";
const ContinuewithGoogle$4 = "Pokračovať s Googlem.";
const pleaseInputEmail$4 = "Prosím, zadajte svoj email!";
const Password$4 = "Heslo";
const pleaseInputPassword$4 = "Prosím, zadajte svoje heslo!";
const passwordLowerUpperDigitSpecial$4 = "Vaše heslo musí obsahovať aspoň jedno malé písmeno, veľké písmeno, číslicu a špeciálny znak.";
const atLeastSixChar$4 = "Aspoň 6 znakov.";
const forgotPassword$4 = "Zabudli ste heslo?";
const Bysigninginyouagreetoour$4 = "Prihlásením súhlasíte s našimi.";
const Terms$4 = "Podmienky";
const Conditions$4 = "Podmienky";
const and$4 = "a";
const PrivacyPolicy$4 = "Zásady ochrany osobných údajov";
const theseAreTheTopsSkillsExtracted$4 = "Toto sú najdôležitejšie zručnosti vyplývajúce z popisu práce.";
const TopSkills$4 = "Top zručnosti";
const weCoulNotExtractSkills$4 = "Nepodarilo sa nám získať žiadne zručnosti z tejto pracovnej ponuky.";
const upgradeToPremiumToView$4 = "Aktualizujte na prémiovú verziu, aby ste videli zhodu vašich zručností v životopise.";
const SkillScore$4 = "Skóre zručnosti";
const thisIsYourSkillScoreBasedOn$4 = "Toto je váš skóre zručností na základe pracovného popisu a vášho životopisu.";
const theseSkllsAreStrongMatch$4 = "Tieto zručnosti sú silným zodpovedaním medzi vašim životopisom a popisom práce.";
const Strongmatch$4 = "Silný zápas";
const theseSkillsArePartialMatch$4 = "Tieto zručnosti sú čiastočným zodpovedaním medzi vašim životopisom a popisom práce.";
const Partialmatch$4 = "Čiastočné zhody";
const theseSkillsAreMissingFrom$4 = "Tieto kľúčové slová chýbajú vo vašom životopise, ale sú uvedené v popise práce. Môžu to byť zručnosti alebo všeobecné kľúčové slová, ktoré sú špecifické pre pracovnú príležitosť a mohli by byť užitočné pre pridanie do vášho životopisu.";
const SkillMatchComponent$4 = {
	removeSkill: "Aký je váš hlavný dôvod na nahlásenie problému s týmto kľúčovým slovom"
};
const Optional$4 = "Voliteľné";
const Notrelevanttothejob$4 = "Nevhodné pre túto prácu";
const Notaskill$4 = "Žiadna zručnosť";
const Toogeneric$4 = "Príliš všeobecné";
const Pleaseshareanyfeedback$4 = "Prosím, zdieľajte akékoľvek pripomienky";
const excludedKeywordsWillNot$4 = "Vylúčené kľúčové slová sa nebudú počítať do vášho zhodnotenia pre všetky budúce skenovania. Môžete zmeniť vylúčené kľúčové slová vo svojom profile.";
const yesExcludeThisSkillFrom$4 = "Áno, vylúčte túto zručnosť zo všetkých skenov mojich životopisov.";
const PartialMatch$4 = "Čiastočný zápas";
const MissingKeywords$4 = "Chýbajúce kľúčové slová";
const Providetitletotask$4 = "Poskytnite názov úlohe";
const TasksList$4 = "Zoznam úloh";
const AddTask$4 = "Pridať úlohu";
const EnterTaskTitlehere$4 = "Zadajte názov úlohy sem";
const TasksComponent$4 = {
	listEmpty: "Zoznam úloh je prázdny, vytvorte nový."
};
const CompletedTasks$4 = "Dokončené úlohy";
const CompleteYourtasks$4 = "Dokončite svoje úlohy";
const Steps$4 = "Kroky";
const PremiumMember$4 = "Prémiový člen";
const Thankyouforupgradingto$4 = "Ďakujeme vám za upgrade na\"\"\"";
const CareerflowPremium$4 = "Kariérny tok Premium";
const hereIsHowYouCanAccessPremium$4 = "Tu je ako získať svoje prémiové výhody!";
const stepOne$4 = "Krok 1";
const DownloadourChromeExtension$4 = "Stiahnite si našu rozšírenie pre Chrome.";
const youJobSearchCopilotIshere$4 = "Váš AI spolujazdec pri hľadaní práce je tu.";
const DownloadNow$4 = "Stiahnuť teraz";
const stepTwo$4 = "Krok 2";
const GetStarted$4 = "Začať";
const stepThree$4 = "Krok 3";
const SignintoChromeExtension$4 = "Prihlásiť sa do rozšírenia Chrome";
const entityCreated$4 = "Vytvorená nová {{entity}}";
const entityUpdated$4 = "{{entity}} aktualizované.";
const entityDeleted$4 = "{{entity}} zmazané.";
const entityLinked$4 = "{{entity}} prepojené";
const entityUnlinked$4 = "{{entity}} odpojené";
const entityMovedTo$4 = "Presunuté na {{entity}}.";
const youAddedANewEntity$4 = "Pridali ste novú {{entity}}.";
const personCreated$4 = "{{creator}} vytvoril {{entity}} pre {{owner}}.";
const youUpdatedAEntity$4 = "Aktualizovali ste {{entity}}";
const personUpdated$4 = "{{creator}} aktualizoval {{entity}} pre {{owner}}.";
const youDeletedAEntity$4 = "Vymazali ste {{entity}}";
const personDeleted$4 = "{{creator}} vymazal {{entity}} pre {{owner}}.";
const youLinkedEntity$4 = "Pripojili ste {{entity}} k tomuto pracovnému miestu.";
const personLinked$4 = "{{creator}} pripojil {{entity}} k tomuto úlohe pre {{owner}}.";
const youUnlinked$4 = "Odpojili ste {{entity}} od tohto pracovného miesta.";
const personUnlinked$4 = "{{creator}} odpojil {{entity}} od tohto úlohy pre {{owner}}.";
const youMovedEntity$4 = "Presunuli ste tento {{entity}} z {{sectionFrom}} do {{sectionTo}}.";
const personMoved$4 = "{{creator}} presunul tento {{entity}} z {{sectionFrom}} do {{sectionTo}} pre {{owner}}.";
const addedByName$4 = "Pridané používateľom {{name}}.";
const DownloadChromeExtension$4 = "Stiahnuť rozšírenie Chrome";
const ourChromeExtensionIs$4 = "Náš chrome rozšírenie je integrovaný nástroj, ktorý vám pomôže optimalizovať váš LinkedIn profil, uložiť pracovné pozície, kontakty, generovať motivačný list a ďalšie.";
const Optimizeyourprofile$4 = "Optimalizujte svoj profil.";
const startOptimizingYourProfile$4 = "Začnite optimalizovať svoj profil, aby ste mali lepšie šance na kontaktovanie rekrutérmi.";
const OptimizeNow$4 = "Optimalizovať teraz";
const Addyourfirstjob$4 = "Pridajte svoju prvú prácu";
const startSavingJobApplicationsToTrack$4 = "Začnite ukladať žiadosti o prácu, aby ste sledovali svoju cestu hľadania zamestnania a našli užitočné poznatky.";
const AddNow$4 = "Pridať teraz";
const CompleteProfile$4 = "Úplný profil";
const completeYourProfileForUsing$4 = "Dokončite svoj profil pre použitie funkcie automatického vyplňovania a získanie viac personalizovaného zážitku.";
const CompleteNow$4 = "Kompletné teraz";
const Addyourfirstcontact$4 = "Pridajte svoj prvý kontakt";
const addContactToFollowUpWith$4 = "Pridajte kontakt na neskoršie sledovanie, pridajte poznámky a ďalšie.";
const JoinCommunity$4 = "Pripojiť sa k spoločenstvu";
const ourCommunityisAlways$4 = "Naša komunita je vždy s vami počas vašej cesty hľadania práce.";
const JoinNow$4 = "Pripojte sa teraz";
const welcomeToCareerflow$4 = "Vitajte v Careerflow!";
const yourHubForCareerInsights2$4 = "Toto je váš stred pre kariérne poznatky, aktivity a ďalšie. Preskúmajte svoju personalizovanú nástenku, aby ste zostali na vrchole svojej profesionálnej cesty.";
const ChecklistCompleted$4 = "Váš kontrolný zoznam je dokončený!";
const Completeyourchecklist$4 = "Dokončite svoj kontrolný zoznam.";
const completeAFewStepsTo$4 = "Dokončite niekoľko krokov, aby ste získali svoju ďalšiu prácu.";
const Completed$4 = "Dokončené";
const JobCountByStage$4 = "Počet pracovných miest podľa fázy";
const NopastapplicationDatafound$4 = "Nenašli sa žiadne dáta o predchádzajúcich žiadostiach";
const YourJobSearchStages$4 = "Fázy vášho hľadania práce";
const NoDatafound$4 = "Neboli nájdené žiadne údaje.";
const sk = {
	copyToClipboard: copyToClipboard$4,
	UnlocktheAIgenerated: UnlocktheAIgenerated$4,
	UpgradetoPremium: UpgradetoPremium$4,
	Result: Result$4,
	Copy: Copy$4,
	Save: Save$4,
	Edit: Edit$4,
	Processing: Processing$4,
	YourAIgeneratedcontentwillshowhere: YourAIgeneratedcontentwillshowhere$4,
	hopeYouFindUseful: hopeYouFindUseful$4,
	regenerate: regenerate$4,
	ProvideAdditionalFeedback: ProvideAdditionalFeedback$4,
	Enteranyfeedback: Enteranyfeedback$4,
	Notimpressive: Notimpressive$4,
	thisIsntTrue: thisIsntTrue$4,
	Notpersonalized: Notpersonalized$4,
	Tone: Tone$4,
	Length: Length$4,
	Template: Template$4,
	Generatedon: Generatedon$4,
	Copiedtoclipboard: Copiedtoclipboard$4,
	CopytoClipboard: CopytoClipboard$4,
	DownloadasPDF: DownloadasPDF$4,
	ViewDetails: ViewDetails$4,
	JobDescriptionImported: JobDescriptionImported$4,
	ImportfromJob: ImportfromJob$4,
	Saved: Saved$4,
	Applied: Applied$4,
	Offer: Offer$4,
	Interviewing: Interviewing$4,
	Rejected: Rejected$4,
	Search: Search$4,
	Import: Import$4,
	CoverLetterGeneratorHistory: CoverLetterGeneratorHistory$4,
	NoCoverLettersGenerated: NoCoverLettersGenerated$4,
	getStartedCoverLetter: getStartedCoverLetter$4,
	getStarted: getStarted$4,
	Documents: Documents$4,
	UploadNewDocument: UploadNewDocument$4,
	AICoverLetterGenerator: AICoverLetterGenerator$4,
	ViewHistory: ViewHistory$4,
	JobDescription: JobDescription$4,
	ImportfromBoard: ImportfromBoard$4,
	EnterJobDescription: EnterJobDescription$4,
	JobTitle: JobTitle$4,
	EnterJobTitle: EnterJobTitle$4,
	CompanyName: CompanyName$4,
	EnterCompanyName: EnterCompanyName$4,
	YourProfile: YourProfile$4,
	ResumeUpload: ResumeUpload$4,
	UseLinkedinProfile: UseLinkedinProfile$4,
	Uploadyourresume: Uploadyourresume$4,
	AddyourResume: AddyourResume$4,
	fileNameCannotFormat: fileNameCannotFormat$4,
	ChooseorUpload: ChooseorUpload$4,
	SelectTemplate: SelectTemplate$4,
	Preview: Preview$4,
	UseTemplate: UseTemplate$4,
	Change: Change$4,
	AdvancedSettings: AdvancedSettings$4,
	AdditionalContext: AdditionalContext$4,
	Professional: Professional$4,
	Casual: Casual$4,
	Enthusiastic: Enthusiastic$4,
	Informational: Informational$4,
	Short: Short$4,
	Medium: Medium$4,
	Long: Long$4,
	Language: Language$4,
	iAmOkayBack: iAmOkayBack$4,
	Generate: Generate$4,
	CoverLetter: CoverLetter$4,
	SelectLanguage: SelectLanguage$4,
	AboutGeneratorHistory: AboutGeneratorHistory$4,
	NoAboutsGenerated: NoAboutsGenerated$4,
	getStartedAbouts: getStartedAbouts$4,
	noAttachmentsFound: noAttachmentsFound$4,
	TargetJobTitle: TargetJobTitle$4,
	KeywordsToInclude: KeywordsToInclude$4,
	UploadYourResume: UploadYourResume$4,
	AddYourResume: AddYourResume$4,
	LinkedinProfile: LinkedinProfile$4,
	Linkedinprofilenotfound: Linkedinprofilenotfound$4,
	startUsingChromeExtension: startUsingChromeExtension$4,
	Download: Download$4,
	UseEmojis: UseEmojis$4,
	UseBulletPoints: UseBulletPoints$4,
	SpeechFocus: SpeechFocus$4,
	FirstPerson: FirstPerson$4,
	ThirdPerson: ThirdPerson$4,
	HeadlineGeneratorHistory: HeadlineGeneratorHistory$4,
	NoHeadlinesGenerated: NoHeadlinesGenerated$4,
	getStartedHeadline: getStartedHeadline$4,
	AIHeadlineGenerator: AIHeadlineGenerator$4,
	KeywordstoInclude: KeywordstoInclude$4,
	Pressenteraftereachword: Pressenteraftereachword$4,
	LinkedinProfilenotfound: LinkedinProfilenotfound$4,
	Headline: Headline$4,
	PostGeneratorHistory: PostGeneratorHistory$4,
	NoPostsGenerated: NoPostsGenerated$4,
	getStartedPost: getStartedPost$4,
	Topic: Topic$4,
	Description: Description$4,
	UseHashtags: UseHashtags$4,
	Custom: Custom$4,
	EnterCustomTone: EnterCustomTone$4,
	Added: Added$4,
	ComingSoon: ComingSoon$4,
	Company: Company$4,
	JobInterview: JobInterview$4,
	Research: Research$4,
	Networking: Networking$4,
	Referral: Referral$4,
	MustbeContacted: MustbeContacted$4,
	ScheduleaMeeting: ScheduleaMeeting$4,
	needAFollowUp: needAFollowUp$4,
	Today: Today$4,
	Viewdetails: Viewdetails$4,
	Activity: Activity$4,
	ActivityDetails: ActivityDetails$4,
	Delete: Delete$4,
	Title: Title$4,
	Goal: Goal$4,
	Status: Status$4,
	FollowUp: FollowUp$4,
	AddActivity: AddActivity$4,
	Enteractivitytitle: Enteractivitytitle$4,
	Cancel: Cancel$4,
	SaveActivity: SaveActivity$4,
	noActivityPresent: noActivityPresent$4,
	Addnew: Addnew$4,
	About: About$4,
	noDataPresentYou: noDataPresentYou$4,
	Experience: Experience$4,
	Education: Education$4,
	Skills: Skills$4,
	Overview: Overview$4,
	LinkedJobs: LinkedJobs$4,
	Notes: Notes$4,
	FullName: FullName$4,
	Location: Location$4,
	Relationship: Relationship$4,
	Contacts: Contacts$4,
	CreateContact: CreateContact$4,
	NotesCreated: NotesCreated$4,
	Notesupdated: Notesupdated$4,
	Addnote: Addnote$4,
	areYouSureDeleteNote: areYouSureDeleteNote$4,
	Createdby: Createdby$4,
	notSureWhyResumeCalls: notSureWhyResumeCalls$4,
	getExpertResumeReview: getExpertResumeReview$4,
	youHaventAddedContacts: youHaventAddedContacts$4,
	noMatchingContacts: noMatchingContacts$4,
	Link: Link$4,
	unlink: unlink$4,
	Locationnotavailable: Locationnotavailable$4,
	Emailnotavailable: Emailnotavailable$4,
	PhoneNumbernotavailable: PhoneNumbernotavailable$4,
	createdby: createdby$4,
	areYouSureDeleteContact: areYouSureDeleteContact$4,
	areYouSureUnlinkContact: areYouSureUnlinkContact$4,
	Addedbyyou: Addedbyyou$4,
	Addedby: Addedby$4,
	Timeline: Timeline$4,
	Timelineempty: Timelineempty$4,
	Discard: Discard$4,
	SaveContact: SaveContact$4,
	Recruiter: Recruiter$4,
	Candidate: Candidate$4,
	Colleague: Colleague$4,
	Employee: Employee$4,
	"Needtofollow-up": "Potreba nasledovať",
	EnterValidEmail: EnterValidEmail$4,
	EnterValidPhoneNumber: EnterValidPhoneNumber$4,
	editingProfileNotAvailable: editingProfileNotAvailable$4,
	itWillBeSoonAvailable: itWillBeSoonAvailable$4,
	ChromeExtension: ChromeExtension$4,
	SelectTag: SelectTag$4,
	FirstName: FirstName$4,
	FirstNameisrequired: FirstNameisrequired$4,
	LastName: LastName$4,
	LastNameisrequired: LastNameisrequired$4,
	Companyisrequired: Companyisrequired$4,
	Email: Email$4,
	ThisisnotavalidEmail: ThisisnotavalidEmail$4,
	AddEmail: AddEmail$4,
	PhoneNumber: PhoneNumber$4,
	notaValidPhone: notaValidPhone$4,
	phoneNoMinimum5char: phoneNoMinimum5char$4,
	phoneNoMinumum15char: phoneNoMinumum15char$4,
	AddPhoneNumber: AddPhoneNumber$4,
	SelectGoal: SelectGoal$4,
	SelectStatus: SelectStatus$4,
	Followup: Followup$4,
	SocialMedia: SocialMedia$4,
	Linkedinhandle: Linkedinhandle$4,
	Twitterhandle: Twitterhandle$4,
	Facebookhandle: Facebookhandle$4,
	Githubhandle: Githubhandle$4,
	Gmailhandle: Gmailhandle$4,
	Changessavedsuccessfully: Changessavedsuccessfully$4,
	EditContact: EditContact$4,
	BasicInformation: BasicInformation$4,
	EditContactDetails: EditContactDetails$4,
	SaveChanges: SaveChanges$4,
	phoneNoMinimum14char: phoneNoMinimum14char$4,
	LinkedIn: LinkedIn$4,
	Twitter: Twitter$4,
	Facebook: Facebook$4,
	Github: Github$4,
	Gmail: Gmail$4,
	youCanWriteAbout: youCanWriteAbout$4,
	Addednewsection: Addednewsection$4,
	Removedsuccessfully: Removedsuccessfully$4,
	Remove: Remove$4,
	Institute: Institute$4,
	Schoolisrequired: Schoolisrequired$4,
	Degree: Degree$4,
	StartMonth: StartMonth$4,
	StartYear: StartYear$4,
	EndMonth: EndMonth$4,
	EndYear: EndYear$4,
	Addmore: Addmore$4,
	PositionTitle: PositionTitle$4,
	ExperienceType: ExperienceType$4,
	Addednewitem: Addednewitem$4,
	whatSkillsDoYouEnjoy: whatSkillsDoYouEnjoy$4,
	Typeskillshere: Typeskillshere$4,
	LinkedContacts: LinkedContacts$4,
	LinkContact: LinkContact$4,
	NocontactsLinked: NocontactsLinked$4,
	JobContactsComponent: JobContactsComponent$4,
	Nocontacts: Nocontacts$4,
	LinkJobto: LinkJobto$4,
	Contact: Contact$4,
	Document: Document$4,
	Nojobsfound: Nojobsfound$4,
	LinkJob: LinkJob$4,
	youCanLinkContactJobImported: youCanLinkContactJobImported$4,
	Prev: Prev$4,
	Next: Next$4,
	areYouSureUnlinkDocument: areYouSureUnlinkDocument$4,
	areYouSureDeleteDocument: areYouSureDeleteDocument$4,
	Category: Category$4,
	CreatedOn: CreatedOn$4,
	Joblinked: Joblinked$4,
	Quickactions: Quickactions$4,
	All: All$4,
	Resume: Resume$4,
	Portfolio: Portfolio$4,
	Other: Other$4,
	Adddocument: Adddocument$4,
	Type: Type$4,
	Sortingby: Sortingby$4,
	SwitchtoGridLayout: SwitchtoGridLayout$4,
	SwitchtoListLayout: SwitchtoListLayout$4,
	NoDocumentsAdded: NoDocumentsAdded$4,
	DocumentsComponent: DocumentsComponent$4,
	NoDocumentFound: NoDocumentFound$4,
	SelectFile: SelectFile$4,
	onlyPdfDocxSupported: onlyPdfDocxSupported$4,
	Uploadfile: Uploadfile$4,
	DocumentCategory: DocumentCategory$4,
	SaveDocument: SaveDocument$4,
	AddDocument: AddDocument$4,
	LinkedDocuments: LinkedDocuments$4,
	LinkDocument: LinkDocument$4,
	NodocumentsLinked: NodocumentsLinked$4,
	JobDocumentsComponent: JobDocumentsComponent$4,
	NoDocuments: NoDocuments$4,
	CreateDocuments: CreateDocuments$4,
	youCanLinkDocumentJobImported: youCanLinkDocumentJobImported$4,
	Documenteditedsuccessfully: Documenteditedsuccessfully$4,
	DocumentDetails: DocumentDetails$4,
	UnsavedChanges: UnsavedChanges$4,
	yourChangesWillBeLostSureClose: yourChangesWillBeLostSureClose$4,
	yourChangesWillBeLostSureDiscard: yourChangesWillBeLostSureDiscard$4,
	DiscardChanges: DiscardChanges$4,
	WeeklyGoalAlert: WeeklyGoalAlert$4,
	Progress: Progress$4,
	AllGoals: AllGoals$4,
	Name: Name$4,
	Completedon: Completedon$4,
	Createdon: Createdon$4,
	Action: Action$4,
	Back: Back$4,
	OverallScore: OverallScore$4,
	Aboutthegoal: Aboutthegoal$4,
	GoalTracking: GoalTracking$4,
	Week: Week$4,
	progress: progress$4,
	loading: loading$4,
	Apply: Apply$4,
	Thisskillhasbeenreported: Thisskillhasbeenreported$4,
	issueGettingResume: issueGettingResume$4,
	Interview: Interview$4,
	Tasks: Tasks$4,
	Loading: Loading$4,
	Skilladdedsuccessfully: Skilladdedsuccessfully$4,
	problemAddingSkill: problemAddingSkill$4,
	Reportaproblem: Reportaproblem$4,
	Submit: Submit$4,
	Addanewskill: Addanewskill$4,
	JobDetailsComponent: JobDetailsComponent$4,
	HardSkill: HardSkill$4,
	SoftSkill: SoftSkill$4,
	Pleaseshareanyadditionalcontext: Pleaseshareanyadditionalcontext$4,
	Addasskill: Addasskill$4,
	Skill: Skill$4,
	JobFrequency: JobFrequency$4,
	ResumeFrequency: ResumeFrequency$4,
	Reportskill: Reportskill$4,
	JobDetails: JobDetails$4,
	ViewJobLink: ViewJobLink$4,
	Salary: Salary$4,
	areYouSureDeleteJob: areYouSureDeleteJob$4,
	ViewMore: ViewMore$4,
	ViewLess: ViewLess$4,
	matchYouSkillsAgainstJob: matchYouSkillsAgainstJob$4,
	pleaseUploadResumeSkillMatch: pleaseUploadResumeSkillMatch$4,
	AddResume: AddResume$4,
	thisJobDoesNotHaveAnyDesc: thisJobDoesNotHaveAnyDesc$4,
	youCanEditJobToAdd: youCanEditJobToAdd$4,
	chromeextension: chromeextension$4,
	fromVariousJobPortalsOnce: fromVariousJobPortalsOnce$4,
	AddDescription: AddDescription$4,
	CompanyInfo: CompanyInfo$4,
	Website: Website$4,
	Industry: Industry$4,
	EmployeeCount: EmployeeCount$4,
	ExprienceLevel: ExprienceLevel$4,
	Address: Address$4,
	Resumes: Resumes$4,
	Setasdefault: Setasdefault$4,
	Ok: Ok$4,
	UploadNewResume: UploadNewResume$4,
	Default: Default$4,
	Jobnotfound: Jobnotfound$4,
	EditDetails: EditDetails$4,
	JobPostURL: JobPostURL$4,
	Enterjoburl: Enterjoburl$4,
	Nojobselected: Nojobselected$4,
	Viewjobdetails: Viewjobdetails$4,
	Jobaddedtoyourboardsuccessfully: Jobaddedtoyourboardsuccessfully$4,
	AddJob: AddJob$4,
	Addnewjobname: Addnewjobname$4,
	JobUrl: JobUrl$4,
	Addjoburl: Addjoburl$4,
	Section: Section$4,
	didYouKnow: didYouKnow$4,
	Jobs: Jobs$4,
	AddJobtoboard: AddJobtoboard$4,
	Currentlynojobsareavailable: Currentlynojobsareavailable$4,
	noMatchingJobs: noMatchingJobs$4,
	welcomeToYourPersonalJobTracker: welcomeToYourPersonalJobTracker$4,
	weShortTutorialOnHowTrackingJob: weShortTutorialOnHowTrackingJob$4,
	Addanewjob: Addanewjob$4,
	inOrderTrackCreatButton: inOrderTrackCreatButton$4,
	Providesomedetails: Providesomedetails$4,
	toBeginTypeJobTitleCompany: toBeginTypeJobTitleCompany$4,
	asAnExampleFilledForYou: asAnExampleFilledForYou$4,
	wohooAddedFirstJob: wohooAddedFirstJob$4,
	youCanDragDropJobCard: youCanDragDropJobCard$4,
	Lastbutnotleast: Lastbutnotleast$4,
	finalStepMakeSure: finalStepMakeSure$4,
	autoMaticallyImportJobs: autoMaticallyImportJobs$4,
	selectanysection: selectanysection$4,
	Accept: Accept$4,
	My2023JobSearch: My2023JobSearch$4,
	AddedFrom: AddedFrom$4,
	AddedUntil: AddedUntil$4,
	BasicModal: BasicModal$4,
	AddnewSectionName: AddnewSectionName$4,
	OpenTo: OpenTo$4,
	Featured: Featured$4,
	LicenceAndCerts: LicenceAndCerts$4,
	Banner: Banner$4,
	LinkedInURL: LinkedInURL$4,
	Recommendations: Recommendations$4,
	LinkedinReview: LinkedinReview$4,
	NoDataAvailable: NoDataAvailable$4,
	looksLikeYouDidNot: looksLikeYouDidNot$4,
	toOptimizeProfileScoreVisible: toOptimizeProfileScoreVisible$4,
	LinkedinComponent: LinkedinComponent$4,
	improveYourChancesLandingDreamJob: improveYourChancesLandingDreamJob$4,
	VisitProfile: VisitProfile$4,
	wantToGetLinkedinMakeover: wantToGetLinkedinMakeover$4,
	PostGenerator: PostGenerator$4,
	LinkedinHeadlineGenerator: LinkedinHeadlineGenerator$4,
	LinkedinAboutSectionGenerator: LinkedinAboutSectionGenerator$4,
	AITools: AITools$4,
	Premium: Premium$4,
	LinkedInOptimization: LinkedInOptimization$4,
	JobTracker: JobTracker$4,
	whoIsHiring: whoIsHiring$4,
	Autofill: Autofill$4,
	HeadlineGenerator: HeadlineGenerator$4,
	skillMatching: skillMatching$4,
	SummarizeJD: SummarizeJD$4,
	contactFeature: contactFeature$4,
	documentFeature: documentFeature$4,
	landJobWithoutStress: landJobWithoutStress$4,
	discoverFeatures: discoverFeatures$4,
	letsBeginOnboarding: letsBeginOnboarding$4,
	inTheNextFewScreensJobThirdParties: inTheNextFewScreensJobThirdParties$4,
	letsAddBasicInformation: letsAddBasicInformation$4,
	Pleaseselectanoptionfirst: Pleaseselectanoptionfirst$4,
	JobApplicationTracker: JobApplicationTracker$4,
	LinkedInProfileOptimizer: LinkedInProfileOptimizer$4,
	UnlimitedDocuments: UnlimitedDocuments$4,
	UnlimitedContacts: UnlimitedContacts$4,
	HiringManagerSearch: HiringManagerSearch$4,
	AILinkedInPostGenerator: AILinkedInPostGenerator$4,
	ATSKeywordSkillMatch: ATSKeywordSkillMatch$4,
	"Auto-Apply": "Automatické použitie",
	ChooseyourPlan: ChooseyourPlan$4,
	superChargeYourJobSearch: superChargeYourJobSearch$4,
	startNowGoto: startNowGoto$4,
	CreatedBy: CreatedBy$4,
	CreateNewNote: CreateNewNote$4,
	Nonotescreated: Nonotescreated$4,
	approxTimeIsFourMinutes: approxTimeIsFourMinutes$4,
	Continue: Continue$4,
	iWillDoLaterTakeMeToApp: iWillDoLaterTakeMeToApp$4,
	allDone: allDone$4,
	welcomeAbord: welcomeAbord$4,
	letsBegin: letsBegin$4,
	UpgradeyourplanandgetAIAssistance: UpgradeyourplanandgetAIAssistance$4,
	DownloadPDF: DownloadPDF$4,
	oopsWeCouldntProcessResume: oopsWeCouldntProcessResume$4,
	MyProfile: MyProfile$4,
	Setting: Setting$4,
	Logout: Logout$4,
	SignIn: SignIn$4,
	Typeyourfirstnamehere: Typeyourfirstnamehere$4,
	Enteryourlastname: Enteryourlastname$4,
	ManageSubscription: ManageSubscription$4,
	ifYouHaveDifficultiesProfile: ifYouHaveDifficultiesProfile$4,
	forSupport: forSupport$4,
	whatIsIdealCompanySize: whatIsIdealCompanySize$4,
	Saveandcontinue: Saveandcontinue$4,
	whatIsMinExpectedSalary: whatIsMinExpectedSalary$4,
	Atleast: Atleast$4,
	SlidetoAdjust: SlidetoAdjust$4,
	whatIndustryExcitedWork: whatIndustryExcitedWork$4,
	Add: Add$4,
	statusOfJobSearch: statusOfJobSearch$4,
	Finish: Finish$4,
	whatLevelRoleLooking: whatLevelRoleLooking$4,
	Selectuptotwo: Selectuptotwo$4,
	PreviousStep: PreviousStep$4,
	Skip: Skip$4,
	whatDoYouValueNewRole: whatDoYouValueNewRole$4,
	Selectuptothree: Selectuptothree$4,
	EqualEmploymentData: EqualEmploymentData$4,
	whatIsYourEthnicity: whatIsYourEthnicity$4,
	areYouAuthorizedToWorkUs: areYouAuthorizedToWorkUs$4,
	willYouRequireSponsorShip: willYouRequireSponsorShip$4,
	doYouHaveADisability: doYouHaveADisability$4,
	areYouAVeteran: areYouAVeteran$4,
	rolesYouInterestedIn: rolesYouInterestedIn$4,
	Selectuptofive: Selectuptofive$4,
	AddCustomrole: AddCustomrole$4,
	whereDoYouLikeWork: whereDoYouLikeWork$4,
	Resources: Resources$4,
	currentlyNoResourceAvailable: currentlyNoResourceAvailable$4,
	AddNewSection: AddNewSection$4,
	ChangeSections: ChangeSections$4,
	Settings: Settings$4,
	Dashboard: Dashboard$4,
	JobBoard: JobBoard$4,
	Linkedin: Linkedin$4,
	Community: Community$4,
	FindRecruiters: FindRecruiters$4,
	Goals: Goals$4,
	DownloadExtension: DownloadExtension$4,
	SuggestaFeature: SuggestaFeature$4,
	leftPanel: leftPanel$4,
	PhoneNumberisrequired: PhoneNumberisrequired$4,
	MobileNumber: MobileNumber$4,
	Enteronlynumbers: Enteronlynumbers$4,
	Countryyoulivein: Countryyoulivein$4,
	SelectaCountry: SelectaCountry$4,
	DateofBirth: DateofBirth$4,
	Gender: Gender$4,
	JobPreferences: JobPreferences$4,
	pleaseEnterValidEmail: pleaseEnterValidEmail$4,
	emailSendForResetting: emailSendForResetting$4,
	VerifyyourEmailID: VerifyyourEmailID$4,
	sentPleaseCheckEmail: sentPleaseCheckEmail$4,
	tooManyAttemptsTryAgain: tooManyAttemptsTryAgain$4,
	Resend: Resend$4,
	Login: Login$4,
	weHaveSentVerificationLinkAtEmail: weHaveSentVerificationLinkAtEmail$4,
	pleaseVerifyEmailContinueSpam: pleaseVerifyEmailContinueSpam$4,
	Logintogetstarted: Logintogetstarted$4,
	ContinuewithGoogle: ContinuewithGoogle$4,
	pleaseInputEmail: pleaseInputEmail$4,
	Password: Password$4,
	pleaseInputPassword: pleaseInputPassword$4,
	passwordLowerUpperDigitSpecial: passwordLowerUpperDigitSpecial$4,
	atLeastSixChar: atLeastSixChar$4,
	forgotPassword: forgotPassword$4,
	Bysigninginyouagreetoour: Bysigninginyouagreetoour$4,
	Terms: Terms$4,
	Conditions: Conditions$4,
	and: and$4,
	PrivacyPolicy: PrivacyPolicy$4,
	theseAreTheTopsSkillsExtracted: theseAreTheTopsSkillsExtracted$4,
	TopSkills: TopSkills$4,
	weCoulNotExtractSkills: weCoulNotExtractSkills$4,
	upgradeToPremiumToView: upgradeToPremiumToView$4,
	SkillScore: SkillScore$4,
	thisIsYourSkillScoreBasedOn: thisIsYourSkillScoreBasedOn$4,
	theseSkllsAreStrongMatch: theseSkllsAreStrongMatch$4,
	Strongmatch: Strongmatch$4,
	theseSkillsArePartialMatch: theseSkillsArePartialMatch$4,
	Partialmatch: Partialmatch$4,
	theseSkillsAreMissingFrom: theseSkillsAreMissingFrom$4,
	"Missing Keywords": "Chýbajúce kľúčové slová",
	SkillMatchComponent: SkillMatchComponent$4,
	Optional: Optional$4,
	Notrelevanttothejob: Notrelevanttothejob$4,
	Notaskill: Notaskill$4,
	Toogeneric: Toogeneric$4,
	Pleaseshareanyfeedback: Pleaseshareanyfeedback$4,
	excludedKeywordsWillNot: excludedKeywordsWillNot$4,
	yesExcludeThisSkillFrom: yesExcludeThisSkillFrom$4,
	PartialMatch: PartialMatch$4,
	MissingKeywords: MissingKeywords$4,
	Providetitletotask: Providetitletotask$4,
	TasksList: TasksList$4,
	AddTask: AddTask$4,
	EnterTaskTitlehere: EnterTaskTitlehere$4,
	TasksComponent: TasksComponent$4,
	CompletedTasks: CompletedTasks$4,
	CompleteYourtasks: CompleteYourtasks$4,
	Steps: Steps$4,
	PremiumMember: PremiumMember$4,
	Thankyouforupgradingto: Thankyouforupgradingto$4,
	CareerflowPremium: CareerflowPremium$4,
	hereIsHowYouCanAccessPremium: hereIsHowYouCanAccessPremium$4,
	stepOne: stepOne$4,
	DownloadourChromeExtension: DownloadourChromeExtension$4,
	youJobSearchCopilotIshere: youJobSearchCopilotIshere$4,
	DownloadNow: DownloadNow$4,
	stepTwo: stepTwo$4,
	GetStarted: GetStarted$4,
	stepThree: stepThree$4,
	SignintoChromeExtension: SignintoChromeExtension$4,
	entityCreated: entityCreated$4,
	entityUpdated: entityUpdated$4,
	entityDeleted: entityDeleted$4,
	entityLinked: entityLinked$4,
	entityUnlinked: entityUnlinked$4,
	entityMovedTo: entityMovedTo$4,
	youAddedANewEntity: youAddedANewEntity$4,
	personCreated: personCreated$4,
	youUpdatedAEntity: youUpdatedAEntity$4,
	personUpdated: personUpdated$4,
	youDeletedAEntity: youDeletedAEntity$4,
	personDeleted: personDeleted$4,
	youLinkedEntity: youLinkedEntity$4,
	personLinked: personLinked$4,
	youUnlinked: youUnlinked$4,
	personUnlinked: personUnlinked$4,
	youMovedEntity: youMovedEntity$4,
	personMoved: personMoved$4,
	addedByName: addedByName$4,
	DownloadChromeExtension: DownloadChromeExtension$4,
	ourChromeExtensionIs: ourChromeExtensionIs$4,
	Optimizeyourprofile: Optimizeyourprofile$4,
	startOptimizingYourProfile: startOptimizingYourProfile$4,
	OptimizeNow: OptimizeNow$4,
	Addyourfirstjob: Addyourfirstjob$4,
	startSavingJobApplicationsToTrack: startSavingJobApplicationsToTrack$4,
	AddNow: AddNow$4,
	CompleteProfile: CompleteProfile$4,
	completeYourProfileForUsing: completeYourProfileForUsing$4,
	CompleteNow: CompleteNow$4,
	Addyourfirstcontact: Addyourfirstcontact$4,
	addContactToFollowUpWith: addContactToFollowUpWith$4,
	JoinCommunity: JoinCommunity$4,
	ourCommunityisAlways: ourCommunityisAlways$4,
	JoinNow: JoinNow$4,
	welcomeToCareerflow: welcomeToCareerflow$4,
	yourHubForCareerInsights2: yourHubForCareerInsights2$4,
	ChecklistCompleted: ChecklistCompleted$4,
	Completeyourchecklist: Completeyourchecklist$4,
	completeAFewStepsTo: completeAFewStepsTo$4,
	Completed: Completed$4,
	JobCountByStage: JobCountByStage$4,
	NopastapplicationDatafound: NopastapplicationDatafound$4,
	YourJobSearchStages: YourJobSearchStages$4,
	NoDatafound: NoDatafound$4
};

const copyToClipboard$3 = "Kopirano v odložišče!";
const UnlocktheAIgenerated$3 = "Odklenite umetno inteligenco, ki je bila ustvarjena.";
const UpgradetoPremium$3 = "Nadgradite na Premium";
const Result$3 = "Rezultat";
const Copy$3 = "Kopiraj";
const Save$3 = "Shrani";
const Edit$3 = "Uredi";
const Processing$3 = "Obdelava";
const YourAIgeneratedcontentwillshowhere$3 = "Vaš vsebina, generirana s pomočjo umetne inteligence, se bo prikazala tukaj";
const hopeYouFindUseful$3 = "Upam, da boste našli ta rezultat uporaben!";
const regenerate$3 = "Ponovno ustvari";
const ProvideAdditionalFeedback$3 = "Podajte dodaten povratni odziv";
const Enteranyfeedback$3 = "Vnesite kakršen koli povratni odziv";
const Notimpressive$3 = "Ni prepričljivo";
const thisIsntTrue$3 = "To ni res";
const Notpersonalized$3 = "Ni prilagojeno";
const Tone$3 = "Ton";
const Length$3 = "Dolžina";
const Template$3 = "Predloga";
const Generatedon$3 = "Ustvarjeno dne";
const Copiedtoclipboard$3 = "Kopirano v odložišče";
const CopytoClipboard$3 = "Kopiraj v odložišče";
const DownloadasPDF$3 = "Prenesi kot PDF";
const ViewDetails$3 = "Ogled podrobnosti";
const JobDescriptionImported$3 = "Opis dela uvožen";
const ImportfromJob$3 = "Uvoz iz dela";
const Saved$3 = "Shranjeno";
const Applied$3 = "Uporabljeno";
const Offer$3 = "Ponudba";
const Interviewing$3 = "Intervjuiranje";
const Rejected$3 = "Zavrnjeno";
const Search$3 = "Iskanje";
const Import$3 = "Uvoz";
const CoverLetterGeneratorHistory$3 = "Zgodovina generatorja motivacijskih pisem";
const NoCoverLettersGenerated$3 = "Ni ustvarjenih motivacijskih pisem";
const getStartedCoverLetter$3 = "Še niste ustvarili nobenega motivacijskega pisma. Začnite in ustvarite motivacijska pisma s primerjanjem opisa dela s svojimi relevantnimi izkušnjami.";
const getStarted$3 = "Začnite!";
const Documents$3 = "Dokumenti";
const UploadNewDocument$3 = "Naloži nov dokument";
const AICoverLetterGenerator$3 = "AI generator motivacijskih pisem";
const ViewHistory$3 = "Ogled zgodovine";
const JobDescription$3 = "Opis dela";
const ImportfromBoard$3 = "Uvozi iz table";
const EnterJobDescription$3 = "Vnesi opis dela";
const JobTitle$3 = "Naziv dela";
const EnterJobTitle$3 = "Vnesi naziv dela";
const CompanyName$3 = "Ime podjetja";
const EnterCompanyName$3 = "Vnesi ime podjetja";
const YourProfile$3 = "Vaš profil";
const ResumeUpload$3 = "Naloži življenjepis";
const UseLinkedinProfile$3 = "Uporabi LinkedIn profil";
const Uploadyourresume$3 = "Naložite svoj življenjepis";
const AddyourResume$3 = "Dodajte svoj življenjepis";
const fileNameCannotFormat$3 = "Imena datotek ne smejo vsebovati presledkov ali podčrtajev in naj bodo v formatu .doc, .docx ali .pdf.";
const ChooseorUpload$3 = "Izberite ali naložite";
const SelectTemplate$3 = "Izberi predlogo";
const Preview$3 = "Predogled";
const UseTemplate$3 = "Uporabi predlogo";
const Change$3 = "Spremeni";
const AdvancedSettings$3 = "Napredne nastavitve";
const AdditionalContext$3 = "Dodaten kontekst";
const Professional$3 = "Poklicen";
const Casual$3 = "Sproščen";
const Enthusiastic$3 = "Navdušen";
const Informational$3 = "Informativen";
const Short$3 = "Kratek";
const Medium$3 = "Srednji";
const Long$3 = "Dolg";
const Language$3 = "Jezik";
const iAmOkayBack$3 = "V redu je! Nazaj";
const Generate$3 = "Generiraj";
const CoverLetter$3 = "Spremno pismo";
const SelectLanguage$3 = "Izberi jezik";
const AboutGeneratorHistory$3 = "Zgodovina generatorja o meni";
const NoAboutsGenerated$3 = "Ni ustvarjenih o meni";
const getStartedAbouts$3 = "Še niste ustvarili nobenega osebnega opisa. Začnite in ustvarite osebne opise s primerjanjem opisa dela s svojimi relevantnimi izkušnjami.";
const noAttachmentsFound$3 = "Ni najdenih prilog.";
const TargetJobTitle$3 = "Ciljni naziv dela";
const KeywordsToInclude$3 = "Ključne besede za vključitev";
const UploadYourResume$3 = "Naložite svoj življenjepis";
const AddYourResume$3 = "Dodajte svoj življenjepis.";
const LinkedinProfile$3 = "LinkedIn profil";
const Linkedinprofilenotfound$3 = "LinkedIn profila ni mogoče najti";
const startUsingChromeExtension$3 = "Začnite optimizirati svoj LinkedIn profil z našim dodatkom za Chrome, da uporabite to možnost.";
const Download$3 = "Prenesi";
const UseEmojis$3 = "Uporabi emotikone";
const UseBulletPoints$3 = "Uporabi oznake";
const SpeechFocus$3 = "Orientacija govora";
const FirstPerson$3 = "Prva oseba";
const ThirdPerson$3 = "Tretja oseba";
const HeadlineGeneratorHistory$3 = "Zgodovina generatorja naslovov";
const NoHeadlinesGenerated$3 = "Ni ustvarjenih naslovov";
const getStartedHeadline$3 = "Še niste ustvarili nobenih naslovov. Začnite in ustvarite naslove s primerjanjem opisa dela s svojimi relevantnimi izkušnjami.";
const AIHeadlineGenerator$3 = "AI generator naslovov";
const KeywordstoInclude$3 = "Vključene ključne besede";
const Pressenteraftereachword$3 = "Pritisnite Enter po vsaki besedi.";
const LinkedinProfilenotfound$3 = "Profil LinkedIn ni bil najden.";
const Headline$3 = "Naslov";
const PostGeneratorHistory$3 = "Zgodovina generatorja objav";
const NoPostsGenerated$3 = "Ni ustvarjenih objav";
const getStartedPost$3 = "Še niste ustvarili nobenih objav. Začnite in ustvarite objave s primerjanjem opisa dela s svojimi relevantnimi izkušnjami.";
const Topic$3 = "Tema";
const Description$3 = "Opis";
const UseHashtags$3 = "Uporabi hashtage";
const Custom$3 = "Po meri";
const EnterCustomTone$3 = "Vnesi prilagojen ton";
const Added$3 = "Dodano";
const ComingSoon$3 = {
	header: "Inženirji pri delu!",
	content_1: "Naša ekipa inženirjev trdo dela, da kmalu zagnemo to funkcijo",
	content_2: "Želite to funkcijo kmalu? Sporočite nam s preprostim označevanjem spodnjega polja.",
	content_3: "Želim to funkcijo"
};
const Company$3 = "Podjetje";
const JobInterview$3 = "Pogovor za delo";
const Research$3 = "Raziskava";
const Networking$3 = "Mreženje";
const Referral$3 = "Priporočilo";
const MustbeContacted$3 = "Treba se je obrniti";
const ScheduleaMeeting$3 = "Načrtuj sestanek";
const needAFollowUp$3 = "Potrebno je slediti";
const Today$3 = "Danes";
const Viewdetails$3 = "Ogled podrobnosti";
const Activity$3 = "Dejavnost";
const ActivityDetails$3 = "Podrobnosti dejavnosti";
const Delete$3 = "Izbriši";
const Title$3 = "Naslov";
const Goal$3 = "Cilj";
const Status$3 = "Status";
const FollowUp$3 = "Sledi";
const AddActivity$3 = "Dodaj dejavnost";
const Enteractivitytitle$3 = "Vnesite naslov dejavnosti";
const Cancel$3 = "Prekliči";
const SaveActivity$3 = "Shrani dejavnost";
const noActivityPresent$3 = "Ni dejavnosti prisotne, dodaj dejavnost.";
const Addnew$3 = "Dodaj novo";
const About$3 = "O meni";
const noDataPresentYou$3 = "Ni podatkov, lahko uredite ta stik in dodate polja.";
const Experience$3 = "Izkušnje";
const Education$3 = "Izobrazba";
const Skills$3 = "Spretnosti";
const Overview$3 = "Pregled";
const LinkedJobs$3 = "Povezana dela";
const Notes$3 = "Opombe";
const FullName$3 = "Polno ime";
const Location$3 = "Lokacija";
const Relationship$3 = "Odnos";
const Contacts$3 = "Stiki";
const CreateContact$3 = "Ustvari stik";
const NotesCreated$3 = "Opombe ustvarjene";
const Notesupdated$3 = "Opombe posodobljene";
const Addnote$3 = "Dodaj opombo";
const areYouSureDeleteNote$3 = "Ste prepričani, da želite izbrisati to opombo?";
const Createdby$3 = "Ustvaril";
const notSureWhyResumeCalls$3 = "Niste prepričani, zakaj vaš življenjepis ne prinaša klicev za razgovore? ☎️";
const getExpertResumeReview$3 = "Pridobite strokovno oceno življenjepisa 💎✨";
const youHaventAddedContacts$3 = "Še niste dodali nobenih stikov.";
const noMatchingContacts$3 = "Nobenih ujemajočih se stikov ni bilo najdenih.";
const Link$3 = "Povezava";
const unlink$3 = "Prekini povezavo";
const Locationnotavailable$3 = "Lokacija ni na voljo";
const Emailnotavailable$3 = "E-pošta ni na voljo";
const PhoneNumbernotavailable$3 = "Telefonska številka ni na voljo";
const createdby$3 = "ustvarjeno od";
const areYouSureDeleteContact$3 = "Ste prepričani, da želite izbrisati ta stik?";
const areYouSureUnlinkContact$3 = "Ste prepričani, da želite prekiniti povezavo s tem stikom?";
const Addedbyyou$3 = "Dodano s strani vas";
const Addedby$3 = "Dodano od";
const Timeline$3 = "Časovnica";
const Timelineempty$3 = "Časovnica prazna";
const Discard$3 = "Zavrzi";
const SaveContact$3 = "Shrani stik.";
const Recruiter$3 = "Iskalec kadrov";
const Candidate$3 = "Kandidat";
const Colleague$3 = "Sodelavec";
const Employee$3 = "Zaposleni";
const EnterValidEmail$3 = "Vnesite veljaven e-poštni naslov";
const EnterValidPhoneNumber$3 = "Vnesite veljavno telefonsko številko";
const editingProfileNotAvailable$3 = "Urejanje profilske slike še ni na voljo.";
const itWillBeSoonAvailable$3 = "Kmalu bo na voljo v našem.";
const ChromeExtension$3 = "Razširitev Chrome";
const SelectTag$3 = "Izberi oznako";
const FirstName$3 = "Ime";
const FirstNameisrequired$3 = "Ime je obvezno";
const LastName$3 = "Priimek";
const LastNameisrequired$3 = "Priimek je obvezno";
const Companyisrequired$3 = "Podjetje je obvezno.";
const Email$3 = "E-pošta";
const ThisisnotavalidEmail$3 = "To ni veljaven e-poštni naslov.";
const AddEmail$3 = "Dodaj e-pošto";
const PhoneNumber$3 = "Telefonska številka";
const notaValidPhone$3 = "To ni veljavna telefonska številka. Vnesite samo številke.";
const phoneNoMinimum5char$3 = "Telefonska številka mora biti dolga vsaj 5 znakov.";
const phoneNoMinumum15char$3 = "Telefonska številka mora biti največ 15 znakov dolga.";
const AddPhoneNumber$3 = "Dodaj telefonsko številko";
const SelectGoal$3 = "Izberite cilj";
const SelectStatus$3 = "Izberite status";
const Followup$3 = "Sledenje";
const SocialMedia$3 = "Socialna omrežja";
const Linkedinhandle$3 = "Povezava na Linkedin";
const Twitterhandle$3 = "Twitter ročaj";
const Facebookhandle$3 = "Facebook ročaj";
const Githubhandle$3 = "Github ročaj";
const Gmailhandle$3 = "Gmail ročaj";
const Changessavedsuccessfully$3 = "Spremembe uspešno shranjene";
const EditContact$3 = "Uredi stik";
const BasicInformation$3 = "Osnovne informacije";
const EditContactDetails$3 = "Uredi podrobnosti stika";
const SaveChanges$3 = "Shrani spremembe";
const phoneNoMinimum14char$3 = "Telefonska številka mora biti vsaj 14 znakov dolga.";
const LinkedIn$3 = "LinkedIn";
const Twitter$3 = "Twitter";
const Facebook$3 = "Facebook";
const Github$3 = "Github";
const Gmail$3 = "Gmail";
const youCanWriteAbout$3 = "Lahko pišete o svojih letih izkušenj, industriji ali spretnostih. Ljudje govorijo tudi o svojih dosežkih ali prejšnjih delovnih izkušnjah.";
const Addednewsection$3 = "Dodana nova sekcija";
const Removedsuccessfully$3 = "Uspešno odstranjeno.";
const Remove$3 = "Odstrani";
const Institute$3 = "Institut";
const Schoolisrequired$3 = "Šola je obvezna.";
const Degree$3 = "Stopnja";
const StartMonth$3 = "Začetni mesec";
const StartYear$3 = "Začetno leto";
const EndMonth$3 = "Konec meseca";
const EndYear$3 = "Konec leta";
const Addmore$3 = "Dodaj več";
const PositionTitle$3 = "Naslov položaja";
const ExperienceType$3 = "Vrsta izkušnje";
const Addednewitem$3 = "Dodan nov element";
const whatSkillsDoYouEnjoy$3 = "Kakšne spretnosti imate ali uživate delati z njimi?";
const Typeskillshere$3 = "Vnesite veščine tukaj";
const LinkedContacts$3 = "Povezani stiki";
const LinkContact$3 = "Poveži stik";
const NocontactsLinked$3 = "Ni povezanih stikov";
const JobContactsComponent$3 = {
	linkContact: "Z združevanjem stikov hitro vidite, kdo so pomembne osebe, kot so iskalec kadrov, vodja zaposlovanja, itd., za to vlogo! V prihodnosti bomo lahko ponudili relevantne informacije na podlagi vaših stikov."
};
const Nocontacts$3 = "Ni stikov";
const LinkJobto$3 = "Poveži delovno mesto z";
const Contact$3 = "Kontakt";
const Document$3 = "Dokument";
const Nojobsfound$3 = "Ni najdenih del";
const LinkJob$3 = "Poveži delo";
const youCanLinkContactJobImported$3 = "Lahko povežete ta stik s službo, ki ste jo uvozili v Careerflow.";
const Prev$3 = "Nazaj";
const Next$3 = "Naslednje";
const areYouSureUnlinkDocument$3 = "Ste prepričani, da želite prekiniti povezavo s tem dokumentom?";
const areYouSureDeleteDocument$3 = "Ste prepričani, da želite izbrisati ta dokument?";
const Category$3 = "Kategorija";
const CreatedOn$3 = "Ustvarjeno dne";
const Joblinked$3 = "Povezano delo";
const Quickactions$3 = "Hitri ukrepi";
const All$3 = "Vse";
const Resume$3 = "Življenjepis";
const Portfolio$3 = "Portfelj";
const Other$3 = "Drugo";
const Adddocument$3 = "Dodaj dokument";
const Type$3 = "Vrsta";
const Sortingby$3 = "Razvrščanje po";
const SwitchtoGridLayout$3 = "Preklopi na mrežni način postavitve";
const SwitchtoListLayout$3 = "Preklopi na seznam postavitve";
const NoDocumentsAdded$3 = "Ni dodanih dokumentov";
const DocumentsComponent$3 = {
	nodocs: "Še niste ustvarili nobenih dokumentov. Lahko naložite različice življenjepisa, spremnih pisem in več ter jih povežete z deli, ki jih spremljate!"
};
const NoDocumentFound$3 = "Nobenega dokumenta ni bilo mogoče najti.";
const SelectFile$3 = "Izberite datoteko";
const onlyPdfDocxSupported$3 = "Podprti sta le .pdf in .docx format.";
const Uploadfile$3 = "Naloži datoteko";
const DocumentCategory$3 = "Kategorija dokumenta";
const SaveDocument$3 = "Shrani dokument";
const AddDocument$3 = "Dodaj dokument";
const LinkedDocuments$3 = "Povezani dokumenti";
const LinkDocument$3 = "Poveži dokument";
const NodocumentsLinked$3 = "Ni povezanih dokumentov";
const JobDocumentsComponent$3 = {
	linkDocs: "Povezovanje vseh relevantnih dokumentov, kot so življenjepis, spremno pismo, itd., ki ste jih predložili za to delo, vam bo pomagalo, da ohranite pregled vsega na enem mestu. Poskusite!"
};
const NoDocuments$3 = "Brez dokumentov";
const CreateDocuments$3 = "Ustvari dokumente";
const youCanLinkDocumentJobImported$3 = "Lahko povežete ta dokument s službo, ki ste jo uvozili v Careerflow.";
const Documenteditedsuccessfully$3 = "Dokument je uspešno urejen.";
const DocumentDetails$3 = "Podrobnosti dokumenta";
const UnsavedChanges$3 = "Neshranjene spremembe";
const yourChangesWillBeLostSureClose$3 = "Vaše spremembe bodo izgubljene, ali ste prepričani, da želite zapreti?";
const yourChangesWillBeLostSureDiscard$3 = "Vaše spremembe bodo izgubljene, ali ste prepričani, da želite zavreči svoje spremembe?";
const DiscardChanges$3 = "Zavrzi spremembe";
const WeeklyGoalAlert$3 = "Teden ciljne opombe";
const Progress$3 = "Napredek";
const AllGoals$3 = "Vsi cilji";
const Name$3 = "Ime";
const Completedon$3 = "Dokončano dne";
const Createdon$3 = "Ustvarjeno dne";
const Action$3 = "Akcija";
const Back$3 = "Nazaj";
const OverallScore$3 = "Skupna ocena";
const Aboutthegoal$3 = "O cilju";
const GoalTracking$3 = "Sledenje ciljem";
const Week$3 = "Teden";
const progress$3 = "napredek";
const loading$3 = "Nalaganje";
const Apply$3 = "Uporabi";
const Thisskillhasbeenreported$3 = "Ta spretnost je bila prijavljena.";
const issueGettingResume$3 = "Prišlo je do težave pri pridobivanju življenjepisa.";
const Interview$3 = "Pogovor";
const Tasks$3 = "Naloge";
const Loading$3 = "Nalaganje";
const Skilladdedsuccessfully$3 = "Spretnost uspešno dodana";
const problemAddingSkill$3 = "Prišlo je do težave pri dodajanju spretnosti.";
const Reportaproblem$3 = "Prijavi težavo";
const Submit$3 = "Oddaj";
const Addanewskill$3 = "Dodaj novo spretnost";
const JobDetailsComponent$3 = {
	classifySkill: "Kako bi razvrstili to spretnost? (Neobvezno)",
	includedKeywordsWillCount: "Vključiti to ključno besedo?",
	yesIncludeThisSkill: "Vključene ključne besede bodo vplivale na vašo ujemanje ocene za vse prihodnje skeniranje. Vključene ključne besede lahko spremenite v svojem profilu.",
	addSkill: "Ali želite to dodati kot spretnost?"
};
const HardSkill$3 = "Trda spretnost";
const SoftSkill$3 = "Mehka spretnost";
const Pleaseshareanyadditionalcontext$3 = "Prosimo, delite dodaten kontekst";
const Addasskill$3 = "Dodaj kot spretnost";
const Skill$3 = "Spretnost";
const JobFrequency$3 = "Frekvenca dela";
const ResumeFrequency$3 = "Frekvenca življenjepisa";
const Reportskill$3 = "Prijavi spretnost";
const JobDetails$3 = "Podrobnosti o delovnem mestu";
const ViewJobLink$3 = "Prikaži povezavo do dela";
const Salary$3 = "Plača";
const areYouSureDeleteJob$3 = "Ste prepričani, da želite izbrisati to delo?";
const ViewMore$3 = "Več informacij";
const ViewLess$3 = "Manj informacij";
const matchYouSkillsAgainstJob$3 = "Primerjajte svoje spretnosti s opisom dela.";
const pleaseUploadResumeSkillMatch$3 = "Naložite svoj življenjepis, da dobite rezultat ujemanja vaših spretnosti.";
const AddResume$3 = "Dodaj življenjepis";
const thisJobDoesNotHaveAnyDesc$3 = "Ta delovno mesto nima nobenega opisa.";
const youCanEditJobToAdd$3 = "Lahko uredite to delo in mu dodate opis. Dela lahko uvozite tudi z našim.";
const chromeextension$3 = "razširitev Chrome";
const fromVariousJobPortalsOnce$3 = "iz različnih portalov za zaposlitev. Ko dodate opis, boste lahko videli tudi informacije o spretnostih.";
const AddDescription$3 = "Dodaj opis.";
const CompanyInfo$3 = "Podatki o podjetju";
const Website$3 = "Spletna stran";
const Industry$3 = "Industrija";
const EmployeeCount$3 = "Število zaposlenih";
const ExprienceLevel$3 = "Raven izkušenj";
const Address$3 = "Naslov";
const Resumes$3 = "Življenjepisi";
const Setasdefault$3 = "Nastavi kot privzeto";
const Ok$3 = "V redu";
const UploadNewResume$3 = "Naloži nov življenjepis";
const Default$3 = "Privzeto";
const Jobnotfound$3 = "Delo ni najdeno";
const EditDetails$3 = "Uredi podrobnosti";
const JobPostURL$3 = "URL objave dela";
const Enterjoburl$3 = "Vnesite URL delovnega mesta.";
const Nojobselected$3 = "Nobeno delo ni izbrano";
const Viewjobdetails$3 = "Poglej podrobnosti o delu";
const Jobaddedtoyourboardsuccessfully$3 = "Delovno mesto uspešno dodano na vašo desko.";
const AddJob$3 = "Dodaj delo";
const Addnewjobname$3 = "Dodaj novo ime službe";
const JobUrl$3 = "URL dela";
const Addjoburl$3 = "Dodaj URL dela.";
const Section$3 = "Oddelek";
const didYouKnow$3 = {
	chromeExtension: "Ste vedeli? Dela lahko shranite tudi neposredno iz naše razširitve za Chrome in vse podatke uvozite s samo enim klikom! Traja le nekaj sekund."
};
const Jobs$3 = "Dela";
const AddJobtoboard$3 = "Dodaj delovno mesto na oglasno desko.";
const Currentlynojobsareavailable$3 = "Trenutno ni razpoložljivih delovnih mest.";
const noMatchingJobs$3 = "Nobenih ustreznih delovnih mest ni bilo najdenih.";
const welcomeToYourPersonalJobTracker$3 = "Dobrodošli v vašem osebnem sledilniku zaposlitev!";
const weShortTutorialOnHowTrackingJob$3 = "V nekaj preprostih korakih vam bomo predstavili kratek priročnik, kako začeti spremljati vaše prijave za delo!";
const Addanewjob$3 = "Dodaj nov delovni kraj.";
const inOrderTrackCreatButton$3 = "Da začnete spremljati prijave za delo, jih morate najprej dodati na ploščo s klikom na gumb \"Ustvari\".";
const Providesomedetails$3 = "Navedite nekaj podrobnosti";
const toBeginTypeJobTitleCompany$3 = "Najprej preprosto vnesite naziv delovnega mesta, ime podjetja in status, ki ga želite dodati. Kasneje lahko dodate več podrobnosti, vendar je to vse, kar potrebujete za zdaj!";
const asAnExampleFilledForYou$3 = "Kot primer, smo to že izpolnili za vas!";
const wohooAddedFirstJob$3 = "Woohoo! Dodali ste svoje prvo delo v sledilnik delovnih mest!";
const youCanDragDropJobCard$3 = "Sedaj lahko povlečete in spustite kartico zaposlitve v različne faze postopka prijave na delovno mesto. Klik na kartico zaposlitve vam omogoča ogled več podrobnosti, urejanje, shranjevanje opomb in še več!";
const Lastbutnotleast$3 = "Zadnji, a ne najmanj pomemben";
const finalStepMakeSure$3 = "Kot zadnji korak, poskrbite, da imate naše.";
const autoMaticallyImportJobs$3 = "kar vam bo omogočilo samodejni uvoz delovnih mest iz vaših najljubših spletnih mest za iskanje zaposlitve, kot so LinkedIn, Indeed in še več! Naša razširitev vam tudi pomaga izboljšati vaš LinkedIn profil in doseči 2,5-krat več pojavitev v iskanju!";
const selectanysection$3 = "izberite kateri koli odsek";
const Accept$3 = "Sprejmi";
const My2023JobSearch$3 = "Moje iskanje dela 2023";
const AddedFrom$3 = "Dodano iz";
const AddedUntil$3 = "Dodano do";
const BasicModal$3 = "Osnovni modalni okvir";
const AddnewSectionName$3 = "Dodaj novo ime odseka";
const OpenTo$3 = "Odperto za";
const Featured$3 = "Predstavljeno";
const LicenceAndCerts$3 = "Licence in certifikati";
const Banner$3 = "Plakat";
const LinkedInURL$3 = "LinkedIn URL";
const Recommendations$3 = "Priporočila";
const LinkedinReview$3 = "Pregled na Linkedinu";
const NoDataAvailable$3 = "Podatki niso na voljo";
const looksLikeYouDidNot$3 = "Izgleda, da še niste začeli uporabljati našega";
const toOptimizeProfileScoreVisible$3 = "še niste optimizirali svojega profila na LinkedInu. Ko to storite, bo vaša ocena profila vidna tukaj.";
const LinkedinComponent$3 = {
	letsOptimize: "Optimizirajmo"
};
const improveYourChancesLandingDreamJob$3 = "Izboljšajte svoje možnosti za pridobitev sanjske službe. Uporabite te preizkušene strategije, da boste svojemu profilu na LinkedInu dali potrebno preobrazbo.";
const VisitProfile$3 = "Ogled profila";
const wantToGetLinkedinMakeover$3 = "Želite popolno preobrazbo profila na LinkedInu?";
const PostGenerator$3 = "Generator objav";
const LinkedinHeadlineGenerator$3 = "Generator naslova na LinkedIn-u";
const LinkedinAboutSectionGenerator$3 = "Generator razdelka 'O meni' na LinkedIn-u";
const AITools$3 = "AI Orodja";
const Premium$3 = "Premium";
const LinkedInOptimization$3 = "Optimizacija na LinkedIn-u";
const JobTracker$3 = "Delovni sledilnik";
const whoIsHiring$3 = "Kdo zaposluje";
const Autofill$3 = "Samodejno izpolnjevanje";
const HeadlineGenerator$3 = "Generator naslovov";
const skillMatching$3 = "Ujemanje spretnosti";
const SummarizeJD$3 = "Povzetek opisa delovnega mesta";
const contactFeature$3 = "Sledenje stikom";
const documentFeature$3 = "Dokumenti";
const landJobWithoutStress$3 = "Dosezite svojo sanjsko službo. Brez stresa.";
const discoverFeatures$3 = "Odkrijte nabor funkcij Careerflow.ai, namenjenih poenostavitvi iskanja zaposlitve in izboljšanju vaše poklicne poti!";
const letsBeginOnboarding$3 = "Poznajmo te bolje!";
const inTheNextFewScreensJobThirdParties$3 = "V naslednjih nekaj zaslonih vam bomo zastavili nekaj vprašanj, ki nam bodo pomagala prilagoditi izkušnjo za vas in samodejno izpolniti vaše prijave za delo (da vam ni treba)! Vaših podatkov ne prodajamo tretjim osebam.";
const letsAddBasicInformation$3 = "Dodajmo vaše osnovne informacije.";
const Pleaseselectanoptionfirst$3 = "Prosim, najprej izberite možnost.";
const JobApplicationTracker$3 = "Sledilec prijav za delo";
const LinkedInProfileOptimizer$3 = "Optimizator profila na Linked In-u";
const UnlimitedDocuments$3 = "Neomejeno dokumentov";
const UnlimitedContacts$3 = "Neomejene stike";
const HiringManagerSearch$3 = "Iskanje vodje zaposlovanja";
const AILinkedInPostGenerator$3 = "Generator objav na LinkedInu z umetno inteligenco";
const ATSKeywordSkillMatch$3 = "Ujemanje ključnih besed / spretnosti pri delu ATS";
const ChooseyourPlan$3 = "Izberite svoj načrt";
const superChargeYourJobSearch$3 = "Pospešite svoje iskanje zaposlitve in izboljšajte postopek prijave na delovno mesto, povečajte število razgovorov in si zagotovite svojo sanjsko službo. Vse to s pomočjo premium orodij Careerflow-a.";
const startNowGoto$3 = "Začni zdaj (Pojdi v aplikacijo)";
const CreatedBy$3 = "Ustvaril";
const CreateNewNote$3 = "Ustvari novo opombo";
const Nonotescreated$3 = "Ni ustvarjenih opomb";
const approxTimeIsFourMinutes$3 = "Približen čas za dokončanje procesa uvajanja je 4 minute.";
const Continue$3 = "Naprej";
const iWillDoLaterTakeMeToApp$3 = "To bom naredil pozneje. Pelji me v aplikacijo.";
const allDone$3 = "Vse je narejeno!";
const welcomeAbord$3 = "Dobrodošli na krovu!";
const letsBegin$3 = "Začnimo.";
const UpgradeyourplanandgetAIAssistance$3 = "Nadgradite svoj načrt in pridobite pomoč umetne inteligence.";
const DownloadPDF$3 = "Prenesi PDF";
const oopsWeCouldntProcessResume$3 = "Oprostite, tega življenjepisa ne moremo obdelati.";
const MyProfile$3 = "Moj profil";
const Setting$3 = "Nastavitev";
const Logout$3 = "Odjava";
const SignIn$3 = "Prijava";
const Typeyourfirstnamehere$3 = "Vaše ime";
const Enteryourlastname$3 = "Vaše priimek";
const ManageSubscription$3 = "Upravljanje naročnine";
const ifYouHaveDifficultiesProfile$3 = "Če imate težave s svojimi informacijami profila, se obrnite na\"\"\"";
const forSupport$3 = "za podporo.";
const whatIsIdealCompanySize$3 = "Kakšna je vaša idealna velikost podjetja?";
const Saveandcontinue$3 = "Shrani in nadaljuj";
const whatIsMinExpectedSalary$3 = "Kakšna je vaša minimalna pričakovana plača (na leto)?";
const Atleast$3 = "Vsaj";
const SlidetoAdjust$3 = "Drsnik za prilagajanje";
const whatIndustryExcitedWork$3 = "Katera področja industrije te navdušujejo?";
const Add$3 = "Dodaj";
const statusOfJobSearch$3 = "Kakšen je vaš trenutni status iskanja zaposlitve?";
const Finish$3 = "Končaj";
const whatLevelRoleLooking$3 = "Kakšno raven vloge iščete?";
const Selectuptotwo$3 = "Izberite do dva";
const PreviousStep$3 = "Prejšnji korak";
const Skip$3 = "Preskoči";
const whatDoYouValueNewRole$3 = "Kaj cenite v novi vlogi?";
const Selectuptothree$3 = "Izberite do tri";
const EqualEmploymentData$3 = "Podatki o enakih zaposlitvenih možnostih";
const whatIsYourEthnicity$3 = "Kakšne narodnosti si?";
const areYouAuthorizedToWorkUs$3 = "Ali imate dovoljenje za delo v ZDA?";
const willYouRequireSponsorShip$3 = "Ali boste zdaj ali v prihodnosti potrebovali sponzorstvo za zaposlitev in vizumski status?";
const doYouHaveADisability$3 = "Ali imate invalidnost?";
const areYouAVeteran$3 = "Ste veteran?";
const rolesYouInterestedIn$3 = "V kakšne vloge ste zainteresirani?";
const Selectuptofive$3 = "Izberite do pet";
const AddCustomrole$3 = "Dodajanje prilagojene vloge";
const whereDoYouLikeWork$3 = "Kje bi želeli delati?";
const Resources$3 = "Vir";
const currentlyNoResourceAvailable$3 = "Trenutno ni na voljo nobenih virov.";
const AddNewSection$3 = "Dodaj nov odsek";
const ChangeSections$3 = "Spremeni odseke";
const Settings$3 = "Nastavitve";
const Dashboard$3 = "Nadzorna plošča";
const JobBoard$3 = "Oglasna deska za delo";
const Linkedin$3 = "Linkedin";
const Community$3 = "Skupnost";
const FindRecruiters$3 = "Poišči kadrovnike";
const Goals$3 = "Cilji";
const DownloadExtension$3 = "Prenesi razširitev";
const SuggestaFeature$3 = "Predlagaj funkcijo";
const leftPanel$3 = {
	ReportanIssue: "Prijavi težavo"
};
const PhoneNumberisrequired$3 = "Telefonska številka je obvezna.";
const MobileNumber$3 = "Mobilna številka";
const Enteronlynumbers$3 = "Vnesite samo številke.";
const Countryyoulivein$3 = "Država, v kateri živite";
const SelectaCountry$3 = "Izberite državo";
const DateofBirth$3 = "Datum rojstva";
const Gender$3 = "Spol";
const JobPreferences$3 = "Želje glede zaposlitve";
const pleaseEnterValidEmail$3 = "Prosim, vnesite veljaven e-poštni naslov.";
const emailSendForResetting$3 = "Na vaš e-poštni naslov je bil poslan e-poštni sporočilo za ponastavitev gesla.";
const VerifyyourEmailID$3 = "Preverite svoj e-poštni naslov";
const sentPleaseCheckEmail$3 = "Poslano! Prosimo, preverite svoj e-poštni predal.";
const tooManyAttemptsTryAgain$3 = "Preveč poskusov, poskusite znova čez nekaj časa.";
const Resend$3 = "Ponovno pošlji";
const Login$3 = "Prijava";
const weHaveSentVerificationLinkAtEmail$3 = "Poslali smo vam povezavo za preverjanje na vaš e-poštni naslov.";
const pleaseVerifyEmailContinueSpam$3 = "Prosim, preverite svoj e-poštni naslov, da nadaljujete. Prosimo, preverite tudi mapo za neželeno pošto ali promocije za e-pošto za preverjanje.";
const Logintogetstarted$3 = "Prijavite se, da začnete";
const ContinuewithGoogle$3 = "Nadaljujte z Google";
const pleaseInputEmail$3 = "Prosim, vnesite svoj e-poštni naslov!";
const Password$3 = "Geslo";
const pleaseInputPassword$3 = "Prosim, vnesite svoje geslo!";
const passwordLowerUpperDigitSpecial$3 = "Vaše geslo mora vsebovati vsaj eno malo črko, veliko črko, številko in poseben znak.";
const atLeastSixChar$3 = "Najmanj 6 znakov.";
const forgotPassword$3 = "Pozabljeno geslo?";
const Bysigninginyouagreetoour$3 = "Z vpisom se strinjate z našimi.";
const Terms$3 = "Pogoji";
const Conditions$3 = "Pogoji";
const and$3 = "in";
const PrivacyPolicy$3 = "Politika zasebnosti";
const theseAreTheTopsSkillsExtracted$3 = "To so najpomembnejše spretnosti, izluščene iz opisa delovnega mesta.";
const TopSkills$3 = "Najboljše spretnosti";
const weCoulNotExtractSkills$3 = "Iz te opisov dela nismo mogli izluščiti nobenih spretnosti.";
const upgradeToPremiumToView$3 = "Nadgradite na Premium, da si ogledate ujemanje vaših spretnosti v življenjepisu.";
const SkillScore$3 = "Ocena spretnosti";
const thisIsYourSkillScoreBasedOn$3 = "To je vaša ocena spretnosti na podlagi opisa delovnega mesta in vašega življenjepisa.";
const theseSkllsAreStrongMatch$3 = "Te spretnosti so močno ujemanje med vašim življenjepisom in opisom dela.";
const Strongmatch$3 = "Močno ujemanje";
const theseSkillsArePartialMatch$3 = "Te spretnosti so delno ujemanje med vašim življenjepisom in opisom dela.";
const Partialmatch$3 = "Delno ujemanje";
const theseSkillsAreMissingFrom$3 = "Ti ključni besedi manjkata v tvojem življenjepisu, vendar sta prisotni v opisu delovnega mesta. Lahko gre za spretnosti ali splošne ključne besede, ki so specifične za delovno priložnost in bi jih bilo koristno dodati v tvoj življenjepis.";
const SkillMatchComponent$3 = {
	removeSkill: "Kakšen je vaš glavni razlog za prijavo težave glede ključne besede"
};
const Optional$3 = "Neobvezno";
const Notrelevanttothejob$3 = "Ni relevantno za delo";
const Notaskill$3 = "Ni spretnost";
const Toogeneric$3 = "Preveč splošno";
const Pleaseshareanyfeedback$3 = "Prosimo, delite svoje povratne informacije";
const excludedKeywordsWillNot$3 = "Izključene ključne besede ne bodo vplivale na vaš ujemanje rezultatov pri vseh prihodnjih skeniranjih. Izključene ključne besede lahko spremenite v svojem profilu.";
const yesExcludeThisSkillFrom$3 = "Da, izključite to spretnost iz vseh skeniranj mojega življenjepisa.";
const PartialMatch$3 = "Delno ujemanje";
const MissingKeywords$3 = "Manjkajoče ključne besede";
const Providetitletotask$3 = "Navedite naslov naloge";
const TasksList$3 = "Seznam nalog";
const AddTask$3 = "Dodaj nalogo";
const EnterTaskTitlehere$3 = "Vnesite naslov naloge tukaj";
const TasksComponent$3 = {
	listEmpty: "Seznam nalog je prazen, ustvarite novega."
};
const CompletedTasks$3 = "Dokončane naloge";
const CompleteYourtasks$3 = "Dokončajte svoje naloge";
const Steps$3 = "Koraki";
const PremiumMember$3 = "Premium član";
const Thankyouforupgradingto$3 = "Hvala vam za nadgradnjo na";
const CareerflowPremium$3 = "Karierni tok Premium";
const hereIsHowYouCanAccessPremium$3 = "Tukaj je, kako dostopati do vaših Premium ugodnosti!";
const stepOne$3 = "Korak 1";
const DownloadourChromeExtension$3 = "Prenesite našo razširitev za Chrome";
const youJobSearchCopilotIshere$3 = "Vaš AI sopilot pri iskanju zaposlitve je tukaj.";
const DownloadNow$3 = "Prenesi zdaj";
const stepTwo$3 = "Korak 2";
const GetStarted$3 = "Začnite";
const stepThree$3 = "Korak 3";
const SignintoChromeExtension$3 = "Prijavite se v razširitev Chrome";
const entityCreated$3 = "Novo {{entity}} ustvarjeno";
const entityUpdated$3 = "{{entity}} posodobljeno.";
const entityDeleted$3 = "{{entity}} izbrisano.";
const entityLinked$3 = "{{entity}} povezan/a.";
const entityUnlinked$3 = "{{entity}} odstranjeno povezavo";
const entityMovedTo$3 = "Prestavljeno na {{entity}}.";
const youAddedANewEntity$3 = "Dodali ste novo {{entity}}.";
const personCreated$3 = "{{creator}} je ustvaril {{entity}} za {{owner}}.";
const youUpdatedAEntity$3 = "Posodobili ste {{entity}}.";
const personUpdated$3 = "{{creator}} je posodobil {{entity}} za {{owner}}.";
const youDeletedAEntity$3 = "Izbrisali ste {{entity}}.";
const personDeleted$3 = "{{creator}} je izbrisal {{entity}} za {{owner}}.";
const youLinkedEntity$3 = "Povezali ste {{entity}} s to delovno mesto.";
const personLinked$3 = "{{creator}} je povezal {{entity}} s to nalogo za {{owner}}.";
const youUnlinked$3 = "Odklopili ste {{entity}} od te službe.";
const personUnlinked$3 = "{{creator}} je odstranil povezavo {{entity}} s to nalogo za {{owner}}.";
const youMovedEntity$3 = "Prestavili ste to {{entity}} iz {{sectionFrom}} v {{sectionTo}}.";
const personMoved$3 = "{{creator}} je premaknil to {{entity}} iz {{sectionFrom}} v {{sectionTo}} za {{owner}}.";
const addedByName$3 = "Dodano od {{name}}.";
const DownloadChromeExtension$3 = "Prenesi razširitev Chrome";
const ourChromeExtensionIs$3 = "Naša Chrome razširitev je integrirano orodje, ki vam pomaga optimizirati vaš LinkedIn profil, shranjevati delovna mesta, shranjevati stike, generirati motivacijska pisma in še več.";
const Optimizeyourprofile$3 = "Optimizirajte svoj profil.";
const startOptimizingYourProfile$3 = "Začnite optimizirati svoj profil, da boste imeli večje možnosti, da vas kontaktirajo kadroviki.";
const OptimizeNow$3 = "Optimiziraj zdaj";
const Addyourfirstjob$3 = "Dodajte svoje prvo delo.";
const startSavingJobApplicationsToTrack$3 = "Začnite shranjevati prijave za delo, da boste lahko spremljali svoje iskanje zaposlitve in našli uporabne vpoglede.";
const AddNow$3 = "Dodaj zdaj";
const CompleteProfile$3 = "Popoln profil";
const completeYourProfileForUsing$3 = "Dokončajte svoj profil za uporabo funkcije samodejnega izpolnjevanja in pridobite bolj personalizirano izkušnjo.";
const CompleteNow$3 = "Dokončaj zdaj";
const Addyourfirstcontact$3 = "Dodajte svoj prvi stik.";
const addContactToFollowUpWith$3 = "Dodajte stik za kasnejše spremljanje, dodajte opombe in še več.";
const JoinCommunity$3 = "Pridruži se skupnosti";
const ourCommunityisAlways$3 = "Naša skupnost je vedno z vami na vaši poti iskanja zaposlitve.";
const JoinNow$3 = "Pridruži se zdaj";
const welcomeToCareerflow$3 = "Dobrodošli v Careerflow!";
const yourHubForCareerInsights2$3 = "To je vaš center za vpogled v kariero, dejavnosti in še več. Raziščite svojo personalizirano nadzorno ploščo, da ostanete na vrhu svoje profesionalne poti.";
const ChecklistCompleted$3 = "Vaš seznam je dokončan!";
const Completeyourchecklist$3 = "Dokončajte svoj seznam kontrolnih točk";
const completeAFewStepsTo$3 = "Izpolnite nekaj korakov, da boste dobili svojo naslednjo službo.";
const Completed$3 = "Dokončano";
const JobCountByStage$3 = "Število delovnih mest po stopnji";
const NopastapplicationDatafound$3 = "Nobenih prejšnjih podatkov o prijavi ni bilo najdenih.";
const YourJobSearchStages$3 = "Faze iskanja zaposlitve";
const NoDatafound$3 = "Ni najdenih podatkov";
const sl = {
	copyToClipboard: copyToClipboard$3,
	UnlocktheAIgenerated: UnlocktheAIgenerated$3,
	UpgradetoPremium: UpgradetoPremium$3,
	Result: Result$3,
	Copy: Copy$3,
	Save: Save$3,
	Edit: Edit$3,
	Processing: Processing$3,
	YourAIgeneratedcontentwillshowhere: YourAIgeneratedcontentwillshowhere$3,
	hopeYouFindUseful: hopeYouFindUseful$3,
	regenerate: regenerate$3,
	ProvideAdditionalFeedback: ProvideAdditionalFeedback$3,
	Enteranyfeedback: Enteranyfeedback$3,
	Notimpressive: Notimpressive$3,
	thisIsntTrue: thisIsntTrue$3,
	Notpersonalized: Notpersonalized$3,
	Tone: Tone$3,
	Length: Length$3,
	Template: Template$3,
	Generatedon: Generatedon$3,
	Copiedtoclipboard: Copiedtoclipboard$3,
	CopytoClipboard: CopytoClipboard$3,
	DownloadasPDF: DownloadasPDF$3,
	ViewDetails: ViewDetails$3,
	JobDescriptionImported: JobDescriptionImported$3,
	ImportfromJob: ImportfromJob$3,
	Saved: Saved$3,
	Applied: Applied$3,
	Offer: Offer$3,
	Interviewing: Interviewing$3,
	Rejected: Rejected$3,
	Search: Search$3,
	Import: Import$3,
	CoverLetterGeneratorHistory: CoverLetterGeneratorHistory$3,
	NoCoverLettersGenerated: NoCoverLettersGenerated$3,
	getStartedCoverLetter: getStartedCoverLetter$3,
	getStarted: getStarted$3,
	Documents: Documents$3,
	UploadNewDocument: UploadNewDocument$3,
	AICoverLetterGenerator: AICoverLetterGenerator$3,
	ViewHistory: ViewHistory$3,
	JobDescription: JobDescription$3,
	ImportfromBoard: ImportfromBoard$3,
	EnterJobDescription: EnterJobDescription$3,
	JobTitle: JobTitle$3,
	EnterJobTitle: EnterJobTitle$3,
	CompanyName: CompanyName$3,
	EnterCompanyName: EnterCompanyName$3,
	YourProfile: YourProfile$3,
	ResumeUpload: ResumeUpload$3,
	UseLinkedinProfile: UseLinkedinProfile$3,
	Uploadyourresume: Uploadyourresume$3,
	AddyourResume: AddyourResume$3,
	fileNameCannotFormat: fileNameCannotFormat$3,
	ChooseorUpload: ChooseorUpload$3,
	SelectTemplate: SelectTemplate$3,
	Preview: Preview$3,
	UseTemplate: UseTemplate$3,
	Change: Change$3,
	AdvancedSettings: AdvancedSettings$3,
	AdditionalContext: AdditionalContext$3,
	Professional: Professional$3,
	Casual: Casual$3,
	Enthusiastic: Enthusiastic$3,
	Informational: Informational$3,
	Short: Short$3,
	Medium: Medium$3,
	Long: Long$3,
	Language: Language$3,
	iAmOkayBack: iAmOkayBack$3,
	Generate: Generate$3,
	CoverLetter: CoverLetter$3,
	SelectLanguage: SelectLanguage$3,
	AboutGeneratorHistory: AboutGeneratorHistory$3,
	NoAboutsGenerated: NoAboutsGenerated$3,
	getStartedAbouts: getStartedAbouts$3,
	noAttachmentsFound: noAttachmentsFound$3,
	TargetJobTitle: TargetJobTitle$3,
	KeywordsToInclude: KeywordsToInclude$3,
	UploadYourResume: UploadYourResume$3,
	AddYourResume: AddYourResume$3,
	LinkedinProfile: LinkedinProfile$3,
	Linkedinprofilenotfound: Linkedinprofilenotfound$3,
	startUsingChromeExtension: startUsingChromeExtension$3,
	Download: Download$3,
	UseEmojis: UseEmojis$3,
	UseBulletPoints: UseBulletPoints$3,
	SpeechFocus: SpeechFocus$3,
	FirstPerson: FirstPerson$3,
	ThirdPerson: ThirdPerson$3,
	HeadlineGeneratorHistory: HeadlineGeneratorHistory$3,
	NoHeadlinesGenerated: NoHeadlinesGenerated$3,
	getStartedHeadline: getStartedHeadline$3,
	AIHeadlineGenerator: AIHeadlineGenerator$3,
	KeywordstoInclude: KeywordstoInclude$3,
	Pressenteraftereachword: Pressenteraftereachword$3,
	LinkedinProfilenotfound: LinkedinProfilenotfound$3,
	Headline: Headline$3,
	PostGeneratorHistory: PostGeneratorHistory$3,
	NoPostsGenerated: NoPostsGenerated$3,
	getStartedPost: getStartedPost$3,
	Topic: Topic$3,
	Description: Description$3,
	UseHashtags: UseHashtags$3,
	Custom: Custom$3,
	EnterCustomTone: EnterCustomTone$3,
	Added: Added$3,
	ComingSoon: ComingSoon$3,
	Company: Company$3,
	JobInterview: JobInterview$3,
	Research: Research$3,
	Networking: Networking$3,
	Referral: Referral$3,
	MustbeContacted: MustbeContacted$3,
	ScheduleaMeeting: ScheduleaMeeting$3,
	needAFollowUp: needAFollowUp$3,
	Today: Today$3,
	Viewdetails: Viewdetails$3,
	Activity: Activity$3,
	ActivityDetails: ActivityDetails$3,
	Delete: Delete$3,
	Title: Title$3,
	Goal: Goal$3,
	Status: Status$3,
	FollowUp: FollowUp$3,
	AddActivity: AddActivity$3,
	Enteractivitytitle: Enteractivitytitle$3,
	Cancel: Cancel$3,
	SaveActivity: SaveActivity$3,
	noActivityPresent: noActivityPresent$3,
	Addnew: Addnew$3,
	About: About$3,
	noDataPresentYou: noDataPresentYou$3,
	Experience: Experience$3,
	Education: Education$3,
	Skills: Skills$3,
	Overview: Overview$3,
	LinkedJobs: LinkedJobs$3,
	Notes: Notes$3,
	FullName: FullName$3,
	Location: Location$3,
	Relationship: Relationship$3,
	Contacts: Contacts$3,
	CreateContact: CreateContact$3,
	NotesCreated: NotesCreated$3,
	Notesupdated: Notesupdated$3,
	Addnote: Addnote$3,
	areYouSureDeleteNote: areYouSureDeleteNote$3,
	Createdby: Createdby$3,
	notSureWhyResumeCalls: notSureWhyResumeCalls$3,
	getExpertResumeReview: getExpertResumeReview$3,
	youHaventAddedContacts: youHaventAddedContacts$3,
	noMatchingContacts: noMatchingContacts$3,
	Link: Link$3,
	unlink: unlink$3,
	Locationnotavailable: Locationnotavailable$3,
	Emailnotavailable: Emailnotavailable$3,
	PhoneNumbernotavailable: PhoneNumbernotavailable$3,
	createdby: createdby$3,
	areYouSureDeleteContact: areYouSureDeleteContact$3,
	areYouSureUnlinkContact: areYouSureUnlinkContact$3,
	Addedbyyou: Addedbyyou$3,
	Addedby: Addedby$3,
	Timeline: Timeline$3,
	Timelineempty: Timelineempty$3,
	Discard: Discard$3,
	SaveContact: SaveContact$3,
	Recruiter: Recruiter$3,
	Candidate: Candidate$3,
	Colleague: Colleague$3,
	Employee: Employee$3,
	"Needtofollow-up": "Potreba po sledenju",
	EnterValidEmail: EnterValidEmail$3,
	EnterValidPhoneNumber: EnterValidPhoneNumber$3,
	editingProfileNotAvailable: editingProfileNotAvailable$3,
	itWillBeSoonAvailable: itWillBeSoonAvailable$3,
	ChromeExtension: ChromeExtension$3,
	SelectTag: SelectTag$3,
	FirstName: FirstName$3,
	FirstNameisrequired: FirstNameisrequired$3,
	LastName: LastName$3,
	LastNameisrequired: LastNameisrequired$3,
	Companyisrequired: Companyisrequired$3,
	Email: Email$3,
	ThisisnotavalidEmail: ThisisnotavalidEmail$3,
	AddEmail: AddEmail$3,
	PhoneNumber: PhoneNumber$3,
	notaValidPhone: notaValidPhone$3,
	phoneNoMinimum5char: phoneNoMinimum5char$3,
	phoneNoMinumum15char: phoneNoMinumum15char$3,
	AddPhoneNumber: AddPhoneNumber$3,
	SelectGoal: SelectGoal$3,
	SelectStatus: SelectStatus$3,
	Followup: Followup$3,
	SocialMedia: SocialMedia$3,
	Linkedinhandle: Linkedinhandle$3,
	Twitterhandle: Twitterhandle$3,
	Facebookhandle: Facebookhandle$3,
	Githubhandle: Githubhandle$3,
	Gmailhandle: Gmailhandle$3,
	Changessavedsuccessfully: Changessavedsuccessfully$3,
	EditContact: EditContact$3,
	BasicInformation: BasicInformation$3,
	EditContactDetails: EditContactDetails$3,
	SaveChanges: SaveChanges$3,
	phoneNoMinimum14char: phoneNoMinimum14char$3,
	LinkedIn: LinkedIn$3,
	Twitter: Twitter$3,
	Facebook: Facebook$3,
	Github: Github$3,
	Gmail: Gmail$3,
	youCanWriteAbout: youCanWriteAbout$3,
	Addednewsection: Addednewsection$3,
	Removedsuccessfully: Removedsuccessfully$3,
	Remove: Remove$3,
	Institute: Institute$3,
	Schoolisrequired: Schoolisrequired$3,
	Degree: Degree$3,
	StartMonth: StartMonth$3,
	StartYear: StartYear$3,
	EndMonth: EndMonth$3,
	EndYear: EndYear$3,
	Addmore: Addmore$3,
	PositionTitle: PositionTitle$3,
	ExperienceType: ExperienceType$3,
	Addednewitem: Addednewitem$3,
	whatSkillsDoYouEnjoy: whatSkillsDoYouEnjoy$3,
	Typeskillshere: Typeskillshere$3,
	LinkedContacts: LinkedContacts$3,
	LinkContact: LinkContact$3,
	NocontactsLinked: NocontactsLinked$3,
	JobContactsComponent: JobContactsComponent$3,
	Nocontacts: Nocontacts$3,
	LinkJobto: LinkJobto$3,
	Contact: Contact$3,
	Document: Document$3,
	Nojobsfound: Nojobsfound$3,
	LinkJob: LinkJob$3,
	youCanLinkContactJobImported: youCanLinkContactJobImported$3,
	Prev: Prev$3,
	Next: Next$3,
	areYouSureUnlinkDocument: areYouSureUnlinkDocument$3,
	areYouSureDeleteDocument: areYouSureDeleteDocument$3,
	Category: Category$3,
	CreatedOn: CreatedOn$3,
	Joblinked: Joblinked$3,
	Quickactions: Quickactions$3,
	All: All$3,
	Resume: Resume$3,
	Portfolio: Portfolio$3,
	Other: Other$3,
	Adddocument: Adddocument$3,
	Type: Type$3,
	Sortingby: Sortingby$3,
	SwitchtoGridLayout: SwitchtoGridLayout$3,
	SwitchtoListLayout: SwitchtoListLayout$3,
	NoDocumentsAdded: NoDocumentsAdded$3,
	DocumentsComponent: DocumentsComponent$3,
	NoDocumentFound: NoDocumentFound$3,
	SelectFile: SelectFile$3,
	onlyPdfDocxSupported: onlyPdfDocxSupported$3,
	Uploadfile: Uploadfile$3,
	DocumentCategory: DocumentCategory$3,
	SaveDocument: SaveDocument$3,
	AddDocument: AddDocument$3,
	LinkedDocuments: LinkedDocuments$3,
	LinkDocument: LinkDocument$3,
	NodocumentsLinked: NodocumentsLinked$3,
	JobDocumentsComponent: JobDocumentsComponent$3,
	NoDocuments: NoDocuments$3,
	CreateDocuments: CreateDocuments$3,
	youCanLinkDocumentJobImported: youCanLinkDocumentJobImported$3,
	Documenteditedsuccessfully: Documenteditedsuccessfully$3,
	DocumentDetails: DocumentDetails$3,
	UnsavedChanges: UnsavedChanges$3,
	yourChangesWillBeLostSureClose: yourChangesWillBeLostSureClose$3,
	yourChangesWillBeLostSureDiscard: yourChangesWillBeLostSureDiscard$3,
	DiscardChanges: DiscardChanges$3,
	WeeklyGoalAlert: WeeklyGoalAlert$3,
	Progress: Progress$3,
	AllGoals: AllGoals$3,
	Name: Name$3,
	Completedon: Completedon$3,
	Createdon: Createdon$3,
	Action: Action$3,
	Back: Back$3,
	OverallScore: OverallScore$3,
	Aboutthegoal: Aboutthegoal$3,
	GoalTracking: GoalTracking$3,
	Week: Week$3,
	progress: progress$3,
	loading: loading$3,
	Apply: Apply$3,
	Thisskillhasbeenreported: Thisskillhasbeenreported$3,
	issueGettingResume: issueGettingResume$3,
	Interview: Interview$3,
	Tasks: Tasks$3,
	Loading: Loading$3,
	Skilladdedsuccessfully: Skilladdedsuccessfully$3,
	problemAddingSkill: problemAddingSkill$3,
	Reportaproblem: Reportaproblem$3,
	Submit: Submit$3,
	Addanewskill: Addanewskill$3,
	JobDetailsComponent: JobDetailsComponent$3,
	HardSkill: HardSkill$3,
	SoftSkill: SoftSkill$3,
	Pleaseshareanyadditionalcontext: Pleaseshareanyadditionalcontext$3,
	Addasskill: Addasskill$3,
	Skill: Skill$3,
	JobFrequency: JobFrequency$3,
	ResumeFrequency: ResumeFrequency$3,
	Reportskill: Reportskill$3,
	JobDetails: JobDetails$3,
	ViewJobLink: ViewJobLink$3,
	Salary: Salary$3,
	areYouSureDeleteJob: areYouSureDeleteJob$3,
	ViewMore: ViewMore$3,
	ViewLess: ViewLess$3,
	matchYouSkillsAgainstJob: matchYouSkillsAgainstJob$3,
	pleaseUploadResumeSkillMatch: pleaseUploadResumeSkillMatch$3,
	AddResume: AddResume$3,
	thisJobDoesNotHaveAnyDesc: thisJobDoesNotHaveAnyDesc$3,
	youCanEditJobToAdd: youCanEditJobToAdd$3,
	chromeextension: chromeextension$3,
	fromVariousJobPortalsOnce: fromVariousJobPortalsOnce$3,
	AddDescription: AddDescription$3,
	CompanyInfo: CompanyInfo$3,
	Website: Website$3,
	Industry: Industry$3,
	EmployeeCount: EmployeeCount$3,
	ExprienceLevel: ExprienceLevel$3,
	Address: Address$3,
	Resumes: Resumes$3,
	Setasdefault: Setasdefault$3,
	Ok: Ok$3,
	UploadNewResume: UploadNewResume$3,
	Default: Default$3,
	Jobnotfound: Jobnotfound$3,
	EditDetails: EditDetails$3,
	JobPostURL: JobPostURL$3,
	Enterjoburl: Enterjoburl$3,
	Nojobselected: Nojobselected$3,
	Viewjobdetails: Viewjobdetails$3,
	Jobaddedtoyourboardsuccessfully: Jobaddedtoyourboardsuccessfully$3,
	AddJob: AddJob$3,
	Addnewjobname: Addnewjobname$3,
	JobUrl: JobUrl$3,
	Addjoburl: Addjoburl$3,
	Section: Section$3,
	didYouKnow: didYouKnow$3,
	Jobs: Jobs$3,
	AddJobtoboard: AddJobtoboard$3,
	Currentlynojobsareavailable: Currentlynojobsareavailable$3,
	noMatchingJobs: noMatchingJobs$3,
	welcomeToYourPersonalJobTracker: welcomeToYourPersonalJobTracker$3,
	weShortTutorialOnHowTrackingJob: weShortTutorialOnHowTrackingJob$3,
	Addanewjob: Addanewjob$3,
	inOrderTrackCreatButton: inOrderTrackCreatButton$3,
	Providesomedetails: Providesomedetails$3,
	toBeginTypeJobTitleCompany: toBeginTypeJobTitleCompany$3,
	asAnExampleFilledForYou: asAnExampleFilledForYou$3,
	wohooAddedFirstJob: wohooAddedFirstJob$3,
	youCanDragDropJobCard: youCanDragDropJobCard$3,
	Lastbutnotleast: Lastbutnotleast$3,
	finalStepMakeSure: finalStepMakeSure$3,
	autoMaticallyImportJobs: autoMaticallyImportJobs$3,
	selectanysection: selectanysection$3,
	Accept: Accept$3,
	My2023JobSearch: My2023JobSearch$3,
	AddedFrom: AddedFrom$3,
	AddedUntil: AddedUntil$3,
	BasicModal: BasicModal$3,
	AddnewSectionName: AddnewSectionName$3,
	OpenTo: OpenTo$3,
	Featured: Featured$3,
	LicenceAndCerts: LicenceAndCerts$3,
	Banner: Banner$3,
	LinkedInURL: LinkedInURL$3,
	Recommendations: Recommendations$3,
	LinkedinReview: LinkedinReview$3,
	NoDataAvailable: NoDataAvailable$3,
	looksLikeYouDidNot: looksLikeYouDidNot$3,
	toOptimizeProfileScoreVisible: toOptimizeProfileScoreVisible$3,
	LinkedinComponent: LinkedinComponent$3,
	improveYourChancesLandingDreamJob: improveYourChancesLandingDreamJob$3,
	VisitProfile: VisitProfile$3,
	wantToGetLinkedinMakeover: wantToGetLinkedinMakeover$3,
	PostGenerator: PostGenerator$3,
	LinkedinHeadlineGenerator: LinkedinHeadlineGenerator$3,
	LinkedinAboutSectionGenerator: LinkedinAboutSectionGenerator$3,
	AITools: AITools$3,
	Premium: Premium$3,
	LinkedInOptimization: LinkedInOptimization$3,
	JobTracker: JobTracker$3,
	whoIsHiring: whoIsHiring$3,
	Autofill: Autofill$3,
	HeadlineGenerator: HeadlineGenerator$3,
	skillMatching: skillMatching$3,
	SummarizeJD: SummarizeJD$3,
	contactFeature: contactFeature$3,
	documentFeature: documentFeature$3,
	landJobWithoutStress: landJobWithoutStress$3,
	discoverFeatures: discoverFeatures$3,
	letsBeginOnboarding: letsBeginOnboarding$3,
	inTheNextFewScreensJobThirdParties: inTheNextFewScreensJobThirdParties$3,
	letsAddBasicInformation: letsAddBasicInformation$3,
	Pleaseselectanoptionfirst: Pleaseselectanoptionfirst$3,
	JobApplicationTracker: JobApplicationTracker$3,
	LinkedInProfileOptimizer: LinkedInProfileOptimizer$3,
	UnlimitedDocuments: UnlimitedDocuments$3,
	UnlimitedContacts: UnlimitedContacts$3,
	HiringManagerSearch: HiringManagerSearch$3,
	AILinkedInPostGenerator: AILinkedInPostGenerator$3,
	ATSKeywordSkillMatch: ATSKeywordSkillMatch$3,
	"Auto-Apply": "Samodejna uporaba",
	ChooseyourPlan: ChooseyourPlan$3,
	superChargeYourJobSearch: superChargeYourJobSearch$3,
	startNowGoto: startNowGoto$3,
	CreatedBy: CreatedBy$3,
	CreateNewNote: CreateNewNote$3,
	Nonotescreated: Nonotescreated$3,
	approxTimeIsFourMinutes: approxTimeIsFourMinutes$3,
	Continue: Continue$3,
	iWillDoLaterTakeMeToApp: iWillDoLaterTakeMeToApp$3,
	allDone: allDone$3,
	welcomeAbord: welcomeAbord$3,
	letsBegin: letsBegin$3,
	UpgradeyourplanandgetAIAssistance: UpgradeyourplanandgetAIAssistance$3,
	DownloadPDF: DownloadPDF$3,
	oopsWeCouldntProcessResume: oopsWeCouldntProcessResume$3,
	MyProfile: MyProfile$3,
	Setting: Setting$3,
	Logout: Logout$3,
	SignIn: SignIn$3,
	Typeyourfirstnamehere: Typeyourfirstnamehere$3,
	Enteryourlastname: Enteryourlastname$3,
	ManageSubscription: ManageSubscription$3,
	ifYouHaveDifficultiesProfile: ifYouHaveDifficultiesProfile$3,
	forSupport: forSupport$3,
	whatIsIdealCompanySize: whatIsIdealCompanySize$3,
	Saveandcontinue: Saveandcontinue$3,
	whatIsMinExpectedSalary: whatIsMinExpectedSalary$3,
	Atleast: Atleast$3,
	SlidetoAdjust: SlidetoAdjust$3,
	whatIndustryExcitedWork: whatIndustryExcitedWork$3,
	Add: Add$3,
	statusOfJobSearch: statusOfJobSearch$3,
	Finish: Finish$3,
	whatLevelRoleLooking: whatLevelRoleLooking$3,
	Selectuptotwo: Selectuptotwo$3,
	PreviousStep: PreviousStep$3,
	Skip: Skip$3,
	whatDoYouValueNewRole: whatDoYouValueNewRole$3,
	Selectuptothree: Selectuptothree$3,
	EqualEmploymentData: EqualEmploymentData$3,
	whatIsYourEthnicity: whatIsYourEthnicity$3,
	areYouAuthorizedToWorkUs: areYouAuthorizedToWorkUs$3,
	willYouRequireSponsorShip: willYouRequireSponsorShip$3,
	doYouHaveADisability: doYouHaveADisability$3,
	areYouAVeteran: areYouAVeteran$3,
	rolesYouInterestedIn: rolesYouInterestedIn$3,
	Selectuptofive: Selectuptofive$3,
	AddCustomrole: AddCustomrole$3,
	whereDoYouLikeWork: whereDoYouLikeWork$3,
	Resources: Resources$3,
	currentlyNoResourceAvailable: currentlyNoResourceAvailable$3,
	AddNewSection: AddNewSection$3,
	ChangeSections: ChangeSections$3,
	Settings: Settings$3,
	Dashboard: Dashboard$3,
	JobBoard: JobBoard$3,
	Linkedin: Linkedin$3,
	Community: Community$3,
	FindRecruiters: FindRecruiters$3,
	Goals: Goals$3,
	DownloadExtension: DownloadExtension$3,
	SuggestaFeature: SuggestaFeature$3,
	leftPanel: leftPanel$3,
	PhoneNumberisrequired: PhoneNumberisrequired$3,
	MobileNumber: MobileNumber$3,
	Enteronlynumbers: Enteronlynumbers$3,
	Countryyoulivein: Countryyoulivein$3,
	SelectaCountry: SelectaCountry$3,
	DateofBirth: DateofBirth$3,
	Gender: Gender$3,
	JobPreferences: JobPreferences$3,
	pleaseEnterValidEmail: pleaseEnterValidEmail$3,
	emailSendForResetting: emailSendForResetting$3,
	VerifyyourEmailID: VerifyyourEmailID$3,
	sentPleaseCheckEmail: sentPleaseCheckEmail$3,
	tooManyAttemptsTryAgain: tooManyAttemptsTryAgain$3,
	Resend: Resend$3,
	Login: Login$3,
	weHaveSentVerificationLinkAtEmail: weHaveSentVerificationLinkAtEmail$3,
	pleaseVerifyEmailContinueSpam: pleaseVerifyEmailContinueSpam$3,
	Logintogetstarted: Logintogetstarted$3,
	ContinuewithGoogle: ContinuewithGoogle$3,
	pleaseInputEmail: pleaseInputEmail$3,
	Password: Password$3,
	pleaseInputPassword: pleaseInputPassword$3,
	passwordLowerUpperDigitSpecial: passwordLowerUpperDigitSpecial$3,
	atLeastSixChar: atLeastSixChar$3,
	forgotPassword: forgotPassword$3,
	Bysigninginyouagreetoour: Bysigninginyouagreetoour$3,
	Terms: Terms$3,
	Conditions: Conditions$3,
	and: and$3,
	PrivacyPolicy: PrivacyPolicy$3,
	theseAreTheTopsSkillsExtracted: theseAreTheTopsSkillsExtracted$3,
	TopSkills: TopSkills$3,
	weCoulNotExtractSkills: weCoulNotExtractSkills$3,
	upgradeToPremiumToView: upgradeToPremiumToView$3,
	SkillScore: SkillScore$3,
	thisIsYourSkillScoreBasedOn: thisIsYourSkillScoreBasedOn$3,
	theseSkllsAreStrongMatch: theseSkllsAreStrongMatch$3,
	Strongmatch: Strongmatch$3,
	theseSkillsArePartialMatch: theseSkillsArePartialMatch$3,
	Partialmatch: Partialmatch$3,
	theseSkillsAreMissingFrom: theseSkillsAreMissingFrom$3,
	"Missing Keywords": "Manjkajoče ključne besede",
	SkillMatchComponent: SkillMatchComponent$3,
	Optional: Optional$3,
	Notrelevanttothejob: Notrelevanttothejob$3,
	Notaskill: Notaskill$3,
	Toogeneric: Toogeneric$3,
	Pleaseshareanyfeedback: Pleaseshareanyfeedback$3,
	excludedKeywordsWillNot: excludedKeywordsWillNot$3,
	yesExcludeThisSkillFrom: yesExcludeThisSkillFrom$3,
	PartialMatch: PartialMatch$3,
	MissingKeywords: MissingKeywords$3,
	Providetitletotask: Providetitletotask$3,
	TasksList: TasksList$3,
	AddTask: AddTask$3,
	EnterTaskTitlehere: EnterTaskTitlehere$3,
	TasksComponent: TasksComponent$3,
	CompletedTasks: CompletedTasks$3,
	CompleteYourtasks: CompleteYourtasks$3,
	Steps: Steps$3,
	PremiumMember: PremiumMember$3,
	Thankyouforupgradingto: Thankyouforupgradingto$3,
	CareerflowPremium: CareerflowPremium$3,
	hereIsHowYouCanAccessPremium: hereIsHowYouCanAccessPremium$3,
	stepOne: stepOne$3,
	DownloadourChromeExtension: DownloadourChromeExtension$3,
	youJobSearchCopilotIshere: youJobSearchCopilotIshere$3,
	DownloadNow: DownloadNow$3,
	stepTwo: stepTwo$3,
	GetStarted: GetStarted$3,
	stepThree: stepThree$3,
	SignintoChromeExtension: SignintoChromeExtension$3,
	entityCreated: entityCreated$3,
	entityUpdated: entityUpdated$3,
	entityDeleted: entityDeleted$3,
	entityLinked: entityLinked$3,
	entityUnlinked: entityUnlinked$3,
	entityMovedTo: entityMovedTo$3,
	youAddedANewEntity: youAddedANewEntity$3,
	personCreated: personCreated$3,
	youUpdatedAEntity: youUpdatedAEntity$3,
	personUpdated: personUpdated$3,
	youDeletedAEntity: youDeletedAEntity$3,
	personDeleted: personDeleted$3,
	youLinkedEntity: youLinkedEntity$3,
	personLinked: personLinked$3,
	youUnlinked: youUnlinked$3,
	personUnlinked: personUnlinked$3,
	youMovedEntity: youMovedEntity$3,
	personMoved: personMoved$3,
	addedByName: addedByName$3,
	DownloadChromeExtension: DownloadChromeExtension$3,
	ourChromeExtensionIs: ourChromeExtensionIs$3,
	Optimizeyourprofile: Optimizeyourprofile$3,
	startOptimizingYourProfile: startOptimizingYourProfile$3,
	OptimizeNow: OptimizeNow$3,
	Addyourfirstjob: Addyourfirstjob$3,
	startSavingJobApplicationsToTrack: startSavingJobApplicationsToTrack$3,
	AddNow: AddNow$3,
	CompleteProfile: CompleteProfile$3,
	completeYourProfileForUsing: completeYourProfileForUsing$3,
	CompleteNow: CompleteNow$3,
	Addyourfirstcontact: Addyourfirstcontact$3,
	addContactToFollowUpWith: addContactToFollowUpWith$3,
	JoinCommunity: JoinCommunity$3,
	ourCommunityisAlways: ourCommunityisAlways$3,
	JoinNow: JoinNow$3,
	welcomeToCareerflow: welcomeToCareerflow$3,
	yourHubForCareerInsights2: yourHubForCareerInsights2$3,
	ChecklistCompleted: ChecklistCompleted$3,
	Completeyourchecklist: Completeyourchecklist$3,
	completeAFewStepsTo: completeAFewStepsTo$3,
	Completed: Completed$3,
	JobCountByStage: JobCountByStage$3,
	NopastapplicationDatafound: NopastapplicationDatafound$3,
	YourJobSearchStages: YourJobSearchStages$3,
	NoDatafound: NoDatafound$3
};

const copyToClipboard$2 = "Копирано у клипборд!";
const UnlocktheAIgenerated$2 = "Откључајте генерисану вештачку интелигенцију.";
const UpgradetoPremium$2 = "Надоградите на Премиум";
const Result$2 = "Резултат";
const Copy$2 = "Копирај";
const Save$2 = "Сачувај";
const Edit$2 = "Измени";
const Processing$2 = "Обрада";
const YourAIgeneratedcontentwillshowhere$2 = "Ваш садржај генерисан од стране ИИ-а ће се приказати овде";
const hopeYouFindUseful$2 = "Надам се да ћете наћи овај резултат корисним!";
const regenerate$2 = "Поново генериши";
const ProvideAdditionalFeedback$2 = "Пружи додатни фидбек";
const Enteranyfeedback$2 = "Унеси било какав фидбек";
const Notimpressive$2 = "Није утисакљиво";
const thisIsntTrue$2 = "Ово није тачно";
const Notpersonalized$2 = "Није персонализовано";
const Tone$2 = "Тон";
const Length$2 = "Дужина";
const Template$2 = "Шаблон";
const Generatedon$2 = "Генерисано на";
const Copiedtoclipboard$2 = "Копирано у клипборд";
const CopytoClipboard$2 = "Копирај у клипборд";
const DownloadasPDF$2 = "Преузми као PDF";
const ViewDetails$2 = "Погледај детаље";
const JobDescriptionImported$2 = "Опис посла увезен";
const ImportfromJob$2 = "Увоз из Радног места";
const Saved$2 = "Сачувано";
const Applied$2 = "Пријављено";
const Offer$2 = "Понуда";
const Interviewing$2 = "Интервјуисање";
const Rejected$2 = "Одбијено";
const Search$2 = "Претрага";
const Import$2 = "Увоз";
const CoverLetterGeneratorHistory$2 = "Историја генератора пријавница";
const NoCoverLettersGenerated$2 = "Нема генерисаних пријавница";
const getStartedCoverLetter$2 = "Још увек нисте генерисали ниједну пријаву. Почните и генеришите пријаве усагласивањем описа послова са вашим релевантним искуством.";
const getStarted$2 = "Почните!";
const Documents$2 = "Документи";
const UploadNewDocument$2 = "Отпреми нови документ";
const AICoverLetterGenerator$2 = "ИИ генератор пријавница";
const ViewHistory$2 = "Погледај историју";
const JobDescription$2 = "Опис послова";
const ImportfromBoard$2 = "Увези са табле";
const EnterJobDescription$2 = "Унесите опис послова";
const JobTitle$2 = "Назив послова";
const EnterJobTitle$2 = "Унесите назив послова";
const CompanyName$2 = "Назив компаније";
const EnterCompanyName$2 = "Унесите назив компаније";
const YourProfile$2 = "Ваш профил";
const ResumeUpload$2 = "Отпреми резиме";
const UseLinkedinProfile$2 = "Користите Линкедин профил";
const Uploadyourresume$2 = "Отпремите своје резиме";
const AddyourResume$2 = "Додајте своје резиме";
const fileNameCannotFormat$2 = "Имена датотека не могу садржавати размаке или доцрти и треба да буду у облику .doc, .docx или .pdf.";
const ChooseorUpload$2 = "Изаберите или отпремите";
const SelectTemplate$2 = "Изаберите шаблон";
const Preview$2 = "Преглед";
const UseTemplate$2 = "Користи шаблон";
const Change$2 = "Промени";
const AdvancedSettings$2 = "Напредна подешавања";
const AdditionalContext$2 = "Додатни контекст";
const Professional$2 = "Професионално";
const Casual$2 = "Неслужбено";
const Enthusiastic$2 = "Ентузијастично";
const Informational$2 = "Информативно";
const Short$2 = "Кратко";
const Medium$2 = "Средње";
const Long$2 = "Дуго";
const Language$2 = "Језик";
const iAmOkayBack$2 = "У реду је! Иди назад";
const Generate$2 = "Генериши";
const CoverLetter$2 = "Приговор";
const SelectLanguage$2 = "Изаберите језик";
const AboutGeneratorHistory$2 = "О историји генератора";
const NoAboutsGenerated$2 = "Нема генерисаних описа";
const getStartedAbouts$2 = "Још увек нисте генерисали ниједан опис. Почните и генеришите описе усагласивањем описа послова са вашим релевантним искуством.";
const noAttachmentsFound$2 = "Није пронађен ниједан прилог.";
const TargetJobTitle$2 = "Циљни назив послова";
const KeywordsToInclude$2 = "Кључне речи за укључивање";
const UploadYourResume$2 = "Поставите свој резиме";
const AddYourResume$2 = "Додајте свој резиме";
const LinkedinProfile$2 = "Линкедин профил";
const Linkedinprofilenotfound$2 = "Линкедин профил није пронађен";
const startUsingChromeExtension$2 = "Почните оптимизацију свог Линкедин профила користећи наш Хром додатак да бисте користили ову опцију.";
const Download$2 = "Преузми";
const UseEmojis$2 = "Користите емоџије";
const UseBulletPoints$2 = "Користите бројеве";
const SpeechFocus$2 = "Фокус на говору";
const FirstPerson$2 = "Прва особа";
const ThirdPerson$2 = "Трећа особа";
const HeadlineGeneratorHistory$2 = "Историја генератора наслова";
const NoHeadlinesGenerated$2 = "Нема генерисаних наслова";
const getStartedHeadline$2 = "Још увек нисте генерисали ниједан наслов. Почните и генеришите наслове усагласивањем описа послова са вашим релевантним искуством.";
const AIHeadlineGenerator$2 = "ИИ генератор наслова";
const KeywordstoInclude$2 = "Кључне речи за укључивање";
const Pressenteraftereachword$2 = "Притисните ентер после сваке речи.";
const LinkedinProfilenotfound$2 = "Профил на ЛинкедИну није пронађен";
const Headline$2 = "Наслов";
const PostGeneratorHistory$2 = "Историја генератора постова";
const NoPostsGenerated$2 = "Нема генерисаних постова";
const getStartedPost$2 = "Још увек нисте генерисали ниједан пост. Почните и генеришите постове усагласивањем описа послова са вашим релевантним искуством.";
const Topic$2 = "Тема";
const Description$2 = "Опис";
const UseHashtags$2 = "Користите хештагове";
const Custom$2 = "Прилагођено";
const EnterCustomTone$2 = "Унесите прилагођени тон";
const Added$2 = "Додато";
const ComingSoon$2 = {
	header: "Инжењери на делу!",
	content_1: "Наш тим инжењера мукотрпно ради на томе да ова функција ускоро заработи",
	content_2: "Желите ову функцију ускоро? Обавестите нас тако што ћете једноставно означити кутију испод.",
	content_3: "Желим ову функцију"
};
const Company$2 = "Компанија";
const JobInterview$2 = "Разговор за послова";
const Research$2 = "Истраживање";
const Networking$2 = "Мрежа";
const Referral$2 = "Препорука";
const MustbeContacted$2 = "Мора се контактирати";
const ScheduleaMeeting$2 = "Закажите састанак";
const needAFollowUp$2 = "Потребно је да пратимо";
const Today$2 = "Данас";
const Viewdetails$2 = "Погледај детаље";
const Activity$2 = "Активност";
const ActivityDetails$2 = "Детаљи активности";
const Delete$2 = "Обриши";
const Title$2 = "Наслов";
const Goal$2 = "Циљ";
const Status$2 = "Статус";
const FollowUp$2 = "Праћење";
const AddActivity$2 = "Додај активност";
const Enteractivitytitle$2 = "Унесите наслов активности";
const Cancel$2 = "Откажи";
const SaveActivity$2 = "Сачувај активност";
const noActivityPresent$2 = "Нема активности, додај активност.";
const Addnew$2 = "Додај ново";
const About$2 = "О нама";
const noDataPresentYou$2 = "Нема доступних података, можете уредити овај контакт и додати поља.";
const Experience$2 = "Искуство";
const Education$2 = "Образовање";
const Skills$2 = "Вештине";
const Overview$2 = "Преглед";
const LinkedJobs$2 = "Повезани послови";
const Notes$2 = "Белешке";
const FullName$2 = "Пуно име";
const Location$2 = "Локација";
const Relationship$2 = "Однос";
const Contacts$2 = "Контакти";
const CreateContact$2 = "Креирај контакт";
const NotesCreated$2 = "Белешке креиране";
const Notesupdated$2 = "Белешке ажуриране";
const Addnote$2 = "Додај белешку";
const areYouSureDeleteNote$2 = "Да ли сте сигурни да желите да избришете ову белешку?";
const Createdby$2 = "Креирано од";
const notSureWhyResumeCalls$2 = "Нисам сигуран зашто вам резиме не доноси позиве за интервјуе? ☎️";
const getExpertResumeReview$2 = "Добијте професионалну рецензију резимеа 💎✨";
const youHaventAddedContacts$2 = "Још увек нисте додали никакве контакте.";
const noMatchingContacts$2 = "Није пронађен ниједан одговарајући контакт.";
const Link$2 = "Веза";
const unlink$2 = "Одвежи везу";
const Locationnotavailable$2 = "Локација није доступна";
const Emailnotavailable$2 = "Е-пошта није доступна";
const PhoneNumbernotavailable$2 = "Број телефона није доступан";
const createdby$2 = "направљено од";
const areYouSureDeleteContact$2 = "Желите ли заиста избрисати овај Контакт?";
const areYouSureUnlinkContact$2 = "Желите ли заиста раздвојити овај Контакт?";
const Addedbyyou$2 = "Додато од стране вас";
const Addedby$2 = "Додато од";
const Timeline$2 = "Временска линија";
const Timelineempty$2 = "Временска линија је празна";
const Discard$2 = "Откажи";
const SaveContact$2 = "Сачувај контакт";
const Recruiter$2 = "Рекрутер";
const Candidate$2 = "Кандидат";
const Colleague$2 = "Колега";
const Employee$2 = "Запослени";
const EnterValidEmail$2 = "Унесите исправну е-пошту";
const EnterValidPhoneNumber$2 = "Унесите исправан број телефона";
const editingProfileNotAvailable$2 = "Уређивање профилне фотографије још увек није доступно.";
const itWillBeSoonAvailable$2 = "Uskoro će biti dostupno kod nas";
const ChromeExtension$2 = "Chrome додатак";
const SelectTag$2 = "Изабери ознаку";
const FirstName$2 = "Име";
const FirstNameisrequired$2 = "Име је обавезно";
const LastName$2 = "Презиме";
const LastNameisrequired$2 = "Презиме је обавезно";
const Companyisrequired$2 = "Компанија је потребна";
const Email$2 = "Е-пошта";
const ThisisnotavalidEmail$2 = "Ово није важећа е-пошта.";
const AddEmail$2 = "Додај е-пошту";
const PhoneNumber$2 = "Број телефона";
const notaValidPhone$2 = "Ово није важећи број телефона. Унесите само.";
const phoneNoMinimum5char$2 = "Број телефона мора бити најмање 5 карактера.";
const phoneNoMinumum15char$2 = "Број телефона мора бити највише 15 карактера.";
const AddPhoneNumber$2 = "Додај број телефона";
const SelectGoal$2 = "Изаберите циљ";
const SelectStatus$2 = "Изабери Статус";
const Followup$2 = "Праћење";
const SocialMedia$2 = "Друштвене мреже";
const Linkedinhandle$2 = "Линкедин ручка";
const Twitterhandle$2 = "Твитер корисничко име";
const Facebookhandle$2 = "Фејсбук корисничко име";
const Githubhandle$2 = "Гитхаб корисничко име";
const Gmailhandle$2 = "Гмејл корисничко име";
const Changessavedsuccessfully$2 = "Промене успешно сачуване";
const EditContact$2 = "Измени контакт";
const BasicInformation$2 = "Основне информације";
const EditContactDetails$2 = "Уреди детаље контакта";
const SaveChanges$2 = "Сачувај промене";
const phoneNoMinimum14char$2 = "Број телефона мора бити најмање 14 карактера.";
const LinkedIn$2 = "ЛинкедИн";
const Twitter$2 = "Твитер";
const Facebook$2 = "Фејсбук";
const Github$2 = "Гитхаб";
const Gmail$2 = "Џимејл";
const youCanWriteAbout$2 = "Можете писати о својим годинама искуства, индустрији или вештинама. Људи такође говоре о својим достигнућима или претходним радним искуствима.";
const Addednewsection$2 = "Додата је нова секција";
const Removedsuccessfully$2 = "Успешно уклоњено";
const Remove$2 = "Уклони";
const Institute$2 = "Институт";
const Schoolisrequired$2 = "Школа је обавезна";
const Degree$2 = "Степен";
const StartMonth$2 = "Почетни месец";
const StartYear$2 = "Почетна година";
const EndMonth$2 = "Крај месеца";
const EndYear$2 = "Крај године";
const Addmore$2 = "Додај још";
const PositionTitle$2 = "Назив позиције";
const ExperienceType$2 = "Врста искуства";
const Addednewitem$2 = "Додат нови предмет";
const whatSkillsDoYouEnjoy$2 = "Које вештине имате или уживате да радите с њима?";
const Typeskillshere$2 = "Унесите вештине овде";
const LinkedContacts$2 = "Повезани контакти";
const LinkContact$2 = "Повежи контакт";
const NocontactsLinked$2 = "Нема повезаних контаката";
const JobContactsComponent$2 = {
	linkContact: "Повезивањем контаката брзо можете видети ко су важни људи као рекрутер, менаџер за запошљавање итд. за ову улогу! У будућности ћемо бити у могућности да представимо релевантне увиде на основу ваших контаката."
};
const Nocontacts$2 = "Нема контаката";
const LinkJobto$2 = "Poveži posao sa";
const Contact$2 = "Контакт";
const Document$2 = "Документ";
const Nojobsfound$2 = "Нема пронађених послова";
const LinkJob$2 = "Повежи пословање";
const youCanLinkContactJobImported$2 = "Можете повезати овај контакт са послом који сте увезли у Каријерфлоу.";
const Prev$2 = "Претходно";
const Next$2 = "Следеће";
const areYouSureUnlinkDocument$2 = "Желите ли заиста раздвојити овај документ?";
const areYouSureDeleteDocument$2 = "Желите ли заиста избрисати овај Документ?";
const Category$2 = "Категорија";
const CreatedOn$2 = "Креирано на";
const Joblinked$2 = "Повезаност рада";
const Quickactions$2 = "Брзе акције";
const All$2 = "Све";
const Resume$2 = "Резиме";
const Portfolio$2 = "Портфолио";
const Other$2 = "Остало";
const Adddocument$2 = "Додај документ";
const Type$2 = "Тип";
const Sortingby$2 = "Сортирање по";
const SwitchtoGridLayout$2 = "Пређи на мрежни распоред";
const SwitchtoListLayout$2 = "Пребаци се на листу";
const NoDocumentsAdded$2 = "Нема додатих докумената";
const DocumentsComponent$2 = {
	nodocs: "Још увек нисте креирали ниједан документ. Можете отпремити верзије свог резимеа, приговора и више, и повезати их с пословима које следите!"
};
const NoDocumentFound$2 = "Није пронађен документ";
const SelectFile$2 = "Изаберите датотеку";
const onlyPdfDocxSupported$2 = "Подржани су само .pdf и .docx формати";
const Uploadfile$2 = "Отпреми датотеку";
const DocumentCategory$2 = "Категорија документа";
const SaveDocument$2 = "Сачувај документ";
const AddDocument$2 = "Додај документ";
const LinkedDocuments$2 = "Повезани документи";
const LinkDocument$2 = "Повежи документ";
const NodocumentsLinked$2 = "Нема повезаних докумената";
const JobDocumentsComponent$2 = {
	linkDocs: "Повезивање свих релевантних докумената као што су резиме, приговор итд. које сте предали за овај послов помоћи ће вам да пратите све на једном месту. Испробајте!"
};
const NoDocuments$2 = "Без докумената";
const CreateDocuments$2 = "Креирај документе";
const youCanLinkDocumentJobImported$2 = "Можете повезати овај документ са послом који сте увезли у Каријерфлоу.";
const Documenteditedsuccessfully$2 = "Документ успешно уређен";
const DocumentDetails$2 = "Детаљи документа";
const UnsavedChanges$2 = "Несачуване измене";
const yourChangesWillBeLostSureClose$2 = "Ваше измене ће бити изгубљене, да ли сте сигурни да желите да затворите?";
const yourChangesWillBeLostSureDiscard$2 = "Ваше измене ће бити изгубљене, да ли сте сигурни да желите да их откажете?";
const DiscardChanges$2 = "Откажи измене";
const WeeklyGoalAlert$2 = "Недељно обавештење о циљу";
const Progress$2 = "Напредак";
const AllGoals$2 = "Сви циљеви";
const Name$2 = "Име";
const Completedon$2 = "Завршено на";
const Createdon$2 = "Креирано на";
const Action$2 = "Акција";
const Back$2 = "Назад";
const OverallScore$2 = "Укупан резултат";
const Aboutthegoal$2 = "О циљу";
const GoalTracking$2 = "Праћење циља";
const Week$2 = "Недеља";
const progress$2 = "напредак";
const loading$2 = "Учитавање";
const Apply$2 = "Применити";
const Thisskillhasbeenreported$2 = "Ова вештина је пријављена.";
const issueGettingResume$2 = "Постојао је проблем са добијањем резимеа.";
const Interview$2 = "Интервју";
const Tasks$2 = "Задаци";
const Loading$2 = "Учитавање";
const Skilladdedsuccessfully$2 = "Вештина је успешно додата";
const problemAddingSkill$2 = "Постојао је проблем при додавању вештине.";
const Reportaproblem$2 = "Пријави проблем";
const Submit$2 = "Поднеси";
const Addanewskill$2 = "Додај нову вештину";
const JobDetailsComponent$2 = {
	classifySkill: "Како бисте класификовали ову вештину (опционо)?",
	includedKeywordsWillCount: "Укључити овај кључни збор?",
	yesIncludeThisSkill: "Укључени кључни зборови ће се рачунати против вашег резултата у свим будућим скенирањима. Можете променити укључене кључне речи из свог профила.",
	addSkill: "Да ли желите да додате ово као вештину?"
};
const HardSkill$2 = "Тврда вештина";
const SoftSkill$2 = "Мека вештина";
const Pleaseshareanyadditionalcontext$2 = "Молим вас поделите било који додатни контекст";
const Addasskill$2 = "Додај као вештину";
const Skill$2 = "Вештина";
const JobFrequency$2 = "Честота посла";
const ResumeFrequency$2 = "Честота резимеа";
const Reportskill$2 = "Пријави вештину";
const JobDetails$2 = "Детаљи о послу";
const ViewJobLink$2 = "Погледајте везу за послове";
const Salary$2 = "Плата";
const areYouSureDeleteJob$2 = "Да ли сте сигурни да желите да обришете овај посао?";
const ViewMore$2 = "Погледај више";
const ViewLess$2 = "Погледај мање";
const matchYouSkillsAgainstJob$2 = "Упоредите своје вештине са описом посла.";
const pleaseUploadResumeSkillMatch$2 = "Молим вас да отпремите своју биографију да бисте добили резултат о подударности вештина.";
const AddResume$2 = "Додај резиме";
const thisJobDoesNotHaveAnyDesc$2 = "Овај посао нема никакви опис.";
const youCanEditJobToAdd$2 = "Можете уредити овај посао да бисте додали опис. Такође можете увезти послове користећи нашу.";
const chromeextension$2 = "Chrome proširenje";
const fromVariousJobPortalsOnce$2 = "од различитих портала за запошљавање. Када додате опис, такође ћете видети информације о вештинама.";
const AddDescription$2 = "Додај опис";
const CompanyInfo$2 = "Информације о компанији";
const Website$2 = "Веб сајт";
const Industry$2 = "Индустрија";
const EmployeeCount$2 = "Број запослених";
const ExprienceLevel$2 = "Ниво искуства";
const Address$2 = "Адреса";
const Resumes$2 = "Резиме";
const Setasdefault$2 = "Постави као подразумевано";
const Ok$2 = "У реду";
const UploadNewResume$2 = "Отпреми нови резиме";
const Default$2 = "Подразумевано";
const Jobnotfound$2 = "Посао није пронађен";
const EditDetails$2 = "Измени детаље";
const JobPostURL$2 = "URL после за пословање";
const Enterjoburl$2 = "Унесите URL адресу посла";
const Nojobselected$2 = "Ниједан посао није изабран";
const Viewjobdetails$2 = "Погледај детаље о послу";
const Jobaddedtoyourboardsuccessfully$2 = "Посао успешно додат на вашу таблу";
const AddJob$2 = "Додај послу";
const Addnewjobname$2 = "Додај ново име за посао";
const JobUrl$2 = "URL после";
const Addjoburl$2 = "Додај URL посла";
const Section$2 = "Секција";
const didYouKnow$2 = {
	chromeExtension: "Да ли знате? Можете такође сачувати послове директно из нашег Чроме екстензије и импортовати све податке у једном клику! Треба само неколико секунди."
};
const Jobs$2 = "Послови";
const AddJobtoboard$2 = "Додајте посао на таблу.";
const Currentlynojobsareavailable$2 = "Тренутно нема доступних послова.";
const noMatchingJobs$2 = "Није пронађен ниједан одговарајући посао.";
const welcomeToYourPersonalJobTracker$2 = "Добродошли у ваш лични пратилац посла!";
const weShortTutorialOnHowTrackingJob$2 = "Пратићемо вас кроз кратки туторијал о томе како почети праћење вашег примењивања за послове у неколико једноставних корака!";
const Addanewjob$2 = "Додај нови посао";
const inOrderTrackCreatButton$2 = "Да бисте почели да пратите пријаве за послове, прво морате да их додате на таблу кликом на дугме „Креирај“.";
const Providesomedetails$2 = "Обезбедите неке детаље";
const toBeginTypeJobTitleCompany$2 = "Прво, само унесите наслов радног места, име компаније и статус који желите да додате. Касније можете додати више детаља, али за сада је ово све што вам је потребно!";
const asAnExampleFilledForYou$2 = "Као пример, већ смо то попунили за вас!";
const wohooAddedFirstJob$2 = "Ура! Додали сте свој први посао у свој трекер посла!";
const youCanDragDropJobCard$2 = "Сада можете превући и отпустити картицу за послове у различите фазе процеса пријаве за послов. Кликом на картицу за послове можете да видите више детаља, уредите их, сачувате белешке и још много тога!";
const Lastbutnotleast$2 = "Најзад";
const finalStepMakeSure$2 = "Као последњи корак, проверите да ли имате наше.";
const autoMaticallyImportJobs$2 = "što će vam omogućiti automatski uvoz poslova sa vaših omiljenih web stranica za pretragu poslova poput LinkedIn-a, Indeed-a i još mnogo toga! Naša ekstenzija takođe vam pomaže da poboljšate svoj LinkedIn profil i dobijete 2,5 puta više pojavljivanja u pretrazi!";
const selectanysection$2 = "изаберите било коју секцију";
const Accept$2 = "Прихвати";
const My2023JobSearch$2 = "Моја трагања за послом у 2023. години";
const AddedFrom$2 = "Додато из";
const AddedUntil$2 = "Додато до";
const BasicModal$2 = "Основни модал";
const AddnewSectionName$2 = "Додај ново име секције";
const OpenTo$2 = "Отворено за";
const Featured$2 = "Истакнуто";
const LicenceAndCerts$2 = "Лиценце и сертификати";
const Banner$2 = "Банер";
const LinkedInURL$2 = "ЛинкедИн URL";
const Recommendations$2 = "Препоруке";
const LinkedinReview$2 = "Преглед на Линкедину";
const NoDataAvailable$2 = "Нема доступних података";
const looksLikeYouDidNot$2 = "Изгледа да нисте почели да користите нашу.";
const toOptimizeProfileScoreVisible$2 = "још увек нисте оптимизовали свој профил на Линкедину. Када то урадите, ваш резултат профила ће бити видљив овде.";
const LinkedinComponent$2 = {
	letsOptimize: "Оптимизујмо"
};
const improveYourChancesLandingDreamJob$2 = "Побољшајте своје шансе да добијете свој сански посао. Користите ове испробане стратегије да бисте дали свом ЛинкедИн профилу неопходан мејковер.";
const VisitProfile$2 = "Посети профил";
const wantToGetLinkedinMakeover$2 = "Желите да добијете потпуну промену профила на ЛинкедИну?";
const PostGenerator$2 = "Генератор објава";
const LinkedinHeadlineGenerator$2 = "Генератор наслова на ЛинкедИну";
const LinkedinAboutSectionGenerator$2 = "Генератор О делу на ЛинкедИну";
const AITools$2 = "AI Алати";
const Premium$2 = "Премијум";
const LinkedInOptimization$2 = "Оптимизација ЛинкедИн профила";
const JobTracker$2 = "Пратилац послова";
const whoIsHiring$2 = "Ко запошљава";
const Autofill$2 = "Аутоматско попуњавање";
const HeadlineGenerator$2 = "Генератор наслова";
const skillMatching$2 = "Прилагађање вештина";
const SummarizeJD$2 = "Резиме описа посла";
const contactFeature$2 = "Пратење контаката";
const documentFeature$2 = "Документи";
const landJobWithoutStress$2 = "Остварите своју сновну посао. Без стреса.";
const discoverFeatures$2 = "Откријте низ функција Careerflow.ai дизајнираних да убрзају вашу потрагу за послом и унапреде ваш професионални пут!";
const letsBeginOnboarding$2 = "Да се боље упознамо!";
const inTheNextFewScreensJobThirdParties$2 = "У следећим екранима, поставићемо вам нека питања која ће нам помоћи да прилагодимо искуство за вас, као и да аутоматски попунимо ваше пријаве за посао (да не бисте морали ви)! Не продажемо ваше податке трећим странама.";
const letsAddBasicInformation$2 = "Додајмо твоје основне информације.";
const Pleaseselectanoptionfirst$2 = "Молимо вас да прво изаберете опцију.";
const JobApplicationTracker$2 = "Пратилац захтева за послом";
const LinkedInProfileOptimizer$2 = "Оптимизатор профила на ЛинкедИну";
const UnlimitedDocuments$2 = "Неограничени документи";
const UnlimitedContacts$2 = "Неограничени контакти.";
const HiringManagerSearch$2 = "Претрага за менаџером за запошљавање";
const AILinkedInPostGenerator$2 = "Генератор објава на ЛинкедИну помоћу ИИ";
const ATSKeywordSkillMatch$2 = "ATS Кључна реч / Вештина Поклапање Посла";
const ChooseyourPlan$2 = "Изаберите свој план";
const superChargeYourJobSearch$2 = "Убрзајте своју потрагу за послом и побољшајте процес пријављивања за послове, повећајте број интервјуа и добијте свој сански послов. Све то са помоћу премијум алатки Careerflow-а.";
const startNowGoto$2 = "Почни сада (Иди на апликацију)";
const CreatedBy$2 = "Креирао";
const CreateNewNote$2 = "Креирај нову белешку";
const Nonotescreated$2 = "Нема креираних белешки";
const approxTimeIsFourMinutes$2 = "Приближно време за завршетак процеса увоза је 4 минута.";
const Continue$2 = "Настави";
const iWillDoLaterTakeMeToApp$2 = "Касније ћу то урадити. Одведи ме на апликацију.";
const allDone$2 = "Све је готово!";
const welcomeAbord$2 = "Добродошли на борд!";
const letsBegin$2 = "Почнимо.";
const UpgradeyourplanandgetAIAssistance$2 = "Надоградите свој план и добијте помоћ ИИ.";
const DownloadPDF$2 = "Преузми PDF";
const oopsWeCouldntProcessResume$2 = "Упс, нисмо могли да обрадимо овај резиме.";
const MyProfile$2 = "Мој профил";
const Setting$2 = "Подешавање";
const Logout$2 = "Одјави се";
const SignIn$2 = "Пријавите се";
const Typeyourfirstnamehere$2 = "Твоје име";
const Enteryourlastname$2 = "Ваше презиме";
const ManageSubscription$2 = "Управљање претплатом";
const ifYouHaveDifficultiesProfile$2 = "Ако имате било каквих трудности с информацијама на вашем профилу, молимо вас да се обратите.";
const forSupport$2 = "за подршку.";
const whatIsIdealCompanySize$2 = "Која је ваша идеална величина компаније?";
const Saveandcontinue$2 = "Сачувај и настави";
const whatIsMinExpectedSalary$2 = "Која је ваша минимална очекивана плата (годишње)?";
const Atleast$2 = "Бар";
const SlidetoAdjust$2 = "Повуци за прилагођавање";
const whatIndustryExcitedWork$2 = "Које индустрије вас узбуђују?";
const Add$2 = "Додај";
const statusOfJobSearch$2 = "Статус ваше потраге за послом?";
const Finish$2 = "Заврши";
const whatLevelRoleLooking$2 = "Који ниво улоге тражите?";
const Selectuptotwo$2 = "Изаберите до два.";
const PreviousStep$2 = "Претходни корак";
const Skip$2 = "Прескочи";
const whatDoYouValueNewRole$2 = "Шта цениш у новој улози?";
const Selectuptothree$2 = "Изаберите до три.";
const EqualEmploymentData$2 = "Подаци о равноправности запослења";
const whatIsYourEthnicity$2 = "Које си етничко порекло?";
const areYouAuthorizedToWorkUs$2 = "Да ли имате овлашћење да радите у САД?";
const willYouRequireSponsorShip$2 = "Да ли ћете сада или у будућности захтевати спонзорство за статус радне визе?";
const doYouHaveADisability$2 = "Имате ли инвалидитет?";
const areYouAVeteran$2 = "Да ли сте ветеран?";
const rolesYouInterestedIn$2 = "У које улоге сте заинтересовани?";
const Selectuptofive$2 = "Изаберите до пет.";
const AddCustomrole$2 = "Додај прилагођену улогу";
const whereDoYouLikeWork$2 = "Где бисте желели да радите?";
const Resources$2 = "Ресурси";
const currentlyNoResourceAvailable$2 = "Тренутно нема доступних ресурса.";
const AddNewSection$2 = "Додај нову секцију";
const ChangeSections$2 = "Промени одељке";
const Settings$2 = "Поставке";
const Dashboard$2 = "Контролна табла";
const JobBoard$2 = "Огласна табла за пословање";
const Linkedin$2 = "Линкедин";
const Community$2 = "Заједница";
const FindRecruiters$2 = "Пронађи рекрутере";
const Goals$2 = "Циљеви";
const DownloadExtension$2 = "Преузми екстензију";
const SuggestaFeature$2 = "Предложи функцију";
const leftPanel$2 = {
	ReportanIssue: "Пријави проблем"
};
const PhoneNumberisrequired$2 = "Број телефона је обавезан";
const MobileNumber$2 = "Мобилни број";
const Enteronlynumbers$2 = "Унесите само бројеве";
const Countryyoulivein$2 = "Земља у којој живите";
const SelectaCountry$2 = "Изаберите земљу";
const DateofBirth$2 = "Датум рођења";
const Gender$2 = "Пол";
const JobPreferences$2 = "Предлози за посао";
const pleaseEnterValidEmail$2 = "Молимо унесите важећу е-пошту.";
const emailSendForResetting$2 = "Пошта је послата за ресетовање лозинке.";
const VerifyyourEmailID$2 = "Потврдите своју и-мејл адресу";
const sentPleaseCheckEmail$2 = "Послато! Молим проверите своју е-пошту.";
const tooManyAttemptsTryAgain$2 = "Превише покушаја, молимо покушајте поново касније.";
const Resend$2 = "Поново пошаљи";
const Login$2 = "Пријава";
const weHaveSentVerificationLinkAtEmail$2 = "Послали смо вам верификациони линк на вашу е-пошту.";
const pleaseVerifyEmailContinueSpam$2 = "Молимо вас да потврдите своју е-пошту да бисте наставили. Такође проверите спам или промоције за е-пошту за верификацију.";
const Logintogetstarted$2 = "Улогујте се да бисте почели.";
const ContinuewithGoogle$2 = "Настави са Гуглом";
const pleaseInputEmail$2 = "Молимо унесите своју е-пошту!";
const Password$2 = "Шифра";
const pleaseInputPassword$2 = "Унесите своју лозинку!";
const passwordLowerUpperDigitSpecial$2 = "Ваша шифра мора да садржи бар једно мало слово, велико слово, цифру и специјални знак.";
const atLeastSixChar$2 = "Најмање 6 карактера";
const forgotPassword$2 = "Заборавили сте лозинку?";
const Bysigninginyouagreetoour$2 = "Пријављивањем се слажете се са нашим.";
const Terms$2 = "Услови";
const Conditions$2 = "Услови";
const and$2 = "и";
const PrivacyPolicy$2 = "Политика приватности";
const theseAreTheTopsSkillsExtracted$2 = "Ово су најважније вештине издвојене из описа послова";
const TopSkills$2 = "Најбоље вештине";
const weCoulNotExtractSkills$2 = "Нисмо могли извући никакве вештине из овог описа послова.";
const upgradeToPremiumToView$2 = "Надоградите на Премиум да бисте видели колико се ваши вештине у резимеу поклапају.";
const SkillScore$2 = "Оцена вештина";
const thisIsYourSkillScoreBasedOn$2 = "Ово је ваш резултат вештина на основу описа послова и вашег резимеа.";
const theseSkllsAreStrongMatch$2 = "Ове вештине су јако поклапање између вашег резимеа и описа посла.";
const Strongmatch$2 = "Јако подударање";
const theseSkillsArePartialMatch$2 = "Ове вештине су делимично поклапање између вашег резимеа и описа посла.";
const Partialmatch$2 = "Делимично поклапање";
const theseSkillsAreMissingFrom$2 = "Ове кључне речи недостају у вашем резимеу, али су присутне у опису послова. Могу бити вештине или опште кључне речи које су специфичне за пословну прилику и могу бити корисне за додавање у ваш резиме.";
const SkillMatchComponent$2 = {
	removeSkill: "Који је ваш главни разлог за пријављивање проблема за кључну реч"
};
const Optional$2 = "Опционо";
const Notrelevanttothejob$2 = "Није важно за пословање";
const Notaskill$2 = "Нема вештине";
const Toogeneric$2 = "Превише опште";
const Pleaseshareanyfeedback$2 = "Молим вас поделите сваки повратни информације";
const excludedKeywordsWillNot$2 = "Искључени кључни зборови неће утицати на вашу подударност за све будуће скенирање. Можете променити искључене кључне зборове из свог профила.";
const yesExcludeThisSkillFrom$2 = "Да, искључите ову вештину из свих скенирања мог резимеа.";
const PartialMatch$2 = "Делимично подударање";
const MissingKeywords$2 = "Недостајући кључни појмови";
const Providetitletotask$2 = "Дајте наслов задатку";
const TasksList$2 = "Листа задатака";
const AddTask$2 = "Додај задатак";
const EnterTaskTitlehere$2 = "Унесите наслов задатка овде";
const TasksComponent$2 = {
	listEmpty: "Листа задатака је празна, креирајте нову."
};
const CompletedTasks$2 = "Завршени задаци";
const CompleteYourtasks$2 = "Заврши своје задатке";
const Steps$2 = "Кораци";
const PremiumMember$2 = "Премиум члан";
const Thankyouforupgradingto$2 = "Хвала вам што сте надоградили на";
const CareerflowPremium$2 = "Каријерни ток Премиум";
const hereIsHowYouCanAccessPremium$2 = "Ево како да приступите својим Премиум предностима!";
const stepOne$2 = "Корак 1";
const DownloadourChromeExtension$2 = "Преузмите нашу Хром екстензију.";
const youJobSearchCopilotIshere$2 = "Ваш AI копилот за претрагу посла је овде.";
const DownloadNow$2 = "Преузми сада";
const stepTwo$2 = "Корак 2";
const GetStarted$2 = "Почни";
const stepThree$2 = "Корак 3";
const SignintoChromeExtension$2 = "Пријавите се у Хром додатак";
const entityCreated$2 = "Нови {{entity}} креиран.";
const entityUpdated$2 = "{{entity}} је ажурирано.";
const entityDeleted$2 = "{{entity}} је обрисано.";
const entityLinked$2 = "{{entity}} повезано";
const entityUnlinked$2 = "{{entity}} неповезано";
const entityMovedTo$2 = "Прешао на {{entity}}";
const youAddedANewEntity$2 = "Додали сте нови {{entity}}.";
const personCreated$2 = "{{creator}} је направио/ла {{entity}} за {{owner}}.";
const youUpdatedAEntity$2 = "Ажурирали сте {{entity}}";
const personUpdated$2 = "{{creator}} је ажурирао {{entity}} за {{owner}}.";
const youDeletedAEntity$2 = "Избрисали сте {{entity}}.";
const personDeleted$2 = "{{creator}} је обрисао {{entity}} за {{owner}}.";
const youLinkedEntity$2 = "Повезали сте {{entity}} са овим послом.";
const personLinked$2 = "{{creator}} је повезао {{entity}} са овим послом за {{owner}}.";
const youUnlinked$2 = "Одвезали сте {{entity}} од овог пословања";
const personUnlinked$2 = "{{creator}} је уклонио везу {{entity}} са овим послом за {{owner}}.";
const youMovedEntity$2 = "Преместили сте ово {{entity}} из {{sectionFrom}} у {{sectionTo}}.";
const personMoved$2 = "{{creator}} је преместио/ла ово {{entity}} из {{sectionFrom}} у {{sectionTo}} за {{owner}}.";
const addedByName$2 = "Додато од стране {{име}}.";
const DownloadChromeExtension$2 = "Преузми Хром додатак";
const ourChromeExtensionIs$2 = "Наша Хром екстензија је интегрисани алат за помоћ у оптимизацији ЛинкедИн профила, чувању послова, чувању контаката, генерисању прилога за пријаву и још много тога.";
const Optimizeyourprofile$2 = "Оптимизујте свој профил";
const startOptimizingYourProfile$2 = "Почните оптимизацију свог профила да бисте имали боље шансе да вас контактирају рекрутери.";
const OptimizeNow$2 = "Оптимизуј сада";
const Addyourfirstjob$2 = "Додајте свој први посао";
const startSavingJobApplicationsToTrack$2 = "Почните да чувате пријаве за послове да бисте пратили своју потрагу за послом и пронашли корисне увиде.";
const AddNow$2 = "Додај сада";
const CompleteProfile$2 = "Потпуни профил";
const completeYourProfileForUsing$2 = "Завршите свој профил да бисте користили функцију аутоматског попуњавања и добили персонализовано искуство.";
const CompleteNow$2 = "Заврши сада";
const Addyourfirstcontact$2 = "Додајте свој први контакт";
const addContactToFollowUpWith$2 = "Додајте контакт за следеће праћење, додајте белешке и још много тога.";
const JoinCommunity$2 = "Придружите се заједници";
const ourCommunityisAlways$2 = "Наша заједница је увек ту с тобом у твом путу тражења посла.";
const JoinNow$2 = "Придружите се сада";
const welcomeToCareerflow$2 = "Добродошли на Каријерфлоу!";
const yourHubForCareerInsights2$2 = "Ово је ваш центар за каријерне увиде, активности и више. Истражите свој персонализовани контролну таблу да бисте останали на врху свог професионалног пута.";
const ChecklistCompleted$2 = "Ваша листа је завршена!";
const Completeyourchecklist$2 = "Заврши своју листу провера";
const completeAFewStepsTo$2 = "Извршите неколико корака да бисте добили следећи посао.";
const Completed$2 = "Завршено";
const JobCountByStage$2 = "Број радних места по стадијумима";
const NopastapplicationDatafound$2 = "Није пронађене претходне податке о примени.";
const YourJobSearchStages$2 = "Фазе претраге за посао";
const NoDatafound$2 = "Нема пронађених података";
const sr = {
	copyToClipboard: copyToClipboard$2,
	UnlocktheAIgenerated: UnlocktheAIgenerated$2,
	UpgradetoPremium: UpgradetoPremium$2,
	Result: Result$2,
	Copy: Copy$2,
	Save: Save$2,
	Edit: Edit$2,
	Processing: Processing$2,
	YourAIgeneratedcontentwillshowhere: YourAIgeneratedcontentwillshowhere$2,
	hopeYouFindUseful: hopeYouFindUseful$2,
	regenerate: regenerate$2,
	ProvideAdditionalFeedback: ProvideAdditionalFeedback$2,
	Enteranyfeedback: Enteranyfeedback$2,
	Notimpressive: Notimpressive$2,
	thisIsntTrue: thisIsntTrue$2,
	Notpersonalized: Notpersonalized$2,
	Tone: Tone$2,
	Length: Length$2,
	Template: Template$2,
	Generatedon: Generatedon$2,
	Copiedtoclipboard: Copiedtoclipboard$2,
	CopytoClipboard: CopytoClipboard$2,
	DownloadasPDF: DownloadasPDF$2,
	ViewDetails: ViewDetails$2,
	JobDescriptionImported: JobDescriptionImported$2,
	ImportfromJob: ImportfromJob$2,
	Saved: Saved$2,
	Applied: Applied$2,
	Offer: Offer$2,
	Interviewing: Interviewing$2,
	Rejected: Rejected$2,
	Search: Search$2,
	Import: Import$2,
	CoverLetterGeneratorHistory: CoverLetterGeneratorHistory$2,
	NoCoverLettersGenerated: NoCoverLettersGenerated$2,
	getStartedCoverLetter: getStartedCoverLetter$2,
	getStarted: getStarted$2,
	Documents: Documents$2,
	UploadNewDocument: UploadNewDocument$2,
	AICoverLetterGenerator: AICoverLetterGenerator$2,
	ViewHistory: ViewHistory$2,
	JobDescription: JobDescription$2,
	ImportfromBoard: ImportfromBoard$2,
	EnterJobDescription: EnterJobDescription$2,
	JobTitle: JobTitle$2,
	EnterJobTitle: EnterJobTitle$2,
	CompanyName: CompanyName$2,
	EnterCompanyName: EnterCompanyName$2,
	YourProfile: YourProfile$2,
	ResumeUpload: ResumeUpload$2,
	UseLinkedinProfile: UseLinkedinProfile$2,
	Uploadyourresume: Uploadyourresume$2,
	AddyourResume: AddyourResume$2,
	fileNameCannotFormat: fileNameCannotFormat$2,
	ChooseorUpload: ChooseorUpload$2,
	SelectTemplate: SelectTemplate$2,
	Preview: Preview$2,
	UseTemplate: UseTemplate$2,
	Change: Change$2,
	AdvancedSettings: AdvancedSettings$2,
	AdditionalContext: AdditionalContext$2,
	Professional: Professional$2,
	Casual: Casual$2,
	Enthusiastic: Enthusiastic$2,
	Informational: Informational$2,
	Short: Short$2,
	Medium: Medium$2,
	Long: Long$2,
	Language: Language$2,
	iAmOkayBack: iAmOkayBack$2,
	Generate: Generate$2,
	CoverLetter: CoverLetter$2,
	SelectLanguage: SelectLanguage$2,
	AboutGeneratorHistory: AboutGeneratorHistory$2,
	NoAboutsGenerated: NoAboutsGenerated$2,
	getStartedAbouts: getStartedAbouts$2,
	noAttachmentsFound: noAttachmentsFound$2,
	TargetJobTitle: TargetJobTitle$2,
	KeywordsToInclude: KeywordsToInclude$2,
	UploadYourResume: UploadYourResume$2,
	AddYourResume: AddYourResume$2,
	LinkedinProfile: LinkedinProfile$2,
	Linkedinprofilenotfound: Linkedinprofilenotfound$2,
	startUsingChromeExtension: startUsingChromeExtension$2,
	Download: Download$2,
	UseEmojis: UseEmojis$2,
	UseBulletPoints: UseBulletPoints$2,
	SpeechFocus: SpeechFocus$2,
	FirstPerson: FirstPerson$2,
	ThirdPerson: ThirdPerson$2,
	HeadlineGeneratorHistory: HeadlineGeneratorHistory$2,
	NoHeadlinesGenerated: NoHeadlinesGenerated$2,
	getStartedHeadline: getStartedHeadline$2,
	AIHeadlineGenerator: AIHeadlineGenerator$2,
	KeywordstoInclude: KeywordstoInclude$2,
	Pressenteraftereachword: Pressenteraftereachword$2,
	LinkedinProfilenotfound: LinkedinProfilenotfound$2,
	Headline: Headline$2,
	PostGeneratorHistory: PostGeneratorHistory$2,
	NoPostsGenerated: NoPostsGenerated$2,
	getStartedPost: getStartedPost$2,
	Topic: Topic$2,
	Description: Description$2,
	UseHashtags: UseHashtags$2,
	Custom: Custom$2,
	EnterCustomTone: EnterCustomTone$2,
	Added: Added$2,
	ComingSoon: ComingSoon$2,
	Company: Company$2,
	JobInterview: JobInterview$2,
	Research: Research$2,
	Networking: Networking$2,
	Referral: Referral$2,
	MustbeContacted: MustbeContacted$2,
	ScheduleaMeeting: ScheduleaMeeting$2,
	needAFollowUp: needAFollowUp$2,
	Today: Today$2,
	Viewdetails: Viewdetails$2,
	Activity: Activity$2,
	ActivityDetails: ActivityDetails$2,
	Delete: Delete$2,
	Title: Title$2,
	Goal: Goal$2,
	Status: Status$2,
	FollowUp: FollowUp$2,
	AddActivity: AddActivity$2,
	Enteractivitytitle: Enteractivitytitle$2,
	Cancel: Cancel$2,
	SaveActivity: SaveActivity$2,
	noActivityPresent: noActivityPresent$2,
	Addnew: Addnew$2,
	About: About$2,
	noDataPresentYou: noDataPresentYou$2,
	Experience: Experience$2,
	Education: Education$2,
	Skills: Skills$2,
	Overview: Overview$2,
	LinkedJobs: LinkedJobs$2,
	Notes: Notes$2,
	FullName: FullName$2,
	Location: Location$2,
	Relationship: Relationship$2,
	Contacts: Contacts$2,
	CreateContact: CreateContact$2,
	NotesCreated: NotesCreated$2,
	Notesupdated: Notesupdated$2,
	Addnote: Addnote$2,
	areYouSureDeleteNote: areYouSureDeleteNote$2,
	Createdby: Createdby$2,
	notSureWhyResumeCalls: notSureWhyResumeCalls$2,
	getExpertResumeReview: getExpertResumeReview$2,
	youHaventAddedContacts: youHaventAddedContacts$2,
	noMatchingContacts: noMatchingContacts$2,
	Link: Link$2,
	unlink: unlink$2,
	Locationnotavailable: Locationnotavailable$2,
	Emailnotavailable: Emailnotavailable$2,
	PhoneNumbernotavailable: PhoneNumbernotavailable$2,
	createdby: createdby$2,
	areYouSureDeleteContact: areYouSureDeleteContact$2,
	areYouSureUnlinkContact: areYouSureUnlinkContact$2,
	Addedbyyou: Addedbyyou$2,
	Addedby: Addedby$2,
	Timeline: Timeline$2,
	Timelineempty: Timelineempty$2,
	Discard: Discard$2,
	SaveContact: SaveContact$2,
	Recruiter: Recruiter$2,
	Candidate: Candidate$2,
	Colleague: Colleague$2,
	Employee: Employee$2,
	"Needtofollow-up": "Потребно је пратити",
	EnterValidEmail: EnterValidEmail$2,
	EnterValidPhoneNumber: EnterValidPhoneNumber$2,
	editingProfileNotAvailable: editingProfileNotAvailable$2,
	itWillBeSoonAvailable: itWillBeSoonAvailable$2,
	ChromeExtension: ChromeExtension$2,
	SelectTag: SelectTag$2,
	FirstName: FirstName$2,
	FirstNameisrequired: FirstNameisrequired$2,
	LastName: LastName$2,
	LastNameisrequired: LastNameisrequired$2,
	Companyisrequired: Companyisrequired$2,
	Email: Email$2,
	ThisisnotavalidEmail: ThisisnotavalidEmail$2,
	AddEmail: AddEmail$2,
	PhoneNumber: PhoneNumber$2,
	notaValidPhone: notaValidPhone$2,
	phoneNoMinimum5char: phoneNoMinimum5char$2,
	phoneNoMinumum15char: phoneNoMinumum15char$2,
	AddPhoneNumber: AddPhoneNumber$2,
	SelectGoal: SelectGoal$2,
	SelectStatus: SelectStatus$2,
	Followup: Followup$2,
	SocialMedia: SocialMedia$2,
	Linkedinhandle: Linkedinhandle$2,
	Twitterhandle: Twitterhandle$2,
	Facebookhandle: Facebookhandle$2,
	Githubhandle: Githubhandle$2,
	Gmailhandle: Gmailhandle$2,
	Changessavedsuccessfully: Changessavedsuccessfully$2,
	EditContact: EditContact$2,
	BasicInformation: BasicInformation$2,
	EditContactDetails: EditContactDetails$2,
	SaveChanges: SaveChanges$2,
	phoneNoMinimum14char: phoneNoMinimum14char$2,
	LinkedIn: LinkedIn$2,
	Twitter: Twitter$2,
	Facebook: Facebook$2,
	Github: Github$2,
	Gmail: Gmail$2,
	youCanWriteAbout: youCanWriteAbout$2,
	Addednewsection: Addednewsection$2,
	Removedsuccessfully: Removedsuccessfully$2,
	Remove: Remove$2,
	Institute: Institute$2,
	Schoolisrequired: Schoolisrequired$2,
	Degree: Degree$2,
	StartMonth: StartMonth$2,
	StartYear: StartYear$2,
	EndMonth: EndMonth$2,
	EndYear: EndYear$2,
	Addmore: Addmore$2,
	PositionTitle: PositionTitle$2,
	ExperienceType: ExperienceType$2,
	Addednewitem: Addednewitem$2,
	whatSkillsDoYouEnjoy: whatSkillsDoYouEnjoy$2,
	Typeskillshere: Typeskillshere$2,
	LinkedContacts: LinkedContacts$2,
	LinkContact: LinkContact$2,
	NocontactsLinked: NocontactsLinked$2,
	JobContactsComponent: JobContactsComponent$2,
	Nocontacts: Nocontacts$2,
	LinkJobto: LinkJobto$2,
	Contact: Contact$2,
	Document: Document$2,
	Nojobsfound: Nojobsfound$2,
	LinkJob: LinkJob$2,
	youCanLinkContactJobImported: youCanLinkContactJobImported$2,
	Prev: Prev$2,
	Next: Next$2,
	areYouSureUnlinkDocument: areYouSureUnlinkDocument$2,
	areYouSureDeleteDocument: areYouSureDeleteDocument$2,
	Category: Category$2,
	CreatedOn: CreatedOn$2,
	Joblinked: Joblinked$2,
	Quickactions: Quickactions$2,
	All: All$2,
	Resume: Resume$2,
	Portfolio: Portfolio$2,
	Other: Other$2,
	Adddocument: Adddocument$2,
	Type: Type$2,
	Sortingby: Sortingby$2,
	SwitchtoGridLayout: SwitchtoGridLayout$2,
	SwitchtoListLayout: SwitchtoListLayout$2,
	NoDocumentsAdded: NoDocumentsAdded$2,
	DocumentsComponent: DocumentsComponent$2,
	NoDocumentFound: NoDocumentFound$2,
	SelectFile: SelectFile$2,
	onlyPdfDocxSupported: onlyPdfDocxSupported$2,
	Uploadfile: Uploadfile$2,
	DocumentCategory: DocumentCategory$2,
	SaveDocument: SaveDocument$2,
	AddDocument: AddDocument$2,
	LinkedDocuments: LinkedDocuments$2,
	LinkDocument: LinkDocument$2,
	NodocumentsLinked: NodocumentsLinked$2,
	JobDocumentsComponent: JobDocumentsComponent$2,
	NoDocuments: NoDocuments$2,
	CreateDocuments: CreateDocuments$2,
	youCanLinkDocumentJobImported: youCanLinkDocumentJobImported$2,
	Documenteditedsuccessfully: Documenteditedsuccessfully$2,
	DocumentDetails: DocumentDetails$2,
	UnsavedChanges: UnsavedChanges$2,
	yourChangesWillBeLostSureClose: yourChangesWillBeLostSureClose$2,
	yourChangesWillBeLostSureDiscard: yourChangesWillBeLostSureDiscard$2,
	DiscardChanges: DiscardChanges$2,
	WeeklyGoalAlert: WeeklyGoalAlert$2,
	Progress: Progress$2,
	AllGoals: AllGoals$2,
	Name: Name$2,
	Completedon: Completedon$2,
	Createdon: Createdon$2,
	Action: Action$2,
	Back: Back$2,
	OverallScore: OverallScore$2,
	Aboutthegoal: Aboutthegoal$2,
	GoalTracking: GoalTracking$2,
	Week: Week$2,
	progress: progress$2,
	loading: loading$2,
	Apply: Apply$2,
	Thisskillhasbeenreported: Thisskillhasbeenreported$2,
	issueGettingResume: issueGettingResume$2,
	Interview: Interview$2,
	Tasks: Tasks$2,
	Loading: Loading$2,
	Skilladdedsuccessfully: Skilladdedsuccessfully$2,
	problemAddingSkill: problemAddingSkill$2,
	Reportaproblem: Reportaproblem$2,
	Submit: Submit$2,
	Addanewskill: Addanewskill$2,
	JobDetailsComponent: JobDetailsComponent$2,
	HardSkill: HardSkill$2,
	SoftSkill: SoftSkill$2,
	Pleaseshareanyadditionalcontext: Pleaseshareanyadditionalcontext$2,
	Addasskill: Addasskill$2,
	Skill: Skill$2,
	JobFrequency: JobFrequency$2,
	ResumeFrequency: ResumeFrequency$2,
	Reportskill: Reportskill$2,
	JobDetails: JobDetails$2,
	ViewJobLink: ViewJobLink$2,
	Salary: Salary$2,
	areYouSureDeleteJob: areYouSureDeleteJob$2,
	ViewMore: ViewMore$2,
	ViewLess: ViewLess$2,
	matchYouSkillsAgainstJob: matchYouSkillsAgainstJob$2,
	pleaseUploadResumeSkillMatch: pleaseUploadResumeSkillMatch$2,
	AddResume: AddResume$2,
	thisJobDoesNotHaveAnyDesc: thisJobDoesNotHaveAnyDesc$2,
	youCanEditJobToAdd: youCanEditJobToAdd$2,
	chromeextension: chromeextension$2,
	fromVariousJobPortalsOnce: fromVariousJobPortalsOnce$2,
	AddDescription: AddDescription$2,
	CompanyInfo: CompanyInfo$2,
	Website: Website$2,
	Industry: Industry$2,
	EmployeeCount: EmployeeCount$2,
	ExprienceLevel: ExprienceLevel$2,
	Address: Address$2,
	Resumes: Resumes$2,
	Setasdefault: Setasdefault$2,
	Ok: Ok$2,
	UploadNewResume: UploadNewResume$2,
	Default: Default$2,
	Jobnotfound: Jobnotfound$2,
	EditDetails: EditDetails$2,
	JobPostURL: JobPostURL$2,
	Enterjoburl: Enterjoburl$2,
	Nojobselected: Nojobselected$2,
	Viewjobdetails: Viewjobdetails$2,
	Jobaddedtoyourboardsuccessfully: Jobaddedtoyourboardsuccessfully$2,
	AddJob: AddJob$2,
	Addnewjobname: Addnewjobname$2,
	JobUrl: JobUrl$2,
	Addjoburl: Addjoburl$2,
	Section: Section$2,
	didYouKnow: didYouKnow$2,
	Jobs: Jobs$2,
	AddJobtoboard: AddJobtoboard$2,
	Currentlynojobsareavailable: Currentlynojobsareavailable$2,
	noMatchingJobs: noMatchingJobs$2,
	welcomeToYourPersonalJobTracker: welcomeToYourPersonalJobTracker$2,
	weShortTutorialOnHowTrackingJob: weShortTutorialOnHowTrackingJob$2,
	Addanewjob: Addanewjob$2,
	inOrderTrackCreatButton: inOrderTrackCreatButton$2,
	Providesomedetails: Providesomedetails$2,
	toBeginTypeJobTitleCompany: toBeginTypeJobTitleCompany$2,
	asAnExampleFilledForYou: asAnExampleFilledForYou$2,
	wohooAddedFirstJob: wohooAddedFirstJob$2,
	youCanDragDropJobCard: youCanDragDropJobCard$2,
	Lastbutnotleast: Lastbutnotleast$2,
	finalStepMakeSure: finalStepMakeSure$2,
	autoMaticallyImportJobs: autoMaticallyImportJobs$2,
	selectanysection: selectanysection$2,
	Accept: Accept$2,
	My2023JobSearch: My2023JobSearch$2,
	AddedFrom: AddedFrom$2,
	AddedUntil: AddedUntil$2,
	BasicModal: BasicModal$2,
	AddnewSectionName: AddnewSectionName$2,
	OpenTo: OpenTo$2,
	Featured: Featured$2,
	LicenceAndCerts: LicenceAndCerts$2,
	Banner: Banner$2,
	LinkedInURL: LinkedInURL$2,
	Recommendations: Recommendations$2,
	LinkedinReview: LinkedinReview$2,
	NoDataAvailable: NoDataAvailable$2,
	looksLikeYouDidNot: looksLikeYouDidNot$2,
	toOptimizeProfileScoreVisible: toOptimizeProfileScoreVisible$2,
	LinkedinComponent: LinkedinComponent$2,
	improveYourChancesLandingDreamJob: improveYourChancesLandingDreamJob$2,
	VisitProfile: VisitProfile$2,
	wantToGetLinkedinMakeover: wantToGetLinkedinMakeover$2,
	PostGenerator: PostGenerator$2,
	LinkedinHeadlineGenerator: LinkedinHeadlineGenerator$2,
	LinkedinAboutSectionGenerator: LinkedinAboutSectionGenerator$2,
	AITools: AITools$2,
	Premium: Premium$2,
	LinkedInOptimization: LinkedInOptimization$2,
	JobTracker: JobTracker$2,
	whoIsHiring: whoIsHiring$2,
	Autofill: Autofill$2,
	HeadlineGenerator: HeadlineGenerator$2,
	skillMatching: skillMatching$2,
	SummarizeJD: SummarizeJD$2,
	contactFeature: contactFeature$2,
	documentFeature: documentFeature$2,
	landJobWithoutStress: landJobWithoutStress$2,
	discoverFeatures: discoverFeatures$2,
	letsBeginOnboarding: letsBeginOnboarding$2,
	inTheNextFewScreensJobThirdParties: inTheNextFewScreensJobThirdParties$2,
	letsAddBasicInformation: letsAddBasicInformation$2,
	Pleaseselectanoptionfirst: Pleaseselectanoptionfirst$2,
	JobApplicationTracker: JobApplicationTracker$2,
	LinkedInProfileOptimizer: LinkedInProfileOptimizer$2,
	UnlimitedDocuments: UnlimitedDocuments$2,
	UnlimitedContacts: UnlimitedContacts$2,
	HiringManagerSearch: HiringManagerSearch$2,
	AILinkedInPostGenerator: AILinkedInPostGenerator$2,
	ATSKeywordSkillMatch: ATSKeywordSkillMatch$2,
	"Auto-Apply": "Ауто-примени",
	ChooseyourPlan: ChooseyourPlan$2,
	superChargeYourJobSearch: superChargeYourJobSearch$2,
	startNowGoto: startNowGoto$2,
	CreatedBy: CreatedBy$2,
	CreateNewNote: CreateNewNote$2,
	Nonotescreated: Nonotescreated$2,
	approxTimeIsFourMinutes: approxTimeIsFourMinutes$2,
	Continue: Continue$2,
	iWillDoLaterTakeMeToApp: iWillDoLaterTakeMeToApp$2,
	allDone: allDone$2,
	welcomeAbord: welcomeAbord$2,
	letsBegin: letsBegin$2,
	UpgradeyourplanandgetAIAssistance: UpgradeyourplanandgetAIAssistance$2,
	DownloadPDF: DownloadPDF$2,
	oopsWeCouldntProcessResume: oopsWeCouldntProcessResume$2,
	MyProfile: MyProfile$2,
	Setting: Setting$2,
	Logout: Logout$2,
	SignIn: SignIn$2,
	Typeyourfirstnamehere: Typeyourfirstnamehere$2,
	Enteryourlastname: Enteryourlastname$2,
	ManageSubscription: ManageSubscription$2,
	ifYouHaveDifficultiesProfile: ifYouHaveDifficultiesProfile$2,
	forSupport: forSupport$2,
	whatIsIdealCompanySize: whatIsIdealCompanySize$2,
	Saveandcontinue: Saveandcontinue$2,
	whatIsMinExpectedSalary: whatIsMinExpectedSalary$2,
	Atleast: Atleast$2,
	SlidetoAdjust: SlidetoAdjust$2,
	whatIndustryExcitedWork: whatIndustryExcitedWork$2,
	Add: Add$2,
	statusOfJobSearch: statusOfJobSearch$2,
	Finish: Finish$2,
	whatLevelRoleLooking: whatLevelRoleLooking$2,
	Selectuptotwo: Selectuptotwo$2,
	PreviousStep: PreviousStep$2,
	Skip: Skip$2,
	whatDoYouValueNewRole: whatDoYouValueNewRole$2,
	Selectuptothree: Selectuptothree$2,
	EqualEmploymentData: EqualEmploymentData$2,
	whatIsYourEthnicity: whatIsYourEthnicity$2,
	areYouAuthorizedToWorkUs: areYouAuthorizedToWorkUs$2,
	willYouRequireSponsorShip: willYouRequireSponsorShip$2,
	doYouHaveADisability: doYouHaveADisability$2,
	areYouAVeteran: areYouAVeteran$2,
	rolesYouInterestedIn: rolesYouInterestedIn$2,
	Selectuptofive: Selectuptofive$2,
	AddCustomrole: AddCustomrole$2,
	whereDoYouLikeWork: whereDoYouLikeWork$2,
	Resources: Resources$2,
	currentlyNoResourceAvailable: currentlyNoResourceAvailable$2,
	AddNewSection: AddNewSection$2,
	ChangeSections: ChangeSections$2,
	Settings: Settings$2,
	Dashboard: Dashboard$2,
	JobBoard: JobBoard$2,
	Linkedin: Linkedin$2,
	Community: Community$2,
	FindRecruiters: FindRecruiters$2,
	Goals: Goals$2,
	DownloadExtension: DownloadExtension$2,
	SuggestaFeature: SuggestaFeature$2,
	leftPanel: leftPanel$2,
	PhoneNumberisrequired: PhoneNumberisrequired$2,
	MobileNumber: MobileNumber$2,
	Enteronlynumbers: Enteronlynumbers$2,
	Countryyoulivein: Countryyoulivein$2,
	SelectaCountry: SelectaCountry$2,
	DateofBirth: DateofBirth$2,
	Gender: Gender$2,
	JobPreferences: JobPreferences$2,
	pleaseEnterValidEmail: pleaseEnterValidEmail$2,
	emailSendForResetting: emailSendForResetting$2,
	VerifyyourEmailID: VerifyyourEmailID$2,
	sentPleaseCheckEmail: sentPleaseCheckEmail$2,
	tooManyAttemptsTryAgain: tooManyAttemptsTryAgain$2,
	Resend: Resend$2,
	Login: Login$2,
	weHaveSentVerificationLinkAtEmail: weHaveSentVerificationLinkAtEmail$2,
	pleaseVerifyEmailContinueSpam: pleaseVerifyEmailContinueSpam$2,
	Logintogetstarted: Logintogetstarted$2,
	ContinuewithGoogle: ContinuewithGoogle$2,
	pleaseInputEmail: pleaseInputEmail$2,
	Password: Password$2,
	pleaseInputPassword: pleaseInputPassword$2,
	passwordLowerUpperDigitSpecial: passwordLowerUpperDigitSpecial$2,
	atLeastSixChar: atLeastSixChar$2,
	forgotPassword: forgotPassword$2,
	Bysigninginyouagreetoour: Bysigninginyouagreetoour$2,
	Terms: Terms$2,
	Conditions: Conditions$2,
	and: and$2,
	PrivacyPolicy: PrivacyPolicy$2,
	theseAreTheTopsSkillsExtracted: theseAreTheTopsSkillsExtracted$2,
	TopSkills: TopSkills$2,
	weCoulNotExtractSkills: weCoulNotExtractSkills$2,
	upgradeToPremiumToView: upgradeToPremiumToView$2,
	SkillScore: SkillScore$2,
	thisIsYourSkillScoreBasedOn: thisIsYourSkillScoreBasedOn$2,
	theseSkllsAreStrongMatch: theseSkllsAreStrongMatch$2,
	Strongmatch: Strongmatch$2,
	theseSkillsArePartialMatch: theseSkillsArePartialMatch$2,
	Partialmatch: Partialmatch$2,
	theseSkillsAreMissingFrom: theseSkillsAreMissingFrom$2,
	"Missing Keywords": "Недостајући кључни зборови",
	SkillMatchComponent: SkillMatchComponent$2,
	Optional: Optional$2,
	Notrelevanttothejob: Notrelevanttothejob$2,
	Notaskill: Notaskill$2,
	Toogeneric: Toogeneric$2,
	Pleaseshareanyfeedback: Pleaseshareanyfeedback$2,
	excludedKeywordsWillNot: excludedKeywordsWillNot$2,
	yesExcludeThisSkillFrom: yesExcludeThisSkillFrom$2,
	PartialMatch: PartialMatch$2,
	MissingKeywords: MissingKeywords$2,
	Providetitletotask: Providetitletotask$2,
	TasksList: TasksList$2,
	AddTask: AddTask$2,
	EnterTaskTitlehere: EnterTaskTitlehere$2,
	TasksComponent: TasksComponent$2,
	CompletedTasks: CompletedTasks$2,
	CompleteYourtasks: CompleteYourtasks$2,
	Steps: Steps$2,
	PremiumMember: PremiumMember$2,
	Thankyouforupgradingto: Thankyouforupgradingto$2,
	CareerflowPremium: CareerflowPremium$2,
	hereIsHowYouCanAccessPremium: hereIsHowYouCanAccessPremium$2,
	stepOne: stepOne$2,
	DownloadourChromeExtension: DownloadourChromeExtension$2,
	youJobSearchCopilotIshere: youJobSearchCopilotIshere$2,
	DownloadNow: DownloadNow$2,
	stepTwo: stepTwo$2,
	GetStarted: GetStarted$2,
	stepThree: stepThree$2,
	SignintoChromeExtension: SignintoChromeExtension$2,
	entityCreated: entityCreated$2,
	entityUpdated: entityUpdated$2,
	entityDeleted: entityDeleted$2,
	entityLinked: entityLinked$2,
	entityUnlinked: entityUnlinked$2,
	entityMovedTo: entityMovedTo$2,
	youAddedANewEntity: youAddedANewEntity$2,
	personCreated: personCreated$2,
	youUpdatedAEntity: youUpdatedAEntity$2,
	personUpdated: personUpdated$2,
	youDeletedAEntity: youDeletedAEntity$2,
	personDeleted: personDeleted$2,
	youLinkedEntity: youLinkedEntity$2,
	personLinked: personLinked$2,
	youUnlinked: youUnlinked$2,
	personUnlinked: personUnlinked$2,
	youMovedEntity: youMovedEntity$2,
	personMoved: personMoved$2,
	addedByName: addedByName$2,
	DownloadChromeExtension: DownloadChromeExtension$2,
	ourChromeExtensionIs: ourChromeExtensionIs$2,
	Optimizeyourprofile: Optimizeyourprofile$2,
	startOptimizingYourProfile: startOptimizingYourProfile$2,
	OptimizeNow: OptimizeNow$2,
	Addyourfirstjob: Addyourfirstjob$2,
	startSavingJobApplicationsToTrack: startSavingJobApplicationsToTrack$2,
	AddNow: AddNow$2,
	CompleteProfile: CompleteProfile$2,
	completeYourProfileForUsing: completeYourProfileForUsing$2,
	CompleteNow: CompleteNow$2,
	Addyourfirstcontact: Addyourfirstcontact$2,
	addContactToFollowUpWith: addContactToFollowUpWith$2,
	JoinCommunity: JoinCommunity$2,
	ourCommunityisAlways: ourCommunityisAlways$2,
	JoinNow: JoinNow$2,
	welcomeToCareerflow: welcomeToCareerflow$2,
	yourHubForCareerInsights2: yourHubForCareerInsights2$2,
	ChecklistCompleted: ChecklistCompleted$2,
	Completeyourchecklist: Completeyourchecklist$2,
	completeAFewStepsTo: completeAFewStepsTo$2,
	Completed: Completed$2,
	JobCountByStage: JobCountByStage$2,
	NopastapplicationDatafound: NopastapplicationDatafound$2,
	YourJobSearchStages: YourJobSearchStages$2,
	NoDatafound: NoDatafound$2
};

const copyToClipboard$1 = "Kopierat till urklipp!";
const UnlocktheAIgenerated$1 = "Lås upp det AI-genererade.";
const UpgradetoPremium$1 = "Uppgradera till Premium";
const Result$1 = "Resultat";
const Copy$1 = "Kopiera";
const Save$1 = "Spara";
const Edit$1 = "Redigera";
const Processing$1 = "Bearbetning";
const YourAIgeneratedcontentwillshowhere$1 = "Din AI-genererade innehåll kommer visas här";
const hopeYouFindUseful$1 = "Hoppas att du finner detta resultat användbart!";
const regenerate$1 = "Återgenerera";
const ProvideAdditionalFeedback$1 = "Ge ytterligare feedback";
const Enteranyfeedback$1 = "Ange eventuell feedback";
const Notimpressive$1 = "Inte imponerande";
const thisIsntTrue$1 = "Det här är inte sant";
const Notpersonalized$1 = "Inte personligt anpassad";
const Tone$1 = "Ton";
const Length$1 = "Längd";
const Template$1 = "Mall";
const Generatedon$1 = "Genererad den";
const Copiedtoclipboard$1 = "Kopierat till urklipp";
const CopytoClipboard$1 = "Kopiera till Urklipp";
const DownloadasPDF$1 = "Ladda ner som PDF";
const ViewDetails$1 = "Visa detaljer";
const JobDescriptionImported$1 = "Jobbeskrivning importerad";
const ImportfromJob$1 = "Importera från jobb";
const Saved$1 = "Sparad";
const Applied$1 = "Ansökt";
const Offer$1 = "Erbjudande";
const Interviewing$1 = "Intervjuer";
const Rejected$1 = "Avslagen";
const Search$1 = "Sök";
const Import$1 = "Importera";
const CoverLetterGeneratorHistory$1 = "Historik över personligt brevgenerator";
const NoCoverLettersGenerated$1 = "Inga personliga brev genererade";
const getStartedCoverLetter$1 = "Du har ännu inte genererat några personliga brev. Kom igång och få personliga brev genom att matcha jobbeskrivningen med din relevanta erfarenhet.";
const getStarted$1 = "Kom igång!";
const Documents$1 = "Dokument";
const UploadNewDocument$1 = "Ladda upp nytt dokument";
const AICoverLetterGenerator$1 = "AI Personligt Brev Generator";
const ViewHistory$1 = "Visa historik";
const JobDescription$1 = "Jobbeskrivning";
const ImportfromBoard$1 = "Importera från tavla";
const EnterJobDescription$1 = "Ange jobbeskrivning";
const JobTitle$1 = "Jobbtitel";
const EnterJobTitle$1 = "Ange jobbtitel";
const CompanyName$1 = "Företagsnamn";
const EnterCompanyName$1 = "Ange företagsnamn";
const YourProfile$1 = "Din profil";
const ResumeUpload$1 = "Ladda upp CV";
const UseLinkedinProfile$1 = "Använd Linkedin-profil";
const Uploadyourresume$1 = "Ladda upp ditt CV";
const AddyourResume$1 = "Lägg till ditt CV";
const fileNameCannotFormat$1 = "Filnamn får inte innehålla mellanslag eller understreck och bör vara antingen .doc, .docx eller .pdf.";
const ChooseorUpload$1 = "Välj eller ladda upp";
const SelectTemplate$1 = "Välj mall";
const Preview$1 = "Förhandsgranska";
const UseTemplate$1 = "Använd mall";
const Change$1 = "Ändra";
const AdvancedSettings$1 = "Avancerade inställningar";
const AdditionalContext$1 = "Ytterligare sammanhang";
const Professional$1 = "Professionell";
const Casual$1 = "Vardaglig";
const Enthusiastic$1 = "Entusiastisk";
const Informational$1 = "Informativ";
const Short$1 = "Kort";
const Medium$1 = "Medium";
const Long$1 = "Lång";
const Language$1 = "Språk";
const iAmOkayBack$1 = "Jag är okej! Gå tillbaka";
const Generate$1 = "Generera";
const CoverLetter$1 = "Personligt brev";
const SelectLanguage$1 = "Välj språk";
const AboutGeneratorHistory$1 = "Om historikgenerator";
const NoAboutsGenerated$1 = "Inga om-sidor genererade";
const getStartedAbouts$1 = "Du har ännu inte genererat några om-sidor. Kom igång och få om-sidor genom att matcha jobbeskrivningen med din relevanta erfarenhet.";
const noAttachmentsFound$1 = "Inga bilagor hittades.";
const TargetJobTitle$1 = "Måltitel";
const KeywordsToInclude$1 = "Nyckelord att inkludera";
const UploadYourResume$1 = "Ladda upp ditt CV";
const AddYourResume$1 = "Lägg till ditt CV";
const LinkedinProfile$1 = "Linkedin-profil";
const Linkedinprofilenotfound$1 = "Linkedin-profilen hittades inte";
const startUsingChromeExtension$1 = "Börja optimera din Linkedin-profil med vår Chrome-tillägg för att använda detta alternativ.";
const Download$1 = "Ladda ner";
const UseEmojis$1 = "Använd emojis";
const UseBulletPoints$1 = "Använd punktlistor";
const SpeechFocus$1 = "Tal-fokus";
const FirstPerson$1 = "Första personen";
const ThirdPerson$1 = "Tredje personen";
const HeadlineGeneratorHistory$1 = "Historik över rubrikgenerator";
const NoHeadlinesGenerated$1 = "Inga rubriker genererade";
const getStartedHeadline$1 = "Du har ännu inte genererat några rubriker. Kom igång och få rubriker genom att matcha jobbeskrivningen med din relevanta erfarenhet.";
const AIHeadlineGenerator$1 = "AI Rubrikgenerator";
const KeywordstoInclude$1 = "Nyckelord att inkludera";
const Pressenteraftereachword$1 = "Tryck på enter efter varje ord.";
const LinkedinProfilenotfound$1 = "LinkedIn-profil hittades inte.";
const Headline$1 = "Rubrik";
const PostGeneratorHistory$1 = "Historik över inläggs-generator";
const NoPostsGenerated$1 = "Inga inlägg genererade";
const getStartedPost$1 = "Du har ännu inte genererat några inlägg. Kom igång och få inlägg genom att matcha jobbeskrivningen med din relevanta erfarenhet.";
const Topic$1 = "Ämne";
const Description$1 = "Beskrivning";
const UseHashtags$1 = "Använd hashtags";
const Custom$1 = "Anpassad";
const EnterCustomTone$1 = "Ange anpassad ton";
const Added$1 = "Tillagt";
const ComingSoon$1 = {
	header: "Ingenjörer arbetar!",
	content_1: "Vårt team av ingenjörer arbetar hårt för att få den här funktionen att snart vara igång.",
	content_2: "Vill du ha den här funktionen snart? Låt oss veta genom att helt enkelt markera rutan nedan.",
	content_3: "Jag vill ha den här funktionen"
};
const Company$1 = "Företag";
const JobInterview$1 = "Jobbintervju";
const Research$1 = "Forskning";
const Networking$1 = "Nätverkande";
const Referral$1 = "Hänvisning";
const MustbeContacted$1 = "Måste kontaktas";
const ScheduleaMeeting$1 = "Schemalägg ett möte";
const needAFollowUp$1 = "Behöver följa upp.";
const Today$1 = "I dag";
const Viewdetails$1 = "Visa detaljer";
const Activity$1 = "Aktivitet";
const ActivityDetails$1 = "Aktivitetsdetaljer";
const Delete$1 = "Ta bort";
const Title$1 = "Titel";
const Goal$1 = "Mål";
const Status$1 = "Status";
const FollowUp$1 = "Uppföljning";
const AddActivity$1 = "Lägg till aktivitet";
const Enteractivitytitle$1 = "Ange aktivitetstitel";
const Cancel$1 = "Avbryt";
const SaveActivity$1 = "Spara aktivitet";
const noActivityPresent$1 = "Ingen aktivitet finns, lägg till aktivitet.";
const Addnew$1 = "Lägg till nytt";
const About$1 = "Om";
const noDataPresentYou$1 = "Ingen data närvarande, du kan redigera denna kontakt och lägga till fält.";
const Experience$1 = "Erfarenhet";
const Education$1 = "Utbildning";
const Skills$1 = "Färdigheter";
const Overview$1 = "Översikt";
const LinkedJobs$1 = "Länkade jobb";
const Notes$1 = "Anteckningar";
const FullName$1 = "Fullständigt namn";
const Location$1 = "Plats";
const Relationship$1 = "Relation";
const Contacts$1 = "Kontakter";
const CreateContact$1 = "Skapa kontakt";
const NotesCreated$1 = "Anteckningar skapade";
const Notesupdated$1 = "Anteckningar uppdaterade";
const Addnote$1 = "Lägg till anteckning";
const areYouSureDeleteNote$1 = "Är du säker på att du vill radera den här anteckningen?";
const Createdby$1 = "Skapad av";
const notSureWhyResumeCalls$1 = "Osäker på varför ditt CV inte leder till intervjuer? ☎️";
const getExpertResumeReview$1 = "Få en expertgranskning av ditt CV 💎✨";
const youHaventAddedContacts$1 = "Du har inte lagt till några kontakter än.";
const noMatchingContacts$1 = "Inga matchande kontakter hittades.";
const Link$1 = "Länk";
const unlink$1 = "Avlänka";
const Locationnotavailable$1 = "Plats ej tillgänglig";
const Emailnotavailable$1 = "E-post ej tillgänglig";
const PhoneNumbernotavailable$1 = "Telefonnummer ej tillgängligt";
const createdby$1 = "skapad av";
const areYouSureDeleteContact$1 = "Är du säker på att du vill radera denna kontakt?";
const areYouSureUnlinkContact$1 = "Är du säker på att du vill avlänka denna kontakt?";
const Addedbyyou$1 = "Lagt till av dig";
const Addedby$1 = "Tillagd av";
const Timeline$1 = "Tidslinje";
const Timelineempty$1 = "Tidslinje tom";
const Discard$1 = "Förkasta";
const SaveContact$1 = "Spara kontakt";
const Recruiter$1 = "Rekryterare";
const Candidate$1 = "Kandidat";
const Colleague$1 = "Kollega";
const Employee$1 = "Anställd";
const EnterValidEmail$1 = "Ange giltig e-postadress";
const EnterValidPhoneNumber$1 = "Ange giltigt telefonnummer";
const editingProfileNotAvailable$1 = "Redigering av profilbild är ännu inte tillgängligt.";
const itWillBeSoonAvailable$1 = "Det kommer snart att finnas tillgängligt på vår.";
const ChromeExtension$1 = "Chrome-tillägg";
const SelectTag$1 = "Välj tagg";
const FirstName$1 = "Förnamn";
const FirstNameisrequired$1 = "Förnamn krävs";
const LastName$1 = "Efternamn";
const LastNameisrequired$1 = "Efternamn krävs";
const Companyisrequired$1 = "Företag krävs";
const Email$1 = "E-post";
const ThisisnotavalidEmail$1 = "Det här är inte en giltig e-postadress.";
const AddEmail$1 = "Lägg till e-post";
const PhoneNumber$1 = "Telefonnummer";
const notaValidPhone$1 = "Detta är inte ett giltigt telefonnummer. Ange endast siffror.";
const phoneNoMinimum5char$1 = "Telefonnumret måste vara minst 5 tecken.";
const phoneNoMinumum15char$1 = "Telefonnumret får inte vara längre än 15 tecken.";
const AddPhoneNumber$1 = "Lägg till telefonnummer";
const SelectGoal$1 = "Välj mål";
const SelectStatus$1 = "Välj status";
const Followup$1 = "Uppföljning";
const SocialMedia$1 = "Sociala medier";
const Linkedinhandle$1 = "Linkedin-handtag";
const Twitterhandle$1 = "Twitter-hanterare";
const Facebookhandle$1 = "Facebook-hanterare";
const Githubhandle$1 = "Github-hanterare";
const Gmailhandle$1 = "Gmail-hanterare";
const Changessavedsuccessfully$1 = "Ändringar sparade framgångsrikt";
const EditContact$1 = "Redigera kontakt";
const BasicInformation$1 = "Grundläggande information";
const EditContactDetails$1 = "Redigera kontaktuppgifter";
const SaveChanges$1 = "Spara ändringar";
const phoneNoMinimum14char$1 = "Telefonnumret måste vara minst 14 tecken.";
const LinkedIn$1 = "LinkedIn";
const Twitter$1 = "Twitter";
const Facebook$1 = "Facebook";
const Github$1 = "Github";
const Gmail$1 = "Gmail";
const youCanWriteAbout$1 = "Du kan skriva om dina års erfarenhet, bransch eller färdigheter. Människor pratar också om sina prestationer eller tidigare jobberfarenheter.";
const Addednewsection$1 = "Tillagd ny sektion";
const Removedsuccessfully$1 = "Borttagen framgångsrikt";
const Remove$1 = "Ta bort";
const Institute$1 = "Institut";
const Schoolisrequired$1 = "Skola är obligatoriskt";
const Degree$1 = "Examensbevis";
const StartMonth$1 = "Startmånad";
const StartYear$1 = "Startår";
const EndMonth$1 = "Slutet av månaden";
const EndYear$1 = "Slutet av året";
const Addmore$1 = "Lägg till mer";
const PositionTitle$1 = "Positionstitel";
const ExperienceType$1 = "Typ av erfarenhet";
const Addednewitem$1 = "Tillagt nytt objekt";
const whatSkillsDoYouEnjoy$1 = "Vilka färdigheter har du eller tycker du om att arbeta med?";
const Typeskillshere$1 = "Skriv in färdigheter här";
const LinkedContacts$1 = "Länkade kontakter";
const LinkContact$1 = "Länka kontakt";
const NocontactsLinked$1 = "Inga länkade kontakter";
const JobContactsComponent$1 = {
	linkContact: "Genom att länka kontakter kan du snabbt se vilka viktiga personer som rekryteraren, ansvarig för rekrytering, etc., är för den här rollen! I framtiden kommer vi att kunna visa relevanta insikter baserat på dina kontakter."
};
const Nocontacts$1 = "Inga kontakter";
const LinkJobto$1 = "Länka jobb till";
const Contact$1 = "Kontakt";
const Document$1 = "Dokument";
const Nojobsfound$1 = "Inga jobb hittades";
const LinkJob$1 = "Länka jobb";
const youCanLinkContactJobImported$1 = "Du kan koppla den här kontakten till ett jobb du har importerat till Careerflow.";
const Prev$1 = "Prev (This is already in English and does not need to be translated)";
const Next$1 = "Nästa";
const areYouSureUnlinkDocument$1 = "Är du säker på att du vill avlänka detta dokument?";
const areYouSureDeleteDocument$1 = "Är du säker på att du vill radera detta dokument?";
const Category$1 = "Kategori";
const CreatedOn$1 = "Skapad Den";
const Joblinked$1 = "Jobb kopplat";
const Quickactions$1 = "Snabba åtgärder";
const All$1 = "Alla";
const Resume$1 = "CV";
const Portfolio$1 = "Portfölj";
const Other$1 = "Annat";
const Adddocument$1 = "Lägg till dokument";
const Type$1 = "Typ";
const Sortingby$1 = "Sortering efter";
const SwitchtoGridLayout$1 = "Byt till Rutnätslayout";
const SwitchtoListLayout$1 = "Byt till listlayout.";
const NoDocumentsAdded$1 = "Inga dokument tillagda";
const DocumentsComponent$1 = {
	nodocs: "Du har ännu inte skapat några dokument. Du kan ladda upp olika versioner av ditt CV, ansökningsbrev och mer, och länka dem till jobb du följer!"
};
const NoDocumentFound$1 = "Inget dokument hittades.";
const SelectFile$1 = "Välj fil";
const onlyPdfDocxSupported$1 = "Endast .pdf och .docx stöds.";
const Uploadfile$1 = "Ladda upp fil";
const DocumentCategory$1 = "Dokumentkategori";
const SaveDocument$1 = "Spara dokument";
const AddDocument$1 = "Lägg till dokument";
const LinkedDocuments$1 = "Länkade dokument";
const LinkDocument$1 = "Länka dokument";
const NodocumentsLinked$1 = "Inga länkade dokument";
const JobDocumentsComponent$1 = {
	linkDocs: "Genom att länka alla relevanta dokument som ditt CV, personliga brev, etc. som du skickade in för detta jobb kommer du att kunna hålla koll på allt på ett ställe. Prova det!"
};
const NoDocuments$1 = "Inga dokument";
const CreateDocuments$1 = "Skapa dokument";
const youCanLinkDocumentJobImported$1 = "Du kan länka detta dokument till en jobbannons som du har importerat till Careerflow.";
const Documenteditedsuccessfully$1 = "Dokumentet redigerades framgångsrikt";
const DocumentDetails$1 = "Dokumentdetaljer";
const UnsavedChanges$1 = "Osparade ändringar";
const yourChangesWillBeLostSureClose$1 = "Dina ändringar kommer att gå förlorade, är du säker på att du vill stänga?";
const yourChangesWillBeLostSureDiscard$1 = "Dina ändringar kommer att gå förlorade, är du säker på att du vill kasta bort dina ändringar?";
const DiscardChanges$1 = "Kasta ändringar";
const WeeklyGoalAlert$1 = "Veckans målvarning";
const Progress$1 = "Framsteg";
const AllGoals$1 = "Alla Mål";
const Name$1 = "Namn";
const Completedon$1 = "Avslutad Den";
const Createdon$1 = "Skapad Den";
const Action$1 = "Åtgärd";
const Back$1 = "Tillbaka";
const OverallScore$1 = "Totalpoäng";
const Aboutthegoal$1 = "Om Målet";
const GoalTracking$1 = "Mål Spårning";
const Week$1 = "Vecka";
const progress$1 = "framsteg";
const loading$1 = "Laddar";
const Apply$1 = "Ansök";
const Thisskillhasbeenreported$1 = "Denna färdighet har rapporterats.";
const issueGettingResume$1 = "Det fanns ett problem med att få tag på CV:et.";
const Interview$1 = "Intervju";
const Tasks$1 = "Uppgifter";
const Loading$1 = "Laddar";
const Skilladdedsuccessfully$1 = "Färdighet tillagd framgångsrikt";
const problemAddingSkill$1 = "Det uppstod ett problem när färdigheten skulle läggas till.";
const Reportaproblem$1 = "Rapportera ett problem";
const Submit$1 = "Skicka";
const Addanewskill$1 = "Lägg till en ny färdighet";
const JobDetailsComponent$1 = {
	classifySkill: "Hur skulle du klassificera denna färdighet (valfritt)?",
	includedKeywordsWillCount: "Inkludera detta sökord?",
	yesIncludeThisSkill: "Inkluderade nyckelord kommer att räknas mot din matchpoäng för alla framtida skanningar. Du kan ändra inkluderade nyckelord från din profil.",
	addSkill: "Vill du lägga till detta som en färdighet?"
};
const HardSkill$1 = "Hård färdighet";
const SoftSkill$1 = "Mjuk färdighet";
const Pleaseshareanyadditionalcontext$1 = "Vänligen dela med dig av eventuell ytterligare kontext";
const Addasskill$1 = "Lägg till som färdighet";
const Skill$1 = "Färdighet";
const JobFrequency$1 = "Jobb Frekvens";
const ResumeFrequency$1 = "CV Frekvens";
const Reportskill$1 = "Rapportera färdighet";
const JobDetails$1 = "Jobbdetaljer";
const ViewJobLink$1 = "Visa jobblänk";
const Salary$1 = "Lön";
const areYouSureDeleteJob$1 = "Är du säker på att du vill radera detta jobb?";
const ViewMore$1 = "Visa mer";
const ViewLess$1 = "Visa mindre";
const matchYouSkillsAgainstJob$1 = "Matcha dina färdigheter mot jobbeskrivningen.";
const pleaseUploadResumeSkillMatch$1 = "Vänligen ladda upp ditt CV för att få din matchningspoäng för färdigheter.";
const AddResume$1 = "Lägg till CV";
const thisJobDoesNotHaveAnyDesc$1 = "Det här jobbet har ingen beskrivning.";
const youCanEditJobToAdd$1 = "Du kan redigera detta jobb för att lägga till en beskrivning till det. Du kan också importera jobb med hjälp av vår.";
const chromeextension$1 = "Chrome-tillägg";
const fromVariousJobPortalsOnce$1 = "från olika jobbportaler. När du lägger till en beskrivning kommer du också att kunna se information om relaterade färdigheter.";
const AddDescription$1 = "Lägg till beskrivning.";
const CompanyInfo$1 = "Företagsinformation";
const Website$1 = "Webbplats";
const Industry$1 = "Bransch";
const EmployeeCount$1 = "Antal anställda";
const ExprienceLevel$1 = "Erfarenhetsnivå";
const Address$1 = "Adress";
const Resumes$1 = "CV";
const Setasdefault$1 = "Ange som standard";
const Ok$1 = "Ok";
const UploadNewResume$1 = "Ladda upp nytt CV";
const Default$1 = "Standard";
const Jobnotfound$1 = "Jobbet hittades inte.";
const EditDetails$1 = "Redigera detaljer";
const JobPostURL$1 = "Jobbpost-URL";
const Enterjoburl$1 = "Ange jobb-URL";
const Nojobselected$1 = "Inget jobb valt.";
const Viewjobdetails$1 = "Visa Jobbdetaljer";
const Jobaddedtoyourboardsuccessfully$1 = "Jobbet har lagts till på din tavla framgångsrikt.";
const AddJob$1 = "Lägg till jobb";
const Addnewjobname$1 = "Lägg till nytt jobbnamn";
const JobUrl$1 = "Jobb-URL";
const Addjoburl$1 = "Lägg till jobb-URL";
const Section$1 = "Avsnitt";
const didYouKnow$1 = {
	chromeExtension: "Visste du? Du kan också spara jobb direkt från vår Chrome-tillägg och importera all data med ett enda klick! Det tar bara några sekunder."
};
const Jobs$1 = "Jobb";
const AddJobtoboard$1 = "Lägg till jobb på tavlan";
const Currentlynojobsareavailable$1 = "För närvarande finns inga lediga jobb.";
const noMatchingJobs$1 = "Inga matchande jobb hittades.";
const welcomeToYourPersonalJobTracker$1 = "Välkommen till din personliga Jobb Tracker!";
const weShortTutorialOnHowTrackingJob$1 = "Vi kommer att ta dig genom en kort handledning om hur du kan börja spåra dina jobbansökningar på några enkla steg!";
const Addanewjob$1 = "Lägg till ett nytt jobb.";
const inOrderTrackCreatButton$1 = "För att börja spåra jobbansökningar måste du först lägga till den på tavlan genom att klicka på knappen \"Skapa\".";
const Providesomedetails$1 = "Ge några detaljer.";
const toBeginTypeJobTitleCompany$1 = "För att börja, skriv bara in jobbtiteln, företagsnamnet och den status du vill lägga till det i. Du kan lägga till mer information senare, men det är allt du behöver för nu!";
const asAnExampleFilledForYou$1 = "Som ett exempel har vi redan fyllt i detta åt dig!";
const wohooAddedFirstJob$1 = "Woohoo! Du har lagt till ditt första jobb i din jobbtracker!";
const youCanDragDropJobCard$1 = "Du kan nu dra och släppa jobbkortet i olika stadier av jobbansökningsprocessen. Genom att klicka på jobbkortet kan du se mer detaljer, redigera dem, spara anteckningar och mer!";
const Lastbutnotleast$1 = "Sist men inte minst";
const finalStepMakeSure$1 = "Som sista steg, se till att du har vår.";
const autoMaticallyImportJobs$1 = "vilket kommer att tillåta dig att automatiskt importera jobb från dina favorit jobbsökningswebbplatser som LinkedIn, Indeed och mer! Vår tillägg hjälper dig också att förbättra din LinkedIn-profil och få 2,5 gånger fler sökningar!";
const selectanysection$1 = "välj valfri sektion";
const Accept$1 = "Acceptera";
const My2023JobSearch$1 = "Min jobbsökning 2023";
const AddedFrom$1 = "Tillagt från";
const AddedUntil$1 = "Tillagt tills";
const BasicModal$1 = "Grundläggande modal";
const AddnewSectionName$1 = "Lägg till nytt avsnittsnamn";
const OpenTo$1 = "Öppen För";
const Featured$1 = "Utvald";
const LicenceAndCerts$1 = "Licenser och certifikat";
const Banner$1 = "Banner";
const LinkedInURL$1 = "LinkedIn URL";
const Recommendations$1 = "Rekommendationer";
const LinkedinReview$1 = "Linkedin-recension";
const NoDataAvailable$1 = "Ingen data tillgänglig.";
const looksLikeYouDidNot$1 = "Det verkar som att du inte har börjat använda vår";
const toOptimizeProfileScoreVisible$1 = "att optimera din LinkedIn-profil ännu. När du har gjort det kommer din profilpoäng att vara synlig här.";
const LinkedinComponent$1 = {
	letsOptimize: "Optimera vi"
};
const improveYourChancesLandingDreamJob$1 = "Förbättra dina chanser att landa ditt drömjobb. Använd dessa beprövade strategier för att ge din LinkedIn-profil en välbehövlig makeover.";
const VisitProfile$1 = "Besök Profil";
const wantToGetLinkedinMakeover$1 = "Vill du ha en komplett LinkedIn-makeover?";
const PostGenerator$1 = "Inläggs Generator";
const LinkedinHeadlineGenerator$1 = "LinkedIn Rubrik Generator";
const LinkedinAboutSectionGenerator$1 = "LinkedIn Om-sektion Generator";
const AITools$1 = "AI-verktyg";
const Premium$1 = "Premium";
const LinkedInOptimization$1 = "Optimering av LinkedIn";
const JobTracker$1 = "Jobbtracker";
const whoIsHiring$1 = "Vem anställer";
const Autofill$1 = "Automatisk ifyllning";
const HeadlineGenerator$1 = "Rubrikgenerator";
const skillMatching$1 = "Färdighetsmatchning";
const SummarizeJD$1 = "Sammanfatta jobbeskrivningen";
const contactFeature$1 = "Kontaktspårning";
const documentFeature$1 = "Dokument";
const landJobWithoutStress$1 = "Få ditt drömjobb. Utan stress.";
const discoverFeatures$1 = "Upptäck Careerflow.ai:s utbud av funktioner som är utformade för att effektivisera din jobbsökning och förbättra din professionella resa!";
const letsBeginOnboarding$1 = "Låt oss lära känna dig bättre!";
const inTheNextFewScreensJobThirdParties$1 = "I de närmaste skärmarna kommer vi att ställa några frågor som hjälper oss att anpassa upplevelsen för dig och automatiskt fylla i dina jobbansökningar (så att du slipper göra det själv)! Vi säljer inte dina data till tredje part.";
const letsAddBasicInformation$1 = "Låt oss lägga till din grundläggande information";
const Pleaseselectanoptionfirst$1 = "Vänligen välj ett alternativ först.";
const JobApplicationTracker$1 = "Jobbansöknings-spårare";
const LinkedInProfileOptimizer$1 = "Optimerare av Linked In-profil";
const UnlimitedDocuments$1 = "Obegränsade dokument";
const UnlimitedContacts$1 = "Obegränsat antal kontakter";
const HiringManagerSearch$1 = "Rekryteringsansvarig sökning";
const AILinkedInPostGenerator$1 = "AI LinkedIn-inläggs-generator";
const ATSKeywordSkillMatch$1 = "ATS Nyckelord / Färdighetsmatchning Jobb";
const ChooseyourPlan$1 = "Välj ditt plan";
const superChargeYourJobSearch$1 = "Öka kraftigt din jobbsökning och förbättra din jobbansökningsprocess, öka antalet intervjuer och landa ditt drömjobb. Allt med hjälp av Careerflows premiumverktyg.";
const startNowGoto$1 = "Börja nu (Gå till appen)";
const CreatedBy$1 = "Skapad av";
const CreateNewNote$1 = "Skapa ny anteckning";
const Nonotescreated$1 = "Inga anteckningar skapade";
const approxTimeIsFourMinutes$1 = "Den ungefärliga tiden för att slutföra onboarding-processen är 4 minuter.";
const Continue$1 = "Fortsätt";
const iWillDoLaterTakeMeToApp$1 = "Jag gör det senare. Ta mig till appen.";
const allDone$1 = "Allt klart!";
const welcomeAbord$1 = "Välkommen ombord!";
const letsBegin$1 = "Låt oss börja";
const UpgradeyourplanandgetAIAssistance$1 = "Uppgradera ditt abonnemang och få AI-assistans.";
const DownloadPDF$1 = "Ladda ner PDF";
const oopsWeCouldntProcessResume$1 = "Hoppsan, vi kunde inte bearbeta detta CV.";
const MyProfile$1 = "Min profil";
const Setting$1 = "Miljö";
const Logout$1 = "Logga ut";
const SignIn$1 = "Logga in";
const Typeyourfirstnamehere$1 = "Ditt förnamn";
const Enteryourlastname$1 = "Ditt efternamn";
const ManageSubscription$1 = "Hantera prenumeration";
const ifYouHaveDifficultiesProfile$1 = "Om du har några svårigheter med din profilinformation, vänligen kontakta";
const forSupport$1 = "för support.";
const whatIsIdealCompanySize$1 = "Vilken är din idealiska företagsstorlek?";
const Saveandcontinue$1 = "Spara och fortsätt";
const whatIsMinExpectedSalary$1 = "Vad är din minsta förväntade lön (per år)?";
const Atleast$1 = "Åtminstone";
const SlidetoAdjust$1 = "Skjut för att justera";
const whatIndustryExcitedWork$1 = "Vilka branscher är spännande för dig?";
const Add$1 = "Lägg Till";
const statusOfJobSearch$1 = "Status på din jobbsökning?";
const Finish$1 = "Slut.";
const whatLevelRoleLooking$1 = "Vilken rollnivå söker du?";
const Selectuptotwo$1 = "Välj upp till två.";
const PreviousStep$1 = "Föregående steg";
const Skip$1 = "Skip";
const whatDoYouValueNewRole$1 = "Vad värderar du i en ny roll?";
const Selectuptothree$1 = "Välj upp till tre.";
const EqualEmploymentData$1 = "Jämställdhetsdata för anställning";
const whatIsYourEthnicity$1 = "Vilken etnicitet tillhör du?";
const areYouAuthorizedToWorkUs$1 = "Är du auktoriserad att arbeta i USA?";
const willYouRequireSponsorShip$1 = "Kommer du nu eller i framtiden att behöva sponsring för anställningsvisumstatus?";
const doYouHaveADisability$1 = "Har du en funktionsnedsättning?";
const areYouAVeteran$1 = "Är du en veteran?";
const rolesYouInterestedIn$1 = "Vilka slags roller är du intresserad av?";
const Selectuptofive$1 = "Välj upp till fem.";
const AddCustomrole$1 = "Lägg till anpassad roll";
const whereDoYouLikeWork$1 = "Var skulle du vilja arbeta?";
const Resources$1 = "Resurser";
const currentlyNoResourceAvailable$1 = "För närvarande finns inga tillgängliga resurser.";
const AddNewSection$1 = "Lägg till nytt avsnitt";
const ChangeSections$1 = "Ändra avsnitt";
const Settings$1 = "Inställningar";
const Dashboard$1 = "Instrumentpanel";
const JobBoard$1 = "Jobbtavla";
const Linkedin$1 = "Linkedin";
const Community$1 = "Gemenskap";
const FindRecruiters$1 = "Hitta rekryterare";
const Goals$1 = "Mål";
const DownloadExtension$1 = "Ladda ner tillägg";
const SuggestaFeature$1 = "Föreslå en funktion";
const leftPanel$1 = {
	ReportanIssue: "Rapportera ett problem"
};
const PhoneNumberisrequired$1 = "Telefonnummer är obligatoriskt.";
const MobileNumber$1 = "Mobilnummer";
const Enteronlynumbers$1 = "Skriv endast siffror";
const Countryyoulivein$1 = "Landet du bor i";
const SelectaCountry$1 = "Välj ett land";
const DateofBirth$1 = "Födelsedatum";
const Gender$1 = "Kön";
const JobPreferences$1 = "Jobbpreferenser";
const pleaseEnterValidEmail$1 = "Var god ange en giltig e-postadress.";
const emailSendForResetting$1 = "Ett e-postmeddelande har skickats till dig för att återställa lösenordet.";
const VerifyyourEmailID$1 = "Verifiera din e-postadress.";
const sentPleaseCheckEmail$1 = "Skickat! Vänligen kontrollera din e-post.";
const tooManyAttemptsTryAgain$1 = "För många försök, försök igen om en stund.";
const Resend$1 = "Skicka igen";
const Login$1 = "Inloggning";
const weHaveSentVerificationLinkAtEmail$1 = "Vi har skickat en verifieringslänk till din e-post.";
const pleaseVerifyEmailContinueSpam$1 = "Vänligen verifiera din e-postadress för att fortsätta. Kontrollera också skräppost eller promotionsmappen för verifierings-e-posten.";
const Logintogetstarted$1 = "Logga in för att komma igång.";
const ContinuewithGoogle$1 = "Fortsätt med Google";
const pleaseInputEmail$1 = "Var god ange din e-postadress!";
const Password$1 = "Lösenord";
const pleaseInputPassword$1 = "Var god ange ditt lösenord!";
const passwordLowerUpperDigitSpecial$1 = "Ditt lösenord måste innehålla minst en liten bokstav, en stor bokstav, en siffra och ett specialtecken.";
const atLeastSixChar$1 = "Minst 6 tecken";
const forgotPassword$1 = "Glömt lösenord?";
const Bysigninginyouagreetoour$1 = "Genom att logga in godkänner du våra";
const Terms$1 = "Villkor";
const Conditions$1 = "Villkor";
const and$1 = "och";
const PrivacyPolicy$1 = "Sekretesspolicy";
const theseAreTheTopsSkillsExtracted$1 = "Dessa är de främsta färdigheterna som utvunnits från jobbeskrivningen.";
const TopSkills$1 = "Toppkompetenser";
const weCoulNotExtractSkills$1 = "Vi kunde inte extrahera några färdigheter från denna jobbeskrivning.";
const upgradeToPremiumToView$1 = "Uppgradera till Premium för att se din matchningspoäng för färdigheter i ditt CV.";
const SkillScore$1 = "Färdighetspoäng";
const thisIsYourSkillScoreBasedOn$1 = "Detta är din kompetenspoäng baserat på jobbeskrivningen och ditt CV.";
const theseSkllsAreStrongMatch$1 = "Dessa färdigheter är en stark matchning mellan ditt CV och jobbeskrivningen.";
const Strongmatch$1 = "Stark matchning";
const theseSkillsArePartialMatch$1 = "Dessa färdigheter är en delvis matchning mellan ditt CV och jobbeskrivningen.";
const Partialmatch$1 = "Delvis matchning";
const theseSkillsAreMissingFrom$1 = "Dessa nyckelord saknas i ditt CV men finns i jobbeskrivningen. De kan vara färdigheter eller allmänna nyckelord som är specifika för jobbmöjligheten och kan vara användbara att lägga till i ditt CV.";
const SkillMatchComponent$1 = {
	removeSkill: "Vad är din huvudanledning att rapportera ett problem för nyckelordet"
};
const Optional$1 = "Valfritt";
const Notrelevanttothejob$1 = "Inte relevant för jobbet";
const Notaskill$1 = "Ingen färdighet";
const Toogeneric$1 = "För generisk";
const Pleaseshareanyfeedback$1 = "Vänligen dela med dig av eventuell feedback";
const excludedKeywordsWillNot$1 = "Uteslutna sökord kommer inte att räknas mot din matchpoäng för alla framtida skanningar. Du kan ändra uteslutna sökord från din profil.";
const yesExcludeThisSkillFrom$1 = "Ja, uteslut denna färdighet från alla mina CV-skanningar.";
const PartialMatch$1 = "Delvis matchning";
const MissingKeywords$1 = "Saknade nyckelord";
const Providetitletotask$1 = "Ange titel på uppgift";
const TasksList$1 = "Uppgifter Lista";
const AddTask$1 = "Lägg till uppgift";
const EnterTaskTitlehere$1 = "Ange uppgiftstitel här";
const TasksComponent$1 = {
	listEmpty: "Uppgiftslistan är tom. Skapa ny."
};
const CompletedTasks$1 = "Avslutade Uppgifter";
const CompleteYourtasks$1 = "Slutför Dina Uppgifter";
const Steps$1 = "Steg";
const PremiumMember$1 = "Premiummedlem";
const Thankyouforupgradingto$1 = "Tack för uppgraderingen till";
const CareerflowPremium$1 = "Karriärflöde Premium";
const hereIsHowYouCanAccessPremium$1 = "Så här får du tillgång till dina Premium-förmåner!";
const stepOne$1 = "Steg 1";
const DownloadourChromeExtension$1 = "Ladda ner vår Chrome-tillägg.";
const youJobSearchCopilotIshere$1 = "Din AI-kopilot för jobbsökning är här.";
const DownloadNow$1 = "Ladda ner nu";
const stepTwo$1 = "Steg 2";
const GetStarted$1 = "Börja";
const stepThree$1 = "Steg 3";
const SignintoChromeExtension$1 = "Logga in på Chrome-tillägg.";
const entityCreated$1 = "Ny {{entity}} skapad.";
const entityUpdated$1 = "{{entity}} uppdaterad";
const entityDeleted$1 = "{{entity}} borttagen";
const entityLinked$1 = "{{entity}} länkad";
const entityUnlinked$1 = "{{entity}} avlänkad";
const entityMovedTo$1 = "Flyttade till {{entity}}";
const youAddedANewEntity$1 = "Du har lagt till en ny {{entity}}.";
const personCreated$1 = "{{creator}} skapade en {{entity}} för {{owner}}.";
const youUpdatedAEntity$1 = "Du uppdaterade en {{entity}}.";
const personUpdated$1 = "{{creator}} uppdaterade en {{entity}} för {{owner}}.";
const youDeletedAEntity$1 = "Du raderade en {{entity}}.";
const personDeleted$1 = "{{creator}} raderade en {{entity}} för {{owner}}.";
const youLinkedEntity$1 = "Du länkade en {{entity}} till detta jobb.";
const personLinked$1 = "{{creator}} länkade en {{entity}} till detta jobb för {{owner}}.";
const youUnlinked$1 = "Du har avlänkat en {{entity}} från detta jobb.";
const personUnlinked$1 = "{{creator}} avlänkade en {{entity}} från detta jobb för {{owner}}.";
const youMovedEntity$1 = "Du flyttade denna {{entity}} från {{sectionFrom}} till {{sectionTo}}";
const personMoved$1 = "{{creator}} flyttade denna {{entity}} från {{sectionFrom}} till {{sectionTo}} för {{owner}}.";
const addedByName$1 = "Tillagt av {{name}}";
const DownloadChromeExtension$1 = "Ladda ner Chrome-tillägg";
const ourChromeExtensionIs$1 = "Vår Chrome-tillägg är ett integrerat verktyg som hjälper dig att optimera din LinkedIn-profil, spara jobb, spara kontakter, generera personligt brev och mer.";
const Optimizeyourprofile$1 = "Optimera din profil";
const startOptimizingYourProfile$1 = "Börja optimera din profil för att öka dina chanser att bli kontaktad av rekryterare.";
const OptimizeNow$1 = "Optimera nu";
const Addyourfirstjob$1 = "Lägg till ditt första jobb.";
const startSavingJobApplicationsToTrack$1 = "Börja spara jobbansökningar för att följa din jobbsökningsresa och hitta användbara insikter.";
const AddNow$1 = "Lägg till nu";
const CompleteProfile$1 = "Fullständig profil";
const completeYourProfileForUsing$1 = "Fyll i din profil för att använda auto-fyllningsfunktionen och få en mer personlig upplevelse.";
const CompleteNow$1 = "Slutför nu";
const Addyourfirstcontact$1 = "Lägg till din första kontakt.";
const addContactToFollowUpWith$1 = "Lägg till kontakt för att följa upp med dem senare, lägg till anteckningar och mer.";
const JoinCommunity$1 = "Gå med i gemenskapen";
const ourCommunityisAlways$1 = "Vår gemenskap är alltid där med dig under din jobbsökningsresa.";
const JoinNow$1 = "Gå med nu";
const welcomeToCareerflow$1 = "Välkommen till Careerflow!";
const yourHubForCareerInsights2$1 = "Det här är din central för karriärinsikter, aktiviteter och mer. Utforska din personliga instrumentpanel för att hålla dig uppdaterad om din professionella resa.";
const ChecklistCompleted$1 = "Din checklista är klar!";
const Completeyourchecklist$1 = "Slutför din checklista.";
const completeAFewStepsTo$1 = "Slutför några steg för att landa ditt nästa jobb.";
const Completed$1 = "Avslutad";
const JobCountByStage$1 = "Antal jobb per stadium";
const NopastapplicationDatafound$1 = "Ingen tidigare ansökningsdata hittades.";
const YourJobSearchStages$1 = "Dina jobbsökningsstadier";
const NoDatafound$1 = "Ingen data hittades.";
const sv = {
	copyToClipboard: copyToClipboard$1,
	UnlocktheAIgenerated: UnlocktheAIgenerated$1,
	UpgradetoPremium: UpgradetoPremium$1,
	Result: Result$1,
	Copy: Copy$1,
	Save: Save$1,
	Edit: Edit$1,
	Processing: Processing$1,
	YourAIgeneratedcontentwillshowhere: YourAIgeneratedcontentwillshowhere$1,
	hopeYouFindUseful: hopeYouFindUseful$1,
	regenerate: regenerate$1,
	ProvideAdditionalFeedback: ProvideAdditionalFeedback$1,
	Enteranyfeedback: Enteranyfeedback$1,
	Notimpressive: Notimpressive$1,
	thisIsntTrue: thisIsntTrue$1,
	Notpersonalized: Notpersonalized$1,
	Tone: Tone$1,
	Length: Length$1,
	Template: Template$1,
	Generatedon: Generatedon$1,
	Copiedtoclipboard: Copiedtoclipboard$1,
	CopytoClipboard: CopytoClipboard$1,
	DownloadasPDF: DownloadasPDF$1,
	ViewDetails: ViewDetails$1,
	JobDescriptionImported: JobDescriptionImported$1,
	ImportfromJob: ImportfromJob$1,
	Saved: Saved$1,
	Applied: Applied$1,
	Offer: Offer$1,
	Interviewing: Interviewing$1,
	Rejected: Rejected$1,
	Search: Search$1,
	Import: Import$1,
	CoverLetterGeneratorHistory: CoverLetterGeneratorHistory$1,
	NoCoverLettersGenerated: NoCoverLettersGenerated$1,
	getStartedCoverLetter: getStartedCoverLetter$1,
	getStarted: getStarted$1,
	Documents: Documents$1,
	UploadNewDocument: UploadNewDocument$1,
	AICoverLetterGenerator: AICoverLetterGenerator$1,
	ViewHistory: ViewHistory$1,
	JobDescription: JobDescription$1,
	ImportfromBoard: ImportfromBoard$1,
	EnterJobDescription: EnterJobDescription$1,
	JobTitle: JobTitle$1,
	EnterJobTitle: EnterJobTitle$1,
	CompanyName: CompanyName$1,
	EnterCompanyName: EnterCompanyName$1,
	YourProfile: YourProfile$1,
	ResumeUpload: ResumeUpload$1,
	UseLinkedinProfile: UseLinkedinProfile$1,
	Uploadyourresume: Uploadyourresume$1,
	AddyourResume: AddyourResume$1,
	fileNameCannotFormat: fileNameCannotFormat$1,
	ChooseorUpload: ChooseorUpload$1,
	SelectTemplate: SelectTemplate$1,
	Preview: Preview$1,
	UseTemplate: UseTemplate$1,
	Change: Change$1,
	AdvancedSettings: AdvancedSettings$1,
	AdditionalContext: AdditionalContext$1,
	Professional: Professional$1,
	Casual: Casual$1,
	Enthusiastic: Enthusiastic$1,
	Informational: Informational$1,
	Short: Short$1,
	Medium: Medium$1,
	Long: Long$1,
	Language: Language$1,
	iAmOkayBack: iAmOkayBack$1,
	Generate: Generate$1,
	CoverLetter: CoverLetter$1,
	SelectLanguage: SelectLanguage$1,
	AboutGeneratorHistory: AboutGeneratorHistory$1,
	NoAboutsGenerated: NoAboutsGenerated$1,
	getStartedAbouts: getStartedAbouts$1,
	noAttachmentsFound: noAttachmentsFound$1,
	TargetJobTitle: TargetJobTitle$1,
	KeywordsToInclude: KeywordsToInclude$1,
	UploadYourResume: UploadYourResume$1,
	AddYourResume: AddYourResume$1,
	LinkedinProfile: LinkedinProfile$1,
	Linkedinprofilenotfound: Linkedinprofilenotfound$1,
	startUsingChromeExtension: startUsingChromeExtension$1,
	Download: Download$1,
	UseEmojis: UseEmojis$1,
	UseBulletPoints: UseBulletPoints$1,
	SpeechFocus: SpeechFocus$1,
	FirstPerson: FirstPerson$1,
	ThirdPerson: ThirdPerson$1,
	HeadlineGeneratorHistory: HeadlineGeneratorHistory$1,
	NoHeadlinesGenerated: NoHeadlinesGenerated$1,
	getStartedHeadline: getStartedHeadline$1,
	AIHeadlineGenerator: AIHeadlineGenerator$1,
	KeywordstoInclude: KeywordstoInclude$1,
	Pressenteraftereachword: Pressenteraftereachword$1,
	LinkedinProfilenotfound: LinkedinProfilenotfound$1,
	Headline: Headline$1,
	PostGeneratorHistory: PostGeneratorHistory$1,
	NoPostsGenerated: NoPostsGenerated$1,
	getStartedPost: getStartedPost$1,
	Topic: Topic$1,
	Description: Description$1,
	UseHashtags: UseHashtags$1,
	Custom: Custom$1,
	EnterCustomTone: EnterCustomTone$1,
	Added: Added$1,
	ComingSoon: ComingSoon$1,
	Company: Company$1,
	JobInterview: JobInterview$1,
	Research: Research$1,
	Networking: Networking$1,
	Referral: Referral$1,
	MustbeContacted: MustbeContacted$1,
	ScheduleaMeeting: ScheduleaMeeting$1,
	needAFollowUp: needAFollowUp$1,
	Today: Today$1,
	Viewdetails: Viewdetails$1,
	Activity: Activity$1,
	ActivityDetails: ActivityDetails$1,
	Delete: Delete$1,
	Title: Title$1,
	Goal: Goal$1,
	Status: Status$1,
	FollowUp: FollowUp$1,
	AddActivity: AddActivity$1,
	Enteractivitytitle: Enteractivitytitle$1,
	Cancel: Cancel$1,
	SaveActivity: SaveActivity$1,
	noActivityPresent: noActivityPresent$1,
	Addnew: Addnew$1,
	About: About$1,
	noDataPresentYou: noDataPresentYou$1,
	Experience: Experience$1,
	Education: Education$1,
	Skills: Skills$1,
	Overview: Overview$1,
	LinkedJobs: LinkedJobs$1,
	Notes: Notes$1,
	FullName: FullName$1,
	Location: Location$1,
	Relationship: Relationship$1,
	Contacts: Contacts$1,
	CreateContact: CreateContact$1,
	NotesCreated: NotesCreated$1,
	Notesupdated: Notesupdated$1,
	Addnote: Addnote$1,
	areYouSureDeleteNote: areYouSureDeleteNote$1,
	Createdby: Createdby$1,
	notSureWhyResumeCalls: notSureWhyResumeCalls$1,
	getExpertResumeReview: getExpertResumeReview$1,
	youHaventAddedContacts: youHaventAddedContacts$1,
	noMatchingContacts: noMatchingContacts$1,
	Link: Link$1,
	unlink: unlink$1,
	Locationnotavailable: Locationnotavailable$1,
	Emailnotavailable: Emailnotavailable$1,
	PhoneNumbernotavailable: PhoneNumbernotavailable$1,
	createdby: createdby$1,
	areYouSureDeleteContact: areYouSureDeleteContact$1,
	areYouSureUnlinkContact: areYouSureUnlinkContact$1,
	Addedbyyou: Addedbyyou$1,
	Addedby: Addedby$1,
	Timeline: Timeline$1,
	Timelineempty: Timelineempty$1,
	Discard: Discard$1,
	SaveContact: SaveContact$1,
	Recruiter: Recruiter$1,
	Candidate: Candidate$1,
	Colleague: Colleague$1,
	Employee: Employee$1,
	"Needtofollow-up": "Behöver följa upp",
	EnterValidEmail: EnterValidEmail$1,
	EnterValidPhoneNumber: EnterValidPhoneNumber$1,
	editingProfileNotAvailable: editingProfileNotAvailable$1,
	itWillBeSoonAvailable: itWillBeSoonAvailable$1,
	ChromeExtension: ChromeExtension$1,
	SelectTag: SelectTag$1,
	FirstName: FirstName$1,
	FirstNameisrequired: FirstNameisrequired$1,
	LastName: LastName$1,
	LastNameisrequired: LastNameisrequired$1,
	Companyisrequired: Companyisrequired$1,
	Email: Email$1,
	ThisisnotavalidEmail: ThisisnotavalidEmail$1,
	AddEmail: AddEmail$1,
	PhoneNumber: PhoneNumber$1,
	notaValidPhone: notaValidPhone$1,
	phoneNoMinimum5char: phoneNoMinimum5char$1,
	phoneNoMinumum15char: phoneNoMinumum15char$1,
	AddPhoneNumber: AddPhoneNumber$1,
	SelectGoal: SelectGoal$1,
	SelectStatus: SelectStatus$1,
	Followup: Followup$1,
	SocialMedia: SocialMedia$1,
	Linkedinhandle: Linkedinhandle$1,
	Twitterhandle: Twitterhandle$1,
	Facebookhandle: Facebookhandle$1,
	Githubhandle: Githubhandle$1,
	Gmailhandle: Gmailhandle$1,
	Changessavedsuccessfully: Changessavedsuccessfully$1,
	EditContact: EditContact$1,
	BasicInformation: BasicInformation$1,
	EditContactDetails: EditContactDetails$1,
	SaveChanges: SaveChanges$1,
	phoneNoMinimum14char: phoneNoMinimum14char$1,
	LinkedIn: LinkedIn$1,
	Twitter: Twitter$1,
	Facebook: Facebook$1,
	Github: Github$1,
	Gmail: Gmail$1,
	youCanWriteAbout: youCanWriteAbout$1,
	Addednewsection: Addednewsection$1,
	Removedsuccessfully: Removedsuccessfully$1,
	Remove: Remove$1,
	Institute: Institute$1,
	Schoolisrequired: Schoolisrequired$1,
	Degree: Degree$1,
	StartMonth: StartMonth$1,
	StartYear: StartYear$1,
	EndMonth: EndMonth$1,
	EndYear: EndYear$1,
	Addmore: Addmore$1,
	PositionTitle: PositionTitle$1,
	ExperienceType: ExperienceType$1,
	Addednewitem: Addednewitem$1,
	whatSkillsDoYouEnjoy: whatSkillsDoYouEnjoy$1,
	Typeskillshere: Typeskillshere$1,
	LinkedContacts: LinkedContacts$1,
	LinkContact: LinkContact$1,
	NocontactsLinked: NocontactsLinked$1,
	JobContactsComponent: JobContactsComponent$1,
	Nocontacts: Nocontacts$1,
	LinkJobto: LinkJobto$1,
	Contact: Contact$1,
	Document: Document$1,
	Nojobsfound: Nojobsfound$1,
	LinkJob: LinkJob$1,
	youCanLinkContactJobImported: youCanLinkContactJobImported$1,
	Prev: Prev$1,
	Next: Next$1,
	areYouSureUnlinkDocument: areYouSureUnlinkDocument$1,
	areYouSureDeleteDocument: areYouSureDeleteDocument$1,
	Category: Category$1,
	CreatedOn: CreatedOn$1,
	Joblinked: Joblinked$1,
	Quickactions: Quickactions$1,
	All: All$1,
	Resume: Resume$1,
	Portfolio: Portfolio$1,
	Other: Other$1,
	Adddocument: Adddocument$1,
	Type: Type$1,
	Sortingby: Sortingby$1,
	SwitchtoGridLayout: SwitchtoGridLayout$1,
	SwitchtoListLayout: SwitchtoListLayout$1,
	NoDocumentsAdded: NoDocumentsAdded$1,
	DocumentsComponent: DocumentsComponent$1,
	NoDocumentFound: NoDocumentFound$1,
	SelectFile: SelectFile$1,
	onlyPdfDocxSupported: onlyPdfDocxSupported$1,
	Uploadfile: Uploadfile$1,
	DocumentCategory: DocumentCategory$1,
	SaveDocument: SaveDocument$1,
	AddDocument: AddDocument$1,
	LinkedDocuments: LinkedDocuments$1,
	LinkDocument: LinkDocument$1,
	NodocumentsLinked: NodocumentsLinked$1,
	JobDocumentsComponent: JobDocumentsComponent$1,
	NoDocuments: NoDocuments$1,
	CreateDocuments: CreateDocuments$1,
	youCanLinkDocumentJobImported: youCanLinkDocumentJobImported$1,
	Documenteditedsuccessfully: Documenteditedsuccessfully$1,
	DocumentDetails: DocumentDetails$1,
	UnsavedChanges: UnsavedChanges$1,
	yourChangesWillBeLostSureClose: yourChangesWillBeLostSureClose$1,
	yourChangesWillBeLostSureDiscard: yourChangesWillBeLostSureDiscard$1,
	DiscardChanges: DiscardChanges$1,
	WeeklyGoalAlert: WeeklyGoalAlert$1,
	Progress: Progress$1,
	AllGoals: AllGoals$1,
	Name: Name$1,
	Completedon: Completedon$1,
	Createdon: Createdon$1,
	Action: Action$1,
	Back: Back$1,
	OverallScore: OverallScore$1,
	Aboutthegoal: Aboutthegoal$1,
	GoalTracking: GoalTracking$1,
	Week: Week$1,
	progress: progress$1,
	loading: loading$1,
	Apply: Apply$1,
	Thisskillhasbeenreported: Thisskillhasbeenreported$1,
	issueGettingResume: issueGettingResume$1,
	Interview: Interview$1,
	Tasks: Tasks$1,
	Loading: Loading$1,
	Skilladdedsuccessfully: Skilladdedsuccessfully$1,
	problemAddingSkill: problemAddingSkill$1,
	Reportaproblem: Reportaproblem$1,
	Submit: Submit$1,
	Addanewskill: Addanewskill$1,
	JobDetailsComponent: JobDetailsComponent$1,
	HardSkill: HardSkill$1,
	SoftSkill: SoftSkill$1,
	Pleaseshareanyadditionalcontext: Pleaseshareanyadditionalcontext$1,
	Addasskill: Addasskill$1,
	Skill: Skill$1,
	JobFrequency: JobFrequency$1,
	ResumeFrequency: ResumeFrequency$1,
	Reportskill: Reportskill$1,
	JobDetails: JobDetails$1,
	ViewJobLink: ViewJobLink$1,
	Salary: Salary$1,
	areYouSureDeleteJob: areYouSureDeleteJob$1,
	ViewMore: ViewMore$1,
	ViewLess: ViewLess$1,
	matchYouSkillsAgainstJob: matchYouSkillsAgainstJob$1,
	pleaseUploadResumeSkillMatch: pleaseUploadResumeSkillMatch$1,
	AddResume: AddResume$1,
	thisJobDoesNotHaveAnyDesc: thisJobDoesNotHaveAnyDesc$1,
	youCanEditJobToAdd: youCanEditJobToAdd$1,
	chromeextension: chromeextension$1,
	fromVariousJobPortalsOnce: fromVariousJobPortalsOnce$1,
	AddDescription: AddDescription$1,
	CompanyInfo: CompanyInfo$1,
	Website: Website$1,
	Industry: Industry$1,
	EmployeeCount: EmployeeCount$1,
	ExprienceLevel: ExprienceLevel$1,
	Address: Address$1,
	Resumes: Resumes$1,
	Setasdefault: Setasdefault$1,
	Ok: Ok$1,
	UploadNewResume: UploadNewResume$1,
	Default: Default$1,
	Jobnotfound: Jobnotfound$1,
	EditDetails: EditDetails$1,
	JobPostURL: JobPostURL$1,
	Enterjoburl: Enterjoburl$1,
	Nojobselected: Nojobselected$1,
	Viewjobdetails: Viewjobdetails$1,
	Jobaddedtoyourboardsuccessfully: Jobaddedtoyourboardsuccessfully$1,
	AddJob: AddJob$1,
	Addnewjobname: Addnewjobname$1,
	JobUrl: JobUrl$1,
	Addjoburl: Addjoburl$1,
	Section: Section$1,
	didYouKnow: didYouKnow$1,
	Jobs: Jobs$1,
	AddJobtoboard: AddJobtoboard$1,
	Currentlynojobsareavailable: Currentlynojobsareavailable$1,
	noMatchingJobs: noMatchingJobs$1,
	welcomeToYourPersonalJobTracker: welcomeToYourPersonalJobTracker$1,
	weShortTutorialOnHowTrackingJob: weShortTutorialOnHowTrackingJob$1,
	Addanewjob: Addanewjob$1,
	inOrderTrackCreatButton: inOrderTrackCreatButton$1,
	Providesomedetails: Providesomedetails$1,
	toBeginTypeJobTitleCompany: toBeginTypeJobTitleCompany$1,
	asAnExampleFilledForYou: asAnExampleFilledForYou$1,
	wohooAddedFirstJob: wohooAddedFirstJob$1,
	youCanDragDropJobCard: youCanDragDropJobCard$1,
	Lastbutnotleast: Lastbutnotleast$1,
	finalStepMakeSure: finalStepMakeSure$1,
	autoMaticallyImportJobs: autoMaticallyImportJobs$1,
	selectanysection: selectanysection$1,
	Accept: Accept$1,
	My2023JobSearch: My2023JobSearch$1,
	AddedFrom: AddedFrom$1,
	AddedUntil: AddedUntil$1,
	BasicModal: BasicModal$1,
	AddnewSectionName: AddnewSectionName$1,
	OpenTo: OpenTo$1,
	Featured: Featured$1,
	LicenceAndCerts: LicenceAndCerts$1,
	Banner: Banner$1,
	LinkedInURL: LinkedInURL$1,
	Recommendations: Recommendations$1,
	LinkedinReview: LinkedinReview$1,
	NoDataAvailable: NoDataAvailable$1,
	looksLikeYouDidNot: looksLikeYouDidNot$1,
	toOptimizeProfileScoreVisible: toOptimizeProfileScoreVisible$1,
	LinkedinComponent: LinkedinComponent$1,
	improveYourChancesLandingDreamJob: improveYourChancesLandingDreamJob$1,
	VisitProfile: VisitProfile$1,
	wantToGetLinkedinMakeover: wantToGetLinkedinMakeover$1,
	PostGenerator: PostGenerator$1,
	LinkedinHeadlineGenerator: LinkedinHeadlineGenerator$1,
	LinkedinAboutSectionGenerator: LinkedinAboutSectionGenerator$1,
	AITools: AITools$1,
	Premium: Premium$1,
	LinkedInOptimization: LinkedInOptimization$1,
	JobTracker: JobTracker$1,
	whoIsHiring: whoIsHiring$1,
	Autofill: Autofill$1,
	HeadlineGenerator: HeadlineGenerator$1,
	skillMatching: skillMatching$1,
	SummarizeJD: SummarizeJD$1,
	contactFeature: contactFeature$1,
	documentFeature: documentFeature$1,
	landJobWithoutStress: landJobWithoutStress$1,
	discoverFeatures: discoverFeatures$1,
	letsBeginOnboarding: letsBeginOnboarding$1,
	inTheNextFewScreensJobThirdParties: inTheNextFewScreensJobThirdParties$1,
	letsAddBasicInformation: letsAddBasicInformation$1,
	Pleaseselectanoptionfirst: Pleaseselectanoptionfirst$1,
	JobApplicationTracker: JobApplicationTracker$1,
	LinkedInProfileOptimizer: LinkedInProfileOptimizer$1,
	UnlimitedDocuments: UnlimitedDocuments$1,
	UnlimitedContacts: UnlimitedContacts$1,
	HiringManagerSearch: HiringManagerSearch$1,
	AILinkedInPostGenerator: AILinkedInPostGenerator$1,
	ATSKeywordSkillMatch: ATSKeywordSkillMatch$1,
	"Auto-Apply": "Automatisk ansökan",
	ChooseyourPlan: ChooseyourPlan$1,
	superChargeYourJobSearch: superChargeYourJobSearch$1,
	startNowGoto: startNowGoto$1,
	CreatedBy: CreatedBy$1,
	CreateNewNote: CreateNewNote$1,
	Nonotescreated: Nonotescreated$1,
	approxTimeIsFourMinutes: approxTimeIsFourMinutes$1,
	Continue: Continue$1,
	iWillDoLaterTakeMeToApp: iWillDoLaterTakeMeToApp$1,
	allDone: allDone$1,
	welcomeAbord: welcomeAbord$1,
	letsBegin: letsBegin$1,
	UpgradeyourplanandgetAIAssistance: UpgradeyourplanandgetAIAssistance$1,
	DownloadPDF: DownloadPDF$1,
	oopsWeCouldntProcessResume: oopsWeCouldntProcessResume$1,
	MyProfile: MyProfile$1,
	Setting: Setting$1,
	Logout: Logout$1,
	SignIn: SignIn$1,
	Typeyourfirstnamehere: Typeyourfirstnamehere$1,
	Enteryourlastname: Enteryourlastname$1,
	ManageSubscription: ManageSubscription$1,
	ifYouHaveDifficultiesProfile: ifYouHaveDifficultiesProfile$1,
	forSupport: forSupport$1,
	whatIsIdealCompanySize: whatIsIdealCompanySize$1,
	Saveandcontinue: Saveandcontinue$1,
	whatIsMinExpectedSalary: whatIsMinExpectedSalary$1,
	Atleast: Atleast$1,
	SlidetoAdjust: SlidetoAdjust$1,
	whatIndustryExcitedWork: whatIndustryExcitedWork$1,
	Add: Add$1,
	statusOfJobSearch: statusOfJobSearch$1,
	Finish: Finish$1,
	whatLevelRoleLooking: whatLevelRoleLooking$1,
	Selectuptotwo: Selectuptotwo$1,
	PreviousStep: PreviousStep$1,
	Skip: Skip$1,
	whatDoYouValueNewRole: whatDoYouValueNewRole$1,
	Selectuptothree: Selectuptothree$1,
	EqualEmploymentData: EqualEmploymentData$1,
	whatIsYourEthnicity: whatIsYourEthnicity$1,
	areYouAuthorizedToWorkUs: areYouAuthorizedToWorkUs$1,
	willYouRequireSponsorShip: willYouRequireSponsorShip$1,
	doYouHaveADisability: doYouHaveADisability$1,
	areYouAVeteran: areYouAVeteran$1,
	rolesYouInterestedIn: rolesYouInterestedIn$1,
	Selectuptofive: Selectuptofive$1,
	AddCustomrole: AddCustomrole$1,
	whereDoYouLikeWork: whereDoYouLikeWork$1,
	Resources: Resources$1,
	currentlyNoResourceAvailable: currentlyNoResourceAvailable$1,
	AddNewSection: AddNewSection$1,
	ChangeSections: ChangeSections$1,
	Settings: Settings$1,
	Dashboard: Dashboard$1,
	JobBoard: JobBoard$1,
	Linkedin: Linkedin$1,
	Community: Community$1,
	FindRecruiters: FindRecruiters$1,
	Goals: Goals$1,
	DownloadExtension: DownloadExtension$1,
	SuggestaFeature: SuggestaFeature$1,
	leftPanel: leftPanel$1,
	PhoneNumberisrequired: PhoneNumberisrequired$1,
	MobileNumber: MobileNumber$1,
	Enteronlynumbers: Enteronlynumbers$1,
	Countryyoulivein: Countryyoulivein$1,
	SelectaCountry: SelectaCountry$1,
	DateofBirth: DateofBirth$1,
	Gender: Gender$1,
	JobPreferences: JobPreferences$1,
	pleaseEnterValidEmail: pleaseEnterValidEmail$1,
	emailSendForResetting: emailSendForResetting$1,
	VerifyyourEmailID: VerifyyourEmailID$1,
	sentPleaseCheckEmail: sentPleaseCheckEmail$1,
	tooManyAttemptsTryAgain: tooManyAttemptsTryAgain$1,
	Resend: Resend$1,
	Login: Login$1,
	weHaveSentVerificationLinkAtEmail: weHaveSentVerificationLinkAtEmail$1,
	pleaseVerifyEmailContinueSpam: pleaseVerifyEmailContinueSpam$1,
	Logintogetstarted: Logintogetstarted$1,
	ContinuewithGoogle: ContinuewithGoogle$1,
	pleaseInputEmail: pleaseInputEmail$1,
	Password: Password$1,
	pleaseInputPassword: pleaseInputPassword$1,
	passwordLowerUpperDigitSpecial: passwordLowerUpperDigitSpecial$1,
	atLeastSixChar: atLeastSixChar$1,
	forgotPassword: forgotPassword$1,
	Bysigninginyouagreetoour: Bysigninginyouagreetoour$1,
	Terms: Terms$1,
	Conditions: Conditions$1,
	and: and$1,
	PrivacyPolicy: PrivacyPolicy$1,
	theseAreTheTopsSkillsExtracted: theseAreTheTopsSkillsExtracted$1,
	TopSkills: TopSkills$1,
	weCoulNotExtractSkills: weCoulNotExtractSkills$1,
	upgradeToPremiumToView: upgradeToPremiumToView$1,
	SkillScore: SkillScore$1,
	thisIsYourSkillScoreBasedOn: thisIsYourSkillScoreBasedOn$1,
	theseSkllsAreStrongMatch: theseSkllsAreStrongMatch$1,
	Strongmatch: Strongmatch$1,
	theseSkillsArePartialMatch: theseSkillsArePartialMatch$1,
	Partialmatch: Partialmatch$1,
	theseSkillsAreMissingFrom: theseSkillsAreMissingFrom$1,
	"Missing Keywords": "Saknade sökord",
	SkillMatchComponent: SkillMatchComponent$1,
	Optional: Optional$1,
	Notrelevanttothejob: Notrelevanttothejob$1,
	Notaskill: Notaskill$1,
	Toogeneric: Toogeneric$1,
	Pleaseshareanyfeedback: Pleaseshareanyfeedback$1,
	excludedKeywordsWillNot: excludedKeywordsWillNot$1,
	yesExcludeThisSkillFrom: yesExcludeThisSkillFrom$1,
	PartialMatch: PartialMatch$1,
	MissingKeywords: MissingKeywords$1,
	Providetitletotask: Providetitletotask$1,
	TasksList: TasksList$1,
	AddTask: AddTask$1,
	EnterTaskTitlehere: EnterTaskTitlehere$1,
	TasksComponent: TasksComponent$1,
	CompletedTasks: CompletedTasks$1,
	CompleteYourtasks: CompleteYourtasks$1,
	Steps: Steps$1,
	PremiumMember: PremiumMember$1,
	Thankyouforupgradingto: Thankyouforupgradingto$1,
	CareerflowPremium: CareerflowPremium$1,
	hereIsHowYouCanAccessPremium: hereIsHowYouCanAccessPremium$1,
	stepOne: stepOne$1,
	DownloadourChromeExtension: DownloadourChromeExtension$1,
	youJobSearchCopilotIshere: youJobSearchCopilotIshere$1,
	DownloadNow: DownloadNow$1,
	stepTwo: stepTwo$1,
	GetStarted: GetStarted$1,
	stepThree: stepThree$1,
	SignintoChromeExtension: SignintoChromeExtension$1,
	entityCreated: entityCreated$1,
	entityUpdated: entityUpdated$1,
	entityDeleted: entityDeleted$1,
	entityLinked: entityLinked$1,
	entityUnlinked: entityUnlinked$1,
	entityMovedTo: entityMovedTo$1,
	youAddedANewEntity: youAddedANewEntity$1,
	personCreated: personCreated$1,
	youUpdatedAEntity: youUpdatedAEntity$1,
	personUpdated: personUpdated$1,
	youDeletedAEntity: youDeletedAEntity$1,
	personDeleted: personDeleted$1,
	youLinkedEntity: youLinkedEntity$1,
	personLinked: personLinked$1,
	youUnlinked: youUnlinked$1,
	personUnlinked: personUnlinked$1,
	youMovedEntity: youMovedEntity$1,
	personMoved: personMoved$1,
	addedByName: addedByName$1,
	DownloadChromeExtension: DownloadChromeExtension$1,
	ourChromeExtensionIs: ourChromeExtensionIs$1,
	Optimizeyourprofile: Optimizeyourprofile$1,
	startOptimizingYourProfile: startOptimizingYourProfile$1,
	OptimizeNow: OptimizeNow$1,
	Addyourfirstjob: Addyourfirstjob$1,
	startSavingJobApplicationsToTrack: startSavingJobApplicationsToTrack$1,
	AddNow: AddNow$1,
	CompleteProfile: CompleteProfile$1,
	completeYourProfileForUsing: completeYourProfileForUsing$1,
	CompleteNow: CompleteNow$1,
	Addyourfirstcontact: Addyourfirstcontact$1,
	addContactToFollowUpWith: addContactToFollowUpWith$1,
	JoinCommunity: JoinCommunity$1,
	ourCommunityisAlways: ourCommunityisAlways$1,
	JoinNow: JoinNow$1,
	welcomeToCareerflow: welcomeToCareerflow$1,
	yourHubForCareerInsights2: yourHubForCareerInsights2$1,
	ChecklistCompleted: ChecklistCompleted$1,
	Completeyourchecklist: Completeyourchecklist$1,
	completeAFewStepsTo: completeAFewStepsTo$1,
	Completed: Completed$1,
	JobCountByStage: JobCountByStage$1,
	NopastapplicationDatafound: NopastapplicationDatafound$1,
	YourJobSearchStages: YourJobSearchStages$1,
	NoDatafound: NoDatafound$1
};

const copyToClipboard = "已复制到剪贴板！";
const UnlocktheAIgenerated = "解锁由人工智能生成的内容。";
const UpgradetoPremium = "升级至高级版";
const Result = "结果";
const Copy = "复制";
const Save = "保存";
const Edit = "编辑";
const Processing = "处理中";
const YourAIgeneratedcontentwillshowhere = "您的AI生成的内容将显示在这里";
const hopeYouFindUseful = "希望你觉得这个结果有用！";
const regenerate = "重新生成";
const ProvideAdditionalFeedback = "提供额外反馈";
const Enteranyfeedback = "输入任何反馈";
const Notimpressive = "不令人印象深刻";
const thisIsntTrue = "这不是真的";
const Notpersonalized = "不个性化";
const Tone = "语气";
const Length = "长度";
const Template = "模板";
const Generatedon = "生成于";
const Copiedtoclipboard = "复制到剪贴板";
const CopytoClipboard = "复制到剪贴板";
const DownloadasPDF = "下载为PDF";
const ViewDetails = "查看详情";
const JobDescriptionImported = "工作描述导入";
const ImportfromJob = "从工作导入";
const Saved = "已保存";
const Applied = "已申请";
const Offer = "提供";
const Interviewing = "面试";
const Rejected = "已拒绝";
const Search = "搜索";
const Import = "导入";
const CoverLetterGeneratorHistory = "求职信生成器历史记录";
const NoCoverLettersGenerated = "未生成求职信";
const getStartedCoverLetter = "您尚未生成任何求职信。开始匹配职位描述与您的相关经验，生成求职信。";
const getStarted = "开始吧！";
const Documents = "文档";
const UploadNewDocument = "上传新文档";
const AICoverLetterGenerator = "AI求职信生成器";
const ViewHistory = "查看历史记录";
const JobDescription = "职位描述";
const ImportfromBoard = "从板块导入";
const EnterJobDescription = "输入职位描述";
const JobTitle = "职位标题";
const EnterJobTitle = "输入职位标题";
const CompanyName = "公司名称";
const EnterCompanyName = "输入公司名称";
const YourProfile = "您的个人资料";
const ResumeUpload = "简历上传";
const UseLinkedinProfile = "使用Linkedin个人资料";
const Uploadyourresume = "上传您的简历";
const AddyourResume = "添加您的简历";
const fileNameCannotFormat = "文件名不能包含空格或下划线，应为.doc、.docx或.pdf格式。";
const ChooseorUpload = "选择或上传";
const SelectTemplate = "选择模板";
const Preview = "预览";
const UseTemplate = "使用模板";
const Change = "更改";
const AdvancedSettings = "高级设置";
const AdditionalContext = "附加上下文";
const Professional = "专业";
const Casual = "随意";
const Enthusiastic = "热情";
const Informational = "信息性";
const Short = "短";
const Medium = "中";
const Long = "长";
const Language = "语言";
const iAmOkayBack = "我没问题！返回";
const Generate = "生成";
const CoverLetter = "求职信";
const SelectLanguage = "选择语言";
const AboutGeneratorHistory = "关于生成器历史记录";
const NoAboutsGenerated = "未生成关于信息";
const getStartedAbouts = "您尚未生成任何关于信息。开始匹配职位描述与您的相关经验，生成关于信息。";
const noAttachmentsFound = "未找到附件。";
const TargetJobTitle = "目标职位标题";
const KeywordsToInclude = "“包含的关键词”";
const UploadYourResume = "上传您的简历";
const AddYourResume = "添加您的简历";
const LinkedinProfile = "Linkedin个人资料";
const Linkedinprofilenotfound = "未找到Linkedin个人资料";
const startUsingChromeExtension = "开始使用我们的Chrome扩展来优化您的Linkedin个人资料，以使用此选项。";
const Download = "下载";
const UseEmojis = "使用表情符号";
const UseBulletPoints = "使用项目符号";
const SpeechFocus = "语调重点";
const FirstPerson = "第一人称";
const ThirdPerson = "第三人称";
const HeadlineGeneratorHistory = "标题生成器历史记录";
const NoHeadlinesGenerated = "未生成标题";
const getStartedHeadline = "您尚未生成任何标题。开始匹配职位描述与您的相关经验，生成标题。";
const AIHeadlineGenerator = "AI标题生成器";
const KeywordstoInclude = "包含的关键词";
const Pressenteraftereachword = "在每个单词后按回车键。";
const LinkedinProfilenotfound = "未找到LinkedIn个人资料。";
const Headline = "标题";
const PostGeneratorHistory = "文章生成器历史记录";
const NoPostsGenerated = "未生成文章";
const getStartedPost = "您尚未生成任何文章。开始匹配职位描述与您的相关经验，生成文章。";
const Topic = "主题";
const Description = "描述";
const UseHashtags = "使用标签";
const Custom = "自定义";
const EnterCustomTone = "输入自定义语气";
const Added = "添加";
const ComingSoon = {
	header: "工程师正在努力工作！",
	content_1: "我们的工程团队正在努力工作，力图尽快启用此功能",
	content_2: "想要尽快使用此功能吗？通过简单勾选下面的复选框告诉我们。",
	content_3: "我想要这个功能"
};
const Company = "公司";
const JobInterview = "面试";
const Research = "研究";
const Networking = "社交网络";
const Referral = "推荐";
const MustbeContacted = "必须联系";
const ScheduleaMeeting = "安排会议";
const needAFollowUp = "需要跟进。";
const Today = "今天";
const Viewdetails = "查看详情";
const Activity = "活动";
const ActivityDetails = "活动详情";
const Delete = "删除";
const Title = "标题";
const Goal = "目标";
const Status = "状态";
const FollowUp = "跟进";
const AddActivity = "添加活动";
const Enteractivitytitle = "输入活动标题";
const Cancel = "取消";
const SaveActivity = "保存活动";
const noActivityPresent = "没有活动，添加活动。";
const Addnew = "添加新的";
const About = "关于";
const noDataPresentYou = "没有数据，您可以编辑此联系人并添加字段。";
const Experience = "经验";
const Education = "教育";
const Skills = "技能";
const Overview = "概述";
const LinkedJobs = "关联的职位";
const Notes = "备注";
const FullName = "全名";
const Location = "地点";
const Relationship = "关系";
const Contacts = "联系人";
const CreateContact = "创建联系人";
const NotesCreated = "备注已创建";
const Notesupdated = "备注已更新";
const Addnote = "添加备注";
const areYouSureDeleteNote = "您确定要删除这个笔记吗？";
const Createdby = "创建者";
const notSureWhyResumeCalls = "不确定为什么你的简历没有得到面试电话？☎️";
const getExpertResumeReview = "获取专业的简历审核 💎✨";
const youHaventAddedContacts = "你还没有添加任何联系人。";
const noMatchingContacts = "未找到匹配的联系人。";
const Link = "链接";
const unlink = "取消链接";
const Locationnotavailable = "位置不可用";
const Emailnotavailable = "电子邮件不可用";
const PhoneNumbernotavailable = "电话号码不可用";
const createdby = "创建者";
const areYouSureDeleteContact = "您确定要删除此联系人吗？";
const areYouSureUnlinkContact = "您确定要取消链接此联系人吗？";
const Addedbyyou = "由您添加";
const Addedby = "添加者";
const Timeline = "时间轴";
const Timelineempty = "时间轴为空。";
const Discard = "丢弃";
const SaveContact = "保存联系人";
const Recruiter = "招聘人员";
const Candidate = "候选人";
const Colleague = "同事";
const Employee = "员工";
const EnterValidEmail = "输入有效的电子邮件";
const EnterValidPhoneNumber = "输入有效的电话号码";
const editingProfileNotAvailable = "编辑个人资料照片目前还不可用。";
const itWillBeSoonAvailable = "它很快就会在我们这里提供。";
const ChromeExtension = "Chrome扩展程序";
const SelectTag = "选择标签";
const FirstName = "名字";
const FirstNameisrequired = "名字是必需的";
const LastName = "姓氏";
const LastNameisrequired = "姓氏是必需的";
const Companyisrequired = "公司是必需的。";
const Email = "电子邮件";
const ThisisnotavalidEmail = "这不是一个有效的电子邮件。";
const AddEmail = "添加电子邮件";
const PhoneNumber = "电话号码";
const notaValidPhone = "这不是一个有效的电话号码，请只输入数字。";
const phoneNoMinimum5char = "电话号码必须至少为5个字符。";
const phoneNoMinumum15char = "电话号码最多不能超过15个字符。";
const AddPhoneNumber = "添加电话号码";
const SelectGoal = "选择目标";
const SelectStatus = "选择状态";
const Followup = "后续";
const SocialMedia = "社交媒体";
const Linkedinhandle = "领英账号";
const Twitterhandle = "Twitter用户名";
const Facebookhandle = "Facebook用户名";
const Githubhandle = "Github用户名";
const Gmailhandle = "Gmail用户名";
const Changessavedsuccessfully = "更改已成功保存";
const EditContact = "编辑联系人";
const BasicInformation = "基本信息";
const EditContactDetails = "编辑联系人详情";
const SaveChanges = "保存更改";
const phoneNoMinimum14char = "电话号码必须至少为14个字符。";
const LinkedIn = "LinkedIn";
const Twitter = "推特";
const Facebook = "Facebook";
const Github = "Github（GitHub）";
const Gmail = "Gmail（谷歌邮件）";
const youCanWriteAbout = "你可以写关于你的工作经验、行业或技能。人们也会谈论他们的成就或以前的工作经历。";
const Addednewsection = "新增章节";
const Removedsuccessfully = "成功移除。";
const Remove = "移除";
const Institute = "学院";
const Schoolisrequired = "学校是必须的。";
const Degree = "学位";
const StartMonth = "开始月份";
const StartYear = "开始年份";
const EndMonth = "月末";
const EndYear = "年末";
const Addmore = "添加更多";
const PositionTitle = "职位名称";
const ExperienceType = "体验类型";
const Addednewitem = "添加了新项目";
const whatSkillsDoYouEnjoy = "你有哪些技能或喜欢从事哪些工作？";
const Typeskillshere = "在此处输入技能";
const LinkedContacts = "关联的联系人";
const LinkContact = "关联联系人";
const NocontactsLinked = "未关联联系人";
const JobContactsComponent = {
	linkContact: "通过关联联系人，您可以快速了解此角色的重要人物，如招聘人员、招聘经理等！将来，我们将能够根据您的联系人提供相关的见解。"
};
const Nocontacts = "没有联系人。";
const LinkJobto = "将工作链接到";
const Contact = "联系方式";
const Document = "文档";
const Nojobsfound = "未找到职位";
const LinkJob = "关联职位";
const youCanLinkContactJobImported = "您可以将此联系人链接到您在Careerflow中导入的工作。";
const Prev = "之前";
const Next = "下一个";
const areYouSureUnlinkDocument = "您确定要取消链接此文档吗？";
const areYouSureDeleteDocument = "您确定要删除此文档吗？";
const Category = "类别";
const CreatedOn = "创建日期";
const Joblinked = "工作链接";
const Quickactions = "快速操作";
const All = "全部";
const Resume = "简历";
const Portfolio = "作品集";
const Other = "其他";
const Adddocument = "添加文档";
const Type = "类型";
const Sortingby = "按照排序";
const SwitchtoGridLayout = "切换到网格布局";
const SwitchtoListLayout = "切换到列表布局";
const NoDocumentsAdded = "未添加文档";
const DocumentsComponent = {
	nodocs: "您尚未创建任何文档。您可以上传您的简历版本、求职信等，并将它们与您正在追踪的职位关联起来！"
};
const NoDocumentFound = "未找到文件。";
const SelectFile = "选择文件";
const onlyPdfDocxSupported = "仅支持 .pdf 和 .docx 格式。";
const Uploadfile = "上传文件";
const DocumentCategory = "文档类别";
const SaveDocument = "保存文档";
const AddDocument = "添加文档";
const LinkedDocuments = "关联文档";
const LinkDocument = "关联文档";
const NodocumentsLinked = "未关联文档";
const JobDocumentsComponent = {
	linkDocs: "关联您为此职位提交的所有相关文档，如简历、求职信等，将帮助您在一个地方跟踪所有信息。尝试一下！"
};
const NoDocuments = "无文件";
const CreateDocuments = "创建文件";
const youCanLinkDocumentJobImported = "您可以将此文档链接到您在Careerflow中导入的工作。";
const Documenteditedsuccessfully = "文档编辑成功。";
const DocumentDetails = "“文件详情”";
const UnsavedChanges = "未保存的更改";
const yourChangesWillBeLostSureClose = "您的更改将会丢失，您确定要关闭吗？";
const yourChangesWillBeLostSureDiscard = "您的更改将会丢失，您确定要放弃更改吗？";
const DiscardChanges = "放弃更改";
const WeeklyGoalAlert = "每周目标提醒";
const Progress = "进步";
const AllGoals = "所有目标";
const Name = "姓名";
const Completedon = "完成于";
const Createdon = "创建于";
const Action = "操作";
const Back = "返回";
const OverallScore = "总分";
const Aboutthegoal = "关于目标";
const GoalTracking = "目标跟踪";
const Week = "周";
const progress = "进展";
const loading = "加载中";
const Apply = "申请";
const Thisskillhasbeenreported = "这项技能已被报告。";
const issueGettingResume = "获取简历时出现了问题。";
const Interview = "面试";
const Tasks = "任务";
const Loading = "加载中";
const Skilladdedsuccessfully = "技能已成功添加。";
const problemAddingSkill = "添加技能时出现了问题。";
const Reportaproblem = "报告问题";
const Submit = "提交";
const Addanewskill = "添加新技能";
const JobDetailsComponent = {
	classifySkill: "你会如何分类这项技能（可选）？",
	includedKeywordsWillCount: "包括这个关键词吗？",
	yesIncludeThisSkill: "包含的关键词将会影响您未来所有扫描的匹配得分。您可以从您的个人资料中更改包含的关键词。",
	addSkill: "你想将这个添加为技能吗？"
};
const HardSkill = "硬技能";
const SoftSkill = "软技能";
const Pleaseshareanyadditionalcontext = "请分享任何额外的背景";
const Addasskill = "添加为技能";
const Skill = "技能";
const JobFrequency = "工作频率";
const ResumeFrequency = "简历频率";
const Reportskill = "报告技能";
const JobDetails = "工作详情";
const ViewJobLink = "查看工作链接";
const Salary = "薪水";
const areYouSureDeleteJob = "您确定要删除此工作吗？";
const ViewMore = "查看更多";
const ViewLess = "查看更少";
const matchYouSkillsAgainstJob = "将你的技能与工作描述进行匹配。";
const pleaseUploadResumeSkillMatch = "请上传您的简历以获取技能匹配分数。";
const AddResume = "添加简历";
const thisJobDoesNotHaveAnyDesc = "这份工作没有任何描述。";
const youCanEditJobToAdd = "您可以编辑此工作并添加描述。您还可以使用我们的导入工作功能。";
const chromeextension = "Chrome扩展程序";
const fromVariousJobPortalsOnce = "从各种职位门户网站获取。一旦您添加了描述，您还可以看到与技能相关的信息。";
const AddDescription = "添加描述";
const CompanyInfo = "公司信息";
const Website = "网站";
const Industry = "行业";
const EmployeeCount = "员工人数";
const ExprienceLevel = "经验水平";
const Address = "地址";
const Resumes = "简历";
const Setasdefault = "设为默认";
const Ok = "确定";
const UploadNewResume = "上传新简历";
const Default = "默认";
const Jobnotfound = "未找到工作。";
const EditDetails = "编辑详细信息";
const JobPostURL = "工作发布网址";
const Enterjoburl = "输入工作网址";
const Nojobselected = "未选择工作。";
const Viewjobdetails = "查看职位详情";
const Jobaddedtoyourboardsuccessfully = "工作已成功添加到您的板上。";
const AddJob = "添加工作";
const Addnewjobname = "添加新的工作名称。";
const JobUrl = "工作链接";
const Addjoburl = "添加工作链接";
const Section = "部分";
const didYouKnow = {
	chromeExtension: "你知道吗？你还可以直接从我们的Chrome扩展中保存工作，并在单击一次时导入所有数据！只需几秒钟。"
};
const Jobs = "工作";
const AddJobtoboard = "将工作添加到板上。";
const Currentlynojobsareavailable = "目前没有可用的工作。";
const noMatchingJobs = "未找到匹配的工作。";
const welcomeToYourPersonalJobTracker = "欢迎来到您的个人工作追踪器！";
const weShortTutorialOnHowTrackingJob = "我们将通过几个简单的步骤为您介绍如何开始跟踪您的求职申请！";
const Addanewjob = "添加新工作";
const inOrderTrackCreatButton = "为了开始跟踪工作申请，您需要先通过点击“创建”按钮将其添加到面板中。";
const Providesomedetails = "提供一些细节。";
const toBeginTypeJobTitleCompany = "首先，只需输入职位名称、公司名称和您想要添加的状态。您可以稍后添加更多细节，但现在这就足够了！";
const asAnExampleFilledForYou = "例如，我们已经为您填写了这个！";
const wohooAddedFirstJob = "哇哦！你已经将第一份工作添加到了你的工作追踪器中！";
const youCanDragDropJobCard = "现在您可以将工作卡片拖放到工作申请流程的各个阶段中。单击工作卡片将允许您查看更多细节，编辑它们，保存笔记等！";
const Lastbutnotleast = "最后但并非最不重要的";
const finalStepMakeSure = "作为最后一步，请确保您拥有我们的。";
const autoMaticallyImportJobs = "这将允许您自动从您喜爱的职位搜索网站（如LinkedIn、Indeed等）导入工作！我们的扩展还可以帮助您改善LinkedIn个人资料，并获得2.5倍的搜索出现率！";
const selectanysection = "选择任何部分。";
const Accept = "接受";
const My2023JobSearch = "我的2023年求职";
const AddedFrom = "“添加自”";
const AddedUntil = "添加至";
const BasicModal = "基本模态";
const AddnewSectionName = "添加新部分名称";
const OpenTo = "开放给";
const Featured = "精选";
const LicenceAndCerts = "许可证和证书";
const Banner = "横幅";
const LinkedInURL = "LinkedIn URL";
const Recommendations = "推荐";
const LinkedinReview = "领英评论";
const NoDataAvailable = "无数据可用。";
const looksLikeYouDidNot = "看起来你还没有开始使用我们的。";
const toOptimizeProfileScoreVisible = "如果您还没有优化您的LinkedIn个人资料，请先这样做。一旦您完成，您的个人资料得分将在此处显示。";
const LinkedinComponent = {
	letsOptimize: "让我们优化"
};
const improveYourChancesLandingDreamJob = "提高你实现梦想工作的机会。使用这些经过验证的策略，为你的领英个人资料进行必要的改进。";
const VisitProfile = "访问个人资料";
const wantToGetLinkedinMakeover = "想要进行完整的领英改造吗？";
const PostGenerator = "文章生成器";
const LinkedinHeadlineGenerator = "LinkedIn 标题生成器";
const LinkedinAboutSectionGenerator = "LinkedIn 个人简介生成器";
const AITools = "人工智能工具";
const Premium = "高级的";
const LinkedInOptimization = "领英优化";
const JobTracker = "工作跟踪器";
const whoIsHiring = "谁在招聘";
const Autofill = "自动填充";
const HeadlineGenerator = "标题生成器";
const skillMatching = "技能匹配";
const SummarizeJD = "工作描述摘要";
const contactFeature = "接触追踪";
const documentFeature = "文件";
const landJobWithoutStress = "实现你的梦想工作。无压力。";
const discoverFeatures = "发现Careerflow.ai的一系列功能，旨在简化您的求职过程并增强您的职业发展！";
const letsBeginOnboarding = "让我们更好地了解你！";
const inTheNextFewScreensJobThirdParties = "在接下来的几个屏幕中，我们将会问您一些问题，这将帮助我们为您量身定制体验，并自动填充您的工作申请（这样您就不必自己填写了）！我们不会将您的数据出售给任何第三方。";
const letsAddBasicInformation = "让我们添加您的基本信息。";
const Pleaseselectanoptionfirst = "请先选择一个选项。";
const JobApplicationTracker = "职位申请追踪器";
const LinkedInProfileOptimizer = "领英个人资料优化师";
const UnlimitedDocuments = "无限文档";
const UnlimitedContacts = "无限联系人";
const HiringManagerSearch = "招聘经理搜索";
const AILinkedInPostGenerator = "AI LinkedIn帖子生成器";
const ATSKeywordSkillMatch = "ATS关键词/技能匹配工作";
const ChooseyourPlan = "选择您的计划。";
const superChargeYourJobSearch = "通过Careerflow的高级工具包，让您的求职过程更加高效，提高面试机会，实现梦想工作。";
const startNowGoto = "立即开始（前往应用程序）";
const CreatedBy = "创建者";
const CreateNewNote = "创建新注释";
const Nonotescreated = "未创建注释";
const approxTimeIsFourMinutes = "完成入职流程的大约时间为4分钟。";
const Continue = "继续";
const iWillDoLaterTakeMeToApp = "我稍后会做这个。带我去应用程序。";
const allDone = "完成了！";
const welcomeAbord = "欢迎加入！";
const letsBegin = "让我们开始。";
const UpgradeyourplanandgetAIAssistance = "升级您的计划并获得人工智能辅助。";
const DownloadPDF = "下载PDF";
const oopsWeCouldntProcessResume = "哎呀，我们无法处理这份简历。";
const MyProfile = "我的个人资料";
const Setting = "设置";
const Logout = "注销";
const SignIn = "登录";
const Typeyourfirstnamehere = "你的名字";
const Enteryourlastname = "您的姓氏";
const ManageSubscription = "管理订阅";
const ifYouHaveDifficultiesProfile = "如果您在个人资料信息方面遇到任何困难，请联系";
const forSupport = "支持。";
const whatIsIdealCompanySize = "你理想的公司规模是多少？";
const Saveandcontinue = "保存并继续";
const whatIsMinExpectedSalary = "你期望的最低年薪是多少？";
const Atleast = "至少";
const SlidetoAdjust = "滑动调整";
const whatIndustryExcitedWork = "你觉得哪些行业很令人兴奋？";
const Add = "添加";
const statusOfJobSearch = "你的求职状况如何？";
const Finish = "完成";
const whatLevelRoleLooking = "你在寻找什么级别的角色？";
const Selectuptotwo = "选择最多两个。";
const PreviousStep = "上一步";
const Skip = "跳过";
const whatDoYouValueNewRole = "你在新角色中看重什么？";
const Selectuptothree = "选择最多三个。";
const EqualEmploymentData = "平等就业数据";
const whatIsYourEthnicity = "你的种族是什么？";
const areYouAuthorizedToWorkUs = "你有在美国工作的授权吗？";
const willYouRequireSponsorShip = "您现在或将来是否需要赞助雇佣签证身份？";
const doYouHaveADisability = "你有残疾吗？";
const areYouAVeteran = "你是退伍军人吗？";
const rolesYouInterestedIn = "你对什么样的角色感兴趣？";
const Selectuptofive = "选择最多五个。";
const AddCustomrole = "添加自定义角色";
const whereDoYouLikeWork = "你想在哪里工作？";
const Resources = "资源";
const currentlyNoResourceAvailable = "目前没有可用的资源。";
const AddNewSection = "添加新部分";
const ChangeSections = "更改章节";
const Settings = "设置";
const Dashboard = "仪表板";
const JobBoard = "招聘板";
const Linkedin = "领英";
const Community = "社区";
const FindRecruiters = "寻找招聘人员";
const Goals = "目标";
const DownloadExtension = "下载扩展";
const SuggestaFeature = "建议功能";
const leftPanel = {
	ReportanIssue: "报告问题"
};
const PhoneNumberisrequired = "需要电话号码。";
const MobileNumber = "手机号码";
const Enteronlynumbers = "只输入数字。";
const Countryyoulivein = "你居住的国家";
const SelectaCountry = "选择一个国家。";
const DateofBirth = "出生日期";
const Gender = "性别";
const JobPreferences = "工作偏好";
const pleaseEnterValidEmail = "请输入有效的电子邮件。";
const emailSendForResetting = "已向您发送了重置密码的电子邮件。";
const VerifyyourEmailID = "验证您的电子邮件ID。";
const sentPleaseCheckEmail = "已发送！请查看您的电子邮件。";
const tooManyAttemptsTryAgain = "尝试次数过多，请稍后再试。";
const Resend = "重新发送";
const Login = "登录";
const weHaveSentVerificationLinkAtEmail = "我们已经向您的电子邮件发送了验证链接。";
const pleaseVerifyEmailContinueSpam = "请验证您的电子邮件以继续。还请检查垃圾邮件或促销邮件以获取验证电子邮件。";
const Logintogetstarted = "登录开始";
const ContinuewithGoogle = "继续使用谷歌。";
const pleaseInputEmail = "请输入您的电子邮件！";
const Password = "密码";
const pleaseInputPassword = "请输入您的密码！";
const passwordLowerUpperDigitSpecial = "您的密码必须包含至少一个小写字母、一个大写字母、一个数字和一个特殊字符。";
const atLeastSixChar = "至少6个字符。";
const forgotPassword = "忘记密码？";
const Bysigninginyouagreetoour = "通过登录，您同意我们的";
const Terms = "条款";
const Conditions = "条件";
const and = "and";
const PrivacyPolicy = "隐私政策";
const theseAreTheTopsSkillsExtracted = "这些是从工作描述中提取出来的顶级技能。";
const TopSkills = "顶尖技能";
const weCoulNotExtractSkills = "我们无法从这份工作描述中提取任何技能。";
const upgradeToPremiumToView = "升级到高级版，查看您的简历技能匹配得分。";
const SkillScore = "技能评分";
const thisIsYourSkillScoreBasedOn = "这是基于工作描述和您的简历的技能评分。";
const theseSkllsAreStrongMatch = "这些技能与您的简历和工作描述非常匹配。";
const Strongmatch = "强匹配";
const theseSkillsArePartialMatch = "这些技能是你的简历和工作描述之间的部分匹配。";
const Partialmatch = "部分匹配";
const theseSkillsAreMissingFrom = "您的简历中缺少这些关键词，但它们在职位描述中出现。它们可能是与工作机会相关的技能或通用关键词，将它们添加到您的简历可能会有所帮助。";
const SkillMatchComponent = {
	removeSkill: "报告此关键词的问题的主要原因是什么"
};
const Optional = "可选";
const Notrelevanttothejob = "与工作不相关";
const Notaskill = "无技能";
const Toogeneric = "太泛泛";
const Pleaseshareanyfeedback = "请分享任何反馈";
const excludedKeywordsWillNot = "排除的关键词将不会影响您未来所有扫描的匹配得分。您可以从您的个人资料中更改排除的关键词。";
const yesExcludeThisSkillFrom = "是的，请从所有简历扫描中排除这项技能。";
const PartialMatch = "部分匹配";
const MissingKeywords = "缺少关键词";
const Providetitletotask = "提供任务标题";
const TasksList = "任务清单";
const AddTask = "添加任务";
const EnterTaskTitlehere = "在此输入任务标题";
const TasksComponent = {
	listEmpty: "任务列表为空，请创建新任务。"
};
const CompletedTasks = "已完成的任务";
const CompleteYourtasks = "完成您的任务";
const Steps = "步骤";
const PremiumMember = "高级会员";
const Thankyouforupgradingto = "感谢您升级到";
const CareerflowPremium = "职业流动高级版";
const hereIsHowYouCanAccessPremium = "这是如何访问您的高级会员福利！";
const stepOne = "第一步";
const DownloadourChromeExtension = "下载我们的Chrome扩展程序。";
const youJobSearchCopilotIshere = "你的求职AI副驾驶已经到位了。";
const DownloadNow = "立即下载";
const stepTwo = "第二步";
const GetStarted = "开始";
const stepThree = "第三步";
const SignintoChromeExtension = "登录Chrome扩展程序。";
const entityCreated = "新建{{entity}}。";
const entityUpdated = "{{entity}} 已更新。";
const entityDeleted = "{{entity}}已删除。";
const entityLinked = "{{实体}}链接";
const entityUnlinked = "{{entity}}已取消关联。";
const entityMovedTo = "转移到{{entity}}。";
const youAddedANewEntity = "您添加了一个新的{{实体}}。";
const personCreated = "{{creator}} 为 {{owner}} 创建了一个 {{entity}}。";
const youUpdatedAEntity = "您更新了一个{{entity}}。";
const personUpdated = "{{creator}} 更新了 {{owner}} 的 {{entity}}。";
const youDeletedAEntity = "您删除了一个{{entity}}。";
const personDeleted = "{{creator}} 删除了 {{owner}} 的 {{entity}}。";
const youLinkedEntity = "您将{{entity}}链接到了此工作。";
const personLinked = "{{creator}}将{{entity}}链接到了{{owner}}的工作中。";
const youUnlinked = "您已将{{entity}}与此工作取消关联。";
const personUnlinked = "{{creator}} 取消了与此工作的 {{owner}} 的 {{entity}} 的关联。";
const youMovedEntity = "你把这个{{entity}}从{{sectionFrom}}移动到{{sectionTo}}。";
const personMoved = "{{creator}} 将此 {{entity}} 从 {{sectionFrom}} 移动到 {{sectionTo}}，属于 {{owner}}";
const addedByName = "由{{name}}添加";
const DownloadChromeExtension = "下载Chrome扩展程序";
const ourChromeExtensionIs = "我们的Chrome扩展是一个集成工具，帮助您优化LinkedIn个人资料，保存工作，保存联系人，生成求职信等等。";
const Optimizeyourprofile = "优化您的个人资料";
const startOptimizingYourProfile = "开始优化您的个人资料，以增加被招聘人员联系的机会。";
const OptimizeNow = "立即优化";
const Addyourfirstjob = "添加你的第一份工作。";
const startSavingJobApplicationsToTrack = "开始保存工作申请以跟踪您的求职旅程并找到有用的见解。";
const AddNow = "立即添加";
const CompleteProfile = "完整资料";
const completeYourProfileForUsing = "完善您的个人资料以使用自动填充功能并获得更个性化的体验。";
const CompleteNow = "现在完成。";
const Addyourfirstcontact = "添加您的第一个联系人。";
const addContactToFollowUpWith = "添加联系人以便以后跟进，添加备注等。";
const JoinCommunity = "加入社区";
const ourCommunityisAlways = "我们的社区将一直与您同行，陪伴您的求职之旅。";
const JoinNow = "立即加入";
const welcomeToCareerflow = "欢迎来到Careerflow！";
const yourHubForCareerInsights2 = "这是您职业洞察、活动等的中心。探索您的个性化仪表板，以保持职业旅程的领先地位。";
const ChecklistCompleted = "你的清单已完成！";
const Completeyourchecklist = "完成你的清单。";
const completeAFewStepsTo = "完成几个步骤，找到你的下一份工作。";
const Completed = "已完成";
const JobCountByStage = "阶段性工作计数";
const NopastapplicationDatafound = "未找到过去的应用数据。";
const YourJobSearchStages = "您的求职阶段";
const NoDatafound = "未找到数据。";
const zh = {
	copyToClipboard: copyToClipboard,
	UnlocktheAIgenerated: UnlocktheAIgenerated,
	UpgradetoPremium: UpgradetoPremium,
	Result: Result,
	Copy: Copy,
	Save: Save,
	Edit: Edit,
	Processing: Processing,
	YourAIgeneratedcontentwillshowhere: YourAIgeneratedcontentwillshowhere,
	hopeYouFindUseful: hopeYouFindUseful,
	regenerate: regenerate,
	ProvideAdditionalFeedback: ProvideAdditionalFeedback,
	Enteranyfeedback: Enteranyfeedback,
	Notimpressive: Notimpressive,
	thisIsntTrue: thisIsntTrue,
	Notpersonalized: Notpersonalized,
	Tone: Tone,
	Length: Length,
	Template: Template,
	Generatedon: Generatedon,
	Copiedtoclipboard: Copiedtoclipboard,
	CopytoClipboard: CopytoClipboard,
	DownloadasPDF: DownloadasPDF,
	ViewDetails: ViewDetails,
	JobDescriptionImported: JobDescriptionImported,
	ImportfromJob: ImportfromJob,
	Saved: Saved,
	Applied: Applied,
	Offer: Offer,
	Interviewing: Interviewing,
	Rejected: Rejected,
	Search: Search,
	Import: Import,
	CoverLetterGeneratorHistory: CoverLetterGeneratorHistory,
	NoCoverLettersGenerated: NoCoverLettersGenerated,
	getStartedCoverLetter: getStartedCoverLetter,
	getStarted: getStarted,
	Documents: Documents,
	UploadNewDocument: UploadNewDocument,
	AICoverLetterGenerator: AICoverLetterGenerator,
	ViewHistory: ViewHistory,
	JobDescription: JobDescription,
	ImportfromBoard: ImportfromBoard,
	EnterJobDescription: EnterJobDescription,
	JobTitle: JobTitle,
	EnterJobTitle: EnterJobTitle,
	CompanyName: CompanyName,
	EnterCompanyName: EnterCompanyName,
	YourProfile: YourProfile,
	ResumeUpload: ResumeUpload,
	UseLinkedinProfile: UseLinkedinProfile,
	Uploadyourresume: Uploadyourresume,
	AddyourResume: AddyourResume,
	fileNameCannotFormat: fileNameCannotFormat,
	ChooseorUpload: ChooseorUpload,
	SelectTemplate: SelectTemplate,
	Preview: Preview,
	UseTemplate: UseTemplate,
	Change: Change,
	AdvancedSettings: AdvancedSettings,
	AdditionalContext: AdditionalContext,
	Professional: Professional,
	Casual: Casual,
	Enthusiastic: Enthusiastic,
	Informational: Informational,
	Short: Short,
	Medium: Medium,
	Long: Long,
	Language: Language,
	iAmOkayBack: iAmOkayBack,
	Generate: Generate,
	CoverLetter: CoverLetter,
	SelectLanguage: SelectLanguage,
	AboutGeneratorHistory: AboutGeneratorHistory,
	NoAboutsGenerated: NoAboutsGenerated,
	getStartedAbouts: getStartedAbouts,
	noAttachmentsFound: noAttachmentsFound,
	TargetJobTitle: TargetJobTitle,
	KeywordsToInclude: KeywordsToInclude,
	UploadYourResume: UploadYourResume,
	AddYourResume: AddYourResume,
	LinkedinProfile: LinkedinProfile,
	Linkedinprofilenotfound: Linkedinprofilenotfound,
	startUsingChromeExtension: startUsingChromeExtension,
	Download: Download,
	UseEmojis: UseEmojis,
	UseBulletPoints: UseBulletPoints,
	SpeechFocus: SpeechFocus,
	FirstPerson: FirstPerson,
	ThirdPerson: ThirdPerson,
	HeadlineGeneratorHistory: HeadlineGeneratorHistory,
	NoHeadlinesGenerated: NoHeadlinesGenerated,
	getStartedHeadline: getStartedHeadline,
	AIHeadlineGenerator: AIHeadlineGenerator,
	KeywordstoInclude: KeywordstoInclude,
	Pressenteraftereachword: Pressenteraftereachword,
	LinkedinProfilenotfound: LinkedinProfilenotfound,
	Headline: Headline,
	PostGeneratorHistory: PostGeneratorHistory,
	NoPostsGenerated: NoPostsGenerated,
	getStartedPost: getStartedPost,
	Topic: Topic,
	Description: Description,
	UseHashtags: UseHashtags,
	Custom: Custom,
	EnterCustomTone: EnterCustomTone,
	Added: Added,
	ComingSoon: ComingSoon,
	Company: Company,
	JobInterview: JobInterview,
	Research: Research,
	Networking: Networking,
	Referral: Referral,
	MustbeContacted: MustbeContacted,
	ScheduleaMeeting: ScheduleaMeeting,
	needAFollowUp: needAFollowUp,
	Today: Today,
	Viewdetails: Viewdetails,
	Activity: Activity,
	ActivityDetails: ActivityDetails,
	Delete: Delete,
	Title: Title,
	Goal: Goal,
	Status: Status,
	FollowUp: FollowUp,
	AddActivity: AddActivity,
	Enteractivitytitle: Enteractivitytitle,
	Cancel: Cancel,
	SaveActivity: SaveActivity,
	noActivityPresent: noActivityPresent,
	Addnew: Addnew,
	About: About,
	noDataPresentYou: noDataPresentYou,
	Experience: Experience,
	Education: Education,
	Skills: Skills,
	Overview: Overview,
	LinkedJobs: LinkedJobs,
	Notes: Notes,
	FullName: FullName,
	Location: Location,
	Relationship: Relationship,
	Contacts: Contacts,
	CreateContact: CreateContact,
	NotesCreated: NotesCreated,
	Notesupdated: Notesupdated,
	Addnote: Addnote,
	areYouSureDeleteNote: areYouSureDeleteNote,
	Createdby: Createdby,
	notSureWhyResumeCalls: notSureWhyResumeCalls,
	getExpertResumeReview: getExpertResumeReview,
	youHaventAddedContacts: youHaventAddedContacts,
	noMatchingContacts: noMatchingContacts,
	Link: Link,
	unlink: unlink,
	Locationnotavailable: Locationnotavailable,
	Emailnotavailable: Emailnotavailable,
	PhoneNumbernotavailable: PhoneNumbernotavailable,
	createdby: createdby,
	areYouSureDeleteContact: areYouSureDeleteContact,
	areYouSureUnlinkContact: areYouSureUnlinkContact,
	Addedbyyou: Addedbyyou,
	Addedby: Addedby,
	Timeline: Timeline,
	Timelineempty: Timelineempty,
	Discard: Discard,
	SaveContact: SaveContact,
	Recruiter: Recruiter,
	Candidate: Candidate,
	Colleague: Colleague,
	Employee: Employee,
	"Needtofollow-up": "需要跟进",
	EnterValidEmail: EnterValidEmail,
	EnterValidPhoneNumber: EnterValidPhoneNumber,
	editingProfileNotAvailable: editingProfileNotAvailable,
	itWillBeSoonAvailable: itWillBeSoonAvailable,
	ChromeExtension: ChromeExtension,
	SelectTag: SelectTag,
	FirstName: FirstName,
	FirstNameisrequired: FirstNameisrequired,
	LastName: LastName,
	LastNameisrequired: LastNameisrequired,
	Companyisrequired: Companyisrequired,
	Email: Email,
	ThisisnotavalidEmail: ThisisnotavalidEmail,
	AddEmail: AddEmail,
	PhoneNumber: PhoneNumber,
	notaValidPhone: notaValidPhone,
	phoneNoMinimum5char: phoneNoMinimum5char,
	phoneNoMinumum15char: phoneNoMinumum15char,
	AddPhoneNumber: AddPhoneNumber,
	SelectGoal: SelectGoal,
	SelectStatus: SelectStatus,
	Followup: Followup,
	SocialMedia: SocialMedia,
	Linkedinhandle: Linkedinhandle,
	Twitterhandle: Twitterhandle,
	Facebookhandle: Facebookhandle,
	Githubhandle: Githubhandle,
	Gmailhandle: Gmailhandle,
	Changessavedsuccessfully: Changessavedsuccessfully,
	EditContact: EditContact,
	BasicInformation: BasicInformation,
	EditContactDetails: EditContactDetails,
	SaveChanges: SaveChanges,
	phoneNoMinimum14char: phoneNoMinimum14char,
	LinkedIn: LinkedIn,
	Twitter: Twitter,
	Facebook: Facebook,
	Github: Github,
	Gmail: Gmail,
	youCanWriteAbout: youCanWriteAbout,
	Addednewsection: Addednewsection,
	Removedsuccessfully: Removedsuccessfully,
	Remove: Remove,
	Institute: Institute,
	Schoolisrequired: Schoolisrequired,
	Degree: Degree,
	StartMonth: StartMonth,
	StartYear: StartYear,
	EndMonth: EndMonth,
	EndYear: EndYear,
	Addmore: Addmore,
	PositionTitle: PositionTitle,
	ExperienceType: ExperienceType,
	Addednewitem: Addednewitem,
	whatSkillsDoYouEnjoy: whatSkillsDoYouEnjoy,
	Typeskillshere: Typeskillshere,
	LinkedContacts: LinkedContacts,
	LinkContact: LinkContact,
	NocontactsLinked: NocontactsLinked,
	JobContactsComponent: JobContactsComponent,
	Nocontacts: Nocontacts,
	LinkJobto: LinkJobto,
	Contact: Contact,
	Document: Document,
	Nojobsfound: Nojobsfound,
	LinkJob: LinkJob,
	youCanLinkContactJobImported: youCanLinkContactJobImported,
	Prev: Prev,
	Next: Next,
	areYouSureUnlinkDocument: areYouSureUnlinkDocument,
	areYouSureDeleteDocument: areYouSureDeleteDocument,
	Category: Category,
	CreatedOn: CreatedOn,
	Joblinked: Joblinked,
	Quickactions: Quickactions,
	All: All,
	Resume: Resume,
	Portfolio: Portfolio,
	Other: Other,
	Adddocument: Adddocument,
	Type: Type,
	Sortingby: Sortingby,
	SwitchtoGridLayout: SwitchtoGridLayout,
	SwitchtoListLayout: SwitchtoListLayout,
	NoDocumentsAdded: NoDocumentsAdded,
	DocumentsComponent: DocumentsComponent,
	NoDocumentFound: NoDocumentFound,
	SelectFile: SelectFile,
	onlyPdfDocxSupported: onlyPdfDocxSupported,
	Uploadfile: Uploadfile,
	DocumentCategory: DocumentCategory,
	SaveDocument: SaveDocument,
	AddDocument: AddDocument,
	LinkedDocuments: LinkedDocuments,
	LinkDocument: LinkDocument,
	NodocumentsLinked: NodocumentsLinked,
	JobDocumentsComponent: JobDocumentsComponent,
	NoDocuments: NoDocuments,
	CreateDocuments: CreateDocuments,
	youCanLinkDocumentJobImported: youCanLinkDocumentJobImported,
	Documenteditedsuccessfully: Documenteditedsuccessfully,
	DocumentDetails: DocumentDetails,
	UnsavedChanges: UnsavedChanges,
	yourChangesWillBeLostSureClose: yourChangesWillBeLostSureClose,
	yourChangesWillBeLostSureDiscard: yourChangesWillBeLostSureDiscard,
	DiscardChanges: DiscardChanges,
	WeeklyGoalAlert: WeeklyGoalAlert,
	Progress: Progress,
	AllGoals: AllGoals,
	Name: Name,
	Completedon: Completedon,
	Createdon: Createdon,
	Action: Action,
	Back: Back,
	OverallScore: OverallScore,
	Aboutthegoal: Aboutthegoal,
	GoalTracking: GoalTracking,
	Week: Week,
	progress: progress,
	loading: loading,
	Apply: Apply,
	Thisskillhasbeenreported: Thisskillhasbeenreported,
	issueGettingResume: issueGettingResume,
	Interview: Interview,
	Tasks: Tasks,
	Loading: Loading,
	Skilladdedsuccessfully: Skilladdedsuccessfully,
	problemAddingSkill: problemAddingSkill,
	Reportaproblem: Reportaproblem,
	Submit: Submit,
	Addanewskill: Addanewskill,
	JobDetailsComponent: JobDetailsComponent,
	HardSkill: HardSkill,
	SoftSkill: SoftSkill,
	Pleaseshareanyadditionalcontext: Pleaseshareanyadditionalcontext,
	Addasskill: Addasskill,
	Skill: Skill,
	JobFrequency: JobFrequency,
	ResumeFrequency: ResumeFrequency,
	Reportskill: Reportskill,
	JobDetails: JobDetails,
	ViewJobLink: ViewJobLink,
	Salary: Salary,
	areYouSureDeleteJob: areYouSureDeleteJob,
	ViewMore: ViewMore,
	ViewLess: ViewLess,
	matchYouSkillsAgainstJob: matchYouSkillsAgainstJob,
	pleaseUploadResumeSkillMatch: pleaseUploadResumeSkillMatch,
	AddResume: AddResume,
	thisJobDoesNotHaveAnyDesc: thisJobDoesNotHaveAnyDesc,
	youCanEditJobToAdd: youCanEditJobToAdd,
	chromeextension: chromeextension,
	fromVariousJobPortalsOnce: fromVariousJobPortalsOnce,
	AddDescription: AddDescription,
	CompanyInfo: CompanyInfo,
	Website: Website,
	Industry: Industry,
	EmployeeCount: EmployeeCount,
	ExprienceLevel: ExprienceLevel,
	Address: Address,
	Resumes: Resumes,
	Setasdefault: Setasdefault,
	Ok: Ok,
	UploadNewResume: UploadNewResume,
	Default: Default,
	Jobnotfound: Jobnotfound,
	EditDetails: EditDetails,
	JobPostURL: JobPostURL,
	Enterjoburl: Enterjoburl,
	Nojobselected: Nojobselected,
	Viewjobdetails: Viewjobdetails,
	Jobaddedtoyourboardsuccessfully: Jobaddedtoyourboardsuccessfully,
	AddJob: AddJob,
	Addnewjobname: Addnewjobname,
	JobUrl: JobUrl,
	Addjoburl: Addjoburl,
	Section: Section,
	didYouKnow: didYouKnow,
	Jobs: Jobs,
	AddJobtoboard: AddJobtoboard,
	Currentlynojobsareavailable: Currentlynojobsareavailable,
	noMatchingJobs: noMatchingJobs,
	welcomeToYourPersonalJobTracker: welcomeToYourPersonalJobTracker,
	weShortTutorialOnHowTrackingJob: weShortTutorialOnHowTrackingJob,
	Addanewjob: Addanewjob,
	inOrderTrackCreatButton: inOrderTrackCreatButton,
	Providesomedetails: Providesomedetails,
	toBeginTypeJobTitleCompany: toBeginTypeJobTitleCompany,
	asAnExampleFilledForYou: asAnExampleFilledForYou,
	wohooAddedFirstJob: wohooAddedFirstJob,
	youCanDragDropJobCard: youCanDragDropJobCard,
	Lastbutnotleast: Lastbutnotleast,
	finalStepMakeSure: finalStepMakeSure,
	autoMaticallyImportJobs: autoMaticallyImportJobs,
	selectanysection: selectanysection,
	Accept: Accept,
	My2023JobSearch: My2023JobSearch,
	AddedFrom: AddedFrom,
	AddedUntil: AddedUntil,
	BasicModal: BasicModal,
	AddnewSectionName: AddnewSectionName,
	OpenTo: OpenTo,
	Featured: Featured,
	LicenceAndCerts: LicenceAndCerts,
	Banner: Banner,
	LinkedInURL: LinkedInURL,
	Recommendations: Recommendations,
	LinkedinReview: LinkedinReview,
	NoDataAvailable: NoDataAvailable,
	looksLikeYouDidNot: looksLikeYouDidNot,
	toOptimizeProfileScoreVisible: toOptimizeProfileScoreVisible,
	LinkedinComponent: LinkedinComponent,
	improveYourChancesLandingDreamJob: improveYourChancesLandingDreamJob,
	VisitProfile: VisitProfile,
	wantToGetLinkedinMakeover: wantToGetLinkedinMakeover,
	PostGenerator: PostGenerator,
	LinkedinHeadlineGenerator: LinkedinHeadlineGenerator,
	LinkedinAboutSectionGenerator: LinkedinAboutSectionGenerator,
	AITools: AITools,
	Premium: Premium,
	LinkedInOptimization: LinkedInOptimization,
	JobTracker: JobTracker,
	whoIsHiring: whoIsHiring,
	Autofill: Autofill,
	HeadlineGenerator: HeadlineGenerator,
	skillMatching: skillMatching,
	SummarizeJD: SummarizeJD,
	contactFeature: contactFeature,
	documentFeature: documentFeature,
	landJobWithoutStress: landJobWithoutStress,
	discoverFeatures: discoverFeatures,
	letsBeginOnboarding: letsBeginOnboarding,
	inTheNextFewScreensJobThirdParties: inTheNextFewScreensJobThirdParties,
	letsAddBasicInformation: letsAddBasicInformation,
	Pleaseselectanoptionfirst: Pleaseselectanoptionfirst,
	JobApplicationTracker: JobApplicationTracker,
	LinkedInProfileOptimizer: LinkedInProfileOptimizer,
	UnlimitedDocuments: UnlimitedDocuments,
	UnlimitedContacts: UnlimitedContacts,
	HiringManagerSearch: HiringManagerSearch,
	AILinkedInPostGenerator: AILinkedInPostGenerator,
	ATSKeywordSkillMatch: ATSKeywordSkillMatch,
	"Auto-Apply": "自动申请",
	ChooseyourPlan: ChooseyourPlan,
	superChargeYourJobSearch: superChargeYourJobSearch,
	startNowGoto: startNowGoto,
	CreatedBy: CreatedBy,
	CreateNewNote: CreateNewNote,
	Nonotescreated: Nonotescreated,
	approxTimeIsFourMinutes: approxTimeIsFourMinutes,
	Continue: Continue,
	iWillDoLaterTakeMeToApp: iWillDoLaterTakeMeToApp,
	allDone: allDone,
	welcomeAbord: welcomeAbord,
	letsBegin: letsBegin,
	UpgradeyourplanandgetAIAssistance: UpgradeyourplanandgetAIAssistance,
	DownloadPDF: DownloadPDF,
	oopsWeCouldntProcessResume: oopsWeCouldntProcessResume,
	MyProfile: MyProfile,
	Setting: Setting,
	Logout: Logout,
	SignIn: SignIn,
	Typeyourfirstnamehere: Typeyourfirstnamehere,
	Enteryourlastname: Enteryourlastname,
	ManageSubscription: ManageSubscription,
	ifYouHaveDifficultiesProfile: ifYouHaveDifficultiesProfile,
	forSupport: forSupport,
	whatIsIdealCompanySize: whatIsIdealCompanySize,
	Saveandcontinue: Saveandcontinue,
	whatIsMinExpectedSalary: whatIsMinExpectedSalary,
	Atleast: Atleast,
	SlidetoAdjust: SlidetoAdjust,
	whatIndustryExcitedWork: whatIndustryExcitedWork,
	Add: Add,
	statusOfJobSearch: statusOfJobSearch,
	Finish: Finish,
	whatLevelRoleLooking: whatLevelRoleLooking,
	Selectuptotwo: Selectuptotwo,
	PreviousStep: PreviousStep,
	Skip: Skip,
	whatDoYouValueNewRole: whatDoYouValueNewRole,
	Selectuptothree: Selectuptothree,
	EqualEmploymentData: EqualEmploymentData,
	whatIsYourEthnicity: whatIsYourEthnicity,
	areYouAuthorizedToWorkUs: areYouAuthorizedToWorkUs,
	willYouRequireSponsorShip: willYouRequireSponsorShip,
	doYouHaveADisability: doYouHaveADisability,
	areYouAVeteran: areYouAVeteran,
	rolesYouInterestedIn: rolesYouInterestedIn,
	Selectuptofive: Selectuptofive,
	AddCustomrole: AddCustomrole,
	whereDoYouLikeWork: whereDoYouLikeWork,
	Resources: Resources,
	currentlyNoResourceAvailable: currentlyNoResourceAvailable,
	AddNewSection: AddNewSection,
	ChangeSections: ChangeSections,
	Settings: Settings,
	Dashboard: Dashboard,
	JobBoard: JobBoard,
	Linkedin: Linkedin,
	Community: Community,
	FindRecruiters: FindRecruiters,
	Goals: Goals,
	DownloadExtension: DownloadExtension,
	SuggestaFeature: SuggestaFeature,
	leftPanel: leftPanel,
	PhoneNumberisrequired: PhoneNumberisrequired,
	MobileNumber: MobileNumber,
	Enteronlynumbers: Enteronlynumbers,
	Countryyoulivein: Countryyoulivein,
	SelectaCountry: SelectaCountry,
	DateofBirth: DateofBirth,
	Gender: Gender,
	JobPreferences: JobPreferences,
	pleaseEnterValidEmail: pleaseEnterValidEmail,
	emailSendForResetting: emailSendForResetting,
	VerifyyourEmailID: VerifyyourEmailID,
	sentPleaseCheckEmail: sentPleaseCheckEmail,
	tooManyAttemptsTryAgain: tooManyAttemptsTryAgain,
	Resend: Resend,
	Login: Login,
	weHaveSentVerificationLinkAtEmail: weHaveSentVerificationLinkAtEmail,
	pleaseVerifyEmailContinueSpam: pleaseVerifyEmailContinueSpam,
	Logintogetstarted: Logintogetstarted,
	ContinuewithGoogle: ContinuewithGoogle,
	pleaseInputEmail: pleaseInputEmail,
	Password: Password,
	pleaseInputPassword: pleaseInputPassword,
	passwordLowerUpperDigitSpecial: passwordLowerUpperDigitSpecial,
	atLeastSixChar: atLeastSixChar,
	forgotPassword: forgotPassword,
	Bysigninginyouagreetoour: Bysigninginyouagreetoour,
	Terms: Terms,
	Conditions: Conditions,
	and: and,
	PrivacyPolicy: PrivacyPolicy,
	theseAreTheTopsSkillsExtracted: theseAreTheTopsSkillsExtracted,
	TopSkills: TopSkills,
	weCoulNotExtractSkills: weCoulNotExtractSkills,
	upgradeToPremiumToView: upgradeToPremiumToView,
	SkillScore: SkillScore,
	thisIsYourSkillScoreBasedOn: thisIsYourSkillScoreBasedOn,
	theseSkllsAreStrongMatch: theseSkllsAreStrongMatch,
	Strongmatch: Strongmatch,
	theseSkillsArePartialMatch: theseSkillsArePartialMatch,
	Partialmatch: Partialmatch,
	theseSkillsAreMissingFrom: theseSkillsAreMissingFrom,
	"Missing Keywords": "缺失关键词",
	SkillMatchComponent: SkillMatchComponent,
	Optional: Optional,
	Notrelevanttothejob: Notrelevanttothejob,
	Notaskill: Notaskill,
	Toogeneric: Toogeneric,
	Pleaseshareanyfeedback: Pleaseshareanyfeedback,
	excludedKeywordsWillNot: excludedKeywordsWillNot,
	yesExcludeThisSkillFrom: yesExcludeThisSkillFrom,
	PartialMatch: PartialMatch,
	MissingKeywords: MissingKeywords,
	Providetitletotask: Providetitletotask,
	TasksList: TasksList,
	AddTask: AddTask,
	EnterTaskTitlehere: EnterTaskTitlehere,
	TasksComponent: TasksComponent,
	CompletedTasks: CompletedTasks,
	CompleteYourtasks: CompleteYourtasks,
	Steps: Steps,
	PremiumMember: PremiumMember,
	Thankyouforupgradingto: Thankyouforupgradingto,
	CareerflowPremium: CareerflowPremium,
	hereIsHowYouCanAccessPremium: hereIsHowYouCanAccessPremium,
	stepOne: stepOne,
	DownloadourChromeExtension: DownloadourChromeExtension,
	youJobSearchCopilotIshere: youJobSearchCopilotIshere,
	DownloadNow: DownloadNow,
	stepTwo: stepTwo,
	GetStarted: GetStarted,
	stepThree: stepThree,
	SignintoChromeExtension: SignintoChromeExtension,
	entityCreated: entityCreated,
	entityUpdated: entityUpdated,
	entityDeleted: entityDeleted,
	entityLinked: entityLinked,
	entityUnlinked: entityUnlinked,
	entityMovedTo: entityMovedTo,
	youAddedANewEntity: youAddedANewEntity,
	personCreated: personCreated,
	youUpdatedAEntity: youUpdatedAEntity,
	personUpdated: personUpdated,
	youDeletedAEntity: youDeletedAEntity,
	personDeleted: personDeleted,
	youLinkedEntity: youLinkedEntity,
	personLinked: personLinked,
	youUnlinked: youUnlinked,
	personUnlinked: personUnlinked,
	youMovedEntity: youMovedEntity,
	personMoved: personMoved,
	addedByName: addedByName,
	DownloadChromeExtension: DownloadChromeExtension,
	ourChromeExtensionIs: ourChromeExtensionIs,
	Optimizeyourprofile: Optimizeyourprofile,
	startOptimizingYourProfile: startOptimizingYourProfile,
	OptimizeNow: OptimizeNow,
	Addyourfirstjob: Addyourfirstjob,
	startSavingJobApplicationsToTrack: startSavingJobApplicationsToTrack,
	AddNow: AddNow,
	CompleteProfile: CompleteProfile,
	completeYourProfileForUsing: completeYourProfileForUsing,
	CompleteNow: CompleteNow,
	Addyourfirstcontact: Addyourfirstcontact,
	addContactToFollowUpWith: addContactToFollowUpWith,
	JoinCommunity: JoinCommunity,
	ourCommunityisAlways: ourCommunityisAlways,
	JoinNow: JoinNow,
	welcomeToCareerflow: welcomeToCareerflow,
	yourHubForCareerInsights2: yourHubForCareerInsights2,
	ChecklistCompleted: ChecklistCompleted,
	Completeyourchecklist: Completeyourchecklist,
	completeAFewStepsTo: completeAFewStepsTo,
	Completed: Completed,
	JobCountByStage: JobCountByStage,
	NopastapplicationDatafound: NopastapplicationDatafound,
	YourJobSearchStages: YourJobSearchStages,
	NoDatafound: NoDatafound
};

const availableLocales = {
  en,
  bg,
  cs,
  da,
  de,
  es,
  et,
  fi,
  fr,
  hi,
  hr,
  hu,
  it,
  lt,
  lv,
  nl,
  no,
  pl,
  pt,
  ro,
  sk,
  sl,
  sr,
  sv,
  zh
};

export { availableLocales };
